import { createSlice } from "@reduxjs/toolkit";
import APP_CONSTANTS from "../../utils/config";

const initialState = {
  chatBotToggle: false,
  conversation: {},
  conversationData: [],
  conversationLikeDislikeStatus: APP_CONSTANTS.SUCCESS,
  searchConversationText: "",
  selectedDataProduct: "CTS DATA",
  dataProductOptions: [
    { name: "CTS DATA", disabled: false },
    { name: "Sherlock", disabled: false },
  ],

  sherlockAssist: {
    sessionHistory: [],
    activeSession: {},
    activeChatThread: [],
    hotQuestions: [
      "Stores with low inventory in Alabama",
      "Show 2025 sales by state using a heatmap",
      "Which were the top performing stores in 2024?",
      "Compare sales of top 3 stores in 2024 in Texas",
      "How many births has MJN gained monthly since 2022?",
      "POS Sales across retailers in Houston, Texas in 2025?",
      "Compare the quarterly sales for Enfamil and Enfamil WIC",
      "Compare monthly sales trends across top brands in Florida",
      "Which state has shown the best hospital contract performance since 2022?",
    ],

    // 1. Compare monthly sales trends across top brands in Florida.
    // 2. Show 2025 sales by state using a heatmap.
    // 3. How many births has MJN gained monthly since 2022?
    // 4. Compare the quarterly sales for Enfamil and Enfamil WIC.
    // 5. Compare sales of top 3 stores in 2024 in Texas
    // 6. POS Sales across retailers in Houston, Texas in 2025?
    // 7. Which state has shown the best hospital contract performance since 2022?
    // 8. Which were the top performing stores in 2024?
    // 9. Stores with low inventory in Alabama.

    databricksCluster: {
      status: "",
      expiry: "",
    },
    sessionFilters: {
      states: [],
      cities: [],
      retailers: [],
      brands: [],
      skus: [],
      stores: [],
    },
    filterCount: 0,
    filters: {
      state: {
        options: [
          { name: "AK", disabled: false },
          { name: "AL", disabled: false },
          { name: "AR", disabled: false },
          { name: "AZ", disabled: false },
          { name: "CA", disabled: false },
          { name: "CO", disabled: false },
          { name: "CT", disabled: false },
          { name: "DC", disabled: false },
          { name: "DE", disabled: false },
          { name: "FL", disabled: false },
          { name: "GA", disabled: false },
          { name: "HI", disabled: false },
          { name: "IA", disabled: false },
          { name: "ID", disabled: false },
          { name: "IL", disabled: false },
          { name: "IN", disabled: false },
          { name: "KS", disabled: false },
          { name: "KY", disabled: false },
          { name: "LA", disabled: false },
          { name: "MA", disabled: false },
          { name: "MD", disabled: false },
          { name: "ME", disabled: false },
          { name: "MI", disabled: false },
          { name: "MN", disabled: false },
          { name: "MO", disabled: false },
          { name: "MS", disabled: false },
          { name: "MT", disabled: false },
          { name: "NA", disabled: false },
          { name: "NC", disabled: false },
          { name: "ND", disabled: false },
          { name: "NE", disabled: false },
          { name: "NH", disabled: false },
          { name: "NJ", disabled: false },
          { name: "NM", disabled: false },
          { name: "NV", disabled: false },
          { name: "NY", disabled: false },
          { name: "OH", disabled: false },
          { name: "OK", disabled: false },
          { name: "OR", disabled: false },
          { name: "PA", disabled: false },
          { name: "PR", disabled: false },
          { name: "RI", disabled: false },
          { name: "SC", disabled: false },
          { name: "SD", disabled: false },
          { name: "TN", disabled: false },
          { name: "TX", disabled: false },
          { name: "US", disabled: false },
          { name: "UT", disabled: false },
          { name: "VA", disabled: false },
          { name: "VT", disabled: false },
          { name: "WA", disabled: false },
          { name: "WI", disabled: false },
          { name: "WV", disabled: false },
          { name: "WY", disabled: false },
        ],
        value: "",
      },
      city: {
        options: [
          {
            name: "ABBEVILLE",
            disabled: false,
          },
          {
            name: "ABERDEEN",
            disabled: false,
          },
          {
            name: "ABILENE",
            disabled: false,
          },
          {
            name: "ABINGDON",
            disabled: false,
          },
          {
            name: "ABINGTON",
            disabled: false,
          },
          {
            name: "ABITA SPRINGS",
            disabled: false,
          },
          {
            name: "ABSECON",
            disabled: false,
          },
          {
            name: "ACCOKEEK",
            disabled: false,
          },
          {
            name: "ACTON",
            disabled: false,
          },
          {
            name: "ACWORTH",
            disabled: false,
          },
          {
            name: "ADA",
            disabled: false,
          },
          {
            name: "ADAIRSVILLE",
            disabled: false,
          },
          {
            name: "ADAMSVILLE",
            disabled: false,
          },
          {
            name: "ADDISON",
            disabled: false,
          },
          {
            name: "ADEL",
            disabled: false,
          },
          {
            name: "ADELANTO",
            disabled: false,
          },
          {
            name: "ADRIAN",
            disabled: false,
          },
          {
            name: "ADVANCE",
            disabled: false,
          },
          {
            name: "AFFTON",
            disabled: false,
          },
          {
            name: "AGAWAM",
            disabled: false,
          },
          {
            name: "AGOURA",
            disabled: false,
          },
          {
            name: "AGOURA HILLS",
            disabled: false,
          },
          {
            name: "AHOSKIE",
            disabled: false,
          },
          {
            name: "AIEA",
            disabled: false,
          },
          {
            name: "AIKEN",
            disabled: false,
          },
          {
            name: "AITKIN",
            disabled: false,
          },
          {
            name: "AKRON",
            disabled: false,
          },
          {
            name: "ALABASTER",
            disabled: false,
          },
          {
            name: "ALACHUA",
            disabled: false,
          },
          {
            name: "ALAMEDA",
            disabled: false,
          },
          {
            name: "ALAMO",
            disabled: false,
          },
          {
            name: "ALAMO HEIGHTS",
            disabled: false,
          },
          {
            name: "ALAMOGORDO",
            disabled: false,
          },
          {
            name: "ALAMOSA",
            disabled: false,
          },
          {
            name: "ALBANY",
            disabled: false,
          },
          {
            name: "ALBEMARLE",
            disabled: false,
          },
          {
            name: "ALBERT LEA",
            disabled: false,
          },
          {
            name: "ALBERTVILLE",
            disabled: false,
          },
          {
            name: "ALBION",
            disabled: false,
          },
          {
            name: "ALBUQUERQUE",
            disabled: false,
          },
          {
            name: "ALCOA",
            disabled: false,
          },
          {
            name: "ALDEN",
            disabled: false,
          },
          {
            name: "ALDIE",
            disabled: false,
          },
          {
            name: "ALEDO",
            disabled: false,
          },
          {
            name: "ALEXANDER CITY",
            disabled: false,
          },
          {
            name: "ALEXANDRIA",
            disabled: false,
          },
          {
            name: "ALGONAC",
            disabled: false,
          },
          {
            name: "ALGONQUIN",
            disabled: false,
          },
          {
            name: "ALGOOD",
            disabled: false,
          },
          {
            name: "ALHAMBRA",
            disabled: false,
          },
          {
            name: "ALICE",
            disabled: false,
          },
          {
            name: "ALICEVILLE",
            disabled: false,
          },
          {
            name: "ALIQUIPPA",
            disabled: false,
          },
          {
            name: "ALISO VIEJO",
            disabled: false,
          },
          {
            name: "ALLEGAN",
            disabled: false,
          },
          {
            name: "ALLEN",
            disabled: false,
          },
          {
            name: "ALLEN PARK",
            disabled: false,
          },
          {
            name: "ALLENDALE",
            disabled: false,
          },
          {
            name: "ALLENTOWN",
            disabled: false,
          },
          {
            name: "ALLIANCE",
            disabled: false,
          },
          {
            name: "ALLISON PARK",
            disabled: false,
          },
          {
            name: "ALLSTON",
            disabled: false,
          },
          {
            name: "ALMA",
            disabled: false,
          },
          {
            name: "ALMONT",
            disabled: false,
          },
          {
            name: "ALOHA",
            disabled: false,
          },
          {
            name: "ALPENA",
            disabled: false,
          },
          {
            name: "ALPHARETTA",
            disabled: false,
          },
          {
            name: "ALPINE",
            disabled: false,
          },
          {
            name: "ALSIP",
            disabled: false,
          },
          {
            name: "ALTADENA",
            disabled: false,
          },
          {
            name: "ALTAMONTE SPRIN",
            disabled: false,
          },
          {
            name: "ALTAMONTE SPRINGS",
            disabled: false,
          },
          {
            name: "ALTAVISTA",
            disabled: false,
          },
          {
            name: "ALTON",
            disabled: false,
          },
          {
            name: "ALTOONA",
            disabled: false,
          },
          {
            name: "ALTURAS",
            disabled: false,
          },
          {
            name: "ALTUS",
            disabled: false,
          },
          {
            name: "ALVA",
            disabled: false,
          },
          {
            name: "ALVARADO",
            disabled: false,
          },
          {
            name: "ALVIN",
            disabled: false,
          },
          {
            name: "AMARILLO",
            disabled: false,
          },
          {
            name: "AMBLER",
            disabled: false,
          },
          {
            name: "AMBRIDGE",
            disabled: false,
          },
          {
            name: "AMELIA",
            disabled: false,
          },
          {
            name: "AMELIA COURT HOUSE",
            disabled: false,
          },
          {
            name: "AMERICAN CANYON",
            disabled: false,
          },
          {
            name: "AMERICAN FORK",
            disabled: false,
          },
          {
            name: "AMERICUS",
            disabled: false,
          },
          {
            name: "AMES",
            disabled: false,
          },
          {
            name: "AMESBURY",
            disabled: false,
          },
          {
            name: "AMHERST",
            disabled: false,
          },
          {
            name: "AMITE",
            disabled: false,
          },
          {
            name: "AMITYVILLE",
            disabled: false,
          },
          {
            name: "AMMON",
            disabled: false,
          },
          {
            name: "AMORY",
            disabled: false,
          },
          {
            name: "AMSTERDAM",
            disabled: false,
          },
          {
            name: "ANACONDA",
            disabled: false,
          },
          {
            name: "ANACORTES",
            disabled: false,
          },
          {
            name: "ANADARKO",
            disabled: false,
          },
          {
            name: "ANAHEIM",
            disabled: false,
          },
          {
            name: "ANAMOSA",
            disabled: false,
          },
          {
            name: "ANCHORAGE",
            disabled: false,
          },
          {
            name: "ANDALUSIA",
            disabled: false,
          },
          {
            name: "ANDERSON",
            disabled: false,
          },
          {
            name: "ANDOVER",
            disabled: false,
          },
          {
            name: "ANDREWS",
            disabled: false,
          },
          {
            name: "ANGELS CAMP",
            disabled: false,
          },
          {
            name: "ANGIER",
            disabled: false,
          },
          {
            name: "ANGLETON",
            disabled: false,
          },
          {
            name: "ANGOLA",
            disabled: false,
          },
          {
            name: "ANKENY",
            disabled: false,
          },
          {
            name: "ANN ARBOR",
            disabled: false,
          },
          {
            name: "ANNA",
            disabled: false,
          },
          {
            name: "ANNANDALE",
            disabled: false,
          },
          {
            name: "ANNAPOLIS",
            disabled: false,
          },
          {
            name: "ANNISTON",
            disabled: false,
          },
          {
            name: "ANOKA",
            disabled: false,
          },
          {
            name: "ANSONIA",
            disabled: false,
          },
          {
            name: "ANTELOPE",
            disabled: false,
          },
          {
            name: "ANTHEM",
            disabled: false,
          },
          {
            name: "ANTHONY",
            disabled: false,
          },
          {
            name: "ANTIGO",
            disabled: false,
          },
          {
            name: "ANTIOCH",
            disabled: false,
          },
          {
            name: "APACHE JUNCTION",
            disabled: false,
          },
          {
            name: "APALACHICOLA",
            disabled: false,
          },
          {
            name: "APEX",
            disabled: false,
          },
          {
            name: "APOLLO BEACH",
            disabled: false,
          },
          {
            name: "APOPKA",
            disabled: false,
          },
          {
            name: "APPLE VALLEY",
            disabled: false,
          },
          {
            name: "APPLETON",
            disabled: false,
          },
          {
            name: "APPOMATTOX",
            disabled: false,
          },
          {
            name: "APTOS",
            disabled: false,
          },
          {
            name: "ARAB",
            disabled: false,
          },
          {
            name: "ARANSAS PASS",
            disabled: false,
          },
          {
            name: "ARBUTUS",
            disabled: false,
          },
          {
            name: "ARCADIA",
            disabled: false,
          },
          {
            name: "ARCATA",
            disabled: false,
          },
          {
            name: "ARCHBOLD",
            disabled: false,
          },
          {
            name: "ARCHDALE",
            disabled: false,
          },
          {
            name: "ARDEN",
            disabled: false,
          },
          {
            name: "ARDEN HILLS",
            disabled: false,
          },
          {
            name: "ARDMORE",
            disabled: false,
          },
          {
            name: "ARDSLEY",
            disabled: false,
          },
          {
            name: "ARGYLE",
            disabled: false,
          },
          {
            name: "ARKADELPHIA",
            disabled: false,
          },
          {
            name: "ARKANSAS CITY",
            disabled: false,
          },
          {
            name: "ARLETA",
            disabled: false,
          },
          {
            name: "ARLINGTON",
            disabled: false,
          },
          {
            name: "ARLINGTON HEIGHTS",
            disabled: false,
          },
          {
            name: "ARMONK",
            disabled: false,
          },
          {
            name: "ARNOLD",
            disabled: false,
          },
          {
            name: "ARROYO GRANDE",
            disabled: false,
          },
          {
            name: "ARTESIA",
            disabled: false,
          },
          {
            name: "ARVADA",
            disabled: false,
          },
          {
            name: "ASBURY PARK",
            disabled: false,
          },
          {
            name: "ASH FLAT",
            disabled: false,
          },
          {
            name: "ASHBURN",
            disabled: false,
          },
          {
            name: "ASHDOWN",
            disabled: false,
          },
          {
            name: "ASHEBORO",
            disabled: false,
          },
          {
            name: "ASHEVILLE",
            disabled: false,
          },
          {
            name: "ASHLAND",
            disabled: false,
          },
          {
            name: "ASHLAND CITY",
            disabled: false,
          },
          {
            name: "ASHTABULA",
            disabled: false,
          },
          {
            name: "ASHTON",
            disabled: false,
          },
          {
            name: "ASHWAUBENON",
            disabled: false,
          },
          {
            name: "ASTON",
            disabled: false,
          },
          {
            name: "ASTORIA",
            disabled: false,
          },
          {
            name: "ATASCADERO",
            disabled: false,
          },
          {
            name: "ATCHISON",
            disabled: false,
          },
          {
            name: "ATCO",
            disabled: false,
          },
          {
            name: "ATHENS",
            disabled: false,
          },
          {
            name: "ATHOL",
            disabled: false,
          },
          {
            name: "ATLANTA",
            disabled: false,
          },
          {
            name: "ATLANTIC",
            disabled: false,
          },
          {
            name: "ATLANTIC BEACH",
            disabled: false,
          },
          {
            name: "ATLANTIC CITY",
            disabled: false,
          },
          {
            name: "ATMORE",
            disabled: false,
          },
          {
            name: "ATOKA",
            disabled: false,
          },
          {
            name: "ATTALLA",
            disabled: false,
          },
          {
            name: "ATTICA",
            disabled: false,
          },
          {
            name: "ATTLEBORO",
            disabled: false,
          },
          {
            name: "ATWATER",
            disabled: false,
          },
          {
            name: "AUBREY",
            disabled: false,
          },
          {
            name: "AUBURN",
            disabled: false,
          },
          {
            name: "AUBURN HILLS",
            disabled: false,
          },
          {
            name: "AUBURNDALE",
            disabled: false,
          },
          {
            name: "AUDUBON",
            disabled: false,
          },
          {
            name: "AUGUSTA",
            disabled: false,
          },
          {
            name: "AURORA",
            disabled: false,
          },
          {
            name: "AUSTELL",
            disabled: false,
          },
          {
            name: "AUSTIN",
            disabled: false,
          },
          {
            name: "AUSTINTOWN",
            disabled: false,
          },
          {
            name: "AVA",
            disabled: false,
          },
          {
            name: "AVALON",
            disabled: false,
          },
          {
            name: "AVENTURA",
            disabled: false,
          },
          {
            name: "AVON",
            disabled: false,
          },
          {
            name: "AVON LAKE",
            disabled: false,
          },
          {
            name: "AVON PARK",
            disabled: false,
          },
          {
            name: "AVONDALE",
            disabled: false,
          },
          {
            name: "AYDEN",
            disabled: false,
          },
          {
            name: "AYLETT",
            disabled: false,
          },
          {
            name: "AZLE",
            disabled: false,
          },
          {
            name: "AZTEC",
            disabled: false,
          },
          {
            name: "AZUSA",
            disabled: false,
          },
          {
            name: "Abington",
            disabled: false,
          },
          {
            name: "Alamosa",
            disabled: false,
          },
          {
            name: "Albany",
            disabled: false,
          },
          {
            name: "Albuquerque",
            disabled: false,
          },
          {
            name: "Alhambra",
            disabled: false,
          },
          {
            name: "Altadena",
            disabled: false,
          },
          {
            name: "Amelia",
            disabled: false,
          },
          {
            name: "Anaheim",
            disabled: false,
          },
          {
            name: "Anderson",
            disabled: false,
          },
          {
            name: "Andover",
            disabled: false,
          },
          {
            name: "Ann Arbor",
            disabled: false,
          },
          {
            name: "Annapolis",
            disabled: false,
          },
          {
            name: "Antigo",
            disabled: false,
          },
          {
            name: "Antioch",
            disabled: false,
          },
          {
            name: "Apache Junction",
            disabled: false,
          },
          {
            name: "Apex",
            disabled: false,
          },
          {
            name: "Appleton",
            disabled: false,
          },
          {
            name: "Arleta",
            disabled: false,
          },
          {
            name: "Arlington",
            disabled: false,
          },
          {
            name: "Arlington Heights",
            disabled: false,
          },
          {
            name: "Aspen",
            disabled: false,
          },
          {
            name: "Athens",
            disabled: false,
          },
          {
            name: "Atlanta",
            disabled: false,
          },
          {
            name: "Auburn",
            disabled: false,
          },
          {
            name: "Augusta",
            disabled: false,
          },
          {
            name: "Aurora",
            disabled: false,
          },
          {
            name: "Austin",
            disabled: false,
          },
          {
            name: "Avon",
            disabled: false,
          },
          {
            name: "BAD AXE",
            disabled: false,
          },
          {
            name: "BADEN",
            disabled: false,
          },
          {
            name: "BAILEYS CROSSROADS",
            disabled: false,
          },
          {
            name: "BAINBRIDGE",
            disabled: false,
          },
          {
            name: "BAINBRIDGE ISLAND",
            disabled: false,
          },
          {
            name: "BAKER",
            disabled: false,
          },
          {
            name: "BAKER CITY",
            disabled: false,
          },
          {
            name: "BAKERSFIELD",
            disabled: false,
          },
          {
            name: "BALA CYNWYD",
            disabled: false,
          },
          {
            name: "BALCH SPRINGS",
            disabled: false,
          },
          {
            name: "BALCONES HEIGHTS",
            disabled: false,
          },
          {
            name: "BALDWIN",
            disabled: false,
          },
          {
            name: "BALDWIN PARK",
            disabled: false,
          },
          {
            name: "BALDWINSVILLE",
            disabled: false,
          },
          {
            name: "BALLENTINE",
            disabled: false,
          },
          {
            name: "BALLINGER",
            disabled: false,
          },
          {
            name: "BALLSTON LAKE",
            disabled: false,
          },
          {
            name: "BALLSTON SPA",
            disabled: false,
          },
          {
            name: "BALLWIN",
            disabled: false,
          },
          {
            name: "BALTIMORE",
            disabled: false,
          },
          {
            name: "BAMBERG",
            disabled: false,
          },
          {
            name: "BANDON",
            disabled: false,
          },
          {
            name: "BANGOR",
            disabled: false,
          },
          {
            name: "BANNER ELK",
            disabled: false,
          },
          {
            name: "BANNING",
            disabled: false,
          },
          {
            name: "BANNOCKBURN",
            disabled: false,
          },
          {
            name: "BARABOO",
            disabled: false,
          },
          {
            name: "BARBERTON",
            disabled: false,
          },
          {
            name: "BARBOURSVILLE",
            disabled: false,
          },
          {
            name: "BARBOURVILLE",
            disabled: false,
          },
          {
            name: "BARCELONETA",
            disabled: false,
          },
          {
            name: "BARDONIA",
            disabled: false,
          },
          {
            name: "BARDSTOWN",
            disabled: false,
          },
          {
            name: "BARGERSVILLE",
            disabled: false,
          },
          {
            name: "BARNEGAT",
            disabled: false,
          },
          {
            name: "BARNESVILLE",
            disabled: false,
          },
          {
            name: "BARNEVELD",
            disabled: false,
          },
          {
            name: "BARNHART",
            disabled: false,
          },
          {
            name: "BARNWELL",
            disabled: false,
          },
          {
            name: "BARRE",
            disabled: false,
          },
          {
            name: "BARRINGTON",
            disabled: false,
          },
          {
            name: "BARRON",
            disabled: false,
          },
          {
            name: "BARSTOW",
            disabled: false,
          },
          {
            name: "BARTLESVILLE",
            disabled: false,
          },
          {
            name: "BARTLETT",
            disabled: false,
          },
          {
            name: "BARTONSVILLE",
            disabled: false,
          },
          {
            name: "BARTONVILLE",
            disabled: false,
          },
          {
            name: "BARTOW",
            disabled: false,
          },
          {
            name: "BASKING RIDGE",
            disabled: false,
          },
          {
            name: "BASSETT",
            disabled: false,
          },
          {
            name: "BASTROP",
            disabled: false,
          },
          {
            name: "BATAVIA",
            disabled: false,
          },
          {
            name: "BATESBURG",
            disabled: false,
          },
          {
            name: "BATESVILLE",
            disabled: false,
          },
          {
            name: "BATH",
            disabled: false,
          },
          {
            name: "BATON ROUGE",
            disabled: false,
          },
          {
            name: "BATTLE CREEK",
            disabled: false,
          },
          {
            name: "BATTLE GROUND",
            disabled: false,
          },
          {
            name: "BAXLEY",
            disabled: false,
          },
          {
            name: "BAXTER",
            disabled: false,
          },
          {
            name: "BAY CITY",
            disabled: false,
          },
          {
            name: "BAY MINETTE",
            disabled: false,
          },
          {
            name: "BAY POINT",
            disabled: false,
          },
          {
            name: "BAY SHORE",
            disabled: false,
          },
          {
            name: "BAY VILLAGE",
            disabled: false,
          },
          {
            name: "BAYAMON",
            disabled: false,
          },
          {
            name: "BAYONNE",
            disabled: false,
          },
          {
            name: "BAYOU LA BATRE",
            disabled: false,
          },
          {
            name: "BAYPORT",
            disabled: false,
          },
          {
            name: "BAYSIDE",
            disabled: false,
          },
          {
            name: "BAYTOWN",
            disabled: false,
          },
          {
            name: "BAYVILLE",
            disabled: false,
          },
          {
            name: "BEACH PARK",
            disabled: false,
          },
          {
            name: "BEACHWOOD",
            disabled: false,
          },
          {
            name: "BEALETON",
            disabled: false,
          },
          {
            name: "BEAN STATION",
            disabled: false,
          },
          {
            name: "BEAR",
            disabled: false,
          },
          {
            name: "BEARDSTOWN",
            disabled: false,
          },
          {
            name: "BEATRICE",
            disabled: false,
          },
          {
            name: "BEATTYVILLE",
            disabled: false,
          },
          {
            name: "BEAUFORT",
            disabled: false,
          },
          {
            name: "BEAUMONT",
            disabled: false,
          },
          {
            name: "BEAVER",
            disabled: false,
          },
          {
            name: "BEAVER DAM",
            disabled: false,
          },
          {
            name: "BEAVER FALLS",
            disabled: false,
          },
          {
            name: "BEAVERCREEK",
            disabled: false,
          },
          {
            name: "BEAVERTON",
            disabled: false,
          },
          {
            name: "BECHTELSVILLE",
            disabled: false,
          },
          {
            name: "BECKLEY",
            disabled: false,
          },
          {
            name: "BEDFORD",
            disabled: false,
          },
          {
            name: "BEDFORD HILLS",
            disabled: false,
          },
          {
            name: "BEDFORD PARK",
            disabled: false,
          },
          {
            name: "BEDMINSTER",
            disabled: false,
          },
          {
            name: "BEE CAVE",
            disabled: false,
          },
          {
            name: "BEEBE",
            disabled: false,
          },
          {
            name: "BEECH GROVE",
            disabled: false,
          },
          {
            name: "BEECH ISLAND",
            disabled: false,
          },
          {
            name: "BEECHER",
            disabled: false,
          },
          {
            name: "BEEVILLE",
            disabled: false,
          },
          {
            name: "BEL AIR",
            disabled: false,
          },
          {
            name: "BELCAMP",
            disabled: false,
          },
          {
            name: "BELCHERTOWN",
            disabled: false,
          },
          {
            name: "BELEN",
            disabled: false,
          },
          {
            name: "BELFAIR",
            disabled: false,
          },
          {
            name: "BELFAST",
            disabled: false,
          },
          {
            name: "BELFORD",
            disabled: false,
          },
          {
            name: "BELGRADE",
            disabled: false,
          },
          {
            name: "BELHAVEN",
            disabled: false,
          },
          {
            name: "BELL GARDENS",
            disabled: false,
          },
          {
            name: "BELLA VISTA",
            disabled: false,
          },
          {
            name: "BELLAIRE",
            disabled: false,
          },
          {
            name: "BELLE",
            disabled: false,
          },
          {
            name: "BELLE GLADE",
            disabled: false,
          },
          {
            name: "BELLE MEAD",
            disabled: false,
          },
          {
            name: "BELLE VERNON",
            disabled: false,
          },
          {
            name: "BELLEAIR BLUFFS",
            disabled: false,
          },
          {
            name: "BELLEFONTAINE",
            disabled: false,
          },
          {
            name: "BELLEFONTE",
            disabled: false,
          },
          {
            name: "BELLEROSE",
            disabled: false,
          },
          {
            name: "BELLEVIEW",
            disabled: false,
          },
          {
            name: "BELLEVILLE",
            disabled: false,
          },
          {
            name: "BELLEVUE",
            disabled: false,
          },
          {
            name: "BELLFLOWER",
            disabled: false,
          },
          {
            name: "BELLINGHAM",
            disabled: false,
          },
          {
            name: "BELLMEAD",
            disabled: false,
          },
          {
            name: "BELLMORE",
            disabled: false,
          },
          {
            name: "BELLOWS FALLS",
            disabled: false,
          },
          {
            name: "BELLPORT",
            disabled: false,
          },
          {
            name: "BELMONT",
            disabled: false,
          },
          {
            name: "BELOIT",
            disabled: false,
          },
          {
            name: "BELPRE",
            disabled: false,
          },
          {
            name: "BELTON",
            disabled: false,
          },
          {
            name: "BELTSVILLE",
            disabled: false,
          },
          {
            name: "BELVIDERE",
            disabled: false,
          },
          {
            name: "BEMIDJI",
            disabled: false,
          },
          {
            name: "BENBROOK",
            disabled: false,
          },
          {
            name: "BEND",
            disabled: false,
          },
          {
            name: "BENICIA",
            disabled: false,
          },
          {
            name: "BENNETT",
            disabled: false,
          },
          {
            name: "BENNETTSVILLE",
            disabled: false,
          },
          {
            name: "BENNINGTON",
            disabled: false,
          },
          {
            name: "BENSALEM",
            disabled: false,
          },
          {
            name: "BENSENVILLE",
            disabled: false,
          },
          {
            name: "BENSON",
            disabled: false,
          },
          {
            name: "BENTLEYVILLE",
            disabled: false,
          },
          {
            name: "BENTON",
            disabled: false,
          },
          {
            name: "BENTON HARBOR",
            disabled: false,
          },
          {
            name: "BENTONVILLE",
            disabled: false,
          },
          {
            name: "BEREA",
            disabled: false,
          },
          {
            name: "BERGENFIELD",
            disabled: false,
          },
          {
            name: "BERKELEY",
            disabled: false,
          },
          {
            name: "BERKELEY HEIGHTS",
            disabled: false,
          },
          {
            name: "BERKELEY SPRINGS",
            disabled: false,
          },
          {
            name: "BERKLEY",
            disabled: false,
          },
          {
            name: "BERLIN",
            disabled: false,
          },
          {
            name: "BERMUDA DUNES",
            disabled: false,
          },
          {
            name: "BERNALILLO",
            disabled: false,
          },
          {
            name: "BERNARDSVILLE",
            disabled: false,
          },
          {
            name: "BERNE",
            disabled: false,
          },
          {
            name: "BERRIEN SPRINGS",
            disabled: false,
          },
          {
            name: "BERRYVILLE",
            disabled: false,
          },
          {
            name: "BERWICK",
            disabled: false,
          },
          {
            name: "BERWYN",
            disabled: false,
          },
          {
            name: "BESSEMER",
            disabled: false,
          },
          {
            name: "BESSEMER CITY",
            disabled: false,
          },
          {
            name: "BETHALTO",
            disabled: false,
          },
          {
            name: "BETHANY",
            disabled: false,
          },
          {
            name: "BETHEL",
            disabled: false,
          },
          {
            name: "BETHEL PARK",
            disabled: false,
          },
          {
            name: "BETHESDA",
            disabled: false,
          },
          {
            name: "BETHLEHEM",
            disabled: false,
          },
          {
            name: "BETHPAGE",
            disabled: false,
          },
          {
            name: "BETTENDORF",
            disabled: false,
          },
          {
            name: "BEULAVILLE",
            disabled: false,
          },
          {
            name: "BEVERLY",
            disabled: false,
          },
          {
            name: "BEVERLY HILLS",
            disabled: false,
          },
          {
            name: "BIDDEFORD",
            disabled: false,
          },
          {
            name: "BIG BEAR LAKE",
            disabled: false,
          },
          {
            name: "BIG PINE KEY",
            disabled: false,
          },
          {
            name: "BIG RAPIDS",
            disabled: false,
          },
          {
            name: "BIG SPRING",
            disabled: false,
          },
          {
            name: "BIG STONE GAP",
            disabled: false,
          },
          {
            name: "BILLERICA",
            disabled: false,
          },
          {
            name: "BILLINGS",
            disabled: false,
          },
          {
            name: "BILOXI",
            disabled: false,
          },
          {
            name: "BINGHAMTON",
            disabled: false,
          },
          {
            name: "BIRCH RUN",
            disabled: false,
          },
          {
            name: "BIRMINGHAM",
            disabled: false,
          },
          {
            name: "BISBEE",
            disabled: false,
          },
          {
            name: "BISCOE",
            disabled: false,
          },
          {
            name: "BISHOP",
            disabled: false,
          },
          {
            name: "BISHOPVILLE",
            disabled: false,
          },
          {
            name: "BISMARCK",
            disabled: false,
          },
          {
            name: "BIXBY",
            disabled: false,
          },
          {
            name: "BLACK JACK",
            disabled: false,
          },
          {
            name: "BLACK MOUNTAIN",
            disabled: false,
          },
          {
            name: "BLACK RIVER FALLS",
            disabled: false,
          },
          {
            name: "BLACKFOOT",
            disabled: false,
          },
          {
            name: "BLACKLICK",
            disabled: false,
          },
          {
            name: "BLACKSBURG",
            disabled: false,
          },
          {
            name: "BLACKSHEAR",
            disabled: false,
          },
          {
            name: "BLACKSTONE",
            disabled: false,
          },
          {
            name: "BLACKWELL",
            disabled: false,
          },
          {
            name: "BLACKWOOD",
            disabled: false,
          },
          {
            name: "BLAINE",
            disabled: false,
          },
          {
            name: "BLAIR",
            disabled: false,
          },
          {
            name: "BLAIRSTOWN",
            disabled: false,
          },
          {
            name: "BLAIRSVILLE",
            disabled: false,
          },
          {
            name: "BLAKELY",
            disabled: false,
          },
          {
            name: "BLAKESLEE",
            disabled: false,
          },
          {
            name: "BLANCHESTER",
            disabled: false,
          },
          {
            name: "BLANDON",
            disabled: false,
          },
          {
            name: "BLASDELL",
            disabled: false,
          },
          {
            name: "BLOOMFIELD",
            disabled: false,
          },
          {
            name: "BLOOMFIELD HILLS",
            disabled: false,
          },
          {
            name: "BLOOMFIELD TWNS",
            disabled: false,
          },
          {
            name: "BLOOMINGDALE",
            disabled: false,
          },
          {
            name: "BLOOMINGTON",
            disabled: false,
          },
          {
            name: "BLOOMSBURG",
            disabled: false,
          },
          {
            name: "BLOUNTVILLE",
            disabled: false,
          },
          {
            name: "BLOWING ROCK",
            disabled: false,
          },
          {
            name: "BLUE ASH",
            disabled: false,
          },
          {
            name: "BLUE BELL",
            disabled: false,
          },
          {
            name: "BLUE HILL",
            disabled: false,
          },
          {
            name: "BLUE JAY",
            disabled: false,
          },
          {
            name: "BLUE RIDGE",
            disabled: false,
          },
          {
            name: "BLUE SPRINGS",
            disabled: false,
          },
          {
            name: "BLUEFIELD",
            disabled: false,
          },
          {
            name: "BLUFFTON",
            disabled: false,
          },
          {
            name: "BLYTHE",
            disabled: false,
          },
          {
            name: "BLYTHEVILLE",
            disabled: false,
          },
          {
            name: "BLYTHEWOOD",
            disabled: false,
          },
          {
            name: "BOARDMAN",
            disabled: false,
          },
          {
            name: "BOAZ",
            disabled: false,
          },
          {
            name: "BOCA RATON",
            disabled: false,
          },
          {
            name: "BOERNE",
            disabled: false,
          },
          {
            name: "BOGALUSA",
            disabled: false,
          },
          {
            name: "BOGOTA",
            disabled: false,
          },
          {
            name: "BOHEMIA",
            disabled: false,
          },
          {
            name: "BOILING SPRINGS",
            disabled: false,
          },
          {
            name: "BOISE",
            disabled: false,
          },
          {
            name: "BOLINGBROOK",
            disabled: false,
          },
          {
            name: "BOLIVAR",
            disabled: false,
          },
          {
            name: "BONAIRE",
            disabled: false,
          },
          {
            name: "BONHAM",
            disabled: false,
          },
          {
            name: "BONITA",
            disabled: false,
          },
          {
            name: "BONITA SPRINGS",
            disabled: false,
          },
          {
            name: "BONNER SPRINGS",
            disabled: false,
          },
          {
            name: "BONNERS FERRY",
            disabled: false,
          },
          {
            name: "BONNEY LAKE",
            disabled: false,
          },
          {
            name: "BOONE",
            disabled: false,
          },
          {
            name: "BOONEVILLE",
            disabled: false,
          },
          {
            name: "BOONTON",
            disabled: false,
          },
          {
            name: "BOONVILLE",
            disabled: false,
          },
          {
            name: "BOOTHBAY HARBOR",
            disabled: false,
          },
          {
            name: "BOOTHWYN",
            disabled: false,
          },
          {
            name: "BORDENTOWN",
            disabled: false,
          },
          {
            name: "BORGER",
            disabled: false,
          },
          {
            name: "BOSSIER CITY",
            disabled: false,
          },
          {
            name: "BOSTON",
            disabled: false,
          },
          {
            name: "BOSTON HEIGHTS",
            disabled: false,
          },
          {
            name: "BOTHELL",
            disabled: false,
          },
          {
            name: "BOTTINEAU",
            disabled: false,
          },
          {
            name: "BOULDER",
            disabled: false,
          },
          {
            name: "BOULDER CITY",
            disabled: false,
          },
          {
            name: "BOUND BROOK",
            disabled: false,
          },
          {
            name: "BOUNTIFUL",
            disabled: false,
          },
          {
            name: "BOURBONNAIS",
            disabled: false,
          },
          {
            name: "BOURNE",
            disabled: false,
          },
          {
            name: "BOUTTE",
            disabled: false,
          },
          {
            name: "BOWDON",
            disabled: false,
          },
          {
            name: "BOWIE",
            disabled: false,
          },
          {
            name: "BOWLING GREEN",
            disabled: false,
          },
          {
            name: "BOYDS",
            disabled: false,
          },
          {
            name: "BOYERTOWN",
            disabled: false,
          },
          {
            name: "BOYNTON BEACH",
            disabled: false,
          },
          {
            name: "BOZEMAN",
            disabled: false,
          },
          {
            name: "BRADEN RIVER",
            disabled: false,
          },
          {
            name: "BRADENTON",
            disabled: false,
          },
          {
            name: "BRADFORD",
            disabled: false,
          },
          {
            name: "BRADLEY",
            disabled: false,
          },
          {
            name: "BRADY",
            disabled: false,
          },
          {
            name: "BRAIDWOOD",
            disabled: false,
          },
          {
            name: "BRAINERD",
            disabled: false,
          },
          {
            name: "BRAINTREE",
            disabled: false,
          },
          {
            name: "BRANCHLAND",
            disabled: false,
          },
          {
            name: "BRANDENBURG",
            disabled: false,
          },
          {
            name: "BRANDON",
            disabled: false,
          },
          {
            name: "BRANDYWINE",
            disabled: false,
          },
          {
            name: "BRANFORD",
            disabled: false,
          },
          {
            name: "BRANSON",
            disabled: false,
          },
          {
            name: "BRANSON WEST",
            disabled: false,
          },
          {
            name: "BRATTLEBORO",
            disabled: false,
          },
          {
            name: "BRAWLEY",
            disabled: false,
          },
          {
            name: "BRAZIL",
            disabled: false,
          },
          {
            name: "BREA",
            disabled: false,
          },
          {
            name: "BREAUX BRIDGE",
            disabled: false,
          },
          {
            name: "BRECKENRIDGE",
            disabled: false,
          },
          {
            name: "BRECKSVILLE",
            disabled: false,
          },
          {
            name: "BREMEN",
            disabled: false,
          },
          {
            name: "BREMERTON",
            disabled: false,
          },
          {
            name: "BRENHAM",
            disabled: false,
          },
          {
            name: "BRENT",
            disabled: false,
          },
          {
            name: "BRENTWOOD",
            disabled: false,
          },
          {
            name: "BREVARD",
            disabled: false,
          },
          {
            name: "BREWER",
            disabled: false,
          },
          {
            name: "BREWSTER",
            disabled: false,
          },
          {
            name: "BREWTON",
            disabled: false,
          },
          {
            name: "BRIARCLIFF MANOR",
            disabled: false,
          },
          {
            name: "BRICK",
            disabled: false,
          },
          {
            name: "BRICK TOWNSHIP",
            disabled: false,
          },
          {
            name: "BRIDGE CITY",
            disabled: false,
          },
          {
            name: "BRIDGEPORT",
            disabled: false,
          },
          {
            name: "BRIDGETON",
            disabled: false,
          },
          {
            name: "BRIDGEVIEW",
            disabled: false,
          },
          {
            name: "BRIDGEVILLE",
            disabled: false,
          },
          {
            name: "BRIDGEWATER",
            disabled: false,
          },
          {
            name: "BRIDGMAN",
            disabled: false,
          },
          {
            name: "BRIGANTINE",
            disabled: false,
          },
          {
            name: "BRIGHAM CITY",
            disabled: false,
          },
          {
            name: "BRIGHTON",
            disabled: false,
          },
          {
            name: "BRISTOL",
            disabled: false,
          },
          {
            name: "BRISTOW",
            disabled: false,
          },
          {
            name: "BROADVIEW",
            disabled: false,
          },
          {
            name: "BROADVIEW HEIGHTS",
            disabled: false,
          },
          {
            name: "BROCKPORT",
            disabled: false,
          },
          {
            name: "BROCKTON",
            disabled: false,
          },
          {
            name: "BRODHEADSVILLE",
            disabled: false,
          },
          {
            name: "BROKEN ARROW",
            disabled: false,
          },
          {
            name: "BROKEN BOW",
            disabled: false,
          },
          {
            name: "BRONX",
            disabled: false,
          },
          {
            name: "BRONXVILLE",
            disabled: false,
          },
          {
            name: "BROOKFIELD",
            disabled: false,
          },
          {
            name: "BROOKHAVEN",
            disabled: false,
          },
          {
            name: "BROOKINGS",
            disabled: false,
          },
          {
            name: "BROOKLAWN",
            disabled: false,
          },
          {
            name: "BROOKLINE",
            disabled: false,
          },
          {
            name: "BROOKLYN",
            disabled: false,
          },
          {
            name: "BROOKLYN CENTER",
            disabled: false,
          },
          {
            name: "BROOKLYN PARK",
            disabled: false,
          },
          {
            name: "BROOKNEAL",
            disabled: false,
          },
          {
            name: "BROOKSHIRE",
            disabled: false,
          },
          {
            name: "BROOKSVILLE",
            disabled: false,
          },
          {
            name: "BROOKVILLE",
            disabled: false,
          },
          {
            name: "BROOMALL",
            disabled: false,
          },
          {
            name: "BROOMFIELD",
            disabled: false,
          },
          {
            name: "BROUSSARD",
            disabled: false,
          },
          {
            name: "BROWN DEER",
            disabled: false,
          },
          {
            name: "BROWNFIELD",
            disabled: false,
          },
          {
            name: "BROWNS MILLS",
            disabled: false,
          },
          {
            name: "BROWNSBURG",
            disabled: false,
          },
          {
            name: "BROWNSTOWN",
            disabled: false,
          },
          {
            name: "BROWNSVILLE",
            disabled: false,
          },
          {
            name: "BROWNWOOD",
            disabled: false,
          },
          {
            name: "BRUNSWICK",
            disabled: false,
          },
          {
            name: "BRYAN",
            disabled: false,
          },
          {
            name: "BRYANS ROAD",
            disabled: false,
          },
          {
            name: "BRYANT",
            disabled: false,
          },
          {
            name: "BRYN MAWR",
            disabled: false,
          },
          {
            name: "BRYSON CITY",
            disabled: false,
          },
          {
            name: "BUCHANAN",
            disabled: false,
          },
          {
            name: "BUCKEYE",
            disabled: false,
          },
          {
            name: "BUCKHANNON",
            disabled: false,
          },
          {
            name: "BUCKSPORT",
            disabled: false,
          },
          {
            name: "BUCYRUS",
            disabled: false,
          },
          {
            name: "BUDA",
            disabled: false,
          },
          {
            name: "BUDD LAKE",
            disabled: false,
          },
          {
            name: "BUELLTON",
            disabled: false,
          },
          {
            name: "BUENA PARK",
            disabled: false,
          },
          {
            name: "BUENA VISTA",
            disabled: false,
          },
          {
            name: "BUFFALO",
            disabled: false,
          },
          {
            name: "BUFFALO GROVE",
            disabled: false,
          },
          {
            name: "BUFORD",
            disabled: false,
          },
          {
            name: "BULLHEAD CITY",
            disabled: false,
          },
          {
            name: "BUNN",
            disabled: false,
          },
          {
            name: "BURBANK",
            disabled: false,
          },
          {
            name: "BURGAW",
            disabled: false,
          },
          {
            name: "BURGETTSTOWN",
            disabled: false,
          },
          {
            name: "BURIEN",
            disabled: false,
          },
          {
            name: "BURKBURNETT",
            disabled: false,
          },
          {
            name: "BURKE",
            disabled: false,
          },
          {
            name: "BURLESON",
            disabled: false,
          },
          {
            name: "BURLEY",
            disabled: false,
          },
          {
            name: "BURLINGAME",
            disabled: false,
          },
          {
            name: "BURLINGTON",
            disabled: false,
          },
          {
            name: "BURNET",
            disabled: false,
          },
          {
            name: "BURNEY",
            disabled: false,
          },
          {
            name: "BURNHAM",
            disabled: false,
          },
          {
            name: "BURNS",
            disabled: false,
          },
          {
            name: "BURNSVILLE",
            disabled: false,
          },
          {
            name: "BURNT HILLS",
            disabled: false,
          },
          {
            name: "BURTON",
            disabled: false,
          },
          {
            name: "BURTONSVILLE",
            disabled: false,
          },
          {
            name: "BUSHNELL",
            disabled: false,
          },
          {
            name: "BUTLER",
            disabled: false,
          },
          {
            name: "BUTTE",
            disabled: false,
          },
          {
            name: "BUXTON",
            disabled: false,
          },
          {
            name: "BYRAM",
            disabled: false,
          },
          {
            name: "BYRON CENTER",
            disabled: false,
          },
          {
            name: "Bakersfield",
            disabled: false,
          },
          {
            name: "Bannockburn",
            disabled: false,
          },
          {
            name: "Baytown",
            disabled: false,
          },
          {
            name: "Bedford",
            disabled: false,
          },
          {
            name: "Bee Cave",
            disabled: false,
          },
          {
            name: "Belleville",
            disabled: false,
          },
          {
            name: "Bellevue",
            disabled: false,
          },
          {
            name: "Bellflower",
            disabled: false,
          },
          {
            name: "Benwood",
            disabled: false,
          },
          {
            name: "Berkeley",
            disabled: false,
          },
          {
            name: "Bethesda",
            disabled: false,
          },
          {
            name: "Birmingham",
            disabled: false,
          },
          {
            name: "Bloomfield",
            disabled: false,
          },
          {
            name: "Bloomfield Hills",
            disabled: false,
          },
          {
            name: "Bloomingdale",
            disabled: false,
          },
          {
            name: "Blue Ash",
            disabled: false,
          },
          {
            name: "Bluewell",
            disabled: false,
          },
          {
            name: "Bluffdale",
            disabled: false,
          },
          {
            name: "Blytheville",
            disabled: false,
          },
          {
            name: "Bolingbrook",
            disabled: false,
          },
          {
            name: "Boston",
            disabled: false,
          },
          {
            name: "Bothell",
            disabled: false,
          },
          {
            name: "Boulder",
            disabled: false,
          },
          {
            name: "Braintree",
            disabled: false,
          },
          {
            name: "Breckenridge",
            disabled: false,
          },
          {
            name: "Bremerton",
            disabled: false,
          },
          {
            name: "Brighton",
            disabled: false,
          },
          {
            name: "Brighton Township",
            disabled: false,
          },
          {
            name: "Brinkley",
            disabled: false,
          },
          {
            name: "Bronx",
            disabled: false,
          },
          {
            name: "Brookfield",
            disabled: false,
          },
          {
            name: "Brookhaven",
            disabled: false,
          },
          {
            name: "Brooklyn",
            disabled: false,
          },
          {
            name: "Brown Deer",
            disabled: false,
          },
          {
            name: "Brownsburg",
            disabled: false,
          },
          {
            name: "Brownstown",
            disabled: false,
          },
          {
            name: "Brownstown Township",
            disabled: false,
          },
          {
            name: "Brownstown Twp",
            disabled: false,
          },
          {
            name: "Brownsville",
            disabled: false,
          },
          {
            name: "Brownwood",
            disabled: false,
          },
          {
            name: "Buena Park",
            disabled: false,
          },
          {
            name: "Buena Vista",
            disabled: false,
          },
          {
            name: "Buford",
            disabled: false,
          },
          {
            name: "Burbank",
            disabled: false,
          },
          {
            name: "Burien",
            disabled: false,
          },
          {
            name: "Burlington",
            disabled: false,
          },
          {
            name: "CABOT",
            disabled: false,
          },
          {
            name: "CADILLAC",
            disabled: false,
          },
          {
            name: "CADIZ",
            disabled: false,
          },
          {
            name: "CAGUAS",
            disabled: false,
          },
          {
            name: "CAGUAS, BAIROA",
            disabled: false,
          },
          {
            name: "CAHOKIA",
            disabled: false,
          },
          {
            name: "CAIRO",
            disabled: false,
          },
          {
            name: "CALABASAS",
            disabled: false,
          },
          {
            name: "CALABASH",
            disabled: false,
          },
          {
            name: "CALAIS",
            disabled: false,
          },
          {
            name: "CALDWELL",
            disabled: false,
          },
          {
            name: "CALEDONIA",
            disabled: false,
          },
          {
            name: "CALERA",
            disabled: false,
          },
          {
            name: "CALEXICO",
            disabled: false,
          },
          {
            name: "CALHOUN",
            disabled: false,
          },
          {
            name: "CALIFON",
            disabled: false,
          },
          {
            name: "CALIFORNIA",
            disabled: false,
          },
          {
            name: "CALIFORNIA CITY",
            disabled: false,
          },
          {
            name: "CALIMESA",
            disabled: false,
          },
          {
            name: "CALLAHAN",
            disabled: false,
          },
          {
            name: "CALLAO",
            disabled: false,
          },
          {
            name: "CALLAWAY",
            disabled: false,
          },
          {
            name: "CALUMET CITY",
            disabled: false,
          },
          {
            name: "CALUMET PARK",
            disabled: false,
          },
          {
            name: "CAMARILLO",
            disabled: false,
          },
          {
            name: "CAMAS",
            disabled: false,
          },
          {
            name: "CAMBRIDGE",
            disabled: false,
          },
          {
            name: "CAMBRIDGE CITY",
            disabled: false,
          },
          {
            name: "CAMBY",
            disabled: false,
          },
          {
            name: "CAMDEN",
            disabled: false,
          },
          {
            name: "CAMDENTON",
            disabled: false,
          },
          {
            name: "CAMERON",
            disabled: false,
          },
          {
            name: "CAMERON PARK",
            disabled: false,
          },
          {
            name: "CAMILLA",
            disabled: false,
          },
          {
            name: "CAMILLUS",
            disabled: false,
          },
          {
            name: "CAMP HILL",
            disabled: false,
          },
          {
            name: "CAMP SPRINGS",
            disabled: false,
          },
          {
            name: "CAMP VERDE",
            disabled: false,
          },
          {
            name: "CAMPBELL",
            disabled: false,
          },
          {
            name: "CAMPBELLSVILLE",
            disabled: false,
          },
          {
            name: "CANAAN",
            disabled: false,
          },
          {
            name: "CANAL FULTON",
            disabled: false,
          },
          {
            name: "CANAL WINCHESTER",
            disabled: false,
          },
          {
            name: "CANANDAIGUA",
            disabled: false,
          },
          {
            name: "CANBY",
            disabled: false,
          },
          {
            name: "CANDLER",
            disabled: false,
          },
          {
            name: "CANFIELD",
            disabled: false,
          },
          {
            name: "CANOGA PARK",
            disabled: false,
          },
          {
            name: "CANON CITY",
            disabled: false,
          },
          {
            name: "CANONSBURG",
            disabled: false,
          },
          {
            name: "CANOVANAS",
            disabled: false,
          },
          {
            name: "CANTERBURY",
            disabled: false,
          },
          {
            name: "CANTON",
            disabled: false,
          },
          {
            name: "CANTONMENT",
            disabled: false,
          },
          {
            name: "CANYON",
            disabled: false,
          },
          {
            name: "CANYON COUNTRY",
            disabled: false,
          },
          {
            name: "CANYON LAKE",
            disabled: false,
          },
          {
            name: "CAPE CARTERET",
            disabled: false,
          },
          {
            name: "CAPE CHARLES",
            disabled: false,
          },
          {
            name: "CAPE CORAL",
            disabled: false,
          },
          {
            name: "CAPE GIRARDEAU",
            disabled: false,
          },
          {
            name: "CAPE MAY",
            disabled: false,
          },
          {
            name: "CAPE MAY COURT HOUSE",
            disabled: false,
          },
          {
            name: "CAPITOL HEIGHTS",
            disabled: false,
          },
          {
            name: "CAPITOLA",
            disabled: false,
          },
          {
            name: "CARBONDALE",
            disabled: false,
          },
          {
            name: "CARENCRO",
            disabled: false,
          },
          {
            name: "CARIBOU",
            disabled: false,
          },
          {
            name: "CARLE PLACE",
            disabled: false,
          },
          {
            name: "CARLINVILLE",
            disabled: false,
          },
          {
            name: "CARLISLE",
            disabled: false,
          },
          {
            name: "CARLSBAD",
            disabled: false,
          },
          {
            name: "CARLSTADT",
            disabled: false,
          },
          {
            name: "CARLYLE",
            disabled: false,
          },
          {
            name: "CARMEL",
            disabled: false,
          },
          {
            name: "CARMI",
            disabled: false,
          },
          {
            name: "CARMICHAEL",
            disabled: false,
          },
          {
            name: "CARNEGIE",
            disabled: false,
          },
          {
            name: "CARO",
            disabled: false,
          },
          {
            name: "CAROL CITY",
            disabled: false,
          },
          {
            name: "CAROL STREAM",
            disabled: false,
          },
          {
            name: "CAROLINA",
            disabled: false,
          },
          {
            name: "CAROLINA BEACH",
            disabled: false,
          },
          {
            name: "CARPENTERSVILLE",
            disabled: false,
          },
          {
            name: "CARPINTERIA",
            disabled: false,
          },
          {
            name: "CARRBORO",
            disabled: false,
          },
          {
            name: "CARRIZO SPRINGS",
            disabled: false,
          },
          {
            name: "CARROLL",
            disabled: false,
          },
          {
            name: "CARROLLTON",
            disabled: false,
          },
          {
            name: "CARSON",
            disabled: false,
          },
          {
            name: "CARSON CITY",
            disabled: false,
          },
          {
            name: "CARTERET",
            disabled: false,
          },
          {
            name: "CARTERSVILLE",
            disabled: false,
          },
          {
            name: "CARTHAGE",
            disabled: false,
          },
          {
            name: "CARVER",
            disabled: false,
          },
          {
            name: "CARY",
            disabled: false,
          },
          {
            name: "CASA GRANDE",
            disabled: false,
          },
          {
            name: "CASPER",
            disabled: false,
          },
          {
            name: "CASSELBERRY",
            disabled: false,
          },
          {
            name: "CASSOPOLIS",
            disabled: false,
          },
          {
            name: "CASSVILLE",
            disabled: false,
          },
          {
            name: "CASTAIC",
            disabled: false,
          },
          {
            name: "CASTLE HAYNE",
            disabled: false,
          },
          {
            name: "CASTLE HILLS",
            disabled: false,
          },
          {
            name: "CASTLE ROCK",
            disabled: false,
          },
          {
            name: "CASTLETON",
            disabled: false,
          },
          {
            name: "CASTRO VALLEY",
            disabled: false,
          },
          {
            name: "CASTROVILLE",
            disabled: false,
          },
          {
            name: "CATHEDRAL CITY",
            disabled: false,
          },
          {
            name: "CATLETTSBURG",
            disabled: false,
          },
          {
            name: "CATONSVILLE",
            disabled: false,
          },
          {
            name: "CATOOSA",
            disabled: false,
          },
          {
            name: "CATSKILL",
            disabled: false,
          },
          {
            name: "CAVE CREEK",
            disabled: false,
          },
          {
            name: "CAYCE",
            disabled: false,
          },
          {
            name: "CAYEY",
            disabled: false,
          },
          {
            name: "CAZENOVIA",
            disabled: false,
          },
          {
            name: "CEDAR CITY",
            disabled: false,
          },
          {
            name: "CEDAR FALLS",
            disabled: false,
          },
          {
            name: "CEDAR GROVE",
            disabled: false,
          },
          {
            name: "CEDAR HILL",
            disabled: false,
          },
          {
            name: "CEDAR HILLS",
            disabled: false,
          },
          {
            name: "CEDAR KNOLLS",
            disabled: false,
          },
          {
            name: "CEDAR LAKE",
            disabled: false,
          },
          {
            name: "CEDAR PARK",
            disabled: false,
          },
          {
            name: "CEDAR RAPIDS",
            disabled: false,
          },
          {
            name: "CEDAR SPRINGS",
            disabled: false,
          },
          {
            name: "CEDARBURG",
            disabled: false,
          },
          {
            name: "CEDARHURST",
            disabled: false,
          },
          {
            name: "CEDARTOWN",
            disabled: false,
          },
          {
            name: "CELINA",
            disabled: false,
          },
          {
            name: "CENTENNIAL",
            disabled: false,
          },
          {
            name: "CENTER",
            disabled: false,
          },
          {
            name: "CENTER CONWAY",
            disabled: false,
          },
          {
            name: "CENTER LINE",
            disabled: false,
          },
          {
            name: "CENTER MORICHES",
            disabled: false,
          },
          {
            name: "CENTER POINT",
            disabled: false,
          },
          {
            name: "CENTEREACH",
            disabled: false,
          },
          {
            name: "CENTERTON",
            disabled: false,
          },
          {
            name: "CENTERVILLE",
            disabled: false,
          },
          {
            name: "CENTRAL",
            disabled: false,
          },
          {
            name: "CENTRAL CITY",
            disabled: false,
          },
          {
            name: "CENTRAL FALLS",
            disabled: false,
          },
          {
            name: "CENTRAL ISLIP",
            disabled: false,
          },
          {
            name: "CENTRAL POINT",
            disabled: false,
          },
          {
            name: "CENTRAL SQUARE",
            disabled: false,
          },
          {
            name: "CENTRALIA",
            disabled: false,
          },
          {
            name: "CENTRE",
            disabled: false,
          },
          {
            name: "CENTREVILLE",
            disabled: false,
          },
          {
            name: "CENTURY",
            disabled: false,
          },
          {
            name: "CERES",
            disabled: false,
          },
          {
            name: "CERRITOS",
            disabled: false,
          },
          {
            name: "CHADBOURN",
            disabled: false,
          },
          {
            name: "CHADDS FORD",
            disabled: false,
          },
          {
            name: "CHADRON",
            disabled: false,
          },
          {
            name: "CHAGRIN FALLS",
            disabled: false,
          },
          {
            name: "CHALFONT",
            disabled: false,
          },
          {
            name: "CHALMETTE",
            disabled: false,
          },
          {
            name: "CHAMBERSBURG",
            disabled: false,
          },
          {
            name: "CHAMBLEE",
            disabled: false,
          },
          {
            name: "CHAMPAIGN",
            disabled: false,
          },
          {
            name: "CHAMPLIN",
            disabled: false,
          },
          {
            name: "CHANDLER",
            disabled: false,
          },
          {
            name: "CHANHASSEN",
            disabled: false,
          },
          {
            name: "CHANNAHON",
            disabled: false,
          },
          {
            name: "CHANNELVIEW",
            disabled: false,
          },
          {
            name: "CHANTILLY",
            disabled: false,
          },
          {
            name: "CHANUTE",
            disabled: false,
          },
          {
            name: "CHAPEL HILL",
            disabled: false,
          },
          {
            name: "CHAPIN",
            disabled: false,
          },
          {
            name: "CHAPMANVILLE",
            disabled: false,
          },
          {
            name: "CHAPPAQUA",
            disabled: false,
          },
          {
            name: "CHARDON",
            disabled: false,
          },
          {
            name: "CHARLEROI",
            disabled: false,
          },
          {
            name: "CHARLES TOWN",
            disabled: false,
          },
          {
            name: "CHARLESTON",
            disabled: false,
          },
          {
            name: "CHARLESTOWN",
            disabled: false,
          },
          {
            name: "CHARLEVOIX",
            disabled: false,
          },
          {
            name: "CHARLOTTE",
            disabled: false,
          },
          {
            name: "CHARLOTTE HALL",
            disabled: false,
          },
          {
            name: "CHARLOTTESVILLE",
            disabled: false,
          },
          {
            name: "CHARLTON",
            disabled: false,
          },
          {
            name: "CHASE CITY",
            disabled: false,
          },
          {
            name: "CHASKA",
            disabled: false,
          },
          {
            name: "CHATHAM",
            disabled: false,
          },
          {
            name: "CHATSWORTH",
            disabled: false,
          },
          {
            name: "CHATTANOOGA",
            disabled: false,
          },
          {
            name: "CHEBOYGAN",
            disabled: false,
          },
          {
            name: "CHECOTAH",
            disabled: false,
          },
          {
            name: "CHEEKTOWAGA",
            disabled: false,
          },
          {
            name: "CHEHALIS",
            disabled: false,
          },
          {
            name: "CHELAN",
            disabled: false,
          },
          {
            name: "CHELMSFORD",
            disabled: false,
          },
          {
            name: "CHELSEA",
            disabled: false,
          },
          {
            name: "CHENEY",
            disabled: false,
          },
          {
            name: "CHERAW",
            disabled: false,
          },
          {
            name: "CHERRY HILL",
            disabled: false,
          },
          {
            name: "CHERRYVILLE",
            disabled: false,
          },
          {
            name: "CHESAPEAKE",
            disabled: false,
          },
          {
            name: "CHESAPEAKE BEACH",
            disabled: false,
          },
          {
            name: "CHESHIRE",
            disabled: false,
          },
          {
            name: "CHESNEE",
            disabled: false,
          },
          {
            name: "CHESTER",
            disabled: false,
          },
          {
            name: "CHESTER SPRINGS",
            disabled: false,
          },
          {
            name: "CHESTERFIELD",
            disabled: false,
          },
          {
            name: "CHESTERLAND",
            disabled: false,
          },
          {
            name: "CHESTERTON",
            disabled: false,
          },
          {
            name: "CHESTERTOWN",
            disabled: false,
          },
          {
            name: "CHESTNUT HILL",
            disabled: false,
          },
          {
            name: "CHESWICK",
            disabled: false,
          },
          {
            name: "CHEVERLY",
            disabled: false,
          },
          {
            name: "CHEVIOT",
            disabled: false,
          },
          {
            name: "CHEWELAH",
            disabled: false,
          },
          {
            name: "CHEYENNE",
            disabled: false,
          },
          {
            name: "CHICAGO",
            disabled: false,
          },
          {
            name: "CHICAGO HEIGHTS",
            disabled: false,
          },
          {
            name: "CHICKAMAUGA",
            disabled: false,
          },
          {
            name: "CHICKASAW",
            disabled: false,
          },
          {
            name: "CHICKASHA",
            disabled: false,
          },
          {
            name: "CHICO",
            disabled: false,
          },
          {
            name: "CHICOPEE",
            disabled: false,
          },
          {
            name: "CHIEFLAND",
            disabled: false,
          },
          {
            name: "CHILDERSBURG",
            disabled: false,
          },
          {
            name: "CHILDRESS",
            disabled: false,
          },
          {
            name: "CHILLICOTHE",
            disabled: false,
          },
          {
            name: "CHILTON",
            disabled: false,
          },
          {
            name: "CHINA GROVE",
            disabled: false,
          },
          {
            name: "CHINO",
            disabled: false,
          },
          {
            name: "CHINO HILLS",
            disabled: false,
          },
          {
            name: "CHINO VALLEY",
            disabled: false,
          },
          {
            name: "CHIPLEY",
            disabled: false,
          },
          {
            name: "CHIPPEWA FALLS",
            disabled: false,
          },
          {
            name: "CHOCOWINITY",
            disabled: false,
          },
          {
            name: "CHOCTAW",
            disabled: false,
          },
          {
            name: "CHOWCHILLA",
            disabled: false,
          },
          {
            name: "CHRISTIANSBURG",
            disabled: false,
          },
          {
            name: "CHUBBUCK",
            disabled: false,
          },
          {
            name: "CHULA VISTA",
            disabled: false,
          },
          {
            name: "CHURCH HILL",
            disabled: false,
          },
          {
            name: "CIBOLO",
            disabled: false,
          },
          {
            name: "CICERO",
            disabled: false,
          },
          {
            name: "CINCINNATI",
            disabled: false,
          },
          {
            name: "CINNAMINSON",
            disabled: false,
          },
          {
            name: "CIRCLE PINES",
            disabled: false,
          },
          {
            name: "CIRCLEVILLE",
            disabled: false,
          },
          {
            name: "CITRONELLE",
            disabled: false,
          },
          {
            name: "CITRUS HEIGHTS",
            disabled: false,
          },
          {
            name: "CITRUS HILLS",
            disabled: false,
          },
          {
            name: "CITY OF INDUSTR",
            disabled: false,
          },
          {
            name: "CITY OF INDUSTRY",
            disabled: false,
          },
          {
            name: "CLACKAMAS",
            disabled: false,
          },
          {
            name: "CLAIRTON",
            disabled: false,
          },
          {
            name: "CLANTON",
            disabled: false,
          },
          {
            name: "CLARE",
            disabled: false,
          },
          {
            name: "CLAREMONT",
            disabled: false,
          },
          {
            name: "CLAREMORE",
            disabled: false,
          },
          {
            name: "CLARENCE",
            disabled: false,
          },
          {
            name: "CLARENDON HILLS",
            disabled: false,
          },
          {
            name: "CLARION",
            disabled: false,
          },
          {
            name: "CLARK",
            disabled: false,
          },
          {
            name: "CLARKESVILLE",
            disabled: false,
          },
          {
            name: "CLARKS SUMMIT",
            disabled: false,
          },
          {
            name: "CLARKSBURG",
            disabled: false,
          },
          {
            name: "CLARKSDALE",
            disabled: false,
          },
          {
            name: "CLARKSTON",
            disabled: false,
          },
          {
            name: "CLARKSVILLE",
            disabled: false,
          },
          {
            name: "CLATSKANIE",
            disabled: false,
          },
          {
            name: "CLAWSON",
            disabled: false,
          },
          {
            name: "CLAXTON",
            disabled: false,
          },
          {
            name: "CLAY",
            disabled: false,
          },
          {
            name: "CLAYMONT",
            disabled: false,
          },
          {
            name: "CLAYPOOL",
            disabled: false,
          },
          {
            name: "CLAYTON",
            disabled: false,
          },
          {
            name: "CLE ELUM",
            disabled: false,
          },
          {
            name: "CLEAR LAKE SHORES",
            disabled: false,
          },
          {
            name: "CLEARFIELD",
            disabled: false,
          },
          {
            name: "CLEARLAKE",
            disabled: false,
          },
          {
            name: "CLEARWATER",
            disabled: false,
          },
          {
            name: "CLEBURNE",
            disabled: false,
          },
          {
            name: "CLEMENTON",
            disabled: false,
          },
          {
            name: "CLEMMONS",
            disabled: false,
          },
          {
            name: "CLEMSON",
            disabled: false,
          },
          {
            name: "CLENDENIN",
            disabled: false,
          },
          {
            name: "CLEONA",
            disabled: false,
          },
          {
            name: "CLERMONT",
            disabled: false,
          },
          {
            name: "CLEVELAND",
            disabled: false,
          },
          {
            name: "CLEVELAND HEIGHTS",
            disabled: false,
          },
          {
            name: "CLEVES",
            disabled: false,
          },
          {
            name: "CLEWISTON",
            disabled: false,
          },
          {
            name: "CLIFTON",
            disabled: false,
          },
          {
            name: "CLIFTON FORGE",
            disabled: false,
          },
          {
            name: "CLIFTON HEIGHTS",
            disabled: false,
          },
          {
            name: "CLIFTON PARK",
            disabled: false,
          },
          {
            name: "CLINTON",
            disabled: false,
          },
          {
            name: "CLINTON TOWNSHIP",
            disabled: false,
          },
          {
            name: "CLINTONVILLE",
            disabled: false,
          },
          {
            name: "CLIO",
            disabled: false,
          },
          {
            name: "CLIVE",
            disabled: false,
          },
          {
            name: "CLOQUET",
            disabled: false,
          },
          {
            name: "CLOSTER",
            disabled: false,
          },
          {
            name: "CLOVER",
            disabled: false,
          },
          {
            name: "CLOVERDALE",
            disabled: false,
          },
          {
            name: "CLOVIS",
            disabled: false,
          },
          {
            name: "CLUTE",
            disabled: false,
          },
          {
            name: "CLYDE",
            disabled: false,
          },
          {
            name: "COACHELLA",
            disabled: false,
          },
          {
            name: "COAL CITY",
            disabled: false,
          },
          {
            name: "COAL TOWNSHIP",
            disabled: false,
          },
          {
            name: "COALINGA",
            disabled: false,
          },
          {
            name: "COATESVILLE",
            disabled: false,
          },
          {
            name: "COBLESKILL",
            disabled: false,
          },
          {
            name: "COCHRAN",
            disabled: false,
          },
          {
            name: "COCKEYSVILLE",
            disabled: false,
          },
          {
            name: "COCOA",
            disabled: false,
          },
          {
            name: "COCOA BEACH",
            disabled: false,
          },
          {
            name: "COCONUT CREEK",
            disabled: false,
          },
          {
            name: "COCONUT GROVE",
            disabled: false,
          },
          {
            name: "CODY",
            disabled: false,
          },
          {
            name: "COEUR D ALENE",
            disabled: false,
          },
          {
            name: "COEUR D' ALENE",
            disabled: false,
          },
          {
            name: "COEUR D'ALENE",
            disabled: false,
          },
          {
            name: "COFFEYVILLE",
            disabled: false,
          },
          {
            name: "COHASSET",
            disabled: false,
          },
          {
            name: "COHOES",
            disabled: false,
          },
          {
            name: "COLBY",
            disabled: false,
          },
          {
            name: "COLCHESTER",
            disabled: false,
          },
          {
            name: "COLD SPRING",
            disabled: false,
          },
          {
            name: "COLDWATER",
            disabled: false,
          },
          {
            name: "COLEBROOK",
            disabled: false,
          },
          {
            name: "COLLEGE PARK",
            disabled: false,
          },
          {
            name: "COLLEGE PLACE",
            disabled: false,
          },
          {
            name: "COLLEGE POINT",
            disabled: false,
          },
          {
            name: "COLLEGE STATION",
            disabled: false,
          },
          {
            name: "COLLEGEVILLE",
            disabled: false,
          },
          {
            name: "COLLEYVILLE",
            disabled: false,
          },
          {
            name: "COLLIERVILLE",
            disabled: false,
          },
          {
            name: "COLLINGSWOOD",
            disabled: false,
          },
          {
            name: "COLLINSVILLE",
            disabled: false,
          },
          {
            name: "COLMA",
            disabled: false,
          },
          {
            name: "COLMAR MANOR",
            disabled: false,
          },
          {
            name: "COLOMA",
            disabled: false,
          },
          {
            name: "COLONIA",
            disabled: false,
          },
          {
            name: "COLONIAL BEACH",
            disabled: false,
          },
          {
            name: "COLONIAL HEIGHTS",
            disabled: false,
          },
          {
            name: "COLONIE",
            disabled: false,
          },
          {
            name: "COLONY",
            disabled: false,
          },
          {
            name: "COLORADO SPRING",
            disabled: false,
          },
          {
            name: "COLORADO SPRINGS",
            disabled: false,
          },
          {
            name: "COLQUITT",
            disabled: false,
          },
          {
            name: "COLTON",
            disabled: false,
          },
          {
            name: "COLUMBIA",
            disabled: false,
          },
          {
            name: "COLUMBIA CITY",
            disabled: false,
          },
          {
            name: "COLUMBIA FALLS",
            disabled: false,
          },
          {
            name: "COLUMBIANA",
            disabled: false,
          },
          {
            name: "COLUMBUS",
            disabled: false,
          },
          {
            name: "COLUSA",
            disabled: false,
          },
          {
            name: "COLVILLE",
            disabled: false,
          },
          {
            name: "COMMACK",
            disabled: false,
          },
          {
            name: "COMMERCE",
            disabled: false,
          },
          {
            name: "COMMERCE CITY",
            disabled: false,
          },
          {
            name: "COMMERCE TOWNSH",
            disabled: false,
          },
          {
            name: "COMMERCE TOWNSHIP",
            disabled: false,
          },
          {
            name: "COMPTON",
            disabled: false,
          },
          {
            name: "COMSTOCK PARK",
            disabled: false,
          },
          {
            name: "CONCORD",
            disabled: false,
          },
          {
            name: "CONCORDIA",
            disabled: false,
          },
          {
            name: "CONIFER",
            disabled: false,
          },
          {
            name: "CONNEAUT",
            disabled: false,
          },
          {
            name: "CONNEAUT LAKE",
            disabled: false,
          },
          {
            name: "CONNELLSVILLE",
            disabled: false,
          },
          {
            name: "CONNERSVILLE",
            disabled: false,
          },
          {
            name: "CONOVER",
            disabled: false,
          },
          {
            name: "CONROE",
            disabled: false,
          },
          {
            name: "CONSHOHOCKEN",
            disabled: false,
          },
          {
            name: "CONVERSE",
            disabled: false,
          },
          {
            name: "CONWAY",
            disabled: false,
          },
          {
            name: "CONYERS",
            disabled: false,
          },
          {
            name: "COOKEVILLE",
            disabled: false,
          },
          {
            name: "COOLIDGE",
            disabled: false,
          },
          {
            name: "COON RAPIDS",
            disabled: false,
          },
          {
            name: "COOPER CITY",
            disabled: false,
          },
          {
            name: "COOPERSBURG",
            disabled: false,
          },
          {
            name: "COOPERSVILLE",
            disabled: false,
          },
          {
            name: "COOS BAY",
            disabled: false,
          },
          {
            name: "COPIAGUE",
            disabled: false,
          },
          {
            name: "COPLAY",
            disabled: false,
          },
          {
            name: "COPLEY",
            disabled: false,
          },
          {
            name: "COPPELL",
            disabled: false,
          },
          {
            name: "COPPERAS COVE",
            disabled: false,
          },
          {
            name: "COQUILLE",
            disabled: false,
          },
          {
            name: "CORAL GABLES",
            disabled: false,
          },
          {
            name: "CORAL SPRINGS",
            disabled: false,
          },
          {
            name: "CORALVILLE",
            disabled: false,
          },
          {
            name: "CORAM",
            disabled: false,
          },
          {
            name: "CORAOPOLIS",
            disabled: false,
          },
          {
            name: "CORBIN",
            disabled: false,
          },
          {
            name: "CORCORAN",
            disabled: false,
          },
          {
            name: "CORDELE",
            disabled: false,
          },
          {
            name: "CORDOVA",
            disabled: false,
          },
          {
            name: "CORINTH",
            disabled: false,
          },
          {
            name: "CORNELIA",
            disabled: false,
          },
          {
            name: "CORNELIUS",
            disabled: false,
          },
          {
            name: "CORNING",
            disabled: false,
          },
          {
            name: "CORNISH",
            disabled: false,
          },
          {
            name: "CORNWALL",
            disabled: false,
          },
          {
            name: "CORNWELLS HEIGHTS",
            disabled: false,
          },
          {
            name: "CORONA",
            disabled: false,
          },
          {
            name: "CORONA DEL MAR",
            disabled: false,
          },
          {
            name: "CORONADO",
            disabled: false,
          },
          {
            name: "CORPUS CHRISTI",
            disabled: false,
          },
          {
            name: "CORRY",
            disabled: false,
          },
          {
            name: "CORRYTON",
            disabled: false,
          },
          {
            name: "CORSICANA",
            disabled: false,
          },
          {
            name: "CORTE MADERA",
            disabled: false,
          },
          {
            name: "CORTEZ",
            disabled: false,
          },
          {
            name: "CORTLAND",
            disabled: false,
          },
          {
            name: "CORUNNA",
            disabled: false,
          },
          {
            name: "CORVALLIS",
            disabled: false,
          },
          {
            name: "CORYDON",
            disabled: false,
          },
          {
            name: "COS COB",
            disabled: false,
          },
          {
            name: "COSHOCTON",
            disabled: false,
          },
          {
            name: "COSTA MESA",
            disabled: false,
          },
          {
            name: "COTATI",
            disabled: false,
          },
          {
            name: "COTTAGE GROVE",
            disabled: false,
          },
          {
            name: "COTTONWOOD",
            disabled: false,
          },
          {
            name: "COTTONWOOD HEIGHTS",
            disabled: false,
          },
          {
            name: "COUDERSPORT",
            disabled: false,
          },
          {
            name: "COUNCIL BLUFFS",
            disabled: false,
          },
          {
            name: "COUNTRY CLUB HILLS",
            disabled: false,
          },
          {
            name: "COUNTRYSIDE",
            disabled: false,
          },
          {
            name: "COURTLAND",
            disabled: false,
          },
          {
            name: "COVENTRY",
            disabled: false,
          },
          {
            name: "COVINA",
            disabled: false,
          },
          {
            name: "COVINGTON",
            disabled: false,
          },
          {
            name: "COVINGTON TOWNS",
            disabled: false,
          },
          {
            name: "COVINGTON TWP",
            disabled: false,
          },
          {
            name: "COWETA",
            disabled: false,
          },
          {
            name: "CRAFTON",
            disabled: false,
          },
          {
            name: "CRAIG",
            disabled: false,
          },
          {
            name: "CRAIGSVILLE",
            disabled: false,
          },
          {
            name: "CRAMERTON",
            disabled: false,
          },
          {
            name: "CRANBERRY",
            disabled: false,
          },
          {
            name: "CRANBERRY TOWNS",
            disabled: false,
          },
          {
            name: "CRANBERRY TOWNSHIP",
            disabled: false,
          },
          {
            name: "CRANBERRY TWP",
            disabled: false,
          },
          {
            name: "CRANFORD",
            disabled: false,
          },
          {
            name: "CRANSTON",
            disabled: false,
          },
          {
            name: "CRAWFORDSVILLE",
            disabled: false,
          },
          {
            name: "CRAWFORDVILLE",
            disabled: false,
          },
          {
            name: "CREEDMOOR",
            disabled: false,
          },
          {
            name: "CRESCENT CITY",
            disabled: false,
          },
          {
            name: "CRESCENT SPRINGS",
            disabled: false,
          },
          {
            name: "CRESCO",
            disabled: false,
          },
          {
            name: "CRESSKILL",
            disabled: false,
          },
          {
            name: "CRESSON",
            disabled: false,
          },
          {
            name: "CREST HILL",
            disabled: false,
          },
          {
            name: "CRESTLINE",
            disabled: false,
          },
          {
            name: "CRESTON",
            disabled: false,
          },
          {
            name: "CRESTVIEW",
            disabled: false,
          },
          {
            name: "CRESTWOOD",
            disabled: false,
          },
          {
            name: "CRETE",
            disabled: false,
          },
          {
            name: "CREVE COEUR",
            disabled: false,
          },
          {
            name: "CRISFIELD",
            disabled: false,
          },
          {
            name: "CROCKETT",
            disabled: false,
          },
          {
            name: "CROFTON",
            disabled: false,
          },
          {
            name: "CROMWELL",
            disabled: false,
          },
          {
            name: "CROOKSTON",
            disabled: false,
          },
          {
            name: "CROSBY",
            disabled: false,
          },
          {
            name: "CROSS LANES",
            disabled: false,
          },
          {
            name: "CROSS PLAINS",
            disabled: false,
          },
          {
            name: "CROSS ROADS",
            disabled: false,
          },
          {
            name: "CROSSETT",
            disabled: false,
          },
          {
            name: "CROSSROADS",
            disabled: false,
          },
          {
            name: "CROSSVILLE",
            disabled: false,
          },
          {
            name: "CROWLEY",
            disabled: false,
          },
          {
            name: "CROWN POINT",
            disabled: false,
          },
          {
            name: "CROYDON",
            disabled: false,
          },
          {
            name: "CRYSTAL",
            disabled: false,
          },
          {
            name: "CRYSTAL CITY",
            disabled: false,
          },
          {
            name: "CRYSTAL LAKE",
            disabled: false,
          },
          {
            name: "CRYSTAL RIVER",
            disabled: false,
          },
          {
            name: "CUBA",
            disabled: false,
          },
          {
            name: "CUDAHY",
            disabled: false,
          },
          {
            name: "CUERO",
            disabled: false,
          },
          {
            name: "CULLMAN",
            disabled: false,
          },
          {
            name: "CULPEPER",
            disabled: false,
          },
          {
            name: "CULVER CITY",
            disabled: false,
          },
          {
            name: "CUMBERLAND",
            disabled: false,
          },
          {
            name: "CUMMING",
            disabled: false,
          },
          {
            name: "CUPERTINO",
            disabled: false,
          },
          {
            name: "CUSHING",
            disabled: false,
          },
          {
            name: "CUT BANK",
            disabled: false,
          },
          {
            name: "CUT OFF",
            disabled: false,
          },
          {
            name: "CUTHBERT",
            disabled: false,
          },
          {
            name: "CUTLER BAY",
            disabled: false,
          },
          {
            name: "CUYAHOGA FALLS",
            disabled: false,
          },
          {
            name: "CYNTHIANA",
            disabled: false,
          },
          {
            name: "CYPRESS",
            disabled: false,
          },
          {
            name: "Cahokia",
            disabled: false,
          },
          {
            name: "Cambridge",
            disabled: false,
          },
          {
            name: "Camdenton",
            disabled: false,
          },
          {
            name: "Campbellsville",
            disabled: false,
          },
          {
            name: "Canon City",
            disabled: false,
          },
          {
            name: "Canyon Country",
            disabled: false,
          },
          {
            name: "Cape Girardeau",
            disabled: false,
          },
          {
            name: "Carbondale",
            disabled: false,
          },
          {
            name: "Carrollton",
            disabled: false,
          },
          {
            name: "Carson",
            disabled: false,
          },
          {
            name: "Cartersville",
            disabled: false,
          },
          {
            name: "Cary",
            disabled: false,
          },
          {
            name: "Castaic",
            disabled: false,
          },
          {
            name: "Castle Pines",
            disabled: false,
          },
          {
            name: "Castle Rock",
            disabled: false,
          },
          {
            name: "Cave Creek",
            disabled: false,
          },
          {
            name: "Celina",
            disabled: false,
          },
          {
            name: "Champaign",
            disabled: false,
          },
          {
            name: "Chandler",
            disabled: false,
          },
          {
            name: "Chapel Hill",
            disabled: false,
          },
          {
            name: "Charleston",
            disabled: false,
          },
          {
            name: "Charlestown",
            disabled: false,
          },
          {
            name: "Chesapeake",
            disabled: false,
          },
          {
            name: "Chesterfield",
            disabled: false,
          },
          {
            name: "Chicago",
            disabled: false,
          },
          {
            name: "Chino",
            disabled: false,
          },
          {
            name: "Cincinnati",
            disabled: false,
          },
          {
            name: "Citrus Heights",
            disabled: false,
          },
          {
            name: "Clark",
            disabled: false,
          },
          {
            name: "Clarksburg",
            disabled: false,
          },
          {
            name: "Clarksdale",
            disabled: false,
          },
          {
            name: "Cleveland",
            disabled: false,
          },
          {
            name: "Clinton",
            disabled: false,
          },
          {
            name: "Clinton Township",
            disabled: false,
          },
          {
            name: "Clinton Twp.",
            disabled: false,
          },
          {
            name: "Clute",
            disabled: false,
          },
          {
            name: "Coeur D Alene",
            disabled: false,
          },
          {
            name: "College Park",
            disabled: false,
          },
          {
            name: "Collinsville",
            disabled: false,
          },
          {
            name: "Colorado Springs",
            disabled: false,
          },
          {
            name: "Columbia",
            disabled: false,
          },
          {
            name: "Columbia Falls",
            disabled: false,
          },
          {
            name: "Columbus",
            disabled: false,
          },
          {
            name: "Commerce",
            disabled: false,
          },
          {
            name: "Commerce Township",
            disabled: false,
          },
          {
            name: "Compton",
            disabled: false,
          },
          {
            name: "Concord",
            disabled: false,
          },
          {
            name: "Conifer",
            disabled: false,
          },
          {
            name: "Conroe",
            disabled: false,
          },
          {
            name: "Corbin",
            disabled: false,
          },
          {
            name: "Cordova",
            disabled: false,
          },
          {
            name: "Corona",
            disabled: false,
          },
          {
            name: "Cortez",
            disabled: false,
          },
          {
            name: "Corvallis",
            disabled: false,
          },
          {
            name: "Corydon",
            disabled: false,
          },
          {
            name: "Costa Mesa",
            disabled: false,
          },
          {
            name: "Covington",
            disabled: false,
          },
          {
            name: "Craig",
            disabled: false,
          },
          {
            name: "Crawfordsville",
            disabled: false,
          },
          {
            name: "Crosby",
            disabled: false,
          },
          {
            name: "Crossville",
            disabled: false,
          },
          {
            name: "Crystal Lake",
            disabled: false,
          },
          {
            name: "Culver City",
            disabled: false,
          },
          {
            name: "Cynthiana",
            disabled: false,
          },
          {
            name: "D'IBERVILLE",
            disabled: false,
          },
          {
            name: "DACULA",
            disabled: false,
          },
          {
            name: "DADE CITY",
            disabled: false,
          },
          {
            name: "DADEVILLE",
            disabled: false,
          },
          {
            name: "DAHLONEGA",
            disabled: false,
          },
          {
            name: "DALE CITY",
            disabled: false,
          },
          {
            name: "DALEVILLE",
            disabled: false,
          },
          {
            name: "DALLAS",
            disabled: false,
          },
          {
            name: "DALTON",
            disabled: false,
          },
          {
            name: "DALY CITY",
            disabled: false,
          },
          {
            name: "DAMARISCOTTA",
            disabled: false,
          },
          {
            name: "DAMASCUS",
            disabled: false,
          },
          {
            name: "DANA POINT",
            disabled: false,
          },
          {
            name: "DANBURY",
            disabled: false,
          },
          {
            name: "DANIA BEACH",
            disabled: false,
          },
          {
            name: "DANIELSVILLE",
            disabled: false,
          },
          {
            name: "DANSVILLE",
            disabled: false,
          },
          {
            name: "DANVERS",
            disabled: false,
          },
          {
            name: "DANVILLE",
            disabled: false,
          },
          {
            name: "DAPHNE",
            disabled: false,
          },
          {
            name: "DARBY",
            disabled: false,
          },
          {
            name: "DARDANELLE",
            disabled: false,
          },
          {
            name: "DARDENNE PRAIRIE",
            disabled: false,
          },
          {
            name: "DARIEN",
            disabled: false,
          },
          {
            name: "DARLINGTON",
            disabled: false,
          },
          {
            name: "DARTMOUTH",
            disabled: false,
          },
          {
            name: "DAVENPORT",
            disabled: false,
          },
          {
            name: "DAVIDSON",
            disabled: false,
          },
          {
            name: "DAVIE",
            disabled: false,
          },
          {
            name: "DAVIS",
            disabled: false,
          },
          {
            name: "DAVISON",
            disabled: false,
          },
          {
            name: "DAWSONVILLE",
            disabled: false,
          },
          {
            name: "DAYTON",
            disabled: false,
          },
          {
            name: "DAYTONA BEACH",
            disabled: false,
          },
          {
            name: "DAYTONA BEACH SHORES",
            disabled: false,
          },
          {
            name: "DAYVILLE",
            disabled: false,
          },
          {
            name: "DE FOREST",
            disabled: false,
          },
          {
            name: "DE PERE",
            disabled: false,
          },
          {
            name: "DE QUEEN",
            disabled: false,
          },
          {
            name: "DE SOTO",
            disabled: false,
          },
          {
            name: "DEARBORN",
            disabled: false,
          },
          {
            name: "DEARBORN HEIGHTS",
            disabled: false,
          },
          {
            name: "DEBARY",
            disabled: false,
          },
          {
            name: "DECATUR",
            disabled: false,
          },
          {
            name: "DECHERD",
            disabled: false,
          },
          {
            name: "DECORAH",
            disabled: false,
          },
          {
            name: "DEDHAM",
            disabled: false,
          },
          {
            name: "DEEP RIVER",
            disabled: false,
          },
          {
            name: "DEER LODGE",
            disabled: false,
          },
          {
            name: "DEER PARK",
            disabled: false,
          },
          {
            name: "DEERFIELD",
            disabled: false,
          },
          {
            name: "DEERFIELD BEACH",
            disabled: false,
          },
          {
            name: "DEFIANCE",
            disabled: false,
          },
          {
            name: "DEFUNIAK SPRINGS",
            disabled: false,
          },
          {
            name: "DEKALB",
            disabled: false,
          },
          {
            name: "DEL CITY",
            disabled: false,
          },
          {
            name: "DEL MAR",
            disabled: false,
          },
          {
            name: "DEL REY OAKS",
            disabled: false,
          },
          {
            name: "DEL RIO",
            disabled: false,
          },
          {
            name: "DELAFIELD",
            disabled: false,
          },
          {
            name: "DELAND",
            disabled: false,
          },
          {
            name: "DELANO",
            disabled: false,
          },
          {
            name: "DELAVAN",
            disabled: false,
          },
          {
            name: "DELAWARE",
            disabled: false,
          },
          {
            name: "DELHI",
            disabled: false,
          },
          {
            name: "DELMAR",
            disabled: false,
          },
          {
            name: "DELMONT",
            disabled: false,
          },
          {
            name: "DELPHI",
            disabled: false,
          },
          {
            name: "DELPHOS",
            disabled: false,
          },
          {
            name: "DELRAN",
            disabled: false,
          },
          {
            name: "DELRAY BEACH",
            disabled: false,
          },
          {
            name: "DELTA",
            disabled: false,
          },
          {
            name: "DELTONA",
            disabled: false,
          },
          {
            name: "DEMING",
            disabled: false,
          },
          {
            name: "DEMOPOLIS",
            disabled: false,
          },
          {
            name: "DEMOTTE",
            disabled: false,
          },
          {
            name: "DENHAM SPRINGS",
            disabled: false,
          },
          {
            name: "DENISON",
            disabled: false,
          },
          {
            name: "DENMARK",
            disabled: false,
          },
          {
            name: "DENNISON",
            disabled: false,
          },
          {
            name: "DENNISPORT",
            disabled: false,
          },
          {
            name: "DENTON",
            disabled: false,
          },
          {
            name: "DENVER",
            disabled: false,
          },
          {
            name: "DENVILLE",
            disabled: false,
          },
          {
            name: "DEPEW",
            disabled: false,
          },
          {
            name: "DEPTFORD",
            disabled: false,
          },
          {
            name: "DERBY",
            disabled: false,
          },
          {
            name: "DERIDDER",
            disabled: false,
          },
          {
            name: "DERRY",
            disabled: false,
          },
          {
            name: "DERWOOD",
            disabled: false,
          },
          {
            name: "DES MOINES",
            disabled: false,
          },
          {
            name: "DES PERES",
            disabled: false,
          },
          {
            name: "DES PLAINES",
            disabled: false,
          },
          {
            name: "DESERT HOT SPRINGS",
            disabled: false,
          },
          {
            name: "DESLOGE",
            disabled: false,
          },
          {
            name: "DESOTO",
            disabled: false,
          },
          {
            name: "DESTIN",
            disabled: false,
          },
          {
            name: "DESTREHAN",
            disabled: false,
          },
          {
            name: "DETROIT",
            disabled: false,
          },
          {
            name: "DETROIT LAKES",
            disabled: false,
          },
          {
            name: "DEVILS LAKE",
            disabled: false,
          },
          {
            name: "DEVINE",
            disabled: false,
          },
          {
            name: "DEWITT",
            disabled: false,
          },
          {
            name: "DEXTER",
            disabled: false,
          },
          {
            name: "DIAMOND BAR",
            disabled: false,
          },
          {
            name: "DIAMONDHEAD",
            disabled: false,
          },
          {
            name: "DIBERVILLE",
            disabled: false,
          },
          {
            name: "DICKINSON",
            disabled: false,
          },
          {
            name: "DICKSON",
            disabled: false,
          },
          {
            name: "DICKSON CITY",
            disabled: false,
          },
          {
            name: "DILLON",
            disabled: false,
          },
          {
            name: "DILLSBURG",
            disabled: false,
          },
          {
            name: "DILLWYN",
            disabled: false,
          },
          {
            name: "DILWORTH",
            disabled: false,
          },
          {
            name: "DINUBA",
            disabled: false,
          },
          {
            name: "DINWIDDIE",
            disabled: false,
          },
          {
            name: "DISCOVERY BAY",
            disabled: false,
          },
          {
            name: "DISTRICT HEIGHTS",
            disabled: false,
          },
          {
            name: "DIXON",
            disabled: false,
          },
          {
            name: "DOBBS FERRY",
            disabled: false,
          },
          {
            name: "DOBSON",
            disabled: false,
          },
          {
            name: "DODGE CITY",
            disabled: false,
          },
          {
            name: "DODGEVILLE",
            disabled: false,
          },
          {
            name: "DOLTON",
            disabled: false,
          },
          {
            name: "DONALDSONVILLE",
            disabled: false,
          },
          {
            name: "DONALSONVILLE",
            disabled: false,
          },
          {
            name: "DONNA",
            disabled: false,
          },
          {
            name: "DORAL",
            disabled: false,
          },
          {
            name: "DORCHESTER",
            disabled: false,
          },
          {
            name: "DORCHESTER CENTER",
            disabled: false,
          },
          {
            name: "DOTHAN",
            disabled: false,
          },
          {
            name: "DOUGLAS",
            disabled: false,
          },
          {
            name: "DOUGLASSVILLE",
            disabled: false,
          },
          {
            name: "DOUGLASTON",
            disabled: false,
          },
          {
            name: "DOUGLASVILLE",
            disabled: false,
          },
          {
            name: "DOVER",
            disabled: false,
          },
          {
            name: "DOVER FOXCROFT",
            disabled: false,
          },
          {
            name: "DOVER PLAINS",
            disabled: false,
          },
          {
            name: "DOVER-FOXCROFT",
            disabled: false,
          },
          {
            name: "DOWAGIAC",
            disabled: false,
          },
          {
            name: "DOWNERS GROVE",
            disabled: false,
          },
          {
            name: "DOWNEY",
            disabled: false,
          },
          {
            name: "DOWNINGTOWN",
            disabled: false,
          },
          {
            name: "DOYLESTOWN",
            disabled: false,
          },
          {
            name: "DRACUT",
            disabled: false,
          },
          {
            name: "DRAPER",
            disabled: false,
          },
          {
            name: "DRESDEN",
            disabled: false,
          },
          {
            name: "DRESHER",
            disabled: false,
          },
          {
            name: "DREXEL HILL",
            disabled: false,
          },
          {
            name: "DRIPPING SPRINGS",
            disabled: false,
          },
          {
            name: "DRY RIDGE",
            disabled: false,
          },
          {
            name: "DU BOIS",
            disabled: false,
          },
          {
            name: "DU QUOIN",
            disabled: false,
          },
          {
            name: "DUARTE",
            disabled: false,
          },
          {
            name: "DUBLIN",
            disabled: false,
          },
          {
            name: "DUBUQUE",
            disabled: false,
          },
          {
            name: "DUDLEY",
            disabled: false,
          },
          {
            name: "DULLES",
            disabled: false,
          },
          {
            name: "DULUTH",
            disabled: false,
          },
          {
            name: "DUMAS",
            disabled: false,
          },
          {
            name: "DUMFRIES",
            disabled: false,
          },
          {
            name: "DUMONT",
            disabled: false,
          },
          {
            name: "DUNBAR",
            disabled: false,
          },
          {
            name: "DUNCAN",
            disabled: false,
          },
          {
            name: "DUNCANNON",
            disabled: false,
          },
          {
            name: "DUNCANSVILLE",
            disabled: false,
          },
          {
            name: "DUNCANVILLE",
            disabled: false,
          },
          {
            name: "DUNDALK",
            disabled: false,
          },
          {
            name: "DUNDEE",
            disabled: false,
          },
          {
            name: "DUNEDIN",
            disabled: false,
          },
          {
            name: "DUNKIRK",
            disabled: false,
          },
          {
            name: "DUNLAP",
            disabled: false,
          },
          {
            name: "DUNMORE",
            disabled: false,
          },
          {
            name: "DUNN",
            disabled: false,
          },
          {
            name: "DUNNELLON",
            disabled: false,
          },
          {
            name: "DUNWOODY",
            disabled: false,
          },
          {
            name: "DURAND",
            disabled: false,
          },
          {
            name: "DURANGO",
            disabled: false,
          },
          {
            name: "DURANT",
            disabled: false,
          },
          {
            name: "DURHAM",
            disabled: false,
          },
          {
            name: "DUVALL",
            disabled: false,
          },
          {
            name: "DUXBURY",
            disabled: false,
          },
          {
            name: "DYER",
            disabled: false,
          },
          {
            name: "DYERSBURG",
            disabled: false,
          },
          {
            name: "Dallas",
            disabled: false,
          },
          {
            name: "Danbury",
            disabled: false,
          },
          {
            name: "Danville",
            disabled: false,
          },
          {
            name: "Dayton",
            disabled: false,
          },
          {
            name: "De Witt",
            disabled: false,
          },
          {
            name: "Dearborn",
            disabled: false,
          },
          {
            name: "Decatur",
            disabled: false,
          },
          {
            name: "Deforest",
            disabled: false,
          },
          {
            name: "Delta",
            disabled: false,
          },
          {
            name: "Denison",
            disabled: false,
          },
          {
            name: "Denver",
            disabled: false,
          },
          {
            name: "Derby",
            disabled: false,
          },
          {
            name: "Des Moines",
            disabled: false,
          },
          {
            name: "Des Plaines",
            disabled: false,
          },
          {
            name: "Diamond",
            disabled: false,
          },
          {
            name: "Dillon",
            disabled: false,
          },
          {
            name: "Dover",
            disabled: false,
          },
          {
            name: "Du Quoin",
            disabled: false,
          },
          {
            name: "Duarte",
            disabled: false,
          },
          {
            name: "Dublin",
            disabled: false,
          },
          {
            name: "Durango",
            disabled: false,
          },
          {
            name: "Durham",
            disabled: false,
          },
          {
            name: "EAGAN",
            disabled: false,
          },
          {
            name: "EAGLE",
            disabled: false,
          },
          {
            name: "EAGLE PASS",
            disabled: false,
          },
          {
            name: "EAGLE POINT",
            disabled: false,
          },
          {
            name: "EAGLE RIVER",
            disabled: false,
          },
          {
            name: "EASLEY",
            disabled: false,
          },
          {
            name: "EAST AMHERST",
            disabled: false,
          },
          {
            name: "EAST AURORA",
            disabled: false,
          },
          {
            name: "EAST BOSTON",
            disabled: false,
          },
          {
            name: "EAST BRIDGEWATER",
            disabled: false,
          },
          {
            name: "EAST BRUNSWICK",
            disabled: false,
          },
          {
            name: "EAST CHICAGO",
            disabled: false,
          },
          {
            name: "EAST ELLIJAY",
            disabled: false,
          },
          {
            name: "EAST ELMHURST",
            disabled: false,
          },
          {
            name: "EAST FALMOUTH",
            disabled: false,
          },
          {
            name: "EAST GREENBUSH",
            disabled: false,
          },
          {
            name: "EAST GREENVILLE",
            disabled: false,
          },
          {
            name: "EAST GREENWICH",
            disabled: false,
          },
          {
            name: "EAST HAMPSTEAD",
            disabled: false,
          },
          {
            name: "EAST HAMPTON",
            disabled: false,
          },
          {
            name: "EAST HANOVER",
            disabled: false,
          },
          {
            name: "EAST HARTFORD",
            disabled: false,
          },
          {
            name: "EAST HAVEN",
            disabled: false,
          },
          {
            name: "EAST HILLS",
            disabled: false,
          },
          {
            name: "EAST ISLIP",
            disabled: false,
          },
          {
            name: "EAST LANSING",
            disabled: false,
          },
          {
            name: "EAST LIVERPOOL",
            disabled: false,
          },
          {
            name: "EAST LONGMEADOW",
            disabled: false,
          },
          {
            name: "EAST LYME",
            disabled: false,
          },
          {
            name: "EAST MEADOW",
            disabled: false,
          },
          {
            name: "EAST MOLINE",
            disabled: false,
          },
          {
            name: "EAST NORRITON",
            disabled: false,
          },
          {
            name: "EAST NORTHPORT",
            disabled: false,
          },
          {
            name: "EAST ORANGE",
            disabled: false,
          },
          {
            name: "EAST PALATKA",
            disabled: false,
          },
          {
            name: "EAST PALESTINE",
            disabled: false,
          },
          {
            name: "EAST PALO ALTO",
            disabled: false,
          },
          {
            name: "EAST PEORIA",
            disabled: false,
          },
          {
            name: "EAST POINT",
            disabled: false,
          },
          {
            name: "EAST PROVIDENCE",
            disabled: false,
          },
          {
            name: "EAST RIDGE",
            disabled: false,
          },
          {
            name: "EAST ROCKAWAY",
            disabled: false,
          },
          {
            name: "EAST RUTHERFORD",
            disabled: false,
          },
          {
            name: "EAST SETAUKET",
            disabled: false,
          },
          {
            name: "EAST STROUDSBURG",
            disabled: false,
          },
          {
            name: "EAST SYRACUSE",
            disabled: false,
          },
          {
            name: "EAST WAREHAM",
            disabled: false,
          },
          {
            name: "EAST WENATCHEE",
            disabled: false,
          },
          {
            name: "EAST WINDSOR",
            disabled: false,
          },
          {
            name: "EASTANOLLEE",
            disabled: false,
          },
          {
            name: "EASTCHESTER",
            disabled: false,
          },
          {
            name: "EASTHAMPTON",
            disabled: false,
          },
          {
            name: "EASTLAKE",
            disabled: false,
          },
          {
            name: "EASTLAND",
            disabled: false,
          },
          {
            name: "EASTMAN",
            disabled: false,
          },
          {
            name: "EASTON",
            disabled: false,
          },
          {
            name: "EASTPOINTE",
            disabled: false,
          },
          {
            name: "EASTPORT",
            disabled: false,
          },
          {
            name: "EASTVALE",
            disabled: false,
          },
          {
            name: "EATON",
            disabled: false,
          },
          {
            name: "EATON RAPIDS",
            disabled: false,
          },
          {
            name: "EATONTON",
            disabled: false,
          },
          {
            name: "EATONTOWN",
            disabled: false,
          },
          {
            name: "EAU CLAIRE",
            disabled: false,
          },
          {
            name: "EBENSBURG",
            disabled: false,
          },
          {
            name: "EDDYSTONE",
            disabled: false,
          },
          {
            name: "EDEN",
            disabled: false,
          },
          {
            name: "EDEN PRAIRIE",
            disabled: false,
          },
          {
            name: "EDENTON",
            disabled: false,
          },
          {
            name: "EDGEFIELD",
            disabled: false,
          },
          {
            name: "EDGEWATER",
            disabled: false,
          },
          {
            name: "EDGEWATER PARK",
            disabled: false,
          },
          {
            name: "EDGEWOOD",
            disabled: false,
          },
          {
            name: "EDINA",
            disabled: false,
          },
          {
            name: "EDINBORO",
            disabled: false,
          },
          {
            name: "EDINBURG",
            disabled: false,
          },
          {
            name: "EDINBURGH",
            disabled: false,
          },
          {
            name: "EDISON",
            disabled: false,
          },
          {
            name: "EDMOND",
            disabled: false,
          },
          {
            name: "EDMONDS",
            disabled: false,
          },
          {
            name: "EDMONTON",
            disabled: false,
          },
          {
            name: "EDNA",
            disabled: false,
          },
          {
            name: "EDWARDSVILLE",
            disabled: false,
          },
          {
            name: "EFFINGHAM",
            disabled: false,
          },
          {
            name: "EFFORT",
            disabled: false,
          },
          {
            name: "EGG HARBOR CITY",
            disabled: false,
          },
          {
            name: "EGG HARBOR TOWNSHIP",
            disabled: false,
          },
          {
            name: "EGG HBR TWP",
            disabled: false,
          },
          {
            name: "EL CAJON",
            disabled: false,
          },
          {
            name: "EL CAMPO",
            disabled: false,
          },
          {
            name: "EL CENTRO",
            disabled: false,
          },
          {
            name: "EL CERRITO",
            disabled: false,
          },
          {
            name: "EL DORADO",
            disabled: false,
          },
          {
            name: "EL DORADO HILLS",
            disabled: false,
          },
          {
            name: "EL MIRAGE",
            disabled: false,
          },
          {
            name: "EL MONTE",
            disabled: false,
          },
          {
            name: "EL PASO",
            disabled: false,
          },
          {
            name: "EL RENO",
            disabled: false,
          },
          {
            name: "EL SEGUNDO",
            disabled: false,
          },
          {
            name: "EL SOBRANTE",
            disabled: false,
          },
          {
            name: "ELBERTON",
            disabled: false,
          },
          {
            name: "ELBURN",
            disabled: false,
          },
          {
            name: "ELDERSBURG",
            disabled: false,
          },
          {
            name: "ELDON",
            disabled: false,
          },
          {
            name: "ELEANOR",
            disabled: false,
          },
          {
            name: "ELGIN",
            disabled: false,
          },
          {
            name: "ELIZABETH",
            disabled: false,
          },
          {
            name: "ELIZABETH CITY",
            disabled: false,
          },
          {
            name: "ELIZABETHTON",
            disabled: false,
          },
          {
            name: "ELIZABETHTOWN",
            disabled: false,
          },
          {
            name: "ELIZABETHVILLE",
            disabled: false,
          },
          {
            name: "ELK CITY",
            disabled: false,
          },
          {
            name: "ELK GROVE",
            disabled: false,
          },
          {
            name: "ELK GROVE VILLAGE",
            disabled: false,
          },
          {
            name: "ELK RIVER",
            disabled: false,
          },
          {
            name: "ELKHART",
            disabled: false,
          },
          {
            name: "ELKHORN",
            disabled: false,
          },
          {
            name: "ELKIN",
            disabled: false,
          },
          {
            name: "ELKINS",
            disabled: false,
          },
          {
            name: "ELKINS PARK",
            disabled: false,
          },
          {
            name: "ELKO",
            disabled: false,
          },
          {
            name: "ELKRIDGE",
            disabled: false,
          },
          {
            name: "ELKTON",
            disabled: false,
          },
          {
            name: "ELKVIEW",
            disabled: false,
          },
          {
            name: "ELLENSBURG",
            disabled: false,
          },
          {
            name: "ELLENTON",
            disabled: false,
          },
          {
            name: "ELLENVILLE",
            disabled: false,
          },
          {
            name: "ELLENWOOD",
            disabled: false,
          },
          {
            name: "ELLICOTT CITY",
            disabled: false,
          },
          {
            name: "ELLIJAY",
            disabled: false,
          },
          {
            name: "ELLISVILLE",
            disabled: false,
          },
          {
            name: "ELLSWORTH",
            disabled: false,
          },
          {
            name: "ELLWOOD CITY",
            disabled: false,
          },
          {
            name: "ELM GROVE",
            disabled: false,
          },
          {
            name: "ELMHURST",
            disabled: false,
          },
          {
            name: "ELMIRA",
            disabled: false,
          },
          {
            name: "ELMONT",
            disabled: false,
          },
          {
            name: "ELMSFORD",
            disabled: false,
          },
          {
            name: "ELMWOOD PARK",
            disabled: false,
          },
          {
            name: "ELSA",
            disabled: false,
          },
          {
            name: "ELVERSON",
            disabled: false,
          },
          {
            name: "ELWOOD",
            disabled: false,
          },
          {
            name: "ELYRIA",
            disabled: false,
          },
          {
            name: "EMERSON",
            disabled: false,
          },
          {
            name: "EMERYVILLE",
            disabled: false,
          },
          {
            name: "EMINENCE",
            disabled: false,
          },
          {
            name: "EMMAUS",
            disabled: false,
          },
          {
            name: "EMMETT",
            disabled: false,
          },
          {
            name: "EMPORIA",
            disabled: false,
          },
          {
            name: "EMPORIUM",
            disabled: false,
          },
          {
            name: "ENCINITAS",
            disabled: false,
          },
          {
            name: "ENCINO",
            disabled: false,
          },
          {
            name: "ENDICOTT",
            disabled: false,
          },
          {
            name: "ENDWELL",
            disabled: false,
          },
          {
            name: "ENFIELD",
            disabled: false,
          },
          {
            name: "ENGLEWOOD",
            disabled: false,
          },
          {
            name: "ENGLISH",
            disabled: false,
          },
          {
            name: "ENGLISHTOWN",
            disabled: false,
          },
          {
            name: "ENID",
            disabled: false,
          },
          {
            name: "ENNIS",
            disabled: false,
          },
          {
            name: "ENOLA",
            disabled: false,
          },
          {
            name: "ENOSBURG FALLS",
            disabled: false,
          },
          {
            name: "ENTERPRISE",
            disabled: false,
          },
          {
            name: "ENUMCLAW",
            disabled: false,
          },
          {
            name: "EPHRAIM",
            disabled: false,
          },
          {
            name: "EPHRATA",
            disabled: false,
          },
          {
            name: "EPPING",
            disabled: false,
          },
          {
            name: "ERDENHEIM",
            disabled: false,
          },
          {
            name: "ERIE",
            disabled: false,
          },
          {
            name: "ERLANGER",
            disabled: false,
          },
          {
            name: "ERWIN",
            disabled: false,
          },
          {
            name: "ESCALON",
            disabled: false,
          },
          {
            name: "ESCANABA",
            disabled: false,
          },
          {
            name: "ESCONDIDO",
            disabled: false,
          },
          {
            name: "ESPANOLA",
            disabled: false,
          },
          {
            name: "ESSEX",
            disabled: false,
          },
          {
            name: "ESSEX JUNCTION",
            disabled: false,
          },
          {
            name: "ESSEXVILLE",
            disabled: false,
          },
          {
            name: "ESTERO",
            disabled: false,
          },
          {
            name: "ESTES PARK",
            disabled: false,
          },
          {
            name: "ETOWAH",
            disabled: false,
          },
          {
            name: "ETTERS",
            disabled: false,
          },
          {
            name: "EUCLID",
            disabled: false,
          },
          {
            name: "EUFAULA",
            disabled: false,
          },
          {
            name: "EUGENE",
            disabled: false,
          },
          {
            name: "EULESS",
            disabled: false,
          },
          {
            name: "EUNICE",
            disabled: false,
          },
          {
            name: "EUREKA",
            disabled: false,
          },
          {
            name: "EUSTIS",
            disabled: false,
          },
          {
            name: "EVANS",
            disabled: false,
          },
          {
            name: "EVANS MILLS",
            disabled: false,
          },
          {
            name: "EVANSTON",
            disabled: false,
          },
          {
            name: "EVANSVILLE",
            disabled: false,
          },
          {
            name: "EVERETT",
            disabled: false,
          },
          {
            name: "EVERGREEN",
            disabled: false,
          },
          {
            name: "EVERGREEN PARK",
            disabled: false,
          },
          {
            name: "EWA BEACH",
            disabled: false,
          },
          {
            name: "EWING",
            disabled: false,
          },
          {
            name: "EXCELSIOR",
            disabled: false,
          },
          {
            name: "EXCELSIOR SPRINGS",
            disabled: false,
          },
          {
            name: "EXETER",
            disabled: false,
          },
          {
            name: "EXMORE",
            disabled: false,
          },
          {
            name: "EXPORT",
            disabled: false,
          },
          {
            name: "EXTON",
            disabled: false,
          },
          {
            name: "Eagle",
            disabled: false,
          },
          {
            name: "East Alton",
            disabled: false,
          },
          {
            name: "East Lansing",
            disabled: false,
          },
          {
            name: "Eastvale",
            disabled: false,
          },
          {
            name: "Eatontown",
            disabled: false,
          },
          {
            name: "Edinburgh",
            disabled: false,
          },
          {
            name: "Edmonds",
            disabled: false,
          },
          {
            name: "El Jebel",
            disabled: false,
          },
          {
            name: "Eldon",
            disabled: false,
          },
          {
            name: "Elk Grove Village",
            disabled: false,
          },
          {
            name: "Elmhurst",
            disabled: false,
          },
          {
            name: "Encino",
            disabled: false,
          },
          {
            name: "England",
            disabled: false,
          },
          {
            name: "Englewood",
            disabled: false,
          },
          {
            name: "English",
            disabled: false,
          },
          {
            name: "Enumclaw",
            disabled: false,
          },
          {
            name: "Erie",
            disabled: false,
          },
          {
            name: "Evans",
            disabled: false,
          },
          {
            name: "Evanston",
            disabled: false,
          },
          {
            name: "Evansville",
            disabled: false,
          },
          {
            name: "Everett",
            disabled: false,
          },
          {
            name: "Evergreen Park",
            disabled: false,
          },
          {
            name: "FAIR HAVEN",
            disabled: false,
          },
          {
            name: "FAIR LAWN",
            disabled: false,
          },
          {
            name: "FAIR OAKS",
            disabled: false,
          },
          {
            name: "FAIR OAKS RANCH",
            disabled: false,
          },
          {
            name: "FAIRBANKS",
            disabled: false,
          },
          {
            name: "FAIRBORN",
            disabled: false,
          },
          {
            name: "FAIRBURN",
            disabled: false,
          },
          {
            name: "FAIRBURY",
            disabled: false,
          },
          {
            name: "FAIRFAX",
            disabled: false,
          },
          {
            name: "FAIRFAX STATION",
            disabled: false,
          },
          {
            name: "FAIRFIELD",
            disabled: false,
          },
          {
            name: "FAIRHAVEN",
            disabled: false,
          },
          {
            name: "FAIRHOPE",
            disabled: false,
          },
          {
            name: "FAIRLAWN",
            disabled: false,
          },
          {
            name: "FAIRLESS HILLS",
            disabled: false,
          },
          {
            name: "FAIRMONT",
            disabled: false,
          },
          {
            name: "FAIRPORT",
            disabled: false,
          },
          {
            name: "FAIRVIEW",
            disabled: false,
          },
          {
            name: "FAIRVIEW HEIGHTS",
            disabled: false,
          },
          {
            name: "FAIRVIEW PARK",
            disabled: false,
          },
          {
            name: "FAJARDO",
            disabled: false,
          },
          {
            name: "FALCON",
            disabled: false,
          },
          {
            name: "FALCONER",
            disabled: false,
          },
          {
            name: "FALFURRIAS",
            disabled: false,
          },
          {
            name: "FALL RIVER",
            disabled: false,
          },
          {
            name: "FALLBROOK",
            disabled: false,
          },
          {
            name: "FALLING WATERS",
            disabled: false,
          },
          {
            name: "FALLON",
            disabled: false,
          },
          {
            name: "FALLS CHURCH",
            disabled: false,
          },
          {
            name: "FALLSTON",
            disabled: false,
          },
          {
            name: "FALMOUTH",
            disabled: false,
          },
          {
            name: "FAR ROCKAWAY",
            disabled: false,
          },
          {
            name: "FARGO",
            disabled: false,
          },
          {
            name: "FARIBAULT",
            disabled: false,
          },
          {
            name: "FARMERS BRANCH",
            disabled: false,
          },
          {
            name: "FARMERSVILLE",
            disabled: false,
          },
          {
            name: "FARMERVILLE",
            disabled: false,
          },
          {
            name: "FARMINGDALE",
            disabled: false,
          },
          {
            name: "FARMINGTON",
            disabled: false,
          },
          {
            name: "FARMINGTON HILLS",
            disabled: false,
          },
          {
            name: "FARMINGVILLE",
            disabled: false,
          },
          {
            name: "FARMVILLE",
            disabled: false,
          },
          {
            name: "FARRAGUT",
            disabled: false,
          },
          {
            name: "FARRELL",
            disabled: false,
          },
          {
            name: "FARWELL",
            disabled: false,
          },
          {
            name: "FAYETTE",
            disabled: false,
          },
          {
            name: "FAYETTEVILLE",
            disabled: false,
          },
          {
            name: "FEASTERVILLE TREVOSE",
            disabled: false,
          },
          {
            name: "FEDERAL HEIGHTS",
            disabled: false,
          },
          {
            name: "FEDERAL WAY",
            disabled: false,
          },
          {
            name: "FEDERALSBURG",
            disabled: false,
          },
          {
            name: "FEEDING HILLS",
            disabled: false,
          },
          {
            name: "FELTON",
            disabled: false,
          },
          {
            name: "FENTON",
            disabled: false,
          },
          {
            name: "FERDINAND",
            disabled: false,
          },
          {
            name: "FERGUS FALLS",
            disabled: false,
          },
          {
            name: "FERGUSON",
            disabled: false,
          },
          {
            name: "FERN PARK",
            disabled: false,
          },
          {
            name: "FERNANDINA BEACH",
            disabled: false,
          },
          {
            name: "FERNDALE",
            disabled: false,
          },
          {
            name: "FERNLEY",
            disabled: false,
          },
          {
            name: "FESTUS",
            disabled: false,
          },
          {
            name: "FIFE",
            disabled: false,
          },
          {
            name: "FILLMORE",
            disabled: false,
          },
          {
            name: "FINDLAY",
            disabled: false,
          },
          {
            name: "FINKSBURG",
            disabled: false,
          },
          {
            name: "FIRESTONE",
            disabled: false,
          },
          {
            name: "FISHERS",
            disabled: false,
          },
          {
            name: "FISHERSVILLE",
            disabled: false,
          },
          {
            name: "FISHKILL",
            disabled: false,
          },
          {
            name: "FITCHBURG",
            disabled: false,
          },
          {
            name: "FITZGERALD",
            disabled: false,
          },
          {
            name: "FLAGLER BEACH",
            disabled: false,
          },
          {
            name: "FLAGSTAFF",
            disabled: false,
          },
          {
            name: "FLANDERS",
            disabled: false,
          },
          {
            name: "FLAT ROCK",
            disabled: false,
          },
          {
            name: "FLATWOODS",
            disabled: false,
          },
          {
            name: "FLEMINGTON",
            disabled: false,
          },
          {
            name: "FLETCHER",
            disabled: false,
          },
          {
            name: "FLINT",
            disabled: false,
          },
          {
            name: "FLIPPIN",
            disabled: false,
          },
          {
            name: "FLORA",
            disabled: false,
          },
          {
            name: "FLORAL PARK",
            disabled: false,
          },
          {
            name: "FLORENCE",
            disabled: false,
          },
          {
            name: "FLORESVILLE",
            disabled: false,
          },
          {
            name: "FLORHAM PARK",
            disabled: false,
          },
          {
            name: "FLORIDA CITY",
            disabled: false,
          },
          {
            name: "FLORISSANT",
            disabled: false,
          },
          {
            name: "FLOSSMOOR",
            disabled: false,
          },
          {
            name: "FLOURTOWN",
            disabled: false,
          },
          {
            name: "FLOWER MOUND",
            disabled: false,
          },
          {
            name: "FLOWERY BRANCH",
            disabled: false,
          },
          {
            name: "FLOWOOD",
            disabled: false,
          },
          {
            name: "FLOYD",
            disabled: false,
          },
          {
            name: "FLOYDS KNOBS",
            disabled: false,
          },
          {
            name: "FLUSHING",
            disabled: false,
          },
          {
            name: "FOGELSVILLE",
            disabled: false,
          },
          {
            name: "FOLEY",
            disabled: false,
          },
          {
            name: "FOLKSTON",
            disabled: false,
          },
          {
            name: "FOLLANSBEE",
            disabled: false,
          },
          {
            name: "FOLSOM",
            disabled: false,
          },
          {
            name: "FOND DU LAC",
            disabled: false,
          },
          {
            name: "FONTANA",
            disabled: false,
          },
          {
            name: "FOOTHILL RANCH",
            disabled: false,
          },
          {
            name: "FORDYCE",
            disabled: false,
          },
          {
            name: "FOREST",
            disabled: false,
          },
          {
            name: "FOREST CITY",
            disabled: false,
          },
          {
            name: "FOREST GROVE",
            disabled: false,
          },
          {
            name: "FOREST HILL",
            disabled: false,
          },
          {
            name: "FOREST HILLS",
            disabled: false,
          },
          {
            name: "FOREST LAKE",
            disabled: false,
          },
          {
            name: "FOREST PARK",
            disabled: false,
          },
          {
            name: "FORESTVILLE",
            disabled: false,
          },
          {
            name: "FORKED RIVER",
            disabled: false,
          },
          {
            name: "FORNEY",
            disabled: false,
          },
          {
            name: "FORREST CITY",
            disabled: false,
          },
          {
            name: "FORSYTH",
            disabled: false,
          },
          {
            name: "FORT ATKINSON",
            disabled: false,
          },
          {
            name: "FORT BRAGG",
            disabled: false,
          },
          {
            name: "FORT COLLINS",
            disabled: false,
          },
          {
            name: "FORT DODGE",
            disabled: false,
          },
          {
            name: "FORT GRATIOT",
            disabled: false,
          },
          {
            name: "FORT KENT",
            disabled: false,
          },
          {
            name: "FORT LAUDERDALE",
            disabled: false,
          },
          {
            name: "FORT LEE",
            disabled: false,
          },
          {
            name: "FORT LUPTON",
            disabled: false,
          },
          {
            name: "FORT MADISON",
            disabled: false,
          },
          {
            name: "FORT MILL",
            disabled: false,
          },
          {
            name: "FORT MITCHELL",
            disabled: false,
          },
          {
            name: "FORT MOHAVE",
            disabled: false,
          },
          {
            name: "FORT MORGAN",
            disabled: false,
          },
          {
            name: "FORT MYERS",
            disabled: false,
          },
          {
            name: "FORT MYERS BEACH",
            disabled: false,
          },
          {
            name: "FORT OGLETHORPE",
            disabled: false,
          },
          {
            name: "FORT PAYNE",
            disabled: false,
          },
          {
            name: "FORT PIERCE",
            disabled: false,
          },
          {
            name: "FORT SCOTT",
            disabled: false,
          },
          {
            name: "FORT SMITH",
            disabled: false,
          },
          {
            name: "FORT STOCKTON",
            disabled: false,
          },
          {
            name: "FORT VALLEY",
            disabled: false,
          },
          {
            name: "FORT WALTON BEACH",
            disabled: false,
          },
          {
            name: "FORT WASHINGTON",
            disabled: false,
          },
          {
            name: "FORT WAYNE",
            disabled: false,
          },
          {
            name: "FORT WORTH",
            disabled: false,
          },
          {
            name: "FORTUNA",
            disabled: false,
          },
          {
            name: "FORTVILLE",
            disabled: false,
          },
          {
            name: "FOSTER CITY",
            disabled: false,
          },
          {
            name: "FOSTORIA",
            disabled: false,
          },
          {
            name: "FOUNTAIN",
            disabled: false,
          },
          {
            name: "FOUNTAIN HILLS",
            disabled: false,
          },
          {
            name: "FOUNTAIN INN",
            disabled: false,
          },
          {
            name: "FOUNTAIN VALLEY",
            disabled: false,
          },
          {
            name: "FOWLERVILLE",
            disabled: false,
          },
          {
            name: "FOX LAKE",
            disabled: false,
          },
          {
            name: "FOX POINT",
            disabled: false,
          },
          {
            name: "FOX RIVER GROVE",
            disabled: false,
          },
          {
            name: "FOXFIELD",
            disabled: false,
          },
          {
            name: "FRACKVILLE",
            disabled: false,
          },
          {
            name: "FRAMINGHAM",
            disabled: false,
          },
          {
            name: "FRANKENMUTH",
            disabled: false,
          },
          {
            name: "FRANKFORT",
            disabled: false,
          },
          {
            name: "FRANKLIN",
            disabled: false,
          },
          {
            name: "FRANKLIN LAKES",
            disabled: false,
          },
          {
            name: "FRANKLIN PARK",
            disabled: false,
          },
          {
            name: "FRANKLIN SQUARE",
            disabled: false,
          },
          {
            name: "FRANKLINTON",
            disabled: false,
          },
          {
            name: "FRASER",
            disabled: false,
          },
          {
            name: "FRAZER",
            disabled: false,
          },
          {
            name: "FREDERICK",
            disabled: false,
          },
          {
            name: "FREDERICKSBURG",
            disabled: false,
          },
          {
            name: "FREDERICKTOWN",
            disabled: false,
          },
          {
            name: "FREDONIA",
            disabled: false,
          },
          {
            name: "FREEDOM",
            disabled: false,
          },
          {
            name: "FREEHOLD",
            disabled: false,
          },
          {
            name: "FREELAND",
            disabled: false,
          },
          {
            name: "FREEPORT",
            disabled: false,
          },
          {
            name: "FREMONT",
            disabled: false,
          },
          {
            name: "FRESH MEADOWS",
            disabled: false,
          },
          {
            name: "FRESNO",
            disabled: false,
          },
          {
            name: "FRIDLEY",
            disabled: false,
          },
          {
            name: "FRIENDSWOOD",
            disabled: false,
          },
          {
            name: "FRISCO",
            disabled: false,
          },
          {
            name: "FRONT ROYAL",
            disabled: false,
          },
          {
            name: "FROSTBURG",
            disabled: false,
          },
          {
            name: "FRUIT COVE",
            disabled: false,
          },
          {
            name: "FRUITA",
            disabled: false,
          },
          {
            name: "FRYEBURG",
            disabled: false,
          },
          {
            name: "FT WRIGHT",
            disabled: false,
          },
          {
            name: "FULLERTON",
            disabled: false,
          },
          {
            name: "FULTON",
            disabled: false,
          },
          {
            name: "FULTONDALE",
            disabled: false,
          },
          {
            name: "FUQUAY VARINA",
            disabled: false,
          },
          {
            name: "FUQUAY-VARINA",
            disabled: false,
          },
          {
            name: "Fairbanks",
            disabled: false,
          },
          {
            name: "Fairborn",
            disabled: false,
          },
          {
            name: "Fairfax",
            disabled: false,
          },
          {
            name: "Fairview Heights",
            disabled: false,
          },
          {
            name: "Falcon",
            disabled: false,
          },
          {
            name: "Falls Church",
            disabled: false,
          },
          {
            name: "Farmers Branch",
            disabled: false,
          },
          {
            name: "Farmington Hills",
            disabled: false,
          },
          {
            name: "Farmville",
            disabled: false,
          },
          {
            name: "Fishers",
            disabled: false,
          },
          {
            name: "Fitchburg",
            disabled: false,
          },
          {
            name: "Flagstaff",
            disabled: false,
          },
          {
            name: "Flint",
            disabled: false,
          },
          {
            name: "Florence",
            disabled: false,
          },
          {
            name: "Floyds Knobs",
            disabled: false,
          },
          {
            name: "Flushing",
            disabled: false,
          },
          {
            name: "Fond du Lac",
            disabled: false,
          },
          {
            name: "Fontana",
            disabled: false,
          },
          {
            name: "Forest Park",
            disabled: false,
          },
          {
            name: "Fort Atkinson",
            disabled: false,
          },
          {
            name: "Fort Collins",
            disabled: false,
          },
          {
            name: "Fort Gratiot",
            disabled: false,
          },
          {
            name: "Fort Wayne",
            disabled: false,
          },
          {
            name: "Fort Worth",
            disabled: false,
          },
          {
            name: "Fountain Valley",
            disabled: false,
          },
          {
            name: "Frankfort",
            disabled: false,
          },
          {
            name: "Franklin",
            disabled: false,
          },
          {
            name: "Frederick",
            disabled: false,
          },
          {
            name: "Fremont",
            disabled: false,
          },
          {
            name: "Fresno",
            disabled: false,
          },
          {
            name: "Fruita",
            disabled: false,
          },
          {
            name: "Fuquay Varina",
            disabled: false,
          },
          {
            name: "GADSDEN",
            disabled: false,
          },
          {
            name: "GAFFNEY",
            disabled: false,
          },
          {
            name: "GAHANNA",
            disabled: false,
          },
          {
            name: "GAINESVILLE",
            disabled: false,
          },
          {
            name: "GAITHERSBURG",
            disabled: false,
          },
          {
            name: "GALAX",
            disabled: false,
          },
          {
            name: "GALENA",
            disabled: false,
          },
          {
            name: "GALES FERRY",
            disabled: false,
          },
          {
            name: "GALESBURG",
            disabled: false,
          },
          {
            name: "GALION",
            disabled: false,
          },
          {
            name: "GALLATIN",
            disabled: false,
          },
          {
            name: "GALLIANO",
            disabled: false,
          },
          {
            name: "GALLIPOLIS",
            disabled: false,
          },
          {
            name: "GALLOWAY",
            disabled: false,
          },
          {
            name: "GALLUP",
            disabled: false,
          },
          {
            name: "GALT",
            disabled: false,
          },
          {
            name: "GALVESTON",
            disabled: false,
          },
          {
            name: "GAMBRILLS",
            disabled: false,
          },
          {
            name: "GARDEN CITY",
            disabled: false,
          },
          {
            name: "GARDEN CITY BEACH",
            disabled: false,
          },
          {
            name: "GARDEN CITY PARK",
            disabled: false,
          },
          {
            name: "GARDEN GROVE",
            disabled: false,
          },
          {
            name: "GARDENA",
            disabled: false,
          },
          {
            name: "GARDENDALE",
            disabled: false,
          },
          {
            name: "GARDINER",
            disabled: false,
          },
          {
            name: "GARDNER",
            disabled: false,
          },
          {
            name: "GARDNERVILLE",
            disabled: false,
          },
          {
            name: "GARFIELD",
            disabled: false,
          },
          {
            name: "GARFIELD HEIGHTS",
            disabled: false,
          },
          {
            name: "GARLAND",
            disabled: false,
          },
          {
            name: "GARNER",
            disabled: false,
          },
          {
            name: "GARNERVILLE",
            disabled: false,
          },
          {
            name: "GARRETTSVILLE",
            disabled: false,
          },
          {
            name: "GARWOOD",
            disabled: false,
          },
          {
            name: "GARY",
            disabled: false,
          },
          {
            name: "GAS CITY",
            disabled: false,
          },
          {
            name: "GASSAWAY",
            disabled: false,
          },
          {
            name: "GASTON",
            disabled: false,
          },
          {
            name: "GASTONIA",
            disabled: false,
          },
          {
            name: "GATE CITY",
            disabled: false,
          },
          {
            name: "GATESVILLE",
            disabled: false,
          },
          {
            name: "GATLINBURG",
            disabled: false,
          },
          {
            name: "GAULEY BRIDGE",
            disabled: false,
          },
          {
            name: "GAUTIER",
            disabled: false,
          },
          {
            name: "GAYLORD",
            disabled: false,
          },
          {
            name: "GEISMAR",
            disabled: false,
          },
          {
            name: "GENESEO",
            disabled: false,
          },
          {
            name: "GENEVA",
            disabled: false,
          },
          {
            name: "GENOA",
            disabled: false,
          },
          {
            name: "GEORGETOWN",
            disabled: false,
          },
          {
            name: "GERMANTOWN",
            disabled: false,
          },
          {
            name: "GETTYSBURG",
            disabled: false,
          },
          {
            name: "GETZVILLE",
            disabled: false,
          },
          {
            name: "GIBBSBORO",
            disabled: false,
          },
          {
            name: "GIBBSTOWN",
            disabled: false,
          },
          {
            name: "GIBSONIA",
            disabled: false,
          },
          {
            name: "GIBSONTON",
            disabled: false,
          },
          {
            name: "GIDDINGS",
            disabled: false,
          },
          {
            name: "GIG HARBOR",
            disabled: false,
          },
          {
            name: "GILBERT",
            disabled: false,
          },
          {
            name: "GILBERTSVILLE",
            disabled: false,
          },
          {
            name: "GILFORD",
            disabled: false,
          },
          {
            name: "GILLETTE",
            disabled: false,
          },
          {
            name: "GILMER",
            disabled: false,
          },
          {
            name: "GILROY",
            disabled: false,
          },
          {
            name: "GIRARD",
            disabled: false,
          },
          {
            name: "GIRDWOOD",
            disabled: false,
          },
          {
            name: "GLADEWATER",
            disabled: false,
          },
          {
            name: "GLADSTONE",
            disabled: false,
          },
          {
            name: "GLADWIN",
            disabled: false,
          },
          {
            name: "GLASGOW",
            disabled: false,
          },
          {
            name: "GLASSBORO",
            disabled: false,
          },
          {
            name: "GLASSPORT",
            disabled: false,
          },
          {
            name: "GLASTONBURY",
            disabled: false,
          },
          {
            name: "GLEN ALLEN",
            disabled: false,
          },
          {
            name: "GLEN BURNIE",
            disabled: false,
          },
          {
            name: "GLEN CARBON",
            disabled: false,
          },
          {
            name: "GLEN COVE",
            disabled: false,
          },
          {
            name: "GLEN ELLYN",
            disabled: false,
          },
          {
            name: "GLEN HEAD",
            disabled: false,
          },
          {
            name: "GLEN MILLS",
            disabled: false,
          },
          {
            name: "GLEN ROCK",
            disabled: false,
          },
          {
            name: "GLENARDEN",
            disabled: false,
          },
          {
            name: "GLENDALE",
            disabled: false,
          },
          {
            name: "GLENDALE HEIGHTS",
            disabled: false,
          },
          {
            name: "GLENDIVE",
            disabled: false,
          },
          {
            name: "GLENDORA",
            disabled: false,
          },
          {
            name: "GLENMONT",
            disabled: false,
          },
          {
            name: "GLENNVILLE",
            disabled: false,
          },
          {
            name: "GLENOLDEN",
            disabled: false,
          },
          {
            name: "GLENPOOL",
            disabled: false,
          },
          {
            name: "GLENS FALLS",
            disabled: false,
          },
          {
            name: "GLENSHAW",
            disabled: false,
          },
          {
            name: "GLENSIDE",
            disabled: false,
          },
          {
            name: "GLENVIEW",
            disabled: false,
          },
          {
            name: "GLENVILLE",
            disabled: false,
          },
          {
            name: "GLENWOOD SPRINGS",
            disabled: false,
          },
          {
            name: "GLOBE",
            disabled: false,
          },
          {
            name: "GLOCESTER",
            disabled: false,
          },
          {
            name: "GLOUCESTER",
            disabled: false,
          },
          {
            name: "GLOUCESTER CITY",
            disabled: false,
          },
          {
            name: "GLOVERSVILLE",
            disabled: false,
          },
          {
            name: "GODDARD",
            disabled: false,
          },
          {
            name: "GODFREY",
            disabled: false,
          },
          {
            name: "GOLD CANYON",
            disabled: false,
          },
          {
            name: "GOLDEN",
            disabled: false,
          },
          {
            name: "GOLDEN VALLEY",
            disabled: false,
          },
          {
            name: "GOLDENS BRIDGE",
            disabled: false,
          },
          {
            name: "GOLDSBORO",
            disabled: false,
          },
          {
            name: "GOLETA",
            disabled: false,
          },
          {
            name: "GONZALES",
            disabled: false,
          },
          {
            name: "GOOCHLAND",
            disabled: false,
          },
          {
            name: "GOODLAND",
            disabled: false,
          },
          {
            name: "GOODLETTSVILLE",
            disabled: false,
          },
          {
            name: "GOODYEAR",
            disabled: false,
          },
          {
            name: "GOOSE CREEK",
            disabled: false,
          },
          {
            name: "GORDO",
            disabled: false,
          },
          {
            name: "GORDONSVILLE",
            disabled: false,
          },
          {
            name: "GORHAM",
            disabled: false,
          },
          {
            name: "GOSHEN",
            disabled: false,
          },
          {
            name: "GOWANDA",
            disabled: false,
          },
          {
            name: "GRAFTON",
            disabled: false,
          },
          {
            name: "GRAHAM",
            disabled: false,
          },
          {
            name: "GRANADA HILLS",
            disabled: false,
          },
          {
            name: "GRANBURY",
            disabled: false,
          },
          {
            name: "GRANBY",
            disabled: false,
          },
          {
            name: "GRAND BAY",
            disabled: false,
          },
          {
            name: "GRAND BLANC",
            disabled: false,
          },
          {
            name: "GRAND CHUTE",
            disabled: false,
          },
          {
            name: "GRAND COULEE",
            disabled: false,
          },
          {
            name: "GRAND FORKS",
            disabled: false,
          },
          {
            name: "GRAND HAVEN",
            disabled: false,
          },
          {
            name: "GRAND ISLAND",
            disabled: false,
          },
          {
            name: "GRAND JUNCTION",
            disabled: false,
          },
          {
            name: "GRAND LEDGE",
            disabled: false,
          },
          {
            name: "GRAND PRAIRIE",
            disabled: false,
          },
          {
            name: "GRAND RAPIDS",
            disabled: false,
          },
          {
            name: "GRAND TERRACE",
            disabled: false,
          },
          {
            name: "GRANDVIEW",
            disabled: false,
          },
          {
            name: "GRANDVIEW HEIGHTS",
            disabled: false,
          },
          {
            name: "GRANDVILLE",
            disabled: false,
          },
          {
            name: "GRANGER",
            disabled: false,
          },
          {
            name: "GRANITE BAY",
            disabled: false,
          },
          {
            name: "GRANITE CITY",
            disabled: false,
          },
          {
            name: "GRANITE FALLS",
            disabled: false,
          },
          {
            name: "GRANT",
            disabled: false,
          },
          {
            name: "GRANTS",
            disabled: false,
          },
          {
            name: "GRANTS PASS",
            disabled: false,
          },
          {
            name: "GRANTSBORO",
            disabled: false,
          },
          {
            name: "GRANTSVILLE",
            disabled: false,
          },
          {
            name: "GRANVILLE",
            disabled: false,
          },
          {
            name: "GRAPEVINE",
            disabled: false,
          },
          {
            name: "GRASS VALLEY",
            disabled: false,
          },
          {
            name: "GRAY",
            disabled: false,
          },
          {
            name: "GRAYLING",
            disabled: false,
          },
          {
            name: "GRAYSLAKE",
            disabled: false,
          },
          {
            name: "GRAYSON",
            disabled: false,
          },
          {
            name: "GREAT BARRINGTON",
            disabled: false,
          },
          {
            name: "GREAT BEND",
            disabled: false,
          },
          {
            name: "GREAT FALLS",
            disabled: false,
          },
          {
            name: "GREAT NECK",
            disabled: false,
          },
          {
            name: "GREECE",
            disabled: false,
          },
          {
            name: "GREELEY",
            disabled: false,
          },
          {
            name: "GREEN BAY",
            disabled: false,
          },
          {
            name: "GREEN BROOK",
            disabled: false,
          },
          {
            name: "GREEN COVE SPRINGS",
            disabled: false,
          },
          {
            name: "GREEN PARK",
            disabled: false,
          },
          {
            name: "GREEN RIVER",
            disabled: false,
          },
          {
            name: "GREEN VALLEY",
            disabled: false,
          },
          {
            name: "GREENACRES",
            disabled: false,
          },
          {
            name: "GREENBELT",
            disabled: false,
          },
          {
            name: "GREENBRIER",
            disabled: false,
          },
          {
            name: "GREENCASTLE",
            disabled: false,
          },
          {
            name: "GREENDALE",
            disabled: false,
          },
          {
            name: "GREENEVILLE",
            disabled: false,
          },
          {
            name: "GREENFIELD",
            disabled: false,
          },
          {
            name: "GREENLAND",
            disabled: false,
          },
          {
            name: "GREENLAWN",
            disabled: false,
          },
          {
            name: "GREENSBORO",
            disabled: false,
          },
          {
            name: "GREENSBURG",
            disabled: false,
          },
          {
            name: "GREENVALE",
            disabled: false,
          },
          {
            name: "GREENVILLE",
            disabled: false,
          },
          {
            name: "GREENWELL SPRINGS",
            disabled: false,
          },
          {
            name: "GREENWICH",
            disabled: false,
          },
          {
            name: "GREENWOOD",
            disabled: false,
          },
          {
            name: "GREENWOOD LAKE",
            disabled: false,
          },
          {
            name: "GREENWOOD VILLAGE",
            disabled: false,
          },
          {
            name: "GREER",
            disabled: false,
          },
          {
            name: "GRENADA",
            disabled: false,
          },
          {
            name: "GRESHAM",
            disabled: false,
          },
          {
            name: "GRETNA",
            disabled: false,
          },
          {
            name: "GRIDLEY",
            disabled: false,
          },
          {
            name: "GRIFFIN",
            disabled: false,
          },
          {
            name: "GRIFFITH",
            disabled: false,
          },
          {
            name: "GRIMES",
            disabled: false,
          },
          {
            name: "GRINDSTONE",
            disabled: false,
          },
          {
            name: "GRINNELL",
            disabled: false,
          },
          {
            name: "GROSSE ILE",
            disabled: false,
          },
          {
            name: "GROSSE POINTE PARK",
            disabled: false,
          },
          {
            name: "GROSSE POINTE WOODS",
            disabled: false,
          },
          {
            name: "GROTON",
            disabled: false,
          },
          {
            name: "GROTTOES",
            disabled: false,
          },
          {
            name: "GROVE",
            disabled: false,
          },
          {
            name: "GROVE CITY",
            disabled: false,
          },
          {
            name: "GROVELAND",
            disabled: false,
          },
          {
            name: "GROVEPORT",
            disabled: false,
          },
          {
            name: "GROVER BEACH",
            disabled: false,
          },
          {
            name: "GROVES",
            disabled: false,
          },
          {
            name: "GROVETOWN",
            disabled: false,
          },
          {
            name: "GRUNDY",
            disabled: false,
          },
          {
            name: "GUAYAMA",
            disabled: false,
          },
          {
            name: "GUERNEVILLE",
            disabled: false,
          },
          {
            name: "GUILDERLAND",
            disabled: false,
          },
          {
            name: "GUILFORD",
            disabled: false,
          },
          {
            name: "GULF BREEZE",
            disabled: false,
          },
          {
            name: "GULF SHORES",
            disabled: false,
          },
          {
            name: "GULFPORT",
            disabled: false,
          },
          {
            name: "GUN BARREL CITY",
            disabled: false,
          },
          {
            name: "GUNNISON",
            disabled: false,
          },
          {
            name: "GUNTERSVILLE",
            disabled: false,
          },
          {
            name: "GURNEE",
            disabled: false,
          },
          {
            name: "GUTHRIE",
            disabled: false,
          },
          {
            name: "GUYMON",
            disabled: false,
          },
          {
            name: "GYPSUM",
            disabled: false,
          },
          {
            name: "Gainesville",
            disabled: false,
          },
          {
            name: "Galax",
            disabled: false,
          },
          {
            name: "Garden City",
            disabled: false,
          },
          {
            name: "Garner",
            disabled: false,
          },
          {
            name: "Georgetown",
            disabled: false,
          },
          {
            name: "Germantown",
            disabled: false,
          },
          {
            name: "Gig Harbor",
            disabled: false,
          },
          {
            name: "Gilbert",
            disabled: false,
          },
          {
            name: "Glasgow",
            disabled: false,
          },
          {
            name: "Glendale",
            disabled: false,
          },
          {
            name: "Glendora",
            disabled: false,
          },
          {
            name: "Glenview",
            disabled: false,
          },
          {
            name: "Glenwood Springs",
            disabled: false,
          },
          {
            name: "Globe",
            disabled: false,
          },
          {
            name: "Godfrey",
            disabled: false,
          },
          {
            name: "Goodlettsville",
            disabled: false,
          },
          {
            name: "Goodyear",
            disabled: false,
          },
          {
            name: "Grafton",
            disabled: false,
          },
          {
            name: "Granbury",
            disabled: false,
          },
          {
            name: "Granby",
            disabled: false,
          },
          {
            name: "Grand Junction",
            disabled: false,
          },
          {
            name: "Grand Prairie",
            disabled: false,
          },
          {
            name: "Granger",
            disabled: false,
          },
          {
            name: "Granite City",
            disabled: false,
          },
          {
            name: "Grass Valley",
            disabled: false,
          },
          {
            name: "Great Bend",
            disabled: false,
          },
          {
            name: "Green Bay",
            disabled: false,
          },
          {
            name: "Greenville",
            disabled: false,
          },
          {
            name: "Griffin",
            disabled: false,
          },
          {
            name: "Groveland",
            disabled: false,
          },
          {
            name: "Groveport",
            disabled: false,
          },
          {
            name: "Gunnison",
            disabled: false,
          },
          {
            name: "Gurnee",
            disabled: false,
          },
          {
            name: "HACIENDA HEIGHTS",
            disabled: false,
          },
          {
            name: "HACKENSACK",
            disabled: false,
          },
          {
            name: "HACKETTSTOWN",
            disabled: false,
          },
          {
            name: "HADDON HEIGHTS",
            disabled: false,
          },
          {
            name: "HADDON TOWNSHIP",
            disabled: false,
          },
          {
            name: "HADDONFIELD",
            disabled: false,
          },
          {
            name: "HADLEY",
            disabled: false,
          },
          {
            name: "HAGERSTOWN",
            disabled: false,
          },
          {
            name: "HAHIRA",
            disabled: false,
          },
          {
            name: "HAILEY",
            disabled: false,
          },
          {
            name: "HAINES CITY",
            disabled: false,
          },
          {
            name: "HAINESVILLE",
            disabled: false,
          },
          {
            name: "HALEDON",
            disabled: false,
          },
          {
            name: "HALEIWA",
            disabled: false,
          },
          {
            name: "HALES CORNERS",
            disabled: false,
          },
          {
            name: "HALEYVILLE",
            disabled: false,
          },
          {
            name: "HALF MOON BAY",
            disabled: false,
          },
          {
            name: "HALIFAX",
            disabled: false,
          },
          {
            name: "HALLANDALE BEACH",
            disabled: false,
          },
          {
            name: "HALLETTSVILLE",
            disabled: false,
          },
          {
            name: "HALTOM CITY",
            disabled: false,
          },
          {
            name: "HAMBURG",
            disabled: false,
          },
          {
            name: "HAMDEN",
            disabled: false,
          },
          {
            name: "HAMILTON",
            disabled: false,
          },
          {
            name: "HAMILTON SQ",
            disabled: false,
          },
          {
            name: "HAMLET",
            disabled: false,
          },
          {
            name: "HAMLIN",
            disabled: false,
          },
          {
            name: "HAMMOND",
            disabled: false,
          },
          {
            name: "HAMMONTON",
            disabled: false,
          },
          {
            name: "HAMPDEN",
            disabled: false,
          },
          {
            name: "HAMPSTEAD",
            disabled: false,
          },
          {
            name: "HAMPTON",
            disabled: false,
          },
          {
            name: "HAMPTON BAYS",
            disabled: false,
          },
          {
            name: "HAMTRAMCK",
            disabled: false,
          },
          {
            name: "HANCEVILLE",
            disabled: false,
          },
          {
            name: "HANCOCK",
            disabled: false,
          },
          {
            name: "HANFORD",
            disabled: false,
          },
          {
            name: "HANNIBAL",
            disabled: false,
          },
          {
            name: "HANOVER",
            disabled: false,
          },
          {
            name: "HANOVER PARK",
            disabled: false,
          },
          {
            name: "HANSON",
            disabled: false,
          },
          {
            name: "HAPPY VALLEY",
            disabled: false,
          },
          {
            name: "HARAHAN",
            disabled: false,
          },
          {
            name: "HARBOR",
            disabled: false,
          },
          {
            name: "HARBOR CITY",
            disabled: false,
          },
          {
            name: "HARBORCREEK",
            disabled: false,
          },
          {
            name: "HARDEEVILLE",
            disabled: false,
          },
          {
            name: "HARDINSBURG",
            disabled: false,
          },
          {
            name: "HARDWICK",
            disabled: false,
          },
          {
            name: "HARDY",
            disabled: false,
          },
          {
            name: "HARKER HEIGHTS",
            disabled: false,
          },
          {
            name: "HARLAN",
            disabled: false,
          },
          {
            name: "HARLEM",
            disabled: false,
          },
          {
            name: "HARLEYSVILLE",
            disabled: false,
          },
          {
            name: "HARLINGEN",
            disabled: false,
          },
          {
            name: "HARMONY",
            disabled: false,
          },
          {
            name: "HARPER WOODS",
            disabled: false,
          },
          {
            name: "HARRIMAN",
            disabled: false,
          },
          {
            name: "HARRINGTON",
            disabled: false,
          },
          {
            name: "HARRISBURG",
            disabled: false,
          },
          {
            name: "HARRISON",
            disabled: false,
          },
          {
            name: "HARRISON TOWNSHIP",
            disabled: false,
          },
          {
            name: "HARRISONBURG",
            disabled: false,
          },
          {
            name: "HARRISONVILLE",
            disabled: false,
          },
          {
            name: "HARRISVILLE",
            disabled: false,
          },
          {
            name: "HARRODSBURG",
            disabled: false,
          },
          {
            name: "HARTFORD",
            disabled: false,
          },
          {
            name: "HARTFORD CITY",
            disabled: false,
          },
          {
            name: "HARTLAND",
            disabled: false,
          },
          {
            name: "HARTSDALE",
            disabled: false,
          },
          {
            name: "HARTSELLE",
            disabled: false,
          },
          {
            name: "HARTSVILLE",
            disabled: false,
          },
          {
            name: "HARTVILLE",
            disabled: false,
          },
          {
            name: "HARTWELL",
            disabled: false,
          },
          {
            name: "HARVARD",
            disabled: false,
          },
          {
            name: "HARVEST",
            disabled: false,
          },
          {
            name: "HARVEY",
            disabled: false,
          },
          {
            name: "HARWICH",
            disabled: false,
          },
          {
            name: "HARWICH PORT",
            disabled: false,
          },
          {
            name: "HASBROUCK HEIGHTS",
            disabled: false,
          },
          {
            name: "HASKELL",
            disabled: false,
          },
          {
            name: "HASLET",
            disabled: false,
          },
          {
            name: "HASLETT",
            disabled: false,
          },
          {
            name: "HASTINGS",
            disabled: false,
          },
          {
            name: "HATBORO",
            disabled: false,
          },
          {
            name: "HATFIELD",
            disabled: false,
          },
          {
            name: "HATILLO",
            disabled: false,
          },
          {
            name: "HATTIESBURG",
            disabled: false,
          },
          {
            name: "HAUGHTON",
            disabled: false,
          },
          {
            name: "HAUPPAUGE",
            disabled: false,
          },
          {
            name: "HAVANA",
            disabled: false,
          },
          {
            name: "HAVELOCK",
            disabled: false,
          },
          {
            name: "HAVERHILL",
            disabled: false,
          },
          {
            name: "HAVERTOWN",
            disabled: false,
          },
          {
            name: "HAVRE",
            disabled: false,
          },
          {
            name: "HAVRE DE GRACE",
            disabled: false,
          },
          {
            name: "HAW RIVER",
            disabled: false,
          },
          {
            name: "HAWAIIAN GARDENS",
            disabled: false,
          },
          {
            name: "HAWKINSVILLE",
            disabled: false,
          },
          {
            name: "HAWLEY",
            disabled: false,
          },
          {
            name: "HAWTHORNE",
            disabled: false,
          },
          {
            name: "HAYDEN",
            disabled: false,
          },
          {
            name: "HAYES",
            disabled: false,
          },
          {
            name: "HAYESVILLE",
            disabled: false,
          },
          {
            name: "HAYMARKET",
            disabled: false,
          },
          {
            name: "HAYS",
            disabled: false,
          },
          {
            name: "HAYWARD",
            disabled: false,
          },
          {
            name: "HAZARD",
            disabled: false,
          },
          {
            name: "HAZEL CREST",
            disabled: false,
          },
          {
            name: "HAZEL GREEN",
            disabled: false,
          },
          {
            name: "HAZEL PARK",
            disabled: false,
          },
          {
            name: "HAZELWOOD",
            disabled: false,
          },
          {
            name: "HAZLE TOWNSHIP",
            disabled: false,
          },
          {
            name: "HAZLEHURST",
            disabled: false,
          },
          {
            name: "HAZLET",
            disabled: false,
          },
          {
            name: "HAZLETON",
            disabled: false,
          },
          {
            name: "HEALDSBURG",
            disabled: false,
          },
          {
            name: "HEATH",
            disabled: false,
          },
          {
            name: "HEATHSVILLE",
            disabled: false,
          },
          {
            name: "HEBER CITY",
            disabled: false,
          },
          {
            name: "HEBER SPGS",
            disabled: false,
          },
          {
            name: "HEBRON",
            disabled: false,
          },
          {
            name: "HELENA",
            disabled: false,
          },
          {
            name: "HELENA-WEST HELENA",
            disabled: false,
          },
          {
            name: "HELLERTOWN",
            disabled: false,
          },
          {
            name: "HELOTES",
            disabled: false,
          },
          {
            name: "HEMET",
            disabled: false,
          },
          {
            name: "HEMINGWAY",
            disabled: false,
          },
          {
            name: "HEMPSTEAD",
            disabled: false,
          },
          {
            name: "HENDERSON",
            disabled: false,
          },
          {
            name: "HENDERSONVILLE",
            disabled: false,
          },
          {
            name: "HENRICO",
            disabled: false,
          },
          {
            name: "HENRIETTA",
            disabled: false,
          },
          {
            name: "HENRYETTA",
            disabled: false,
          },
          {
            name: "HEPHZIBAH",
            disabled: false,
          },
          {
            name: "HERCULES",
            disabled: false,
          },
          {
            name: "HEREFORD",
            disabled: false,
          },
          {
            name: "HERKIMER",
            disabled: false,
          },
          {
            name: "HERMANTOWN",
            disabled: false,
          },
          {
            name: "HERMISTON",
            disabled: false,
          },
          {
            name: "HERMITAGE",
            disabled: false,
          },
          {
            name: "HERMOSA BEACH",
            disabled: false,
          },
          {
            name: "HERNANDO",
            disabled: false,
          },
          {
            name: "HERNDON",
            disabled: false,
          },
          {
            name: "HERRIMAN",
            disabled: false,
          },
          {
            name: "HERRIN",
            disabled: false,
          },
          {
            name: "HERSHEY",
            disabled: false,
          },
          {
            name: "HESPERIA",
            disabled: false,
          },
          {
            name: "HEWITT",
            disabled: false,
          },
          {
            name: "HEWLETT",
            disabled: false,
          },
          {
            name: "HIALEAH",
            disabled: false,
          },
          {
            name: "HIALEAH GARDENS",
            disabled: false,
          },
          {
            name: "HIAWASSEE",
            disabled: false,
          },
          {
            name: "HIAWATHA",
            disabled: false,
          },
          {
            name: "HIBBING",
            disabled: false,
          },
          {
            name: "HICKORY",
            disabled: false,
          },
          {
            name: "HICKORY CREEK",
            disabled: false,
          },
          {
            name: "HICKORY HILLS",
            disabled: false,
          },
          {
            name: "HICKSVILLE",
            disabled: false,
          },
          {
            name: "HIDALGO",
            disabled: false,
          },
          {
            name: "HIGGINSVILLE",
            disabled: false,
          },
          {
            name: "HIGH POINT",
            disabled: false,
          },
          {
            name: "HIGH RIDGE",
            disabled: false,
          },
          {
            name: "HIGH SPRINGS",
            disabled: false,
          },
          {
            name: "HIGHLAND",
            disabled: false,
          },
          {
            name: "HIGHLAND FALLS",
            disabled: false,
          },
          {
            name: "HIGHLAND HEIGHTS",
            disabled: false,
          },
          {
            name: "HIGHLAND PARK",
            disabled: false,
          },
          {
            name: "HIGHLAND SPRINGS",
            disabled: false,
          },
          {
            name: "HIGHLAND VILLAGE",
            disabled: false,
          },
          {
            name: "HIGHLANDS",
            disabled: false,
          },
          {
            name: "HIGHLANDS RANCH",
            disabled: false,
          },
          {
            name: "HIGHWOOD",
            disabled: false,
          },
          {
            name: "HILDEBRAN",
            disabled: false,
          },
          {
            name: "HILLIARD",
            disabled: false,
          },
          {
            name: "HILLSBORO",
            disabled: false,
          },
          {
            name: "HILLSBOROUGH",
            disabled: false,
          },
          {
            name: "HILLSDALE",
            disabled: false,
          },
          {
            name: "HILLSIDE",
            disabled: false,
          },
          {
            name: "HILLSVILLE",
            disabled: false,
          },
          {
            name: "HILLTOP",
            disabled: false,
          },
          {
            name: "HILMAR",
            disabled: false,
          },
          {
            name: "HILO",
            disabled: false,
          },
          {
            name: "HILTON",
            disabled: false,
          },
          {
            name: "HILTON HEAD ISLAND",
            disabled: false,
          },
          {
            name: "HINCKLEY",
            disabled: false,
          },
          {
            name: "HINDMAN",
            disabled: false,
          },
          {
            name: "HINES",
            disabled: false,
          },
          {
            name: "HINESVILLE",
            disabled: false,
          },
          {
            name: "HINGHAM",
            disabled: false,
          },
          {
            name: "HINSDALE",
            disabled: false,
          },
          {
            name: "HINTON",
            disabled: false,
          },
          {
            name: "HIRAM",
            disabled: false,
          },
          {
            name: "HIXSON",
            disabled: false,
          },
          {
            name: "HOBART",
            disabled: false,
          },
          {
            name: "HOBBS",
            disabled: false,
          },
          {
            name: "HOBE SOUND",
            disabled: false,
          },
          {
            name: "HOBOKEN",
            disabled: false,
          },
          {
            name: "HOCKESSIN",
            disabled: false,
          },
          {
            name: "HODGENVILLE",
            disabled: false,
          },
          {
            name: "HODGKINS",
            disabled: false,
          },
          {
            name: "HOFFMAN ESTATES",
            disabled: false,
          },
          {
            name: "HOGANSVILLE",
            disabled: false,
          },
          {
            name: "HOHENWALD",
            disabled: false,
          },
          {
            name: "HOLBROOK",
            disabled: false,
          },
          {
            name: "HOLDEN",
            disabled: false,
          },
          {
            name: "HOLDEN BEACH",
            disabled: false,
          },
          {
            name: "HOLDENVILLE",
            disabled: false,
          },
          {
            name: "HOLIDAY",
            disabled: false,
          },
          {
            name: "HOLLAND",
            disabled: false,
          },
          {
            name: "HOLLINS",
            disabled: false,
          },
          {
            name: "HOLLISTER",
            disabled: false,
          },
          {
            name: "HOLLISTON",
            disabled: false,
          },
          {
            name: "HOLLY",
            disabled: false,
          },
          {
            name: "HOLLY HILL",
            disabled: false,
          },
          {
            name: "HOLLY SPRINGS",
            disabled: false,
          },
          {
            name: "HOLLYWOOD",
            disabled: false,
          },
          {
            name: "HOLMES",
            disabled: false,
          },
          {
            name: "HOLMES BEACH",
            disabled: false,
          },
          {
            name: "HOLT",
            disabled: false,
          },
          {
            name: "HOLTON",
            disabled: false,
          },
          {
            name: "HOLYOKE",
            disabled: false,
          },
          {
            name: "HOMEDALE",
            disabled: false,
          },
          {
            name: "HOMER",
            disabled: false,
          },
          {
            name: "HOMER GLEN",
            disabled: false,
          },
          {
            name: "HOMERVILLE",
            disabled: false,
          },
          {
            name: "HOMESTEAD",
            disabled: false,
          },
          {
            name: "HOMETOWN",
            disabled: false,
          },
          {
            name: "HOMEWOOD",
            disabled: false,
          },
          {
            name: "HOMOSASSA",
            disabled: false,
          },
          {
            name: "HONDO",
            disabled: false,
          },
          {
            name: "HONEA PATH",
            disabled: false,
          },
          {
            name: "HONEOYE",
            disabled: false,
          },
          {
            name: "HONEOYE FALLS",
            disabled: false,
          },
          {
            name: "HONESDALE",
            disabled: false,
          },
          {
            name: "HONOLULU",
            disabled: false,
          },
          {
            name: "HONOLULU (OAHU)",
            disabled: false,
          },
          {
            name: "HOOD RIVER",
            disabled: false,
          },
          {
            name: "HOOKSETT",
            disabled: false,
          },
          {
            name: "HOOPESTON",
            disabled: false,
          },
          {
            name: "HOOVER",
            disabled: false,
          },
          {
            name: "HOPATCONG",
            disabled: false,
          },
          {
            name: "HOPE",
            disabled: false,
          },
          {
            name: "HOPE MILLS",
            disabled: false,
          },
          {
            name: "HOPEWELL",
            disabled: false,
          },
          {
            name: "HOPEWELL JUNCTION",
            disabled: false,
          },
          {
            name: "HOPKINS",
            disabled: false,
          },
          {
            name: "HOPKINSVILLE",
            disabled: false,
          },
          {
            name: "HOPKINTON",
            disabled: false,
          },
          {
            name: "HOQUIAM",
            disabled: false,
          },
          {
            name: "HORIZON CITY",
            disabled: false,
          },
          {
            name: "HORN LAKE",
            disabled: false,
          },
          {
            name: "HORNELL",
            disabled: false,
          },
          {
            name: "HORSE CAVE",
            disabled: false,
          },
          {
            name: "HORSEHEADS",
            disabled: false,
          },
          {
            name: "HORSHAM",
            disabled: false,
          },
          {
            name: "HOSCHTON",
            disabled: false,
          },
          {
            name: "HOT SPRINGS",
            disabled: false,
          },
          {
            name: "HOT SPRINGS VILLAGE",
            disabled: false,
          },
          {
            name: "HOUGHTON",
            disabled: false,
          },
          {
            name: "HOUGHTON LAKE",
            disabled: false,
          },
          {
            name: "HOULTON",
            disabled: false,
          },
          {
            name: "HOUMA",
            disabled: false,
          },
          {
            name: "HOUSE SPRINGS",
            disabled: false,
          },
          {
            name: "HOUSTON",
            disabled: false,
          },
          {
            name: "HOWARD BEACH",
            disabled: false,
          },
          {
            name: "HOWELL",
            disabled: false,
          },
          {
            name: "HUBBARD",
            disabled: false,
          },
          {
            name: "HUBER HEIGHTS",
            disabled: false,
          },
          {
            name: "HUDSON",
            disabled: false,
          },
          {
            name: "HUDSON FALLS",
            disabled: false,
          },
          {
            name: "HUDSON OAKS",
            disabled: false,
          },
          {
            name: "HUDSONVILLE",
            disabled: false,
          },
          {
            name: "HUEYTOWN",
            disabled: false,
          },
          {
            name: "HUGO",
            disabled: false,
          },
          {
            name: "HULL",
            disabled: false,
          },
          {
            name: "HUMACAO",
            disabled: false,
          },
          {
            name: "HUMBLE",
            disabled: false,
          },
          {
            name: "HUMBOLDT",
            disabled: false,
          },
          {
            name: "HUMMELSTOWN",
            disabled: false,
          },
          {
            name: "HUNTERSVILLE",
            disabled: false,
          },
          {
            name: "HUNTINGBURG",
            disabled: false,
          },
          {
            name: "HUNTINGDON",
            disabled: false,
          },
          {
            name: "HUNTINGDON VALLEY",
            disabled: false,
          },
          {
            name: "HUNTINGTON",
            disabled: false,
          },
          {
            name: "HUNTINGTON BEAC",
            disabled: false,
          },
          {
            name: "HUNTINGTON BEACH",
            disabled: false,
          },
          {
            name: "HUNTINGTON PARK",
            disabled: false,
          },
          {
            name: "HUNTINGTON STATION",
            disabled: false,
          },
          {
            name: "HUNTINGTON WOODS",
            disabled: false,
          },
          {
            name: "HUNTLEY",
            disabled: false,
          },
          {
            name: "HUNTSVILLE",
            disabled: false,
          },
          {
            name: "HURLEY",
            disabled: false,
          },
          {
            name: "HURON",
            disabled: false,
          },
          {
            name: "HURRICANE",
            disabled: false,
          },
          {
            name: "HURST",
            disabled: false,
          },
          {
            name: "HUTCHINSON",
            disabled: false,
          },
          {
            name: "HUTTO",
            disabled: false,
          },
          {
            name: "HYANNIS",
            disabled: false,
          },
          {
            name: "HYATTSVILLE",
            disabled: false,
          },
          {
            name: "HYDE PARK",
            disabled: false,
          },
          {
            name: "Hadlock",
            disabled: false,
          },
          {
            name: "Haltom City",
            disabled: false,
          },
          {
            name: "Hampton",
            disabled: false,
          },
          {
            name: "Hanford",
            disabled: false,
          },
          {
            name: "Happy Valley",
            disabled: false,
          },
          {
            name: "Harwood Heights",
            disabled: false,
          },
          {
            name: "Heber City",
            disabled: false,
          },
          {
            name: "Henderson",
            disabled: false,
          },
          {
            name: "Hendersonville",
            disabled: false,
          },
          {
            name: "Henrico",
            disabled: false,
          },
          {
            name: "Hermosa Beach",
            disabled: false,
          },
          {
            name: "Hernando",
            disabled: false,
          },
          {
            name: "Highland",
            disabled: false,
          },
          {
            name: "Hilliard",
            disabled: false,
          },
          {
            name: "Hilton Head",
            disabled: false,
          },
          {
            name: "Hinton",
            disabled: false,
          },
          {
            name: "Hoffman Estates",
            disabled: false,
          },
          {
            name: "Holland",
            disabled: false,
          },
          {
            name: "Hollywood",
            disabled: false,
          },
          {
            name: "Holyoke",
            disabled: false,
          },
          {
            name: "Homestead",
            disabled: false,
          },
          {
            name: "Homewood",
            disabled: false,
          },
          {
            name: "Honolulu",
            disabled: false,
          },
          {
            name: "Hotchkiss",
            disabled: false,
          },
          {
            name: "Houston",
            disabled: false,
          },
          {
            name: "Howell",
            disabled: false,
          },
          {
            name: "Humble",
            disabled: false,
          },
          {
            name: "Huntington",
            disabled: false,
          },
          {
            name: "Huntington Beach",
            disabled: false,
          },
          {
            name: "Huntington Park",
            disabled: false,
          },
          {
            name: "Huntsville",
            disabled: false,
          },
          {
            name: "Hurricane",
            disabled: false,
          },
          {
            name: "Hutchinson",
            disabled: false,
          },
          {
            name: "IDABEL",
            disabled: false,
          },
          {
            name: "IDAHO FALLS",
            disabled: false,
          },
          {
            name: "IDAHO SPRINGS",
            disabled: false,
          },
          {
            name: "ILION",
            disabled: false,
          },
          {
            name: "IMLAY CITY",
            disabled: false,
          },
          {
            name: "IMMOKALEE",
            disabled: false,
          },
          {
            name: "IMPERIAL",
            disabled: false,
          },
          {
            name: "IMPERIAL BEACH",
            disabled: false,
          },
          {
            name: "INDEPENDENCE",
            disabled: false,
          },
          {
            name: "INDIALANTIC",
            disabled: false,
          },
          {
            name: "INDIAN LAND",
            disabled: false,
          },
          {
            name: "INDIAN ROCKS BEACH",
            disabled: false,
          },
          {
            name: "INDIAN TRAIL",
            disabled: false,
          },
          {
            name: "INDIAN WELLS",
            disabled: false,
          },
          {
            name: "INDIANA",
            disabled: false,
          },
          {
            name: "INDIANAPOLIS",
            disabled: false,
          },
          {
            name: "INDIANOLA",
            disabled: false,
          },
          {
            name: "INDIO",
            disabled: false,
          },
          {
            name: "INGLEWOOD",
            disabled: false,
          },
          {
            name: "INKSTER",
            disabled: false,
          },
          {
            name: "INMAN",
            disabled: false,
          },
          {
            name: "INTERLACHEN",
            disabled: false,
          },
          {
            name: "INVER GROVE HEIGHTS",
            disabled: false,
          },
          {
            name: "INVERNESS",
            disabled: false,
          },
          {
            name: "INWOOD",
            disabled: false,
          },
          {
            name: "IOLA",
            disabled: false,
          },
          {
            name: "IONIA",
            disabled: false,
          },
          {
            name: "IOWA CITY",
            disabled: false,
          },
          {
            name: "IOWA FALLS",
            disabled: false,
          },
          {
            name: "IPSWICH",
            disabled: false,
          },
          {
            name: "IRMO",
            disabled: false,
          },
          {
            name: "IRON MOUNTAIN",
            disabled: false,
          },
          {
            name: "IRONDALE",
            disabled: false,
          },
          {
            name: "IRONDEQUOIT",
            disabled: false,
          },
          {
            name: "IRONTON",
            disabled: false,
          },
          {
            name: "IRONWOOD",
            disabled: false,
          },
          {
            name: "IRVINE",
            disabled: false,
          },
          {
            name: "IRVING",
            disabled: false,
          },
          {
            name: "IRVINGTON",
            disabled: false,
          },
          {
            name: "IRWIN",
            disabled: false,
          },
          {
            name: "ISABELA",
            disabled: false,
          },
          {
            name: "ISLAMORADA",
            disabled: false,
          },
          {
            name: "ISLAND CITY",
            disabled: false,
          },
          {
            name: "ISLAND LAKE",
            disabled: false,
          },
          {
            name: "ISLANDIA",
            disabled: false,
          },
          {
            name: "ISLIP TERRACE",
            disabled: false,
          },
          {
            name: "ISSAQUAH",
            disabled: false,
          },
          {
            name: "ITASCA",
            disabled: false,
          },
          {
            name: "ITHACA",
            disabled: false,
          },
          {
            name: "IUKA",
            disabled: false,
          },
          {
            name: "Idaho Falls",
            disabled: false,
          },
          {
            name: "Independence",
            disabled: false,
          },
          {
            name: "Indian Wells",
            disabled: false,
          },
          {
            name: "Indianapolis",
            disabled: false,
          },
          {
            name: "Inglewood",
            disabled: false,
          },
          {
            name: "Iowa City",
            disabled: false,
          },
          {
            name: "Irvine",
            disabled: false,
          },
          {
            name: "Issaquah",
            disabled: false,
          },
          {
            name: "JACINTO CITY",
            disabled: false,
          },
          {
            name: "JACKSBORO",
            disabled: false,
          },
          {
            name: "JACKSON",
            disabled: false,
          },
          {
            name: "JACKSON HEIGHTS",
            disabled: false,
          },
          {
            name: "JACKSONVILLE",
            disabled: false,
          },
          {
            name: "JACKSONVILLE BEACH",
            disabled: false,
          },
          {
            name: "JAFFREY",
            disabled: false,
          },
          {
            name: "JAMAICA",
            disabled: false,
          },
          {
            name: "JAMAICA PLAIN",
            disabled: false,
          },
          {
            name: "JAMESBURG",
            disabled: false,
          },
          {
            name: "JAMESTOWN",
            disabled: false,
          },
          {
            name: "JAMISON",
            disabled: false,
          },
          {
            name: "JANESVILLE",
            disabled: false,
          },
          {
            name: "JASPER",
            disabled: false,
          },
          {
            name: "JEANNETTE",
            disabled: false,
          },
          {
            name: "JEFFERSON",
            disabled: false,
          },
          {
            name: "JEFFERSON CITY",
            disabled: false,
          },
          {
            name: "JEFFERSONTOWN",
            disabled: false,
          },
          {
            name: "JEFFERSONVILLE",
            disabled: false,
          },
          {
            name: "JELLICO",
            disabled: false,
          },
          {
            name: "JENA",
            disabled: false,
          },
          {
            name: "JENISON",
            disabled: false,
          },
          {
            name: "JENKINS",
            disabled: false,
          },
          {
            name: "JENKINTOWN",
            disabled: false,
          },
          {
            name: "JENKS",
            disabled: false,
          },
          {
            name: "JENNINGS",
            disabled: false,
          },
          {
            name: "JENSEN BEACH",
            disabled: false,
          },
          {
            name: "JERICHO",
            disabled: false,
          },
          {
            name: "JEROME",
            disabled: false,
          },
          {
            name: "JERSEY CITY",
            disabled: false,
          },
          {
            name: "JERSEY SHORE",
            disabled: false,
          },
          {
            name: "JERSEYVILLE",
            disabled: false,
          },
          {
            name: "JESSUP",
            disabled: false,
          },
          {
            name: "JESUP",
            disabled: false,
          },
          {
            name: "JEWETT CITY",
            disabled: false,
          },
          {
            name: "JOHNS CREEK",
            disabled: false,
          },
          {
            name: "JOHNS ISLAND",
            disabled: false,
          },
          {
            name: "JOHNSBURG",
            disabled: false,
          },
          {
            name: "JOHNSON CITY",
            disabled: false,
          },
          {
            name: "JOHNSTON",
            disabled: false,
          },
          {
            name: "JOHNSTOWN",
            disabled: false,
          },
          {
            name: "JOLIET",
            disabled: false,
          },
          {
            name: "JONESBORO",
            disabled: false,
          },
          {
            name: "JONESBOROUGH",
            disabled: false,
          },
          {
            name: "JONESVILLE",
            disabled: false,
          },
          {
            name: "JOPLIN",
            disabled: false,
          },
          {
            name: "JOPPA",
            disabled: false,
          },
          {
            name: "JUNCTION CITY",
            disabled: false,
          },
          {
            name: "JUNEAU",
            disabled: false,
          },
          {
            name: "JUNO BEACH",
            disabled: false,
          },
          {
            name: "JUPITER",
            disabled: false,
          },
          {
            name: "JURUPA VALLEY",
            disabled: false,
          },
          {
            name: "Jackson",
            disabled: false,
          },
          {
            name: "Jacksonville",
            disabled: false,
          },
          {
            name: "Jamaica",
            disabled: false,
          },
          {
            name: "Jamestown",
            disabled: false,
          },
          {
            name: "Jasper",
            disabled: false,
          },
          {
            name: "Jefferson City",
            disabled: false,
          },
          {
            name: "Jeffersontown",
            disabled: false,
          },
          {
            name: "Jeffersonville",
            disabled: false,
          },
          {
            name: "Johnstown",
            disabled: false,
          },
          {
            name: "Jonesboro",
            disabled: false,
          },
          {
            name: "Joplin",
            disabled: false,
          },
          {
            name: "KAHULUI",
            disabled: false,
          },
          {
            name: "KAILUA",
            disabled: false,
          },
          {
            name: "KAILUA KONA",
            disabled: false,
          },
          {
            name: "KALAMAZOO",
            disabled: false,
          },
          {
            name: "KALISPELL",
            disabled: false,
          },
          {
            name: "KALKASKA",
            disabled: false,
          },
          {
            name: "KANE",
            disabled: false,
          },
          {
            name: "KANEOHE",
            disabled: false,
          },
          {
            name: "KANKAKEE",
            disabled: false,
          },
          {
            name: "KANNAPOLIS",
            disabled: false,
          },
          {
            name: "KANSAS CITY",
            disabled: false,
          },
          {
            name: "KAPAA",
            disabled: false,
          },
          {
            name: "KAPLAN",
            disabled: false,
          },
          {
            name: "KAPOLEI",
            disabled: false,
          },
          {
            name: "KARNS",
            disabled: false,
          },
          {
            name: "KATONAH",
            disabled: false,
          },
          {
            name: "KATY",
            disabled: false,
          },
          {
            name: "KAUFMAN",
            disabled: false,
          },
          {
            name: "KAUKAUNA",
            disabled: false,
          },
          {
            name: "KAYSVILLE",
            disabled: false,
          },
          {
            name: "KEAAU",
            disabled: false,
          },
          {
            name: "KEARNEY",
            disabled: false,
          },
          {
            name: "KEARNS",
            disabled: false,
          },
          {
            name: "KEARNY",
            disabled: false,
          },
          {
            name: "KEEGO HARBOR",
            disabled: false,
          },
          {
            name: "KEENE",
            disabled: false,
          },
          {
            name: "KEIZER",
            disabled: false,
          },
          {
            name: "KELLER",
            disabled: false,
          },
          {
            name: "KELSO",
            disabled: false,
          },
          {
            name: "KEMAH",
            disabled: false,
          },
          {
            name: "KENAI",
            disabled: false,
          },
          {
            name: "KENANSVILLE",
            disabled: false,
          },
          {
            name: "KENDALL",
            disabled: false,
          },
          {
            name: "KENDALL PARK",
            disabled: false,
          },
          {
            name: "KENDALLVILLE",
            disabled: false,
          },
          {
            name: "KENEDY",
            disabled: false,
          },
          {
            name: "KENILWORTH",
            disabled: false,
          },
          {
            name: "KENLY",
            disabled: false,
          },
          {
            name: "KENMORE",
            disabled: false,
          },
          {
            name: "KENNEBUNK",
            disabled: false,
          },
          {
            name: "KENNER",
            disabled: false,
          },
          {
            name: "KENNESAW",
            disabled: false,
          },
          {
            name: "KENNETT",
            disabled: false,
          },
          {
            name: "KENNETT SQUARE",
            disabled: false,
          },
          {
            name: "KENNEWICK",
            disabled: false,
          },
          {
            name: "KENOSHA",
            disabled: false,
          },
          {
            name: "KENOVA",
            disabled: false,
          },
          {
            name: "KENSINGTON",
            disabled: false,
          },
          {
            name: "KENT",
            disabled: false,
          },
          {
            name: "KENTLAND",
            disabled: false,
          },
          {
            name: "KENTON",
            disabled: false,
          },
          {
            name: "KENTWOOD",
            disabled: false,
          },
          {
            name: "KEOKUK",
            disabled: false,
          },
          {
            name: "KERMAN",
            disabled: false,
          },
          {
            name: "KERNERSVILLE",
            disabled: false,
          },
          {
            name: "KERRVILLE",
            disabled: false,
          },
          {
            name: "KERSHAW",
            disabled: false,
          },
          {
            name: "KETCHIKAN",
            disabled: false,
          },
          {
            name: "KETTERING",
            disabled: false,
          },
          {
            name: "KEWANEE",
            disabled: false,
          },
          {
            name: "KEY BISCAYNE",
            disabled: false,
          },
          {
            name: "KEY LARGO",
            disabled: false,
          },
          {
            name: "KEY WEST",
            disabled: false,
          },
          {
            name: "KEYPORT",
            disabled: false,
          },
          {
            name: "KEYSER",
            disabled: false,
          },
          {
            name: "KEYSTONE HEIGHTS",
            disabled: false,
          },
          {
            name: "KEYSVILLE",
            disabled: false,
          },
          {
            name: "KIHEI",
            disabled: false,
          },
          {
            name: "KILGORE",
            disabled: false,
          },
          {
            name: "KILL DEVIL HILLS",
            disabled: false,
          },
          {
            name: "KILLEEN",
            disabled: false,
          },
          {
            name: "KILMARNOCK",
            disabled: false,
          },
          {
            name: "KIMBALL",
            disabled: false,
          },
          {
            name: "KING",
            disabled: false,
          },
          {
            name: "KING CITY",
            disabled: false,
          },
          {
            name: "KING GEORGE",
            disabled: false,
          },
          {
            name: "KING OF PRUSSIA",
            disabled: false,
          },
          {
            name: "KINGFISHER",
            disabled: false,
          },
          {
            name: "KINGMAN",
            disabled: false,
          },
          {
            name: "KINGS BEACH",
            disabled: false,
          },
          {
            name: "KINGS MOUNTAIN",
            disabled: false,
          },
          {
            name: "KINGS PARK",
            disabled: false,
          },
          {
            name: "KINGSBURG",
            disabled: false,
          },
          {
            name: "KINGSLAND",
            disabled: false,
          },
          {
            name: "KINGSPORT",
            disabled: false,
          },
          {
            name: "KINGSTON",
            disabled: false,
          },
          {
            name: "KINGSTREE",
            disabled: false,
          },
          {
            name: "KINGSVILLE",
            disabled: false,
          },
          {
            name: "KINGWOOD",
            disabled: false,
          },
          {
            name: "KINNELON",
            disabled: false,
          },
          {
            name: "KINSTON",
            disabled: false,
          },
          {
            name: "KIRKLAND",
            disabled: false,
          },
          {
            name: "KIRKSVILLE",
            disabled: false,
          },
          {
            name: "KIRKWOOD",
            disabled: false,
          },
          {
            name: "KISSIMMEE",
            disabled: false,
          },
          {
            name: "KITTANNING",
            disabled: false,
          },
          {
            name: "KITTERY",
            disabled: false,
          },
          {
            name: "KITTY HAWK",
            disabled: false,
          },
          {
            name: "KLAMATH FALLS",
            disabled: false,
          },
          {
            name: "KNIGHTDALE",
            disabled: false,
          },
          {
            name: "KNIGHTSTOWN",
            disabled: false,
          },
          {
            name: "KNOX",
            disabled: false,
          },
          {
            name: "KNOXVILLE",
            disabled: false,
          },
          {
            name: "KODIAK",
            disabled: false,
          },
          {
            name: "KOKOMO",
            disabled: false,
          },
          {
            name: "KOSCIUSKO",
            disabled: false,
          },
          {
            name: "KUNA",
            disabled: false,
          },
          {
            name: "KUTZTOWN",
            disabled: false,
          },
          {
            name: "KYLE",
            disabled: false,
          },
          {
            name: "Kailua Kona",
            disabled: false,
          },
          {
            name: "Kaneohe",
            disabled: false,
          },
          {
            name: "Katy",
            disabled: false,
          },
          {
            name: "Kearny",
            disabled: false,
          },
          {
            name: "Kenosha",
            disabled: false,
          },
          {
            name: "Kent",
            disabled: false,
          },
          {
            name: "Kenton",
            disabled: false,
          },
          {
            name: "Kettering",
            disabled: false,
          },
          {
            name: "Kill Devil Hills",
            disabled: false,
          },
          {
            name: "Kingwood",
            disabled: false,
          },
          {
            name: "Kirkland",
            disabled: false,
          },
          {
            name: "Klamath Falls",
            disabled: false,
          },
          {
            name: "Knoxville",
            disabled: false,
          },
          {
            name: "LA CANADA FLINTRIDGE",
            disabled: false,
          },
          {
            name: "LA CRESCENTA",
            disabled: false,
          },
          {
            name: "LA CROSSE",
            disabled: false,
          },
          {
            name: "LA FAYETTE",
            disabled: false,
          },
          {
            name: "LA FERIA",
            disabled: false,
          },
          {
            name: "LA FOLLETTE",
            disabled: false,
          },
          {
            name: "LA GRANDE",
            disabled: false,
          },
          {
            name: "LA GRANGE",
            disabled: false,
          },
          {
            name: "LA GRANGE PARK",
            disabled: false,
          },
          {
            name: "LA HABRA",
            disabled: false,
          },
          {
            name: "LA JOLLA",
            disabled: false,
          },
          {
            name: "LA JUNTA",
            disabled: false,
          },
          {
            name: "LA MARQUE",
            disabled: false,
          },
          {
            name: "LA MESA",
            disabled: false,
          },
          {
            name: "LA MIRADA",
            disabled: false,
          },
          {
            name: "LA PALMA",
            disabled: false,
          },
          {
            name: "LA PLACE",
            disabled: false,
          },
          {
            name: "LA PLATA",
            disabled: false,
          },
          {
            name: "LA PORTE",
            disabled: false,
          },
          {
            name: "LA PUENTE",
            disabled: false,
          },
          {
            name: "LA QUINTA",
            disabled: false,
          },
          {
            name: "LA VERGNE",
            disabled: false,
          },
          {
            name: "LA VERNE",
            disabled: false,
          },
          {
            name: "LA VERNIA",
            disabled: false,
          },
          {
            name: "LA VISTA",
            disabled: false,
          },
          {
            name: "LABELLE",
            disabled: false,
          },
          {
            name: "LACEY",
            disabled: false,
          },
          {
            name: "LACKAWANNA",
            disabled: false,
          },
          {
            name: "LACONIA",
            disabled: false,
          },
          {
            name: "LADERA RANCH",
            disabled: false,
          },
          {
            name: "LADSON",
            disabled: false,
          },
          {
            name: "LADY LAKE",
            disabled: false,
          },
          {
            name: "LADYSMITH",
            disabled: false,
          },
          {
            name: "LAFAYETTE",
            disabled: false,
          },
          {
            name: "LAGO VISTA",
            disabled: false,
          },
          {
            name: "LAGRANGE",
            disabled: false,
          },
          {
            name: "LAGUNA BEACH",
            disabled: false,
          },
          {
            name: "LAGUNA HILLS",
            disabled: false,
          },
          {
            name: "LAGUNA NIGUEL",
            disabled: false,
          },
          {
            name: "LAGUNA WOODS",
            disabled: false,
          },
          {
            name: "LAHAINA",
            disabled: false,
          },
          {
            name: "LAKE ARIEL",
            disabled: false,
          },
          {
            name: "LAKE BLUFF",
            disabled: false,
          },
          {
            name: "LAKE BUTLER",
            disabled: false,
          },
          {
            name: "LAKE CHARLES",
            disabled: false,
          },
          {
            name: "LAKE CITY",
            disabled: false,
          },
          {
            name: "LAKE ELSINORE",
            disabled: false,
          },
          {
            name: "LAKE FOREST",
            disabled: false,
          },
          {
            name: "LAKE FOREST PARK",
            disabled: false,
          },
          {
            name: "LAKE GENEVA",
            disabled: false,
          },
          {
            name: "LAKE HAVASU CITY",
            disabled: false,
          },
          {
            name: "LAKE HIAWATHA",
            disabled: false,
          },
          {
            name: "LAKE IN THE HIL",
            disabled: false,
          },
          {
            name: "LAKE IN THE HILLS",
            disabled: false,
          },
          {
            name: "LAKE ISABELLA",
            disabled: false,
          },
          {
            name: "LAKE JACKSON",
            disabled: false,
          },
          {
            name: "LAKE MARY",
            disabled: false,
          },
          {
            name: "LAKE MILLS",
            disabled: false,
          },
          {
            name: "LAKE ORION",
            disabled: false,
          },
          {
            name: "LAKE OSWEGO",
            disabled: false,
          },
          {
            name: "LAKE OZARK",
            disabled: false,
          },
          {
            name: "LAKE PARK",
            disabled: false,
          },
          {
            name: "LAKE PLACID",
            disabled: false,
          },
          {
            name: "LAKE RONKONKOMA",
            disabled: false,
          },
          {
            name: "LAKE SAINT LOUIS",
            disabled: false,
          },
          {
            name: "LAKE STATION",
            disabled: false,
          },
          {
            name: "LAKE STEVENS",
            disabled: false,
          },
          {
            name: "LAKE VILLA",
            disabled: false,
          },
          {
            name: "LAKE WALES",
            disabled: false,
          },
          {
            name: "LAKE WORTH",
            disabled: false,
          },
          {
            name: "LAKE WYLIE",
            disabled: false,
          },
          {
            name: "LAKE ZURICH",
            disabled: false,
          },
          {
            name: "LAKELAND",
            disabled: false,
          },
          {
            name: "LAKEMOOR",
            disabled: false,
          },
          {
            name: "LAKEPORT",
            disabled: false,
          },
          {
            name: "LAKESIDE",
            disabled: false,
          },
          {
            name: "LAKEVIEW",
            disabled: false,
          },
          {
            name: "LAKEVILLE",
            disabled: false,
          },
          {
            name: "LAKEWAY",
            disabled: false,
          },
          {
            name: "LAKEWOOD",
            disabled: false,
          },
          {
            name: "LAMAR",
            disabled: false,
          },
          {
            name: "LAMBERTVILLE",
            disabled: false,
          },
          {
            name: "LAMESA",
            disabled: false,
          },
          {
            name: "LAMONT",
            disabled: false,
          },
          {
            name: "LAMPASAS",
            disabled: false,
          },
          {
            name: "LANCASTER",
            disabled: false,
          },
          {
            name: "LANDENBERG",
            disabled: false,
          },
          {
            name: "LANDER",
            disabled: false,
          },
          {
            name: "LANDISVILLE",
            disabled: false,
          },
          {
            name: "LANDOVER",
            disabled: false,
          },
          {
            name: "LANDOVER HILLS",
            disabled: false,
          },
          {
            name: "LANDRUM",
            disabled: false,
          },
          {
            name: "LANESBOROUGH",
            disabled: false,
          },
          {
            name: "LANETT",
            disabled: false,
          },
          {
            name: "LANGHORNE",
            disabled: false,
          },
          {
            name: "LANHAM",
            disabled: false,
          },
          {
            name: "LANOKA HARBOR",
            disabled: false,
          },
          {
            name: "LANSDALE",
            disabled: false,
          },
          {
            name: "LANSDOWNE",
            disabled: false,
          },
          {
            name: "LANSFORD",
            disabled: false,
          },
          {
            name: "LANSING",
            disabled: false,
          },
          {
            name: "LANTANA",
            disabled: false,
          },
          {
            name: "LAPEER",
            disabled: false,
          },
          {
            name: "LAPORTE",
            disabled: false,
          },
          {
            name: "LARAMIE",
            disabled: false,
          },
          {
            name: "LARCHMONT",
            disabled: false,
          },
          {
            name: "LAREDO",
            disabled: false,
          },
          {
            name: "LARGO",
            disabled: false,
          },
          {
            name: "LARNED",
            disabled: false,
          },
          {
            name: "LAS CRUCES",
            disabled: false,
          },
          {
            name: "LAS VEGAS",
            disabled: false,
          },
          {
            name: "LATHAM",
            disabled: false,
          },
          {
            name: "LATHROP",
            disabled: false,
          },
          {
            name: "LATONIA",
            disabled: false,
          },
          {
            name: "LATROBE",
            disabled: false,
          },
          {
            name: "LAUDERDALE LAKES",
            disabled: false,
          },
          {
            name: "LAUDERHILL",
            disabled: false,
          },
          {
            name: "LAUREL",
            disabled: false,
          },
          {
            name: "LAUREL SPRINGS",
            disabled: false,
          },
          {
            name: "LAURENS",
            disabled: false,
          },
          {
            name: "LAURINBURG",
            disabled: false,
          },
          {
            name: "LAVALE",
            disabled: false,
          },
          {
            name: "LAVEEN",
            disabled: false,
          },
          {
            name: "LAVONIA",
            disabled: false,
          },
          {
            name: "LAWNDALE",
            disabled: false,
          },
          {
            name: "LAWRENCE",
            disabled: false,
          },
          {
            name: "LAWRENCE TOWNSH",
            disabled: false,
          },
          {
            name: "LAWRENCEBURG",
            disabled: false,
          },
          {
            name: "LAWRENCEVILLE",
            disabled: false,
          },
          {
            name: "LAWTON",
            disabled: false,
          },
          {
            name: "LAYTON",
            disabled: false,
          },
          {
            name: "LE MARS",
            disabled: false,
          },
          {
            name: "LE ROY",
            disabled: false,
          },
          {
            name: "LEADVILLE",
            disabled: false,
          },
          {
            name: "LEAGUE CITY",
            disabled: false,
          },
          {
            name: "LEANDER",
            disabled: false,
          },
          {
            name: "LEAVENWORTH",
            disabled: false,
          },
          {
            name: "LEAWOOD",
            disabled: false,
          },
          {
            name: "LEBANON",
            disabled: false,
          },
          {
            name: "LECANTO",
            disabled: false,
          },
          {
            name: "LEDGEWOOD",
            disabled: false,
          },
          {
            name: "LEE",
            disabled: false,
          },
          {
            name: "LEECHBURG",
            disabled: false,
          },
          {
            name: "LEEDS",
            disabled: false,
          },
          {
            name: "LEES SUMMIT",
            disabled: false,
          },
          {
            name: "LEESBURG",
            disabled: false,
          },
          {
            name: "LEESPORT",
            disabled: false,
          },
          {
            name: "LEESVILLE",
            disabled: false,
          },
          {
            name: "LEETSDALE",
            disabled: false,
          },
          {
            name: "LEHI",
            disabled: false,
          },
          {
            name: "LEHIGH ACRES",
            disabled: false,
          },
          {
            name: "LEHIGHTON",
            disabled: false,
          },
          {
            name: "LEICESTER",
            disabled: false,
          },
          {
            name: "LEITCHFIELD",
            disabled: false,
          },
          {
            name: "LELAND",
            disabled: false,
          },
          {
            name: "LEMON GROVE",
            disabled: false,
          },
          {
            name: "LEMONT",
            disabled: false,
          },
          {
            name: "LEMOORE",
            disabled: false,
          },
          {
            name: "LEMOYNE",
            disabled: false,
          },
          {
            name: "LENEXA",
            disabled: false,
          },
          {
            name: "LENOIR",
            disabled: false,
          },
          {
            name: "LENOIR CITY",
            disabled: false,
          },
          {
            name: "LENOX",
            disabled: false,
          },
          {
            name: "LEOLA",
            disabled: false,
          },
          {
            name: "LEOMINSTER",
            disabled: false,
          },
          {
            name: "LEONARDTOWN",
            disabled: false,
          },
          {
            name: "LEONIA",
            disabled: false,
          },
          {
            name: "LEVELLAND",
            disabled: false,
          },
          {
            name: "LEVITTOWN",
            disabled: false,
          },
          {
            name: "LEWES",
            disabled: false,
          },
          {
            name: "LEWIS CENTER",
            disabled: false,
          },
          {
            name: "LEWISBURG",
            disabled: false,
          },
          {
            name: "LEWISTON",
            disabled: false,
          },
          {
            name: "LEWISTOWN",
            disabled: false,
          },
          {
            name: "LEWISVILLE",
            disabled: false,
          },
          {
            name: "LEXINGTON",
            disabled: false,
          },
          {
            name: "LEXINGTON PARK",
            disabled: false,
          },
          {
            name: "LIBERAL",
            disabled: false,
          },
          {
            name: "LIBERTY",
            disabled: false,
          },
          {
            name: "LIBERTY LAKE",
            disabled: false,
          },
          {
            name: "LIBERTYVILLE",
            disabled: false,
          },
          {
            name: "LIGHTHOUSE POINT",
            disabled: false,
          },
          {
            name: "LIGONIER",
            disabled: false,
          },
          {
            name: "LIHUE",
            disabled: false,
          },
          {
            name: "LIHUE (KAUAI)",
            disabled: false,
          },
          {
            name: "LILBURN",
            disabled: false,
          },
          {
            name: "LILLINGTON",
            disabled: false,
          },
          {
            name: "LIMA",
            disabled: false,
          },
          {
            name: "LIMERICK",
            disabled: false,
          },
          {
            name: "LINCOLN",
            disabled: false,
          },
          {
            name: "LINCOLN CITY",
            disabled: false,
          },
          {
            name: "LINCOLN PARK",
            disabled: false,
          },
          {
            name: "LINCOLNSHIRE",
            disabled: false,
          },
          {
            name: "LINCOLNTON",
            disabled: false,
          },
          {
            name: "LINCOLNWOOD",
            disabled: false,
          },
          {
            name: "LINCROFT",
            disabled: false,
          },
          {
            name: "LINDALE",
            disabled: false,
          },
          {
            name: "LINDEN",
            disabled: false,
          },
          {
            name: "LINDENHURST",
            disabled: false,
          },
          {
            name: "LINDENWOLD",
            disabled: false,
          },
          {
            name: "LINDON",
            disabled: false,
          },
          {
            name: "LINDSAY",
            disabled: false,
          },
          {
            name: "LINO LAKES",
            disabled: false,
          },
          {
            name: "LINTON",
            disabled: false,
          },
          {
            name: "LISBON",
            disabled: false,
          },
          {
            name: "LISBON FALLS",
            disabled: false,
          },
          {
            name: "LISLE",
            disabled: false,
          },
          {
            name: "LITCHFIELD",
            disabled: false,
          },
          {
            name: "LITCHFIELD PARK",
            disabled: false,
          },
          {
            name: "LITHIA",
            disabled: false,
          },
          {
            name: "LITHIA SPRINGS",
            disabled: false,
          },
          {
            name: "LITHONIA",
            disabled: false,
          },
          {
            name: "LITITZ",
            disabled: false,
          },
          {
            name: "LITTLE CHUTE",
            disabled: false,
          },
          {
            name: "LITTLE EGG HARBOR",
            disabled: false,
          },
          {
            name: "LITTLE ELM",
            disabled: false,
          },
          {
            name: "LITTLE FALLS",
            disabled: false,
          },
          {
            name: "LITTLE FERRY",
            disabled: false,
          },
          {
            name: "LITTLE RIVER",
            disabled: false,
          },
          {
            name: "LITTLE ROCK",
            disabled: false,
          },
          {
            name: "LITTLE SILVER",
            disabled: false,
          },
          {
            name: "LITTLETON",
            disabled: false,
          },
          {
            name: "LIVE OAK",
            disabled: false,
          },
          {
            name: "LIVERMORE",
            disabled: false,
          },
          {
            name: "LIVERMORE FALLS",
            disabled: false,
          },
          {
            name: "LIVERPOOL",
            disabled: false,
          },
          {
            name: "LIVINGSTON",
            disabled: false,
          },
          {
            name: "LIVONIA",
            disabled: false,
          },
          {
            name: "LOCK HAVEN",
            disabled: false,
          },
          {
            name: "LOCKHART",
            disabled: false,
          },
          {
            name: "LOCKPORT",
            disabled: false,
          },
          {
            name: "LOCUST",
            disabled: false,
          },
          {
            name: "LOCUST GROVE",
            disabled: false,
          },
          {
            name: "LODI",
            disabled: false,
          },
          {
            name: "LOGAN",
            disabled: false,
          },
          {
            name: "LOGANSPORT",
            disabled: false,
          },
          {
            name: "LOGANVILLE",
            disabled: false,
          },
          {
            name: "LOMA LINDA",
            disabled: false,
          },
          {
            name: "LOMBARD",
            disabled: false,
          },
          {
            name: "LOMITA",
            disabled: false,
          },
          {
            name: "LOMPOC",
            disabled: false,
          },
          {
            name: "LONDON",
            disabled: false,
          },
          {
            name: "LONDONDERRY",
            disabled: false,
          },
          {
            name: "LONE TREE",
            disabled: false,
          },
          {
            name: "LONG BEACH",
            disabled: false,
          },
          {
            name: "LONG BEACH TOWNSHIP",
            disabled: false,
          },
          {
            name: "LONG BRANCH",
            disabled: false,
          },
          {
            name: "LONG GROVE",
            disabled: false,
          },
          {
            name: "LONG ISLAND CIT",
            disabled: false,
          },
          {
            name: "LONGBOAT KEY",
            disabled: false,
          },
          {
            name: "LONGMEADOW",
            disabled: false,
          },
          {
            name: "LONGMONT",
            disabled: false,
          },
          {
            name: "LONGVIEW",
            disabled: false,
          },
          {
            name: "LONGWOOD",
            disabled: false,
          },
          {
            name: "LONOKE",
            disabled: false,
          },
          {
            name: "LOOGOOTEE",
            disabled: false,
          },
          {
            name: "LORAIN",
            disabled: false,
          },
          {
            name: "LORIS",
            disabled: false,
          },
          {
            name: "LORTON",
            disabled: false,
          },
          {
            name: "LOS ALAMITOS",
            disabled: false,
          },
          {
            name: "LOS ALAMOS",
            disabled: false,
          },
          {
            name: "LOS ALTOS",
            disabled: false,
          },
          {
            name: "LOS ANGELES",
            disabled: false,
          },
          {
            name: "LOS BANOS",
            disabled: false,
          },
          {
            name: "LOS FRESNOS",
            disabled: false,
          },
          {
            name: "LOS GATOS",
            disabled: false,
          },
          {
            name: "LOS LUNAS",
            disabled: false,
          },
          {
            name: "LOS OSOS",
            disabled: false,
          },
          {
            name: "LOUDON",
            disabled: false,
          },
          {
            name: "LOUDONVILLE",
            disabled: false,
          },
          {
            name: "LOUISA",
            disabled: false,
          },
          {
            name: "LOUISBURG",
            disabled: false,
          },
          {
            name: "LOUISVILLE",
            disabled: false,
          },
          {
            name: "LOVELAND",
            disabled: false,
          },
          {
            name: "LOVELOCK",
            disabled: false,
          },
          {
            name: "LOVES PARK",
            disabled: false,
          },
          {
            name: "LOVINGSTON",
            disabled: false,
          },
          {
            name: "LOWELL",
            disabled: false,
          },
          {
            name: "LOWER BURRELL",
            disabled: false,
          },
          {
            name: "LOWVILLE",
            disabled: false,
          },
          {
            name: "LOXAHATCHEE",
            disabled: false,
          },
          {
            name: "LUBBOCK",
            disabled: false,
          },
          {
            name: "LUCAS",
            disabled: false,
          },
          {
            name: "LUCEDALE",
            disabled: false,
          },
          {
            name: "LUDINGTON",
            disabled: false,
          },
          {
            name: "LUDLOW",
            disabled: false,
          },
          {
            name: "LUFKIN",
            disabled: false,
          },
          {
            name: "LUGOFF",
            disabled: false,
          },
          {
            name: "LULING",
            disabled: false,
          },
          {
            name: "LUMBERTON",
            disabled: false,
          },
          {
            name: "LUNENBURG",
            disabled: false,
          },
          {
            name: "LURAY",
            disabled: false,
          },
          {
            name: "LUSBY",
            disabled: false,
          },
          {
            name: "LUTHERVILLE",
            disabled: false,
          },
          {
            name: "LUTZ",
            disabled: false,
          },
          {
            name: "LUZERNE",
            disabled: false,
          },
          {
            name: "LYMAN",
            disabled: false,
          },
          {
            name: "LYNBROOK",
            disabled: false,
          },
          {
            name: "LYNCHBURG",
            disabled: false,
          },
          {
            name: "LYNDEN",
            disabled: false,
          },
          {
            name: "LYNDHURST",
            disabled: false,
          },
          {
            name: "LYNDON",
            disabled: false,
          },
          {
            name: "LYNDONVILLE",
            disabled: false,
          },
          {
            name: "LYNN",
            disabled: false,
          },
          {
            name: "LYNN HAVEN",
            disabled: false,
          },
          {
            name: "LYNNWOOD",
            disabled: false,
          },
          {
            name: "LYNWOOD",
            disabled: false,
          },
          {
            name: "LYONS",
            disabled: false,
          },
          {
            name: "LYTLE",
            disabled: false,
          },
          {
            name: "La Canada",
            disabled: false,
          },
          {
            name: "La Crescenta",
            disabled: false,
          },
          {
            name: "La Jolla",
            disabled: false,
          },
          {
            name: "La Mesa",
            disabled: false,
          },
          {
            name: "La Puente",
            disabled: false,
          },
          {
            name: "La Quinta",
            disabled: false,
          },
          {
            name: "LaGrange",
            disabled: false,
          },
          {
            name: "Lacey",
            disabled: false,
          },
          {
            name: "Lafayette",
            disabled: false,
          },
          {
            name: "Laguna Niguel",
            disabled: false,
          },
          {
            name: "Lake Charles",
            disabled: false,
          },
          {
            name: "Lake Forest",
            disabled: false,
          },
          {
            name: "Lake Zurich",
            disabled: false,
          },
          {
            name: "Lakewood",
            disabled: false,
          },
          {
            name: "Lancaster",
            disabled: false,
          },
          {
            name: "Las Vegas",
            disabled: false,
          },
          {
            name: "Laveen",
            disabled: false,
          },
          {
            name: "Lawrence",
            disabled: false,
          },
          {
            name: "Lawrenceville",
            disabled: false,
          },
          {
            name: "League City",
            disabled: false,
          },
          {
            name: "Lebanon",
            disabled: false,
          },
          {
            name: "Leesburg",
            disabled: false,
          },
          {
            name: "Lenox",
            disabled: false,
          },
          {
            name: "Lewis Center",
            disabled: false,
          },
          {
            name: "Lewisville",
            disabled: false,
          },
          {
            name: "Lexington",
            disabled: false,
          },
          {
            name: "Liberty Township",
            disabled: false,
          },
          {
            name: "Liberty Twp",
            disabled: false,
          },
          {
            name: "Libertyville",
            disabled: false,
          },
          {
            name: "Lima",
            disabled: false,
          },
          {
            name: "Lincoln",
            disabled: false,
          },
          {
            name: "Lincoln Park",
            disabled: false,
          },
          {
            name: "Lincolnwood",
            disabled: false,
          },
          {
            name: "Little Rock",
            disabled: false,
          },
          {
            name: "Littleton",
            disabled: false,
          },
          {
            name: "Logan Township",
            disabled: false,
          },
          {
            name: "Logansport",
            disabled: false,
          },
          {
            name: "Lombard",
            disabled: false,
          },
          {
            name: "Lompoc",
            disabled: false,
          },
          {
            name: "Long Beach",
            disabled: false,
          },
          {
            name: "Long Island City",
            disabled: false,
          },
          {
            name: "Loogootee",
            disabled: false,
          },
          {
            name: "Los Alamos",
            disabled: false,
          },
          {
            name: "Los Angeles",
            disabled: false,
          },
          {
            name: "Louisiana",
            disabled: false,
          },
          {
            name: "Louisville",
            disabled: false,
          },
          {
            name: "Lynchburg",
            disabled: false,
          },
          {
            name: "Lynnwood",
            disabled: false,
          },
          {
            name: "MABLETON",
            disabled: false,
          },
          {
            name: "MACARTHUR",
            disabled: false,
          },
          {
            name: "MACCLENNY",
            disabled: false,
          },
          {
            name: "MACEDON",
            disabled: false,
          },
          {
            name: "MACEDONIA",
            disabled: false,
          },
          {
            name: "MACHESNEY PARK",
            disabled: false,
          },
          {
            name: "MACHIAS",
            disabled: false,
          },
          {
            name: "MACOMB",
            disabled: false,
          },
          {
            name: "MACON",
            disabled: false,
          },
          {
            name: "MACUNGIE",
            disabled: false,
          },
          {
            name: "MADAWASKA",
            disabled: false,
          },
          {
            name: "MADEIRA",
            disabled: false,
          },
          {
            name: "MADEIRA BEACH",
            disabled: false,
          },
          {
            name: "MADERA",
            disabled: false,
          },
          {
            name: "MADILL",
            disabled: false,
          },
          {
            name: "MADISON",
            disabled: false,
          },
          {
            name: "MADISON HEIGHTS",
            disabled: false,
          },
          {
            name: "MADISONVILLE",
            disabled: false,
          },
          {
            name: "MADRAS",
            disabled: false,
          },
          {
            name: "MAGALIA",
            disabled: false,
          },
          {
            name: "MAGEE",
            disabled: false,
          },
          {
            name: "MAGNA",
            disabled: false,
          },
          {
            name: "MAGNOLIA",
            disabled: false,
          },
          {
            name: "MAHANOY CITY",
            disabled: false,
          },
          {
            name: "MAHOMET",
            disabled: false,
          },
          {
            name: "MAHOPAC",
            disabled: false,
          },
          {
            name: "MAHWAH",
            disabled: false,
          },
          {
            name: "MAIDEN",
            disabled: false,
          },
          {
            name: "MAINEVILLE",
            disabled: false,
          },
          {
            name: "MAITLAND",
            disabled: false,
          },
          {
            name: "MALAGA",
            disabled: false,
          },
          {
            name: "MALDEN",
            disabled: false,
          },
          {
            name: "MALIBU",
            disabled: false,
          },
          {
            name: "MALONE",
            disabled: false,
          },
          {
            name: "MALTA",
            disabled: false,
          },
          {
            name: "MALVERN",
            disabled: false,
          },
          {
            name: "MAMARONECK",
            disabled: false,
          },
          {
            name: "MAMMOTH LAKES",
            disabled: false,
          },
          {
            name: "MAN",
            disabled: false,
          },
          {
            name: "MANAHAWKIN",
            disabled: false,
          },
          {
            name: "MANALAPAN",
            disabled: false,
          },
          {
            name: "MANASSAS",
            disabled: false,
          },
          {
            name: "MANASSAS PARK",
            disabled: false,
          },
          {
            name: "MANATI",
            disabled: false,
          },
          {
            name: "MANCHESTER",
            disabled: false,
          },
          {
            name: "MANCHESTER CENTER",
            disabled: false,
          },
          {
            name: "MANDAN",
            disabled: false,
          },
          {
            name: "MANDEVILLE",
            disabled: false,
          },
          {
            name: "MANHATTAN",
            disabled: false,
          },
          {
            name: "MANHATTAN BEACH",
            disabled: false,
          },
          {
            name: "MANHEIM",
            disabled: false,
          },
          {
            name: "MANISTEE",
            disabled: false,
          },
          {
            name: "MANITOWOC",
            disabled: false,
          },
          {
            name: "MANKATO",
            disabled: false,
          },
          {
            name: "MANLIUS",
            disabled: false,
          },
          {
            name: "MANNING",
            disabled: false,
          },
          {
            name: "MANNINGTON",
            disabled: false,
          },
          {
            name: "MANOR",
            disabled: false,
          },
          {
            name: "MANORVILLE",
            disabled: false,
          },
          {
            name: "MANSFIELD",
            disabled: false,
          },
          {
            name: "MANTECA",
            disabled: false,
          },
          {
            name: "MANTENO",
            disabled: false,
          },
          {
            name: "MANTEO",
            disabled: false,
          },
          {
            name: "MANTUA",
            disabled: false,
          },
          {
            name: "MANVEL",
            disabled: false,
          },
          {
            name: "MANVILLE",
            disabled: false,
          },
          {
            name: "MANY",
            disabled: false,
          },
          {
            name: "MAPLE GLEN",
            disabled: false,
          },
          {
            name: "MAPLE GROVE",
            disabled: false,
          },
          {
            name: "MAPLE HEIGHTS",
            disabled: false,
          },
          {
            name: "MAPLE SHADE",
            disabled: false,
          },
          {
            name: "MAPLE VALLEY",
            disabled: false,
          },
          {
            name: "MAPLEWOOD",
            disabled: false,
          },
          {
            name: "MAQUOKETA",
            disabled: false,
          },
          {
            name: "MARANA",
            disabled: false,
          },
          {
            name: "MARATHON",
            disabled: false,
          },
          {
            name: "MARBLE FALLS",
            disabled: false,
          },
          {
            name: "MARCO ISLAND",
            disabled: false,
          },
          {
            name: "MARGARETVILLE",
            disabled: false,
          },
          {
            name: "MARGATE",
            disabled: false,
          },
          {
            name: "MARIANNA",
            disabled: false,
          },
          {
            name: "MARICOPA",
            disabled: false,
          },
          {
            name: "MARIETTA",
            disabled: false,
          },
          {
            name: "MARINA",
            disabled: false,
          },
          {
            name: "MARINA DEL REY",
            disabled: false,
          },
          {
            name: "MARINE CITY",
            disabled: false,
          },
          {
            name: "MARINETTE",
            disabled: false,
          },
          {
            name: "MARION",
            disabled: false,
          },
          {
            name: "MARIPOSA",
            disabled: false,
          },
          {
            name: "MARKSVILLE",
            disabled: false,
          },
          {
            name: "MARLBORO",
            disabled: false,
          },
          {
            name: "MARLBOROUGH",
            disabled: false,
          },
          {
            name: "MARLETTE",
            disabled: false,
          },
          {
            name: "MARLIN",
            disabled: false,
          },
          {
            name: "MARLINTON",
            disabled: false,
          },
          {
            name: "MARLTON",
            disabled: false,
          },
          {
            name: "MARMET",
            disabled: false,
          },
          {
            name: "MARMORA",
            disabled: false,
          },
          {
            name: "MARQUETTE",
            disabled: false,
          },
          {
            name: "MARRERO",
            disabled: false,
          },
          {
            name: "MARS",
            disabled: false,
          },
          {
            name: "MARS HILL",
            disabled: false,
          },
          {
            name: "MARSHALL",
            disabled: false,
          },
          {
            name: "MARSHALLTOWN",
            disabled: false,
          },
          {
            name: "MARSHFIELD",
            disabled: false,
          },
          {
            name: "MARSHVILLE",
            disabled: false,
          },
          {
            name: "MARSTONS MILLS",
            disabled: false,
          },
          {
            name: "MARTIN",
            disabled: false,
          },
          {
            name: "MARTINEZ",
            disabled: false,
          },
          {
            name: "MARTINS FERRY",
            disabled: false,
          },
          {
            name: "MARTINSBURG",
            disabled: false,
          },
          {
            name: "MARTINSVILLE",
            disabled: false,
          },
          {
            name: "MARY ESTHER",
            disabled: false,
          },
          {
            name: "MARYLAND HEIGHTS",
            disabled: false,
          },
          {
            name: "MARYSVILLE",
            disabled: false,
          },
          {
            name: "MARYVILLE",
            disabled: false,
          },
          {
            name: "MASHPEE",
            disabled: false,
          },
          {
            name: "MASON",
            disabled: false,
          },
          {
            name: "MASON CITY",
            disabled: false,
          },
          {
            name: "MASONTOWN",
            disabled: false,
          },
          {
            name: "MASSAPEQUA",
            disabled: false,
          },
          {
            name: "MASSAPEQUA PARK",
            disabled: false,
          },
          {
            name: "MASSENA",
            disabled: false,
          },
          {
            name: "MASSILLON",
            disabled: false,
          },
          {
            name: "MATAWAN",
            disabled: false,
          },
          {
            name: "MATHEWS",
            disabled: false,
          },
          {
            name: "MATHIS",
            disabled: false,
          },
          {
            name: "MATTAPAN",
            disabled: false,
          },
          {
            name: "MATTHEWS",
            disabled: false,
          },
          {
            name: "MATTITUCK",
            disabled: false,
          },
          {
            name: "MATTOON",
            disabled: false,
          },
          {
            name: "MATTYDALE",
            disabled: false,
          },
          {
            name: "MAULDIN",
            disabled: false,
          },
          {
            name: "MAUMEE",
            disabled: false,
          },
          {
            name: "MAUMELLE",
            disabled: false,
          },
          {
            name: "MAUSTON",
            disabled: false,
          },
          {
            name: "MAXTON",
            disabled: false,
          },
          {
            name: "MAYAGUEZ",
            disabled: false,
          },
          {
            name: "MAYFIELD",
            disabled: false,
          },
          {
            name: "MAYFIELD HEIGHTS",
            disabled: false,
          },
          {
            name: "MAYNARD",
            disabled: false,
          },
          {
            name: "MAYNARDVILLE",
            disabled: false,
          },
          {
            name: "MAYODAN",
            disabled: false,
          },
          {
            name: "MAYS LANDING",
            disabled: false,
          },
          {
            name: "MAYSVILLE",
            disabled: false,
          },
          {
            name: "MAYWOOD",
            disabled: false,
          },
          {
            name: "MC KINNEY",
            disabled: false,
          },
          {
            name: "MC LEAN",
            disabled: false,
          },
          {
            name: "MCALESTER",
            disabled: false,
          },
          {
            name: "MCALLEN",
            disabled: false,
          },
          {
            name: "MCCALL",
            disabled: false,
          },
          {
            name: "MCCOMB",
            disabled: false,
          },
          {
            name: "MCCONNELSVILLE",
            disabled: false,
          },
          {
            name: "MCCOOK",
            disabled: false,
          },
          {
            name: "MCCORDSVILLE",
            disabled: false,
          },
          {
            name: "MCCORMICK",
            disabled: false,
          },
          {
            name: "MCDONALD",
            disabled: false,
          },
          {
            name: "MCDONOUGH",
            disabled: false,
          },
          {
            name: "MCFARLAND",
            disabled: false,
          },
          {
            name: "MCGEHEE",
            disabled: false,
          },
          {
            name: "MCHENRY",
            disabled: false,
          },
          {
            name: "MCKEE",
            disabled: false,
          },
          {
            name: "MCKEES ROCKS",
            disabled: false,
          },
          {
            name: "MCKEESPORT",
            disabled: false,
          },
          {
            name: "MCKENZIE",
            disabled: false,
          },
          {
            name: "MCKINLEYVILLE",
            disabled: false,
          },
          {
            name: "MCKINNEY",
            disabled: false,
          },
          {
            name: "MCLEAN",
            disabled: false,
          },
          {
            name: "MCMINNVILLE",
            disabled: false,
          },
          {
            name: "MCMURRAY",
            disabled: false,
          },
          {
            name: "MCPHERSON",
            disabled: false,
          },
          {
            name: "MEADOWS PLACE",
            disabled: false,
          },
          {
            name: "MEADVILLE",
            disabled: false,
          },
          {
            name: "MEBANE",
            disabled: false,
          },
          {
            name: "MECHANICSBURG",
            disabled: false,
          },
          {
            name: "MECHANICSVILLE",
            disabled: false,
          },
          {
            name: "MECHANICVILLE",
            disabled: false,
          },
          {
            name: "MEDFIELD",
            disabled: false,
          },
          {
            name: "MEDFORD",
            disabled: false,
          },
          {
            name: "MEDIA",
            disabled: false,
          },
          {
            name: "MEDINA",
            disabled: false,
          },
          {
            name: "MEDWAY",
            disabled: false,
          },
          {
            name: "MELBOURNE",
            disabled: false,
          },
          {
            name: "MELBOURNE VILLAGE",
            disabled: false,
          },
          {
            name: "MELISSA",
            disabled: false,
          },
          {
            name: "MELROSE",
            disabled: false,
          },
          {
            name: "MELROSE PARK",
            disabled: false,
          },
          {
            name: "MELVILLE",
            disabled: false,
          },
          {
            name: "MELVINDALE",
            disabled: false,
          },
          {
            name: "MEMPHIS",
            disabled: false,
          },
          {
            name: "MENA",
            disabled: false,
          },
          {
            name: "MENASHA",
            disabled: false,
          },
          {
            name: "MENDHAM",
            disabled: false,
          },
          {
            name: "MENDOTA",
            disabled: false,
          },
          {
            name: "MENDOTA HEIGHTS",
            disabled: false,
          },
          {
            name: "MENIFEE",
            disabled: false,
          },
          {
            name: "MENLO PARK",
            disabled: false,
          },
          {
            name: "MENOMINEE",
            disabled: false,
          },
          {
            name: "MENOMONEE FALLS",
            disabled: false,
          },
          {
            name: "MENOMONIE",
            disabled: false,
          },
          {
            name: "MENTOR",
            disabled: false,
          },
          {
            name: "MEQUON",
            disabled: false,
          },
          {
            name: "MERAUX",
            disabled: false,
          },
          {
            name: "MERCED",
            disabled: false,
          },
          {
            name: "MERCEDES",
            disabled: false,
          },
          {
            name: "MERCER",
            disabled: false,
          },
          {
            name: "MERCER ISLAND",
            disabled: false,
          },
          {
            name: "MERCERSBURG",
            disabled: false,
          },
          {
            name: "MEREDITH",
            disabled: false,
          },
          {
            name: "MERIDEN",
            disabled: false,
          },
          {
            name: "MERIDIAN",
            disabled: false,
          },
          {
            name: "MERIDIANVILLE",
            disabled: false,
          },
          {
            name: "MERRIAM",
            disabled: false,
          },
          {
            name: "MERRICK",
            disabled: false,
          },
          {
            name: "MERRILL",
            disabled: false,
          },
          {
            name: "MERRILLVILLE",
            disabled: false,
          },
          {
            name: "MERRIMACK",
            disabled: false,
          },
          {
            name: "MERRIONETTE PARK",
            disabled: false,
          },
          {
            name: "MERRITT ISLAND",
            disabled: false,
          },
          {
            name: "MESA",
            disabled: false,
          },
          {
            name: "MESQUITE",
            disabled: false,
          },
          {
            name: "METAIRIE",
            disabled: false,
          },
          {
            name: "METAMORA",
            disabled: false,
          },
          {
            name: "METHUEN",
            disabled: false,
          },
          {
            name: "METROPOLIS",
            disabled: false,
          },
          {
            name: "METTAWA",
            disabled: false,
          },
          {
            name: "METTER",
            disabled: false,
          },
          {
            name: "MEXIA",
            disabled: false,
          },
          {
            name: "MEXICO",
            disabled: false,
          },
          {
            name: "MEYERSDALE",
            disabled: false,
          },
          {
            name: "MIAMI",
            disabled: false,
          },
          {
            name: "MIAMI BEACH",
            disabled: false,
          },
          {
            name: "MIAMI GARDENS",
            disabled: false,
          },
          {
            name: "MIAMI LAKES",
            disabled: false,
          },
          {
            name: "MIAMI SHORES",
            disabled: false,
          },
          {
            name: "MIAMISBURG",
            disabled: false,
          },
          {
            name: "MICHIGAN CITY",
            disabled: false,
          },
          {
            name: "MIDDLE ISLAND",
            disabled: false,
          },
          {
            name: "MIDDLE RIVER",
            disabled: false,
          },
          {
            name: "MIDDLE VILLAGE",
            disabled: false,
          },
          {
            name: "MIDDLEBORO",
            disabled: false,
          },
          {
            name: "MIDDLEBOROUGH",
            disabled: false,
          },
          {
            name: "MIDDLEBURG",
            disabled: false,
          },
          {
            name: "MIDDLEBURG HEIGHTS",
            disabled: false,
          },
          {
            name: "MIDDLEBURY",
            disabled: false,
          },
          {
            name: "MIDDLEFIELD",
            disabled: false,
          },
          {
            name: "MIDDLESBORO",
            disabled: false,
          },
          {
            name: "MIDDLESEX",
            disabled: false,
          },
          {
            name: "MIDDLETON",
            disabled: false,
          },
          {
            name: "MIDDLETOWN",
            disabled: false,
          },
          {
            name: "MIDFIELD",
            disabled: false,
          },
          {
            name: "MIDLAND",
            disabled: false,
          },
          {
            name: "MIDLAND PARK",
            disabled: false,
          },
          {
            name: "MIDLOTHIAN",
            disabled: false,
          },
          {
            name: "MIDVALE",
            disabled: false,
          },
          {
            name: "MIDWEST CITY",
            disabled: false,
          },
          {
            name: "MIFFLINBURG",
            disabled: false,
          },
          {
            name: "MILAN",
            disabled: false,
          },
          {
            name: "MILES CITY",
            disabled: false,
          },
          {
            name: "MILFORD",
            disabled: false,
          },
          {
            name: "MILILANI",
            disabled: false,
          },
          {
            name: "MILL CREEK",
            disabled: false,
          },
          {
            name: "MILL HALL",
            disabled: false,
          },
          {
            name: "MILL VALLEY",
            disabled: false,
          },
          {
            name: "MILLBRAE",
            disabled: false,
          },
          {
            name: "MILLBROOK",
            disabled: false,
          },
          {
            name: "MILLBURY",
            disabled: false,
          },
          {
            name: "MILLEDGEVILLE",
            disabled: false,
          },
          {
            name: "MILLER PLACE",
            disabled: false,
          },
          {
            name: "MILLERS CREEK",
            disabled: false,
          },
          {
            name: "MILLERSBURG",
            disabled: false,
          },
          {
            name: "MILLERSVILLE",
            disabled: false,
          },
          {
            name: "MILLERTON",
            disabled: false,
          },
          {
            name: "MILLINGTON",
            disabled: false,
          },
          {
            name: "MILLIS",
            disabled: false,
          },
          {
            name: "MILLS RIVER",
            disabled: false,
          },
          {
            name: "MILLSBORO",
            disabled: false,
          },
          {
            name: "MILLTOWN",
            disabled: false,
          },
          {
            name: "MILLVILLE",
            disabled: false,
          },
          {
            name: "MILLWOOD",
            disabled: false,
          },
          {
            name: "MILO",
            disabled: false,
          },
          {
            name: "MILPITAS",
            disabled: false,
          },
          {
            name: "MILTON",
            disabled: false,
          },
          {
            name: "MILTON FREEWATER",
            disabled: false,
          },
          {
            name: "MILWAUKEE",
            disabled: false,
          },
          {
            name: "MILWAUKIE",
            disabled: false,
          },
          {
            name: "MIMS",
            disabled: false,
          },
          {
            name: "MINDEN",
            disabled: false,
          },
          {
            name: "MINEOLA",
            disabled: false,
          },
          {
            name: "MINERAL",
            disabled: false,
          },
          {
            name: "MINERAL WELLS",
            disabled: false,
          },
          {
            name: "MINERSVILLE",
            disabled: false,
          },
          {
            name: "MINERVA",
            disabled: false,
          },
          {
            name: "MINNEAPOLIS",
            disabled: false,
          },
          {
            name: "MINNEOLA",
            disabled: false,
          },
          {
            name: "MINNETONKA",
            disabled: false,
          },
          {
            name: "MINOCQUA",
            disabled: false,
          },
          {
            name: "MINOOKA",
            disabled: false,
          },
          {
            name: "MINOT",
            disabled: false,
          },
          {
            name: "MINT HILL",
            disabled: false,
          },
          {
            name: "MIO",
            disabled: false,
          },
          {
            name: "MIRA LOMA",
            disabled: false,
          },
          {
            name: "MIRAMAR",
            disabled: false,
          },
          {
            name: "MISHAWAKA",
            disabled: false,
          },
          {
            name: "MISSION",
            disabled: false,
          },
          {
            name: "MISSION HILLS",
            disabled: false,
          },
          {
            name: "MISSION VIEJO",
            disabled: false,
          },
          {
            name: "MISSOULA",
            disabled: false,
          },
          {
            name: "MISSOURI CITY",
            disabled: false,
          },
          {
            name: "MITCHELL",
            disabled: false,
          },
          {
            name: "MOBERLY",
            disabled: false,
          },
          {
            name: "MOBILE",
            disabled: false,
          },
          {
            name: "MOCKSVILLE",
            disabled: false,
          },
          {
            name: "MODESTO",
            disabled: false,
          },
          {
            name: "MOGADORE",
            disabled: false,
          },
          {
            name: "MOHEGAN LAKE",
            disabled: false,
          },
          {
            name: "MOKENA",
            disabled: false,
          },
          {
            name: "MOLALLA",
            disabled: false,
          },
          {
            name: "MOLINE",
            disabled: false,
          },
          {
            name: "MONACA",
            disabled: false,
          },
          {
            name: "MONCKS CORNER",
            disabled: false,
          },
          {
            name: "MONESSEN",
            disabled: false,
          },
          {
            name: "MONETA",
            disabled: false,
          },
          {
            name: "MONETT",
            disabled: false,
          },
          {
            name: "MONMOUTH",
            disabled: false,
          },
          {
            name: "MONMOUTH JUNCTION",
            disabled: false,
          },
          {
            name: "MONONA",
            disabled: false,
          },
          {
            name: "MONONGAHELA",
            disabled: false,
          },
          {
            name: "MONROE",
            disabled: false,
          },
          {
            name: "MONROE TOWNSHIP",
            disabled: false,
          },
          {
            name: "MONROEVILLE",
            disabled: false,
          },
          {
            name: "MONROVIA",
            disabled: false,
          },
          {
            name: "MONSEY",
            disabled: false,
          },
          {
            name: "MONSON",
            disabled: false,
          },
          {
            name: "MONT BELVIEU",
            disabled: false,
          },
          {
            name: "MONTCLAIR",
            disabled: false,
          },
          {
            name: "MONTE VISTA",
            disabled: false,
          },
          {
            name: "MONTEAGLE",
            disabled: false,
          },
          {
            name: "MONTEBELLO",
            disabled: false,
          },
          {
            name: "MONTECITO",
            disabled: false,
          },
          {
            name: "MONTEREY",
            disabled: false,
          },
          {
            name: "MONTEREY PARK",
            disabled: false,
          },
          {
            name: "MONTEVALLO",
            disabled: false,
          },
          {
            name: "MONTEVIDEO",
            disabled: false,
          },
          {
            name: "MONTEZUMA",
            disabled: false,
          },
          {
            name: "MONTGOMERY",
            disabled: false,
          },
          {
            name: "MONTICELLO",
            disabled: false,
          },
          {
            name: "MONTOURSVILLE",
            disabled: false,
          },
          {
            name: "MONTPELIER",
            disabled: false,
          },
          {
            name: "MONTROSE",
            disabled: false,
          },
          {
            name: "MONTROSS",
            disabled: false,
          },
          {
            name: "MONTVALE",
            disabled: false,
          },
          {
            name: "MONUMENT",
            disabled: false,
          },
          {
            name: "MOODY",
            disabled: false,
          },
          {
            name: "MOON TOWNSHIP",
            disabled: false,
          },
          {
            name: "MOORE",
            disabled: false,
          },
          {
            name: "MOOREFIELD",
            disabled: false,
          },
          {
            name: "MOORESTOWN",
            disabled: false,
          },
          {
            name: "MOORESVILLE",
            disabled: false,
          },
          {
            name: "MOORHEAD",
            disabled: false,
          },
          {
            name: "MOORPARK",
            disabled: false,
          },
          {
            name: "MOOSIC",
            disabled: false,
          },
          {
            name: "MOOSUP",
            disabled: false,
          },
          {
            name: "MORAGA",
            disabled: false,
          },
          {
            name: "MORAINE",
            disabled: false,
          },
          {
            name: "MOREHEAD",
            disabled: false,
          },
          {
            name: "MOREHEAD CITY",
            disabled: false,
          },
          {
            name: "MORENO VALLEY",
            disabled: false,
          },
          {
            name: "MORGAN CITY",
            disabled: false,
          },
          {
            name: "MORGAN HILL",
            disabled: false,
          },
          {
            name: "MORGANFIELD",
            disabled: false,
          },
          {
            name: "MORGANTON",
            disabled: false,
          },
          {
            name: "MORGANTOWN",
            disabled: false,
          },
          {
            name: "MORGANVILLE",
            disabled: false,
          },
          {
            name: "MORRILTON",
            disabled: false,
          },
          {
            name: "MORRIS",
            disabled: false,
          },
          {
            name: "MORRIS PLAINS",
            disabled: false,
          },
          {
            name: "MORRISTOWN",
            disabled: false,
          },
          {
            name: "MORRISVILLE",
            disabled: false,
          },
          {
            name: "MORRO BAY",
            disabled: false,
          },
          {
            name: "MORROW",
            disabled: false,
          },
          {
            name: "MORTON",
            disabled: false,
          },
          {
            name: "MORTON GROVE",
            disabled: false,
          },
          {
            name: "MOSCOW",
            disabled: false,
          },
          {
            name: "MOSELEY",
            disabled: false,
          },
          {
            name: "MOSES LAKE",
            disabled: false,
          },
          {
            name: "MOSINEE",
            disabled: false,
          },
          {
            name: "MOSS BLUFF",
            disabled: false,
          },
          {
            name: "MOULTON",
            disabled: false,
          },
          {
            name: "MOULTRIE",
            disabled: false,
          },
          {
            name: "MOUND",
            disabled: false,
          },
          {
            name: "MOUNDS VIEW",
            disabled: false,
          },
          {
            name: "MOUNDSVILLE",
            disabled: false,
          },
          {
            name: "MOUNT AIRY",
            disabled: false,
          },
          {
            name: "MOUNT CARMEL",
            disabled: false,
          },
          {
            name: "MOUNT DORA",
            disabled: false,
          },
          {
            name: "MOUNT EPHRAIM",
            disabled: false,
          },
          {
            name: "MOUNT GILEAD",
            disabled: false,
          },
          {
            name: "MOUNT HOLLY",
            disabled: false,
          },
          {
            name: "MOUNT HOREB",
            disabled: false,
          },
          {
            name: "MOUNT JACKSON",
            disabled: false,
          },
          {
            name: "MOUNT JOY",
            disabled: false,
          },
          {
            name: "MOUNT JULIET",
            disabled: false,
          },
          {
            name: "MOUNT KISCO",
            disabled: false,
          },
          {
            name: "MOUNT LAUREL",
            disabled: false,
          },
          {
            name: "MOUNT LEBANON",
            disabled: false,
          },
          {
            name: "MOUNT MORRIS",
            disabled: false,
          },
          {
            name: "MOUNT OLIVE",
            disabled: false,
          },
          {
            name: "MOUNT ORAB",
            disabled: false,
          },
          {
            name: "MOUNT PLEASANT",
            disabled: false,
          },
          {
            name: "MOUNT POCONO",
            disabled: false,
          },
          {
            name: "MOUNT PROSPECT",
            disabled: false,
          },
          {
            name: "MOUNT SHASTA",
            disabled: false,
          },
          {
            name: "MOUNT SINAI",
            disabled: false,
          },
          {
            name: "MOUNT STERLING",
            disabled: false,
          },
          {
            name: "MOUNT VERNON",
            disabled: false,
          },
          {
            name: "MOUNT WASHINGTON",
            disabled: false,
          },
          {
            name: "MOUNTAIN BROOK",
            disabled: false,
          },
          {
            name: "MOUNTAIN CITY",
            disabled: false,
          },
          {
            name: "MOUNTAIN GROVE",
            disabled: false,
          },
          {
            name: "MOUNTAIN HOME",
            disabled: false,
          },
          {
            name: "MOUNTAIN IRON",
            disabled: false,
          },
          {
            name: "MOUNTAIN TOP",
            disabled: false,
          },
          {
            name: "MOUNTAIN VIEW",
            disabled: false,
          },
          {
            name: "MOUNTLAKE TERRACE",
            disabled: false,
          },
          {
            name: "MOYOCK",
            disabled: false,
          },
          {
            name: "MUKILTEO",
            disabled: false,
          },
          {
            name: "MUKWONAGO",
            disabled: false,
          },
          {
            name: "MULBERRY",
            disabled: false,
          },
          {
            name: "MULESHOE",
            disabled: false,
          },
          {
            name: "MULLENS",
            disabled: false,
          },
          {
            name: "MULLICA HILL",
            disabled: false,
          },
          {
            name: "MULLINS",
            disabled: false,
          },
          {
            name: "MUNCIE",
            disabled: false,
          },
          {
            name: "MUNCY",
            disabled: false,
          },
          {
            name: "MUNDELEIN",
            disabled: false,
          },
          {
            name: "MUNFORD",
            disabled: false,
          },
          {
            name: "MUNHALL",
            disabled: false,
          },
          {
            name: "MUNSTER",
            disabled: false,
          },
          {
            name: "MURFREESBORO",
            disabled: false,
          },
          {
            name: "MURPHY",
            disabled: false,
          },
          {
            name: "MURPHYSBORO",
            disabled: false,
          },
          {
            name: "MURRAY",
            disabled: false,
          },
          {
            name: "MURRELLS INLET",
            disabled: false,
          },
          {
            name: "MURRIETA",
            disabled: false,
          },
          {
            name: "MURRYSVILLE",
            disabled: false,
          },
          {
            name: "MUSCATINE",
            disabled: false,
          },
          {
            name: "MUSCLE SHOALS",
            disabled: false,
          },
          {
            name: "MUSKEGO",
            disabled: false,
          },
          {
            name: "MUSKEGON",
            disabled: false,
          },
          {
            name: "MUSKOGEE",
            disabled: false,
          },
          {
            name: "MUSTANG",
            disabled: false,
          },
          {
            name: "MYRTLE BEACH",
            disabled: false,
          },
          {
            name: "MYSTIC",
            disabled: false,
          },
          {
            name: "Macomb",
            disabled: false,
          },
          {
            name: "Macon",
            disabled: false,
          },
          {
            name: "Madison",
            disabled: false,
          },
          {
            name: "Maineville",
            disabled: false,
          },
          {
            name: "Mandeville",
            disabled: false,
          },
          {
            name: "Manitowoc",
            disabled: false,
          },
          {
            name: "Marana",
            disabled: false,
          },
          {
            name: "Maricopa",
            disabled: false,
          },
          {
            name: "Marietta",
            disabled: false,
          },
          {
            name: "Marina Del Rey",
            disabled: false,
          },
          {
            name: "Marion",
            disabled: false,
          },
          {
            name: "Martin",
            disabled: false,
          },
          {
            name: "Marysville",
            disabled: false,
          },
          {
            name: "Mayfield",
            disabled: false,
          },
          {
            name: "Maywood",
            disabled: false,
          },
          {
            name: "Mc Pherson",
            disabled: false,
          },
          {
            name: "McDonough",
            disabled: false,
          },
          {
            name: "Mccomb",
            disabled: false,
          },
          {
            name: "Melissa",
            disabled: false,
          },
          {
            name: "Memphis",
            disabled: false,
          },
          {
            name: "Mequon",
            disabled: false,
          },
          {
            name: "Mercer Island",
            disabled: false,
          },
          {
            name: "Merrillville",
            disabled: false,
          },
          {
            name: "Mesa",
            disabled: false,
          },
          {
            name: "Miami",
            disabled: false,
          },
          {
            name: "Miami Beach",
            disabled: false,
          },
          {
            name: "Miamisburg",
            disabled: false,
          },
          {
            name: "Middleton",
            disabled: false,
          },
          {
            name: "Middletown",
            disabled: false,
          },
          {
            name: "Midlothian",
            disabled: false,
          },
          {
            name: "Milan",
            disabled: false,
          },
          {
            name: "Milwaukee",
            disabled: false,
          },
          {
            name: "Minneapolis",
            disabled: false,
          },
          {
            name: "Mission Hills",
            disabled: false,
          },
          {
            name: "Mission Viejo",
            disabled: false,
          },
          {
            name: "Mitchell",
            disabled: false,
          },
          {
            name: "Moab",
            disabled: false,
          },
          {
            name: "Monona",
            disabled: false,
          },
          {
            name: "Monroe",
            disabled: false,
          },
          {
            name: "Montgomery",
            disabled: false,
          },
          {
            name: "Monticello",
            disabled: false,
          },
          {
            name: "Montrose",
            disabled: false,
          },
          {
            name: "Morgantown",
            disabled: false,
          },
          {
            name: "Morrilton",
            disabled: false,
          },
          {
            name: "Mount Pleasant",
            disabled: false,
          },
          {
            name: "Mount Sterling",
            disabled: false,
          },
          {
            name: "Mount Vernon",
            disabled: false,
          },
          {
            name: "Mountlake Terrace",
            disabled: false,
          },
          {
            name: "Mt Gay",
            disabled: false,
          },
          {
            name: "Mt. Pleasant",
            disabled: false,
          },
          {
            name: "Mt. Vernon",
            disabled: false,
          },
          {
            name: "Mukilteo",
            disabled: false,
          },
          {
            name: "Mulvane",
            disabled: false,
          },
          {
            name: "Muncie",
            disabled: false,
          },
          {
            name: "Murfreesboro",
            disabled: false,
          },
          {
            name: "Murrieta",
            disabled: false,
          },
          {
            name: "Muskegon",
            disabled: false,
          },
          {
            name: "Myrtle Beach",
            disabled: false,
          },
          {
            name: "N. MIAMI",
            disabled: false,
          },
          {
            name: "NA",
            disabled: false,
          },
          {
            name: "NACOGDOCHES",
            disabled: false,
          },
          {
            name: "NAMPA",
            disabled: false,
          },
          {
            name: "NANTICOKE",
            disabled: false,
          },
          {
            name: "NANTUCKET",
            disabled: false,
          },
          {
            name: "NANUET",
            disabled: false,
          },
          {
            name: "NAPA",
            disabled: false,
          },
          {
            name: "NAPANOCH",
            disabled: false,
          },
          {
            name: "NAPERVILLE",
            disabled: false,
          },
          {
            name: "NAPLES",
            disabled: false,
          },
          {
            name: "NAPOLEON",
            disabled: false,
          },
          {
            name: "NAPPANEE",
            disabled: false,
          },
          {
            name: "NARANJA",
            disabled: false,
          },
          {
            name: "NARBERTH",
            disabled: false,
          },
          {
            name: "NARRAGANSETT",
            disabled: false,
          },
          {
            name: "NASHOTAH",
            disabled: false,
          },
          {
            name: "NASHUA",
            disabled: false,
          },
          {
            name: "NASHVILLE",
            disabled: false,
          },
          {
            name: "NASSAU BAY",
            disabled: false,
          },
          {
            name: "NATCHEZ",
            disabled: false,
          },
          {
            name: "NATCHITOCHES",
            disabled: false,
          },
          {
            name: "NATICK",
            disabled: false,
          },
          {
            name: "NATIONAL CITY",
            disabled: false,
          },
          {
            name: "NATRONA HEIGHTS",
            disabled: false,
          },
          {
            name: "NAUGATUCK",
            disabled: false,
          },
          {
            name: "NAVARRE",
            disabled: false,
          },
          {
            name: "NAVASOTA",
            disabled: false,
          },
          {
            name: "NAZARETH",
            disabled: false,
          },
          {
            name: "NEBRASKA CITY",
            disabled: false,
          },
          {
            name: "NEDERLAND",
            disabled: false,
          },
          {
            name: "NEEDHAM",
            disabled: false,
          },
          {
            name: "NEEDLES",
            disabled: false,
          },
          {
            name: "NEENAH",
            disabled: false,
          },
          {
            name: "NELSONVILLE",
            disabled: false,
          },
          {
            name: "NEOSHO",
            disabled: false,
          },
          {
            name: "NEPTUNE",
            disabled: false,
          },
          {
            name: "NEPTUNE BEACH",
            disabled: false,
          },
          {
            name: "NESCONSET",
            disabled: false,
          },
          {
            name: "NESQUEHONING",
            disabled: false,
          },
          {
            name: "NEVADA",
            disabled: false,
          },
          {
            name: "NEW ALBANY",
            disabled: false,
          },
          {
            name: "NEW BALTIMORE",
            disabled: false,
          },
          {
            name: "NEW BEDFORD",
            disabled: false,
          },
          {
            name: "NEW BERLIN",
            disabled: false,
          },
          {
            name: "NEW BERN",
            disabled: false,
          },
          {
            name: "NEW BETHLEHEM",
            disabled: false,
          },
          {
            name: "NEW BOSTON",
            disabled: false,
          },
          {
            name: "NEW BRAUNFELS",
            disabled: false,
          },
          {
            name: "NEW BRIGHTON",
            disabled: false,
          },
          {
            name: "NEW BRITAIN",
            disabled: false,
          },
          {
            name: "NEW BRUNSWICK",
            disabled: false,
          },
          {
            name: "NEW CANAAN",
            disabled: false,
          },
          {
            name: "NEW CANEY",
            disabled: false,
          },
          {
            name: "NEW CARLISLE",
            disabled: false,
          },
          {
            name: "NEW CARROLLTON",
            disabled: false,
          },
          {
            name: "NEW CASTLE",
            disabled: false,
          },
          {
            name: "NEW CITY",
            disabled: false,
          },
          {
            name: "NEW CUMBERLAND",
            disabled: false,
          },
          {
            name: "NEW EGYPT",
            disabled: false,
          },
          {
            name: "NEW FAIRFIELD",
            disabled: false,
          },
          {
            name: "NEW HARTFORD",
            disabled: false,
          },
          {
            name: "NEW HAVEN",
            disabled: false,
          },
          {
            name: "NEW HOLLAND",
            disabled: false,
          },
          {
            name: "NEW HOPE",
            disabled: false,
          },
          {
            name: "NEW HUDSON",
            disabled: false,
          },
          {
            name: "NEW HYDE PARK",
            disabled: false,
          },
          {
            name: "NEW IBERIA",
            disabled: false,
          },
          {
            name: "NEW KENSINGTON",
            disabled: false,
          },
          {
            name: "NEW LEBANON",
            disabled: false,
          },
          {
            name: "NEW LENOX",
            disabled: false,
          },
          {
            name: "NEW LEXINGTON",
            disabled: false,
          },
          {
            name: "NEW LONDON",
            disabled: false,
          },
          {
            name: "NEW MARKET",
            disabled: false,
          },
          {
            name: "NEW MARTINSVILLE",
            disabled: false,
          },
          {
            name: "NEW MILFORD",
            disabled: false,
          },
          {
            name: "NEW ORLEANS",
            disabled: false,
          },
          {
            name: "NEW OXFORD",
            disabled: false,
          },
          {
            name: "NEW PALESTINE",
            disabled: false,
          },
          {
            name: "NEW PALTZ",
            disabled: false,
          },
          {
            name: "NEW PHILADELPHIA",
            disabled: false,
          },
          {
            name: "NEW PORT RICHEY",
            disabled: false,
          },
          {
            name: "NEW PRAGUE",
            disabled: false,
          },
          {
            name: "NEW PROVIDENCE",
            disabled: false,
          },
          {
            name: "NEW RICHMOND",
            disabled: false,
          },
          {
            name: "NEW ROADS",
            disabled: false,
          },
          {
            name: "NEW ROCHELLE",
            disabled: false,
          },
          {
            name: "NEW SALISBURY",
            disabled: false,
          },
          {
            name: "NEW SMYRNA BEACH",
            disabled: false,
          },
          {
            name: "NEW TAZEWELL",
            disabled: false,
          },
          {
            name: "NEW ULM",
            disabled: false,
          },
          {
            name: "NEW WINDSOR",
            disabled: false,
          },
          {
            name: "NEW YORK",
            disabled: false,
          },
          {
            name: "NEWARK",
            disabled: false,
          },
          {
            name: "NEWARK VALLEY",
            disabled: false,
          },
          {
            name: "NEWBERG",
            disabled: false,
          },
          {
            name: "NEWBERRY",
            disabled: false,
          },
          {
            name: "NEWBURGH",
            disabled: false,
          },
          {
            name: "NEWBURY PARK",
            disabled: false,
          },
          {
            name: "NEWBURYPORT",
            disabled: false,
          },
          {
            name: "NEWCASTLE",
            disabled: false,
          },
          {
            name: "NEWHALL",
            disabled: false,
          },
          {
            name: "NEWINGTON",
            disabled: false,
          },
          {
            name: "NEWLAND",
            disabled: false,
          },
          {
            name: "NEWMAN",
            disabled: false,
          },
          {
            name: "NEWMARKET",
            disabled: false,
          },
          {
            name: "NEWNAN",
            disabled: false,
          },
          {
            name: "NEWPORT",
            disabled: false,
          },
          {
            name: "NEWPORT BEACH",
            disabled: false,
          },
          {
            name: "NEWPORT NEWS",
            disabled: false,
          },
          {
            name: "NEWTON",
            disabled: false,
          },
          {
            name: "NEWTON FALLS",
            disabled: false,
          },
          {
            name: "NEWTON GROVE",
            disabled: false,
          },
          {
            name: "NEWTONVILLE",
            disabled: false,
          },
          {
            name: "NEWTOWN",
            disabled: false,
          },
          {
            name: "NEWTOWN SQUARE",
            disabled: false,
          },
          {
            name: "NIAGARA FALLS",
            disabled: false,
          },
          {
            name: "NIANTIC",
            disabled: false,
          },
          {
            name: "NICEVILLE",
            disabled: false,
          },
          {
            name: "NICHOLASVILLE",
            disabled: false,
          },
          {
            name: "NILES",
            disabled: false,
          },
          {
            name: "NIPOMO",
            disabled: false,
          },
          {
            name: "NIXA",
            disabled: false,
          },
          {
            name: "NOBLESVILLE",
            disabled: false,
          },
          {
            name: "NOGALES",
            disabled: false,
          },
          {
            name: "NOKOMIS",
            disabled: false,
          },
          {
            name: "NOME",
            disabled: false,
          },
          {
            name: "NORCO",
            disabled: false,
          },
          {
            name: "NORCROSS",
            disabled: false,
          },
          {
            name: "NORFOLK",
            disabled: false,
          },
          {
            name: "NORMAL",
            disabled: false,
          },
          {
            name: "NORMAN",
            disabled: false,
          },
          {
            name: "NORMANDY PARK",
            disabled: false,
          },
          {
            name: "NORRIDGE",
            disabled: false,
          },
          {
            name: "NORRISTOWN",
            disabled: false,
          },
          {
            name: "NORTH ADAMS",
            disabled: false,
          },
          {
            name: "NORTH ANDOVER",
            disabled: false,
          },
          {
            name: "NORTH ARLINGTON",
            disabled: false,
          },
          {
            name: "NORTH ATTLEBORO",
            disabled: false,
          },
          {
            name: "NORTH AUGUSTA",
            disabled: false,
          },
          {
            name: "NORTH AURORA",
            disabled: false,
          },
          {
            name: "NORTH BABYLON",
            disabled: false,
          },
          {
            name: "NORTH BELLMORE",
            disabled: false,
          },
          {
            name: "NORTH BEND",
            disabled: false,
          },
          {
            name: "NORTH BERGEN",
            disabled: false,
          },
          {
            name: "NORTH BILLERICA",
            disabled: false,
          },
          {
            name: "NORTH BRANFORD",
            disabled: false,
          },
          {
            name: "NORTH BRUNSWICK",
            disabled: false,
          },
          {
            name: "NORTH CANTON",
            disabled: false,
          },
          {
            name: "NORTH CAPE MAY",
            disabled: false,
          },
          {
            name: "NORTH CHARLESTON",
            disabled: false,
          },
          {
            name: "NORTH CHESTERFI",
            disabled: false,
          },
          {
            name: "NORTH CHESTERFIELD",
            disabled: false,
          },
          {
            name: "NORTH CHILI",
            disabled: false,
          },
          {
            name: "NORTH CONWAY",
            disabled: false,
          },
          {
            name: "NORTH DARTMOUTH",
            disabled: false,
          },
          {
            name: "NORTH EAST",
            disabled: false,
          },
          {
            name: "NORTH EASTON",
            disabled: false,
          },
          {
            name: "NORTH FORT MYERS",
            disabled: false,
          },
          {
            name: "NORTH HAMPTON",
            disabled: false,
          },
          {
            name: "NORTH HAVEN",
            disabled: false,
          },
          {
            name: "NORTH HIGHLANDS",
            disabled: false,
          },
          {
            name: "NORTH HILLS",
            disabled: false,
          },
          {
            name: "NORTH HOLLYWOOD",
            disabled: false,
          },
          {
            name: "NORTH HUNTINGDON",
            disabled: false,
          },
          {
            name: "NORTH JUDSON",
            disabled: false,
          },
          {
            name: "NORTH KINGSTOWN",
            disabled: false,
          },
          {
            name: "NORTH LAS VEGAS",
            disabled: false,
          },
          {
            name: "NORTH LAUDERDALE",
            disabled: false,
          },
          {
            name: "NORTH LIBERTY",
            disabled: false,
          },
          {
            name: "NORTH LITTLE ROCK",
            disabled: false,
          },
          {
            name: "NORTH LOGAN",
            disabled: false,
          },
          {
            name: "NORTH MANCHESTER",
            disabled: false,
          },
          {
            name: "NORTH MANKATO",
            disabled: false,
          },
          {
            name: "NORTH MIAMI",
            disabled: false,
          },
          {
            name: "NORTH MIAMI BEACH",
            disabled: false,
          },
          {
            name: "NORTH MUSKEGON",
            disabled: false,
          },
          {
            name: "NORTH MYRTLE BEACH",
            disabled: false,
          },
          {
            name: "NORTH OAKS",
            disabled: false,
          },
          {
            name: "NORTH OGDEN",
            disabled: false,
          },
          {
            name: "NORTH OLMSTED",
            disabled: false,
          },
          {
            name: "NORTH OXFORD",
            disabled: false,
          },
          {
            name: "NORTH PALM BEACH",
            disabled: false,
          },
          {
            name: "NORTH PLAINFIEL",
            disabled: false,
          },
          {
            name: "NORTH PLATTE",
            disabled: false,
          },
          {
            name: "NORTH POLE",
            disabled: false,
          },
          {
            name: "NORTH PORT",
            disabled: false,
          },
          {
            name: "NORTH PROVIDENCE",
            disabled: false,
          },
          {
            name: "NORTH READING",
            disabled: false,
          },
          {
            name: "NORTH RICHLAND HILL",
            disabled: false,
          },
          {
            name: "NORTH RICHLAND HILLS",
            disabled: false,
          },
          {
            name: "NORTH RIDGEVILLE",
            disabled: false,
          },
          {
            name: "NORTH RIVERSIDE",
            disabled: false,
          },
          {
            name: "NORTH ROYALTON",
            disabled: false,
          },
          {
            name: "NORTH SAINT PAUL",
            disabled: false,
          },
          {
            name: "NORTH SCITUATE",
            disabled: false,
          },
          {
            name: "NORTH SMITHFIELD",
            disabled: false,
          },
          {
            name: "NORTH SYRACUSE",
            disabled: false,
          },
          {
            name: "NORTH TAZEWELL",
            disabled: false,
          },
          {
            name: "NORTH TONAWANDA",
            disabled: false,
          },
          {
            name: "NORTH VERNON",
            disabled: false,
          },
          {
            name: "NORTH VERSAILLES",
            disabled: false,
          },
          {
            name: "NORTH WALES",
            disabled: false,
          },
          {
            name: "NORTH WEBSTER",
            disabled: false,
          },
          {
            name: "NORTH WILDWOOD",
            disabled: false,
          },
          {
            name: "NORTH WILKESBORO",
            disabled: false,
          },
          {
            name: "NORTH WINDHAM",
            disabled: false,
          },
          {
            name: "NORTHAMPTON",
            disabled: false,
          },
          {
            name: "NORTHBOROUGH",
            disabled: false,
          },
          {
            name: "NORTHBROOK",
            disabled: false,
          },
          {
            name: "NORTHERN CAMBRIA",
            disabled: false,
          },
          {
            name: "NORTHFIELD",
            disabled: false,
          },
          {
            name: "NORTHFORD",
            disabled: false,
          },
          {
            name: "NORTHGLENN",
            disabled: false,
          },
          {
            name: "NORTHLAKE",
            disabled: false,
          },
          {
            name: "NORTHPORT",
            disabled: false,
          },
          {
            name: "NORTHRIDGE",
            disabled: false,
          },
          {
            name: "NORTHUMBERLAND",
            disabled: false,
          },
          {
            name: "NORTHVALE",
            disabled: false,
          },
          {
            name: "NORTHVILLE",
            disabled: false,
          },
          {
            name: "NORTON",
            disabled: false,
          },
          {
            name: "NORTON SHORES",
            disabled: false,
          },
          {
            name: "NORWALK",
            disabled: false,
          },
          {
            name: "NORWAY",
            disabled: false,
          },
          {
            name: "NORWELL",
            disabled: false,
          },
          {
            name: "NORWICH",
            disabled: false,
          },
          {
            name: "NORWOOD",
            disabled: false,
          },
          {
            name: "NOTTINGHAM",
            disabled: false,
          },
          {
            name: "NOVATO",
            disabled: false,
          },
          {
            name: "NOVI",
            disabled: false,
          },
          {
            name: "NUTLEY",
            disabled: false,
          },
          {
            name: "NUTTERFORT",
            disabled: false,
          },
          {
            name: "NYACK",
            disabled: false,
          },
          {
            name: "Naperville",
            disabled: false,
          },
          {
            name: "Nashville",
            disabled: false,
          },
          {
            name: "Neenah",
            disabled: false,
          },
          {
            name: "New Albany",
            disabled: false,
          },
          {
            name: "New Berlin",
            disabled: false,
          },
          {
            name: "New Caney",
            disabled: false,
          },
          {
            name: "New Castle",
            disabled: false,
          },
          {
            name: "New Hyde Park",
            disabled: false,
          },
          {
            name: "New York",
            disabled: false,
          },
          {
            name: "New York City",
            disabled: false,
          },
          {
            name: "Newark",
            disabled: false,
          },
          {
            name: "Newburgh",
            disabled: false,
          },
          {
            name: "Newcastle",
            disabled: false,
          },
          {
            name: "Newport",
            disabled: false,
          },
          {
            name: "Nokomis",
            disabled: false,
          },
          {
            name: "Norfolk",
            disabled: false,
          },
          {
            name: "North Bend",
            disabled: false,
          },
          {
            name: "North Charleston",
            disabled: false,
          },
          {
            name: "North Chesterfield",
            disabled: false,
          },
          {
            name: "North Hills",
            disabled: false,
          },
          {
            name: "North Hollywood",
            disabled: false,
          },
          {
            name: "North Huntingdon",
            disabled: false,
          },
          {
            name: "North Las Vegas",
            disabled: false,
          },
          {
            name: "North Little Rock",
            disabled: false,
          },
          {
            name: "North Myrtle Beach",
            disabled: false,
          },
          {
            name: "North Ogden",
            disabled: false,
          },
          {
            name: "North Vernon",
            disabled: false,
          },
          {
            name: "Northbrook",
            disabled: false,
          },
          {
            name: "Northfield",
            disabled: false,
          },
          {
            name: "Norwalk",
            disabled: false,
          },
          {
            name: "Nottingham",
            disabled: false,
          },
          {
            name: "O FALLON",
            disabled: false,
          },
          {
            name: "O Fallon",
            disabled: false,
          },
          {
            name: "OAK BROOK",
            disabled: false,
          },
          {
            name: "OAK CREEK",
            disabled: false,
          },
          {
            name: "OAK FOREST",
            disabled: false,
          },
          {
            name: "OAK GROVE",
            disabled: false,
          },
          {
            name: "OAK HALL",
            disabled: false,
          },
          {
            name: "OAK HARBOR",
            disabled: false,
          },
          {
            name: "OAK HILL",
            disabled: false,
          },
          {
            name: "OAK LAWN",
            disabled: false,
          },
          {
            name: "OAK PARK",
            disabled: false,
          },
          {
            name: "OAK PARK HEIGHTS",
            disabled: false,
          },
          {
            name: "OAK POINT",
            disabled: false,
          },
          {
            name: "OAK RIDGE",
            disabled: false,
          },
          {
            name: "OAKBORO",
            disabled: false,
          },
          {
            name: "OAKDALE",
            disabled: false,
          },
          {
            name: "OAKHURST",
            disabled: false,
          },
          {
            name: "OAKLAND",
            disabled: false,
          },
          {
            name: "OAKLAND PARK",
            disabled: false,
          },
          {
            name: "OAKLEY",
            disabled: false,
          },
          {
            name: "OAKLYN",
            disabled: false,
          },
          {
            name: "OAKMONT",
            disabled: false,
          },
          {
            name: "OAKS",
            disabled: false,
          },
          {
            name: "OAKTON",
            disabled: false,
          },
          {
            name: "OAKVILLE",
            disabled: false,
          },
          {
            name: "OAKWOOD",
            disabled: false,
          },
          {
            name: "OBERLIN",
            disabled: false,
          },
          {
            name: "OCALA",
            disabled: false,
          },
          {
            name: "OCEAN",
            disabled: false,
          },
          {
            name: "OCEAN CITY",
            disabled: false,
          },
          {
            name: "OCEAN ISLE BEACH",
            disabled: false,
          },
          {
            name: "OCEAN SPRINGS",
            disabled: false,
          },
          {
            name: "OCEAN VIEW",
            disabled: false,
          },
          {
            name: "OCEANA",
            disabled: false,
          },
          {
            name: "OCEANSIDE",
            disabled: false,
          },
          {
            name: "OCOEE",
            disabled: false,
          },
          {
            name: "OCONOMOWOC",
            disabled: false,
          },
          {
            name: "ODENTON",
            disabled: false,
          },
          {
            name: "ODESSA",
            disabled: false,
          },
          {
            name: "OGALLALA",
            disabled: false,
          },
          {
            name: "OGDEN",
            disabled: false,
          },
          {
            name: "OGDENSBURG",
            disabled: false,
          },
          {
            name: "OIL CITY",
            disabled: false,
          },
          {
            name: "OJAI",
            disabled: false,
          },
          {
            name: "OKATIE",
            disabled: false,
          },
          {
            name: "OKEECHOBEE",
            disabled: false,
          },
          {
            name: "OKEMOS",
            disabled: false,
          },
          {
            name: "OKLAHOMA CITY",
            disabled: false,
          },
          {
            name: "OKMULGEE",
            disabled: false,
          },
          {
            name: "OLATHE",
            disabled: false,
          },
          {
            name: "OLD BRIDGE",
            disabled: false,
          },
          {
            name: "OLD FORGE",
            disabled: false,
          },
          {
            name: "OLD GREENWICH",
            disabled: false,
          },
          {
            name: "OLD LYME",
            disabled: false,
          },
          {
            name: "OLD SAYBROOK",
            disabled: false,
          },
          {
            name: "OLD TAPPAN",
            disabled: false,
          },
          {
            name: "OLD TOWN",
            disabled: false,
          },
          {
            name: "OLDSMAR",
            disabled: false,
          },
          {
            name: "OLEAN",
            disabled: false,
          },
          {
            name: "OLIVE BRANCH",
            disabled: false,
          },
          {
            name: "OLIVE HILL",
            disabled: false,
          },
          {
            name: "OLIVEHURST",
            disabled: false,
          },
          {
            name: "OLIVETTE",
            disabled: false,
          },
          {
            name: "OLNEY",
            disabled: false,
          },
          {
            name: "OLYMPIA",
            disabled: false,
          },
          {
            name: "OLYMPIA FIELDS",
            disabled: false,
          },
          {
            name: "OLYPHANT",
            disabled: false,
          },
          {
            name: "OMAHA",
            disabled: false,
          },
          {
            name: "OMAK",
            disabled: false,
          },
          {
            name: "ONALASKA",
            disabled: false,
          },
          {
            name: "ONEIDA",
            disabled: false,
          },
          {
            name: "ONEONTA",
            disabled: false,
          },
          {
            name: "ONLEY",
            disabled: false,
          },
          {
            name: "ONTARIO",
            disabled: false,
          },
          {
            name: "OOLTEWAH",
            disabled: false,
          },
          {
            name: "OPELIKA",
            disabled: false,
          },
          {
            name: "OPELOUSAS",
            disabled: false,
          },
          {
            name: "ORADELL",
            disabled: false,
          },
          {
            name: "ORANGE",
            disabled: false,
          },
          {
            name: "ORANGE BEACH",
            disabled: false,
          },
          {
            name: "ORANGE CITY",
            disabled: false,
          },
          {
            name: "ORANGE PARK",
            disabled: false,
          },
          {
            name: "ORANGEBURG",
            disabled: false,
          },
          {
            name: "ORANGEVALE",
            disabled: false,
          },
          {
            name: "ORCHARD PARK",
            disabled: false,
          },
          {
            name: "ORCUTT",
            disabled: false,
          },
          {
            name: "OREGON",
            disabled: false,
          },
          {
            name: "OREGON CITY",
            disabled: false,
          },
          {
            name: "OREM",
            disabled: false,
          },
          {
            name: "ORINDA",
            disabled: false,
          },
          {
            name: "ORLAND",
            disabled: false,
          },
          {
            name: "ORLAND HILLS",
            disabled: false,
          },
          {
            name: "ORLAND PARK",
            disabled: false,
          },
          {
            name: "ORLANDO",
            disabled: false,
          },
          {
            name: "ORLEANS",
            disabled: false,
          },
          {
            name: "ORMOND BEACH",
            disabled: false,
          },
          {
            name: "ORO VALLEY",
            disabled: false,
          },
          {
            name: "OROVILLE",
            disabled: false,
          },
          {
            name: "ORRVILLE",
            disabled: false,
          },
          {
            name: "ORTING",
            disabled: false,
          },
          {
            name: "ORTLEY BEACH",
            disabled: false,
          },
          {
            name: "ORTONVILLE",
            disabled: false,
          },
          {
            name: "OSAGE BEACH",
            disabled: false,
          },
          {
            name: "OSCEOLA",
            disabled: false,
          },
          {
            name: "OSCODA",
            disabled: false,
          },
          {
            name: "OSHKOSH",
            disabled: false,
          },
          {
            name: "OSKALOOSA",
            disabled: false,
          },
          {
            name: "OSPREY",
            disabled: false,
          },
          {
            name: "OSSINING",
            disabled: false,
          },
          {
            name: "OSSIPEE",
            disabled: false,
          },
          {
            name: "OSWEGO",
            disabled: false,
          },
          {
            name: "OTHELLO",
            disabled: false,
          },
          {
            name: "OTISVILLE",
            disabled: false,
          },
          {
            name: "OTSEGO",
            disabled: false,
          },
          {
            name: "OTTAWA",
            disabled: false,
          },
          {
            name: "OTTSVILLE",
            disabled: false,
          },
          {
            name: "OTTUMWA",
            disabled: false,
          },
          {
            name: "OVERLAND",
            disabled: false,
          },
          {
            name: "OVERLAND PARK",
            disabled: false,
          },
          {
            name: "OVIEDO",
            disabled: false,
          },
          {
            name: "OWASSO",
            disabled: false,
          },
          {
            name: "OWATONNA",
            disabled: false,
          },
          {
            name: "OWEGO",
            disabled: false,
          },
          {
            name: "OWENS CROSS ROADS",
            disabled: false,
          },
          {
            name: "OWENSBORO",
            disabled: false,
          },
          {
            name: "OWENSVILLE",
            disabled: false,
          },
          {
            name: "OWINGS MILLS",
            disabled: false,
          },
          {
            name: "OWOSSO",
            disabled: false,
          },
          {
            name: "OXFORD",
            disabled: false,
          },
          {
            name: "OXNARD",
            disabled: false,
          },
          {
            name: "OXON HILL",
            disabled: false,
          },
          {
            name: "OYSTER BAY",
            disabled: false,
          },
          {
            name: "OZARK",
            disabled: false,
          },
          {
            name: "OZONE PARK",
            disabled: false,
          },
          {
            name: "Oak Creek",
            disabled: false,
          },
          {
            name: "Oak Forest",
            disabled: false,
          },
          {
            name: "Oak Grove",
            disabled: false,
          },
          {
            name: "Oak Lawn",
            disabled: false,
          },
          {
            name: "Oak Park",
            disabled: false,
          },
          {
            name: "Oak Ridge",
            disabled: false,
          },
          {
            name: "Oakland",
            disabled: false,
          },
          {
            name: "Oceanside",
            disabled: false,
          },
          {
            name: "Oconomowoc",
            disabled: false,
          },
          {
            name: "Odon",
            disabled: false,
          },
          {
            name: "Oklahoma City",
            disabled: false,
          },
          {
            name: "Old Bridge",
            disabled: false,
          },
          {
            name: "Olney",
            disabled: false,
          },
          {
            name: "Omaha",
            disabled: false,
          },
          {
            name: "Ontario",
            disabled: false,
          },
          {
            name: "Opa-Locka",
            disabled: false,
          },
          {
            name: "Orange",
            disabled: false,
          },
          {
            name: "Oregon",
            disabled: false,
          },
          {
            name: "Orion",
            disabled: false,
          },
          {
            name: "Orland Park",
            disabled: false,
          },
          {
            name: "Osgood",
            disabled: false,
          },
          {
            name: "Oxnard",
            disabled: false,
          },
          {
            name: "PACE",
            disabled: false,
          },
          {
            name: "PACIFIC",
            disabled: false,
          },
          {
            name: "PACIFIC GROVE",
            disabled: false,
          },
          {
            name: "PACIFIC PALISADES",
            disabled: false,
          },
          {
            name: "PACIFICA",
            disabled: false,
          },
          {
            name: "PACOIMA",
            disabled: false,
          },
          {
            name: "PADUCAH",
            disabled: false,
          },
          {
            name: "PAGE",
            disabled: false,
          },
          {
            name: "PAGELAND",
            disabled: false,
          },
          {
            name: "PAGOSA SPRINGS",
            disabled: false,
          },
          {
            name: "PAHRUMP",
            disabled: false,
          },
          {
            name: "PAINESVILLE",
            disabled: false,
          },
          {
            name: "PAINTED POST",
            disabled: false,
          },
          {
            name: "PAINTSVILLE",
            disabled: false,
          },
          {
            name: "PALATINE",
            disabled: false,
          },
          {
            name: "PALATINE BRIDGE",
            disabled: false,
          },
          {
            name: "PALATKA",
            disabled: false,
          },
          {
            name: "PALESTINE",
            disabled: false,
          },
          {
            name: "PALM BAY",
            disabled: false,
          },
          {
            name: "PALM BEACH GARD",
            disabled: false,
          },
          {
            name: "PALM BEACH GARDENS",
            disabled: false,
          },
          {
            name: "PALM CITY",
            disabled: false,
          },
          {
            name: "PALM COAST",
            disabled: false,
          },
          {
            name: "PALM DESERT",
            disabled: false,
          },
          {
            name: "PALM HARBOR",
            disabled: false,
          },
          {
            name: "PALM SPRINGS",
            disabled: false,
          },
          {
            name: "PALM SPRINGS VILLAG",
            disabled: false,
          },
          {
            name: "PALM SPRINGS VILLAGE",
            disabled: false,
          },
          {
            name: "PALMDALE",
            disabled: false,
          },
          {
            name: "PALMER",
            disabled: false,
          },
          {
            name: "PALMERTON",
            disabled: false,
          },
          {
            name: "PALMETTO",
            disabled: false,
          },
          {
            name: "PALMHURST",
            disabled: false,
          },
          {
            name: "PALMVIEW",
            disabled: false,
          },
          {
            name: "PALMYRA",
            disabled: false,
          },
          {
            name: "PALO ALTO",
            disabled: false,
          },
          {
            name: "PALO CEDRO",
            disabled: false,
          },
          {
            name: "PALOS HEIGHTS",
            disabled: false,
          },
          {
            name: "PALOS HILLS",
            disabled: false,
          },
          {
            name: "PALOS PARK",
            disabled: false,
          },
          {
            name: "PAMPA",
            disabled: false,
          },
          {
            name: "PANA",
            disabled: false,
          },
          {
            name: "PANAMA CITY",
            disabled: false,
          },
          {
            name: "PANAMA CITY BEACH",
            disabled: false,
          },
          {
            name: "PANORAMA CITY",
            disabled: false,
          },
          {
            name: "PANTEGO",
            disabled: false,
          },
          {
            name: "PAOLA",
            disabled: false,
          },
          {
            name: "PAOLI",
            disabled: false,
          },
          {
            name: "PAPILLION",
            disabled: false,
          },
          {
            name: "PARADISE",
            disabled: false,
          },
          {
            name: "PARAGOULD",
            disabled: false,
          },
          {
            name: "PARAMOUNT",
            disabled: false,
          },
          {
            name: "PARAMUS",
            disabled: false,
          },
          {
            name: "PARIS",
            disabled: false,
          },
          {
            name: "PARK CITY",
            disabled: false,
          },
          {
            name: "PARK FOREST",
            disabled: false,
          },
          {
            name: "PARK RAPIDS",
            disabled: false,
          },
          {
            name: "PARK RIDGE",
            disabled: false,
          },
          {
            name: "PARKER",
            disabled: false,
          },
          {
            name: "PARKERSBURG",
            disabled: false,
          },
          {
            name: "PARKESBURG",
            disabled: false,
          },
          {
            name: "PARKLAND",
            disabled: false,
          },
          {
            name: "PARKVILLE",
            disabled: false,
          },
          {
            name: "PARLIN",
            disabled: false,
          },
          {
            name: "PARMA",
            disabled: false,
          },
          {
            name: "PARMA HEIGHTS",
            disabled: false,
          },
          {
            name: "PARRISH",
            disabled: false,
          },
          {
            name: "PARSIPPANY",
            disabled: false,
          },
          {
            name: "PARSONS",
            disabled: false,
          },
          {
            name: "PASADENA",
            disabled: false,
          },
          {
            name: "PASCAGOULA",
            disabled: false,
          },
          {
            name: "PASCO",
            disabled: false,
          },
          {
            name: "PASCOAG",
            disabled: false,
          },
          {
            name: "PASO ROBLES",
            disabled: false,
          },
          {
            name: "PASS CHRISTIAN",
            disabled: false,
          },
          {
            name: "PASSAIC",
            disabled: false,
          },
          {
            name: "PATASKALA",
            disabled: false,
          },
          {
            name: "PATCHOGUE",
            disabled: false,
          },
          {
            name: "PATERSON",
            disabled: false,
          },
          {
            name: "PATTERSON",
            disabled: false,
          },
          {
            name: "PAULDING",
            disabled: false,
          },
          {
            name: "PAULS VALLEY",
            disabled: false,
          },
          {
            name: "PAULSBORO",
            disabled: false,
          },
          {
            name: "PAW PAW",
            disabled: false,
          },
          {
            name: "PAWCATUCK",
            disabled: false,
          },
          {
            name: "PAWLEYS ISLAND",
            disabled: false,
          },
          {
            name: "PAWLING",
            disabled: false,
          },
          {
            name: "PAWTUCKET",
            disabled: false,
          },
          {
            name: "PAYETTE",
            disabled: false,
          },
          {
            name: "PAYSON",
            disabled: false,
          },
          {
            name: "PEA RIDGE",
            disabled: false,
          },
          {
            name: "PEABODY",
            disabled: false,
          },
          {
            name: "PEACHTREE CITY",
            disabled: false,
          },
          {
            name: "PEACHTREE CORNERS",
            disabled: false,
          },
          {
            name: "PEARISBURG",
            disabled: false,
          },
          {
            name: "PEARL",
            disabled: false,
          },
          {
            name: "PEARL CITY",
            disabled: false,
          },
          {
            name: "PEARL RIVER",
            disabled: false,
          },
          {
            name: "PEARLAND",
            disabled: false,
          },
          {
            name: "PEARSALL",
            disabled: false,
          },
          {
            name: "PECOS",
            disabled: false,
          },
          {
            name: "PEEKSKILL",
            disabled: false,
          },
          {
            name: "PEKIN",
            disabled: false,
          },
          {
            name: "PELHAM",
            disabled: false,
          },
          {
            name: "PELHAM MANOR",
            disabled: false,
          },
          {
            name: "PELL CITY",
            disabled: false,
          },
          {
            name: "PELLA",
            disabled: false,
          },
          {
            name: "PELZER",
            disabled: false,
          },
          {
            name: "PEMBROKE",
            disabled: false,
          },
          {
            name: "PEMBROKE PINES",
            disabled: false,
          },
          {
            name: "PENDERGRASS",
            disabled: false,
          },
          {
            name: "PENDLETON",
            disabled: false,
          },
          {
            name: "PENFIELD",
            disabled: false,
          },
          {
            name: "PENITAS",
            disabled: false,
          },
          {
            name: "PENN VALLEY",
            disabled: false,
          },
          {
            name: "PENN YAN",
            disabled: false,
          },
          {
            name: "PENNINGTON",
            disabled: false,
          },
          {
            name: "PENNINGTON GAP",
            disabled: false,
          },
          {
            name: "PENNS GROVE",
            disabled: false,
          },
          {
            name: "PENNSAUKEN",
            disabled: false,
          },
          {
            name: "PENNSBURG",
            disabled: false,
          },
          {
            name: "PENNSVILLE",
            disabled: false,
          },
          {
            name: "PENSACOLA",
            disabled: false,
          },
          {
            name: "PEORIA",
            disabled: false,
          },
          {
            name: "PEORIA HEIGHTS",
            disabled: false,
          },
          {
            name: "PEOTONE",
            disabled: false,
          },
          {
            name: "PEPPERELL",
            disabled: false,
          },
          {
            name: "PEQUANNOCK",
            disabled: false,
          },
          {
            name: "PERKASIE",
            disabled: false,
          },
          {
            name: "PERRIS",
            disabled: false,
          },
          {
            name: "PERRY",
            disabled: false,
          },
          {
            name: "PERRY HALL",
            disabled: false,
          },
          {
            name: "PERRYSBURG",
            disabled: false,
          },
          {
            name: "PERRYVILLE",
            disabled: false,
          },
          {
            name: "PERTH AMBOY",
            disabled: false,
          },
          {
            name: "PERU",
            disabled: false,
          },
          {
            name: "PETAL",
            disabled: false,
          },
          {
            name: "PETALUMA",
            disabled: false,
          },
          {
            name: "PETERBOROUGH",
            disabled: false,
          },
          {
            name: "PETERSBURG",
            disabled: false,
          },
          {
            name: "PETOSKEY",
            disabled: false,
          },
          {
            name: "PEWAUKEE",
            disabled: false,
          },
          {
            name: "PFAFFTOWN",
            disabled: false,
          },
          {
            name: "PFLUGERVILLE",
            disabled: false,
          },
          {
            name: "PHARR",
            disabled: false,
          },
          {
            name: "PHELAN",
            disabled: false,
          },
          {
            name: "PHENIX CITY",
            disabled: false,
          },
          {
            name: "PHILADELPHIA",
            disabled: false,
          },
          {
            name: "PHILIPSBURG",
            disabled: false,
          },
          {
            name: "PHILLIPS",
            disabled: false,
          },
          {
            name: "PHILLIPSBURG",
            disabled: false,
          },
          {
            name: "PHOENIX",
            disabled: false,
          },
          {
            name: "PHOENIXVILLE",
            disabled: false,
          },
          {
            name: "PICAYUNE",
            disabled: false,
          },
          {
            name: "PICKENS",
            disabled: false,
          },
          {
            name: "PICKERINGTON",
            disabled: false,
          },
          {
            name: "PICO RIVERA",
            disabled: false,
          },
          {
            name: "PIEDMONT",
            disabled: false,
          },
          {
            name: "PIERRE",
            disabled: false,
          },
          {
            name: "PIGEON FORGE",
            disabled: false,
          },
          {
            name: "PIKESVILLE",
            disabled: false,
          },
          {
            name: "PIKEVILLE",
            disabled: false,
          },
          {
            name: "PILESGROVE",
            disabled: false,
          },
          {
            name: "PILOT MOUNTAIN",
            disabled: false,
          },
          {
            name: "PINCKNEY",
            disabled: false,
          },
          {
            name: "PINE BLUFF",
            disabled: false,
          },
          {
            name: "PINE BUSH",
            disabled: false,
          },
          {
            name: "PINE CITY",
            disabled: false,
          },
          {
            name: "PINECREST",
            disabled: false,
          },
          {
            name: "PINEHURST",
            disabled: false,
          },
          {
            name: "PINELLAS PARK",
            disabled: false,
          },
          {
            name: "PINEVILLE",
            disabled: false,
          },
          {
            name: "PINEY FLATS",
            disabled: false,
          },
          {
            name: "PINK HILL",
            disabled: false,
          },
          {
            name: "PINOLE",
            disabled: false,
          },
          {
            name: "PINSON",
            disabled: false,
          },
          {
            name: "PIPERSVILLE",
            disabled: false,
          },
          {
            name: "PIQUA",
            disabled: false,
          },
          {
            name: "PISCATAWAY",
            disabled: false,
          },
          {
            name: "PISGAH FOREST",
            disabled: false,
          },
          {
            name: "PISMO BEACH",
            disabled: false,
          },
          {
            name: "PITTSBORO",
            disabled: false,
          },
          {
            name: "PITTSBURG",
            disabled: false,
          },
          {
            name: "PITTSBURGH",
            disabled: false,
          },
          {
            name: "PITTSFIELD",
            disabled: false,
          },
          {
            name: "PITTSTON",
            disabled: false,
          },
          {
            name: "PLACENTIA",
            disabled: false,
          },
          {
            name: "PLACERVILLE",
            disabled: false,
          },
          {
            name: "PLAIN CITY",
            disabled: false,
          },
          {
            name: "PLAINFIELD",
            disabled: false,
          },
          {
            name: "PLAINS",
            disabled: false,
          },
          {
            name: "PLAINSBORO",
            disabled: false,
          },
          {
            name: "PLAINVIEW",
            disabled: false,
          },
          {
            name: "PLAINVILLE",
            disabled: false,
          },
          {
            name: "PLAINWELL",
            disabled: false,
          },
          {
            name: "PLAISTOW",
            disabled: false,
          },
          {
            name: "PLANO",
            disabled: false,
          },
          {
            name: "PLANT CITY",
            disabled: false,
          },
          {
            name: "PLANTATION",
            disabled: false,
          },
          {
            name: "PLAQUEMINE",
            disabled: false,
          },
          {
            name: "PLATTE CITY",
            disabled: false,
          },
          {
            name: "PLATTEVILLE",
            disabled: false,
          },
          {
            name: "PLATTSBURGH",
            disabled: false,
          },
          {
            name: "PLEASANT GROVE",
            disabled: false,
          },
          {
            name: "PLEASANT HILL",
            disabled: false,
          },
          {
            name: "PLEASANT PRAIRI",
            disabled: false,
          },
          {
            name: "PLEASANT PRAIRIE",
            disabled: false,
          },
          {
            name: "PLEASANT VALLEY",
            disabled: false,
          },
          {
            name: "PLEASANTON",
            disabled: false,
          },
          {
            name: "PLEASANTVILLE",
            disabled: false,
          },
          {
            name: "PLOVER",
            disabled: false,
          },
          {
            name: "PLUMSTEADVILLE",
            disabled: false,
          },
          {
            name: "PLYMOUTH",
            disabled: false,
          },
          {
            name: "PLYMOUTH MEETING",
            disabled: false,
          },
          {
            name: "POCAHONTAS",
            disabled: false,
          },
          {
            name: "POCATELLO",
            disabled: false,
          },
          {
            name: "POCOMOKE CITY",
            disabled: false,
          },
          {
            name: "POINT PLEASANT",
            disabled: false,
          },
          {
            name: "POINT PLEASANT BEACH",
            disabled: false,
          },
          {
            name: "POLAND",
            disabled: false,
          },
          {
            name: "POLLOCK PINES",
            disabled: false,
          },
          {
            name: "POLSON",
            disabled: false,
          },
          {
            name: "POMEROY",
            disabled: false,
          },
          {
            name: "POMONA",
            disabled: false,
          },
          {
            name: "POMPANO BEACH",
            disabled: false,
          },
          {
            name: "PONCA CITY",
            disabled: false,
          },
          {
            name: "PONCE",
            disabled: false,
          },
          {
            name: "PONCHATOULA",
            disabled: false,
          },
          {
            name: "PONDERAY",
            disabled: false,
          },
          {
            name: "PONTE VEDRA",
            disabled: false,
          },
          {
            name: "PONTIAC",
            disabled: false,
          },
          {
            name: "PONTOTOC",
            disabled: false,
          },
          {
            name: "POOLER",
            disabled: false,
          },
          {
            name: "POOLESVILLE",
            disabled: false,
          },
          {
            name: "POPLAR BLUFF",
            disabled: false,
          },
          {
            name: "POQUOSON",
            disabled: false,
          },
          {
            name: "PORT ALLEGANY",
            disabled: false,
          },
          {
            name: "PORT ALLEN",
            disabled: false,
          },
          {
            name: "PORT ANGELES",
            disabled: false,
          },
          {
            name: "PORT ARTHUR",
            disabled: false,
          },
          {
            name: "PORT CHARLOTTE",
            disabled: false,
          },
          {
            name: "PORT CHESTER",
            disabled: false,
          },
          {
            name: "PORT CLINTON",
            disabled: false,
          },
          {
            name: "PORT HADLOCK",
            disabled: false,
          },
          {
            name: "PORT HUENEME",
            disabled: false,
          },
          {
            name: "PORT HURON",
            disabled: false,
          },
          {
            name: "PORT ISABEL",
            disabled: false,
          },
          {
            name: "PORT JEFFERSON",
            disabled: false,
          },
          {
            name: "PORT JERVIS",
            disabled: false,
          },
          {
            name: "PORT LAVACA",
            disabled: false,
          },
          {
            name: "PORT MONMOUTH",
            disabled: false,
          },
          {
            name: "PORT NECHES",
            disabled: false,
          },
          {
            name: "PORT ORANGE",
            disabled: false,
          },
          {
            name: "PORT ORCHARD",
            disabled: false,
          },
          {
            name: "PORT RICHEY",
            disabled: false,
          },
          {
            name: "PORT ROYAL",
            disabled: false,
          },
          {
            name: "PORT SAINT JOE",
            disabled: false,
          },
          {
            name: "PORT SAINT LUCIE",
            disabled: false,
          },
          {
            name: "PORT ST LUCIE",
            disabled: false,
          },
          {
            name: "PORT TOWNSEND",
            disabled: false,
          },
          {
            name: "PORT WASHINGTON",
            disabled: false,
          },
          {
            name: "PORT WENTWORTH",
            disabled: false,
          },
          {
            name: "PORTAGE",
            disabled: false,
          },
          {
            name: "PORTALES",
            disabled: false,
          },
          {
            name: "PORTER",
            disabled: false,
          },
          {
            name: "PORTER RANCH",
            disabled: false,
          },
          {
            name: "PORTERVILLE",
            disabled: false,
          },
          {
            name: "PORTLAND",
            disabled: false,
          },
          {
            name: "PORTSMOUTH",
            disabled: false,
          },
          {
            name: "POSEN",
            disabled: false,
          },
          {
            name: "POST",
            disabled: false,
          },
          {
            name: "POST FALLS",
            disabled: false,
          },
          {
            name: "POTEAU",
            disabled: false,
          },
          {
            name: "POTOMAC",
            disabled: false,
          },
          {
            name: "POTOSI",
            disabled: false,
          },
          {
            name: "POTSDAM",
            disabled: false,
          },
          {
            name: "POTTSTOWN",
            disabled: false,
          },
          {
            name: "POTTSVILLE",
            disabled: false,
          },
          {
            name: "POUGHKEEPSIE",
            disabled: false,
          },
          {
            name: "POULSBO",
            disabled: false,
          },
          {
            name: "POULTNEY",
            disabled: false,
          },
          {
            name: "POUNDING MILL",
            disabled: false,
          },
          {
            name: "POWAY",
            disabled: false,
          },
          {
            name: "POWDER SPRINGS",
            disabled: false,
          },
          {
            name: "POWDERLY",
            disabled: false,
          },
          {
            name: "POWELL",
            disabled: false,
          },
          {
            name: "POWHATAN",
            disabled: false,
          },
          {
            name: "PRAIRIE DU CHIEN",
            disabled: false,
          },
          {
            name: "PRAIRIE VILLAGE",
            disabled: false,
          },
          {
            name: "PRAIRIEVILLE",
            disabled: false,
          },
          {
            name: "PRATHER",
            disabled: false,
          },
          {
            name: "PRATT",
            disabled: false,
          },
          {
            name: "PRATTVILLE",
            disabled: false,
          },
          {
            name: "PRESCOTT",
            disabled: false,
          },
          {
            name: "PRESCOTT VALLEY",
            disabled: false,
          },
          {
            name: "PRESQUE ISLE",
            disabled: false,
          },
          {
            name: "PRESTONSBURG",
            disabled: false,
          },
          {
            name: "PRICE",
            disabled: false,
          },
          {
            name: "PRICHARD",
            disabled: false,
          },
          {
            name: "PRINCE FREDERICK",
            disabled: false,
          },
          {
            name: "PRINCE GEORGE",
            disabled: false,
          },
          {
            name: "PRINCESS ANNE",
            disabled: false,
          },
          {
            name: "PRINCETON",
            disabled: false,
          },
          {
            name: "PRINCETON JUNCTION",
            disabled: false,
          },
          {
            name: "PRINEVILLE",
            disabled: false,
          },
          {
            name: "PROCTORVILLE",
            disabled: false,
          },
          {
            name: "PROSPECT",
            disabled: false,
          },
          {
            name: "PROSPECT HEIGHTS",
            disabled: false,
          },
          {
            name: "PROSPECT PARK",
            disabled: false,
          },
          {
            name: "PROSPER",
            disabled: false,
          },
          {
            name: "PROVIDENCE",
            disabled: false,
          },
          {
            name: "PROVIDENCE FORGE",
            disabled: false,
          },
          {
            name: "PROVO",
            disabled: false,
          },
          {
            name: "PRUDENVILLE",
            disabled: false,
          },
          {
            name: "PRUNEDALE",
            disabled: false,
          },
          {
            name: "PRYOR",
            disabled: false,
          },
          {
            name: "PUEBLO",
            disabled: false,
          },
          {
            name: "PUEBLO WEST",
            disabled: false,
          },
          {
            name: "PUKALANI",
            disabled: false,
          },
          {
            name: "PULASKI",
            disabled: false,
          },
          {
            name: "PULLMAN",
            disabled: false,
          },
          {
            name: "PUNTA GORDA",
            disabled: false,
          },
          {
            name: "PUNXSUTAWNEY",
            disabled: false,
          },
          {
            name: "PURCELL",
            disabled: false,
          },
          {
            name: "PURCELLVILLE",
            disabled: false,
          },
          {
            name: "PUTNAM",
            disabled: false,
          },
          {
            name: "PUYALLUP",
            disabled: false,
          },
          {
            name: "Pagosa Springs",
            disabled: false,
          },
          {
            name: "Palatine",
            disabled: false,
          },
          {
            name: "Palm Springs",
            disabled: false,
          },
          {
            name: "Palmdale",
            disabled: false,
          },
          {
            name: "Palmer",
            disabled: false,
          },
          {
            name: "Paris",
            disabled: false,
          },
          {
            name: "Park Ridge",
            disabled: false,
          },
          {
            name: "Parsippany",
            disabled: false,
          },
          {
            name: "Pataskala",
            disabled: false,
          },
          {
            name: "Peoria",
            disabled: false,
          },
          {
            name: "Perrysburg",
            disabled: false,
          },
          {
            name: "Petersburg",
            disabled: false,
          },
          {
            name: "Pewaukee",
            disabled: false,
          },
          {
            name: "Philadelphia",
            disabled: false,
          },
          {
            name: "Phoenix",
            disabled: false,
          },
          {
            name: "Pico Rivera",
            disabled: false,
          },
          {
            name: "Pittsburg",
            disabled: false,
          },
          {
            name: "Pittsburgh",
            disabled: false,
          },
          {
            name: "Plain City",
            disabled: false,
          },
          {
            name: "Plano",
            disabled: false,
          },
          {
            name: "Pleasant Prairie",
            disabled: false,
          },
          {
            name: "Plover",
            disabled: false,
          },
          {
            name: "Pocatello",
            disabled: false,
          },
          {
            name: "Port Chester",
            disabled: false,
          },
          {
            name: "Port Orchard",
            disabled: false,
          },
          {
            name: "Port Saint Lucie",
            disabled: false,
          },
          {
            name: "Port Townsend",
            disabled: false,
          },
          {
            name: "Porter",
            disabled: false,
          },
          {
            name: "Portland",
            disabled: false,
          },
          {
            name: "Portsmouth",
            disabled: false,
          },
          {
            name: "Post Falls",
            disabled: false,
          },
          {
            name: "Pottstown",
            disabled: false,
          },
          {
            name: "Poughkeepsie",
            disabled: false,
          },
          {
            name: "Princeton",
            disabled: false,
          },
          {
            name: "Prosper",
            disabled: false,
          },
          {
            name: "Provo",
            disabled: false,
          },
          {
            name: "QUAKERTOWN",
            disabled: false,
          },
          {
            name: "QUARRYVILLE",
            disabled: false,
          },
          {
            name: "QUEEN CREEK",
            disabled: false,
          },
          {
            name: "QUEENSBURY",
            disabled: false,
          },
          {
            name: "QUINCY",
            disabled: false,
          },
          {
            name: "QUINLAN",
            disabled: false,
          },
          {
            name: "QUINTON",
            disabled: false,
          },
          {
            name: "QUITMAN",
            disabled: false,
          },
          {
            name: "Queen Creek",
            disabled: false,
          },
          {
            name: "Quincy",
            disabled: false,
          },
          {
            name: "RACELAND",
            disabled: false,
          },
          {
            name: "RACINE",
            disabled: false,
          },
          {
            name: "RADCLIFF",
            disabled: false,
          },
          {
            name: "RADFORD",
            disabled: false,
          },
          {
            name: "RAEFORD",
            disabled: false,
          },
          {
            name: "RAHWAY",
            disabled: false,
          },
          {
            name: "RAINBOW CITY",
            disabled: false,
          },
          {
            name: "RAINELLE",
            disabled: false,
          },
          {
            name: "RALEIGH",
            disabled: false,
          },
          {
            name: "RAMONA",
            disabled: false,
          },
          {
            name: "RAMSEUR",
            disabled: false,
          },
          {
            name: "RAMSEY",
            disabled: false,
          },
          {
            name: "RANCHO CORDOVA",
            disabled: false,
          },
          {
            name: "RANCHO CUCAMONG",
            disabled: false,
          },
          {
            name: "RANCHO CUCAMONGA",
            disabled: false,
          },
          {
            name: "RANCHO MIRAGE",
            disabled: false,
          },
          {
            name: "RANCHO PALOS VERDES",
            disabled: false,
          },
          {
            name: "RANCHO SANTA MARGAR",
            disabled: false,
          },
          {
            name: "RANCHO SANTA MARGARITA",
            disabled: false,
          },
          {
            name: "RANDALLSTOWN",
            disabled: false,
          },
          {
            name: "RANDLEMAN",
            disabled: false,
          },
          {
            name: "RANDOLPH",
            disabled: false,
          },
          {
            name: "RANSOMVILLE",
            disabled: false,
          },
          {
            name: "RANSON",
            disabled: false,
          },
          {
            name: "RANTOUL",
            disabled: false,
          },
          {
            name: "RAPID CITY",
            disabled: false,
          },
          {
            name: "RAVENA",
            disabled: false,
          },
          {
            name: "RAVENEL",
            disabled: false,
          },
          {
            name: "RAVENNA",
            disabled: false,
          },
          {
            name: "RAVENSWOOD",
            disabled: false,
          },
          {
            name: "RAWLINS",
            disabled: false,
          },
          {
            name: "RAYMOND",
            disabled: false,
          },
          {
            name: "RAYMONDVILLE",
            disabled: false,
          },
          {
            name: "RAYMORE",
            disabled: false,
          },
          {
            name: "RAYNE",
            disabled: false,
          },
          {
            name: "RAYNHAM",
            disabled: false,
          },
          {
            name: "RAYTOWN",
            disabled: false,
          },
          {
            name: "RAYVILLE",
            disabled: false,
          },
          {
            name: "READING",
            disabled: false,
          },
          {
            name: "RED BANK",
            disabled: false,
          },
          {
            name: "RED BLUFF",
            disabled: false,
          },
          {
            name: "RED HOOK",
            disabled: false,
          },
          {
            name: "RED LION",
            disabled: false,
          },
          {
            name: "RED OAK",
            disabled: false,
          },
          {
            name: "RED SPRINGS",
            disabled: false,
          },
          {
            name: "RED WING",
            disabled: false,
          },
          {
            name: "REDDING",
            disabled: false,
          },
          {
            name: "REDFORD",
            disabled: false,
          },
          {
            name: "REDLANDS",
            disabled: false,
          },
          {
            name: "REDMOND",
            disabled: false,
          },
          {
            name: "REDONDO BEACH",
            disabled: false,
          },
          {
            name: "REDWOOD CITY",
            disabled: false,
          },
          {
            name: "REDWOOD FALLS",
            disabled: false,
          },
          {
            name: "REED CITY",
            disabled: false,
          },
          {
            name: "REEDLEY",
            disabled: false,
          },
          {
            name: "REEDSBURG",
            disabled: false,
          },
          {
            name: "REEDSPORT",
            disabled: false,
          },
          {
            name: "REGO PARK",
            disabled: false,
          },
          {
            name: "REHOBOTH BEACH",
            disabled: false,
          },
          {
            name: "REIDSVILLE",
            disabled: false,
          },
          {
            name: "REISTERSTOWN",
            disabled: false,
          },
          {
            name: "RENO",
            disabled: false,
          },
          {
            name: "RENSSELAER",
            disabled: false,
          },
          {
            name: "RENTON",
            disabled: false,
          },
          {
            name: "REPUBLIC",
            disabled: false,
          },
          {
            name: "RESEDA",
            disabled: false,
          },
          {
            name: "RESTON",
            disabled: false,
          },
          {
            name: "REVERE",
            disabled: false,
          },
          {
            name: "REXBURG",
            disabled: false,
          },
          {
            name: "REYNOLDSBURG",
            disabled: false,
          },
          {
            name: "RHINEBECK",
            disabled: false,
          },
          {
            name: "RHINELANDER",
            disabled: false,
          },
          {
            name: "RIALTO",
            disabled: false,
          },
          {
            name: "RICE LAKE",
            disabled: false,
          },
          {
            name: "RICES LANDING",
            disabled: false,
          },
          {
            name: "RICH CREEK",
            disabled: false,
          },
          {
            name: "RICHARDSON",
            disabled: false,
          },
          {
            name: "RICHBORO",
            disabled: false,
          },
          {
            name: "RICHEYVILLE",
            disabled: false,
          },
          {
            name: "RICHFIELD",
            disabled: false,
          },
          {
            name: "RICHLAND",
            disabled: false,
          },
          {
            name: "RICHLAND CENTER",
            disabled: false,
          },
          {
            name: "RICHLAND HILLS",
            disabled: false,
          },
          {
            name: "RICHLANDS",
            disabled: false,
          },
          {
            name: "RICHMOND",
            disabled: false,
          },
          {
            name: "RICHMOND HEIGHTS",
            disabled: false,
          },
          {
            name: "RICHMOND HILL",
            disabled: false,
          },
          {
            name: "RICHTON PARK",
            disabled: false,
          },
          {
            name: "RICHWOOD",
            disabled: false,
          },
          {
            name: "RIDGECREST",
            disabled: false,
          },
          {
            name: "RIDGEFIELD",
            disabled: false,
          },
          {
            name: "RIDGELAND",
            disabled: false,
          },
          {
            name: "RIDGEWOOD",
            disabled: false,
          },
          {
            name: "RIDGWAY",
            disabled: false,
          },
          {
            name: "RIFLE",
            disabled: false,
          },
          {
            name: "RINCON",
            disabled: false,
          },
          {
            name: "RINDGE",
            disabled: false,
          },
          {
            name: "RINGGOLD",
            disabled: false,
          },
          {
            name: "RINGWOOD",
            disabled: false,
          },
          {
            name: "RIO GRANDE",
            disabled: false,
          },
          {
            name: "RIO GRANDE CITY",
            disabled: false,
          },
          {
            name: "RIO RANCHO",
            disabled: false,
          },
          {
            name: "RIPLEY",
            disabled: false,
          },
          {
            name: "RIPON",
            disabled: false,
          },
          {
            name: "RITTMAN",
            disabled: false,
          },
          {
            name: "RIVER FALLS",
            disabled: false,
          },
          {
            name: "RIVER FOREST",
            disabled: false,
          },
          {
            name: "RIVER GROVE",
            disabled: false,
          },
          {
            name: "RIVER OAKS",
            disabled: false,
          },
          {
            name: "RIVER RIDGE",
            disabled: false,
          },
          {
            name: "RIVER VALE",
            disabled: false,
          },
          {
            name: "RIVERBANK",
            disabled: false,
          },
          {
            name: "RIVERDALE",
            disabled: false,
          },
          {
            name: "RIVERHEAD",
            disabled: false,
          },
          {
            name: "RIVERSIDE",
            disabled: false,
          },
          {
            name: "RIVERTON",
            disabled: false,
          },
          {
            name: "RIVERVIEW",
            disabled: false,
          },
          {
            name: "RIVIERA BEACH",
            disabled: false,
          },
          {
            name: "ROANOKE",
            disabled: false,
          },
          {
            name: "ROANOKE RAPIDS",
            disabled: false,
          },
          {
            name: "ROARING SPRING",
            disabled: false,
          },
          {
            name: "ROBBINSDALE",
            disabled: false,
          },
          {
            name: "ROBBINSVILLE",
            disabled: false,
          },
          {
            name: "ROBERSONVILLE",
            disabled: false,
          },
          {
            name: "ROBERTSDALE",
            disabled: false,
          },
          {
            name: "ROBINSON",
            disabled: false,
          },
          {
            name: "ROBSTOWN",
            disabled: false,
          },
          {
            name: "ROCHELLE",
            disabled: false,
          },
          {
            name: "ROCHELLE PARK",
            disabled: false,
          },
          {
            name: "ROCHESTER",
            disabled: false,
          },
          {
            name: "ROCHESTER HILLS",
            disabled: false,
          },
          {
            name: "ROCK FALLS",
            disabled: false,
          },
          {
            name: "ROCK HILL",
            disabled: false,
          },
          {
            name: "ROCK ISLAND",
            disabled: false,
          },
          {
            name: "ROCK SPRINGS",
            disabled: false,
          },
          {
            name: "ROCKAWAY",
            disabled: false,
          },
          {
            name: "ROCKAWAY PARK",
            disabled: false,
          },
          {
            name: "ROCKDALE",
            disabled: false,
          },
          {
            name: "ROCKFORD",
            disabled: false,
          },
          {
            name: "ROCKINGHAM",
            disabled: false,
          },
          {
            name: "ROCKLAND",
            disabled: false,
          },
          {
            name: "ROCKLEDGE",
            disabled: false,
          },
          {
            name: "ROCKLIN",
            disabled: false,
          },
          {
            name: "ROCKMART",
            disabled: false,
          },
          {
            name: "ROCKPORT",
            disabled: false,
          },
          {
            name: "ROCKVILLE",
            disabled: false,
          },
          {
            name: "ROCKVILLE CENTRE",
            disabled: false,
          },
          {
            name: "ROCKWALL",
            disabled: false,
          },
          {
            name: "ROCKWELL",
            disabled: false,
          },
          {
            name: "ROCKWOOD",
            disabled: false,
          },
          {
            name: "ROCKY FACE",
            disabled: false,
          },
          {
            name: "ROCKY HILL",
            disabled: false,
          },
          {
            name: "ROCKY MOUNT",
            disabled: false,
          },
          {
            name: "ROCKY POINT",
            disabled: false,
          },
          {
            name: "ROCKY RIVER",
            disabled: false,
          },
          {
            name: "ROEBUCK",
            disabled: false,
          },
          {
            name: "ROELAND PARK",
            disabled: false,
          },
          {
            name: "ROGERS",
            disabled: false,
          },
          {
            name: "ROGERSVILLE",
            disabled: false,
          },
          {
            name: "ROHNERT PARK",
            disabled: false,
          },
          {
            name: "ROLESVILLE",
            disabled: false,
          },
          {
            name: "ROLLA",
            disabled: false,
          },
          {
            name: "ROLLING HILLS ESTATES",
            disabled: false,
          },
          {
            name: "ROLLING MEADOWS",
            disabled: false,
          },
          {
            name: "ROME",
            disabled: false,
          },
          {
            name: "ROMEO",
            disabled: false,
          },
          {
            name: "ROMEOVILLE",
            disabled: false,
          },
          {
            name: "ROMNEY",
            disabled: false,
          },
          {
            name: "RONCEVERTE",
            disabled: false,
          },
          {
            name: "RONKONKOMA",
            disabled: false,
          },
          {
            name: "ROOTSTOWN",
            disabled: false,
          },
          {
            name: "ROSAMOND",
            disabled: false,
          },
          {
            name: "ROSCOE",
            disabled: false,
          },
          {
            name: "ROSCOMMON",
            disabled: false,
          },
          {
            name: "ROSEBORO",
            disabled: false,
          },
          {
            name: "ROSEBURG",
            disabled: false,
          },
          {
            name: "ROSEDALE",
            disabled: false,
          },
          {
            name: "ROSELAND",
            disabled: false,
          },
          {
            name: "ROSELLE",
            disabled: false,
          },
          {
            name: "ROSEMEAD",
            disabled: false,
          },
          {
            name: "ROSEMONT",
            disabled: false,
          },
          {
            name: "ROSEMOUNT",
            disabled: false,
          },
          {
            name: "ROSENBERG",
            disabled: false,
          },
          {
            name: "ROSEVILLE",
            disabled: false,
          },
          {
            name: "ROSHARON",
            disabled: false,
          },
          {
            name: "ROSLINDALE",
            disabled: false,
          },
          {
            name: "ROSLYN HEIGHTS",
            disabled: false,
          },
          {
            name: "ROSSFORD",
            disabled: false,
          },
          {
            name: "ROSSVILLE",
            disabled: false,
          },
          {
            name: "ROSWELL",
            disabled: false,
          },
          {
            name: "ROTTERDAM",
            disabled: false,
          },
          {
            name: "ROUND LAKE",
            disabled: false,
          },
          {
            name: "ROUND LAKE BEACH",
            disabled: false,
          },
          {
            name: "ROUND ROCK",
            disabled: false,
          },
          {
            name: "ROWLAND HEIGHTS",
            disabled: false,
          },
          {
            name: "ROWLETT",
            disabled: false,
          },
          {
            name: "ROWLEY",
            disabled: false,
          },
          {
            name: "ROXBORO",
            disabled: false,
          },
          {
            name: "ROXBURY",
            disabled: false,
          },
          {
            name: "ROXBURY CROSSING",
            disabled: false,
          },
          {
            name: "ROY",
            disabled: false,
          },
          {
            name: "ROYAL OAK",
            disabled: false,
          },
          {
            name: "ROYAL PALM BEAC",
            disabled: false,
          },
          {
            name: "ROYAL PALM BEACH",
            disabled: false,
          },
          {
            name: "ROYERSFORD",
            disabled: false,
          },
          {
            name: "ROYSE CITY",
            disabled: false,
          },
          {
            name: "ROYSTON",
            disabled: false,
          },
          {
            name: "RUCKERSVILLE",
            disabled: false,
          },
          {
            name: "RUIDOSO",
            disabled: false,
          },
          {
            name: "RUIDOSO DOWNS",
            disabled: false,
          },
          {
            name: "RUMFORD",
            disabled: false,
          },
          {
            name: "RUNNEMEDE",
            disabled: false,
          },
          {
            name: "RURAL HALL",
            disabled: false,
          },
          {
            name: "RUSHVILLE",
            disabled: false,
          },
          {
            name: "RUSSELL SPRINGS",
            disabled: false,
          },
          {
            name: "RUSSELLS POINT",
            disabled: false,
          },
          {
            name: "RUSSELLVILLE",
            disabled: false,
          },
          {
            name: "RUSTBURG",
            disabled: false,
          },
          {
            name: "RUSTON",
            disabled: false,
          },
          {
            name: "RUTHER GLEN",
            disabled: false,
          },
          {
            name: "RUTHERFORD",
            disabled: false,
          },
          {
            name: "RUTHERFORD COLLEGE",
            disabled: false,
          },
          {
            name: "RUTHERFORDTON",
            disabled: false,
          },
          {
            name: "RUTLAND",
            disabled: false,
          },
          {
            name: "RYE",
            disabled: false,
          },
          {
            name: "RYE BROOK",
            disabled: false,
          },
          {
            name: "Racine",
            disabled: false,
          },
          {
            name: "Raleigh",
            disabled: false,
          },
          {
            name: "Rancho Santa Margari",
            disabled: false,
          },
          {
            name: "Rawlins",
            disabled: false,
          },
          {
            name: "Redford",
            disabled: false,
          },
          {
            name: "Redmond",
            disabled: false,
          },
          {
            name: "Redwood City",
            disabled: false,
          },
          {
            name: "Renton",
            disabled: false,
          },
          {
            name: "Reseda",
            disabled: false,
          },
          {
            name: "Reynoldsburg",
            disabled: false,
          },
          {
            name: "Rialto",
            disabled: false,
          },
          {
            name: "Richmond",
            disabled: false,
          },
          {
            name: "Ridgeland",
            disabled: false,
          },
          {
            name: "Rifle",
            disabled: false,
          },
          {
            name: "Rincon",
            disabled: false,
          },
          {
            name: "Riverside",
            disabled: false,
          },
          {
            name: "Roanoke",
            disabled: false,
          },
          {
            name: "Robinson",
            disabled: false,
          },
          {
            name: "Rockledge",
            disabled: false,
          },
          {
            name: "Rockwall",
            disabled: false,
          },
          {
            name: "Romulus",
            disabled: false,
          },
          {
            name: "Roseville",
            disabled: false,
          },
          {
            name: "Roslindale",
            disabled: false,
          },
          {
            name: "Rosslyn",
            disabled: false,
          },
          {
            name: "Royal Oak",
            disabled: false,
          },
          {
            name: "Russellville",
            disabled: false,
          },
          {
            name: "SACHSE",
            disabled: false,
          },
          {
            name: "SACO",
            disabled: false,
          },
          {
            name: "SACRAMENTO",
            disabled: false,
          },
          {
            name: "SADDLE BROOK",
            disabled: false,
          },
          {
            name: "SAFFORD",
            disabled: false,
          },
          {
            name: "SAGINAW",
            disabled: false,
          },
          {
            name: "SAHUARITA",
            disabled: false,
          },
          {
            name: "SAINT ALBANS",
            disabled: false,
          },
          {
            name: "SAINT ANN",
            disabled: false,
          },
          {
            name: "SAINT ANTHONY",
            disabled: false,
          },
          {
            name: "SAINT AUGUSTINE",
            disabled: false,
          },
          {
            name: "SAINT CHARLES",
            disabled: false,
          },
          {
            name: "SAINT CLAIR",
            disabled: false,
          },
          {
            name: "SAINT CLAIR SHORES",
            disabled: false,
          },
          {
            name: "SAINT CLAIRSVILLE",
            disabled: false,
          },
          {
            name: "SAINT CLOUD",
            disabled: false,
          },
          {
            name: "SAINT CROIX FALLS",
            disabled: false,
          },
          {
            name: "SAINT GEORGE",
            disabled: false,
          },
          {
            name: "SAINT HELENA",
            disabled: false,
          },
          {
            name: "SAINT HELENS",
            disabled: false,
          },
          {
            name: "SAINT JAMES CITY",
            disabled: false,
          },
          {
            name: "SAINT JOHN",
            disabled: false,
          },
          {
            name: "SAINT JOHNS",
            disabled: false,
          },
          {
            name: "SAINT JOSEPH",
            disabled: false,
          },
          {
            name: "SAINT LOUIS",
            disabled: false,
          },
          {
            name: "SAINT LOUIS PAR",
            disabled: false,
          },
          {
            name: "SAINT MARYS",
            disabled: false,
          },
          {
            name: "SAINT MATTHEWS",
            disabled: false,
          },
          {
            name: "SAINT MICHAEL",
            disabled: false,
          },
          {
            name: "SAINT PAUL",
            disabled: false,
          },
          {
            name: "SAINT PAULS",
            disabled: false,
          },
          {
            name: "SAINT PETERS",
            disabled: false,
          },
          {
            name: "SAINT PETERSBURG",
            disabled: false,
          },
          {
            name: "SAINT ROBERT",
            disabled: false,
          },
          {
            name: "SAINT SIMONS ISLAND",
            disabled: false,
          },
          {
            name: "SALAMANCA",
            disabled: false,
          },
          {
            name: "SALEM",
            disabled: false,
          },
          {
            name: "SALIDA",
            disabled: false,
          },
          {
            name: "SALINA",
            disabled: false,
          },
          {
            name: "SALINAS",
            disabled: false,
          },
          {
            name: "SALINE",
            disabled: false,
          },
          {
            name: "SALISBURY",
            disabled: false,
          },
          {
            name: "SALLISAW",
            disabled: false,
          },
          {
            name: "SALT LAKE CITY",
            disabled: false,
          },
          {
            name: "SALUDA",
            disabled: false,
          },
          {
            name: "SALYERSVILLE",
            disabled: false,
          },
          {
            name: "SAMMAMISH",
            disabled: false,
          },
          {
            name: "SAN ANGELO",
            disabled: false,
          },
          {
            name: "SAN ANSELMO",
            disabled: false,
          },
          {
            name: "SAN ANTONIO",
            disabled: false,
          },
          {
            name: "SAN BENITO",
            disabled: false,
          },
          {
            name: "SAN BERNARDINO",
            disabled: false,
          },
          {
            name: "SAN BRUNO",
            disabled: false,
          },
          {
            name: "SAN CARLOS",
            disabled: false,
          },
          {
            name: "SAN CLEMENTE",
            disabled: false,
          },
          {
            name: "SAN DIEGO",
            disabled: false,
          },
          {
            name: "SAN DIMAS",
            disabled: false,
          },
          {
            name: "SAN FERNANDO",
            disabled: false,
          },
          {
            name: "SAN FRANCISCO",
            disabled: false,
          },
          {
            name: "SAN GABRIEL",
            disabled: false,
          },
          {
            name: "SAN JACINTO",
            disabled: false,
          },
          {
            name: "SAN JOSE",
            disabled: false,
          },
          {
            name: "SAN JUAN",
            disabled: false,
          },
          {
            name: "SAN JUAN CAPIST",
            disabled: false,
          },
          {
            name: "SAN JUAN CAPISTRANO",
            disabled: false,
          },
          {
            name: "SAN LEANDRO",
            disabled: false,
          },
          {
            name: "SAN LUIS",
            disabled: false,
          },
          {
            name: "SAN LUIS OBISPO",
            disabled: false,
          },
          {
            name: "SAN MARCOS",
            disabled: false,
          },
          {
            name: "SAN MATEO",
            disabled: false,
          },
          {
            name: "SAN PABLO",
            disabled: false,
          },
          {
            name: "SAN PEDRO",
            disabled: false,
          },
          {
            name: "SAN RAFAEL",
            disabled: false,
          },
          {
            name: "SAN RAMON",
            disabled: false,
          },
          {
            name: "SAN TAN VALLEY",
            disabled: false,
          },
          {
            name: "SAND CITY",
            disabled: false,
          },
          {
            name: "SAND SPRINGS",
            disabled: false,
          },
          {
            name: "SANDERSVILLE",
            disabled: false,
          },
          {
            name: "SANDPOINT",
            disabled: false,
          },
          {
            name: "SANDUSKY",
            disabled: false,
          },
          {
            name: "SANDWICH",
            disabled: false,
          },
          {
            name: "SANDY",
            disabled: false,
          },
          {
            name: "SANDY SPRINGS",
            disabled: false,
          },
          {
            name: "SANFORD",
            disabled: false,
          },
          {
            name: "SANGER",
            disabled: false,
          },
          {
            name: "SANTA ANA",
            disabled: false,
          },
          {
            name: "SANTA BARBARA",
            disabled: false,
          },
          {
            name: "SANTA CLARA",
            disabled: false,
          },
          {
            name: "SANTA CLARITA",
            disabled: false,
          },
          {
            name: "SANTA CRUZ",
            disabled: false,
          },
          {
            name: "SANTA FE",
            disabled: false,
          },
          {
            name: "SANTA FE SPRINGS",
            disabled: false,
          },
          {
            name: "SANTA ISABEL",
            disabled: false,
          },
          {
            name: "SANTA MARIA",
            disabled: false,
          },
          {
            name: "SANTA MONICA",
            disabled: false,
          },
          {
            name: "SANTA PAULA",
            disabled: false,
          },
          {
            name: "SANTA ROSA",
            disabled: false,
          },
          {
            name: "SANTA ROSA BEACH",
            disabled: false,
          },
          {
            name: "SANTEE",
            disabled: false,
          },
          {
            name: "SAPULPA",
            disabled: false,
          },
          {
            name: "SARALAND",
            disabled: false,
          },
          {
            name: "SARANAC LAKE",
            disabled: false,
          },
          {
            name: "SARASOTA",
            disabled: false,
          },
          {
            name: "SARATOGA",
            disabled: false,
          },
          {
            name: "SARATOGA SPRING",
            disabled: false,
          },
          {
            name: "SARATOGA SPRINGS",
            disabled: false,
          },
          {
            name: "SARTELL",
            disabled: false,
          },
          {
            name: "SARVER",
            disabled: false,
          },
          {
            name: "SATELLITE BEACH",
            disabled: false,
          },
          {
            name: "SAUGERTIES",
            disabled: false,
          },
          {
            name: "SAUGUS",
            disabled: false,
          },
          {
            name: "SAUK CENTRE",
            disabled: false,
          },
          {
            name: "SAUK CITY",
            disabled: false,
          },
          {
            name: "SAUK RAPIDS",
            disabled: false,
          },
          {
            name: "SAUK VILLAGE",
            disabled: false,
          },
          {
            name: "SAUKVILLE",
            disabled: false,
          },
          {
            name: "SAULT SAINTE MARIE",
            disabled: false,
          },
          {
            name: "SAUSALITO",
            disabled: false,
          },
          {
            name: "SAVAGE",
            disabled: false,
          },
          {
            name: "SAVANNAH",
            disabled: false,
          },
          {
            name: "SAVOY",
            disabled: false,
          },
          {
            name: "SAYRE",
            disabled: false,
          },
          {
            name: "SAYREVILLE",
            disabled: false,
          },
          {
            name: "SAYVILLE",
            disabled: false,
          },
          {
            name: "SCAPPOOSE",
            disabled: false,
          },
          {
            name: "SCARBOROUGH",
            disabled: false,
          },
          {
            name: "SCARSDALE",
            disabled: false,
          },
          {
            name: "SCHAGHTICOKE",
            disabled: false,
          },
          {
            name: "SCHAUMBURG",
            disabled: false,
          },
          {
            name: "SCHENECTADY",
            disabled: false,
          },
          {
            name: "SCHERERVILLE",
            disabled: false,
          },
          {
            name: "SCHERTZ",
            disabled: false,
          },
          {
            name: "SCHILLER PARK",
            disabled: false,
          },
          {
            name: "SCHNECKSVILLE",
            disabled: false,
          },
          {
            name: "SCHOFIELD",
            disabled: false,
          },
          {
            name: "SCHWENKSVILLE",
            disabled: false,
          },
          {
            name: "SCOTCH PLAINS",
            disabled: false,
          },
          {
            name: "SCOTIA",
            disabled: false,
          },
          {
            name: "SCOTLAND NECK",
            disabled: false,
          },
          {
            name: "SCOTT",
            disabled: false,
          },
          {
            name: "SCOTTS VALLEY",
            disabled: false,
          },
          {
            name: "SCOTTSBLUFF",
            disabled: false,
          },
          {
            name: "SCOTTSBORO",
            disabled: false,
          },
          {
            name: "SCOTTSBURG",
            disabled: false,
          },
          {
            name: "SCOTTSDALE",
            disabled: false,
          },
          {
            name: "SCOTTSVILLE",
            disabled: false,
          },
          {
            name: "SCRANTON",
            disabled: false,
          },
          {
            name: "SEA ISLE CITY",
            disabled: false,
          },
          {
            name: "SEABROOK",
            disabled: false,
          },
          {
            name: "SEAFORD",
            disabled: false,
          },
          {
            name: "SEAGOVILLE",
            disabled: false,
          },
          {
            name: "SEAL BEACH",
            disabled: false,
          },
          {
            name: "SEALY",
            disabled: false,
          },
          {
            name: "SEARCY",
            disabled: false,
          },
          {
            name: "SEASIDE",
            disabled: false,
          },
          {
            name: "SEAT PLEASANT",
            disabled: false,
          },
          {
            name: "SEATAC",
            disabled: false,
          },
          {
            name: "SEATTLE",
            disabled: false,
          },
          {
            name: "SEBASTIAN",
            disabled: false,
          },
          {
            name: "SEBASTOPOL",
            disabled: false,
          },
          {
            name: "SEBRING",
            disabled: false,
          },
          {
            name: "SECANE",
            disabled: false,
          },
          {
            name: "SECAUCUS",
            disabled: false,
          },
          {
            name: "SEDALIA",
            disabled: false,
          },
          {
            name: "SEDONA",
            disabled: false,
          },
          {
            name: "SEEKONK",
            disabled: false,
          },
          {
            name: "SEFFNER",
            disabled: false,
          },
          {
            name: "SEGUIN",
            disabled: false,
          },
          {
            name: "SELBYVILLE",
            disabled: false,
          },
          {
            name: "SELDEN",
            disabled: false,
          },
          {
            name: "SELINSGROVE",
            disabled: false,
          },
          {
            name: "SELLERSBURG",
            disabled: false,
          },
          {
            name: "SELMA",
            disabled: false,
          },
          {
            name: "SELMER",
            disabled: false,
          },
          {
            name: "SEMINOLE",
            disabled: false,
          },
          {
            name: "SEMMES",
            disabled: false,
          },
          {
            name: "SENATOBIA",
            disabled: false,
          },
          {
            name: "SENECA",
            disabled: false,
          },
          {
            name: "SEQUIM",
            disabled: false,
          },
          {
            name: "SETAUKET",
            disabled: false,
          },
          {
            name: "SEVEN FIELDS",
            disabled: false,
          },
          {
            name: "SEVEN HILLS",
            disabled: false,
          },
          {
            name: "SEVERN",
            disabled: false,
          },
          {
            name: "SEVERNA PARK",
            disabled: false,
          },
          {
            name: "SEVIERVILLE",
            disabled: false,
          },
          {
            name: "SEWARD",
            disabled: false,
          },
          {
            name: "SEWELL",
            disabled: false,
          },
          {
            name: "SEWICKLEY",
            disabled: false,
          },
          {
            name: "SEYMOUR",
            disabled: false,
          },
          {
            name: "SHAFTER",
            disabled: false,
          },
          {
            name: "SHAKER HEIGHTS",
            disabled: false,
          },
          {
            name: "SHAKOPEE",
            disabled: false,
          },
          {
            name: "SHALLOTTE",
            disabled: false,
          },
          {
            name: "SHAMOKIN",
            disabled: false,
          },
          {
            name: "SHARON",
            disabled: false,
          },
          {
            name: "SHARON HILL",
            disabled: false,
          },
          {
            name: "SHARONVILLE",
            disabled: false,
          },
          {
            name: "SHARPSBURG",
            disabled: false,
          },
          {
            name: "SHASTA LAKE",
            disabled: false,
          },
          {
            name: "SHAVANO PARK",
            disabled: false,
          },
          {
            name: "SHAVERTOWN",
            disabled: false,
          },
          {
            name: "SHAWANO",
            disabled: false,
          },
          {
            name: "SHAWNEE",
            disabled: false,
          },
          {
            name: "SHEBOYGAN",
            disabled: false,
          },
          {
            name: "SHEBOYGAN FALLS",
            disabled: false,
          },
          {
            name: "SHEFFIELD LAKE",
            disabled: false,
          },
          {
            name: "SHELBY",
            disabled: false,
          },
          {
            name: "SHELBY TOWNSHIP",
            disabled: false,
          },
          {
            name: "SHELBYVILLE",
            disabled: false,
          },
          {
            name: "SHELTON",
            disabled: false,
          },
          {
            name: "SHENANDOAH",
            disabled: false,
          },
          {
            name: "SHEPHERDSTOWN",
            disabled: false,
          },
          {
            name: "SHEPHERDSVILLE",
            disabled: false,
          },
          {
            name: "SHERIDAN",
            disabled: false,
          },
          {
            name: "SHERMAN",
            disabled: false,
          },
          {
            name: "SHERMAN OAKS",
            disabled: false,
          },
          {
            name: "SHERWOOD",
            disabled: false,
          },
          {
            name: "SHICKSHINNY",
            disabled: false,
          },
          {
            name: "SHILLINGTON",
            disabled: false,
          },
          {
            name: "SHILOH",
            disabled: false,
          },
          {
            name: "SHINNSTON",
            disabled: false,
          },
          {
            name: "SHIPPENSBURG",
            disabled: false,
          },
          {
            name: "SHIRLEY",
            disabled: false,
          },
          {
            name: "SHOEMAKERSVILLE",
            disabled: false,
          },
          {
            name: "SHORELINE",
            disabled: false,
          },
          {
            name: "SHOREVIEW",
            disabled: false,
          },
          {
            name: "SHOREWOOD",
            disabled: false,
          },
          {
            name: "SHOREWOOD HILLS",
            disabled: false,
          },
          {
            name: "SHORT HILLS",
            disabled: false,
          },
          {
            name: "SHOW LOW",
            disabled: false,
          },
          {
            name: "SHREVEPORT",
            disabled: false,
          },
          {
            name: "SHREWSBURY",
            disabled: false,
          },
          {
            name: "SHRUB OAK",
            disabled: false,
          },
          {
            name: "SICKLERVILLE",
            disabled: false,
          },
          {
            name: "SIDNEY",
            disabled: false,
          },
          {
            name: "SIERRA VISTA",
            disabled: false,
          },
          {
            name: "SIGNAL HILL",
            disabled: false,
          },
          {
            name: "SIGNAL MOUNTAIN",
            disabled: false,
          },
          {
            name: "SIKESTON",
            disabled: false,
          },
          {
            name: "SILER CITY",
            disabled: false,
          },
          {
            name: "SILOAM SPRINGS",
            disabled: false,
          },
          {
            name: "SILSBEE",
            disabled: false,
          },
          {
            name: "SILVER CITY",
            disabled: false,
          },
          {
            name: "SILVER CREEK",
            disabled: false,
          },
          {
            name: "SILVER SPRING",
            disabled: false,
          },
          {
            name: "SILVER SPRINGS",
            disabled: false,
          },
          {
            name: "SILVERDALE",
            disabled: false,
          },
          {
            name: "SILVERTHORNE",
            disabled: false,
          },
          {
            name: "SILVERTON",
            disabled: false,
          },
          {
            name: "SILVIS",
            disabled: false,
          },
          {
            name: "SIMI VALLEY",
            disabled: false,
          },
          {
            name: "SIMPSONVILLE",
            disabled: false,
          },
          {
            name: "SIMSBURY",
            disabled: false,
          },
          {
            name: "SINKING SPRING",
            disabled: false,
          },
          {
            name: "SINTON",
            disabled: false,
          },
          {
            name: "SIOUX CENTER",
            disabled: false,
          },
          {
            name: "SIOUX CITY",
            disabled: false,
          },
          {
            name: "SIOUX FALLS",
            disabled: false,
          },
          {
            name: "SKANEATELES",
            disabled: false,
          },
          {
            name: "SKIATOOK",
            disabled: false,
          },
          {
            name: "SKILLMAN",
            disabled: false,
          },
          {
            name: "SKOKIE",
            disabled: false,
          },
          {
            name: "SKOWHEGAN",
            disabled: false,
          },
          {
            name: "SLATON",
            disabled: false,
          },
          {
            name: "SLIDELL",
            disabled: false,
          },
          {
            name: "SLIPPERY ROCK",
            disabled: false,
          },
          {
            name: "SMELTERVILLE",
            disabled: false,
          },
          {
            name: "SMITHFIELD",
            disabled: false,
          },
          {
            name: "SMITHSBURG",
            disabled: false,
          },
          {
            name: "SMITHTOWN",
            disabled: false,
          },
          {
            name: "SMITHVILLE",
            disabled: false,
          },
          {
            name: "SMYRNA",
            disabled: false,
          },
          {
            name: "SNEADS FERRY",
            disabled: false,
          },
          {
            name: "SNEEDVILLE",
            disabled: false,
          },
          {
            name: "SNELLVILLE",
            disabled: false,
          },
          {
            name: "SNOHOMISH",
            disabled: false,
          },
          {
            name: "SNOQUALMIE",
            disabled: false,
          },
          {
            name: "SNYDER",
            disabled: false,
          },
          {
            name: "SOCORRO",
            disabled: false,
          },
          {
            name: "SODDY DAISY",
            disabled: false,
          },
          {
            name: "SODDY-DAISY",
            disabled: false,
          },
          {
            name: "SODUS",
            disabled: false,
          },
          {
            name: "SOLANA BEACH",
            disabled: false,
          },
          {
            name: "SOLDOTNA",
            disabled: false,
          },
          {
            name: "SOLOMONS",
            disabled: false,
          },
          {
            name: "SOLON",
            disabled: false,
          },
          {
            name: "SOLVANG",
            disabled: false,
          },
          {
            name: "SOMERDALE",
            disabled: false,
          },
          {
            name: "SOMERS",
            disabled: false,
          },
          {
            name: "SOMERS POINT",
            disabled: false,
          },
          {
            name: "SOMERSET",
            disabled: false,
          },
          {
            name: "SOMERSWORTH",
            disabled: false,
          },
          {
            name: "SOMERVILLE",
            disabled: false,
          },
          {
            name: "SONOMA",
            disabled: false,
          },
          {
            name: "SONORA",
            disabled: false,
          },
          {
            name: "SOPHIA",
            disabled: false,
          },
          {
            name: "SOQUEL",
            disabled: false,
          },
          {
            name: "SOUDERTON",
            disabled: false,
          },
          {
            name: "SOUTH ATTLEBORO",
            disabled: false,
          },
          {
            name: "SOUTH BEND",
            disabled: false,
          },
          {
            name: "SOUTH BOSTON",
            disabled: false,
          },
          {
            name: "SOUTH BURLINGTON",
            disabled: false,
          },
          {
            name: "SOUTH CHARLESTON",
            disabled: false,
          },
          {
            name: "SOUTH CHICAGO HEIGHTS",
            disabled: false,
          },
          {
            name: "SOUTH DARTMOUTH",
            disabled: false,
          },
          {
            name: "SOUTH DENNIS",
            disabled: false,
          },
          {
            name: "SOUTH EASTON",
            disabled: false,
          },
          {
            name: "SOUTH ELGIN",
            disabled: false,
          },
          {
            name: "SOUTH EUCLID",
            disabled: false,
          },
          {
            name: "SOUTH FARMINGDALE",
            disabled: false,
          },
          {
            name: "SOUTH GATE",
            disabled: false,
          },
          {
            name: "SOUTH GLENS FALLS",
            disabled: false,
          },
          {
            name: "SOUTH HAVEN",
            disabled: false,
          },
          {
            name: "SOUTH HILL",
            disabled: false,
          },
          {
            name: "SOUTH HOLLAND",
            disabled: false,
          },
          {
            name: "SOUTH JORDAN",
            disabled: false,
          },
          {
            name: "SOUTH LAKE TAHOE",
            disabled: false,
          },
          {
            name: "SOUTH LEBANON",
            disabled: false,
          },
          {
            name: "SOUTH LYON",
            disabled: false,
          },
          {
            name: "SOUTH MIAMI",
            disabled: false,
          },
          {
            name: "SOUTH MILWAUKEE",
            disabled: false,
          },
          {
            name: "SOUTH OGDEN",
            disabled: false,
          },
          {
            name: "SOUTH ORANGE",
            disabled: false,
          },
          {
            name: "SOUTH PARK",
            disabled: false,
          },
          {
            name: "SOUTH PASADENA",
            disabled: false,
          },
          {
            name: "SOUTH PLAINFIELD",
            disabled: false,
          },
          {
            name: "SOUTH POINT",
            disabled: false,
          },
          {
            name: "SOUTH PORTLAND",
            disabled: false,
          },
          {
            name: "SOUTH RIVER",
            disabled: false,
          },
          {
            name: "SOUTH SAN FRANC",
            disabled: false,
          },
          {
            name: "SOUTH SAN FRANCISCO",
            disabled: false,
          },
          {
            name: "SOUTH SETAUKET",
            disabled: false,
          },
          {
            name: "SOUTH SIOUX CITY",
            disabled: false,
          },
          {
            name: "SOUTH WEYMOUTH",
            disabled: false,
          },
          {
            name: "SOUTH WILLIAMSON",
            disabled: false,
          },
          {
            name: "SOUTH WILLIAMSPORT",
            disabled: false,
          },
          {
            name: "SOUTH WINDSOR",
            disabled: false,
          },
          {
            name: "SOUTH YARMOUTH",
            disabled: false,
          },
          {
            name: "SOUTHAMPTON",
            disabled: false,
          },
          {
            name: "SOUTHAVEN",
            disabled: false,
          },
          {
            name: "SOUTHBOROUGH",
            disabled: false,
          },
          {
            name: "SOUTHBRIDGE",
            disabled: false,
          },
          {
            name: "SOUTHBURY",
            disabled: false,
          },
          {
            name: "SOUTHERN PINES",
            disabled: false,
          },
          {
            name: "SOUTHFIELD",
            disabled: false,
          },
          {
            name: "SOUTHGATE",
            disabled: false,
          },
          {
            name: "SOUTHINGTON",
            disabled: false,
          },
          {
            name: "SOUTHLAKE",
            disabled: false,
          },
          {
            name: "SOUTHPORT",
            disabled: false,
          },
          {
            name: "SOUTHWEST RANCHES",
            disabled: false,
          },
          {
            name: "SOUTHWICK",
            disabled: false,
          },
          {
            name: "SPANAWAY",
            disabled: false,
          },
          {
            name: "SPANISH FORK",
            disabled: false,
          },
          {
            name: "SPANISH FORT",
            disabled: false,
          },
          {
            name: "SPARKS",
            disabled: false,
          },
          {
            name: "SPARTA",
            disabled: false,
          },
          {
            name: "SPARTANBURG",
            disabled: false,
          },
          {
            name: "SPEARFISH",
            disabled: false,
          },
          {
            name: "SPENCER",
            disabled: false,
          },
          {
            name: "SPENCERPORT",
            disabled: false,
          },
          {
            name: "SPIRIT LAKE",
            disabled: false,
          },
          {
            name: "SPOKANE",
            disabled: false,
          },
          {
            name: "SPOKANE VALLEY",
            disabled: false,
          },
          {
            name: "SPOTSWOOD",
            disabled: false,
          },
          {
            name: "SPOTSYLVANIA",
            disabled: false,
          },
          {
            name: "SPRING",
            disabled: false,
          },
          {
            name: "SPRING BRANCH",
            disabled: false,
          },
          {
            name: "SPRING CITY",
            disabled: false,
          },
          {
            name: "SPRING GROVE",
            disabled: false,
          },
          {
            name: "SPRING HILL",
            disabled: false,
          },
          {
            name: "SPRING HOPE",
            disabled: false,
          },
          {
            name: "SPRING HOUSE",
            disabled: false,
          },
          {
            name: "SPRING LAKE",
            disabled: false,
          },
          {
            name: "SPRING VALLEY",
            disabled: false,
          },
          {
            name: "SPRINGBORO",
            disabled: false,
          },
          {
            name: "SPRINGDALE",
            disabled: false,
          },
          {
            name: "SPRINGERVILLE",
            disabled: false,
          },
          {
            name: "SPRINGFIELD",
            disabled: false,
          },
          {
            name: "SPRINGFIELD GARDENS",
            disabled: false,
          },
          {
            name: "SPRINGHILL",
            disabled: false,
          },
          {
            name: "SPRINGVALE",
            disabled: false,
          },
          {
            name: "SPRINGVILLE",
            disabled: false,
          },
          {
            name: "SPRUCE PINE",
            disabled: false,
          },
          {
            name: "ST AUGUSTINE",
            disabled: false,
          },
          {
            name: "ST CHARLES",
            disabled: false,
          },
          {
            name: "ST CLOUD",
            disabled: false,
          },
          {
            name: "ST GEORGE",
            disabled: false,
          },
          {
            name: "ST PETERSBURG",
            disabled: false,
          },
          {
            name: "ST. ALBANS",
            disabled: false,
          },
          {
            name: "ST. CLAIR SHORES",
            disabled: false,
          },
          {
            name: "ST. PETERS",
            disabled: false,
          },
          {
            name: "STAFFORD",
            disabled: false,
          },
          {
            name: "STAFFORD SPRINGS",
            disabled: false,
          },
          {
            name: "STAFFORD TOWNSH",
            disabled: false,
          },
          {
            name: "STALLINGS",
            disabled: false,
          },
          {
            name: "STAMFORD",
            disabled: false,
          },
          {
            name: "STANDISH",
            disabled: false,
          },
          {
            name: "STANFORD",
            disabled: false,
          },
          {
            name: "STANHOPE",
            disabled: false,
          },
          {
            name: "STANLEY",
            disabled: false,
          },
          {
            name: "STANLEYTOWN",
            disabled: false,
          },
          {
            name: "STANTON",
            disabled: false,
          },
          {
            name: "STANWOOD",
            disabled: false,
          },
          {
            name: "STAR",
            disabled: false,
          },
          {
            name: "STAR CITY",
            disabled: false,
          },
          {
            name: "STARKE",
            disabled: false,
          },
          {
            name: "STARKVILLE",
            disabled: false,
          },
          {
            name: "STATE COLLEGE",
            disabled: false,
          },
          {
            name: "STATELINE",
            disabled: false,
          },
          {
            name: "STATEN ISLAND",
            disabled: false,
          },
          {
            name: "STATESBORO",
            disabled: false,
          },
          {
            name: "STATESVILLE",
            disabled: false,
          },
          {
            name: "STAUNTON",
            disabled: false,
          },
          {
            name: "STAYTON",
            disabled: false,
          },
          {
            name: "STEAMBOAT SPRINGS",
            disabled: false,
          },
          {
            name: "STEDMAN",
            disabled: false,
          },
          {
            name: "STEELTON",
            disabled: false,
          },
          {
            name: "STEPHENS CITY",
            disabled: false,
          },
          {
            name: "STEPHENVILLE",
            disabled: false,
          },
          {
            name: "STERLING",
            disabled: false,
          },
          {
            name: "STERLING HEIGHTS",
            disabled: false,
          },
          {
            name: "STEUBENVILLE",
            disabled: false,
          },
          {
            name: "STEVENS POINT",
            disabled: false,
          },
          {
            name: "STEVENSON RANCH",
            disabled: false,
          },
          {
            name: "STEVENSVILLE",
            disabled: false,
          },
          {
            name: "STEWARTSTOWN",
            disabled: false,
          },
          {
            name: "STICKNEY",
            disabled: false,
          },
          {
            name: "STIGLER",
            disabled: false,
          },
          {
            name: "STILLWATER",
            disabled: false,
          },
          {
            name: "STILWELL",
            disabled: false,
          },
          {
            name: "STIRLING",
            disabled: false,
          },
          {
            name: "STOCK ISLAND",
            disabled: false,
          },
          {
            name: "STOCKBRIDGE",
            disabled: false,
          },
          {
            name: "STOCKTON",
            disabled: false,
          },
          {
            name: "STONE MOUNTAIN",
            disabled: false,
          },
          {
            name: "STONE RIDGE",
            disabled: false,
          },
          {
            name: "STONEHAM",
            disabled: false,
          },
          {
            name: "STONY POINT",
            disabled: false,
          },
          {
            name: "STORM LAKE",
            disabled: false,
          },
          {
            name: "STOUGHTON",
            disabled: false,
          },
          {
            name: "STOW",
            disabled: false,
          },
          {
            name: "STOWE",
            disabled: false,
          },
          {
            name: "STRASBURG",
            disabled: false,
          },
          {
            name: "STRATFORD",
            disabled: false,
          },
          {
            name: "STRATHAM",
            disabled: false,
          },
          {
            name: "STREAMWOOD",
            disabled: false,
          },
          {
            name: "STREATOR",
            disabled: false,
          },
          {
            name: "STREETSBORO",
            disabled: false,
          },
          {
            name: "STRONGSVILLE",
            disabled: false,
          },
          {
            name: "STROUDSBURG",
            disabled: false,
          },
          {
            name: "STRUTHERS",
            disabled: false,
          },
          {
            name: "STUART",
            disabled: false,
          },
          {
            name: "STUARTS DRAFT",
            disabled: false,
          },
          {
            name: "STUDIO CITY",
            disabled: false,
          },
          {
            name: "STURBRIDGE",
            disabled: false,
          },
          {
            name: "STURGEON BAY",
            disabled: false,
          },
          {
            name: "STURGIS",
            disabled: false,
          },
          {
            name: "STURTEVANT",
            disabled: false,
          },
          {
            name: "STUTTGART",
            disabled: false,
          },
          {
            name: "SUCCASUNNA",
            disabled: false,
          },
          {
            name: "SUDBURY",
            disabled: false,
          },
          {
            name: "SUFFERN",
            disabled: false,
          },
          {
            name: "SUFFIELD",
            disabled: false,
          },
          {
            name: "SUFFOLK",
            disabled: false,
          },
          {
            name: "SUGAR GROVE",
            disabled: false,
          },
          {
            name: "SUGAR HILL",
            disabled: false,
          },
          {
            name: "SUGAR LAND",
            disabled: false,
          },
          {
            name: "SUGAR MOUNTAIN",
            disabled: false,
          },
          {
            name: "SUISUN CITY",
            disabled: false,
          },
          {
            name: "SULLIVAN",
            disabled: false,
          },
          {
            name: "SULPHUR",
            disabled: false,
          },
          {
            name: "SULPHUR SPRINGS",
            disabled: false,
          },
          {
            name: "SUMITON",
            disabled: false,
          },
          {
            name: "SUMMERFIELD",
            disabled: false,
          },
          {
            name: "SUMMERSVILLE",
            disabled: false,
          },
          {
            name: "SUMMERVILLE",
            disabled: false,
          },
          {
            name: "SUMMIT",
            disabled: false,
          },
          {
            name: "SUMNER",
            disabled: false,
          },
          {
            name: "SUMTER",
            disabled: false,
          },
          {
            name: "SUN CITY",
            disabled: false,
          },
          {
            name: "SUN CITY CENTER",
            disabled: false,
          },
          {
            name: "SUN CITY WEST",
            disabled: false,
          },
          {
            name: "SUN LAKES",
            disabled: false,
          },
          {
            name: "SUN PRAIRIE",
            disabled: false,
          },
          {
            name: "SUN VALLEY",
            disabled: false,
          },
          {
            name: "SUNBURY",
            disabled: false,
          },
          {
            name: "SUNNY ISLES BEACH",
            disabled: false,
          },
          {
            name: "SUNNYSIDE",
            disabled: false,
          },
          {
            name: "SUNNYVALE",
            disabled: false,
          },
          {
            name: "SUNRISE",
            disabled: false,
          },
          {
            name: "SUNSET",
            disabled: false,
          },
          {
            name: "SUNSET BEACH",
            disabled: false,
          },
          {
            name: "SUPERIOR",
            disabled: false,
          },
          {
            name: "SURF CITY",
            disabled: false,
          },
          {
            name: "SURFSIDE",
            disabled: false,
          },
          {
            name: "SURFSIDE BEACH",
            disabled: false,
          },
          {
            name: "SURPRISE",
            disabled: false,
          },
          {
            name: "SUSANVILLE",
            disabled: false,
          },
          {
            name: "SUSSEX",
            disabled: false,
          },
          {
            name: "SUTTER CREEK",
            disabled: false,
          },
          {
            name: "SUTTON",
            disabled: false,
          },
          {
            name: "SUWANEE",
            disabled: false,
          },
          {
            name: "SWAINSBORO",
            disabled: false,
          },
          {
            name: "SWAMPSCOTT",
            disabled: false,
          },
          {
            name: "SWANNANOA",
            disabled: false,
          },
          {
            name: "SWANSBORO",
            disabled: false,
          },
          {
            name: "SWANSEA",
            disabled: false,
          },
          {
            name: "SWANTON",
            disabled: false,
          },
          {
            name: "SWARTHMORE",
            disabled: false,
          },
          {
            name: "SWARTZ CREEK",
            disabled: false,
          },
          {
            name: "SWEDESBORO",
            disabled: false,
          },
          {
            name: "SWEET HOME",
            disabled: false,
          },
          {
            name: "SWEETWATER",
            disabled: false,
          },
          {
            name: "SWISSVALE",
            disabled: false,
          },
          {
            name: "SYCAMORE",
            disabled: false,
          },
          {
            name: "SYKESVILLE",
            disabled: false,
          },
          {
            name: "SYLACAUGA",
            disabled: false,
          },
          {
            name: "SYLMAR",
            disabled: false,
          },
          {
            name: "SYLVA",
            disabled: false,
          },
          {
            name: "SYLVAN LAKE",
            disabled: false,
          },
          {
            name: "SYLVANIA",
            disabled: false,
          },
          {
            name: "SYLVESTER",
            disabled: false,
          },
          {
            name: "SYOSSET",
            disabled: false,
          },
          {
            name: "SYRACUSE",
            disabled: false,
          },
          {
            name: "Sacramento",
            disabled: false,
          },
          {
            name: "Saginaw",
            disabled: false,
          },
          {
            name: "Saint Albans",
            disabled: false,
          },
          {
            name: "Saint Ann",
            disabled: false,
          },
          {
            name: "Saint Augustine",
            disabled: false,
          },
          {
            name: "Saint Charles",
            disabled: false,
          },
          {
            name: "Saint Clair Shores",
            disabled: false,
          },
          {
            name: "Saint Clairsville",
            disabled: false,
          },
          {
            name: "Saint Francis",
            disabled: false,
          },
          {
            name: "Saint John",
            disabled: false,
          },
          {
            name: "Saint Louis",
            disabled: false,
          },
          {
            name: "Saint Paul",
            disabled: false,
          },
          {
            name: "Saint Peters",
            disabled: false,
          },
          {
            name: "Saint Petersburg",
            disabled: false,
          },
          {
            name: "Salem",
            disabled: false,
          },
          {
            name: "Salina",
            disabled: false,
          },
          {
            name: "Salinas",
            disabled: false,
          },
          {
            name: "Salt Lake City",
            disabled: false,
          },
          {
            name: "Sammamish",
            disabled: false,
          },
          {
            name: "San Antonio",
            disabled: false,
          },
          {
            name: "San Diego",
            disabled: false,
          },
          {
            name: "San Dimas",
            disabled: false,
          },
          {
            name: "San Fernando",
            disabled: false,
          },
          {
            name: "San Francisco",
            disabled: false,
          },
          {
            name: "San Juan Capistrano",
            disabled: false,
          },
          {
            name: "San Juan Capristrano",
            disabled: false,
          },
          {
            name: "San Marcos",
            disabled: false,
          },
          {
            name: "San Mateo",
            disabled: false,
          },
          {
            name: "Sandusky",
            disabled: false,
          },
          {
            name: "Sandy Springs",
            disabled: false,
          },
          {
            name: "Santa Ana",
            disabled: false,
          },
          {
            name: "Santa Barbara",
            disabled: false,
          },
          {
            name: "Santa Maria",
            disabled: false,
          },
          {
            name: "Santa Monica",
            disabled: false,
          },
          {
            name: "Saratoga Springs",
            disabled: false,
          },
          {
            name: "Savannah",
            disabled: false,
          },
          {
            name: "Schofield",
            disabled: false,
          },
          {
            name: "Scott Depot",
            disabled: false,
          },
          {
            name: "Scotts Valley",
            disabled: false,
          },
          {
            name: "Scottsburg",
            disabled: false,
          },
          {
            name: "Scottsdale",
            disabled: false,
          },
          {
            name: "Scottsville",
            disabled: false,
          },
          {
            name: "Searcy",
            disabled: false,
          },
          {
            name: "Seattle",
            disabled: false,
          },
          {
            name: "Sellersburg",
            disabled: false,
          },
          {
            name: "Seymour",
            disabled: false,
          },
          {
            name: "Shelby Township",
            disabled: false,
          },
          {
            name: "Shelby Twp.",
            disabled: false,
          },
          {
            name: "Shelton",
            disabled: false,
          },
          {
            name: "Sherman Oaks",
            disabled: false,
          },
          {
            name: "Shiprock",
            disabled: false,
          },
          {
            name: "Shoals",
            disabled: false,
          },
          {
            name: "Shoreline",
            disabled: false,
          },
          {
            name: "Shorewood",
            disabled: false,
          },
          {
            name: "Sierra Vista",
            disabled: false,
          },
          {
            name: "Sikeston",
            disabled: false,
          },
          {
            name: "Skokie",
            disabled: false,
          },
          {
            name: "Smithers",
            disabled: false,
          },
          {
            name: "Snellville",
            disabled: false,
          },
          {
            name: "Snoqualmie",
            disabled: false,
          },
          {
            name: "Socorro",
            disabled: false,
          },
          {
            name: "Soledad",
            disabled: false,
          },
          {
            name: "Somerset",
            disabled: false,
          },
          {
            name: "South Milwaukee",
            disabled: false,
          },
          {
            name: "Southfield",
            disabled: false,
          },
          {
            name: "Southgate",
            disabled: false,
          },
          {
            name: "Spanish Fork",
            disabled: false,
          },
          {
            name: "Sparta",
            disabled: false,
          },
          {
            name: "Spokane",
            disabled: false,
          },
          {
            name: "Spring",
            disabled: false,
          },
          {
            name: "Springboro",
            disabled: false,
          },
          {
            name: "Springfield",
            disabled: false,
          },
          {
            name: "St George",
            disabled: false,
          },
          {
            name: "St Louis Park",
            disabled: false,
          },
          {
            name: "St. Charles",
            disabled: false,
          },
          {
            name: "St. Joseph",
            disabled: false,
          },
          {
            name: "St. Matthews",
            disabled: false,
          },
          {
            name: "St.Louis Park",
            disabled: false,
          },
          {
            name: "Stanwood",
            disabled: false,
          },
          {
            name: "State College",
            disabled: false,
          },
          {
            name: "Steamboat Springs",
            disabled: false,
          },
          {
            name: "Sterling",
            disabled: false,
          },
          {
            name: "Sterling Heights",
            disabled: false,
          },
          {
            name: "Stevensville",
            disabled: false,
          },
          {
            name: "Stone Mountain",
            disabled: false,
          },
          {
            name: "Studio City",
            disabled: false,
          },
          {
            name: "Sturgeon Bay",
            disabled: false,
          },
          {
            name: "Suffolk",
            disabled: false,
          },
          {
            name: "Sugar Land",
            disabled: false,
          },
          {
            name: "Sun Prairie",
            disabled: false,
          },
          {
            name: "Sun Valley",
            disabled: false,
          },
          {
            name: "Sunland",
            disabled: false,
          },
          {
            name: "Sunnyvale",
            disabled: false,
          },
          {
            name: "Superior",
            disabled: false,
          },
          {
            name: "Surprise",
            disabled: false,
          },
          {
            name: "Sylmar",
            disabled: false,
          },
          {
            name: "TABERNACLE",
            disabled: false,
          },
          {
            name: "TABOR CITY",
            disabled: false,
          },
          {
            name: "TACOMA",
            disabled: false,
          },
          {
            name: "TAFT",
            disabled: false,
          },
          {
            name: "TAHLEQUAH",
            disabled: false,
          },
          {
            name: "TAHOE CITY",
            disabled: false,
          },
          {
            name: "TAKOMA PARK",
            disabled: false,
          },
          {
            name: "TALLADEGA",
            disabled: false,
          },
          {
            name: "TALLAHASSEE",
            disabled: false,
          },
          {
            name: "TALLAPOOSA",
            disabled: false,
          },
          {
            name: "TALLASSEE",
            disabled: false,
          },
          {
            name: "TALLMADGE",
            disabled: false,
          },
          {
            name: "TAMAQUA",
            disabled: false,
          },
          {
            name: "TAMARAC",
            disabled: false,
          },
          {
            name: "TAMPA",
            disabled: false,
          },
          {
            name: "TANEYTOWN",
            disabled: false,
          },
          {
            name: "TANNERSVILLE",
            disabled: false,
          },
          {
            name: "TAOS",
            disabled: false,
          },
          {
            name: "TAPPAHANNOCK",
            disabled: false,
          },
          {
            name: "TAPPAN",
            disabled: false,
          },
          {
            name: "TARBORO",
            disabled: false,
          },
          {
            name: "TARENTUM",
            disabled: false,
          },
          {
            name: "TARPON SPRINGS",
            disabled: false,
          },
          {
            name: "TARRYTOWN",
            disabled: false,
          },
          {
            name: "TARZANA",
            disabled: false,
          },
          {
            name: "TAUNTON",
            disabled: false,
          },
          {
            name: "TAVARES",
            disabled: false,
          },
          {
            name: "TAVERNIER",
            disabled: false,
          },
          {
            name: "TAWAS CITY",
            disabled: false,
          },
          {
            name: "TAYLOR",
            disabled: false,
          },
          {
            name: "TAYLORS",
            disabled: false,
          },
          {
            name: "TAYLORSVILLE",
            disabled: false,
          },
          {
            name: "TAYLORVILLE",
            disabled: false,
          },
          {
            name: "TEANECK",
            disabled: false,
          },
          {
            name: "TEATICKET",
            disabled: false,
          },
          {
            name: "TECUMSEH",
            disabled: false,
          },
          {
            name: "TEGA CAY",
            disabled: false,
          },
          {
            name: "TEHACHAPI",
            disabled: false,
          },
          {
            name: "TELL CITY",
            disabled: false,
          },
          {
            name: "TEMECULA",
            disabled: false,
          },
          {
            name: "TEMPE",
            disabled: false,
          },
          {
            name: "TEMPLE",
            disabled: false,
          },
          {
            name: "TEMPLE CITY",
            disabled: false,
          },
          {
            name: "TEMPLE HILLS",
            disabled: false,
          },
          {
            name: "TEMPLE TERRACE",
            disabled: false,
          },
          {
            name: "TENAFLY",
            disabled: false,
          },
          {
            name: "TEQUESTA",
            disabled: false,
          },
          {
            name: "TERRE HAUTE",
            disabled: false,
          },
          {
            name: "TERRELL",
            disabled: false,
          },
          {
            name: "TERRYTOWN",
            disabled: false,
          },
          {
            name: "TERRYVILLE",
            disabled: false,
          },
          {
            name: "TETERBORO",
            disabled: false,
          },
          {
            name: "TEWKSBURY",
            disabled: false,
          },
          {
            name: "TEXARKANA",
            disabled: false,
          },
          {
            name: "TEXAS CITY",
            disabled: false,
          },
          {
            name: "THATCHER",
            disabled: false,
          },
          {
            name: "THAYER",
            disabled: false,
          },
          {
            name: "THE COLONY",
            disabled: false,
          },
          {
            name: "THE DALLES",
            disabled: false,
          },
          {
            name: "THE PLAINS",
            disabled: false,
          },
          {
            name: "THE VILLAGE",
            disabled: false,
          },
          {
            name: "THE VILLAGES",
            disabled: false,
          },
          {
            name: "THE WOODLANDS",
            disabled: false,
          },
          {
            name: "THEODORE",
            disabled: false,
          },
          {
            name: "THIBODAUX",
            disabled: false,
          },
          {
            name: "THIEF RIVER FALLS",
            disabled: false,
          },
          {
            name: "THIENSVILLE",
            disabled: false,
          },
          {
            name: "THIRD LAKE",
            disabled: false,
          },
          {
            name: "THOMASTON",
            disabled: false,
          },
          {
            name: "THOMASVILLE",
            disabled: false,
          },
          {
            name: "THOMPSONS STATION",
            disabled: false,
          },
          {
            name: "THOMSON",
            disabled: false,
          },
          {
            name: "THORNDALE",
            disabled: false,
          },
          {
            name: "THORNTON",
            disabled: false,
          },
          {
            name: "THORNWOOD",
            disabled: false,
          },
          {
            name: "THOUSAND OAKS",
            disabled: false,
          },
          {
            name: "THREE RIVERS",
            disabled: false,
          },
          {
            name: "THURMONT",
            disabled: false,
          },
          {
            name: "TIBURON",
            disabled: false,
          },
          {
            name: "TICONDEROGA",
            disabled: false,
          },
          {
            name: "TIFFIN",
            disabled: false,
          },
          {
            name: "TIFTON",
            disabled: false,
          },
          {
            name: "TIGARD",
            disabled: false,
          },
          {
            name: "TILLAMOOK",
            disabled: false,
          },
          {
            name: "TILTON",
            disabled: false,
          },
          {
            name: "TIMBERVILLE",
            disabled: false,
          },
          {
            name: "TIMNATH",
            disabled: false,
          },
          {
            name: "TIMONIUM",
            disabled: false,
          },
          {
            name: "TINLEY PARK",
            disabled: false,
          },
          {
            name: "TINTON FALLS",
            disabled: false,
          },
          {
            name: "TIPP CITY",
            disabled: false,
          },
          {
            name: "TIPTON",
            disabled: false,
          },
          {
            name: "TITUSVILLE",
            disabled: false,
          },
          {
            name: "TIVERTON",
            disabled: false,
          },
          {
            name: "TOA BAJA",
            disabled: false,
          },
          {
            name: "TOBYHANNA",
            disabled: false,
          },
          {
            name: "TOCCOA",
            disabled: false,
          },
          {
            name: "TOLEDO",
            disabled: false,
          },
          {
            name: "TOLLESON",
            disabled: false,
          },
          {
            name: "TOMAH",
            disabled: false,
          },
          {
            name: "TOMBALL",
            disabled: false,
          },
          {
            name: "TOMPKINSVILLE",
            disabled: false,
          },
          {
            name: "TOMS RIVER",
            disabled: false,
          },
          {
            name: "TONAWANDA",
            disabled: false,
          },
          {
            name: "TOOELE",
            disabled: false,
          },
          {
            name: "TOPEKA",
            disabled: false,
          },
          {
            name: "TOPPENISH",
            disabled: false,
          },
          {
            name: "TOPSHAM",
            disabled: false,
          },
          {
            name: "TORRANCE",
            disabled: false,
          },
          {
            name: "TORRINGTON",
            disabled: false,
          },
          {
            name: "TOTOWA",
            disabled: false,
          },
          {
            name: "TOWANDA",
            disabled: false,
          },
          {
            name: "TOWNSEND",
            disabled: false,
          },
          {
            name: "TOWSON",
            disabled: false,
          },
          {
            name: "TRABUCO CANYON",
            disabled: false,
          },
          {
            name: "TRACY",
            disabled: false,
          },
          {
            name: "TRAFALGAR",
            disabled: false,
          },
          {
            name: "TRAVELERS REST",
            disabled: false,
          },
          {
            name: "TRAVERSE CITY",
            disabled: false,
          },
          {
            name: "TREASURE ISLAND",
            disabled: false,
          },
          {
            name: "TRENTON",
            disabled: false,
          },
          {
            name: "TREVOSE",
            disabled: false,
          },
          {
            name: "TREXLERTOWN",
            disabled: false,
          },
          {
            name: "TRIADELPHIA",
            disabled: false,
          },
          {
            name: "TRINIDAD",
            disabled: false,
          },
          {
            name: "TRINITY",
            disabled: false,
          },
          {
            name: "TRION",
            disabled: false,
          },
          {
            name: "TROPHY CLUB",
            disabled: false,
          },
          {
            name: "TROTWOOD",
            disabled: false,
          },
          {
            name: "TROUTDALE",
            disabled: false,
          },
          {
            name: "TROUTMAN",
            disabled: false,
          },
          {
            name: "TROUTVILLE",
            disabled: false,
          },
          {
            name: "TROY",
            disabled: false,
          },
          {
            name: "TRUCKEE",
            disabled: false,
          },
          {
            name: "TRUMANN",
            disabled: false,
          },
          {
            name: "TRUMBULL",
            disabled: false,
          },
          {
            name: "TRUSSVILLE",
            disabled: false,
          },
          {
            name: "TRUTH OR CONSEQUENC",
            disabled: false,
          },
          {
            name: "TRUTH OR CONSEQUENCES",
            disabled: false,
          },
          {
            name: "TUCKER",
            disabled: false,
          },
          {
            name: "TUCKERTON",
            disabled: false,
          },
          {
            name: "TUCSON",
            disabled: false,
          },
          {
            name: "TUJUNGA",
            disabled: false,
          },
          {
            name: "TUKWILA",
            disabled: false,
          },
          {
            name: "TULARE",
            disabled: false,
          },
          {
            name: "TULLAHOMA",
            disabled: false,
          },
          {
            name: "TULSA",
            disabled: false,
          },
          {
            name: "TUMWATER",
            disabled: false,
          },
          {
            name: "TUNKHANNOCK",
            disabled: false,
          },
          {
            name: "TUPELO",
            disabled: false,
          },
          {
            name: "TURLOCK",
            disabled: false,
          },
          {
            name: "TURNERS FALLS",
            disabled: false,
          },
          {
            name: "TURNERSVILLE",
            disabled: false,
          },
          {
            name: "TURTLE CREEK",
            disabled: false,
          },
          {
            name: "TUSCALOOSA",
            disabled: false,
          },
          {
            name: "TUSKEGEE",
            disabled: false,
          },
          {
            name: "TUSTIN",
            disabled: false,
          },
          {
            name: "TWENTYNINE PALMS",
            disabled: false,
          },
          {
            name: "TWIN FALLS",
            disabled: false,
          },
          {
            name: "TWINSBURG",
            disabled: false,
          },
          {
            name: "TWO RIVERS",
            disabled: false,
          },
          {
            name: "TYLER",
            disabled: false,
          },
          {
            name: "TYRONE",
            disabled: false,
          },
          {
            name: "Tacoma",
            disabled: false,
          },
          {
            name: "Tampa",
            disabled: false,
          },
          {
            name: "Taylorville",
            disabled: false,
          },
          {
            name: "Terre Haute",
            disabled: false,
          },
          {
            name: "Thornton",
            disabled: false,
          },
          {
            name: "Tigard",
            disabled: false,
          },
          {
            name: "Toledo",
            disabled: false,
          },
          {
            name: "Topeka",
            disabled: false,
          },
          {
            name: "Trimble",
            disabled: false,
          },
          {
            name: "Troy",
            disabled: false,
          },
          {
            name: "Tualatin",
            disabled: false,
          },
          {
            name: "Tucson",
            disabled: false,
          },
          {
            name: "Tulare",
            disabled: false,
          },
          {
            name: "Tustin",
            disabled: false,
          },
          {
            name: "Two Rivers",
            disabled: false,
          },
          {
            name: "UHRICHSVILLE",
            disabled: false,
          },
          {
            name: "UKIAH",
            disabled: false,
          },
          {
            name: "UNALASKA",
            disabled: false,
          },
          {
            name: "UNCASVILLE",
            disabled: false,
          },
          {
            name: "UNICOI",
            disabled: false,
          },
          {
            name: "UNION",
            disabled: false,
          },
          {
            name: "UNION CITY",
            disabled: false,
          },
          {
            name: "UNION GAP",
            disabled: false,
          },
          {
            name: "UNION SPRINGS",
            disabled: false,
          },
          {
            name: "UNIONDALE",
            disabled: false,
          },
          {
            name: "UNIONTOWN",
            disabled: false,
          },
          {
            name: "UNIONVILLE",
            disabled: false,
          },
          {
            name: "UNIVERSAL CITY",
            disabled: false,
          },
          {
            name: "UNIVERSITY CITY",
            disabled: false,
          },
          {
            name: "UNIVERSITY HEIGHTS",
            disabled: false,
          },
          {
            name: "UNIVERSITY PARK",
            disabled: false,
          },
          {
            name: "UNIVERSITY PLACE",
            disabled: false,
          },
          {
            name: "UPLAND",
            disabled: false,
          },
          {
            name: "UPPER ARLINGTON",
            disabled: false,
          },
          {
            name: "UPPER DARBY",
            disabled: false,
          },
          {
            name: "UPPER MARLBORO",
            disabled: false,
          },
          {
            name: "UPPER MONTCLAIR",
            disabled: false,
          },
          {
            name: "UPPER SANDUSKY",
            disabled: false,
          },
          {
            name: "URBANA",
            disabled: false,
          },
          {
            name: "URBANDALE",
            disabled: false,
          },
          {
            name: "UTICA",
            disabled: false,
          },
          {
            name: "UVALDE",
            disabled: false,
          },
          {
            name: "UXBRIDGE",
            disabled: false,
          },
          {
            name: "Union",
            disabled: false,
          },
          {
            name: "University Place",
            disabled: false,
          },
          {
            name: "Upper Arlington",
            disabled: false,
          },
          {
            name: "VACAVILLE",
            disabled: false,
          },
          {
            name: "VADNAIS HEIGHTS",
            disabled: false,
          },
          {
            name: "VAIL",
            disabled: false,
          },
          {
            name: "VAILS GATE",
            disabled: false,
          },
          {
            name: "VALATIE",
            disabled: false,
          },
          {
            name: "VALDEZ",
            disabled: false,
          },
          {
            name: "VALDOSTA",
            disabled: false,
          },
          {
            name: "VALENCIA",
            disabled: false,
          },
          {
            name: "VALLEJO",
            disabled: false,
          },
          {
            name: "VALLEY",
            disabled: false,
          },
          {
            name: "VALLEY CENTER",
            disabled: false,
          },
          {
            name: "VALLEY COTTAGE",
            disabled: false,
          },
          {
            name: "VALLEY SPRINGS",
            disabled: false,
          },
          {
            name: "VALLEY STREAM",
            disabled: false,
          },
          {
            name: "VALPARAISO",
            disabled: false,
          },
          {
            name: "VALRICO",
            disabled: false,
          },
          {
            name: "VAN BUREN",
            disabled: false,
          },
          {
            name: "VAN BUREN TWP",
            disabled: false,
          },
          {
            name: "VAN NUYS",
            disabled: false,
          },
          {
            name: "VAN WERT",
            disabled: false,
          },
          {
            name: "VANCEBORO",
            disabled: false,
          },
          {
            name: "VANCOUVER",
            disabled: false,
          },
          {
            name: "VANDALIA",
            disabled: false,
          },
          {
            name: "VAUXHALL",
            disabled: false,
          },
          {
            name: "VENICE",
            disabled: false,
          },
          {
            name: "VENTNOR CITY",
            disabled: false,
          },
          {
            name: "VENTURA",
            disabled: false,
          },
          {
            name: "VERGENNES",
            disabled: false,
          },
          {
            name: "VERMILION",
            disabled: false,
          },
          {
            name: "VERMILLION",
            disabled: false,
          },
          {
            name: "VERNAL",
            disabled: false,
          },
          {
            name: "VERNON",
            disabled: false,
          },
          {
            name: "VERNON HILLS",
            disabled: false,
          },
          {
            name: "VERNON ROCKVILLE",
            disabled: false,
          },
          {
            name: "VERO BEACH",
            disabled: false,
          },
          {
            name: "VERONA",
            disabled: false,
          },
          {
            name: "VERSAILLES",
            disabled: false,
          },
          {
            name: "VESTAL",
            disabled: false,
          },
          {
            name: "VESTAVIA HILLS",
            disabled: false,
          },
          {
            name: "VEVAY",
            disabled: false,
          },
          {
            name: "VICKSBURG",
            disabled: false,
          },
          {
            name: "VICTOR",
            disabled: false,
          },
          {
            name: "VICTORIA",
            disabled: false,
          },
          {
            name: "VICTORVILLE",
            disabled: false,
          },
          {
            name: "VIDALIA",
            disabled: false,
          },
          {
            name: "VIDOR",
            disabled: false,
          },
          {
            name: "VIENNA",
            disabled: false,
          },
          {
            name: "VILLA PARK",
            disabled: false,
          },
          {
            name: "VILLA RICA",
            disabled: false,
          },
          {
            name: "VILLAS",
            disabled: false,
          },
          {
            name: "VILLE PLATTE",
            disabled: false,
          },
          {
            name: "VINCENNES",
            disabled: false,
          },
          {
            name: "VINELAND",
            disabled: false,
          },
          {
            name: "VINITA",
            disabled: false,
          },
          {
            name: "VINTON",
            disabled: false,
          },
          {
            name: "VIRGINIA",
            disabled: false,
          },
          {
            name: "VIRGINIA BEACH",
            disabled: false,
          },
          {
            name: "VIROQUA",
            disabled: false,
          },
          {
            name: "VISALIA",
            disabled: false,
          },
          {
            name: "VISTA",
            disabled: false,
          },
          {
            name: "VIVIAN",
            disabled: false,
          },
          {
            name: "VOORHEES",
            disabled: false,
          },
          {
            name: "Vail",
            disabled: false,
          },
          {
            name: "Valencia",
            disabled: false,
          },
          {
            name: "Van Wert",
            disabled: false,
          },
          {
            name: "Vancouver",
            disabled: false,
          },
          {
            name: "Ventura",
            disabled: false,
          },
          {
            name: "Vernon Hills",
            disabled: false,
          },
          {
            name: "Versailles",
            disabled: false,
          },
          {
            name: "Vincennes",
            disabled: false,
          },
          {
            name: "W Frankfort",
            disabled: false,
          },
          {
            name: "WABASH",
            disabled: false,
          },
          {
            name: "WACO",
            disabled: false,
          },
          {
            name: "WACONIA",
            disabled: false,
          },
          {
            name: "WADENA",
            disabled: false,
          },
          {
            name: "WADESBORO",
            disabled: false,
          },
          {
            name: "WADING RIVER",
            disabled: false,
          },
          {
            name: "WADSWORTH",
            disabled: false,
          },
          {
            name: "WAGONER",
            disabled: false,
          },
          {
            name: "WAHIAWA",
            disabled: false,
          },
          {
            name: "WAHPETON",
            disabled: false,
          },
          {
            name: "WAIANAE",
            disabled: false,
          },
          {
            name: "WAILUKU",
            disabled: false,
          },
          {
            name: "WAIPAHU",
            disabled: false,
          },
          {
            name: "WAITE PARK",
            disabled: false,
          },
          {
            name: "WAITSFIELD",
            disabled: false,
          },
          {
            name: "WAKE FOREST",
            disabled: false,
          },
          {
            name: "WAKE VILLAGE",
            disabled: false,
          },
          {
            name: "WAKEFIELD",
            disabled: false,
          },
          {
            name: "WALDORF",
            disabled: false,
          },
          {
            name: "WALDWICK",
            disabled: false,
          },
          {
            name: "WALES",
            disabled: false,
          },
          {
            name: "WALKER",
            disabled: false,
          },
          {
            name: "WALKERSVILLE",
            disabled: false,
          },
          {
            name: "WALKERTON",
            disabled: false,
          },
          {
            name: "WALKERTOWN",
            disabled: false,
          },
          {
            name: "WALL TOWNSHIP",
            disabled: false,
          },
          {
            name: "WALLA WALLA",
            disabled: false,
          },
          {
            name: "WALLACE",
            disabled: false,
          },
          {
            name: "WALLED LAKE",
            disabled: false,
          },
          {
            name: "WALLER",
            disabled: false,
          },
          {
            name: "WALLINGFORD",
            disabled: false,
          },
          {
            name: "WALLS",
            disabled: false,
          },
          {
            name: "WALNUT",
            disabled: false,
          },
          {
            name: "WALNUT COVE",
            disabled: false,
          },
          {
            name: "WALNUT CREEK",
            disabled: false,
          },
          {
            name: "WALNUT RIDGE",
            disabled: false,
          },
          {
            name: "WALNUTPORT",
            disabled: false,
          },
          {
            name: "WALPOLE",
            disabled: false,
          },
          {
            name: "WALSENBURG",
            disabled: false,
          },
          {
            name: "WALTERBORO",
            disabled: false,
          },
          {
            name: "WALTHAM",
            disabled: false,
          },
          {
            name: "WALTON",
            disabled: false,
          },
          {
            name: "WANTAGH",
            disabled: false,
          },
          {
            name: "WAPAKONETA",
            disabled: false,
          },
          {
            name: "WAPPINGERS FALLS",
            disabled: false,
          },
          {
            name: "WARE",
            disabled: false,
          },
          {
            name: "WAREHAM",
            disabled: false,
          },
          {
            name: "WARETOWN",
            disabled: false,
          },
          {
            name: "WARFIELD",
            disabled: false,
          },
          {
            name: "WARMINSTER",
            disabled: false,
          },
          {
            name: "WARNER ROBINS",
            disabled: false,
          },
          {
            name: "WARR ACRES",
            disabled: false,
          },
          {
            name: "WARREN",
            disabled: false,
          },
          {
            name: "WARRENSBURG",
            disabled: false,
          },
          {
            name: "WARRENSVILLE HEIGHTS",
            disabled: false,
          },
          {
            name: "WARRENTON",
            disabled: false,
          },
          {
            name: "WARRENVILLE",
            disabled: false,
          },
          {
            name: "WARRINGTON",
            disabled: false,
          },
          {
            name: "WARRIOR",
            disabled: false,
          },
          {
            name: "WARSAW",
            disabled: false,
          },
          {
            name: "WARTBURG",
            disabled: false,
          },
          {
            name: "WARWICK",
            disabled: false,
          },
          {
            name: "WASCO",
            disabled: false,
          },
          {
            name: "WASECA",
            disabled: false,
          },
          {
            name: "WASHINGTON",
            disabled: false,
          },
          {
            name: "WASHINGTON COURT HO",
            disabled: false,
          },
          {
            name: "WASHINGTON COURT HOUSE",
            disabled: false,
          },
          {
            name: "WASHINGTON DC",
            disabled: false,
          },
          {
            name: "WASHINGTONVILLE",
            disabled: false,
          },
          {
            name: "WASHOUGAL",
            disabled: false,
          },
          {
            name: "WASILLA",
            disabled: false,
          },
          {
            name: "WATAUGA",
            disabled: false,
          },
          {
            name: "WATCHUNG",
            disabled: false,
          },
          {
            name: "WATERBURY",
            disabled: false,
          },
          {
            name: "WATERFORD",
            disabled: false,
          },
          {
            name: "WATERLOO",
            disabled: false,
          },
          {
            name: "WATERTOWN",
            disabled: false,
          },
          {
            name: "WATERVILLE",
            disabled: false,
          },
          {
            name: "WATERVLIET",
            disabled: false,
          },
          {
            name: "WATKINS GLEN",
            disabled: false,
          },
          {
            name: "WATKINSVILLE",
            disabled: false,
          },
          {
            name: "WATSEKA",
            disabled: false,
          },
          {
            name: "WATSONVILLE",
            disabled: false,
          },
          {
            name: "WAUCHULA",
            disabled: false,
          },
          {
            name: "WAUCONDA",
            disabled: false,
          },
          {
            name: "WAUKEGAN",
            disabled: false,
          },
          {
            name: "WAUKESHA",
            disabled: false,
          },
          {
            name: "WAUNAKEE",
            disabled: false,
          },
          {
            name: "WAUPACA",
            disabled: false,
          },
          {
            name: "WAUPUN",
            disabled: false,
          },
          {
            name: "WAUSAU",
            disabled: false,
          },
          {
            name: "WAUSEON",
            disabled: false,
          },
          {
            name: "WAUWATOSA",
            disabled: false,
          },
          {
            name: "WAVELAND",
            disabled: false,
          },
          {
            name: "WAVERLY",
            disabled: false,
          },
          {
            name: "WAXAHACHIE",
            disabled: false,
          },
          {
            name: "WAXHAW",
            disabled: false,
          },
          {
            name: "WAYCROSS",
            disabled: false,
          },
          {
            name: "WAYLAND",
            disabled: false,
          },
          {
            name: "WAYNE",
            disabled: false,
          },
          {
            name: "WAYNESBORO",
            disabled: false,
          },
          {
            name: "WAYNESBURG",
            disabled: false,
          },
          {
            name: "WAYNESVILLE",
            disabled: false,
          },
          {
            name: "WAYZATA",
            disabled: false,
          },
          {
            name: "WEATHERFORD",
            disabled: false,
          },
          {
            name: "WEAVERVILLE",
            disabled: false,
          },
          {
            name: "WEBB CITY",
            disabled: false,
          },
          {
            name: "WEBSTER",
            disabled: false,
          },
          {
            name: "WEBSTER GROVES",
            disabled: false,
          },
          {
            name: "WEEKI WACHEE",
            disabled: false,
          },
          {
            name: "WEIRTON",
            disabled: false,
          },
          {
            name: "WELCOME",
            disabled: false,
          },
          {
            name: "WELDON SPRING",
            disabled: false,
          },
          {
            name: "WELLESLEY",
            disabled: false,
          },
          {
            name: "WELLINGTON",
            disabled: false,
          },
          {
            name: "WELLS",
            disabled: false,
          },
          {
            name: "WELLSBORO",
            disabled: false,
          },
          {
            name: "WELLSBURG",
            disabled: false,
          },
          {
            name: "WELLSVILLE",
            disabled: false,
          },
          {
            name: "WENATCHEE",
            disabled: false,
          },
          {
            name: "WENDELL",
            disabled: false,
          },
          {
            name: "WENONAH",
            disabled: false,
          },
          {
            name: "WENTZVILLE",
            disabled: false,
          },
          {
            name: "WESLACO",
            disabled: false,
          },
          {
            name: "WESLEY CHAPEL",
            disabled: false,
          },
          {
            name: "WEST ALLIS",
            disabled: false,
          },
          {
            name: "WEST BABYLON",
            disabled: false,
          },
          {
            name: "WEST BADEN SPRINGS",
            disabled: false,
          },
          {
            name: "WEST BEND",
            disabled: false,
          },
          {
            name: "WEST BERLIN",
            disabled: false,
          },
          {
            name: "WEST BOUNTIFUL",
            disabled: false,
          },
          {
            name: "WEST BOYLSTON",
            disabled: false,
          },
          {
            name: "WEST BRANCH",
            disabled: false,
          },
          {
            name: "WEST BRIDGEWATER",
            disabled: false,
          },
          {
            name: "WEST BROWNSVILLE",
            disabled: false,
          },
          {
            name: "WEST BURLINGTON",
            disabled: false,
          },
          {
            name: "WEST CHESTER",
            disabled: false,
          },
          {
            name: "WEST CHICAGO",
            disabled: false,
          },
          {
            name: "WEST COLUMBIA",
            disabled: false,
          },
          {
            name: "WEST COVINA",
            disabled: false,
          },
          {
            name: "WEST DEPTFORD",
            disabled: false,
          },
          {
            name: "WEST DES MOINES",
            disabled: false,
          },
          {
            name: "WEST DUNDEE",
            disabled: false,
          },
          {
            name: "WEST FARGO",
            disabled: false,
          },
          {
            name: "WEST FRANKFORT",
            disabled: false,
          },
          {
            name: "WEST GROVE",
            disabled: false,
          },
          {
            name: "WEST HARTFORD",
            disabled: false,
          },
          {
            name: "WEST HAVEN",
            disabled: false,
          },
          {
            name: "WEST HEMPSTEAD",
            disabled: false,
          },
          {
            name: "WEST HILLS",
            disabled: false,
          },
          {
            name: "WEST HOLLYWOOD",
            disabled: false,
          },
          {
            name: "WEST ISLIP",
            disabled: false,
          },
          {
            name: "WEST JEFFERSON",
            disabled: false,
          },
          {
            name: "WEST JORDAN",
            disabled: false,
          },
          {
            name: "WEST LAFAYETTE",
            disabled: false,
          },
          {
            name: "WEST LAKE HILLS",
            disabled: false,
          },
          {
            name: "WEST LEBANON",
            disabled: false,
          },
          {
            name: "WEST LINN",
            disabled: false,
          },
          {
            name: "WEST LONG BRANCH",
            disabled: false,
          },
          {
            name: "WEST MELBOURNE",
            disabled: false,
          },
          {
            name: "WEST MEMPHIS",
            disabled: false,
          },
          {
            name: "WEST MIFFLIN",
            disabled: false,
          },
          {
            name: "WEST MILFORD",
            disabled: false,
          },
          {
            name: "WEST MILWAUKEE",
            disabled: false,
          },
          {
            name: "WEST MONROE",
            disabled: false,
          },
          {
            name: "WEST NEW YORK",
            disabled: false,
          },
          {
            name: "WEST NEWTON",
            disabled: false,
          },
          {
            name: "WEST NYACK",
            disabled: false,
          },
          {
            name: "WEST ORANGE",
            disabled: false,
          },
          {
            name: "WEST PALM BEACH",
            disabled: false,
          },
          {
            name: "WEST PELZER",
            disabled: false,
          },
          {
            name: "WEST PEORIA",
            disabled: false,
          },
          {
            name: "WEST PITTSTON",
            disabled: false,
          },
          {
            name: "WEST PLAINS",
            disabled: false,
          },
          {
            name: "WEST POINT",
            disabled: false,
          },
          {
            name: "WEST READING",
            disabled: false,
          },
          {
            name: "WEST ROXBURY",
            disabled: false,
          },
          {
            name: "WEST RUTLAND",
            disabled: false,
          },
          {
            name: "WEST SACRAMENTO",
            disabled: false,
          },
          {
            name: "WEST SAINT PAUL",
            disabled: false,
          },
          {
            name: "WEST SAND LAKE",
            disabled: false,
          },
          {
            name: "WEST SAYVILLE",
            disabled: false,
          },
          {
            name: "WEST SENECA",
            disabled: false,
          },
          {
            name: "WEST SPRINGFIEL",
            disabled: false,
          },
          {
            name: "WEST SPRINGFIELD",
            disabled: false,
          },
          {
            name: "WEST ST PAUL",
            disabled: false,
          },
          {
            name: "WEST UNION",
            disabled: false,
          },
          {
            name: "WEST VALLEY CITY",
            disabled: false,
          },
          {
            name: "WEST WARWICK",
            disabled: false,
          },
          {
            name: "WEST WENDOVER",
            disabled: false,
          },
          {
            name: "WEST YARMOUTH",
            disabled: false,
          },
          {
            name: "WESTAMPTON",
            disabled: false,
          },
          {
            name: "WESTBOROUGH",
            disabled: false,
          },
          {
            name: "WESTBROOK",
            disabled: false,
          },
          {
            name: "WESTBURY",
            disabled: false,
          },
          {
            name: "WESTCHESTER",
            disabled: false,
          },
          {
            name: "WESTERLY",
            disabled: false,
          },
          {
            name: "WESTERN SPRINGS",
            disabled: false,
          },
          {
            name: "WESTERVILLE",
            disabled: false,
          },
          {
            name: "WESTFIELD",
            disabled: false,
          },
          {
            name: "WESTFORD",
            disabled: false,
          },
          {
            name: "WESTLAKE",
            disabled: false,
          },
          {
            name: "WESTLAKE VILLAG",
            disabled: false,
          },
          {
            name: "WESTLAKE VILLAGE",
            disabled: false,
          },
          {
            name: "WESTLAND",
            disabled: false,
          },
          {
            name: "WESTMINSTER",
            disabled: false,
          },
          {
            name: "WESTMONT",
            disabled: false,
          },
          {
            name: "WESTON",
            disabled: false,
          },
          {
            name: "WESTPORT",
            disabled: false,
          },
          {
            name: "WESTVILLE",
            disabled: false,
          },
          {
            name: "WESTWEGO",
            disabled: false,
          },
          {
            name: "WESTWOOD",
            disabled: false,
          },
          {
            name: "WESTWORTH VILLAGE",
            disabled: false,
          },
          {
            name: "WETHERSFIELD",
            disabled: false,
          },
          {
            name: "WETUMPKA",
            disabled: false,
          },
          {
            name: "WEXFORD",
            disabled: false,
          },
          {
            name: "WEYMOUTH",
            disabled: false,
          },
          {
            name: "WHARTON",
            disabled: false,
          },
          {
            name: "WHEAT RIDGE",
            disabled: false,
          },
          {
            name: "WHEATLAND",
            disabled: false,
          },
          {
            name: "WHEATON",
            disabled: false,
          },
          {
            name: "WHEELERSBURG",
            disabled: false,
          },
          {
            name: "WHEELING",
            disabled: false,
          },
          {
            name: "WHIPPANY",
            disabled: false,
          },
          {
            name: "WHITE BEAR LAKE",
            disabled: false,
          },
          {
            name: "WHITE HOUSE",
            disabled: false,
          },
          {
            name: "WHITE LAKE",
            disabled: false,
          },
          {
            name: "WHITE OAK",
            disabled: false,
          },
          {
            name: "WHITE PLAINS",
            disabled: false,
          },
          {
            name: "WHITE ROCK",
            disabled: false,
          },
          {
            name: "WHITE SULPHUR SPRINGS",
            disabled: false,
          },
          {
            name: "WHITEFISH",
            disabled: false,
          },
          {
            name: "WHITEFISH BAY",
            disabled: false,
          },
          {
            name: "WHITEHALL",
            disabled: false,
          },
          {
            name: "WHITEHOUSE",
            disabled: false,
          },
          {
            name: "WHITEHOUSE STATION",
            disabled: false,
          },
          {
            name: "WHITELAND",
            disabled: false,
          },
          {
            name: "WHITESBORO",
            disabled: false,
          },
          {
            name: "WHITESBURG",
            disabled: false,
          },
          {
            name: "WHITESTONE",
            disabled: false,
          },
          {
            name: "WHITEVILLE",
            disabled: false,
          },
          {
            name: "WHITEWATER",
            disabled: false,
          },
          {
            name: "WHITING",
            disabled: false,
          },
          {
            name: "WHITINSVILLE",
            disabled: false,
          },
          {
            name: "WHITLEY CITY",
            disabled: false,
          },
          {
            name: "WHITMAN",
            disabled: false,
          },
          {
            name: "WHITSETT",
            disabled: false,
          },
          {
            name: "WHITTIER",
            disabled: false,
          },
          {
            name: "WICHITA",
            disabled: false,
          },
          {
            name: "WICHITA FALLS",
            disabled: false,
          },
          {
            name: "WICKENBURG",
            disabled: false,
          },
          {
            name: "WIGGINS",
            disabled: false,
          },
          {
            name: "WILBRAHAM",
            disabled: false,
          },
          {
            name: "WILDOMAR",
            disabled: false,
          },
          {
            name: "WILDWOOD",
            disabled: false,
          },
          {
            name: "WILKES BARRE",
            disabled: false,
          },
          {
            name: "WILKES-BARRE",
            disabled: false,
          },
          {
            name: "WILKESBORO",
            disabled: false,
          },
          {
            name: "WILLCOX",
            disabled: false,
          },
          {
            name: "WILLIAMS",
            disabled: false,
          },
          {
            name: "WILLIAMSBURG",
            disabled: false,
          },
          {
            name: "WILLIAMSON",
            disabled: false,
          },
          {
            name: "WILLIAMSPORT",
            disabled: false,
          },
          {
            name: "WILLIAMSTON",
            disabled: false,
          },
          {
            name: "WILLIAMSTOWN",
            disabled: false,
          },
          {
            name: "WILLIAMSVILLE",
            disabled: false,
          },
          {
            name: "WILLIMANTIC",
            disabled: false,
          },
          {
            name: "WILLINGBORO",
            disabled: false,
          },
          {
            name: "WILLIS",
            disabled: false,
          },
          {
            name: "WILLISTON",
            disabled: false,
          },
          {
            name: "WILLISTON PARK",
            disabled: false,
          },
          {
            name: "WILLITS",
            disabled: false,
          },
          {
            name: "WILLMAR",
            disabled: false,
          },
          {
            name: "WILLOUGHBY",
            disabled: false,
          },
          {
            name: "WILLOUGHBY HILLS",
            disabled: false,
          },
          {
            name: "WILLOW GROVE",
            disabled: false,
          },
          {
            name: "WILLOW STREET",
            disabled: false,
          },
          {
            name: "WILLOWBROOK",
            disabled: false,
          },
          {
            name: "WILLOWICK",
            disabled: false,
          },
          {
            name: "WILLOWS",
            disabled: false,
          },
          {
            name: "WILMETTE",
            disabled: false,
          },
          {
            name: "WILMINGTON",
            disabled: false,
          },
          {
            name: "WILSON",
            disabled: false,
          },
          {
            name: "WILSONVILLE",
            disabled: false,
          },
          {
            name: "WILTON",
            disabled: false,
          },
          {
            name: "WILTON MANORS",
            disabled: false,
          },
          {
            name: "WIMAUMA",
            disabled: false,
          },
          {
            name: "WIMBERLEY",
            disabled: false,
          },
          {
            name: "WINAMAC",
            disabled: false,
          },
          {
            name: "WINCHENDON",
            disabled: false,
          },
          {
            name: "WINCHESTER",
            disabled: false,
          },
          {
            name: "WIND GAP",
            disabled: false,
          },
          {
            name: "WINDBER",
            disabled: false,
          },
          {
            name: "WINDER",
            disabled: false,
          },
          {
            name: "WINDERMERE",
            disabled: false,
          },
          {
            name: "WINDHAM",
            disabled: false,
          },
          {
            name: "WINDSOR",
            disabled: false,
          },
          {
            name: "WINDSOR HEIGHTS",
            disabled: false,
          },
          {
            name: "WINDSOR LOCKS",
            disabled: false,
          },
          {
            name: "WINFIELD",
            disabled: false,
          },
          {
            name: "WINGATE",
            disabled: false,
          },
          {
            name: "WINNEMUCCA",
            disabled: false,
          },
          {
            name: "WINNETKA",
            disabled: false,
          },
          {
            name: "WINNFIELD",
            disabled: false,
          },
          {
            name: "WINNSBORO",
            disabled: false,
          },
          {
            name: "WINONA",
            disabled: false,
          },
          {
            name: "WINOOSKI",
            disabled: false,
          },
          {
            name: "WINSLOW",
            disabled: false,
          },
          {
            name: "WINSTED",
            disabled: false,
          },
          {
            name: "WINSTON SALEM",
            disabled: false,
          },
          {
            name: "WINSTON-SALEM",
            disabled: false,
          },
          {
            name: "WINTER GARDEN",
            disabled: false,
          },
          {
            name: "WINTER HAVEN",
            disabled: false,
          },
          {
            name: "WINTER PARK",
            disabled: false,
          },
          {
            name: "WINTER SPRINGS",
            disabled: false,
          },
          {
            name: "WINTERSVILLE",
            disabled: false,
          },
          {
            name: "WINTERVILLE",
            disabled: false,
          },
          {
            name: "WINTHROP",
            disabled: false,
          },
          {
            name: "WISCASSET",
            disabled: false,
          },
          {
            name: "WISCONSIN DELLS",
            disabled: false,
          },
          {
            name: "WISCONSIN RAPIDS",
            disabled: false,
          },
          {
            name: "WIXOM",
            disabled: false,
          },
          {
            name: "WOBURN",
            disabled: false,
          },
          {
            name: "WOLCOTT",
            disabled: false,
          },
          {
            name: "WOLF POINT",
            disabled: false,
          },
          {
            name: "WOLFEBORO",
            disabled: false,
          },
          {
            name: "WOMELSDORF",
            disabled: false,
          },
          {
            name: "WOOD DALE",
            disabled: false,
          },
          {
            name: "WOOD RIVER",
            disabled: false,
          },
          {
            name: "WOOD VILLAGE",
            disabled: false,
          },
          {
            name: "WOODBINE",
            disabled: false,
          },
          {
            name: "WOODBRIDGE",
            disabled: false,
          },
          {
            name: "WOODBURN",
            disabled: false,
          },
          {
            name: "WOODBURY",
            disabled: false,
          },
          {
            name: "WOODFIN",
            disabled: false,
          },
          {
            name: "WOODHAVEN",
            disabled: false,
          },
          {
            name: "WOODINVILLE",
            disabled: false,
          },
          {
            name: "WOODLAKE",
            disabled: false,
          },
          {
            name: "WOODLAND",
            disabled: false,
          },
          {
            name: "WOODLAND HILLS",
            disabled: false,
          },
          {
            name: "WOODLAND PARK",
            disabled: false,
          },
          {
            name: "WOODLANDS",
            disabled: false,
          },
          {
            name: "WOODLYN",
            disabled: false,
          },
          {
            name: "WOODMERE",
            disabled: false,
          },
          {
            name: "WOODRIDGE",
            disabled: false,
          },
          {
            name: "WOODRUFF",
            disabled: false,
          },
          {
            name: "WOODS CROSS",
            disabled: false,
          },
          {
            name: "WOODSFIELD",
            disabled: false,
          },
          {
            name: "WOODSTOCK",
            disabled: false,
          },
          {
            name: "WOODSTOWN",
            disabled: false,
          },
          {
            name: "WOODSVILLE",
            disabled: false,
          },
          {
            name: "WOODVILLE",
            disabled: false,
          },
          {
            name: "WOODWARD",
            disabled: false,
          },
          {
            name: "WOODWAY",
            disabled: false,
          },
          {
            name: "WOONSOCKET",
            disabled: false,
          },
          {
            name: "WOOSTER",
            disabled: false,
          },
          {
            name: "WORCESTER",
            disabled: false,
          },
          {
            name: "WORTH",
            disabled: false,
          },
          {
            name: "WORTHINGTON",
            disabled: false,
          },
          {
            name: "WRENTHAM",
            disabled: false,
          },
          {
            name: "WRIGHTSTOWN",
            disabled: false,
          },
          {
            name: "WYANDOTTE",
            disabled: false,
          },
          {
            name: "WYCKOFF",
            disabled: false,
          },
          {
            name: "WYLIE",
            disabled: false,
          },
          {
            name: "WYNANTSKILL",
            disabled: false,
          },
          {
            name: "WYNCOTE",
            disabled: false,
          },
          {
            name: "WYNNE",
            disabled: false,
          },
          {
            name: "WYNNEWOOD",
            disabled: false,
          },
          {
            name: "WYOMING",
            disabled: false,
          },
          {
            name: "WYOMISSING",
            disabled: false,
          },
          {
            name: "WYTHEVILLE",
            disabled: false,
          },
          {
            name: "Wales",
            disabled: false,
          },
          {
            name: "Wall Township",
            disabled: false,
          },
          {
            name: "Warren",
            disabled: false,
          },
          {
            name: "Warrenton",
            disabled: false,
          },
          {
            name: "Warsaw",
            disabled: false,
          },
          {
            name: "Washington",
            disabled: false,
          },
          {
            name: "Washington Court Hou",
            disabled: false,
          },
          {
            name: "Waterford",
            disabled: false,
          },
          {
            name: "Watertown",
            disabled: false,
          },
          {
            name: "Waukesha",
            disabled: false,
          },
          {
            name: "Waupaca",
            disabled: false,
          },
          {
            name: "Wautoma",
            disabled: false,
          },
          {
            name: "Wauwatosa",
            disabled: false,
          },
          {
            name: "Wayne",
            disabled: false,
          },
          {
            name: "Waynesboro",
            disabled: false,
          },
          {
            name: "Weirton",
            disabled: false,
          },
          {
            name: "Wellston",
            disabled: false,
          },
          {
            name: "Wendover",
            disabled: false,
          },
          {
            name: "West Allis",
            disabled: false,
          },
          {
            name: "West Baden Springs",
            disabled: false,
          },
          {
            name: "West Bend",
            disabled: false,
          },
          {
            name: "West Bloomfield",
            disabled: false,
          },
          {
            name: "West Bloomfield Town",
            disabled: false,
          },
          {
            name: "West Covina",
            disabled: false,
          },
          {
            name: "West Hartford",
            disabled: false,
          },
          {
            name: "West Hollywood",
            disabled: false,
          },
          {
            name: "West Lafayette",
            disabled: false,
          },
          {
            name: "West Nyack",
            disabled: false,
          },
          {
            name: "West Point",
            disabled: false,
          },
          {
            name: "Westchester",
            disabled: false,
          },
          {
            name: "Western Springs",
            disabled: false,
          },
          {
            name: "Westlake Village",
            disabled: false,
          },
          {
            name: "Westmont",
            disabled: false,
          },
          {
            name: "Weston",
            disabled: false,
          },
          {
            name: "Wheaton",
            disabled: false,
          },
          {
            name: "Wheeling",
            disabled: false,
          },
          {
            name: "White Hall",
            disabled: false,
          },
          {
            name: "White Lake",
            disabled: false,
          },
          {
            name: "White Plains",
            disabled: false,
          },
          {
            name: "Whitehall",
            disabled: false,
          },
          {
            name: "Whitley City",
            disabled: false,
          },
          {
            name: "Wichita",
            disabled: false,
          },
          {
            name: "Wilkes-Barre Township",
            disabled: false,
          },
          {
            name: "Williamstown",
            disabled: false,
          },
          {
            name: "Wilsonville",
            disabled: false,
          },
          {
            name: "Winston Salem",
            disabled: false,
          },
          {
            name: "Wisconsin Rapids",
            disabled: false,
          },
          {
            name: "Woodbury",
            disabled: false,
          },
          {
            name: "Woodhaven",
            disabled: false,
          },
          {
            name: "Woodland Hills",
            disabled: false,
          },
          {
            name: "Woodland Park",
            disabled: false,
          },
          {
            name: "Woodmere",
            disabled: false,
          },
          {
            name: "XENIA",
            disabled: false,
          },
          {
            name: "YADKINVILLE",
            disabled: false,
          },
          {
            name: "YAKIMA",
            disabled: false,
          },
          {
            name: "YANCEYVILLE",
            disabled: false,
          },
          {
            name: "YANKTON",
            disabled: false,
          },
          {
            name: "YAPHANK",
            disabled: false,
          },
          {
            name: "YARDLEY",
            disabled: false,
          },
          {
            name: "YARDVILLE",
            disabled: false,
          },
          {
            name: "YARMOUTH",
            disabled: false,
          },
          {
            name: "YAZOO CITY",
            disabled: false,
          },
          {
            name: "YEADON",
            disabled: false,
          },
          {
            name: "YELM",
            disabled: false,
          },
          {
            name: "YOAKUM",
            disabled: false,
          },
          {
            name: "YONKERS",
            disabled: false,
          },
          {
            name: "YORBA LINDA",
            disabled: false,
          },
          {
            name: "YORK",
            disabled: false,
          },
          {
            name: "YORKSHIRE",
            disabled: false,
          },
          {
            name: "YORKTOWN",
            disabled: false,
          },
          {
            name: "YORKTOWN HEIGHTS",
            disabled: false,
          },
          {
            name: "YORKVILLE",
            disabled: false,
          },
          {
            name: "YOUNGSTOWN",
            disabled: false,
          },
          {
            name: "YOUNGSVILLE",
            disabled: false,
          },
          {
            name: "YPSILANTI",
            disabled: false,
          },
          {
            name: "YREKA",
            disabled: false,
          },
          {
            name: "YUBA CITY",
            disabled: false,
          },
          {
            name: "YUCAIPA",
            disabled: false,
          },
          {
            name: "YUCCA VALLEY",
            disabled: false,
          },
          {
            name: "YUKON",
            disabled: false,
          },
          {
            name: "YULEE",
            disabled: false,
          },
          {
            name: "YUMA",
            disabled: false,
          },
          {
            name: "Yonkers",
            disabled: false,
          },
          {
            name: "Yorba Linda",
            disabled: false,
          },
          {
            name: "York",
            disabled: false,
          },
          {
            name: "Yorktown",
            disabled: false,
          },
          {
            name: "Yucca Valley",
            disabled: false,
          },
          {
            name: "ZACHARY",
            disabled: false,
          },
          {
            name: "ZANESVILLE",
            disabled: false,
          },
          {
            name: "ZAPATA",
            disabled: false,
          },
          {
            name: "ZEBULON",
            disabled: false,
          },
          {
            name: "ZELIENOPLE",
            disabled: false,
          },
          {
            name: "ZEPHYR COVE",
            disabled: false,
          },
          {
            name: "ZEPHYRHILLS",
            disabled: false,
          },
          {
            name: "ZION",
            disabled: false,
          },
          {
            name: "ZIONSVILLE",
            disabled: false,
          },
        ],
        value: "",
      },
      retailer: {
        options: [
          {
            name: "ADUSA",
            disabled: false,
          },
          {
            name: "Albertsons",
            disabled: false,
          },
          {
            name: "BJ's",
            disabled: false,
          },
          {
            name: "CVS",
            disabled: false,
          },
          {
            name: "Costco",
            disabled: false,
          },
          {
            name: "HEB",
            disabled: false,
          },
          {
            name: "Kroger",
            disabled: false,
          },
          {
            name: "Meijer",
            disabled: false,
          },
          {
            name: "Rite Aid",
            disabled: false,
          },
          {
            name: "ShopRite",
            disabled: false,
          },
          {
            name: "Target",
            disabled: false,
          },
          {
            name: "Walgreens",
            disabled: false,
          },
          {
            name: "Walmart",
            disabled: false,
          },
        ],
        value: "",
      },
      store: {
        options: [
          {
            name: "1, ADUSA, BROOKLINE, MA",
            disabled: false,
          },
          {
            name: "1, ADUSA, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "1, Albertsons, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "1, BJ's, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "1, Costco, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "1, Kroger, DODGE CITY, KS",
            disabled: false,
          },
          {
            name: "1, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "1, Kroger, La Crescenta, CA",
            disabled: false,
          },
          {
            name: "1, Kroger, Salt Lake City, UT",
            disabled: false,
          },
          {
            name: "1, Kroger, Scottsburg, IN",
            disabled: false,
          },
          {
            name: "1, Walmart, ROGERS, AR",
            disabled: false,
          },
          {
            name: "10, ADUSA, IRWIN, PA",
            disabled: false,
          },
          {
            name: "10, Albertsons, EVERGREEN, CO",
            disabled: false,
          },
          {
            name: "10, BJ's, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "10, Costco, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "10, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "10, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "10, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "10, Kroger, GOLETA, CA",
            disabled: false,
          },
          {
            name: "10, Kroger, Groveport, OH",
            disabled: false,
          },
          {
            name: "10, Kroger, HUTCHINSON, KS",
            disabled: false,
          },
          {
            name: "10, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "10, Kroger, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "10, Walmart, TAHLEQUAH, OK",
            disabled: false,
          },
          {
            name: "100, ADUSA, COCKEYSVILLE, MD",
            disabled: false,
          },
          {
            name: "100, ADUSA, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "100, BJ's, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "100, Kroger, GREENWOOD VILLAGE, CO",
            disabled: false,
          },
          {
            name: "100, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "100, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "100, Target, MINNETONKA, MN",
            disabled: false,
          },
          {
            name: "100, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "1000, Costco, ELKRIDGE, MD",
            disabled: false,
          },
          {
            name: "1000, Target, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "1000, Walmart, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "10001, CVS, MORRISTOWN, NJ",
            disabled: false,
          },
          {
            name: "10002, Walgreens, TULARE, CA",
            disabled: false,
          },
          {
            name: "10003, CVS, BRANSON, MO",
            disabled: false,
          },
          {
            name: "10003, Walgreens, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "10005, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "10006, CVS, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "10007, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "10007, Walgreens, WATERTOWN, SD",
            disabled: false,
          },
          {
            name: "10008, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "10009, CVS, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "1001, CVS, MALDEN, MA",
            disabled: false,
          },
          {
            name: "1001, Costco, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "1001, Target, Nottingham, MD",
            disabled: false,
          },
          {
            name: "1001, Walmart, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "10013, CVS, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "10016, CVS, PRINCETON, TX",
            disabled: false,
          },
          {
            name: "10017, CVS, IPSWICH, MA",
            disabled: false,
          },
          {
            name: "10018, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "10019, CVS, TEXARKANA, AR",
            disabled: false,
          },
          {
            name: "1002, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "1002, Costco, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "1002, Target, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "1002, Walgreens, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "1002, Walmart, LINTON, IN",
            disabled: false,
          },
          {
            name: "10020, CVS, CLINTON, MS",
            disabled: false,
          },
          {
            name: "10021, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "10022, CVS, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "10025, CVS, CRYSTAL CITY, MO",
            disabled: false,
          },
          {
            name: "10026, CVS, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "10028, CVS, YUMA, AZ",
            disabled: false,
          },
          {
            name: "10029, Walgreens, BAY VILLAGE, OH",
            disabled: false,
          },
          {
            name: "1003, CVS, NASHUA, NH",
            disabled: false,
          },
          {
            name: "1003, Costco, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "1003, Target, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "1003, Walmart, PLANO, IL",
            disabled: false,
          },
          {
            name: "10031, CVS, OCEAN, NJ",
            disabled: false,
          },
          {
            name: "10032, CVS, MARION, IA",
            disabled: false,
          },
          {
            name: "10032, Walgreens, BRECKSVILLE, OH",
            disabled: false,
          },
          {
            name: "10034, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10037, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "10039, CVS, WAYLAND, MA",
            disabled: false,
          },
          {
            name: "1004, CVS, SALEM, NH",
            disabled: false,
          },
          {
            name: "1004, Costco, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1004, Target, BOWIE, MD",
            disabled: false,
          },
          {
            name: "1004, Walgreens, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "1004, Walmart, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "10040, CVS, YONKERS, NY",
            disabled: false,
          },
          {
            name: "10045, CVS, READING, PA",
            disabled: false,
          },
          {
            name: "10047, CVS, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "10048, CVS, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "10048, Walgreens, KANEOHE, HI",
            disabled: false,
          },
          {
            name: "10049, CVS, COLUMBIA, KY",
            disabled: false,
          },
          {
            name: "1005, Costco, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "1005, Target, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1005, Walmart, WAVERLY, IA",
            disabled: false,
          },
          {
            name: "10050, CVS, BENTON, KY",
            disabled: false,
          },
          {
            name: "10050, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "10051, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10051, Walgreens, MASON, OH",
            disabled: false,
          },
          {
            name: "10052, CVS, WILMETTE, IL",
            disabled: false,
          },
          {
            name: "10053, CVS, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "10053, Walgreens, UPPER ARLINGTON, OH",
            disabled: false,
          },
          {
            name: "10054, Walgreens, ONTARIO, OR",
            disabled: false,
          },
          {
            name: "10055, CVS, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "10056, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10056, Walgreens, SAINT HELENS, OR",
            disabled: false,
          },
          {
            name: "10057, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "10059, Walgreens, CABOT, AR",
            disabled: false,
          },
          {
            name: "1006, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1006, CVS, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "1006, Costco, SELMA, TX",
            disabled: false,
          },
          {
            name: "1006, Target, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "1006, Walmart, CORDELE, GA",
            disabled: false,
          },
          {
            name: "10060, CVS, WAILUKU, HI",
            disabled: false,
          },
          {
            name: "10061, CVS, AMBLER, PA",
            disabled: false,
          },
          {
            name: "10062, CVS, MORGANVILLE, NJ",
            disabled: false,
          },
          {
            name: "10062, Walgreens, DELTONA, FL",
            disabled: false,
          },
          {
            name: "10063, Walgreens, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "10064, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "10065, CVS, SAND SPRINGS, OK",
            disabled: false,
          },
          {
            name: "10066, Walgreens, SWEETWATER, TN",
            disabled: false,
          },
          {
            name: "10067, Walgreens, PHILADELPHIA, MS",
            disabled: false,
          },
          {
            name: "10068, CVS, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "10069, Walgreens, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "1007, CVS, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "1007, Costco, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "1007, Target, LAUREL, MD",
            disabled: false,
          },
          {
            name: "1007, Walmart, RICHLAND CENTER, WI",
            disabled: false,
          },
          {
            name: "10070, CVS, WICHITA, KS",
            disabled: false,
          },
          {
            name: "10070, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "10071, CVS, ARNOLD, MO",
            disabled: false,
          },
          {
            name: "10072, CVS, SAVANNAH, TN",
            disabled: false,
          },
          {
            name: "10073, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10073, Walgreens, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "10074, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "10074, Walgreens, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "10075, CVS, WICHITA, KS",
            disabled: false,
          },
          {
            name: "10076, CVS, ENTERPRISE, AL",
            disabled: false,
          },
          {
            name: "10076, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "10077, CVS, WICHITA, KS",
            disabled: false,
          },
          {
            name: "10077, Walgreens, BATH, ME",
            disabled: false,
          },
          {
            name: "10078, CVS, HALLANDALE BEACH, FL",
            disabled: false,
          },
          {
            name: "10078, Walgreens, BENTON HARBOR, MI",
            disabled: false,
          },
          {
            name: "10079, Walgreens, NORTON SHORES, MI",
            disabled: false,
          },
          {
            name: "1008, Costco, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "1008, Target, WALDORF, MD",
            disabled: false,
          },
          {
            name: "1008, Walmart, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "10080, CVS, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "10080, Walgreens, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "10081, Walgreens, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "10082, Walgreens, CREVE COEUR, MO",
            disabled: false,
          },
          {
            name: "10083, CVS, WOBURN, MA",
            disabled: false,
          },
          {
            name: "10083, Walgreens, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "10084, Rite Aid, CLINTON, MA",
            disabled: false,
          },
          {
            name: "10084, Walgreens, HELENA, MT",
            disabled: false,
          },
          {
            name: "10085, Walgreens, GARNER, NC",
            disabled: false,
          },
          {
            name: "10086, Walgreens, MOUNT AIRY, NC",
            disabled: false,
          },
          {
            name: "10087, CVS, WEST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "10087, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "10088, CVS, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "10088, Walgreens, WALLACE, NC",
            disabled: false,
          },
          {
            name: "1009, CVS, CHARLESTOWN, MA",
            disabled: false,
          },
          {
            name: "1009, Costco, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "1009, Target, STERLING, VA",
            disabled: false,
          },
          {
            name: "1009, Walmart, REPUBLIC, MO",
            disabled: false,
          },
          {
            name: "10090, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "10090, Walgreens, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "10092, Rite Aid, WEBSTER, MA",
            disabled: false,
          },
          {
            name: "10094, CVS, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "10094, Walgreens, EDMOND, OK",
            disabled: false,
          },
          {
            name: "10095, Walgreens, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "10098, CVS, MOUNT PLEASANT, MI",
            disabled: false,
          },
          {
            name: "10099, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "101, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "101, BJ's, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "101, Costco, BEND, OR",
            disabled: false,
          },
          {
            name: "101, Kroger, BELFAIR, WA",
            disabled: false,
          },
          {
            name: "101, Kroger, Plover, WI",
            disabled: false,
          },
          {
            name: "101, Kroger, Romulus, MI",
            disabled: false,
          },
          {
            name: "101, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "101, Kroger, THORNTON, CO",
            disabled: false,
          },
          {
            name: "101, Walgreens, CASTRO VALLEY, CA",
            disabled: false,
          },
          {
            name: "101, Walmart, ROLLA, MO",
            disabled: false,
          },
          {
            name: "1010, Albertsons, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "1010, CVS, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "1010, Costco, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "1010, Rite Aid, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "1010, Target, AMHERST, NY",
            disabled: false,
          },
          {
            name: "1010, Walmart, ROCKINGHAM, NC",
            disabled: false,
          },
          {
            name: "10100, Walgreens, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "10101, CVS, STILLWATER, OK",
            disabled: false,
          },
          {
            name: "10102, CVS, ENID, OK",
            disabled: false,
          },
          {
            name: "10103, CVS, NEWARK, DE",
            disabled: false,
          },
          {
            name: "10103, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "10104, Walgreens, SARATOGA SPRINGS, UT",
            disabled: false,
          },
          {
            name: "10106, CVS, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "10106, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "10107, CVS, MISSION, TX",
            disabled: false,
          },
          {
            name: "10107, Walgreens, WALLA WALLA, WA",
            disabled: false,
          },
          {
            name: "10108, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "10109, Walgreens, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "1011, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1011, CVS, DANVERS, MA",
            disabled: false,
          },
          {
            name: "1011, Costco, CHICO, CA",
            disabled: false,
          },
          {
            name: "1011, Target, WILLIAMSVILLE, NY",
            disabled: false,
          },
          {
            name: "1011, Walmart, RINCON, GA",
            disabled: false,
          },
          {
            name: "10110, Walgreens, LEEDS, AL",
            disabled: false,
          },
          {
            name: "10111, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10111, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "10114, CVS, ANKENY, IA",
            disabled: false,
          },
          {
            name: "10114, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "10115, CVS, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "10116, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "10117, Walgreens, GOLDEN, CO",
            disabled: false,
          },
          {
            name: "10118, CVS, NIXA, MO",
            disabled: false,
          },
          {
            name: "10119, CVS, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "10119, Walgreens, BERLIN, CT",
            disabled: false,
          },
          {
            name: "1012, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1012, Costco, OMAHA, NE",
            disabled: false,
          },
          {
            name: "1012, Target, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "1012, Walmart, BEAVER DAM, WI",
            disabled: false,
          },
          {
            name: "10121, CVS, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "10121, Walgreens, JASPER, GA",
            disabled: false,
          },
          {
            name: "10122, CVS, STOCK ISLAND, FL",
            disabled: false,
          },
          {
            name: "10122, Walgreens, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "10123, Walgreens, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "10124, CVS, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "10124, Walgreens, ELKHART, IN",
            disabled: false,
          },
          {
            name: "10125, Walgreens, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "10126, Walgreens, BROUSSARD, LA",
            disabled: false,
          },
          {
            name: "10127, CVS, BARRE, VT",
            disabled: false,
          },
          {
            name: "10127, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "10128, CVS, FREELAND, PA",
            disabled: false,
          },
          {
            name: "10128, Walgreens, WARE, MA",
            disabled: false,
          },
          {
            name: "10129, Walgreens, BYRON CENTER, MI",
            disabled: false,
          },
          {
            name: "1013, CVS, ENGLEWOOD, FL",
            disabled: false,
          },
          {
            name: "1013, Costco, UNION GAP, WA",
            disabled: false,
          },
          {
            name: "1013, Target, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1013, Walmart, CLINTON, IN",
            disabled: false,
          },
          {
            name: "10130, CVS, HEBRON, CT",
            disabled: false,
          },
          {
            name: "10130, Walgreens, PARKVILLE, MO",
            disabled: false,
          },
          {
            name: "10131, Walgreens, NATCHEZ, MS",
            disabled: false,
          },
          {
            name: "10132, Walgreens, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "10133, Walgreens, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "10134, Walgreens, FRANKLIN SQUARE, NY",
            disabled: false,
          },
          {
            name: "10135, Walgreens, NEW YORK, NY",
            disabled: false,
          },
          {
            name: "10137, CVS, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "10137, Walgreens, SANDY, OR",
            disabled: false,
          },
          {
            name: "10138, CVS, CROSSROADS, TX",
            disabled: false,
          },
          {
            name: "10138, Walgreens, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "10139, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "10139, Walgreens, VIDOR, TX",
            disabled: false,
          },
          {
            name: "1014, Costco, COLORADO SPRING, CO",
            disabled: false,
          },
          {
            name: "1014, Rite Aid, BLAIRSVILLE, PA",
            disabled: false,
          },
          {
            name: "1014, Target, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "1014, Walmart, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "10140, CVS, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "10140, Walgreens, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "10141, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10141, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "10142, CVS, PHARR, TX",
            disabled: false,
          },
          {
            name: "10142, Walgreens, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "10143, CVS, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "10144, Walgreens, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "10145, CVS, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "10145, Walgreens, NORTH PORT, FL",
            disabled: false,
          },
          {
            name: "10147, CVS, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "10147, Walgreens, QUINCY, FL",
            disabled: false,
          },
          {
            name: "10148, CVS, HOBBS, NM",
            disabled: false,
          },
          {
            name: "10148, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "10149, CVS, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "10149, Walgreens, FISHERS, IN",
            disabled: false,
          },
          {
            name: "1015, Costco, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "1015, Target, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "1015, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "1015, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10150, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "10150, Walgreens, GARDNER, KS",
            disabled: false,
          },
          {
            name: "10151, CVS, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "10151, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "10152, CVS, CLINTON, MO",
            disabled: false,
          },
          {
            name: "10152, Walgreens, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "10153, Walgreens, POPLAR BLUFF, MO",
            disabled: false,
          },
          {
            name: "10154, Walgreens, MAIDEN, NC",
            disabled: false,
          },
          {
            name: "10155, CVS, HAZARD, KY",
            disabled: false,
          },
          {
            name: "10156, CVS, ABERDEEN, NC",
            disabled: false,
          },
          {
            name: "10156, Walgreens, MOUNT EPHRAIM, NJ",
            disabled: false,
          },
          {
            name: "10157, CVS, CAMERON, NC",
            disabled: false,
          },
          {
            name: "10157, Walgreens, AUBURN, NY",
            disabled: false,
          },
          {
            name: "10158, Walgreens, CORTLAND, NY",
            disabled: false,
          },
          {
            name: "10159, CVS, WICHITA, KS",
            disabled: false,
          },
          {
            name: "10159, Walgreens, ROME, NY",
            disabled: false,
          },
          {
            name: "1016, Costco, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "1016, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1016, Target, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "1016, Walmart, THIBODAUX, LA",
            disabled: false,
          },
          {
            name: "10160, CVS, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "10162, CVS, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "10162, Walgreens, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "10163, CVS, WISCONSIN RAPIDS, WI",
            disabled: false,
          },
          {
            name: "10163, Walgreens, SENECA, SC",
            disabled: false,
          },
          {
            name: "10164, Walgreens, MADISONVILLE, TN",
            disabled: false,
          },
          {
            name: "10165, CVS, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "10165, Walgreens, HERNDON, VA",
            disabled: false,
          },
          {
            name: "10166, CVS, YONKERS, NY",
            disabled: false,
          },
          {
            name: "10166, Rite Aid, REVERE, MA",
            disabled: false,
          },
          {
            name: "10168, CVS, COLLEGE PARK, MD",
            disabled: false,
          },
          {
            name: "10168, Walgreens, GRAND BAY, AL",
            disabled: false,
          },
          {
            name: "10169, CVS, KEY WEST, FL",
            disabled: false,
          },
          {
            name: "10169, Walgreens, SPANISH FORT, AL",
            disabled: false,
          },
          {
            name: "1017, CVS, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1017, Costco, VISALIA, CA",
            disabled: false,
          },
          {
            name: "1017, Target, CHESTER, VA",
            disabled: false,
          },
          {
            name: "1017, Walmart, MANNING, SC",
            disabled: false,
          },
          {
            name: "10170, CVS, VIENNA, VA",
            disabled: false,
          },
          {
            name: "10170, Walgreens, CONWAY, AR",
            disabled: false,
          },
          {
            name: "10171, CVS, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "10172, CVS, WAUSAU, WI",
            disabled: false,
          },
          {
            name: "10173, CVS, CARMEL, IN",
            disabled: false,
          },
          {
            name: "10175, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "10175, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "10176, CVS, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "10177, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "10177, Walgreens, NORWALK, CT",
            disabled: false,
          },
          {
            name: "10178, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10179, Walgreens, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "1018, CVS, WATERTOWN, MA",
            disabled: false,
          },
          {
            name: "1018, Costco, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1018, Target, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1018, Walmart, EASTMAN, GA",
            disabled: false,
          },
          {
            name: "10181, CVS, HOOVER, AL",
            disabled: false,
          },
          {
            name: "10181, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "10184, Walgreens, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "10186, Walgreens, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "10187, CVS, SANDY, UT",
            disabled: false,
          },
          {
            name: "10187, Walgreens, MOORHEAD, MN",
            disabled: false,
          },
          {
            name: "10188, Walgreens, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "10189, Walgreens, WORTHINGTON, MN",
            disabled: false,
          },
          {
            name: "1019, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1019, Costco, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "1019, Rite Aid, VALLEY COTTAGE, NY",
            disabled: false,
          },
          {
            name: "1019, Target, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "1019, Walmart, CANON CITY, CO",
            disabled: false,
          },
          {
            name: "10190, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "10190, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10191, Walgreens, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "10192, Walgreens, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "10193, CVS, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "10193, Walgreens, DESOTO, TX",
            disabled: false,
          },
          {
            name: "10195, Walgreens, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "10196, Walgreens, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "10197, CVS, MORRISVILLE, VT",
            disabled: false,
          },
          {
            name: "10197, Walgreens, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "10198, Walgreens, EL DORADO, AR",
            disabled: false,
          },
          {
            name: "10199, CVS, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "10199, Rite Aid, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "10199, Walgreens, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "102, ADUSA, WILSON, NC",
            disabled: false,
          },
          {
            name: "102, BJ's, AKRON, OH",
            disabled: false,
          },
          {
            name: "102, Costco, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "102, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "102, Kroger, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "102, Kroger, Springfield, MO",
            disabled: false,
          },
          {
            name: "102, Kroger, Sun Prairie, WI",
            disabled: false,
          },
          {
            name: "102, Meijer, KETTERING, OH",
            disabled: false,
          },
          {
            name: "102, ShopRite, BRONX, NY",
            disabled: false,
          },
          {
            name: "102, Walmart, STUTTGART, AR",
            disabled: false,
          },
          {
            name: "1020, CVS, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "1020, Costco, MIDDLETON, WI",
            disabled: false,
          },
          {
            name: "1020, Walmart, ALBERT LEA, MN",
            disabled: false,
          },
          {
            name: "10200, CVS, SHELBYVILLE, KY",
            disabled: false,
          },
          {
            name: "10201, Walgreens, DINUBA, CA",
            disabled: false,
          },
          {
            name: "10202, CVS, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "10202, Walgreens, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "10203, Rite Aid, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "10203, Walgreens, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "10204, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "10204, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "10205, CVS, EMINENCE, KY",
            disabled: false,
          },
          {
            name: "10205, Walgreens, TROY, IL",
            disabled: false,
          },
          {
            name: "10206, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "10207, CVS, OXFORD, AL",
            disabled: false,
          },
          {
            name: "10207, Walgreens, SHEPHERDSVILLE, KY",
            disabled: false,
          },
          {
            name: "10209, CVS, UNIONTOWN, OH",
            disabled: false,
          },
          {
            name: "10209, Rite Aid, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "10209, Walgreens, NORTH ANDOVER, MA",
            disabled: false,
          },
          {
            name: "1021, CVS, SOUTH DENNIS, MA",
            disabled: false,
          },
          {
            name: "1021, Costco, MAPLEWOOD, MN",
            disabled: false,
          },
          {
            name: "1021, Rite Aid, OLD FORGE, PA",
            disabled: false,
          },
          {
            name: "1021, Target, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1021, Walmart, WARRENTON, MO",
            disabled: false,
          },
          {
            name: "10210, CVS, BARDONIA, NY",
            disabled: false,
          },
          {
            name: "10210, Walgreens, SARTELL, MN",
            disabled: false,
          },
          {
            name: "10211, CVS, MAPLEWOOD, NJ",
            disabled: false,
          },
          {
            name: "10211, Walgreens, WARRENTON, MO",
            disabled: false,
          },
          {
            name: "10212, Walgreens, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "10213, CVS, DURANT, OK",
            disabled: false,
          },
          {
            name: "10214, CVS, JENKS, OK",
            disabled: false,
          },
          {
            name: "10215, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10215, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10216, CVS, COLCHESTER, VT",
            disabled: false,
          },
          {
            name: "10218, CVS, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "10218, Walgreens, PENN YAN, NY",
            disabled: false,
          },
          {
            name: "10219, Walgreens, WATERTOWN, NY",
            disabled: false,
          },
          {
            name: "1022, CVS, CAMBRIDGE, MA",
            disabled: false,
          },
          {
            name: "1022, Costco, PARKER, CO",
            disabled: false,
          },
          {
            name: "1022, Target, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "1022, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "10220, CVS, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "10220, Walgreens, BEDFORD, OH",
            disabled: false,
          },
          {
            name: "10221, CVS, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "10222, CVS, MILFORD, DE",
            disabled: false,
          },
          {
            name: "10222, Walgreens, LORAIN, OH",
            disabled: false,
          },
          {
            name: "10223, CVS, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "10223, Walgreens, MUSKOGEE, OK",
            disabled: false,
          },
          {
            name: "10226, Walgreens, IRMO, SC",
            disabled: false,
          },
          {
            name: "10227, CVS, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "10227, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "10228, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "10229, CVS, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "10229, Walgreens, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "1023, CVS, BURLINGTON, MA",
            disabled: false,
          },
          {
            name: "1023, Costco, MIAMI, FL",
            disabled: false,
          },
          {
            name: "1023, Target, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "1023, Walmart, GALAX, VA",
            disabled: false,
          },
          {
            name: "10230, CVS, PROVO, UT",
            disabled: false,
          },
          {
            name: "10230, Walgreens, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "10231, Walgreens, ALICE, TX",
            disabled: false,
          },
          {
            name: "10232, CVS, ROY, UT",
            disabled: false,
          },
          {
            name: "10232, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "10233, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "10234, CVS, OGDEN, UT",
            disabled: false,
          },
          {
            name: "10234, Walgreens, GRAND CHUTE, WI",
            disabled: false,
          },
          {
            name: "10235, Walgreens, DE PERE, WI",
            disabled: false,
          },
          {
            name: "10236, Walgreens, NEENAH, WI",
            disabled: false,
          },
          {
            name: "10237, CVS, ROCKAWAY, NJ",
            disabled: false,
          },
          {
            name: "10237, Walgreens, REEDSBURG, WI",
            disabled: false,
          },
          {
            name: "10238, CVS, CLAYMONT, DE",
            disabled: false,
          },
          {
            name: "10239, Walgreens, WATERTOWN, NY",
            disabled: false,
          },
          {
            name: "1024, Target, LOMBARD, IL",
            disabled: false,
          },
          {
            name: "1024, Walmart, SWAINSBORO, GA",
            disabled: false,
          },
          {
            name: "10240, CVS, MENLO PARK, CA",
            disabled: false,
          },
          {
            name: "10240, Walgreens, BRYANT, AR",
            disabled: false,
          },
          {
            name: "10241, CVS, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "10241, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "10242, Walgreens, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "10243, CVS, GRAND ISLAND, NE",
            disabled: false,
          },
          {
            name: "10243, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "10244, CVS, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "10244, Walgreens, WESTBROOK, CT",
            disabled: false,
          },
          {
            name: "10246, CVS, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "10246, Walgreens, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "10247, Walgreens, RINGGOLD, GA",
            disabled: false,
          },
          {
            name: "10248, CVS, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "10248, Walgreens, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "10249, CVS, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "1025, CVS, SALEM, MA",
            disabled: false,
          },
          {
            name: "1025, Costco, STAFFORD TOWNSH, NJ",
            disabled: false,
          },
          {
            name: "1025, Rite Aid, MACOMB, MI",
            disabled: false,
          },
          {
            name: "1025, Target, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "1025, Walmart, MCCOMB, MS",
            disabled: false,
          },
          {
            name: "10250, Walgreens, ALMA, MI",
            disabled: false,
          },
          {
            name: "10251, CVS, HOPEWELL, VA",
            disabled: false,
          },
          {
            name: "10251, Walgreens, SAINT JOHNS, MI",
            disabled: false,
          },
          {
            name: "10252, CVS, HASTINGS, MN",
            disabled: false,
          },
          {
            name: "10253, Walgreens, CONCORD, NC",
            disabled: false,
          },
          {
            name: "10255, CVS, VAN BUREN, AR",
            disabled: false,
          },
          {
            name: "10255, Walgreens, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "10256, CVS, CAPE GIRARDEAU, MO",
            disabled: false,
          },
          {
            name: "10256, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "10257, Walgreens, MONCKS CORNER, SC",
            disabled: false,
          },
          {
            name: "10258, Walgreens, MINERAL WELLS, TX",
            disabled: false,
          },
          {
            name: "10259, CVS, DYER, IN",
            disabled: false,
          },
          {
            name: "10259, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1026, Costco, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1026, Target, NAPA, CA",
            disabled: false,
          },
          {
            name: "1026, Walmart, BEDFORD, IN",
            disabled: false,
          },
          {
            name: "10260, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "10261, CVS, BRIDGETON, MO",
            disabled: false,
          },
          {
            name: "10261, Walgreens, DEEP RIVER, CT",
            disabled: false,
          },
          {
            name: "10262, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "10262, Walgreens, SOUTH GATE, CA",
            disabled: false,
          },
          {
            name: "10264, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10264, Rite Aid, DERRY, NH",
            disabled: false,
          },
          {
            name: "10264, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "10265, CVS, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "10265, Rite Aid, HUDSON, NH",
            disabled: false,
          },
          {
            name: "10265, Walgreens, SANDY SPRINGS, GA",
            disabled: false,
          },
          {
            name: "10266, Rite Aid, HUDSON, NH",
            disabled: false,
          },
          {
            name: "10266, Walgreens, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "10267, CVS, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "10267, Rite Aid, LONDONDERRY, NH",
            disabled: false,
          },
          {
            name: "10267, Walgreens, HOUMA, LA",
            disabled: false,
          },
          {
            name: "10268, Rite Aid, MILFORD, NH",
            disabled: false,
          },
          {
            name: "10268, Walgreens, BELLINGHAM, MA",
            disabled: false,
          },
          {
            name: "10269, Rite Aid, MILFORD, NH",
            disabled: false,
          },
          {
            name: "10269, Walgreens, LAKEVILLE, MA",
            disabled: false,
          },
          {
            name: "1027, CVS, NORWICH, CT",
            disabled: false,
          },
          {
            name: "1027, Costco, SHERIDAN, CO",
            disabled: false,
          },
          {
            name: "1027, Target, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "1027, Walmart, CONCORD, NC",
            disabled: false,
          },
          {
            name: "10270, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "10270, Rite Aid, NASHUA, NH",
            disabled: false,
          },
          {
            name: "10270, Walgreens, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "10271, CVS, DENTON, TX",
            disabled: false,
          },
          {
            name: "10272, CVS, CLAREMORE, OK",
            disabled: false,
          },
          {
            name: "10272, Walgreens, WHITMAN, MA",
            disabled: false,
          },
          {
            name: "10273, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "10273, Rite Aid, SALEM, NH",
            disabled: false,
          },
          {
            name: "10273, Walgreens, PICAYUNE, MS",
            disabled: false,
          },
          {
            name: "10274, CVS, DUNCAN, OK",
            disabled: false,
          },
          {
            name: "10274, Rite Aid, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "10274, Walgreens, BREVARD, NC",
            disabled: false,
          },
          {
            name: "10275, CVS, MCALESTER, OK",
            disabled: false,
          },
          {
            name: "10275, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "10276, Rite Aid, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "10276, Walgreens, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "10277, Rite Aid, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "10278, CVS, LIBERTY, KY",
            disabled: false,
          },
          {
            name: "10278, Rite Aid, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "10278, Walgreens, LONG BEACH, NY",
            disabled: false,
          },
          {
            name: "1028, Costco, MESA, AZ",
            disabled: false,
          },
          {
            name: "1028, Target, West Covina, CA",
            disabled: false,
          },
          {
            name: "1028, Walmart, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "10280, CVS, ROLLA, MO",
            disabled: false,
          },
          {
            name: "10280, Rite Aid, LACONIA, NH",
            disabled: false,
          },
          {
            name: "10281, CVS, POPLAR BLUFF, MO",
            disabled: false,
          },
          {
            name: "10281, Rite Aid, MEREDITH, NH",
            disabled: false,
          },
          {
            name: "10282, CVS, FORT DODGE, IA",
            disabled: false,
          },
          {
            name: "10282, Rite Aid, CONCORD, NH",
            disabled: false,
          },
          {
            name: "10282, Walgreens, WEXFORD, PA",
            disabled: false,
          },
          {
            name: "10283, CVS, PEEKSKILL, NY",
            disabled: false,
          },
          {
            name: "10283, Rite Aid, CONCORD, NH",
            disabled: false,
          },
          {
            name: "10283, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "10284, CVS, FAIRPORT, NY",
            disabled: false,
          },
          {
            name: "10284, Rite Aid, KEENE, NH",
            disabled: false,
          },
          {
            name: "10285, CVS, RENTON, WA",
            disabled: false,
          },
          {
            name: "10285, Rite Aid, PETERBOROUGH, NH",
            disabled: false,
          },
          {
            name: "10286, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "10287, Walgreens, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "10288, CVS, PALMYRA, PA",
            disabled: false,
          },
          {
            name: "10288, Rite Aid, CLAREMONT, NH",
            disabled: false,
          },
          {
            name: "10288, Walgreens, HILLSDALE, MI",
            disabled: false,
          },
          {
            name: "10289, Walgreens, ELK RIVER, MN",
            disabled: false,
          },
          {
            name: "1029, Costco, COVINGTON, WA",
            disabled: false,
          },
          {
            name: "1029, Target, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "1029, Walmart, HOMOSASSA, FL",
            disabled: false,
          },
          {
            name: "10290, Rite Aid, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "10290, Walgreens, PICAYUNE, MS",
            disabled: false,
          },
          {
            name: "10291, Rite Aid, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "10291, Walgreens, JOHNSON CITY, NY",
            disabled: false,
          },
          {
            name: "10292, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "10292, Rite Aid, DOVER, NH",
            disabled: false,
          },
          {
            name: "10293, CVS, NORFOLK, NE",
            disabled: false,
          },
          {
            name: "10293, Walgreens, POTSDAM, NY",
            disabled: false,
          },
          {
            name: "10294, CVS, EMPORIA, KS",
            disabled: false,
          },
          {
            name: "10294, Rite Aid, LEE, NH",
            disabled: false,
          },
          {
            name: "10295, Rite Aid, DURHAM, NH",
            disabled: false,
          },
          {
            name: "10295, Walgreens, MARION, OH",
            disabled: false,
          },
          {
            name: "10296, CVS, LEWES, DE",
            disabled: false,
          },
          {
            name: "10296, Rite Aid, HAMPTON, NH",
            disabled: false,
          },
          {
            name: "10297, CVS, SIKESTON, MO",
            disabled: false,
          },
          {
            name: "10297, Rite Aid, NEWMARKET, NH",
            disabled: false,
          },
          {
            name: "10298, Rite Aid, PLAISTOW, NH",
            disabled: false,
          },
          {
            name: "10299, CVS, CHARLESTOWN, RI",
            disabled: false,
          },
          {
            name: "10299, Walgreens, ERWIN, TN",
            disabled: false,
          },
          {
            name: "103, Albertsons, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "103, CVS, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "103, Costco, CLARKSTON, WA",
            disabled: false,
          },
          {
            name: "103, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "103, Kroger, COTTONWOOD, AZ",
            disabled: false,
          },
          {
            name: "103, Kroger, Springfield, MO",
            disabled: false,
          },
          {
            name: "103, Meijer, DAYTON, OH",
            disabled: false,
          },
          {
            name: "103, Walmart, SHAWNEE, OK",
            disabled: false,
          },
          {
            name: "1030, CVS, NEW CITY, NY",
            disabled: false,
          },
          {
            name: "1030, Costco, COLORADO SPRING, CO",
            disabled: false,
          },
          {
            name: "1030, Target, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "1030, Walmart, LANCASTER, SC",
            disabled: false,
          },
          {
            name: "10300, Rite Aid, ROCHESTER, NH",
            disabled: false,
          },
          {
            name: "10300, Walgreens, PALMHURST, TX",
            disabled: false,
          },
          {
            name: "10301, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10301, Walgreens, VIROQUA, WI",
            disabled: false,
          },
          {
            name: "10304, CVS, JUNCTION CITY, KS",
            disabled: false,
          },
          {
            name: "10304, Walgreens, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "10305, CVS, SEDALIA, MO",
            disabled: false,
          },
          {
            name: "10306, Walgreens, EVERGREEN, CO",
            disabled: false,
          },
          {
            name: "10307, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "10307, Walgreens, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "10308, CVS, HERRIMAN, UT",
            disabled: false,
          },
          {
            name: "10308, Rite Aid, BETHEL, VT",
            disabled: false,
          },
          {
            name: "10308, Walgreens, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "10309, Walgreens, BRANFORD, CT",
            disabled: false,
          },
          {
            name: "1031, Albertsons, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "1031, CVS, ROSLINDALE, MA",
            disabled: false,
          },
          {
            name: "1031, Costco, MANTECA, CA",
            disabled: false,
          },
          {
            name: "1031, Target, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "10310, CVS, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "10310, Rite Aid, WINDSOR, VT",
            disabled: false,
          },
          {
            name: "10312, Rite Aid, LUDLOW, VT",
            disabled: false,
          },
          {
            name: "10312, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "10313, Rite Aid, SPRINGFIELD, VT",
            disabled: false,
          },
          {
            name: "10314, Walgreens, HAYDEN, ID",
            disabled: false,
          },
          {
            name: "10315, Rite Aid, BRATTLEBORO, VT",
            disabled: false,
          },
          {
            name: "10315, Walgreens, INDEPENDENCE, KY",
            disabled: false,
          },
          {
            name: "10316, CVS, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "10316, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "10317, Walgreens, BOSTON, MA",
            disabled: false,
          },
          {
            name: "10318, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "10318, Walgreens, SOUTHBOROUGH, MA",
            disabled: false,
          },
          {
            name: "10319, Walgreens, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "1032, Target, IRVING, TX",
            disabled: false,
          },
          {
            name: "1032, Walmart, LYNN HAVEN, FL",
            disabled: false,
          },
          {
            name: "10321, CVS, ASHTON, MD",
            disabled: false,
          },
          {
            name: "10321, Walgreens, WAVELAND, MS",
            disabled: false,
          },
          {
            name: "10322, CVS, VERNON, NJ",
            disabled: false,
          },
          {
            name: "10324, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10324, Walgreens, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "10325, CVS, CLAYTON, MO",
            disabled: false,
          },
          {
            name: "10327, CVS, SALINA, KS",
            disabled: false,
          },
          {
            name: "10327, Walgreens, GREENVILLE, OH",
            disabled: false,
          },
          {
            name: "10328, Walgreens, PARMA, OH",
            disabled: false,
          },
          {
            name: "10329, CVS, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "10329, Walgreens, HARTSVILLE, SC",
            disabled: false,
          },
          {
            name: "1033, CVS, SMITHVILLE, NJ",
            disabled: false,
          },
          {
            name: "1033, Costco, POCATELLO, ID",
            disabled: false,
          },
          {
            name: "1033, Target, BALDWIN PARK, CA",
            disabled: false,
          },
          {
            name: "1033, Walgreens, WILMETTE, IL",
            disabled: false,
          },
          {
            name: "1033, Walmart, SEYMOUR, IN",
            disabled: false,
          },
          {
            name: "10330, Walgreens, BLOUNTVILLE, TN",
            disabled: false,
          },
          {
            name: "10331, Walgreens, CENTREVILLE, VA",
            disabled: false,
          },
          {
            name: "10332, CVS, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "10332, Walgreens, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "10333, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "10334, CVS, KIRKWOOD, MO",
            disabled: false,
          },
          {
            name: "10334, Walgreens, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "10335, CVS, ALVARADO, TX",
            disabled: false,
          },
          {
            name: "10335, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "10336, Walgreens, ORANGE, CA",
            disabled: false,
          },
          {
            name: "10337, CVS, ELGIN, TX",
            disabled: false,
          },
          {
            name: "10338, CVS, LA FERIA, TX",
            disabled: false,
          },
          {
            name: "10339, Walgreens, BOURBONNAIS, IL",
            disabled: false,
          },
          {
            name: "1034, CVS, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "1034, Target, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "1034, Walgreens, CRAFTON, PA",
            disabled: false,
          },
          {
            name: "1034, Walmart, SHELBY, NC",
            disabled: false,
          },
          {
            name: "10340, CVS, MINEOLA, TX",
            disabled: false,
          },
          {
            name: "10340, Walgreens, JASPER, IN",
            disabled: false,
          },
          {
            name: "10342, Walgreens, MELROSE, MA",
            disabled: false,
          },
          {
            name: "10345, CVS, HANNIBAL, MO",
            disabled: false,
          },
          {
            name: "10345, Walgreens, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10347, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10347, Walgreens, MITCHELL, SD",
            disabled: false,
          },
          {
            name: "10348, Walgreens, GOODLETTSVILLE, TN",
            disabled: false,
          },
          {
            name: "1035, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "1035, Target, Saint Peters, MO",
            disabled: false,
          },
          {
            name: "1035, Walmart, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "10350, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "10350, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "10351, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10351, Walgreens, WALKER, MI",
            disabled: false,
          },
          {
            name: "10352, CVS, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "10352, Walgreens, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "10354, Walgreens, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "10355, CVS, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "10356, CVS, DEL RIO, TX",
            disabled: false,
          },
          {
            name: "10356, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10357, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "10358, CVS, MANCHESTER, GA",
            disabled: false,
          },
          {
            name: "1036, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "1036, Target, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "1036, Walmart, FOREST CITY, NC",
            disabled: false,
          },
          {
            name: "10360, CVS, LIVINGSTON, CA",
            disabled: false,
          },
          {
            name: "10360, Walgreens, GAUTIER, MS",
            disabled: false,
          },
          {
            name: "10361, CVS, RESTON, VA",
            disabled: false,
          },
          {
            name: "10364, CVS, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "10364, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "10365, Walgreens, MALVERN, AR",
            disabled: false,
          },
          {
            name: "10366, Walgreens, CALIMESA, CA",
            disabled: false,
          },
          {
            name: "10367, CVS, TRUMBULL, CT",
            disabled: false,
          },
          {
            name: "10367, Rite Aid, MILFORD, CT",
            disabled: false,
          },
          {
            name: "10368, Walgreens, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "10369, Rite Aid, MONROE, CT",
            disabled: false,
          },
          {
            name: "1037, CVS, BASTROP, TX",
            disabled: false,
          },
          {
            name: "1037, Costco, BLOOMFIELD, MI",
            disabled: false,
          },
          {
            name: "1037, Target, SPRINGDALE, OH",
            disabled: false,
          },
          {
            name: "1037, Walmart, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "10370, CVS, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "10370, Rite Aid, MONROE, CT",
            disabled: false,
          },
          {
            name: "10370, Walgreens, CORTEZ, CO",
            disabled: false,
          },
          {
            name: "10371, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "10371, Rite Aid, NORTH BRANFORD, CT",
            disabled: false,
          },
          {
            name: "10371, Walgreens, DURANGO, CO",
            disabled: false,
          },
          {
            name: "10372, CVS, CANTON, OH",
            disabled: false,
          },
          {
            name: "10372, Rite Aid, NORTHFORD, CT",
            disabled: false,
          },
          {
            name: "10372, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "10373, CVS, BURIEN, WA",
            disabled: false,
          },
          {
            name: "10373, Walgreens, LADY LAKE, FL",
            disabled: false,
          },
          {
            name: "10374, Walgreens, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "10375, CVS, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "10375, Rite Aid, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "10375, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "10376, Rite Aid, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "10377, CVS, WYNNEWOOD, PA",
            disabled: false,
          },
          {
            name: "10377, Walgreens, MOBERLY, MO",
            disabled: false,
          },
          {
            name: "10378, Walgreens, EAST HAMPSTEAD, NH",
            disabled: false,
          },
          {
            name: "10379, CVS, ENGLEWOOD, NJ",
            disabled: false,
          },
          {
            name: "10379, Walgreens, DOVER, NJ",
            disabled: false,
          },
          {
            name: "1038, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "1038, CVS, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1038, Costco, KAPOLEI, HI",
            disabled: false,
          },
          {
            name: "1038, Target, NORTH MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "1038, Walmart, WASECA, MN",
            disabled: false,
          },
          {
            name: "10380, Walgreens, CANANDAIGUA, NY",
            disabled: false,
          },
          {
            name: "10381, CVS, PARSIPPANY, NJ",
            disabled: false,
          },
          {
            name: "10382, Rite Aid, BETHEL, CT",
            disabled: false,
          },
          {
            name: "10382, Walgreens, NORTH CHILI, NY",
            disabled: false,
          },
          {
            name: "10383, Rite Aid, BROOKFIELD, CT",
            disabled: false,
          },
          {
            name: "10383, Walgreens, WEST SENECA, NY",
            disabled: false,
          },
          {
            name: "10384, Rite Aid, DANBURY, CT",
            disabled: false,
          },
          {
            name: "10384, Walgreens, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "10386, Rite Aid, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "10386, Walgreens, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "10388, Walgreens, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "10389, Rite Aid, RIDGEFIELD, CT",
            disabled: false,
          },
          {
            name: "10389, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "1039, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1039, Costco, BRANDYWINE, MD",
            disabled: false,
          },
          {
            name: "1039, Target, Miami, FL",
            disabled: false,
          },
          {
            name: "1039, Walmart, MOUNT AIRY, NC",
            disabled: false,
          },
          {
            name: "10390, Walgreens, GREER, SC",
            disabled: false,
          },
          {
            name: "10391, Walgreens, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "10392, Walgreens, BELTON, TX",
            disabled: false,
          },
          {
            name: "10393, Walgreens, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "10394, Walgreens, STEPHENS CITY, VA",
            disabled: false,
          },
          {
            name: "10395, Walgreens, CHEHALIS, WA",
            disabled: false,
          },
          {
            name: "10396, Walgreens, COLUMBUS, WI",
            disabled: false,
          },
          {
            name: "10397, CVS, AITKIN, MN",
            disabled: false,
          },
          {
            name: "10398, CVS, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "10398, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "10399, CVS, PARKESBURG, PA",
            disabled: false,
          },
          {
            name: "10399, Walgreens, CROWLEY, LA",
            disabled: false,
          },
          {
            name: "104, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "104, Costco, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "104, HEB, MARLIN, TX",
            disabled: false,
          },
          {
            name: "104, Kroger, Bremerton, WA",
            disabled: false,
          },
          {
            name: "104, Kroger, Flagstaff, AZ",
            disabled: false,
          },
          {
            name: "104, Kroger, La Mesa, CA",
            disabled: false,
          },
          {
            name: "104, Kroger, WINDSOR, CO",
            disabled: false,
          },
          {
            name: "104, Meijer, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "104, Walmart, MILAN, TN",
            disabled: false,
          },
          {
            name: "1040, Costco, SAINT CHARLES, IL",
            disabled: false,
          },
          {
            name: "1040, Target, VISTA, CA",
            disabled: false,
          },
          {
            name: "1040, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10400, CVS, VICKSBURG, MS",
            disabled: false,
          },
          {
            name: "10400, Walgreens, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "10401, Walgreens, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "10402, CVS, ANNA, TX",
            disabled: false,
          },
          {
            name: "10402, Rite Aid, NEWARK, NJ",
            disabled: false,
          },
          {
            name: "10402, Walgreens, LUSBY, MD",
            disabled: false,
          },
          {
            name: "10403, CVS, CANYON LAKE, TX",
            disabled: false,
          },
          {
            name: "10404, Walgreens, GAYLORD, MI",
            disabled: false,
          },
          {
            name: "10405, CVS, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "10408, CVS, BELLA VISTA, AR",
            disabled: false,
          },
          {
            name: "10408, Rite Aid, HAMBURG, NJ",
            disabled: false,
          },
          {
            name: "10408, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "10409, CVS, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "10409, Walgreens, LACONIA, NH",
            disabled: false,
          },
          {
            name: "1041, ADUSA, NILES, OH",
            disabled: false,
          },
          {
            name: "1041, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1041, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1041, CVS, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "1041, Target, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1041, Walmart, WESLACO, TX",
            disabled: false,
          },
          {
            name: "10410, Walgreens, LITTLETON, NH",
            disabled: false,
          },
          {
            name: "10411, CVS, MENOMONIE, WI",
            disabled: false,
          },
          {
            name: "10412, CVS, DONNA, TX",
            disabled: false,
          },
          {
            name: "10413, Rite Aid, WALDWICK, NJ",
            disabled: false,
          },
          {
            name: "10414, CVS, BELTON, TX",
            disabled: false,
          },
          {
            name: "10414, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10415, Rite Aid, WEST MILFORD, NJ",
            disabled: false,
          },
          {
            name: "10415, Walgreens, TOOELE, UT",
            disabled: false,
          },
          {
            name: "10416, CVS, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "10416, Walgreens, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "10417, CVS, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "10418, CVS, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "10418, Walgreens, HOPE, AR",
            disabled: false,
          },
          {
            name: "1042, ADUSA, MOYOCK, NC",
            disabled: false,
          },
          {
            name: "1042, CVS, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "1042, Costco, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "1042, Target, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "1042, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "1042, Walmart, BASTROP, TX",
            disabled: false,
          },
          {
            name: "10420, Walgreens, BIG BEAR LAKE, CA",
            disabled: false,
          },
          {
            name: "10421, Walgreens, SUSANVILLE, CA",
            disabled: false,
          },
          {
            name: "10422, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "10423, CVS, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "10423, Walgreens, CUMMING, GA",
            disabled: false,
          },
          {
            name: "10424, CVS, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "10424, Rite Aid, NEPTUNE, NJ",
            disabled: false,
          },
          {
            name: "10425, CVS, SEDONA, AZ",
            disabled: false,
          },
          {
            name: "10425, Rite Aid, PORT MONMOUTH, NJ",
            disabled: false,
          },
          {
            name: "10425, Walgreens, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "10426, Walgreens, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "10427, Rite Aid, BLAIRSTOWN, NJ",
            disabled: false,
          },
          {
            name: "10427, Walgreens, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "10428, CVS, SPRING BRANCH, TX",
            disabled: false,
          },
          {
            name: "10428, Walgreens, WINDHAM, ME",
            disabled: false,
          },
          {
            name: "10429, Rite Aid, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "10429, Walgreens, BALLWIN, MO",
            disabled: false,
          },
          {
            name: "1043, CVS, SOUTH WINDSOR, CT",
            disabled: false,
          },
          {
            name: "1043, Target, ABERDEEN, MD",
            disabled: false,
          },
          {
            name: "1043, Walmart, PAULS VALLEY, OK",
            disabled: false,
          },
          {
            name: "10430, CVS, SHERWOOD, AR",
            disabled: false,
          },
          {
            name: "10430, Walgreens, PETAL, MS",
            disabled: false,
          },
          {
            name: "10431, Walgreens, CAPE CARTERET, NC",
            disabled: false,
          },
          {
            name: "10432, CVS, BRYANT, AR",
            disabled: false,
          },
          {
            name: "10432, Rite Aid, WASHINGTON, NJ",
            disabled: false,
          },
          {
            name: "10432, Walgreens, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "10434, CVS, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "10434, Walgreens, MOREHEAD CITY, NC",
            disabled: false,
          },
          {
            name: "10436, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "10436, Rite Aid, BERLIN, NJ",
            disabled: false,
          },
          {
            name: "10436, Walgreens, SWANSBORO, NC",
            disabled: false,
          },
          {
            name: "10437, CVS, MUSKOGEE, OK",
            disabled: false,
          },
          {
            name: "10437, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "10438, Walgreens, MORRISTOWN, NJ",
            disabled: false,
          },
          {
            name: "10439, Walgreens, NEWTON, NJ",
            disabled: false,
          },
          {
            name: "1044, CVS, DERBY, CT",
            disabled: false,
          },
          {
            name: "1044, Target, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "1044, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "10440, CVS, FLOYD, VA",
            disabled: false,
          },
          {
            name: "10440, Rite Aid, LAUREL SPRINGS, NJ",
            disabled: false,
          },
          {
            name: "10440, Walgreens, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "10441, CVS, COLUMBUS, NE",
            disabled: false,
          },
          {
            name: "10441, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "10442, CVS, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "10442, Walgreens, KENMORE, NY",
            disabled: false,
          },
          {
            name: "10443, Rite Aid, BROOKLAWN, NJ",
            disabled: false,
          },
          {
            name: "10443, Walgreens, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "10445, Rite Aid, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "10446, CVS, LAREDO, TX",
            disabled: false,
          },
          {
            name: "10446, Walgreens, STONY POINT, NY",
            disabled: false,
          },
          {
            name: "10447, Walgreens, DILLON, SC",
            disabled: false,
          },
          {
            name: "10448, CVS, CARLSBAD, NM",
            disabled: false,
          },
          {
            name: "10448, Walgreens, LANCASTER, SC",
            disabled: false,
          },
          {
            name: "10449, CVS, SILVER CITY, NM",
            disabled: false,
          },
          {
            name: "10449, Rite Aid, MANTUA, NJ",
            disabled: false,
          },
          {
            name: "10449, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "1045, Albertsons, FORT LUPTON, CO",
            disabled: false,
          },
          {
            name: "1045, Target, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "1045, Walmart, LAFAYETTE, CO",
            disabled: false,
          },
          {
            name: "10450, CVS, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "10451, Rite Aid, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "10451, Walgreens, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "10452, Rite Aid, MEDFORD, NJ",
            disabled: false,
          },
          {
            name: "10453, CVS, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "10453, Rite Aid, MEDFORD, NJ",
            disabled: false,
          },
          {
            name: "10453, Walgreens, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "10454, Walgreens, MANTECA, CA",
            disabled: false,
          },
          {
            name: "10455, Walgreens, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "10456, Rite Aid, MULLICA HILL, NJ",
            disabled: false,
          },
          {
            name: "10456, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "10457, CVS, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "10457, Rite Aid, PAULSBORO, NJ",
            disabled: false,
          },
          {
            name: "10457, Walgreens, TUCKER, GA",
            disabled: false,
          },
          {
            name: "10458, CVS, BEACHWOOD, NJ",
            disabled: false,
          },
          {
            name: "1046, CVS, SECANE, PA",
            disabled: false,
          },
          {
            name: "1046, Target, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "1046, Walmart, CARRIZO SPRINGS, TX",
            disabled: false,
          },
          {
            name: "10460, Walgreens, SOUTH YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "10461, CVS, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "10461, Walgreens, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "10462, CVS, RIDGEFIELD, CT",
            disabled: false,
          },
          {
            name: "10462, Rite Aid, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "10462, Walgreens, MILFORD, NH",
            disabled: false,
          },
          {
            name: "10463, Rite Aid, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "10464, Walgreens, THORNWOOD, NY",
            disabled: false,
          },
          {
            name: "10465, Walgreens, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "10466, Walgreens, RIVERTON, WY",
            disabled: false,
          },
          {
            name: "10467, CVS, NORTHBROOK, IL",
            disabled: false,
          },
          {
            name: "10467, Walgreens, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "10469, Walgreens, GREEN COVE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "1047, ADUSA, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "1047, Albertsons, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "1047, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "1047, Target, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1047, Walmart, MORROW, GA",
            disabled: false,
          },
          {
            name: "10470, CVS, MCHENRY, IL",
            disabled: false,
          },
          {
            name: "10470, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10471, CVS, FARMINGTON, MO",
            disabled: false,
          },
          {
            name: "10471, Rite Aid, COLLINGSWOOD, NJ",
            disabled: false,
          },
          {
            name: "10472, Rite Aid, PENNSAUKEN, NJ",
            disabled: false,
          },
          {
            name: "10473, CVS, POULSBO, WA",
            disabled: false,
          },
          {
            name: "10473, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "10474, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "10475, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "10476, Walgreens, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "10477, Walgreens, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "10478, CVS, CRESCENT CITY, CA",
            disabled: false,
          },
          {
            name: "10478, Walgreens, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "10479, Walgreens, CONYERS, GA",
            disabled: false,
          },
          {
            name: "1048, Albertsons, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1048, CVS, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "1048, Target, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1048, Walmart, WILLIAMSBURG, KY",
            disabled: false,
          },
          {
            name: "10480, CVS, URBANDALE, IA",
            disabled: false,
          },
          {
            name: "10480, Walgreens, PELL CITY, AL",
            disabled: false,
          },
          {
            name: "10481, CVS, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "10481, Walgreens, COALINGA, CA",
            disabled: false,
          },
          {
            name: "10482, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "10483, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "10483, Walgreens, NEW LONDON, CT",
            disabled: false,
          },
          {
            name: "10484, Rite Aid, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "10484, Walgreens, LITHIA, FL",
            disabled: false,
          },
          {
            name: "10485, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10485, Walgreens, CALUMET PARK, IL",
            disabled: false,
          },
          {
            name: "10486, CVS, HUTTO, TX",
            disabled: false,
          },
          {
            name: "10486, Walgreens, BRAZIL, IN",
            disabled: false,
          },
          {
            name: "10487, CVS, ROANOKE, TX",
            disabled: false,
          },
          {
            name: "10487, Rite Aid, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "10487, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "10488, Rite Aid, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "10489, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "10489, Walgreens, PRUDENVILLE, MI",
            disabled: false,
          },
          {
            name: "1049, CVS, HYDE PARK, MA",
            disabled: false,
          },
          {
            name: "1049, Costco, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "1049, Target, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "10490, Rite Aid, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "10490, Walgreens, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "10491, Walgreens, RIO GRANDE, NJ",
            disabled: false,
          },
          {
            name: "10493, CVS, SPRING HOUSE, PA",
            disabled: false,
          },
          {
            name: "10493, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "10494, Walgreens, ROCHESTER, PA",
            disabled: false,
          },
          {
            name: "10496, Rite Aid, JACKSON, NJ",
            disabled: false,
          },
          {
            name: "10496, Walgreens, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "10497, Walgreens, DEBARY, FL",
            disabled: false,
          },
          {
            name: "10498, Walgreens, YORKVILLE, IL",
            disabled: false,
          },
          {
            name: "105, ADUSA, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "105, Albertsons, WALDORF, MD",
            disabled: false,
          },
          {
            name: "105, BJ's, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "105, Kroger, FIRESTONE, CO",
            disabled: false,
          },
          {
            name: "105, Kroger, Joplin, MO",
            disabled: false,
          },
          {
            name: "105, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "105, Kroger, TACOMA, WA",
            disabled: false,
          },
          {
            name: "105, Meijer, Chesterfield, MI",
            disabled: false,
          },
          {
            name: "105, ShopRite, KEARNY, NJ",
            disabled: false,
          },
          {
            name: "105, Walmart, CORINTH, MS",
            disabled: false,
          },
          {
            name: "1050, CVS, HOLDEN, MA",
            disabled: false,
          },
          {
            name: "1050, Costco, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "1050, Target, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "10500, Walgreens, DULUTH, MN",
            disabled: false,
          },
          {
            name: "10501, Walgreens, VIRGINIA, MN",
            disabled: false,
          },
          {
            name: "10502, CVS, NEWBURYPORT, MA",
            disabled: false,
          },
          {
            name: "10502, Walgreens, SOUTH SIOUX CITY, NE",
            disabled: false,
          },
          {
            name: "10504, CVS, JUPITER, FL",
            disabled: false,
          },
          {
            name: "10504, Walgreens, TRUSSVILLE, AL",
            disabled: false,
          },
          {
            name: "10505, CVS, COMMERCE, TX",
            disabled: false,
          },
          {
            name: "10505, Rite Aid, ROBBINSVILLE, NJ",
            disabled: false,
          },
          {
            name: "10505, Walgreens, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "10506, CVS, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "10506, Walgreens, RICHMOND HILL, GA",
            disabled: false,
          },
          {
            name: "10507, Rite Aid, FORKED RIVER, NJ",
            disabled: false,
          },
          {
            name: "10507, Walgreens, LA GRANGE, KY",
            disabled: false,
          },
          {
            name: "10508, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "10508, Walgreens, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "10509, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "10509, Walgreens, SULPHUR, LA",
            disabled: false,
          },
          {
            name: "1051, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "1051, Target, TAMPA, FL",
            disabled: false,
          },
          {
            name: "1051, Walgreens, SHALLOTTE, NC",
            disabled: false,
          },
          {
            name: "1051, Walmart, LEVELLAND, TX",
            disabled: false,
          },
          {
            name: "10510, Walgreens, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "10511, Walgreens, HENRIETTA, NY",
            disabled: false,
          },
          {
            name: "10512, Rite Aid, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10512, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "10513, CVS, MCKINLEYVILLE, CA",
            disabled: false,
          },
          {
            name: "10513, Rite Aid, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10513, Walgreens, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "10514, Rite Aid, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10514, Walgreens, CHEBOYGAN, MI",
            disabled: false,
          },
          {
            name: "10515, CVS, PARIS, TN",
            disabled: false,
          },
          {
            name: "10515, Rite Aid, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10515, Walgreens, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "10516, CVS, HARVEST, AL",
            disabled: false,
          },
          {
            name: "10516, Walgreens, NEW ULM, MN",
            disabled: false,
          },
          {
            name: "10517, Rite Aid, WHITING, NJ",
            disabled: false,
          },
          {
            name: "10517, Walgreens, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "10518, Walgreens, MADISON, OH",
            disabled: false,
          },
          {
            name: "10519, CVS, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "1052, Target, WYOMING, MI",
            disabled: false,
          },
          {
            name: "1052, Walmart, FAYETTE, AL",
            disabled: false,
          },
          {
            name: "10520, CVS, LAWTON, OK",
            disabled: false,
          },
          {
            name: "10520, Walgreens, ERIE, PA",
            disabled: false,
          },
          {
            name: "10521, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "10523, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "10523, Walgreens, FORT PAYNE, AL",
            disabled: false,
          },
          {
            name: "10524, Walgreens, SELMA, AL",
            disabled: false,
          },
          {
            name: "10525, Walgreens, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "10526, Rite Aid, PHILLIPSBURG, NJ",
            disabled: false,
          },
          {
            name: "10526, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "10527, CVS, NEWARK, NJ",
            disabled: false,
          },
          {
            name: "10528, CVS, JESSUP, MD",
            disabled: false,
          },
          {
            name: "10528, Walgreens, DALLAS, GA",
            disabled: false,
          },
          {
            name: "10529, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "10529, Walgreens, EAST CHICAGO, IN",
            disabled: false,
          },
          {
            name: "1053, Target, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "1053, Walmart, LA GRANGE, KY",
            disabled: false,
          },
          {
            name: "10532, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "10532, Walgreens, MONTICELLO, IN",
            disabled: false,
          },
          {
            name: "10533, CVS, RACINE, WI",
            disabled: false,
          },
          {
            name: "10533, Walgreens, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "10534, Walgreens, WHITING, IN",
            disabled: false,
          },
          {
            name: "10535, CVS, BUDA, TX",
            disabled: false,
          },
          {
            name: "10536, Walgreens, BASTROP, LA",
            disabled: false,
          },
          {
            name: "10537, CVS, BEECHER, IL",
            disabled: false,
          },
          {
            name: "10537, Walgreens, DERIDDER, LA",
            disabled: false,
          },
          {
            name: "10538, Walgreens, LEESVILLE, LA",
            disabled: false,
          },
          {
            name: "10539, CVS, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "10539, Walgreens, CLARKSVILLE, MD",
            disabled: false,
          },
          {
            name: "1054, Albertsons, MIDLAND PARK, NJ",
            disabled: false,
          },
          {
            name: "1054, Target, SAN BRUNO, CA",
            disabled: false,
          },
          {
            name: "1054, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1054, Walmart, ATCHISON, KS",
            disabled: false,
          },
          {
            name: "10540, CVS, FAIR OAKS RANCH, TX",
            disabled: false,
          },
          {
            name: "10541, CVS, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "10541, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "10543, Rite Aid, BRONX, NY",
            disabled: false,
          },
          {
            name: "10545, Rite Aid, ARDSLEY, NY",
            disabled: false,
          },
          {
            name: "10546, CVS, O FALLON, MO",
            disabled: false,
          },
          {
            name: "10546, Rite Aid, CARMEL, NY",
            disabled: false,
          },
          {
            name: "10546, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "10547, CVS, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "10547, Rite Aid, HARTSDALE, NY",
            disabled: false,
          },
          {
            name: "10548, CVS, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "10548, Walgreens, TROY, NY",
            disabled: false,
          },
          {
            name: "10549, CVS, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "10549, Walgreens, LATROBE, PA",
            disabled: false,
          },
          {
            name: "1055, Albertsons, PRESCOTT VALLEY, AZ",
            disabled: false,
          },
          {
            name: "1055, CVS, CANTONMENT, FL",
            disabled: false,
          },
          {
            name: "1055, Target, EDISON, NJ",
            disabled: false,
          },
          {
            name: "1055, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "10550, CVS, EAU CLAIRE, WI",
            disabled: false,
          },
          {
            name: "10550, Walgreens, SAN JUAN, TX",
            disabled: false,
          },
          {
            name: "10551, CVS, WARWICK, RI",
            disabled: false,
          },
          {
            name: "10551, Rite Aid, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "10551, Walgreens, WESLACO, TX",
            disabled: false,
          },
          {
            name: "10552, CVS, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "10552, Walgreens, LOGAN, UT",
            disabled: false,
          },
          {
            name: "10553, CVS, BRAIDWOOD, IL",
            disabled: false,
          },
          {
            name: "10553, Walgreens, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "10554, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10554, Walgreens, MCFARLAND, WI",
            disabled: false,
          },
          {
            name: "10555, CVS, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "10555, Walgreens, MIDDLETON, WI",
            disabled: false,
          },
          {
            name: "10556, CVS, SANDY, UT",
            disabled: false,
          },
          {
            name: "10556, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "10557, Walgreens, CEDAR FALLS, IA",
            disabled: false,
          },
          {
            name: "10558, CVS, LEESVILLE, LA",
            disabled: false,
          },
          {
            name: "10559, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "10559, Walgreens, CORYDON, IN",
            disabled: false,
          },
          {
            name: "1056, Target, VESTAL, NY",
            disabled: false,
          },
          {
            name: "1056, Walgreens, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "1056, Walmart, NEWCASTLE, OK",
            disabled: false,
          },
          {
            name: "10560, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "10561, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "10562, CVS, HEATH, TX",
            disabled: false,
          },
          {
            name: "10562, Walgreens, BRIDGEWATER, MA",
            disabled: false,
          },
          {
            name: "10563, CVS, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "10565, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "10566, CVS, MILTON, WV",
            disabled: false,
          },
          {
            name: "10566, Walgreens, MOCKSVILLE, NC",
            disabled: false,
          },
          {
            name: "10567, Walgreens, AURORA, OH",
            disabled: false,
          },
          {
            name: "10569, Walgreens, NILES, OH",
            disabled: false,
          },
          {
            name: "1057, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1057, Target, ORCHARD PARK, NY",
            disabled: false,
          },
          {
            name: "1057, Walmart, TALLASSEE, AL",
            disabled: false,
          },
          {
            name: "10572, CVS, MILFORD, NH",
            disabled: false,
          },
          {
            name: "10572, Walgreens, PIERRE, SD",
            disabled: false,
          },
          {
            name: "10573, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "10574, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "10574, Walgreens, MERRILL, WI",
            disabled: false,
          },
          {
            name: "10575, CVS, SARALAND, AL",
            disabled: false,
          },
          {
            name: "10576, CVS, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "10576, Walgreens, PALM BEACH GARDENS, FL",
            disabled: false,
          },
          {
            name: "10577, CVS, AMERICAN FORK, UT",
            disabled: false,
          },
          {
            name: "10577, Walgreens, JENNINGS, LA",
            disabled: false,
          },
          {
            name: "10578, CVS, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "10579, CVS, ALAMO HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "10579, Walgreens, BRYAN, OH",
            disabled: false,
          },
          {
            name: "1058, ADUSA, BASSETT, VA",
            disabled: false,
          },
          {
            name: "1058, Albertsons, MAHWAH, NJ",
            disabled: false,
          },
          {
            name: "1058, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1058, Target, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1058, Walmart, MONTROSE, CO",
            disabled: false,
          },
          {
            name: "10580, CVS, CONROE, TX",
            disabled: false,
          },
          {
            name: "10580, Walgreens, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "10581, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "10581, Walgreens, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "10582, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10583, Walgreens, TEXAS CITY, TX",
            disabled: false,
          },
          {
            name: "10584, Walgreens, BURLINGTON, WI",
            disabled: false,
          },
          {
            name: "10585, CVS, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "10585, Walgreens, RIVER FALLS, WI",
            disabled: false,
          },
          {
            name: "10586, CVS, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "10586, Rite Aid, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "10586, Walgreens, SILOAM SPRINGS, AR",
            disabled: false,
          },
          {
            name: "10587, Walgreens, MEXICO, MO",
            disabled: false,
          },
          {
            name: "10588, CVS, CATONSVILLE, MD",
            disabled: false,
          },
          {
            name: "1059, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1059, CVS, RAMSEY, NJ",
            disabled: false,
          },
          {
            name: "1059, Costco, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "1059, Target, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "1059, Walmart, FOREST, MS",
            disabled: false,
          },
          {
            name: "10591, CVS, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "10591, Walgreens, MALONE, NY",
            disabled: false,
          },
          {
            name: "10592, CVS, SAINT JOSEPH, MI",
            disabled: false,
          },
          {
            name: "10592, Rite Aid, BAYSIDE, NY",
            disabled: false,
          },
          {
            name: "10594, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "10595, CVS, CIBOLO, TX",
            disabled: false,
          },
          {
            name: "10596, CVS, SHREWSBURY, MA",
            disabled: false,
          },
          {
            name: "10596, Walgreens, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "10597, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10598, CVS, LA MARQUE, TX",
            disabled: false,
          },
          {
            name: "10598, Walgreens, SYLACAUGA, AL",
            disabled: false,
          },
          {
            name: "10599, CVS, COAL CITY, IL",
            disabled: false,
          },
          {
            name: "10599, Walgreens, CAMERON PARK, CA",
            disabled: false,
          },
          {
            name: "106, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "106, ADUSA, POTOMAC, MD",
            disabled: false,
          },
          {
            name: "106, Albertsons, EULESS, TX",
            disabled: false,
          },
          {
            name: "106, BJ's, PARKLAND, FL",
            disabled: false,
          },
          {
            name: "106, Costco, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "106, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "106, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "106, Kroger, PORT TOWNSEND, WA",
            disabled: false,
          },
          {
            name: "106, Meijer, ENGLEWOOD, OH",
            disabled: false,
          },
          {
            name: "106, Walmart, FULTON, KY",
            disabled: false,
          },
          {
            name: "1060, CVS, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "1060, Costco, MANCHESTER, MO",
            disabled: false,
          },
          {
            name: "1060, Target, MADISON, WI",
            disabled: false,
          },
          {
            name: "1060, Walmart, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "10600, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10601, CVS, WATERTOWN, MA",
            disabled: false,
          },
          {
            name: "10601, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "10602, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "10602, Walgreens, EVANS, GA",
            disabled: false,
          },
          {
            name: "10603, CVS, ROSHARON, TX",
            disabled: false,
          },
          {
            name: "10603, Walgreens, AMMON, ID",
            disabled: false,
          },
          {
            name: "10604, CVS, MANVEL, TX",
            disabled: false,
          },
          {
            name: "10604, Walgreens, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "10605, CVS, STAFFORD SPRINGS, CT",
            disabled: false,
          },
          {
            name: "10605, Walgreens, SHOREWOOD, IL",
            disabled: false,
          },
          {
            name: "10606, CVS, CHESAPEAKE BEACH, MD",
            disabled: false,
          },
          {
            name: "10606, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "10607, Rite Aid, OZONE PARK, NY",
            disabled: false,
          },
          {
            name: "10608, CVS, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10608, Walgreens, DALLAS, NC",
            disabled: false,
          },
          {
            name: "10609, CVS, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "10609, Walgreens, NORTH CONWAY, NH",
            disabled: false,
          },
          {
            name: "1061, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1061, Costco, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "1061, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1061, Walmart, HAZLEHURST, GA",
            disabled: false,
          },
          {
            name: "10610, CVS, VALLEY COTTAGE, NY",
            disabled: false,
          },
          {
            name: "10611, CVS, LINDEN, NJ",
            disabled: false,
          },
          {
            name: "10612, Rite Aid, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "10612, Walgreens, HARRIMAN, TN",
            disabled: false,
          },
          {
            name: "10613, Rite Aid, WEST HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "10613, Walgreens, PINEHURST, TX",
            disabled: false,
          },
          {
            name: "10614, Rite Aid, EAST MEADOW, NY",
            disabled: false,
          },
          {
            name: "10614, Walgreens, YORK, SC",
            disabled: false,
          },
          {
            name: "10615, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "10615, Rite Aid, LONG BEACH, NY",
            disabled: false,
          },
          {
            name: "10615, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "10616, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "10616, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "10618, CVS, HIGHLAND, UT",
            disabled: false,
          },
          {
            name: "10618, Rite Aid, ROCKVILLE CENTRE, NY",
            disabled: false,
          },
          {
            name: "10619, Rite Aid, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "10619, Walgreens, ALBEMARLE, NC",
            disabled: false,
          },
          {
            name: "1062, ADUSA, LEWISVILLE, NC",
            disabled: false,
          },
          {
            name: "1062, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1062, CVS, CLEMENTON, NJ",
            disabled: false,
          },
          {
            name: "1062, Costco, NEW YORK, NY",
            disabled: false,
          },
          {
            name: "1062, Target, SAND CITY, CA",
            disabled: false,
          },
          {
            name: "1062, Walmart, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "10620, CVS, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "10620, Rite Aid, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "10621, Rite Aid, WILLISTON PARK, NY",
            disabled: false,
          },
          {
            name: "10623, Rite Aid, NORTH BABYLON, NY",
            disabled: false,
          },
          {
            name: "10626, CVS, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "10626, Rite Aid, BAY SHORE, NY",
            disabled: false,
          },
          {
            name: "10628, CVS, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "10628, Walgreens, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "1063, Albertsons, PATTERSON, NY",
            disabled: false,
          },
          {
            name: "1063, Target, CARMEL, IN",
            disabled: false,
          },
          {
            name: "1063, Walmart, GENEVA, AL",
            disabled: false,
          },
          {
            name: "10631, CVS, CONROE, TX",
            disabled: false,
          },
          {
            name: "10631, Rite Aid, BRENTWOOD, NY",
            disabled: false,
          },
          {
            name: "10631, Walgreens, LATHROP, CA",
            disabled: false,
          },
          {
            name: "10632, Rite Aid, COMMACK, NY",
            disabled: false,
          },
          {
            name: "10632, Walgreens, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "10633, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10633, Rite Aid, COPIAGUE, NY",
            disabled: false,
          },
          {
            name: "10634, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10634, Walgreens, MACON, GA",
            disabled: false,
          },
          {
            name: "10635, CVS, ROYSE CITY, TX",
            disabled: false,
          },
          {
            name: "10635, Rite Aid, EAST NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "10635, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "10637, CVS, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "10638, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10639, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "10639, Walgreens, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "1064, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1064, Target, WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "1064, Walmart, LENOIR, NC",
            disabled: false,
          },
          {
            name: "10640, Rite Aid, HUNTINGTON, NY",
            disabled: false,
          },
          {
            name: "10640, Walgreens, ALBERT LEA, MN",
            disabled: false,
          },
          {
            name: "10641, CVS, PROSPER, TX",
            disabled: false,
          },
          {
            name: "10641, Rite Aid, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "10641, Walgreens, EAGAN, MN",
            disabled: false,
          },
          {
            name: "10642, CVS, CORINTH, TX",
            disabled: false,
          },
          {
            name: "10642, Rite Aid, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "10642, Walgreens, LEE, NH",
            disabled: false,
          },
          {
            name: "10643, CVS, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "10643, Walgreens, GROVE, OK",
            disabled: false,
          },
          {
            name: "10644, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10644, Rite Aid, KINGS PARK, NY",
            disabled: false,
          },
          {
            name: "10645, CVS, DYERSBURG, TN",
            disabled: false,
          },
          {
            name: "10646, CVS, AVENTURA, FL",
            disabled: false,
          },
          {
            name: "10647, Walgreens, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "10648, CVS, CLARKSVILLE, MD",
            disabled: false,
          },
          {
            name: "10648, Rite Aid, MASSAPEQUA PARK, NY",
            disabled: false,
          },
          {
            name: "10648, Walgreens, SOUTHWEST RANCHES, FL",
            disabled: false,
          },
          {
            name: "10649, CVS, STURBRIDGE, MA",
            disabled: false,
          },
          {
            name: "10649, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1065, ADUSA, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "1065, Albertsons, FORT LEE, NJ",
            disabled: false,
          },
          {
            name: "1065, Target, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "1065, Walmart, HOPE, AR",
            disabled: false,
          },
          {
            name: "10650, Rite Aid, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "10651, Rite Aid, MILLER PLACE, NY",
            disabled: false,
          },
          {
            name: "10652, CVS, KATONAH, NY",
            disabled: false,
          },
          {
            name: "10652, Rite Aid, MOUNT SINAI, NY",
            disabled: false,
          },
          {
            name: "10652, Walgreens, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "10653, CVS, GLEN HEAD, NY",
            disabled: false,
          },
          {
            name: "10655, Rite Aid, OYSTER BAY, NY",
            disabled: false,
          },
          {
            name: "10656, Walgreens, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "10657, CVS, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "10657, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "10659, CVS, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "1066, ADUSA, PULASKI, VA",
            disabled: false,
          },
          {
            name: "1066, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1066, Target, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "1066, Walmart, PASCAGOULA, MS",
            disabled: false,
          },
          {
            name: "10661, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "10661, Rite Aid, SAYVILLE, NY",
            disabled: false,
          },
          {
            name: "10662, CVS, LAYTON, UT",
            disabled: false,
          },
          {
            name: "10662, Rite Aid, SELDEN, NY",
            disabled: false,
          },
          {
            name: "10663, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "10663, Rite Aid, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "10664, CVS, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "10664, Walgreens, WETUMPKA, AL",
            disabled: false,
          },
          {
            name: "10665, CVS, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "10665, Rite Aid, WEST ISLIP, NY",
            disabled: false,
          },
          {
            name: "10666, CVS, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "10666, Walgreens, MONTICELLO, AR",
            disabled: false,
          },
          {
            name: "10667, CVS, RAYMONDVILLE, TX",
            disabled: false,
          },
          {
            name: "10668, CVS, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "10668, Rite Aid, EASTPORT, NY",
            disabled: false,
          },
          {
            name: "10668, Walgreens, ARCADIA, FL",
            disabled: false,
          },
          {
            name: "10669, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "10669, Walgreens, MACCLENNY, FL",
            disabled: false,
          },
          {
            name: "1067, ADUSA, TULLAHOMA, TN",
            disabled: false,
          },
          {
            name: "1067, CVS, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "1067, Walmart, HALLETTSVILLE, TX",
            disabled: false,
          },
          {
            name: "10670, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10670, Walgreens, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "10671, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "10671, Rite Aid, MIDDLE ISLAND, NY",
            disabled: false,
          },
          {
            name: "10671, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "10672, Walgreens, NAMPA, ID",
            disabled: false,
          },
          {
            name: "10673, CVS, MELISSA, TX",
            disabled: false,
          },
          {
            name: "10673, Rite Aid, SHIRLEY, NY",
            disabled: false,
          },
          {
            name: "10674, Walgreens, ADVANCE, NC",
            disabled: false,
          },
          {
            name: "10675, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "10675, Walgreens, SUMMERFIELD, NC",
            disabled: false,
          },
          {
            name: "10676, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "10676, Walgreens, GREEN BROOK, NJ",
            disabled: false,
          },
          {
            name: "10677, CVS, WHEATON, IL",
            disabled: false,
          },
          {
            name: "10678, CVS, PARAGOULD, AR",
            disabled: false,
          },
          {
            name: "1068, CVS, ATHOL, MA",
            disabled: false,
          },
          {
            name: "1068, Target, OWATONNA, MN",
            disabled: false,
          },
          {
            name: "1068, Walmart, SEBASTIAN, FL",
            disabled: false,
          },
          {
            name: "10680, CVS, MANTENO, IL",
            disabled: false,
          },
          {
            name: "10680, Rite Aid, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "10680, Walgreens, ARANSAS PASS, TX",
            disabled: false,
          },
          {
            name: "10681, CVS, HOPKINTON, MA",
            disabled: false,
          },
          {
            name: "10681, Rite Aid, GLOVERSVILLE, NY",
            disabled: false,
          },
          {
            name: "10681, Walgreens, SEALY, TX",
            disabled: false,
          },
          {
            name: "10682, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "10682, Walgreens, PRAIRIE DU CHIEN, WI",
            disabled: false,
          },
          {
            name: "10684, CVS, GREAT FALLS, VA",
            disabled: false,
          },
          {
            name: "10684, Walgreens, VAIL, AZ",
            disabled: false,
          },
          {
            name: "10685, Walgreens, NORFOLK, MA",
            disabled: false,
          },
          {
            name: "10687, CVS, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "10687, Rite Aid, TROY, NY",
            disabled: false,
          },
          {
            name: "10688, CVS, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "10688, Walgreens, NEWPORT, TN",
            disabled: false,
          },
          {
            name: "10689, CVS, SCARSDALE, NY",
            disabled: false,
          },
          {
            name: "10689, Walgreens, BEEVILLE, TX",
            disabled: false,
          },
          {
            name: "1069, Target, MADISON, WI",
            disabled: false,
          },
          {
            name: "1069, Walmart, NEWTON, MS",
            disabled: false,
          },
          {
            name: "10690, CVS, SOUTH BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "10690, Walgreens, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "10691, CVS, MARBLE FALLS, TX",
            disabled: false,
          },
          {
            name: "10691, Rite Aid, ALBANY, NY",
            disabled: false,
          },
          {
            name: "10691, Walgreens, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "10692, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "10693, Walgreens, NORTH HIGHLANDS, CA",
            disabled: false,
          },
          {
            name: "10694, CVS, EXTON, PA",
            disabled: false,
          },
          {
            name: "10694, Walgreens, BYRAM, MS",
            disabled: false,
          },
          {
            name: "10695, Walgreens, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "10697, Walgreens, GENEVA, NY",
            disabled: false,
          },
          {
            name: "10698, Walgreens, MASSENA, NY",
            disabled: false,
          },
          {
            name: "107, Albertsons, GREENBELT, MD",
            disabled: false,
          },
          {
            name: "107, BJ's, JENSEN BEACH, FL",
            disabled: false,
          },
          {
            name: "107, Costco, JUNEAU, AK",
            disabled: false,
          },
          {
            name: "107, HEB, ENNIS, TX",
            disabled: false,
          },
          {
            name: "107, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "107, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "107, Kroger, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "107, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "107, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "107, Kroger, Saratoga Springs, UT",
            disabled: false,
          },
          {
            name: "107, Kroger, Springfield, MO",
            disabled: false,
          },
          {
            name: "107, Kroger, YUMA, AZ",
            disabled: false,
          },
          {
            name: "107, Meijer, FAIRBORN, OH",
            disabled: false,
          },
          {
            name: "107, Rite Aid, KENMORE, NY",
            disabled: false,
          },
          {
            name: "107, Walmart, MARTIN, TN",
            disabled: false,
          },
          {
            name: "1070, Albertsons, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "1070, CVS, WINDSOR LOCKS, CT",
            disabled: false,
          },
          {
            name: "1070, Costco, REGO PARK, NY",
            disabled: false,
          },
          {
            name: "1070, Rite Aid, MERRIMACK, NH",
            disabled: false,
          },
          {
            name: "1070, Target, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "1070, Walmart, EAST ELLIJAY, GA",
            disabled: false,
          },
          {
            name: "10700, Rite Aid, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "10700, Walgreens, MARION, VA",
            disabled: false,
          },
          {
            name: "10703, Walgreens, INDIO, CA",
            disabled: false,
          },
          {
            name: "10704, Walgreens, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "10705, Walgreens, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "10706, Rite Aid, HOPEWELL JUNCTION, NY",
            disabled: false,
          },
          {
            name: "10706, Walgreens, HERNANDO, MS",
            disabled: false,
          },
          {
            name: "10707, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "10709, Walgreens, HAMILTON, NJ",
            disabled: false,
          },
          {
            name: "1071, Costco, PACOIMA, CA",
            disabled: false,
          },
          {
            name: "1071, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "1071, Walmart, WOOD RIVER, IL",
            disabled: false,
          },
          {
            name: "10710, Walgreens, EUCLID, OH",
            disabled: false,
          },
          {
            name: "10711, Walgreens, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "10712, Rite Aid, WAPPINGERS FALLS, NY",
            disabled: false,
          },
          {
            name: "10712, Walgreens, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "10713, Rite Aid, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "10714, Rite Aid, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "10714, Walgreens, ELKHORN, WI",
            disabled: false,
          },
          {
            name: "10715, Walgreens, ARKADELPHIA, AR",
            disabled: false,
          },
          {
            name: "10716, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "10717, Rite Aid, GLENS FALLS, NY",
            disabled: false,
          },
          {
            name: "10717, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "10718, Walgreens, LITCHFIELD, IL",
            disabled: false,
          },
          {
            name: "1072, ADUSA, LADSON, SC",
            disabled: false,
          },
          {
            name: "1072, CVS, GLEN ROCK, NJ",
            disabled: false,
          },
          {
            name: "1072, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1072, Target, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1072, Walgreens, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "1072, Walmart, TIFTON, GA",
            disabled: false,
          },
          {
            name: "10720, Walgreens, MADISON, IN",
            disabled: false,
          },
          {
            name: "10721, Rite Aid, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "10721, Walgreens, EL DORADO, KS",
            disabled: false,
          },
          {
            name: "10722, Rite Aid, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "10722, Walgreens, LIBERAL, KS",
            disabled: false,
          },
          {
            name: "10725, Walgreens, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "10726, Walgreens, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "10728, Walgreens, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "10729, Rite Aid, AUBURN, NY",
            disabled: false,
          },
          {
            name: "10729, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "1073, ADUSA, CHADBOURN, NC",
            disabled: false,
          },
          {
            name: "1073, Albertsons, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "1073, Costco, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "1073, Target, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "1073, Walgreens, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1073, Walmart, LAMPASAS, TX",
            disabled: false,
          },
          {
            name: "10730, Rite Aid, BALDWINSVILLE, NY",
            disabled: false,
          },
          {
            name: "10730, Walgreens, HARKER HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "10731, Walgreens, COTTONWOOD HEIGHTS, UT",
            disabled: false,
          },
          {
            name: "10737, CVS, PEOTONE, IL",
            disabled: false,
          },
          {
            name: "10737, Rite Aid, CICERO, NY",
            disabled: false,
          },
          {
            name: "10738, Rite Aid, CORTLAND, NY",
            disabled: false,
          },
          {
            name: "10738, Walgreens, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "10739, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "1074, Albertsons, JOLIET, IL",
            disabled: false,
          },
          {
            name: "1074, CVS, KENNETT SQUARE, PA",
            disabled: false,
          },
          {
            name: "1074, Costco, METTAWA, IL",
            disabled: false,
          },
          {
            name: "1074, Rite Aid, LEMOYNE, PA",
            disabled: false,
          },
          {
            name: "1074, Target, AVENTURA, FL",
            disabled: false,
          },
          {
            name: "1074, Walmart, GRENADA, MS",
            disabled: false,
          },
          {
            name: "10741, CVS, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "10741, Walgreens, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "10742, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "10742, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "10743, CVS, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "10745, Walgreens, RAMSEY, NJ",
            disabled: false,
          },
          {
            name: "10746, CVS, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "10747, CVS, EVERETT, WA",
            disabled: false,
          },
          {
            name: "10747, Walgreens, AMSTERDAM, NY",
            disabled: false,
          },
          {
            name: "10749, Walgreens, BALDWINSVILLE, NY",
            disabled: false,
          },
          {
            name: "1075, CVS, PASCOAG, RI",
            disabled: false,
          },
          {
            name: "1075, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "1075, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "10750, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10750, Walgreens, CICERO, NY",
            disabled: false,
          },
          {
            name: "10751, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "10751, Walgreens, NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "10752, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "10752, Walgreens, GLOVERSVILLE, NY",
            disabled: false,
          },
          {
            name: "10755, CVS, DIAMONDHEAD, MS",
            disabled: false,
          },
          {
            name: "10756, Rite Aid, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "10758, Walgreens, ASHLAND, WI",
            disabled: false,
          },
          {
            name: "10759, CVS, JERSEYVILLE, IL",
            disabled: false,
          },
          {
            name: "10759, Walgreens, KAUKAUNA, WI",
            disabled: false,
          },
          {
            name: "1076, Albertsons, SNOHOMISH, WA",
            disabled: false,
          },
          {
            name: "1076, Target, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1076, Walgreens, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "1076, Walmart, MACON, GA",
            disabled: false,
          },
          {
            name: "10760, Walgreens, PALM SPRINGS, FL",
            disabled: false,
          },
          {
            name: "10761, Walgreens, ATMORE, AL",
            disabled: false,
          },
          {
            name: "10762, Walgreens, BREWTON, AL",
            disabled: false,
          },
          {
            name: "10764, Walgreens, PASADENA, CA",
            disabled: false,
          },
          {
            name: "10766, CVS, PHILLIPSBURG, NJ",
            disabled: false,
          },
          {
            name: "10766, Walgreens, TRACY, CA",
            disabled: false,
          },
          {
            name: "10767, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10767, Walgreens, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "10768, Walgreens, FONTANA, CA",
            disabled: false,
          },
          {
            name: "10769, CVS, RUTHER GLEN, VA",
            disabled: false,
          },
          {
            name: "1077, Albertsons, DENVILLE, NJ",
            disabled: false,
          },
          {
            name: "1077, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1077, Target, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "1077, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "1077, Walmart, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "10770, CVS, MONTPELIER, VA",
            disabled: false,
          },
          {
            name: "10770, Walgreens, CARROLL, IA",
            disabled: false,
          },
          {
            name: "10772, CVS, BARRON, WI",
            disabled: false,
          },
          {
            name: "10772, Walgreens, JOLIET, IL",
            disabled: false,
          },
          {
            name: "10773, CVS, PACIFIC, MO",
            disabled: false,
          },
          {
            name: "10773, Rite Aid, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "10774, Rite Aid, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "10775, CVS, HASLET, TX",
            disabled: false,
          },
          {
            name: "10776, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "10777, Walgreens, MILFORD, MI",
            disabled: false,
          },
          {
            name: "10778, Walgreens, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "10779, CVS, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "1078, ADUSA, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "1078, Albertsons, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "1078, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "1078, Costco, GLENARDEN, MD",
            disabled: false,
          },
          {
            name: "1078, Target, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1078, Walgreens, PASCO, WA",
            disabled: false,
          },
          {
            name: "1078, Walmart, BALLINGER, TX",
            disabled: false,
          },
          {
            name: "10780, Walgreens, DOVER, NH",
            disabled: false,
          },
          {
            name: "10782, CVS, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "10782, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10783, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10784, CVS, DENVER, CO",
            disabled: false,
          },
          {
            name: "10784, Walgreens, RAVENNA, OH",
            disabled: false,
          },
          {
            name: "10785, CVS, PARKER, CO",
            disabled: false,
          },
          {
            name: "10785, Walgreens, TAHLEQUAH, OK",
            disabled: false,
          },
          {
            name: "10786, Walgreens, CANONSBURG, PA",
            disabled: false,
          },
          {
            name: "10787, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10788, Walgreens, LIBERTY LAKE, WA",
            disabled: false,
          },
          {
            name: "1079, Costco, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1079, Rite Aid, AMHERST, NY",
            disabled: false,
          },
          {
            name: "1079, Target, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "1079, Walmart, NEW SMYRNA BEACH, FL",
            disabled: false,
          },
          {
            name: "10790, CVS, FRANKENMUTH, MI",
            disabled: false,
          },
          {
            name: "10790, Rite Aid, ENDWELL, NY",
            disabled: false,
          },
          {
            name: "10791, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "10792, CVS, COLTON, CA",
            disabled: false,
          },
          {
            name: "10792, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "10793, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10795, CVS, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "10796, Rite Aid, ONEONTA, NY",
            disabled: false,
          },
          {
            name: "10796, Walgreens, ALBANY, GA",
            disabled: false,
          },
          {
            name: "10797, Walgreens, ALBANY, GA",
            disabled: false,
          },
          {
            name: "10798, Walgreens, CHATSWORTH, GA",
            disabled: false,
          },
          {
            name: "10799, Walgreens, RINCON, GA",
            disabled: false,
          },
          {
            name: "108, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "108, ADUSA, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "108, Albertsons, GARDENA, CA",
            disabled: false,
          },
          {
            name: "108, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "108, Kroger, HERRIMAN, UT",
            disabled: false,
          },
          {
            name: "108, Kroger, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "108, Kroger, LA JOLLA, CA",
            disabled: false,
          },
          {
            name: "108, Kroger, PITTSBURG, KS",
            disabled: false,
          },
          {
            name: "108, Kroger, Port Orchard, WA",
            disabled: false,
          },
          {
            name: "108, Kroger, TEXAS CITY, TX",
            disabled: false,
          },
          {
            name: "108, Meijer, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "108, Target, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "108, Walmart, GUTHRIE, OK",
            disabled: false,
          },
          {
            name: "1080, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1080, CVS, NEW LONDON, CT",
            disabled: false,
          },
          {
            name: "1080, Costco, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "1080, Target, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1080, Walgreens, HEMET, CA",
            disabled: false,
          },
          {
            name: "1080, Walmart, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "10800, Walgreens, CLINTON, IL",
            disabled: false,
          },
          {
            name: "10801, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "10802, Walgreens, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "10803, Rite Aid, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "10803, Walgreens, KENTWOOD, MI",
            disabled: false,
          },
          {
            name: "10804, Rite Aid, AKRON, NY",
            disabled: false,
          },
          {
            name: "10804, Walgreens, LAMBERTVILLE, MI",
            disabled: false,
          },
          {
            name: "10805, CVS, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "10805, Rite Aid, ALDEN, NY",
            disabled: false,
          },
          {
            name: "10805, Walgreens, MAGEE, MS",
            disabled: false,
          },
          {
            name: "10806, CVS, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "10806, Rite Aid, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "10807, Rite Aid, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "10808, Rite Aid, DEPEW, NY",
            disabled: false,
          },
          {
            name: "10808, Walgreens, SILVER CITY, NM",
            disabled: false,
          },
          {
            name: "10809, CVS, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "10809, Rite Aid, DEPEW, NY",
            disabled: false,
          },
          {
            name: "1081, ADUSA, COVINGTON, VA",
            disabled: false,
          },
          {
            name: "1081, CVS, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "1081, Costco, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "1081, Rite Aid, DREXEL HILL, PA",
            disabled: false,
          },
          {
            name: "1081, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1081, Walgreens, HEMET, CA",
            disabled: false,
          },
          {
            name: "1081, Walmart, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "10810, Rite Aid, DERBY, NY",
            disabled: false,
          },
          {
            name: "10810, Walgreens, HEATH, OH",
            disabled: false,
          },
          {
            name: "10811, Rite Aid, DUNKIRK, NY",
            disabled: false,
          },
          {
            name: "10812, CVS, SHEPHERDSVILLE, KY",
            disabled: false,
          },
          {
            name: "10812, Rite Aid, EAST AURORA, NY",
            disabled: false,
          },
          {
            name: "10812, Walgreens, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "10813, Rite Aid, EDEN, NY",
            disabled: false,
          },
          {
            name: "10814, Rite Aid, GETZVILLE, NY",
            disabled: false,
          },
          {
            name: "10814, Walgreens, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "10815, Rite Aid, GRAND ISLAND, NY",
            disabled: false,
          },
          {
            name: "10815, Walgreens, SPARTA, TN",
            disabled: false,
          },
          {
            name: "10816, CVS, ROGERS, AR",
            disabled: false,
          },
          {
            name: "10816, Walgreens, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "10817, CVS, ZAPATA, TX",
            disabled: false,
          },
          {
            name: "10817, Rite Aid, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "10817, Walgreens, FORNEY, TX",
            disabled: false,
          },
          {
            name: "10818, CVS, WACO, TX",
            disabled: false,
          },
          {
            name: "10818, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "10819, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "10819, Rite Aid, NORTH TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "10819, Walgreens, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "1082, Target, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "1082, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "10820, Rite Aid, ORCHARD PARK, NY",
            disabled: false,
          },
          {
            name: "10820, Walgreens, NORTH OGDEN, UT",
            disabled: false,
          },
          {
            name: "10821, Rite Aid, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "10822, Walgreens, GAINESVILLE, VA",
            disabled: false,
          },
          {
            name: "10823, Rite Aid, YORKSHIRE, NY",
            disabled: false,
          },
          {
            name: "10824, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "10824, Walgreens, REVERE, MA",
            disabled: false,
          },
          {
            name: "10825, CVS, PLYMOUTH MEETING, PA",
            disabled: false,
          },
          {
            name: "10825, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "10826, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "10826, Walgreens, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "10827, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "10827, Walgreens, DELANO, CA",
            disabled: false,
          },
          {
            name: "10828, Rite Aid, KENMORE, NY",
            disabled: false,
          },
          {
            name: "10829, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "1083, Albertsons, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "1083, Costco, RINGGOLD, GA",
            disabled: false,
          },
          {
            name: "1083, Target, West Nyack, NY",
            disabled: false,
          },
          {
            name: "1083, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "10830, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "10830, Walgreens, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "10831, Rite Aid, AMHERST, NY",
            disabled: false,
          },
          {
            name: "10831, Walgreens, BAINBRIDGE, GA",
            disabled: false,
          },
          {
            name: "10832, Walgreens, MILLEDGEVILLE, GA",
            disabled: false,
          },
          {
            name: "10833, Walgreens, TIFTON, GA",
            disabled: false,
          },
          {
            name: "10834, Rite Aid, WEST SENECA, NY",
            disabled: false,
          },
          {
            name: "10835, Rite Aid, WEST SENECA, NY",
            disabled: false,
          },
          {
            name: "10835, Walgreens, MCCOMB, MS",
            disabled: false,
          },
          {
            name: "10836, Walgreens, OKMULGEE, OK",
            disabled: false,
          },
          {
            name: "10837, Rite Aid, AMHERST, NY",
            disabled: false,
          },
          {
            name: "10837, Walgreens, MEADVILLE, PA",
            disabled: false,
          },
          {
            name: "10838, Rite Aid, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "10838, Walgreens, LAKE WYLIE, SC",
            disabled: false,
          },
          {
            name: "10839, Rite Aid, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "10839, Walgreens, FREDERICKSBURG, TX",
            disabled: false,
          },
          {
            name: "1084, Costco, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1084, Target, UNION, NJ",
            disabled: false,
          },
          {
            name: "1084, Walgreens, BATTLE GROUND, WA",
            disabled: false,
          },
          {
            name: "1084, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "10841, Walgreens, BUDA, TX",
            disabled: false,
          },
          {
            name: "10842, CVS, FLORESVILLE, TX",
            disabled: false,
          },
          {
            name: "10842, Rite Aid, CANANDAIGUA, NY",
            disabled: false,
          },
          {
            name: "10843, Rite Aid, CANANDAIGUA, NY",
            disabled: false,
          },
          {
            name: "10846, Rite Aid, GENEVA, NY",
            disabled: false,
          },
          {
            name: "10849, Rite Aid, NEWARK, NY",
            disabled: false,
          },
          {
            name: "1085, ADUSA, MARION, NC",
            disabled: false,
          },
          {
            name: "1085, CVS, METHUEN, MA",
            disabled: false,
          },
          {
            name: "1085, Costco, MELROSE PARK, IL",
            disabled: false,
          },
          {
            name: "1085, Target, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "1085, Walgreens, CAMAS, WA",
            disabled: false,
          },
          {
            name: "1085, Walmart, PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "10850, Rite Aid, NORTH CHILI, NY",
            disabled: false,
          },
          {
            name: "10850, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "10851, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "10852, CVS, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "10852, Walgreens, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "10853, CVS, BELLE MEAD, NJ",
            disabled: false,
          },
          {
            name: "10854, CVS, MONSEY, NY",
            disabled: false,
          },
          {
            name: "10854, Walgreens, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "10855, Walgreens, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "10856, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "10856, Walgreens, KINGSLAND, GA",
            disabled: false,
          },
          {
            name: "10857, Walgreens, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "10858, Walgreens, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "10859, CVS, DOUGLAS, AZ",
            disabled: false,
          },
          {
            name: "10859, Rite Aid, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "10859, Walgreens, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "1086, ADUSA, ROANOKE RAPIDS, NC",
            disabled: false,
          },
          {
            name: "1086, CVS, TIVERTON, RI",
            disabled: false,
          },
          {
            name: "1086, Costco, CAMAS, WA",
            disabled: false,
          },
          {
            name: "1086, Target, Winston Salem, NC",
            disabled: false,
          },
          {
            name: "1086, Walmart, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "10861, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10861, Walgreens, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "10862, CVS, GARDNER, KS",
            disabled: false,
          },
          {
            name: "10862, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "10863, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "10864, Walgreens, ELMIRA, NY",
            disabled: false,
          },
          {
            name: "10868, Rite Aid, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "10868, Walgreens, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "10869, Walgreens, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "1087, ADUSA, BOWLING GREEN, VA",
            disabled: false,
          },
          {
            name: "1087, Albertsons, KAILUA, HI",
            disabled: false,
          },
          {
            name: "1087, CVS, STONY POINT, NY",
            disabled: false,
          },
          {
            name: "1087, Costco, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "1087, Rite Aid, CHESHIRE, CT",
            disabled: false,
          },
          {
            name: "1087, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1087, Walmart, STUART, FL",
            disabled: false,
          },
          {
            name: "10870, Walgreens, ONEIDA, TN",
            disabled: false,
          },
          {
            name: "10871, Walgreens, SAVANNAH, TN",
            disabled: false,
          },
          {
            name: "10872, Walgreens, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "10873, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "10874, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10875, CVS, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "10875, Rite Aid, OLEAN, NY",
            disabled: false,
          },
          {
            name: "10876, Walgreens, PRINCETON, WV",
            disabled: false,
          },
          {
            name: "10877, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "10877, Rite Aid, CORNING, NY",
            disabled: false,
          },
          {
            name: "10879, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "10879, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1088, CVS, MATAWAN, NJ",
            disabled: false,
          },
          {
            name: "1088, Costco, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "1088, Target, RESTON, VA",
            disabled: false,
          },
          {
            name: "1088, Walmart, BILOXI, MS",
            disabled: false,
          },
          {
            name: "10880, CVS, IRVING, TX",
            disabled: false,
          },
          {
            name: "10880, Rite Aid, HORSEHEADS, NY",
            disabled: false,
          },
          {
            name: "10881, CVS, WESTLAKE, TX",
            disabled: false,
          },
          {
            name: "10881, Rite Aid, HORSEHEADS, NY",
            disabled: false,
          },
          {
            name: "10881, Walgreens, GRASS VALLEY, CA",
            disabled: false,
          },
          {
            name: "10882, Walgreens, MIMS, FL",
            disabled: false,
          },
          {
            name: "10884, Walgreens, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "10885, CVS, HOUMA, LA",
            disabled: false,
          },
          {
            name: "10885, Walgreens, MONTGOMERY, IL",
            disabled: false,
          },
          {
            name: "10886, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "10886, Rite Aid, ELMIRA, NY",
            disabled: false,
          },
          {
            name: "10886, Walgreens, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "10887, CVS, WYLIE, TX",
            disabled: false,
          },
          {
            name: "10887, Rite Aid, ELMIRA, NY",
            disabled: false,
          },
          {
            name: "10887, Walgreens, TILTON, NH",
            disabled: false,
          },
          {
            name: "10888, Rite Aid, ALIQUIPPA, PA",
            disabled: false,
          },
          {
            name: "10889, CVS, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "10889, Rite Aid, AMBRIDGE, PA",
            disabled: false,
          },
          {
            name: "10889, Walgreens, WINCHESTER, KY",
            disabled: false,
          },
          {
            name: "1089, Albertsons, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1089, CVS, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1089, Costco, NORTH CHESTERFI, VA",
            disabled: false,
          },
          {
            name: "1089, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1089, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1089, Walmart, KIMBALL, TN",
            disabled: false,
          },
          {
            name: "10890, Rite Aid, BEAVER FALLS, PA",
            disabled: false,
          },
          {
            name: "10891, Rite Aid, BELLE VERNON, PA",
            disabled: false,
          },
          {
            name: "10891, Walgreens, SHELBY, NC",
            disabled: false,
          },
          {
            name: "10892, CVS, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "10892, Rite Aid, BRIDGEVILLE, PA",
            disabled: false,
          },
          {
            name: "10892, Walgreens, YORK, NE",
            disabled: false,
          },
          {
            name: "10893, CVS, PARMA, OH",
            disabled: false,
          },
          {
            name: "10893, Rite Aid, CHESWICK, PA",
            disabled: false,
          },
          {
            name: "10893, Walgreens, CANBY, OR",
            disabled: false,
          },
          {
            name: "10894, Rite Aid, CONWAY, PA",
            disabled: false,
          },
          {
            name: "10894, Walgreens, BUTLER, PA",
            disabled: false,
          },
          {
            name: "10896, CVS, WAYNE, PA",
            disabled: false,
          },
          {
            name: "10897, Walgreens, MAGNOLIA, AR",
            disabled: false,
          },
          {
            name: "10898, CVS, SPANISH FORT, AL",
            disabled: false,
          },
          {
            name: "10899, Rite Aid, LOWER BURRELL, PA",
            disabled: false,
          },
          {
            name: "109, ADUSA, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "109, BJ's, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "109, CVS, CHELSEA, MA",
            disabled: false,
          },
          {
            name: "109, Costco, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "109, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "109, Kroger, Clute, TX",
            disabled: false,
          },
          {
            name: "109, Kroger, Englewood, CO",
            disabled: false,
          },
          {
            name: "109, Kroger, Globe, AZ",
            disabled: false,
          },
          {
            name: "109, Kroger, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "109, Kroger, MIAMI, AZ",
            disabled: false,
          },
          {
            name: "109, Kroger, Oceanside, CA",
            disabled: false,
          },
          {
            name: "109, Meijer, Commerce, MI",
            disabled: false,
          },
          {
            name: "109, Walmart, CAMERON, MO",
            disabled: false,
          },
          {
            name: "1090, ADUSA, WALNUT COVE, NC",
            disabled: false,
          },
          {
            name: "1090, Albertsons, KODIAK, AK",
            disabled: false,
          },
          {
            name: "1090, CVS, GLENMONT, NY",
            disabled: false,
          },
          {
            name: "1090, Rite Aid, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "1090, Target, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "1090, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1090, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "10900, Rite Aid, NEW KENSINGTON, PA",
            disabled: false,
          },
          {
            name: "10900, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "10901, Rite Aid, ROCHESTER, PA",
            disabled: false,
          },
          {
            name: "10901, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "10902, CVS, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "10903, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "10905, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "10905, Rite Aid, ALLISON PARK, PA",
            disabled: false,
          },
          {
            name: "10905, Walgreens, CAMBRIDGE, MD",
            disabled: false,
          },
          {
            name: "10906, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "10906, Rite Aid, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "10907, Rite Aid, CARNEGIE, PA",
            disabled: false,
          },
          {
            name: "10907, Walgreens, FULTON, MO",
            disabled: false,
          },
          {
            name: "10908, CVS, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "10908, Walgreens, PERRYVILLE, MO",
            disabled: false,
          },
          {
            name: "10909, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1091, CVS, SAYRE, PA",
            disabled: false,
          },
          {
            name: "1091, Costco, LODI, CA",
            disabled: false,
          },
          {
            name: "1091, Target, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1091, Walmart, ANDALUSIA, AL",
            disabled: false,
          },
          {
            name: "10910, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10910, Rite Aid, WEST MIFFLIN, PA",
            disabled: false,
          },
          {
            name: "10910, Walgreens, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "10911, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10911, Rite Aid, WHITE OAK, PA",
            disabled: false,
          },
          {
            name: "10912, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "10913, CVS, SANTA BARBARA, CA",
            disabled: false,
          },
          {
            name: "10914, CVS, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "10914, Rite Aid, MCKEES ROCKS, PA",
            disabled: false,
          },
          {
            name: "10914, Walgreens, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "10915, Rite Aid, OAKMONT, PA",
            disabled: false,
          },
          {
            name: "10915, Walgreens, BELLEFONTAINE, OH",
            disabled: false,
          },
          {
            name: "10916, Rite Aid, SEWICKLEY, PA",
            disabled: false,
          },
          {
            name: "10916, Walgreens, GUTHRIE, OK",
            disabled: false,
          },
          {
            name: "10917, Rite Aid, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "10918, CVS, OAK PARK, CA",
            disabled: false,
          },
          {
            name: "10918, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "10919, CVS, SPRING VALLEY, CA",
            disabled: false,
          },
          {
            name: "10919, Rite Aid, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "10919, Walgreens, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "1092, Albertsons, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "1092, CVS, NORTH BELLMORE, NY",
            disabled: false,
          },
          {
            name: "1092, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "1092, Target, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "10920, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "10920, Walgreens, FRISCO, TX",
            disabled: false,
          },
          {
            name: "10921, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "10922, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10923, Walgreens, LOUISA, VA",
            disabled: false,
          },
          {
            name: "10924, CVS, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "10924, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10924, Walgreens, PULASKI, VA",
            disabled: false,
          },
          {
            name: "10925, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10925, Walgreens, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "10926, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10926, Walgreens, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "10927, CVS, SYRACUSE, UT",
            disabled: false,
          },
          {
            name: "10927, Walgreens, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "10928, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "10928, Walgreens, BEAVER, WV",
            disabled: false,
          },
          {
            name: "10929, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1093, CVS, COOPERSBURG, PA",
            disabled: false,
          },
          {
            name: "1093, Costco, MORGANVILLE, NJ",
            disabled: false,
          },
          {
            name: "1093, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1093, Walmart, RANTOUL, IL",
            disabled: false,
          },
          {
            name: "10931, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10932, CVS, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "10934, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10935, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "10937, CVS, POQUOSON, VA",
            disabled: false,
          },
          {
            name: "10938, Walgreens, ROCHELLE, IL",
            disabled: false,
          },
          {
            name: "10939, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10939, Walgreens, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "1094, Albertsons, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "1094, CVS, GREENFIELD, MA",
            disabled: false,
          },
          {
            name: "1094, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1094, Target, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "1094, Walmart, RAYTOWN, MO",
            disabled: false,
          },
          {
            name: "10940, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10940, Walgreens, MIDDLETON, MA",
            disabled: false,
          },
          {
            name: "10941, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "10942, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10943, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10943, Walgreens, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "10944, CVS, ALTON, TX",
            disabled: false,
          },
          {
            name: "10944, Walgreens, BRENHAM, TX",
            disabled: false,
          },
          {
            name: "10945, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "10946, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10946, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "10947, CVS, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "10947, Walgreens, OPELIKA, AL",
            disabled: false,
          },
          {
            name: "10948, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "10948, Walgreens, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "10949, CVS, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "10949, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1095, Albertsons, ALLENDALE, NJ",
            disabled: false,
          },
          {
            name: "1095, Rite Aid, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "1095, Target, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "1095, Walmart, GLENWOOD SPRINGS, CO",
            disabled: false,
          },
          {
            name: "10950, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10951, CVS, GRANITE CITY, IL",
            disabled: false,
          },
          {
            name: "10951, Walgreens, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "10952, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "10953, Walgreens, DAVISON, MI",
            disabled: false,
          },
          {
            name: "10954, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10955, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10955, Walgreens, CATSKILL, NY",
            disabled: false,
          },
          {
            name: "10956, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "10956, Walgreens, NORWALK, OH",
            disabled: false,
          },
          {
            name: "10957, Walgreens, NEWCASTLE, OK",
            disabled: false,
          },
          {
            name: "10958, Rite Aid, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "10958, Walgreens, LIMERICK, PA",
            disabled: false,
          },
          {
            name: "10959, Walgreens, JAMESTOWN, TN",
            disabled: false,
          },
          {
            name: "1096, Albertsons, KENILWORTH, NJ",
            disabled: false,
          },
          {
            name: "1096, Target, WINONA, MN",
            disabled: false,
          },
          {
            name: "1096, Walmart, MOCKSVILLE, NC",
            disabled: false,
          },
          {
            name: "10960, Rite Aid, CANONSBURG, PA",
            disabled: false,
          },
          {
            name: "10960, Walgreens, ROGERSVILLE, TN",
            disabled: false,
          },
          {
            name: "10961, CVS, DENNISON, OH",
            disabled: false,
          },
          {
            name: "10961, Rite Aid, MCMURRAY, PA",
            disabled: false,
          },
          {
            name: "10961, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "10962, CVS, GARY, IN",
            disabled: false,
          },
          {
            name: "10962, Rite Aid, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "10962, Walgreens, DODGEVILLE, WI",
            disabled: false,
          },
          {
            name: "10963, Walgreens, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "10964, Rite Aid, CONNELLSVILLE, PA",
            disabled: false,
          },
          {
            name: "10964, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "10965, Walgreens, BOAZ, AL",
            disabled: false,
          },
          {
            name: "10966, Rite Aid, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "10966, Walgreens, HARTSELLE, AL",
            disabled: false,
          },
          {
            name: "10967, Rite Aid, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "10968, Walgreens, MABLETON, GA",
            disabled: false,
          },
          {
            name: "1097, ADUSA, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1097, CVS, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "1097, Costco, FRISCO, TX",
            disabled: false,
          },
          {
            name: "1097, Target, AUBURN, CA",
            disabled: false,
          },
          {
            name: "1097, Walmart, ABERDEEN, NC",
            disabled: false,
          },
          {
            name: "10970, Rite Aid, IRWIN, PA",
            disabled: false,
          },
          {
            name: "10971, Walgreens, ISLAND LAKE, IL",
            disabled: false,
          },
          {
            name: "10972, Rite Aid, LATROBE, PA",
            disabled: false,
          },
          {
            name: "10972, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "10973, Rite Aid, MOUNT PLEASANT, PA",
            disabled: false,
          },
          {
            name: "10973, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "10974, Rite Aid, EXPORT, PA",
            disabled: false,
          },
          {
            name: "10974, Walgreens, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "10975, CVS, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "10975, Rite Aid, PUNXSUTAWNEY, PA",
            disabled: false,
          },
          {
            name: "10975, Walgreens, MORGAN CITY, LA",
            disabled: false,
          },
          {
            name: "10976, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "10976, Walgreens, CLINTON, MD",
            disabled: false,
          },
          {
            name: "10977, Walgreens, ELKTON, MD",
            disabled: false,
          },
          {
            name: "10979, CVS, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "10979, Rite Aid, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "1098, CVS, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "1098, Target, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "1098, Walmart, PORT LAVACA, TX",
            disabled: false,
          },
          {
            name: "10980, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "10980, Rite Aid, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "10981, CVS, OTTAWA, IL",
            disabled: false,
          },
          {
            name: "10981, Walgreens, ATHENS, AL",
            disabled: false,
          },
          {
            name: "10982, Rite Aid, BUTLER, PA",
            disabled: false,
          },
          {
            name: "10982, Walgreens, JACKSON, AL",
            disabled: false,
          },
          {
            name: "10983, CVS, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "10983, Rite Aid, BUTLER, PA",
            disabled: false,
          },
          {
            name: "10983, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "10984, CVS, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "10984, Walgreens, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "10985, CVS, ODESSA, TX",
            disabled: false,
          },
          {
            name: "10985, Walgreens, CORALVILLE, IA",
            disabled: false,
          },
          {
            name: "10986, Rite Aid, HARMONY, PA",
            disabled: false,
          },
          {
            name: "10987, Rite Aid, SEVEN FIELDS, PA",
            disabled: false,
          },
          {
            name: "10988, CVS, WAIANAE, HI",
            disabled: false,
          },
          {
            name: "10988, Walgreens, SCARBOROUGH, ME",
            disabled: false,
          },
          {
            name: "10989, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1099, Albertsons, OAK RIDGE, NJ",
            disabled: false,
          },
          {
            name: "1099, CVS, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "1099, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "10990, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "10990, Rite Aid, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "10991, CVS, WINDSOR, VA",
            disabled: false,
          },
          {
            name: "10991, Rite Aid, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "10992, CVS, MOSELEY, VA",
            disabled: false,
          },
          {
            name: "10992, Rite Aid, ELLWOOD CITY, PA",
            disabled: false,
          },
          {
            name: "10995, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "10995, Walgreens, TUKWILA, WA",
            disabled: false,
          },
          {
            name: "10996, CVS, WILLIS, TX",
            disabled: false,
          },
          {
            name: "10998, CVS, NORCO, CA",
            disabled: false,
          },
          {
            name: "10998, Rite Aid, KITTANNING, PA",
            disabled: false,
          },
          {
            name: "10998, Walgreens, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "10999, Rite Aid, CONNEAUT LAKE, PA",
            disabled: false,
          },
          {
            name: "11, ADUSA, REVERE, MA",
            disabled: false,
          },
          {
            name: "11, CVS, HUNTINGTON, NY",
            disabled: false,
          },
          {
            name: "11, Kroger, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "11, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "11, Kroger, GREELEY, CO",
            disabled: false,
          },
          {
            name: "11, Kroger, Jeffersonville, IN",
            disabled: false,
          },
          {
            name: "11, Kroger, Monroe, OH",
            disabled: false,
          },
          {
            name: "11, Kroger, Saint John, KS",
            disabled: false,
          },
          {
            name: "11, Walmart, MOUNTAIN HOME, AR",
            disabled: false,
          },
          {
            name: "110, Albertsons, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "110, BJ's, CARY, NC",
            disabled: false,
          },
          {
            name: "110, Costco, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "110, HEB, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "110, Kroger, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "110, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "110, Kroger, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "110, Meijer, LIMA, OH",
            disabled: false,
          },
          {
            name: "110, Walmart, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "1100, ADUSA, MURFREESBORO, NC",
            disabled: false,
          },
          {
            name: "1100, Costco, NATIONAL CITY, CA",
            disabled: false,
          },
          {
            name: "1100, Target, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "1100, Walgreens, HAPPY VALLEY, OR",
            disabled: false,
          },
          {
            name: "1100, Walmart, HAMILTON, AL",
            disabled: false,
          },
          {
            name: "11001, CVS, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11002, CVS, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11002, Rite Aid, FRANKLIN, PA",
            disabled: false,
          },
          {
            name: "11002, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11003, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11005, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11006, Rite Aid, NORTH EAST, PA",
            disabled: false,
          },
          {
            name: "11006, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11008, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "11008, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11009, CVS, BUTLER, NJ",
            disabled: false,
          },
          {
            name: "11009, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "11009, Walgreens, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "1101, CVS, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1101, Costco, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "1101, Target, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "1101, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1101, Walmart, WETUMPKA, AL",
            disabled: false,
          },
          {
            name: "11010, CVS, LUMBERTON, NJ",
            disabled: false,
          },
          {
            name: "11010, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "11011, Rite Aid, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "11011, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11012, CVS, MIDDLETOWN, NJ",
            disabled: false,
          },
          {
            name: "11012, Rite Aid, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "11013, Rite Aid, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "11014, Rite Aid, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "11015, Rite Aid, BELLEFONTE, PA",
            disabled: false,
          },
          {
            name: "11016, Rite Aid, WELLSBORO, PA",
            disabled: false,
          },
          {
            name: "11016, Walgreens, LAUREL, DE",
            disabled: false,
          },
          {
            name: "11017, CVS, POOLER, GA",
            disabled: false,
          },
          {
            name: "11017, Rite Aid, CAMP HILL, PA",
            disabled: false,
          },
          {
            name: "11017, Walgreens, BEAR, DE",
            disabled: false,
          },
          {
            name: "11018, Rite Aid, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "11019, Rite Aid, DILLSBURG, PA",
            disabled: false,
          },
          {
            name: "1102, CVS, BLOOMFIELD, CT",
            disabled: false,
          },
          {
            name: "1102, Costco, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "1102, Target, BRENTWOOD, MO",
            disabled: false,
          },
          {
            name: "1102, Walmart, BAKER, LA",
            disabled: false,
          },
          {
            name: "11020, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "11020, Rite Aid, LEBANON, PA",
            disabled: false,
          },
          {
            name: "11021, Rite Aid, CLEONA, PA",
            disabled: false,
          },
          {
            name: "11021, Walgreens, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "11022, Walgreens, BEAR, DE",
            disabled: false,
          },
          {
            name: "11023, CVS, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "11024, CVS, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11024, Rite Aid, WAYNESBORO, PA",
            disabled: false,
          },
          {
            name: "11024, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11026, Walgreens, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "11027, Rite Aid, HANOVER, PA",
            disabled: false,
          },
          {
            name: "11027, Walgreens, PENNSVILLE, NJ",
            disabled: false,
          },
          {
            name: "11028, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11029, Rite Aid, RED LION, PA",
            disabled: false,
          },
          {
            name: "1103, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1103, CVS, KEY LARGO, FL",
            disabled: false,
          },
          {
            name: "1103, Costco, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "1103, Target, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "1103, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11030, Rite Aid, SHREWSBURY, PA",
            disabled: false,
          },
          {
            name: "11030, Walgreens, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "11031, Rite Aid, STEWARTSTOWN, PA",
            disabled: false,
          },
          {
            name: "11031, Walgreens, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "11032, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11033, CVS, VENTURA, CA",
            disabled: false,
          },
          {
            name: "11033, Rite Aid, YORK, PA",
            disabled: false,
          },
          {
            name: "11034, CVS, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "11034, Rite Aid, WILLOW STREET, PA",
            disabled: false,
          },
          {
            name: "11034, Walgreens, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "11035, CVS, FONTANA, CA",
            disabled: false,
          },
          {
            name: "11035, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11036, Rite Aid, WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "11037, Walgreens, NORTH EAST, MD",
            disabled: false,
          },
          {
            name: "11038, CVS, WHITESTONE, NY",
            disabled: false,
          },
          {
            name: "11038, Rite Aid, BLOOMSBURG, PA",
            disabled: false,
          },
          {
            name: "1104, CVS, ALLEN, TX",
            disabled: false,
          },
          {
            name: "1104, Target, GARNER, NC",
            disabled: false,
          },
          {
            name: "1104, Walmart, INVERNESS, FL",
            disabled: false,
          },
          {
            name: "11040, CVS, HUMMELSTOWN, PA",
            disabled: false,
          },
          {
            name: "11042, Rite Aid, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "11043, Rite Aid, EASTON, PA",
            disabled: false,
          },
          {
            name: "11044, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "11044, Walgreens, CLARKSVILLE, DE",
            disabled: false,
          },
          {
            name: "11045, CVS, SCHERTZ, TX",
            disabled: false,
          },
          {
            name: "11045, Rite Aid, EASTON, PA",
            disabled: false,
          },
          {
            name: "11045, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11046, CVS, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "11046, Rite Aid, EMMAUS, PA",
            disabled: false,
          },
          {
            name: "11047, Rite Aid, FOGELSVILLE, PA",
            disabled: false,
          },
          {
            name: "11047, Walgreens, GEORGETOWN, DE",
            disabled: false,
          },
          {
            name: "11048, Rite Aid, HELLERTOWN, PA",
            disabled: false,
          },
          {
            name: "11048, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11049, Rite Aid, WALNUTPORT, PA",
            disabled: false,
          },
          {
            name: "11049, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1105, Albertsons, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "1105, Target, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1105, Walmart, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "11050, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11051, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11052, Walgreens, HOCKESSIN, DE",
            disabled: false,
          },
          {
            name: "11054, CVS, BOYDS, MD",
            disabled: false,
          },
          {
            name: "11054, Rite Aid, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "11054, Walgreens, PERRYVILLE, MD",
            disabled: false,
          },
          {
            name: "11055, Rite Aid, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "11055, Walgreens, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "11056, CVS, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "11056, Rite Aid, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "11056, Walgreens, GLEN MILLS, PA",
            disabled: false,
          },
          {
            name: "11057, Walgreens, CENTREVILLE, MD",
            disabled: false,
          },
          {
            name: "11058, Rite Aid, LEHIGHTON, PA",
            disabled: false,
          },
          {
            name: "11058, Walgreens, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "11059, Rite Aid, LEHIGHTON, PA",
            disabled: false,
          },
          {
            name: "1106, Costco, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "1106, Target, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "1106, Walgreens, FLOURTOWN, PA",
            disabled: false,
          },
          {
            name: "1106, Walmart, VIDALIA, LA",
            disabled: false,
          },
          {
            name: "11060, Rite Aid, TAMAQUA, PA",
            disabled: false,
          },
          {
            name: "11060, Walgreens, DOVER, DE",
            disabled: false,
          },
          {
            name: "11061, Walgreens, DOVER, DE",
            disabled: false,
          },
          {
            name: "11062, Rite Aid, MOUNT POCONO, PA",
            disabled: false,
          },
          {
            name: "11063, CVS, ELKTON, MD",
            disabled: false,
          },
          {
            name: "11063, Walgreens, MAGNOLIA, DE",
            disabled: false,
          },
          {
            name: "11065, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "11066, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11066, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11067, CVS, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "11067, Walgreens, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "11069, Rite Aid, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "11069, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1107, Costco, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1107, Target, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1107, Walmart, OAKDALE, LA",
            disabled: false,
          },
          {
            name: "11070, CVS, BROOKLYN PARK, MN",
            disabled: false,
          },
          {
            name: "11073, Rite Aid, BERWICK, PA",
            disabled: false,
          },
          {
            name: "11073, Walgreens, MILTON, DE",
            disabled: false,
          },
          {
            name: "11074, Walgreens, OXFORD, PA",
            disabled: false,
          },
          {
            name: "11075, CVS, NEW YORK, NY",
            disabled: false,
          },
          {
            name: "11075, Rite Aid, PITTSTON, PA",
            disabled: false,
          },
          {
            name: "11075, Walgreens, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "11076, Rite Aid, TUNKHANNOCK, PA",
            disabled: false,
          },
          {
            name: "11077, Rite Aid, WILKES-BARRE, PA",
            disabled: false,
          },
          {
            name: "11079, Walgreens, DELMAR, DE",
            disabled: false,
          },
          {
            name: "1108, Albertsons, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "1108, CVS, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "1108, Costco, PHARR, TX",
            disabled: false,
          },
          {
            name: "1108, Target, COMMACK, NY",
            disabled: false,
          },
          {
            name: "1108, Walmart, OAK GROVE, LA",
            disabled: false,
          },
          {
            name: "11080, CVS, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "11080, Walgreens, HOCKESSIN, DE",
            disabled: false,
          },
          {
            name: "11081, CVS, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "11081, Rite Aid, LUZERNE, PA",
            disabled: false,
          },
          {
            name: "11081, Walgreens, FALLBROOK, CA",
            disabled: false,
          },
          {
            name: "11082, Rite Aid, MONTROSE, PA",
            disabled: false,
          },
          {
            name: "11083, CVS, POWHATAN, VA",
            disabled: false,
          },
          {
            name: "11083, Rite Aid, SAYRE, PA",
            disabled: false,
          },
          {
            name: "11083, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "11084, CVS, WHITEHALL, PA",
            disabled: false,
          },
          {
            name: "11084, Rite Aid, TOWANDA, PA",
            disabled: false,
          },
          {
            name: "11084, Walgreens, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "11085, Rite Aid, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "11085, Walgreens, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "11086, Walgreens, FORT SCOTT, KS",
            disabled: false,
          },
          {
            name: "11087, Rite Aid, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "11087, Walgreens, RAYMORE, MO",
            disabled: false,
          },
          {
            name: "11088, CVS, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "11088, Walgreens, ROCKINGHAM, NC",
            disabled: false,
          },
          {
            name: "11089, Rite Aid, NEWTOWN, PA",
            disabled: false,
          },
          {
            name: "11089, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "1109, Albertsons, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "1109, CVS, BETHEL, CT",
            disabled: false,
          },
          {
            name: "1109, Target, MAYS LANDING, NJ",
            disabled: false,
          },
          {
            name: "1109, Walmart, RAYVILLE, LA",
            disabled: false,
          },
          {
            name: "11090, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "11090, Rite Aid, PERKASIE, PA",
            disabled: false,
          },
          {
            name: "11091, CVS, ARGYLE, TX",
            disabled: false,
          },
          {
            name: "11091, Rite Aid, PIPERSVILLE, PA",
            disabled: false,
          },
          {
            name: "11092, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "11092, Rite Aid, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "11093, CVS, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "11095, Rite Aid, SOUDERTON, PA",
            disabled: false,
          },
          {
            name: "11095, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "11096, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "11097, CVS, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "11097, Rite Aid, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "11097, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11098, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "11098, Walgreens, TROY, AL",
            disabled: false,
          },
          {
            name: "11099, CVS, ODESSA, TX",
            disabled: false,
          },
          {
            name: "11099, Rite Aid, HUNTINGDON VALLEY, PA",
            disabled: false,
          },
          {
            name: "11099, Walgreens, HELENA, AL",
            disabled: false,
          },
          {
            name: "111, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "111, ADUSA, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "111, Albertsons, GRASS VALLEY, CA",
            disabled: false,
          },
          {
            name: "111, CVS, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "111, Costco, TIGARD, OR",
            disabled: false,
          },
          {
            name: "111, Kroger, Bellevue, WI",
            disabled: false,
          },
          {
            name: "111, Kroger, Columbia, MO",
            disabled: false,
          },
          {
            name: "111, Kroger, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "111, Kroger, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "111, Kroger, GARDENA, CA",
            disabled: false,
          },
          {
            name: "111, Meijer, MARION, OH",
            disabled: false,
          },
          {
            name: "111, ShopRite, NUTLEY, NJ",
            disabled: false,
          },
          {
            name: "111, Target, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "111, Walmart, CHANUTE, KS",
            disabled: false,
          },
          {
            name: "1110, Albertsons, SALINAS, CA",
            disabled: false,
          },
          {
            name: "1110, CVS, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "1110, Costco, HUNTINGTON BEAC, CA",
            disabled: false,
          },
          {
            name: "1110, Target, GREENACRES, FL",
            disabled: false,
          },
          {
            name: "1110, Walmart, FARMERVILLE, LA",
            disabled: false,
          },
          {
            name: "11100, Rite Aid, BRISTOL, PA",
            disabled: false,
          },
          {
            name: "11101, Rite Aid, BRYN MAWR, PA",
            disabled: false,
          },
          {
            name: "11101, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "11104, CVS, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "11104, Rite Aid, DRESHER, PA",
            disabled: false,
          },
          {
            name: "11104, Walgreens, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "11105, Rite Aid, DREXEL HILL, PA",
            disabled: false,
          },
          {
            name: "11105, Walgreens, OCOEE, FL",
            disabled: false,
          },
          {
            name: "11106, Rite Aid, FAIRLESS HILLS, PA",
            disabled: false,
          },
          {
            name: "11106, Walgreens, AMERICUS, GA",
            disabled: false,
          },
          {
            name: "11107, Walgreens, CAIRO, GA",
            disabled: false,
          },
          {
            name: "11108, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "11109, Rite Aid, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "11109, Walgreens, MIDLOTHIAN, IL",
            disabled: false,
          },
          {
            name: "1111, Albertsons, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "1111, CVS, WARE, MA",
            disabled: false,
          },
          {
            name: "1111, Costco, CORALVILLE, IA",
            disabled: false,
          },
          {
            name: "1111, Walmart, HARTWELL, GA",
            disabled: false,
          },
          {
            name: "11110, Rite Aid, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "11111, CVS, BREA, CA",
            disabled: false,
          },
          {
            name: "11111, Walgreens, MADISON, MS",
            disabled: false,
          },
          {
            name: "11112, CVS, UPLAND, CA",
            disabled: false,
          },
          {
            name: "11112, Rite Aid, BOOTHWYN, PA",
            disabled: false,
          },
          {
            name: "11112, Walgreens, JAMAICA, NY",
            disabled: false,
          },
          {
            name: "11113, Rite Aid, MEDIA, PA",
            disabled: false,
          },
          {
            name: "11113, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "11115, Rite Aid, MORRISVILLE, PA",
            disabled: false,
          },
          {
            name: "11115, Walgreens, THOMASVILLE, AL",
            disabled: false,
          },
          {
            name: "11116, Rite Aid, NEWTOWN SQUARE, PA",
            disabled: false,
          },
          {
            name: "11116, Walgreens, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "11117, Rite Aid, UPPER DARBY, PA",
            disabled: false,
          },
          {
            name: "11118, Walgreens, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "11119, Walgreens, CLINTON, MA",
            disabled: false,
          },
          {
            name: "1112, Target, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "1112, Walmart, THOMASTON, GA",
            disabled: false,
          },
          {
            name: "11120, Walgreens, HOLDEN, MA",
            disabled: false,
          },
          {
            name: "11122, Rite Aid, WYNNEWOOD, PA",
            disabled: false,
          },
          {
            name: "11124, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11125, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11125, Walgreens, HIBBING, MN",
            disabled: false,
          },
          {
            name: "11126, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11126, Walgreens, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "11128, Walgreens, COVENTRY, RI",
            disabled: false,
          },
          {
            name: "11129, Walgreens, PORTLAND, TN",
            disabled: false,
          },
          {
            name: "1113, Target, CORALVILLE, IA",
            disabled: false,
          },
          {
            name: "1113, Walmart, LONDON, KY",
            disabled: false,
          },
          {
            name: "11130, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11130, Walgreens, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "11131, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11131, Walgreens, LOCKHART, TX",
            disabled: false,
          },
          {
            name: "11132, Walgreens, MILFORD, DE",
            disabled: false,
          },
          {
            name: "11133, CVS, OAK POINT, TX",
            disabled: false,
          },
          {
            name: "11133, Walgreens, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11134, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11134, Walgreens, SMYRNA, DE",
            disabled: false,
          },
          {
            name: "11135, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11135, Walgreens, TOWNSEND, DE",
            disabled: false,
          },
          {
            name: "11136, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11136, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11136, Walgreens, SELBYVILLE, DE",
            disabled: false,
          },
          {
            name: "11137, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "11138, Walgreens, HOUMA, LA",
            disabled: false,
          },
          {
            name: "11139, CVS, GLEN ELLYN, IL",
            disabled: false,
          },
          {
            name: "11139, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11139, Walgreens, RUSTON, LA",
            disabled: false,
          },
          {
            name: "1114, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1114, Costco, GLEN MILLS, PA",
            disabled: false,
          },
          {
            name: "1114, Target, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "1114, Walmart, MOUNTAIN VIEW, AR",
            disabled: false,
          },
          {
            name: "11140, Walgreens, TAKOMA PARK, MD",
            disabled: false,
          },
          {
            name: "11141, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11142, Rite Aid, COATESVILLE, PA",
            disabled: false,
          },
          {
            name: "11142, Walgreens, CLARENCE, NY",
            disabled: false,
          },
          {
            name: "11143, Rite Aid, DOWNINGTOWN, PA",
            disabled: false,
          },
          {
            name: "11143, Walgreens, FAIRLAWN, OH",
            disabled: false,
          },
          {
            name: "11144, Rite Aid, DOWNINGTOWN, PA",
            disabled: false,
          },
          {
            name: "11145, Walgreens, POWELL, OH",
            disabled: false,
          },
          {
            name: "11147, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "11148, Rite Aid, KENNETT SQUARE, PA",
            disabled: false,
          },
          {
            name: "11148, Walgreens, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "1115, CVS, LINDENHURST, NY",
            disabled: false,
          },
          {
            name: "1115, Costco, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1115, Target, CONROE, TX",
            disabled: false,
          },
          {
            name: "1115, Walmart, HOHENWALD, TN",
            disabled: false,
          },
          {
            name: "11150, CVS, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "11150, Walgreens, OREM, UT",
            disabled: false,
          },
          {
            name: "11153, Rite Aid, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "11153, Walgreens, SPENCER, IA",
            disabled: false,
          },
          {
            name: "11155, CVS, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "11155, Walgreens, OAKLAND, NJ",
            disabled: false,
          },
          {
            name: "11157, Walgreens, ALEXANDRIA, MN",
            disabled: false,
          },
          {
            name: "11158, Walgreens, HILLSBORO, OH",
            disabled: false,
          },
          {
            name: "1116, Albertsons, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "1116, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "1116, Costco, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "1116, Target, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "1116, Walgreens, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "1116, Walmart, DUNCAN, OK",
            disabled: false,
          },
          {
            name: "11160, CVS, EL PASO, TX",
            disabled: false,
          },
          {
            name: "11160, Rite Aid, CONSHOHOCKEN, PA",
            disabled: false,
          },
          {
            name: "11160, Walgreens, OOLTEWAH, TN",
            disabled: false,
          },
          {
            name: "11161, Walgreens, NEWPORT, AR",
            disabled: false,
          },
          {
            name: "11162, CVS, FARMERS BRANCH, TX",
            disabled: false,
          },
          {
            name: "11162, Rite Aid, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "11164, Walgreens, RIDGEFIELD, CT",
            disabled: false,
          },
          {
            name: "11165, Rite Aid, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "11165, Walgreens, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "11166, Rite Aid, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "11166, Walgreens, ELBERTON, GA",
            disabled: false,
          },
          {
            name: "11167, Walgreens, EMPORIA, KS",
            disabled: false,
          },
          {
            name: "11168, Walgreens, RUSSELLVILLE, KY",
            disabled: false,
          },
          {
            name: "11169, CVS, BOISE, ID",
            disabled: false,
          },
          {
            name: "11169, Rite Aid, KUTZTOWN, PA",
            disabled: false,
          },
          {
            name: "11169, Walgreens, ABERDEEN, MD",
            disabled: false,
          },
          {
            name: "1117, Albertsons, KAILUA KONA, HI",
            disabled: false,
          },
          {
            name: "1117, CVS, BOHEMIA, NY",
            disabled: false,
          },
          {
            name: "1117, Target, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "1117, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "11171, Rite Aid, READING, PA",
            disabled: false,
          },
          {
            name: "11171, Walgreens, GREENWOOD, MS",
            disabled: false,
          },
          {
            name: "11172, Rite Aid, READING, PA",
            disabled: false,
          },
          {
            name: "11173, CVS, WRENTHAM, MA",
            disabled: false,
          },
          {
            name: "11173, Rite Aid, READING, PA",
            disabled: false,
          },
          {
            name: "11173, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "11174, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "11175, Rite Aid, BEAR, DE",
            disabled: false,
          },
          {
            name: "11175, Walgreens, KILGORE, TX",
            disabled: false,
          },
          {
            name: "11176, Rite Aid, BEAR, DE",
            disabled: false,
          },
          {
            name: "11176, Walgreens, LAKE MILLS, WI",
            disabled: false,
          },
          {
            name: "11177, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11177, Rite Aid, CLAYMONT, DE",
            disabled: false,
          },
          {
            name: "11179, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "11179, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "1118, Albertsons, CLINTON, IA",
            disabled: false,
          },
          {
            name: "1118, CVS, BAYPORT, NY",
            disabled: false,
          },
          {
            name: "1118, Costco, SPANISH FORK, UT",
            disabled: false,
          },
          {
            name: "1118, Target, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "1118, Walmart, BALCH SPRINGS, TX",
            disabled: false,
          },
          {
            name: "11180, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11180, Walgreens, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "11181, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11182, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "11182, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "11183, Rite Aid, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "11183, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "11186, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11187, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "11187, Walgreens, FRUITA, CO",
            disabled: false,
          },
          {
            name: "11188, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1119, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "1119, CVS, HURLEY, MS",
            disabled: false,
          },
          {
            name: "1119, Costco, WEST FARGO, ND",
            disabled: false,
          },
          {
            name: "1119, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "11190, Rite Aid, CAMDEN, DE",
            disabled: false,
          },
          {
            name: "11190, Walgreens, LAKE WALES, FL",
            disabled: false,
          },
          {
            name: "11191, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "11192, Rite Aid, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "11192, Walgreens, LAHAINA, HI",
            disabled: false,
          },
          {
            name: "11193, Rite Aid, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "11193, Walgreens, BOONE, IA",
            disabled: false,
          },
          {
            name: "11194, Rite Aid, SEAFORD, DE",
            disabled: false,
          },
          {
            name: "11195, CVS, DENVER, CO",
            disabled: false,
          },
          {
            name: "11195, Rite Aid, SMYRNA, DE",
            disabled: false,
          },
          {
            name: "11195, Walgreens, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "11196, Walgreens, GEISMAR, LA",
            disabled: false,
          },
          {
            name: "11197, Walgreens, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "11198, Walgreens, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "11199, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "112, Costco, EAST WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "112, Kroger, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "112, Kroger, BENNETT, CO",
            disabled: false,
          },
          {
            name: "112, Kroger, Flint, MI",
            disabled: false,
          },
          {
            name: "112, Kroger, Springfield, MO",
            disabled: false,
          },
          {
            name: "112, Meijer, TROY, OH",
            disabled: false,
          },
          {
            name: "112, Walmart, STARKVILLE, MS",
            disabled: false,
          },
          {
            name: "1120, CVS, VENICE, FL",
            disabled: false,
          },
          {
            name: "1120, Costco, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1120, Target, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "1120, Walmart, GLADSTONE, MO",
            disabled: false,
          },
          {
            name: "11200, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "11201, Walgreens, ELKIN, NC",
            disabled: false,
          },
          {
            name: "11203, CVS, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "11203, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "11204, CVS, MENDHAM, NJ",
            disabled: false,
          },
          {
            name: "11204, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "11205, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "11206, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "11207, Walgreens, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "11208, Rite Aid, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "11209, CVS, LA PORTE, TX",
            disabled: false,
          },
          {
            name: "11209, Walgreens, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "1121, CVS, WESTFORD, MA",
            disabled: false,
          },
          {
            name: "1121, Costco, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "1121, Target, Citrus Heights, CA",
            disabled: false,
          },
          {
            name: "1121, Walmart, MILLEDGEVILLE, GA",
            disabled: false,
          },
          {
            name: "11210, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11210, Walgreens, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "11211, Rite Aid, HAVRE DE GRACE, MD",
            disabled: false,
          },
          {
            name: "11211, Walgreens, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "11212, Walgreens, HENDERSON, TX",
            disabled: false,
          },
          {
            name: "11213, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "11213, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11214, Walgreens, OAK HARBOR, WA",
            disabled: false,
          },
          {
            name: "11215, Walgreens, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "11216, CVS, GOLETA, CA",
            disabled: false,
          },
          {
            name: "11218, Rite Aid, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "11219, Rite Aid, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "1122, Costco, BAXTER, MN",
            disabled: false,
          },
          {
            name: "1122, Target, San Mateo, CA",
            disabled: false,
          },
          {
            name: "1122, Walmart, EASTANOLLEE, GA",
            disabled: false,
          },
          {
            name: "11221, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "11224, Walgreens, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "11225, Walgreens, RAYMOND, NH",
            disabled: false,
          },
          {
            name: "11226, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "11227, Walgreens, SPARKS, NV",
            disabled: false,
          },
          {
            name: "1123, Albertsons, HOOD RIVER, OR",
            disabled: false,
          },
          {
            name: "1123, CVS, SOUTHBURY, CT",
            disabled: false,
          },
          {
            name: "1123, Costco, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "1123, Walmart, SENECA, SC",
            disabled: false,
          },
          {
            name: "11233, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "11234, Walgreens, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "11235, Rite Aid, HAYES, VA",
            disabled: false,
          },
          {
            name: "11235, Walgreens, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "11236, CVS, ODESSA, FL",
            disabled: false,
          },
          {
            name: "11236, Walgreens, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "11237, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "11238, Walgreens, ELKINS, WV",
            disabled: false,
          },
          {
            name: "11239, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "1124, Costco, WHEATON, MD",
            disabled: false,
          },
          {
            name: "1124, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1124, Walmart, HARTSELLE, AL",
            disabled: false,
          },
          {
            name: "11241, Walgreens, ALISO VIEJO, CA",
            disabled: false,
          },
          {
            name: "11242, Walgreens, MADERA, CA",
            disabled: false,
          },
          {
            name: "11243, CVS, BELLEVILLE, MI",
            disabled: false,
          },
          {
            name: "11243, Walgreens, NORWALK, CA",
            disabled: false,
          },
          {
            name: "11244, CVS, BIRMINGHAM, MI",
            disabled: false,
          },
          {
            name: "11244, Walgreens, ALACHUA, FL",
            disabled: false,
          },
          {
            name: "11245, CVS, GROSSE ILE, MI",
            disabled: false,
          },
          {
            name: "11245, Walgreens, NEWBERRY, FL",
            disabled: false,
          },
          {
            name: "11247, CVS, MONTROSE, MI",
            disabled: false,
          },
          {
            name: "11248, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "11249, Walgreens, WYOMING, MI",
            disabled: false,
          },
          {
            name: "1125, Albertsons, CHICO, CA",
            disabled: false,
          },
          {
            name: "1125, CVS, PLAINFIELD, CT",
            disabled: false,
          },
          {
            name: "1125, Costco, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "1125, Target, NILES, IL",
            disabled: false,
          },
          {
            name: "1125, Walmart, NORMAL, IL",
            disabled: false,
          },
          {
            name: "11250, CVS, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "11250, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11250, Walgreens, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "11251, CVS, CANTON, MI",
            disabled: false,
          },
          {
            name: "11251, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11251, Walgreens, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "11252, CVS, IMLAY CITY, MI",
            disabled: false,
          },
          {
            name: "11252, Walgreens, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "11253, Walgreens, BEAVER DAM, WI",
            disabled: false,
          },
          {
            name: "11254, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11255, CVS, HARDEEVILLE, SC",
            disabled: false,
          },
          {
            name: "11255, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11256, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "11258, Rite Aid, SMITHFIELD, VA",
            disabled: false,
          },
          {
            name: "11259, Rite Aid, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "1126, Costco, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "1126, Target, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "1126, Walmart, BOERNE, TX",
            disabled: false,
          },
          {
            name: "11261, Walgreens, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "11262, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11262, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "11263, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11263, Walgreens, GREELEY, CO",
            disabled: false,
          },
          {
            name: "11264, CVS, SHELTON, CT",
            disabled: false,
          },
          {
            name: "11264, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11265, Walgreens, STEVENSVILLE, MI",
            disabled: false,
          },
          {
            name: "11266, CVS, LOWELL, MA",
            disabled: false,
          },
          {
            name: "11266, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11266, Walgreens, CORNELIUS, NC",
            disabled: false,
          },
          {
            name: "11268, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11269, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1127, Albertsons, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "1127, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1127, Walgreens, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "11270, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11270, Walgreens, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "11271, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11271, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11272, Walgreens, BEE CAVE, TX",
            disabled: false,
          },
          {
            name: "11273, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11273, Walgreens, COPPERAS COVE, TX",
            disabled: false,
          },
          {
            name: "11274, Walgreens, GATESVILLE, TX",
            disabled: false,
          },
          {
            name: "11275, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "11275, Walgreens, GROVES, TX",
            disabled: false,
          },
          {
            name: "11276, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "11276, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11277, Rite Aid, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "11277, Walgreens, SAUK CITY, WI",
            disabled: false,
          },
          {
            name: "11278, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11278, Rite Aid, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "11278, Walgreens, STEVENS POINT, WI",
            disabled: false,
          },
          {
            name: "11279, Walgreens, ALBERTVILLE, AL",
            disabled: false,
          },
          {
            name: "1128, CVS, CHESTER, NY",
            disabled: false,
          },
          {
            name: "1128, Target, BEAVERCREEK, OH",
            disabled: false,
          },
          {
            name: "1128, Walmart, MARKSVILLE, LA",
            disabled: false,
          },
          {
            name: "11281, Walgreens, GONZALES, LA",
            disabled: false,
          },
          {
            name: "11282, Rite Aid, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "11283, CVS, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "11283, Walgreens, CHESTER, MD",
            disabled: false,
          },
          {
            name: "11285, Walgreens, BANGOR, ME",
            disabled: false,
          },
          {
            name: "11286, Walgreens, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "11287, Rite Aid, POQUOSON, VA",
            disabled: false,
          },
          {
            name: "11287, Walgreens, BLAINE, MN",
            disabled: false,
          },
          {
            name: "11288, Walgreens, WEST PLAINS, MO",
            disabled: false,
          },
          {
            name: "11289, Walgreens, BATESVILLE, MS",
            disabled: false,
          },
          {
            name: "1129, Albertsons, DUNKIRK, MD",
            disabled: false,
          },
          {
            name: "1129, CVS, ROBBINSDALE, MN",
            disabled: false,
          },
          {
            name: "1129, Target, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "1129, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11290, Rite Aid, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "11290, Walgreens, TUPELO, MS",
            disabled: false,
          },
          {
            name: "11291, Rite Aid, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "11293, Walgreens, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "11294, Walgreens, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "11295, CVS, SOLVANG, CA",
            disabled: false,
          },
          {
            name: "11295, Walgreens, ADA, OK",
            disabled: false,
          },
          {
            name: "11297, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "11297, Rite Aid, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "11297, Walgreens, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "11298, Walgreens, HAYES, VA",
            disabled: false,
          },
          {
            name: "11299, Walgreens, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "113, Albertsons, NASHUA, NH",
            disabled: false,
          },
          {
            name: "113, BJ's, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "113, Costco, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "113, Kroger, Denver, CO",
            disabled: false,
          },
          {
            name: "113, Kroger, FONTANA, CA",
            disabled: false,
          },
          {
            name: "113, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "113, Meijer, CORUNNA, MI",
            disabled: false,
          },
          {
            name: "113, ShopRite, LYNDHURST, NJ",
            disabled: false,
          },
          {
            name: "113, Walmart, CHICKASHA, OK",
            disabled: false,
          },
          {
            name: "1130, CVS, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "1130, Walmart, LAURENS, SC",
            disabled: false,
          },
          {
            name: "11300, Walgreens, BURLINGTON, WA",
            disabled: false,
          },
          {
            name: "11301, Walgreens, NEW LONDON, WI",
            disabled: false,
          },
          {
            name: "11304, Rite Aid, FRANKLIN, VA",
            disabled: false,
          },
          {
            name: "11305, Rite Aid, LAWRENCEVILLE, VA",
            disabled: false,
          },
          {
            name: "11305, Walgreens, STUART, FL",
            disabled: false,
          },
          {
            name: "11306, Walgreens, WILLISTON, FL",
            disabled: false,
          },
          {
            name: "11307, Walgreens, BARDSTOWN, KY",
            disabled: false,
          },
          {
            name: "1131, Albertsons, MONTROSE, CO",
            disabled: false,
          },
          {
            name: "1131, CVS, NORTH ADAMS, MA",
            disabled: false,
          },
          {
            name: "1131, Target, Saint Petersburg, FL",
            disabled: false,
          },
          {
            name: "1131, Walgreens, NORTH AURORA, IL",
            disabled: false,
          },
          {
            name: "1131, Walmart, TAYLORSVILLE, NC",
            disabled: false,
          },
          {
            name: "11310, Walgreens, MANISTEE, MI",
            disabled: false,
          },
          {
            name: "11311, Walgreens, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "11312, CVS, LEXINGTON, MO",
            disabled: false,
          },
          {
            name: "11316, CVS, MARSHALL, MO",
            disabled: false,
          },
          {
            name: "11317, Walgreens, DURANT, OK",
            disabled: false,
          },
          {
            name: "1132, CVS, NEWBURYPORT, MA",
            disabled: false,
          },
          {
            name: "1132, Target, TURNERSVILLE, NJ",
            disabled: false,
          },
          {
            name: "1132, Walmart, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "11320, Walgreens, LITTLE ELM, TX",
            disabled: false,
          },
          {
            name: "11323, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "11323, Walgreens, AVONDALE, PA",
            disabled: false,
          },
          {
            name: "11324, CVS, ALEDO, TX",
            disabled: false,
          },
          {
            name: "11326, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11327, CVS, ROSHARON, TX",
            disabled: false,
          },
          {
            name: "11327, Walgreens, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "11328, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11329, Walgreens, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "1133, Target, VOORHEES, NJ",
            disabled: false,
          },
          {
            name: "1133, Walmart, ALBEMARLE, NC",
            disabled: false,
          },
          {
            name: "11330, Walgreens, STORM LAKE, IA",
            disabled: false,
          },
          {
            name: "11331, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "11332, Walgreens, NORRIDGE, IL",
            disabled: false,
          },
          {
            name: "11333, Walgreens, RIVERSIDE, NJ",
            disabled: false,
          },
          {
            name: "11334, Walgreens, ANGOLA, NY",
            disabled: false,
          },
          {
            name: "11337, Walgreens, CEDAR CITY, UT",
            disabled: false,
          },
          {
            name: "11339, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "1134, CVS, BEDFORD HILLS, NY",
            disabled: false,
          },
          {
            name: "1134, Target, EXTON, PA",
            disabled: false,
          },
          {
            name: "1134, Walmart, DEFUNIAK SPRINGS, FL",
            disabled: false,
          },
          {
            name: "11340, Walgreens, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "11341, CVS, REDDING, CA",
            disabled: false,
          },
          {
            name: "11342, CVS, ANDERSON, CA",
            disabled: false,
          },
          {
            name: "11344, Walgreens, FORREST CITY, AR",
            disabled: false,
          },
          {
            name: "11345, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "11348, Walgreens, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "1135, Albertsons, CLE ELUM, WA",
            disabled: false,
          },
          {
            name: "1135, Target, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "1135, Walmart, HARTSVILLE, SC",
            disabled: false,
          },
          {
            name: "11352, Walgreens, LELAND, NC",
            disabled: false,
          },
          {
            name: "11353, Walgreens, SILER CITY, NC",
            disabled: false,
          },
          {
            name: "11355, Walgreens, PAPILLION, NE",
            disabled: false,
          },
          {
            name: "11356, Walgreens, PAPILLION, NE",
            disabled: false,
          },
          {
            name: "11357, Walgreens, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "11358, Walgreens, DENVILLE, NJ",
            disabled: false,
          },
          {
            name: "1136, Target, Springfield, PA",
            disabled: false,
          },
          {
            name: "1136, Walmart, PORT ALLEN, LA",
            disabled: false,
          },
          {
            name: "11360, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "11361, Walgreens, LOS LUNAS, NM",
            disabled: false,
          },
          {
            name: "11362, Walgreens, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "11363, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "11365, Walgreens, AMERICAN CANYON, CA",
            disabled: false,
          },
          {
            name: "11367, Walgreens, LAKEMOOR, IL",
            disabled: false,
          },
          {
            name: "11368, Walgreens, URBANA, IL",
            disabled: false,
          },
          {
            name: "1137, Target, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1137, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11370, CVS, PLAINFIELD, NJ",
            disabled: false,
          },
          {
            name: "11370, Walgreens, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "11371, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "11373, Walgreens, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "11374, Walgreens, LITTLE FALLS, MN",
            disabled: false,
          },
          {
            name: "11375, Walgreens, EXCELSIOR SPRINGS, MO",
            disabled: false,
          },
          {
            name: "11376, Walgreens, CONCORD, NH",
            disabled: false,
          },
          {
            name: "11377, Walgreens, FAIRPORT, NY",
            disabled: false,
          },
          {
            name: "11378, Walgreens, PLATTSBURGH, NY",
            disabled: false,
          },
          {
            name: "11379, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1138, Albertsons, BELMONT, CA",
            disabled: false,
          },
          {
            name: "1138, CVS, FISHERS, IN",
            disabled: false,
          },
          {
            name: "1138, Target, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1138, Walmart, MADISON, WI",
            disabled: false,
          },
          {
            name: "11381, Walgreens, KILMARNOCK, VA",
            disabled: false,
          },
          {
            name: "11382, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "11389, CVS, IRVING, TX",
            disabled: false,
          },
          {
            name: "11389, Walgreens, MILLBROOK, AL",
            disabled: false,
          },
          {
            name: "1139, Target, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "1139, Walgreens, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "1139, Walmart, MOREHEAD, KY",
            disabled: false,
          },
          {
            name: "11392, CVS, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "11394, Walgreens, MADISONVILLE, KY",
            disabled: false,
          },
          {
            name: "11395, Walgreens, UTICA, MI",
            disabled: false,
          },
          {
            name: "11396, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "11398, Walgreens, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "11399, Walgreens, LEBANON, OR",
            disabled: false,
          },
          {
            name: "114, ADUSA, CLINTON, NC",
            disabled: false,
          },
          {
            name: "114, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "114, BJ's, PINEVILLE, NC",
            disabled: false,
          },
          {
            name: "114, CVS, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "114, Costco, EVERETT, WA",
            disabled: false,
          },
          {
            name: "114, Kroger, COMMERCE CITY, CO",
            disabled: false,
          },
          {
            name: "114, Kroger, Fontana, CA",
            disabled: false,
          },
          {
            name: "114, Kroger, MADISON, WI",
            disabled: false,
          },
          {
            name: "114, Kroger, Peoria, AZ",
            disabled: false,
          },
          {
            name: "114, Kroger, Spring, TX",
            disabled: false,
          },
          {
            name: "114, Meijer, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "114, Walmart, BOONEVILLE, MS",
            disabled: false,
          },
          {
            name: "1140, Target, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "1140, Walmart, MOUNT STERLING, KY",
            disabled: false,
          },
          {
            name: "11400, Walgreens, EASLEY, SC",
            disabled: false,
          },
          {
            name: "11404, Walgreens, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "11407, Walgreens, VISALIA, CA",
            disabled: false,
          },
          {
            name: "1141, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1141, Walmart, GREENFIELD, IN",
            disabled: false,
          },
          {
            name: "11410, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "11410, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "11411, Walgreens, HARVARD, IL",
            disabled: false,
          },
          {
            name: "11413, Walgreens, GONZALES, LA",
            disabled: false,
          },
          {
            name: "11414, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "11415, Walgreens, ALLENDALE, MI",
            disabled: false,
          },
          {
            name: "11416, Walgreens, NORWAY, ME",
            disabled: false,
          },
          {
            name: "11417, Walgreens, WHITEHALL, MI",
            disabled: false,
          },
          {
            name: "11419, Walgreens, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "1142, Albertsons, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "1142, CVS, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "1142, Target, TOWSON, MD",
            disabled: false,
          },
          {
            name: "1142, Walgreens, OSAGE BEACH, MO",
            disabled: false,
          },
          {
            name: "1142, Walmart, SCOTTSBURG, IN",
            disabled: false,
          },
          {
            name: "11421, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "11429, Walgreens, ERIE, PA",
            disabled: false,
          },
          {
            name: "1143, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1143, CVS, NORTH READING, MA",
            disabled: false,
          },
          {
            name: "1143, Target, WATSONVILLE, CA",
            disabled: false,
          },
          {
            name: "1143, Walmart, SANDERSVILLE, GA",
            disabled: false,
          },
          {
            name: "11432, Walgreens, BEECH ISLAND, SC",
            disabled: false,
          },
          {
            name: "11434, Walgreens, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "11435, Walgreens, NEW TAZEWELL, TN",
            disabled: false,
          },
          {
            name: "11436, Walgreens, SOCORRO, TX",
            disabled: false,
          },
          {
            name: "1144, Target, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "1144, Walmart, YORK, SC",
            disabled: false,
          },
          {
            name: "11440, Walgreens, MONTEREY PARK, CA",
            disabled: false,
          },
          {
            name: "11442, Walgreens, PASADENA, CA",
            disabled: false,
          },
          {
            name: "1145, CVS, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "11450, Walgreens, SUMITON, AL",
            disabled: false,
          },
          {
            name: "11452, Walgreens, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "11453, Walgreens, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "11454, Walgreens, SEYMOUR, IN",
            disabled: false,
          },
          {
            name: "11456, Walgreens, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "11458, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "1146, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1146, CVS, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "1146, Costco, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "1146, Target, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1146, Walmart, MONCKS CORNER, SC",
            disabled: false,
          },
          {
            name: "11463, Walgreens, TRAVELERS REST, SC",
            disabled: false,
          },
          {
            name: "11464, Walgreens, BROWNSVILLE, TN",
            disabled: false,
          },
          {
            name: "11465, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11468, Walgreens, GREENVILLE, AL",
            disabled: false,
          },
          {
            name: "11469, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "1147, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "1147, Costco, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "1147, Rite Aid, BENTLEYVILLE, PA",
            disabled: false,
          },
          {
            name: "1147, Target, COPIAGUE, NY",
            disabled: false,
          },
          {
            name: "1147, Walmart, FLIPPIN, AR",
            disabled: false,
          },
          {
            name: "11470, Walgreens, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "11472, Walgreens, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "11473, Walgreens, MONROVIA, CA",
            disabled: false,
          },
          {
            name: "11477, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11478, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1148, ADUSA, HEATHSVILLE, VA",
            disabled: false,
          },
          {
            name: "1148, CVS, CHESHIRE, CT",
            disabled: false,
          },
          {
            name: "1148, Rite Aid, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "1148, Target, BAY SHORE, NY",
            disabled: false,
          },
          {
            name: "1148, Walmart, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "11481, Walgreens, FLORIDA CITY, FL",
            disabled: false,
          },
          {
            name: "11482, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "11484, Walgreens, MINNEOLA, FL",
            disabled: false,
          },
          {
            name: "11486, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "11487, Walgreens, VENICE, FL",
            disabled: false,
          },
          {
            name: "11488, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1149, CVS, NORWALK, CT",
            disabled: false,
          },
          {
            name: "1149, Walmart, SAFFORD, AZ",
            disabled: false,
          },
          {
            name: "11490, Walgreens, THOMASTON, GA",
            disabled: false,
          },
          {
            name: "11491, Walgreens, VILLA RICA, GA",
            disabled: false,
          },
          {
            name: "11492, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "11493, Walgreens, PEKIN, IL",
            disabled: false,
          },
          {
            name: "11494, Walgreens, KENDALLVILLE, IN",
            disabled: false,
          },
          {
            name: "11495, Walgreens, ALEXANDRIA, KY",
            disabled: false,
          },
          {
            name: "11496, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "11498, Walgreens, ZACHARY, LA",
            disabled: false,
          },
          {
            name: "11499, Walgreens, NORTH READING, MA",
            disabled: false,
          },
          {
            name: "115, BJ's, AVON, OH",
            disabled: false,
          },
          {
            name: "115, Costco, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "115, HEB, SINTON, TX",
            disabled: false,
          },
          {
            name: "115, Kroger, Antigo, WI",
            disabled: false,
          },
          {
            name: "115, Kroger, Brownsburg, IN",
            disabled: false,
          },
          {
            name: "115, Kroger, Buena Park, CA",
            disabled: false,
          },
          {
            name: "115, Kroger, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "115, Kroger, Denver, CO",
            disabled: false,
          },
          {
            name: "115, Kroger, FLINT, MI",
            disabled: false,
          },
          {
            name: "115, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "115, Meijer, MAUMEE, OH",
            disabled: false,
          },
          {
            name: "115, Walmart, WEST POINT, MS",
            disabled: false,
          },
          {
            name: "1150, CVS, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "1150, Costco, LAREDO, TX",
            disabled: false,
          },
          {
            name: "1150, Rite Aid, SALEM, NJ",
            disabled: false,
          },
          {
            name: "1150, Target, COLLEGE POINT, NY",
            disabled: false,
          },
          {
            name: "1150, Walmart, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "11500, Walgreens, BOWIE, MD",
            disabled: false,
          },
          {
            name: "11501, Walgreens, SEVERNA PARK, MD",
            disabled: false,
          },
          {
            name: "11502, Walgreens, MARSHFIELD, MO",
            disabled: false,
          },
          {
            name: "11503, Walgreens, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "11504, Walgreens, APEX, NC",
            disabled: false,
          },
          {
            name: "11505, Walgreens, NASHUA, NH",
            disabled: false,
          },
          {
            name: "11507, Walgreens, WEST MILFORD, NJ",
            disabled: false,
          },
          {
            name: "11509, Walgreens, YONKERS, NY",
            disabled: false,
          },
          {
            name: "1151, CVS, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "1151, Target, PRINCETON, NJ",
            disabled: false,
          },
          {
            name: "1151, Walmart, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "11510, Walgreens, BEAVERCREEK, OH",
            disabled: false,
          },
          {
            name: "11511, Walgreens, TRENTON, OH",
            disabled: false,
          },
          {
            name: "11513, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11514, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "11515, Walgreens, DENTON, TX",
            disabled: false,
          },
          {
            name: "11516, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "11518, Walgreens, HORIZON CITY, TX",
            disabled: false,
          },
          {
            name: "11519, Walgreens, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "1152, ADUSA, SOUTH HILL, VA",
            disabled: false,
          },
          {
            name: "1152, CVS, NIANTIC, CT",
            disabled: false,
          },
          {
            name: "1152, Costco, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "1152, Target, MILLTOWN, NJ",
            disabled: false,
          },
          {
            name: "1152, Walmart, SIOUX CENTER, IA",
            disabled: false,
          },
          {
            name: "11520, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11521, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11522, Walgreens, SILSBEE, TX",
            disabled: false,
          },
          {
            name: "11523, Walgreens, HEBER CITY, UT",
            disabled: false,
          },
          {
            name: "11524, Walgreens, HERRIMAN, UT",
            disabled: false,
          },
          {
            name: "11525, Walgreens, LORTON, VA",
            disabled: false,
          },
          {
            name: "11526, Walgreens, BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "11527, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "11528, Walgreens, BELOIT, WI",
            disabled: false,
          },
          {
            name: "1153, ADUSA, PRINCESS ANNE, MD",
            disabled: false,
          },
          {
            name: "1153, CVS, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "1153, Costco, NORTH RIVERSIDE, IL",
            disabled: false,
          },
          {
            name: "1153, Target, BRICK, NJ",
            disabled: false,
          },
          {
            name: "1153, Walmart, MACON, GA",
            disabled: false,
          },
          {
            name: "11531, Walgreens, CHELSEA, AL",
            disabled: false,
          },
          {
            name: "11532, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "11533, Walgreens, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "11535, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "11537, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "11538, Walgreens, GARDEN CITY, GA",
            disabled: false,
          },
          {
            name: "11539, Walgreens, MONROE, GA",
            disabled: false,
          },
          {
            name: "1154, CVS, NORWALK, CT",
            disabled: false,
          },
          {
            name: "1154, Target, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "1154, Walmart, FREDERICKSBURG, TX",
            disabled: false,
          },
          {
            name: "11541, Walgreens, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "11542, Walgreens, CHARLESTON, IL",
            disabled: false,
          },
          {
            name: "11544, Walgreens, GRANGER, IN",
            disabled: false,
          },
          {
            name: "11545, Walgreens, BREWER, ME",
            disabled: false,
          },
          {
            name: "11547, Walgreens, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "1155, Target, WATCHUNG, NJ",
            disabled: false,
          },
          {
            name: "1155, Walmart, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "11550, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "11552, Walgreens, FARGO, ND",
            disabled: false,
          },
          {
            name: "11554, Walgreens, HUDSON, NH",
            disabled: false,
          },
          {
            name: "11555, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "11558, Walgreens, LYNDHURST, OH",
            disabled: false,
          },
          {
            name: "11559, Walgreens, WAGONER, OK",
            disabled: false,
          },
          {
            name: "1156, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1156, Albertsons, KANKAKEE, IL",
            disabled: false,
          },
          {
            name: "1156, CVS, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1156, Costco, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "1156, Target, VICTOR, NY",
            disabled: false,
          },
          {
            name: "1156, Walmart, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "11560, Walgreens, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "11563, Walgreens, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "11564, Walgreens, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "11566, Walgreens, HUTTO, TX",
            disabled: false,
          },
          {
            name: "11567, Walgreens, AUBREY, TX",
            disabled: false,
          },
          {
            name: "11568, Walgreens, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "1157, Albertsons, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "1157, CVS, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "1157, Target, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1157, Walgreens, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "1157, Walmart, NORTH VERNON, IN",
            disabled: false,
          },
          {
            name: "11571, Walgreens, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "11572, Walgreens, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "11573, Walgreens, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "11576, Walgreens, BELLEVUE, WI",
            disabled: false,
          },
          {
            name: "1158, ADUSA, CAMBRIDGE, MD",
            disabled: false,
          },
          {
            name: "1158, Albertsons, DEER LODGE, MT",
            disabled: false,
          },
          {
            name: "1158, Target, BURLINGTON, NJ",
            disabled: false,
          },
          {
            name: "1158, Walgreens, WOODRUFF, WI",
            disabled: false,
          },
          {
            name: "1158, Walmart, ADAMSVILLE, AL",
            disabled: false,
          },
          {
            name: "1159, Albertsons, NEWPORT, WA",
            disabled: false,
          },
          {
            name: "1159, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "1159, Costco, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "1159, Target, NORTH WALES, PA",
            disabled: false,
          },
          {
            name: "1159, Walgreens, VERONA, WI",
            disabled: false,
          },
          {
            name: "1159, Walmart, NEW TAZEWELL, TN",
            disabled: false,
          },
          {
            name: "116, Albertsons, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "116, BJ's, VICTOR, NY",
            disabled: false,
          },
          {
            name: "116, CVS, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "116, Costco, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "116, HEB, LUMBERTON, TX",
            disabled: false,
          },
          {
            name: "116, Kroger, Anaheim, CA",
            disabled: false,
          },
          {
            name: "116, Kroger, Eldon, MO",
            disabled: false,
          },
          {
            name: "116, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "116, Kroger, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "116, Kroger, Thornton, CO",
            disabled: false,
          },
          {
            name: "116, Meijer, OREGON, OH",
            disabled: false,
          },
          {
            name: "116, Rite Aid, MILLVILLE, NJ",
            disabled: false,
          },
          {
            name: "116, Walmart, VIVIAN, LA",
            disabled: false,
          },
          {
            name: "1160, ADUSA, TROUTVILLE, VA",
            disabled: false,
          },
          {
            name: "1160, Albertsons, WALLA WALLA, WA",
            disabled: false,
          },
          {
            name: "1160, Costco, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1160, Target, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "1160, Walmart, AURORA, IN",
            disabled: false,
          },
          {
            name: "1161, CVS, AURORA, IL",
            disabled: false,
          },
          {
            name: "1161, Costco, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "1161, Target, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "1161, Walmart, SAINT CHARLES, MO",
            disabled: false,
          },
          {
            name: "11610, Walgreens, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "11611, Walgreens, COACHELLA, CA",
            disabled: false,
          },
          {
            name: "11612, Walgreens, LEMOORE, CA",
            disabled: false,
          },
          {
            name: "11614, Walgreens, PINOLE, CA",
            disabled: false,
          },
          {
            name: "11615, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "11619, Walgreens, SEYMOUR, CT",
            disabled: false,
          },
          {
            name: "1162, Costco, BELLEVUE, WI",
            disabled: false,
          },
          {
            name: "1162, Target, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "1162, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "1162, Walmart, WASHINGTON, IN",
            disabled: false,
          },
          {
            name: "11620, Walgreens, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "11621, Walgreens, SEAFORD, DE",
            disabled: false,
          },
          {
            name: "11622, Walgreens, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "11623, Walgreens, ELKHART, IN",
            disabled: false,
          },
          {
            name: "11625, Walgreens, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "11628, Walgreens, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "11629, Walgreens, HICKORY, NC",
            disabled: false,
          },
          {
            name: "1163, Costco, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "1163, Target, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "1163, Walmart, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "11630, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "11632, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "11634, Walgreens, DAYTON, TN",
            disabled: false,
          },
          {
            name: "11635, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "11636, Walgreens, MUSKEGO, WI",
            disabled: false,
          },
          {
            name: "1164, Target, AUSTELL, GA",
            disabled: false,
          },
          {
            name: "1164, Walgreens, RIPON, WI",
            disabled: false,
          },
          {
            name: "1164, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "11643, Walgreens, EUGENE, OR",
            disabled: false,
          },
          {
            name: "11645, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "11646, Walgreens, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "11647, Walgreens, MONROE, WI",
            disabled: false,
          },
          {
            name: "11648, Walgreens, MOUNT HOREB, WI",
            disabled: false,
          },
          {
            name: "11649, Walgreens, WAUPUN, WI",
            disabled: false,
          },
          {
            name: "1165, Albertsons, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "1165, CVS, WENONAH, NJ",
            disabled: false,
          },
          {
            name: "1165, Costco, WASHINGTON DC, DC",
            disabled: false,
          },
          {
            name: "1165, Target, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "1165, Walmart, RADCLIFF, KY",
            disabled: false,
          },
          {
            name: "11651, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "11652, Walgreens, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "11653, Walgreens, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "11654, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "11657, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "11658, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "1166, CVS, WINDSOR, CT",
            disabled: false,
          },
          {
            name: "1166, Costco, NORTH PLAINFIEL, NJ",
            disabled: false,
          },
          {
            name: "1166, Target, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "1166, Walgreens, BROOKHAVEN, MS",
            disabled: false,
          },
          {
            name: "1166, Walmart, ELIZABETHTOWN, NC",
            disabled: false,
          },
          {
            name: "11661, Walgreens, DOUGLAS, GA",
            disabled: false,
          },
          {
            name: "11662, Walgreens, BARRINGTON, IL",
            disabled: false,
          },
          {
            name: "11664, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "11665, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "11666, Walgreens, BOLIVAR, MO",
            disabled: false,
          },
          {
            name: "11667, Walgreens, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "11668, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1167, CVS, ELMWOOD PARK, NJ",
            disabled: false,
          },
          {
            name: "1167, Costco, KATY, TX",
            disabled: false,
          },
          {
            name: "1167, Rite Aid, GENEVA, OH",
            disabled: false,
          },
          {
            name: "1167, Target, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "1167, Walmart, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "11670, Walgreens, DUNLAP, TN",
            disabled: false,
          },
          {
            name: "11671, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "11672, Walgreens, PORT ISABEL, TX",
            disabled: false,
          },
          {
            name: "11673, Walgreens, HURRICANE, UT",
            disabled: false,
          },
          {
            name: "11675, Walgreens, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "11676, Walgreens, JACKSON, WI",
            disabled: false,
          },
          {
            name: "11677, Walgreens, MARTINSBURG, WV",
            disabled: false,
          },
          {
            name: "1168, Target, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "1168, Walmart, COLUMBIA, MS",
            disabled: false,
          },
          {
            name: "11683, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "11684, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "11685, Walgreens, BREMEN, GA",
            disabled: false,
          },
          {
            name: "11686, Walgreens, DALLAS, GA",
            disabled: false,
          },
          {
            name: "11687, Walgreens, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "11689, Walgreens, GRAYLING, MI",
            disabled: false,
          },
          {
            name: "1169, ADUSA, CLARKSBURG, WV",
            disabled: false,
          },
          {
            name: "1169, CVS, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "1169, Target, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "1169, Walgreens, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "1169, Walmart, SPRINGHILL, LA",
            disabled: false,
          },
          {
            name: "11690, Walgreens, WACONIA, MN",
            disabled: false,
          },
          {
            name: "11691, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "11692, Walgreens, MONROE, NC",
            disabled: false,
          },
          {
            name: "11693, Walgreens, SPRING LAKE, NC",
            disabled: false,
          },
          {
            name: "11694, Walgreens, COSHOCTON, OH",
            disabled: false,
          },
          {
            name: "11695, Walgreens, STEUBENVILLE, OH",
            disabled: false,
          },
          {
            name: "11696, Walgreens, HOOD RIVER, OR",
            disabled: false,
          },
          {
            name: "11698, Walgreens, PICKENS, SC",
            disabled: false,
          },
          {
            name: "11699, Walgreens, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "117, ADUSA, CATONSVILLE, MD",
            disabled: false,
          },
          {
            name: "117, Albertsons, BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "117, BJ's, PARAMUS, NJ",
            disabled: false,
          },
          {
            name: "117, CVS, WEST ROXBURY, MA",
            disabled: false,
          },
          {
            name: "117, Costco, WESTLAKE VILLAG, CA",
            disabled: false,
          },
          {
            name: "117, HEB, CRYSTAL CITY, TX",
            disabled: false,
          },
          {
            name: "117, Kroger, GREELEY, CO",
            disabled: false,
          },
          {
            name: "117, Kroger, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "117, Kroger, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "117, Kroger, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "117, Meijer, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "117, ShopRite, EMERSON, NJ",
            disabled: false,
          },
          {
            name: "117, Walmart, BROKEN BOW, OK",
            disabled: false,
          },
          {
            name: "1170, ADUSA, CANTON, NC",
            disabled: false,
          },
          {
            name: "1170, CVS, JOLIET, IL",
            disabled: false,
          },
          {
            name: "1170, Target, AMES, IA",
            disabled: false,
          },
          {
            name: "1170, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "11700, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "11701, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "11704, Walgreens, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "11705, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "11706, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "11707, Walgreens, OXNARD, CA",
            disabled: false,
          },
          {
            name: "11708, Walgreens, SWAINSBORO, GA",
            disabled: false,
          },
          {
            name: "11709, Walgreens, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "1171, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1171, Walmart, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "11710, Walgreens, NORTH LIBERTY, IA",
            disabled: false,
          },
          {
            name: "11712, Walgreens, ARDEN, NC",
            disabled: false,
          },
          {
            name: "11713, Walgreens, GARNER, NC",
            disabled: false,
          },
          {
            name: "11716, Walgreens, BATH, NY",
            disabled: false,
          },
          {
            name: "11717, Walgreens, SHIRLEY, NY",
            disabled: false,
          },
          {
            name: "11718, Walgreens, ENID, OK",
            disabled: false,
          },
          {
            name: "1172, CVS, LINDENHURST, IL",
            disabled: false,
          },
          {
            name: "1172, Costco, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "1172, Target, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "1172, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "11724, Walgreens, SUMTER, SC",
            disabled: false,
          },
          {
            name: "11725, Walgreens, PLEASANTON, TX",
            disabled: false,
          },
          {
            name: "11726, Walgreens, LOWELL, MA",
            disabled: false,
          },
          {
            name: "11729, Walgreens, DUNKIRK, NY",
            disabled: false,
          },
          {
            name: "1173, ADUSA, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "1173, Albertsons, LACEY, WA",
            disabled: false,
          },
          {
            name: "1173, Albertsons, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "1173, CVS, HEALDSBURG, CA",
            disabled: false,
          },
          {
            name: "1173, Costco, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "1173, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "11730, Walgreens, CORTLAND, OH",
            disabled: false,
          },
          {
            name: "11732, Walgreens, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "11733, Walgreens, MUNFORD, TN",
            disabled: false,
          },
          {
            name: "11734, Walgreens, PROVO, UT",
            disabled: false,
          },
          {
            name: "11737, Walgreens, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "11739, Walgreens, HUNTLEY, IL",
            disabled: false,
          },
          {
            name: "1174, ADUSA, SUMMERSVILLE, WV",
            disabled: false,
          },
          {
            name: "1174, Costco, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "1174, Walmart, THOMASVILLE, AL",
            disabled: false,
          },
          {
            name: "11740, Walgreens, MONTGOMERY, IL",
            disabled: false,
          },
          {
            name: "11742, Walgreens, ELLSWORTH, ME",
            disabled: false,
          },
          {
            name: "11744, Walgreens, ELLISVILLE, MO",
            disabled: false,
          },
          {
            name: "11747, Walgreens, ONEONTA, NY",
            disabled: false,
          },
          {
            name: "11748, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "11749, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1175, ADUSA, SYLVA, NC",
            disabled: false,
          },
          {
            name: "1175, CVS, HUDSON, NH",
            disabled: false,
          },
          {
            name: "1175, Costco, CUMMING, GA",
            disabled: false,
          },
          {
            name: "1175, Target, FAIRFIELD, NJ",
            disabled: false,
          },
          {
            name: "1175, Walmart, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "11750, Walgreens, CROSS LANES, WV",
            disabled: false,
          },
          {
            name: "11754, Walgreens, CRESCENT CITY, CA",
            disabled: false,
          },
          {
            name: "11756, Walgreens, HARRINGTON, DE",
            disabled: false,
          },
          {
            name: "11757, Walgreens, BROOKHAVEN, GA",
            disabled: false,
          },
          {
            name: "11758, Walgreens, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "11759, Walgreens, FORT MADISON, IA",
            disabled: false,
          },
          {
            name: "1176, CVS, LOMITA, CA",
            disabled: false,
          },
          {
            name: "1176, Costco, CAMILLUS, NY",
            disabled: false,
          },
          {
            name: "1176, Target, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "1176, Walmart, STOUGHTON, WI",
            disabled: false,
          },
          {
            name: "11760, Walgreens, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "11761, Walgreens, RADCLIFF, KY",
            disabled: false,
          },
          {
            name: "11762, Walgreens, WALKER, LA",
            disabled: false,
          },
          {
            name: "11763, Walgreens, CHESTERTOWN, MD",
            disabled: false,
          },
          {
            name: "11764, Walgreens, MENDOTA HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "11765, Walgreens, LINCOLNTON, NC",
            disabled: false,
          },
          {
            name: "11766, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "11768, Walgreens, MURRYSVILLE, PA",
            disabled: false,
          },
          {
            name: "11769, Walgreens, CLEMSON, SC",
            disabled: false,
          },
          {
            name: "1177, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1177, CVS, WHEATON, MD",
            disabled: false,
          },
          {
            name: "1177, Costco, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "1177, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1177, Walmart, MANCHESTER, MO",
            disabled: false,
          },
          {
            name: "11770, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "11771, Walgreens, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "11773, Walgreens, SOUTH BOSTON, VA",
            disabled: false,
          },
          {
            name: "11778, Walgreens, PATCHOGUE, NY",
            disabled: false,
          },
          {
            name: "1178, CVS, EMMAUS, PA",
            disabled: false,
          },
          {
            name: "1178, Costco, TIMNATH, CO",
            disabled: false,
          },
          {
            name: "1178, Target, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "1178, Walmart, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "11781, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "11785, Walgreens, HUNTINGTON PARK, CA",
            disabled: false,
          },
          {
            name: "11786, Walgreens, IRVINE, CA",
            disabled: false,
          },
          {
            name: "11787, Walgreens, NOKOMIS, FL",
            disabled: false,
          },
          {
            name: "1179, ADUSA, EXMORE, VA",
            disabled: false,
          },
          {
            name: "1179, CVS, HUDSON, MA",
            disabled: false,
          },
          {
            name: "1179, Target, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "1179, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1179, Walmart, ARDEN, NC",
            disabled: false,
          },
          {
            name: "11790, Walgreens, ZEPHYRHILLS, FL",
            disabled: false,
          },
          {
            name: "11791, Walgreens, COMMERCE, GA",
            disabled: false,
          },
          {
            name: "11792, Walgreens, JESUP, GA",
            disabled: false,
          },
          {
            name: "11793, Walgreens, PERRY, GA",
            disabled: false,
          },
          {
            name: "11794, Walgreens, THOMASVILLE, GA",
            disabled: false,
          },
          {
            name: "11795, Walgreens, ELKHART, IN",
            disabled: false,
          },
          {
            name: "11796, Walgreens, BEREA, KY",
            disabled: false,
          },
          {
            name: "11797, Walgreens, ALLSTON, MA",
            disabled: false,
          },
          {
            name: "118, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "118, BJ's, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "118, Costco, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "118, Kroger, APPLETON, WI",
            disabled: false,
          },
          {
            name: "118, Kroger, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "118, Kroger, CLIFTON FORGE, VA",
            disabled: false,
          },
          {
            name: "118, Kroger, Jefferson City, MO",
            disabled: false,
          },
          {
            name: "118, Kroger, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "118, Kroger, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "118, Meijer, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "118, Walmart, AMORY, MS",
            disabled: false,
          },
          {
            name: "1180, CVS, AVON, CT",
            disabled: false,
          },
          {
            name: "1180, Rite Aid, DUNMORE, PA",
            disabled: false,
          },
          {
            name: "1180, Target, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1180, Walmart, GREENSBURG, IN",
            disabled: false,
          },
          {
            name: "11801, Walgreens, WYOMING, MI",
            disabled: false,
          },
          {
            name: "11803, Walgreens, MEBANE, NC",
            disabled: false,
          },
          {
            name: "11804, Walgreens, BERGENFIELD, NJ",
            disabled: false,
          },
          {
            name: "11807, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "11808, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "1181, ADUSA, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "1181, Albertsons, MONTEBELLO, CA",
            disabled: false,
          },
          {
            name: "1181, CVS, DANVERS, MA",
            disabled: false,
          },
          {
            name: "1181, Costco, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "1181, Target, HICKORY, NC",
            disabled: false,
          },
          {
            name: "1181, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "11810, Walgreens, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "11811, Walgreens, SHAWNEE, OK",
            disabled: false,
          },
          {
            name: "11812, Walgreens, CRANBERRY TOWNSHIP, PA",
            disabled: false,
          },
          {
            name: "11813, Walgreens, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "11814, Walgreens, CLEVELAND, TX",
            disabled: false,
          },
          {
            name: "11816, Walgreens, LAREDO, TX",
            disabled: false,
          },
          {
            name: "11817, Walgreens, LAREDO, TX",
            disabled: false,
          },
          {
            name: "11819, Walgreens, ANNISTON, AL",
            disabled: false,
          },
          {
            name: "1182, CVS, COHASSET, MA",
            disabled: false,
          },
          {
            name: "1182, Target, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "1182, Walmart, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "11822, Walgreens, NAPA, CA",
            disabled: false,
          },
          {
            name: "11823, Walgreens, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "11825, Walgreens, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "11827, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "11828, Walgreens, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "11829, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "1183, Costco, GRANGER, IN",
            disabled: false,
          },
          {
            name: "1183, Target, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "1183, Walmart, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "11830, Walgreens, MARKSVILLE, LA",
            disabled: false,
          },
          {
            name: "11831, Walgreens, QUINCY, MA",
            disabled: false,
          },
          {
            name: "11832, Walgreens, ANOKA, MN",
            disabled: false,
          },
          {
            name: "11834, Walgreens, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "11837, Walgreens, HOLDEN BEACH, NC",
            disabled: false,
          },
          {
            name: "11838, Walgreens, LOUISBURG, NC",
            disabled: false,
          },
          {
            name: "1184, ADUSA, WALDORF, MD",
            disabled: false,
          },
          {
            name: "1184, CVS, ROWLEY, MA",
            disabled: false,
          },
          {
            name: "1184, Costco, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1184, Target, MANALAPAN, NJ",
            disabled: false,
          },
          {
            name: "1184, Walmart, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "11846, Walgreens, EATON, OH",
            disabled: false,
          },
          {
            name: "11849, Walgreens, AIKEN, SC",
            disabled: false,
          },
          {
            name: "1185, ADUSA, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "1185, CVS, YORKTOWN HEIGHTS, NY",
            disabled: false,
          },
          {
            name: "1185, Costco, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "1185, Rite Aid, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "1185, Target, NORTH SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "1185, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11851, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "11852, Walgreens, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "11853, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "11854, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "11856, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "11857, Walgreens, HAYWARD, WI",
            disabled: false,
          },
          {
            name: "1186, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1186, Albertsons, DES MOINES, WA",
            disabled: false,
          },
          {
            name: "1186, CVS, SELDEN, NY",
            disabled: false,
          },
          {
            name: "1186, Rite Aid, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "1186, Target, SALEM, NH",
            disabled: false,
          },
          {
            name: "1186, Walmart, LIBERTY, TX",
            disabled: false,
          },
          {
            name: "11860, Walgreens, RICE LAKE, WI",
            disabled: false,
          },
          {
            name: "11862, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "11863, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11864, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "11865, Walgreens, ZELIENOPLE, PA",
            disabled: false,
          },
          {
            name: "1187, Rite Aid, NEW CARLISLE, OH",
            disabled: false,
          },
          {
            name: "1187, Target, DANVERS, MA",
            disabled: false,
          },
          {
            name: "1187, Walmart, IOLA, KS",
            disabled: false,
          },
          {
            name: "11877, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "1188, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1188, CVS, OLD FORGE, PA",
            disabled: false,
          },
          {
            name: "1188, Target, WARWICK, RI",
            disabled: false,
          },
          {
            name: "1188, Walmart, BRIDGETON, MO",
            disabled: false,
          },
          {
            name: "11880, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "11881, Walgreens, MONMOUTH, IL",
            disabled: false,
          },
          {
            name: "11882, Walgreens, PRINCETON, IN",
            disabled: false,
          },
          {
            name: "11884, Walgreens, BARBOURVILLE, KY",
            disabled: false,
          },
          {
            name: "11885, Walgreens, NORTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "11886, Walgreens, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "11887, Walgreens, CLARE, MI",
            disabled: false,
          },
          {
            name: "1189, Albertsons, CHESTERTON, IN",
            disabled: false,
          },
          {
            name: "1189, CVS, HINGHAM, MA",
            disabled: false,
          },
          {
            name: "1189, Costco, CONROE, TX",
            disabled: false,
          },
          {
            name: "1189, Target, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "1189, Walgreens, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "1189, Walmart, BARBOURVILLE, KY",
            disabled: false,
          },
          {
            name: "11890, Walgreens, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "11891, Walgreens, HAMILTON, MT",
            disabled: false,
          },
          {
            name: "11892, Walgreens, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "11893, Walgreens, BEULAVILLE, NC",
            disabled: false,
          },
          {
            name: "11894, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "11895, Walgreens, MOREHEAD CITY, NC",
            disabled: false,
          },
          {
            name: "11897, Walgreens, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "11899, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "119, BJ's, COVENTRY, RI",
            disabled: false,
          },
          {
            name: "119, Costco, KAHULUI, HI",
            disabled: false,
          },
          {
            name: "119, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "119, Kroger, Camdenton, MO",
            disabled: false,
          },
          {
            name: "119, Kroger, LEHI, UT",
            disabled: false,
          },
          {
            name: "119, Kroger, Tucson, AZ",
            disabled: false,
          },
          {
            name: "119, Meijer, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "119, Rite Aid, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "119, Walmart, BATESVILLE, AR",
            disabled: false,
          },
          {
            name: "1190, Albertsons, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "1190, CVS, CENTER MORICHES, NY",
            disabled: false,
          },
          {
            name: "1190, Costco, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "1190, Target, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "1190, Walmart, BEREA, KY",
            disabled: false,
          },
          {
            name: "11904, Walgreens, LE ROY, NY",
            disabled: false,
          },
          {
            name: "11907, Walgreens, GREENEVILLE, TN",
            disabled: false,
          },
          {
            name: "11908, Walgreens, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "11909, Walgreens, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "1191, CVS, HORSHAM, PA",
            disabled: false,
          },
          {
            name: "1191, Costco, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "1191, Target, SOUTH SETAUKET, NY",
            disabled: false,
          },
          {
            name: "1191, Walmart, HILLSBOROUGH, NC",
            disabled: false,
          },
          {
            name: "11910, Walgreens, SULPHUR SPRINGS, TX",
            disabled: false,
          },
          {
            name: "11912, Walgreens, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "11918, Rite Aid, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "11918, Walgreens, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "11919, Walgreens, COVENTRY, CT",
            disabled: false,
          },
          {
            name: "1192, ADUSA, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "1192, Albertsons, CONCORD, CA",
            disabled: false,
          },
          {
            name: "1192, CVS, HOLBROOK, NY",
            disabled: false,
          },
          {
            name: "1192, Costco, MOBILE, AL",
            disabled: false,
          },
          {
            name: "1192, Target, Middletown, NJ",
            disabled: false,
          },
          {
            name: "1192, Walmart, MAGEE, MS",
            disabled: false,
          },
          {
            name: "11920, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "11921, Walgreens, WINDERMERE, FL",
            disabled: false,
          },
          {
            name: "11924, Walgreens, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "11925, Walgreens, OAK GROVE, MO",
            disabled: false,
          },
          {
            name: "11926, Walgreens, BROWNWOOD, TX",
            disabled: false,
          },
          {
            name: "11928, Walgreens, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "1193, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1193, CVS, JENKINTOWN, PA",
            disabled: false,
          },
          {
            name: "1193, Target, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1193, Walmart, MONROE, LA",
            disabled: false,
          },
          {
            name: "11933, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "11934, Walgreens, OAKDALE, CA",
            disabled: false,
          },
          {
            name: "11938, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "11939, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "1194, ADUSA, WILSON, NC",
            disabled: false,
          },
          {
            name: "1194, Albertsons, OMAK, WA",
            disabled: false,
          },
          {
            name: "1194, CVS, LORIS, SC",
            disabled: false,
          },
          {
            name: "1194, Costco, PERRYSBURG, OH",
            disabled: false,
          },
          {
            name: "1194, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1194, Target, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1194, Walgreens, CONVERSE, TX",
            disabled: false,
          },
          {
            name: "1194, Walmart, OAK RIDGE, TN",
            disabled: false,
          },
          {
            name: "11940, Walgreens, GRAY, GA",
            disabled: false,
          },
          {
            name: "11942, Walgreens, DUBUQUE, IA",
            disabled: false,
          },
          {
            name: "11944, Walgreens, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "11945, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "11949, Walgreens, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "1195, Albertsons, CLAYTON, CA",
            disabled: false,
          },
          {
            name: "1195, CVS, MANVILLE, NJ",
            disabled: false,
          },
          {
            name: "1195, Costco, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1195, Target, FAIRPORT, NY",
            disabled: false,
          },
          {
            name: "1195, Walmart, WAVELAND, MS",
            disabled: false,
          },
          {
            name: "11952, Walgreens, SAVAGE, MN",
            disabled: false,
          },
          {
            name: "11953, Walgreens, IRON MOUNTAIN, MI",
            disabled: false,
          },
          {
            name: "11955, Walgreens, OWOSSO, MI",
            disabled: false,
          },
          {
            name: "11956, Walgreens, WAITE PARK, MN",
            disabled: false,
          },
          {
            name: "11957, Walgreens, BLAIR, NE",
            disabled: false,
          },
          {
            name: "11958, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "11959, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "1196, ADUSA, WARSAW, VA",
            disabled: false,
          },
          {
            name: "1196, Albertsons, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "1196, Costco, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "1196, Target, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "1196, Walmart, NEW ROADS, LA",
            disabled: false,
          },
          {
            name: "11960, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "11961, Walgreens, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "11964, Walgreens, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "11966, Walgreens, MARYSVILLE, OH",
            disabled: false,
          },
          {
            name: "11968, Walgreens, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "11969, Walgreens, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "1197, ADUSA, SOPHIA, WV",
            disabled: false,
          },
          {
            name: "1197, Albertsons, UNION CITY, CA",
            disabled: false,
          },
          {
            name: "1197, Costco, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "1197, Rite Aid, MONONGAHELA, PA",
            disabled: false,
          },
          {
            name: "1197, Target, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1197, Walgreens, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "1197, Walmart, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "11970, Walgreens, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "11971, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11972, Walgreens, DUBLIN, VA",
            disabled: false,
          },
          {
            name: "11977, Walgreens, BARBOURSVILLE, WV",
            disabled: false,
          },
          {
            name: "11978, Walgreens, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "1198, ADUSA, PAWLEYS ISLAND, SC",
            disabled: false,
          },
          {
            name: "1198, CVS, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "1198, Costco, PLEASANT PRAIRI, WI",
            disabled: false,
          },
          {
            name: "1198, Target, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "1198, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "11980, Walgreens, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "11981, Walgreens, SUMMERSVILLE, WV",
            disabled: false,
          },
          {
            name: "11982, Walgreens, PENNS GROVE, NJ",
            disabled: false,
          },
          {
            name: "11984, Walgreens, YORKSHIRE, NY",
            disabled: false,
          },
          {
            name: "11985, Walgreens, WALPOLE, NH",
            disabled: false,
          },
          {
            name: "11986, Walgreens, FRANKLIN, VA",
            disabled: false,
          },
          {
            name: "11987, Walgreens, ALMA, AR",
            disabled: false,
          },
          {
            name: "11988, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "11989, Walgreens, RIALTO, CA",
            disabled: false,
          },
          {
            name: "1199, ADUSA, WINDSOR, NC",
            disabled: false,
          },
          {
            name: "1199, Costco, LAWRENCE TOWNSH, NJ",
            disabled: false,
          },
          {
            name: "1199, Target, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1199, Walgreens, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "1199, Walmart, AVON, CO",
            disabled: false,
          },
          {
            name: "11990, Walgreens, LAKESIDE, CA",
            disabled: false,
          },
          {
            name: "11991, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "11992, Walgreens, COCOA, FL",
            disabled: false,
          },
          {
            name: "11994, Walgreens, DALTON, GA",
            disabled: false,
          },
          {
            name: "11995, Walgreens, THOMSON, GA",
            disabled: false,
          },
          {
            name: "11996, Walgreens, ABITA SPRINGS, LA",
            disabled: false,
          },
          {
            name: "11997, Walgreens, SCOTT, LA",
            disabled: false,
          },
          {
            name: "11998, Walgreens, NORTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "11999, Walgreens, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "12, ADUSA, MONONGAHELA, PA",
            disabled: false,
          },
          {
            name: "12, ADUSA, SANDWICH, MA",
            disabled: false,
          },
          {
            name: "12, CVS, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "12, Kroger, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "12, Kroger, Columbus, OH",
            disabled: false,
          },
          {
            name: "12, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "12, Kroger, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "12, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "12, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "12, Target, BRIDGETON, MO",
            disabled: false,
          },
          {
            name: "12, Walmart, CLAREMORE, OK",
            disabled: false,
          },
          {
            name: "120, Albertsons, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "120, BJ's, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "120, Costco, HONOLULU (OAHU), HI",
            disabled: false,
          },
          {
            name: "120, Kroger, Pocatello, ID",
            disabled: false,
          },
          {
            name: "120, Kroger, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "120, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "120, Meijer, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "120, Walmart, HUMBOLDT, TN",
            disabled: false,
          },
          {
            name: "1200, ADUSA, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "1200, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1200, Costco, WICHITA, KS",
            disabled: false,
          },
          {
            name: "1200, Target, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "1200, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "12004, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "12005, Walgreens, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "12008, Walgreens, PICKERINGTON, OH",
            disabled: false,
          },
          {
            name: "12009, Walgreens, CHICKASHA, OK",
            disabled: false,
          },
          {
            name: "1201, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1201, Costco, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "1201, Target, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "1201, Walmart, GARDENDALE, AL",
            disabled: false,
          },
          {
            name: "12014, Walgreens, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "12015, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "12016, Walgreens, LIVINGSTON, TN",
            disabled: false,
          },
          {
            name: "12017, Walgreens, COLLINSVILLE, VA",
            disabled: false,
          },
          {
            name: "12019, Walgreens, APPLETON, WI",
            disabled: false,
          },
          {
            name: "1202, CVS, GRANBY, CT",
            disabled: false,
          },
          {
            name: "1202, Costco, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "1202, Walmart, WISCONSIN RAPIDS, WI",
            disabled: false,
          },
          {
            name: "12020, Walgreens, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "12021, Walgreens, WALES, WI",
            disabled: false,
          },
          {
            name: "12023, Walgreens, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "12024, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "12027, Walgreens, EL RENO, OK",
            disabled: false,
          },
          {
            name: "12029, Walgreens, DRIPPING SPRINGS, TX",
            disabled: false,
          },
          {
            name: "1203, Albertsons, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "1203, Rite Aid, FRANKLIN SQUARE, NY",
            disabled: false,
          },
          {
            name: "1203, Walmart, WIMAUMA, FL",
            disabled: false,
          },
          {
            name: "12032, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "12034, Walgreens, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "1204, Albertsons, PRUNEDALE, CA",
            disabled: false,
          },
          {
            name: "1204, CVS, LYNN, MA",
            disabled: false,
          },
          {
            name: "1204, Target, SELMA, TX",
            disabled: false,
          },
          {
            name: "1204, Walmart, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "12041, Walgreens, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "12042, Walgreens, ESSEXVILLE, MI",
            disabled: false,
          },
          {
            name: "12044, Walgreens, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "12045, Walgreens, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "12046, Walgreens, WINTERVILLE, NC",
            disabled: false,
          },
          {
            name: "12047, Walgreens, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "12048, Walgreens, GLASSBORO, NJ",
            disabled: false,
          },
          {
            name: "12049, Walgreens, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "1205, Albertsons, DAVIS, CA",
            disabled: false,
          },
          {
            name: "1205, Costco, WOODLAND HILLS, CA",
            disabled: false,
          },
          {
            name: "1205, Target, Gig Harbor, WA",
            disabled: false,
          },
          {
            name: "1205, Walmart, MACCLENNY, FL",
            disabled: false,
          },
          {
            name: "12052, Walgreens, WEST COLUMBIA, TX",
            disabled: false,
          },
          {
            name: "12053, Walgreens, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "12056, Walgreens, HOOVER, AL",
            disabled: false,
          },
          {
            name: "12057, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "12058, Walgreens, DAYVILLE, CT",
            disabled: false,
          },
          {
            name: "1206, ADUSA, SELBYVILLE, DE",
            disabled: false,
          },
          {
            name: "1206, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1206, Costco, APEX, NC",
            disabled: false,
          },
          {
            name: "1206, Target, BUFORD, GA",
            disabled: false,
          },
          {
            name: "1206, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "12062, Walgreens, BRANSON WEST, MO",
            disabled: false,
          },
          {
            name: "12063, Walgreens, ZEBULON, NC",
            disabled: false,
          },
          {
            name: "12064, Walgreens, NEWARK, NJ",
            disabled: false,
          },
          {
            name: "12066, Walgreens, GRAND ISLAND, NY",
            disabled: false,
          },
          {
            name: "12067, Walgreens, VAILS GATE, NY",
            disabled: false,
          },
          {
            name: "12068, Walgreens, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "12069, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1207, Albertsons, SEDONA, AZ",
            disabled: false,
          },
          {
            name: "1207, CVS, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "1207, Costco, TULSA, OK",
            disabled: false,
          },
          {
            name: "1207, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1207, Walmart, CALLAWAY, FL",
            disabled: false,
          },
          {
            name: "12074, Walgreens, HEBRON, IN",
            disabled: false,
          },
          {
            name: "12075, Walgreens, GEORGETOWN, KY",
            disabled: false,
          },
          {
            name: "12076, Walgreens, LEBANON, KY",
            disabled: false,
          },
          {
            name: "12077, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "12078, Walgreens, SANFORD, NC",
            disabled: false,
          },
          {
            name: "12079, Walgreens, BELLEVILLE, NJ",
            disabled: false,
          },
          {
            name: "1208, ADUSA, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1208, Albertsons, EAST BOSTON, MA",
            disabled: false,
          },
          {
            name: "1208, Costco, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "1208, Target, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "12081, Walgreens, HAMBURG, NY",
            disabled: false,
          },
          {
            name: "12082, Walgreens, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "12083, Walgreens, GRANDVIEW HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "12087, Walgreens, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "12089, Walgreens, HERRIN, IL",
            disabled: false,
          },
          {
            name: "1209, ADUSA, LANCASTER, SC",
            disabled: false,
          },
          {
            name: "1209, Albertsons, KAPAA, HI",
            disabled: false,
          },
          {
            name: "1209, Costco, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "1209, Target, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "1209, Walmart, LINCOLNTON, NC",
            disabled: false,
          },
          {
            name: "12090, Walgreens, MAYFIELD, KY",
            disabled: false,
          },
          {
            name: "12095, Walgreens, WOODBURN, OR",
            disabled: false,
          },
          {
            name: "12098, Walgreens, JACKSONVILLE, AL",
            disabled: false,
          },
          {
            name: "12099, Walgreens, TALLADEGA, AL",
            disabled: false,
          },
          {
            name: "121, Albertsons, MONTPELIER, VT",
            disabled: false,
          },
          {
            name: "121, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "121, Costco, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "121, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "121, Kroger, Idaho Falls, ID",
            disabled: false,
          },
          {
            name: "121, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "121, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "121, Kroger, Wisconsin Rapids, WI",
            disabled: false,
          },
          {
            name: "121, Meijer, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "121, Walmart, OKMULGEE, OK",
            disabled: false,
          },
          {
            name: "1210, Albertsons, RENO, NV",
            disabled: false,
          },
          {
            name: "1210, Target, HUTCHINSON, MN",
            disabled: false,
          },
          {
            name: "1210, Walmart, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "12100, Walgreens, ARVADA, CO",
            disabled: false,
          },
          {
            name: "12102, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "12103, Walgreens, WEEKI WACHEE, FL",
            disabled: false,
          },
          {
            name: "12104, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "12105, Walgreens, TAVARES, FL",
            disabled: false,
          },
          {
            name: "12106, Walgreens, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "12107, Walgreens, WAYNESBORO, GA",
            disabled: false,
          },
          {
            name: "12108, Walgreens, AMES, IA",
            disabled: false,
          },
          {
            name: "12109, Walgreens, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "1211, ADUSA, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "1211, Albertsons, DANVILLE, CA",
            disabled: false,
          },
          {
            name: "1211, Costco, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "1211, Target, NORTHFIELD, MN",
            disabled: false,
          },
          {
            name: "1211, Walmart, HARVARD, IL",
            disabled: false,
          },
          {
            name: "12111, Walgreens, CORBIN, KY",
            disabled: false,
          },
          {
            name: "12114, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "12115, Walgreens, COLUMBUS, NE",
            disabled: false,
          },
          {
            name: "12117, Walgreens, NORTH TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "1212, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1212, Costco, NEW BERLIN, WI",
            disabled: false,
          },
          {
            name: "1212, Target, GRAFTON, WI",
            disabled: false,
          },
          {
            name: "1212, Walmart, SARALAND, AL",
            disabled: false,
          },
          {
            name: "12120, Walgreens, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "12123, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "12124, Walgreens, EAGLE, ID",
            disabled: false,
          },
          {
            name: "12125, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "12126, Walgreens, MACHESNEY PARK, IL",
            disabled: false,
          },
          {
            name: "1213, Target, LEMONT, IL",
            disabled: false,
          },
          {
            name: "1213, Walmart, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "12130, Walgreens, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "12131, Walgreens, WILLMAR, MN",
            disabled: false,
          },
          {
            name: "12132, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "12133, Walgreens, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "12135, Walgreens, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "12136, Walgreens, BELOIT, WI",
            disabled: false,
          },
          {
            name: "1214, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1214, CVS, HIGHLANDS, NJ",
            disabled: false,
          },
          {
            name: "1214, Costco, TETERBORO, NJ",
            disabled: false,
          },
          {
            name: "1214, Target, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "1214, Walmart, COLBY, KS",
            disabled: false,
          },
          {
            name: "12140, Walgreens, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "12143, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "12148, Walgreens, WAVERLY, IA",
            disabled: false,
          },
          {
            name: "1215, Albertsons, BAY POINT, CA",
            disabled: false,
          },
          {
            name: "1215, Costco, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "1215, Target, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "1215, Walmart, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "12151, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "12152, Walgreens, LONDON, KY",
            disabled: false,
          },
          {
            name: "12154, Walgreens, HAZLEHURST, MS",
            disabled: false,
          },
          {
            name: "12155, Walgreens, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "12158, Walgreens, WAPPINGERS FALLS, NY",
            disabled: false,
          },
          {
            name: "12159, Walgreens, FREMONT, OH",
            disabled: false,
          },
          {
            name: "1216, ADUSA, THURMONT, MD",
            disabled: false,
          },
          {
            name: "1216, Costco, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "1216, Target, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "1216, Walmart, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "12160, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "12161, Walgreens, COLLINSVILLE, OK",
            disabled: false,
          },
          {
            name: "12163, Walgreens, BATESBURG, SC",
            disabled: false,
          },
          {
            name: "12164, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "12165, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "12167, Walgreens, BRISTOW, VA",
            disabled: false,
          },
          {
            name: "12168, Walgreens, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "1217, ADUSA, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "1217, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "1217, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1217, Walmart, FRANKLIN, NC",
            disabled: false,
          },
          {
            name: "1218, Albertsons, SUSANVILLE, CA",
            disabled: false,
          },
          {
            name: "1218, CVS, WALKERTOWN, NC",
            disabled: false,
          },
          {
            name: "1218, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1218, Walmart, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "1219, ADUSA, WARREN, OH",
            disabled: false,
          },
          {
            name: "1219, Albertsons, MIDDLEBURY, VT",
            disabled: false,
          },
          {
            name: "1219, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "1219, Target, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "1219, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "122, ADUSA, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "122, Albertsons, MOLINE, IL",
            disabled: false,
          },
          {
            name: "122, Costco, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "122, Kroger, Jefferson City, MO",
            disabled: false,
          },
          {
            name: "122, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "122, Kroger, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "122, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "122, Kroger, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "122, Meijer, WIXOM, MI",
            disabled: false,
          },
          {
            name: "122, ShopRite, LODI, NJ",
            disabled: false,
          },
          {
            name: "122, Walmart, JACKSON, MO",
            disabled: false,
          },
          {
            name: "1220, CVS, BELLEVILLE, NJ",
            disabled: false,
          },
          {
            name: "1220, Target, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "1220, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1221, ADUSA, WEST POINT, VA",
            disabled: false,
          },
          {
            name: "1221, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "1221, CVS, MILFORD, MA",
            disabled: false,
          },
          {
            name: "1221, Costco, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "1221, Target, YORK, PA",
            disabled: false,
          },
          {
            name: "1221, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "1222, Albertsons, LAHAINA, HI",
            disabled: false,
          },
          {
            name: "1222, CVS, DEER PARK, NY",
            disabled: false,
          },
          {
            name: "1222, Costco, GRAND CHUTE, WI",
            disabled: false,
          },
          {
            name: "1222, Target, WYOMISSING, PA",
            disabled: false,
          },
          {
            name: "1222, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "1222, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "1223, CVS, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "1223, Target, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "1223, Walmart, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1224, Albertsons, NEWARK, CA",
            disabled: false,
          },
          {
            name: "1224, CVS, OLD TAPPAN, NJ",
            disabled: false,
          },
          {
            name: "1224, Target, BRIDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "1224, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "1225, Albertsons, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "1225, CVS, BLACKSTONE, MA",
            disabled: false,
          },
          {
            name: "1225, Costco, REDMOND, WA",
            disabled: false,
          },
          {
            name: "1225, Target, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "1225, Walmart, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "12257, Walgreens, BURLINGAME, CA",
            disabled: false,
          },
          {
            name: "12259, Walgreens, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "1226, ADUSA, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1226, Costco, BOSTON HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "1226, Target, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "1226, Walmart, ASHLAND CITY, TN",
            disabled: false,
          },
          {
            name: "12260, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "12262, Walgreens, BROOKHAVEN, GA",
            disabled: false,
          },
          {
            name: "12264, Walgreens, ELKHART, IN",
            disabled: false,
          },
          {
            name: "12266, Walgreens, OAKLAND, MD",
            disabled: false,
          },
          {
            name: "12267, Walgreens, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "12268, Walgreens, HOLLISTER, MO",
            disabled: false,
          },
          {
            name: "12269, Walgreens, GRENADA, MS",
            disabled: false,
          },
          {
            name: "1227, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "1227, Costco, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "1227, Target, CONCORD, NH",
            disabled: false,
          },
          {
            name: "1227, Walmart, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "12270, Walgreens, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "12271, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "12272, Walgreens, ORCHARD PARK, NY",
            disabled: false,
          },
          {
            name: "12273, Walgreens, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "12275, Walgreens, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "12276, Walgreens, BRIDGEPORT, WV",
            disabled: false,
          },
          {
            name: "12277, Walgreens, GRAFTON, WV",
            disabled: false,
          },
          {
            name: "1228, ADUSA, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "1228, CVS, NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "1228, Costco, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "1228, Target, NASHUA, NH",
            disabled: false,
          },
          {
            name: "1228, Walmart, ROUND LAKE BEACH, IL",
            disabled: false,
          },
          {
            name: "12282, Walgreens, SANGER, CA",
            disabled: false,
          },
          {
            name: "12283, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "12285, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "12286, Walgreens, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "12287, Walgreens, FREEPORT, IL",
            disabled: false,
          },
          {
            name: "12288, Walgreens, DUNDEE, MI",
            disabled: false,
          },
          {
            name: "1229, Albertsons, NOGALES, AZ",
            disabled: false,
          },
          {
            name: "1229, CVS, OYSTER BAY, NY",
            disabled: false,
          },
          {
            name: "1229, Costco, MIAMI, FL",
            disabled: false,
          },
          {
            name: "1229, Target, EVERETT, MA",
            disabled: false,
          },
          {
            name: "1229, Walmart, HOOVER, AL",
            disabled: false,
          },
          {
            name: "12290, Walgreens, COTTAGE GROVE, OR",
            disabled: false,
          },
          {
            name: "12292, Walgreens, FRISCO, TX",
            disabled: false,
          },
          {
            name: "12293, Walgreens, MOUNT PLEASANT, TX",
            disabled: false,
          },
          {
            name: "12294, Walgreens, DRAPER, UT",
            disabled: false,
          },
          {
            name: "12298, Walgreens, REEDLEY, CA",
            disabled: false,
          },
          {
            name: "123, ADUSA, TEMPLE HILLS, MD",
            disabled: false,
          },
          {
            name: "123, Albertsons, DARIEN, IL",
            disabled: false,
          },
          {
            name: "123, BJ's, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "123, CVS, OLD SAYBROOK, CT",
            disabled: false,
          },
          {
            name: "123, Kroger, APPLETON, WI",
            disabled: false,
          },
          {
            name: "123, Kroger, BURLEY, ID",
            disabled: false,
          },
          {
            name: "123, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "123, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "123, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "123, Meijer, SOUTHGATE, MI",
            disabled: false,
          },
          {
            name: "123, Walmart, SEMINOLE, OK",
            disabled: false,
          },
          {
            name: "1230, Albertsons, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "1230, CVS, BELCHERTOWN, MA",
            disabled: false,
          },
          {
            name: "1230, Target, BOISE, ID",
            disabled: false,
          },
          {
            name: "1230, Walgreens, GULF SHORES, AL",
            disabled: false,
          },
          {
            name: "1230, Walmart, SHOW LOW, AZ",
            disabled: false,
          },
          {
            name: "12300, Walgreens, MILTON, FL",
            disabled: false,
          },
          {
            name: "12303, Walgreens, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "12304, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "12305, Walgreens, GENESEO, IL",
            disabled: false,
          },
          {
            name: "12306, Walgreens, MANY, LA",
            disabled: false,
          },
          {
            name: "12307, Walgreens, ROLLA, MO",
            disabled: false,
          },
          {
            name: "12308, Walgreens, SENATOBIA, MS",
            disabled: false,
          },
          {
            name: "12309, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1231, Albertsons, CLACKAMAS, OR",
            disabled: false,
          },
          {
            name: "1231, CVS, SCARSDALE, NY",
            disabled: false,
          },
          {
            name: "1231, Target, ALLEN, TX",
            disabled: false,
          },
          {
            name: "1231, Walmart, THORNTON, CO",
            disabled: false,
          },
          {
            name: "12311, Walgreens, CLINTON, TN",
            disabled: false,
          },
          {
            name: "12315, Walgreens, NEWTOWN, CT",
            disabled: false,
          },
          {
            name: "12316, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "12317, Walgreens, GROVELAND, FL",
            disabled: false,
          },
          {
            name: "12318, Walgreens, HOLIDAY, FL",
            disabled: false,
          },
          {
            name: "12319, Walgreens, HAWKINSVILLE, GA",
            disabled: false,
          },
          {
            name: "1232, ADUSA, KEYSVILLE, VA",
            disabled: false,
          },
          {
            name: "1232, Albertsons, KING CITY, CA",
            disabled: false,
          },
          {
            name: "1232, Costco, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1232, Target, Holyoke, MA",
            disabled: false,
          },
          {
            name: "1232, Walmart, BELTON, TX",
            disabled: false,
          },
          {
            name: "12322, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "12324, Walgreens, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1233, Target, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "1233, Walgreens, WEBSTER, MA",
            disabled: false,
          },
          {
            name: "1233, Walmart, PAINTSVILLE, KY",
            disabled: false,
          },
          {
            name: "12330, Walgreens, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "12332, Walgreens, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "12333, Walgreens, PRICHARD, AL",
            disabled: false,
          },
          {
            name: "12334, Walgreens, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "12335, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "12337, Walgreens, SELMA, CA",
            disabled: false,
          },
          {
            name: "12338, Walgreens, MIDDLETOWN, CT",
            disabled: false,
          },
          {
            name: "1234, Albertsons, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "1234, CVS, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "1234, Target, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "1234, Walgreens, BEREA, OH",
            disabled: false,
          },
          {
            name: "1234, Walmart, MONTICELLO, KY",
            disabled: false,
          },
          {
            name: "12340, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "12342, Walgreens, LOXAHATCHEE, FL",
            disabled: false,
          },
          {
            name: "12345, Walgreens, GRAND HAVEN, MI",
            disabled: false,
          },
          {
            name: "12346, Walgreens, MOUNT PLEASANT, MI",
            disabled: false,
          },
          {
            name: "12347, Walgreens, WHITEFISH, MT",
            disabled: false,
          },
          {
            name: "12349, Walgreens, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "1235, Albertsons, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "1235, Costco, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1235, Target, HUDSON, WI",
            disabled: false,
          },
          {
            name: "1235, Walgreens, WARRENSBURG, MO",
            disabled: false,
          },
          {
            name: "1235, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "12350, Walgreens, STALLINGS, NC",
            disabled: false,
          },
          {
            name: "12352, Walgreens, PELHAM, NH",
            disabled: false,
          },
          {
            name: "12355, Walgreens, BRIDGE CITY, TX",
            disabled: false,
          },
          {
            name: "12356, Walgreens, HUDSON OAKS, TX",
            disabled: false,
          },
          {
            name: "12357, Walgreens, LAREDO, TX",
            disabled: false,
          },
          {
            name: "12358, Walgreens, TYLER, TX",
            disabled: false,
          },
          {
            name: "12359, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1236, ADUSA, BROOKNEAL, VA",
            disabled: false,
          },
          {
            name: "1236, Costco, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "1236, Target, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1236, Walgreens, GRANDVIEW, MO",
            disabled: false,
          },
          {
            name: "1236, Walmart, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "12360, Walgreens, HOPEWELL, VA",
            disabled: false,
          },
          {
            name: "12361, Walgreens, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "12366, Walgreens, GLENDALE, CO",
            disabled: false,
          },
          {
            name: "12367, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "1237, ADUSA, CAMERON, NC",
            disabled: false,
          },
          {
            name: "1237, CVS, HAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "1237, Costco, LA VISTA, NE",
            disabled: false,
          },
          {
            name: "1237, Target, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "1237, Walmart, ERWIN, NC",
            disabled: false,
          },
          {
            name: "12372, Walgreens, WASHINGTON COURT HOUSE, OH",
            disabled: false,
          },
          {
            name: "12373, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "12375, Walgreens, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "12376, Walgreens, ANTHONY, TX",
            disabled: false,
          },
          {
            name: "12377, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "12378, Walgreens, CODY, WY",
            disabled: false,
          },
          {
            name: "1238, ADUSA, NEW MARKET, MD",
            disabled: false,
          },
          {
            name: "1238, ADUSA, VERMILION, OH",
            disabled: false,
          },
          {
            name: "1238, CVS, MEDFIELD, MA",
            disabled: false,
          },
          {
            name: "1238, Costco, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "1238, Target, IRVINE, CA",
            disabled: false,
          },
          {
            name: "1238, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "12381, Walgreens, WELLSVILLE, NY",
            disabled: false,
          },
          {
            name: "12384, Walgreens, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "12385, Walgreens, CAMP VERDE, AZ",
            disabled: false,
          },
          {
            name: "12386, Walgreens, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "1239, CVS, NORTH ANDOVER, MA",
            disabled: false,
          },
          {
            name: "1239, Target, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "1239, Walmart, URBANA, OH",
            disabled: false,
          },
          {
            name: "12391, Walgreens, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "12392, Walgreens, VENICE, FL",
            disabled: false,
          },
          {
            name: "12393, Walgreens, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "12395, Walgreens, MARYVILLE, IL",
            disabled: false,
          },
          {
            name: "12396, Walgreens, NORMAL, IL",
            disabled: false,
          },
          {
            name: "12399, Walgreens, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "124, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "124, BJ's, MIDDLEBURG HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "124, CVS, NAUGATUCK, CT",
            disabled: false,
          },
          {
            name: "124, Costco, VISTA, CA",
            disabled: false,
          },
          {
            name: "124, Kroger, Columbia, MO",
            disabled: false,
          },
          {
            name: "124, Kroger, GLENDALE, CO",
            disabled: false,
          },
          {
            name: "124, Kroger, Neenah, WI",
            disabled: false,
          },
          {
            name: "124, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "124, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "124, Meijer, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "124, Walmart, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "1240, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1240, Walmart, SIERRA VISTA, AZ",
            disabled: false,
          },
          {
            name: "12400, Walgreens, SANFORD, ME",
            disabled: false,
          },
          {
            name: "12403, Walgreens, NORTH OAKS, MN",
            disabled: false,
          },
          {
            name: "12404, Walgreens, RED WING, MN",
            disabled: false,
          },
          {
            name: "12405, Walgreens, NORTH PLATTE, NE",
            disabled: false,
          },
          {
            name: "12406, Walgreens, NORTH BERGEN, NJ",
            disabled: false,
          },
          {
            name: "12407, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "12408, Walgreens, AMHERST, NY",
            disabled: false,
          },
          {
            name: "1241, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1241, CVS, MILFORD, CT",
            disabled: false,
          },
          {
            name: "1241, Target, O Fallon, MO",
            disabled: false,
          },
          {
            name: "1241, Walmart, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "12410, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "12413, Walgreens, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "12417, Walgreens, BATESVILLE, AR",
            disabled: false,
          },
          {
            name: "12418, Walgreens, MAUMELLE, AR",
            disabled: false,
          },
          {
            name: "12419, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "1242, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1242, CVS, SIMSBURY, CT",
            disabled: false,
          },
          {
            name: "1242, Target, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "1242, Walmart, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "12421, Walgreens, POWAY, CA",
            disabled: false,
          },
          {
            name: "12422, Walgreens, COMMERCE CITY, CO",
            disabled: false,
          },
          {
            name: "12423, Walgreens, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "12424, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "12427, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "12428, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "1243, Costco, PLAIN CITY, OH",
            disabled: false,
          },
          {
            name: "1243, Walmart, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "12434, Walgreens, EXCELSIOR, MN",
            disabled: false,
          },
          {
            name: "12436, Walgreens, NEW ALBANY, MS",
            disabled: false,
          },
          {
            name: "12437, Walgreens, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "1244, CVS, PROSPECT, CT",
            disabled: false,
          },
          {
            name: "1244, Costco, HANFORD, CA",
            disabled: false,
          },
          {
            name: "1244, Target, FOREST LAKE, MN",
            disabled: false,
          },
          {
            name: "1244, Walmart, TAYLORS, SC",
            disabled: false,
          },
          {
            name: "12441, Walgreens, ENGLISHTOWN, NJ",
            disabled: false,
          },
          {
            name: "12442, Walgreens, UNION CITY, NJ",
            disabled: false,
          },
          {
            name: "12444, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "12445, Walgreens, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "12447, Walgreens, DUNCAN, SC",
            disabled: false,
          },
          {
            name: "12448, Walgreens, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "12449, Walgreens, BURNET, TX",
            disabled: false,
          },
          {
            name: "1245, Albertsons, LOS GATOS, CA",
            disabled: false,
          },
          {
            name: "1245, Walmart, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "12452, Walgreens, WOODS CROSS, UT",
            disabled: false,
          },
          {
            name: "12453, Walgreens, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "12454, Walgreens, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "12455, Walgreens, LA CROSSE, WI",
            disabled: false,
          },
          {
            name: "12456, Walgreens, LA CROSSE, WI",
            disabled: false,
          },
          {
            name: "1246, ADUSA, MCCORMICK, SC",
            disabled: false,
          },
          {
            name: "1246, CVS, CREEDMOOR, NC",
            disabled: false,
          },
          {
            name: "1246, Target, STURGEON BAY, WI",
            disabled: false,
          },
          {
            name: "1246, Walgreens, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "12462, Walgreens, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "12464, Walgreens, CLAYTON, GA",
            disabled: false,
          },
          {
            name: "12466, Walgreens, KAILUA, HI",
            disabled: false,
          },
          {
            name: "12468, Walgreens, KANKAKEE, IL",
            disabled: false,
          },
          {
            name: "12469, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "1247, Target, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "1247, Walmart, HAZARD, KY",
            disabled: false,
          },
          {
            name: "12472, Walgreens, FORESTVILLE, MD",
            disabled: false,
          },
          {
            name: "12473, Walgreens, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "12476, Walgreens, JACKSON, OH",
            disabled: false,
          },
          {
            name: "12478, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "12479, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1248, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "1248, CVS, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "1248, Target, APPLETON, WI",
            disabled: false,
          },
          {
            name: "1248, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "12480, Walgreens, VERNAL, UT",
            disabled: false,
          },
          {
            name: "12483, Walgreens, NAMPA, ID",
            disabled: false,
          },
          {
            name: "12484, Walgreens, HICKORY, NC",
            disabled: false,
          },
          {
            name: "12488, Walgreens, FERNLEY, NV",
            disabled: false,
          },
          {
            name: "12489, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1249, ADUSA, DUMFRIES, VA",
            disabled: false,
          },
          {
            name: "1249, CVS, HANSON, MA",
            disabled: false,
          },
          {
            name: "1249, Costco, LUTZ, FL",
            disabled: false,
          },
          {
            name: "1249, Target, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "1249, Walgreens, CICERO, IL",
            disabled: false,
          },
          {
            name: "1249, Walmart, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "12491, Walgreens, EUGENE, OR",
            disabled: false,
          },
          {
            name: "12492, Walgreens, CHADDS FORD, PA",
            disabled: false,
          },
          {
            name: "12494, Walgreens, PORT LAVACA, TX",
            disabled: false,
          },
          {
            name: "12495, Walgreens, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "12496, Walgreens, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "12497, Walgreens, RENTON, WA",
            disabled: false,
          },
          {
            name: "12498, Walgreens, PLATTEVILLE, WI",
            disabled: false,
          },
          {
            name: "125, ADUSA, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "125, ADUSA, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "125, BJ's, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "125, CVS, NEW PROVIDENCE, NJ",
            disabled: false,
          },
          {
            name: "125, Costco, EUREKA, CA",
            disabled: false,
          },
          {
            name: "125, Kroger, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "125, Kroger, Columbia, MO",
            disabled: false,
          },
          {
            name: "125, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "125, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "125, Meijer, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "125, Walmart, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "1250, ADUSA, DENVER, NC",
            disabled: false,
          },
          {
            name: "1250, CVS, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "1250, Costco, KENT, WA",
            disabled: false,
          },
          {
            name: "1250, Target, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "12500, Walgreens, ROGERS, AR",
            disabled: false,
          },
          {
            name: "12502, Walgreens, TOCCOA, GA",
            disabled: false,
          },
          {
            name: "12503, Walgreens, MOSCOW, ID",
            disabled: false,
          },
          {
            name: "12504, Walgreens, METROPOLIS, IL",
            disabled: false,
          },
          {
            name: "12508, Walgreens, CHARLEVOIX, MI",
            disabled: false,
          },
          {
            name: "12509, Walgreens, MOORHEAD, MN",
            disabled: false,
          },
          {
            name: "1251, ADUSA, BEAUFORT, NC",
            disabled: false,
          },
          {
            name: "1251, CVS, HOLBROOK, MA",
            disabled: false,
          },
          {
            name: "1251, Costco, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "1251, Target, AUBURN HILLS, MI",
            disabled: false,
          },
          {
            name: "12510, Walgreens, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "12512, Walgreens, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "12513, Walgreens, LEBANON, TN",
            disabled: false,
          },
          {
            name: "12514, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "12517, Walgreens, KYLE, TX",
            disabled: false,
          },
          {
            name: "12519, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1252, ADUSA, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "1252, Albertsons, BAINBRIDGE ISLAND, WA",
            disabled: false,
          },
          {
            name: "1252, Costco, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "1252, Target, DAYTON, OH",
            disabled: false,
          },
          {
            name: "1252, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "1252, Walmart, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "12520, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "12521, Walgreens, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "12522, Walgreens, TYLER, TX",
            disabled: false,
          },
          {
            name: "12524, Walgreens, BROWN DEER, WI",
            disabled: false,
          },
          {
            name: "12525, Walgreens, LINCOLN, CA",
            disabled: false,
          },
          {
            name: "12527, Walgreens, OLIVEHURST, CA",
            disabled: false,
          },
          {
            name: "12528, Walgreens, SUTTER CREEK, CA",
            disabled: false,
          },
          {
            name: "12529, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "1253, ADUSA, OXFORD, NC",
            disabled: false,
          },
          {
            name: "1253, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1253, CVS, MASHPEE, MA",
            disabled: false,
          },
          {
            name: "1253, Costco, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "1253, Target, HOMESTEAD, PA",
            disabled: false,
          },
          {
            name: "1253, Walgreens, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "1253, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "12533, Walgreens, FREMONT, MI",
            disabled: false,
          },
          {
            name: "12534, Walgreens, PETOSKEY, MI",
            disabled: false,
          },
          {
            name: "12535, Walgreens, NORTH MANKATO, MN",
            disabled: false,
          },
          {
            name: "12536, Walgreens, FOREST, MS",
            disabled: false,
          },
          {
            name: "12537, Walgreens, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "12538, Walgreens, GRAND ISLAND, NE",
            disabled: false,
          },
          {
            name: "12539, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1254, CVS, WELLESLEY, MA",
            disabled: false,
          },
          {
            name: "1254, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1254, Target, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1254, Walgreens, INDIO, CA",
            disabled: false,
          },
          {
            name: "1254, Walmart, BELLMEAD, TX",
            disabled: false,
          },
          {
            name: "12540, Walgreens, SPARKS, NV",
            disabled: false,
          },
          {
            name: "12541, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "12545, Walgreens, EAGLE RIVER, WI",
            disabled: false,
          },
          {
            name: "12548, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "12549, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "1255, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1255, Costco, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "1255, Target, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "1255, Walmart, LAURINBURG, NC",
            disabled: false,
          },
          {
            name: "12550, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "12552, Walgreens, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "12553, Walgreens, CAMILLA, GA",
            disabled: false,
          },
          {
            name: "12554, Walgreens, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "12555, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "12558, Walgreens, FITCHBURG, MA",
            disabled: false,
          },
          {
            name: "1256, Albertsons, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "1256, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1256, Costco, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "1256, Target, Abington, PA",
            disabled: false,
          },
          {
            name: "1256, Walmart, JOLIET, IL",
            disabled: false,
          },
          {
            name: "12560, Walgreens, PIKESVILLE, MD",
            disabled: false,
          },
          {
            name: "12561, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "12562, Walgreens, WALKERTOWN, NC",
            disabled: false,
          },
          {
            name: "12563, Walgreens, FLORHAM PARK, NJ",
            disabled: false,
          },
          {
            name: "12564, Walgreens, HILLSBOROUGH, NJ",
            disabled: false,
          },
          {
            name: "12568, Walgreens, LAURENS, SC",
            disabled: false,
          },
          {
            name: "12569, Walgreens, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "1257, Albertsons, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "1257, CVS, EAST BRIDGEWATER, MA",
            disabled: false,
          },
          {
            name: "1257, Costco, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1257, Target, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1257, Walgreens, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "1257, Walmart, STAMFORD, TX",
            disabled: false,
          },
          {
            name: "12573, Walgreens, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "12574, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "12576, Walgreens, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "12577, Walgreens, LUTZ, FL",
            disabled: false,
          },
          {
            name: "12578, Walgreens, PERRY, FL",
            disabled: false,
          },
          {
            name: "1258, Albertsons, DIXON, CA",
            disabled: false,
          },
          {
            name: "1258, Costco, PENDERGRASS, GA",
            disabled: false,
          },
          {
            name: "1258, Target, CALIFORNIA, MD",
            disabled: false,
          },
          {
            name: "12580, Walgreens, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "12581, Walgreens, ANNA, IL",
            disabled: false,
          },
          {
            name: "12583, Walgreens, LOVES PARK, IL",
            disabled: false,
          },
          {
            name: "12584, Walgreens, NORTHBROOK, IL",
            disabled: false,
          },
          {
            name: "12586, Walgreens, MCPHERSON, KS",
            disabled: false,
          },
          {
            name: "12587, Walgreens, MADISONVILLE, KY",
            disabled: false,
          },
          {
            name: "1259, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1259, Albertsons, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "1259, Costco, OCALA, FL",
            disabled: false,
          },
          {
            name: "1259, Target, CRANBERRY TWP, PA",
            disabled: false,
          },
          {
            name: "1259, Walmart, CORBIN, KY",
            disabled: false,
          },
          {
            name: "12592, Walgreens, FERGUS FALLS, MN",
            disabled: false,
          },
          {
            name: "12593, Walgreens, COLONIA, NJ",
            disabled: false,
          },
          {
            name: "12596, Walgreens, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "12597, Walgreens, MCMURRAY, PA",
            disabled: false,
          },
          {
            name: "126, Albertsons, EMMETT, ID",
            disabled: false,
          },
          {
            name: "126, BJ's, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "126, Costco, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "126, Kroger, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "126, Kroger, LACEY, WA",
            disabled: false,
          },
          {
            name: "126, Kroger, PARKER, CO",
            disabled: false,
          },
          {
            name: "126, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "126, Meijer, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "126, Walmart, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "1260, Albertsons, SEASIDE, OR",
            disabled: false,
          },
          {
            name: "1260, Costco, COVINGTON TWP, PA",
            disabled: false,
          },
          {
            name: "1260, Target, STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "1260, Walmart, LUCEDALE, MS",
            disabled: false,
          },
          {
            name: "12601, Walgreens, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "12603, Walgreens, CROSS PLAINS, WI",
            disabled: false,
          },
          {
            name: "1261, ADUSA, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1261, Target, SOUTH CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "1261, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "1262, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1262, Albertsons, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "1262, Costco, TAMPA, FL",
            disabled: false,
          },
          {
            name: "12621, Walgreens, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "12623, Walgreens, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "12624, Walgreens, WOODRIDGE, IL",
            disabled: false,
          },
          {
            name: "12626, Walgreens, THIBODAUX, LA",
            disabled: false,
          },
          {
            name: "12628, Walgreens, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "1263, ADUSA, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "1263, Albertsons, KAPOLEI, HI",
            disabled: false,
          },
          {
            name: "1263, Target, EDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "1263, Walmart, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "12630, Walgreens, OXFORD, NC",
            disabled: false,
          },
          {
            name: "12631, Walgreens, MONTGOMERY, NY",
            disabled: false,
          },
          {
            name: "12633, Walgreens, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "12634, Walgreens, PARMA, OH",
            disabled: false,
          },
          {
            name: "12635, Walgreens, JOHNS ISLAND, SC",
            disabled: false,
          },
          {
            name: "12638, Walgreens, WHITEWATER, WI",
            disabled: false,
          },
          {
            name: "1264, CVS, JAMAICA PLAIN, MA",
            disabled: false,
          },
          {
            name: "1264, Target, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "1264, Walmart, BELLEFONTAINE, OH",
            disabled: false,
          },
          {
            name: "12640, Walgreens, DEMOTTE, IN",
            disabled: false,
          },
          {
            name: "12641, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "12646, Walgreens, MESQUITE, NV",
            disabled: false,
          },
          {
            name: "1265, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "1265, Rite Aid, JACKSON, MI",
            disabled: false,
          },
          {
            name: "1265, Target, COCKEYSVILLE, MD",
            disabled: false,
          },
          {
            name: "1265, Walgreens, WYANDOTTE, MI",
            disabled: false,
          },
          {
            name: "1265, Walmart, SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "1266, Albertsons, TRUCKEE, CA",
            disabled: false,
          },
          {
            name: "1266, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1266, Target, WOBURN, MA",
            disabled: false,
          },
          {
            name: "1266, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "12669, Walgreens, PITTSTON, PA",
            disabled: false,
          },
          {
            name: "1267, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "1267, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "1267, Costco, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1267, Target, WATERFORD, CT",
            disabled: false,
          },
          {
            name: "1267, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "1267, Walmart, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "12670, Walgreens, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "12672, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "12673, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "12677, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "12678, Walgreens, HURRICANE, WV",
            disabled: false,
          },
          {
            name: "12679, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1268, ADUSA, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "1268, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1268, CVS, WATERFORD, CT",
            disabled: false,
          },
          {
            name: "1268, Costco, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1268, Target, COLONIE, NY",
            disabled: false,
          },
          {
            name: "1268, Walmart, WHITEVILLE, NC",
            disabled: false,
          },
          {
            name: "12680, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "12681, Walgreens, WASILLA, AK",
            disabled: false,
          },
          {
            name: "12683, Walgreens, BOULDER, CO",
            disabled: false,
          },
          {
            name: "12688, Walgreens, PAW PAW, MI",
            disabled: false,
          },
          {
            name: "12689, Walgreens, TUPELO, MS",
            disabled: false,
          },
          {
            name: "1269, CVS, FORT LEE, NJ",
            disabled: false,
          },
          {
            name: "1269, Target, PLYMOUTH MEETING, PA",
            disabled: false,
          },
          {
            name: "12690, Walgreens, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "12693, Walgreens, APPLETON, WI",
            disabled: false,
          },
          {
            name: "12695, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "12698, Walgreens, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "127, ADUSA, RAEFORD, NC",
            disabled: false,
          },
          {
            name: "127, Albertsons, DYER, IN",
            disabled: false,
          },
          {
            name: "127, BJ's, FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "127, Costco, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "127, Kroger, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "127, Kroger, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "127, Kroger, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "127, Kroger, PHILLIPS, WI",
            disabled: false,
          },
          {
            name: "127, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "127, Meijer, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "127, Walmart, MALVERN, AR",
            disabled: false,
          },
          {
            name: "1270, CVS, CRESCO, PA",
            disabled: false,
          },
          {
            name: "1270, Target, WEST MIFFLIN, PA",
            disabled: false,
          },
          {
            name: "1270, Walmart, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "12703, Walgreens, XENIA, OH",
            disabled: false,
          },
          {
            name: "12706, Walgreens, WATERFORD, WI",
            disabled: false,
          },
          {
            name: "12707, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "1271, ADUSA, LIBERTY, NC",
            disabled: false,
          },
          {
            name: "1271, CVS, ROCKY POINT, NY",
            disabled: false,
          },
          {
            name: "1271, Target, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "1271, Walmart, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "12713, Walgreens, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "12714, Walgreens, CATOOSA, OK",
            disabled: false,
          },
          {
            name: "12715, Walgreens, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "12716, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "12718, Walgreens, JACKSON, TN",
            disabled: false,
          },
          {
            name: "1272, Costco, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "1272, Target, SHAKOPEE, MN",
            disabled: false,
          },
          {
            name: "1272, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1272, Walmart, SNYDER, TX",
            disabled: false,
          },
          {
            name: "12720, Walgreens, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "12722, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "12723, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "12724, Walgreens, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "12726, Walgreens, WINDER, GA",
            disabled: false,
          },
          {
            name: "12728, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1273, ADUSA, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "1273, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "1273, Target, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "1273, Walgreens, BALLWIN, MO",
            disabled: false,
          },
          {
            name: "1273, Walmart, FOUNTAIN, CO",
            disabled: false,
          },
          {
            name: "12730, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "12733, Walgreens, GLENS FALLS, NY",
            disabled: false,
          },
          {
            name: "12738, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "12739, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1274, Costco, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "1274, Rite Aid, ASTON, PA",
            disabled: false,
          },
          {
            name: "1274, Target, DAPHNE, AL",
            disabled: false,
          },
          {
            name: "1274, Walmart, WHITEWATER, WI",
            disabled: false,
          },
          {
            name: "12742, Walgreens, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "12744, Walgreens, PANA, IL",
            disabled: false,
          },
          {
            name: "12748, Walgreens, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "12749, Walgreens, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "1275, ADUSA, RICHLANDS, NC",
            disabled: false,
          },
          {
            name: "1275, Albertsons, BENSON, AZ",
            disabled: false,
          },
          {
            name: "1275, Costco, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "1275, Target, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "1275, Walmart, LEBANON, IN",
            disabled: false,
          },
          {
            name: "12750, Walgreens, AMORY, MS",
            disabled: false,
          },
          {
            name: "12751, Walgreens, TAOS, NM",
            disabled: false,
          },
          {
            name: "12752, Walgreens, LEWES, DE",
            disabled: false,
          },
          {
            name: "12754, Walgreens, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "12756, Walgreens, MOULTRIE, GA",
            disabled: false,
          },
          {
            name: "12758, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1276, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1276, CVS, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "1276, Walmart, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "12760, Walgreens, PEEKSKILL, NY",
            disabled: false,
          },
          {
            name: "12769, Walgreens, MONUMENT, CO",
            disabled: false,
          },
          {
            name: "1277, CVS, MIAMI LAKES, FL",
            disabled: false,
          },
          {
            name: "1277, Costco, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "1277, Walmart, BLACK RIVER FALLS, WI",
            disabled: false,
          },
          {
            name: "12772, Walgreens, ELGIN, IL",
            disabled: false,
          },
          {
            name: "12775, Walgreens, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "12776, Walgreens, MARQUETTE, MI",
            disabled: false,
          },
          {
            name: "12777, Walgreens, WALKER, MI",
            disabled: false,
          },
          {
            name: "12778, Walgreens, HARRISONVILLE, MO",
            disabled: false,
          },
          {
            name: "12779, Walgreens, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "1278, Costco, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "1278, Target, ARNOLD, MO",
            disabled: false,
          },
          {
            name: "12780, Walgreens, HUDSON, NC",
            disabled: false,
          },
          {
            name: "12781, Walgreens, LENOIR, NC",
            disabled: false,
          },
          {
            name: "12782, Walgreens, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "12783, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "12786, Walgreens, KAHULUI, HI",
            disabled: false,
          },
          {
            name: "12787, Walgreens, DANVILLE, IL",
            disabled: false,
          },
          {
            name: "12788, Walgreens, GRIFFITH, IN",
            disabled: false,
          },
          {
            name: "1279, ADUSA, GARNER, NC",
            disabled: false,
          },
          {
            name: "1279, CVS, CHATHAM, NJ",
            disabled: false,
          },
          {
            name: "1279, Costco, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "1279, Target, KIRKWOOD, MO",
            disabled: false,
          },
          {
            name: "1279, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "1279, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "12790, Walgreens, CATONSVILLE, MD",
            disabled: false,
          },
          {
            name: "12792, Walgreens, PATERSON, NJ",
            disabled: false,
          },
          {
            name: "12793, Walgreens, HOBBS, NM",
            disabled: false,
          },
          {
            name: "128, Albertsons, WALKERSVILLE, MD",
            disabled: false,
          },
          {
            name: "128, Costco, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "128, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "128, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "128, Kroger, Middleton, WI",
            disabled: false,
          },
          {
            name: "128, Kroger, NEWARK, OH",
            disabled: false,
          },
          {
            name: "128, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "128, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "128, Meijer, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "128, Walmart, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "1280, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1280, CVS, GREENWICH, CT",
            disabled: false,
          },
          {
            name: "1280, Target, SAINT CHARLES, MO",
            disabled: false,
          },
          {
            name: "1280, Walmart, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "12800, Walgreens, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "12802, Walgreens, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "12808, Walgreens, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "1281, Albertsons, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "1281, CVS, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "1281, Target, MILFORD, MA",
            disabled: false,
          },
          {
            name: "1281, Walgreens, MAINEVILLE, OH",
            disabled: false,
          },
          {
            name: "1281, Walmart, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "12811, Walgreens, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "12812, Walgreens, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "12814, Walgreens, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "12815, Walgreens, OLATHE, KS",
            disabled: false,
          },
          {
            name: "12817, Walgreens, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1282, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1282, CVS, ARDMORE, PA",
            disabled: false,
          },
          {
            name: "1282, Rite Aid, SHELBY, OH",
            disabled: false,
          },
          {
            name: "1282, Target, HELENA, MT",
            disabled: false,
          },
          {
            name: "1282, Walmart, CONCORDIA, KS",
            disabled: false,
          },
          {
            name: "12820, Walgreens, TECUMSEH, MI",
            disabled: false,
          },
          {
            name: "12822, Walgreens, BRANDON, MS",
            disabled: false,
          },
          {
            name: "12823, Walgreens, STIRLING, NJ",
            disabled: false,
          },
          {
            name: "1283, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1283, Rite Aid, MEDINA, OH",
            disabled: false,
          },
          {
            name: "1283, Target, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "1283, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1283, Walmart, STARKE, FL",
            disabled: false,
          },
          {
            name: "12830, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "12831, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "12832, Walgreens, ENGLEWOOD, OH",
            disabled: false,
          },
          {
            name: "12837, Walgreens, ALAMO, TX",
            disabled: false,
          },
          {
            name: "12838, Walgreens, BRYAN, TX",
            disabled: false,
          },
          {
            name: "1284, ADUSA, AVON LAKE, OH",
            disabled: false,
          },
          {
            name: "1284, ADUSA, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "1284, CVS, CLINTON, CT",
            disabled: false,
          },
          {
            name: "1284, Costco, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "1284, Target, Seattle, WA",
            disabled: false,
          },
          {
            name: "1284, Walmart, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "12840, Walgreens, EL DORADO HILLS, CA",
            disabled: false,
          },
          {
            name: "12841, Walgreens, GRAND TERRACE, CA",
            disabled: false,
          },
          {
            name: "12846, Walgreens, CHEVERLY, MD",
            disabled: false,
          },
          {
            name: "12847, Walgreens, LUTHERVILLE, MD",
            disabled: false,
          },
          {
            name: "12849, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "1285, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1285, CVS, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "1285, Costco, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "1285, Target, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "1285, Walmart, OTTUMWA, IA",
            disabled: false,
          },
          {
            name: "12853, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "12854, Walgreens, NEBRASKA CITY, NE",
            disabled: false,
          },
          {
            name: "12858, Walgreens, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "1286, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1286, CVS, MACEDON, NY",
            disabled: false,
          },
          {
            name: "1286, Target, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "1286, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "12862, Walgreens, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "12864, Walgreens, ERIE, CO",
            disabled: false,
          },
          {
            name: "12868, Walgreens, MAHOMET, IL",
            disabled: false,
          },
          {
            name: "12869, Walgreens, SOMERSET, MA",
            disabled: false,
          },
          {
            name: "1287, Albertsons, CAMAS, WA",
            disabled: false,
          },
          {
            name: "1287, CVS, MAYS LANDING, NJ",
            disabled: false,
          },
          {
            name: "1287, Costco, CENTRAL POINT, OR",
            disabled: false,
          },
          {
            name: "1287, Target, ERIE, PA",
            disabled: false,
          },
          {
            name: "1287, Walmart, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "12871, Walgreens, OSSINING, NY",
            disabled: false,
          },
          {
            name: "12875, Walgreens, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "12879, Walgreens, MONROEVILLE, AL",
            disabled: false,
          },
          {
            name: "1288, ADUSA, ROME, GA",
            disabled: false,
          },
          {
            name: "1288, CVS, BRUNSWICK, ME",
            disabled: false,
          },
          {
            name: "1288, Costco, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "1288, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1288, Target, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "1288, Walmart, ROXBORO, NC",
            disabled: false,
          },
          {
            name: "12880, Walgreens, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "12884, Walgreens, OCOEE, FL",
            disabled: false,
          },
          {
            name: "12885, Walgreens, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "12886, Walgreens, ATHENS, GA",
            disabled: false,
          },
          {
            name: "1289, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "1289, Target, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "1289, Walmart, WILMINGTON, OH",
            disabled: false,
          },
          {
            name: "12890, Walgreens, MURPHYSBORO, IL",
            disabled: false,
          },
          {
            name: "12893, Walgreens, LOWELL, MI",
            disabled: false,
          },
          {
            name: "12894, Walgreens, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "12895, Walgreens, DUNN, NC",
            disabled: false,
          },
          {
            name: "12899, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "129, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "129, BJ's, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "129, CVS, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "129, Costco, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "129, Kroger, ERIE, CO",
            disabled: false,
          },
          {
            name: "129, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "129, Meijer, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "129, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "129, Walmart, ARDMORE, OK",
            disabled: false,
          },
          {
            name: "1290, ADUSA, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "1290, Target, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "1290, Walmart, WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "12901, Walgreens, NORTH BEND, OR",
            disabled: false,
          },
          {
            name: "12902, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "12906, Walgreens, SPEARFISH, SD",
            disabled: false,
          },
          {
            name: "12907, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "1291, Albertsons, FOUNTAIN HILLS, AZ",
            disabled: false,
          },
          {
            name: "1291, CVS, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "1291, Target, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "1291, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "12911, Walgreens, GUNTERSVILLE, AL",
            disabled: false,
          },
          {
            name: "12912, Walgreens, GREENWOOD, AR",
            disabled: false,
          },
          {
            name: "12913, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "12915, Walgreens, LEMON GROVE, CA",
            disabled: false,
          },
          {
            name: "12916, Walgreens, RANCHO SANTA MARGARITA, CA",
            disabled: false,
          },
          {
            name: "1292, Target, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "1292, Walmart, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "12922, Walgreens, BONNER SPRINGS, KS",
            disabled: false,
          },
          {
            name: "12923, Walgreens, LEAVENWORTH, KS",
            disabled: false,
          },
          {
            name: "12924, Walgreens, KENNER, LA",
            disabled: false,
          },
          {
            name: "12925, Walgreens, PLATTE CITY, MO",
            disabled: false,
          },
          {
            name: "12929, Walgreens, WAYNESBORO, MS",
            disabled: false,
          },
          {
            name: "1293, ADUSA, YADKINVILLE, NC",
            disabled: false,
          },
          {
            name: "1293, Albertsons, CAMPBELL, CA",
            disabled: false,
          },
          {
            name: "1293, CVS, DADE CITY, FL",
            disabled: false,
          },
          {
            name: "1293, Target, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "1293, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1293, Walmart, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "12933, Walgreens, LAKE STEVENS, WA",
            disabled: false,
          },
          {
            name: "12934, Walgreens, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "1294, ADUSA, MILFORD, DE",
            disabled: false,
          },
          {
            name: "1294, Albertsons, KENT, WA",
            disabled: false,
          },
          {
            name: "1294, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "1294, Costco, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1294, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1294, Target, Saint Augustine, FL",
            disabled: false,
          },
          {
            name: "1294, Walmart, MARION, IN",
            disabled: false,
          },
          {
            name: "1295, Costco, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "1295, Rite Aid, NEWPORT, NH",
            disabled: false,
          },
          {
            name: "1295, Target, GREENBELT, MD",
            disabled: false,
          },
          {
            name: "1295, Walmart, MADILL, OK",
            disabled: false,
          },
          {
            name: "1296, ADUSA, ROCKINGHAM, NC",
            disabled: false,
          },
          {
            name: "1296, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1296, CVS, DREXEL HILL, PA",
            disabled: false,
          },
          {
            name: "1296, Target, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "1296, Walmart, SAN BENITO, TX",
            disabled: false,
          },
          {
            name: "1297, ADUSA, FEDERALSBURG, MD",
            disabled: false,
          },
          {
            name: "1297, ADUSA, ROCKY RIVER, OH",
            disabled: false,
          },
          {
            name: "1297, Albertsons, EDMONDS, WA",
            disabled: false,
          },
          {
            name: "1297, CVS, BRAINTREE, MA",
            disabled: false,
          },
          {
            name: "1297, Costco, UKIAH, CA",
            disabled: false,
          },
          {
            name: "1297, Walmart, CHIEFLAND, FL",
            disabled: false,
          },
          {
            name: "12971, Walgreens, LAPEER, MI",
            disabled: false,
          },
          {
            name: "12972, Walgreens, NEW PRAGUE, MN",
            disabled: false,
          },
          {
            name: "12979, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "1298, ADUSA, GORDONSVILLE, VA",
            disabled: false,
          },
          {
            name: "1298, Albertsons, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1298, Costco, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1298, Target, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "1298, Walmart, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "12980, Walgreens, CORRYTON, TN",
            disabled: false,
          },
          {
            name: "12982, Walgreens, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "12983, Walgreens, CLINTONVILLE, WI",
            disabled: false,
          },
          {
            name: "1299, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "1299, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1299, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1299, Target, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "1299, Walmart, COTTONWOOD, AZ",
            disabled: false,
          },
          {
            name: "12999, Rite Aid, HANOVER, PA",
            disabled: false,
          },
          {
            name: "13, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "13, BJ's, MAPLE SHADE, NJ",
            disabled: false,
          },
          {
            name: "13, Costco, SILVERDALE, WA",
            disabled: false,
          },
          {
            name: "13, HEB, RIO GRANDE CITY, TX",
            disabled: false,
          },
          {
            name: "13, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "13, Kroger, LOUISVILLE, CO",
            disabled: false,
          },
          {
            name: "13, Kroger, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "13, Kroger, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "13, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "13, Walmart, CARTHAGE, MO",
            disabled: false,
          },
          {
            name: "130, ADUSA, PEARISBURG, VA",
            disabled: false,
          },
          {
            name: "130, Albertsons, HAILEY, ID",
            disabled: false,
          },
          {
            name: "130, CVS, ARLINGTON, MA",
            disabled: false,
          },
          {
            name: "130, Costco, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "130, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "130, Kroger, Chandler, AZ",
            disabled: false,
          },
          {
            name: "130, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "130, Kroger, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "130, Meijer, CARMEL, IN",
            disabled: false,
          },
          {
            name: "130, Walmart, MUSKOGEE, OK",
            disabled: false,
          },
          {
            name: "1300, CVS, SALINAS, CA",
            disabled: false,
          },
          {
            name: "1300, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1300, Walmart, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "13000, Walgreens, CHICO, CA",
            disabled: false,
          },
          {
            name: "13001, Walgreens, ORLAND, CA",
            disabled: false,
          },
          {
            name: "13003, Walgreens, BRIDGEVILLE, DE",
            disabled: false,
          },
          {
            name: "13004, Walgreens, CARBONDALE, IL",
            disabled: false,
          },
          {
            name: "13005, Walgreens, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "13007, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "13009, Walgreens, ASHLAND CITY, TN",
            disabled: false,
          },
          {
            name: "1301, CVS, KUTZTOWN, PA",
            disabled: false,
          },
          {
            name: "1301, Target, NILES, OH",
            disabled: false,
          },
          {
            name: "1301, Walgreens, OTTUMWA, IA",
            disabled: false,
          },
          {
            name: "1301, Walmart, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "13010, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "13011, Walgreens, PAYSON, UT",
            disabled: false,
          },
          {
            name: "13012, Walgreens, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1302, CVS, LAUDERHILL, FL",
            disabled: false,
          },
          {
            name: "1302, Rite Aid, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "1302, Target, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "1302, Walmart, NORTON, VA",
            disabled: false,
          },
          {
            name: "13026, Walgreens, BAY POINT, CA",
            disabled: false,
          },
          {
            name: "13028, Walgreens, ATLANTIC BEACH, FL",
            disabled: false,
          },
          {
            name: "1303, Albertsons, HOMER GLEN, IL",
            disabled: false,
          },
          {
            name: "1303, CVS, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "1303, Target, CAMBRIDGE, MN",
            disabled: false,
          },
          {
            name: "1303, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "1303, Walmart, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "13031, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "13032, Walgreens, PRAIRIE VILLAGE, KS",
            disabled: false,
          },
          {
            name: "13034, Walgreens, PINEVILLE, KY",
            disabled: false,
          },
          {
            name: "13036, Walgreens, DENVER, NC",
            disabled: false,
          },
          {
            name: "1304, Albertsons, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1304, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "1304, Rite Aid, STEELTON, PA",
            disabled: false,
          },
          {
            name: "1304, Target, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "1304, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "1304, Walmart, WARSAW, IN",
            disabled: false,
          },
          {
            name: "1305, CVS, EASTON, PA",
            disabled: false,
          },
          {
            name: "1305, Target, CERRITOS, CA",
            disabled: false,
          },
          {
            name: "1305, Walmart, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "13055, Walgreens, COVINGTON, KY",
            disabled: false,
          },
          {
            name: "13058, Walgreens, WILLOWICK, OH",
            disabled: false,
          },
          {
            name: "13059, Walgreens, BIXBY, OK",
            disabled: false,
          },
          {
            name: "1306, Albertsons, WEST DUNDEE, IL",
            disabled: false,
          },
          {
            name: "1306, CVS, MIDDLETON, MA",
            disabled: false,
          },
          {
            name: "1306, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "1306, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "1306, Walmart, ALAMOGORDO, NM",
            disabled: false,
          },
          {
            name: "13062, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "13065, Walgreens, CHILTON, WI",
            disabled: false,
          },
          {
            name: "13066, Walgreens, MARSHFIELD, WI",
            disabled: false,
          },
          {
            name: "1307, CVS, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "1307, Target, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "1307, Walmart, BOURBONNAIS, IL",
            disabled: false,
          },
          {
            name: "13078, Walgreens, MARATHON, FL",
            disabled: false,
          },
          {
            name: "1308, CVS, INWOOD, WV",
            disabled: false,
          },
          {
            name: "1308, Target, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "1308, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1308, Walmart, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "13080, Walgreens, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "13081, Walgreens, NEWTON, MA",
            disabled: false,
          },
          {
            name: "13083, Walgreens, HALEDON, NJ",
            disabled: false,
          },
          {
            name: "13086, Walgreens, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "13088, Walgreens, WEST BEND, WI",
            disabled: false,
          },
          {
            name: "1309, CVS, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "1309, Target, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "1309, Walgreens, HIGHLAND, IL",
            disabled: false,
          },
          {
            name: "1309, Walmart, SALEM, VA",
            disabled: false,
          },
          {
            name: "131, Albertsons, ONTARIO, OR",
            disabled: false,
          },
          {
            name: "131, BJ's, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "131, CVS, NORTH BILLERICA, MA",
            disabled: false,
          },
          {
            name: "131, Costco, SAND CITY, CA",
            disabled: false,
          },
          {
            name: "131, Kroger, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "131, Kroger, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "131, Kroger, Madison, WI",
            disabled: false,
          },
          {
            name: "131, Kroger, OGDEN, UT",
            disabled: false,
          },
          {
            name: "131, Kroger, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "131, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "131, Meijer, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "131, Walmart, MOUNT PLEASANT, TX",
            disabled: false,
          },
          {
            name: "1310, CVS, BOYERTOWN, PA",
            disabled: false,
          },
          {
            name: "1310, Target, AIKEN, SC",
            disabled: false,
          },
          {
            name: "1310, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1310, Walmart, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "13105, Walgreens, EMMETT, ID",
            disabled: false,
          },
          {
            name: "13106, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "13107, Walgreens, GATLINBURG, TN",
            disabled: false,
          },
          {
            name: "13108, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "1311, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "1311, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "1311, Target, NEW BERLIN, WI",
            disabled: false,
          },
          {
            name: "1311, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "13111, Walgreens, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "13114, Walgreens, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "13115, Walgreens, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "13116, Walgreens, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "13118, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "1312, CVS, STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "1312, Target, Dover, DE",
            disabled: false,
          },
          {
            name: "1312, Walmart, SPRING LAKE, NC",
            disabled: false,
          },
          {
            name: "13123, Walgreens, PURCELL, OK",
            disabled: false,
          },
          {
            name: "13124, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "13125, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "13126, Walgreens, CHESTERFIELD, VA",
            disabled: false,
          },
          {
            name: "1313, Target, TROY, MI",
            disabled: false,
          },
          {
            name: "1313, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "13134, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "13135, Walgreens, MASHPEE, MA",
            disabled: false,
          },
          {
            name: "13137, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "1314, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1314, Target, FENTON, MO",
            disabled: false,
          },
          {
            name: "1314, Walmart, BUFORD, GA",
            disabled: false,
          },
          {
            name: "13141, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "13148, Walgreens, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "13149, Walgreens, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1315, CVS, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "1315, Target, LINDEN, NJ",
            disabled: false,
          },
          {
            name: "1315, Walgreens, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "1315, Walmart, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "13150, Walgreens, GRAND LEDGE, MI",
            disabled: false,
          },
          {
            name: "13158, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "13159, Walgreens, SEMMES, AL",
            disabled: false,
          },
          {
            name: "1316, CVS, HUDSON, FL",
            disabled: false,
          },
          {
            name: "1316, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1316, Walmart, STURGEON BAY, WI",
            disabled: false,
          },
          {
            name: "13161, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "13162, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "13163, Walgreens, GRAND RAPIDS, MN",
            disabled: false,
          },
          {
            name: "13164, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "1317, ADUSA, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "1317, Costco, EASTVALE, CA",
            disabled: false,
          },
          {
            name: "1317, Target, ROSSFORD, OH",
            disabled: false,
          },
          {
            name: "1317, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1317, Walmart, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "1318, CVS, SATELLITE BEACH, FL",
            disabled: false,
          },
          {
            name: "1318, Costco, MONTEREY PARK, CA",
            disabled: false,
          },
          {
            name: "1318, Rite Aid, PENNS GROVE, NJ",
            disabled: false,
          },
          {
            name: "1318, Target, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "1318, Walgreens, FOLEY, AL",
            disabled: false,
          },
          {
            name: "1318, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "1319, ADUSA, CHARLOTTE HALL, MD",
            disabled: false,
          },
          {
            name: "1319, Albertsons, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "1319, CVS, SHOEMAKERSVILLE, PA",
            disabled: false,
          },
          {
            name: "1319, Costco, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "1319, Target, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1319, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1319, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "132, ADUSA, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "132, ADUSA, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "132, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "132, BJ's, BOWIE, MD",
            disabled: false,
          },
          {
            name: "132, Costco, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "132, Kroger, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "132, Kroger, DRAPER, UT",
            disabled: false,
          },
          {
            name: "132, Kroger, STEVENS POINT, WI",
            disabled: false,
          },
          {
            name: "132, Kroger, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "132, Meijer, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "132, Walmart, KINGFISHER, OK",
            disabled: false,
          },
          {
            name: "1320, CVS, BRODHEADSVILLE, PA",
            disabled: false,
          },
          {
            name: "1320, Costco, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "1320, Rite Aid, NARBERTH, PA",
            disabled: false,
          },
          {
            name: "1320, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "1321, CVS, READING, PA",
            disabled: false,
          },
          {
            name: "1321, Costco, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "1321, Walmart, SMITHFIELD, NC",
            disabled: false,
          },
          {
            name: "1322, ADUSA, HERNDON, VA",
            disabled: false,
          },
          {
            name: "1322, Albertsons, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "1322, Costco, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "1322, Target, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "1322, Walmart, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "1323, Albertsons, POULTNEY, VT",
            disabled: false,
          },
          {
            name: "1323, CVS, POTTSVILLE, PA",
            disabled: false,
          },
          {
            name: "1323, Costco, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "1323, Target, ST CHARLES, IL",
            disabled: false,
          },
          {
            name: "1323, Walmart, PEORIA, IL",
            disabled: false,
          },
          {
            name: "1324, Albertsons, FAIR HAVEN, VT",
            disabled: false,
          },
          {
            name: "1324, Albertsons, WEST HAVEN, VT",
            disabled: false,
          },
          {
            name: "1324, CVS, POTTSVILLE, PA",
            disabled: false,
          },
          {
            name: "1324, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1324, Target, MAYFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "1324, Walmart, NOGALES, AZ",
            disabled: false,
          },
          {
            name: "1325, ADUSA, BUENA VISTA, VA",
            disabled: false,
          },
          {
            name: "1325, CVS, NESQUEHONING, PA",
            disabled: false,
          },
          {
            name: "1325, Costco, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "1325, Target, AVON, OH",
            disabled: false,
          },
          {
            name: "1325, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1326, Costco, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "1326, Rite Aid, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "1326, Target, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "1326, Walmart, GRAND ISLAND, NE",
            disabled: false,
          },
          {
            name: "1327, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1327, Costco, PATTERSON, CA",
            disabled: false,
          },
          {
            name: "1327, Target, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1327, Walmart, MADISON, IN",
            disabled: false,
          },
          {
            name: "1328, CVS, HOLIDAY, FL",
            disabled: false,
          },
          {
            name: "1328, Rite Aid, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "1328, Target, SEAL BEACH, CA",
            disabled: false,
          },
          {
            name: "1328, Walmart, WINSLOW, AZ",
            disabled: false,
          },
          {
            name: "1329, Albertsons, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "1329, Target, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "1329, Walmart, LOGANSPORT, IN",
            disabled: false,
          },
          {
            name: "133, BJ's, SANFORD, FL",
            disabled: false,
          },
          {
            name: "133, CVS, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "133, Costco, REDDING, CA",
            disabled: false,
          },
          {
            name: "133, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "133, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "133, Kroger, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "133, Meijer, AVON, IN",
            disabled: false,
          },
          {
            name: "133, Walmart, ASHDOWN, AR",
            disabled: false,
          },
          {
            name: "1330, ADUSA, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "1330, Costco, WEBSTER, TX",
            disabled: false,
          },
          {
            name: "1330, Target, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "1330, Walmart, LIMA, OH",
            disabled: false,
          },
          {
            name: "1331, Albertsons, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1331, Costco, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "1331, Target, LAKE STEVENS, WA",
            disabled: false,
          },
          {
            name: "1331, Walmart, SIDNEY, OH",
            disabled: false,
          },
          {
            name: "1332, Costco, N. MIAMI, FL",
            disabled: false,
          },
          {
            name: "1332, Target, PASADENA, CA",
            disabled: false,
          },
          {
            name: "1332, Walmart, SOUTH SIOUX CITY, NE",
            disabled: false,
          },
          {
            name: "1333, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1333, Albertsons, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "1333, Costco, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "1333, Target, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "1333, Walmart, VAN WERT, OH",
            disabled: false,
          },
          {
            name: "1334, ADUSA, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "1334, Costco, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "1334, Target, MARQUETTE, MI",
            disabled: false,
          },
          {
            name: "1334, Walmart, CLAYPOOL, AZ",
            disabled: false,
          },
          {
            name: "1335, Albertsons, CALABASAS, CA",
            disabled: false,
          },
          {
            name: "1335, Target, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "1335, Walmart, LEXINGTON, VA",
            disabled: false,
          },
          {
            name: "1336, ADUSA, QUINTON, VA",
            disabled: false,
          },
          {
            name: "1336, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1336, Walmart, MARION, VA",
            disabled: false,
          },
          {
            name: "1337, Albertsons, ROSAMOND, CA",
            disabled: false,
          },
          {
            name: "1337, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1337, Target, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "1337, Walgreens, CANTON, OH",
            disabled: false,
          },
          {
            name: "1337, Walmart, ELKIN, NC",
            disabled: false,
          },
          {
            name: "1338, ADUSA, APEX, NC",
            disabled: false,
          },
          {
            name: "1338, Target, SOUTH PORTLAND, ME",
            disabled: false,
          },
          {
            name: "1338, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "1339, ADUSA, SMITHVILLE, TN",
            disabled: false,
          },
          {
            name: "1339, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "1339, Costco, SAN JUAN, PR",
            disabled: false,
          },
          {
            name: "1339, Target, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "1339, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "134, BJ's, CONCORD, NC",
            disabled: false,
          },
          {
            name: "134, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "134, Costco, VISALIA, CA",
            disabled: false,
          },
          {
            name: "134, Kroger, Baytown, TX",
            disabled: false,
          },
          {
            name: "134, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "134, Kroger, Glendale, CA",
            disabled: false,
          },
          {
            name: "134, Kroger, Scottsdale, AZ",
            disabled: false,
          },
          {
            name: "134, Meijer, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "134, Walmart, ELK CITY, OK",
            disabled: false,
          },
          {
            name: "1340, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1340, Target, NORWALK, CA",
            disabled: false,
          },
          {
            name: "1340, Walmart, LITHONIA, GA",
            disabled: false,
          },
          {
            name: "1341, Target, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1341, Walmart, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "1342, ADUSA, LINCOLNTON, NC",
            disabled: false,
          },
          {
            name: "1342, Costco, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "1342, Target, ROSEMONT, IL",
            disabled: false,
          },
          {
            name: "1342, Walmart, KENNER, LA",
            disabled: false,
          },
          {
            name: "1343, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1343, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1343, Costco, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "1344, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1344, Costco, SAINT CLOUD, MN",
            disabled: false,
          },
          {
            name: "1344, Target, Elmhurst, NY",
            disabled: false,
          },
          {
            name: "1344, Walmart, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "13440, Walgreens, SPRINGFIELD, NJ",
            disabled: false,
          },
          {
            name: "13444, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "13446, Walgreens, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "13447, Walgreens, UVALDE, TX",
            disabled: false,
          },
          {
            name: "13449, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1345, Albertsons, MORRO BAY, CA",
            disabled: false,
          },
          {
            name: "1345, Target, EAST WINDSOR, NJ",
            disabled: false,
          },
          {
            name: "1345, Walmart, SOUTH BOSTON, VA",
            disabled: false,
          },
          {
            name: "13450, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "13454, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "13456, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "13457, Walgreens, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "1346, ADUSA, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "1346, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1346, Target, Huntsville, AL",
            disabled: false,
          },
          {
            name: "1346, Walmart, OCEAN SPRINGS, MS",
            disabled: false,
          },
          {
            name: "13463, Walgreens, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "13465, Walgreens, EDENTON, NC",
            disabled: false,
          },
          {
            name: "13468, Walgreens, NEW CITY, NY",
            disabled: false,
          },
          {
            name: "1347, ADUSA, MOUNT AIRY, NC",
            disabled: false,
          },
          {
            name: "1347, Albertsons, TEHACHAPI, CA",
            disabled: false,
          },
          {
            name: "1347, Rite Aid, RITTMAN, OH",
            disabled: false,
          },
          {
            name: "1347, Target, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "1347, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "13474, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1348, Albertsons, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "1348, Costco, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "1348, Target, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "1348, Walmart, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1349, ADUSA, SANFORD, NC",
            disabled: false,
          },
          {
            name: "1349, Costco, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "1349, Target, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "1349, Walmart, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "135, ADUSA, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "135, Albertsons, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "135, Albertsons, WAKE VILLAGE, TX",
            disabled: false,
          },
          {
            name: "135, CVS, LITCHFIELD, CT",
            disabled: false,
          },
          {
            name: "135, Costco, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "135, Kroger, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "135, Kroger, FARMINGTON, UT",
            disabled: false,
          },
          {
            name: "135, Kroger, LAFAYETTE, CO",
            disabled: false,
          },
          {
            name: "135, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "135, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "135, Meijer, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "135, Rite Aid, WILLINGBORO, NJ",
            disabled: false,
          },
          {
            name: "135, Walmart, CHILLICOTHE, MO",
            disabled: false,
          },
          {
            name: "1350, ADUSA, MOUNT JACKSON, VA",
            disabled: false,
          },
          {
            name: "1350, CVS, WINDERMERE, FL",
            disabled: false,
          },
          {
            name: "1350, Costco, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "1350, Target, FISHERS, IN",
            disabled: false,
          },
          {
            name: "1350, Walmart, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "1351, Albertsons, SEVERNA PARK, MD",
            disabled: false,
          },
          {
            name: "1351, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1351, Rite Aid, TALLMADGE, OH",
            disabled: false,
          },
          {
            name: "1351, Target, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "1351, Walmart, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "1352, ADUSA, ELKIN, NC",
            disabled: false,
          },
          {
            name: "1352, Target, CHASKA, MN",
            disabled: false,
          },
          {
            name: "1352, Walmart, WALLACE, NC",
            disabled: false,
          },
          {
            name: "1353, ADUSA, PFAFFTOWN, NC",
            disabled: false,
          },
          {
            name: "1353, Costco, LOVES PARK, IL",
            disabled: false,
          },
          {
            name: "1353, Rite Aid, CANONSBURG, PA",
            disabled: false,
          },
          {
            name: "1353, Target, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "1353, Walmart, HARAHAN, LA",
            disabled: false,
          },
          {
            name: "1354, ADUSA, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "1354, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1354, Walmart, WASHINGTON, NC",
            disabled: false,
          },
          {
            name: "1355, ADUSA, SUMMERFIELD, NC",
            disabled: false,
          },
          {
            name: "1355, Rite Aid, BRODHEADSVILLE, PA",
            disabled: false,
          },
          {
            name: "1355, Target, LACEY, WA",
            disabled: false,
          },
          {
            name: "1355, Walmart, MOREHEAD CITY, NC",
            disabled: false,
          },
          {
            name: "1356, Target, MINNETONKA, MN",
            disabled: false,
          },
          {
            name: "1356, Walmart, MARTINSVILLE, IN",
            disabled: false,
          },
          {
            name: "1357, Target, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "1357, Walmart, SILVER CITY, NM",
            disabled: false,
          },
          {
            name: "1358, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1358, Albertsons, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1358, Costco, MONROVIA, MD",
            disabled: false,
          },
          {
            name: "1358, Target, White Plains, NY",
            disabled: false,
          },
          {
            name: "1358, Walmart, WALTERBORO, SC",
            disabled: false,
          },
          {
            name: "13584, Walgreens, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "13585, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "13586, Walgreens, MERAUX, LA",
            disabled: false,
          },
          {
            name: "13588, Walgreens, BASTROP, TX",
            disabled: false,
          },
          {
            name: "13589, Walgreens, VIENNA, VA",
            disabled: false,
          },
          {
            name: "1359, CVS, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "1359, Target, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "1359, Walmart, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "136, BJ's, FREEPORT, NY",
            disabled: false,
          },
          {
            name: "136, Costco, CHICO, CA",
            disabled: false,
          },
          {
            name: "136, HEB, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "136, Kroger, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "136, Kroger, CONROE, TX",
            disabled: false,
          },
          {
            name: "136, Kroger, CORONA, CA",
            disabled: false,
          },
          {
            name: "136, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "136, Kroger, PROVO, UT",
            disabled: false,
          },
          {
            name: "136, Meijer, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "136, Walmart, BLACKWELL, OK",
            disabled: false,
          },
          {
            name: "1360, ADUSA, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "1360, Albertsons, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "1360, Albertsons, SAUGUS, CA",
            disabled: false,
          },
          {
            name: "1360, Costco, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "1360, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1360, Walmart, FAYETTEVILLE, WV",
            disabled: false,
          },
          {
            name: "13600, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "13604, Walgreens, AMITE, LA",
            disabled: false,
          },
          {
            name: "13605, Walgreens, RUSTON, LA",
            disabled: false,
          },
          {
            name: "13606, Walgreens, TOWSON, MD",
            disabled: false,
          },
          {
            name: "13609, Walgreens, COLUMBIA, MS",
            disabled: false,
          },
          {
            name: "1361, ADUSA, POWHATAN, VA",
            disabled: false,
          },
          {
            name: "1361, Costco, SHARPSBURG, GA",
            disabled: false,
          },
          {
            name: "1361, Target, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "1361, Walmart, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "13611, Walgreens, NYACK, NY",
            disabled: false,
          },
          {
            name: "13613, Walgreens, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "13614, Walgreens, KUNA, ID",
            disabled: false,
          },
          {
            name: "13615, Walgreens, BELFAST, ME",
            disabled: false,
          },
          {
            name: "1362, ADUSA, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "1362, Target, BURBANK, CA",
            disabled: false,
          },
          {
            name: "1362, Walmart, DESTIN, FL",
            disabled: false,
          },
          {
            name: "13620, Walgreens, CEDARBURG, WI",
            disabled: false,
          },
          {
            name: "1363, ADUSA, NORTH EAST, MD",
            disabled: false,
          },
          {
            name: "1363, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1363, Costco, EAGAN, MN",
            disabled: false,
          },
          {
            name: "1363, Target, RENO, NV",
            disabled: false,
          },
          {
            name: "1363, Walmart, MADISON, GA",
            disabled: false,
          },
          {
            name: "13631, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "13632, Walgreens, LEITCHFIELD, KY",
            disabled: false,
          },
          {
            name: "1364, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1364, Costco, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "1364, Target, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "1364, Walmart, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "13642, Walgreens, LOWELL, MA",
            disabled: false,
          },
          {
            name: "1365, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1365, Albertsons, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1365, Target, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "1365, Walmart, HUDSON, WI",
            disabled: false,
          },
          {
            name: "13656, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "13657, Walgreens, EASTVALE, CA",
            disabled: false,
          },
          {
            name: "13658, Walgreens, RIVER RIDGE, LA",
            disabled: false,
          },
          {
            name: "13659, Walgreens, JACKSON, TN",
            disabled: false,
          },
          {
            name: "1366, ADUSA, SALUDA, VA",
            disabled: false,
          },
          {
            name: "1366, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1366, Costco, RIDGELAND, MS",
            disabled: false,
          },
          {
            name: "1366, Target, CARMEL, IN",
            disabled: false,
          },
          {
            name: "1366, Walmart, MERRILL, WI",
            disabled: false,
          },
          {
            name: "13660, Walgreens, JONESBOROUGH, TN",
            disabled: false,
          },
          {
            name: "1367, CVS, CARMEL, IN",
            disabled: false,
          },
          {
            name: "1367, Target, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "1367, Walmart, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "13670, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "13672, Walgreens, BLACKFOOT, ID",
            disabled: false,
          },
          {
            name: "13673, Walgreens, BURLEY, ID",
            disabled: false,
          },
          {
            name: "13678, Walgreens, DELAND, FL",
            disabled: false,
          },
          {
            name: "13679, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1368, ADUSA, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "1368, CVS, ATLANTA, TX",
            disabled: false,
          },
          {
            name: "1368, Target, EULESS, TX",
            disabled: false,
          },
          {
            name: "1368, Walmart, WEST UNION, OH",
            disabled: false,
          },
          {
            name: "13681, Walgreens, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "13682, Walgreens, PURCELLVILLE, VA",
            disabled: false,
          },
          {
            name: "13683, Walgreens, WEST BEND, WI",
            disabled: false,
          },
          {
            name: "13685, Walgreens, ROSEVILLE, MN",
            disabled: false,
          },
          {
            name: "13686, Walgreens, MAPLEWOOD, NJ",
            disabled: false,
          },
          {
            name: "1369, ADUSA, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "1369, Albertsons, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1369, Target, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "1369, Walmart, PAYSON, AZ",
            disabled: false,
          },
          {
            name: "13690, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "13698, Walgreens, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "137, ADUSA, VINTON, VA",
            disabled: false,
          },
          {
            name: "137, Albertsons, AURORA, CO",
            disabled: false,
          },
          {
            name: "137, CVS, QUINCY, MA",
            disabled: false,
          },
          {
            name: "137, Costco, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "137, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "137, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "137, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "137, Kroger, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "137, Meijer, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "137, Target, NORMAL, IL",
            disabled: false,
          },
          {
            name: "137, Walmart, STILLWATER, OK",
            disabled: false,
          },
          {
            name: "1370, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1370, Rite Aid, MCKEESPORT, PA",
            disabled: false,
          },
          {
            name: "1370, Target, Knoxville, TN",
            disabled: false,
          },
          {
            name: "1370, Walmart, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "13700, Walgreens, WESTFIELD, NJ",
            disabled: false,
          },
          {
            name: "13701, Walgreens, VERONA, NJ",
            disabled: false,
          },
          {
            name: "13702, Walgreens, FAIRFIELD, NJ",
            disabled: false,
          },
          {
            name: "13703, Walgreens, HAZLET, NJ",
            disabled: false,
          },
          {
            name: "13704, Walgreens, RAMSEY, NJ",
            disabled: false,
          },
          {
            name: "13705, Walgreens, VAUXHALL, NJ",
            disabled: false,
          },
          {
            name: "13706, Walgreens, WARREN, NJ",
            disabled: false,
          },
          {
            name: "1371, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1371, Rite Aid, PITTSTON, PA",
            disabled: false,
          },
          {
            name: "1371, Target, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "1371, Walmart, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "13711, Walgreens, ENGLEWOOD, NJ",
            disabled: false,
          },
          {
            name: "13717, Walgreens, PORT MONMOUTH, NJ",
            disabled: false,
          },
          {
            name: "13719, Walgreens, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "1372, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1372, Costco, EAST LYME, CT",
            disabled: false,
          },
          {
            name: "1372, Target, THORNTON, CO",
            disabled: false,
          },
          {
            name: "1372, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "13720, Walgreens, SAYREVILLE, NJ",
            disabled: false,
          },
          {
            name: "13721, Walgreens, BOONTON, NJ",
            disabled: false,
          },
          {
            name: "13722, Walgreens, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "13726, Walgreens, SPRING VALLEY, NY",
            disabled: false,
          },
          {
            name: "13727, Walgreens, GLADSTONE, OR",
            disabled: false,
          },
          {
            name: "1373, ADUSA, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "1373, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1373, Target, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "1373, Walmart, LILBURN, GA",
            disabled: false,
          },
          {
            name: "1374, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1374, CVS, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "1374, Target, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "1374, Walmart, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "1375, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1375, Costco, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "1375, Rite Aid, NAUGATUCK, CT",
            disabled: false,
          },
          {
            name: "1375, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "1375, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1375, Walmart, MARIANNA, FL",
            disabled: false,
          },
          {
            name: "13751, Walgreens, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "13752, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "13753, Walgreens, EDINA, MN",
            disabled: false,
          },
          {
            name: "13759, Walgreens, COLLEGE PARK, GA",
            disabled: false,
          },
          {
            name: "1376, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1376, Albertsons, RIDGECREST, CA",
            disabled: false,
          },
          {
            name: "1376, CVS, PERKASIE, PA",
            disabled: false,
          },
          {
            name: "1376, Target, MOBILE, AL",
            disabled: false,
          },
          {
            name: "1376, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1376, Walmart, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "13760, Walgreens, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "13761, Walgreens, YOUNGSVILLE, LA",
            disabled: false,
          },
          {
            name: "1377, Target, CLEAR LAKE SHORES, TX",
            disabled: false,
          },
          {
            name: "1377, Walmart, JOHNSBURG, IL",
            disabled: false,
          },
          {
            name: "13770, Walgreens, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "13771, Walgreens, WAUSAU, WI",
            disabled: false,
          },
          {
            name: "13779, Walgreens, PRAIRIEVILLE, LA",
            disabled: false,
          },
          {
            name: "1378, CVS, BURKE, VA",
            disabled: false,
          },
          {
            name: "1378, Target, OCEAN, NJ",
            disabled: false,
          },
          {
            name: "1378, Walmart, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "13780, Walgreens, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "13786, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1379, CVS, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "1379, Costco, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "1379, Rite Aid, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "1379, Walmart, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "13790, Walgreens, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "13793, Walgreens, MADISON, AL",
            disabled: false,
          },
          {
            name: "13796, Walgreens, SAN PABLO, CA",
            disabled: false,
          },
          {
            name: "13797, Walgreens, BARTOW, FL",
            disabled: false,
          },
          {
            name: "138, Albertsons, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "138, Kroger, Erie, CO",
            disabled: false,
          },
          {
            name: "138, Kroger, Lafayette, CO",
            disabled: false,
          },
          {
            name: "138, Kroger, MONTICELLO, IN",
            disabled: false,
          },
          {
            name: "138, Kroger, NEW CANEY, TX",
            disabled: false,
          },
          {
            name: "138, Kroger, Oceanside, CA",
            disabled: false,
          },
          {
            name: "138, Kroger, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "138, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "138, Meijer, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "138, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "1380, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1380, Costco, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "1380, Target, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "1380, Walmart, LAS VEGAS, NM",
            disabled: false,
          },
          {
            name: "1381, ADUSA, LIVINGSTON, TN",
            disabled: false,
          },
          {
            name: "1381, CVS, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "1381, Target, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "1381, Walmart, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "13811, Walgreens, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "13812, Walgreens, LA MIRADA, CA",
            disabled: false,
          },
          {
            name: "13813, Walgreens, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "13815, Walgreens, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "13816, Walgreens, ODENTON, MD",
            disabled: false,
          },
          {
            name: "13818, Walgreens, BUTTE, MT",
            disabled: false,
          },
          {
            name: "13819, Walgreens, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "1382, Albertsons, TAFT, CA",
            disabled: false,
          },
          {
            name: "1382, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1382, Target, WESLEY CHAPEL, FL",
            disabled: false,
          },
          {
            name: "1382, Walmart, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "13822, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "13823, Walgreens, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "13824, Walgreens, LUTZ, FL",
            disabled: false,
          },
          {
            name: "13827, Walgreens, WESTMONT, IL",
            disabled: false,
          },
          {
            name: "1383, ADUSA, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1383, CVS, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "1383, Costco, SARATOGA SPRING, UT",
            disabled: false,
          },
          {
            name: "1383, Target, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "1383, Walmart, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "13830, Walgreens, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "13833, Walgreens, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "13834, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "13838, Walgreens, WAHIAWA, HI",
            disabled: false,
          },
          {
            name: "1384, ADUSA, CONWAY, SC",
            disabled: false,
          },
          {
            name: "1384, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1384, Costco, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "1384, Rite Aid, BANGOR, PA",
            disabled: false,
          },
          {
            name: "1384, Target, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1384, Walmart, LA JUNTA, CO",
            disabled: false,
          },
          {
            name: "13840, Walgreens, NOTTINGHAM, MD",
            disabled: false,
          },
          {
            name: "13841, Walgreens, GOLDEN VALLEY, MN",
            disabled: false,
          },
          {
            name: "13842, Walgreens, SAINT MICHAEL, MN",
            disabled: false,
          },
          {
            name: "1385, ADUSA, DOVER, DE",
            disabled: false,
          },
          {
            name: "1385, Target, WHEELING, IL",
            disabled: false,
          },
          {
            name: "1385, Walmart, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "13850, Walgreens, HOLMES BEACH, FL",
            disabled: false,
          },
          {
            name: "13851, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "13853, Walgreens, MINNETONKA, MN",
            disabled: false,
          },
          {
            name: "13854, Walgreens, MOUNT OLIVE, NC",
            disabled: false,
          },
          {
            name: "1386, ADUSA, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "1386, CVS, BAILEYS CROSSROADS, VA",
            disabled: false,
          },
          {
            name: "1386, Target, MESA, AZ",
            disabled: false,
          },
          {
            name: "1386, Walmart, PONTIAC, IL",
            disabled: false,
          },
          {
            name: "13861, Walgreens, WHEATON, IL",
            disabled: false,
          },
          {
            name: "13862, Walgreens, MANALAPAN, NJ",
            disabled: false,
          },
          {
            name: "13863, Walgreens, LITTLE FALLS, NJ",
            disabled: false,
          },
          {
            name: "13866, Walgreens, MILLER PLACE, NY",
            disabled: false,
          },
          {
            name: "1387, CVS, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "1387, Walmart, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "13871, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "13874, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "13875, Walgreens, BAKER, LA",
            disabled: false,
          },
          {
            name: "13876, Walgreens, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "13877, Walgreens, DULUTH, MN",
            disabled: false,
          },
          {
            name: "1388, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1388, Costco, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "1388, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1388, Walmart, KENDALLVILLE, IN",
            disabled: false,
          },
          {
            name: "13880, Walgreens, SAUK RAPIDS, MN",
            disabled: false,
          },
          {
            name: "13888, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "1389, CVS, OAKTON, VA",
            disabled: false,
          },
          {
            name: "1389, Target, DEPTFORD, NJ",
            disabled: false,
          },
          {
            name: "1389, Walmart, BOONE, IA",
            disabled: false,
          },
          {
            name: "13891, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "13892, Walgreens, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "13893, Walgreens, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "139, BJ's, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "139, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "139, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "139, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "139, Kroger, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "139, Kroger, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "139, Meijer, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "139, Target, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "139, Walmart, PURCELL, OK",
            disabled: false,
          },
          {
            name: "1390, CVS, BURKE, VA",
            disabled: false,
          },
          {
            name: "1390, Target, TUCKER, GA",
            disabled: false,
          },
          {
            name: "1390, Walmart, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "13902, Walgreens, MANKATO, MN",
            disabled: false,
          },
          {
            name: "13903, Walgreens, PARK RAPIDS, MN",
            disabled: false,
          },
          {
            name: "1391, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1391, CVS, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1391, Target, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1391, Walmart, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "1392, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1392, Target, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "1392, Walmart, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "13920, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "13921, Walgreens, DECATUR, IL",
            disabled: false,
          },
          {
            name: "13925, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "13927, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "13929, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "1393, ADUSA, CLOVER, SC",
            disabled: false,
          },
          {
            name: "1393, CVS, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1393, Target, MILFORD, OH",
            disabled: false,
          },
          {
            name: "1393, Walmart, OSKALOOSA, IA",
            disabled: false,
          },
          {
            name: "13930, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "13931, Walgreens, MISSION, TX",
            disabled: false,
          },
          {
            name: "13937, Walgreens, HOOVER, AL",
            disabled: false,
          },
          {
            name: "13938, Walgreens, MONTICELLO, MN",
            disabled: false,
          },
          {
            name: "1394, ADUSA, TARBORO, NC",
            disabled: false,
          },
          {
            name: "1394, Albertsons, ORCUTT, CA",
            disabled: false,
          },
          {
            name: "1394, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1394, Target, CUMMING, GA",
            disabled: false,
          },
          {
            name: "1394, Walmart, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "13940, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "13941, Walgreens, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "13942, Walgreens, RICHBORO, PA",
            disabled: false,
          },
          {
            name: "13948, Walgreens, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "13949, Walgreens, PORTAGE, IN",
            disabled: false,
          },
          {
            name: "1395, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1395, Target, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "1395, Walmart, CENTRALIA, IL",
            disabled: false,
          },
          {
            name: "13950, Walgreens, LEAWOOD, KS",
            disabled: false,
          },
          {
            name: "1396, ADUSA, NEWPORT, NC",
            disabled: false,
          },
          {
            name: "1396, CVS, RESTON, VA",
            disabled: false,
          },
          {
            name: "1396, Target, PASADENA, TX",
            disabled: false,
          },
          {
            name: "1396, Walmart, BARABOO, WI",
            disabled: false,
          },
          {
            name: "13961, Walgreens, MINEOLA, NY",
            disabled: false,
          },
          {
            name: "13962, Walgreens, SAN JUAN, TX",
            disabled: false,
          },
          {
            name: "13968, Walgreens, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "1397, CVS, MCLEAN, VA",
            disabled: false,
          },
          {
            name: "1397, Costco, KENT, WA",
            disabled: false,
          },
          {
            name: "1397, Target, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "1397, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "13970, Walgreens, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "13971, Walgreens, EAST WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "1398, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1398, CVS, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "1398, Costco, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "1398, Rite Aid, UNION CITY, PA",
            disabled: false,
          },
          {
            name: "1398, Target, EDMOND, OK",
            disabled: false,
          },
          {
            name: "1398, Walmart, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "13984, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "13985, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "13987, Walgreens, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "13989, Walgreens, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1399, Albertsons, PHOENIX, MD",
            disabled: false,
          },
          {
            name: "1399, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1399, Costco, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "1399, Target, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "1399, Walmart, BEDFORD, VA",
            disabled: false,
          },
          {
            name: "13995, Walgreens, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "14, ADUSA, PEMBROKE, MA",
            disabled: false,
          },
          {
            name: "14, HEB, KYLE, TX",
            disabled: false,
          },
          {
            name: "14, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "14, Kroger, Corydon, IN",
            disabled: false,
          },
          {
            name: "14, Kroger, HAYS, KS",
            disabled: false,
          },
          {
            name: "14, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "14, Kroger, WILLIS, TX",
            disabled: false,
          },
          {
            name: "14, Walmart, LEBANON, MO",
            disabled: false,
          },
          {
            name: "140, ADUSA, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "140, Albertsons, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "140, CVS, WINTHROP, MA",
            disabled: false,
          },
          {
            name: "140, Costco, KAILUA KONA, HI",
            disabled: false,
          },
          {
            name: "140, Kroger, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "140, Kroger, SUNSET, UT",
            disabled: false,
          },
          {
            name: "140, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "140, Meijer, LAPEER, MI",
            disabled: false,
          },
          {
            name: "140, ShopRite, WYCKOFF, NJ",
            disabled: false,
          },
          {
            name: "140, Walmart, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "1400, CVS, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1400, Costco, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "1400, Target, HIRAM, GA",
            disabled: false,
          },
          {
            name: "1400, Walmart, ATHENS, GA",
            disabled: false,
          },
          {
            name: "1401, CVS, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "1401, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1401, Target, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "1401, Walmart, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "1402, ADUSA, ORANGE, VA",
            disabled: false,
          },
          {
            name: "1402, Albertsons, GILFORD, NH",
            disabled: false,
          },
          {
            name: "1402, CVS, HERNDON, VA",
            disabled: false,
          },
          {
            name: "1402, Costco, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "1402, Target, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "1403, Albertsons, STICKNEY, IL",
            disabled: false,
          },
          {
            name: "1403, CVS, VIENNA, VA",
            disabled: false,
          },
          {
            name: "1403, Costco, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "1403, Target, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "1403, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1403, Walmart, CORNELIA, GA",
            disabled: false,
          },
          {
            name: "1404, Albertsons, BRAINTREE, MA",
            disabled: false,
          },
          {
            name: "1404, CVS, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1404, Costco, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1404, Rite Aid, DANBURY, CT",
            disabled: false,
          },
          {
            name: "1404, Target, SMITHFIELD, RI",
            disabled: false,
          },
          {
            name: "1404, Walmart, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "1405, ADUSA, MIDDLE RIVER, MD",
            disabled: false,
          },
          {
            name: "1405, CVS, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "1405, Costco, PENDERGRASS, GA",
            disabled: false,
          },
          {
            name: "1405, Target, EUGENE, OR",
            disabled: false,
          },
          {
            name: "1405, Walmart, BAY CITY, TX",
            disabled: false,
          },
          {
            name: "1406, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1406, CVS, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1406, Costco, OCALA, FL",
            disabled: false,
          },
          {
            name: "1406, Rite Aid, KANE, PA",
            disabled: false,
          },
          {
            name: "1406, Target, FAIRVIEW, OR",
            disabled: false,
          },
          {
            name: "1406, Walmart, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "1407, Albertsons, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "1407, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1407, Costco, COVINGTON TOWNS, PA",
            disabled: false,
          },
          {
            name: "1407, Target, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "1407, Walmart, LEBANON, OH",
            disabled: false,
          },
          {
            name: "1408, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1408, Costco, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1408, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "1408, Walmart, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1409, Albertsons, HANSON, MA",
            disabled: false,
          },
          {
            name: "1409, Costco, PEARL CITY, HI",
            disabled: false,
          },
          {
            name: "1409, Target, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "1409, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "141, ADUSA, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "141, CVS, NORTHBROOK, IL",
            disabled: false,
          },
          {
            name: "141, Costco, NOVATO, CA",
            disabled: false,
          },
          {
            name: "141, Meijer, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "141, ShopRite, NEW MILFORD, NJ",
            disabled: false,
          },
          {
            name: "141, Walmart, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "1410, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1410, Costco, SAN JUAN, PR",
            disabled: false,
          },
          {
            name: "1410, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "1410, Walmart, TROY, OH",
            disabled: false,
          },
          {
            name: "1411, Albertsons, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "1411, CVS, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1411, Costco, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1411, Rite Aid, BEAR, DE",
            disabled: false,
          },
          {
            name: "1411, Target, ROSEMEAD, CA",
            disabled: false,
          },
          {
            name: "1411, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "1411, Walmart, GREEN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "1412, ADUSA, RANDALLSTOWN, MD",
            disabled: false,
          },
          {
            name: "1412, Albertsons, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "1412, Walmart, LARAMIE, WY",
            disabled: false,
          },
          {
            name: "1413, Albertsons, MILL CREEK, WA",
            disabled: false,
          },
          {
            name: "1413, CVS, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "1413, Costco, SAN JUAN, PR",
            disabled: false,
          },
          {
            name: "1413, Rite Aid, WILKES-BARRE, PA",
            disabled: false,
          },
          {
            name: "1413, Target, AURORA, CO",
            disabled: false,
          },
          {
            name: "1413, Walmart, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "1414, ADUSA, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "1414, Albertsons, MEDFIELD, MA",
            disabled: false,
          },
          {
            name: "1414, CVS, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "1414, Target, BUTLER, PA",
            disabled: false,
          },
          {
            name: "1414, Walmart, BELEN, NM",
            disabled: false,
          },
          {
            name: "1415, CVS, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "1415, Costco, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "1415, Target, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1415, Walmart, SPIRIT LAKE, IA",
            disabled: false,
          },
          {
            name: "1416, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1416, Albertsons, RANDOLPH, MA",
            disabled: false,
          },
          {
            name: "1416, CVS, CENTREVILLE, VA",
            disabled: false,
          },
          {
            name: "1416, Target, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "1416, Walmart, NAPOLEON, OH",
            disabled: false,
          },
          {
            name: "1417, ADUSA, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "1417, Albertsons, GREAT FALLS, VA",
            disabled: false,
          },
          {
            name: "1417, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1417, Target, FRESNO, CA",
            disabled: false,
          },
          {
            name: "1417, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1417, Walmart, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "1418, ADUSA, PORTLAND, TN",
            disabled: false,
          },
          {
            name: "1418, Target, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "1418, Walmart, O FALLON, IL",
            disabled: false,
          },
          {
            name: "1419, ADUSA, DOVER, DE",
            disabled: false,
          },
          {
            name: "1419, Albertsons, ASHLAND, MA",
            disabled: false,
          },
          {
            name: "1419, CVS, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "1419, Target, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1419, Walmart, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "142, ADUSA, CARRBORO, NC",
            disabled: false,
          },
          {
            name: "142, CVS, GREENCASTLE, PA",
            disabled: false,
          },
          {
            name: "142, Costco, MERCED, CA",
            disabled: false,
          },
          {
            name: "142, Kroger, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "142, Kroger, SYRACUSE, UT",
            disabled: false,
          },
          {
            name: "142, Meijer, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "142, Rite Aid, HILLSBORO, OH",
            disabled: false,
          },
          {
            name: "1420, ADUSA, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1420, Albertsons, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "1420, Costco, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "1420, Target, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1420, Walmart, STREAMWOOD, IL",
            disabled: false,
          },
          {
            name: "1421, Target, EUREKA, CA",
            disabled: false,
          },
          {
            name: "1421, Walmart, WASHINGTON, IL",
            disabled: false,
          },
          {
            name: "1422, ADUSA, PROVIDENCE FORGE, VA",
            disabled: false,
          },
          {
            name: "1422, Target, FREMONT, CA",
            disabled: false,
          },
          {
            name: "1422, Walmart, ALMA, MI",
            disabled: false,
          },
          {
            name: "1423, ADUSA, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "1423, CVS, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "1423, Target, MONTCLAIR, CA",
            disabled: false,
          },
          {
            name: "1423, Walgreens, BETHANY, OK",
            disabled: false,
          },
          {
            name: "1423, Walmart, SAINT JOHNS, MI",
            disabled: false,
          },
          {
            name: "1424, Albertsons, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "1424, CVS, STERLING, VA",
            disabled: false,
          },
          {
            name: "1424, Target, NORWALK, CA",
            disabled: false,
          },
          {
            name: "1424, Walmart, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "1425, ADUSA, TIMBERVILLE, VA",
            disabled: false,
          },
          {
            name: "1425, Target, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "1425, Walmart, COLUMBIA CITY, IN",
            disabled: false,
          },
          {
            name: "1426, ADUSA, SMYRNA, DE",
            disabled: false,
          },
          {
            name: "1426, Rite Aid, OLYPHANT, PA",
            disabled: false,
          },
          {
            name: "1426, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1426, Walmart, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "1427, CVS, KEYSER, WV",
            disabled: false,
          },
          {
            name: "1427, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1427, Walmart, CIRCLEVILLE, OH",
            disabled: false,
          },
          {
            name: "1428, ADUSA, DARLINGTON, SC",
            disabled: false,
          },
          {
            name: "1428, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1428, CVS, CHARLES TOWN, WV",
            disabled: false,
          },
          {
            name: "1428, Target, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "1428, Walmart, MOUNT PLEASANT, MI",
            disabled: false,
          },
          {
            name: "1429, Albertsons, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "1429, CVS, MARTINSBURG, WV",
            disabled: false,
          },
          {
            name: "1429, Rite Aid, EVERETT, PA",
            disabled: false,
          },
          {
            name: "1429, Target, MESA, AZ",
            disabled: false,
          },
          {
            name: "1429, Walmart, FREMONT, OH",
            disabled: false,
          },
          {
            name: "143, ADUSA, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "143, ADUSA, OXFORD, NC",
            disabled: false,
          },
          {
            name: "143, CVS, BIDDEFORD, ME",
            disabled: false,
          },
          {
            name: "143, Costco, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "143, Kroger, Castaic, CA",
            disabled: false,
          },
          {
            name: "143, Kroger, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "143, Meijer, Lewis Center, OH",
            disabled: false,
          },
          {
            name: "143, Walmart, BENTON, KY",
            disabled: false,
          },
          {
            name: "1430, Albertsons, MEDWAY, MA",
            disabled: false,
          },
          {
            name: "1430, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1430, Rite Aid, BELPRE, OH",
            disabled: false,
          },
          {
            name: "1430, Target, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "1430, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "1430, Walmart, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "1431, Albertsons, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1431, CVS, OLNEY, MD",
            disabled: false,
          },
          {
            name: "1431, Target, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1431, Walmart, KEOKUK, IA",
            disabled: false,
          },
          {
            name: "1432, Albertsons, WHITINSVILLE, MA",
            disabled: false,
          },
          {
            name: "1432, Target, FOUNTAIN HILLS, AZ",
            disabled: false,
          },
          {
            name: "1432, Walmart, CADILLAC, MI",
            disabled: false,
          },
          {
            name: "1433, Rite Aid, NORWALK, OH",
            disabled: false,
          },
          {
            name: "1433, Walmart, CELINA, OH",
            disabled: false,
          },
          {
            name: "1434, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1434, Albertsons, WINDSOR, CA",
            disabled: false,
          },
          {
            name: "1434, CVS, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1434, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1435, Albertsons, BARRINGTON, RI",
            disabled: false,
          },
          {
            name: "1435, CVS, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1435, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1435, Walmart, CRESTON, IA",
            disabled: false,
          },
          {
            name: "1436, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "1436, CVS, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1436, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1436, Walmart, GREENACRES, FL",
            disabled: false,
          },
          {
            name: "1437, ADUSA, BLUE RIDGE, GA",
            disabled: false,
          },
          {
            name: "1437, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "1437, CVS, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1437, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1437, Walmart, GUYMON, OK",
            disabled: false,
          },
          {
            name: "1438, Albertsons, AZTEC, NM",
            disabled: false,
          },
          {
            name: "1438, Target, NAPA, CA",
            disabled: false,
          },
          {
            name: "1438, Walgreens, BANNOCKBURN, IL",
            disabled: false,
          },
          {
            name: "1438, Walmart, CEDAR CITY, UT",
            disabled: false,
          },
          {
            name: "1439, Albertsons, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "1439, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1439, Walmart, WASHINGTON, UT",
            disabled: false,
          },
          {
            name: "144, ADUSA, WASHINGTON, NC",
            disabled: false,
          },
          {
            name: "144, BJ's, CUMMING, GA",
            disabled: false,
          },
          {
            name: "144, Costco, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "144, Kroger, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "144, Kroger, OREM, UT",
            disabled: false,
          },
          {
            name: "144, Kroger, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "144, Meijer, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "144, Target, MADISON, TN",
            disabled: false,
          },
          {
            name: "144, Walmart, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "1440, Albertsons, MONUMENT, CO",
            disabled: false,
          },
          {
            name: "1440, Walmart, TOOELE, UT",
            disabled: false,
          },
          {
            name: "1441, CVS, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1441, Target, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "1441, Walmart, MASON, OH",
            disabled: false,
          },
          {
            name: "1442, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1442, Albertsons, MIDDLETOWN, RI",
            disabled: false,
          },
          {
            name: "1442, CVS, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1442, Target, WATERTOWN, MA",
            disabled: false,
          },
          {
            name: "1442, Walmart, PAGE, AZ",
            disabled: false,
          },
          {
            name: "1443, Albertsons, CLINTON, MD",
            disabled: false,
          },
          {
            name: "1443, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1443, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1444, ADUSA, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1444, Albertsons, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "1444, CVS, COLLEGE PARK, MD",
            disabled: false,
          },
          {
            name: "1444, Target, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1444, Walgreens, LEBANON, IN",
            disabled: false,
          },
          {
            name: "1444, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1445, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1445, Target, Granger, IN",
            disabled: false,
          },
          {
            name: "1445, Walmart, PORT CLINTON, OH",
            disabled: false,
          },
          {
            name: "1446, Albertsons, PARKER, CO",
            disabled: false,
          },
          {
            name: "1446, Target, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "1446, Walmart, RICE LAKE, WI",
            disabled: false,
          },
          {
            name: "1447, ADUSA, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "1447, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1447, Target, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1447, Walmart, SUPERIOR, WI",
            disabled: false,
          },
          {
            name: "1448, ADUSA, STANLEY, VA",
            disabled: false,
          },
          {
            name: "1448, Albertsons, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "1448, CVS, NEW CARROLLTON, MD",
            disabled: false,
          },
          {
            name: "1448, Rite Aid, CORAOPOLIS, PA",
            disabled: false,
          },
          {
            name: "1448, Target, LINO LAKES, MN",
            disabled: false,
          },
          {
            name: "1448, Walmart, ASHLAND, OH",
            disabled: false,
          },
          {
            name: "1449, Albertsons, WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "1449, Target, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1449, Walgreens, BROADVIEW, IL",
            disabled: false,
          },
          {
            name: "1449, Walmart, MANITOWOC, WI",
            disabled: false,
          },
          {
            name: "145, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "145, Albertsons, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "145, CVS, FARMINGTON, CT",
            disabled: false,
          },
          {
            name: "145, Costco, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "145, Kroger, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "145, Kroger, Riverside, CA",
            disabled: false,
          },
          {
            name: "145, Meijer, FRASER, MI",
            disabled: false,
          },
          {
            name: "145, Walmart, BOWLING GREEN, MO",
            disabled: false,
          },
          {
            name: "1450, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "1450, Rite Aid, PALMERTON, PA",
            disabled: false,
          },
          {
            name: "1450, Target, HOUMA, LA",
            disabled: false,
          },
          {
            name: "1450, Walgreens, LYONS, IL",
            disabled: false,
          },
          {
            name: "1450, Walmart, RIPLEY, WV",
            disabled: false,
          },
          {
            name: "1451, ADUSA, PRINCE GEORGE, VA",
            disabled: false,
          },
          {
            name: "1451, CVS, BOWIE, MD",
            disabled: false,
          },
          {
            name: "1451, Rite Aid, MAHOPAC, NY",
            disabled: false,
          },
          {
            name: "1451, Target, HARVEY, LA",
            disabled: false,
          },
          {
            name: "1451, Walgreens, MILFORD, CT",
            disabled: false,
          },
          {
            name: "1451, Walmart, BEARDSTOWN, IL",
            disabled: false,
          },
          {
            name: "1452, CVS, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1452, Target, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "1452, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1453, ADUSA, CONCORD, NC",
            disabled: false,
          },
          {
            name: "1453, CVS, RIVERDALE, MD",
            disabled: false,
          },
          {
            name: "1453, Target, ATHENS, GA",
            disabled: false,
          },
          {
            name: "1453, Walmart, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "1454, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1454, CVS, BOWIE, MD",
            disabled: false,
          },
          {
            name: "1454, Target, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "1454, Walmart, QUINCY, IL",
            disabled: false,
          },
          {
            name: "1455, Albertsons, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "1455, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1455, Walgreens, GUILFORD, CT",
            disabled: false,
          },
          {
            name: "1455, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "1456, ADUSA, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "1456, CVS, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "1456, Target, ROGERS, MN",
            disabled: false,
          },
          {
            name: "1456, Walmart, EVANSTON, WY",
            disabled: false,
          },
          {
            name: "1457, CVS, FORT WASHINGTON, MD",
            disabled: false,
          },
          {
            name: "1457, Target, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "1457, Walmart, RIVERTON, WY",
            disabled: false,
          },
          {
            name: "1458, ADUSA, LAUREL, DE",
            disabled: false,
          },
          {
            name: "1458, Albertsons, COTTAGE GROVE, OR",
            disabled: false,
          },
          {
            name: "1458, Target, SPRING, TX",
            disabled: false,
          },
          {
            name: "1458, Walmart, FORT OGLETHORPE, GA",
            disabled: false,
          },
          {
            name: "1459, Albertsons, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "1459, CVS, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1459, Rite Aid, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "1459, Target, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "1459, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "146, ADUSA, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "146, ADUSA, PRINCE FREDERICK, MD",
            disabled: false,
          },
          {
            name: "146, CVS, EAST ISLIP, NY",
            disabled: false,
          },
          {
            name: "146, Costco, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "146, Kroger, Fort Collins, CO",
            disabled: false,
          },
          {
            name: "146, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "146, Meijer, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "146, Target, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "146, Walmart, GILMER, TX",
            disabled: false,
          },
          {
            name: "1460, ADUSA, MADISON, NC",
            disabled: false,
          },
          {
            name: "1460, Albertsons, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "1460, Target, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "1460, Walmart, HASTINGS, NE",
            disabled: false,
          },
          {
            name: "1461, ADUSA, SPRING HOPE, NC",
            disabled: false,
          },
          {
            name: "1461, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "1461, CVS, BURTONSVILLE, MD",
            disabled: false,
          },
          {
            name: "1461, Target, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "1461, Walmart, ROCK SPRINGS, WY",
            disabled: false,
          },
          {
            name: "1462, ADUSA, CHOCOWINITY, NC",
            disabled: false,
          },
          {
            name: "1462, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1462, Walmart, GREENVILLE, AL",
            disabled: false,
          },
          {
            name: "1463, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1463, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "1463, CVS, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1463, Target, BOARDMAN, OH",
            disabled: false,
          },
          {
            name: "1463, Walmart, XENIA, OH",
            disabled: false,
          },
          {
            name: "1464, Albertsons, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "1464, CVS, FRANKLIN, OH",
            disabled: false,
          },
          {
            name: "1464, Target, PHILLIPSBURG, NJ",
            disabled: false,
          },
          {
            name: "1464, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1465, ADUSA, MOUNT AIRY, MD",
            disabled: false,
          },
          {
            name: "1465, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1465, Target, NOVI, MI",
            disabled: false,
          },
          {
            name: "1465, Walmart, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "1466, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1466, Target, SHELBY TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "1466, Walmart, JACKSBORO, TN",
            disabled: false,
          },
          {
            name: "1467, ADUSA, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "1467, Albertsons, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "1467, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "1467, Target, CLARK, NJ",
            disabled: false,
          },
          {
            name: "1467, Walmart, JAMESTOWN, TN",
            disabled: false,
          },
          {
            name: "1468, Rite Aid, ROCKFORD, MI",
            disabled: false,
          },
          {
            name: "1468, Target, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "1468, Walmart, BATESVILLE, MS",
            disabled: false,
          },
          {
            name: "1469, Albertsons, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1469, CVS, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "1469, Target, MONROE, LA",
            disabled: false,
          },
          {
            name: "1469, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "147, ADUSA, FORT WASHINGTON, MD",
            disabled: false,
          },
          {
            name: "147, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "147, BJ's, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "147, CVS, HAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "147, Costco, FOSTER CITY, CA",
            disabled: false,
          },
          {
            name: "147, Kroger, Falcon, CO",
            disabled: false,
          },
          {
            name: "147, Kroger, Valencia, CA",
            disabled: false,
          },
          {
            name: "147, Kroger, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "147, Meijer, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "147, Target, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "147, Walmart, DENISON, TX",
            disabled: false,
          },
          {
            name: "1470, Albertsons, COEUR D ALENE, ID",
            disabled: false,
          },
          {
            name: "1470, Albertsons, COEUR D'ALENE, ID",
            disabled: false,
          },
          {
            name: "1470, CVS, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "1470, Target, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "1470, Walmart, WILLMAR, MN",
            disabled: false,
          },
          {
            name: "1471, ADUSA, DUMFRIES, VA",
            disabled: false,
          },
          {
            name: "1471, Albertsons, MAPLE VALLEY, WA",
            disabled: false,
          },
          {
            name: "1471, CVS, WALDORF, MD",
            disabled: false,
          },
          {
            name: "1471, Target, AURORA, CO",
            disabled: false,
          },
          {
            name: "1471, Walmart, NEW LONDON, WI",
            disabled: false,
          },
          {
            name: "1472, ADUSA, GLOUCESTER, VA",
            disabled: false,
          },
          {
            name: "1472, Albertsons, MOUNT VERNON, WA",
            disabled: false,
          },
          {
            name: "1472, Rite Aid, JENISON, MI",
            disabled: false,
          },
          {
            name: "1472, Target, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "1472, Walmart, HASTINGS, MN",
            disabled: false,
          },
          {
            name: "1473, ADUSA, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "1473, Albertsons, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "1473, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1473, Target, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "1473, Walmart, MANKATO, MN",
            disabled: false,
          },
          {
            name: "1474, ADUSA, ODENTON, MD",
            disabled: false,
          },
          {
            name: "1474, Albertsons, FORT MOHAVE, AZ",
            disabled: false,
          },
          {
            name: "1474, Rite Aid, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "1474, Target, DICKSON CITY, PA",
            disabled: false,
          },
          {
            name: "1474, Walmart, YUMA, AZ",
            disabled: false,
          },
          {
            name: "1475, ADUSA, SUMTER, SC",
            disabled: false,
          },
          {
            name: "1475, CVS, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "1475, Target, LIVERPOOL, NY",
            disabled: false,
          },
          {
            name: "1475, Walmart, WASHINGTON, IA",
            disabled: false,
          },
          {
            name: "1476, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1476, CVS, FORESTVILLE, MD",
            disabled: false,
          },
          {
            name: "1476, Target, FAYETTEVILLE, NY",
            disabled: false,
          },
          {
            name: "1476, Walmart, CLARKSVILLE, IN",
            disabled: false,
          },
          {
            name: "1477, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1477, CVS, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1477, Target, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "1477, Walmart, SUMMERSVILLE, WV",
            disabled: false,
          },
          {
            name: "1478, Albertsons, TIGARD, OR",
            disabled: false,
          },
          {
            name: "1478, Rite Aid, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "1478, Target, BARBOURSVILLE, WV",
            disabled: false,
          },
          {
            name: "1478, Walmart, SOUTH POINT, OH",
            disabled: false,
          },
          {
            name: "1479, Albertsons, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "1479, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "1479, Walgreens, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "1479, Walmart, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "148, Albertsons, LA MIRADA, CA",
            disabled: false,
          },
          {
            name: "148, BJ's, MONROE, NY",
            disabled: false,
          },
          {
            name: "148, CVS, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "148, Costco, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "148, Meijer, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "148, Walmart, PARIS, TX",
            disabled: false,
          },
          {
            name: "1480, ADUSA, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "1480, Albertsons, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "1480, Target, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "1480, Walmart, WINCHESTER, IN",
            disabled: false,
          },
          {
            name: "1481, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1481, Albertsons, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1481, CVS, WALDORF, MD",
            disabled: false,
          },
          {
            name: "1481, Target, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "1481, Walmart, HOMEWOOD, AL",
            disabled: false,
          },
          {
            name: "1482, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1482, Albertsons, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1482, CVS, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "1482, Target, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "1482, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "1483, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1483, CVS, TIBURON, CA",
            disabled: false,
          },
          {
            name: "1483, Target, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "1483, Walmart, YANKTON, SD",
            disabled: false,
          },
          {
            name: "1484, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1484, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "1484, CVS, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1484, Target, LAKEVILLE, MN",
            disabled: false,
          },
          {
            name: "1484, Walgreens, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "1485, Albertsons, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "1485, Target, SANTEE, CA",
            disabled: false,
          },
          {
            name: "1485, Walmart, GILLETTE, WY",
            disabled: false,
          },
          {
            name: "1486, Albertsons, HELENA, MT",
            disabled: false,
          },
          {
            name: "1486, CVS, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1486, Target, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1486, Walmart, FARMVILLE, VA",
            disabled: false,
          },
          {
            name: "1487, Albertsons, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "1487, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "1487, Target, MISSION, KS",
            disabled: false,
          },
          {
            name: "1487, Walmart, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "1488, CVS, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "1488, Walmart, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "1489, Albertsons, THE DALLES, OR",
            disabled: false,
          },
          {
            name: "1489, CVS, LANDOVER, MD",
            disabled: false,
          },
          {
            name: "1489, Target, GARLAND, TX",
            disabled: false,
          },
          {
            name: "1489, Walmart, VERNON HILLS, IL",
            disabled: false,
          },
          {
            name: "149, ADUSA, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "149, Albertsons, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "149, Costco, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "149, Kroger, CLUTE, TX",
            disabled: false,
          },
          {
            name: "149, Kroger, LAYTON, UT",
            disabled: false,
          },
          {
            name: "149, Meijer, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "149, Rite Aid, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "149, Walmart, JONESBORO, LA",
            disabled: false,
          },
          {
            name: "1490, ADUSA, CORNELIUS, NC",
            disabled: false,
          },
          {
            name: "1490, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1490, Rite Aid, EDGEWOOD, MD",
            disabled: false,
          },
          {
            name: "1490, Target, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "1490, Walmart, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "1491, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1491, CVS, CLINTON, MD",
            disabled: false,
          },
          {
            name: "1491, Target, EAST HANOVER, NJ",
            disabled: false,
          },
          {
            name: "1491, Walmart, INDIANOLA, IA",
            disabled: false,
          },
          {
            name: "1492, ADUSA, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "1492, Albertsons, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "1492, CVS, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1492, Target, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "1492, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "1493, ADUSA, MOUNTAIN CITY, TN",
            disabled: false,
          },
          {
            name: "1493, Albertsons, SEATAC, WA",
            disabled: false,
          },
          {
            name: "1493, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1493, Target, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "1493, Walmart, MONROEVILLE, AL",
            disabled: false,
          },
          {
            name: "1494, ADUSA, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "1494, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1494, CVS, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "1494, Rite Aid, NORTHERN CAMBRIA, PA",
            disabled: false,
          },
          {
            name: "1494, Walmart, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "1495, ADUSA, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "1495, Albertsons, CENTRALIA, WA",
            disabled: false,
          },
          {
            name: "1495, CVS, BELTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1495, Target, KINGSTON, MA",
            disabled: false,
          },
          {
            name: "1495, Walmart, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "1496, ADUSA, APEX, NC",
            disabled: false,
          },
          {
            name: "1496, CVS, CAMP SPRINGS, MD",
            disabled: false,
          },
          {
            name: "1496, Rite Aid, OIL CITY, PA",
            disabled: false,
          },
          {
            name: "1496, Target, WESTBOROUGH, MA",
            disabled: false,
          },
          {
            name: "1496, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1496, Walmart, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "1497, ADUSA, CHURCH HILL, TN",
            disabled: false,
          },
          {
            name: "1497, Albertsons, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "1497, CVS, LEXINGTON PARK, MD",
            disabled: false,
          },
          {
            name: "1497, Target, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "1497, Walgreens, PLYMOUTH, WI",
            disabled: false,
          },
          {
            name: "1497, Walmart, RICHTON PARK, IL",
            disabled: false,
          },
          {
            name: "1498, CVS, LAUREL, MD",
            disabled: false,
          },
          {
            name: "1498, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1499, ADUSA, JOHNS ISLAND, SC",
            disabled: false,
          },
          {
            name: "1499, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1499, Target, OPELIKA, AL",
            disabled: false,
          },
          {
            name: "1499, Walmart, LEWISBURG, WV",
            disabled: false,
          },
          {
            name: "15, ADUSA, NORTH VERSAILLES, PA",
            disabled: false,
          },
          {
            name: "15, ADUSA, SWAMPSCOTT, MA",
            disabled: false,
          },
          {
            name: "15, Albertsons, WOLF POINT, MT",
            disabled: false,
          },
          {
            name: "15, BJ's, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "15, CVS, IRVING, TX",
            disabled: false,
          },
          {
            name: "15, Kroger, Gilbert, AZ",
            disabled: false,
          },
          {
            name: "15, Kroger, Independence, KY",
            disabled: false,
          },
          {
            name: "15, Kroger, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "15, Kroger, Osgood, IN",
            disabled: false,
          },
          {
            name: "15, Kroger, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "15, Walmart, WEST PLAINS, MO",
            disabled: false,
          },
          {
            name: "150, ADUSA, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "150, BJ's, CONYERS, GA",
            disabled: false,
          },
          {
            name: "150, Kroger, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "150, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "150, Meijer, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "150, Walmart, WOODWARD, OK",
            disabled: false,
          },
          {
            name: "1500, Albertsons, KIHEI, HI",
            disabled: false,
          },
          {
            name: "1500, CVS, DAMASCUS, MD",
            disabled: false,
          },
          {
            name: "1500, Rite Aid, DEPEW, NY",
            disabled: false,
          },
          {
            name: "1500, Target, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "1500, Walmart, WATERTOWN, SD",
            disabled: false,
          },
          {
            name: "15000, Walgreens, LINCOLN PARK, NJ",
            disabled: false,
          },
          {
            name: "15001, Walgreens, ROSLINDALE, MA",
            disabled: false,
          },
          {
            name: "15003, Walgreens, CONCORD, CA",
            disabled: false,
          },
          {
            name: "15007, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "1501, ADUSA, TARBORO, NC",
            disabled: false,
          },
          {
            name: "1501, CVS, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1501, Target, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1501, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "15010, Walgreens, IRVINGTON, NJ",
            disabled: false,
          },
          {
            name: "15012, Walgreens, WILLIS, TX",
            disabled: false,
          },
          {
            name: "15013, Walgreens, SOUTH OGDEN, UT",
            disabled: false,
          },
          {
            name: "15017, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "15019, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1502, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1502, Albertsons, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "1502, CVS, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1502, Target, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "1502, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1502, Walmart, ROANOKE RAPIDS, NC",
            disabled: false,
          },
          {
            name: "15020, Walgreens, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "15022, Walgreens, STEAMBOAT SPRINGS, CO",
            disabled: false,
          },
          {
            name: "15024, Walgreens, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1503, ADUSA, BOONE, NC",
            disabled: false,
          },
          {
            name: "1503, Albertsons, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "1503, CVS, MIDDLETOWN, MD",
            disabled: false,
          },
          {
            name: "1503, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1503, Walmart, DAYTON, OH",
            disabled: false,
          },
          {
            name: "15032, Walgreens, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "15033, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "15036, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1504, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "1504, Albertsons, BEND, OR",
            disabled: false,
          },
          {
            name: "1504, CVS, DERWOOD, MD",
            disabled: false,
          },
          {
            name: "1504, Target, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "1504, Walgreens, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "1504, Walmart, DAYTON, OH",
            disabled: false,
          },
          {
            name: "1505, ADUSA, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "1505, Albertsons, GILROY, CA",
            disabled: false,
          },
          {
            name: "1505, Target, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "1505, Walmart, PIKEVILLE, KY",
            disabled: false,
          },
          {
            name: "15054, Walgreens, MOUNTAIN VIEW, MO",
            disabled: false,
          },
          {
            name: "1506, CVS, SEAT PLEASANT, MD",
            disabled: false,
          },
          {
            name: "1506, Target, ODESSA, TX",
            disabled: false,
          },
          {
            name: "1506, Walmart, MANCHESTER, IA",
            disabled: false,
          },
          {
            name: "15065, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "15066, Walgreens, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "15067, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1507, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1507, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1507, Target, RICHMOND, CA",
            disabled: false,
          },
          {
            name: "1507, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "15070, Walgreens, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "15071, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "15072, Walgreens, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "15078, Walgreens, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "15079, Walgreens, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "1508, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1508, Target, ITHACA, NY",
            disabled: false,
          },
          {
            name: "1508, Walmart, SHERIDAN, WY",
            disabled: false,
          },
          {
            name: "15080, Walgreens, BURBANK, IL",
            disabled: false,
          },
          {
            name: "15085, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "15087, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1509, Albertsons, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "1509, CVS, WALKERSVILLE, MD",
            disabled: false,
          },
          {
            name: "1509, Target, SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "1509, Walmart, MAQUOKETA, IA",
            disabled: false,
          },
          {
            name: "15092, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "15097, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "15099, Walgreens, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "151, BJ's, GARNER, NC",
            disabled: false,
          },
          {
            name: "151, Kroger, Colorado Springs, CO",
            disabled: false,
          },
          {
            name: "151, Meijer, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "151, Target, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "151, Walmart, MCALESTER, OK",
            disabled: false,
          },
          {
            name: "1510, Albertsons, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "1510, CVS, SEVERN, MD",
            disabled: false,
          },
          {
            name: "1510, Target, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "1510, Walmart, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "15101, Walgreens, AVON, CO",
            disabled: false,
          },
          {
            name: "15104, Walgreens, LARCHMONT, NY",
            disabled: false,
          },
          {
            name: "15109, Walgreens, JEFFERSON, LA",
            disabled: false,
          },
          {
            name: "1511, ADUSA, CHAPIN, SC",
            disabled: false,
          },
          {
            name: "1511, Albertsons, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "1511, CVS, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "1511, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1511, Target, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "1511, Walmart, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "15110, Walgreens, KINGS MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "15112, Walgreens, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "15115, Walgreens, WAILUKU, HI",
            disabled: false,
          },
          {
            name: "15116, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "15117, Walgreens, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "15118, Walgreens, UNIONDALE, NY",
            disabled: false,
          },
          {
            name: "1512, ADUSA, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "1512, Target, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "1512, Walgreens, GERMANTOWN, TN",
            disabled: false,
          },
          {
            name: "1512, Walmart, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "15121, Walgreens, HUDSON, WI",
            disabled: false,
          },
          {
            name: "15123, Walgreens, ARDEN HILLS, MN",
            disabled: false,
          },
          {
            name: "15124, Walgreens, BUFFALO, MN",
            disabled: false,
          },
          {
            name: "15127, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "15129, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "1513, ADUSA, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "1513, Albertsons, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1513, CVS, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1513, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "1513, Walmart, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "15130, Walgreens, COCKEYSVILLE, MD",
            disabled: false,
          },
          {
            name: "15136, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "15137, Walgreens, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "15138, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "1514, ADUSA, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "1514, CVS, COLMAR MANOR, MD",
            disabled: false,
          },
          {
            name: "1514, Rite Aid, CALIFORNIA, PA",
            disabled: false,
          },
          {
            name: "1514, Target, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "1514, Walmart, ARNOLD, MO",
            disabled: false,
          },
          {
            name: "15140, Walgreens, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "15141, Walgreens, ODESSA, TX",
            disabled: false,
          },
          {
            name: "15144, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "15146, Walgreens, EWA BEACH, HI",
            disabled: false,
          },
          {
            name: "15149, Walgreens, DULUTH, MN",
            disabled: false,
          },
          {
            name: "1515, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1515, CVS, LEONARDTOWN, MD",
            disabled: false,
          },
          {
            name: "1515, Target, Saint Louis, MO",
            disabled: false,
          },
          {
            name: "1515, Walgreens, LOVES PARK, IL",
            disabled: false,
          },
          {
            name: "1515, Walmart, GERMANTOWN, WI",
            disabled: false,
          },
          {
            name: "15150, Walgreens, MOUND, MN",
            disabled: false,
          },
          {
            name: "15151, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "15152, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "15154, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "15155, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "15156, Walgreens, KYLE, TX",
            disabled: false,
          },
          {
            name: "15158, Walgreens, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "1516, Albertsons, KEIZER, OR",
            disabled: false,
          },
          {
            name: "1516, CVS, SEABROOK, MD",
            disabled: false,
          },
          {
            name: "1516, Target, MARLBOROUGH, MA",
            disabled: false,
          },
          {
            name: "1516, Walmart, BORGER, TX",
            disabled: false,
          },
          {
            name: "15160, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "15163, Walgreens, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "15164, Walgreens, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "15169, Walgreens, MAHOMET, IL",
            disabled: false,
          },
          {
            name: "1517, Albertsons, FALLON, NV",
            disabled: false,
          },
          {
            name: "1517, Rite Aid, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "1517, Target, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "1517, Walmart, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "1518, ADUSA, RURAL HALL, NC",
            disabled: false,
          },
          {
            name: "1518, Albertsons, MCHENRY, IL",
            disabled: false,
          },
          {
            name: "1518, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1518, Walgreens, CROSBY, TX",
            disabled: false,
          },
          {
            name: "1518, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "15180, Walgreens, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "15181, Walgreens, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "15182, Walgreens, COVINGTON, KY",
            disabled: false,
          },
          {
            name: "15183, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "15185, Walgreens, LAUREL, MD",
            disabled: false,
          },
          {
            name: "15186, Walgreens, MATAWAN, NJ",
            disabled: false,
          },
          {
            name: "15187, Walgreens, ABILENE, TX",
            disabled: false,
          },
          {
            name: "15188, Walgreens, SHOREWOOD, WI",
            disabled: false,
          },
          {
            name: "15189, Walgreens, CHARLES TOWN, WV",
            disabled: false,
          },
          {
            name: "1519, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1519, Target, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "1519, Walmart, JACKSON, OH",
            disabled: false,
          },
          {
            name: "15192, Walgreens, MADEIRA BEACH, FL",
            disabled: false,
          },
          {
            name: "15197, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "15199, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "152, BJ's, EAST POINT, GA",
            disabled: false,
          },
          {
            name: "152, Meijer, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "152, Target, RACINE, WI",
            disabled: false,
          },
          {
            name: "152, Walmart, DE SOTO, MO",
            disabled: false,
          },
          {
            name: "1520, CVS, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "1520, Target, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "1520, Walmart, ABERDEEN, SD",
            disabled: false,
          },
          {
            name: "15200, Walgreens, GRETNA, LA",
            disabled: false,
          },
          {
            name: "15202, Walgreens, PALMVIEW, TX",
            disabled: false,
          },
          {
            name: "15203, Walgreens, MAPLE VALLEY, WA",
            disabled: false,
          },
          {
            name: "15205, Walgreens, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "15206, Walgreens, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "15207, Walgreens, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "15208, Walgreens, WELLINGTON, FL",
            disabled: false,
          },
          {
            name: "15209, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "1521, Albertsons, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "1521, CVS, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1521, Target, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "1521, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "15211, Walgreens, WILMETTE, IL",
            disabled: false,
          },
          {
            name: "15212, Walgreens, CHAPPAQUA, NY",
            disabled: false,
          },
          {
            name: "1522, Albertsons, ARLINGTON, WA",
            disabled: false,
          },
          {
            name: "1522, CVS, CALIFORNIA, MD",
            disabled: false,
          },
          {
            name: "1522, Target, RED WING, MN",
            disabled: false,
          },
          {
            name: "1522, Walmart, ELKINS, WV",
            disabled: false,
          },
          {
            name: "1523, ADUSA, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "1523, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1523, Target, BALCONES HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "1523, Walmart, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "15236, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "15237, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "15239, Walgreens, NEWPORT, OR",
            disabled: false,
          },
          {
            name: "1524, Albertsons, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "1524, CVS, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1524, Rite Aid, FREMONT, MI",
            disabled: false,
          },
          {
            name: "1524, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1524, Walmart, CHESTER, VA",
            disabled: false,
          },
          {
            name: "15243, Walgreens, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "15246, Walgreens, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "15248, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "15249, Walgreens, QUINCY, IL",
            disabled: false,
          },
          {
            name: "1525, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1525, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1525, Rite Aid, GRANT, MI",
            disabled: false,
          },
          {
            name: "1525, Target, SILVERTHORNE, CO",
            disabled: false,
          },
          {
            name: "1525, Walmart, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "15250, Walgreens, MADISON, MS",
            disabled: false,
          },
          {
            name: "15251, Walgreens, AHOSKIE, NC",
            disabled: false,
          },
          {
            name: "15252, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "15253, Walgreens, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "1526, Albertsons, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "1526, CVS, POMONA, NJ",
            disabled: false,
          },
          {
            name: "1526, Rite Aid, CEDAR SPRINGS, MI",
            disabled: false,
          },
          {
            name: "1526, Target, MANTECA, CA",
            disabled: false,
          },
          {
            name: "1526, Walmart, STORM LAKE, IA",
            disabled: false,
          },
          {
            name: "15260, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "15261, Walgreens, ANTIOCH, IL",
            disabled: false,
          },
          {
            name: "1527, Albertsons, STAYTON, OR",
            disabled: false,
          },
          {
            name: "1527, CVS, WESLEY CHAPEL, FL",
            disabled: false,
          },
          {
            name: "1527, Rite Aid, GREENVILLE, MI",
            disabled: false,
          },
          {
            name: "1527, Target, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "1527, Walmart, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "15272, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "15273, Walgreens, ELIZABETHTOWN, NC",
            disabled: false,
          },
          {
            name: "15274, Walgreens, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "15278, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "1528, ADUSA, HARRINGTON, DE",
            disabled: false,
          },
          {
            name: "1528, Albertsons, NORTH BEND, WA",
            disabled: false,
          },
          {
            name: "1528, Rite Aid, CARSON CITY, MI",
            disabled: false,
          },
          {
            name: "1528, Target, BETHEL, CT",
            disabled: false,
          },
          {
            name: "1528, Walmart, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "15284, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "15287, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "15289, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "1529, Rite Aid, LOWELL, MI",
            disabled: false,
          },
          {
            name: "1529, Target, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "1529, Walmart, YORK, PA",
            disabled: false,
          },
          {
            name: "15290, Walgreens, OGDEN, UT",
            disabled: false,
          },
          {
            name: "15291, Walgreens, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "153, BJ's, VOORHEES, NJ",
            disabled: false,
          },
          {
            name: "153, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "153, Kroger, Happy Valley, OR",
            disabled: false,
          },
          {
            name: "153, Kroger, SANDY, UT",
            disabled: false,
          },
          {
            name: "153, Meijer, MARION, IN",
            disabled: false,
          },
          {
            name: "153, ShopRite, NORTHVALE, NJ",
            disabled: false,
          },
          {
            name: "153, Walmart, NEW ALBANY, MS",
            disabled: false,
          },
          {
            name: "1530, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "1530, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1530, Rite Aid, GRAND LEDGE, MI",
            disabled: false,
          },
          {
            name: "1530, Target, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "1530, Walmart, CLEVELAND, MS",
            disabled: false,
          },
          {
            name: "1531, ADUSA, LOVINGSTON, VA",
            disabled: false,
          },
          {
            name: "1531, Albertsons, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "1531, CVS, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "1531, Target, WACO, TX",
            disabled: false,
          },
          {
            name: "1531, Walgreens, BLACKWOOD, NJ",
            disabled: false,
          },
          {
            name: "1531, Walmart, CARPENTERSVILLE, IL",
            disabled: false,
          },
          {
            name: "15318, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1532, Albertsons, ELIZABETH, CO",
            disabled: false,
          },
          {
            name: "1532, Rite Aid, CALEDONIA, MI",
            disabled: false,
          },
          {
            name: "1532, Target, NASHUA, NH",
            disabled: false,
          },
          {
            name: "1532, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "1533, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "1533, Albertsons, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "1533, Target, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1533, Walmart, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "15330, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "15332, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "15333, Walgreens, HEPHZIBAH, GA",
            disabled: false,
          },
          {
            name: "15334, Walgreens, CARMEL, IN",
            disabled: false,
          },
          {
            name: "15338, Walgreens, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "15339, Walgreens, MAGNOLIA, TX",
            disabled: false,
          },
          {
            name: "1534, Albertsons, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "1534, CVS, HIGHLAND SPRINGS, VA",
            disabled: false,
          },
          {
            name: "1534, Rite Aid, ALLEGAN, MI",
            disabled: false,
          },
          {
            name: "1534, Target, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "1534, Walmart, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "15344, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1535, Albertsons, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "1535, Target, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "1535, Walmart, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "15350, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1536, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1536, Albertsons, PAYSON, AZ",
            disabled: false,
          },
          {
            name: "1536, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1536, Target, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "1536, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "1536, Walmart, ST PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "15361, Walgreens, PINE BLUFF, AR",
            disabled: false,
          },
          {
            name: "15362, Walgreens, EAGLE RIVER, AK",
            disabled: false,
          },
          {
            name: "15363, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "15364, Walgreens, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "15365, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "15366, Walgreens, PORT ALLEN, LA",
            disabled: false,
          },
          {
            name: "15368, Walgreens, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "15369, Walgreens, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "1537, ADUSA, FOREST, VA",
            disabled: false,
          },
          {
            name: "1537, Albertsons, ZEPHYR COVE, NV",
            disabled: false,
          },
          {
            name: "1537, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1537, Rite Aid, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "1537, Target, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "1537, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "1537, Walmart, GETTYSBURG, PA",
            disabled: false,
          },
          {
            name: "15371, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1538, Albertsons, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "1538, Target, BELTON, MO",
            disabled: false,
          },
          {
            name: "1538, Walmart, BROOKINGS, SD",
            disabled: false,
          },
          {
            name: "15381, Walgreens, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "1539, Albertsons, PASADENA, MD",
            disabled: false,
          },
          {
            name: "1539, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "1539, Target, SHILOH, IL",
            disabled: false,
          },
          {
            name: "1539, Walmart, ONTARIO, OH",
            disabled: false,
          },
          {
            name: "15391, Walgreens, BIRMINGHAM, MI",
            disabled: false,
          },
          {
            name: "15392, Walgreens, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "15394, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "15395, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "15398, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "154, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "154, BJ's, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "154, CVS, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "154, Kroger, IRVINE, CA",
            disabled: false,
          },
          {
            name: "154, Meijer, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "154, Target, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "154, Walmart, ABINGDON, VA",
            disabled: false,
          },
          {
            name: "1540, ADUSA, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "1540, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1540, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "1540, Target, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "1540, Walmart, SOUTH HAVEN, MI",
            disabled: false,
          },
          {
            name: "15402, Walgreens, MINDEN, LA",
            disabled: false,
          },
          {
            name: "15403, Walgreens, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "15404, Walgreens, EDMONDS, WA",
            disabled: false,
          },
          {
            name: "1541, Albertsons, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "1541, Target, PIKESVILLE, MD",
            disabled: false,
          },
          {
            name: "1541, Walmart, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "1542, ADUSA, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "1542, CVS, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "1542, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1542, Walmart, GAYLORD, MI",
            disabled: false,
          },
          {
            name: "1543, Albertsons, CAVE CREEK, AZ",
            disabled: false,
          },
          {
            name: "1543, CVS, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "1543, Rite Aid, CRESSON, PA",
            disabled: false,
          },
          {
            name: "1543, Target, OLATHE, KS",
            disabled: false,
          },
          {
            name: "1543, Walmart, SPEARFISH, SD",
            disabled: false,
          },
          {
            name: "15432, Walgreens, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "15433, Walgreens, HOLLISTER, CA",
            disabled: false,
          },
          {
            name: "15434, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "15436, Walgreens, WINDERMERE, FL",
            disabled: false,
          },
          {
            name: "15439, Walgreens, CLOQUET, MN",
            disabled: false,
          },
          {
            name: "1544, ADUSA, CARRBORO, NC",
            disabled: false,
          },
          {
            name: "1544, Albertsons, EPHRATA, WA",
            disabled: false,
          },
          {
            name: "1544, CVS, WESTERLY, RI",
            disabled: false,
          },
          {
            name: "1544, Target, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "1544, Walmart, CLARKSBURG, WV",
            disabled: false,
          },
          {
            name: "15440, Walgreens, JAMESTOWN, NC",
            disabled: false,
          },
          {
            name: "15442, Walgreens, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "15445, Walgreens, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "15446, Walgreens, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "15447, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1545, Target, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "1545, Walmart, GRAND FORKS, ND",
            disabled: false,
          },
          {
            name: "1546, Albertsons, ABERDEEN, WA",
            disabled: false,
          },
          {
            name: "1546, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1546, Target, EAST POINT, GA",
            disabled: false,
          },
          {
            name: "1546, Walmart, IOWA FALLS, IA",
            disabled: false,
          },
          {
            name: "15461, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "15464, Walgreens, PLAISTOW, NH",
            disabled: false,
          },
          {
            name: "15466, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "15467, Walgreens, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "1547, ADUSA, EDGEWOOD, MD",
            disabled: false,
          },
          {
            name: "1547, Albertsons, BURLINGAME, CA",
            disabled: false,
          },
          {
            name: "1547, CVS, CHESTERFIELD, VA",
            disabled: false,
          },
          {
            name: "1547, Target, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "1547, Walmart, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "15471, Walgreens, WHEATON, IL",
            disabled: false,
          },
          {
            name: "15474, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "15475, Walgreens, TARBORO, NC",
            disabled: false,
          },
          {
            name: "1548, ADUSA, RUSTBURG, VA",
            disabled: false,
          },
          {
            name: "1548, Albertsons, LONE TREE, CO",
            disabled: false,
          },
          {
            name: "1548, Rite Aid, NEW BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "1548, Target, CORONA, CA",
            disabled: false,
          },
          {
            name: "1548, Walmart, WATSEKA, IL",
            disabled: false,
          },
          {
            name: "15480, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "15482, Walgreens, BARTLETT, IL",
            disabled: false,
          },
          {
            name: "15484, Walgreens, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "15485, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "15487, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "15488, Walgreens, FRANKLIN, NJ",
            disabled: false,
          },
          {
            name: "1549, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1549, CVS, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "1549, Rite Aid, PORTAGE, PA",
            disabled: false,
          },
          {
            name: "1549, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "15495, Walgreens, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "15499, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "155, ADUSA, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "155, Albertsons, ELKO, NV",
            disabled: false,
          },
          {
            name: "155, Meijer, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "155, Walmart, SENATOBIA, MS",
            disabled: false,
          },
          {
            name: "1550, ADUSA, WALLACE, NC",
            disabled: false,
          },
          {
            name: "1550, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1550, CVS, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "1550, Walmart, GUNNISON, CO",
            disabled: false,
          },
          {
            name: "15501, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "15502, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "15507, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1551, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1551, CVS, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1551, Rite Aid, BRIDGEPORT, MI",
            disabled: false,
          },
          {
            name: "1551, Walmart, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "15511, Walgreens, KINSTON, NC",
            disabled: false,
          },
          {
            name: "15512, Walgreens, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "15518, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "15519, Walgreens, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "1552, ADUSA, CONCORD, NC",
            disabled: false,
          },
          {
            name: "1552, Albertsons, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "1552, CVS, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "1552, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "1552, Walmart, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "1553, Albertsons, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "1553, CVS, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "1553, Walmart, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "15531, Walgreens, WAIPAHU, HI",
            disabled: false,
          },
          {
            name: "15533, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "15535, Walgreens, HASTINGS, MI",
            disabled: false,
          },
          {
            name: "15538, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "1554, Albertsons, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "1554, CVS, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1554, Walmart, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "15542, Walgreens, NEW CANEY, TX",
            disabled: false,
          },
          {
            name: "15545, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "15546, Walgreens, HOUMA, LA",
            disabled: false,
          },
          {
            name: "1555, ADUSA, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "1555, Albertsons, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "1555, CVS, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1555, Walmart, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "15552, Walgreens, GARNER, NC",
            disabled: false,
          },
          {
            name: "15553, Walgreens, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "15556, Walgreens, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "15557, Walgreens, RED BANK, NJ",
            disabled: false,
          },
          {
            name: "15558, Walgreens, ROBBINSVILLE, NJ",
            disabled: false,
          },
          {
            name: "1556, Albertsons, COOS BAY, OR",
            disabled: false,
          },
          {
            name: "1556, Walmart, ORLAND HILLS, IL",
            disabled: false,
          },
          {
            name: "15560, Walgreens, ROSEVILLE, MN",
            disabled: false,
          },
          {
            name: "15561, Walgreens, RICHMOND, KY",
            disabled: false,
          },
          {
            name: "15562, Walgreens, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "15568, Walgreens, CONOVER, NC",
            disabled: false,
          },
          {
            name: "1557, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1557, Albertsons, NORTH BEND, OR",
            disabled: false,
          },
          {
            name: "1557, CVS, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "1557, Walmart, FISHERS, IN",
            disabled: false,
          },
          {
            name: "15571, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1558, ADUSA, ELKTON, MD",
            disabled: false,
          },
          {
            name: "1558, Albertsons, LEBANON, OR",
            disabled: false,
          },
          {
            name: "1558, Walmart, EDEN, NC",
            disabled: false,
          },
          {
            name: "15586, Walgreens, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "15587, Walgreens, FRANKLIN, LA",
            disabled: false,
          },
          {
            name: "1559, ADUSA, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "1559, Albertsons, MIDDLETOWN, MD",
            disabled: false,
          },
          {
            name: "1559, CVS, FARMVILLE, VA",
            disabled: false,
          },
          {
            name: "1559, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "15591, Walgreens, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "15592, Walgreens, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "15593, Walgreens, PATERSON, NJ",
            disabled: false,
          },
          {
            name: "15595, Walgreens, SHORT HILLS, NJ",
            disabled: false,
          },
          {
            name: "156, ADUSA, JEFFERSON, NC",
            disabled: false,
          },
          {
            name: "156, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "156, BJ's, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "156, CVS, LEWISTON, ME",
            disabled: false,
          },
          {
            name: "156, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "156, Kroger, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "156, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "156, Meijer, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "1560, Albertsons, CARMICHAEL, CA",
            disabled: false,
          },
          {
            name: "1560, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "1560, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "15601, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "15603, Walgreens, DEMING, NM",
            disabled: false,
          },
          {
            name: "15607, Walgreens, GRANTS, NM",
            disabled: false,
          },
          {
            name: "15609, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1561, Albertsons, DAVIS, CA",
            disabled: false,
          },
          {
            name: "1561, CVS, EMPORIA, VA",
            disabled: false,
          },
          {
            name: "1561, Rite Aid, TROY, NY",
            disabled: false,
          },
          {
            name: "1561, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "15611, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "15613, Walgreens, MIDFIELD, AL",
            disabled: false,
          },
          {
            name: "15614, Walgreens, ALEXANDER CITY, AL",
            disabled: false,
          },
          {
            name: "15619, Walgreens, GREENACRES, FL",
            disabled: false,
          },
          {
            name: "1562, ADUSA, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "1562, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "1562, Walmart, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "15620, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "15621, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "15623, Walgreens, KEARNS, UT",
            disabled: false,
          },
          {
            name: "1563, ADUSA, CHICKAMAUGA, GA",
            disabled: false,
          },
          {
            name: "1563, Albertsons, RENTON, WA",
            disabled: false,
          },
          {
            name: "1563, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1563, Walmart, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "15630, Walgreens, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "15632, Walgreens, CAMDEN, DE",
            disabled: false,
          },
          {
            name: "15633, Walgreens, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "15635, Walgreens, EVERGREEN PARK, IL",
            disabled: false,
          },
          {
            name: "15637, Walgreens, DE PERE, WI",
            disabled: false,
          },
          {
            name: "15638, Walgreens, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "1564, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "1564, Walmart, NEW BOSTON, OH",
            disabled: false,
          },
          {
            name: "15640, Walgreens, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "15647, Walgreens, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "15648, Walgreens, LAURINBURG, NC",
            disabled: false,
          },
          {
            name: "15649, Walgreens, WHITING, NJ",
            disabled: false,
          },
          {
            name: "1565, ADUSA, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "1565, Albertsons, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1565, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "1565, Walmart, WILLISTON, ND",
            disabled: false,
          },
          {
            name: "15653, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "15654, Walgreens, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1566, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "1566, CVS, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "1566, Rite Aid, GLENOLDEN, PA",
            disabled: false,
          },
          {
            name: "1566, Walmart, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "1567, Rite Aid, BROOMALL, PA",
            disabled: false,
          },
          {
            name: "1567, Walmart, DICKINSON, ND",
            disabled: false,
          },
          {
            name: "15672, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "15673, Walgreens, BAINBRIDGE ISLAND, WA",
            disabled: false,
          },
          {
            name: "15674, Walgreens, BEND, OR",
            disabled: false,
          },
          {
            name: "15675, Walgreens, BEND, OR",
            disabled: false,
          },
          {
            name: "15679, Walgreens, WAYZATA, MN",
            disabled: false,
          },
          {
            name: "1568, ADUSA, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "1568, Albertsons, FRASER, CO",
            disabled: false,
          },
          {
            name: "1568, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "1568, Walmart, HERMITAGE, PA",
            disabled: false,
          },
          {
            name: "15681, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "1569, ADUSA, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "1569, Albertsons, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "1569, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "1569, Walmart, MAYSVILLE, KY",
            disabled: false,
          },
          {
            name: "15690, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "157, Albertsons, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "157, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "157, Meijer, MILFORD, OH",
            disabled: false,
          },
          {
            name: "157, Walmart, SEARCY, AR",
            disabled: false,
          },
          {
            name: "1570, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "1570, Albertsons, RESTON, VA",
            disabled: false,
          },
          {
            name: "1570, CVS, ONLEY, VA",
            disabled: false,
          },
          {
            name: "1570, Rite Aid, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "1570, Walmart, AUBURN, IN",
            disabled: false,
          },
          {
            name: "15703, Walgreens, DANVILLE, AR",
            disabled: false,
          },
          {
            name: "1571, ADUSA, HOPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "1571, Albertsons, BELFAIR, WA",
            disabled: false,
          },
          {
            name: "1571, CVS, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "1571, Walmart, MUKWONAGO, WI",
            disabled: false,
          },
          {
            name: "1572, Albertsons, DUVALL, WA",
            disabled: false,
          },
          {
            name: "1572, Walmart, VERNAL, UT",
            disabled: false,
          },
          {
            name: "1573, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1573, CVS, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "1573, Rite Aid, ESSEXVILLE, MI",
            disabled: false,
          },
          {
            name: "1573, Walmart, PRICE, UT",
            disabled: false,
          },
          {
            name: "15730, Walgreens, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "1574, ADUSA, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "1574, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1574, Rite Aid, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "1574, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1575, CVS, NORTHUMBERLAND, PA",
            disabled: false,
          },
          {
            name: "1575, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "1575, Walmart, OROVILLE, CA",
            disabled: false,
          },
          {
            name: "15751, Walgreens, BARTLESVILLE, OK",
            disabled: false,
          },
          {
            name: "15756, Walgreens, COWETA, OK",
            disabled: false,
          },
          {
            name: "1576, ADUSA, DILLWYN, VA",
            disabled: false,
          },
          {
            name: "1576, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "1576, CVS, BOURNE, MA",
            disabled: false,
          },
          {
            name: "1576, Rite Aid, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "1576, Walmart, SCHERERVILLE, IN",
            disabled: false,
          },
          {
            name: "15762, Walgreens, OWASSO, OK",
            disabled: false,
          },
          {
            name: "15763, Walgreens, PRYOR, OK",
            disabled: false,
          },
          {
            name: "1577, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1577, CVS, SELINSGROVE, PA",
            disabled: false,
          },
          {
            name: "1577, Walmart, BUFFALO, MN",
            disabled: false,
          },
          {
            name: "15770, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15772, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15773, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15777, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "1578, Albertsons, WOODLAND PARK, CO",
            disabled: false,
          },
          {
            name: "1578, Walmart, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "15780, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15782, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15785, Walgreens, MILAN, TN",
            disabled: false,
          },
          {
            name: "15788, Walgreens, BLYTHEVILLE, AR",
            disabled: false,
          },
          {
            name: "1579, Albertsons, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "1579, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "1579, Walmart, OXFORD, NC",
            disabled: false,
          },
          {
            name: "15790, Walgreens, ASHDOWN, AR",
            disabled: false,
          },
          {
            name: "15791, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "15792, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "158, Albertsons, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "158, Kroger, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "158, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "158, Kroger, JUNEAU, AK",
            disabled: false,
          },
          {
            name: "158, Kroger, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "158, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "158, Target, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "158, Walmart, BONHAM, TX",
            disabled: false,
          },
          {
            name: "1580, ADUSA, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "1580, Albertsons, SILVERTON, OR",
            disabled: false,
          },
          {
            name: "1580, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1580, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "15800, Walgreens, DEXTER, MO",
            disabled: false,
          },
          {
            name: "15801, Walgreens, MALDEN, MO",
            disabled: false,
          },
          {
            name: "15809, Walgreens, SAND SPRINGS, OK",
            disabled: false,
          },
          {
            name: "1581, ADUSA, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "1581, Albertsons, DILLON, MT",
            disabled: false,
          },
          {
            name: "1581, Rite Aid, READING, PA",
            disabled: false,
          },
          {
            name: "1581, Walmart, FARGO, ND",
            disabled: false,
          },
          {
            name: "15810, Walgreens, SAPULPA, OK",
            disabled: false,
          },
          {
            name: "15811, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15812, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "15817, Walgreens, WARREN, AR",
            disabled: false,
          },
          {
            name: "1582, Albertsons, BOONTON, NJ",
            disabled: false,
          },
          {
            name: "1582, CVS, DANVILLE, PA",
            disabled: false,
          },
          {
            name: "1583, ADUSA, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "1583, Albertsons, UKIAH, CA",
            disabled: false,
          },
          {
            name: "1583, CVS, SHICKSHINNY, PA",
            disabled: false,
          },
          {
            name: "1583, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1583, Walmart, MADERA, CA",
            disabled: false,
          },
          {
            name: "1584, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1584, Albertsons, WICKENBURG, AZ",
            disabled: false,
          },
          {
            name: "1584, CVS, NANTICOKE, PA",
            disabled: false,
          },
          {
            name: "1584, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1585, ADUSA, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "1585, Albertsons, ORANGE, CA",
            disabled: false,
          },
          {
            name: "1585, CVS, PLYMOUTH, PA",
            disabled: false,
          },
          {
            name: "1585, Walmart, NORTH PLATTE, NE",
            disabled: false,
          },
          {
            name: "15852, Walgreens, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "1586, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1586, CVS, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "1586, Walmart, AUSTELL, GA",
            disabled: false,
          },
          {
            name: "1587, ADUSA, WHITTIER, NC",
            disabled: false,
          },
          {
            name: "1587, CVS, HONESDALE, PA",
            disabled: false,
          },
          {
            name: "1587, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "1587, Walmart, MODESTO, CA",
            disabled: false,
          },
          {
            name: "1588, ADUSA, MARSHALL, VA",
            disabled: false,
          },
          {
            name: "1588, Albertsons, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "1588, CVS, WYOMING, PA",
            disabled: false,
          },
          {
            name: "1588, Walmart, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "1589, Albertsons, LEAVENWORTH, WA",
            disabled: false,
          },
          {
            name: "1589, Rite Aid, SOUTH PARK, PA",
            disabled: false,
          },
          {
            name: "1589, Walmart, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "159, ADUSA, PIKESVILLE, MD",
            disabled: false,
          },
          {
            name: "159, Albertsons, POCATELLO, ID",
            disabled: false,
          },
          {
            name: "159, BJ's, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "159, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "159, Meijer, FAIRFIELD, OH",
            disabled: false,
          },
          {
            name: "159, Rite Aid, NEW WINDSOR, NY",
            disabled: false,
          },
          {
            name: "159, Walmart, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "1590, ADUSA, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "1590, Albertsons, MILTON FREEWATER, OR",
            disabled: false,
          },
          {
            name: "1590, CVS, BLOOMSBURG, PA",
            disabled: false,
          },
          {
            name: "1590, Walmart, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "15900, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "15904, Walgreens, SPRING BRANCH, TX",
            disabled: false,
          },
          {
            name: "15906, Walgreens, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "1591, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1591, Walmart, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "15916, Walgreens, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "1592, Albertsons, KINGS BEACH, CA",
            disabled: false,
          },
          {
            name: "1592, CVS, SUNBURY, PA",
            disabled: false,
          },
          {
            name: "1592, Walmart, BAD AXE, MI",
            disabled: false,
          },
          {
            name: "15927, Walgreens, HAPPY VALLEY, OR",
            disabled: false,
          },
          {
            name: "15928, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "1593, ADUSA, SUNSET BEACH, NC",
            disabled: false,
          },
          {
            name: "1593, Albertsons, GRANDVIEW, WA",
            disabled: false,
          },
          {
            name: "1593, CVS, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "1593, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1593, Walmart, COLDWATER, MI",
            disabled: false,
          },
          {
            name: "15930, Walgreens, SAN FERNANDO, CA",
            disabled: false,
          },
          {
            name: "15931, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "15932, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "15937, Walgreens, READING, PA",
            disabled: false,
          },
          {
            name: "1594, ADUSA, LENOIR, NC",
            disabled: false,
          },
          {
            name: "1594, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "1594, CVS, DALLAS, PA",
            disabled: false,
          },
          {
            name: "1594, Walmart, HEATH, OH",
            disabled: false,
          },
          {
            name: "15941, Walgreens, SAINT ANN, MO",
            disabled: false,
          },
          {
            name: "15942, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "15944, Walgreens, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "15946, Walgreens, LAFAYETTE, CA",
            disabled: false,
          },
          {
            name: "15947, Walgreens, SAN PABLO, CA",
            disabled: false,
          },
          {
            name: "1595, ADUSA, CONWAY, SC",
            disabled: false,
          },
          {
            name: "1595, Walmart, MARYSVILLE, OH",
            disabled: false,
          },
          {
            name: "15951, Walgreens, DEWITT, MI",
            disabled: false,
          },
          {
            name: "1596, Albertsons, GAMBRILLS, MD",
            disabled: false,
          },
          {
            name: "1596, CVS, MIFFLINBURG, PA",
            disabled: false,
          },
          {
            name: "1596, Rite Aid, VOORHEES, NJ",
            disabled: false,
          },
          {
            name: "1596, Walmart, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "15967, Walgreens, DUNCANVILLE, TX",
            disabled: false,
          },
          {
            name: "15968, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "15969, Walgreens, SWAMPSCOTT, MA",
            disabled: false,
          },
          {
            name: "1597, ADUSA, MARION, SC",
            disabled: false,
          },
          {
            name: "1597, CVS, CLARKS SUMMIT, PA",
            disabled: false,
          },
          {
            name: "1597, Rite Aid, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "1597, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "15973, Walgreens, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "15974, Walgreens, CENTRAL POINT, OR",
            disabled: false,
          },
          {
            name: "1598, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "1598, Albertsons, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "1598, CVS, WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "1598, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "15982, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "15983, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "15986, Walgreens, HILMAR, CA",
            disabled: false,
          },
          {
            name: "1599, ADUSA, CONWAY, SC",
            disabled: false,
          },
          {
            name: "1599, Albertsons, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "1599, CVS, BERWICK, PA",
            disabled: false,
          },
          {
            name: "1599, Walmart, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "15993, Walgreens, EAGLE PASS, TX",
            disabled: false,
          },
          {
            name: "15995, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "15997, Walgreens, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "16, ADUSA, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "16, CVS, YOUNGSVILLE, LA",
            disabled: false,
          },
          {
            name: "16, Costco, BOISE, ID",
            disabled: false,
          },
          {
            name: "16, HEB, BURLESON, TX",
            disabled: false,
          },
          {
            name: "16, Kroger, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "16, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "16, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "16, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "16, Kroger, Myrtle Beach, SC",
            disabled: false,
          },
          {
            name: "16, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "16, Walmart, VAN BUREN, AR",
            disabled: false,
          },
          {
            name: "160, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "160, BJ's, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "160, HEB, MATHIS, TX",
            disabled: false,
          },
          {
            name: "160, Kroger, INDIO, CA",
            disabled: false,
          },
          {
            name: "160, Meijer, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "160, ShopRite, PARAMUS, NJ",
            disabled: false,
          },
          {
            name: "160, Walmart, ASH FLAT, AR",
            disabled: false,
          },
          {
            name: "1600, Albertsons, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "1600, CVS, CARBONDALE, PA",
            disabled: false,
          },
          {
            name: "1600, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "1600, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "1600, Walmart, RIDGECREST, CA",
            disabled: false,
          },
          {
            name: "16000, Walgreens, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "1601, Albertsons, MCMINNVILLE, OR",
            disabled: false,
          },
          {
            name: "1601, Walmart, CARMEL, IN",
            disabled: false,
          },
          {
            name: "1602, ADUSA, CHESTERFIELD, VA",
            disabled: false,
          },
          {
            name: "1602, Albertsons, NAMPA, ID",
            disabled: false,
          },
          {
            name: "1602, Walmart, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "16021, Walgreens, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "16025, Walgreens, CLARKSTON, WA",
            disabled: false,
          },
          {
            name: "16026, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "1603, ADUSA, BENTLEYVILLE, PA",
            disabled: false,
          },
          {
            name: "1603, ADUSA, DALTON, GA",
            disabled: false,
          },
          {
            name: "1603, CVS, NORWELL, MA",
            disabled: false,
          },
          {
            name: "1603, Walmart, CHESTER, SC",
            disabled: false,
          },
          {
            name: "16030, Walgreens, PORTLAND, TX",
            disabled: false,
          },
          {
            name: "16031, Walgreens, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "16034, Walgreens, EWING, NJ",
            disabled: false,
          },
          {
            name: "16036, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "1604, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "1604, CVS, LEWISBURG, PA",
            disabled: false,
          },
          {
            name: "1604, Walmart, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "1605, ADUSA, ALLIANCE, OH",
            disabled: false,
          },
          {
            name: "1605, ADUSA, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "1605, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "1605, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "16051, Walgreens, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "16052, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "16057, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "16058, Walgreens, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "16059, Walgreens, SOLDOTNA, AK",
            disabled: false,
          },
          {
            name: "1606, Albertsons, BURKE, VA",
            disabled: false,
          },
          {
            name: "1606, CVS, MILTON, PA",
            disabled: false,
          },
          {
            name: "1606, Walmart, HIXSON, TN",
            disabled: false,
          },
          {
            name: "16061, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "16064, Walgreens, TAPPAN, NY",
            disabled: false,
          },
          {
            name: "16065, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "16067, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1607, ADUSA, CALABASH, NC",
            disabled: false,
          },
          {
            name: "1607, Walmart, LEWISTOWN, PA",
            disabled: false,
          },
          {
            name: "1608, ADUSA, BUTLER, PA",
            disabled: false,
          },
          {
            name: "1608, ADUSA, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "1608, Walmart, RED BLUFF, CA",
            disabled: false,
          },
          {
            name: "16080, Walgreens, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "16082, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "16084, Walgreens, POLSON, MT",
            disabled: false,
          },
          {
            name: "16087, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "16089, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "1609, ADUSA, BUTLER, PA",
            disabled: false,
          },
          {
            name: "1609, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "1609, Albertsons, WISCASSET, ME",
            disabled: false,
          },
          {
            name: "1609, Rite Aid, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "1609, Walmart, GRAND RAPIDS, MN",
            disabled: false,
          },
          {
            name: "16090, Walgreens, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "16095, Walgreens, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "16098, Walgreens, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "161, ADUSA, DERWOOD, MD",
            disabled: false,
          },
          {
            name: "161, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "161, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "161, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "161, Kroger, IRVINE, CA",
            disabled: false,
          },
          {
            name: "161, Meijer, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "161, Walmart, HUNTINGDON, TN",
            disabled: false,
          },
          {
            name: "1610, Albertsons, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "1610, CVS, MUNCY, PA",
            disabled: false,
          },
          {
            name: "1610, Walmart, GREECE, NY",
            disabled: false,
          },
          {
            name: "16101, Walgreens, ANDREWS, NC",
            disabled: false,
          },
          {
            name: "16102, Walgreens, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "16103, Walgreens, BRYSON CITY, NC",
            disabled: false,
          },
          {
            name: "16105, Walgreens, FRANKLIN, NC",
            disabled: false,
          },
          {
            name: "16107, Walgreens, HAYESVILLE, NC",
            disabled: false,
          },
          {
            name: "1611, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1611, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1611, CVS, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "1611, Rite Aid, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "1611, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1611, Walmart, FORT GRATIOT, MI",
            disabled: false,
          },
          {
            name: "16110, Walgreens, ROBBINSVILLE, NC",
            disabled: false,
          },
          {
            name: "16112, Walgreens, MOUNT AIRY, NC",
            disabled: false,
          },
          {
            name: "16119, Walgreens, PEMBROKE, NC",
            disabled: false,
          },
          {
            name: "1612, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "1612, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1612, CVS, DUNMORE, PA",
            disabled: false,
          },
          {
            name: "1612, Rite Aid, HOLT, MI",
            disabled: false,
          },
          {
            name: "1612, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "16120, Walgreens, TROUTMAN, NC",
            disabled: false,
          },
          {
            name: "16122, Walgreens, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "16123, Walgreens, DOBSON, NC",
            disabled: false,
          },
          {
            name: "16128, Walgreens, HILLSBOROUGH, NC",
            disabled: false,
          },
          {
            name: "16129, Walgreens, JAMESTOWN, NC",
            disabled: false,
          },
          {
            name: "1613, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1613, CVS, SOUTH WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "1613, Walmart, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "16130, Walgreens, PLYMOUTH, NC",
            disabled: false,
          },
          {
            name: "16131, Walgreens, RAMSEUR, NC",
            disabled: false,
          },
          {
            name: "16133, Walgreens, SPARTA, NC",
            disabled: false,
          },
          {
            name: "16135, Walgreens, ANGIER, NC",
            disabled: false,
          },
          {
            name: "16136, Walgreens, CARTHAGE, NC",
            disabled: false,
          },
          {
            name: "16137, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "16138, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1614, ADUSA, INDIAN TRAIL, NC",
            disabled: false,
          },
          {
            name: "1614, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "1614, Walmart, DURHAM, NC",
            disabled: false,
          },
          {
            name: "16140, Walgreens, FRANKLINTON, NC",
            disabled: false,
          },
          {
            name: "16142, Walgreens, PITTSBORO, NC",
            disabled: false,
          },
          {
            name: "16143, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "16147, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "16148, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "16149, Walgreens, SANFORD, NC",
            disabled: false,
          },
          {
            name: "1615, Albertsons, BOULDER, CO",
            disabled: false,
          },
          {
            name: "1615, Rite Aid, LANSING, MI",
            disabled: false,
          },
          {
            name: "1615, Walmart, PITTSBURG, CA",
            disabled: false,
          },
          {
            name: "16150, Walgreens, WARRENTON, NC",
            disabled: false,
          },
          {
            name: "16152, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "16153, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "16154, Walgreens, AYDEN, NC",
            disabled: false,
          },
          {
            name: "16155, Walgreens, BELHAVEN, NC",
            disabled: false,
          },
          {
            name: "16156, Walgreens, BENSON, NC",
            disabled: false,
          },
          {
            name: "16158, Walgreens, BURGAW, NC",
            disabled: false,
          },
          {
            name: "1616, Albertsons, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "1616, CVS, EXETER, PA",
            disabled: false,
          },
          {
            name: "1616, Walmart, SUSANVILLE, CA",
            disabled: false,
          },
          {
            name: "16161, Walgreens, FAIRMONT, NC",
            disabled: false,
          },
          {
            name: "16164, Walgreens, NASHVILLE, NC",
            disabled: false,
          },
          {
            name: "16168, Walgreens, ROSEBORO, NC",
            disabled: false,
          },
          {
            name: "1617, ADUSA, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "1617, Albertsons, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "1617, CVS, TUNKHANNOCK, PA",
            disabled: false,
          },
          {
            name: "1617, Rite Aid, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "1617, Walmart, CASPER, WY",
            disabled: false,
          },
          {
            name: "16170, Walgreens, SOUTHPORT, NC",
            disabled: false,
          },
          {
            name: "16171, Walgreens, SAINT PAULS, NC",
            disabled: false,
          },
          {
            name: "16172, Walgreens, TABOR CITY, NC",
            disabled: false,
          },
          {
            name: "1618, ADUSA, HARTVILLE, OH",
            disabled: false,
          },
          {
            name: "1618, Albertsons, CAMERON PARK, CA",
            disabled: false,
          },
          {
            name: "1618, Walmart, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "1619, ADUSA, SMITHFIELD, NC",
            disabled: false,
          },
          {
            name: "1619, Albertsons, YELM, WA",
            disabled: false,
          },
          {
            name: "1619, Walmart, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "162, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "162, BJ's, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "162, CVS, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "162, Meijer, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "162, Target, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "162, Walmart, ANADARKO, OK",
            disabled: false,
          },
          {
            name: "1620, Albertsons, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "1620, Walmart, BREWTON, AL",
            disabled: false,
          },
          {
            name: "1621, Albertsons, NIPOMO, CA",
            disabled: false,
          },
          {
            name: "1621, CVS, WALDORF, MD",
            disabled: false,
          },
          {
            name: "1621, Rite Aid, ATTICA, NY",
            disabled: false,
          },
          {
            name: "1621, Walmart, CENTERVILLE, IA",
            disabled: false,
          },
          {
            name: "1622, ADUSA, ANGIER, NC",
            disabled: false,
          },
          {
            name: "1622, CVS, LEMOYNE, PA",
            disabled: false,
          },
          {
            name: "1622, Walgreens, JUPITER, FL",
            disabled: false,
          },
          {
            name: "1622, Walmart, TIFFIN, OH",
            disabled: false,
          },
          {
            name: "1623, Albertsons, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "1623, Walmart, WILKES BARRE, PA",
            disabled: false,
          },
          {
            name: "1624, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1624, Albertsons, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "1624, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1624, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1625, Albertsons, GARDENA, CA",
            disabled: false,
          },
          {
            name: "1625, CVS, MIDDLETOWN, PA",
            disabled: false,
          },
          {
            name: "1625, Walgreens, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "1625, Walmart, LE MARS, IA",
            disabled: false,
          },
          {
            name: "16253, Walgreens, MURPHY, NC",
            disabled: false,
          },
          {
            name: "16254, Walgreens, HOUGHTON, MI",
            disabled: false,
          },
          {
            name: "1626, Albertsons, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "1626, CVS, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "1626, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "16260, Walgreens, HILLSIDE, NJ",
            disabled: false,
          },
          {
            name: "16261, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1627, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1627, Walmart, DILWORTH, MN",
            disabled: false,
          },
          {
            name: "1628, Rite Aid, DERRY, PA",
            disabled: false,
          },
          {
            name: "1628, Walmart, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "1629, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1629, Albertsons, SALEM, OR",
            disabled: false,
          },
          {
            name: "1629, Walmart, BRAZIL, IN",
            disabled: false,
          },
          {
            name: "16293, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "163, Albertsons, CAMBRIDGE, MA",
            disabled: false,
          },
          {
            name: "163, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "163, Kroger, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "163, Kroger, San Juan Capistrano, CA",
            disabled: false,
          },
          {
            name: "163, Meijer, Fort Gratiot, MI",
            disabled: false,
          },
          {
            name: "163, Walmart, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "1630, Albertsons, ELLENSBURG, WA",
            disabled: false,
          },
          {
            name: "1630, CVS, CAMP HILL, PA",
            disabled: false,
          },
          {
            name: "1630, Walmart, YREKA, CA",
            disabled: false,
          },
          {
            name: "16303, Walgreens, BRENTWOOD, NY",
            disabled: false,
          },
          {
            name: "1631, Albertsons, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "1631, CVS, LEBANON, PA",
            disabled: false,
          },
          {
            name: "1631, Walmart, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "16312, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "16314, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "1632, Albertsons, CARVER, MA",
            disabled: false,
          },
          {
            name: "1632, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1632, Rite Aid, PLAINS, PA",
            disabled: false,
          },
          {
            name: "1632, Walmart, ALEXANDRIA, MN",
            disabled: false,
          },
          {
            name: "16326, Walgreens, SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "1633, Walgreens, HAZELWOOD, MO",
            disabled: false,
          },
          {
            name: "1633, Walmart, SARTELL, MN",
            disabled: false,
          },
          {
            name: "1634, Walgreens, KARNS, TN",
            disabled: false,
          },
          {
            name: "1634, Walmart, LITTLE FALLS, MN",
            disabled: false,
          },
          {
            name: "1635, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1635, Albertsons, FEDERAL HEIGHTS, CO",
            disabled: false,
          },
          {
            name: "1635, Rite Aid, POMEROY, OH",
            disabled: false,
          },
          {
            name: "1635, Walmart, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "16354, Walgreens, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "1636, CVS, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "1636, Walmart, MINOT, ND",
            disabled: false,
          },
          {
            name: "16361, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "1637, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "1637, CVS, MILLERSBURG, PA",
            disabled: false,
          },
          {
            name: "1637, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "1638, Albertsons, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "1638, Walmart, EUFAULA, AL",
            disabled: false,
          },
          {
            name: "16388, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "1639, Albertsons, WILLIAMS, AZ",
            disabled: false,
          },
          {
            name: "1639, Walmart, ROCHESTER, IN",
            disabled: false,
          },
          {
            name: "164, Albertsons, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "164, CVS, WINDHAM, NH",
            disabled: false,
          },
          {
            name: "164, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "164, Meijer, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "164, Target, CASPER, WY",
            disabled: false,
          },
          {
            name: "164, Walmart, PONTOTOC, MS",
            disabled: false,
          },
          {
            name: "1640, Albertsons, MCKINLEYVILLE, CA",
            disabled: false,
          },
          {
            name: "1640, CVS, ELIZABETHVILLE, PA",
            disabled: false,
          },
          {
            name: "1640, Rite Aid, RED LION, PA",
            disabled: false,
          },
          {
            name: "1640, Walmart, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "16400, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "16404, Walgreens, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "1641, Albertsons, EASTVALE, CA",
            disabled: false,
          },
          {
            name: "1641, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1641, Walmart, WILLIAMSTON, NC",
            disabled: false,
          },
          {
            name: "1642, Albertsons, PENDLETON, OR",
            disabled: false,
          },
          {
            name: "1642, CVS, WAYNESBORO, PA",
            disabled: false,
          },
          {
            name: "1642, Walmart, CHARLOTTE, MI",
            disabled: false,
          },
          {
            name: "1643, Albertsons, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "1643, CVS, DAVIDSON, NC",
            disabled: false,
          },
          {
            name: "1643, Walmart, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "1644, Albertsons, FALCON, CO",
            disabled: false,
          },
          {
            name: "1644, Walmart, LEWISBURG, PA",
            disabled: false,
          },
          {
            name: "1645, Albertsons, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "1645, Walmart, HANFORD, CA",
            disabled: false,
          },
          {
            name: "1646, Albertsons, POLSON, MT",
            disabled: false,
          },
          {
            name: "1646, CVS, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "1646, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "1646, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "16465, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "16466, Walgreens, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "1647, Albertsons, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "1647, Walmart, DECATUR, IN",
            disabled: false,
          },
          {
            name: "16474, Walgreens, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "16476, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "1648, Albertsons, LODI, CA",
            disabled: false,
          },
          {
            name: "1648, Walmart, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "1649, CVS, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "1649, Rite Aid, GOWANDA, NY",
            disabled: false,
          },
          {
            name: "1649, Walmart, JAMESTOWN, ND",
            disabled: false,
          },
          {
            name: "16492, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "165, Albertsons, MOUNTAIN HOME, ID",
            disabled: false,
          },
          {
            name: "165, BJ's, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "165, Kroger, Klamath Falls, OR",
            disabled: false,
          },
          {
            name: "165, Kroger, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "165, Meijer, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "165, Walmart, HENDERSON, TX",
            disabled: false,
          },
          {
            name: "1650, CVS, HERSHEY, PA",
            disabled: false,
          },
          {
            name: "1650, Walmart, SAUKVILLE, WI",
            disabled: false,
          },
          {
            name: "1651, Albertsons, CHICO, CA",
            disabled: false,
          },
          {
            name: "1651, Walmart, AMERICAN CANYON, CA",
            disabled: false,
          },
          {
            name: "1652, Albertsons, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "1652, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1652, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "1652, Walmart, DUBLIN, VA",
            disabled: false,
          },
          {
            name: "16526, Walgreens, PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "1653, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1653, CVS, HANOVER, PA",
            disabled: false,
          },
          {
            name: "1653, Rite Aid, JAFFREY, NH",
            disabled: false,
          },
          {
            name: "1653, Walmart, WESTON, WV",
            disabled: false,
          },
          {
            name: "1654, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1654, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1654, CVS, YORK, PA",
            disabled: false,
          },
          {
            name: "1654, Walmart, BAXTER, MN",
            disabled: false,
          },
          {
            name: "16546, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "1655, ADUSA, LELAND, NC",
            disabled: false,
          },
          {
            name: "1655, Walmart, CRAWFORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "1656, Albertsons, SUPERIOR, CO",
            disabled: false,
          },
          {
            name: "1656, CVS, CHESTER, VA",
            disabled: false,
          },
          {
            name: "1656, Walmart, MEADVILLE, PA",
            disabled: false,
          },
          {
            name: "1657, Albertsons, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "1657, CVS, YORK, PA",
            disabled: false,
          },
          {
            name: "1657, Walgreens, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "1657, Walmart, FARIBAULT, MN",
            disabled: false,
          },
          {
            name: "1658, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1658, CVS, AVON, IN",
            disabled: false,
          },
          {
            name: "1658, Walmart, THOMSON, GA",
            disabled: false,
          },
          {
            name: "1659, Albertsons, ALBANY, OR",
            disabled: false,
          },
          {
            name: "1659, Rite Aid, BROOKVILLE, OH",
            disabled: false,
          },
          {
            name: "1659, Walmart, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "166, Albertsons, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "166, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "166, Kroger, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "166, Kroger, MANHATTAN BEACH, CA",
            disabled: false,
          },
          {
            name: "166, Meijer, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "166, Walmart, HOUSTON, MO",
            disabled: false,
          },
          {
            name: "1660, Albertsons, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "1660, Walmart, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "1661, ADUSA, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1661, Albertsons, MODESTO, CA",
            disabled: false,
          },
          {
            name: "1661, CVS, PRAIRIEVILLE, LA",
            disabled: false,
          },
          {
            name: "1661, Walmart, KINSTON, NC",
            disabled: false,
          },
          {
            name: "1662, ADUSA, LAUREL, MD",
            disabled: false,
          },
          {
            name: "1662, Albertsons, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "1662, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "1662, Rite Aid, PALMYRA, PA",
            disabled: false,
          },
          {
            name: "1662, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "1662, Walmart, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "1663, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1663, CVS, NEW HOLLAND, PA",
            disabled: false,
          },
          {
            name: "1663, Rite Aid, GAYLORD, MI",
            disabled: false,
          },
          {
            name: "1663, Walmart, WAYNESVILLE, NC",
            disabled: false,
          },
          {
            name: "1664, ADUSA, SALEM, OH",
            disabled: false,
          },
          {
            name: "1664, Albertsons, BURIEN, WA",
            disabled: false,
          },
          {
            name: "1664, Walmart, WILSON, NC",
            disabled: false,
          },
          {
            name: "1665, Albertsons, REDMOND, OR",
            disabled: false,
          },
          {
            name: "1665, CVS, MANHEIM, PA",
            disabled: false,
          },
          {
            name: "1665, Walmart, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "1666, Albertsons, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "1666, CVS, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "1666, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1667, ADUSA, EBENSBURG, PA",
            disabled: false,
          },
          {
            name: "1667, Albertsons, ERIE, CO",
            disabled: false,
          },
          {
            name: "1667, CVS, LITITZ, PA",
            disabled: false,
          },
          {
            name: "1667, Walmart, WABASH, IN",
            disabled: false,
          },
          {
            name: "1668, ADUSA, PASADENA, MD",
            disabled: false,
          },
          {
            name: "1668, Albertsons, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1668, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "1668, Rite Aid, FARRELL, PA",
            disabled: false,
          },
          {
            name: "1668, Walmart, GURNEE, IL",
            disabled: false,
          },
          {
            name: "1669, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1669, Walmart, EAU CLAIRE, WI",
            disabled: false,
          },
          {
            name: "167, ADUSA, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "167, ADUSA, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "167, BJ's, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "167, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "167, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "167, Meijer, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "167, Target, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "167, Walmart, CROSSETT, AR",
            disabled: false,
          },
          {
            name: "1670, CVS, COLUMBIA, PA",
            disabled: false,
          },
          {
            name: "1670, Rite Aid, PERTH AMBOY, NJ",
            disabled: false,
          },
          {
            name: "1670, Walgreens, HINSDALE, IL",
            disabled: false,
          },
          {
            name: "1670, Walmart, WYOMISSING, PA",
            disabled: false,
          },
          {
            name: "1671, Albertsons, CHATSWORTH, CA",
            disabled: false,
          },
          {
            name: "1671, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "1671, Walmart, PAPILLION, NE",
            disabled: false,
          },
          {
            name: "1672, Albertsons, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "1672, CVS, ELIZABETHTOWN, PA",
            disabled: false,
          },
          {
            name: "1672, Rite Aid, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "1672, Walmart, ASHLAND, WI",
            disabled: false,
          },
          {
            name: "1673, Walmart, CANANDAIGUA, NY",
            disabled: false,
          },
          {
            name: "1674, Albertsons, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "1674, CVS, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "1674, Rite Aid, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "1674, Walmart, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1675, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "1675, Walmart, LEBANON, KY",
            disabled: false,
          },
          {
            name: "1676, Walmart, TELL CITY, IN",
            disabled: false,
          },
          {
            name: "1677, ADUSA, MILLERS CREEK, NC",
            disabled: false,
          },
          {
            name: "1677, CVS, LEWISTOWN, PA",
            disabled: false,
          },
          {
            name: "1677, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1677, Walmart, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "1678, Albertsons, ELDERSBURG, MD",
            disabled: false,
          },
          {
            name: "1678, Walmart, DELAFIELD, WI",
            disabled: false,
          },
          {
            name: "1679, CVS, MANSFIELD, PA",
            disabled: false,
          },
          {
            name: "1679, Walmart, ONALASKA, WI",
            disabled: false,
          },
          {
            name: "168, Albertsons, PAYETTE, ID",
            disabled: false,
          },
          {
            name: "168, CVS, ENDWELL, NY",
            disabled: false,
          },
          {
            name: "168, HEB, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "168, Kroger, COLUMBIA FALLS, MT",
            disabled: false,
          },
          {
            name: "168, Kroger, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "168, Meijer, COLD SPRING, KY",
            disabled: false,
          },
          {
            name: "168, Walmart, OWASSO, OK",
            disabled: false,
          },
          {
            name: "1680, ADUSA, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "1680, Albertsons, SILVERDALE, WA",
            disabled: false,
          },
          {
            name: "1680, CVS, CLARION, PA",
            disabled: false,
          },
          {
            name: "1680, Walmart, KENDALL, FL",
            disabled: false,
          },
          {
            name: "1681, ADUSA, SUMTER, SC",
            disabled: false,
          },
          {
            name: "1681, Albertsons, ALAMOSA, CO",
            disabled: false,
          },
          {
            name: "1681, CVS, LOCK HAVEN, PA",
            disabled: false,
          },
          {
            name: "1681, Walmart, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "1682, Albertsons, PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "1682, CVS, BEDFORD, PA",
            disabled: false,
          },
          {
            name: "1682, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1683, CVS, BROOKLYN CENTER, MN",
            disabled: false,
          },
          {
            name: "1683, Walmart, SHENANDOAH, IA",
            disabled: false,
          },
          {
            name: "1684, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1684, CVS, BELLEFONTE, PA",
            disabled: false,
          },
          {
            name: "1684, Walmart, EVERETT, PA",
            disabled: false,
          },
          {
            name: "1685, ADUSA, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "1685, CVS, CLEARFIELD, PA",
            disabled: false,
          },
          {
            name: "1685, Rite Aid, WEST PITTSTON, PA",
            disabled: false,
          },
          {
            name: "1685, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "1685, Walmart, PIERRE, SD",
            disabled: false,
          },
          {
            name: "1686, Walmart, TAYLORSVILLE, UT",
            disabled: false,
          },
          {
            name: "1687, ADUSA, KINSTON, NC",
            disabled: false,
          },
          {
            name: "1687, Albertsons, WASHOUGAL, WA",
            disabled: false,
          },
          {
            name: "1687, CVS, BURNHAM, PA",
            disabled: false,
          },
          {
            name: "1687, Walmart, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "1688, CVS, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "1688, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "1689, ADUSA, RICES LANDING, PA",
            disabled: false,
          },
          {
            name: "1689, ADUSA, SILER CITY, NC",
            disabled: false,
          },
          {
            name: "1689, Albertsons, HERNDON, VA",
            disabled: false,
          },
          {
            name: "1689, Rite Aid, LACKAWANNA, NY",
            disabled: false,
          },
          {
            name: "1689, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "169, ADUSA, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "169, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "169, BJ's, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "169, CVS, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "169, Meijer, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "169, ShopRite, ENGLEWOOD, NJ",
            disabled: false,
          },
          {
            name: "169, Walmart, LONOKE, AR",
            disabled: false,
          },
          {
            name: "1690, Albertsons, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "1690, Walmart, DECATUR, IL",
            disabled: false,
          },
          {
            name: "1691, ADUSA, GIBSONIA, PA",
            disabled: false,
          },
          {
            name: "1691, Rite Aid, PETOSKEY, MI",
            disabled: false,
          },
          {
            name: "1691, Walmart, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "1692, ADUSA, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "1692, Walmart, COLTON, CA",
            disabled: false,
          },
          {
            name: "1693, Walmart, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "1694, ADUSA, TABOR CITY, NC",
            disabled: false,
          },
          {
            name: "1694, Walmart, MARION, NC",
            disabled: false,
          },
          {
            name: "1695, ADUSA, ROCKY FACE, GA",
            disabled: false,
          },
          {
            name: "1695, Walmart, DEVILS LAKE, ND",
            disabled: false,
          },
          {
            name: "1696, ADUSA, ADAIRSVILLE, GA",
            disabled: false,
          },
          {
            name: "1696, Walmart, FERGUS FALLS, MN",
            disabled: false,
          },
          {
            name: "1697, Walmart, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "1698, ADUSA, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "1698, Rite Aid, SLIPPERY ROCK, PA",
            disabled: false,
          },
          {
            name: "1698, Walmart, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "1699, Walmart, LAYTON, UT",
            disabled: false,
          },
          {
            name: "17, ADUSA, QUINCY, MA",
            disabled: false,
          },
          {
            name: "17, Albertsons, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "17, BJ's, SALEM, NH",
            disabled: false,
          },
          {
            name: "17, CVS, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "17, Costco, EUGENE, OR",
            disabled: false,
          },
          {
            name: "17, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "17, Kroger, Milan, IN",
            disabled: false,
          },
          {
            name: "17, Kroger, SOLDOTNA, AK",
            disabled: false,
          },
          {
            name: "17, Kroger, SUN VALLEY, CA",
            disabled: false,
          },
          {
            name: "17, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "17, Walmart, NEOSHO, MO",
            disabled: false,
          },
          {
            name: "170, Albertsons, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "170, BJ's, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "170, CVS, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "170, Kroger, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "170, Meijer, HIGHLAND, IN",
            disabled: false,
          },
          {
            name: "170, Walmart, NATCHITOCHES, LA",
            disabled: false,
          },
          {
            name: "1700, Walmart, POWAY, CA",
            disabled: false,
          },
          {
            name: "17003, Walgreens, GREELEY, CO",
            disabled: false,
          },
          {
            name: "17009, Walgreens, SALEM, IN",
            disabled: false,
          },
          {
            name: "1701, Walmart, ELBERTON, GA",
            disabled: false,
          },
          {
            name: "17014, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "17015, Walgreens, SUGAR MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "17018, Walgreens, WINTERVILLE, NC",
            disabled: false,
          },
          {
            name: "1702, Albertsons, DALE CITY, VA",
            disabled: false,
          },
          {
            name: "1702, Walmart, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "17020, Walgreens, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "17024, Walgreens, CAMDEN, SC",
            disabled: false,
          },
          {
            name: "17027, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "17028, Walgreens, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "1703, Walmart, MARTINSBURG, WV",
            disabled: false,
          },
          {
            name: "17030, Walgreens, VICKSBURG, MS",
            disabled: false,
          },
          {
            name: "17033, Walgreens, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "17037, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1704, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1704, Rite Aid, YARDLEY, PA",
            disabled: false,
          },
          {
            name: "1704, Walmart, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "17043, Walgreens, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "17044, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "17046, Walgreens, CLAXTON, GA",
            disabled: false,
          },
          {
            name: "17049, Walgreens, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "1705, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "1705, Walmart, WATERLOO, NY",
            disabled: false,
          },
          {
            name: "17055, Walgreens, MONROE, LA",
            disabled: false,
          },
          {
            name: "17059, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1706, Albertsons, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "17066, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "17067, Walgreens, PINEHURST, NC",
            disabled: false,
          },
          {
            name: "1707, Albertsons, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "1707, Walmart, EAST LIVERPOOL, OH",
            disabled: false,
          },
          {
            name: "17073, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "17076, Walgreens, RUTHERFORDTON, NC",
            disabled: false,
          },
          {
            name: "17077, Walgreens, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "17078, Walgreens, KERSHAW, SC",
            disabled: false,
          },
          {
            name: "1708, Albertsons, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "1708, Walmart, RIVERDALE, UT",
            disabled: false,
          },
          {
            name: "17083, Walgreens, CEDARTOWN, GA",
            disabled: false,
          },
          {
            name: "1709, Albertsons, MENLO PARK, CA",
            disabled: false,
          },
          {
            name: "1709, Walmart, ANGOLA, IN",
            disabled: false,
          },
          {
            name: "17092, Walgreens, HOUMA, LA",
            disabled: false,
          },
          {
            name: "17097, Walgreens, ROME, NY",
            disabled: false,
          },
          {
            name: "171, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "171, Albertsons, REXBURG, ID",
            disabled: false,
          },
          {
            name: "171, CVS, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "171, Kroger, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "171, Kroger, Glendora, CA",
            disabled: false,
          },
          {
            name: "171, Meijer, CADILLAC, MI",
            disabled: false,
          },
          {
            name: "171, Target, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "171, Walmart, CAMDEN, AR",
            disabled: false,
          },
          {
            name: "1710, Albertsons, SWEET HOME, OR",
            disabled: false,
          },
          {
            name: "1710, Walmart, CLINTON, MS",
            disabled: false,
          },
          {
            name: "1711, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1711, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "17110, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "17111, Walgreens, SAINT ALBANS, WV",
            disabled: false,
          },
          {
            name: "17113, Walgreens, BUCKHANNON, WV",
            disabled: false,
          },
          {
            name: "17116, Walgreens, RIPLEY, WV",
            disabled: false,
          },
          {
            name: "17117, Walgreens, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "17118, Walgreens, BAMBERG, SC",
            disabled: false,
          },
          {
            name: "17119, Walgreens, WESTMINSTER, SC",
            disabled: false,
          },
          {
            name: "1712, Walmart, LARGO, FL",
            disabled: false,
          },
          {
            name: "17123, Walgreens, MCKENZIE, TN",
            disabled: false,
          },
          {
            name: "17128, Walgreens, ONLEY, VA",
            disabled: false,
          },
          {
            name: "1713, Albertsons, WEST LINN, OR",
            disabled: false,
          },
          {
            name: "1713, Walmart, CANTON, IL",
            disabled: false,
          },
          {
            name: "17139, Walgreens, SKOWHEGAN, ME",
            disabled: false,
          },
          {
            name: "1714, Albertsons, PINOLE, CA",
            disabled: false,
          },
          {
            name: "1714, Walmart, FAIRMONT, WV",
            disabled: false,
          },
          {
            name: "17141, Walgreens, BANGOR, ME",
            disabled: false,
          },
          {
            name: "17142, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "17144, Walgreens, JACKSON, KY",
            disabled: false,
          },
          {
            name: "17145, Walgreens, STANFORD, KY",
            disabled: false,
          },
          {
            name: "17147, Walgreens, LINCOLN, ME",
            disabled: false,
          },
          {
            name: "17148, Walgreens, HENDERSON, KY",
            disabled: false,
          },
          {
            name: "17149, Walgreens, BUCKSPORT, ME",
            disabled: false,
          },
          {
            name: "1715, Albertsons, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1715, Rite Aid, MIO, MI",
            disabled: false,
          },
          {
            name: "1715, Walmart, EASTON, MD",
            disabled: false,
          },
          {
            name: "17150, Walgreens, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "17151, Walgreens, ROCKAWAY PARK, NY",
            disabled: false,
          },
          {
            name: "17152, Walgreens, PRESQUE ISLE, ME",
            disabled: false,
          },
          {
            name: "17155, Walgreens, NORTH WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "17156, Walgreens, WATERVILLE, ME",
            disabled: false,
          },
          {
            name: "17159, Walgreens, RUMFORD, ME",
            disabled: false,
          },
          {
            name: "1716, Albertsons, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "1716, CVS, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "1716, Rite Aid, CLEMENTON, NJ",
            disabled: false,
          },
          {
            name: "1716, Walmart, PRINCE FREDERICK, MD",
            disabled: false,
          },
          {
            name: "17163, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "17164, Walgreens, PRESTONSBURG, KY",
            disabled: false,
          },
          {
            name: "17166, Walgreens, HUDSON, MA",
            disabled: false,
          },
          {
            name: "17167, Walgreens, LANCASTER, NH",
            disabled: false,
          },
          {
            name: "17169, Walgreens, SOUTH BOSTON, MA",
            disabled: false,
          },
          {
            name: "1717, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "1717, Walmart, WALDORF, MD",
            disabled: false,
          },
          {
            name: "17171, Walgreens, MONROE, LA",
            disabled: false,
          },
          {
            name: "17172, Walgreens, MONTICELLO, KY",
            disabled: false,
          },
          {
            name: "17176, Walgreens, WHITLEY CITY, KY",
            disabled: false,
          },
          {
            name: "17177, Walgreens, GARDNER, MA",
            disabled: false,
          },
          {
            name: "17178, Walgreens, WARFIELD, KY",
            disabled: false,
          },
          {
            name: "1718, Walmart, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "17180, Walgreens, MOUNT VERNON, KY",
            disabled: false,
          },
          {
            name: "17182, Walgreens, CANTON, NY",
            disabled: false,
          },
          {
            name: "17185, Walgreens, HARDWICK, VT",
            disabled: false,
          },
          {
            name: "17189, Walgreens, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "1719, CVS, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "1719, Walmart, BIG RAPIDS, MI",
            disabled: false,
          },
          {
            name: "17191, Walgreens, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "17192, Walgreens, ELMONT, NY",
            disabled: false,
          },
          {
            name: "17194, Walgreens, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "17199, Walgreens, HARAHAN, LA",
            disabled: false,
          },
          {
            name: "172, BJ's, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "172, CVS, BRANFORD, CT",
            disabled: false,
          },
          {
            name: "172, HEB, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "172, Kroger, Jackson, MI",
            disabled: false,
          },
          {
            name: "172, Kroger, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "172, Kroger, KENT, WA",
            disabled: false,
          },
          {
            name: "172, Kroger, Norwalk, CA",
            disabled: false,
          },
          {
            name: "172, Meijer, Howell, MI",
            disabled: false,
          },
          {
            name: "172, Rite Aid, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "172, Walmart, WASHINGTON, MO",
            disabled: false,
          },
          {
            name: "1720, CVS, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "1720, Walmart, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "17200, Walgreens, STERLING, VA",
            disabled: false,
          },
          {
            name: "17201, Walgreens, MOUNT AIRY, MD",
            disabled: false,
          },
          {
            name: "17202, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "17204, Walgreens, CORTLAND, NY",
            disabled: false,
          },
          {
            name: "17205, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1721, Albertsons, LAMAR, CO",
            disabled: false,
          },
          {
            name: "1721, Walmart, IOWA CITY, IA",
            disabled: false,
          },
          {
            name: "17212, Walgreens, TOWNSEND, MA",
            disabled: false,
          },
          {
            name: "17216, Walgreens, COLCHESTER, CT",
            disabled: false,
          },
          {
            name: "17217, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1722, Albertsons, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "1722, Walmart, MARSHALL, MN",
            disabled: false,
          },
          {
            name: "17222, Walgreens, METTER, GA",
            disabled: false,
          },
          {
            name: "17226, Walgreens, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "17227, Walgreens, SARANAC LAKE, NY",
            disabled: false,
          },
          {
            name: "17228, Walgreens, BRAINTREE, MA",
            disabled: false,
          },
          {
            name: "17229, Walgreens, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "1723, Albertsons, SAN ANSELMO, CA",
            disabled: false,
          },
          {
            name: "1723, Walmart, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "17230, Walgreens, GARDNER, MA",
            disabled: false,
          },
          {
            name: "17232, Walgreens, DALTON, GA",
            disabled: false,
          },
          {
            name: "17235, Walgreens, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "17239, Walgreens, RIDGELAND, SC",
            disabled: false,
          },
          {
            name: "1724, Albertsons, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "1724, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "1724, Walmart, MILLERSBURG, OH",
            disabled: false,
          },
          {
            name: "17240, Walgreens, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "17241, Walgreens, CARROLLTON, KY",
            disabled: false,
          },
          {
            name: "1725, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "17257, Walgreens, MATTAPAN, MA",
            disabled: false,
          },
          {
            name: "17258, Walgreens, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "1726, Rite Aid, DELMONT, PA",
            disabled: false,
          },
          {
            name: "1726, Walmart, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "17262, Walgreens, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "1727, Walmart, BERLIN, WI",
            disabled: false,
          },
          {
            name: "17274, Walgreens, ELEANOR, WV",
            disabled: false,
          },
          {
            name: "17275, Walgreens, RICHWOOD, WV",
            disabled: false,
          },
          {
            name: "17278, Walgreens, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "1728, Walmart, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "17280, Walgreens, RAVENSWOOD, WV",
            disabled: false,
          },
          {
            name: "17282, Walgreens, CUMMING, GA",
            disabled: false,
          },
          {
            name: "1729, Rite Aid, FLUSHING, MI",
            disabled: false,
          },
          {
            name: "1729, Walmart, CONNERSVILLE, IN",
            disabled: false,
          },
          {
            name: "17292, Walgreens, SHELBY, NC",
            disabled: false,
          },
          {
            name: "17298, Walgreens, BLOOMFIELD, CT",
            disabled: false,
          },
          {
            name: "173, Albertsons, MONTEREY, CA",
            disabled: false,
          },
          {
            name: "173, BJ's, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "173, Kroger, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "173, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "173, Meijer, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "173, Walmart, POTOSI, MO",
            disabled: false,
          },
          {
            name: "1730, Walmart, TAPPAHANNOCK, VA",
            disabled: false,
          },
          {
            name: "17300, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "17301, Walgreens, CAZENOVIA, NY",
            disabled: false,
          },
          {
            name: "17302, Walgreens, PALMER, MA",
            disabled: false,
          },
          {
            name: "17303, Walgreens, STEUBENVILLE, OH",
            disabled: false,
          },
          {
            name: "17306, Walgreens, GRUNDY, VA",
            disabled: false,
          },
          {
            name: "17308, Walgreens, STRASBURG, VA",
            disabled: false,
          },
          {
            name: "17309, Walgreens, ROMNEY, WV",
            disabled: false,
          },
          {
            name: "1731, Albertsons, PRINCE FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1731, CVS, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "1731, Walmart, GENEVA, NY",
            disabled: false,
          },
          {
            name: "17317, Walgreens, NEW PALTZ, NY",
            disabled: false,
          },
          {
            name: "17319, Walgreens, WHEELING, WV",
            disabled: false,
          },
          {
            name: "1732, Albertsons, COOLIDGE, AZ",
            disabled: false,
          },
          {
            name: "1732, Walmart, DENISON, IA",
            disabled: false,
          },
          {
            name: "17325, Walgreens, SANFORD, NC",
            disabled: false,
          },
          {
            name: "17328, Walgreens, JENKINS, KY",
            disabled: false,
          },
          {
            name: "1733, Albertsons, SHOW LOW, AZ",
            disabled: false,
          },
          {
            name: "1733, CVS, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1733, Walmart, OWOSSO, MI",
            disabled: false,
          },
          {
            name: "17330, Walgreens, WILLIAMSTON, SC",
            disabled: false,
          },
          {
            name: "17333, Walgreens, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "17338, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "1734, Albertsons, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "1734, Walmart, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "17341, Walgreens, ABERDEEN, MS",
            disabled: false,
          },
          {
            name: "17346, Walgreens, HOOVER, AL",
            disabled: false,
          },
          {
            name: "1735, Albertsons, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "1735, CVS, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "1735, Walmart, WHEELING, IL",
            disabled: false,
          },
          {
            name: "17350, Walgreens, MCCOMB, MS",
            disabled: false,
          },
          {
            name: "17353, Walgreens, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "17356, Walgreens, FARMINGTON, ME",
            disabled: false,
          },
          {
            name: "1736, Albertsons, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "1736, Walmart, DOVER, DE",
            disabled: false,
          },
          {
            name: "17363, Walgreens, MADISON, AL",
            disabled: false,
          },
          {
            name: "17366, Walgreens, MAYSVILLE, KY",
            disabled: false,
          },
          {
            name: "17368, Walgreens, MOUNT HOLLY, NC",
            disabled: false,
          },
          {
            name: "1737, CVS, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "1737, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "1737, Walmart, VILLA PARK, IL",
            disabled: false,
          },
          {
            name: "17370, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "17379, Walgreens, WILMINGTON, VT",
            disabled: false,
          },
          {
            name: "1738, Walmart, HUTCHINSON, MN",
            disabled: false,
          },
          {
            name: "17381, Walgreens, INMAN, SC",
            disabled: false,
          },
          {
            name: "17386, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1739, Albertsons, PALMER, AK",
            disabled: false,
          },
          {
            name: "1739, Walmart, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "17392, Walgreens, FRANKLIN, KY",
            disabled: false,
          },
          {
            name: "17394, Walgreens, STUART, VA",
            disabled: false,
          },
          {
            name: "17398, Walgreens, OXFORD, AL",
            disabled: false,
          },
          {
            name: "174, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "174, CVS, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "174, Meijer, MASON, MI",
            disabled: false,
          },
          {
            name: "174, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "174, Walmart, COCOA, FL",
            disabled: false,
          },
          {
            name: "1740, Albertsons, CHENEY, WA",
            disabled: false,
          },
          {
            name: "1740, Rite Aid, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "1740, Walmart, FREEPORT, IL",
            disabled: false,
          },
          {
            name: "17402, Walgreens, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "17404, Walgreens, MARTIN, KY",
            disabled: false,
          },
          {
            name: "17405, Walgreens, NUTTERFORT, WV",
            disabled: false,
          },
          {
            name: "17408, Walgreens, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "17409, Walgreens, HURRICANE, WV",
            disabled: false,
          },
          {
            name: "1741, CVS, WAVERLY, TN",
            disabled: false,
          },
          {
            name: "1741, Walmart, MILFORD, DE",
            disabled: false,
          },
          {
            name: "17413, Walgreens, DANVILLE, WV",
            disabled: false,
          },
          {
            name: "1742, Albertsons, FONTANA, CA",
            disabled: false,
          },
          {
            name: "1742, CVS, MONROE, NC",
            disabled: false,
          },
          {
            name: "1742, Walmart, TURNERSVILLE, NJ",
            disabled: false,
          },
          {
            name: "17421, Walgreens, SYLVANIA, GA",
            disabled: false,
          },
          {
            name: "17422, Walgreens, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "17426, Walgreens, OAK HILL, WV",
            disabled: false,
          },
          {
            name: "17429, Walgreens, FARMVILLE, VA",
            disabled: false,
          },
          {
            name: "1743, Albertsons, GALLUP, NM",
            disabled: false,
          },
          {
            name: "1743, CVS, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "1743, Walmart, HARLAN, KY",
            disabled: false,
          },
          {
            name: "17432, Walgreens, SPRINGFIELD, KY",
            disabled: false,
          },
          {
            name: "17438, Walgreens, HORSE CAVE, KY",
            disabled: false,
          },
          {
            name: "1744, Albertsons, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "1744, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1744, Walmart, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "17440, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "17442, Walgreens, LOUISA, KY",
            disabled: false,
          },
          {
            name: "17443, Walgreens, SEMMES, AL",
            disabled: false,
          },
          {
            name: "17445, Walgreens, IRVINE, KY",
            disabled: false,
          },
          {
            name: "1745, CVS, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "1745, Walmart, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "17450, Walgreens, BUXTON, ME",
            disabled: false,
          },
          {
            name: "17454, Walgreens, SELLERSBURG, IN",
            disabled: false,
          },
          {
            name: "17455, Walgreens, CALAIS, ME",
            disabled: false,
          },
          {
            name: "17457, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1746, Albertsons, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "1746, CVS, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "1746, Walmart, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "17461, Walgreens, NORTHVILLE, NY",
            disabled: false,
          },
          {
            name: "17464, Walgreens, PEPPERELL, MA",
            disabled: false,
          },
          {
            name: "17465, Walgreens, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "17466, Walgreens, HUDSON, NY",
            disabled: false,
          },
          {
            name: "17469, Walgreens, HAVELOCK, NC",
            disabled: false,
          },
          {
            name: "1747, Albertsons, CHINO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "1747, CVS, CHANHASSEN, MN",
            disabled: false,
          },
          {
            name: "1747, Walmart, PERRIS, CA",
            disabled: false,
          },
          {
            name: "17471, Walgreens, ESSEX JUNCTION, VT",
            disabled: false,
          },
          {
            name: "17473, Walgreens, ROCKLAND, ME",
            disabled: false,
          },
          {
            name: "17474, Walgreens, PAINTSVILLE, KY",
            disabled: false,
          },
          {
            name: "17476, Walgreens, ROCKWOOD, TN",
            disabled: false,
          },
          {
            name: "17478, Walgreens, HODGENVILLE, KY",
            disabled: false,
          },
          {
            name: "1748, Albertsons, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "1748, CVS, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "1748, Walmart, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "17481, Walgreens, MACHIAS, ME",
            disabled: false,
          },
          {
            name: "17482, Walgreens, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "17484, Walgreens, OAKLAND, ME",
            disabled: false,
          },
          {
            name: "17485, Walgreens, WINOOSKI, VT",
            disabled: false,
          },
          {
            name: "17486, Walgreens, METHUEN, MA",
            disabled: false,
          },
          {
            name: "17488, Walgreens, TURNERS FALLS, MA",
            disabled: false,
          },
          {
            name: "1749, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1749, Walmart, SOMERSWORTH, NH",
            disabled: false,
          },
          {
            name: "17492, Walgreens, PALATINE BRIDGE, NY",
            disabled: false,
          },
          {
            name: "17494, Walgreens, PINE BUSH, NY",
            disabled: false,
          },
          {
            name: "17496, Walgreens, BLUEFIELD, WV",
            disabled: false,
          },
          {
            name: "17499, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "175, BJ's, REVERE, MA",
            disabled: false,
          },
          {
            name: "175, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "175, Kroger, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "175, Kroger, Wautoma, WI",
            disabled: false,
          },
          {
            name: "175, Meijer, THREE RIVERS, MI",
            disabled: false,
          },
          {
            name: "175, Walmart, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "1750, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1750, CVS, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "1750, Target, CENTERVILLE, UT",
            disabled: false,
          },
          {
            name: "1750, Walgreens, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "1750, Walmart, MARION, OH",
            disabled: false,
          },
          {
            name: "17500, Walgreens, PUTNAM, CT",
            disabled: false,
          },
          {
            name: "1751, Albertsons, MOLALLA, OR",
            disabled: false,
          },
          {
            name: "1751, Rite Aid, NEWARK, DE",
            disabled: false,
          },
          {
            name: "1751, Target, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "1751, Walgreens, MAPLEWOOD, MN",
            disabled: false,
          },
          {
            name: "1751, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "17511, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "17513, Walgreens, EAST SETAUKET, NY",
            disabled: false,
          },
          {
            name: "17518, Walgreens, BARRE, VT",
            disabled: false,
          },
          {
            name: "17519, Walgreens, RUMFORD, RI",
            disabled: false,
          },
          {
            name: "1752, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1752, Target, SANDY, UT",
            disabled: false,
          },
          {
            name: "1752, Walmart, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "17522, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "17524, Walgreens, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "17527, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1753, Albertsons, BISHOP, CA",
            disabled: false,
          },
          {
            name: "1753, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1753, Target, RIVERDALE, UT",
            disabled: false,
          },
          {
            name: "1753, Walmart, DERRY, NH",
            disabled: false,
          },
          {
            name: "17534, Walgreens, BRANCHLAND, WV",
            disabled: false,
          },
          {
            name: "17538, Walgreens, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "1754, Albertsons, FRESNO, CA",
            disabled: false,
          },
          {
            name: "1754, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1754, Target, OREM, UT",
            disabled: false,
          },
          {
            name: "1754, Walmart, HOWELL, MI",
            disabled: false,
          },
          {
            name: "17540, Walgreens, WEST SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "17542, Walgreens, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "17545, Walgreens, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "17547, Walgreens, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "17548, Walgreens, DONALSONVILLE, GA",
            disabled: false,
          },
          {
            name: "1755, Target, LAYTON, UT",
            disabled: false,
          },
          {
            name: "1755, Walmart, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "17550, Walgreens, WEST POINT, VA",
            disabled: false,
          },
          {
            name: "17551, Walgreens, SELMER, TN",
            disabled: false,
          },
          {
            name: "1756, Albertsons, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "1756, CVS, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "1756, Target, OLATHE, KS",
            disabled: false,
          },
          {
            name: "1756, Walgreens, RUTLAND, VT",
            disabled: false,
          },
          {
            name: "1756, Walmart, FONTANA, CA",
            disabled: false,
          },
          {
            name: "17562, Walgreens, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "17566, Walgreens, OSWEGO, NY",
            disabled: false,
          },
          {
            name: "17568, Walgreens, HIRAM, GA",
            disabled: false,
          },
          {
            name: "1757, Albertsons, HOLLISTER, CA",
            disabled: false,
          },
          {
            name: "1757, Target, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "1757, Walmart, HERMANTOWN, MN",
            disabled: false,
          },
          {
            name: "1758, Albertsons, PERRY HALL, MD",
            disabled: false,
          },
          {
            name: "1758, CVS, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "1758, Rite Aid, CLIFTON HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "1758, Walmart, NEW CASTLE, IN",
            disabled: false,
          },
          {
            name: "17586, Walgreens, STAFFORD SPRINGS, CT",
            disabled: false,
          },
          {
            name: "17587, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1759, Albertsons, STERLING, VA",
            disabled: false,
          },
          {
            name: "1759, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1759, Target, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "1759, Walmart, GLOUCESTER, VA",
            disabled: false,
          },
          {
            name: "17593, Walgreens, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "17595, Walgreens, IRONTON, OH",
            disabled: false,
          },
          {
            name: "176, Albertsons, NAMPA, ID",
            disabled: false,
          },
          {
            name: "176, CVS, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "176, Meijer, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "176, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "176, Walmart, RIPLEY, MS",
            disabled: false,
          },
          {
            name: "1760, Albertsons, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "1760, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1760, Walmart, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "17604, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "17607, Walgreens, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "17609, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1761, Albertsons, LINCOLN, CA",
            disabled: false,
          },
          {
            name: "1761, Target, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "1761, Walmart, GRANITE CITY, IL",
            disabled: false,
          },
          {
            name: "17610, Walgreens, ARNOLD, MD",
            disabled: false,
          },
          {
            name: "17612, Walgreens, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "17617, Walgreens, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "17619, Walgreens, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "1762, Albertsons, WOODLAND, WA",
            disabled: false,
          },
          {
            name: "1762, Rite Aid, GIBBSTOWN, NJ",
            disabled: false,
          },
          {
            name: "1762, Target, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "1762, Walmart, SEABROOK, NH",
            disabled: false,
          },
          {
            name: "17625, Walgreens, LYNDONVILLE, VT",
            disabled: false,
          },
          {
            name: "17626, Walgreens, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1763, Albertsons, DOVER, DE",
            disabled: false,
          },
          {
            name: "1763, Target, FRISCO, TX",
            disabled: false,
          },
          {
            name: "1763, Walmart, BLUEFIELD, VA",
            disabled: false,
          },
          {
            name: "17631, Walgreens, BENNINGTON, VT",
            disabled: false,
          },
          {
            name: "17632, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "17638, Walgreens, POTOMAC, MD",
            disabled: false,
          },
          {
            name: "1764, Albertsons, MONTCLAIR, NJ",
            disabled: false,
          },
          {
            name: "1764, CVS, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "1764, Target, PLANO, TX",
            disabled: false,
          },
          {
            name: "1764, Walmart, WINDSOR HEIGHTS, IA",
            disabled: false,
          },
          {
            name: "17640, Walgreens, SMITHSBURG, MD",
            disabled: false,
          },
          {
            name: "17641, Walgreens, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "17643, Walgreens, MANLIUS, NY",
            disabled: false,
          },
          {
            name: "1765, Albertsons, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "1765, Target, WATAUGA, TX",
            disabled: false,
          },
          {
            name: "1765, Walmart, SOMERSET, PA",
            disabled: false,
          },
          {
            name: "17650, Walgreens, SOUTHWICK, MA",
            disabled: false,
          },
          {
            name: "1766, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1766, Target, HURST, TX",
            disabled: false,
          },
          {
            name: "1766, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "17660, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "17667, Walgreens, HIGHLAND FALLS, NY",
            disabled: false,
          },
          {
            name: "17668, Walgreens, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "17669, Walgreens, MCMINNVILLE, TN",
            disabled: false,
          },
          {
            name: "1767, Albertsons, BRAWLEY, CA",
            disabled: false,
          },
          {
            name: "1767, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1767, Target, ANKENY, IA",
            disabled: false,
          },
          {
            name: "1767, Walmart, SHALLOTTE, NC",
            disabled: false,
          },
          {
            name: "17672, Walgreens, CHARLOTTE HALL, MD",
            disabled: false,
          },
          {
            name: "17673, Walgreens, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "17676, Walgreens, HIGHLAND, NY",
            disabled: false,
          },
          {
            name: "17679, Walgreens, GRANTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1768, CVS, OLYMPIA FIELDS, IL",
            disabled: false,
          },
          {
            name: "1768, Rite Aid, NORTHAMPTON, PA",
            disabled: false,
          },
          {
            name: "1768, Target, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "1768, Walmart, OREM, UT",
            disabled: false,
          },
          {
            name: "17680, Walgreens, HOWARD BEACH, NY",
            disabled: false,
          },
          {
            name: "17685, Walgreens, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "17686, Walgreens, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "1769, Albertsons, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "1769, CVS, LEESPORT, PA",
            disabled: false,
          },
          {
            name: "1769, Target, Superior, CO",
            disabled: false,
          },
          {
            name: "1769, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "1769, Walmart, DU BOIS, PA",
            disabled: false,
          },
          {
            name: "17690, Walgreens, NEW SALISBURY, IN",
            disabled: false,
          },
          {
            name: "17697, Walgreens, EAST ELLIJAY, GA",
            disabled: false,
          },
          {
            name: "177, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "177, CVS, WANTAGH, NY",
            disabled: false,
          },
          {
            name: "177, Meijer, WASHINGTON, MI",
            disabled: false,
          },
          {
            name: "177, Walmart, PARIS, TN",
            disabled: false,
          },
          {
            name: "1770, Albertsons, HOLMES, PA",
            disabled: false,
          },
          {
            name: "1770, CVS, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "1770, Target, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "1770, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "1770, Walmart, CRANBERRY TOWNSHIP, PA",
            disabled: false,
          },
          {
            name: "17701, Walgreens, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "17706, Walgreens, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "17708, Walgreens, BLUE HILL, ME",
            disabled: false,
          },
          {
            name: "1771, Albertsons, SAHUARITA, AZ",
            disabled: false,
          },
          {
            name: "1771, CVS, LUTZ, FL",
            disabled: false,
          },
          {
            name: "1771, Target, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "1771, Walmart, STURGIS, MI",
            disabled: false,
          },
          {
            name: "17715, Walgreens, HARTSVILLE, TN",
            disabled: false,
          },
          {
            name: "17717, Walgreens, GRANVILLE, NY",
            disabled: false,
          },
          {
            name: "1772, Target, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "1772, Walmart, KLAMATH FALLS, OR",
            disabled: false,
          },
          {
            name: "17722, Walgreens, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "17724, Walgreens, UTICA, NY",
            disabled: false,
          },
          {
            name: "17725, Walgreens, BRUNSWICK, ME",
            disabled: false,
          },
          {
            name: "17726, Walgreens, PAWCATUCK, CT",
            disabled: false,
          },
          {
            name: "17727, Walgreens, FLATWOODS, KY",
            disabled: false,
          },
          {
            name: "17728, Walgreens, EVERETT, MA",
            disabled: false,
          },
          {
            name: "1773, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1773, CVS, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "1773, Target, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "1773, Walmart, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "17731, Walgreens, RIDGEWOOD, NJ",
            disabled: false,
          },
          {
            name: "17732, Walgreens, DANIELSVILLE, GA",
            disabled: false,
          },
          {
            name: "17736, Walgreens, MONTICELLO, NY",
            disabled: false,
          },
          {
            name: "17738, Walgreens, SOUTH CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "1774, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "1774, Target, EAU CLAIRE, WI",
            disabled: false,
          },
          {
            name: "1774, Walmart, SANFORD, NC",
            disabled: false,
          },
          {
            name: "17741, Walgreens, ALLENDALE, SC",
            disabled: false,
          },
          {
            name: "17742, Walgreens, HOPATCONG, NJ",
            disabled: false,
          },
          {
            name: "17743, Walgreens, MONROE TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "17745, Walgreens, WINTHROP, ME",
            disabled: false,
          },
          {
            name: "17747, Walgreens, MILTON, VT",
            disabled: false,
          },
          {
            name: "1775, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1775, Walmart, LEBANON, OR",
            disabled: false,
          },
          {
            name: "1776, CVS, WHITE BEAR LAKE, MN",
            disabled: false,
          },
          {
            name: "1776, Target, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "1776, Walgreens, PLEASANT GROVE, UT",
            disabled: false,
          },
          {
            name: "1776, Walmart, WATERTOWN, WI",
            disabled: false,
          },
          {
            name: "17767, Walgreens, ESSEX, CT",
            disabled: false,
          },
          {
            name: "17768, Walgreens, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "1777, Albertsons, EDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "1777, CVS, AUBURN, AL",
            disabled: false,
          },
          {
            name: "1777, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "1777, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "1777, Walmart, READING, PA",
            disabled: false,
          },
          {
            name: "17776, Walgreens, BOONVILLE, NY",
            disabled: false,
          },
          {
            name: "1778, CVS, PASADENA, CA",
            disabled: false,
          },
          {
            name: "1778, Rite Aid, TINTON FALLS, NJ",
            disabled: false,
          },
          {
            name: "1778, Walmart, CODY, WY",
            disabled: false,
          },
          {
            name: "17781, Walgreens, BELLE, WV",
            disabled: false,
          },
          {
            name: "17783, Rite Aid, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "17784, Walgreens, WYTHEVILLE, VA",
            disabled: false,
          },
          {
            name: "17787, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "17788, Walgreens, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "1779, Albertsons, LAKEWAY, TX",
            disabled: false,
          },
          {
            name: "1779, Walmart, BRIDGEVIEW, IL",
            disabled: false,
          },
          {
            name: "17792, Walgreens, CHAPMANVILLE, WV",
            disabled: false,
          },
          {
            name: "17795, Walgreens, BLACKSHEAR, GA",
            disabled: false,
          },
          {
            name: "17796, Walgreens, MCKEE, KY",
            disabled: false,
          },
          {
            name: "17797, Walgreens, HARRISON, NJ",
            disabled: false,
          },
          {
            name: "17798, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "178, BJ's, NEWARK, DE",
            disabled: false,
          },
          {
            name: "178, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "178, Kroger, BRIGHAM CITY, UT",
            disabled: false,
          },
          {
            name: "178, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "178, Kroger, MADISON, WI",
            disabled: false,
          },
          {
            name: "178, Meijer, AURORA, IL",
            disabled: false,
          },
          {
            name: "178, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "178, Walmart, ALVA, OK",
            disabled: false,
          },
          {
            name: "1780, Albertsons, KELLER, TX",
            disabled: false,
          },
          {
            name: "1780, Rite Aid, WINDBER, PA",
            disabled: false,
          },
          {
            name: "1780, Target, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "1780, Walmart, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "17800, Walgreens, GALAX, VA",
            disabled: false,
          },
          {
            name: "17805, Walgreens, ATHENS, GA",
            disabled: false,
          },
          {
            name: "17806, Walgreens, BERKELEY SPRINGS, WV",
            disabled: false,
          },
          {
            name: "17807, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "1781, Albertsons, COPPELL, TX",
            disabled: false,
          },
          {
            name: "1781, CVS, LYNBROOK, NY",
            disabled: false,
          },
          {
            name: "1781, Walmart, CORTLAND, NY",
            disabled: false,
          },
          {
            name: "17817, Walgreens, WARTBURG, TN",
            disabled: false,
          },
          {
            name: "1782, Albertsons, CLARK, NJ",
            disabled: false,
          },
          {
            name: "1782, CVS, JACKSON, NJ",
            disabled: false,
          },
          {
            name: "1782, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "1782, Target, TULSA, OK",
            disabled: false,
          },
          {
            name: "1782, Walmart, VIENNA, WV",
            disabled: false,
          },
          {
            name: "17826, Walgreens, BARNESVILLE, OH",
            disabled: false,
          },
          {
            name: "17828, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1783, Albertsons, GARLAND, TX",
            disabled: false,
          },
          {
            name: "1783, Target, GRAND FORKS, ND",
            disabled: false,
          },
          {
            name: "1783, Walmart, PRINCETON, IN",
            disabled: false,
          },
          {
            name: "17830, Walgreens, MOUNT PLEASANT, TN",
            disabled: false,
          },
          {
            name: "17836, Walgreens, TIMONIUM, MD",
            disabled: false,
          },
          {
            name: "17838, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1784, Albertsons, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "1784, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1784, Walmart, SALEM, OR",
            disabled: false,
          },
          {
            name: "17843, Walgreens, KEYSVILLE, VA",
            disabled: false,
          },
          {
            name: "17845, Walgreens, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "1785, Albertsons, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "1785, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1785, Walmart, HUDSON, NH",
            disabled: false,
          },
          {
            name: "17852, Walgreens, ATHENS, GA",
            disabled: false,
          },
          {
            name: "17855, Walgreens, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "17856, Walgreens, WEST SAND LAKE, NY",
            disabled: false,
          },
          {
            name: "17857, Walgreens, FROSTBURG, MD",
            disabled: false,
          },
          {
            name: "17859, Walgreens, DISTRICT HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "1786, Albertsons, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "1786, CVS, LAWRENCE, MA",
            disabled: false,
          },
          {
            name: "1786, Target, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "1786, Walmart, EAGAN, MN",
            disabled: false,
          },
          {
            name: "17860, Walgreens, SOUTH GLENS FALLS, NY",
            disabled: false,
          },
          {
            name: "17861, Walgreens, SOUTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "17862, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "17863, Walgreens, KINGS MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "1787, Albertsons, SUSSEX, NJ",
            disabled: false,
          },
          {
            name: "1787, CVS, EASTON, PA",
            disabled: false,
          },
          {
            name: "1787, Target, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "1787, Walmart, CARROLL, IA",
            disabled: false,
          },
          {
            name: "17876, Walgreens, RIDGEWOOD, NY",
            disabled: false,
          },
          {
            name: "1788, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "1788, Target, AVON, IN",
            disabled: false,
          },
          {
            name: "1788, Walmart, SCARBOROUGH, ME",
            disabled: false,
          },
          {
            name: "17880, Walgreens, CHINA GROVE, NC",
            disabled: false,
          },
          {
            name: "17884, Walgreens, NORWELL, MA",
            disabled: false,
          },
          {
            name: "17885, Walgreens, SOUTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "1789, Albertsons, TROPHY CLUB, TX",
            disabled: false,
          },
          {
            name: "1789, Target, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "1789, Walmart, LODI, CA",
            disabled: false,
          },
          {
            name: "17890, Walgreens, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "17893, Walgreens, EAST LYME, CT",
            disabled: false,
          },
          {
            name: "17899, Walgreens, THOMASTON, CT",
            disabled: false,
          },
          {
            name: "179, ADUSA, SUMTER, SC",
            disabled: false,
          },
          {
            name: "179, Kroger, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "179, Kroger, Indian Wells, CA",
            disabled: false,
          },
          {
            name: "179, Kroger, Madison, WI",
            disabled: false,
          },
          {
            name: "179, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "179, Meijer, COLDWATER, MI",
            disabled: false,
          },
          {
            name: "179, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "1790, CVS, LAUREL, MD",
            disabled: false,
          },
          {
            name: "1790, Rite Aid, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "1790, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "1790, Walmart, MONROE, MI",
            disabled: false,
          },
          {
            name: "17900, Walgreens, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "17901, Walgreens, KING, NC",
            disabled: false,
          },
          {
            name: "17902, Walgreens, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "1791, Albertsons, WINDSOR, CO",
            disabled: false,
          },
          {
            name: "1791, Target, URBANDALE, IA",
            disabled: false,
          },
          {
            name: "1791, Walmart, FREMONT, MI",
            disabled: false,
          },
          {
            name: "17917, Walgreens, LAUREL, MD",
            disabled: false,
          },
          {
            name: "1792, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "1792, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "1792, Target, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "1792, Walmart, SAINT MARYS, PA",
            disabled: false,
          },
          {
            name: "17920, Walgreens, AMELIA COURT HOUSE, VA",
            disabled: false,
          },
          {
            name: "17922, Walgreens, WARSAW, VA",
            disabled: false,
          },
          {
            name: "17923, Walgreens, WATKINSVILLE, GA",
            disabled: false,
          },
          {
            name: "17925, Walgreens, SOUTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "17926, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "17928, Walgreens, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "17929, Walgreens, MOOSUP, CT",
            disabled: false,
          },
          {
            name: "1793, Rite Aid, CADIZ, OH",
            disabled: false,
          },
          {
            name: "1793, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1793, Walmart, WOODBURN, OR",
            disabled: false,
          },
          {
            name: "17935, Walgreens, SAINT MARYS, WV",
            disabled: false,
          },
          {
            name: "17936, Walgreens, PIKEVILLE, KY",
            disabled: false,
          },
          {
            name: "17938, Walgreens, WOBURN, MA",
            disabled: false,
          },
          {
            name: "1794, Albertsons, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "1794, Target, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1794, Walmart, BLOOMSBURG, PA",
            disabled: false,
          },
          {
            name: "17942, Walgreens, CHARLESTOWN, IN",
            disabled: false,
          },
          {
            name: "17943, Walgreens, BLAIRSVILLE, GA",
            disabled: false,
          },
          {
            name: "17944, Walgreens, EDGEWATER, MD",
            disabled: false,
          },
          {
            name: "17946, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "17949, Walgreens, MOUNDSVILLE, WV",
            disabled: false,
          },
          {
            name: "1795, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "1795, CVS, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "1795, Target, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "1795, Walmart, PISGAH FOREST, NC",
            disabled: false,
          },
          {
            name: "17950, Walgreens, LAWRENCEBURG, KY",
            disabled: false,
          },
          {
            name: "17951, Walgreens, NEW MARTINSVILLE, WV",
            disabled: false,
          },
          {
            name: "17952, Walgreens, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "17956, Walgreens, GREENVILLE, KY",
            disabled: false,
          },
          {
            name: "17957, Walgreens, UNION, NJ",
            disabled: false,
          },
          {
            name: "1796, Albertsons, YUCAIPA, CA",
            disabled: false,
          },
          {
            name: "1796, CVS, WHITE PLAINS, MD",
            disabled: false,
          },
          {
            name: "1796, Target, RENSSELAER, NY",
            disabled: false,
          },
          {
            name: "1796, Walmart, AMHERST, NH",
            disabled: false,
          },
          {
            name: "17964, Walgreens, DAMARISCOTTA, ME",
            disabled: false,
          },
          {
            name: "17966, Walgreens, ELKRIDGE, MD",
            disabled: false,
          },
          {
            name: "1797, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "1797, CVS, POOLESVILLE, MD",
            disabled: false,
          },
          {
            name: "1797, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1797, Walmart, THOMASTON, ME",
            disabled: false,
          },
          {
            name: "17971, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1798, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "1798, CVS, CHESTER, VA",
            disabled: false,
          },
          {
            name: "1798, Target, BRONX, NY",
            disabled: false,
          },
          {
            name: "1798, Walmart, CARO, MI",
            disabled: false,
          },
          {
            name: "17983, Walgreens, ALBANY, GA",
            disabled: false,
          },
          {
            name: "17987, Walgreens, PROVIDENCE FORGE, VA",
            disabled: false,
          },
          {
            name: "1799, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "1799, Target, MACHESNEY PARK, IL",
            disabled: false,
          },
          {
            name: "1799, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "1799, Walmart, PORTAGE, WI",
            disabled: false,
          },
          {
            name: "17990, Walgreens, MANCHESTER, ME",
            disabled: false,
          },
          {
            name: "17991, Walgreens, SNEEDVILLE, TN",
            disabled: false,
          },
          {
            name: "17997, Walgreens, MONTROSS, VA",
            disabled: false,
          },
          {
            name: "18, ADUSA, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "18, ADUSA, GLENSHAW, PA",
            disabled: false,
          },
          {
            name: "18, Albertsons, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "18, BJ's, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "18, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "18, Kroger, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "18, Kroger, AUGUSTA, KS",
            disabled: false,
          },
          {
            name: "18, Kroger, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "18, Kroger, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "18, Kroger, Santa Ana, CA",
            disabled: false,
          },
          {
            name: "18, Walmart, NEWPORT, AR",
            disabled: false,
          },
          {
            name: "180, Albertsons, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "180, BJ's, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "180, Costco, LANTANA, FL",
            disabled: false,
          },
          {
            name: "180, Kroger, GILLETTE, WY",
            disabled: false,
          },
          {
            name: "180, Kroger, Hollywood, CA",
            disabled: false,
          },
          {
            name: "180, Kroger, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "180, Kroger, SHOREWOOD HILLS, WI",
            disabled: false,
          },
          {
            name: "180, Meijer, GRAND HAVEN, MI",
            disabled: false,
          },
          {
            name: "180, Walmart, JACKSONVILLE, TX",
            disabled: false,
          },
          {
            name: "1800, Albertsons, SHERWOOD, OR",
            disabled: false,
          },
          {
            name: "1800, Rite Aid, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "1800, Target, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "1800, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "18000, Walgreens, OLD TOWN, ME",
            disabled: false,
          },
          {
            name: "18004, Walgreens, SACO, ME",
            disabled: false,
          },
          {
            name: "18005, Walgreens, PARIS, KY",
            disabled: false,
          },
          {
            name: "18006, Walgreens, POINT PLEASANT, WV",
            disabled: false,
          },
          {
            name: "1801, Albertsons, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "1801, CVS, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "1801, Rite Aid, CHARLEVOIX, MI",
            disabled: false,
          },
          {
            name: "1801, Target, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "1801, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "18010, Walgreens, MOREHEAD, KY",
            disabled: false,
          },
          {
            name: "18016, Walgreens, WILLIAMSTOWN, MA",
            disabled: false,
          },
          {
            name: "1802, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1802, Target, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "1802, Walmart, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "18020, Walgreens, MANCHESTER CENTER, VT",
            disabled: false,
          },
          {
            name: "18021, Walgreens, MAYNARDVILLE, TN",
            disabled: false,
          },
          {
            name: "1803, Albertsons, LAKE STEVENS, WA",
            disabled: false,
          },
          {
            name: "1803, CVS, WEST BRIDGEWATER, MA",
            disabled: false,
          },
          {
            name: "1803, Rite Aid, GARRETTSVILLE, OH",
            disabled: false,
          },
          {
            name: "1803, Target, SALEM, MA",
            disabled: false,
          },
          {
            name: "1803, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "18030, Walgreens, TICONDEROGA, NY",
            disabled: false,
          },
          {
            name: "18038, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "18039, Walgreens, OCEAN SPRINGS, MS",
            disabled: false,
          },
          {
            name: "1804, Albertsons, BOWIE, MD",
            disabled: false,
          },
          {
            name: "1804, CVS, NAPA, CA",
            disabled: false,
          },
          {
            name: "1804, Target, UNIVERSITY HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "1804, Walmart, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "18040, Walgreens, CENTERVILLE, TN",
            disabled: false,
          },
          {
            name: "1805, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1805, CVS, COATESVILLE, PA",
            disabled: false,
          },
          {
            name: "1805, Target, VISALIA, CA",
            disabled: false,
          },
          {
            name: "1805, Walmart, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "18053, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "18059, Walgreens, HINDMAN, KY",
            disabled: false,
          },
          {
            name: "1806, CVS, FOLEY, AL",
            disabled: false,
          },
          {
            name: "1806, Target, GLENDALE, CO",
            disabled: false,
          },
          {
            name: "1806, Walmart, GLOVERSVILLE, NY",
            disabled: false,
          },
          {
            name: "18064, Walgreens, CICERO, NY",
            disabled: false,
          },
          {
            name: "18065, Walgreens, ASHLAND, MA",
            disabled: false,
          },
          {
            name: "1807, Albertsons, EAGLE RIVER, AK",
            disabled: false,
          },
          {
            name: "1807, CVS, LEHIGH ACRES, FL",
            disabled: false,
          },
          {
            name: "1807, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1807, Target, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "1807, Walgreens, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "1807, Walmart, WEST BERLIN, NJ",
            disabled: false,
          },
          {
            name: "18072, Walgreens, MOUNT KISCO, NY",
            disabled: false,
          },
          {
            name: "18074, Walgreens, BROCKPORT, NY",
            disabled: false,
          },
          {
            name: "18076, Walgreens, WILLIAMSON, NY",
            disabled: false,
          },
          {
            name: "18079, Walgreens, WOODSTOCK, VA",
            disabled: false,
          },
          {
            name: "1808, Albertsons, KENAI, AK",
            disabled: false,
          },
          {
            name: "1808, Target, SPRING VALLEY, NY",
            disabled: false,
          },
          {
            name: "1808, Walmart, STEAMBOAT SPRINGS, CO",
            disabled: false,
          },
          {
            name: "18080, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "18087, Walgreens, CALLAO, VA",
            disabled: false,
          },
          {
            name: "18089, Walgreens, MCLEAN, VA",
            disabled: false,
          },
          {
            name: "1809, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1809, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1809, Walmart, JONESVILLE, MI",
            disabled: false,
          },
          {
            name: "18095, Walgreens, ALMA, GA",
            disabled: false,
          },
          {
            name: "181, BJ's, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "181, CVS, PLAISTOW, NH",
            disabled: false,
          },
          {
            name: "181, Costco, MIAMI LAKES, FL",
            disabled: false,
          },
          {
            name: "181, Kroger, Monona, WI",
            disabled: false,
          },
          {
            name: "181, Kroger, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "181, Meijer, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "181, Walmart, NEW BOSTON, TX",
            disabled: false,
          },
          {
            name: "1810, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "1810, Walmart, FISHKILL, NY",
            disabled: false,
          },
          {
            name: "18100, Walgreens, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "18101, Walgreens, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "18103, Walgreens, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "18107, Walgreens, SOUTHERN PINES, NC",
            disabled: false,
          },
          {
            name: "1811, Albertsons, WASILLA, AK",
            disabled: false,
          },
          {
            name: "1811, CVS, JACKSONVILLE BEACH, FL",
            disabled: false,
          },
          {
            name: "1811, Target, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "1811, Walmart, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "18112, Walgreens, HAMPDEN, ME",
            disabled: false,
          },
          {
            name: "18115, Walgreens, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "1812, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1812, CVS, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "1812, Target, Bee Cave, TX",
            disabled: false,
          },
          {
            name: "1812, Walmart, WOOSTER, OH",
            disabled: false,
          },
          {
            name: "18121, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "18124, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "18125, Walgreens, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "1813, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1813, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "1813, Target, GREELEY, CO",
            disabled: false,
          },
          {
            name: "1813, Walgreens, TARZANA, CA",
            disabled: false,
          },
          {
            name: "1813, Walmart, NEWARK, NY",
            disabled: false,
          },
          {
            name: "18132, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1814, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "1814, Rite Aid, WEST NEWTON, PA",
            disabled: false,
          },
          {
            name: "1814, Target, AMERICAN FORK, UT",
            disabled: false,
          },
          {
            name: "1814, Walmart, ELGIN, IL",
            disabled: false,
          },
          {
            name: "18148, Walgreens, CLANTON, AL",
            disabled: false,
          },
          {
            name: "1815, Albertsons, MOUNT AIRY, MD",
            disabled: false,
          },
          {
            name: "1815, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "1815, Target, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "1815, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "18155, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1816, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "1816, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1816, Target, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "1816, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1816, Walmart, KNIGHTDALE, NC",
            disabled: false,
          },
          {
            name: "18160, Walgreens, PASADENA, MD",
            disabled: false,
          },
          {
            name: "18163, Walgreens, GLENWOOD SPRINGS, CO",
            disabled: false,
          },
          {
            name: "18165, Walgreens, PRINCE FREDERICK, MD",
            disabled: false,
          },
          {
            name: "18166, Walgreens, FAYETTEVILLE, NY",
            disabled: false,
          },
          {
            name: "18168, Walgreens, MOUNT MORRIS, NY",
            disabled: false,
          },
          {
            name: "18169, Walgreens, WATERTOWN, CT",
            disabled: false,
          },
          {
            name: "1817, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "1817, CVS, LAKE CITY, FL",
            disabled: false,
          },
          {
            name: "1817, Walmart, HERMISTON, OR",
            disabled: false,
          },
          {
            name: "18170, Walgreens, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "18171, Walgreens, STANTON, KY",
            disabled: false,
          },
          {
            name: "18175, Walgreens, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "18178, Walgreens, MIDLAND, GA",
            disabled: false,
          },
          {
            name: "1818, Albertsons, KETCHIKAN, AK",
            disabled: false,
          },
          {
            name: "1818, Target, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "18183, Walgreens, WAREHAM, MA",
            disabled: false,
          },
          {
            name: "18185, Walgreens, GLENNVILLE, GA",
            disabled: false,
          },
          {
            name: "18188, Walgreens, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "1819, Albertsons, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "1819, CVS, STEPHENS CITY, VA",
            disabled: false,
          },
          {
            name: "1819, Target, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "1819, Walmart, MENOMONIE, WI",
            disabled: false,
          },
          {
            name: "18191, Walgreens, MORGAN CITY, LA",
            disabled: false,
          },
          {
            name: "18193, Walgreens, COLONIAL BEACH, VA",
            disabled: false,
          },
          {
            name: "18196, Walgreens, QUINTON, VA",
            disabled: false,
          },
          {
            name: "182, Albertsons, EAGLE, ID",
            disabled: false,
          },
          {
            name: "182, CVS, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "182, Costco, MIAMI, FL",
            disabled: false,
          },
          {
            name: "182, HEB, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "182, Kroger, Fitchburg, WI",
            disabled: false,
          },
          {
            name: "182, Kroger, ROCK SPRINGS, WY",
            disabled: false,
          },
          {
            name: "182, Kroger, San Dimas, CA",
            disabled: false,
          },
          {
            name: "182, Meijer, St. Charles, IL",
            disabled: false,
          },
          {
            name: "182, Walmart, GREENVILLE, MS",
            disabled: false,
          },
          {
            name: "1820, Albertsons, JUNEAU, AK",
            disabled: false,
          },
          {
            name: "1820, CVS, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "1820, Target, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "1820, Walmart, KITTANNING, PA",
            disabled: false,
          },
          {
            name: "18200, Walgreens, BOWLING GREEN, VA",
            disabled: false,
          },
          {
            name: "18204, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "18207, Walgreens, CAMBRIDGE, NY",
            disabled: false,
          },
          {
            name: "1821, Albertsons, NORTH POLE, AK",
            disabled: false,
          },
          {
            name: "1821, CVS, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "1821, Target, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "1821, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "18211, Walgreens, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "18215, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "18216, Walgreens, UTICA, NY",
            disabled: false,
          },
          {
            name: "1822, CVS, ROBERTSDALE, AL",
            disabled: false,
          },
          {
            name: "1822, Rite Aid, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "1822, Target, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "1822, Walmart, FAJARDO, PR",
            disabled: false,
          },
          {
            name: "18220, Walgreens, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "18225, Walgreens, MONROE, NY",
            disabled: false,
          },
          {
            name: "18226, Walgreens, CARTHAGE, NY",
            disabled: false,
          },
          {
            name: "18228, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "18229, Walgreens, EXMORE, VA",
            disabled: false,
          },
          {
            name: "1823, Target, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "1823, Walmart, HANOVER, PA",
            disabled: false,
          },
          {
            name: "18231, Walgreens, NORWOOD, MA",
            disabled: false,
          },
          {
            name: "1824, Albertsons, SOUTH LAKE TAHOE, CA",
            disabled: false,
          },
          {
            name: "1824, CVS, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "1824, Target, GARNER, NC",
            disabled: false,
          },
          {
            name: "18243, Walgreens, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "18245, Walgreens, NORTH EASTON, MA",
            disabled: false,
          },
          {
            name: "18248, Walgreens, CARIBOU, ME",
            disabled: false,
          },
          {
            name: "1825, Albertsons, POLLOCK PINES, CA",
            disabled: false,
          },
          {
            name: "1825, CVS, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "1825, Target, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "1825, Walmart, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "18250, Walgreens, CLEVELAND, GA",
            disabled: false,
          },
          {
            name: "18251, Walgreens, MEDINA, NY",
            disabled: false,
          },
          {
            name: "18255, Walgreens, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "18259, Walgreens, GREENVILLE, RI",
            disabled: false,
          },
          {
            name: "1826, Albertsons, REDDING, CA",
            disabled: false,
          },
          {
            name: "1826, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "1826, Target, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "1826, Walgreens, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1826, Walmart, VISALIA, CA",
            disabled: false,
          },
          {
            name: "18265, Walgreens, BRANDON, VT",
            disabled: false,
          },
          {
            name: "18266, Walgreens, WESTERLY, RI",
            disabled: false,
          },
          {
            name: "18268, Walgreens, WOLFEBORO, NH",
            disabled: false,
          },
          {
            name: "1827, Albertsons, LA GRANDE, OR",
            disabled: false,
          },
          {
            name: "1827, Target, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "1827, Walmart, PARK CITY, UT",
            disabled: false,
          },
          {
            name: "18274, Walgreens, PRINCETON JUNCTION, NJ",
            disabled: false,
          },
          {
            name: "18275, Walgreens, LOGAN, WV",
            disabled: false,
          },
          {
            name: "18277, Walgreens, ELIZABETH, NJ",
            disabled: false,
          },
          {
            name: "18278, Walgreens, WEST RUTLAND, VT",
            disabled: false,
          },
          {
            name: "1828, Albertsons, FIRESTONE, CO",
            disabled: false,
          },
          {
            name: "1828, Target, BRIDGEPORT, WV",
            disabled: false,
          },
          {
            name: "1828, Walmart, PLOVER, WI",
            disabled: false,
          },
          {
            name: "18281, Walgreens, NEWARK VALLEY, NY",
            disabled: false,
          },
          {
            name: "18284, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "18287, Walgreens, PORT WASHINGTON, NY",
            disabled: false,
          },
          {
            name: "18289, Walgreens, YORKVILLE, OH",
            disabled: false,
          },
          {
            name: "1829, Target, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "1829, Walmart, MARION, SC",
            disabled: false,
          },
          {
            name: "18291, Walgreens, NASHVILLE, GA",
            disabled: false,
          },
          {
            name: "18296, Walgreens, JOHNSTOWN, NY",
            disabled: false,
          },
          {
            name: "18298, Walgreens, BEALETON, VA",
            disabled: false,
          },
          {
            name: "18299, Walgreens, SCARBOROUGH, ME",
            disabled: false,
          },
          {
            name: "183, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "183, Albertsons, JACKSON, WY",
            disabled: false,
          },
          {
            name: "183, CVS, BILLERICA, MA",
            disabled: false,
          },
          {
            name: "183, Costco, ALTAMONTE SPRIN, FL",
            disabled: false,
          },
          {
            name: "183, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "183, Kroger, MADISON, WI",
            disabled: false,
          },
          {
            name: "183, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "183, Kroger, RIVERTON, WY",
            disabled: false,
          },
          {
            name: "183, Meijer, ELGIN, IL",
            disabled: false,
          },
          {
            name: "183, Target, PACOIMA, CA",
            disabled: false,
          },
          {
            name: "183, Walmart, LOUISVILLE, MS",
            disabled: false,
          },
          {
            name: "1830, Rite Aid, TOWANDA, PA",
            disabled: false,
          },
          {
            name: "1830, Target, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "1830, Walmart, AUBURN, NY",
            disabled: false,
          },
          {
            name: "18301, Walgreens, CORBIN, KY",
            disabled: false,
          },
          {
            name: "18303, Walgreens, CELINA, TN",
            disabled: false,
          },
          {
            name: "18304, Walgreens, RICH CREEK, VA",
            disabled: false,
          },
          {
            name: "18305, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "1831, CVS, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "1831, Target, CHAMPLIN, MN",
            disabled: false,
          },
          {
            name: "1831, Walmart, LIVERPOOL, NY",
            disabled: false,
          },
          {
            name: "18312, Walgreens, CLARK, NJ",
            disabled: false,
          },
          {
            name: "18316, Walgreens, DUXBURY, MA",
            disabled: false,
          },
          {
            name: "1832, Albertsons, HOMER, AK",
            disabled: false,
          },
          {
            name: "1832, Target, BLAINE, MN",
            disabled: false,
          },
          {
            name: "1832, Walmart, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "18320, Walgreens, ETOWAH, TN",
            disabled: false,
          },
          {
            name: "18321, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "18327, Walgreens, MOUNTAIN CITY, TN",
            disabled: false,
          },
          {
            name: "18329, Walgreens, HOMERVILLE, GA",
            disabled: false,
          },
          {
            name: "1833, Albertsons, VALDEZ, AK",
            disabled: false,
          },
          {
            name: "1833, Target, SAVAGE, MN",
            disabled: false,
          },
          {
            name: "1833, Walmart, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "18330, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "18337, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1834, Albertsons, UNALASKA, AK",
            disabled: false,
          },
          {
            name: "1834, Target, UPLAND, CA",
            disabled: false,
          },
          {
            name: "1834, Walmart, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "18340, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "18341, Walgreens, POOLER, GA",
            disabled: false,
          },
          {
            name: "18342, Walgreens, METHUEN, MA",
            disabled: false,
          },
          {
            name: "18344, Walgreens, HINTON, WV",
            disabled: false,
          },
          {
            name: "1835, Albertsons, NOME, AK",
            disabled: false,
          },
          {
            name: "1835, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1835, Target, MILLBURY, MA",
            disabled: false,
          },
          {
            name: "1835, Walmart, VESTAL, NY",
            disabled: false,
          },
          {
            name: "18350, Walgreens, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "18351, Walgreens, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "18352, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "18354, Walgreens, FAIR HAVEN, VT",
            disabled: false,
          },
          {
            name: "1836, CVS, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "1836, Target, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "1836, Walmart, ADRIAN, MI",
            disabled: false,
          },
          {
            name: "18361, Walgreens, QUINCY, MA",
            disabled: false,
          },
          {
            name: "18362, Walgreens, RUSSELL SPRINGS, KY",
            disabled: false,
          },
          {
            name: "18364, Walgreens, HONEOYE FALLS, NY",
            disabled: false,
          },
          {
            name: "18367, Walgreens, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "1837, CVS, FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "1837, Target, WEBSTER, TX",
            disabled: false,
          },
          {
            name: "1837, Walmart, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "18374, Walgreens, DADEVILLE, AL",
            disabled: false,
          },
          {
            name: "18375, Walgreens, MIDDLEBURY, VT",
            disabled: false,
          },
          {
            name: "18376, Walgreens, HERKIMER, NY",
            disabled: false,
          },
          {
            name: "1838, CVS, BRYANS ROAD, MD",
            disabled: false,
          },
          {
            name: "1838, Target, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "1838, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "18389, Walgreens, LYNDHURST, NJ",
            disabled: false,
          },
          {
            name: "1839, Albertsons, GIRDWOOD, AK",
            disabled: false,
          },
          {
            name: "1839, Rite Aid, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "1839, Target, HADLEY, MA",
            disabled: false,
          },
          {
            name: "1839, Walmart, LORAIN, OH",
            disabled: false,
          },
          {
            name: "18391, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "18397, Walgreens, MULLENS, WV",
            disabled: false,
          },
          {
            name: "184, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "184, BJ's, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "184, Costco, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "184, Kroger, JACKSON, WY",
            disabled: false,
          },
          {
            name: "184, Meijer, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "184, Target, Alhambra, CA",
            disabled: false,
          },
          {
            name: "184, Walmart, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "1840, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1840, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "1840, Walmart, MANTECA, CA",
            disabled: false,
          },
          {
            name: "18402, Walgreens, HIAWASSEE, GA",
            disabled: false,
          },
          {
            name: "18403, Walgreens, FRYEBURG, ME",
            disabled: false,
          },
          {
            name: "18404, Walgreens, RAINELLE, WV",
            disabled: false,
          },
          {
            name: "18409, Walgreens, BIDDEFORD, ME",
            disabled: false,
          },
          {
            name: "1841, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1841, Albertsons, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "1841, Target, NORTHFIELD, OH",
            disabled: false,
          },
          {
            name: "1841, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "18411, Walgreens, GUILFORD, ME",
            disabled: false,
          },
          {
            name: "18412, Walgreens, OZONE PARK, NY",
            disabled: false,
          },
          {
            name: "18414, Walgreens, LIVERMORE FALLS, ME",
            disabled: false,
          },
          {
            name: "18416, Walgreens, FAIRFIELD, ME",
            disabled: false,
          },
          {
            name: "18418, Walgreens, BRATTLEBORO, VT",
            disabled: false,
          },
          {
            name: "18419, Walgreens, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1842, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "1842, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1842, Target, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "1842, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "18421, Walgreens, SOUTHBRIDGE, MA",
            disabled: false,
          },
          {
            name: "18423, Walgreens, HARRISVILLE, WV",
            disabled: false,
          },
          {
            name: "18425, Walgreens, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "18427, Walgreens, BEATTYVILLE, KY",
            disabled: false,
          },
          {
            name: "18429, Walgreens, STERLING, VA",
            disabled: false,
          },
          {
            name: "1843, Target, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "1843, Walmart, MCMINNVILLE, OR",
            disabled: false,
          },
          {
            name: "18431, Walgreens, KENNEBUNK, ME",
            disabled: false,
          },
          {
            name: "1844, Albertsons, ORTING, WA",
            disabled: false,
          },
          {
            name: "1844, CVS, LUNENBURG, MA",
            disabled: false,
          },
          {
            name: "1844, Walmart, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "1845, CVS, WILMINGTON, MA",
            disabled: false,
          },
          {
            name: "1845, Target, Wilkes-Barre Township, PA",
            disabled: false,
          },
          {
            name: "1845, Walmart, COOPER CITY, FL",
            disabled: false,
          },
          {
            name: "1846, Albertsons, FAIR OAKS, CA",
            disabled: false,
          },
          {
            name: "1846, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "1846, Walmart, DOUGLAS, AZ",
            disabled: false,
          },
          {
            name: "1847, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "1847, CVS, VIENNA, VA",
            disabled: false,
          },
          {
            name: "1847, Target, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "1847, Walgreens, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "1847, Walmart, OCALA, FL",
            disabled: false,
          },
          {
            name: "1848, CVS, BELMONT, MA",
            disabled: false,
          },
          {
            name: "1848, Target, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "1848, Walmart, GLEN ELLYN, IL",
            disabled: false,
          },
          {
            name: "1849, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1849, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "1849, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "185, Albertsons, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "185, CVS, SEYMOUR, CT",
            disabled: false,
          },
          {
            name: "185, Costco, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "185, Kroger, CASPER, WY",
            disabled: false,
          },
          {
            name: "185, Kroger, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "185, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "185, Kroger, Manitowoc, WI",
            disabled: false,
          },
          {
            name: "185, Meijer, AUBURN HILLS, MI",
            disabled: false,
          },
          {
            name: "185, Rite Aid, SOUDERTON, PA",
            disabled: false,
          },
          {
            name: "185, Walmart, GAINESVILLE, TX",
            disabled: false,
          },
          {
            name: "1850, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1850, CVS, SANDWICH, MA",
            disabled: false,
          },
          {
            name: "1850, Target, ADDISON, TX",
            disabled: false,
          },
          {
            name: "1850, Walmart, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "1851, Albertsons, BLAIRSTOWN, NJ",
            disabled: false,
          },
          {
            name: "1851, Target, GILROY, CA",
            disabled: false,
          },
          {
            name: "1851, Walgreens, NATICK, MA",
            disabled: false,
          },
          {
            name: "1851, Walmart, NORTH LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "1852, CVS, MEDWAY, MA",
            disabled: false,
          },
          {
            name: "1852, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1852, Walmart, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "1853, CVS, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "1853, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1853, Walmart, HEMET, CA",
            disabled: false,
          },
          {
            name: "1854, Albertsons, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "1854, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "1854, Target, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1854, Walmart, HATILLO, PR",
            disabled: false,
          },
          {
            name: "1855, CVS, SHARON, MA",
            disabled: false,
          },
          {
            name: "1855, Target, BANGOR, ME",
            disabled: false,
          },
          {
            name: "1855, Walgreens, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "1855, Walmart, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "1856, Albertsons, WEST NEW YORK, NJ",
            disabled: false,
          },
          {
            name: "1856, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "1856, Target, Poughkeepsie, NY",
            disabled: false,
          },
          {
            name: "1856, Walmart, BANGOR, ME",
            disabled: false,
          },
          {
            name: "1857, CVS, ORLEANS, MA",
            disabled: false,
          },
          {
            name: "1857, Target, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "1857, Walmart, MENTOR, OH",
            disabled: false,
          },
          {
            name: "1858, Albertsons, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "1858, Target, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "1858, Walmart, MONTEVIDEO, MN",
            disabled: false,
          },
          {
            name: "1859, CVS, HARWICH, MA",
            disabled: false,
          },
          {
            name: "1859, Rite Aid, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "1859, Target, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "1859, Walmart, CALEXICO, CA",
            disabled: false,
          },
          {
            name: "186, Albertsons, KINGSTON, WA",
            disabled: false,
          },
          {
            name: "186, BJ's, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "186, Costco, MORROW, GA",
            disabled: false,
          },
          {
            name: "186, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "186, Kroger, Green Bay, WI",
            disabled: false,
          },
          {
            name: "186, Kroger, LACEY, WA",
            disabled: false,
          },
          {
            name: "186, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "186, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "186, Meijer, WEST LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "186, Rite Aid, NEW BRITAIN, PA",
            disabled: false,
          },
          {
            name: "186, Walmart, EL DORADO, KS",
            disabled: false,
          },
          {
            name: "1860, CVS, HOLLISTON, MA",
            disabled: false,
          },
          {
            name: "1860, Rite Aid, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "1860, Target, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "1860, Walmart, ELKTON, MD",
            disabled: false,
          },
          {
            name: "1861, Target, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "1861, Walmart, OAK PARK HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "1862, CVS, CHESTNUT HILL, MA",
            disabled: false,
          },
          {
            name: "1862, Rite Aid, SILVER CREEK, NY",
            disabled: false,
          },
          {
            name: "1862, Target, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "1862, Walmart, RIALTO, CA",
            disabled: false,
          },
          {
            name: "1863, Albertsons, DELTA, CO",
            disabled: false,
          },
          {
            name: "1863, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "1863, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1863, Walgreens, LEXINGTON, MA",
            disabled: false,
          },
          {
            name: "1863, Walmart, EASTLAKE, OH",
            disabled: false,
          },
          {
            name: "1864, Albertsons, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "1864, CVS, ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "1864, Target, ROCKAWAY, NJ",
            disabled: false,
          },
          {
            name: "1864, Walgreens, ARLINGTON, MA",
            disabled: false,
          },
          {
            name: "1864, Walmart, BROOKLYN PARK, MN",
            disabled: false,
          },
          {
            name: "1865, CVS, PEMBROKE, MA",
            disabled: false,
          },
          {
            name: "1865, Target, NORTH BERGEN, NJ",
            disabled: false,
          },
          {
            name: "1865, Walmart, REDWOOD FALLS, MN",
            disabled: false,
          },
          {
            name: "1866, Albertsons, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "1866, CVS, MANSFIELD, MA",
            disabled: false,
          },
          {
            name: "1866, Rite Aid, ATCO, NJ",
            disabled: false,
          },
          {
            name: "1866, Target, FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "1866, Walmart, FARMINGTON, ME",
            disabled: false,
          },
          {
            name: "1867, CVS, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "1867, Rite Aid, EDGEWATER PARK, NJ",
            disabled: false,
          },
          {
            name: "1867, Target, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "1867, Walmart, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "1868, Target, SHERWOOD, OR",
            disabled: false,
          },
          {
            name: "1868, Walmart, AUBURN, ME",
            disabled: false,
          },
          {
            name: "1869, CVS, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "1869, Target, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "1869, Walmart, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "187, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "187, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "187, Costco, DULUTH, GA",
            disabled: false,
          },
          {
            name: "187, Kroger, Appleton, WI",
            disabled: false,
          },
          {
            name: "187, Kroger, GREEN RIVER, WY",
            disabled: false,
          },
          {
            name: "187, Kroger, Tustin, CA",
            disabled: false,
          },
          {
            name: "187, Meijer, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "1870, Rite Aid, WHITEHOUSE STATION, NJ",
            disabled: false,
          },
          {
            name: "1870, Target, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "1870, Walgreens, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "1870, Walmart, PULLMAN, WA",
            disabled: false,
          },
          {
            name: "1871, CVS, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "1871, Target, ABINGDON, MD",
            disabled: false,
          },
          {
            name: "1871, Walmart, WATERTOWN, NY",
            disabled: false,
          },
          {
            name: "1872, CVS, MIDDLEBOROUGH, MA",
            disabled: false,
          },
          {
            name: "1872, Target, DURHAM, NC",
            disabled: false,
          },
          {
            name: "1872, Walmart, HELENA, MT",
            disabled: false,
          },
          {
            name: "1873, Albertsons, THORNTON, CO",
            disabled: false,
          },
          {
            name: "1873, CVS, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "1873, Target, GAINESVILLE, VA",
            disabled: false,
          },
          {
            name: "1873, Walmart, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "1874, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1874, CVS, WAYLAND, MA",
            disabled: false,
          },
          {
            name: "1874, Target, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "1874, Walmart, ENGLEWOOD, FL",
            disabled: false,
          },
          {
            name: "1875, CVS, ASHLAND, MA",
            disabled: false,
          },
          {
            name: "1875, Target, YORK, PA",
            disabled: false,
          },
          {
            name: "1875, Walgreens, HILLSDALE, NJ",
            disabled: false,
          },
          {
            name: "1875, Walmart, SEVERN, MD",
            disabled: false,
          },
          {
            name: "1876, CVS, BOSTON, MA",
            disabled: false,
          },
          {
            name: "1876, Target, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "1876, Walmart, HOOD RIVER, OR",
            disabled: false,
          },
          {
            name: "1877, Albertsons, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "1877, CVS, NORTON, MA",
            disabled: false,
          },
          {
            name: "1877, Target, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "1877, Walmart, PORTERVILLE, CA",
            disabled: false,
          },
          {
            name: "1878, Target, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "1878, Walmart, REXBURG, ID",
            disabled: false,
          },
          {
            name: "1879, Albertsons, MILPITAS, CA",
            disabled: false,
          },
          {
            name: "1879, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1879, Walgreens, FORT LEE, NJ",
            disabled: false,
          },
          {
            name: "1879, Walmart, BARSTOW, CA",
            disabled: false,
          },
          {
            name: "188, Albertsons, RENO, NV",
            disabled: false,
          },
          {
            name: "188, BJ's, TAMPA, FL",
            disabled: false,
          },
          {
            name: "188, CVS, LARGO, FL",
            disabled: false,
          },
          {
            name: "188, Costco, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "188, Kroger, DANA POINT, CA",
            disabled: false,
          },
          {
            name: "188, Kroger, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "188, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "188, Meijer, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "188, Rite Aid, HUNTINGDON VALLEY, PA",
            disabled: false,
          },
          {
            name: "188, Target, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "188, Walmart, CAPE GIRARDEAU, MO",
            disabled: false,
          },
          {
            name: "1880, Albertsons, PARKVILLE, MD",
            disabled: false,
          },
          {
            name: "1880, Target, SHEBOYGAN FALLS, WI",
            disabled: false,
          },
          {
            name: "1880, Walmart, COOS BAY, OR",
            disabled: false,
          },
          {
            name: "1881, CVS, DUNKIRK, MD",
            disabled: false,
          },
          {
            name: "1881, Target, SHOREWOOD, IL",
            disabled: false,
          },
          {
            name: "1881, Walgreens, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "1881, Walmart, ANTELOPE, CA",
            disabled: false,
          },
          {
            name: "1882, Albertsons, FORT WASHINGTON, MD",
            disabled: false,
          },
          {
            name: "1882, CVS, FITCHBURG, MA",
            disabled: false,
          },
          {
            name: "1882, Rite Aid, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "1882, Target, WILLOWBROOK, IL",
            disabled: false,
          },
          {
            name: "1882, Walmart, SELMA, CA",
            disabled: false,
          },
          {
            name: "1883, Albertsons, AMERICAN CANYON, CA",
            disabled: false,
          },
          {
            name: "1883, Target, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "1883, Walmart, MONACA, PA",
            disabled: false,
          },
          {
            name: "1884, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1884, Target, West Hollywood, CA",
            disabled: false,
          },
          {
            name: "1884, Walmart, DICKSON CITY, PA",
            disabled: false,
          },
          {
            name: "1885, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1885, CVS, LITTLETON, MA",
            disabled: false,
          },
          {
            name: "1885, Target, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "1885, Walmart, BUTLER, PA",
            disabled: false,
          },
          {
            name: "1886, CVS, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "1886, Target, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "1886, Walmart, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "1887, Albertsons, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "1887, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1887, Target, Mount Vernon, NY",
            disabled: false,
          },
          {
            name: "1887, Walmart, MONTOURSVILLE, PA",
            disabled: false,
          },
          {
            name: "1888, Albertsons, BEND, OR",
            disabled: false,
          },
          {
            name: "1888, CVS, WESTWOOD, MA",
            disabled: false,
          },
          {
            name: "1888, Target, NORRIDGE, IL",
            disabled: false,
          },
          {
            name: "1888, Walmart, NORTH LOGAN, UT",
            disabled: false,
          },
          {
            name: "1889, Albertsons, ALOHA, OR",
            disabled: false,
          },
          {
            name: "1889, CVS, BRIGHTON, MA",
            disabled: false,
          },
          {
            name: "1889, Rite Aid, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "1889, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1889, Walmart, ISLAND CITY, OR",
            disabled: false,
          },
          {
            name: "189, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "189, BJ's, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "189, Costco, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "189, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "189, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "189, Kroger, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "189, Kroger, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "189, Meijer, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "189, Target, COMMERCE, CA",
            disabled: false,
          },
          {
            name: "189, Walmart, KIRKSVILLE, MO",
            disabled: false,
          },
          {
            name: "1890, Albertsons, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "1890, Target, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "1890, Walmart, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "1891, Albertsons, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "1891, CVS, HAZLETON, PA",
            disabled: false,
          },
          {
            name: "1891, Target, CONWAY, AR",
            disabled: false,
          },
          {
            name: "1891, Walmart, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "1892, Albertsons, CORTEZ, CO",
            disabled: false,
          },
          {
            name: "1892, Target, Raleigh, NC",
            disabled: false,
          },
          {
            name: "1892, Walmart, HODGKINS, IL",
            disabled: false,
          },
          {
            name: "1893, Target, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1893, Walmart, BOWIE, MD",
            disabled: false,
          },
          {
            name: "1894, CVS, SHAMOKIN, PA",
            disabled: false,
          },
          {
            name: "1894, Rite Aid, DOVER, PA",
            disabled: false,
          },
          {
            name: "1894, Target, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "1894, Walmart, MEDINA, OH",
            disabled: false,
          },
          {
            name: "18946, Walgreens, JOPPA, MD",
            disabled: false,
          },
          {
            name: "18949, Walgreens, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "1895, Albertsons, FAIR OAKS, CA",
            disabled: false,
          },
          {
            name: "1895, Target, WEST MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "1895, Walmart, FAIRLAWN, OH",
            disabled: false,
          },
          {
            name: "18950, Walgreens, JELLICO, TN",
            disabled: false,
          },
          {
            name: "18951, Walgreens, GAMBRILLS, MD",
            disabled: false,
          },
          {
            name: "18956, Walgreens, RANSON, WV",
            disabled: false,
          },
          {
            name: "18959, Walgreens, MANNINGTON, WV",
            disabled: false,
          },
          {
            name: "1896, Albertsons, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "1896, CVS, ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "1896, Target, SOUTH ELGIN, IL",
            disabled: false,
          },
          {
            name: "1896, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "18968, Walgreens, HOLDEN, MA",
            disabled: false,
          },
          {
            name: "18969, Walgreens, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1897, Albertsons, SANTEE, CA",
            disabled: false,
          },
          {
            name: "1897, CVS, NEWTOWN, CT",
            disabled: false,
          },
          {
            name: "1897, Rite Aid, WHEELERSBURG, OH",
            disabled: false,
          },
          {
            name: "1897, Target, DISTRICT HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "1897, Walmart, ELK GROVE VILLAGE, IL",
            disabled: false,
          },
          {
            name: "18974, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "18975, Walgreens, WATERTOWN, CT",
            disabled: false,
          },
          {
            name: "18978, Walgreens, CHATHAM, NY",
            disabled: false,
          },
          {
            name: "1898, CVS, OLD GREENWICH, CT",
            disabled: false,
          },
          {
            name: "1898, Target, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "1898, Walmart, SAINT CHARLES, IL",
            disabled: false,
          },
          {
            name: "18980, Walgreens, GREENVILLE, NY",
            disabled: false,
          },
          {
            name: "18984, Walgreens, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "18986, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "18988, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1899, Albertsons, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "1899, CVS, LYNN, MA",
            disabled: false,
          },
          {
            name: "1899, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1899, Walmart, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "18994, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "18997, Walgreens, EGG HARBOR TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "19, ADUSA, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "19, Albertsons, LEWISTOWN, MT",
            disabled: false,
          },
          {
            name: "19, BJ's, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "19, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "19, Costco, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "19, HEB, LYTLE, TX",
            disabled: false,
          },
          {
            name: "19, Kroger, AUBURN, WA",
            disabled: false,
          },
          {
            name: "19, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "19, Kroger, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "19, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "19, Kroger, Tucson, AZ",
            disabled: false,
          },
          {
            name: "19, Meijer, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "19, Target, TULSA, OK",
            disabled: false,
          },
          {
            name: "19, Walmart, POPLAR BLUFF, MO",
            disabled: false,
          },
          {
            name: "190, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "190, BJ's, NORTH BERGEN, NJ",
            disabled: false,
          },
          {
            name: "190, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "190, Kroger, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "190, Kroger, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "190, Kroger, OXNARD, CA",
            disabled: false,
          },
          {
            name: "190, Meijer, ANGOLA, IN",
            disabled: false,
          },
          {
            name: "190, Rite Aid, FRANKLIN, NH",
            disabled: false,
          },
          {
            name: "190, Target, SOUTH GATE, CA",
            disabled: false,
          },
          {
            name: "190, Walmart, KENNETT, MO",
            disabled: false,
          },
          {
            name: "1900, Walmart, BURLEY, ID",
            disabled: false,
          },
          {
            name: "19002, Walgreens, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "19006, Walgreens, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "19008, Walgreens, ROXBORO, NC",
            disabled: false,
          },
          {
            name: "1901, CVS, BANGOR, PA",
            disabled: false,
          },
          {
            name: "1901, Target, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "1901, Walmart, BUTTE, MT",
            disabled: false,
          },
          {
            name: "19011, Walgreens, ROYSTON, GA",
            disabled: false,
          },
          {
            name: "1902, Rite Aid, SPRING GROVE, PA",
            disabled: false,
          },
          {
            name: "1902, Target, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "1902, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1902, Walmart, AMMON, ID",
            disabled: false,
          },
          {
            name: "19020, Walgreens, SUSSEX, NJ",
            disabled: false,
          },
          {
            name: "1903, CVS, BLOOMFIELD, CT",
            disabled: false,
          },
          {
            name: "1903, Target, WARRENVILLE, IL",
            disabled: false,
          },
          {
            name: "1903, Walmart, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "19032, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "19035, Walgreens, JAMAICA, NY",
            disabled: false,
          },
          {
            name: "1904, Target, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "1904, Walmart, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "19047, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "19049, Walgreens, MATTYDALE, NY",
            disabled: false,
          },
          {
            name: "1905, CVS, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "1905, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1905, Walmart, BLACKFOOT, ID",
            disabled: false,
          },
          {
            name: "19051, Walgreens, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "19057, Walgreens, WILLISTON, SC",
            disabled: false,
          },
          {
            name: "19058, Walgreens, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "1906, Target, HANFORD, CA",
            disabled: false,
          },
          {
            name: "1906, Walmart, FAIRHAVEN, MA",
            disabled: false,
          },
          {
            name: "19061, Walgreens, STONE RIDGE, NY",
            disabled: false,
          },
          {
            name: "19066, Walgreens, HARRISBURG, NC",
            disabled: false,
          },
          {
            name: "1907, CVS, WEST SAYVILLE, NY",
            disabled: false,
          },
          {
            name: "1907, Target, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "1907, Walmart, HINSDALE, NH",
            disabled: false,
          },
          {
            name: "19074, Walgreens, SMITHVILLE, TN",
            disabled: false,
          },
          {
            name: "19075, Walgreens, BERLIN, NH",
            disabled: false,
          },
          {
            name: "19078, Walgreens, WESTBROOK, ME",
            disabled: false,
          },
          {
            name: "19079, Walgreens, ASHLAND, MA",
            disabled: false,
          },
          {
            name: "1908, Albertsons, BROWNS MILLS, NJ",
            disabled: false,
          },
          {
            name: "1908, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "1908, Target, KATY, TX",
            disabled: false,
          },
          {
            name: "1908, Walmart, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "19086, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "19087, Walgreens, ENDICOTT, NY",
            disabled: false,
          },
          {
            name: "1909, Albertsons, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "1909, CVS, ELKRIDGE, MD",
            disabled: false,
          },
          {
            name: "1909, Walmart, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "19091, Walgreens, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "19094, Walgreens, SHINNSTON, WV",
            disabled: false,
          },
          {
            name: "19095, Walgreens, PENNINGTON GAP, VA",
            disabled: false,
          },
          {
            name: "19096, Walgreens, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "19098, Walgreens, JEFFERSON, NC",
            disabled: false,
          },
          {
            name: "191, Albertsons, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "191, BJ's, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "191, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "191, Kroger, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "191, Kroger, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "191, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "191, Kroger, PLOVER, WI",
            disabled: false,
          },
          {
            name: "191, Meijer, PLAINWELL, MI",
            disabled: false,
          },
          {
            name: "1910, Albertsons, MAPLE SHADE, NJ",
            disabled: false,
          },
          {
            name: "1910, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1910, Target, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "1910, Walgreens, HOWELL, MI",
            disabled: false,
          },
          {
            name: "1910, Walmart, CRESCENT CITY, CA",
            disabled: false,
          },
          {
            name: "19103, Walgreens, BOULDER, CO",
            disabled: false,
          },
          {
            name: "19104, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "19107, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "1911, Albertsons, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "1911, CVS, DOVER, DE",
            disabled: false,
          },
          {
            name: "1911, Target, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "1911, Walmart, AKRON, OH",
            disabled: false,
          },
          {
            name: "19110, Walgreens, ABSECON, NJ",
            disabled: false,
          },
          {
            name: "19111, Walgreens, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "19113, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "19115, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1912, Albertsons, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "1912, CVS, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "1912, Rite Aid, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "1912, Target, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "1912, Walmart, CORONA, CA",
            disabled: false,
          },
          {
            name: "19124, Walgreens, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "19129, Walgreens, REISTERSTOWN, MD",
            disabled: false,
          },
          {
            name: "1913, Albertsons, OXNARD, CA",
            disabled: false,
          },
          {
            name: "1913, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1913, Rite Aid, YOUNGSTOWN, NY",
            disabled: false,
          },
          {
            name: "1913, Target, MUNSTER, IN",
            disabled: false,
          },
          {
            name: "1913, Walgreens, CORINTH, MS",
            disabled: false,
          },
          {
            name: "1913, Walmart, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "1914, Albertsons, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "1914, CVS, LEBANON, PA",
            disabled: false,
          },
          {
            name: "1914, Target, OSAGE BEACH, MO",
            disabled: false,
          },
          {
            name: "1914, Walmart, HIGHLAND, CA",
            disabled: false,
          },
          {
            name: "19141, Walgreens, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "19144, Walgreens, FALLSTON, MD",
            disabled: false,
          },
          {
            name: "19145, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "19147, Walgreens, FITZGERALD, GA",
            disabled: false,
          },
          {
            name: "19148, Walgreens, ILION, NY",
            disabled: false,
          },
          {
            name: "19149, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1915, Target, LATHAM, NY",
            disabled: false,
          },
          {
            name: "1915, Walmart, YUCCA VALLEY, CA",
            disabled: false,
          },
          {
            name: "19152, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1916, CVS, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "1916, Target, NORTH HAVEN, CT",
            disabled: false,
          },
          {
            name: "1916, Walgreens, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "1916, Walmart, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "19160, Walgreens, SYLVA, NC",
            disabled: false,
          },
          {
            name: "19162, Walgreens, AUBURN, ME",
            disabled: false,
          },
          {
            name: "19165, Walgreens, NORTH SMITHFIELD, RI",
            disabled: false,
          },
          {
            name: "19168, Walgreens, PARK CITY, UT",
            disabled: false,
          },
          {
            name: "1917, Albertsons, DISCOVERY BAY, CA",
            disabled: false,
          },
          {
            name: "1917, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1917, Rite Aid, CLAYTON, NJ",
            disabled: false,
          },
          {
            name: "1917, Target, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "1917, Walmart, SANTEE, CA",
            disabled: false,
          },
          {
            name: "19170, Walgreens, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "1918, CVS, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "1918, Target, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "1918, Walmart, BELLINGHAM, MA",
            disabled: false,
          },
          {
            name: "19184, Walgreens, PASSAIC, NJ",
            disabled: false,
          },
          {
            name: "19189, Walgreens, NARRAGANSETT, RI",
            disabled: false,
          },
          {
            name: "1919, CVS, PHILIPSBURG, PA",
            disabled: false,
          },
          {
            name: "1919, Target, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "1919, Walmart, LINCOLN, ME",
            disabled: false,
          },
          {
            name: "19190, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "19191, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "19197, Walgreens, CHAPIN, SC",
            disabled: false,
          },
          {
            name: "192, ADUSA, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "192, ADUSA, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "192, Albertsons, PAOLI, PA",
            disabled: false,
          },
          {
            name: "192, BJ's, MANAHAWKIN, NJ",
            disabled: false,
          },
          {
            name: "192, Kroger, BREA, CA",
            disabled: false,
          },
          {
            name: "192, Kroger, Galax, VA",
            disabled: false,
          },
          {
            name: "192, Meijer, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "192, Target, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "192, Walmart, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "1920, Albertsons, MCLEAN, VA",
            disabled: false,
          },
          {
            name: "1920, CVS, LEBANON, PA",
            disabled: false,
          },
          {
            name: "1920, Target, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "1920, Walmart, SALEM, OR",
            disabled: false,
          },
          {
            name: "19207, Walgreens, KINNELON, NJ",
            disabled: false,
          },
          {
            name: "19209, Walgreens, CLENDENIN, WV",
            disabled: false,
          },
          {
            name: "1921, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1921, Walmart, MANAHAWKIN, NJ",
            disabled: false,
          },
          {
            name: "19210, Walgreens, INWOOD, WV",
            disabled: false,
          },
          {
            name: "19212, Walgreens, TIMONIUM, MD",
            disabled: false,
          },
          {
            name: "19215, Walgreens, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "19219, Walgreens, WAYNESVILLE, NC",
            disabled: false,
          },
          {
            name: "1922, Albertsons, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "1922, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1922, Rite Aid, QUARRYVILLE, PA",
            disabled: false,
          },
          {
            name: "1922, Target, BURLESON, TX",
            disabled: false,
          },
          {
            name: "1922, Walmart, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "19220, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1923, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1923, CVS, SINKING SPRING, PA",
            disabled: false,
          },
          {
            name: "1923, Target, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "1923, Walmart, COMSTOCK PARK, MI",
            disabled: false,
          },
          {
            name: "19231, Walgreens, LOUDON, TN",
            disabled: false,
          },
          {
            name: "19233, Walgreens, BELLOWS FALLS, VT",
            disabled: false,
          },
          {
            name: "19234, Walgreens, SPRING LAKE, NJ",
            disabled: false,
          },
          {
            name: "19239, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "1924, CVS, ZACHARY, LA",
            disabled: false,
          },
          {
            name: "1924, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "1924, Walmart, PRESQUE ISLE, ME",
            disabled: false,
          },
          {
            name: "19240, Walgreens, DUDLEY, MA",
            disabled: false,
          },
          {
            name: "19241, Walgreens, FORT KENT, ME",
            disabled: false,
          },
          {
            name: "19244, Walgreens, JEWETT CITY, CT",
            disabled: false,
          },
          {
            name: "19249, Walgreens, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "1925, Albertsons, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "1925, CVS, FARMINGTON, NY",
            disabled: false,
          },
          {
            name: "1925, Rite Aid, GLASSPORT, PA",
            disabled: false,
          },
          {
            name: "1925, Target, OAK CREEK, WI",
            disabled: false,
          },
          {
            name: "1925, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "1925, Walmart, NEWPORT, OR",
            disabled: false,
          },
          {
            name: "19250, Walgreens, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "19251, Walgreens, CORNISH, ME",
            disabled: false,
          },
          {
            name: "19253, Walgreens, MILO, ME",
            disabled: false,
          },
          {
            name: "19254, Walgreens, WILSON, NC",
            disabled: false,
          },
          {
            name: "19255, Walgreens, SPANISH FORT, AL",
            disabled: false,
          },
          {
            name: "19256, Walgreens, ANNISTON, AL",
            disabled: false,
          },
          {
            name: "19258, Walgreens, FAIRMONT, WV",
            disabled: false,
          },
          {
            name: "1926, Albertsons, HANOVER, MD",
            disabled: false,
          },
          {
            name: "1926, Target, ALBANY, CA",
            disabled: false,
          },
          {
            name: "1926, Walmart, OSWEGO, NY",
            disabled: false,
          },
          {
            name: "19263, Walgreens, CUMBERLAND, RI",
            disabled: false,
          },
          {
            name: "19265, Walgreens, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "19267, Walgreens, WOODBURY, TN",
            disabled: false,
          },
          {
            name: "19268, Walgreens, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "1927, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1927, Walmart, MACEDONIA, OH",
            disabled: false,
          },
          {
            name: "19273, Walgreens, DURANGO, CO",
            disabled: false,
          },
          {
            name: "19278, Walgreens, ASBURY PARK, NJ",
            disabled: false,
          },
          {
            name: "1928, Albertsons, AURORA, CO",
            disabled: false,
          },
          {
            name: "1928, Target, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "1928, Walmart, FLINT, MI",
            disabled: false,
          },
          {
            name: "19282, Walgreens, EGG HARBOR CITY, NJ",
            disabled: false,
          },
          {
            name: "19285, Walgreens, GARDINER, ME",
            disabled: false,
          },
          {
            name: "1929, Albertsons, SOQUEL, CA",
            disabled: false,
          },
          {
            name: "1929, CVS, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "1929, Rite Aid, EXTON, PA",
            disabled: false,
          },
          {
            name: "1929, Target, SOUTH PLAINFIELD, NJ",
            disabled: false,
          },
          {
            name: "1929, Walmart, CLOQUET, MN",
            disabled: false,
          },
          {
            name: "19298, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "193, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "193, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "193, BJ's, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "193, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "193, Kroger, BURBANK, CA",
            disabled: false,
          },
          {
            name: "193, Meijer, LUDINGTON, MI",
            disabled: false,
          },
          {
            name: "193, Rite Aid, HUBBARD, OH",
            disabled: false,
          },
          {
            name: "193, Target, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "1930, Albertsons, LYNDEN, WA",
            disabled: false,
          },
          {
            name: "1930, Target, PLAINVILLE, MA",
            disabled: false,
          },
          {
            name: "1930, Walmart, PLAISTOW, NH",
            disabled: false,
          },
          {
            name: "19304, Walgreens, MADAWASKA, ME",
            disabled: false,
          },
          {
            name: "1931, Albertsons, FREMONT, CA",
            disabled: false,
          },
          {
            name: "1931, CVS, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "1931, Target, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1931, Walmart, RHINELANDER, WI",
            disabled: false,
          },
          {
            name: "19312, Walgreens, RIVERDALE, MD",
            disabled: false,
          },
          {
            name: "19313, Walgreens, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "1932, Albertsons, DUBLIN, CA",
            disabled: false,
          },
          {
            name: "1932, Target, APEX, NC",
            disabled: false,
          },
          {
            name: "1932, Walmart, ELLSWORTH, ME",
            disabled: false,
          },
          {
            name: "19322, Walgreens, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "19323, Walgreens, MIDDLEBORO, MA",
            disabled: false,
          },
          {
            name: "19324, Walgreens, ROBERTSDALE, AL",
            disabled: false,
          },
          {
            name: "19329, Walgreens, CHICKASAW, AL",
            disabled: false,
          },
          {
            name: "1933, Target, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "1933, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1933, Walmart, NORTHLAKE, IL",
            disabled: false,
          },
          {
            name: "19330, Walgreens, KITTERY, ME",
            disabled: false,
          },
          {
            name: "19331, Walgreens, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "19334, Walgreens, CLAY, WV",
            disabled: false,
          },
          {
            name: "19336, Walgreens, LARGO, MD",
            disabled: false,
          },
          {
            name: "1934, CVS, GREAT NECK, NY",
            disabled: false,
          },
          {
            name: "1934, Target, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "1934, Walgreens, PLANT CITY, FL",
            disabled: false,
          },
          {
            name: "1934, Walmart, SOUTH HILL, VA",
            disabled: false,
          },
          {
            name: "19342, Walgreens, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "19343, Walgreens, NORTH SCITUATE, RI",
            disabled: false,
          },
          {
            name: "19346, Walgreens, ENOSBURG FALLS, VT",
            disabled: false,
          },
          {
            name: "19349, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "1935, Albertsons, SALEM, OR",
            disabled: false,
          },
          {
            name: "1935, CVS, NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "1935, Target, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "1935, Walmart, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "19350, Walgreens, PLEASANTVILLE, NJ",
            disabled: false,
          },
          {
            name: "19353, Walgreens, BARNEVELD, NY",
            disabled: false,
          },
          {
            name: "19354, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "19356, Walgreens, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "19359, Walgreens, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "1936, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "1936, CVS, EAST MEADOW, NY",
            disabled: false,
          },
          {
            name: "1936, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1936, Target, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "1936, Walmart, SAULT SAINTE MARIE, MI",
            disabled: false,
          },
          {
            name: "19361, Walgreens, ATLANTIC CITY, NJ",
            disabled: false,
          },
          {
            name: "19368, Walgreens, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "1937, Target, TAYLORS, SC",
            disabled: false,
          },
          {
            name: "1937, Walgreens, EAU CLAIRE, WI",
            disabled: false,
          },
          {
            name: "1937, Walmart, COSHOCTON, OH",
            disabled: false,
          },
          {
            name: "19370, Walgreens, ITHACA, NY",
            disabled: false,
          },
          {
            name: "19374, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "19377, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "1938, Albertsons, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "1938, CVS, PLAINVIEW, NY",
            disabled: false,
          },
          {
            name: "1938, Target, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "1938, Walmart, BEDFORD PARK, IL",
            disabled: false,
          },
          {
            name: "19380, Walgreens, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "19382, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "1939, Albertsons, CHESTER, MD",
            disabled: false,
          },
          {
            name: "1939, Target, ALTOONA, IA",
            disabled: false,
          },
          {
            name: "1939, Walmart, BRUNSWICK, ME",
            disabled: false,
          },
          {
            name: "19393, Walgreens, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "19394, Walgreens, NARRAGANSETT, RI",
            disabled: false,
          },
          {
            name: "19396, Walgreens, SOUTH RIVER, NJ",
            disabled: false,
          },
          {
            name: "19398, Walgreens, COLEBROOK, NH",
            disabled: false,
          },
          {
            name: "194, ADUSA, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "194, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "194, Albertsons, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "194, Meijer, CHARLOTTE, MI",
            disabled: false,
          },
          {
            name: "194, Walmart, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "1940, CVS, YONKERS, NY",
            disabled: false,
          },
          {
            name: "1940, Target, DAYTON, OH",
            disabled: false,
          },
          {
            name: "1940, Walmart, EAST GREENBUSH, NY",
            disabled: false,
          },
          {
            name: "19400, Walgreens, IRVINGTON, NJ",
            disabled: false,
          },
          {
            name: "19403, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "19404, Walgreens, SOMERS POINT, NJ",
            disabled: false,
          },
          {
            name: "19407, Walgreens, DUBLIN, GA",
            disabled: false,
          },
          {
            name: "1941, CVS, MONROE, CT",
            disabled: false,
          },
          {
            name: "1941, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1941, Target, LAKE PARK, FL",
            disabled: false,
          },
          {
            name: "1941, Walgreens, ROSWELL, NM",
            disabled: false,
          },
          {
            name: "1941, Walmart, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "19410, Walgreens, CHESTER, NJ",
            disabled: false,
          },
          {
            name: "19414, Walgreens, OLD LYME, CT",
            disabled: false,
          },
          {
            name: "19419, Walgreens, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "1942, CVS, TANNERSVILLE, PA",
            disabled: false,
          },
          {
            name: "1942, Target, REVERE, MA",
            disabled: false,
          },
          {
            name: "1942, Walmart, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "19420, Walgreens, OAKHURST, NJ",
            disabled: false,
          },
          {
            name: "19421, Walgreens, MONSON, MA",
            disabled: false,
          },
          {
            name: "19423, Walgreens, YARMOUTH, ME",
            disabled: false,
          },
          {
            name: "19426, Walgreens, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "19428, Walgreens, LAVONIA, GA",
            disabled: false,
          },
          {
            name: "1943, Target, WICHITA, KS",
            disabled: false,
          },
          {
            name: "1943, Walmart, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "19432, Walgreens, STAMFORD, NY",
            disabled: false,
          },
          {
            name: "19437, Walgreens, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "19438, Walgreens, PIEDMONT, SC",
            disabled: false,
          },
          {
            name: "1944, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "1944, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "1944, Target, WICHITA, KS",
            disabled: false,
          },
          {
            name: "19441, Walgreens, MANSFIELD, MA",
            disabled: false,
          },
          {
            name: "19444, Walgreens, HAWLEY, PA",
            disabled: false,
          },
          {
            name: "19448, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "19449, Walgreens, BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "1945, Albertsons, HADDONFIELD, NJ",
            disabled: false,
          },
          {
            name: "1945, Target, WICHITA, KS",
            disabled: false,
          },
          {
            name: "1945, Walmart, MANSFIELD, PA",
            disabled: false,
          },
          {
            name: "19451, Walgreens, DENTON, MD",
            disabled: false,
          },
          {
            name: "19453, Walgreens, FRESH MEADOWS, NY",
            disabled: false,
          },
          {
            name: "19454, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "19455, Walgreens, CONCORD, MA",
            disabled: false,
          },
          {
            name: "19459, Walgreens, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "1946, CVS, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "1946, Target, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "1946, Walmart, MASSENA, NY",
            disabled: false,
          },
          {
            name: "19460, Walgreens, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "19461, Walgreens, FALMOUTH, ME",
            disabled: false,
          },
          {
            name: "19462, Walgreens, MECHANICVILLE, NY",
            disabled: false,
          },
          {
            name: "19464, Walgreens, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "19467, Walgreens, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "1947, Target, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "1947, Walmart, OMAK, WA",
            disabled: false,
          },
          {
            name: "19471, Walgreens, LEONARDTOWN, MD",
            disabled: false,
          },
          {
            name: "19475, Walgreens, CREEDMOOR, NC",
            disabled: false,
          },
          {
            name: "19476, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "1948, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "1948, CVS, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "1948, Target, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "1948, Walmart, WEIRTON, WV",
            disabled: false,
          },
          {
            name: "19487, Walgreens, CAMBRIDGE, MA",
            disabled: false,
          },
          {
            name: "1949, Target, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "1949, Walmart, FREDONIA, NY",
            disabled: false,
          },
          {
            name: "19494, Walgreens, HUDSON FALLS, NY",
            disabled: false,
          },
          {
            name: "195, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "195, BJ's, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "195, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "195, Kroger, La Quinta, CA",
            disabled: false,
          },
          {
            name: "195, Kroger, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "195, Meijer, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "195, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "195, Target, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "195, Walmart, EXCELSIOR SPRINGS, MO",
            disabled: false,
          },
          {
            name: "1950, CVS, ISLIP TERRACE, NY",
            disabled: false,
          },
          {
            name: "1950, Target, STREAMWOOD, IL",
            disabled: false,
          },
          {
            name: "1950, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "1950, Walmart, AHOSKIE, NC",
            disabled: false,
          },
          {
            name: "19500, Walgreens, PORT JERVIS, NY",
            disabled: false,
          },
          {
            name: "19502, Walgreens, HOULTON, ME",
            disabled: false,
          },
          {
            name: "1951, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "1951, CVS, ENDICOTT, NY",
            disabled: false,
          },
          {
            name: "1951, Target, DECATUR, IL",
            disabled: false,
          },
          {
            name: "1951, Walgreens, FARIBAULT, MN",
            disabled: false,
          },
          {
            name: "1951, Walmart, ONTARIO, OR",
            disabled: false,
          },
          {
            name: "19510, Walgreens, MILTON, WV",
            disabled: false,
          },
          {
            name: "19513, Walgreens, EDEN, NC",
            disabled: false,
          },
          {
            name: "1952, Albertsons, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "1952, CVS, MINEOLA, NY",
            disabled: false,
          },
          {
            name: "1952, Target, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "1952, Walgreens, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "1952, Walmart, FRIDLEY, MN",
            disabled: false,
          },
          {
            name: "19523, Walgreens, RIVER VALE, NJ",
            disabled: false,
          },
          {
            name: "19525, Walgreens, NORTH ADAMS, MA",
            disabled: false,
          },
          {
            name: "19529, Walgreens, WARWICK, RI",
            disabled: false,
          },
          {
            name: "1953, Albertsons, DUBLIN, CA",
            disabled: false,
          },
          {
            name: "1953, CVS, HINGHAM, MA",
            disabled: false,
          },
          {
            name: "1953, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1953, Walmart, LOUISBURG, NC",
            disabled: false,
          },
          {
            name: "19532, Walgreens, PORTLAND, CT",
            disabled: false,
          },
          {
            name: "19535, Walgreens, RENSSELAER, NY",
            disabled: false,
          },
          {
            name: "19536, Walgreens, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "19539, Walgreens, ALBION, NY",
            disabled: false,
          },
          {
            name: "1954, Albertsons, REDDING, CA",
            disabled: false,
          },
          {
            name: "1954, Target, MOUNT KISCO, NY",
            disabled: false,
          },
          {
            name: "1954, Walmart, SANFORD, ME",
            disabled: false,
          },
          {
            name: "19542, Walgreens, LIVERPOOL, NY",
            disabled: false,
          },
          {
            name: "19543, Walgreens, HINGHAM, MA",
            disabled: false,
          },
          {
            name: "19545, Walgreens, SALYERSVILLE, KY",
            disabled: false,
          },
          {
            name: "19546, Walgreens, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "19548, Walgreens, ONTARIO, NY",
            disabled: false,
          },
          {
            name: "19549, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "1955, CVS, SOUTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "1955, Rite Aid, TOBYHANNA, PA",
            disabled: false,
          },
          {
            name: "1955, Target, ORANGE, CT",
            disabled: false,
          },
          {
            name: "1955, Walmart, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "1956, Albertsons, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "1956, CVS, SCOTCH PLAINS, NJ",
            disabled: false,
          },
          {
            name: "1956, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "1956, Target, TRUMBULL, CT",
            disabled: false,
          },
          {
            name: "1956, Walgreens, LELAND, NC",
            disabled: false,
          },
          {
            name: "1956, Walmart, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "19560, Walgreens, NEW MILFORD, CT",
            disabled: false,
          },
          {
            name: "19561, Walgreens, CLARKESVILLE, GA",
            disabled: false,
          },
          {
            name: "1957, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "1957, Target, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "1957, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "19570, Walgreens, BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "19575, Walgreens, BETHEL, ME",
            disabled: false,
          },
          {
            name: "19577, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "19578, Walgreens, CHESTER, NY",
            disabled: false,
          },
          {
            name: "19579, Walgreens, PENNINGTON, NJ",
            disabled: false,
          },
          {
            name: "1958, CVS, SYOSSET, NY",
            disabled: false,
          },
          {
            name: "1958, Target, FONTANA, CA",
            disabled: false,
          },
          {
            name: "1958, Walmart, RIO GRANDE CITY, TX",
            disabled: false,
          },
          {
            name: "19585, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1959, CVS, PELHAM MANOR, NY",
            disabled: false,
          },
          {
            name: "1959, Target, MESA, AZ",
            disabled: false,
          },
          {
            name: "1959, Walmart, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "19592, Walgreens, FALMOUTH, MA",
            disabled: false,
          },
          {
            name: "196, ADUSA, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "196, ADUSA, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "196, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "196, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "196, Kroger, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "196, Meijer, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "196, Walmart, CARBONDALE, IL",
            disabled: false,
          },
          {
            name: "1960, Albertsons, MADRAS, OR",
            disabled: false,
          },
          {
            name: "1960, CVS, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "1960, Target, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "1960, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "19604, Walgreens, TERRYVILLE, CT",
            disabled: false,
          },
          {
            name: "19606, Walgreens, SPRINGVALE, ME",
            disabled: false,
          },
          {
            name: "19608, Walgreens, ANDALUSIA, AL",
            disabled: false,
          },
          {
            name: "19609, Walgreens, MARLBORO, NJ",
            disabled: false,
          },
          {
            name: "1961, Target, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "1961, Walmart, ALEXANDRIA, KY",
            disabled: false,
          },
          {
            name: "19611, Walgreens, ROTTERDAM, NY",
            disabled: false,
          },
          {
            name: "19614, Walgreens, VIENNA, WV",
            disabled: false,
          },
          {
            name: "19616, Walgreens, GRANTSVILLE, WV",
            disabled: false,
          },
          {
            name: "1962, Albertsons, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "1962, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "1962, Target, WAXAHACHIE, TX",
            disabled: false,
          },
          {
            name: "1962, Walmart, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "19620, Walgreens, MORGANTOWN, KY",
            disabled: false,
          },
          {
            name: "19623, Walgreens, BEAN STATION, TN",
            disabled: false,
          },
          {
            name: "19628, Walgreens, BASKING RIDGE, NJ",
            disabled: false,
          },
          {
            name: "19629, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "1963, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1963, CVS, GREAT NECK, NY",
            disabled: false,
          },
          {
            name: "1963, Rite Aid, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "1963, Target, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "1963, Walmart, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "19631, Walgreens, AMESBURY, MA",
            disabled: false,
          },
          {
            name: "19633, Walgreens, CALIFON, NJ",
            disabled: false,
          },
          {
            name: "19635, Walgreens, TROY, NY",
            disabled: false,
          },
          {
            name: "19636, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "1964, CVS, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "1964, Target, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "1964, Walmart, WESTERLY, RI",
            disabled: false,
          },
          {
            name: "19644, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "19646, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "1965, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1965, Target, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "1965, Walmart, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "19650, Walgreens, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "19652, Walgreens, CANTON, NC",
            disabled: false,
          },
          {
            name: "19653, Walgreens, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "19654, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "19658, Walgreens, MANCHESTER, KY",
            disabled: false,
          },
          {
            name: "1966, Albertsons, KENT, WA",
            disabled: false,
          },
          {
            name: "1966, CVS, GUILFORD, CT",
            disabled: false,
          },
          {
            name: "1966, Target, SANFORD, FL",
            disabled: false,
          },
          {
            name: "1966, Walmart, GENESEO, NY",
            disabled: false,
          },
          {
            name: "19660, Walgreens, STUARTS DRAFT, VA",
            disabled: false,
          },
          {
            name: "19666, Walgreens, KINGWOOD, WV",
            disabled: false,
          },
          {
            name: "19667, Walgreens, NORTHFIELD, NJ",
            disabled: false,
          },
          {
            name: "19668, Walgreens, EUFAULA, AL",
            disabled: false,
          },
          {
            name: "1967, Target, TRINITY, FL",
            disabled: false,
          },
          {
            name: "1967, Walmart, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "19672, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "19673, Walgreens, CYNTHIANA, KY",
            disabled: false,
          },
          {
            name: "19674, Walgreens, WINSLOW, ME",
            disabled: false,
          },
          {
            name: "19676, Walgreens, WEIRTON, WV",
            disabled: false,
          },
          {
            name: "19678, Walgreens, SOUTH PORTLAND, ME",
            disabled: false,
          },
          {
            name: "19679, Walgreens, MARLINTON, WV",
            disabled: false,
          },
          {
            name: "1968, Albertsons, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "1968, CVS, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "1968, Target, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "1968, Walmart, ABERDEEN, MD",
            disabled: false,
          },
          {
            name: "19680, Walgreens, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "19681, Walgreens, PINEVILLE, WV",
            disabled: false,
          },
          {
            name: "19689, Walgreens, WARRENSBURG, NY",
            disabled: false,
          },
          {
            name: "1969, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "1969, Target, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "1969, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "1969, Walmart, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "19690, Walgreens, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "19692, Walgreens, GORHAM, ME",
            disabled: false,
          },
          {
            name: "19693, Walgreens, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "197, ADUSA, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "197, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "197, BJ's, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "197, Meijer, OXFORD, MI",
            disabled: false,
          },
          {
            name: "197, Walmart, MACOMB, IL",
            disabled: false,
          },
          {
            name: "1970, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "1970, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1970, Rite Aid, HALEDON, NJ",
            disabled: false,
          },
          {
            name: "1970, Target, MIDDLE RIVER, MD",
            disabled: false,
          },
          {
            name: "1970, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "1970, Walmart, HUDSON, MA",
            disabled: false,
          },
          {
            name: "19700, Walgreens, HOGANSVILLE, GA",
            disabled: false,
          },
          {
            name: "19702, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "19703, Walgreens, BOGOTA, NJ",
            disabled: false,
          },
          {
            name: "19708, Walgreens, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "19709, Walgreens, SHEPHERDSTOWN, WV",
            disabled: false,
          },
          {
            name: "1971, Albertsons, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "1971, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1971, Target, HOWELL, MI",
            disabled: false,
          },
          {
            name: "1971, Walmart, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "19717, Walgreens, SPENCERPORT, NY",
            disabled: false,
          },
          {
            name: "1972, Albertsons, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "1972, CVS, WEST SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "1972, Target, WHITEHALL, OH",
            disabled: false,
          },
          {
            name: "1972, Walgreens, GARDEN CITY, ID",
            disabled: false,
          },
          {
            name: "1972, Walmart, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "19723, Walgreens, ORADELL, NJ",
            disabled: false,
          },
          {
            name: "19725, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "19729, Walgreens, DELHI, NY",
            disabled: false,
          },
          {
            name: "1973, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1973, Target, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "1973, Walmart, LAKEWOOD, NY",
            disabled: false,
          },
          {
            name: "19732, Walgreens, SCHAGHTICOKE, NY",
            disabled: false,
          },
          {
            name: "19733, Walgreens, HASBROUCK HEIGHTS, NJ",
            disabled: false,
          },
          {
            name: "19735, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "19736, Walgreens, WOLCOTT, NY",
            disabled: false,
          },
          {
            name: "19739, Walgreens, PERRY, NY",
            disabled: false,
          },
          {
            name: "1974, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1974, Walmart, HOULTON, ME",
            disabled: false,
          },
          {
            name: "19741, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "19743, Walgreens, FOLLANSBEE, WV",
            disabled: false,
          },
          {
            name: "19745, Walgreens, HAMMONTON, NJ",
            disabled: false,
          },
          {
            name: "19746, Walgreens, OCEANA, WV",
            disabled: false,
          },
          {
            name: "1975, Albertsons, FOUNTAIN, CO",
            disabled: false,
          },
          {
            name: "1975, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1975, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "1975, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "1975, Walmart, CLAREMONT, NH",
            disabled: false,
          },
          {
            name: "19751, Walgreens, OLIVE HILL, KY",
            disabled: false,
          },
          {
            name: "19757, Walgreens, BELFORD, NJ",
            disabled: false,
          },
          {
            name: "1976, Albertsons, WOODBURN, OR",
            disabled: false,
          },
          {
            name: "1976, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1976, Rite Aid, COUDERSPORT, PA",
            disabled: false,
          },
          {
            name: "1976, Target, AURORA, CO",
            disabled: false,
          },
          {
            name: "1976, Walgreens, FORT ATKINSON, WI",
            disabled: false,
          },
          {
            name: "1976, Walmart, HORSEHEADS, NY",
            disabled: false,
          },
          {
            name: "19760, Walgreens, HORNELL, NY",
            disabled: false,
          },
          {
            name: "19761, Walgreens, NORTH PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "19762, Walgreens, SPOTSWOOD, NJ",
            disabled: false,
          },
          {
            name: "19765, Walgreens, SCOTTSVILLE, KY",
            disabled: false,
          },
          {
            name: "19766, Walgreens, DANSVILLE, NY",
            disabled: false,
          },
          {
            name: "1977, Albertsons, LACEY, WA",
            disabled: false,
          },
          {
            name: "1977, Rite Aid, IRVINGTON, NJ",
            disabled: false,
          },
          {
            name: "1977, Target, St. Joseph, MO",
            disabled: false,
          },
          {
            name: "1977, Walgreens, VERNON ROCKVILLE, CT",
            disabled: false,
          },
          {
            name: "1977, Walmart, BRICK, NJ",
            disabled: false,
          },
          {
            name: "19770, Walgreens, FULTONDALE, AL",
            disabled: false,
          },
          {
            name: "19776, Walgreens, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "1978, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "1978, CVS, PETERSBURG, VA",
            disabled: false,
          },
          {
            name: "1978, Target, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "1978, Walmart, PLYMOUTH, IN",
            disabled: false,
          },
          {
            name: "19787, Walgreens, LATHAM, NY",
            disabled: false,
          },
          {
            name: "19788, Walgreens, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "19789, Walgreens, GRAY, ME",
            disabled: false,
          },
          {
            name: "1979, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1979, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "1979, Walmart, CLEARLAKE, CA",
            disabled: false,
          },
          {
            name: "19790, Walgreens, DUNBAR, WV",
            disabled: false,
          },
          {
            name: "19791, Walgreens, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "19793, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "19796, Walgreens, YORK, ME",
            disabled: false,
          },
          {
            name: "19797, Walgreens, PINSON, AL",
            disabled: false,
          },
          {
            name: "198, ADUSA, HILLSBOROUGH, NC",
            disabled: false,
          },
          {
            name: "198, ADUSA, POTOMAC, MD",
            disabled: false,
          },
          {
            name: "198, BJ's, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "198, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "198, Kroger, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "198, Meijer, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "198, Target, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "198, Walmart, SALEM, IL",
            disabled: false,
          },
          {
            name: "1980, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "1980, CVS, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "1980, Target, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "1980, Walmart, PUTNAM, CT",
            disabled: false,
          },
          {
            name: "19801, Walgreens, PETERSBURG, WV",
            disabled: false,
          },
          {
            name: "19802, Walgreens, LEWISTON, ME",
            disabled: false,
          },
          {
            name: "19804, Walgreens, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "19806, Walgreens, ACTON, MA",
            disabled: false,
          },
          {
            name: "19809, Walgreens, MADISON, AL",
            disabled: false,
          },
          {
            name: "1981, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "1981, Target, WEATHERFORD, TX",
            disabled: false,
          },
          {
            name: "1981, Walmart, CALIFORNIA, MD",
            disabled: false,
          },
          {
            name: "19810, Walgreens, CATLETTSBURG, KY",
            disabled: false,
          },
          {
            name: "19811, Walgreens, LIBERTY, NY",
            disabled: false,
          },
          {
            name: "19812, Walgreens, RED BANK, NJ",
            disabled: false,
          },
          {
            name: "19816, Walgreens, PENFIELD, NY",
            disabled: false,
          },
          {
            name: "1982, Target, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "1982, Walmart, APPLETON, WI",
            disabled: false,
          },
          {
            name: "19823, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "19827, Walgreens, PLEASANTVILLE, NJ",
            disabled: false,
          },
          {
            name: "19828, Walgreens, MANCHESTER, GA",
            disabled: false,
          },
          {
            name: "1983, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1983, CVS, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "1983, Rite Aid, NAZARETH, PA",
            disabled: false,
          },
          {
            name: "1983, Target, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "1983, Walmart, CERES, CA",
            disabled: false,
          },
          {
            name: "19836, Walgreens, CANTERBURY, CT",
            disabled: false,
          },
          {
            name: "19838, Walgreens, WARWICK, RI",
            disabled: false,
          },
          {
            name: "19839, Walgreens, ASHBURN, GA",
            disabled: false,
          },
          {
            name: "1984, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1984, Costco, AURORA, CO",
            disabled: false,
          },
          {
            name: "1984, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "1984, Walmart, NORTH ADAMS, MA",
            disabled: false,
          },
          {
            name: "19840, Walgreens, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "19843, Walgreens, PASADENA, MD",
            disabled: false,
          },
          {
            name: "19848, Walgreens, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "1985, CVS, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "1985, Costco, OWATONNA, US",
            disabled: false,
          },
          {
            name: "1985, Walmart, LAUREL, MD",
            disabled: false,
          },
          {
            name: "19851, Walgreens, BELTSVILLE, MD",
            disabled: false,
          },
          {
            name: "19855, Walgreens, GREENSBURG, KY",
            disabled: false,
          },
          {
            name: "19856, Walgreens, CASTLETON, NY",
            disabled: false,
          },
          {
            name: "19857, Walgreens, HENDERSON, KY",
            disabled: false,
          },
          {
            name: "1986, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1986, Costco, BROOKSHIRE, TX",
            disabled: false,
          },
          {
            name: "1986, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "1986, Walmart, NORWALK, OH",
            disabled: false,
          },
          {
            name: "19860, Walgreens, ATLANTIC CITY, NJ",
            disabled: false,
          },
          {
            name: "19865, Walgreens, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "1987, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "1987, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "1987, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "1987, Walmart, LAPEER, MI",
            disabled: false,
          },
          {
            name: "19876, Walgreens, WATERLOO, NY",
            disabled: false,
          },
          {
            name: "19877, Walgreens, PINEVILLE, NC",
            disabled: false,
          },
          {
            name: "19878, Walgreens, WHARTON, NJ",
            disabled: false,
          },
          {
            name: "1988, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1988, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1988, Costco, TOLLESON, AZ",
            disabled: false,
          },
          {
            name: "1988, Walgreens, GRAFTON, WI",
            disabled: false,
          },
          {
            name: "1988, Walmart, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "19880, Walgreens, THOMASVILLE, GA",
            disabled: false,
          },
          {
            name: "19882, Walgreens, BALLSTON LAKE, NY",
            disabled: false,
          },
          {
            name: "19884, Walgreens, LOUDONVILLE, NY",
            disabled: false,
          },
          {
            name: "19885, Walgreens, CUMBERLAND, KY",
            disabled: false,
          },
          {
            name: "19886, Walgreens, BOOTHBAY HARBOR, ME",
            disabled: false,
          },
          {
            name: "19889, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "1989, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "1989, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1989, Costco, VAN BUREN TWP, MI",
            disabled: false,
          },
          {
            name: "1989, Walgreens, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "1989, Walmart, LOMPOC, CA",
            disabled: false,
          },
          {
            name: "19890, Walgreens, YADKINVILLE, NC",
            disabled: false,
          },
          {
            name: "199, ADUSA, MADISON HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "199, ADUSA, NORTH RIDGEVILLE, OH",
            disabled: false,
          },
          {
            name: "199, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "199, BJ's, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "199, Meijer, CALEDONIA, MI",
            disabled: false,
          },
          {
            name: "199, Target, MANHATTAN BEACH, CA",
            disabled: false,
          },
          {
            name: "199, Walmart, LINCOLN, IL",
            disabled: false,
          },
          {
            name: "1990, Albertsons, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "1990, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1990, Costco, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "1990, Walgreens, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "1990, Walmart, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "19900, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "19902, Walgreens, NAPLES, ME",
            disabled: false,
          },
          {
            name: "19904, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "19907, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "19908, Walgreens, LISBON FALLS, ME",
            disabled: false,
          },
          {
            name: "1991, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1991, Costco, MORRIS, IL",
            disabled: false,
          },
          {
            name: "1991, Walmart, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "19911, Walgreens, CORINTH, NY",
            disabled: false,
          },
          {
            name: "19912, Walgreens, OSSIPEE, NH",
            disabled: false,
          },
          {
            name: "19918, Walgreens, NORTH CAPE MAY, NJ",
            disabled: false,
          },
          {
            name: "19919, Walgreens, PALMYRA, NY",
            disabled: false,
          },
          {
            name: "1992, Albertsons, SADDLE BROOK, NJ",
            disabled: false,
          },
          {
            name: "1992, Costco, COLLEGE PARK, GA",
            disabled: false,
          },
          {
            name: "1992, Walmart, UPLAND, CA",
            disabled: false,
          },
          {
            name: "19924, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "1993, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "1993, Costco, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "1993, Walgreens, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "1993, Walmart, BROCKPORT, NY",
            disabled: false,
          },
          {
            name: "19931, Walgreens, RUTHERFORD, NJ",
            disabled: false,
          },
          {
            name: "19935, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "19937, Walgreens, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "19939, Walgreens, COLQUITT, GA",
            disabled: false,
          },
          {
            name: "1994, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "1994, Costco, TRACY, CA",
            disabled: false,
          },
          {
            name: "1994, Walgreens, WOODSTOCK, IL",
            disabled: false,
          },
          {
            name: "1994, Walmart, PLATTSBURGH, NY",
            disabled: false,
          },
          {
            name: "19942, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "19944, Walgreens, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "19947, Walgreens, MARSTONS MILLS, MA",
            disabled: false,
          },
          {
            name: "19948, Walgreens, WATERVLIET, NY",
            disabled: false,
          },
          {
            name: "19949, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "1995, CVS, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "1995, Costco, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "1995, Walgreens, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "1995, Walmart, CHUBBUCK, ID",
            disabled: false,
          },
          {
            name: "19951, Walgreens, WEST BABYLON, NY",
            disabled: false,
          },
          {
            name: "19952, Walgreens, NORWICH, NY",
            disabled: false,
          },
          {
            name: "19953, Walgreens, BERNARDSVILLE, NJ",
            disabled: false,
          },
          {
            name: "19954, Walgreens, MAN, WV",
            disabled: false,
          },
          {
            name: "19955, Walgreens, BASKING RIDGE, NJ",
            disabled: false,
          },
          {
            name: "19957, Walgreens, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "1996, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "1996, Costco, MONROVIA, MD",
            disabled: false,
          },
          {
            name: "1996, Walgreens, WOOD RIVER, IL",
            disabled: false,
          },
          {
            name: "1996, Walmart, HALLANDALE BEACH, FL",
            disabled: false,
          },
          {
            name: "19963, Walgreens, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "19964, Walgreens, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "19966, Walgreens, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "1997, Albertsons, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "1997, CVS, MOUNT KISCO, NY",
            disabled: false,
          },
          {
            name: "1997, Costco, MONROE TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "1997, Walmart, LATHAM, NY",
            disabled: false,
          },
          {
            name: "19971, Walgreens, GRAYSON, KY",
            disabled: false,
          },
          {
            name: "19974, Walgreens, EDMONTON, KY",
            disabled: false,
          },
          {
            name: "19977, Walgreens, ONEIDA, NY",
            disabled: false,
          },
          {
            name: "19978, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "1998, Albertsons, ARVADA, CO",
            disabled: false,
          },
          {
            name: "1998, Costco, SUMNER, WA",
            disabled: false,
          },
          {
            name: "1998, Walmart, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "19980, Walgreens, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "19983, Walgreens, DENNISPORT, MA",
            disabled: false,
          },
          {
            name: "19985, Walgreens, NORTH PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "19986, Walgreens, COLUMBUS, MS",
            disabled: false,
          },
          {
            name: "1999, Walmart, ANDOVER, MN",
            disabled: false,
          },
          {
            name: "19990, Walgreens, CRAIGSVILLE, WV",
            disabled: false,
          },
          {
            name: "19991, Walgreens, WELLSBURG, WV",
            disabled: false,
          },
          {
            name: "19992, Walgreens, ALBEMARLE, NC",
            disabled: false,
          },
          {
            name: "19993, Walgreens, ELLENVILLE, NY",
            disabled: false,
          },
          {
            name: "19994, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "19995, Walgreens, GARFIELD, NJ",
            disabled: false,
          },
          {
            name: "19996, Walgreens, LONG BRANCH, NJ",
            disabled: false,
          },
          {
            name: "19997, Walgreens, FOLKSTON, GA",
            disabled: false,
          },
          {
            name: "19999, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "2, ADUSA, MCKEES ROCKS, PA",
            disabled: false,
          },
          {
            name: "2, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2, Costco, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "2, Kroger, IRMO, SC",
            disabled: false,
          },
          {
            name: "2, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2, Kroger, Salt Lake City, UT",
            disabled: false,
          },
          {
            name: "2, Walmart, HARRISON, AR",
            disabled: false,
          },
          {
            name: "20, ADUSA, QUINCY, MA",
            disabled: false,
          },
          {
            name: "20, Albertsons, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "20, BJ's, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "20, CVS, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "20, HEB, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "20, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "20, Kroger, Huntington Beach, CA",
            disabled: false,
          },
          {
            name: "20, Kroger, North Myrtle Beach, SC",
            disabled: false,
          },
          {
            name: "20, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "20, Kroger, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "20, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "20, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "20, Walmart, CLINTON, MO",
            disabled: false,
          },
          {
            name: "200, BJ's, OAKS, PA",
            disabled: false,
          },
          {
            name: "200, CVS, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "200, HEB, FALFURRIAS, TX",
            disabled: false,
          },
          {
            name: "200, Rite Aid, LEBANON, PA",
            disabled: false,
          },
          {
            name: "200, Target, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "200, Walmart, JACKSONVILLE, IL",
            disabled: false,
          },
          {
            name: "2000, Rite Aid, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "2000, Walmart, KITTY HAWK, NC",
            disabled: false,
          },
          {
            name: "2001, Albertsons, AGOURA HILLS, CA",
            disabled: false,
          },
          {
            name: "2001, CVS, SOUTH PLAINFIELD, NJ",
            disabled: false,
          },
          {
            name: "2001, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "2002, Albertsons, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "2002, CVS, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "2002, Walmart, GILROY, CA",
            disabled: false,
          },
          {
            name: "2003, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2003, Walmart, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "2004, Albertsons, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "2004, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2004, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "2004, Walmart, DUBUQUE, IA",
            disabled: false,
          },
          {
            name: "2005, CVS, DISTRICT HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "2005, Walmart, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "2006, CVS, HERNDON, VA",
            disabled: false,
          },
          {
            name: "2006, Target, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2006, Walmart, CLARKSTON, WA",
            disabled: false,
          },
          {
            name: "2007, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2007, Target, BOWIE, MD",
            disabled: false,
          },
          {
            name: "2007, Walmart, MOSES LAKE, WA",
            disabled: false,
          },
          {
            name: "2008, Target, LAKE WORTH, TX",
            disabled: false,
          },
          {
            name: "2008, Walmart, GROVE CITY, PA",
            disabled: false,
          },
          {
            name: "2009, CVS, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "2009, Target, BEDFORD, NH",
            disabled: false,
          },
          {
            name: "2009, Walmart, ABINGDON, MD",
            disabled: false,
          },
          {
            name: "201, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "201, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "201, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "201, Meijer, GREENVILLE, MI",
            disabled: false,
          },
          {
            name: "201, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "201, Walmart, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "2010, CVS, ODENTON, MD",
            disabled: false,
          },
          {
            name: "2010, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2010, Walmart, NILES, MI",
            disabled: false,
          },
          {
            name: "2011, CVS, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "2011, Target, ARDEN, NC",
            disabled: false,
          },
          {
            name: "2012, Albertsons, GLASGOW, MT",
            disabled: false,
          },
          {
            name: "2012, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2012, Walgreens, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "2012, Walmart, NORTH OXFORD, MA",
            disabled: false,
          },
          {
            name: "2013, Albertsons, MALTA, MT",
            disabled: false,
          },
          {
            name: "2013, Walmart, WATERVILLE, ME",
            disabled: false,
          },
          {
            name: "2014, Target, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "2014, Walgreens, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "2014, Walmart, HOUGHTON LAKE, MI",
            disabled: false,
          },
          {
            name: "2015, Target, CALEDONIA, MI",
            disabled: false,
          },
          {
            name: "2015, Walmart, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2016, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "2016, CVS, GREENBELT, MD",
            disabled: false,
          },
          {
            name: "2016, Target, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "2016, Walmart, COLVILLE, WA",
            disabled: false,
          },
          {
            name: "2017, Albertsons, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "2017, CVS, MIDDLESEX, NJ",
            disabled: false,
          },
          {
            name: "2017, Rite Aid, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "2017, Target, DUMFRIES, VA",
            disabled: false,
          },
          {
            name: "2018, CVS, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "2018, Target, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "2019, CVS, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "2019, Target, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "2019, Walmart, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "202, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "202, Costco, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "202, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "202, Kroger, Hermosa Beach, CA",
            disabled: false,
          },
          {
            name: "202, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "202, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "202, Kroger, Wheeling, WV",
            disabled: false,
          },
          {
            name: "202, Walmart, FRISCO, TX",
            disabled: false,
          },
          {
            name: "2020, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "2020, Target, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "2020, Walgreens, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "2020, Walmart, RENSSELAER, IN",
            disabled: false,
          },
          {
            name: "2021, CVS, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "2021, Target, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "2021, Walmart, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "2022, CVS, SUFFIELD, CT",
            disabled: false,
          },
          {
            name: "2022, Target, DAVIE, FL",
            disabled: false,
          },
          {
            name: "2022, Walmart, NORTH WINDHAM, CT",
            disabled: false,
          },
          {
            name: "2023, Target, LONE TREE, CO",
            disabled: false,
          },
          {
            name: "2023, Walgreens, MONROE, MI",
            disabled: false,
          },
          {
            name: "2023, Walmart, LEBANON, PA",
            disabled: false,
          },
          {
            name: "2024, CVS, GARFIELD, NJ",
            disabled: false,
          },
          {
            name: "2024, Target, MONROE, NY",
            disabled: false,
          },
          {
            name: "2024, Walmart, TUNKHANNOCK, PA",
            disabled: false,
          },
          {
            name: "2025, CVS, EASTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "2025, Target, ANDOVER, MN",
            disabled: false,
          },
          {
            name: "2025, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2025, Walmart, TRACY, CA",
            disabled: false,
          },
          {
            name: "2026, CVS, UNION, NJ",
            disabled: false,
          },
          {
            name: "2026, Target, CARSON, CA",
            disabled: false,
          },
          {
            name: "2026, Walgreens, BERNALILLO, NM",
            disabled: false,
          },
          {
            name: "2026, Walmart, PONCE, PR",
            disabled: false,
          },
          {
            name: "2027, Albertsons, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "2027, CVS, BELLEROSE, NY",
            disabled: false,
          },
          {
            name: "2027, Target, EVANS, GA",
            disabled: false,
          },
          {
            name: "2027, Walmart, LAVALE, MD",
            disabled: false,
          },
          {
            name: "2028, Albertsons, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "2028, CVS, HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "2028, Target, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "2028, Walmart, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2029, Albertsons, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "2029, Target, GLENWOOD SPRINGS, CO",
            disabled: false,
          },
          {
            name: "203, ADUSA, CHESTERLAND, OH",
            disabled: false,
          },
          {
            name: "203, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "203, BJ's, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "203, CVS, CHATHAM, NJ",
            disabled: false,
          },
          {
            name: "203, Costco, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "203, Meijer, BIG RAPIDS, MI",
            disabled: false,
          },
          {
            name: "203, ShopRite, STANHOPE, NJ",
            disabled: false,
          },
          {
            name: "203, Target, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "203, Walmart, BROOKFIELD, MO",
            disabled: false,
          },
          {
            name: "2030, Albertsons, VALENCIA, CA",
            disabled: false,
          },
          {
            name: "2030, CVS, WAUCHULA, FL",
            disabled: false,
          },
          {
            name: "2030, Target, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "2030, Walmart, SONORA, CA",
            disabled: false,
          },
          {
            name: "2031, Target, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "2031, Walmart, UNION CITY, CA",
            disabled: false,
          },
          {
            name: "2032, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "2032, CVS, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "2032, Target, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "2032, Walmart, OXNARD, CA",
            disabled: false,
          },
          {
            name: "2033, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "2033, CVS, EDGEWATER, MD",
            disabled: false,
          },
          {
            name: "2033, Target, ALLEN PARK, MI",
            disabled: false,
          },
          {
            name: "2033, Walmart, MANDAN, ND",
            disabled: false,
          },
          {
            name: "2034, Albertsons, SYLMAR, CA",
            disabled: false,
          },
          {
            name: "2034, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2034, Target, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "2035, Target, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "2035, Walmart, GREENVILLE, OH",
            disabled: false,
          },
          {
            name: "2036, Target, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2036, Walmart, SOUTH CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "2037, Target, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "2037, Walmart, ABERDEEN, WA",
            disabled: false,
          },
          {
            name: "2038, CVS, WEST POINT, MS",
            disabled: false,
          },
          {
            name: "2038, Target, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "2038, Walmart, STERLING, VA",
            disabled: false,
          },
          {
            name: "2039, Albertsons, RESEDA, CA",
            disabled: false,
          },
          {
            name: "2039, Albertsons, TARZANA, CA",
            disabled: false,
          },
          {
            name: "2039, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2039, Walmart, MERCED, CA",
            disabled: false,
          },
          {
            name: "204, ADUSA, NORTH ROYALTON, OH",
            disabled: false,
          },
          {
            name: "204, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "204, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "204, Costco, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "204, Meijer, CAMBY, IN",
            disabled: false,
          },
          {
            name: "204, Walmart, PRINCETON, KY",
            disabled: false,
          },
          {
            name: "2040, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2040, CVS, JAMISON, PA",
            disabled: false,
          },
          {
            name: "2040, Target, Tampa, FL",
            disabled: false,
          },
          {
            name: "2040, Walmart, BURLINGTON, NJ",
            disabled: false,
          },
          {
            name: "2041, Albertsons, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "2041, CVS, OZONE PARK, NY",
            disabled: false,
          },
          {
            name: "2041, Target, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "2041, Walmart, PENNSVILLE, NJ",
            disabled: false,
          },
          {
            name: "2042, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2042, CVS, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "2042, Target, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2043, CVS, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "2043, Target, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "2043, Walmart, WARSAW, NY",
            disabled: false,
          },
          {
            name: "2044, Albertsons, GREEN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "2044, CVS, WILLISTON PARK, NY",
            disabled: false,
          },
          {
            name: "2044, Target, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "2044, Walmart, CHICO, CA",
            disabled: false,
          },
          {
            name: "2045, CVS, PARKVILLE, MD",
            disabled: false,
          },
          {
            name: "2045, Target, MILFORD, CT",
            disabled: false,
          },
          {
            name: "2045, Walmart, NOTTINGHAM, MD",
            disabled: false,
          },
          {
            name: "2046, CVS, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "2046, Target, WEST ST PAUL, MN",
            disabled: false,
          },
          {
            name: "2046, Walmart, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "2047, Albertsons, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "2047, CVS, THORNWOOD, NY",
            disabled: false,
          },
          {
            name: "2047, Walmart, PALMYRA, ME",
            disabled: false,
          },
          {
            name: "2048, CVS, GLOCESTER, RI",
            disabled: false,
          },
          {
            name: "2048, Target, SAINT JOHN, IN",
            disabled: false,
          },
          {
            name: "2048, Walmart, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "2049, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "2049, Walmart, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "205, Albertsons, KAILUA, HI",
            disabled: false,
          },
          {
            name: "205, BJ's, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "205, CVS, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "205, Costco, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "205, Kroger, CALABASAS, CA",
            disabled: false,
          },
          {
            name: "205, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "205, Kroger, Salem, IN",
            disabled: false,
          },
          {
            name: "205, Meijer, LOWELL, MI",
            disabled: false,
          },
          {
            name: "205, Rite Aid, SHAMOKIN, PA",
            disabled: false,
          },
          {
            name: "205, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "205, Walmart, PHILADELPHIA, MS",
            disabled: false,
          },
          {
            name: "2050, CVS, INDIO, CA",
            disabled: false,
          },
          {
            name: "2050, Walgreens, BELEN, NM",
            disabled: false,
          },
          {
            name: "2050, Walmart, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2051, Albertsons, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "2051, CVS, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "2051, Target, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "2051, Walmart, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "2052, Albertsons, COTTONWOOD, AZ",
            disabled: false,
          },
          {
            name: "2052, CVS, WANTAGH, NY",
            disabled: false,
          },
          {
            name: "2052, Target, DENVER, CO",
            disabled: false,
          },
          {
            name: "2052, Walmart, UKIAH, CA",
            disabled: false,
          },
          {
            name: "2053, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2053, CVS, LANDISVILLE, PA",
            disabled: false,
          },
          {
            name: "2053, Target, HIXSON, TN",
            disabled: false,
          },
          {
            name: "2053, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "2053, Walmart, WILLOWS, CA",
            disabled: false,
          },
          {
            name: "2054, Albertsons, SUN CITY WEST, AZ",
            disabled: false,
          },
          {
            name: "2054, CVS, NORWOOD, MA",
            disabled: false,
          },
          {
            name: "2054, Walmart, JACKSON, CA",
            disabled: false,
          },
          {
            name: "2055, CVS, TEWKSBURY, MA",
            disabled: false,
          },
          {
            name: "2055, Target, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "2055, Walmart, CONCORD, NH",
            disabled: false,
          },
          {
            name: "2056, Albertsons, COVINA, CA",
            disabled: false,
          },
          {
            name: "2056, CVS, MYSTIC, CT",
            disabled: false,
          },
          {
            name: "2056, Target, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "2056, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "2056, Walmart, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "2057, CVS, FOREST HILLS, NY",
            disabled: false,
          },
          {
            name: "2057, Target, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "2057, Walmart, RINDGE, NH",
            disabled: false,
          },
          {
            name: "2058, Target, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "2058, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2059, CVS, WEST BABYLON, NY",
            disabled: false,
          },
          {
            name: "2059, Target, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "2059, Walmart, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "206, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "206, BJ's, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "206, Costco, NESCONSET, NY",
            disabled: false,
          },
          {
            name: "206, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "206, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "206, Meijer, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "206, ShopRite, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "206, Walmart, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "2060, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2060, CVS, EAST ROCKAWAY, NY",
            disabled: false,
          },
          {
            name: "2061, Albertsons, CODY, WY",
            disabled: false,
          },
          {
            name: "2061, CVS, ELMONT, NY",
            disabled: false,
          },
          {
            name: "2061, Target, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "2061, Walmart, PLAINWELL, MI",
            disabled: false,
          },
          {
            name: "2062, Target, MOUNT DORA, FL",
            disabled: false,
          },
          {
            name: "2062, Walmart, BENTON HARBOR, MI",
            disabled: false,
          },
          {
            name: "2063, CVS, CANTON, OH",
            disabled: false,
          },
          {
            name: "2063, Target, NAPLES, FL",
            disabled: false,
          },
          {
            name: "2063, Walmart, AUSTINTOWN, OH",
            disabled: false,
          },
          {
            name: "2064, CVS, ROSELLE, NJ",
            disabled: false,
          },
          {
            name: "2064, Target, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "2064, Walmart, MILFORD, PA",
            disabled: false,
          },
          {
            name: "2065, Albertsons, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "2065, Target, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "2065, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "2066, Albertsons, TARZANA, CA",
            disabled: false,
          },
          {
            name: "2066, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2066, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2066, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2067, Target, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "2067, Walmart, MAYAGUEZ, PR",
            disabled: false,
          },
          {
            name: "2068, Target, CLARKSVILLE, IN",
            disabled: false,
          },
          {
            name: "2068, Walmart, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "2069, Albertsons, LAKESIDE, AZ",
            disabled: false,
          },
          {
            name: "2069, CVS, DOVER, DE",
            disabled: false,
          },
          {
            name: "2069, Target, DURHAM, NC",
            disabled: false,
          },
          {
            name: "2069, Walmart, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "207, ADUSA, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "207, Albertsons, KANEOHE, HI",
            disabled: false,
          },
          {
            name: "207, BJ's, CAPITOL HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "207, CVS, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "207, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "207, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "207, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "207, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "207, Kroger, SARATOGA SPRINGS, UT",
            disabled: false,
          },
          {
            name: "207, Meijer, NORMAL, IL",
            disabled: false,
          },
          {
            name: "207, Walmart, CLEVELAND, OK",
            disabled: false,
          },
          {
            name: "2070, CVS, JAMAICA PLAIN, MA",
            disabled: false,
          },
          {
            name: "2070, Target, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "2070, Walmart, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "2071, Albertsons, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "2071, CVS, HOLYOKE, MA",
            disabled: false,
          },
          {
            name: "2071, Target, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "2071, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "2071, Walmart, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "2072, CVS, BURNT HILLS, NY",
            disabled: false,
          },
          {
            name: "2072, Target, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "2072, Walmart, GUAYAMA, PR",
            disabled: false,
          },
          {
            name: "2073, Target, LINCOLN, RI",
            disabled: false,
          },
          {
            name: "2073, Walmart, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "2074, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2074, Target, MONROE, NC",
            disabled: false,
          },
          {
            name: "2074, Walmart, WASILLA, AK",
            disabled: false,
          },
          {
            name: "2075, Albertsons, PARKER, AZ",
            disabled: false,
          },
          {
            name: "2075, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2075, Walmart, BEND, OR",
            disabled: false,
          },
          {
            name: "2076, Albertsons, SPRINGERVILLE, AZ",
            disabled: false,
          },
          {
            name: "2076, Target, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "2077, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2077, Rite Aid, GIRARD, OH",
            disabled: false,
          },
          {
            name: "2077, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2077, Walgreens, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "2077, Walmart, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "2078, Albertsons, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "2078, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2078, Walgreens, ANDOVER, MN",
            disabled: false,
          },
          {
            name: "2078, Walmart, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "2079, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2079, CVS, MOUNT HOLLY, NJ",
            disabled: false,
          },
          {
            name: "2079, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2079, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2079, Walmart, MARQUETTE, MI",
            disabled: false,
          },
          {
            name: "208, Albertsons, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "208, BJ's, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "208, CVS, GLASSBORO, NJ",
            disabled: false,
          },
          {
            name: "208, Costco, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "208, Kroger, Roanoke, VA",
            disabled: false,
          },
          {
            name: "208, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "208, Meijer, LINCOLN PARK, MI",
            disabled: false,
          },
          {
            name: "208, Rite Aid, SHENANDOAH, PA",
            disabled: false,
          },
          {
            name: "2080, CVS, OSSINING, NY",
            disabled: false,
          },
          {
            name: "2080, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2080, Walmart, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "2081, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2081, CVS, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "2081, Target, BROADVIEW, IL",
            disabled: false,
          },
          {
            name: "2081, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2081, Walmart, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "2082, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2082, Target, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "2082, Walmart, CERRITOS, CA",
            disabled: false,
          },
          {
            name: "2083, Albertsons, SIERRA VISTA, AZ",
            disabled: false,
          },
          {
            name: "2083, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2083, Target, YUMA, AZ",
            disabled: false,
          },
          {
            name: "2083, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "2083, Walmart, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "2084, Target, DECATUR, AL",
            disabled: false,
          },
          {
            name: "2084, Walmart, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "2085, Target, DESTIN, FL",
            disabled: false,
          },
          {
            name: "2085, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "2085, Walmart, ISABELA, PR",
            disabled: false,
          },
          {
            name: "2086, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2086, Target, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "2086, Walgreens, EVANS, CO",
            disabled: false,
          },
          {
            name: "2086, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "2087, Target, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "2087, Walmart, VADNAIS HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "2088, CVS, MORROW, GA",
            disabled: false,
          },
          {
            name: "2088, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2088, Walmart, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "2089, Albertsons, LAGUNA BEACH, CA",
            disabled: false,
          },
          {
            name: "2089, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2089, Target, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2089, Walmart, BRISTOL, VA",
            disabled: false,
          },
          {
            name: "209, ADUSA, BEDFORD, OH",
            disabled: false,
          },
          {
            name: "209, CVS, NORTH ANDOVER, MA",
            disabled: false,
          },
          {
            name: "209, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "209, Kroger, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "209, Kroger, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "209, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "209, Meijer, DEWITT, MI",
            disabled: false,
          },
          {
            name: "209, Walgreens, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "209, Walmart, OZARK, AR",
            disabled: false,
          },
          {
            name: "2090, Albertsons, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "2090, CVS, OAKLYN, NJ",
            disabled: false,
          },
          {
            name: "2090, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2090, Walmart, FRANKLIN, NJ",
            disabled: false,
          },
          {
            name: "2091, Albertsons, SAN JUAN CAPISTRANO, CA",
            disabled: false,
          },
          {
            name: "2091, CVS, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "2091, Target, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "2091, Walmart, DORAL, FL",
            disabled: false,
          },
          {
            name: "2092, Albertsons, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "2092, CVS, BUDD LAKE, NJ",
            disabled: false,
          },
          {
            name: "2092, Target, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "2092, Walmart, OGDENSBURG, NY",
            disabled: false,
          },
          {
            name: "2093, Albertsons, LA MESA, CA",
            disabled: false,
          },
          {
            name: "2093, CVS, FAIR LAWN, NJ",
            disabled: false,
          },
          {
            name: "2093, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2093, Walmart, UTICA, NY",
            disabled: false,
          },
          {
            name: "2094, Albertsons, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "2094, CVS, WESTAMPTON, NJ",
            disabled: false,
          },
          {
            name: "2094, Walmart, VISTA, CA",
            disabled: false,
          },
          {
            name: "2095, Target, OWASSO, OK",
            disabled: false,
          },
          {
            name: "2095, Walmart, WAREHAM, MA",
            disabled: false,
          },
          {
            name: "2096, Albertsons, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2096, CVS, HEWLETT, NY",
            disabled: false,
          },
          {
            name: "2096, Target, RIVERBANK, CA",
            disabled: false,
          },
          {
            name: "2096, Walmart, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "2097, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2097, CVS, ORANGE, CT",
            disabled: false,
          },
          {
            name: "2097, Walmart, HUDSON, NY",
            disabled: false,
          },
          {
            name: "2098, CVS, GARDNER, MA",
            disabled: false,
          },
          {
            name: "2098, Target, BRANSON, MO",
            disabled: false,
          },
          {
            name: "2098, Walmart, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "2099, CVS, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "2099, Target, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "2099, Walmart, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "21, ADUSA, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "21, BJ's, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "21, Costco, DANVILLE, CA",
            disabled: false,
          },
          {
            name: "21, Kroger, BEND, OR",
            disabled: false,
          },
          {
            name: "21, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "21, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "21, Kroger, Groveland, FL",
            disabled: false,
          },
          {
            name: "21, Kroger, SOUTH PASADENA, CA",
            disabled: false,
          },
          {
            name: "21, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "21, Meijer, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "21, Walmart, SAINT ROBERT, MO",
            disabled: false,
          },
          {
            name: "210, ADUSA, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "210, BJ's, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "210, CVS, BARRINGTON, RI",
            disabled: false,
          },
          {
            name: "210, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "210, Kroger, BLACKSBURG, VA",
            disabled: false,
          },
          {
            name: "210, Kroger, DUNWOODY, GA",
            disabled: false,
          },
          {
            name: "210, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "210, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "210, Kroger, MONROE, WA",
            disabled: false,
          },
          {
            name: "210, Meijer, GRAND LEDGE, MI",
            disabled: false,
          },
          {
            name: "210, Rite Aid, JEANNETTE, PA",
            disabled: false,
          },
          {
            name: "210, Walmart, HOLDENVILLE, OK",
            disabled: false,
          },
          {
            name: "2100, ADUSA, MAXTON, NC",
            disabled: false,
          },
          {
            name: "2100, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2100, CVS, FAIRFAX STATION, VA",
            disabled: false,
          },
          {
            name: "2100, Target, MONACA, PA",
            disabled: false,
          },
          {
            name: "2100, Walmart, CHEBOYGAN, MI",
            disabled: false,
          },
          {
            name: "2101, Albertsons, MONTECITO, CA",
            disabled: false,
          },
          {
            name: "2101, CVS, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "2101, Target, ROSEVILLE, MN",
            disabled: false,
          },
          {
            name: "2101, Walmart, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "2102, ADUSA, CHASE CITY, VA",
            disabled: false,
          },
          {
            name: "2102, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "2102, Target, CENTRAL ISLIP, NY",
            disabled: false,
          },
          {
            name: "2102, Walmart, LUDINGTON, MI",
            disabled: false,
          },
          {
            name: "2103, ADUSA, DOBSON, NC",
            disabled: false,
          },
          {
            name: "2103, Albertsons, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "2103, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "2103, Target, DARDENNE PRAIRIE, MO",
            disabled: false,
          },
          {
            name: "2103, Walmart, WALPOLE, MA",
            disabled: false,
          },
          {
            name: "2104, ADUSA, VICTORIA, VA",
            disabled: false,
          },
          {
            name: "2104, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2104, Target, DELRAN, NJ",
            disabled: false,
          },
          {
            name: "2104, Walmart, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "2105, ADUSA, BLACKSBURG, SC",
            disabled: false,
          },
          {
            name: "2105, Albertsons, MARINA DEL REY, CA",
            disabled: false,
          },
          {
            name: "2105, CVS, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "2105, Target, FENTON, MI",
            disabled: false,
          },
          {
            name: "2105, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2106, ADUSA, SAINT PAULS, NC",
            disabled: false,
          },
          {
            name: "2106, Albertsons, WHITEFISH, MT",
            disabled: false,
          },
          {
            name: "2106, Target, FITCHBURG, WI",
            disabled: false,
          },
          {
            name: "2106, Walmart, RENO, NV",
            disabled: false,
          },
          {
            name: "2107, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2107, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "2107, Walmart, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "2108, ADUSA, VANCEBORO, NC",
            disabled: false,
          },
          {
            name: "2108, Albertsons, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "2108, CVS, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "2108, Target, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "2108, Walmart, MAYS LANDING, NJ",
            disabled: false,
          },
          {
            name: "2109, ADUSA, BUNN, NC",
            disabled: false,
          },
          {
            name: "2109, CVS, VERNON ROCKVILLE, CT",
            disabled: false,
          },
          {
            name: "2109, Target, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "2109, Walmart, MILLVILLE, NJ",
            disabled: false,
          },
          {
            name: "211, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "211, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "211, BJ's, NORTHBOROUGH, MA",
            disabled: false,
          },
          {
            name: "211, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "211, Meijer, ROSSFORD, OH",
            disabled: false,
          },
          {
            name: "211, Walmart, HILLSBORO, TX",
            disabled: false,
          },
          {
            name: "2110, ADUSA, COLUMBIA, NC",
            disabled: false,
          },
          {
            name: "2110, Albertsons, HERMOSA BEACH, CA",
            disabled: false,
          },
          {
            name: "2110, CVS, HUNTINGDON VALLEY, PA",
            disabled: false,
          },
          {
            name: "2110, Target, KEIZER, OR",
            disabled: false,
          },
          {
            name: "2110, Walgreens, SAUKVILLE, WI",
            disabled: false,
          },
          {
            name: "2110, Walmart, PARAMOUNT, CA",
            disabled: false,
          },
          {
            name: "2111, ADUSA, COURTLAND, VA",
            disabled: false,
          },
          {
            name: "2111, Albertsons, NEWHALL, CA",
            disabled: false,
          },
          {
            name: "2111, CVS, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "2111, Target, KNIGHTDALE, NC",
            disabled: false,
          },
          {
            name: "2111, Walmart, HOOVER, AL",
            disabled: false,
          },
          {
            name: "2112, CVS, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "2112, Target, LAREDO, TX",
            disabled: false,
          },
          {
            name: "2112, Walgreens, CLAYTON, CA",
            disabled: false,
          },
          {
            name: "2112, Walmart, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "2113, ADUSA, HAW RIVER, NC",
            disabled: false,
          },
          {
            name: "2113, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2113, Target, Macomb, MI",
            disabled: false,
          },
          {
            name: "2113, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2114, Target, North Huntingdon, PA",
            disabled: false,
          },
          {
            name: "2114, Walmart, CHIPLEY, FL",
            disabled: false,
          },
          {
            name: "21144, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2115, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2115, CVS, HELLERTOWN, PA",
            disabled: false,
          },
          {
            name: "2115, Target, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2115, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2115, Walmart, NEW PHILADELPHIA, OH",
            disabled: false,
          },
          {
            name: "21154, Walgreens, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "21156, Walgreens, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "21157, Walgreens, PLAQUEMINE, LA",
            disabled: false,
          },
          {
            name: "21159, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2116, ADUSA, ROCKY POINT, NC",
            disabled: false,
          },
          {
            name: "2116, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2116, CVS, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "2116, Walmart, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "21166, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2117, ADUSA, MILLINGTON, MD",
            disabled: false,
          },
          {
            name: "2117, Walmart, LOS BANOS, CA",
            disabled: false,
          },
          {
            name: "2118, ADUSA, DINWIDDIE, VA",
            disabled: false,
          },
          {
            name: "2118, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2118, CVS, SOLOMONS, MD",
            disabled: false,
          },
          {
            name: "2118, Target, LUTZ, FL",
            disabled: false,
          },
          {
            name: "2118, Walmart, LUNENBURG, MA",
            disabled: false,
          },
          {
            name: "2119, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2119, CVS, KENSINGTON, CT",
            disabled: false,
          },
          {
            name: "2119, Target, WADSWORTH, OH",
            disabled: false,
          },
          {
            name: "2119, Walmart, MILPITAS, CA",
            disabled: false,
          },
          {
            name: "21192, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "212, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "212, BJ's, GARDEN CITY, NY",
            disabled: false,
          },
          {
            name: "212, HEB, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "212, Kroger, Bluffdale, UT",
            disabled: false,
          },
          {
            name: "212, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "212, Kroger, TUCKER, GA",
            disabled: false,
          },
          {
            name: "212, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "212, Meijer, Reynoldsburg, OH",
            disabled: false,
          },
          {
            name: "212, Target, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "212, Walmart, NORMAN, OK",
            disabled: false,
          },
          {
            name: "2120, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2120, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2120, Target, KEENE, NH",
            disabled: false,
          },
          {
            name: "2120, Walmart, NORWICH, NY",
            disabled: false,
          },
          {
            name: "21200, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "2121, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2121, Target, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "2121, Walmart, SHELTON, WA",
            disabled: false,
          },
          {
            name: "2122, CVS, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "2122, Target, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "2122, Walgreens, YONKERS, NY",
            disabled: false,
          },
          {
            name: "2122, Walmart, AVON, MA",
            disabled: false,
          },
          {
            name: "2123, ADUSA, SELBYVILLE, DE",
            disabled: false,
          },
          {
            name: "2123, Albertsons, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "2123, Target, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "2123, Walmart, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "21237, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "21238, Walgreens, LIVINGSTON, TX",
            disabled: false,
          },
          {
            name: "2124, ADUSA, LADSON, SC",
            disabled: false,
          },
          {
            name: "2124, Albertsons, TUJUNGA, CA",
            disabled: false,
          },
          {
            name: "2124, CVS, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "2124, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2124, Walmart, BEAVERCREEK, OH",
            disabled: false,
          },
          {
            name: "21246, Walgreens, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "2125, Albertsons, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "2125, CVS, NATICK, MA",
            disabled: false,
          },
          {
            name: "2125, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2125, Walmart, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "2126, CVS, LAWRENCEVILLE, NJ",
            disabled: false,
          },
          {
            name: "2126, Target, MOUNT JULIET, TN",
            disabled: false,
          },
          {
            name: "2126, Walmart, MILILANI, HI",
            disabled: false,
          },
          {
            name: "2127, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "2127, Target, LANESBOROUGH, MA",
            disabled: false,
          },
          {
            name: "2127, Walmart, WAUSAU, WI",
            disabled: false,
          },
          {
            name: "2128, CVS, NEEDHAM, MA",
            disabled: false,
          },
          {
            name: "2128, Target, IRVINE, CA",
            disabled: false,
          },
          {
            name: "2128, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "2128, Walmart, HALIFAX, MA",
            disabled: false,
          },
          {
            name: "21283, Walgreens, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "2129, CVS, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "2129, Target, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "2129, Walgreens, SUNNY ISLES BEACH, FL",
            disabled: false,
          },
          {
            name: "2129, Walmart, CLEARFIELD, PA",
            disabled: false,
          },
          {
            name: "21293, Walgreens, MARICOPA, AZ",
            disabled: false,
          },
          {
            name: "213, BJ's, AMHERST, NY",
            disabled: false,
          },
          {
            name: "213, Costco, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "213, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "213, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "213, Kroger, WEST HILLS, CA",
            disabled: false,
          },
          {
            name: "213, Meijer, BIRCH RUN, MI",
            disabled: false,
          },
          {
            name: "213, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "213, ShopRite, NEWTON, NJ",
            disabled: false,
          },
          {
            name: "213, Walmart, LITCHFIELD, IL",
            disabled: false,
          },
          {
            name: "2130, ADUSA, SHALLOTTE, NC",
            disabled: false,
          },
          {
            name: "2130, Albertsons, BONITA, CA",
            disabled: false,
          },
          {
            name: "2130, CVS, LAKEWOOD, NJ",
            disabled: false,
          },
          {
            name: "2130, Target, TOPSHAM, ME",
            disabled: false,
          },
          {
            name: "2130, Walmart, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "2131, Albertsons, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "2131, CVS, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "2131, Target, ROYERSFORD, PA",
            disabled: false,
          },
          {
            name: "2131, Walmart, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "2132, ADUSA, DAWSONVILLE, GA",
            disabled: false,
          },
          {
            name: "2132, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2132, Walgreens, INDEPENDENCE, OH",
            disabled: false,
          },
          {
            name: "2132, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2133, CVS, KINGSTON, PA",
            disabled: false,
          },
          {
            name: "2133, Target, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "2133, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2134, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2134, CVS, NORTH BELLMORE, NY",
            disabled: false,
          },
          {
            name: "2134, Target, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "2134, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2135, CVS, CORTLAND, NY",
            disabled: false,
          },
          {
            name: "2135, Target, OAKDALE, MN",
            disabled: false,
          },
          {
            name: "2135, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2135, Walmart, COBLESKILL, NY",
            disabled: false,
          },
          {
            name: "2136, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2136, Target, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "2136, Walgreens, DEER PARK, OH",
            disabled: false,
          },
          {
            name: "2136, Walmart, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "2137, CVS, WYNANTSKILL, NY",
            disabled: false,
          },
          {
            name: "2137, Target, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2137, Walgreens, BEACH PARK, IL",
            disabled: false,
          },
          {
            name: "2137, Walmart, DURHAM, NC",
            disabled: false,
          },
          {
            name: "2138, ADUSA, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "2138, CVS, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "2138, Target, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "2138, Walmart, WEST LEBANON, NH",
            disabled: false,
          },
          {
            name: "2139, CVS, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "2139, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2139, Walmart, LYNN, MA",
            disabled: false,
          },
          {
            name: "214, ADUSA, WILSON, NC",
            disabled: false,
          },
          {
            name: "214, Albertsons, AIEA, HI",
            disabled: false,
          },
          {
            name: "214, BJ's, BROOKFIELD, CT",
            disabled: false,
          },
          {
            name: "214, CVS, DELAND, FL",
            disabled: false,
          },
          {
            name: "214, Costco, BELTSVILLE, MD",
            disabled: false,
          },
          {
            name: "214, Kroger, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "214, Kroger, Heber City, UT",
            disabled: false,
          },
          {
            name: "214, Kroger, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "214, Meijer, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "214, Walmart, JASPER, TX",
            disabled: false,
          },
          {
            name: "2140, CVS, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "2140, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2140, Walmart, NORTH CONWAY, NH",
            disabled: false,
          },
          {
            name: "2141, Albertsons, BREA, CA",
            disabled: false,
          },
          {
            name: "2141, Target, VAUXHALL, NJ",
            disabled: false,
          },
          {
            name: "2141, Walgreens, WYCKOFF, NJ",
            disabled: false,
          },
          {
            name: "2141, Walmart, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2142, Albertsons, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "2142, Target, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "2142, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "2142, Walmart, SALEM, NH",
            disabled: false,
          },
          {
            name: "2143, ADUSA, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "2143, Target, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "2143, Walmart, SKOWHEGAN, ME",
            disabled: false,
          },
          {
            name: "2144, Albertsons, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "2144, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2144, Walmart, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "2145, ADUSA, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "2145, CVS, WOODMERE, NY",
            disabled: false,
          },
          {
            name: "2145, Target, DENTON, TX",
            disabled: false,
          },
          {
            name: "2145, Walmart, WHITEHALL, PA",
            disabled: false,
          },
          {
            name: "2146, ADUSA, OAK RIDGE, NC",
            disabled: false,
          },
          {
            name: "2146, CVS, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "2146, Target, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "2146, Walmart, AMSTERDAM, NY",
            disabled: false,
          },
          {
            name: "2147, Albertsons, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "2147, CVS, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "2147, Target, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "2147, Walmart, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "2148, CVS, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "2149, Target, TOLLESON, AZ",
            disabled: false,
          },
          {
            name: "2149, Walmart, MOUNT VERNON, OH",
            disabled: false,
          },
          {
            name: "215, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "215, BJ's, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "215, Kroger, BROWNSBURG, IN",
            disabled: false,
          },
          {
            name: "215, Kroger, FAIRLAWN, VA",
            disabled: false,
          },
          {
            name: "215, Kroger, KENT, WA",
            disabled: false,
          },
          {
            name: "215, Kroger, Loogootee, IN",
            disabled: false,
          },
          {
            name: "215, Kroger, Weirton, WV",
            disabled: false,
          },
          {
            name: "215, Meijer, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "215, ShopRite, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "215, Target, SAINT CLOUD, MN",
            disabled: false,
          },
          {
            name: "215, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2150, ADUSA, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "2150, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2150, CVS, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "2150, Target, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "2150, Walgreens, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "2150, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2151, CVS, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "2151, Target, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "2151, Walmart, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "2152, Albertsons, PASADENA, CA",
            disabled: false,
          },
          {
            name: "2152, CVS, RICHFIELD, MN",
            disabled: false,
          },
          {
            name: "2152, Target, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "2152, Walmart, ALBANY, NY",
            disabled: false,
          },
          {
            name: "2153, CVS, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "2153, Target, OXFORD, AL",
            disabled: false,
          },
          {
            name: "2153, Walmart, BIDDEFORD, ME",
            disabled: false,
          },
          {
            name: "2154, CVS, BELLMORE, NY",
            disabled: false,
          },
          {
            name: "2154, Target, GULF SHORES, AL",
            disabled: false,
          },
          {
            name: "2154, Walmart, DULUTH, GA",
            disabled: false,
          },
          {
            name: "2155, ADUSA, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "2155, Albertsons, CLAREMONT, CA",
            disabled: false,
          },
          {
            name: "2155, CVS, HERNDON, VA",
            disabled: false,
          },
          {
            name: "2155, Target, YULEE, FL",
            disabled: false,
          },
          {
            name: "2155, Walgreens, MONTEBELLO, CA",
            disabled: false,
          },
          {
            name: "2155, Walmart, GARDNER, MA",
            disabled: false,
          },
          {
            name: "2156, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "2156, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2156, Target, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "2156, Walgreens, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "2156, Walmart, MIDDLE ISLAND, NY",
            disabled: false,
          },
          {
            name: "2157, Target, STREETSBORO, OH",
            disabled: false,
          },
          {
            name: "2157, Walmart, NORTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "2158, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "2158, Target, ELMIRA, NY",
            disabled: false,
          },
          {
            name: "2158, Walmart, NORTHBOROUGH, MA",
            disabled: false,
          },
          {
            name: "2159, ADUSA, RICHMOND HILL, GA",
            disabled: false,
          },
          {
            name: "2159, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2159, Target, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "2159, Walmart, OLEAN, NY",
            disabled: false,
          },
          {
            name: "216, Albertsons, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "216, BJ's, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "216, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "216, Rite Aid, MOSCOW, PA",
            disabled: false,
          },
          {
            name: "216, Walmart, MARION, IL",
            disabled: false,
          },
          {
            name: "2160, Albertsons, PALOS PARK, IL",
            disabled: false,
          },
          {
            name: "2160, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2160, Walmart, PETERSBURG, VA",
            disabled: false,
          },
          {
            name: "2161, CVS, OXFORD, MA",
            disabled: false,
          },
          {
            name: "2161, Target, Aurora, OH",
            disabled: false,
          },
          {
            name: "2161, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "2161, Walmart, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "2162, Albertsons, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "2162, Walgreens, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "2163, CVS, DELRAN, NJ",
            disabled: false,
          },
          {
            name: "2163, Target, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "2163, Walmart, SHELTON, CT",
            disabled: false,
          },
          {
            name: "2164, ADUSA, CLAYMONT, DE",
            disabled: false,
          },
          {
            name: "2164, Albertsons, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2164, CVS, MOUNT VERNON, NY",
            disabled: false,
          },
          {
            name: "2164, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2164, Walmart, SPRINGVILLE, NY",
            disabled: false,
          },
          {
            name: "2165, Target, VISTA, CA",
            disabled: false,
          },
          {
            name: "2166, Target, BIDDEFORD, ME",
            disabled: false,
          },
          {
            name: "2166, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "2166, Walmart, EAST SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "2167, Albertsons, WALNUT, CA",
            disabled: false,
          },
          {
            name: "2167, Target, NORTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "2167, Walmart, EXTON, PA",
            disabled: false,
          },
          {
            name: "2168, Target, WILSON, NC",
            disabled: false,
          },
          {
            name: "2169, Albertsons, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "2169, CVS, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "2169, Target, Concord, NC",
            disabled: false,
          },
          {
            name: "2169, Walmart, LEHIGHTON, PA",
            disabled: false,
          },
          {
            name: "217, CVS, TEWKSBURY, MA",
            disabled: false,
          },
          {
            name: "217, Costco, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "217, Meijer, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "217, Target, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "217, Walmart, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "2170, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2170, Target, MILLVILLE, NJ",
            disabled: false,
          },
          {
            name: "2170, Walgreens, AUBURN, CA",
            disabled: false,
          },
          {
            name: "2170, Walmart, NORWICH, CT",
            disabled: false,
          },
          {
            name: "2171, CVS, MILLBURY, MA",
            disabled: false,
          },
          {
            name: "2171, Target, Atlanta, GA",
            disabled: false,
          },
          {
            name: "2171, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "2172, Target, GLEN MILLS, PA",
            disabled: false,
          },
          {
            name: "2173, CVS, MEDIA, PA",
            disabled: false,
          },
          {
            name: "2173, Target, ABINGTON, MA",
            disabled: false,
          },
          {
            name: "2174, ADUSA, MONETA, VA",
            disabled: false,
          },
          {
            name: "2174, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2174, Target, CONYERS, GA",
            disabled: false,
          },
          {
            name: "2174, Walmart, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "2175, Albertsons, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "2175, Target, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "2175, Walmart, BRANSON WEST, MO",
            disabled: false,
          },
          {
            name: "2176, Albertsons, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "2176, Target, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "2176, Walmart, JUPITER, FL",
            disabled: false,
          },
          {
            name: "2177, Albertsons, DESERT HOT SPRINGS, CA",
            disabled: false,
          },
          {
            name: "2177, CVS, GEORGETOWN, MA",
            disabled: false,
          },
          {
            name: "2177, Target, NORTH AURORA, IL",
            disabled: false,
          },
          {
            name: "2177, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2178, CVS, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "2178, Target, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "2178, Walmart, CALAIS, ME",
            disabled: false,
          },
          {
            name: "2179, CVS, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "2179, Target, DIAMOND BAR, CA",
            disabled: false,
          },
          {
            name: "218, ADUSA, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "218, Albertsons, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "218, CVS, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "218, Costco, STERLING, VA",
            disabled: false,
          },
          {
            name: "218, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "218, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "218, Kroger, Brookhaven, GA",
            disabled: false,
          },
          {
            name: "218, Kroger, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "218, Meijer, MCHENRY, IL",
            disabled: false,
          },
          {
            name: "218, Rite Aid, NANTICOKE, PA",
            disabled: false,
          },
          {
            name: "218, Walmart, SELMER, TN",
            disabled: false,
          },
          {
            name: "2180, ADUSA, MERCERSBURG, PA",
            disabled: false,
          },
          {
            name: "2180, CVS, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "2180, Target, MONTICELLO, MN",
            disabled: false,
          },
          {
            name: "2180, Walmart, DANVERS, MA",
            disabled: false,
          },
          {
            name: "2181, ADUSA, CARTHAGE, NC",
            disabled: false,
          },
          {
            name: "2181, Target, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "2181, Walmart, INDIO, CA",
            disabled: false,
          },
          {
            name: "2182, ADUSA, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "2182, Target, SOMERSWORTH, NH",
            disabled: false,
          },
          {
            name: "2183, Target, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "2183, Walmart, OXFORD, ME",
            disabled: false,
          },
          {
            name: "2184, CVS, FOREST PARK, GA",
            disabled: false,
          },
          {
            name: "2184, Target, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "2184, Walmart, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "2185, CVS, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "2185, Target, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "2185, Walmart, SELINSGROVE, PA",
            disabled: false,
          },
          {
            name: "2186, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2186, Target, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "2187, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "2187, CVS, MABLETON, GA",
            disabled: false,
          },
          {
            name: "2187, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2187, Walmart, WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "2188, Albertsons, FRESNO, CA",
            disabled: false,
          },
          {
            name: "2188, CVS, STARKE, FL",
            disabled: false,
          },
          {
            name: "2188, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2188, Walmart, EAGLE RIVER, AK",
            disabled: false,
          },
          {
            name: "2189, ADUSA, MINERAL, VA",
            disabled: false,
          },
          {
            name: "2189, CVS, GREER, SC",
            disabled: false,
          },
          {
            name: "2189, Target, St.Louis Park, MN",
            disabled: false,
          },
          {
            name: "2189, Walmart, RENO, NV",
            disabled: false,
          },
          {
            name: "219, ADUSA, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "219, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "219, CVS, SANFORD, FL",
            disabled: false,
          },
          {
            name: "219, Meijer, HOMER GLEN, IL",
            disabled: false,
          },
          {
            name: "219, Rite Aid, DENVILLE, NJ",
            disabled: false,
          },
          {
            name: "219, ShopRite, PEARL RIVER, NY",
            disabled: false,
          },
          {
            name: "219, Target, ABILENE, TX",
            disabled: false,
          },
          {
            name: "219, Walmart, SEDALIA, MO",
            disabled: false,
          },
          {
            name: "2190, Albertsons, BELMONT, NH",
            disabled: false,
          },
          {
            name: "2190, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2190, Target, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "2190, Walmart, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "2191, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2191, Target, DEPEW, NY",
            disabled: false,
          },
          {
            name: "2191, Walmart, BRYAN, OH",
            disabled: false,
          },
          {
            name: "2192, CVS, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "2192, Target, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "2192, Walgreens, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "2192, Walmart, HOUGHTON, MI",
            disabled: false,
          },
          {
            name: "2193, ADUSA, FINKSBURG, MD",
            disabled: false,
          },
          {
            name: "2193, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2193, Target, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "2193, Walgreens, DAVIE, FL",
            disabled: false,
          },
          {
            name: "2193, Walmart, STEUBENVILLE, OH",
            disabled: false,
          },
          {
            name: "2194, ADUSA, FALLING WATERS, WV",
            disabled: false,
          },
          {
            name: "2194, CVS, MAULDIN, SC",
            disabled: false,
          },
          {
            name: "2194, Target, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "2194, Walmart, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2195, ADUSA, MEYERSDALE, PA",
            disabled: false,
          },
          {
            name: "2195, Target, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "2195, Walmart, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "2196, CVS, BLACKWOOD, NJ",
            disabled: false,
          },
          {
            name: "2196, Target, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "2196, Walmart, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "2197, ADUSA, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "2197, CVS, ROCHESTER, NH",
            disabled: false,
          },
          {
            name: "2197, Target, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "2197, Walmart, CORTLAND, OH",
            disabled: false,
          },
          {
            name: "2198, CVS, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "2198, Walmart, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "2199, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2199, CVS, CAMDEN, NJ",
            disabled: false,
          },
          {
            name: "2199, Target, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "2199, Walmart, SAINT CLAIRSVILLE, OH",
            disabled: false,
          },
          {
            name: "22, ADUSA, SOUTH YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "22, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "22, Costco, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "22, HEB, ROBSTOWN, TX",
            disabled: false,
          },
          {
            name: "22, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "22, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "22, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "22, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "22, Kroger, Tampa, FL",
            disabled: false,
          },
          {
            name: "22, Meijer, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "22, Walmart, PRYOR, OK",
            disabled: false,
          },
          {
            name: "220, ADUSA, AMHERST, OH",
            disabled: false,
          },
          {
            name: "220, BJ's, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "220, Kroger, Mitchell, IN",
            disabled: false,
          },
          {
            name: "220, Kroger, NEWBERG, OR",
            disabled: false,
          },
          {
            name: "220, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "220, Meijer, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "220, Rite Aid, BELVIDERE, NJ",
            disabled: false,
          },
          {
            name: "220, Target, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "220, Walmart, BURLESON, TX",
            disabled: false,
          },
          {
            name: "2200, Albertsons, MONROVIA, CA",
            disabled: false,
          },
          {
            name: "2200, CVS, MARSTONS MILLS, MA",
            disabled: false,
          },
          {
            name: "2200, Target, FRIDLEY, MN",
            disabled: false,
          },
          {
            name: "2200, Walmart, GROTON, CT",
            disabled: false,
          },
          {
            name: "2201, CVS, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "2201, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2201, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "2202, ADUSA, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "2202, Target, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "2202, Walmart, WINDHAM, ME",
            disabled: false,
          },
          {
            name: "2203, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "2203, CVS, HILLSBOROUGH, NJ",
            disabled: false,
          },
          {
            name: "2203, Target, Chesapeake, VA",
            disabled: false,
          },
          {
            name: "2203, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "2204, ADUSA, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "2204, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2204, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2204, Target, BRYANT, AR",
            disabled: false,
          },
          {
            name: "2204, Walmart, FOREST PARK, IL",
            disabled: false,
          },
          {
            name: "2205, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2205, Rite Aid, FOREST HILL, MD",
            disabled: false,
          },
          {
            name: "2205, Target, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "2205, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "2205, Walmart, YORK, PA",
            disabled: false,
          },
          {
            name: "2206, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "2206, CVS, SOUTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "2206, Target, NAMPA, ID",
            disabled: false,
          },
          {
            name: "2206, Walgreens, MACOMB, IL",
            disabled: false,
          },
          {
            name: "2206, Walmart, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "2207, CVS, MILLVILLE, NJ",
            disabled: false,
          },
          {
            name: "2207, Target, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "2207, Walmart, MIDVALE, UT",
            disabled: false,
          },
          {
            name: "2208, Albertsons, KAILUA, HI",
            disabled: false,
          },
          {
            name: "2208, Target, PANAMA CITY BEACH, FL",
            disabled: false,
          },
          {
            name: "2208, Walgreens, PEABODY, MA",
            disabled: false,
          },
          {
            name: "2208, Walmart, SAYRE, PA",
            disabled: false,
          },
          {
            name: "2209, ADUSA, SENECA, SC",
            disabled: false,
          },
          {
            name: "2209, Albertsons, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "2209, CVS, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "2209, Walgreens, YUMA, AZ",
            disabled: false,
          },
          {
            name: "2209, Walmart, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "221, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "221, Costco, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "221, Kroger, Columbus, OH",
            disabled: false,
          },
          {
            name: "221, Kroger, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "221, Meijer, GRANDVILLE, MI",
            disabled: false,
          },
          {
            name: "221, Target, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "221, Walmart, YUKON, OK",
            disabled: false,
          },
          {
            name: "2210, Albertsons, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "2210, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2210, Target, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "2210, Walmart, AMHERST, NY",
            disabled: false,
          },
          {
            name: "2211, CVS, LINDENHURST, NY",
            disabled: false,
          },
          {
            name: "2211, Target, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "2211, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2211, Walmart, POLAND, OH",
            disabled: false,
          },
          {
            name: "2212, ADUSA, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "2212, Albertsons, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "2212, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2212, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "2212, Walgreens, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "2213, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "2213, CVS, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "2213, Target, WINDSOR, CT",
            disabled: false,
          },
          {
            name: "2213, Walgreens, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "2213, Walmart, SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "2214, ADUSA, HARRISBURG, NC",
            disabled: false,
          },
          {
            name: "2214, Albertsons, BURBANK, CA",
            disabled: false,
          },
          {
            name: "2214, CVS, DE PERE, WI",
            disabled: false,
          },
          {
            name: "2214, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2214, Target, LINCOLN, CA",
            disabled: false,
          },
          {
            name: "2214, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2215, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2215, Albertsons, WESTLAKE VILLAGE, CA",
            disabled: false,
          },
          {
            name: "2215, Walmart, DARIEN, IL",
            disabled: false,
          },
          {
            name: "2216, Albertsons, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "2216, CVS, TOWSON, MD",
            disabled: false,
          },
          {
            name: "2216, Target, EL PASO, TX",
            disabled: false,
          },
          {
            name: "2217, Albertsons, RANCHO SANTA MARGARITA, CA",
            disabled: false,
          },
          {
            name: "2217, CVS, GREECE, NY",
            disabled: false,
          },
          {
            name: "2217, Target, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "2218, Albertsons, MILILANI, HI",
            disabled: false,
          },
          {
            name: "2218, Target, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "2218, Walmart, FOOTHILL RANCH, CA",
            disabled: false,
          },
          {
            name: "2219, ADUSA, QUINTON, VA",
            disabled: false,
          },
          {
            name: "2219, Albertsons, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "2219, CVS, ROCKY HILL, CT",
            disabled: false,
          },
          {
            name: "2219, Target, PARKER, CO",
            disabled: false,
          },
          {
            name: "2219, Walgreens, YUMA, AZ",
            disabled: false,
          },
          {
            name: "222, Albertsons, WILMINGTON, VT",
            disabled: false,
          },
          {
            name: "222, Costco, HAZLET, NJ",
            disabled: false,
          },
          {
            name: "222, Kroger, Bloomfield, IN",
            disabled: false,
          },
          {
            name: "222, Kroger, Decatur, GA",
            disabled: false,
          },
          {
            name: "222, Kroger, SHERMAN OAKS, CA",
            disabled: false,
          },
          {
            name: "222, Meijer, MADISON HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "222, Target, ROWLAND HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "222, Walmart, SPARTA, IL",
            disabled: false,
          },
          {
            name: "2220, ADUSA, WASHINGTON, NC",
            disabled: false,
          },
          {
            name: "2220, CVS, COVENTRY, CT",
            disabled: false,
          },
          {
            name: "2220, Target, NORMAN, OK",
            disabled: false,
          },
          {
            name: "2220, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "2221, ADUSA, HAMPTON, SC",
            disabled: false,
          },
          {
            name: "2221, CVS, KENSINGTON, MD",
            disabled: false,
          },
          {
            name: "2221, Target, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "2221, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "2222, ADUSA, AMERICUS, GA",
            disabled: false,
          },
          {
            name: "2222, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2222, Target, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "2222, Walgreens, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "2222, Walmart, TEWKSBURY, MA",
            disabled: false,
          },
          {
            name: "2223, ADUSA, SOUTHPORT, NC",
            disabled: false,
          },
          {
            name: "2223, CVS, YARDLEY, PA",
            disabled: false,
          },
          {
            name: "2223, Rite Aid, ELDERSBURG, MD",
            disabled: false,
          },
          {
            name: "2223, Target, MEDINA, MN",
            disabled: false,
          },
          {
            name: "2223, Walgreens, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "2223, Walmart, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "2224, ADUSA, SEAFORD, DE",
            disabled: false,
          },
          {
            name: "2224, Albertsons, PASADENA, CA",
            disabled: false,
          },
          {
            name: "2224, CVS, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "2224, Target, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "2224, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "2224, Walmart, WILLISTON, VT",
            disabled: false,
          },
          {
            name: "2225, ADUSA, EDENTON, NC",
            disabled: false,
          },
          {
            name: "2225, Albertsons, WEST HILLS, CA",
            disabled: false,
          },
          {
            name: "2225, CVS, NESCONSET, NY",
            disabled: false,
          },
          {
            name: "2225, Target, EDGEWATER, CO",
            disabled: false,
          },
          {
            name: "2225, Walgreens, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "2225, Walmart, NORTH SMITHFIELD, RI",
            disabled: false,
          },
          {
            name: "2226, ADUSA, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "2226, CVS, MECHANICVILLE, NY",
            disabled: false,
          },
          {
            name: "2226, Target, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "2226, Walgreens, GARFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "2226, Walmart, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "2227, ADUSA, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "2227, CVS, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "2227, Target, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "2227, Walgreens, EUREKA, MO",
            disabled: false,
          },
          {
            name: "2227, Walmart, ABINGTON, MA",
            disabled: false,
          },
          {
            name: "2228, Albertsons, SOUTH PASADENA, CA",
            disabled: false,
          },
          {
            name: "2228, CVS, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "2228, Target, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "2228, Walgreens, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "2228, Walmart, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "2229, ADUSA, MONROE, NC",
            disabled: false,
          },
          {
            name: "2229, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2229, CVS, PLYMOUTH, NH",
            disabled: false,
          },
          {
            name: "2229, Target, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "223, ADUSA, CREEDMOOR, NC",
            disabled: false,
          },
          {
            name: "223, CVS, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "223, HEB, ALICE, TX",
            disabled: false,
          },
          {
            name: "223, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "223, Kroger, LAGUNA HILLS, CA",
            disabled: false,
          },
          {
            name: "223, Kroger, PRATT, KS",
            disabled: false,
          },
          {
            name: "223, Meijer, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "223, Rite Aid, FRACKVILLE, PA",
            disabled: false,
          },
          {
            name: "223, Target, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2230, ADUSA, NEWARK, DE",
            disabled: false,
          },
          {
            name: "2230, CVS, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "2230, Target, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "2230, Walmart, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "2231, ADUSA, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "2231, Albertsons, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "2231, Target, TRIADELPHIA, WV",
            disabled: false,
          },
          {
            name: "2231, Walmart, MOLINE, IL",
            disabled: false,
          },
          {
            name: "2232, Albertsons, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "2232, CVS, GREENLAWN, NY",
            disabled: false,
          },
          {
            name: "2232, Target, NATIONAL CITY, CA",
            disabled: false,
          },
          {
            name: "2232, Walgreens, GREEN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "2232, Walmart, BRANFORD, CT",
            disabled: false,
          },
          {
            name: "2233, ADUSA, HANCOCK, MD",
            disabled: false,
          },
          {
            name: "2233, Albertsons, ROLLING HILLS ESTATES, CA",
            disabled: false,
          },
          {
            name: "2233, CVS, BELMONT, NC",
            disabled: false,
          },
          {
            name: "2233, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "2233, Walmart, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "2234, ADUSA, GARNER, NC",
            disabled: false,
          },
          {
            name: "2234, CVS, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "2234, Target, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "2234, Walmart, ROME, NY",
            disabled: false,
          },
          {
            name: "2235, Albertsons, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "2235, CVS, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "2235, Target, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "2236, CVS, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "2236, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2236, Walmart, HARLEYSVILLE, PA",
            disabled: false,
          },
          {
            name: "2237, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "2237, CVS, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "2237, Target, MISSION, TX",
            disabled: false,
          },
          {
            name: "2237, Walmart, LEHIGH ACRES, FL",
            disabled: false,
          },
          {
            name: "2238, ADUSA, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "2238, CVS, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "2238, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2238, Walmart, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "2239, CVS, FORT WASHINGTON, MD",
            disabled: false,
          },
          {
            name: "2239, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2239, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "224, ADUSA, TWINSBURG, OH",
            disabled: false,
          },
          {
            name: "224, Albertsons, JOLIET, IL",
            disabled: false,
          },
          {
            name: "224, CVS, READING, MA",
            disabled: false,
          },
          {
            name: "224, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "224, Kroger, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "224, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "224, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "224, Kroger, Mission Viejo, CA",
            disabled: false,
          },
          {
            name: "224, Meijer, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "224, Target, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "224, Walmart, MOUNT VERNON, IL",
            disabled: false,
          },
          {
            name: "2240, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2240, Target, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "2240, Walmart, HUMACAO, PR",
            disabled: false,
          },
          {
            name: "2241, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2241, Target, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "2241, Walmart, SUNNYSIDE, WA",
            disabled: false,
          },
          {
            name: "2242, ADUSA, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "2242, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2242, CVS, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "2242, Walmart, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "2243, ADUSA, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "2243, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "2243, Target, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "2243, Walgreens, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "2243, Walmart, REDMOND, OR",
            disabled: false,
          },
          {
            name: "2244, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2244, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2244, Walmart, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "2245, Target, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "2245, Walmart, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "2246, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "2246, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2246, Target, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "2247, ADUSA, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "2247, Target, RIVERDALE, NJ",
            disabled: false,
          },
          {
            name: "2247, Walmart, CARY, NC",
            disabled: false,
          },
          {
            name: "2248, Albertsons, LIBERTY LAKE, WA",
            disabled: false,
          },
          {
            name: "2248, Rite Aid, LAKE ARIEL, PA",
            disabled: false,
          },
          {
            name: "2248, Target, Port Saint Lucie, FL",
            disabled: false,
          },
          {
            name: "2248, Walmart, CATONSVILLE, MD",
            disabled: false,
          },
          {
            name: "2249, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "2249, Target, ANSONIA, CT",
            disabled: false,
          },
          {
            name: "2249, Walmart, CHEHALIS, WA",
            disabled: false,
          },
          {
            name: "225, Costco, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "225, Kroger, SALEM, OR",
            disabled: false,
          },
          {
            name: "225, Walmart, SULPHUR, OK",
            disabled: false,
          },
          {
            name: "2250, ADUSA, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "2250, Albertsons, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "2250, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2250, Target, CULPEPER, VA",
            disabled: false,
          },
          {
            name: "2250, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2251, ADUSA, WARRENVILLE, SC",
            disabled: false,
          },
          {
            name: "2251, CVS, SUMTER, SC",
            disabled: false,
          },
          {
            name: "2251, Target, PLEASANT PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "2251, Walmart, CITY OF INDUSTRY, CA",
            disabled: false,
          },
          {
            name: "2252, CVS, OWEGO, NY",
            disabled: false,
          },
          {
            name: "2252, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2252, Target, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "2252, Walmart, EASTON, PA",
            disabled: false,
          },
          {
            name: "2253, ADUSA, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "2253, CVS, CANTON, CT",
            disabled: false,
          },
          {
            name: "2253, Target, WATERTOWN, NY",
            disabled: false,
          },
          {
            name: "2253, Walmart, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "2254, ADUSA, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2254, Albertsons, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "2254, CVS, MILFORD, MA",
            disabled: false,
          },
          {
            name: "2254, Target, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "2254, Walmart, HAMMONTON, NJ",
            disabled: false,
          },
          {
            name: "2255, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2255, Albertsons, HAWTHORNE, NV",
            disabled: false,
          },
          {
            name: "2255, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2255, Target, WASHINGTON, MO",
            disabled: false,
          },
          {
            name: "2255, Walmart, HAZLE TOWNSHIP, PA",
            disabled: false,
          },
          {
            name: "2256, Target, MONMOUTH JUNCTION, NJ",
            disabled: false,
          },
          {
            name: "2256, Walmart, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "2257, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2258, Albertsons, TAHOE CITY, CA",
            disabled: false,
          },
          {
            name: "2258, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "2258, Target, STOUGHTON, MA",
            disabled: false,
          },
          {
            name: "2258, Walmart, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2259, Target, Washington, DC",
            disabled: false,
          },
          {
            name: "2259, Walmart, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "226, Albertsons, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "226, Costco, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "226, HEB, MISSION, TX",
            disabled: false,
          },
          {
            name: "226, Kroger, NAMPA, ID",
            disabled: false,
          },
          {
            name: "226, Kroger, SALEM, VA",
            disabled: false,
          },
          {
            name: "226, Meijer, ROCKFORD, MI",
            disabled: false,
          },
          {
            name: "226, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "226, Target, LA VERNE, CA",
            disabled: false,
          },
          {
            name: "226, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "226, Walmart, ATLANTA, TX",
            disabled: false,
          },
          {
            name: "2260, Target, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "2261, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2261, Target, SHERIDAN, CO",
            disabled: false,
          },
          {
            name: "2261, Walmart, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "2262, Albertsons, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "2262, CVS, BLAKESLEE, PA",
            disabled: false,
          },
          {
            name: "2262, Target, GIBSONIA, PA",
            disabled: false,
          },
          {
            name: "2262, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "2262, Walmart, ONEONTA, NY",
            disabled: false,
          },
          {
            name: "2263, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2263, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2263, Walmart, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "2264, CVS, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "2264, Rite Aid, CHESTER, PA",
            disabled: false,
          },
          {
            name: "2264, Target, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "2264, Walmart, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "2265, Albertsons, LA GRANGE PARK, IL",
            disabled: false,
          },
          {
            name: "2265, CVS, SADDLE BROOK, NJ",
            disabled: false,
          },
          {
            name: "2265, Target, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "2265, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2265, Walmart, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "2266, Albertsons, PACIFIC PALISADES, CA",
            disabled: false,
          },
          {
            name: "2266, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2266, Target, FAIRVIEW PARK, OH",
            disabled: false,
          },
          {
            name: "2266, Walmart, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "2267, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "2267, Rite Aid, BRISTOL, PA",
            disabled: false,
          },
          {
            name: "2267, Target, SOUTH EASTON, MA",
            disabled: false,
          },
          {
            name: "2267, Walmart, WEST BOYLSTON, MA",
            disabled: false,
          },
          {
            name: "2268, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2268, Target, WEST SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2269, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2269, Target, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "2269, Walmart, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "227, ADUSA, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "227, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "227, CVS, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "227, Costco, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "227, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "227, Kroger, Evansville, IN",
            disabled: false,
          },
          {
            name: "227, Kroger, NEWPORT, OR",
            disabled: false,
          },
          {
            name: "227, Meijer, WHITE LAKE, MI",
            disabled: false,
          },
          {
            name: "227, Target, SANTA FE SPRINGS, CA",
            disabled: false,
          },
          {
            name: "227, Walmart, EL RENO, OK",
            disabled: false,
          },
          {
            name: "2270, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2270, Target, EL DORADO HILLS, CA",
            disabled: false,
          },
          {
            name: "2270, Walmart, DURANGO, CO",
            disabled: false,
          },
          {
            name: "2271, CVS, NORMAN, OK",
            disabled: false,
          },
          {
            name: "2271, Rite Aid, MANCHESTER, PA",
            disabled: false,
          },
          {
            name: "2271, Target, Annapolis, MD",
            disabled: false,
          },
          {
            name: "2271, Walmart, SHAWANO, WI",
            disabled: false,
          },
          {
            name: "2272, Target, STERLING, VA",
            disabled: false,
          },
          {
            name: "2272, Walmart, CAMBRIDGE, MD",
            disabled: false,
          },
          {
            name: "2273, Albertsons, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "2273, Target, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "2273, Walmart, BURTON, MI",
            disabled: false,
          },
          {
            name: "2274, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "2274, Rite Aid, WHITEHALL, MI",
            disabled: false,
          },
          {
            name: "2274, Target, PRATTVILLE, AL",
            disabled: false,
          },
          {
            name: "2274, Walmart, FOREST LAKE, MN",
            disabled: false,
          },
          {
            name: "2275, Albertsons, MANHATTAN BEACH, CA",
            disabled: false,
          },
          {
            name: "2275, Target, COMPTON, CA",
            disabled: false,
          },
          {
            name: "2275, Walmart, OXFORD, OH",
            disabled: false,
          },
          {
            name: "2276, Target, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "2276, Walmart, LA PORTE, IN",
            disabled: false,
          },
          {
            name: "2277, Rite Aid, BEAVER, PA",
            disabled: false,
          },
          {
            name: "2277, Target, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "2277, Walgreens, MARYSVILLE, CA",
            disabled: false,
          },
          {
            name: "2277, Walmart, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "2278, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2278, Target, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "2278, Walmart, ERIE, PA",
            disabled: false,
          },
          {
            name: "2279, CVS, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "2279, Target, PACE, FL",
            disabled: false,
          },
          {
            name: "2279, Walmart, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "228, Albertsons, PASCO, WA",
            disabled: false,
          },
          {
            name: "228, CVS, WOODBURY, NJ",
            disabled: false,
          },
          {
            name: "228, Kroger, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "228, Meijer, ROLLING MEADOWS, IL",
            disabled: false,
          },
          {
            name: "228, Target, WEST HILLS, CA",
            disabled: false,
          },
          {
            name: "228, Walmart, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "2280, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "2280, Target, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "2280, Walmart, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "2281, CVS, JONESBORO, GA",
            disabled: false,
          },
          {
            name: "2281, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2281, Walmart, WEST MIFFLIN, PA",
            disabled: false,
          },
          {
            name: "2282, CVS, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "2282, Walmart, EAST WINDSOR, CT",
            disabled: false,
          },
          {
            name: "2283, Albertsons, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "2283, CVS, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "2283, Target, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "2283, Walmart, COVENTRY, RI",
            disabled: false,
          },
          {
            name: "2284, Target, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "2284, Walgreens, COCOA BEACH, FL",
            disabled: false,
          },
          {
            name: "2284, Walmart, NAUGATUCK, CT",
            disabled: false,
          },
          {
            name: "2285, Albertsons, LOS ALAMITOS, CA",
            disabled: false,
          },
          {
            name: "2285, CVS, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "2285, Walmart, HERKIMER, NY",
            disabled: false,
          },
          {
            name: "2286, Albertsons, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "2286, CVS, RONKONKOMA, NY",
            disabled: false,
          },
          {
            name: "2286, Walmart, CENTEREACH, NY",
            disabled: false,
          },
          {
            name: "2287, Albertsons, GRIDLEY, CA",
            disabled: false,
          },
          {
            name: "2287, Target, METHUEN, MA",
            disabled: false,
          },
          {
            name: "2287, Walmart, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "2288, Albertsons, MONTROSE, CA",
            disabled: false,
          },
          {
            name: "2288, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2288, Walmart, POMONA, CA",
            disabled: false,
          },
          {
            name: "2289, CVS, WINNETKA, CA",
            disabled: false,
          },
          {
            name: "2289, Target, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2289, Walmart, BENNINGTON, VT",
            disabled: false,
          },
          {
            name: "229, ADUSA, BRUNSWICK, OH",
            disabled: false,
          },
          {
            name: "229, ADUSA, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "229, Costco, BRICK TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "229, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "229, Meijer, MARYSVILLE, MI",
            disabled: false,
          },
          {
            name: "229, Rite Aid, HONESDALE, PA",
            disabled: false,
          },
          {
            name: "229, Target, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "229, Walmart, TRUMANN, AR",
            disabled: false,
          },
          {
            name: "2290, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2290, Target, RENTON, WA",
            disabled: false,
          },
          {
            name: "2291, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2291, Walmart, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "2292, CVS, FISHKILL, NY",
            disabled: false,
          },
          {
            name: "2292, Target, WAREHAM, MA",
            disabled: false,
          },
          {
            name: "2292, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "2292, Walmart, COVINA, CA",
            disabled: false,
          },
          {
            name: "2293, Walmart, EVERGREEN, CO",
            disabled: false,
          },
          {
            name: "2294, Target, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "2294, Walmart, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "2295, Albertsons, CORNING, CA",
            disabled: false,
          },
          {
            name: "2295, Target, CICERO, NY",
            disabled: false,
          },
          {
            name: "2295, Walmart, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2296, CVS, MACUNGIE, PA",
            disabled: false,
          },
          {
            name: "2296, Target, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "2296, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2297, CVS, LITITZ, PA",
            disabled: false,
          },
          {
            name: "2297, Target, FRONT ROYAL, VA",
            disabled: false,
          },
          {
            name: "2297, Walmart, STEVENSON RANCH, CA",
            disabled: false,
          },
          {
            name: "2299, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2299, Walmart, CROMWELL, CT",
            disabled: false,
          },
          {
            name: "23, ADUSA, SARVER, PA",
            disabled: false,
          },
          {
            name: "23, Albertsons, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "23, BJ's, NORTH DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "23, CVS, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "23, Costco, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "23, Kroger, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "23, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "23, Kroger, Jacksonville, FL",
            disabled: false,
          },
          {
            name: "23, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "23, Kroger, PRATT, KS",
            disabled: false,
          },
          {
            name: "23, Meijer, LANSING, MI",
            disabled: false,
          },
          {
            name: "23, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "23, Walmart, RUSTON, LA",
            disabled: false,
          },
          {
            name: "230, ADUSA, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "230, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "230, CVS, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "230, Costco, HOLBROOK, NY",
            disabled: false,
          },
          {
            name: "230, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "230, Meijer, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "230, Rite Aid, GREENCASTLE, PA",
            disabled: false,
          },
          {
            name: "230, Target, ORANGE, CA",
            disabled: false,
          },
          {
            name: "230, Walmart, PARIS, AR",
            disabled: false,
          },
          {
            name: "2300, CVS, PAULSBORO, NJ",
            disabled: false,
          },
          {
            name: "2300, Target, RICHFIELD, MN",
            disabled: false,
          },
          {
            name: "2300, Walmart, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2301, ADUSA, BURTONSVILLE, MD",
            disabled: false,
          },
          {
            name: "2301, Albertsons, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "2301, CVS, NEW EGYPT, NJ",
            disabled: false,
          },
          {
            name: "2301, Target, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "2302, CVS, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "2302, Target, TEMPLE, PA",
            disabled: false,
          },
          {
            name: "2302, Walmart, BARCELONETA, PR",
            disabled: false,
          },
          {
            name: "2303, Albertsons, HIGHLAND, CA",
            disabled: false,
          },
          {
            name: "2303, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "2303, Target, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "2304, ADUSA, NOTTINGHAM, MD",
            disabled: false,
          },
          {
            name: "2304, Target, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "2305, Albertsons, RESEDA, CA",
            disabled: false,
          },
          {
            name: "2305, CVS, MILLER PLACE, NY",
            disabled: false,
          },
          {
            name: "2305, Rite Aid, RUSSELLS POINT, OH",
            disabled: false,
          },
          {
            name: "2305, Target, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "2306, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2306, Albertsons, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "2306, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "2306, Target, MARINA, CA",
            disabled: false,
          },
          {
            name: "2306, Walmart, NORTHPORT, AL",
            disabled: false,
          },
          {
            name: "2307, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2307, Target, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "2307, Walmart, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "2308, Target, BRISTOL, VA",
            disabled: false,
          },
          {
            name: "2308, Walmart, LIHUE, HI",
            disabled: false,
          },
          {
            name: "2309, CVS, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "2309, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2309, Target, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "2309, Walmart, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "231, ADUSA, OAKTON, VA",
            disabled: false,
          },
          {
            name: "231, ADUSA, SHEFFIELD LAKE, OH",
            disabled: false,
          },
          {
            name: "231, CVS, VERNON, CT",
            disabled: false,
          },
          {
            name: "231, Costco, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "231, HEB, WESLACO, TX",
            disabled: false,
          },
          {
            name: "231, Kroger, Bedford, IN",
            disabled: false,
          },
          {
            name: "231, Meijer, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "231, Walmart, ADA, OK",
            disabled: false,
          },
          {
            name: "2310, ADUSA, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "2310, Albertsons, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "2310, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "2310, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2310, Target, EASTON, MD",
            disabled: false,
          },
          {
            name: "2310, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "2311, ADUSA, ODENTON, MD",
            disabled: false,
          },
          {
            name: "2311, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2311, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "2311, Walmart, HUNTINGTON, IN",
            disabled: false,
          },
          {
            name: "2312, ADUSA, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "2312, CVS, GARNERVILLE, NY",
            disabled: false,
          },
          {
            name: "2312, Target, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "2312, Walmart, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "2313, Albertsons, ELGIN, IL",
            disabled: false,
          },
          {
            name: "2313, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2313, Rite Aid, NAPOLEON, OH",
            disabled: false,
          },
          {
            name: "2313, Target, EDINA, MN",
            disabled: false,
          },
          {
            name: "2313, Walmart, STREETSBORO, OH",
            disabled: false,
          },
          {
            name: "2314, Albertsons, ATASCADERO, CA",
            disabled: false,
          },
          {
            name: "2314, CVS, CORNELIUS, NC",
            disabled: false,
          },
          {
            name: "2314, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2314, Target, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "2314, Walgreens, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "2314, Walmart, WAIPAHU, HI",
            disabled: false,
          },
          {
            name: "2315, Albertsons, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "2315, CVS, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "2315, Target, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "2315, Walmart, DALLAS, OR",
            disabled: false,
          },
          {
            name: "2316, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2316, Target, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "2316, Walgreens, BROOKLYN PARK, MN",
            disabled: false,
          },
          {
            name: "2316, Walmart, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "2317, ADUSA, OLNEY, MD",
            disabled: false,
          },
          {
            name: "2317, CVS, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "2317, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2317, Target, ESTERO, FL",
            disabled: false,
          },
          {
            name: "2317, Walmart, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "2318, ADUSA, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "2318, Albertsons, CORTE MADERA, CA",
            disabled: false,
          },
          {
            name: "2318, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2318, Walmart, INDIANA, PA",
            disabled: false,
          },
          {
            name: "2319, CVS, PENNSAUKEN, NJ",
            disabled: false,
          },
          {
            name: "2319, Rite Aid, LIMA, OH",
            disabled: false,
          },
          {
            name: "2319, Target, SIGNAL HILL, CA",
            disabled: false,
          },
          {
            name: "2319, Walmart, OAK HARBOR, WA",
            disabled: false,
          },
          {
            name: "232, ADUSA, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "232, ADUSA, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "232, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "232, CVS, AVON, NY",
            disabled: false,
          },
          {
            name: "232, Kroger, Lake Charles, LA",
            disabled: false,
          },
          {
            name: "232, Kroger, Princeton, IN",
            disabled: false,
          },
          {
            name: "232, Kroger, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "232, Meijer, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "232, Rite Aid, FAYETTEVILLE, PA",
            disabled: false,
          },
          {
            name: "232, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "232, Walmart, ATOKA, OK",
            disabled: false,
          },
          {
            name: "2320, CVS, MEDFORD, NJ",
            disabled: false,
          },
          {
            name: "2320, Rite Aid, FOSTORIA, OH",
            disabled: false,
          },
          {
            name: "2320, Target, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "2320, Walmart, COTTAGE GROVE, OR",
            disabled: false,
          },
          {
            name: "2321, CVS, ENOLA, PA",
            disabled: false,
          },
          {
            name: "2321, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2321, Target, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "2321, Walmart, KAILUA KONA, HI",
            disabled: false,
          },
          {
            name: "2322, CVS, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "2322, Target, MENTOR, OH",
            disabled: false,
          },
          {
            name: "2322, Walmart, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "2323, Albertsons, LA JOLLA, CA",
            disabled: false,
          },
          {
            name: "2323, CVS, WEST WARWICK, RI",
            disabled: false,
          },
          {
            name: "2323, Target, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "2323, Walmart, STOW, OH",
            disabled: false,
          },
          {
            name: "2324, CVS, OWASSO, OK",
            disabled: false,
          },
          {
            name: "2324, Target, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "2325, Albertsons, STOWE, VT",
            disabled: false,
          },
          {
            name: "2325, CVS, STOUGHTON, MA",
            disabled: false,
          },
          {
            name: "2325, Target, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "2325, Walgreens, LYNN, MA",
            disabled: false,
          },
          {
            name: "2325, Walmart, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "2326, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2326, Rite Aid, PERRYSBURG, OH",
            disabled: false,
          },
          {
            name: "2326, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2326, Walmart, HORNELL, NY",
            disabled: false,
          },
          {
            name: "2327, Albertsons, SOLANA BEACH, CA",
            disabled: false,
          },
          {
            name: "2327, Target, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "2328, Albertsons, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "2328, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "2328, Target, CARSON, CA",
            disabled: false,
          },
          {
            name: "2328, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2329, Target, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "2329, Walmart, ORANGE, MA",
            disabled: false,
          },
          {
            name: "233, ADUSA, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "233, CVS, NEWTOWN SQUARE, PA",
            disabled: false,
          },
          {
            name: "233, Costco, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "233, HEB, WHARTON, TX",
            disabled: false,
          },
          {
            name: "233, Kroger, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "233, Kroger, Evansville, IN",
            disabled: false,
          },
          {
            name: "233, Meijer, ALLEN PARK, MI",
            disabled: false,
          },
          {
            name: "233, Rite Aid, HUNTINGDON, PA",
            disabled: false,
          },
          {
            name: "233, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "233, Walmart, ANNA, IL",
            disabled: false,
          },
          {
            name: "2330, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2330, Target, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "2330, Walgreens, NEWTON, MA",
            disabled: false,
          },
          {
            name: "2330, Walmart, ROCHESTER, NH",
            disabled: false,
          },
          {
            name: "2331, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2331, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2331, Target, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "2331, Walmart, WATERFORD, CT",
            disabled: false,
          },
          {
            name: "2332, CVS, GEORGETOWN, KY",
            disabled: false,
          },
          {
            name: "2332, Target, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "2332, Walmart, ST. ALBANS, VT",
            disabled: false,
          },
          {
            name: "2333, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2333, Target, Sandy Springs, GA",
            disabled: false,
          },
          {
            name: "2333, Walmart, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "2334, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2334, Walmart, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "2335, Albertsons, ORANGE, CA",
            disabled: false,
          },
          {
            name: "2335, CVS, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "2335, Target, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "2335, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "2335, Walmart, MADISON, WI",
            disabled: false,
          },
          {
            name: "2336, Walmart, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "2337, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "2337, Target, HENRICO, VA",
            disabled: false,
          },
          {
            name: "2337, Walmart, ROCKY MOUNT, VA",
            disabled: false,
          },
          {
            name: "2338, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2338, CVS, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "2338, Target, FRISCO, TX",
            disabled: false,
          },
          {
            name: "2338, Walmart, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "2339, CVS, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "2339, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2339, Target, WASILLA, AK",
            disabled: false,
          },
          {
            name: "2339, Walmart, WEST LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "234, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "234, ADUSA, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "234, Kroger, Henderson, KY",
            disabled: false,
          },
          {
            name: "234, Meijer, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "234, Walmart, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "2340, CVS, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "2340, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2340, Target, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "2340, Walmart, EPHRATA, PA",
            disabled: false,
          },
          {
            name: "2341, Albertsons, FORT MORGAN, CO",
            disabled: false,
          },
          {
            name: "2341, CVS, BALLWIN, MO",
            disabled: false,
          },
          {
            name: "2341, Target, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "2341, Walmart, QUINCY, MA",
            disabled: false,
          },
          {
            name: "2342, Albertsons, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "2342, Target, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "2343, Albertsons, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "2343, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2343, Rite Aid, HOLLAND, OH",
            disabled: false,
          },
          {
            name: "2343, Target, MONTROSE, CO",
            disabled: false,
          },
          {
            name: "2344, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "2344, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2345, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "2345, CVS, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "2345, Target, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "2346, Albertsons, CAROL STREAM, IL",
            disabled: false,
          },
          {
            name: "2346, CVS, ERIE, PA",
            disabled: false,
          },
          {
            name: "2346, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2346, Target, AKRON, OH",
            disabled: false,
          },
          {
            name: "2346, Walmart, TOA BAJA, PR",
            disabled: false,
          },
          {
            name: "2347, CVS, EAST PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "2347, Rite Aid, BRYAN, OH",
            disabled: false,
          },
          {
            name: "2347, Target, LATHROP, CA",
            disabled: false,
          },
          {
            name: "2348, Albertsons, DEL MAR, CA",
            disabled: false,
          },
          {
            name: "2348, Rite Aid, WAUSEON, OH",
            disabled: false,
          },
          {
            name: "2348, Target, LAKE GENEVA, WI",
            disabled: false,
          },
          {
            name: "2348, Walmart, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "2349, Target, TULARE, CA",
            disabled: false,
          },
          {
            name: "2349, Walgreens, HOBBS, NM",
            disabled: false,
          },
          {
            name: "235, ADUSA, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "235, ADUSA, SHELBY, NC",
            disabled: false,
          },
          {
            name: "235, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "235, Kroger, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "235, Kroger, Evansville, IN",
            disabled: false,
          },
          {
            name: "235, Meijer, MARYSVILLE, OH",
            disabled: false,
          },
          {
            name: "2350, CVS, SCHWENKSVILLE, PA",
            disabled: false,
          },
          {
            name: "2350, Rite Aid, OTTAWA, OH",
            disabled: false,
          },
          {
            name: "2350, Target, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "2350, Walmart, WAUSEON, OH",
            disabled: false,
          },
          {
            name: "2351, ADUSA, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "2351, Rite Aid, LIMA, OH",
            disabled: false,
          },
          {
            name: "2351, Target, AMHERST, OH",
            disabled: false,
          },
          {
            name: "2351, Walmart, CATSKILL, NY",
            disabled: false,
          },
          {
            name: "2352, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2352, CVS, MURRAY, KY",
            disabled: false,
          },
          {
            name: "2352, Rite Aid, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "2352, Walmart, CAMBRIDGE, MN",
            disabled: false,
          },
          {
            name: "2353, CVS, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "2353, Rite Aid, WATERVILLE, OH",
            disabled: false,
          },
          {
            name: "2354, Rite Aid, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "2354, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2354, Walmart, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "2355, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2355, Rite Aid, SWANTON, OH",
            disabled: false,
          },
          {
            name: "2355, Target, FULTONDALE, AL",
            disabled: false,
          },
          {
            name: "2355, Walmart, WILLIAMSVILLE, NY",
            disabled: false,
          },
          {
            name: "2356, CVS, GARNER, NC",
            disabled: false,
          },
          {
            name: "2356, Target, MAGNOLIA, TX",
            disabled: false,
          },
          {
            name: "2357, CVS, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "2357, Rite Aid, SALEM, OH",
            disabled: false,
          },
          {
            name: "2357, Target, TULSA, OK",
            disabled: false,
          },
          {
            name: "2357, Walmart, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "2358, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2358, CVS, PORTSMOUTH, RI",
            disabled: false,
          },
          {
            name: "2358, Target, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "2358, Walmart, ALPENA, MI",
            disabled: false,
          },
          {
            name: "2359, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2359, CVS, MARTINEZ, GA",
            disabled: false,
          },
          {
            name: "2359, Rite Aid, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "2359, Target, LOS BANOS, CA",
            disabled: false,
          },
          {
            name: "2359, Walgreens, CHAMBLEE, GA",
            disabled: false,
          },
          {
            name: "2359, Walmart, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "236, ADUSA, HILLSVILLE, VA",
            disabled: false,
          },
          {
            name: "236, Albertsons, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "236, HEB, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "236, Kroger, Newburgh, IN",
            disabled: false,
          },
          {
            name: "236, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "236, Meijer, WILLIAMSBURG, MI",
            disabled: false,
          },
          {
            name: "236, Rite Aid, CLEMENTON, NJ",
            disabled: false,
          },
          {
            name: "236, Walmart, CROCKETT, TX",
            disabled: false,
          },
          {
            name: "2360, Albertsons, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "2360, CVS, NEW YORK, NY",
            disabled: false,
          },
          {
            name: "2360, Target, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "2360, Walmart, DUNWOODY, GA",
            disabled: false,
          },
          {
            name: "2361, CVS, MIDDLETOWN, NY",
            disabled: false,
          },
          {
            name: "2361, Target, TRUMBULL, CT",
            disabled: false,
          },
          {
            name: "2361, Walgreens, OWASSO, OK",
            disabled: false,
          },
          {
            name: "2361, Walmart, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "2362, Target, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "2362, Walgreens, BEDFORD, IN",
            disabled: false,
          },
          {
            name: "2362, Walmart, SOUTH EUCLID, OH",
            disabled: false,
          },
          {
            name: "2363, Albertsons, OAK FOREST, IL",
            disabled: false,
          },
          {
            name: "2363, CVS, WEBSTER GROVES, MO",
            disabled: false,
          },
          {
            name: "2363, Rite Aid, KENTON, OH",
            disabled: false,
          },
          {
            name: "2363, Target, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "2363, Walgreens, MADISON, AL",
            disabled: false,
          },
          {
            name: "2364, Albertsons, CORONADO, CA",
            disabled: false,
          },
          {
            name: "2364, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2364, Rite Aid, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "2364, Target, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "2364, Walgreens, JACKSONVILLE, AR",
            disabled: false,
          },
          {
            name: "2365, CVS, FRANKLIN SQUARE, NY",
            disabled: false,
          },
          {
            name: "2365, Target, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "2365, Walmart, MOUNT POCONO, PA",
            disabled: false,
          },
          {
            name: "2366, Target, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "2366, Walmart, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "2367, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "2367, Rite Aid, LIMA, OH",
            disabled: false,
          },
          {
            name: "2367, Target, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "2367, Walmart, PINE CITY, MN",
            disabled: false,
          },
          {
            name: "2368, Target, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "2368, Walmart, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "2369, CVS, JACKSON, NJ",
            disabled: false,
          },
          {
            name: "2369, Target, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "2369, Walmart, TILTON, NH",
            disabled: false,
          },
          {
            name: "237, ADUSA, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "237, ADUSA, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "237, CVS, SOMERSET, MA",
            disabled: false,
          },
          {
            name: "237, Costco, MELVILLE, NY",
            disabled: false,
          },
          {
            name: "237, HEB, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "237, Meijer, WARREN, MI",
            disabled: false,
          },
          {
            name: "237, Walmart, HARRISBURG, IL",
            disabled: false,
          },
          {
            name: "2370, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2370, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "2370, Target, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "2370, Walmart, TROY, NY",
            disabled: false,
          },
          {
            name: "2371, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "2371, Target, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "2371, Walmart, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "2372, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2372, Rite Aid, PAULDING, OH",
            disabled: false,
          },
          {
            name: "2372, Target, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "2372, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2373, CVS, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "2373, Rite Aid, GENOA, OH",
            disabled: false,
          },
          {
            name: "2373, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2373, Walmart, WARWICK, RI",
            disabled: false,
          },
          {
            name: "2374, Albertsons, BIG BEAR LAKE, CA",
            disabled: false,
          },
          {
            name: "2374, CVS, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2374, Target, HARKER HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "2375, CVS, DEKALB, IL",
            disabled: false,
          },
          {
            name: "2375, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "2375, Target, BESSEMER, AL",
            disabled: false,
          },
          {
            name: "2376, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2377, CVS, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "2377, Target, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "2378, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2378, Target, YORKVILLE, IL",
            disabled: false,
          },
          {
            name: "2379, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2379, Target, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "238, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "238, Albertsons, LEWISTON, ID",
            disabled: false,
          },
          {
            name: "238, Costco, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "238, HEB, CORSICANA, TX",
            disabled: false,
          },
          {
            name: "238, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "238, Kroger, Lima, OH",
            disabled: false,
          },
          {
            name: "238, Rite Aid, BERGENFIELD, NJ",
            disabled: false,
          },
          {
            name: "238, Target, APPLETON, WI",
            disabled: false,
          },
          {
            name: "238, Walmart, PULASKI, TN",
            disabled: false,
          },
          {
            name: "2380, CVS, FLATWOODS, KY",
            disabled: false,
          },
          {
            name: "2380, Rite Aid, MEADVILLE, PA",
            disabled: false,
          },
          {
            name: "2380, Target, New York, NY",
            disabled: false,
          },
          {
            name: "2381, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2381, Albertsons, CORONA, CA",
            disabled: false,
          },
          {
            name: "2381, CVS, LEWIS CENTER, OH",
            disabled: false,
          },
          {
            name: "2381, Target, PARAMUS, NJ",
            disabled: false,
          },
          {
            name: "2382, CVS, AUBURN, ME",
            disabled: false,
          },
          {
            name: "2382, Rite Aid, ERIE, PA",
            disabled: false,
          },
          {
            name: "2382, Target, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "2383, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2384, Albertsons, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "2384, CVS, WEST WARWICK, RI",
            disabled: false,
          },
          {
            name: "2384, Target, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "2384, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2385, CVS, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "2385, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2385, Walmart, AUBURN, WA",
            disabled: false,
          },
          {
            name: "2386, Albertsons, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "2386, Albertsons, SUN CITY, CA",
            disabled: false,
          },
          {
            name: "2386, CVS, JACKSON, TN",
            disabled: false,
          },
          {
            name: "2386, Target, ATWATER, CA",
            disabled: false,
          },
          {
            name: "2386, Walmart, WARE, MA",
            disabled: false,
          },
          {
            name: "2387, CVS, GRANGER, IN",
            disabled: false,
          },
          {
            name: "2387, Target, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "2387, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2387, Walmart, BRANDON, FL",
            disabled: false,
          },
          {
            name: "2388, CVS, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "2388, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "2388, Target, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "2388, Walmart, PORTLAND, IN",
            disabled: false,
          },
          {
            name: "2389, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2389, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "2389, Target, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "239, ADUSA, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "239, Albertsons, WINSLOW, AZ",
            disabled: false,
          },
          {
            name: "239, Costco, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "239, Kroger, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "239, Kroger, Marion, IN",
            disabled: false,
          },
          {
            name: "239, Meijer, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "239, Target, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "239, Walmart, KOSCIUSKO, MS",
            disabled: false,
          },
          {
            name: "2390, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2390, CVS, MULLICA HILL, NJ",
            disabled: false,
          },
          {
            name: "2390, Rite Aid, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "2390, Target, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "2391, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2391, Target, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2391, Walmart, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "2392, CVS, ALIQUIPPA, PA",
            disabled: false,
          },
          {
            name: "2392, Rite Aid, NEW PHILADELPHIA, OH",
            disabled: false,
          },
          {
            name: "2392, Target, MANAHAWKIN, NJ",
            disabled: false,
          },
          {
            name: "2392, Walmart, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "2393, Rite Aid, CANAL FULTON, OH",
            disabled: false,
          },
          {
            name: "2393, Walmart, MOORE, OK",
            disabled: false,
          },
          {
            name: "2394, CVS, BELPRE, OH",
            disabled: false,
          },
          {
            name: "2394, Rite Aid, CRESTLINE, OH",
            disabled: false,
          },
          {
            name: "2394, Target, BRANDYWINE, MD",
            disabled: false,
          },
          {
            name: "2394, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "2395, Rite Aid, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "2395, Target, WESLEY CHAPEL, NC",
            disabled: false,
          },
          {
            name: "2395, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "2396, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2396, Target, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "2396, Walmart, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "2397, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2397, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2397, Rite Aid, ASHLAND, OH",
            disabled: false,
          },
          {
            name: "2397, Target, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "2397, Walmart, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "2398, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2398, Rite Aid, MINERVA, OH",
            disabled: false,
          },
          {
            name: "2398, Target, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2398, Walgreens, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "2398, Walmart, NEWINGTON, NH",
            disabled: false,
          },
          {
            name: "2399, Target, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "2399, Walmart, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "24, ADUSA, BRIDGEVILLE, PA",
            disabled: false,
          },
          {
            name: "24, Albertsons, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "24, Costco, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "24, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "24, Kroger, BURLINGTON, WA",
            disabled: false,
          },
          {
            name: "24, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "24, Kroger, Chandler, AZ",
            disabled: false,
          },
          {
            name: "24, Kroger, Rockledge, FL",
            disabled: false,
          },
          {
            name: "24, Kroger, Thornton, CO",
            disabled: false,
          },
          {
            name: "24, Walmart, JACKSONVILLE, AR",
            disabled: false,
          },
          {
            name: "240, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "240, Costco, COMMACK, NY",
            disabled: false,
          },
          {
            name: "240, Kroger, Oak Grove, OR",
            disabled: false,
          },
          {
            name: "240, Meijer, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "240, Walmart, COMMERCE, TX",
            disabled: false,
          },
          {
            name: "2400, Albertsons, MAMMOTH LAKES, CA",
            disabled: false,
          },
          {
            name: "2400, Target, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "2400, Walmart, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "2401, CVS, MARSHFIELD, MA",
            disabled: false,
          },
          {
            name: "2401, Rite Aid, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "2401, Walgreens, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "2401, Walmart, DUARTE, CA",
            disabled: false,
          },
          {
            name: "2402, CVS, AUBURN, AL",
            disabled: false,
          },
          {
            name: "2402, Walmart, ELKO, NV",
            disabled: false,
          },
          {
            name: "2403, Albertsons, CENTER CONWAY, NH",
            disabled: false,
          },
          {
            name: "2403, CVS, ROSLYN HEIGHTS, NY",
            disabled: false,
          },
          {
            name: "2403, Rite Aid, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "2403, Target, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "2403, Walmart, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "2404, ADUSA, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "2404, CVS, POWELL, TN",
            disabled: false,
          },
          {
            name: "2404, Rite Aid, ALLIANCE, OH",
            disabled: false,
          },
          {
            name: "2404, Target, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2404, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2405, CVS, NEWARK, OH",
            disabled: false,
          },
          {
            name: "2405, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "2405, Walmart, HAMBURG, NY",
            disabled: false,
          },
          {
            name: "2406, ADUSA, NORTH READING, MA",
            disabled: false,
          },
          {
            name: "2406, Albertsons, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "2406, Target, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "2406, Walmart, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "2407, CVS, EVANS, GA",
            disabled: false,
          },
          {
            name: "2407, Target, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "2408, Albertsons, NORTH EASTON, MA",
            disabled: false,
          },
          {
            name: "2408, CVS, DREXEL HILL, PA",
            disabled: false,
          },
          {
            name: "2408, Rite Aid, LOUISVILLE, OH",
            disabled: false,
          },
          {
            name: "2408, Target, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "2409, Albertsons, OAKHURST, CA",
            disabled: false,
          },
          {
            name: "2409, CVS, MOORESTOWN, NJ",
            disabled: false,
          },
          {
            name: "2409, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "2409, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "241, Albertsons, CLARKSTON, WA",
            disabled: false,
          },
          {
            name: "241, CVS, FARMINGTON, MN",
            disabled: false,
          },
          {
            name: "241, Costco, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "241, Kroger, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "241, Meijer, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "2410, Target, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "2410, Walgreens, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "2411, ADUSA, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "2411, Albertsons, YORKTOWN HEIGHTS, NY",
            disabled: false,
          },
          {
            name: "2411, Target, KAPOLEI, HI",
            disabled: false,
          },
          {
            name: "2412, Albertsons, IRVINE, CA",
            disabled: false,
          },
          {
            name: "2412, CVS, SHOW LOW, AZ",
            disabled: false,
          },
          {
            name: "2412, Target, Kailua Kona, HI",
            disabled: false,
          },
          {
            name: "2412, Walmart, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "2413, Albertsons, LAKE ISABELLA, CA",
            disabled: false,
          },
          {
            name: "2414, ADUSA, PEMBROKE, MA",
            disabled: false,
          },
          {
            name: "2414, CVS, JOHNSON CITY, NY",
            disabled: false,
          },
          {
            name: "2414, Rite Aid, UHRICHSVILLE, OH",
            disabled: false,
          },
          {
            name: "2414, Target, FAIRVIEW HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "2414, Walmart, CARY, NC",
            disabled: false,
          },
          {
            name: "2415, ADUSA, NANTUCKET, MA",
            disabled: false,
          },
          {
            name: "2415, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "2415, Target, CANTON, MI",
            disabled: false,
          },
          {
            name: "2416, Albertsons, THORNWOOD, NY",
            disabled: false,
          },
          {
            name: "2416, CVS, DENVILLE, NJ",
            disabled: false,
          },
          {
            name: "2416, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2417, Albertsons, YONKERS, NY",
            disabled: false,
          },
          {
            name: "2417, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "2417, Rite Aid, CONNEAUT, OH",
            disabled: false,
          },
          {
            name: "2417, Walmart, PETOSKEY, MI",
            disabled: false,
          },
          {
            name: "2418, ADUSA, MILFORD, MA",
            disabled: false,
          },
          {
            name: "2418, Albertsons, MOHEGAN LAKE, NY",
            disabled: false,
          },
          {
            name: "2418, Rite Aid, LISBON, OH",
            disabled: false,
          },
          {
            name: "2418, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2418, Walmart, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "2419, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2419, Walmart, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "242, CVS, HOLBROOK, MA",
            disabled: false,
          },
          {
            name: "242, Kroger, Celina, OH",
            disabled: false,
          },
          {
            name: "242, Kroger, OREGON CITY, OR",
            disabled: false,
          },
          {
            name: "242, Meijer, Lenox, MI",
            disabled: false,
          },
          {
            name: "242, Walmart, PAOLA, KS",
            disabled: false,
          },
          {
            name: "2420, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "2420, CVS, LONDONDERRY, NH",
            disabled: false,
          },
          {
            name: "2420, Target, PORTERVILLE, CA",
            disabled: false,
          },
          {
            name: "2420, Walmart, BELLE VERNON, PA",
            disabled: false,
          },
          {
            name: "2421, Target, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "2421, Walmart, SAINT CROIX FALLS, WI",
            disabled: false,
          },
          {
            name: "2422, ADUSA, SOUTH YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "2422, Albertsons, BREWSTER, NY",
            disabled: false,
          },
          {
            name: "2422, Rite Aid, LANSFORD, PA",
            disabled: false,
          },
          {
            name: "2422, Target, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "2422, Walmart, SAINT HELENS, OR",
            disabled: false,
          },
          {
            name: "2423, Target, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "2423, Walmart, CAROLINA, PR",
            disabled: false,
          },
          {
            name: "2424, Albertsons, GOLDENS BRIDGE, NY",
            disabled: false,
          },
          {
            name: "2424, Target, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "2424, Walmart, TICONDEROGA, NY",
            disabled: false,
          },
          {
            name: "2425, Target, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2425, Walgreens, LAS VEGAS, NM",
            disabled: false,
          },
          {
            name: "2425, Walmart, COLLINSVILLE, IL",
            disabled: false,
          },
          {
            name: "2426, CVS, HIXSON, TN",
            disabled: false,
          },
          {
            name: "2426, Rite Aid, EDWARDSVILLE, PA",
            disabled: false,
          },
          {
            name: "2426, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2426, Walgreens, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "2426, Walmart, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "2427, Target, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "2427, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2428, Albertsons, HOPEWELL JUNCTION, NY",
            disabled: false,
          },
          {
            name: "2428, Albertsons, HOPEWELL, NY",
            disabled: false,
          },
          {
            name: "2428, Target, BRYAN, TX",
            disabled: false,
          },
          {
            name: "2428, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2428, Walmart, NEWTON, KS",
            disabled: false,
          },
          {
            name: "2429, Target, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "2429, Walgreens, SAFFORD, AZ",
            disabled: false,
          },
          {
            name: "2429, Walmart, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "243, ADUSA, EDEN, NC",
            disabled: false,
          },
          {
            name: "243, ADUSA, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "243, Albertsons, COEUR D ALENE, ID",
            disabled: false,
          },
          {
            name: "243, Albertsons, COEUR D'ALENE, ID",
            disabled: false,
          },
          {
            name: "243, CVS, WILLINGBORO, NJ",
            disabled: false,
          },
          {
            name: "243, Costco, LONG ISLAND CIT, NY",
            disabled: false,
          },
          {
            name: "243, HEB, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "243, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "243, Kroger, Lawrence, KS",
            disabled: false,
          },
          {
            name: "243, Kroger, Van Wert, OH",
            disabled: false,
          },
          {
            name: "243, Meijer, Clinton Twp., MI",
            disabled: false,
          },
          {
            name: "243, Walmart, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "2430, Albertsons, OJAI, CA",
            disabled: false,
          },
          {
            name: "2430, Target, WARWICK, RI",
            disabled: false,
          },
          {
            name: "2431, Albertsons, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2431, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2431, Target, MILTON, GA",
            disabled: false,
          },
          {
            name: "2431, Walmart, SEARCY, AR",
            disabled: false,
          },
          {
            name: "2432, CVS, EASTCHESTER, NY",
            disabled: false,
          },
          {
            name: "2432, Target, DAYVILLE, CT",
            disabled: false,
          },
          {
            name: "2432, Walmart, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "2433, Rite Aid, NEW BRIGHTON, PA",
            disabled: false,
          },
          {
            name: "2433, Target, LISBON, CT",
            disabled: false,
          },
          {
            name: "2433, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "2434, Albertsons, SANTA PAULA, CA",
            disabled: false,
          },
          {
            name: "2434, Target, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "2434, Walgreens, TRACY, CA",
            disabled: false,
          },
          {
            name: "2434, Walmart, IRON MOUNTAIN, MI",
            disabled: false,
          },
          {
            name: "2435, Walmart, DUNDALK, MD",
            disabled: false,
          },
          {
            name: "2436, Albertsons, OXNARD, CA",
            disabled: false,
          },
          {
            name: "2436, Target, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2436, Walmart, SYKESVILLE, MD",
            disabled: false,
          },
          {
            name: "2437, Albertsons, BRONXVILLE, NY",
            disabled: false,
          },
          {
            name: "2437, Rite Aid, WAYNESBURG, OH",
            disabled: false,
          },
          {
            name: "2437, Target, MUNCY, PA",
            disabled: false,
          },
          {
            name: "2437, Walmart, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "2438, Albertsons, WAKEFIELD, RI",
            disabled: false,
          },
          {
            name: "2438, Target, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "2438, Walmart, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "2439, Albertsons, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "2439, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2439, Target, SELINSGROVE, PA",
            disabled: false,
          },
          {
            name: "2439, Walmart, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "244, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "244, CVS, CHESTER, MD",
            disabled: false,
          },
          {
            name: "244, Costco, EAST HANOVER, NJ",
            disabled: false,
          },
          {
            name: "244, Meijer, DAVISON, MI",
            disabled: false,
          },
          {
            name: "244, Walmart, WINNFIELD, LA",
            disabled: false,
          },
          {
            name: "2440, CVS, INWOOD, NY",
            disabled: false,
          },
          {
            name: "2440, Target, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "2440, Walmart, SYLVA, NC",
            disabled: false,
          },
          {
            name: "2441, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2441, Walmart, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "2442, Albertsons, FILLMORE, CA",
            disabled: false,
          },
          {
            name: "2442, CVS, FAR ROCKAWAY, NY",
            disabled: false,
          },
          {
            name: "2442, Rite Aid, YEADON, PA",
            disabled: false,
          },
          {
            name: "2442, Target, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "2442, Walmart, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "2443, Walgreens, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "2443, Walmart, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "2444, Albertsons, ELMHURST, IL",
            disabled: false,
          },
          {
            name: "2444, CVS, AVON PARK, FL",
            disabled: false,
          },
          {
            name: "2444, Walmart, ONEIDA, NY",
            disabled: false,
          },
          {
            name: "2445, Albertsons, COHASSET, MA",
            disabled: false,
          },
          {
            name: "2445, Target, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "2445, Walmart, HATFIELD, PA",
            disabled: false,
          },
          {
            name: "2446, Albertsons, MAHOPAC, NY",
            disabled: false,
          },
          {
            name: "2446, CVS, WOODRUFF, SC",
            disabled: false,
          },
          {
            name: "2446, Target, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "2446, Walgreens, ESSEX, MD",
            disabled: false,
          },
          {
            name: "2446, Walmart, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "2447, CVS, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "2447, Walgreens, HANOVER PARK, IL",
            disabled: false,
          },
          {
            name: "2447, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2448, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "2448, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "2448, Target, DERBY, KS",
            disabled: false,
          },
          {
            name: "2448, Walmart, COTTAGE GROVE, MN",
            disabled: false,
          },
          {
            name: "2449, Albertsons, NAPA, CA",
            disabled: false,
          },
          {
            name: "2449, CVS, WEXFORD, PA",
            disabled: false,
          },
          {
            name: "2449, Rite Aid, EAST PALESTINE, OH",
            disabled: false,
          },
          {
            name: "2449, Target, WACONIA, MN",
            disabled: false,
          },
          {
            name: "2449, Walmart, CAGUAS, PR",
            disabled: false,
          },
          {
            name: "245, Albertsons, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "245, Costco, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "245, Kroger, Augusta, GA",
            disabled: false,
          },
          {
            name: "245, Kroger, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "245, Meijer, HARTLAND, MI",
            disabled: false,
          },
          {
            name: "245, Rite Aid, LEBANON, PA",
            disabled: false,
          },
          {
            name: "245, ShopRite, CEDAR KNOLLS, NJ",
            disabled: false,
          },
          {
            name: "245, Target, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "2450, Albertsons, RYE BROOK, NY",
            disabled: false,
          },
          {
            name: "2450, Target, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "2450, Walgreens, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "2450, Walmart, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "2451, Albertsons, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "2451, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2451, Target, Flushing, NY",
            disabled: false,
          },
          {
            name: "2451, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "2452, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "2452, Rite Aid, CORTLAND, OH",
            disabled: false,
          },
          {
            name: "2452, Walgreens, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "2452, Walmart, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2453, Albertsons, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "2453, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2453, Walgreens, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "2453, Walmart, FALLON, NV",
            disabled: false,
          },
          {
            name: "2454, Albertsons, LOS ALTOS, CA",
            disabled: false,
          },
          {
            name: "2454, CVS, QUINCY, MA",
            disabled: false,
          },
          {
            name: "2454, Target, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "2454, Walgreens, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "2455, Albertsons, SAN ANSELMO, CA",
            disabled: false,
          },
          {
            name: "2455, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2455, Target, DAVIS, CA",
            disabled: false,
          },
          {
            name: "2455, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "2455, Walmart, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "2456, Albertsons, PETALUMA, CA",
            disabled: false,
          },
          {
            name: "2456, CVS, EDISON, NJ",
            disabled: false,
          },
          {
            name: "2456, Rite Aid, AKRON, OH",
            disabled: false,
          },
          {
            name: "2456, Target, OTSEGO, MN",
            disabled: false,
          },
          {
            name: "2457, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "2457, Target, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "2457, Walmart, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "2458, CVS, CHALFONT, PA",
            disabled: false,
          },
          {
            name: "2458, Target, AURORA, CO",
            disabled: false,
          },
          {
            name: "2458, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2458, Walmart, SALINAS, CA",
            disabled: false,
          },
          {
            name: "2459, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "2459, Target, PLATTSBURGH, NY",
            disabled: false,
          },
          {
            name: "2459, Walmart, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "246, Albertsons, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "246, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "246, CVS, COCOA BEACH, FL",
            disabled: false,
          },
          {
            name: "246, Costco, NEWARK, DE",
            disabled: false,
          },
          {
            name: "246, Kroger, Danville, IL",
            disabled: false,
          },
          {
            name: "246, Meijer, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "246, Rite Aid, HERSHEY, PA",
            disabled: false,
          },
          {
            name: "246, Target, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "246, Walmart, SKIATOOK, OK",
            disabled: false,
          },
          {
            name: "2460, Target, YUKON, OK",
            disabled: false,
          },
          {
            name: "2460, Walgreens, CAMBRIDGE, MN",
            disabled: false,
          },
          {
            name: "2460, Walmart, SEAFORD, DE",
            disabled: false,
          },
          {
            name: "2461, Target, AMSTERDAM, NY",
            disabled: false,
          },
          {
            name: "2462, Albertsons, WHEATLAND, WY",
            disabled: false,
          },
          {
            name: "2462, CVS, SOMERS POINT, NJ",
            disabled: false,
          },
          {
            name: "2462, Target, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "2462, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2463, Rite Aid, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "2463, Target, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "2463, Walmart, FRISCO, TX",
            disabled: false,
          },
          {
            name: "2464, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2465, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2465, Walmart, HEPHZIBAH, GA",
            disabled: false,
          },
          {
            name: "2466, Albertsons, LARAMIE, WY",
            disabled: false,
          },
          {
            name: "2466, Rite Aid, MONESSEN, PA",
            disabled: false,
          },
          {
            name: "2467, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2467, Walgreens, ANGOLA, IN",
            disabled: false,
          },
          {
            name: "2468, CVS, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "2468, Target, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "2468, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "2468, Walmart, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "2469, CVS, BAY VILLAGE, OH",
            disabled: false,
          },
          {
            name: "2469, Target, VISALIA, CA",
            disabled: false,
          },
          {
            name: "2469, Walgreens, KENNER, LA",
            disabled: false,
          },
          {
            name: "2469, Walmart, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "247, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "247, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "247, Costco, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "247, Kroger, Crosby, TX",
            disabled: false,
          },
          {
            name: "247, Kroger, Post Falls, ID",
            disabled: false,
          },
          {
            name: "247, Kroger, UNION CITY, GA",
            disabled: false,
          },
          {
            name: "247, Meijer, URBANA, IL",
            disabled: false,
          },
          {
            name: "247, Walmart, HENRYETTA, OK",
            disabled: false,
          },
          {
            name: "2470, Albertsons, SHREWSBURY, MA",
            disabled: false,
          },
          {
            name: "2470, CVS, CANTON, GA",
            disabled: false,
          },
          {
            name: "2470, Target, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "2470, Walgreens, ROSELAND, NJ",
            disabled: false,
          },
          {
            name: "2471, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2471, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2471, Target, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "2471, Walgreens, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "2471, Walmart, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "2472, Albertsons, STURBRIDGE, MA",
            disabled: false,
          },
          {
            name: "2472, Target, SPARKS, NV",
            disabled: false,
          },
          {
            name: "2472, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2472, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "2473, Rite Aid, OSCODA, MI",
            disabled: false,
          },
          {
            name: "2473, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "2473, Walgreens, ROCK FALLS, IL",
            disabled: false,
          },
          {
            name: "2473, Walmart, HILO, HI",
            disabled: false,
          },
          {
            name: "2474, Rite Aid, PORT ALLEGANY, PA",
            disabled: false,
          },
          {
            name: "2474, Target, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "2474, Walgreens, SPARKS, NV",
            disabled: false,
          },
          {
            name: "2474, Walmart, KEYSER, WV",
            disabled: false,
          },
          {
            name: "2475, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2475, CVS, COS COB, CT",
            disabled: false,
          },
          {
            name: "2475, Target, Bronx, NY",
            disabled: false,
          },
          {
            name: "2475, Walmart, CONYERS, GA",
            disabled: false,
          },
          {
            name: "2476, CVS, AGAWAM, MA",
            disabled: false,
          },
          {
            name: "2476, Rite Aid, RIDGWAY, PA",
            disabled: false,
          },
          {
            name: "2476, Target, CANTON, GA",
            disabled: false,
          },
          {
            name: "2476, Walmart, COLLEGE PLACE, WA",
            disabled: false,
          },
          {
            name: "2477, Albertsons, WEST LAKE HILLS, TX",
            disabled: false,
          },
          {
            name: "2477, Walmart, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "2478, Albertsons, PEABODY, MA",
            disabled: false,
          },
          {
            name: "2478, Rite Aid, ASHLAND, PA",
            disabled: false,
          },
          {
            name: "2478, Target, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "2479, Albertsons, DOVER, NH",
            disabled: false,
          },
          {
            name: "2479, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2479, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "248, Albertsons, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "248, CVS, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "248, Costco, NORTH WALES, PA",
            disabled: false,
          },
          {
            name: "248, Kroger, BRAZIL, IN",
            disabled: false,
          },
          {
            name: "248, Meijer, CEDAR SPRINGS, MI",
            disabled: false,
          },
          {
            name: "248, Walmart, MEXIA, TX",
            disabled: false,
          },
          {
            name: "2480, Rite Aid, MIDLAND, PA",
            disabled: false,
          },
          {
            name: "2480, Target, LOWELL, MA",
            disabled: false,
          },
          {
            name: "2480, Walmart, HONESDALE, PA",
            disabled: false,
          },
          {
            name: "2481, CVS, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "2481, Walmart, COAL TOWNSHIP, PA",
            disabled: false,
          },
          {
            name: "2482, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2482, Rite Aid, ELIZABETH, PA",
            disabled: false,
          },
          {
            name: "2482, Target, BREA, CA",
            disabled: false,
          },
          {
            name: "2482, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "2483, Target, NEWPORT, KY",
            disabled: false,
          },
          {
            name: "2483, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2484, Albertsons, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "2484, CVS, MARION, IN",
            disabled: false,
          },
          {
            name: "2484, Walmart, CLEWISTON, FL",
            disabled: false,
          },
          {
            name: "2485, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2485, Target, D'IBERVILLE, MS",
            disabled: false,
          },
          {
            name: "2485, Walmart, PONDERAY, ID",
            disabled: false,
          },
          {
            name: "2486, CVS, NILES, OH",
            disabled: false,
          },
          {
            name: "2486, Target, SOUTH LEBANON, OH",
            disabled: false,
          },
          {
            name: "2486, Walmart, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2487, Target, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "2487, Walmart, CORONA, CA",
            disabled: false,
          },
          {
            name: "2488, Albertsons, BOURBONNAIS, IL",
            disabled: false,
          },
          {
            name: "2488, Target, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2488, Walmart, DECATUR, AL",
            disabled: false,
          },
          {
            name: "2489, Albertsons, CONCORD, NH",
            disabled: false,
          },
          {
            name: "2489, CVS, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "2489, Target, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "2489, Walgreens, AVENTURA, FL",
            disabled: false,
          },
          {
            name: "249, ADUSA, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "249, ADUSA, BEDFORD, VA",
            disabled: false,
          },
          {
            name: "249, Albertsons, PAGE, AZ",
            disabled: false,
          },
          {
            name: "249, Costco, DURHAM, NC",
            disabled: false,
          },
          {
            name: "249, Kroger, Champaign, IL",
            disabled: false,
          },
          {
            name: "249, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "249, Kroger, Wichita, KS",
            disabled: false,
          },
          {
            name: "249, Meijer, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "249, Target, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "249, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "249, Walmart, CLEVELAND, TX",
            disabled: false,
          },
          {
            name: "2490, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2490, Target, HILLSIDE, IL",
            disabled: false,
          },
          {
            name: "2490, Walgreens, COLLINSVILLE, IL",
            disabled: false,
          },
          {
            name: "2490, Walmart, ROELAND PARK, KS",
            disabled: false,
          },
          {
            name: "2491, Albertsons, NEWBURYPORT, MA",
            disabled: false,
          },
          {
            name: "2491, CVS, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "2491, Target, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "2491, Walmart, DANVILLE, IL",
            disabled: false,
          },
          {
            name: "2492, Albertsons, MILFORD, NH",
            disabled: false,
          },
          {
            name: "2492, CVS, CEDAR GROVE, NJ",
            disabled: false,
          },
          {
            name: "2492, Target, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2492, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "2492, Walmart, PENDLETON, OR",
            disabled: false,
          },
          {
            name: "2493, Albertsons, SALEM, MA",
            disabled: false,
          },
          {
            name: "2493, Target, BETHLEHEM, GA",
            disabled: false,
          },
          {
            name: "2493, Walmart, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "2494, Albertsons, GREENWICH, CT",
            disabled: false,
          },
          {
            name: "2494, CVS, MOUNT JOY, PA",
            disabled: false,
          },
          {
            name: "2494, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2494, Walmart, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "2495, Albertsons, BRIARCLIFF MANOR, NY",
            disabled: false,
          },
          {
            name: "2495, CVS, DOWNINGTOWN, PA",
            disabled: false,
          },
          {
            name: "2495, Target, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "2495, Walmart, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "2496, CVS, MAPLE GLEN, PA",
            disabled: false,
          },
          {
            name: "2496, Target, EXTON, PA",
            disabled: false,
          },
          {
            name: "2496, Walgreens, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "2496, Walmart, BOONE, NC",
            disabled: false,
          },
          {
            name: "2497, Albertsons, RIVERSIDE, CT",
            disabled: false,
          },
          {
            name: "2497, CVS, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "2497, Target, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2497, Walmart, PHILLIPSBURG, NJ",
            disabled: false,
          },
          {
            name: "2498, Target, ROGERS, AR",
            disabled: false,
          },
          {
            name: "2499, Albertsons, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "2499, Target, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "2499, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "25, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "25, Costco, RENO, NV",
            disabled: false,
          },
          {
            name: "25, HEB, FLORESVILLE, TX",
            disabled: false,
          },
          {
            name: "25, Kroger, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "25, Kroger, HUTCHINSON, KS",
            disabled: false,
          },
          {
            name: "25, Kroger, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "25, Kroger, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "25, Kroger, Opa-Locka, FL",
            disabled: false,
          },
          {
            name: "25, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "25, Meijer, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "25, Walmart, MEXICO, MO",
            disabled: false,
          },
          {
            name: "250, ADUSA, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "250, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "250, Kroger, Decatur, IL",
            disabled: false,
          },
          {
            name: "250, Kroger, Lakewood, CA",
            disabled: false,
          },
          {
            name: "250, Kroger, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "250, Meijer, GAYLORD, MI",
            disabled: false,
          },
          {
            name: "250, Target, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "250, Walmart, WARSAW, MO",
            disabled: false,
          },
          {
            name: "2500, ADUSA, ABINGDON, VA",
            disabled: false,
          },
          {
            name: "2500, CVS, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "2501, Albertsons, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "2501, CVS, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "2501, Target, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "2501, Walgreens, BRIDGETON, MO",
            disabled: false,
          },
          {
            name: "2501, Walmart, BAYAMON, PR",
            disabled: false,
          },
          {
            name: "2502, ADUSA, OSSINING, NY",
            disabled: false,
          },
          {
            name: "2502, Albertsons, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "2502, CVS, CHESHIRE, CT",
            disabled: false,
          },
          {
            name: "2502, Walmart, LATROBE, PA",
            disabled: false,
          },
          {
            name: "2503, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2503, Target, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "2503, Walmart, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "2504, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2504, Albertsons, MERRIONETTE PARK, IL",
            disabled: false,
          },
          {
            name: "2504, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "2504, Walmart, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "2505, ADUSA, SHIRLEY, NY",
            disabled: false,
          },
          {
            name: "2505, CVS, MOUNTAIN BROOK, AL",
            disabled: false,
          },
          {
            name: "2505, Walmart, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "2506, CVS, CUMBERLAND, RI",
            disabled: false,
          },
          {
            name: "2506, Walgreens, RICHMOND, CA",
            disabled: false,
          },
          {
            name: "2506, Walmart, RAVENNA, OH",
            disabled: false,
          },
          {
            name: "2507, ADUSA, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "2507, Albertsons, FOX RIVER GROVE, IL",
            disabled: false,
          },
          {
            name: "2507, CVS, SCHNECKSVILLE, PA",
            disabled: false,
          },
          {
            name: "2507, Walmart, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "2508, ADUSA, CAPE CHARLES, VA",
            disabled: false,
          },
          {
            name: "2508, Albertsons, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "2508, CVS, MANALAPAN, NJ",
            disabled: false,
          },
          {
            name: "2508, Walmart, BOISE, ID",
            disabled: false,
          },
          {
            name: "2509, Albertsons, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "2509, Rite Aid, WARREN, MI",
            disabled: false,
          },
          {
            name: "2509, Walmart, CHILTON, WI",
            disabled: false,
          },
          {
            name: "251, ADUSA, ALBEMARLE, NC",
            disabled: false,
          },
          {
            name: "251, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "251, Albertsons, DAVENPORT, WA",
            disabled: false,
          },
          {
            name: "251, Kroger, Charleston, IL",
            disabled: false,
          },
          {
            name: "251, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "251, Kroger, MCCONNELSVILLE, OH",
            disabled: false,
          },
          {
            name: "251, Meijer, STEVENSVILLE, MI",
            disabled: false,
          },
          {
            name: "251, Target, MESA, AZ",
            disabled: false,
          },
          {
            name: "251, Walmart, MINEOLA, TX",
            disabled: false,
          },
          {
            name: "2510, CVS, COLLINSVILLE, IL",
            disabled: false,
          },
          {
            name: "2510, Rite Aid, HANOVER, PA",
            disabled: false,
          },
          {
            name: "2510, Walmart, MINOCQUA, WI",
            disabled: false,
          },
          {
            name: "2511, ADUSA, AYDEN, NC",
            disabled: false,
          },
          {
            name: "2511, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2511, Walmart, AMERICAN FORK, UT",
            disabled: false,
          },
          {
            name: "2512, ADUSA, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2512, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2513, ADUSA, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2513, Albertsons, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "2513, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "2513, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "2513, Walgreens, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "2513, Walmart, DAHLONEGA, GA",
            disabled: false,
          },
          {
            name: "2514, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "2514, Albertsons, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2514, CVS, SHARON HILL, PA",
            disabled: false,
          },
          {
            name: "2514, Walmart, POCOMOKE CITY, MD",
            disabled: false,
          },
          {
            name: "2515, ADUSA, MAHOPAC, NY",
            disabled: false,
          },
          {
            name: "2515, Albertsons, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "2515, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2516, Target, ALLEN, TX",
            disabled: false,
          },
          {
            name: "2516, Walmart, RENTON, WA",
            disabled: false,
          },
          {
            name: "2517, ADUSA, HANOVER, MD",
            disabled: false,
          },
          {
            name: "2517, Albertsons, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "2517, Walgreens, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "2517, Walmart, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "2518, Albertsons, WILLISTON, VT",
            disabled: false,
          },
          {
            name: "2518, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "2518, Walmart, HAMILTON, NJ",
            disabled: false,
          },
          {
            name: "2519, CVS, SCHERERVILLE, IN",
            disabled: false,
          },
          {
            name: "2519, Target, INVER GROVE HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "2519, Walgreens, CLINTON, UT",
            disabled: false,
          },
          {
            name: "2519, Walmart, SHREWSBURY, PA",
            disabled: false,
          },
          {
            name: "252, ADUSA, PURCELLVILLE, VA",
            disabled: false,
          },
          {
            name: "252, Albertsons, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "252, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "252, Walmart, DU QUOIN, IL",
            disabled: false,
          },
          {
            name: "2520, ADUSA, ROCKY POINT, NY",
            disabled: false,
          },
          {
            name: "2520, CVS, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "2520, Target, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "2520, Walmart, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "2521, ADUSA, BRIDGEVILLE, DE",
            disabled: false,
          },
          {
            name: "2521, CVS, HICKORY, NC",
            disabled: false,
          },
          {
            name: "2521, Rite Aid, LUMBERTON, NJ",
            disabled: false,
          },
          {
            name: "2522, ADUSA, CENTREVILLE, MD",
            disabled: false,
          },
          {
            name: "2522, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2522, Rite Aid, BAYVILLE, NJ",
            disabled: false,
          },
          {
            name: "2522, Walmart, ESCANABA, MI",
            disabled: false,
          },
          {
            name: "2523, CVS, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "2523, Target, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "2523, Walgreens, LAYTON, UT",
            disabled: false,
          },
          {
            name: "2523, Walmart, BREA, CA",
            disabled: false,
          },
          {
            name: "2524, ADUSA, AYLETT, VA",
            disabled: false,
          },
          {
            name: "2524, Target, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "2525, ADUSA, RUTHER GLEN, VA",
            disabled: false,
          },
          {
            name: "2525, CVS, ROCKY HILL, CT",
            disabled: false,
          },
          {
            name: "2525, Target, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "2526, ADUSA, WHITEVILLE, NC",
            disabled: false,
          },
          {
            name: "2526, Albertsons, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "2526, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2526, Rite Aid, WRIGHTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "2526, Target, CEDAR FALLS, IA",
            disabled: false,
          },
          {
            name: "2526, Walmart, PORTER RANCH, CA",
            disabled: false,
          },
          {
            name: "2527, Albertsons, LUDLOW, VT",
            disabled: false,
          },
          {
            name: "2527, Rite Aid, MANCHESTER, NJ",
            disabled: false,
          },
          {
            name: "2527, Target, WYNCOTE, PA",
            disabled: false,
          },
          {
            name: "2527, Walgreens, SOUTH OGDEN, UT",
            disabled: false,
          },
          {
            name: "2527, Walmart, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "2528, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "2528, Albertsons, MCMINNVILLE, OR",
            disabled: false,
          },
          {
            name: "2528, CVS, OAKWOOD, OH",
            disabled: false,
          },
          {
            name: "2528, Target, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "2528, Walgreens, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "2528, Walmart, MILL HALL, PA",
            disabled: false,
          },
          {
            name: "2529, ADUSA, GRETNA, VA",
            disabled: false,
          },
          {
            name: "2529, Rite Aid, BARNEGAT, NJ",
            disabled: false,
          },
          {
            name: "2529, Target, READING, PA",
            disabled: false,
          },
          {
            name: "2529, Walgreens, SYRACUSE, UT",
            disabled: false,
          },
          {
            name: "2529, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "253, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "253, Albertsons, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "253, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "253, Meijer, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "253, Target, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "253, Walmart, JERSEYVILLE, IL",
            disabled: false,
          },
          {
            name: "2530, ADUSA, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "2530, CVS, WILLOW GROVE, PA",
            disabled: false,
          },
          {
            name: "2530, Target, GREENLAND, NH",
            disabled: false,
          },
          {
            name: "2530, Walgreens, SOUTHPORT, NC",
            disabled: false,
          },
          {
            name: "2530, Walmart, RUTLAND, VT",
            disabled: false,
          },
          {
            name: "2531, ADUSA, JAMESTOWN, NC",
            disabled: false,
          },
          {
            name: "2531, Albertsons, SPRINGFIELD, VT",
            disabled: false,
          },
          {
            name: "2531, CVS, EASTON, MD",
            disabled: false,
          },
          {
            name: "2531, Target, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "2531, Walmart, MOHEGAN LAKE, NY",
            disabled: false,
          },
          {
            name: "2532, ADUSA, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "2532, Albertsons, LANCASTER, NH",
            disabled: false,
          },
          {
            name: "2532, CVS, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "2532, Target, HANOVER, MA",
            disabled: false,
          },
          {
            name: "2532, Walmart, BELOIT, WI",
            disabled: false,
          },
          {
            name: "2533, ADUSA, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "2533, CVS, PEABODY, MA",
            disabled: false,
          },
          {
            name: "2533, Target, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "2533, Walmart, GULF BREEZE, FL",
            disabled: false,
          },
          {
            name: "2534, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2534, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2534, Target, KENNER, LA",
            disabled: false,
          },
          {
            name: "2534, Walmart, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "2535, Albertsons, WOODSVILLE, NH",
            disabled: false,
          },
          {
            name: "2535, CVS, MONTCLAIR, NJ",
            disabled: false,
          },
          {
            name: "2535, Walmart, SAINT CLAIR, PA",
            disabled: false,
          },
          {
            name: "2536, ADUSA, SANFORD, NC",
            disabled: false,
          },
          {
            name: "2536, Albertsons, VERGENNES, VT",
            disabled: false,
          },
          {
            name: "2536, Target, EASTON, PA",
            disabled: false,
          },
          {
            name: "2536, Walgreens, KENNETT SQUARE, PA",
            disabled: false,
          },
          {
            name: "2536, Walmart, TULARE, CA",
            disabled: false,
          },
          {
            name: "2537, ADUSA, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "2537, CVS, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "2537, Target, MALVERN, PA",
            disabled: false,
          },
          {
            name: "2537, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "2537, Walmart, REDDING, CA",
            disabled: false,
          },
          {
            name: "2538, ADUSA, LITTLETON, NC",
            disabled: false,
          },
          {
            name: "2538, Albertsons, WINDHAM, ME",
            disabled: false,
          },
          {
            name: "2538, CVS, SWANNANOA, NC",
            disabled: false,
          },
          {
            name: "2538, Target, MARTINSBURG, WV",
            disabled: false,
          },
          {
            name: "2538, Walmart, EUGENE, OR",
            disabled: false,
          },
          {
            name: "2539, ADUSA, ALTAVISTA, VA",
            disabled: false,
          },
          {
            name: "2539, Walmart, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "254, Albertsons, HAYDEN, ID",
            disabled: false,
          },
          {
            name: "254, Meijer, HUDSONVILLE, MI",
            disabled: false,
          },
          {
            name: "254, Target, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "254, Walmart, OLNEY, IL",
            disabled: false,
          },
          {
            name: "2540, CVS, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "2540, Target, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "2540, Walgreens, BOONE, NC",
            disabled: false,
          },
          {
            name: "2540, Walmart, CLARION, PA",
            disabled: false,
          },
          {
            name: "2541, ADUSA, CHESTER, VA",
            disabled: false,
          },
          {
            name: "2541, Albertsons, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "2541, CVS, VISALIA, CA",
            disabled: false,
          },
          {
            name: "2541, Walmart, ALLIANCE, OH",
            disabled: false,
          },
          {
            name: "2542, ADUSA, GROTTOES, VA",
            disabled: false,
          },
          {
            name: "2542, CVS, HIGHLAND, IN",
            disabled: false,
          },
          {
            name: "2542, Target, TULSA, OK",
            disabled: false,
          },
          {
            name: "2542, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "2542, Walmart, OTTAWA, OH",
            disabled: false,
          },
          {
            name: "2543, Albertsons, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "2543, CVS, CANFIELD, OH",
            disabled: false,
          },
          {
            name: "2543, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "2543, Walmart, PITTSTON, PA",
            disabled: false,
          },
          {
            name: "2544, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2544, CVS, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "2544, Target, WARREN, MI",
            disabled: false,
          },
          {
            name: "2544, Walmart, PORTAGE, IN",
            disabled: false,
          },
          {
            name: "2545, ADUSA, BENSON, NC",
            disabled: false,
          },
          {
            name: "2545, ADUSA, ORANGEBURG, NY",
            disabled: false,
          },
          {
            name: "2545, CVS, DANBURY, CT",
            disabled: false,
          },
          {
            name: "2545, Rite Aid, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "2545, Target, LITITZ, PA",
            disabled: false,
          },
          {
            name: "2545, Walmart, MARINETTE, WI",
            disabled: false,
          },
          {
            name: "2546, Target, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "2546, Walmart, ORANGE, CA",
            disabled: false,
          },
          {
            name: "2547, ADUSA, WALDORF, MD",
            disabled: false,
          },
          {
            name: "2547, CVS, MORGANVILLE, NJ",
            disabled: false,
          },
          {
            name: "2547, Target, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "2547, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "2547, Walmart, MONTICELLO, NY",
            disabled: false,
          },
          {
            name: "2548, CVS, SURF CITY, NC",
            disabled: false,
          },
          {
            name: "2548, Target, Pottstown, PA",
            disabled: false,
          },
          {
            name: "2548, Walmart, SOUTH WILLIAMSON, KY",
            disabled: false,
          },
          {
            name: "2549, Albertsons, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "2549, Rite Aid, STANDISH, MI",
            disabled: false,
          },
          {
            name: "2549, Walmart, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "255, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "255, CVS, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "255, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "255, Kroger, ABINGDON, VA",
            disabled: false,
          },
          {
            name: "255, Kroger, ATHENS, GA",
            disabled: false,
          },
          {
            name: "255, Kroger, Carson, CA",
            disabled: false,
          },
          {
            name: "255, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "255, Target, IRVING, TX",
            disabled: false,
          },
          {
            name: "2550, Albertsons, AUBURN, ME",
            disabled: false,
          },
          {
            name: "2550, CVS, MOHEGAN LAKE, NY",
            disabled: false,
          },
          {
            name: "2550, Target, WYLIE, TX",
            disabled: false,
          },
          {
            name: "2550, Walmart, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "2551, ADUSA, HAMPTON BAYS, NY",
            disabled: false,
          },
          {
            name: "2551, Albertsons, ORANGE, CA",
            disabled: false,
          },
          {
            name: "2551, Walmart, MOUNT AIRY, MD",
            disabled: false,
          },
          {
            name: "2552, ADUSA, WEST HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "2552, ADUSA, WILSON, NC",
            disabled: false,
          },
          {
            name: "2552, Albertsons, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "2552, CVS, PROSPECT PARK, PA",
            disabled: false,
          },
          {
            name: "2552, Walmart, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "2553, ADUSA, CAROLINA BEACH, NC",
            disabled: false,
          },
          {
            name: "2553, ADUSA, WEST ISLIP, NY",
            disabled: false,
          },
          {
            name: "2553, Walmart, WINDSOR, CA",
            disabled: false,
          },
          {
            name: "2554, ADUSA, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "2554, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "2554, CVS, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "2554, Walmart, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "2555, ADUSA, MERRICK, NY",
            disabled: false,
          },
          {
            name: "2555, ADUSA, OAK HALL, VA",
            disabled: false,
          },
          {
            name: "2555, Albertsons, SIDNEY, NE",
            disabled: false,
          },
          {
            name: "2555, CVS, GAFFNEY, SC",
            disabled: false,
          },
          {
            name: "2555, Walgreens, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "2555, Walmart, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "2556, ADUSA, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "2556, Albertsons, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "2556, Walmart, ARROYO GRANDE, CA",
            disabled: false,
          },
          {
            name: "2557, ADUSA, MADISON HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "2557, Albertsons, GAINESVILLE, TX",
            disabled: false,
          },
          {
            name: "2557, Target, BLUE ASH, OH",
            disabled: false,
          },
          {
            name: "2557, Walgreens, MUSCLE SHOALS, AL",
            disabled: false,
          },
          {
            name: "2557, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "2558, ADUSA, ROBERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "2558, Albertsons, DANA POINT, CA",
            disabled: false,
          },
          {
            name: "2558, Walmart, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "2559, ADUSA, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "2559, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2559, Target, DEKALB, IL",
            disabled: false,
          },
          {
            name: "2559, Walmart, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "256, ADUSA, SPOTSYLVANIA, VA",
            disabled: false,
          },
          {
            name: "256, Albertsons, CHICO, CA",
            disabled: false,
          },
          {
            name: "256, HEB, COLUMBUS, TX",
            disabled: false,
          },
          {
            name: "256, Kroger, ANGLETON, TX",
            disabled: false,
          },
          {
            name: "256, Kroger, CARSON, CA",
            disabled: false,
          },
          {
            name: "256, Meijer, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "256, Rite Aid, MARION, OH",
            disabled: false,
          },
          {
            name: "256, Target, AURORA, CO",
            disabled: false,
          },
          {
            name: "256, Walmart, GLEN CARBON, IL",
            disabled: false,
          },
          {
            name: "2560, Albertsons, GROVER BEACH, CA",
            disabled: false,
          },
          {
            name: "2560, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2560, Walgreens, DANVILLE, CA",
            disabled: false,
          },
          {
            name: "2560, Walmart, BERLIN, MD",
            disabled: false,
          },
          {
            name: "2561, Albertsons, GARLAND, TX",
            disabled: false,
          },
          {
            name: "2561, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2561, Walmart, ERIE, PA",
            disabled: false,
          },
          {
            name: "2562, ADUSA, CARROLLTON, VA",
            disabled: false,
          },
          {
            name: "2562, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2562, Walmart, GOODLAND, KS",
            disabled: false,
          },
          {
            name: "2563, ADUSA, STEDMAN, NC",
            disabled: false,
          },
          {
            name: "2563, Albertsons, CHADRON, NE",
            disabled: false,
          },
          {
            name: "2563, CVS, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "2563, Walmart, PAOLI, IN",
            disabled: false,
          },
          {
            name: "2564, Walgreens, NEWBURYPORT, MA",
            disabled: false,
          },
          {
            name: "2564, Walmart, LURAY, VA",
            disabled: false,
          },
          {
            name: "2565, ADUSA, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "2565, Albertsons, CAMBRIDGE, MA",
            disabled: false,
          },
          {
            name: "2565, CVS, TOWANDA, PA",
            disabled: false,
          },
          {
            name: "2565, Target, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "2565, Walmart, MADISON HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "2566, CVS, WILBRAHAM, MA",
            disabled: false,
          },
          {
            name: "2566, Rite Aid, OAK HARBOR, OH",
            disabled: false,
          },
          {
            name: "2566, Walgreens, SALEM, NH",
            disabled: false,
          },
          {
            name: "2566, Walmart, CHARLES TOWN, WV",
            disabled: false,
          },
          {
            name: "2567, ADUSA, MADISON, VA",
            disabled: false,
          },
          {
            name: "2567, Target, HANOVER, PA",
            disabled: false,
          },
          {
            name: "2567, Walmart, GRANDVILLE, MI",
            disabled: false,
          },
          {
            name: "2568, CVS, MORRISVILLE, PA",
            disabled: false,
          },
          {
            name: "2568, Rite Aid, SHAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "2568, Target, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2568, Walmart, PANORAMA CITY, CA",
            disabled: false,
          },
          {
            name: "2569, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2569, Albertsons, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "2569, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "2569, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "257, ADUSA, GAINESVILLE, VA",
            disabled: false,
          },
          {
            name: "257, CVS, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "257, HEB, CLEVELAND, TX",
            disabled: false,
          },
          {
            name: "257, Kroger, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "257, Meijer, PETOSKEY, MI",
            disabled: false,
          },
          {
            name: "257, Target, VALENCIA, CA",
            disabled: false,
          },
          {
            name: "257, Walmart, MORGANFIELD, KY",
            disabled: false,
          },
          {
            name: "2570, ADUSA, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "2570, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "2570, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "2570, Target, MARLBOROUGH, MA",
            disabled: false,
          },
          {
            name: "2571, ADUSA, PINK HILL, NC",
            disabled: false,
          },
          {
            name: "2571, Albertsons, SUDBURY, MA",
            disabled: false,
          },
          {
            name: "2571, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2571, Walmart, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "2572, Albertsons, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2572, CVS, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "2572, Target, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "2572, Walmart, WAVERLY, OH",
            disabled: false,
          },
          {
            name: "2573, ADUSA, BLACKSBURG, VA",
            disabled: false,
          },
          {
            name: "2573, Albertsons, QUINCY, MA",
            disabled: false,
          },
          {
            name: "2573, CVS, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "2574, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2574, Rite Aid, MILFORD, CT",
            disabled: false,
          },
          {
            name: "2574, Walmart, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "2575, ADUSA, EAST HAMPTON, NY",
            disabled: false,
          },
          {
            name: "2575, ADUSA, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "2575, Albertsons, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "2575, CVS, MANCHESTER, PA",
            disabled: false,
          },
          {
            name: "2575, Walgreens, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "2575, Walmart, CONWAY, AR",
            disabled: false,
          },
          {
            name: "2576, ADUSA, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "2576, ADUSA, SOUTHAMPTON, NY",
            disabled: false,
          },
          {
            name: "2576, Albertsons, BOSTON, MA",
            disabled: false,
          },
          {
            name: "2576, CVS, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "2576, Walmart, CROSS LANES, WV",
            disabled: false,
          },
          {
            name: "2577, ADUSA, BALDWIN, NY",
            disabled: false,
          },
          {
            name: "2577, CVS, PEQUANNOCK, NJ",
            disabled: false,
          },
          {
            name: "2577, Walgreens, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "2577, Walmart, COCKEYSVILLE, MD",
            disabled: false,
          },
          {
            name: "2578, ADUSA, MASSAPEQUA, NY",
            disabled: false,
          },
          {
            name: "2578, ADUSA, MATHEWS, VA",
            disabled: false,
          },
          {
            name: "2578, Albertsons, GARLAND, TX",
            disabled: false,
          },
          {
            name: "2578, CVS, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "2579, Albertsons, HYDE PARK, MA",
            disabled: false,
          },
          {
            name: "2579, CVS, ELMSFORD, NY",
            disabled: false,
          },
          {
            name: "2579, Walmart, CHADRON, NE",
            disabled: false,
          },
          {
            name: "258, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "258, CVS, MCKEES ROCKS, PA",
            disabled: false,
          },
          {
            name: "258, Kroger, Springfield, IL",
            disabled: false,
          },
          {
            name: "258, Kroger, Wellston, OH",
            disabled: false,
          },
          {
            name: "258, Meijer, RICHMOND, KY",
            disabled: false,
          },
          {
            name: "258, Target, CHINO, CA",
            disabled: false,
          },
          {
            name: "258, Walmart, TUPELO, MS",
            disabled: false,
          },
          {
            name: "2580, ADUSA, LA GRANGE, NC",
            disabled: false,
          },
          {
            name: "2580, Albertsons, SOUTHLAKE, TX",
            disabled: false,
          },
          {
            name: "2580, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "2580, Walmart, CLINTON, NC",
            disabled: false,
          },
          {
            name: "2581, Albertsons, FRISCO, TX",
            disabled: false,
          },
          {
            name: "2581, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2581, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "2581, Walmart, CAMILLUS, NY",
            disabled: false,
          },
          {
            name: "2582, ADUSA, LONG BEACH, NY",
            disabled: false,
          },
          {
            name: "2582, ADUSA, WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "2582, Walmart, CLINTON, NJ",
            disabled: false,
          },
          {
            name: "2583, ADUSA, HUNTINGTON, NY",
            disabled: false,
          },
          {
            name: "2583, Albertsons, BELMONT, MA",
            disabled: false,
          },
          {
            name: "2583, Rite Aid, ARCHBOLD, OH",
            disabled: false,
          },
          {
            name: "2583, Walmart, UNIONDALE, NY",
            disabled: false,
          },
          {
            name: "2584, ADUSA, GREENVALE, NY",
            disabled: false,
          },
          {
            name: "2584, ADUSA, HOPKINS, SC",
            disabled: false,
          },
          {
            name: "2584, Albertsons, STOW, MA",
            disabled: false,
          },
          {
            name: "2584, Target, Sunnyvale, CA",
            disabled: false,
          },
          {
            name: "2584, Walgreens, FREEPORT, IL",
            disabled: false,
          },
          {
            name: "2584, Walmart, TUCKER, GA",
            disabled: false,
          },
          {
            name: "2585, Albertsons, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "2585, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "2585, Walmart, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "2586, ADUSA, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2586, Albertsons, RANCHO MIRAGE, CA",
            disabled: false,
          },
          {
            name: "2586, CVS, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "2586, Target, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "2586, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2586, Walmart, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "2587, ADUSA, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "2587, ADUSA, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "2587, CVS, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "2587, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2587, Walmart, CABOT, AR",
            disabled: false,
          },
          {
            name: "2588, ADUSA, BREVARD, NC",
            disabled: false,
          },
          {
            name: "2588, ADUSA, SEAFORD, NY",
            disabled: false,
          },
          {
            name: "2588, CVS, AVON, OH",
            disabled: false,
          },
          {
            name: "2588, Walmart, NORTH VERSAILLES, PA",
            disabled: false,
          },
          {
            name: "2589, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "2589, ADUSA, OZONE PARK, NY",
            disabled: false,
          },
          {
            name: "2589, CVS, MARS, PA",
            disabled: false,
          },
          {
            name: "2589, Walgreens, DECATUR, AL",
            disabled: false,
          },
          {
            name: "259, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "259, Albertsons, BUTTE, MT",
            disabled: false,
          },
          {
            name: "259, Meijer, SWARTZ CREEK, MI",
            disabled: false,
          },
          {
            name: "259, Target, ALISO VIEJO, CA",
            disabled: false,
          },
          {
            name: "259, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "259, Walmart, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "2590, ADUSA, FRANKLIN SQUARE, NY",
            disabled: false,
          },
          {
            name: "2590, ADUSA, MEBANE, NC",
            disabled: false,
          },
          {
            name: "2590, Albertsons, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "2590, Rite Aid, WELLINGTON, OH",
            disabled: false,
          },
          {
            name: "2590, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2590, Walmart, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "2591, ADUSA, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2591, ADUSA, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "2591, Albertsons, IRVINE, CA",
            disabled: false,
          },
          {
            name: "2591, Rite Aid, READING, PA",
            disabled: false,
          },
          {
            name: "2591, Walgreens, DIXON, IL",
            disabled: false,
          },
          {
            name: "2591, Walmart, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "2592, ADUSA, BOONE, NC",
            disabled: false,
          },
          {
            name: "2592, ADUSA, BRONX, NY",
            disabled: false,
          },
          {
            name: "2592, Albertsons, BATTLE GROUND, WA",
            disabled: false,
          },
          {
            name: "2592, CVS, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "2592, Walmart, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2593, ADUSA, BRONX, NY",
            disabled: false,
          },
          {
            name: "2593, CVS, LEESBURG, GA",
            disabled: false,
          },
          {
            name: "2593, Walgreens, EDISON, NJ",
            disabled: false,
          },
          {
            name: "2593, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2594, ADUSA, SPRING LAKE, NC",
            disabled: false,
          },
          {
            name: "2594, Albertsons, MARSHFIELD, MA",
            disabled: false,
          },
          {
            name: "2594, Walmart, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "2595, ADUSA, NEWTON GROVE, NC",
            disabled: false,
          },
          {
            name: "2595, ADUSA, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2595, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "2595, CVS, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "2595, Walmart, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "2596, ADUSA, MOUNT KISCO, NY",
            disabled: false,
          },
          {
            name: "2596, ADUSA, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "2596, Albertsons, CORONA, CA",
            disabled: false,
          },
          {
            name: "2596, CVS, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "2596, Target, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "2596, Walmart, MOUNT VERNON, WA",
            disabled: false,
          },
          {
            name: "2597, CVS, CHALMETTE, LA",
            disabled: false,
          },
          {
            name: "2597, Walmart, CRANBERRY, PA",
            disabled: false,
          },
          {
            name: "2598, Albertsons, LA CRESCENTA, CA",
            disabled: false,
          },
          {
            name: "2598, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2598, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2599, Albertsons, BEND, OR",
            disabled: false,
          },
          {
            name: "2599, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "2599, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "26, BJ's, EDISON, NJ",
            disabled: false,
          },
          {
            name: "26, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "26, Kroger, AGOURA, CA",
            disabled: false,
          },
          {
            name: "26, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "26, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "26, Kroger, Groveland, FL",
            disabled: false,
          },
          {
            name: "26, Kroger, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "26, Kroger, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "26, Meijer, JENISON, MI",
            disabled: false,
          },
          {
            name: "26, Target, BALLWIN, MO",
            disabled: false,
          },
          {
            name: "26, Walmart, LEAVENWORTH, KS",
            disabled: false,
          },
          {
            name: "260, Albertsons, SAINT CHARLES, IL",
            disabled: false,
          },
          {
            name: "260, Kroger, AUBURN, AL",
            disabled: false,
          },
          {
            name: "260, Kroger, POCATELLO, ID",
            disabled: false,
          },
          {
            name: "260, Kroger, Paris, IL",
            disabled: false,
          },
          {
            name: "260, Meijer, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "260, Rite Aid, ELMIRA, NY",
            disabled: false,
          },
          {
            name: "260, ShopRite, NEW WINDSOR, NY",
            disabled: false,
          },
          {
            name: "260, Target, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "260, Target, St Louis Park, MN",
            disabled: false,
          },
          {
            name: "260, Walmart, WAXAHACHIE, TX",
            disabled: false,
          },
          {
            name: "2600, ADUSA, GOOCHLAND, VA",
            disabled: false,
          },
          {
            name: "2600, Albertsons, TRACY, CA",
            disabled: false,
          },
          {
            name: "2600, CVS, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "2600, Walmart, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "2601, ADUSA, MOREHEAD CITY, NC",
            disabled: false,
          },
          {
            name: "2601, Albertsons, LITTLETON, NH",
            disabled: false,
          },
          {
            name: "2601, Target, PETALUMA, CA",
            disabled: false,
          },
          {
            name: "2602, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2603, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2603, Walmart, GIBSONIA, PA",
            disabled: false,
          },
          {
            name: "2604, ADUSA, BLYTHEWOOD, SC",
            disabled: false,
          },
          {
            name: "2604, ADUSA, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "2604, Albertsons, CANBY, OR",
            disabled: false,
          },
          {
            name: "2604, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2604, Target, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "2604, Walmart, NEWTON, NJ",
            disabled: false,
          },
          {
            name: "2605, ADUSA, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "2605, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "2605, Albertsons, SAINT HELENA, CA",
            disabled: false,
          },
          {
            name: "2605, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2605, Walmart, GALLIPOLIS, OH",
            disabled: false,
          },
          {
            name: "2606, ADUSA, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "2606, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "2606, Walgreens, SALINAS, CA",
            disabled: false,
          },
          {
            name: "2607, ADUSA, DUNN, NC",
            disabled: false,
          },
          {
            name: "2607, ADUSA, PAWCATUCK, CT",
            disabled: false,
          },
          {
            name: "2607, Albertsons, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "2607, Target, SWANSEA, MA",
            disabled: false,
          },
          {
            name: "2607, Walmart, POLSON, MT",
            disabled: false,
          },
          {
            name: "2608, Albertsons, EDGEWATER, MD",
            disabled: false,
          },
          {
            name: "2608, Target, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "2608, Walmart, MILES CITY, MT",
            disabled: false,
          },
          {
            name: "2609, ADUSA, GASTON, SC",
            disabled: false,
          },
          {
            name: "2609, Albertsons, HURST, TX",
            disabled: false,
          },
          {
            name: "2609, Target, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "2609, Walmart, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "261, ADUSA, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "261, ADUSA, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "261, Albertsons, BISBEE, AZ",
            disabled: false,
          },
          {
            name: "261, Kroger, Brownwood, TX",
            disabled: false,
          },
          {
            name: "261, Kroger, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "261, Kroger, Jasper, IN",
            disabled: false,
          },
          {
            name: "261, Walmart, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "2610, ADUSA, DARIEN, CT",
            disabled: false,
          },
          {
            name: "2610, ADUSA, POWHATAN, VA",
            disabled: false,
          },
          {
            name: "2610, Walmart, LOGAN, WV",
            disabled: false,
          },
          {
            name: "2611, ADUSA, EAST HAMPTON, CT",
            disabled: false,
          },
          {
            name: "2611, ADUSA, WOODBINE, MD",
            disabled: false,
          },
          {
            name: "2611, Walgreens, YUMA, AZ",
            disabled: false,
          },
          {
            name: "2611, Walmart, MOUNT PLEASANT, PA",
            disabled: false,
          },
          {
            name: "2612, ADUSA, NEW FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "2612, Albertsons, AURORA, CO",
            disabled: false,
          },
          {
            name: "2612, Walgreens, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "2612, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "2613, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "2613, ADUSA, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "2613, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2613, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2613, Walmart, BUCYRUS, OH",
            disabled: false,
          },
          {
            name: "2614, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2614, Walmart, TEMPLE, PA",
            disabled: false,
          },
          {
            name: "2615, ADUSA, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "2615, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2615, Target, FREMONT, CA",
            disabled: false,
          },
          {
            name: "2615, Walmart, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "2616, Albertsons, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2616, Walgreens, HANNIBAL, MO",
            disabled: false,
          },
          {
            name: "2616, Walmart, O FALLON, MO",
            disabled: false,
          },
          {
            name: "2617, ADUSA, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "2617, Walmart, WINNEMUCCA, NV",
            disabled: false,
          },
          {
            name: "2618, ADUSA, ELIZABETHTOWN, NC",
            disabled: false,
          },
          {
            name: "2618, Albertsons, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "2618, Walmart, COMMERCE, MI",
            disabled: false,
          },
          {
            name: "2619, ADUSA, STANLEYTOWN, VA",
            disabled: false,
          },
          {
            name: "2619, Walgreens, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "2619, Walmart, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "262, ADUSA, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "262, Albertsons, QUINCY, CA",
            disabled: false,
          },
          {
            name: "262, CVS, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "262, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "262, Meijer, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "262, Walmart, BENTON, IL",
            disabled: false,
          },
          {
            name: "2620, ADUSA, CLARKSVILLE, VA",
            disabled: false,
          },
          {
            name: "2620, Albertsons, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "2620, Walmart, HASTINGS, MI",
            disabled: false,
          },
          {
            name: "2621, ADUSA, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "2621, Albertsons, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "2621, Walmart, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "2622, ADUSA, SOUTH HILL, VA",
            disabled: false,
          },
          {
            name: "2623, ADUSA, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "2623, Albertsons, NEWBERG, OR",
            disabled: false,
          },
          {
            name: "2623, Walgreens, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "2624, ADUSA, CREEDMOOR, NC",
            disabled: false,
          },
          {
            name: "2624, Albertsons, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "2625, ADUSA, CONCORD, NC",
            disabled: false,
          },
          {
            name: "2625, Albertsons, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "2626, ADUSA, RUTHERFORDTON, NC",
            disabled: false,
          },
          {
            name: "2626, Albertsons, SACO, ME",
            disabled: false,
          },
          {
            name: "2626, Walgreens, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "2626, Walmart, LIVE OAK, FL",
            disabled: false,
          },
          {
            name: "2627, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2627, Albertsons, ASTORIA, OR",
            disabled: false,
          },
          {
            name: "2627, Target, AZUSA, CA",
            disabled: false,
          },
          {
            name: "2627, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2628, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "2628, Walmart, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "2629, ADUSA, ELGIN, SC",
            disabled: false,
          },
          {
            name: "2629, Albertsons, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "2629, Rite Aid, NEW CARLISLE, OH",
            disabled: false,
          },
          {
            name: "2629, Walmart, WHITINSVILLE, MA",
            disabled: false,
          },
          {
            name: "263, ADUSA, DALLAS, NC",
            disabled: false,
          },
          {
            name: "263, HEB, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "263, Kroger, Muncie, IN",
            disabled: false,
          },
          {
            name: "263, Rite Aid, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "2630, ADUSA, PERRYVILLE, MD",
            disabled: false,
          },
          {
            name: "2630, Albertsons, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "2630, Walmart, JESUP, GA",
            disabled: false,
          },
          {
            name: "2631, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "2631, Albertsons, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "2631, Target, GAMBRILLS, MD",
            disabled: false,
          },
          {
            name: "2631, Walmart, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "2632, ADUSA, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "2632, Albertsons, PLEASANT VALLEY, NY",
            disabled: false,
          },
          {
            name: "2632, Target, Culver City, CA",
            disabled: false,
          },
          {
            name: "2632, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2633, ADUSA, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "2633, ADUSA, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "2633, Albertsons, NEW CANAAN, CT",
            disabled: false,
          },
          {
            name: "2633, Walmart, PISCATAWAY, NJ",
            disabled: false,
          },
          {
            name: "2634, Walmart, GORHAM, NH",
            disabled: false,
          },
          {
            name: "2635, ADUSA, FARMVILLE, NC",
            disabled: false,
          },
          {
            name: "2635, Albertsons, BRISTOW, VA",
            disabled: false,
          },
          {
            name: "2636, ADUSA, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "2636, Albertsons, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "2636, Walgreens, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "2636, Walmart, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "2637, Albertsons, KELSO, WA",
            disabled: false,
          },
          {
            name: "2637, Rite Aid, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "2637, Walmart, MONROE, NY",
            disabled: false,
          },
          {
            name: "2638, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2638, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2638, Walmart, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "2639, Albertsons, PULLMAN, WA",
            disabled: false,
          },
          {
            name: "2639, Walmart, GILFORD, NH",
            disabled: false,
          },
          {
            name: "264, Albertsons, GLENDALE HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "264, Kroger, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "264, Kroger, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "264, Rite Aid, INDIANA, PA",
            disabled: false,
          },
          {
            name: "264, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "264, Walmart, DICKSON, TN",
            disabled: false,
          },
          {
            name: "2640, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "2640, Rite Aid, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "2640, Walmart, SALEM, MA",
            disabled: false,
          },
          {
            name: "2641, ADUSA, ROEBUCK, SC",
            disabled: false,
          },
          {
            name: "2641, Target, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "2641, Walgreens, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "2641, Walmart, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "2642, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2642, Walmart, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "2643, Albertsons, ADDISON, TX",
            disabled: false,
          },
          {
            name: "2643, Walmart, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "2644, ADUSA, PIEDMONT, SC",
            disabled: false,
          },
          {
            name: "2644, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "2644, Walgreens, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "2644, Walmart, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "2645, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "2645, Walmart, BLACKSTONE, VA",
            disabled: false,
          },
          {
            name: "2646, ADUSA, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "2646, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "2646, Walmart, PEARISBURG, VA",
            disabled: false,
          },
          {
            name: "2647, Walgreens, MOSES LAKE, WA",
            disabled: false,
          },
          {
            name: "2647, Walmart, WOODSTOCK, VA",
            disabled: false,
          },
          {
            name: "2648, Albertsons, THATCHER, AZ",
            disabled: false,
          },
          {
            name: "2648, Walmart, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "2649, Albertsons, OCEAN CITY, NJ",
            disabled: false,
          },
          {
            name: "2649, Target, WESTWOOD, MA",
            disabled: false,
          },
          {
            name: "2649, Walmart, IRVING, TX",
            disabled: false,
          },
          {
            name: "265, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "265, CVS, WARREN, RI",
            disabled: false,
          },
          {
            name: "265, HEB, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "265, Kroger, Baytown, TX",
            disabled: false,
          },
          {
            name: "265, Kroger, Compton, CA",
            disabled: false,
          },
          {
            name: "265, Kroger, DALTON, GA",
            disabled: false,
          },
          {
            name: "265, Kroger, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "265, Kroger, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "265, Meijer, EVERGREEN PARK, IL",
            disabled: false,
          },
          {
            name: "265, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "265, Walmart, TERRELL, TX",
            disabled: false,
          },
          {
            name: "2650, ADUSA, CHINA GROVE, NC",
            disabled: false,
          },
          {
            name: "2650, Walgreens, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2650, Walmart, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2651, ADUSA, HILDEBRAN, NC",
            disabled: false,
          },
          {
            name: "2651, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2651, Walmart, MANVILLE, NJ",
            disabled: false,
          },
          {
            name: "2652, Walmart, GRANTS, NM",
            disabled: false,
          },
          {
            name: "2653, Albertsons, WAREHAM, MA",
            disabled: false,
          },
          {
            name: "2653, Walmart, PORTALES, NM",
            disabled: false,
          },
          {
            name: "2654, Albertsons, SALINAS, CA",
            disabled: false,
          },
          {
            name: "2654, Rite Aid, CHARDON, OH",
            disabled: false,
          },
          {
            name: "2654, Walmart, TOMPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "2655, ADUSA, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "2655, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2656, Albertsons, SPARKS, NV",
            disabled: false,
          },
          {
            name: "2656, Walmart, ESPANOLA, NM",
            disabled: false,
          },
          {
            name: "2658, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "2658, Walmart, WEST BEND, WI",
            disabled: false,
          },
          {
            name: "2659, ADUSA, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "2659, Albertsons, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2659, Walmart, FALMOUTH, ME",
            disabled: false,
          },
          {
            name: "266, ADUSA, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "266, CVS, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "266, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "266, Meijer, PORTAGE, IN",
            disabled: false,
          },
          {
            name: "266, Walmart, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "2660, Albertsons, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "2660, Target, KAHULUI, HI",
            disabled: false,
          },
          {
            name: "2660, Walgreens, FREMONT, CA",
            disabled: false,
          },
          {
            name: "2660, Walmart, NORTH READING, MA",
            disabled: false,
          },
          {
            name: "2661, Albertsons, WALDORF, MD",
            disabled: false,
          },
          {
            name: "2661, CVS, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "2661, Walgreens, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "2662, CVS, HOOVER, AL",
            disabled: false,
          },
          {
            name: "2662, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "2662, Walmart, COVINGTON, VA",
            disabled: false,
          },
          {
            name: "2663, ADUSA, MONTPELIER, VA",
            disabled: false,
          },
          {
            name: "2663, CVS, KANKAKEE, IL",
            disabled: false,
          },
          {
            name: "2663, Walmart, EBENSBURG, PA",
            disabled: false,
          },
          {
            name: "2664, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "2664, Walmart, PUNXSUTAWNEY, PA",
            disabled: false,
          },
          {
            name: "2665, ADUSA, STANLEY, NC",
            disabled: false,
          },
          {
            name: "2665, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "2665, CVS, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "2665, Walmart, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "2666, ADUSA, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "2666, Albertsons, GREELEY, CO",
            disabled: false,
          },
          {
            name: "2666, Rite Aid, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "2666, Walmart, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "2667, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2667, Albertsons, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "2667, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2668, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2668, Walmart, STURTEVANT, WI",
            disabled: false,
          },
          {
            name: "2669, ADUSA, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "2669, Albertsons, CARMEL, CA",
            disabled: false,
          },
          {
            name: "2669, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "2669, Rite Aid, BRONX, NY",
            disabled: false,
          },
          {
            name: "2669, Walgreens, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "267, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "267, Kroger, Frankfort, IN",
            disabled: false,
          },
          {
            name: "267, Meijer, WARSAW, IN",
            disabled: false,
          },
          {
            name: "267, Target, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "267, Walmart, WEBB CITY, MO",
            disabled: false,
          },
          {
            name: "2670, Albertsons, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "2670, Walgreens, WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "2671, Albertsons, KATY, TX",
            disabled: false,
          },
          {
            name: "2671, Walmart, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "2672, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2672, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2672, Walmart, LAMAR, CO",
            disabled: false,
          },
          {
            name: "2673, ADUSA, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "2674, Walmart, GREENVILLE, PA",
            disabled: false,
          },
          {
            name: "2675, ADUSA, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "2675, Albertsons, WARREN, NJ",
            disabled: false,
          },
          {
            name: "2676, CVS, HICKORY, NC",
            disabled: false,
          },
          {
            name: "2676, Walgreens, COLUMBUS, MS",
            disabled: false,
          },
          {
            name: "2677, ADUSA, MOCKSVILLE, NC",
            disabled: false,
          },
          {
            name: "2677, Albertsons, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2677, CVS, NEW ALBANY, OH",
            disabled: false,
          },
          {
            name: "2678, Albertsons, VENTURA, CA",
            disabled: false,
          },
          {
            name: "2678, CVS, ERIE, PA",
            disabled: false,
          },
          {
            name: "2678, Walmart, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "2679, Albertsons, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "2679, Walgreens, LEWISTON, ID",
            disabled: false,
          },
          {
            name: "2679, Walmart, ELKHART, IN",
            disabled: false,
          },
          {
            name: "268, Kroger, Sugar Land, TX",
            disabled: false,
          },
          {
            name: "268, Kroger, WELLSBURG, WV",
            disabled: false,
          },
          {
            name: "268, Meijer, DETROIT, MI",
            disabled: false,
          },
          {
            name: "268, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "268, Walmart, SAVANNAH, TN",
            disabled: false,
          },
          {
            name: "2680, Albertsons, NEWARK, DE",
            disabled: false,
          },
          {
            name: "2680, CVS, GROTON, MA",
            disabled: false,
          },
          {
            name: "2680, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "2680, Walmart, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "2681, ADUSA, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "2681, Albertsons, UPLAND, CA",
            disabled: false,
          },
          {
            name: "2681, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2681, Walmart, LITTLETON, NH",
            disabled: false,
          },
          {
            name: "2682, ADUSA, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "2682, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "2682, CVS, WINSTED, CT",
            disabled: false,
          },
          {
            name: "2682, Target, HILO, HI",
            disabled: false,
          },
          {
            name: "2682, Walgreens, DUMONT, NJ",
            disabled: false,
          },
          {
            name: "2682, Walmart, BERLIN, VT",
            disabled: false,
          },
          {
            name: "2683, ADUSA, HANOVER, PA",
            disabled: false,
          },
          {
            name: "2683, Albertsons, EL DORADO HILLS, CA",
            disabled: false,
          },
          {
            name: "2683, CVS, BERLIN, NJ",
            disabled: false,
          },
          {
            name: "2683, Rite Aid, LEWISTON, MI",
            disabled: false,
          },
          {
            name: "2683, Walmart, HADLEY, MA",
            disabled: false,
          },
          {
            name: "2684, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "2684, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2684, CVS, MALAGA, NJ",
            disabled: false,
          },
          {
            name: "2684, Walmart, NEW MARTINSVILLE, WV",
            disabled: false,
          },
          {
            name: "2685, CVS, HUDSON FALLS, NY",
            disabled: false,
          },
          {
            name: "2685, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "2686, ADUSA, YOUNGSVILLE, NC",
            disabled: false,
          },
          {
            name: "2686, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "2686, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2686, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "2687, CVS, EXTON, PA",
            disabled: false,
          },
          {
            name: "2687, Walmart, GREER, SC",
            disabled: false,
          },
          {
            name: "2688, ADUSA, CRISFIELD, MD",
            disabled: false,
          },
          {
            name: "2688, Albertsons, EASTVALE, CA",
            disabled: false,
          },
          {
            name: "2688, Albertsons, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "2688, CVS, COLLEGEVILLE, PA",
            disabled: false,
          },
          {
            name: "2688, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "2689, Walgreens, MILFORD, MA",
            disabled: false,
          },
          {
            name: "2689, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "269, Albertsons, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "269, CVS, EAST PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "269, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "269, Kroger, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "269, Meijer, DANVILLE, IL",
            disabled: false,
          },
          {
            name: "269, Walmart, LAWTON, OK",
            disabled: false,
          },
          {
            name: "2690, Albertsons, MILWAUKIE, OR",
            disabled: false,
          },
          {
            name: "2690, CVS, LIMERICK, PA",
            disabled: false,
          },
          {
            name: "2690, Walmart, MADISON, AL",
            disabled: false,
          },
          {
            name: "2691, CVS, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "2691, Walmart, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "2692, ADUSA, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "2692, Albertsons, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "2692, CVS, JACKSONVILLE, IL",
            disabled: false,
          },
          {
            name: "2692, Walgreens, CHANNELVIEW, TX",
            disabled: false,
          },
          {
            name: "2692, Walmart, CHESTERFIELD, MI",
            disabled: false,
          },
          {
            name: "2693, Albertsons, BOOTHWYN, PA",
            disabled: false,
          },
          {
            name: "2693, Rite Aid, MINERSVILLE, PA",
            disabled: false,
          },
          {
            name: "2693, Target, Braintree, MA",
            disabled: false,
          },
          {
            name: "2693, Walmart, FENTON, MI",
            disabled: false,
          },
          {
            name: "2694, ADUSA, PORT WENTWORTH, GA",
            disabled: false,
          },
          {
            name: "2694, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2694, Walmart, KIRKWOOD, MO",
            disabled: false,
          },
          {
            name: "2695, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "2695, Walgreens, TEANECK, NJ",
            disabled: false,
          },
          {
            name: "2695, Walmart, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "2696, ADUSA, FISHERSVILLE, VA",
            disabled: false,
          },
          {
            name: "2696, Albertsons, MILWAUKIE, OR",
            disabled: false,
          },
          {
            name: "2696, Walgreens, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "2696, Walmart, MOOREFIELD, WV",
            disabled: false,
          },
          {
            name: "2697, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2697, Target, KAILUA, HI",
            disabled: false,
          },
          {
            name: "2697, Walgreens, BLUE ASH, OH",
            disabled: false,
          },
          {
            name: "2697, Walmart, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "2699, Albertsons, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "2699, Walmart, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "27, Albertsons, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "27, Kroger, Groveland, FL",
            disabled: false,
          },
          {
            name: "27, Kroger, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "27, Kroger, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "27, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "27, Kroger, Salina, KS",
            disabled: false,
          },
          {
            name: "27, Meijer, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "27, Walmart, SALEM, MO",
            disabled: false,
          },
          {
            name: "270, Albertsons, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "270, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "270, Meijer, ALMA, MI",
            disabled: false,
          },
          {
            name: "2700, ADUSA, WAYLAND, MA",
            disabled: false,
          },
          {
            name: "2700, Walgreens, MONROE, NC",
            disabled: false,
          },
          {
            name: "2700, Walmart, WHITE LAKE, MI",
            disabled: false,
          },
          {
            name: "2701, ADUSA, EAST PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "2701, Albertsons, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "2702, Albertsons, YORKVILLE, IL",
            disabled: false,
          },
          {
            name: "2702, CVS, COLONIE, NY",
            disabled: false,
          },
          {
            name: "2702, Walmart, NIXA, MO",
            disabled: false,
          },
          {
            name: "2703, Walmart, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "2704, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2704, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2704, Walmart, RANDLEMAN, NC",
            disabled: false,
          },
          {
            name: "2705, Walmart, FRANKLIN, VA",
            disabled: false,
          },
          {
            name: "2706, Albertsons, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "2706, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2706, Walgreens, LITTLE SILVER, NJ",
            disabled: false,
          },
          {
            name: "2706, Walmart, HARVEY, LA",
            disabled: false,
          },
          {
            name: "2707, Albertsons, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "2707, Rite Aid, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "2708, Albertsons, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "2708, Walmart, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "2709, Albertsons, LAVEEN, AZ",
            disabled: false,
          },
          {
            name: "2709, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "271, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "271, CVS, SOUTH PLAINFIELD, NJ",
            disabled: false,
          },
          {
            name: "271, HEB, WEST COLUMBIA, TX",
            disabled: false,
          },
          {
            name: "271, Kroger, LOS OSOS, CA",
            disabled: false,
          },
          {
            name: "271, Kroger, SPRINGVILLE, UT",
            disabled: false,
          },
          {
            name: "271, Meijer, SOUTH HAVEN, MI",
            disabled: false,
          },
          {
            name: "271, Target, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "271, Walmart, BOWIE, TX",
            disabled: false,
          },
          {
            name: "2710, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "2710, Walgreens, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "2710, Walmart, KETCHIKAN, AK",
            disabled: false,
          },
          {
            name: "2711, Rite Aid, COLDWATER, MI",
            disabled: false,
          },
          {
            name: "2711, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2711, Walmart, KODIAK, AK",
            disabled: false,
          },
          {
            name: "2712, Albertsons, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "2712, Walgreens, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2712, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "2713, Albertsons, BOWIE, MD",
            disabled: false,
          },
          {
            name: "2713, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "2714, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "2714, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2714, Walgreens, WYOMING, MI",
            disabled: false,
          },
          {
            name: "2714, Walmart, SPENCER, IA",
            disabled: false,
          },
          {
            name: "2715, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2715, Target, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "2715, Walmart, DIBERVILLE, MS",
            disabled: false,
          },
          {
            name: "2716, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2716, Target, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "2716, Walgreens, LYNN, MA",
            disabled: false,
          },
          {
            name: "2716, Walmart, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "2717, Target, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "2717, Walmart, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "2718, Albertsons, MILL VALLEY, CA",
            disabled: false,
          },
          {
            name: "2718, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2719, Albertsons, MENLO PARK, CA",
            disabled: false,
          },
          {
            name: "2719, CVS, OZONE PARK, NY",
            disabled: false,
          },
          {
            name: "2719, Walmart, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "272, Albertsons, WILLCOX, AZ",
            disabled: false,
          },
          {
            name: "272, CVS, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "272, Kroger, Belleville, IL",
            disabled: false,
          },
          {
            name: "272, Kroger, WEST POINT, UT",
            disabled: false,
          },
          {
            name: "272, Kroger, Wichita, KS",
            disabled: false,
          },
          {
            name: "272, Meijer, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "272, Walmart, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "2720, Walgreens, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "2720, Walmart, MADISON, MS",
            disabled: false,
          },
          {
            name: "2721, CVS, FARMINGVILLE, NY",
            disabled: false,
          },
          {
            name: "2721, Target, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "2721, Walgreens, NILES, IL",
            disabled: false,
          },
          {
            name: "2721, Walmart, CAYEY, PR",
            disabled: false,
          },
          {
            name: "2722, Albertsons, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "2722, Walmart, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "2723, Albertsons, TILLAMOOK, OR",
            disabled: false,
          },
          {
            name: "2723, Walmart, SUMITON, AL",
            disabled: false,
          },
          {
            name: "2724, Albertsons, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "2724, CVS, PASSAIC, NJ",
            disabled: false,
          },
          {
            name: "2724, Walmart, PASADENA, TX",
            disabled: false,
          },
          {
            name: "2725, CVS, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "2725, Target, KYLE, TX",
            disabled: false,
          },
          {
            name: "2725, Walmart, LEWIS CENTER, OH",
            disabled: false,
          },
          {
            name: "2726, CVS, WADING RIVER, NY",
            disabled: false,
          },
          {
            name: "2726, Walmart, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "2727, Target, MOORE, OK",
            disabled: false,
          },
          {
            name: "2727, Walmart, FLORIDA CITY, FL",
            disabled: false,
          },
          {
            name: "2728, Albertsons, SEWARD, AK",
            disabled: false,
          },
          {
            name: "2728, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "2728, Walmart, DECATUR, IL",
            disabled: false,
          },
          {
            name: "2729, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "2729, CVS, PITTSTON, PA",
            disabled: false,
          },
          {
            name: "2729, Rite Aid, COOPERSVILLE, MI",
            disabled: false,
          },
          {
            name: "2729, Target, WILMINGTON, MA",
            disabled: false,
          },
          {
            name: "2729, Walmart, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "273, Albertsons, ANDERSON, CA",
            disabled: false,
          },
          {
            name: "273, CVS, LEWISTON, ME",
            disabled: false,
          },
          {
            name: "273, Kroger, Bluewell, WV",
            disabled: false,
          },
          {
            name: "273, Kroger, Cahokia, IL",
            disabled: false,
          },
          {
            name: "273, Kroger, WORTHINGTON, OH",
            disabled: false,
          },
          {
            name: "273, Meijer, MOKENA, IL",
            disabled: false,
          },
          {
            name: "273, ShopRite, CHESTER, NJ",
            disabled: false,
          },
          {
            name: "273, Target, MODESTO, CA",
            disabled: false,
          },
          {
            name: "273, Walmart, FULTON, MS",
            disabled: false,
          },
          {
            name: "2730, CVS, ROYERSFORD, PA",
            disabled: false,
          },
          {
            name: "2730, Target, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "2730, Walmart, TARBORO, NC",
            disabled: false,
          },
          {
            name: "2731, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "2731, Rite Aid, TROY, MI",
            disabled: false,
          },
          {
            name: "2731, Walmart, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "2732, CVS, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "2732, Walgreens, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "2732, Walmart, VILLA RICA, GA",
            disabled: false,
          },
          {
            name: "2733, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "2733, Walmart, PERRY, GA",
            disabled: false,
          },
          {
            name: "2734, Albertsons, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "2734, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2734, Walmart, NORMAN, OK",
            disabled: false,
          },
          {
            name: "2735, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2735, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "2735, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "2736, CVS, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "2737, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2737, Target, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "2739, Albertsons, WEST HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "2739, Target, LAWTON, OK",
            disabled: false,
          },
          {
            name: "2739, Walmart, BAY MINETTE, AL",
            disabled: false,
          },
          {
            name: "274, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "274, Albertsons, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "274, CVS, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "274, Kroger, Collinsville, IL",
            disabled: false,
          },
          {
            name: "274, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "274, Kroger, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "274, Meijer, GRAFTON, WI",
            disabled: false,
          },
          {
            name: "274, Target, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "274, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "274, Walmart, IUKA, MS",
            disabled: false,
          },
          {
            name: "2740, Walgreens, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "2740, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2741, ADUSA, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2741, CVS, LA VISTA, NE",
            disabled: false,
          },
          {
            name: "2741, Walgreens, BLACK JACK, MO",
            disabled: false,
          },
          {
            name: "2741, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "2742, ADUSA, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "2742, Target, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "2742, Walmart, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "2743, ADUSA, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "2743, Albertsons, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "2743, CVS, COHOES, NY",
            disabled: false,
          },
          {
            name: "2743, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2743, Walmart, SHERWOOD, AR",
            disabled: false,
          },
          {
            name: "2744, ADUSA, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "2744, Rite Aid, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2744, Target, FRESNO, CA",
            disabled: false,
          },
          {
            name: "2744, Walmart, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "2745, Walmart, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "2746, ADUSA, HERNDON, VA",
            disabled: false,
          },
          {
            name: "2746, CVS, LEONIA, NJ",
            disabled: false,
          },
          {
            name: "2747, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "2747, CVS, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "2747, Target, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "2747, Walmart, WARWICK, RI",
            disabled: false,
          },
          {
            name: "2748, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "2748, Walmart, GULF SHORES, AL",
            disabled: false,
          },
          {
            name: "2749, CVS, CONCORD, NC",
            disabled: false,
          },
          {
            name: "2749, Walgreens, SHARON, PA",
            disabled: false,
          },
          {
            name: "2749, Walmart, SPRUCE PINE, NC",
            disabled: false,
          },
          {
            name: "275, Albertsons, WAIPAHU, HI",
            disabled: false,
          },
          {
            name: "275, CVS, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "275, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "275, Meijer, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "275, Target, FRESNO, CA",
            disabled: false,
          },
          {
            name: "275, Walmart, LIVINGSTON, TX",
            disabled: false,
          },
          {
            name: "2750, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "2751, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "2751, Walmart, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "2752, Walgreens, ELM GROVE, WI",
            disabled: false,
          },
          {
            name: "2752, Walmart, COMMERCE CITY, CO",
            disabled: false,
          },
          {
            name: "2753, Albertsons, KENSINGTON, MD",
            disabled: false,
          },
          {
            name: "2753, CVS, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "2753, Target, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "2753, Walmart, CLAYTON, GA",
            disabled: false,
          },
          {
            name: "2754, Albertsons, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "2754, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "2754, Target, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2754, Walmart, WAYNESBORO, GA",
            disabled: false,
          },
          {
            name: "2755, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2755, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2755, Walmart, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "2756, Albertsons, BROUSSARD, LA",
            disabled: false,
          },
          {
            name: "2756, CVS, BROOMALL, PA",
            disabled: false,
          },
          {
            name: "2756, Walmart, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "2757, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2757, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "2758, CVS, MARGATE, FL",
            disabled: false,
          },
          {
            name: "2758, Walgreens, TARRYTOWN, NY",
            disabled: false,
          },
          {
            name: "2758, Walmart, PLYMOUTH, NH",
            disabled: false,
          },
          {
            name: "2759, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "2759, Target, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "2759, Walgreens, QUINCY, MA",
            disabled: false,
          },
          {
            name: "276, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "276, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "276, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "276, Kroger, East Alton, IL",
            disabled: false,
          },
          {
            name: "276, Kroger, Jeffersonville, IN",
            disabled: false,
          },
          {
            name: "276, Kroger, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "276, Meijer, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "276, ShopRite, THORNWOOD, NY",
            disabled: false,
          },
          {
            name: "276, Walmart, STIGLER, OK",
            disabled: false,
          },
          {
            name: "2760, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2760, Rite Aid, BEAVERTON, MI",
            disabled: false,
          },
          {
            name: "2760, Target, OXNARD, CA",
            disabled: false,
          },
          {
            name: "2760, Walmart, JACKSON, AL",
            disabled: false,
          },
          {
            name: "2761, Albertsons, LANDER, WY",
            disabled: false,
          },
          {
            name: "2761, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "2761, Walgreens, TREASURE ISLAND, FL",
            disabled: false,
          },
          {
            name: "2761, Walmart, POUNDING MILL, VA",
            disabled: false,
          },
          {
            name: "2762, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2762, CVS, SOMERSET, NJ",
            disabled: false,
          },
          {
            name: "2762, Walmart, FAIRLAWN, VA",
            disabled: false,
          },
          {
            name: "2763, Walmart, DONNA, TX",
            disabled: false,
          },
          {
            name: "2764, Albertsons, ARNOLD, MD",
            disabled: false,
          },
          {
            name: "2764, Target, NEWARK, DE",
            disabled: false,
          },
          {
            name: "2764, Walmart, ALTOONA, IA",
            disabled: false,
          },
          {
            name: "2765, Target, MADISON, WI",
            disabled: false,
          },
          {
            name: "2765, Walmart, LOS FRESNOS, TX",
            disabled: false,
          },
          {
            name: "2766, Target, San Francisco, CA",
            disabled: false,
          },
          {
            name: "2766, Walgreens, EAGAN, MN",
            disabled: false,
          },
          {
            name: "2766, Walmart, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "2767, Albertsons, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "2767, CVS, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "2767, Target, EMERYVILLE, CA",
            disabled: false,
          },
          {
            name: "2767, Walgreens, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "2767, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "2768, Target, San Francisco, CA",
            disabled: false,
          },
          {
            name: "2768, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "2769, Rite Aid, MERCER, PA",
            disabled: false,
          },
          {
            name: "2769, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "2769, Walgreens, WHITE BEAR LAKE, MN",
            disabled: false,
          },
          {
            name: "2769, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "277, Kroger, Fairview Heights, IL",
            disabled: false,
          },
          {
            name: "277, Kroger, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "277, Kroger, KAYSVILLE, UT",
            disabled: false,
          },
          {
            name: "277, Kroger, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "277, Meijer, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "277, Rite Aid, MARION, OH",
            disabled: false,
          },
          {
            name: "277, ShopRite, HUDSON, NY",
            disabled: false,
          },
          {
            name: "277, Walmart, MOORE, OK",
            disabled: false,
          },
          {
            name: "2770, Target, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "2770, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "2771, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2771, CVS, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "2771, Target, DUBLIN, CA",
            disabled: false,
          },
          {
            name: "2771, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "2771, Walmart, MONTICELLO, IN",
            disabled: false,
          },
          {
            name: "2772, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "2772, Target, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "2772, Walmart, SOUTHPORT, NC",
            disabled: false,
          },
          {
            name: "2773, CVS, NEW YORK, NY",
            disabled: false,
          },
          {
            name: "2773, Walmart, LAGRANGE, GA",
            disabled: false,
          },
          {
            name: "2774, Albertsons, HORSHAM, PA",
            disabled: false,
          },
          {
            name: "2774, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "2774, Walgreens, WEST MEMPHIS, AR",
            disabled: false,
          },
          {
            name: "2774, Walmart, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "2775, CVS, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "2775, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "2775, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "2776, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2776, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "2776, Rite Aid, SPRING LAKE, MI",
            disabled: false,
          },
          {
            name: "2776, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "2777, CVS, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "2777, Walgreens, KEY WEST, FL",
            disabled: false,
          },
          {
            name: "2777, Walmart, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "2778, Albertsons, JACKSON, CA",
            disabled: false,
          },
          {
            name: "2778, Walgreens, ELMONT, NY",
            disabled: false,
          },
          {
            name: "2778, Walmart, COOLIDGE, AZ",
            disabled: false,
          },
          {
            name: "2779, CVS, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "2779, Target, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "278, CVS, ARLINGTON, MA",
            disabled: false,
          },
          {
            name: "278, Kroger, Godfrey, IL",
            disabled: false,
          },
          {
            name: "278, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "278, Kroger, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "278, Meijer, FLAT ROCK, MI",
            disabled: false,
          },
          {
            name: "278, ShopRite, MOHEGAN LAKE, NY",
            disabled: false,
          },
          {
            name: "278, Target, SHELBY TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "278, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "2780, CVS, WEST HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "2780, Target, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "2780, Walmart, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "2781, Albertsons, WHEATON, MD",
            disabled: false,
          },
          {
            name: "2781, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2781, Walgreens, NORTON, MA",
            disabled: false,
          },
          {
            name: "2781, Walmart, NAMPA, ID",
            disabled: false,
          },
          {
            name: "2782, CVS, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "2782, Walmart, MOUNTAIN HOME, ID",
            disabled: false,
          },
          {
            name: "2783, Albertsons, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "2783, Walmart, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "2784, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2784, CVS, WEST GROVE, PA",
            disabled: false,
          },
          {
            name: "2784, Target, CARY, NC",
            disabled: false,
          },
          {
            name: "2784, Walmart, BEATRICE, NE",
            disabled: false,
          },
          {
            name: "2785, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2785, CVS, WOODLYN, PA",
            disabled: false,
          },
          {
            name: "2785, Target, HOLLY SPRINGS, NC",
            disabled: false,
          },
          {
            name: "2785, Walgreens, CICERO, IL",
            disabled: false,
          },
          {
            name: "2785, Walmart, VICTOR, NY",
            disabled: false,
          },
          {
            name: "2786, CVS, SOUTH ELGIN, IL",
            disabled: false,
          },
          {
            name: "2786, Target, Seattle, WA",
            disabled: false,
          },
          {
            name: "2786, Walmart, AVON, IN",
            disabled: false,
          },
          {
            name: "2787, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2787, Target, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2787, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2788, CVS, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "2788, Walmart, BROWNSBURG, IN",
            disabled: false,
          },
          {
            name: "2789, Albertsons, UPPER DARBY, PA",
            disabled: false,
          },
          {
            name: "2789, Walmart, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "279, ADUSA, HAVELOCK, NC",
            disabled: false,
          },
          {
            name: "279, CVS, BUFORD, GA",
            disabled: false,
          },
          {
            name: "279, Kroger, Granite City, IL",
            disabled: false,
          },
          {
            name: "279, Kroger, Marina Del Rey, CA",
            disabled: false,
          },
          {
            name: "279, Kroger, NORTH OGDEN, UT",
            disabled: false,
          },
          {
            name: "279, Meijer, MANISTEE, MI",
            disabled: false,
          },
          {
            name: "279, Target, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "279, Walmart, DE QUEEN, AR",
            disabled: false,
          },
          {
            name: "2790, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "2790, CVS, EVERGREEN PARK, IL",
            disabled: false,
          },
          {
            name: "2790, Target, Fairfax, VA",
            disabled: false,
          },
          {
            name: "2790, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2790, Walmart, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "2791, Albertsons, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "2791, CVS, LOMBARD, IL",
            disabled: false,
          },
          {
            name: "2791, Walmart, GEORGETOWN, DE",
            disabled: false,
          },
          {
            name: "2792, Albertsons, CONIFER, CO",
            disabled: false,
          },
          {
            name: "2792, Walmart, WAYNE, WV",
            disabled: false,
          },
          {
            name: "2793, Walmart, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "2794, Albertsons, DAMASCUS, MD",
            disabled: false,
          },
          {
            name: "2794, Walmart, EPHRAIM, UT",
            disabled: false,
          },
          {
            name: "2795, Albertsons, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "2795, CVS, EAST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "2795, Rite Aid, WOODSFIELD, OH",
            disabled: false,
          },
          {
            name: "2795, Target, CAPITOLA, CA",
            disabled: false,
          },
          {
            name: "2795, Walmart, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "2796, Albertsons, CORONA, CA",
            disabled: false,
          },
          {
            name: "2796, CVS, CLARK, NJ",
            disabled: false,
          },
          {
            name: "2796, Target, HOMEWOOD, AL",
            disabled: false,
          },
          {
            name: "2796, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2796, Walmart, OLDSMAR, FL",
            disabled: false,
          },
          {
            name: "2797, Albertsons, OLNEY, MD",
            disabled: false,
          },
          {
            name: "2797, CVS, NILES, IL",
            disabled: false,
          },
          {
            name: "2797, Rite Aid, MELROSE PARK, PA",
            disabled: false,
          },
          {
            name: "2797, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2797, Walmart, STURBRIDGE, MA",
            disabled: false,
          },
          {
            name: "2798, Albertsons, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "2798, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2798, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "2799, Albertsons, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "2799, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "2799, Walmart, CLINTON, MD",
            disabled: false,
          },
          {
            name: "28, ADUSA, NORWELL, MA",
            disabled: false,
          },
          {
            name: "28, Albertsons, SUMMIT, NJ",
            disabled: false,
          },
          {
            name: "28, Albertsons, WILLISTON, ND",
            disabled: false,
          },
          {
            name: "28, CVS, MILAN, MI",
            disabled: false,
          },
          {
            name: "28, Costco, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "28, HEB, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "28, Kroger, BOULDER, CO",
            disabled: false,
          },
          {
            name: "28, Kroger, BURIEN, WA",
            disabled: false,
          },
          {
            name: "28, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "28, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "28, Walmart, MIAMI, OK",
            disabled: false,
          },
          {
            name: "280, Albertsons, KAHULUI, HI",
            disabled: false,
          },
          {
            name: "280, CVS, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "280, Kroger, MARINA DEL REY, CA",
            disabled: false,
          },
          {
            name: "280, Kroger, St George, UT",
            disabled: false,
          },
          {
            name: "280, Meijer, FLOSSMOOR, IL",
            disabled: false,
          },
          {
            name: "280, Target, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "280, Walmart, ROCKDALE, TX",
            disabled: false,
          },
          {
            name: "2800, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2801, ADUSA, CAYCE, SC",
            disabled: false,
          },
          {
            name: "2801, Walmart, ALBANY, GA",
            disabled: false,
          },
          {
            name: "2802, ADUSA, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "2802, ADUSA, WALTERBORO, SC",
            disabled: false,
          },
          {
            name: "2802, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2802, Target, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "2803, ADUSA, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "2803, Albertsons, SEAL BEACH, CA",
            disabled: false,
          },
          {
            name: "2803, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2803, Walmart, EDMOND, OK",
            disabled: false,
          },
          {
            name: "2804, ADUSA, CHESTER, SC",
            disabled: false,
          },
          {
            name: "2804, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2804, CVS, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "2804, Target, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "2804, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "2805, ADUSA, MADISON, NJ",
            disabled: false,
          },
          {
            name: "2805, Target, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "2805, Walmart, EMPORIA, VA",
            disabled: false,
          },
          {
            name: "2806, ADUSA, THOMASVILLE, GA",
            disabled: false,
          },
          {
            name: "2806, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2806, Walmart, BOILING SPRINGS, SC",
            disabled: false,
          },
          {
            name: "2807, ADUSA, NASHVILLE, GA",
            disabled: false,
          },
          {
            name: "2807, Walmart, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "2808, ADUSA, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "2808, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2808, Walmart, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "2809, ADUSA, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "2809, Albertsons, VAIL, AZ",
            disabled: false,
          },
          {
            name: "2809, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2809, Walmart, BUCKHANNON, WV",
            disabled: false,
          },
          {
            name: "281, ADUSA, LITTLE RIVER, SC",
            disabled: false,
          },
          {
            name: "281, CVS, ROCKLAND, MA",
            disabled: false,
          },
          {
            name: "281, Kroger, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "281, Kroger, VENICE, CA",
            disabled: false,
          },
          {
            name: "281, Meijer, MACHESNEY PARK, IL",
            disabled: false,
          },
          {
            name: "281, ShopRite, SUCCASUNNA, NJ",
            disabled: false,
          },
          {
            name: "281, Target, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "281, Walmart, HEBER SPGS, AR",
            disabled: false,
          },
          {
            name: "2810, ADUSA, CAYCE, SC",
            disabled: false,
          },
          {
            name: "2810, Albertsons, MONTE VISTA, CO",
            disabled: false,
          },
          {
            name: "2810, Target, WESTLAKE VILLAGE, CA",
            disabled: false,
          },
          {
            name: "2810, Walgreens, FREEDOM, CA",
            disabled: false,
          },
          {
            name: "2810, Walmart, SPENCER, WV",
            disabled: false,
          },
          {
            name: "2811, Target, BRONX, NY",
            disabled: false,
          },
          {
            name: "2811, Walmart, ATHENS, GA",
            disabled: false,
          },
          {
            name: "2812, ADUSA, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "2812, ADUSA, REIDSVILLE, GA",
            disabled: false,
          },
          {
            name: "2812, Albertsons, LOUISVILLE, CO",
            disabled: false,
          },
          {
            name: "2812, Walmart, ROCHESTER, MN",
            disabled: false,
          },
          {
            name: "2813, ADUSA, LONG BRANCH, NJ",
            disabled: false,
          },
          {
            name: "2813, Albertsons, MALIBU, CA",
            disabled: false,
          },
          {
            name: "2813, CVS, WEST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "2813, Target, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "2813, Walmart, MARSHFIELD, WI",
            disabled: false,
          },
          {
            name: "2814, Albertsons, LOS ALTOS, CA",
            disabled: false,
          },
          {
            name: "2814, Walmart, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "2815, ADUSA, GREER, SC",
            disabled: false,
          },
          {
            name: "2815, Albertsons, LOS GATOS, CA",
            disabled: false,
          },
          {
            name: "2815, CVS, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "2815, Target, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "2815, Walmart, ROLLING MEADOWS, IL",
            disabled: false,
          },
          {
            name: "2816, ADUSA, PELZER, SC",
            disabled: false,
          },
          {
            name: "2816, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "2816, Target, MADISON, AL",
            disabled: false,
          },
          {
            name: "2816, Walmart, NILES, IL",
            disabled: false,
          },
          {
            name: "2817, ADUSA, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "2817, ADUSA, SOUTH ORANGE, NJ",
            disabled: false,
          },
          {
            name: "2817, Albertsons, SALIDA, CO",
            disabled: false,
          },
          {
            name: "2817, Walmart, LANSING, IL",
            disabled: false,
          },
          {
            name: "2818, ADUSA, ALBANY, GA",
            disabled: false,
          },
          {
            name: "2818, Albertsons, CORONA, CA",
            disabled: false,
          },
          {
            name: "2818, Target, GRANDVILLE, MI",
            disabled: false,
          },
          {
            name: "2818, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2818, Walmart, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "2819, ADUSA, CLOSTER, NJ",
            disabled: false,
          },
          {
            name: "2819, Walmart, BLUFFTON, IN",
            disabled: false,
          },
          {
            name: "282, ADUSA, FARMVILLE, VA",
            disabled: false,
          },
          {
            name: "282, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "282, Kroger, Mayfield, KY",
            disabled: false,
          },
          {
            name: "282, Meijer, ALPENA, MI",
            disabled: false,
          },
          {
            name: "282, Target, MADISON HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "282, Walmart, FRANKLIN, KY",
            disabled: false,
          },
          {
            name: "2820, ADUSA, ALBANY, GA",
            disabled: false,
          },
          {
            name: "2820, Albertsons, VERNON, NJ",
            disabled: false,
          },
          {
            name: "2820, CVS, PENNSAUKEN, NJ",
            disabled: false,
          },
          {
            name: "2820, Target, DENVER, CO",
            disabled: false,
          },
          {
            name: "2820, Walmart, WORTHINGTON, MN",
            disabled: false,
          },
          {
            name: "2821, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "2821, Albertsons, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "2821, Walmart, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2822, ADUSA, SALUDA, SC",
            disabled: false,
          },
          {
            name: "2822, Target, Boston, MA",
            disabled: false,
          },
          {
            name: "2822, Walmart, WALKER, LA",
            disabled: false,
          },
          {
            name: "2823, ADUSA, WINNSBORO, SC",
            disabled: false,
          },
          {
            name: "2823, Walgreens, LYNN, MA",
            disabled: false,
          },
          {
            name: "2823, Walmart, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "2824, ADUSA, METTER, GA",
            disabled: false,
          },
          {
            name: "2824, Albertsons, LEADVILLE, CO",
            disabled: false,
          },
          {
            name: "2824, Target, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "2825, ADUSA, STATESBORO, GA",
            disabled: false,
          },
          {
            name: "2825, Albertsons, OXNARD, CA",
            disabled: false,
          },
          {
            name: "2825, CVS, BRANDON, FL",
            disabled: false,
          },
          {
            name: "2825, Walgreens, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "2825, Walmart, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "2826, ADUSA, SPRINGFIELD, GA",
            disabled: false,
          },
          {
            name: "2826, Albertsons, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "2826, Walmart, COACHELLA, CA",
            disabled: false,
          },
          {
            name: "2827, ADUSA, HONEA PATH, SC",
            disabled: false,
          },
          {
            name: "2827, Albertsons, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "2827, CVS, HILLSIDE, IL",
            disabled: false,
          },
          {
            name: "2827, Walmart, CORALVILLE, IA",
            disabled: false,
          },
          {
            name: "2828, ADUSA, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "2828, Albertsons, NOVATO, CA",
            disabled: false,
          },
          {
            name: "2828, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "2828, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "2828, Walmart, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2829, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2829, Target, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "283, Albertsons, WHEATON, IL",
            disabled: false,
          },
          {
            name: "283, Costco, MIRA LOMA, CA",
            disabled: false,
          },
          {
            name: "283, Kroger, DERBY, KS",
            disabled: false,
          },
          {
            name: "283, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "283, Meijer, OAK CREEK, WI",
            disabled: false,
          },
          {
            name: "283, Walmart, BRIDGE CITY, TX",
            disabled: false,
          },
          {
            name: "2830, ADUSA, YORK, SC",
            disabled: false,
          },
          {
            name: "2830, Albertsons, SHRUB OAK, NY",
            disabled: false,
          },
          {
            name: "2830, Target, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "2830, Walmart, EDDYSTONE, PA",
            disabled: false,
          },
          {
            name: "2831, ADUSA, HAWKINSVILLE, GA",
            disabled: false,
          },
          {
            name: "2831, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "2831, Target, POMONA, CA",
            disabled: false,
          },
          {
            name: "2831, Walgreens, NORTH ARLINGTON, NJ",
            disabled: false,
          },
          {
            name: "2831, Walmart, JEROME, ID",
            disabled: false,
          },
          {
            name: "2832, ADUSA, QUITMAN, GA",
            disabled: false,
          },
          {
            name: "2832, Albertsons, LA VERNE, CA",
            disabled: false,
          },
          {
            name: "2832, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2832, Walmart, HARDEEVILLE, SC",
            disabled: false,
          },
          {
            name: "2833, ADUSA, HAHIRA, GA",
            disabled: false,
          },
          {
            name: "2833, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2833, Walmart, GRAFTON, WV",
            disabled: false,
          },
          {
            name: "2834, ADUSA, CHESNEE, SC",
            disabled: false,
          },
          {
            name: "2834, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2835, ADUSA, INMAN, SC",
            disabled: false,
          },
          {
            name: "2835, Albertsons, FLORENCE, AZ",
            disabled: false,
          },
          {
            name: "2835, CVS, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "2835, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2836, ADUSA, HARTSVILLE, SC",
            disabled: false,
          },
          {
            name: "2836, Albertsons, SMYRNA, DE",
            disabled: false,
          },
          {
            name: "2836, Walmart, FUQUAY VARINA, NC",
            disabled: false,
          },
          {
            name: "2837, ADUSA, SYLVANIA, GA",
            disabled: false,
          },
          {
            name: "2837, CVS, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "2838, Albertsons, NORTH WILDWOOD, NJ",
            disabled: false,
          },
          {
            name: "2838, CVS, RHINEBECK, NY",
            disabled: false,
          },
          {
            name: "2838, Walmart, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2839, ADUSA, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "2839, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "2839, CVS, UNCASVILLE, CT",
            disabled: false,
          },
          {
            name: "2839, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "284, Albertsons, REEDSPORT, OR",
            disabled: false,
          },
          {
            name: "284, Kroger, Benwood, WV",
            disabled: false,
          },
          {
            name: "284, Kroger, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "284, Kroger, Glasgow, KY",
            disabled: false,
          },
          {
            name: "284, Meijer, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "284, Walmart, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "2840, ADUSA, FOUNTAIN INN, SC",
            disabled: false,
          },
          {
            name: "2840, Albertsons, FREEDOM, CA",
            disabled: false,
          },
          {
            name: "2840, CVS, MASON, OH",
            disabled: false,
          },
          {
            name: "2840, Target, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "2840, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2840, Walmart, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "2841, ADUSA, ROYSTON, GA",
            disabled: false,
          },
          {
            name: "2841, Albertsons, DEL REY OAKS, CA",
            disabled: false,
          },
          {
            name: "2841, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "2841, Walmart, LUMBERTON, NJ",
            disabled: false,
          },
          {
            name: "2842, ADUSA, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2842, Albertsons, GRASS VALLEY, CA",
            disabled: false,
          },
          {
            name: "2842, CVS, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "2842, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "2842, Walmart, CORONA, CA",
            disabled: false,
          },
          {
            name: "2843, ADUSA, YORK, SC",
            disabled: false,
          },
          {
            name: "2843, Albertsons, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "2843, CVS, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "2843, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2843, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "2843, Walmart, SUMMERFIELD, FL",
            disabled: false,
          },
          {
            name: "2844, CVS, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "2844, Target, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "2844, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2844, Walmart, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "2845, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2845, Target, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "2845, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "2845, Walmart, SILER CITY, NC",
            disabled: false,
          },
          {
            name: "2846, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2846, Walmart, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "2847, Albertsons, NEW PROVIDENCE, NJ",
            disabled: false,
          },
          {
            name: "2847, Target, SAYVILLE, NY",
            disabled: false,
          },
          {
            name: "2847, Walmart, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "2848, Albertsons, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "2848, CVS, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "2848, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "2848, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "2849, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "2849, Walgreens, LIVINGSTON, NJ",
            disabled: false,
          },
          {
            name: "2849, Walmart, MASON, WV",
            disabled: false,
          },
          {
            name: "285, Albertsons, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "285, CVS, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "285, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "285, Meijer, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "285, Walmart, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "2850, Target, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2850, Walgreens, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "2850, Walmart, HAMPSTEAD, MD",
            disabled: false,
          },
          {
            name: "2851, Target, POWELL, OH",
            disabled: false,
          },
          {
            name: "2852, Walmart, MOUNDSVILLE, WV",
            disabled: false,
          },
          {
            name: "2853, ADUSA, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "2853, Albertsons, BRANDYWINE, MD",
            disabled: false,
          },
          {
            name: "2853, CVS, GALLOWAY, NJ",
            disabled: false,
          },
          {
            name: "2853, Target, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "2853, Walmart, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "2854, CVS, BRIDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "2854, Walmart, LISBON, CT",
            disabled: false,
          },
          {
            name: "2855, Albertsons, NORTH CAPE MAY, NJ",
            disabled: false,
          },
          {
            name: "2855, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "2855, Walmart, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "2856, ADUSA, LINCOLNTON, NC",
            disabled: false,
          },
          {
            name: "2856, Albertsons, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "2856, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "2856, Walmart, OAK GROVE, MO",
            disabled: false,
          },
          {
            name: "2857, Target, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "2857, Walmart, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "2858, Albertsons, PASADENA, CA",
            disabled: false,
          },
          {
            name: "2858, Walgreens, MIDDLETOWN, CT",
            disabled: false,
          },
          {
            name: "2858, Walmart, STATESBORO, GA",
            disabled: false,
          },
          {
            name: "2859, Albertsons, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "2859, Walmart, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "286, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "286, Kroger, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "286, Meijer, DETROIT, MI",
            disabled: false,
          },
          {
            name: "286, Target, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "286, Walmart, ENNIS, TX",
            disabled: false,
          },
          {
            name: "2860, CVS, ELMHURST, IL",
            disabled: false,
          },
          {
            name: "2860, Target, LAKE BLUFF, IL",
            disabled: false,
          },
          {
            name: "2860, Walmart, POOLER, GA",
            disabled: false,
          },
          {
            name: "2861, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "2861, Walgreens, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "2861, Walmart, GARDEN CITY, ID",
            disabled: false,
          },
          {
            name: "2862, Albertsons, ELKTON, MD",
            disabled: false,
          },
          {
            name: "2862, Walmart, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "2863, CVS, ROLLING MEADOWS, IL",
            disabled: false,
          },
          {
            name: "2864, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2865, Target, SPRING, TX",
            disabled: false,
          },
          {
            name: "2865, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "2865, Walmart, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "2866, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "2866, Walmart, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "2867, CVS, FOLSOM, PA",
            disabled: false,
          },
          {
            name: "2867, Target, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "2867, Walgreens, SEASIDE, CA",
            disabled: false,
          },
          {
            name: "2867, Walmart, LANSING, MI",
            disabled: false,
          },
          {
            name: "2868, CVS, NEPTUNE, NJ",
            disabled: false,
          },
          {
            name: "2868, Target, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "2869, Target, Rialto, CA",
            disabled: false,
          },
          {
            name: "2869, Walmart, LANSING, MI",
            disabled: false,
          },
          {
            name: "287, CVS, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "287, Kroger, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "287, Meijer, Evansville, IN",
            disabled: false,
          },
          {
            name: "287, Walmart, JASPER, AL",
            disabled: false,
          },
          {
            name: "2870, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "2870, CVS, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "2870, Target, Honolulu, HI",
            disabled: false,
          },
          {
            name: "2870, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "2871, Target, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "2871, Walmart, CINNAMINSON, NJ",
            disabled: false,
          },
          {
            name: "2872, Target, GOLETA, CA",
            disabled: false,
          },
          {
            name: "2872, Walmart, VAN BUREN TWP, MI",
            disabled: false,
          },
          {
            name: "2873, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "2873, Target, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "2873, Walmart, TROY, MI",
            disabled: false,
          },
          {
            name: "2874, Albertsons, HERCULES, CA",
            disabled: false,
          },
          {
            name: "2874, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "2874, Walmart, GLENVILLE, NY",
            disabled: false,
          },
          {
            name: "2875, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2875, Target, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "2875, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "2875, Walmart, WARR ACRES, OK",
            disabled: false,
          },
          {
            name: "2876, Albertsons, MEDIA, PA",
            disabled: false,
          },
          {
            name: "2876, CVS, PROSPER, TX",
            disabled: false,
          },
          {
            name: "2876, Walgreens, MOUNT VERNON, IL",
            disabled: false,
          },
          {
            name: "2876, Walmart, EDMOND, OK",
            disabled: false,
          },
          {
            name: "2877, CVS, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "2877, Target, GLENDALE, WI",
            disabled: false,
          },
          {
            name: "2877, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2877, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "2878, Albertsons, MILLBRAE, CA",
            disabled: false,
          },
          {
            name: "2878, CVS, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "2878, Target, SOMERS POINT, NJ",
            disabled: false,
          },
          {
            name: "2878, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "2879, CVS, SOUDERTON, PA",
            disabled: false,
          },
          {
            name: "2879, Target, Yonkers, NY",
            disabled: false,
          },
          {
            name: "2879, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "288, Albertsons, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "288, CVS, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "288, HEB, ALVIN, TX",
            disabled: false,
          },
          {
            name: "288, Kroger, LAKE FOREST, CA",
            disabled: false,
          },
          {
            name: "288, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "288, Meijer, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "288, Target, WOODLAND HILLS, CA",
            disabled: false,
          },
          {
            name: "288, Walmart, WOODVILLE, TX",
            disabled: false,
          },
          {
            name: "2880, CVS, CROYDON, PA",
            disabled: false,
          },
          {
            name: "2880, Target, Auburn, ME",
            disabled: false,
          },
          {
            name: "2880, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "2881, CVS, CHICO, CA",
            disabled: false,
          },
          {
            name: "2881, Target, Kearny, NJ",
            disabled: false,
          },
          {
            name: "2881, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "2882, Target, Katy, TX",
            disabled: false,
          },
          {
            name: "2882, Walmart, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "2883, Albertsons, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "2883, CVS, SEVERN, MD",
            disabled: false,
          },
          {
            name: "2883, Target, New Hyde Park, NY",
            disabled: false,
          },
          {
            name: "2883, Walgreens, WALDWICK, NJ",
            disabled: false,
          },
          {
            name: "2883, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "2884, Target, Prosper, TX",
            disabled: false,
          },
          {
            name: "2884, Walgreens, ELIZABETH, NJ",
            disabled: false,
          },
          {
            name: "2884, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2885, Walmart, NEWPORT, RI",
            disabled: false,
          },
          {
            name: "2886, Target, Lebanon, PA",
            disabled: false,
          },
          {
            name: "2886, Walmart, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "2887, Albertsons, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "2887, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2887, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "2888, Target, Kaneohe, HI",
            disabled: false,
          },
          {
            name: "2888, Walmart, PALMYRA, PA",
            disabled: false,
          },
          {
            name: "2889, Target, New Caney, TX",
            disabled: false,
          },
          {
            name: "2889, Walgreens, MARLBOROUGH, MA",
            disabled: false,
          },
          {
            name: "2889, Walmart, CLINTON, IA",
            disabled: false,
          },
          {
            name: "289, ADUSA, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "289, CVS, TEANECK, NJ",
            disabled: false,
          },
          {
            name: "289, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "289, Meijer, ROUND LAKE BEACH, IL",
            disabled: false,
          },
          {
            name: "289, Target, CERRITOS, CA",
            disabled: false,
          },
          {
            name: "289, Walmart, MCGEHEE, AR",
            disabled: false,
          },
          {
            name: "2890, Target, Jamestown, NY",
            disabled: false,
          },
          {
            name: "2890, Walmart, MACON, GA",
            disabled: false,
          },
          {
            name: "2891, Target, Grass Valley, CA",
            disabled: false,
          },
          {
            name: "2891, Walmart, ODESSA, TX",
            disabled: false,
          },
          {
            name: "2892, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2892, Target, Sylmar, CA",
            disabled: false,
          },
          {
            name: "2892, Walmart, PARKER, CO",
            disabled: false,
          },
          {
            name: "2893, Albertsons, HILO, HI",
            disabled: false,
          },
          {
            name: "2893, Target, Old Bridge, NJ",
            disabled: false,
          },
          {
            name: "2893, Walmart, INDEPENDENCE, KS",
            disabled: false,
          },
          {
            name: "2894, Albertsons, LIHUE, HI",
            disabled: false,
          },
          {
            name: "2894, Walmart, OAKLAND, MD",
            disabled: false,
          },
          {
            name: "2895, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "2896, CVS, MIDDLETOWN, CT",
            disabled: false,
          },
          {
            name: "2896, Target, Quincy, IL",
            disabled: false,
          },
          {
            name: "2896, Walgreens, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "2897, Albertsons, EWA BEACH, HI",
            disabled: false,
          },
          {
            name: "2897, Target, Hurricane, WV",
            disabled: false,
          },
          {
            name: "2897, Walmart, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "2898, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2898, Target, Spanish Fork, UT",
            disabled: false,
          },
          {
            name: "2898, Walmart, OLD SAYBROOK, CT",
            disabled: false,
          },
          {
            name: "2899, Walmart, AVON, CT",
            disabled: false,
          },
          {
            name: "29, ADUSA, WEST MIFFLIN, PA",
            disabled: false,
          },
          {
            name: "29, BJ's, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "29, Costco, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "29, HEB, WEST LAKE HILLS, TX",
            disabled: false,
          },
          {
            name: "29, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "29, Kroger, EL DORADO, KS",
            disabled: false,
          },
          {
            name: "29, Kroger, Reseda, CA",
            disabled: false,
          },
          {
            name: "29, Meijer, BURTON, MI",
            disabled: false,
          },
          {
            name: "29, Walmart, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "290, Albertsons, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "290, Kroger, Champaign, IL",
            disabled: false,
          },
          {
            name: "290, Meijer, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "290, Rite Aid, SHILLINGTON, PA",
            disabled: false,
          },
          {
            name: "290, Target, GARDENA, CA",
            disabled: false,
          },
          {
            name: "290, Walmart, GONZALES, TX",
            disabled: false,
          },
          {
            name: "2900, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2900, CVS, THIRD LAKE, IL",
            disabled: false,
          },
          {
            name: "2900, Walgreens, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "2900, Walmart, ROCKY HILL, CT",
            disabled: false,
          },
          {
            name: "2901, CVS, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "2901, Walgreens, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "2901, Walmart, NORTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "2902, Albertsons, GALLUP, NM",
            disabled: false,
          },
          {
            name: "2902, Target, Danbury, CT",
            disabled: false,
          },
          {
            name: "2902, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "2902, Walmart, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "2903, CVS, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "2903, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2903, Walmart, CHELMSFORD, MA",
            disabled: false,
          },
          {
            name: "2904, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "2904, Target, Provo, UT",
            disabled: false,
          },
          {
            name: "2904, Walmart, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "2905, Walgreens, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "2905, Walmart, SUFFERN, NY",
            disabled: false,
          },
          {
            name: "2906, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "2906, Walmart, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "2907, Walmart, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "2908, Albertsons, EUREKA, CA",
            disabled: false,
          },
          {
            name: "2908, CVS, MONROE, NY",
            disabled: false,
          },
          {
            name: "2908, Walmart, BISCOE, NC",
            disabled: false,
          },
          {
            name: "2909, Walgreens, NEW SMYRNA BEACH, FL",
            disabled: false,
          },
          {
            name: "2909, Walmart, CORRY, PA",
            disabled: false,
          },
          {
            name: "291, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "291, CVS, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "291, HEB, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "291, Kroger, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "291, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "291, Kroger, Olney, IL",
            disabled: false,
          },
          {
            name: "291, Meijer, STURGIS, MI",
            disabled: false,
          },
          {
            name: "291, Target, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "2910, Albertsons, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "2910, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2910, Walmart, SALEM, OH",
            disabled: false,
          },
          {
            name: "2911, Albertsons, BOULDER, CO",
            disabled: false,
          },
          {
            name: "2911, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2911, Walmart, CENTRAL SQUARE, NY",
            disabled: false,
          },
          {
            name: "2912, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "2912, Walmart, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "2913, Albertsons, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "2913, Walmart, BOUTTE, LA",
            disabled: false,
          },
          {
            name: "2914, Albertsons, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "2914, Walmart, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "2915, Albertsons, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "2915, Walmart, EAST SETAUKET, NY",
            disabled: false,
          },
          {
            name: "2916, Albertsons, MILLTOWN, NJ",
            disabled: false,
          },
          {
            name: "2916, Walmart, EAST MEADOW, NY",
            disabled: false,
          },
          {
            name: "2917, Albertsons, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "2917, Walmart, ISLANDIA, NY",
            disabled: false,
          },
          {
            name: "2918, Albertsons, GREELEY, CO",
            disabled: false,
          },
          {
            name: "2918, Walmart, ALLEN, TX",
            disabled: false,
          },
          {
            name: "2919, Albertsons, BOULDER, CO",
            disabled: false,
          },
          {
            name: "2919, Walmart, MONROE, LA",
            disabled: false,
          },
          {
            name: "292, Albertsons, LITTLE SILVER, NJ",
            disabled: false,
          },
          {
            name: "292, HEB, BAY CITY, TX",
            disabled: false,
          },
          {
            name: "292, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "292, Kroger, Robinson, IL",
            disabled: false,
          },
          {
            name: "292, Kroger, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "292, Meijer, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "292, Walmart, LOCKHART, TX",
            disabled: false,
          },
          {
            name: "2920, Walgreens, SULPHUR, LA",
            disabled: false,
          },
          {
            name: "2920, Walmart, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "2921, Walgreens, APPLETON, WI",
            disabled: false,
          },
          {
            name: "2921, Walmart, HARRISVILLE, UT",
            disabled: false,
          },
          {
            name: "2922, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "2922, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2923, Walmart, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "2924, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "2924, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "2925, Albertsons, CLAYTON, NJ",
            disabled: false,
          },
          {
            name: "2925, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2925, Walmart, NAPA, CA",
            disabled: false,
          },
          {
            name: "2926, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "2927, Albertsons, RANDOLPH, NJ",
            disabled: false,
          },
          {
            name: "2927, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "2927, Walmart, WOOD VILLAGE, OR",
            disabled: false,
          },
          {
            name: "2928, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2928, Walmart, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "2929, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2929, Walmart, HOPE MILLS, NC",
            disabled: false,
          },
          {
            name: "293, Albertsons, OCEAN CITY, MD",
            disabled: false,
          },
          {
            name: "293, Costco, MONROE TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "293, Kroger, Cartersville, GA",
            disabled: false,
          },
          {
            name: "293, Kroger, WEST HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "293, Meijer, SAULT SAINTE MARIE, MI",
            disabled: false,
          },
          {
            name: "293, Rite Aid, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "293, ShopRite, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "293, Target, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "293, Walmart, NAVASOTA, TX",
            disabled: false,
          },
          {
            name: "2930, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2930, Walmart, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "2931, Albertsons, AUDUBON, NJ",
            disabled: false,
          },
          {
            name: "2931, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "2931, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "2931, Walmart, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "2932, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "2932, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "2932, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "2933, CVS, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "2933, Walmart, PRINCETON, WV",
            disabled: false,
          },
          {
            name: "2934, Walmart, PARIS, IL",
            disabled: false,
          },
          {
            name: "2935, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2935, Walgreens, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "2935, Walmart, KNOXVILLE, IA",
            disabled: false,
          },
          {
            name: "2936, CVS, JOLIET, IL",
            disabled: false,
          },
          {
            name: "2936, Walmart, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "2937, Walmart, HIBBING, MN",
            disabled: false,
          },
          {
            name: "2938, Walmart, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "2939, Walgreens, SAN BRUNO, CA",
            disabled: false,
          },
          {
            name: "2939, Walmart, RICHLAND, MS",
            disabled: false,
          },
          {
            name: "294, Albertsons, VENTNOR CITY, NJ",
            disabled: false,
          },
          {
            name: "294, CVS, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "294, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "294, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "294, Kroger, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "294, Kroger, MARTINEZ, GA",
            disabled: false,
          },
          {
            name: "294, Meijer, ESCANABA, MI",
            disabled: false,
          },
          {
            name: "294, ShopRite, SPRINGFIELD, NJ",
            disabled: false,
          },
          {
            name: "294, Target, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "294, Walmart, CENTRAL CITY, KY",
            disabled: false,
          },
          {
            name: "2940, Albertsons, EL CERRITO, CA",
            disabled: false,
          },
          {
            name: "2940, Walmart, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "2941, Albertsons, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "2941, CVS, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "2941, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "2941, Walmart, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "2942, Walgreens, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "2943, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2944, Albertsons, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "2944, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "2944, Walmart, DELAND, FL",
            disabled: false,
          },
          {
            name: "2945, CVS, MILTON, GA",
            disabled: false,
          },
          {
            name: "2945, Walgreens, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "2945, Walmart, PARKESBURG, PA",
            disabled: false,
          },
          {
            name: "2946, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "2946, Walmart, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "2947, Walmart, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "2948, Albertsons, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "2948, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "2948, Walmart, SANTA FE SPRINGS, CA",
            disabled: false,
          },
          {
            name: "2949, CVS, EAST HANOVER, NJ",
            disabled: false,
          },
          {
            name: "295, Albertsons, ORTLEY BEACH, NJ",
            disabled: false,
          },
          {
            name: "295, CVS, FAIRLESS HILLS, PA",
            disabled: false,
          },
          {
            name: "295, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "295, Kroger, Cape Girardeau, MO",
            disabled: false,
          },
          {
            name: "295, Kroger, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "295, Meijer, FRANKLIN, IN",
            disabled: false,
          },
          {
            name: "295, Walmart, EUREKA, MO",
            disabled: false,
          },
          {
            name: "2950, CVS, NEW MILFORD, NJ",
            disabled: false,
          },
          {
            name: "2950, Walmart, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "2951, Albertsons, YUMA, AZ",
            disabled: false,
          },
          {
            name: "2951, CVS, CHESTER SPRINGS, PA",
            disabled: false,
          },
          {
            name: "2951, Walmart, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "2952, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2952, Walmart, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "2953, Walmart, SWANSEA, MA",
            disabled: false,
          },
          {
            name: "2954, Albertsons, BONNERS FERRY, ID",
            disabled: false,
          },
          {
            name: "2954, Walgreens, LAKE JACKSON, TX",
            disabled: false,
          },
          {
            name: "2954, Walmart, NORWALK, CT",
            disabled: false,
          },
          {
            name: "2955, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "2955, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2955, Walmart, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "2956, Albertsons, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "2956, CVS, NEW MARKET, MD",
            disabled: false,
          },
          {
            name: "2956, Walgreens, BEECH GROVE, IN",
            disabled: false,
          },
          {
            name: "2956, Walmart, SHOREWOOD, IL",
            disabled: false,
          },
          {
            name: "2957, CVS, EAST RUTHERFORD, NJ",
            disabled: false,
          },
          {
            name: "2957, Walgreens, CAMPBELL, CA",
            disabled: false,
          },
          {
            name: "2957, Walmart, DETROIT LAKES, MN",
            disabled: false,
          },
          {
            name: "2958, Walgreens, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "2958, Walmart, APPLETON, WI",
            disabled: false,
          },
          {
            name: "2959, CVS, DANVERS, MA",
            disabled: false,
          },
          {
            name: "2959, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2959, Walmart, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "296, Albertsons, MC KINNEY, TX",
            disabled: false,
          },
          {
            name: "296, Albertsons, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "296, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "296, Costco, SUMNER, WA",
            disabled: false,
          },
          {
            name: "296, Kroger, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "296, Kroger, Sikeston, MO",
            disabled: false,
          },
          {
            name: "296, Meijer, MCCORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "296, ShopRite, WEST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "296, Target, POWAY, CA",
            disabled: false,
          },
          {
            name: "296, Walmart, DARDANELLE, AR",
            disabled: false,
          },
          {
            name: "2960, CVS, PORT JEFFERSON, NY",
            disabled: false,
          },
          {
            name: "2961, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2961, CVS, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "2961, Walgreens, LODI, CA",
            disabled: false,
          },
          {
            name: "2962, Walmart, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "2963, Albertsons, FRISCO, TX",
            disabled: false,
          },
          {
            name: "2963, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2963, Walgreens, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "2963, Walmart, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "2964, Albertsons, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "2964, CVS, MAINEVILLE, OH",
            disabled: false,
          },
          {
            name: "2964, Walmart, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "2965, CVS, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "2965, Walmart, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "2966, CVS, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "2966, Walmart, WADSWORTH, OH",
            disabled: false,
          },
          {
            name: "2967, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "2967, Walmart, FT WRIGHT, KY",
            disabled: false,
          },
          {
            name: "2968, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "2968, CVS, SPARTA, NJ",
            disabled: false,
          },
          {
            name: "2968, Walgreens, LODI, NJ",
            disabled: false,
          },
          {
            name: "2968, Walmart, CARROLLTON, KY",
            disabled: false,
          },
          {
            name: "2969, CVS, WOMELSDORF, PA",
            disabled: false,
          },
          {
            name: "297, Meijer, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "297, ShopRite, LINCOLN PARK, NJ",
            disabled: false,
          },
          {
            name: "297, Walmart, PORTER, TX",
            disabled: false,
          },
          {
            name: "2970, CVS, LANOKA HARBOR, NJ",
            disabled: false,
          },
          {
            name: "2971, Walgreens, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "2973, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "2973, Walmart, MURPHY, TX",
            disabled: false,
          },
          {
            name: "2974, Albertsons, WESTMONT, NJ",
            disabled: false,
          },
          {
            name: "2974, Walmart, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "2975, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "2975, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "2976, CVS, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "2976, Walgreens, NORWICH, CT",
            disabled: false,
          },
          {
            name: "2976, Walmart, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "2977, Albertsons, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "2977, CVS, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "2977, Walgreens, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "2977, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "2978, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2979, Albertsons, TOWSON, MD",
            disabled: false,
          },
          {
            name: "2979, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2979, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "298, CVS, UPPER MONTCLAIR, NJ",
            disabled: false,
          },
          {
            name: "298, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "298, Kroger, Oceanside, CA",
            disabled: false,
          },
          {
            name: "298, Meijer, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "298, Target, VENTURA, CA",
            disabled: false,
          },
          {
            name: "298, Walmart, BOAZ, AL",
            disabled: false,
          },
          {
            name: "2980, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "2980, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2980, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2981, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "2981, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2981, Walmart, KELLER, TX",
            disabled: false,
          },
          {
            name: "2982, Albertsons, MOUNT HOLLY, NJ",
            disabled: false,
          },
          {
            name: "2982, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "2982, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2984, Walmart, LAWTON, OK",
            disabled: false,
          },
          {
            name: "2985, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "2985, Walgreens, GRAYSLAKE, IL",
            disabled: false,
          },
          {
            name: "2985, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "2986, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "2986, Walgreens, ELGIN, IL",
            disabled: false,
          },
          {
            name: "2986, Walmart, NEENAH, WI",
            disabled: false,
          },
          {
            name: "2987, Albertsons, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "2987, CVS, LINCOLN PARK, NJ",
            disabled: false,
          },
          {
            name: "2987, Walmart, DAVIE, FL",
            disabled: false,
          },
          {
            name: "2988, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "2988, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "2988, Walmart, LA FAYETTE, GA",
            disabled: false,
          },
          {
            name: "2989, Albertsons, SHERMAN OAKS, CA",
            disabled: false,
          },
          {
            name: "2989, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2989, Walmart, FREMONT, CA",
            disabled: false,
          },
          {
            name: "299, ADUSA, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "299, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "299, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "299, Kroger, Columbus, OH",
            disabled: false,
          },
          {
            name: "299, Kroger, IRVINE, CA",
            disabled: false,
          },
          {
            name: "299, Meijer, WEST BEND, WI",
            disabled: false,
          },
          {
            name: "299, Target, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "299, Walmart, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "2990, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2990, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "2990, Walmart, MITCHELL, SD",
            disabled: false,
          },
          {
            name: "2991, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "2991, Walmart, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "2992, Walmart, PAINTED POST, NY",
            disabled: false,
          },
          {
            name: "2993, Albertsons, OREGON CITY, OR",
            disabled: false,
          },
          {
            name: "2993, Walmart, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "2994, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "2994, CVS, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "2994, Walgreens, JENNINGS, MO",
            disabled: false,
          },
          {
            name: "2994, Walmart, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "2995, Albertsons, PENNSVILLE, NJ",
            disabled: false,
          },
          {
            name: "2995, CVS, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "2995, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2995, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "2996, CVS, LUMBERTON, TX",
            disabled: false,
          },
          {
            name: "2996, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "2996, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "2997, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "2997, Walgreens, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "2998, Albertsons, RUNNEMEDE, NJ",
            disabled: false,
          },
          {
            name: "2998, Walmart, LOMA LINDA, CA",
            disabled: false,
          },
          {
            name: "2999, Albertsons, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "3, ADUSA, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "3, CVS, TABERNACLE, NJ",
            disabled: false,
          },
          {
            name: "3, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "3, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "3, Kroger, Great Bend, KS",
            disabled: false,
          },
          {
            name: "3, Target, CRYSTAL, MN",
            disabled: false,
          },
          {
            name: "3, Walmart, COMMERCE, GA",
            disabled: false,
          },
          {
            name: "30, ADUSA, ALBEMARLE, NC",
            disabled: false,
          },
          {
            name: "30, ADUSA, HOLYOKE, MA",
            disabled: false,
          },
          {
            name: "30, BJ's, DANVERS, MA",
            disabled: false,
          },
          {
            name: "30, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "30, Kroger, BROOKINGS, OR",
            disabled: false,
          },
          {
            name: "30, Kroger, OGDEN, UT",
            disabled: false,
          },
          {
            name: "30, Meijer, JACKSON, MI",
            disabled: false,
          },
          {
            name: "30, Walmart, DEXTER, MO",
            disabled: false,
          },
          {
            name: "300, ADUSA, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "300, Albertsons, SCOTTS VALLEY, CA",
            disabled: false,
          },
          {
            name: "300, CVS, ARDSLEY, NY",
            disabled: false,
          },
          {
            name: "300, Kroger, Bellevue, NE",
            disabled: false,
          },
          {
            name: "300, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "300, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "300, Kroger, Lynchburg, VA",
            disabled: false,
          },
          {
            name: "300, Kroger, North Charleston, SC",
            disabled: false,
          },
          {
            name: "300, Kroger, VISTA, CA",
            disabled: false,
          },
          {
            name: "300, Meijer, APPLETON, WI",
            disabled: false,
          },
          {
            name: "300, Target, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "300, Walmart, JACKSONVILLE, AL",
            disabled: false,
          },
          {
            name: "3000, CVS, CHIEFLAND, FL",
            disabled: false,
          },
          {
            name: "3000, Walgreens, MIDDLETOWN, RI",
            disabled: false,
          },
          {
            name: "3001, Walgreens, LA PORTE, TX",
            disabled: false,
          },
          {
            name: "3003, Albertsons, CLARENDON HILLS, IL",
            disabled: false,
          },
          {
            name: "3003, CVS, MARY ESTHER, FL",
            disabled: false,
          },
          {
            name: "3003, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3004, Albertsons, HELENA, MT",
            disabled: false,
          },
          {
            name: "3004, CVS, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "3004, Target, Woodbury, MN",
            disabled: false,
          },
          {
            name: "3004, Walmart, CICERO, IL",
            disabled: false,
          },
          {
            name: "3005, Albertsons, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "3005, Target, Tucson, AZ",
            disabled: false,
          },
          {
            name: "3006, Albertsons, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "3006, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3007, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3007, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3008, Albertsons, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "3008, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "3008, Walmart, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "3009, Walgreens, OTTAWA, IL",
            disabled: false,
          },
          {
            name: "301, ADUSA, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "301, Albertsons, WASHINGTON, UT",
            disabled: false,
          },
          {
            name: "301, BJ's, MASSENA, NY",
            disabled: false,
          },
          {
            name: "301, CVS, STONEHAM, MA",
            disabled: false,
          },
          {
            name: "301, Costco, DANVERS, MA",
            disabled: false,
          },
          {
            name: "301, Kroger, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "301, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "301, Kroger, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "301, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "301, Kroger, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "301, Meijer, BRADLEY, IL",
            disabled: false,
          },
          {
            name: "301, Target, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "301, Walmart, GADSDEN, AL",
            disabled: false,
          },
          {
            name: "3010, Albertsons, CASTRO VALLEY, CA",
            disabled: false,
          },
          {
            name: "3010, CVS, SETAUKET, NY",
            disabled: false,
          },
          {
            name: "3011, Albertsons, PETALUMA, CA",
            disabled: false,
          },
          {
            name: "3011, CVS, BLUE BELL, PA",
            disabled: false,
          },
          {
            name: "3011, Rite Aid, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "3011, Walmart, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "3012, Target, York, PA",
            disabled: false,
          },
          {
            name: "3012, Walgreens, GRANDVILLE, MI",
            disabled: false,
          },
          {
            name: "3013, Albertsons, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "3013, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "3013, Target, Albany, OR",
            disabled: false,
          },
          {
            name: "3013, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3013, Walmart, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "3014, Target, Midlothian, TX",
            disabled: false,
          },
          {
            name: "3014, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "3014, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3015, CVS, WEST BABYLON, NY",
            disabled: false,
          },
          {
            name: "3015, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3016, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3016, CVS, PARIS, KY",
            disabled: false,
          },
          {
            name: "3016, Rite Aid, WARREN, OH",
            disabled: false,
          },
          {
            name: "3016, Walgreens, ROXBURY, MA",
            disabled: false,
          },
          {
            name: "3017, Albertsons, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "3017, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "3017, Walgreens, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "3017, Walmart, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "3018, CVS, MANASSAS PARK, VA",
            disabled: false,
          },
          {
            name: "3018, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3018, Walmart, FOUNTAIN, CO",
            disabled: false,
          },
          {
            name: "3019, Walmart, THORNTON, CO",
            disabled: false,
          },
          {
            name: "302, CVS, WHITINSVILLE, MA",
            disabled: false,
          },
          {
            name: "302, Costco, WEST SPRINGFIEL, MA",
            disabled: false,
          },
          {
            name: "302, Kroger, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "302, Kroger, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "302, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "302, Meijer, MARQUETTE, MI",
            disabled: false,
          },
          {
            name: "302, Target, DUARTE, CA",
            disabled: false,
          },
          {
            name: "302, Walmart, MURPHYSBORO, IL",
            disabled: false,
          },
          {
            name: "3020, Walgreens, ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "3021, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3021, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "3022, CVS, GALT, CA",
            disabled: false,
          },
          {
            name: "3022, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "3022, Walmart, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "3023, Walmart, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3024, CVS, DUBLIN, CA",
            disabled: false,
          },
          {
            name: "3024, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3025, CVS, ALPINE, CA",
            disabled: false,
          },
          {
            name: "3025, Walgreens, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "3026, Albertsons, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "3026, Target, Madison, AL",
            disabled: false,
          },
          {
            name: "3026, Walmart, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "3027, Target, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "3028, Rite Aid, WOOSTER, OH",
            disabled: false,
          },
          {
            name: "303, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "303, BJ's, ONEONTA, NY",
            disabled: false,
          },
          {
            name: "303, Costco, AVON, MA",
            disabled: false,
          },
          {
            name: "303, Kroger, DECATUR, GA",
            disabled: false,
          },
          {
            name: "303, Kroger, RIALTO, CA",
            disabled: false,
          },
          {
            name: "303, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "303, Meijer, IONIA, MI",
            disabled: false,
          },
          {
            name: "303, Target, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "303, Walmart, HOLLY SPRINGS, MS",
            disabled: false,
          },
          {
            name: "3030, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3030, Walgreens, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "3031, Albertsons, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "3031, CVS, BRIDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "3031, Rite Aid, VANDALIA, OH",
            disabled: false,
          },
          {
            name: "3032, CVS, RICHMOND HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3032, Rite Aid, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "3033, Rite Aid, JAMESTOWN, NY",
            disabled: false,
          },
          {
            name: "3034, CVS, SANGER, CA",
            disabled: false,
          },
          {
            name: "3035, CVS, BEREA, OH",
            disabled: false,
          },
          {
            name: "3035, Walmart, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "3037, Target, Logan Township, NJ",
            disabled: false,
          },
          {
            name: "3037, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3038, CVS, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "3038, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3039, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "304, ADUSA, WALDORF, MD",
            disabled: false,
          },
          {
            name: "304, Albertsons, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "304, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "304, Costco, BROOKFIELD, CT",
            disabled: false,
          },
          {
            name: "304, Kroger, Corona, CA",
            disabled: false,
          },
          {
            name: "304, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "304, Target, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "304, Walmart, SPRINGFIELD, TN",
            disabled: false,
          },
          {
            name: "3040, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "3041, CVS, AKRON, OH",
            disabled: false,
          },
          {
            name: "3041, Rite Aid, BEACHWOOD, OH",
            disabled: false,
          },
          {
            name: "3042, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3042, CVS, BEAR, DE",
            disabled: false,
          },
          {
            name: "3042, Walmart, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "3043, CVS, ARNOLD, MD",
            disabled: false,
          },
          {
            name: "3043, Rite Aid, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3043, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3044, Albertsons, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "3044, CVS, HUBBARD, OH",
            disabled: false,
          },
          {
            name: "3044, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3045, CVS, SEVERNA PARK, MD",
            disabled: false,
          },
          {
            name: "3046, Walgreens, LARGO, FL",
            disabled: false,
          },
          {
            name: "3046, Walmart, MODESTO, CA",
            disabled: false,
          },
          {
            name: "3047, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3047, Walmart, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "3048, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "3048, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "3049, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3049, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "305, Albertsons, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "305, CVS, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "305, Costco, NANUET, NY",
            disabled: false,
          },
          {
            name: "305, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "305, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "305, Kroger, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "305, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "305, Walmart, CARTHAGE, MS",
            disabled: false,
          },
          {
            name: "3050, CVS, MARINA, CA",
            disabled: false,
          },
          {
            name: "3050, Walmart, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "3051, Albertsons, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "3051, CVS, SALINAS, CA",
            disabled: false,
          },
          {
            name: "3051, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3052, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "3053, Albertsons, PALOS HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3053, CVS, EL CERRITO, CA",
            disabled: false,
          },
          {
            name: "3053, Rite Aid, PARMA, OH",
            disabled: false,
          },
          {
            name: "3053, Walmart, EVERETT, WA",
            disabled: false,
          },
          {
            name: "3054, CVS, MANKATO, MN",
            disabled: false,
          },
          {
            name: "3055, CVS, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "3055, Walgreens, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "3055, Walmart, CATOOSA, OK",
            disabled: false,
          },
          {
            name: "3056, Walgreens, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "3056, Walmart, SPRING BRANCH, TX",
            disabled: false,
          },
          {
            name: "3057, CVS, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "3057, Rite Aid, THE PLAINS, OH",
            disabled: false,
          },
          {
            name: "3057, Walmart, HELOTES, TX",
            disabled: false,
          },
          {
            name: "3058, Albertsons, YUCCA VALLEY, CA",
            disabled: false,
          },
          {
            name: "3058, CVS, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "3058, Rite Aid, FREMONT, OH",
            disabled: false,
          },
          {
            name: "3058, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3059, CVS, PUKALANI, HI",
            disabled: false,
          },
          {
            name: "3059, Walmart, CANTON, MS",
            disabled: false,
          },
          {
            name: "306, BJ's, MIDDLETOWN, RI",
            disabled: false,
          },
          {
            name: "306, CVS, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "306, Costco, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "306, Kroger, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "306, Kroger, North Las Vegas, NV",
            disabled: false,
          },
          {
            name: "306, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "306, Meijer, WARREN, MI",
            disabled: false,
          },
          {
            name: "306, Walmart, ARAB, AL",
            disabled: false,
          },
          {
            name: "3060, CVS, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "3060, Rite Aid, EAST LIVERPOOL, OH",
            disabled: false,
          },
          {
            name: "3060, Walmart, YAZOO CITY, MS",
            disabled: false,
          },
          {
            name: "3061, Albertsons, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "3061, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3061, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "3061, Walmart, SHREWSBURY, MO",
            disabled: false,
          },
          {
            name: "3062, CVS, EFFORT, PA",
            disabled: false,
          },
          {
            name: "3062, Walgreens, CANTON, MA",
            disabled: false,
          },
          {
            name: "3062, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3063, CVS, PETERBOROUGH, NH",
            disabled: false,
          },
          {
            name: "3064, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3064, Walgreens, SUPERIOR, WI",
            disabled: false,
          },
          {
            name: "3065, Albertsons, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "3065, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3066, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3066, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "3066, Walmart, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3067, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3067, CVS, BRIARCLIFF MANOR, NY",
            disabled: false,
          },
          {
            name: "3067, Walmart, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "3068, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3069, Albertsons, YORBA LINDA, CA",
            disabled: false,
          },
          {
            name: "3069, CVS, NEWBURY PARK, CA",
            disabled: false,
          },
          {
            name: "3069, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "3069, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "307, Albertsons, WALLA WALLA, WA",
            disabled: false,
          },
          {
            name: "307, BJ's, GREENFIELD, MA",
            disabled: false,
          },
          {
            name: "307, CVS, LEXINGTON, MA",
            disabled: false,
          },
          {
            name: "307, Costco, NASHUA, NH",
            disabled: false,
          },
          {
            name: "307, Kroger, Augusta, GA",
            disabled: false,
          },
          {
            name: "307, Kroger, BELL GARDENS, CA",
            disabled: false,
          },
          {
            name: "307, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "307, Target, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "307, Walmart, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "3070, CVS, HALEIWA, HI",
            disabled: false,
          },
          {
            name: "3070, Walmart, DUNWOODY, GA",
            disabled: false,
          },
          {
            name: "3071, Walmart, TUCKER, GA",
            disabled: false,
          },
          {
            name: "3072, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3072, Walmart, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "3073, Albertsons, NORMAL, IL",
            disabled: false,
          },
          {
            name: "3074, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3074, Walmart, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "3075, Albertsons, SOUTH PASADENA, CA",
            disabled: false,
          },
          {
            name: "3075, CVS, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "3075, Walmart, PANAMA CITY, FL",
            disabled: false,
          },
          {
            name: "3076, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "3076, Walgreens, RIVER FOREST, IL",
            disabled: false,
          },
          {
            name: "3077, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "3077, Walmart, HAYMARKET, VA",
            disabled: false,
          },
          {
            name: "3078, CVS, RICHMOND, CA",
            disabled: false,
          },
          {
            name: "3078, Walgreens, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "3078, Walmart, EAST BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "3079, CVS, RIVERBANK, CA",
            disabled: false,
          },
          {
            name: "3079, Walgreens, WEST MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "308, ADUSA, EDGEWATER, MD",
            disabled: false,
          },
          {
            name: "308, ADUSA, GATE CITY, VA",
            disabled: false,
          },
          {
            name: "308, Albertsons, HALF MOON BAY, CA",
            disabled: false,
          },
          {
            name: "308, BJ's, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "308, Costco, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "308, Kroger, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "308, Kroger, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "308, Kroger, Waukesha, WI",
            disabled: false,
          },
          {
            name: "308, Walmart, MANCHESTER, TN",
            disabled: false,
          },
          {
            name: "3080, CVS, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3080, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "3081, Walgreens, ORANGE, TX",
            disabled: false,
          },
          {
            name: "3081, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "3082, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3082, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3082, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3083, Albertsons, BURBANK, CA",
            disabled: false,
          },
          {
            name: "3083, CVS, AKRON, OH",
            disabled: false,
          },
          {
            name: "3083, Walgreens, CONVERSE, TX",
            disabled: false,
          },
          {
            name: "3083, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3084, Albertsons, SHOREWOOD, IL",
            disabled: false,
          },
          {
            name: "3084, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3084, Walgreens, COTATI, CA",
            disabled: false,
          },
          {
            name: "3084, Walmart, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "3085, CVS, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "3085, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3086, Albertsons, HACIENDA HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "3086, CVS, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "3087, Albertsons, HUDSON, MA",
            disabled: false,
          },
          {
            name: "3087, CVS, CREVE COEUR, MO",
            disabled: false,
          },
          {
            name: "3087, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3087, Walmart, OXNARD, CA",
            disabled: false,
          },
          {
            name: "3088, Albertsons, SILVIS, IL",
            disabled: false,
          },
          {
            name: "3088, CVS, WADSWORTH, OH",
            disabled: false,
          },
          {
            name: "3088, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3088, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "3088, Walmart, ST CLOUD, MN",
            disabled: false,
          },
          {
            name: "309, Albertsons, FREMONT, CA",
            disabled: false,
          },
          {
            name: "309, BJ's, TILTON, NH",
            disabled: false,
          },
          {
            name: "309, CVS, DUNKIRK, NY",
            disabled: false,
          },
          {
            name: "309, Kroger, Arleta, CA",
            disabled: false,
          },
          {
            name: "309, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "309, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "309, Target, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "309, Walmart, ABBEVILLE, LA",
            disabled: false,
          },
          {
            name: "3090, CVS, MOGADORE, OH",
            disabled: false,
          },
          {
            name: "3090, Walmart, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "3091, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "3091, Rite Aid, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "3092, Albertsons, WAILUKU, HI",
            disabled: false,
          },
          {
            name: "3092, CVS, COPLEY, OH",
            disabled: false,
          },
          {
            name: "3092, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "3093, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "3093, Walmart, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "3094, CVS, NEWARK, OH",
            disabled: false,
          },
          {
            name: "3094, Walmart, BOISE, ID",
            disabled: false,
          },
          {
            name: "3095, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3095, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "3095, Rite Aid, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "3095, Target, Clark, NJ",
            disabled: false,
          },
          {
            name: "3095, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3096, Albertsons, MUNSTER, IN",
            disabled: false,
          },
          {
            name: "3097, Albertsons, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "3097, CVS, TEANECK, NJ",
            disabled: false,
          },
          {
            name: "3097, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3098, Albertsons, ALSIP, IL",
            disabled: false,
          },
          {
            name: "3098, CVS, GREENWOOD LAKE, NY",
            disabled: false,
          },
          {
            name: "3098, Walmart, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "3099, Albertsons, HEATH, TX",
            disabled: false,
          },
          {
            name: "3099, CVS, BAY SHORE, NY",
            disabled: false,
          },
          {
            name: "3099, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3099, Walmart, LA PALMA, CA",
            disabled: false,
          },
          {
            name: "31, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "31, BJ's, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "31, Costco, FRESNO, CA",
            disabled: false,
          },
          {
            name: "31, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "31, Kroger, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "31, Kroger, RENTON, WA",
            disabled: false,
          },
          {
            name: "31, Kroger, Sherman Oaks, CA",
            disabled: false,
          },
          {
            name: "31, Kroger, Wichita, KS",
            disabled: false,
          },
          {
            name: "31, Walmart, POTEAU, OK",
            disabled: false,
          },
          {
            name: "310, ADUSA, BOWIE, MD",
            disabled: false,
          },
          {
            name: "310, BJ's, AUBURN, ME",
            disabled: false,
          },
          {
            name: "310, Costco, LAWRENCE, NY",
            disabled: false,
          },
          {
            name: "310, Kroger, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "310, Kroger, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "310, Kroger, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "310, Kroger, LANETT, AL",
            disabled: false,
          },
          {
            name: "310, Target, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "310, Walmart, CROWLEY, LA",
            disabled: false,
          },
          {
            name: "3100, CVS, CORAM, NY",
            disabled: false,
          },
          {
            name: "3101, Walgreens, SAINT CLOUD, MN",
            disabled: false,
          },
          {
            name: "3101, Walmart, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "3102, CVS, WOODSTOCK, NY",
            disabled: false,
          },
          {
            name: "3102, Rite Aid, GALION, OH",
            disabled: false,
          },
          {
            name: "3102, Walgreens, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "3102, Walmart, PRINCETON, MN",
            disabled: false,
          },
          {
            name: "3103, CVS, CRYSTAL RIVER, FL",
            disabled: false,
          },
          {
            name: "3103, Walgreens, EXETER, NH",
            disabled: false,
          },
          {
            name: "3103, Walmart, GODDARD, KS",
            disabled: false,
          },
          {
            name: "3104, CVS, NEW HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "3104, Walgreens, MANITOWOC, WI",
            disabled: false,
          },
          {
            name: "3104, Walmart, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "3105, CVS, MATTITUCK, NY",
            disabled: false,
          },
          {
            name: "3105, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3106, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "3106, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3106, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "3106, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3107, CVS, ARCADIA, FL",
            disabled: false,
          },
          {
            name: "3107, Walgreens, SANFORD, FL",
            disabled: false,
          },
          {
            name: "3107, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3109, Rite Aid, WARREN, OH",
            disabled: false,
          },
          {
            name: "3109, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "311, BJ's, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "311, CVS, EAST GREENWICH, RI",
            disabled: false,
          },
          {
            name: "311, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "311, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "311, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "311, Kroger, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "311, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "311, Target, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "311, Walmart, FRANKLIN, LA",
            disabled: false,
          },
          {
            name: "3110, CVS, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "3110, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "3110, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3111, Albertsons, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "3111, CVS, PALMETTO, FL",
            disabled: false,
          },
          {
            name: "3111, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3112, Walgreens, ARLINGTON, MA",
            disabled: false,
          },
          {
            name: "3112, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3113, CVS, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "3114, CVS, ORANGE CITY, FL",
            disabled: false,
          },
          {
            name: "3114, Walgreens, EDINA, MN",
            disabled: false,
          },
          {
            name: "3114, Walmart, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "3115, CVS, NEW SMYRNA BEACH, FL",
            disabled: false,
          },
          {
            name: "3115, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "3116, Albertsons, SOUTH SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3117, CVS, ATWATER, CA",
            disabled: false,
          },
          {
            name: "3118, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3118, Walmart, DECATUR, GA",
            disabled: false,
          },
          {
            name: "3119, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "3119, Walmart, PANAMA CITY BEACH, FL",
            disabled: false,
          },
          {
            name: "312, BJ's, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "312, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "312, Costco, MILFORD, CT",
            disabled: false,
          },
          {
            name: "312, Kroger, BARSTOW, CA",
            disabled: false,
          },
          {
            name: "312, Kroger, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "312, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "312, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "312, Target, Sacramento, CA",
            disabled: false,
          },
          {
            name: "312, Walmart, VILLE PLATTE, LA",
            disabled: false,
          },
          {
            name: "3120, Albertsons, BURIEN, WA",
            disabled: false,
          },
          {
            name: "3120, CVS, RUTHERFORD COLLEGE, NC",
            disabled: false,
          },
          {
            name: "3120, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3121, Albertsons, MADERA, CA",
            disabled: false,
          },
          {
            name: "3122, Albertsons, AUBURN, CA",
            disabled: false,
          },
          {
            name: "3122, CVS, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "3122, Walgreens, OAKDALE, MN",
            disabled: false,
          },
          {
            name: "3123, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3123, Walmart, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "3124, Albertsons, MANTECA, CA",
            disabled: false,
          },
          {
            name: "3124, CVS, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "3125, Albertsons, EMERYVILLE, CA",
            disabled: false,
          },
          {
            name: "3125, CVS, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "3125, Walgreens, FOX POINT, WI",
            disabled: false,
          },
          {
            name: "3126, CVS, OSPREY, FL",
            disabled: false,
          },
          {
            name: "3126, Walmart, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "3127, Albertsons, SONORA, CA",
            disabled: false,
          },
          {
            name: "3127, CVS, AUBURNDALE, FL",
            disabled: false,
          },
          {
            name: "3127, Walmart, DENVER, CO",
            disabled: false,
          },
          {
            name: "3128, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3128, Walmart, DENVER, CO",
            disabled: false,
          },
          {
            name: "3129, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3129, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "313, ADUSA, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "313, Costco, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "313, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "313, Kroger, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "313, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "313, Kroger, NEW LEXINGTON, OH",
            disabled: false,
          },
          {
            name: "313, Target, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "313, Walmart, HIGH RIDGE, MO",
            disabled: false,
          },
          {
            name: "3130, CVS, LAKE PLACID, FL",
            disabled: false,
          },
          {
            name: "3130, Walgreens, MALDEN, MA",
            disabled: false,
          },
          {
            name: "3131, Walgreens, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "3131, Walmart, RIALTO, CA",
            disabled: false,
          },
          {
            name: "3132, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "3132, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3132, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3132, Walmart, POMONA, CA",
            disabled: false,
          },
          {
            name: "3133, Walgreens, ASHWAUBENON, WI",
            disabled: false,
          },
          {
            name: "3133, Walmart, LA PUENTE, CA",
            disabled: false,
          },
          {
            name: "3134, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "3134, CVS, KELLER, TX",
            disabled: false,
          },
          {
            name: "3134, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3135, Albertsons, WESTLAKE VILLAGE, CA",
            disabled: false,
          },
          {
            name: "3135, Walgreens, BOSTON, MA",
            disabled: false,
          },
          {
            name: "3135, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3136, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "3136, CVS, NORTH ARLINGTON, NJ",
            disabled: false,
          },
          {
            name: "3136, Walgreens, CAHOKIA, IL",
            disabled: false,
          },
          {
            name: "3136, Walmart, HORIZON CITY, TX",
            disabled: false,
          },
          {
            name: "3137, Walgreens, OAK RIDGE, TN",
            disabled: false,
          },
          {
            name: "3137, Walmart, FAIRVIEW, TN",
            disabled: false,
          },
          {
            name: "3138, Albertsons, CANYON COUNTRY, CA",
            disabled: false,
          },
          {
            name: "3138, Walgreens, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "3138, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3139, CVS, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "3139, Rite Aid, KETTERING, OH",
            disabled: false,
          },
          {
            name: "3139, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3139, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "314, Albertsons, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "314, Costco, COLCHESTER, VT",
            disabled: false,
          },
          {
            name: "314, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "314, Kroger, PANORAMA CITY, CA",
            disabled: false,
          },
          {
            name: "314, Target, FRESNO, CA",
            disabled: false,
          },
          {
            name: "314, Walmart, FAYETTEVILLE, TN",
            disabled: false,
          },
          {
            name: "3140, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3140, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3141, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3141, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3141, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3142, CVS, LANSDOWNE, PA",
            disabled: false,
          },
          {
            name: "3142, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3143, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3143, Rite Aid, AKRON, OH",
            disabled: false,
          },
          {
            name: "3143, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3144, CVS, WILDWOOD, FL",
            disabled: false,
          },
          {
            name: "3144, Rite Aid, FAIRLAWN, OH",
            disabled: false,
          },
          {
            name: "3144, Walmart, MILWAUKIE, OR",
            disabled: false,
          },
          {
            name: "3145, Albertsons, LEANDER, TX",
            disabled: false,
          },
          {
            name: "3145, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3145, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3145, Walmart, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "3146, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3146, Walgreens, NEWARK, NJ",
            disabled: false,
          },
          {
            name: "3146, Walmart, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "3147, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3147, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "3147, Walmart, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "3148, Albertsons, POULSBO, WA",
            disabled: false,
          },
          {
            name: "3148, CVS, LARCHMONT, NY",
            disabled: false,
          },
          {
            name: "3148, Walgreens, LOGANSPORT, IN",
            disabled: false,
          },
          {
            name: "3149, Walmart, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "315, ADUSA, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "315, BJ's, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "315, CVS, LUDLOW, MA",
            disabled: false,
          },
          {
            name: "315, Costco, WHARTON, NJ",
            disabled: false,
          },
          {
            name: "315, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "315, Kroger, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "315, Kroger, Katy, TX",
            disabled: false,
          },
          {
            name: "315, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "315, Kroger, Lexington, KY",
            disabled: false,
          },
          {
            name: "315, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "315, Kroger, PERRIS, CA",
            disabled: false,
          },
          {
            name: "315, Kroger, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "315, Walmart, ONEONTA, AL",
            disabled: false,
          },
          {
            name: "3150, CVS, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3150, Walmart, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "3151, Albertsons, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "3151, CVS, INDIALANTIC, FL",
            disabled: false,
          },
          {
            name: "3151, Rite Aid, AKRON, OH",
            disabled: false,
          },
          {
            name: "3151, Walgreens, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "3151, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3152, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3153, Walgreens, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "3153, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3154, CVS, WARWICK, NY",
            disabled: false,
          },
          {
            name: "3154, Walmart, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "3155, CVS, SEBRING, FL",
            disabled: false,
          },
          {
            name: "3155, Rite Aid, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "3155, Walmart, DERBY, KS",
            disabled: false,
          },
          {
            name: "3156, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3156, Walgreens, HARVEY, LA",
            disabled: false,
          },
          {
            name: "3156, Walmart, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "3157, CVS, LARGO, FL",
            disabled: false,
          },
          {
            name: "3157, Rite Aid, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3157, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3157, Walmart, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "3158, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "3158, Walgreens, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "3159, Walgreens, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "3159, Walmart, TETERBORO, NJ",
            disabled: false,
          },
          {
            name: "316, ADUSA, GREENBELT, MD",
            disabled: false,
          },
          {
            name: "316, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "316, BJ's, WILLIMANTIC, CT",
            disabled: false,
          },
          {
            name: "316, CVS, BELLINGHAM, MA",
            disabled: false,
          },
          {
            name: "316, Costco, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "316, Kroger, Fresno, CA",
            disabled: false,
          },
          {
            name: "316, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "316, Kroger, PRINCETON, WV",
            disabled: false,
          },
          {
            name: "316, Kroger, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "316, Meijer, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "316, Walmart, ATTALLA, AL",
            disabled: false,
          },
          {
            name: "3160, Albertsons, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "3160, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3161, Albertsons, MISSION HILLS, CA",
            disabled: false,
          },
          {
            name: "3161, CVS, EAST WINDSOR, NJ",
            disabled: false,
          },
          {
            name: "3161, Walgreens, WINTER SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3161, Walmart, PASADENA, FL",
            disabled: false,
          },
          {
            name: "3162, CVS, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "3162, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "3162, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3163, CVS, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "3163, Rite Aid, MAPLE HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3163, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "3163, Walmart, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "3164, CVS, CLEWISTON, FL",
            disabled: false,
          },
          {
            name: "3164, Walgreens, CONCORD, CA",
            disabled: false,
          },
          {
            name: "3164, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "3165, Albertsons, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "3165, CVS, NEW KENSINGTON, PA",
            disabled: false,
          },
          {
            name: "3166, CVS, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "3166, Walgreens, APOPKA, FL",
            disabled: false,
          },
          {
            name: "3166, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3167, Albertsons, SOUTH CHICAGO HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3167, Rite Aid, ALLIANCE, OH",
            disabled: false,
          },
          {
            name: "3167, Walmart, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3168, CVS, ERIE, PA",
            disabled: false,
          },
          {
            name: "3168, Walmart, CONWAY, AR",
            disabled: false,
          },
          {
            name: "3169, CVS, GENEVA, OH",
            disabled: false,
          },
          {
            name: "3169, Rite Aid, SHEFFIELD LAKE, OH",
            disabled: false,
          },
          {
            name: "3169, Walmart, MANOR, TX",
            disabled: false,
          },
          {
            name: "317, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "317, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "317, Costco, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "317, Kroger, CANTON, IL",
            disabled: false,
          },
          {
            name: "317, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "317, Target, CHICO, CA",
            disabled: false,
          },
          {
            name: "317, Walmart, VANDALIA, IL",
            disabled: false,
          },
          {
            name: "3170, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3170, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3170, Walmart, ELGIN, TX",
            disabled: false,
          },
          {
            name: "3171, Albertsons, LOMPOC, CA",
            disabled: false,
          },
          {
            name: "3171, CVS, INVERNESS, FL",
            disabled: false,
          },
          {
            name: "3171, Walgreens, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "3172, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3172, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3172, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3172, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3173, Albertsons, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "3173, Walgreens, MIAMI SHORES, FL",
            disabled: false,
          },
          {
            name: "3173, Walmart, LA VISTA, NE",
            disabled: false,
          },
          {
            name: "3174, Albertsons, AMMON, ID",
            disabled: false,
          },
          {
            name: "3174, CVS, NEWARK, OH",
            disabled: false,
          },
          {
            name: "3174, Walgreens, HAMPTON, NH",
            disabled: false,
          },
          {
            name: "3175, Albertsons, TUJUNGA, CA",
            disabled: false,
          },
          {
            name: "3175, Walgreens, JACKSON, TN",
            disabled: false,
          },
          {
            name: "3175, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3176, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3176, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3176, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3176, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3177, Albertsons, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "3177, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3177, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "3177, Walmart, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "3178, Albertsons, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "3178, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3178, Walmart, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "3179, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3179, Rite Aid, PORT CLINTON, OH",
            disabled: false,
          },
          {
            name: "3179, Walgreens, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "3179, Walmart, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "318, BJ's, DERBY, CT",
            disabled: false,
          },
          {
            name: "318, CVS, PEABODY, MA",
            disabled: false,
          },
          {
            name: "318, Costco, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "318, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "318, Kroger, Bellevue, NE",
            disabled: false,
          },
          {
            name: "318, Kroger, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "318, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "318, Kroger, LEMON GROVE, CA",
            disabled: false,
          },
          {
            name: "318, ShopRite, CLINTON, CT",
            disabled: false,
          },
          {
            name: "318, Target, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "318, Walmart, ARKADELPHIA, AR",
            disabled: false,
          },
          {
            name: "3180, CVS, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "3180, Rite Aid, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "3180, Walgreens, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "3180, Walmart, SOUTH GATE, CA",
            disabled: false,
          },
          {
            name: "3181, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3181, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3181, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "3182, Albertsons, LEMONT, IL",
            disabled: false,
          },
          {
            name: "3182, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "3182, Walmart, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "3183, CVS, LODI, OH",
            disabled: false,
          },
          {
            name: "3183, Walmart, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "3184, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "3184, Walmart, HOOVER, AL",
            disabled: false,
          },
          {
            name: "3185, Rite Aid, DELPHOS, OH",
            disabled: false,
          },
          {
            name: "3185, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "3186, CVS, CLARKSBURG, WV",
            disabled: false,
          },
          {
            name: "3186, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3187, Albertsons, GLOBE, AZ",
            disabled: false,
          },
          {
            name: "3187, CVS, COPPELL, TX",
            disabled: false,
          },
          {
            name: "3187, Walgreens, WHITE BEAR LAKE, MN",
            disabled: false,
          },
          {
            name: "3188, Albertsons, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "3188, CVS, HARRISBURG, IL",
            disabled: false,
          },
          {
            name: "3188, Walmart, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "3189, Albertsons, HOLBROOK, AZ",
            disabled: false,
          },
          {
            name: "3189, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "319, ADUSA, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "319, BJ's, STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "319, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "319, Costco, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "319, Kroger, LA PORTE, TX",
            disabled: false,
          },
          {
            name: "319, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "319, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "319, Kroger, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "319, Kroger, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "319, Rite Aid, BERLIN, MD",
            disabled: false,
          },
          {
            name: "319, ShopRite, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "319, Target, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "319, Walmart, RAYMORE, MO",
            disabled: false,
          },
          {
            name: "3190, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3190, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "3191, Albertsons, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "3191, Rite Aid, TIFFIN, OH",
            disabled: false,
          },
          {
            name: "3191, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3191, Walmart, PICKENS, SC",
            disabled: false,
          },
          {
            name: "3192, Albertsons, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "3192, Walgreens, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "3192, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "3193, Walgreens, MARGATE, FL",
            disabled: false,
          },
          {
            name: "3194, Albertsons, STAR, ID",
            disabled: false,
          },
          {
            name: "3194, CVS, SWEDESBORO, NJ",
            disabled: false,
          },
          {
            name: "3194, Rite Aid, WILLIAMSVILLE, NY",
            disabled: false,
          },
          {
            name: "3195, Albertsons, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "3195, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "3195, Rite Aid, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "3196, CVS, STUART, FL",
            disabled: false,
          },
          {
            name: "3196, Walgreens, MARSHALLTOWN, IA",
            disabled: false,
          },
          {
            name: "3197, Albertsons, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "3197, CVS, FORNEY, TX",
            disabled: false,
          },
          {
            name: "3197, Walgreens, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "3197, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3198, Albertsons, HUNTLEY, IL",
            disabled: false,
          },
          {
            name: "3198, CVS, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "3198, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3198, Walmart, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "3199, Walgreens, MARRERO, LA",
            disabled: false,
          },
          {
            name: "3199, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "32, ADUSA, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "32, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "32, BJ's, ROYAL PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "32, Kroger, GREELEY, CO",
            disabled: false,
          },
          {
            name: "32, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "32, Kroger, Mulvane, KS",
            disabled: false,
          },
          {
            name: "32, Meijer, CANTON, MI",
            disabled: false,
          },
          {
            name: "32, Walmart, BRANSON, MO",
            disabled: false,
          },
          {
            name: "320, ADUSA, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "320, CVS, WESTWOOD, NJ",
            disabled: false,
          },
          {
            name: "320, Costco, UNION, NJ",
            disabled: false,
          },
          {
            name: "320, Kroger, CONYERS, GA",
            disabled: false,
          },
          {
            name: "320, Kroger, Highland, IL",
            disabled: false,
          },
          {
            name: "320, Kroger, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "320, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "320, Kroger, SALEM, VA",
            disabled: false,
          },
          {
            name: "320, Kroger, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "320, ShopRite, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "320, Target, COLMA, CA",
            disabled: false,
          },
          {
            name: "320, Walmart, MARLIN, TX",
            disabled: false,
          },
          {
            name: "3200, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "3200, Rite Aid, CLAIRTON, PA",
            disabled: false,
          },
          {
            name: "3200, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "3200, Walmart, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "3201, Albertsons, VISTA, CA",
            disabled: false,
          },
          {
            name: "3201, Walmart, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "3202, Albertsons, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "3202, Target, Berkeley, CA",
            disabled: false,
          },
          {
            name: "3202, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3202, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3203, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3204, Albertsons, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "3204, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "3204, Target, Saint Paul, MN",
            disabled: false,
          },
          {
            name: "3204, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "3204, Walmart, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "3205, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "3205, Target, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3205, Walmart, LITHIA SPRINGS, GA",
            disabled: false,
          },
          {
            name: "3206, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "3206, CVS, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "3206, Target, Philadelphia, PA",
            disabled: false,
          },
          {
            name: "3206, Walmart, LIMA, OH",
            disabled: false,
          },
          {
            name: "3207, Albertsons, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "3207, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3207, Walgreens, THORNTON, CO",
            disabled: false,
          },
          {
            name: "3207, Walmart, SANFORD, FL",
            disabled: false,
          },
          {
            name: "3208, Albertsons, ARCADIA, CA",
            disabled: false,
          },
          {
            name: "3208, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3208, Walmart, SPRINGVILLE, UT",
            disabled: false,
          },
          {
            name: "3209, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "3209, Walmart, ELK RIVER, MN",
            disabled: false,
          },
          {
            name: "321, BJ's, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "321, CVS, CANTON, MA",
            disabled: false,
          },
          {
            name: "321, Costco, YONKERS, NY",
            disabled: false,
          },
          {
            name: "321, Kroger, ALVIN, TX",
            disabled: false,
          },
          {
            name: "321, Kroger, HUNTINGTON PARK, CA",
            disabled: false,
          },
          {
            name: "321, Kroger, Omaha, NE",
            disabled: false,
          },
          {
            name: "321, ShopRite, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "321, Target, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "321, Walmart, BRENHAM, TX",
            disabled: false,
          },
          {
            name: "3210, Target, Rosslyn, VA",
            disabled: false,
          },
          {
            name: "3210, Walmart, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "3211, Albertsons, BAKER CITY, OR",
            disabled: false,
          },
          {
            name: "3211, Target, College Park, MD",
            disabled: false,
          },
          {
            name: "3211, Walgreens, DORAL, FL",
            disabled: false,
          },
          {
            name: "3212, Albertsons, ASHLAND, OR",
            disabled: false,
          },
          {
            name: "3212, CVS, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "3212, Target, Philadelphia, PA",
            disabled: false,
          },
          {
            name: "3212, Walgreens, DANVILLE, IL",
            disabled: false,
          },
          {
            name: "3212, Walmart, EGG HBR TWP, NJ",
            disabled: false,
          },
          {
            name: "3213, Albertsons, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "3213, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3213, Walmart, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "3214, CVS, GARNER, NC",
            disabled: false,
          },
          {
            name: "3214, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3214, Walmart, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "3215, Albertsons, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "3215, CVS, BELLEVIEW, FL",
            disabled: false,
          },
          {
            name: "3215, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "3215, Walmart, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "3216, Albertsons, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "3216, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "3216, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "3216, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "3217, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "3217, CVS, PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "3217, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3217, Walmart, OTHELLO, WA",
            disabled: false,
          },
          {
            name: "3218, CVS, SEMINOLE, FL",
            disabled: false,
          },
          {
            name: "3218, Target, MISSION HILLS, CA",
            disabled: false,
          },
          {
            name: "3218, Walmart, SPANAWAY, WA",
            disabled: false,
          },
          {
            name: "3219, Albertsons, BATAVIA, IL",
            disabled: false,
          },
          {
            name: "3219, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3219, Walmart, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "322, ADUSA, REISTERSTOWN, MD",
            disabled: false,
          },
          {
            name: "322, Albertsons, GOLDEN, CO",
            disabled: false,
          },
          {
            name: "322, Costco, BRIDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "322, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "322, Kroger, PASADENA, TX",
            disabled: false,
          },
          {
            name: "322, Kroger, Princeton, KY",
            disabled: false,
          },
          {
            name: "322, Kroger, VINTON, VA",
            disabled: false,
          },
          {
            name: "322, Target, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "322, Walmart, BRYAN, TX",
            disabled: false,
          },
          {
            name: "3220, Albertsons, ELK GROVE VILLAGE, IL",
            disabled: false,
          },
          {
            name: "3220, Walgreens, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "3220, Walmart, ST GEORGE, UT",
            disabled: false,
          },
          {
            name: "3221, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3221, Walgreens, MADISON, TN",
            disabled: false,
          },
          {
            name: "3221, Walmart, WATKINS GLEN, NY",
            disabled: false,
          },
          {
            name: "3222, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3222, Target, Cambridge, MA",
            disabled: false,
          },
          {
            name: "3222, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3222, Walmart, CENTRAL, SC",
            disabled: false,
          },
          {
            name: "3223, Albertsons, RIVER FOREST, IL",
            disabled: false,
          },
          {
            name: "3223, Target, Roslindale, MA",
            disabled: false,
          },
          {
            name: "3223, Walgreens, CLARKSVILLE, IN",
            disabled: false,
          },
          {
            name: "3223, Walmart, BEAVER FALLS, PA",
            disabled: false,
          },
          {
            name: "3224, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3224, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3224, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "3225, CVS, APOPKA, FL",
            disabled: false,
          },
          {
            name: "3225, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3225, Target, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "3225, Walmart, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "3226, Target, Boston, MA",
            disabled: false,
          },
          {
            name: "3226, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "3227, CVS, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "3227, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3227, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3227, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3227, Walmart, MONUMENT, CO",
            disabled: false,
          },
          {
            name: "3228, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "3228, CVS, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "3228, Walmart, DELMONT, PA",
            disabled: false,
          },
          {
            name: "3229, CVS, NEPTUNE BEACH, FL",
            disabled: false,
          },
          {
            name: "3229, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3229, Walmart, VERNON, TX",
            disabled: false,
          },
          {
            name: "323, ADUSA, EASTON, MD",
            disabled: false,
          },
          {
            name: "323, ADUSA, ERWIN, TN",
            disabled: false,
          },
          {
            name: "323, CVS, SAUGERTIES, NY",
            disabled: false,
          },
          {
            name: "323, Costco, EDISON, NJ",
            disabled: false,
          },
          {
            name: "323, Kroger, Fremont, NE",
            disabled: false,
          },
          {
            name: "323, Kroger, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "323, Target, CUPERTINO, CA",
            disabled: false,
          },
          {
            name: "323, Walmart, MANSFIELD, LA",
            disabled: false,
          },
          {
            name: "3230, Albertsons, WHEATON, IL",
            disabled: false,
          },
          {
            name: "3230, Rite Aid, CLYDE, OH",
            disabled: false,
          },
          {
            name: "3230, Target, FOREST HILLS, NY",
            disabled: false,
          },
          {
            name: "3230, Walmart, BRYANT, AR",
            disabled: false,
          },
          {
            name: "3231, CVS, SELBYVILLE, DE",
            disabled: false,
          },
          {
            name: "3231, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3231, Walmart, GREENWOOD, AR",
            disabled: false,
          },
          {
            name: "3232, Walgreens, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "3232, Walmart, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "3233, Target, Irvine, CA",
            disabled: false,
          },
          {
            name: "3233, Walgreens, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "3233, Walmart, BEMIDJI, MN",
            disabled: false,
          },
          {
            name: "3234, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3234, CVS, SANTA FE, TX",
            disabled: false,
          },
          {
            name: "3234, Rite Aid, FARWELL, MI",
            disabled: false,
          },
          {
            name: "3234, Target, State College, PA",
            disabled: false,
          },
          {
            name: "3234, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3234, Walmart, ROGERSVILLE, TN",
            disabled: false,
          },
          {
            name: "3235, CVS, FERNANDINA BEACH, FL",
            disabled: false,
          },
          {
            name: "3235, Rite Aid, NORTH BELLMORE, NY",
            disabled: false,
          },
          {
            name: "3235, Target, CLOSTER, NJ",
            disabled: false,
          },
          {
            name: "3235, Walgreens, SHAKER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3235, Walmart, NORTH MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "3236, Albertsons, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "3236, CVS, KEY BISCAYNE, FL",
            disabled: false,
          },
          {
            name: "3236, Target, FREEPORT, NY",
            disabled: false,
          },
          {
            name: "3236, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3236, Walmart, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "3237, Albertsons, BEVERLY HILLS, CA",
            disabled: false,
          },
          {
            name: "3237, CVS, OKEECHOBEE, FL",
            disabled: false,
          },
          {
            name: "3237, Target, ELMONT, NY",
            disabled: false,
          },
          {
            name: "3237, Walmart, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "3238, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "3238, Target, Gainesville, FL",
            disabled: false,
          },
          {
            name: "3238, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3239, Target, Minneapolis, MN",
            disabled: false,
          },
          {
            name: "3239, Walmart, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "324, ADUSA, PASADENA, MD",
            disabled: false,
          },
          {
            name: "324, Costco, NORWALK, CT",
            disabled: false,
          },
          {
            name: "324, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "324, Kroger, Garner, NC",
            disabled: false,
          },
          {
            name: "324, Kroger, LYNWOOD, CA",
            disabled: false,
          },
          {
            name: "324, Meijer, LANSING, MI",
            disabled: false,
          },
          {
            name: "324, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "324, Walmart, BRISTOW, OK",
            disabled: false,
          },
          {
            name: "3240, Albertsons, AURORA, IL",
            disabled: false,
          },
          {
            name: "3240, Target, SAUSALITO, CA",
            disabled: false,
          },
          {
            name: "3241, Albertsons, CAMPBELL, CA",
            disabled: false,
          },
          {
            name: "3241, Target, Chapel Hill, NC",
            disabled: false,
          },
          {
            name: "3241, Walgreens, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "3241, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3242, CVS, READING, PA",
            disabled: false,
          },
          {
            name: "3242, Target, Bethesda, MD",
            disabled: false,
          },
          {
            name: "3243, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "3243, Walmart, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "3244, Target, Columbus, OH",
            disabled: false,
          },
          {
            name: "3245, CVS, MARIANNA, FL",
            disabled: false,
          },
          {
            name: "3245, Walgreens, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "3245, Walmart, HAYWARD, WI",
            disabled: false,
          },
          {
            name: "3246, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "3246, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3247, Albertsons, GRAND COULEE, WA",
            disabled: false,
          },
          {
            name: "3247, CVS, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "3247, Rite Aid, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "3247, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3247, Walgreens, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "3247, Walmart, DELAVAN, WI",
            disabled: false,
          },
          {
            name: "3248, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "3248, CVS, IMMOKALEE, FL",
            disabled: false,
          },
          {
            name: "3248, Walmart, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "3249, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3249, CVS, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "3249, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3249, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "325, ADUSA, DUNKIRK, MD",
            disabled: false,
          },
          {
            name: "325, Costco, HANOVER, MD",
            disabled: false,
          },
          {
            name: "325, Kroger, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "325, Kroger, EUGENE, OR",
            disabled: false,
          },
          {
            name: "325, Kroger, Logansport, IN",
            disabled: false,
          },
          {
            name: "325, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "325, Walmart, RICHMOND, MO",
            disabled: false,
          },
          {
            name: "3250, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "3250, Target, Austin, TX",
            disabled: false,
          },
          {
            name: "3250, Walgreens, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "3250, Walmart, AURORA, OH",
            disabled: false,
          },
          {
            name: "3251, Albertsons, CUPERTINO, CA",
            disabled: false,
          },
          {
            name: "3251, CVS, LONGWOOD, FL",
            disabled: false,
          },
          {
            name: "3251, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3251, Target, Burbank, CA",
            disabled: false,
          },
          {
            name: "3251, Walgreens, WALTHAM, MA",
            disabled: false,
          },
          {
            name: "3251, Walmart, WASHINGTON COURT HO, OH",
            disabled: false,
          },
          {
            name: "3251, Walmart, WASHINGTON COURT HOUSE, OH",
            disabled: false,
          },
          {
            name: "3252, Albertsons, MOSES LAKE, WA",
            disabled: false,
          },
          {
            name: "3252, CVS, CONSHOHOCKEN, PA",
            disabled: false,
          },
          {
            name: "3252, Target, Skokie, IL",
            disabled: false,
          },
          {
            name: "3252, Walmart, BOOTHWYN, PA",
            disabled: false,
          },
          {
            name: "3253, Albertsons, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "3253, CVS, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3253, Rite Aid, HARRISON, MI",
            disabled: false,
          },
          {
            name: "3253, Target, STONEHAM, MA",
            disabled: false,
          },
          {
            name: "3253, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "3253, Walmart, EDINBORO, PA",
            disabled: false,
          },
          {
            name: "3254, CVS, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "3254, Target, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "3254, Walmart, RENO, NV",
            disabled: false,
          },
          {
            name: "3255, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "3255, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "3255, Target, Raleigh, NC",
            disabled: false,
          },
          {
            name: "3255, Walgreens, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "3255, Walmart, SAVOY, IL",
            disabled: false,
          },
          {
            name: "3256, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3257, Albertsons, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "3257, CVS, SEFFNER, FL",
            disabled: false,
          },
          {
            name: "3257, Target, Arlington, VA",
            disabled: false,
          },
          {
            name: "3257, Walgreens, LACKAWANNA, NY",
            disabled: false,
          },
          {
            name: "3258, Albertsons, MONTEBELLO, CA",
            disabled: false,
          },
          {
            name: "3258, CVS, NORTH PORT, FL",
            disabled: false,
          },
          {
            name: "3258, Target, ORANGE, CA",
            disabled: false,
          },
          {
            name: "3258, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3258, Walmart, EUGENE, OR",
            disabled: false,
          },
          {
            name: "3259, Target, PORT WASHINGTON, NY",
            disabled: false,
          },
          {
            name: "3259, Walmart, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "326, ADUSA, LANHAM, MD",
            disabled: false,
          },
          {
            name: "326, Albertsons, WAITSFIELD, VT",
            disabled: false,
          },
          {
            name: "326, CVS, NORTH SMITHFIELD, RI",
            disabled: false,
          },
          {
            name: "326, Costco, PORT CHESTER, NY",
            disabled: false,
          },
          {
            name: "326, Kroger, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "326, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "326, Kroger, Jeffersontown, KY",
            disabled: false,
          },
          {
            name: "326, Kroger, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "326, Walmart, HIGGINSVILLE, MO",
            disabled: false,
          },
          {
            name: "3260, CVS, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "3260, Walmart, EPHRATA, WA",
            disabled: false,
          },
          {
            name: "3261, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "3261, Target, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "3261, Walgreens, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "3261, Walmart, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "3262, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3262, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3262, Walmart, CAMBRIDGE, OH",
            disabled: false,
          },
          {
            name: "3263, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3263, CVS, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "3263, Target, Philadelphia, PA",
            disabled: false,
          },
          {
            name: "3264, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3264, Rite Aid, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "3264, Target, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3264, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3265, Albertsons, CHELAN, WA",
            disabled: false,
          },
          {
            name: "3265, CVS, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "3265, Target, EAST PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "3265, Walmart, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "3266, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "3266, Rite Aid, FREDERICKTOWN, OH",
            disabled: false,
          },
          {
            name: "3266, Walgreens, ARVADA, CO",
            disabled: false,
          },
          {
            name: "3266, Walmart, EAST WINDSOR, NJ",
            disabled: false,
          },
          {
            name: "3267, CVS, LONGBOAT KEY, FL",
            disabled: false,
          },
          {
            name: "3267, Target, Berkeley, CA",
            disabled: false,
          },
          {
            name: "3267, Walgreens, AMHERST, NY",
            disabled: false,
          },
          {
            name: "3267, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3268, CVS, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "3268, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3268, Walmart, ANTIGO, WI",
            disabled: false,
          },
          {
            name: "3269, Albertsons, HAMILTON, MT",
            disabled: false,
          },
          {
            name: "3269, CVS, PALM BEACH GARDENS, FL",
            disabled: false,
          },
          {
            name: "3269, Target, Miami Beach, FL",
            disabled: false,
          },
          {
            name: "3269, Walgreens, HASTINGS, NE",
            disabled: false,
          },
          {
            name: "3269, Walmart, MEXICO, ME",
            disabled: false,
          },
          {
            name: "327, ADUSA, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "327, CVS, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "327, Costco, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "327, Kroger, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "327, Kroger, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "327, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "327, Kroger, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "327, Kroger, PASADENA, CA",
            disabled: false,
          },
          {
            name: "3270, CVS, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "3270, Target, Oak Park, IL",
            disabled: false,
          },
          {
            name: "3270, Walgreens, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "3270, Walmart, WYTHEVILLE, VA",
            disabled: false,
          },
          {
            name: "3271, CVS, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "3271, Walgreens, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "3271, Walmart, CALERA, AL",
            disabled: false,
          },
          {
            name: "3272, Albertsons, DEKALB, IL",
            disabled: false,
          },
          {
            name: "3272, CVS, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "3272, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3272, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3273, CVS, LAUDERHILL, FL",
            disabled: false,
          },
          {
            name: "3273, Rite Aid, AMBLER, PA",
            disabled: false,
          },
          {
            name: "3273, Target, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "3273, Walgreens, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "3273, Walmart, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "3274, Albertsons, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "3274, CVS, SAINT JAMES CITY, FL",
            disabled: false,
          },
          {
            name: "3274, Target, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "3274, Walmart, NORTH RICHLAND HILL, TX",
            disabled: false,
          },
          {
            name: "3274, Walmart, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "3275, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "3275, Target, Bellevue, WA",
            disabled: false,
          },
          {
            name: "3275, Walmart, EDMOND, OK",
            disabled: false,
          },
          {
            name: "3276, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "3276, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "3276, Walmart, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "3277, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3277, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3277, Walmart, RENO, NV",
            disabled: false,
          },
          {
            name: "3278, Albertsons, LOMBARD, IL",
            disabled: false,
          },
          {
            name: "3278, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "3278, Target, East Lansing, MI",
            disabled: false,
          },
          {
            name: "3278, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "3278, Walmart, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "3279, Albertsons, BUTTE, MT",
            disabled: false,
          },
          {
            name: "3279, Target, Denver, CO",
            disabled: false,
          },
          {
            name: "3279, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "3279, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "328, Costco, CRANBERRY TOWNS, PA",
            disabled: false,
          },
          {
            name: "328, Kroger, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "328, Kroger, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "328, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "328, Kroger, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "328, Kroger, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "328, Kroger, Upper Arlington, OH",
            disabled: false,
          },
          {
            name: "328, Target, DUBLIN, CA",
            disabled: false,
          },
          {
            name: "328, Walmart, WATERLOO, IL",
            disabled: false,
          },
          {
            name: "3280, Albertsons, AVALON, CA",
            disabled: false,
          },
          {
            name: "3280, CVS, CORYDON, IN",
            disabled: false,
          },
          {
            name: "3280, Target, Elmhurst, NY",
            disabled: false,
          },
          {
            name: "3280, Walmart, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "3281, Albertsons, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "3281, CVS, ESTERO, FL",
            disabled: false,
          },
          {
            name: "3281, Target, Portland, OR",
            disabled: false,
          },
          {
            name: "3281, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "3281, Walmart, HARBORCREEK, PA",
            disabled: false,
          },
          {
            name: "3282, Rite Aid, NORTH HAMPTON, NH",
            disabled: false,
          },
          {
            name: "3282, Walmart, LOGAN, OH",
            disabled: false,
          },
          {
            name: "3283, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "3283, Target, Evanston, IL",
            disabled: false,
          },
          {
            name: "3283, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "3283, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "3284, Albertsons, VILLA PARK, IL",
            disabled: false,
          },
          {
            name: "3284, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3284, Walgreens, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "3284, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3285, Albertsons, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "3285, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "3285, Target, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3285, Walmart, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "3286, Target, Seattle, WA",
            disabled: false,
          },
          {
            name: "3286, Walgreens, LA PORTE, TX",
            disabled: false,
          },
          {
            name: "3286, Walmart, HICKORY CREEK, TX",
            disabled: false,
          },
          {
            name: "3287, CVS, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "3287, Target, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "3287, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3287, Walmart, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "3288, Rite Aid, RAYMOND, NH",
            disabled: false,
          },
          {
            name: "3288, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "3288, Walgreens, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "3288, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3289, CVS, JENSEN BEACH, FL",
            disabled: false,
          },
          {
            name: "3289, Walmart, WEST JEFFERSON, NC",
            disabled: false,
          },
          {
            name: "329, ADUSA, ROCKVILLE, MD",
            disabled: false,
          },
          {
            name: "329, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "329, CVS, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "329, Costco, OCEAN, NJ",
            disabled: false,
          },
          {
            name: "329, Kroger, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "329, Kroger, Sturgeon Bay, WI",
            disabled: false,
          },
          {
            name: "329, Walmart, ANNISTON, AL",
            disabled: false,
          },
          {
            name: "3290, Albertsons, MELROSE PARK, IL",
            disabled: false,
          },
          {
            name: "3290, Target, Parsippany, NJ",
            disabled: false,
          },
          {
            name: "3290, Walgreens, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "3290, Walmart, KAHULUI, HI",
            disabled: false,
          },
          {
            name: "3291, Albertsons, ELGIN, IL",
            disabled: false,
          },
          {
            name: "3291, CVS, DAVIE, FL",
            disabled: false,
          },
          {
            name: "3291, Target, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "3291, Walgreens, SUN PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "3291, Walmart, FLANDERS, NJ",
            disabled: false,
          },
          {
            name: "3292, CVS, WYLIE, TX",
            disabled: false,
          },
          {
            name: "3292, Target, Dallas, TX",
            disabled: false,
          },
          {
            name: "3292, Walgreens, ORANGE, NJ",
            disabled: false,
          },
          {
            name: "3292, Walmart, UNION, NJ",
            disabled: false,
          },
          {
            name: "3293, CVS, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "3293, Target, LA CANADA FLINTRIDGE, CA",
            disabled: false,
          },
          {
            name: "3293, Walgreens, CIRCLE PINES, MN",
            disabled: false,
          },
          {
            name: "3293, Walmart, CHARDON, OH",
            disabled: false,
          },
          {
            name: "3294, Albertsons, ADDISON, IL",
            disabled: false,
          },
          {
            name: "3294, CVS, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "3294, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3294, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3294, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3295, Albertsons, COEUR D ALENE, ID",
            disabled: false,
          },
          {
            name: "3295, Albertsons, COEUR D'ALENE, ID",
            disabled: false,
          },
          {
            name: "3295, Target, Falls Church, VA",
            disabled: false,
          },
          {
            name: "3295, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "3296, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3296, Target, HADDON TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "3296, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3297, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3297, Target, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3297, Walgreens, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "3297, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3298, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "3298, CVS, HOBE SOUND, FL",
            disabled: false,
          },
          {
            name: "3298, Target, SANTA BARBARA, CA",
            disabled: false,
          },
          {
            name: "3298, Walgreens, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "3298, Walmart, KEMAH, TX",
            disabled: false,
          },
          {
            name: "3299, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "33, ADUSA, STOUGHTON, MA",
            disabled: false,
          },
          {
            name: "33, Albertsons, CUT BANK, MT",
            disabled: false,
          },
          {
            name: "33, BJ's, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "33, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "33, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "33, Kroger, Boulder, CO",
            disabled: false,
          },
          {
            name: "33, Kroger, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "33, Kroger, Mitchell, IN",
            disabled: false,
          },
          {
            name: "33, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "33, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "33, Meijer, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "33, Walmart, NASHVILLE, AR",
            disabled: false,
          },
          {
            name: "330, ADUSA, BOWIE, MD",
            disabled: false,
          },
          {
            name: "330, CVS, GREENVILLE, RI",
            disabled: false,
          },
          {
            name: "330, Costco, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "330, Kroger, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "330, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "330, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "330, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "330, Kroger, SALEM, VA",
            disabled: false,
          },
          {
            name: "330, ShopRite, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "330, Target, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "330, Walmart, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "3300, Walgreens, MARLBOROUGH, MA",
            disabled: false,
          },
          {
            name: "3300, Walmart, WAPAKONETA, OH",
            disabled: false,
          },
          {
            name: "3301, Albertsons, VALENCIA, CA",
            disabled: false,
          },
          {
            name: "3301, CVS, WOODMERE, OH",
            disabled: false,
          },
          {
            name: "3301, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3301, Walmart, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "3302, CVS, BOARDMAN, OH",
            disabled: false,
          },
          {
            name: "3302, Target, San Diego, CA",
            disabled: false,
          },
          {
            name: "3302, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3302, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3303, Target, San Diego, CA",
            disabled: false,
          },
          {
            name: "3303, Walmart, GRUNDY, VA",
            disabled: false,
          },
          {
            name: "3304, CVS, WARREN, OH",
            disabled: false,
          },
          {
            name: "3304, Rite Aid, EXETER, NH",
            disabled: false,
          },
          {
            name: "3304, Target, Cambridge, MA",
            disabled: false,
          },
          {
            name: "3304, Walmart, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "3305, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "3305, Target, BURLINGTON, MA",
            disabled: false,
          },
          {
            name: "3305, Walgreens, CREVE COEUR, MO",
            disabled: false,
          },
          {
            name: "3305, Walmart, MAYODAN, NC",
            disabled: false,
          },
          {
            name: "3306, CVS, AKRON, OH",
            disabled: false,
          },
          {
            name: "3306, Target, SOUTH BURLINGTON, VT",
            disabled: false,
          },
          {
            name: "3307, CVS, BOSTON, MA",
            disabled: false,
          },
          {
            name: "3307, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3307, Walmart, CRAWFORDVILLE, FL",
            disabled: false,
          },
          {
            name: "3308, Target, Washington, DC",
            disabled: false,
          },
          {
            name: "3308, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3308, Walmart, MIDDLEBURG, FL",
            disabled: false,
          },
          {
            name: "3309, Target, West Lafayette, IN",
            disabled: false,
          },
          {
            name: "3309, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "331, ADUSA, WOODSTOCK, VA",
            disabled: false,
          },
          {
            name: "331, Albertsons, RIDGECREST, CA",
            disabled: false,
          },
          {
            name: "331, CVS, FREMONT, CA",
            disabled: false,
          },
          {
            name: "331, Kroger, Chino, CA",
            disabled: false,
          },
          {
            name: "331, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "331, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "331, Kroger, Henderson, NV",
            disabled: false,
          },
          {
            name: "331, Kroger, LONDON, KY",
            disabled: false,
          },
          {
            name: "331, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "331, Target, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "331, Walmart, SULPHUR, LA",
            disabled: false,
          },
          {
            name: "3310, Rite Aid, DERRY, NH",
            disabled: false,
          },
          {
            name: "3310, Target, WAYNE, PA",
            disabled: false,
          },
          {
            name: "3310, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3310, Walmart, DELTONA, FL",
            disabled: false,
          },
          {
            name: "3311, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3311, Walmart, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "3312, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3312, CVS, VAN WERT, OH",
            disabled: false,
          },
          {
            name: "3312, Rite Aid, DURAND, MI",
            disabled: false,
          },
          {
            name: "3312, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3312, Walgreens, EUCLID, OH",
            disabled: false,
          },
          {
            name: "3313, CVS, WEST SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "3313, Target, Lexington, KY",
            disabled: false,
          },
          {
            name: "3313, Walmart, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "3314, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3314, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3314, Walgreens, PARMA, OH",
            disabled: false,
          },
          {
            name: "3314, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3315, Rite Aid, MARLETTE, MI",
            disabled: false,
          },
          {
            name: "3315, Target, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "3315, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3316, Albertsons, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "3316, Target, PROVO, UT",
            disabled: false,
          },
          {
            name: "3316, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3317, Albertsons, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "3317, CVS, CHARDON, OH",
            disabled: false,
          },
          {
            name: "3317, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3317, Walgreens, CORAL GABLES, FL",
            disabled: false,
          },
          {
            name: "3317, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3318, CVS, NOKOMIS, FL",
            disabled: false,
          },
          {
            name: "3318, Target, SELDEN, NY",
            disabled: false,
          },
          {
            name: "3318, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3319, Albertsons, RENTON, WA",
            disabled: false,
          },
          {
            name: "3319, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3319, Target, SPRING VALLEY, CA",
            disabled: false,
          },
          {
            name: "3319, Walmart, HARKER HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "332, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "332, CVS, JERICHO, NY",
            disabled: false,
          },
          {
            name: "332, Costco, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "332, HEB, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "332, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "332, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "332, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "332, Kroger, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "332, Kroger, Spokane, WA",
            disabled: false,
          },
          {
            name: "332, Kroger, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "332, Target, PITTSBURG, CA",
            disabled: false,
          },
          {
            name: "332, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "3320, CVS, BARBERTON, OH",
            disabled: false,
          },
          {
            name: "3320, Rite Aid, ROSCOMMON, MI",
            disabled: false,
          },
          {
            name: "3320, Target, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "3320, Walgreens, FOX LAKE, IL",
            disabled: false,
          },
          {
            name: "3320, Walmart, PALMHURST, TX",
            disabled: false,
          },
          {
            name: "3321, Albertsons, GIG HARBOR, WA",
            disabled: false,
          },
          {
            name: "3321, CVS, WOOSTER, OH",
            disabled: false,
          },
          {
            name: "3321, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3321, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3322, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3322, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3322, Target, Miami, FL",
            disabled: false,
          },
          {
            name: "3322, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "3322, Walmart, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3323, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3323, Target, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "3323, Walgreens, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "3324, Albertsons, BUELLTON, CA",
            disabled: false,
          },
          {
            name: "3324, Target, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "3324, Walgreens, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "3324, Walmart, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "3325, Albertsons, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "3325, Albertsons, SAUGUS, CA",
            disabled: false,
          },
          {
            name: "3325, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3325, Target, Quincy, MA",
            disabled: false,
          },
          {
            name: "3326, Albertsons, GOLETA, CA",
            disabled: false,
          },
          {
            name: "3326, CVS, MENTOR, OH",
            disabled: false,
          },
          {
            name: "3326, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "3327, Albertsons, LA MESA, CA",
            disabled: false,
          },
          {
            name: "3327, Target, Seattle, WA",
            disabled: false,
          },
          {
            name: "3327, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3328, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3328, Target, Washington, DC",
            disabled: false,
          },
          {
            name: "3328, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3328, Walmart, GREENVILLE, MI",
            disabled: false,
          },
          {
            name: "3329, Albertsons, SANTA BARBARA, CA",
            disabled: false,
          },
          {
            name: "3329, CVS, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "3329, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3329, Walmart, POTSDAM, NY",
            disabled: false,
          },
          {
            name: "333, Albertsons, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "333, CVS, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "333, Costco, EVERETT, MA",
            disabled: false,
          },
          {
            name: "333, HEB, ARANSAS PASS, TX",
            disabled: false,
          },
          {
            name: "333, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "333, Kroger, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "333, Walmart, BEAVER DAM, KY",
            disabled: false,
          },
          {
            name: "3330, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "3330, Target, Oakland, CA",
            disabled: false,
          },
          {
            name: "3330, Walgreens, MERCED, CA",
            disabled: false,
          },
          {
            name: "3330, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "3331, Albertsons, SAINT CHARLES, IL",
            disabled: false,
          },
          {
            name: "3331, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3331, Walmart, PINE BLUFF, AR",
            disabled: false,
          },
          {
            name: "3332, CVS, NORTH ROYALTON, OH",
            disabled: false,
          },
          {
            name: "3332, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3332, Walmart, FULTON, NY",
            disabled: false,
          },
          {
            name: "3333, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3333, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3333, Target, West Hartford, CT",
            disabled: false,
          },
          {
            name: "3334, Albertsons, ANTHEM, AZ",
            disabled: false,
          },
          {
            name: "3334, CVS, MIDDLEBURG HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3334, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3334, Walmart, MALONE, NY",
            disabled: false,
          },
          {
            name: "3335, Target, San Marcos, TX",
            disabled: false,
          },
          {
            name: "3336, CVS, DALEVILLE, VA",
            disabled: false,
          },
          {
            name: "3336, Rite Aid, AMSTERDAM, NY",
            disabled: false,
          },
          {
            name: "3336, Target, LAWNDALE, CA",
            disabled: false,
          },
          {
            name: "3336, Walmart, WOODHAVEN, MI",
            disabled: false,
          },
          {
            name: "3337, Albertsons, KUNA, ID",
            disabled: false,
          },
          {
            name: "3337, Walgreens, LAWRENCE, MA",
            disabled: false,
          },
          {
            name: "3337, Walmart, RIO GRANDE, NJ",
            disabled: false,
          },
          {
            name: "3338, Albertsons, WEST CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3338, CVS, EUCLID, OH",
            disabled: false,
          },
          {
            name: "3338, Target, Santa Monica, CA",
            disabled: false,
          },
          {
            name: "3338, Walgreens, CAPE GIRARDEAU, MO",
            disabled: false,
          },
          {
            name: "3338, Walmart, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "3339, Albertsons, BOISE, ID",
            disabled: false,
          },
          {
            name: "3339, CVS, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "3339, Target, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "3339, Walmart, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "334, ADUSA, HYATTSVILLE, MD",
            disabled: false,
          },
          {
            name: "334, ADUSA, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "334, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "334, Costco, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "334, HEB, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "334, Kroger, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "334, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "334, Kroger, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "334, Kroger, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "334, Walmart, CARLINVILLE, IL",
            disabled: false,
          },
          {
            name: "3340, Albertsons, GLEN ELLYN, IL",
            disabled: false,
          },
          {
            name: "3340, CVS, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "3340, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "3341, Albertsons, WOOD DALE, IL",
            disabled: false,
          },
          {
            name: "3341, CVS, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "3341, Target, Champaign, IL",
            disabled: false,
          },
          {
            name: "3341, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "3341, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3342, Albertsons, ROCK SPRINGS, WY",
            disabled: false,
          },
          {
            name: "3342, Target, Austin, TX",
            disabled: false,
          },
          {
            name: "3342, Walgreens, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "3342, Walmart, AMELIA, OH",
            disabled: false,
          },
          {
            name: "3343, Albertsons, SOUTH ELGIN, IL",
            disabled: false,
          },
          {
            name: "3343, CVS, MAYFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3343, Target, Inglewood, CA",
            disabled: false,
          },
          {
            name: "3343, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "3344, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3344, CVS, SHAKOPEE, MN",
            disabled: false,
          },
          {
            name: "3344, Target, Santa Monica, CA",
            disabled: false,
          },
          {
            name: "3344, Walgreens, PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "3344, Walmart, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "3345, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3345, Target, Encino, CA",
            disabled: false,
          },
          {
            name: "3345, Walgreens, WARWICK, RI",
            disabled: false,
          },
          {
            name: "3346, Albertsons, ELMHURST, IL",
            disabled: false,
          },
          {
            name: "3346, CVS, SHAKER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3346, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "3346, Walgreens, SOUTH SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3347, Albertsons, ELBURN, IL",
            disabled: false,
          },
          {
            name: "3347, CVS, UNIVERSITY HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3347, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3347, Walmart, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "3348, Albertsons, BARTLETT, IL",
            disabled: false,
          },
          {
            name: "3348, CVS, WAYCROSS, GA",
            disabled: false,
          },
          {
            name: "3348, Walmart, LAKE PARK, FL",
            disabled: false,
          },
          {
            name: "3349, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3349, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3349, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3349, Walgreens, GRAND HAVEN, MI",
            disabled: false,
          },
          {
            name: "3349, Walmart, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "335, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "335, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "335, CVS, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "335, Costco, SAN JUAN, PR",
            disabled: false,
          },
          {
            name: "335, Kroger, BRISTOL, VA",
            disabled: false,
          },
          {
            name: "335, Kroger, Lima, OH",
            disabled: false,
          },
          {
            name: "335, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "335, Kroger, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "335, Kroger, OXNARD, CA",
            disabled: false,
          },
          {
            name: "335, Target, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "335, Walmart, JACKSON, TN",
            disabled: false,
          },
          {
            name: "3350, Target, CORAL GABLES, FL",
            disabled: false,
          },
          {
            name: "3350, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3351, Target, Washington, DC",
            disabled: false,
          },
          {
            name: "3351, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3351, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3352, Walgreens, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "3352, Walmart, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "3353, CVS, LORAIN, OH",
            disabled: false,
          },
          {
            name: "3353, Target, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "3354, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3354, Walmart, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "3355, CVS, NORTON, OH",
            disabled: false,
          },
          {
            name: "3355, Target, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "3355, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "3355, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3356, CVS, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "3356, Rite Aid, METAMORA, MI",
            disabled: false,
          },
          {
            name: "3356, Target, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "3356, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3356, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3357, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3357, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3358, CVS, RAVENNA, OH",
            disabled: false,
          },
          {
            name: "3358, Target, Portland, OR",
            disabled: false,
          },
          {
            name: "3359, CVS, SOLON, OH",
            disabled: false,
          },
          {
            name: "3359, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3359, Walgreens, STRATFORD, CT",
            disabled: false,
          },
          {
            name: "3359, Walmart, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "336, ADUSA, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "336, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "336, CVS, PLEASANTVILLE, NJ",
            disabled: false,
          },
          {
            name: "336, Costco, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "336, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "336, Kroger, MONROE, OH",
            disabled: false,
          },
          {
            name: "336, Kroger, Muncie, IN",
            disabled: false,
          },
          {
            name: "336, Kroger, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "336, Kroger, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "336, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "336, ShopRite, NORWICH, CT",
            disabled: false,
          },
          {
            name: "336, Target, IRVINE, CA",
            disabled: false,
          },
          {
            name: "336, Walmart, SHERIDAN, AR",
            disabled: false,
          },
          {
            name: "3360, Albertsons, MCCALL, ID",
            disabled: false,
          },
          {
            name: "3360, CVS, STOW, OH",
            disabled: false,
          },
          {
            name: "3360, Target, ROLLING HILLS ESTATES, CA",
            disabled: false,
          },
          {
            name: "3360, Walmart, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3362, CVS, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "3362, Target, Athens, GA",
            disabled: false,
          },
          {
            name: "3362, Walmart, OAK GROVE, KY",
            disabled: false,
          },
          {
            name: "3363, Target, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "3363, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3363, Walmart, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "3364, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "3364, CVS, SUNBURY, OH",
            disabled: false,
          },
          {
            name: "3364, Walgreens, NILES, MI",
            disabled: false,
          },
          {
            name: "3364, Walmart, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "3365, Rite Aid, GRAFTON, OH",
            disabled: false,
          },
          {
            name: "3365, Target, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "3365, Walgreens, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "3366, Albertsons, HOMEDALE, ID",
            disabled: false,
          },
          {
            name: "3366, Rite Aid, CASSOPOLIS, MI",
            disabled: false,
          },
          {
            name: "3366, Target, SAN JUAN CAPISTRANO, CA",
            disabled: false,
          },
          {
            name: "3366, Target, San Juan Capristrano, CA",
            disabled: false,
          },
          {
            name: "3366, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3366, Walmart, CENTERVILLE, UT",
            disabled: false,
          },
          {
            name: "3367, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "3367, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3367, Walmart, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "3368, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3368, Rite Aid, BERRIEN SPRINGS, MI",
            disabled: false,
          },
          {
            name: "3368, Target, Boston, MA",
            disabled: false,
          },
          {
            name: "3368, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3369, Target, La Jolla, CA",
            disabled: false,
          },
          {
            name: "337, ADUSA, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "337, ADUSA, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "337, Albertsons, CHEWELAH, WA",
            disabled: false,
          },
          {
            name: "337, CVS, BENNINGTON, VT",
            disabled: false,
          },
          {
            name: "337, Costco, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "337, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "337, Kroger, PASADENA, TX",
            disabled: false,
          },
          {
            name: "337, Kroger, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "337, Target, EVERETT, WA",
            disabled: false,
          },
          {
            name: "337, Walmart, FREDERICKTOWN, MO",
            disabled: false,
          },
          {
            name: "3370, CVS, HOMOSASSA, FL",
            disabled: false,
          },
          {
            name: "3370, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3370, Walmart, PALMETTO, FL",
            disabled: false,
          },
          {
            name: "3371, CVS, MARCO ISLAND, FL",
            disabled: false,
          },
          {
            name: "3371, Target, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "3371, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3371, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3372, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3372, Target, Jamaica, NY",
            disabled: false,
          },
          {
            name: "3372, Walmart, LARGO, FL",
            disabled: false,
          },
          {
            name: "3373, CVS, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "3373, Rite Aid, FREDONIA, NY",
            disabled: false,
          },
          {
            name: "3373, Walgreens, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "3374, Albertsons, SUGAR GROVE, IL",
            disabled: false,
          },
          {
            name: "3374, Target, Iowa City, IA",
            disabled: false,
          },
          {
            name: "3375, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3376, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3376, CVS, NORTH RIDGEVILLE, OH",
            disabled: false,
          },
          {
            name: "3376, Target, TAYLORSVILLE, UT",
            disabled: false,
          },
          {
            name: "3377, CVS, BRUNSWICK, OH",
            disabled: false,
          },
          {
            name: "3377, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3377, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3377, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3378, CVS, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "3378, Target, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "3378, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3379, CVS, WILTON, NY",
            disabled: false,
          },
          {
            name: "3379, Walmart, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "338, ADUSA, ACCOKEEK, MD",
            disabled: false,
          },
          {
            name: "338, ADUSA, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "338, Costco, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "338, Kroger, EL MONTE, CA",
            disabled: false,
          },
          {
            name: "338, Kroger, Muncie, IN",
            disabled: false,
          },
          {
            name: "338, Kroger, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "338, Kroger, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "338, Kroger, Porter, TX",
            disabled: false,
          },
          {
            name: "338, Target, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "338, Walmart, LAMAR, MO",
            disabled: false,
          },
          {
            name: "3380, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3380, Walgreens, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "3380, Walmart, PASCO, WA",
            disabled: false,
          },
          {
            name: "3381, Albertsons, SYCAMORE, IL",
            disabled: false,
          },
          {
            name: "3381, CVS, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "3381, Target, Portland, OR",
            disabled: false,
          },
          {
            name: "3381, Walmart, SWEETWATER, TX",
            disabled: false,
          },
          {
            name: "3382, CVS, SHIRLEY, NY",
            disabled: false,
          },
          {
            name: "3382, Target, LAWRENCE, NY",
            disabled: false,
          },
          {
            name: "3382, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3382, Walmart, PUEBLO WEST, CO",
            disabled: false,
          },
          {
            name: "3383, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3383, Rite Aid, REED CITY, MI",
            disabled: false,
          },
          {
            name: "3383, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "3384, CVS, MINNEOLA, FL",
            disabled: false,
          },
          {
            name: "3384, Target, Sacramento, CA",
            disabled: false,
          },
          {
            name: "3384, Walmart, HEREFORD, TX",
            disabled: false,
          },
          {
            name: "3385, CVS, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "3385, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3385, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3385, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3386, Target, Denver, CO",
            disabled: false,
          },
          {
            name: "3386, Walmart, SPRINGVILLE, AL",
            disabled: false,
          },
          {
            name: "3387, CVS, ROANOKE RAPIDS, NC",
            disabled: false,
          },
          {
            name: "3387, Target, New York, NY",
            disabled: false,
          },
          {
            name: "3387, Walgreens, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "3387, Walmart, NORTH PORT, FL",
            disabled: false,
          },
          {
            name: "3388, Walgreens, ALCOA, TN",
            disabled: false,
          },
          {
            name: "3388, Walmart, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "3389, Rite Aid, AUDUBON, PA",
            disabled: false,
          },
          {
            name: "3389, Target, WYNNEWOOD, PA",
            disabled: false,
          },
          {
            name: "3389, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "3389, Walmart, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "339, ADUSA, LA PLATA, MD",
            disabled: false,
          },
          {
            name: "339, Albertsons, TOOELE, UT",
            disabled: false,
          },
          {
            name: "339, Costco, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "339, HEB, LIVINGSTON, TX",
            disabled: false,
          },
          {
            name: "339, Kroger, Fresno, CA",
            disabled: false,
          },
          {
            name: "339, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "339, Kroger, LAGRANGE, GA",
            disabled: false,
          },
          {
            name: "339, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "339, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "339, Target, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "339, Walmart, FORDYCE, AR",
            disabled: false,
          },
          {
            name: "3390, Walmart, WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "3391, CVS, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "3391, Target, Costa Mesa, CA",
            disabled: false,
          },
          {
            name: "3391, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "3391, Walmart, SCHERTZ, TX",
            disabled: false,
          },
          {
            name: "3392, CVS, JASPER, GA",
            disabled: false,
          },
          {
            name: "3392, Target, Pittsburgh, PA",
            disabled: false,
          },
          {
            name: "3392, Walgreens, NEENAH, WI",
            disabled: false,
          },
          {
            name: "3392, Walmart, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "3393, CVS, AURORA, OH",
            disabled: false,
          },
          {
            name: "3393, Target, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "3393, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "3394, Albertsons, HUNTLEY, IL",
            disabled: false,
          },
          {
            name: "3394, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3394, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3394, Target, New York City, NY",
            disabled: false,
          },
          {
            name: "3394, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3394, Walmart, ATLANTIC, IA",
            disabled: false,
          },
          {
            name: "3395, CVS, SILVER SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3395, Target, Bronx, NY",
            disabled: false,
          },
          {
            name: "3395, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3395, Walmart, GRAND ISLAND, NE",
            disabled: false,
          },
          {
            name: "3396, CVS, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "3397, CVS, SPOTSYLVANIA, VA",
            disabled: false,
          },
          {
            name: "3397, Walmart, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "3398, CVS, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "3398, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3399, Albertsons, BURLINGTON, CO",
            disabled: false,
          },
          {
            name: "3399, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "3399, Target, Port Chester, NY",
            disabled: false,
          },
          {
            name: "3399, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "34, ADUSA, MONROE, NC",
            disabled: false,
          },
          {
            name: "34, BJ's, STOUGHTON, MA",
            disabled: false,
          },
          {
            name: "34, HEB, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "34, Kroger, Denver, CO",
            disabled: false,
          },
          {
            name: "34, Kroger, Laguna Niguel, CA",
            disabled: false,
          },
          {
            name: "34, Kroger, Tucson, AZ",
            disabled: false,
          },
          {
            name: "34, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "34, Meijer, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "34, Walmart, NEVADA, MO",
            disabled: false,
          },
          {
            name: "340, ADUSA, LAUREL, MD",
            disabled: false,
          },
          {
            name: "340, CVS, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "340, Costco, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "340, Kroger, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "340, ShopRite, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "340, Walmart, CHECOTAH, OK",
            disabled: false,
          },
          {
            name: "3400, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "3400, Rite Aid, WOMELSDORF, PA",
            disabled: false,
          },
          {
            name: "3400, Target, LIHUE, HI",
            disabled: false,
          },
          {
            name: "3400, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3400, Walmart, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "3401, Target, WEST LEBANON, NH",
            disabled: false,
          },
          {
            name: "3401, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "3401, Walmart, COLLEGE PARK, GA",
            disabled: false,
          },
          {
            name: "3402, CVS, PIQUA, OH",
            disabled: false,
          },
          {
            name: "3402, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3402, Walmart, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "3403, Albertsons, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "3403, CVS, CHESAPEAKE, OH",
            disabled: false,
          },
          {
            name: "3403, Target, Denver, CO",
            disabled: false,
          },
          {
            name: "3403, Walmart, DALLAS, GA",
            disabled: false,
          },
          {
            name: "3404, CVS, XENIA, OH",
            disabled: false,
          },
          {
            name: "3404, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "3404, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "3404, Walmart, ROSEVILLE, MN",
            disabled: false,
          },
          {
            name: "3405, Albertsons, GURNEE, IL",
            disabled: false,
          },
          {
            name: "3405, Target, Madison, WI",
            disabled: false,
          },
          {
            name: "3405, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "3406, CVS, BUCYRUS, OH",
            disabled: false,
          },
          {
            name: "3406, Target, Huntington Park, CA",
            disabled: false,
          },
          {
            name: "3406, Walgreens, LAKE IN THE HILLS, IL",
            disabled: false,
          },
          {
            name: "3406, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3407, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3407, Target, MOSCOW, ID",
            disabled: false,
          },
          {
            name: "3407, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3407, Walmart, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "3408, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "3408, CVS, WASHINGTON COURT HOUSE, OH",
            disabled: false,
          },
          {
            name: "3408, Target, Wall Township, NJ",
            disabled: false,
          },
          {
            name: "3408, Walmart, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "3409, Target, Jackson, WY",
            disabled: false,
          },
          {
            name: "3409, Walmart, LEICESTER, MA",
            disabled: false,
          },
          {
            name: "341, ADUSA, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "341, ADUSA, ZEBULON, NC",
            disabled: false,
          },
          {
            name: "341, Albertsons, PAHRUMP, NV",
            disabled: false,
          },
          {
            name: "341, Costco, COMMERCE TOWNSH, MI",
            disabled: false,
          },
          {
            name: "341, Kroger, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "341, Kroger, MAYWOOD, CA",
            disabled: false,
          },
          {
            name: "341, Kroger, Martin, TN",
            disabled: false,
          },
          {
            name: "341, Kroger, PAHRUMP, NV",
            disabled: false,
          },
          {
            name: "341, Target, TACOMA, WA",
            disabled: false,
          },
          {
            name: "341, Walmart, MARYSVILLE, KS",
            disabled: false,
          },
          {
            name: "3410, Albertsons, FAIRBANKS, AK",
            disabled: false,
          },
          {
            name: "3410, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "3410, Target, Scotts Valley, CA",
            disabled: false,
          },
          {
            name: "3411, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "3411, CVS, FAIRBORN, OH",
            disabled: false,
          },
          {
            name: "3411, Rite Aid, LANCASTER, NY",
            disabled: false,
          },
          {
            name: "3411, Target, New York City, NY",
            disabled: false,
          },
          {
            name: "3411, Walgreens, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "3411, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "3412, Albertsons, WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "3412, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "3412, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "3412, Walmart, ELIZABETHVILLE, PA",
            disabled: false,
          },
          {
            name: "3413, Albertsons, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "3413, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "3413, Target, Portland, OR",
            disabled: false,
          },
          {
            name: "3414, Albertsons, WALLA WALLA, WA",
            disabled: false,
          },
          {
            name: "3414, Target, Kill Devil Hills, NC",
            disabled: false,
          },
          {
            name: "3414, Walmart, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "3415, Albertsons, SPRING GROVE, IL",
            disabled: false,
          },
          {
            name: "3415, Target, Ann Arbor, MI",
            disabled: false,
          },
          {
            name: "3415, Walmart, TARPON SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3416, Albertsons, LAKE FOREST PARK, WA",
            disabled: false,
          },
          {
            name: "3416, CVS, PORTSMOUTH, OH",
            disabled: false,
          },
          {
            name: "3416, Target, Fort Collins, CO",
            disabled: false,
          },
          {
            name: "3416, Walgreens, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "3417, Albertsons, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "3417, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "3418, Albertsons, REDMOND, WA",
            disabled: false,
          },
          {
            name: "3418, CVS, ROYAL PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "3418, Walmart, WESLEY CHAPEL, FL",
            disabled: false,
          },
          {
            name: "3419, Albertsons, SNOHOMISH, WA",
            disabled: false,
          },
          {
            name: "3419, CVS, JACKSON, OH",
            disabled: false,
          },
          {
            name: "3419, Target, Stevensville, MD",
            disabled: false,
          },
          {
            name: "3419, Walgreens, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "3419, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "342, Albertsons, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "342, Costco, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "342, Kroger, Cary, NC",
            disabled: false,
          },
          {
            name: "342, Kroger, Lexington, TN",
            disabled: false,
          },
          {
            name: "342, Kroger, MESQUITE, NV",
            disabled: false,
          },
          {
            name: "342, Kroger, SEABROOK, TX",
            disabled: false,
          },
          {
            name: "342, Target, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "342, Walmart, HIAWATHA, KS",
            disabled: false,
          },
          {
            name: "3420, CVS, KETTERING, OH",
            disabled: false,
          },
          {
            name: "3420, Target, Miami, FL",
            disabled: false,
          },
          {
            name: "3420, Walgreens, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "3420, Walmart, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "3421, Albertsons, ZION, IL",
            disabled: false,
          },
          {
            name: "3421, Target, Auburn, AL",
            disabled: false,
          },
          {
            name: "3422, Albertsons, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3422, CVS, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "3422, Target, Huntington Beach, CA",
            disabled: false,
          },
          {
            name: "3422, Walmart, DEPTFORD, NJ",
            disabled: false,
          },
          {
            name: "3423, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "3423, Walgreens, ANOKA, MN",
            disabled: false,
          },
          {
            name: "3423, Walmart, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "3424, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "3424, Target, Homestead, FL",
            disabled: false,
          },
          {
            name: "3424, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "3424, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "3425, Albertsons, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "3425, Rite Aid, HAMBURG, PA",
            disabled: false,
          },
          {
            name: "3425, Walgreens, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "3425, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3426, Albertsons, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "3426, CVS, WALLS, MS",
            disabled: false,
          },
          {
            name: "3426, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "3427, Albertsons, OAK HARBOR, WA",
            disabled: false,
          },
          {
            name: "3427, CVS, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "3427, Rite Aid, NEWTON, NJ",
            disabled: false,
          },
          {
            name: "3427, Target, North Hollywood, CA",
            disabled: false,
          },
          {
            name: "3427, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "3427, Walmart, ARTESIA, NM",
            disabled: false,
          },
          {
            name: "3428, Albertsons, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "3428, Target, Charleston, SC",
            disabled: false,
          },
          {
            name: "3428, Walmart, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "3429, Albertsons, NILES, IL",
            disabled: false,
          },
          {
            name: "3429, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "3429, Target, Brooklyn, NY",
            disabled: false,
          },
          {
            name: "3429, Walgreens, SEMINOLE, FL",
            disabled: false,
          },
          {
            name: "3429, Walmart, WARREN, PA",
            disabled: false,
          },
          {
            name: "343, ADUSA, LUSBY, MD",
            disabled: false,
          },
          {
            name: "343, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "343, Costco, AVON, OH",
            disabled: false,
          },
          {
            name: "343, Kroger, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "343, Kroger, PLYMOUTH, WI",
            disabled: false,
          },
          {
            name: "343, Kroger, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "343, Kroger, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "343, Target, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "343, Walmart, TAYLORVILLE, IL",
            disabled: false,
          },
          {
            name: "3430, Albertsons, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "3430, Target, Arlington, VA",
            disabled: false,
          },
          {
            name: "3430, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "3430, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3431, CVS, PAMPA, TX",
            disabled: false,
          },
          {
            name: "3431, Walgreens, UNION, NJ",
            disabled: false,
          },
          {
            name: "3431, Walmart, HUDSON OAKS, TX",
            disabled: false,
          },
          {
            name: "3432, Albertsons, ROUND LAKE BEACH, IL",
            disabled: false,
          },
          {
            name: "3432, CVS, MARION, OH",
            disabled: false,
          },
          {
            name: "3432, Target, Eatontown, NJ",
            disabled: false,
          },
          {
            name: "3432, Walmart, DESOTO, TX",
            disabled: false,
          },
          {
            name: "3433, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3433, Target, Long Island City, NY",
            disabled: false,
          },
          {
            name: "3433, Walgreens, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "3433, Walmart, RED OAK, TX",
            disabled: false,
          },
          {
            name: "3434, Albertsons, RIVERSIDE, RI",
            disabled: false,
          },
          {
            name: "3434, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3434, Walmart, WOODSTOCK, IL",
            disabled: false,
          },
          {
            name: "3435, Albertsons, POWELL, WY",
            disabled: false,
          },
          {
            name: "3435, CVS, CONCORD, NC",
            disabled: false,
          },
          {
            name: "3435, Walmart, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "3436, Albertsons, BURLINGTON, WA",
            disabled: false,
          },
          {
            name: "3436, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "3436, Walmart, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "3437, CVS, JUPITER, FL",
            disabled: false,
          },
          {
            name: "3437, Target, Woodmere, OH",
            disabled: false,
          },
          {
            name: "3437, Walgreens, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "3438, Albertsons, AUBURN, WA",
            disabled: false,
          },
          {
            name: "3438, Walgreens, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "3439, Albertsons, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "3439, CVS, ELKINS, WV",
            disabled: false,
          },
          {
            name: "3439, Walmart, NAVARRE, FL",
            disabled: false,
          },
          {
            name: "344, ADUSA, ELKRIDGE, MD",
            disabled: false,
          },
          {
            name: "344, ADUSA, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "344, Albertsons, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "344, Costco, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "344, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "344, Kroger, GOSHEN, OH",
            disabled: false,
          },
          {
            name: "344, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "344, Kroger, League City, TX",
            disabled: false,
          },
          {
            name: "344, Kroger, RENO, NV",
            disabled: false,
          },
          {
            name: "344, Kroger, West Point, MS",
            disabled: false,
          },
          {
            name: "344, Target, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "344, Walmart, EL CAMPO, TX",
            disabled: false,
          },
          {
            name: "3440, CVS, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "3440, Rite Aid, NORWALK, CT",
            disabled: false,
          },
          {
            name: "3440, Walgreens, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "3441, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3441, Target, Mandeville, LA",
            disabled: false,
          },
          {
            name: "3441, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3442, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3442, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3442, Walmart, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "3443, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3443, Rite Aid, GRINDSTONE, PA",
            disabled: false,
          },
          {
            name: "3443, Walmart, RIVERDALE, NJ",
            disabled: false,
          },
          {
            name: "3444, Albertsons, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "3444, Walgreens, JACINTO CITY, TX",
            disabled: false,
          },
          {
            name: "3445, Albertsons, PALATINE, IL",
            disabled: false,
          },
          {
            name: "3445, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3445, Target, Yorba Linda, CA",
            disabled: false,
          },
          {
            name: "3445, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3445, Walmart, HOLLAND, OH",
            disabled: false,
          },
          {
            name: "3446, Albertsons, NILES, IL",
            disabled: false,
          },
          {
            name: "3446, CVS, HILLSBORO, OH",
            disabled: false,
          },
          {
            name: "3446, Target, Ontario, CA",
            disabled: false,
          },
          {
            name: "3446, Walgreens, SALINAS, CA",
            disabled: false,
          },
          {
            name: "3447, CVS, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3447, Rite Aid, GROVE CITY, PA",
            disabled: false,
          },
          {
            name: "3447, Target, Chicago, IL",
            disabled: false,
          },
          {
            name: "3447, Walgreens, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "3447, Walmart, WHITEHALL, OH",
            disabled: false,
          },
          {
            name: "3448, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "3448, Walgreens, MEQUON, WI",
            disabled: false,
          },
          {
            name: "3449, Albertsons, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "3449, Rite Aid, GREENVILLE, PA",
            disabled: false,
          },
          {
            name: "3449, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "3449, Walmart, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "345, ADUSA, LOCUST, NC",
            disabled: false,
          },
          {
            name: "345, CVS, CLOVERDALE, CA",
            disabled: false,
          },
          {
            name: "345, Costco, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "345, Kroger, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "345, Kroger, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "345, Kroger, JACKSON, MS",
            disabled: false,
          },
          {
            name: "345, Kroger, Merrillville, IN",
            disabled: false,
          },
          {
            name: "345, Kroger, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "345, Kroger, Somerset, KY",
            disabled: false,
          },
          {
            name: "345, Target, TIGARD, OR",
            disabled: false,
          },
          {
            name: "345, Walmart, PALESTINE, TX",
            disabled: false,
          },
          {
            name: "3450, Albertsons, MOUNT VERNON, WA",
            disabled: false,
          },
          {
            name: "3450, Walmart, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "3451, Albertsons, BARRINGTON, IL",
            disabled: false,
          },
          {
            name: "3451, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "3452, CVS, URBANA, OH",
            disabled: false,
          },
          {
            name: "3452, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3453, Albertsons, FOX LAKE, IL",
            disabled: false,
          },
          {
            name: "3453, Walmart, WYOMING, MI",
            disabled: false,
          },
          {
            name: "3454, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3454, CVS, LOGAN, OH",
            disabled: false,
          },
          {
            name: "3454, Rite Aid, HAMBURG, NY",
            disabled: false,
          },
          {
            name: "3454, Walmart, PERRY, UT",
            disabled: false,
          },
          {
            name: "3455, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3455, CVS, COSHOCTON, OH",
            disabled: false,
          },
          {
            name: "3455, Walgreens, RIVIERA BEACH, FL",
            disabled: false,
          },
          {
            name: "3455, Walmart, RICHMOND, CA",
            disabled: false,
          },
          {
            name: "3456, Albertsons, WILMETTE, IL",
            disabled: false,
          },
          {
            name: "3456, Walmart, HOPE MILLS, NC",
            disabled: false,
          },
          {
            name: "3457, CVS, NEW CARLISLE, OH",
            disabled: false,
          },
          {
            name: "3457, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3457, Walgreens, HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "3457, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "3458, CVS, BEAVERCREEK, OH",
            disabled: false,
          },
          {
            name: "3458, Walmart, WHITEHALL, MI",
            disabled: false,
          },
          {
            name: "3459, Albertsons, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "3459, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "3459, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3459, Walmart, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "346, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "346, CVS, SUFFERN, NY",
            disabled: false,
          },
          {
            name: "346, Costco, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "346, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "346, Kroger, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "346, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "346, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "346, Kroger, NATIONAL CITY, CA",
            disabled: false,
          },
          {
            name: "346, Target, CLACKAMAS, OR",
            disabled: false,
          },
          {
            name: "346, Walmart, AUGUSTA, KS",
            disabled: false,
          },
          {
            name: "3460, Albertsons, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "3460, CVS, BLACKSBURG, VA",
            disabled: false,
          },
          {
            name: "3460, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3460, Walmart, PEORIA, IL",
            disabled: false,
          },
          {
            name: "3461, Albertsons, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3461, CVS, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3461, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3461, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3461, Walmart, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "3462, CVS, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3462, Walmart, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "3463, CVS, LARGO, FL",
            disabled: false,
          },
          {
            name: "3463, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3463, Walmart, BRANDON, FL",
            disabled: false,
          },
          {
            name: "3464, Albertsons, GRAYSLAKE, IL",
            disabled: false,
          },
          {
            name: "3464, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3464, Walmart, CHINO, CA",
            disabled: false,
          },
          {
            name: "3465, Albertsons, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "3465, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3465, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3466, Albertsons, ANTIOCH, IL",
            disabled: false,
          },
          {
            name: "3466, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "3466, Rite Aid, GREENFIELD, OH",
            disabled: false,
          },
          {
            name: "3467, CVS, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3467, Walgreens, GRAND ISLAND, NE",
            disabled: false,
          },
          {
            name: "3468, CVS, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "3468, Rite Aid, CARROLLTON, OH",
            disabled: false,
          },
          {
            name: "3468, Walgreens, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "3469, Walgreens, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "3469, Walmart, LINDEN, NJ",
            disabled: false,
          },
          {
            name: "347, Costco, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "347, Kroger, Brownsville, TN",
            disabled: false,
          },
          {
            name: "347, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "347, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "347, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "347, Kroger, NORMAL, IL",
            disabled: false,
          },
          {
            name: "347, Kroger, ROCKY MOUNT, VA",
            disabled: false,
          },
          {
            name: "347, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "347, Rite Aid, WESTMINSTER, MD",
            disabled: false,
          },
          {
            name: "347, Target, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "347, Walmart, INDIANOLA, MS",
            disabled: false,
          },
          {
            name: "3470, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3470, Walgreens, HUNTINGTON STATION, NY",
            disabled: false,
          },
          {
            name: "3471, Albertsons, WILMETTE, IL",
            disabled: false,
          },
          {
            name: "3471, CVS, FREMONT, OH",
            disabled: false,
          },
          {
            name: "3471, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3471, Walmart, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "3472, CVS, CAMBRIDGE, OH",
            disabled: false,
          },
          {
            name: "3472, Walgreens, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "3472, Walmart, POST FALLS, ID",
            disabled: false,
          },
          {
            name: "3473, Albertsons, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "3473, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3473, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3474, Albertsons, PALATINE, IL",
            disabled: false,
          },
          {
            name: "3474, CVS, IRONTON, OH",
            disabled: false,
          },
          {
            name: "3474, Walmart, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "3475, Albertsons, DEERFIELD, IL",
            disabled: false,
          },
          {
            name: "3475, CVS, FAIRMONT, WV",
            disabled: false,
          },
          {
            name: "3475, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3475, Walmart, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "3476, Albertsons, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "3476, CVS, TIPP CITY, OH",
            disabled: false,
          },
          {
            name: "3476, Walgreens, VISALIA, CA",
            disabled: false,
          },
          {
            name: "3476, Walmart, CANTON, MI",
            disabled: false,
          },
          {
            name: "3477, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3477, CVS, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "3477, Rite Aid, SOMERSET, NJ",
            disabled: false,
          },
          {
            name: "3477, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3477, Walmart, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "3478, Albertsons, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3478, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3478, Walmart, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "3479, Albertsons, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "3479, Walmart, ROGERS, AR",
            disabled: false,
          },
          {
            name: "348, ADUSA, CLARKSVILLE, MD",
            disabled: false,
          },
          {
            name: "348, CVS, WETHERSFIELD, CT",
            disabled: false,
          },
          {
            name: "348, Costco, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "348, HEB, SANTA FE, TX",
            disabled: false,
          },
          {
            name: "348, Kroger, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "348, Kroger, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "348, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "348, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "348, Kroger, Milan, TN",
            disabled: false,
          },
          {
            name: "348, Kroger, Oak Creek, WI",
            disabled: false,
          },
          {
            name: "348, Target, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "348, Walmart, MONTICELLO, AR",
            disabled: false,
          },
          {
            name: "3480, Albertsons, STANWOOD, WA",
            disabled: false,
          },
          {
            name: "3480, CVS, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "3480, Walmart, LEBANON, VA",
            disabled: false,
          },
          {
            name: "3481, Albertsons, PARK RIDGE, IL",
            disabled: false,
          },
          {
            name: "3481, CVS, MARYSVILLE, OH",
            disabled: false,
          },
          {
            name: "3481, Walmart, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "3482, Albertsons, SNOHOMISH, WA",
            disabled: false,
          },
          {
            name: "3482, Rite Aid, NASHUA, NH",
            disabled: false,
          },
          {
            name: "3482, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "3483, Albertsons, DERRY, NH",
            disabled: false,
          },
          {
            name: "3483, Walmart, HOUMA, LA",
            disabled: false,
          },
          {
            name: "3484, Albertsons, NILES, IL",
            disabled: false,
          },
          {
            name: "3484, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "3484, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "3485, Albertsons, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "3485, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3485, Walmart, BLAIRSVILLE, GA",
            disabled: false,
          },
          {
            name: "3486, Albertsons, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "3486, CVS, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "3486, Rite Aid, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "3486, Walgreens, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "3486, Walmart, ATHENS, OH",
            disabled: false,
          },
          {
            name: "3487, Albertsons, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "3487, CVS, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "3487, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3487, Walmart, SHELBY TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "3488, Albertsons, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "3488, Walgreens, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "3488, Walmart, BURLINGTON, WI",
            disabled: false,
          },
          {
            name: "3489, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3489, CVS, PINEY FLATS, TN",
            disabled: false,
          },
          {
            name: "3489, Walgreens, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "3489, Walmart, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "349, ADUSA, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "349, CVS, WINDSOR, CT",
            disabled: false,
          },
          {
            name: "349, Costco, LENEXA, KS",
            disabled: false,
          },
          {
            name: "349, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "349, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "349, Kroger, SANTEE, CA",
            disabled: false,
          },
          {
            name: "349, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "349, Target, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "3490, Albertsons, LAKE FOREST, IL",
            disabled: false,
          },
          {
            name: "3490, CVS, WINTER SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3490, Walmart, HANOVER, MD",
            disabled: false,
          },
          {
            name: "3491, Albertsons, ROLLING MEADOWS, IL",
            disabled: false,
          },
          {
            name: "3491, CVS, SUN LAKES, AZ",
            disabled: false,
          },
          {
            name: "3491, Walgreens, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "3491, Walmart, METHUEN, MA",
            disabled: false,
          },
          {
            name: "3492, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3492, Walgreens, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "3492, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "3493, Albertsons, FERNDALE, WA",
            disabled: false,
          },
          {
            name: "3493, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3493, Walmart, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "3494, Walmart, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "3495, Albertsons, BENSENVILLE, IL",
            disabled: false,
          },
          {
            name: "3495, Rite Aid, ROYERSFORD, PA",
            disabled: false,
          },
          {
            name: "3495, Walgreens, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "3495, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "3496, Albertsons, CARY, IL",
            disabled: false,
          },
          {
            name: "3496, Rite Aid, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "3496, Walgreens, EVERETT, MA",
            disabled: false,
          },
          {
            name: "3497, Rite Aid, HOLLY, MI",
            disabled: false,
          },
          {
            name: "3497, Walgreens, EAU CLAIRE, WI",
            disabled: false,
          },
          {
            name: "3497, Walmart, PLYMOUTH, WI",
            disabled: false,
          },
          {
            name: "3498, Albertsons, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "3498, CVS, NEW BOSTON, OH",
            disabled: false,
          },
          {
            name: "3498, Walgreens, LA CROSSE, WI",
            disabled: false,
          },
          {
            name: "3498, Walmart, BLAINE, MN",
            disabled: false,
          },
          {
            name: "3499, CVS, NEW LEXINGTON, OH",
            disabled: false,
          },
          {
            name: "3499, Walgreens, ARVADA, CO",
            disabled: false,
          },
          {
            name: "3499, Walmart, JEFFERSON, WI",
            disabled: false,
          },
          {
            name: "35, ADUSA, HINGHAM, MA",
            disabled: false,
          },
          {
            name: "35, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "35, Albertsons, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "35, CVS, PORTERVILLE, CA",
            disabled: false,
          },
          {
            name: "35, Costco, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "35, Kroger, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "35, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "35, Kroger, San Diego, CA",
            disabled: false,
          },
          {
            name: "35, Kroger, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "35, Kroger, West Baden Springs, IN",
            disabled: false,
          },
          {
            name: "35, Kroger, Wichita, KS",
            disabled: false,
          },
          {
            name: "35, Meijer, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "35, Walmart, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "350, ADUSA, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "350, Albertsons, SANDPOINT, ID",
            disabled: false,
          },
          {
            name: "350, BJ's, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "350, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "350, Kroger, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "350, Kroger, GARDENA, CA",
            disabled: false,
          },
          {
            name: "350, Kroger, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "350, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "350, Kroger, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "350, ShopRite, VERNON, CT",
            disabled: false,
          },
          {
            name: "350, Target, FLINT, MI",
            disabled: false,
          },
          {
            name: "350, Walmart, YORK, NE",
            disabled: false,
          },
          {
            name: "3500, Albertsons, KENMORE, WA",
            disabled: false,
          },
          {
            name: "3500, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3500, Rite Aid, RANSOMVILLE, NY",
            disabled: false,
          },
          {
            name: "3500, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "3500, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3501, Albertsons, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "3501, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "3501, Walmart, ELVERSON, PA",
            disabled: false,
          },
          {
            name: "3502, CVS, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "3502, Walgreens, NEW HAVEN, IN",
            disabled: false,
          },
          {
            name: "3502, Walmart, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "3503, Albertsons, WOODSTOCK, IL",
            disabled: false,
          },
          {
            name: "3503, CVS, PULASKI, VA",
            disabled: false,
          },
          {
            name: "3503, Walmart, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "3504, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3504, Walmart, HICKORY, NC",
            disabled: false,
          },
          {
            name: "3505, Albertsons, MERRIMACK, NH",
            disabled: false,
          },
          {
            name: "3505, CVS, KYLE, TX",
            disabled: false,
          },
          {
            name: "3505, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3505, Walmart, WISCONSIN DELLS, WI",
            disabled: false,
          },
          {
            name: "3506, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3507, Albertsons, MELROSE, MA",
            disabled: false,
          },
          {
            name: "3507, Walgreens, PORT NECHES, TX",
            disabled: false,
          },
          {
            name: "3508, Albertsons, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "3508, CVS, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "3508, Rite Aid, BURGETTSTOWN, PA",
            disabled: false,
          },
          {
            name: "3508, Walgreens, WAKEFIELD, MA",
            disabled: false,
          },
          {
            name: "3508, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "3509, CVS, MADISON HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "3509, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3509, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "351, ADUSA, BURGAW, NC",
            disabled: false,
          },
          {
            name: "351, BJ's, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "351, CVS, NORTH PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "351, Costco, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "351, HEB, EDNA, TX",
            disabled: false,
          },
          {
            name: "351, Kroger, Cynthiana, KY",
            disabled: false,
          },
          {
            name: "351, Kroger, EAGLE RIVER, WI",
            disabled: false,
          },
          {
            name: "351, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "351, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "351, Kroger, Montgomery, OH",
            disabled: false,
          },
          {
            name: "351, Kroger, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "351, Kroger, San Francisco, CA",
            disabled: false,
          },
          {
            name: "351, Target, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "351, Walmart, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "3510, Albertsons, NASHUA, NH",
            disabled: false,
          },
          {
            name: "3510, Rite Aid, OTISVILLE, MI",
            disabled: false,
          },
          {
            name: "3510, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "3510, Walmart, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "3511, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "3511, Walmart, HAYDEN, ID",
            disabled: false,
          },
          {
            name: "3512, Albertsons, BANNING, CA",
            disabled: false,
          },
          {
            name: "3512, CVS, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "3512, Walgreens, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "3512, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3513, Albertsons, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "3513, CVS, DESTIN, FL",
            disabled: false,
          },
          {
            name: "3513, Walmart, SHAKOPEE, MN",
            disabled: false,
          },
          {
            name: "3514, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3514, CVS, STANLEY, NC",
            disabled: false,
          },
          {
            name: "3514, Walgreens, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "3514, Walmart, BRADFORD, PA",
            disabled: false,
          },
          {
            name: "3515, Albertsons, WAUCONDA, IL",
            disabled: false,
          },
          {
            name: "3515, CVS, APPOMATTOX, VA",
            disabled: false,
          },
          {
            name: "3515, Walmart, HILLSBORO, OH",
            disabled: false,
          },
          {
            name: "3516, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "3516, Walmart, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "3517, Albertsons, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "3517, Walmart, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "3518, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "3518, Walgreens, KENT, WA",
            disabled: false,
          },
          {
            name: "3518, Walmart, LAREDO, TX",
            disabled: false,
          },
          {
            name: "3519, Albertsons, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "3519, CVS, EAST PALATKA, FL",
            disabled: false,
          },
          {
            name: "3519, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "352, ADUSA, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "352, BJ's, ITHACA, NY",
            disabled: false,
          },
          {
            name: "352, CVS, FOREST HILL, MD",
            disabled: false,
          },
          {
            name: "352, Costco, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "352, Kroger, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "352, Kroger, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "352, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "352, Kroger, Richmond, CA",
            disabled: false,
          },
          {
            name: "352, Kroger, Waupaca, WI",
            disabled: false,
          },
          {
            name: "352, Walmart, CHESTER, IL",
            disabled: false,
          },
          {
            name: "3520, Albertsons, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "3520, CVS, APOLLO BEACH, FL",
            disabled: false,
          },
          {
            name: "3520, Rite Aid, SPARTA, MI",
            disabled: false,
          },
          {
            name: "3520, Walgreens, ROCHESTER, NH",
            disabled: false,
          },
          {
            name: "3520, Walmart, SECAUCUS, NJ",
            disabled: false,
          },
          {
            name: "3521, Albertsons, EAST WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "3521, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "3521, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "3521, Walmart, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "3522, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3522, Walmart, BALDWIN PARK, CA",
            disabled: false,
          },
          {
            name: "3523, Albertsons, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "3523, CVS, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "3523, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3523, Walgreens, DANBURY, CT",
            disabled: false,
          },
          {
            name: "3523, Walmart, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "3524, CVS, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "3524, Walgreens, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "3524, Walmart, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "3525, Albertsons, CHEHALIS, WA",
            disabled: false,
          },
          {
            name: "3525, CVS, NORTH WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "3525, Walgreens, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "3525, Walmart, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "3526, Albertsons, LAKE FOREST, CA",
            disabled: false,
          },
          {
            name: "3526, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3526, Walmart, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "3527, CVS, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "3527, Walgreens, NORTH MIAMI, FL",
            disabled: false,
          },
          {
            name: "3527, Walmart, PORT ST LUCIE, FL",
            disabled: false,
          },
          {
            name: "3528, Albertsons, BRISTOL, VT",
            disabled: false,
          },
          {
            name: "3528, CVS, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "3528, Walmart, WIGGINS, MS",
            disabled: false,
          },
          {
            name: "3529, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "3529, CVS, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "3529, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "353, ADUSA, ABERDEEN, NC",
            disabled: false,
          },
          {
            name: "353, ADUSA, TOWSON, MD",
            disabled: false,
          },
          {
            name: "353, BJ's, QUINCY, MA",
            disabled: false,
          },
          {
            name: "353, Costco, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "353, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "353, Kroger, MONROE, WI",
            disabled: false,
          },
          {
            name: "353, Kroger, Redwood City, CA",
            disabled: false,
          },
          {
            name: "353, Target, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "353, Walmart, GRAHAM, TX",
            disabled: false,
          },
          {
            name: "3530, Walgreens, VINCENNES, IN",
            disabled: false,
          },
          {
            name: "3530, Walmart, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "3531, Albertsons, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "3531, CVS, ROXBORO, NC",
            disabled: false,
          },
          {
            name: "3531, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3531, Walmart, LACEY, WA",
            disabled: false,
          },
          {
            name: "3532, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3533, Albertsons, WALPOLE, NH",
            disabled: false,
          },
          {
            name: "3533, CVS, EASLEY, SC",
            disabled: false,
          },
          {
            name: "3533, Walmart, DENVER, CO",
            disabled: false,
          },
          {
            name: "3534, Albertsons, ORANGE, CA",
            disabled: false,
          },
          {
            name: "3534, CVS, MARION, NC",
            disabled: false,
          },
          {
            name: "3534, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "3534, Walmart, RED WING, MN",
            disabled: false,
          },
          {
            name: "3535, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3535, Walmart, EPPING, NH",
            disabled: false,
          },
          {
            name: "3536, Walgreens, HIXSON, TN",
            disabled: false,
          },
          {
            name: "3537, CVS, SENECA, SC",
            disabled: false,
          },
          {
            name: "3537, Walgreens, EAST RIDGE, TN",
            disabled: false,
          },
          {
            name: "3537, Walmart, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "3538, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3538, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3538, Walmart, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "3539, CVS, DUNNELLON, FL",
            disabled: false,
          },
          {
            name: "3539, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "354, ADUSA, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "354, Albertsons, GOLETA, CA",
            disabled: false,
          },
          {
            name: "354, Costco, NAPLES, FL",
            disabled: false,
          },
          {
            name: "354, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "354, Kroger, North Hills, CA",
            disabled: false,
          },
          {
            name: "354, Kroger, PASADENA, TX",
            disabled: false,
          },
          {
            name: "354, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "354, Kroger, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "354, ShopRite, NEW LONDON, CT",
            disabled: false,
          },
          {
            name: "354, Target, CANTON, MI",
            disabled: false,
          },
          {
            name: "354, Walmart, OWENSVILLE, MO",
            disabled: false,
          },
          {
            name: "3540, Albertsons, DES MOINES, WA",
            disabled: false,
          },
          {
            name: "3540, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3541, Albertsons, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "3541, CVS, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "3541, Walmart, KENNETT SQUARE, PA",
            disabled: false,
          },
          {
            name: "3542, Albertsons, TIGARD, OR",
            disabled: false,
          },
          {
            name: "3542, CVS, NEWBERRY, SC",
            disabled: false,
          },
          {
            name: "3542, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3542, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3543, CVS, ABBEVILLE, SC",
            disabled: false,
          },
          {
            name: "3543, Walmart, DANBURY, CT",
            disabled: false,
          },
          {
            name: "3544, Albertsons, SOUTH PORTLAND, ME",
            disabled: false,
          },
          {
            name: "3544, CVS, ROCKY MOUNT, VA",
            disabled: false,
          },
          {
            name: "3544, Walgreens, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "3545, Albertsons, MILTON, WA",
            disabled: false,
          },
          {
            name: "3545, Walmart, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "3546, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3546, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "3546, Walmart, NEW MILFORD, CT",
            disabled: false,
          },
          {
            name: "3547, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "3547, Walmart, NORWALK, CT",
            disabled: false,
          },
          {
            name: "3548, Albertsons, ROCKLAND, ME",
            disabled: false,
          },
          {
            name: "3548, CVS, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "3548, Walgreens, STONEHAM, MA",
            disabled: false,
          },
          {
            name: "3548, Walmart, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "3549, CVS, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "3549, Walgreens, LINDENWOLD, NJ",
            disabled: false,
          },
          {
            name: "3549, Walmart, KEENE, NH",
            disabled: false,
          },
          {
            name: "355, Albertsons, CARPINTERIA, CA",
            disabled: false,
          },
          {
            name: "355, BJ's, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "355, CVS, NEWPORT, RI",
            disabled: false,
          },
          {
            name: "355, HEB, YOAKUM, TX",
            disabled: false,
          },
          {
            name: "355, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "355, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "355, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "355, Kroger, LAUREL, MS",
            disabled: false,
          },
          {
            name: "355, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "355, Kroger, MIDDLESBORO, KY",
            disabled: false,
          },
          {
            name: "355, Kroger, Raleigh, NC",
            disabled: false,
          },
          {
            name: "355, Kroger, SALEM, OR",
            disabled: false,
          },
          {
            name: "355, Kroger, Sacramento, CA",
            disabled: false,
          },
          {
            name: "355, ShopRite, PARSIPPANY, NJ",
            disabled: false,
          },
          {
            name: "355, Target, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "355, Walmart, OPELIKA, AL",
            disabled: false,
          },
          {
            name: "3551, Albertsons, WATERVILLE, ME",
            disabled: false,
          },
          {
            name: "3551, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3552, CVS, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3553, Albertsons, BEND, OR",
            disabled: false,
          },
          {
            name: "3553, CVS, CITY OF INDUSTRY, CA",
            disabled: false,
          },
          {
            name: "3554, Albertsons, DIAMOND BAR, CA",
            disabled: false,
          },
          {
            name: "3554, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3555, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3556, Walgreens, SEMINOLE, FL",
            disabled: false,
          },
          {
            name: "3557, Albertsons, ALOHA, OR",
            disabled: false,
          },
          {
            name: "3557, CVS, CLINTON, SC",
            disabled: false,
          },
          {
            name: "3558, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3559, Albertsons, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "3559, CVS, RUTHERFORDTON, NC",
            disabled: false,
          },
          {
            name: "3559, Walgreens, STERLING, IL",
            disabled: false,
          },
          {
            name: "356, ADUSA, MARION, VA",
            disabled: false,
          },
          {
            name: "356, CVS, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "356, Costco, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "356, Kroger, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "356, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "356, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "356, Kroger, MIDDLETOWN, KY",
            disabled: false,
          },
          {
            name: "356, Kroger, Yucca Valley, CA",
            disabled: false,
          },
          {
            name: "356, Target, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "356, Walmart, AUBURN, AL",
            disabled: false,
          },
          {
            name: "3560, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3560, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "3560, Walmart, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "3561, Albertsons, NEWTONVILLE, MA",
            disabled: false,
          },
          {
            name: "3561, Walmart, TEATICKET, MA",
            disabled: false,
          },
          {
            name: "3562, CVS, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "3562, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3562, Walmart, SADDLE BROOK, NJ",
            disabled: false,
          },
          {
            name: "3563, Albertsons, DUNCANVILLE, TX",
            disabled: false,
          },
          {
            name: "3563, CVS, HICKORY, NC",
            disabled: false,
          },
          {
            name: "3563, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3563, Walmart, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "3564, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "3564, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "3564, Walgreens, BROOKLINE, MA",
            disabled: false,
          },
          {
            name: "3564, Walmart, WILLOW GROVE, PA",
            disabled: false,
          },
          {
            name: "3565, CVS, CHERAW, SC",
            disabled: false,
          },
          {
            name: "3565, Walgreens, CUTLER BAY, FL",
            disabled: false,
          },
          {
            name: "3566, Albertsons, BROOKLINE, MA",
            disabled: false,
          },
          {
            name: "3566, CVS, BIG STONE GAP, VA",
            disabled: false,
          },
          {
            name: "3566, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "3566, Walmart, DENVER, CO",
            disabled: false,
          },
          {
            name: "3567, Albertsons, NORWOOD, MA",
            disabled: false,
          },
          {
            name: "3567, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "3567, Walgreens, OCONOMOWOC, WI",
            disabled: false,
          },
          {
            name: "3567, Walmart, HIDALGO, TX",
            disabled: false,
          },
          {
            name: "3568, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "3568, Walmart, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "3569, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3569, CVS, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "3569, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "357, ADUSA, BETHESDA, MD",
            disabled: false,
          },
          {
            name: "357, ADUSA, HUDSON, NC",
            disabled: false,
          },
          {
            name: "357, Albertsons, GOLETA, CA",
            disabled: false,
          },
          {
            name: "357, BJ's, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "357, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "357, Costco, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "357, Kroger, Apex, NC",
            disabled: false,
          },
          {
            name: "357, Kroger, CONROE, TX",
            disabled: false,
          },
          {
            name: "357, Kroger, GERMANTOWN, WI",
            disabled: false,
          },
          {
            name: "357, Kroger, Ridgeland, MS",
            disabled: false,
          },
          {
            name: "357, Kroger, SPARKS, NV",
            disabled: false,
          },
          {
            name: "357, Kroger, San Francisco, CA",
            disabled: false,
          },
          {
            name: "357, Target, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "357, Walmart, VERSAILLES, MO",
            disabled: false,
          },
          {
            name: "3570, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3570, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3570, Walmart, EVANS, GA",
            disabled: false,
          },
          {
            name: "3571, CVS, WEST PELZER, SC",
            disabled: false,
          },
          {
            name: "3571, Rite Aid, IMPERIAL, PA",
            disabled: false,
          },
          {
            name: "3571, Walgreens, SHAVANO PARK, TX",
            disabled: false,
          },
          {
            name: "3571, Walmart, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "3572, CVS, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "3572, Walgreens, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "3572, Walmart, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "3573, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "3573, Rite Aid, BEACHWOOD, NJ",
            disabled: false,
          },
          {
            name: "3573, Walmart, MANASSAS, VA",
            disabled: false,
          },
          {
            name: "3574, Albertsons, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "3574, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "3574, Walgreens, MARATHON, FL",
            disabled: false,
          },
          {
            name: "3574, Walmart, ALLEN, TX",
            disabled: false,
          },
          {
            name: "3575, Albertsons, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "3576, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3577, Albertsons, WEST ROXBURY, MA",
            disabled: false,
          },
          {
            name: "3578, CVS, BATESBURG, SC",
            disabled: false,
          },
          {
            name: "3578, Walgreens, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "3579, Albertsons, ALLEN, TX",
            disabled: false,
          },
          {
            name: "3579, CVS, OLDSMAR, FL",
            disabled: false,
          },
          {
            name: "3579, Walgreens, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "3579, Walmart, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "358, ADUSA, SEVERNA PARK, MD",
            disabled: false,
          },
          {
            name: "358, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "358, Costco, BRANDON, FL",
            disabled: false,
          },
          {
            name: "358, Kroger, Buford, GA",
            disabled: false,
          },
          {
            name: "358, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "358, Kroger, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "358, Kroger, POMONA, CA",
            disabled: false,
          },
          {
            name: "358, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "358, Target, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "358, Walmart, ALMA, AR",
            disabled: false,
          },
          {
            name: "3580, Albertsons, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "3580, Rite Aid, LIMA, OH",
            disabled: false,
          },
          {
            name: "3580, Walmart, NEWARK, OH",
            disabled: false,
          },
          {
            name: "3581, Albertsons, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "3581, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "3581, Walmart, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "3582, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3582, CVS, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "3582, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "3582, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3583, CVS, HUDSON, FL",
            disabled: false,
          },
          {
            name: "3583, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3583, Walmart, GLENMONT, NY",
            disabled: false,
          },
          {
            name: "3584, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3584, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3585, CVS, WALTERBORO, SC",
            disabled: false,
          },
          {
            name: "3585, Rite Aid, CLARENCE, NY",
            disabled: false,
          },
          {
            name: "3585, Walmart, SPRING, TX",
            disabled: false,
          },
          {
            name: "3586, CVS, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "3586, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3587, Albertsons, BLYTHE, CA",
            disabled: false,
          },
          {
            name: "3587, Walmart, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "3588, Albertsons, BOSTON, MA",
            disabled: false,
          },
          {
            name: "3588, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "3588, Walmart, DUMFRIES, VA",
            disabled: false,
          },
          {
            name: "3589, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "3589, Rite Aid, FARMINGTON, NH",
            disabled: false,
          },
          {
            name: "3589, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "3589, Walmart, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "359, ADUSA, CALIFORNIA, MD",
            disabled: false,
          },
          {
            name: "359, Albertsons, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "359, BJ's, DEER PARK, NY",
            disabled: false,
          },
          {
            name: "359, Costco, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "359, Kroger, BELLEVUE, KY",
            disabled: false,
          },
          {
            name: "359, Kroger, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "359, Kroger, Kingwood, TX",
            disabled: false,
          },
          {
            name: "359, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "359, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "359, Kroger, Mt. Vernon, IN",
            disabled: false,
          },
          {
            name: "359, Target, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "359, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "359, Walmart, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "3590, Albertsons, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "3590, Walgreens, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "3590, Walmart, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "3591, Albertsons, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "3591, CVS, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "3591, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "3591, Walmart, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "3592, Albertsons, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "3592, CVS, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "3593, Albertsons, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "3593, CVS, MONROE, NC",
            disabled: false,
          },
          {
            name: "3593, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3593, Walmart, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "3594, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "3594, Walmart, PANTEGO, TX",
            disabled: false,
          },
          {
            name: "3595, Albertsons, CENTRAL POINT, OR",
            disabled: false,
          },
          {
            name: "3595, Walgreens, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "3595, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "3596, CVS, BERKELEY HEIGHTS, NJ",
            disabled: false,
          },
          {
            name: "3596, Walmart, LOS LUNAS, NM",
            disabled: false,
          },
          {
            name: "3597, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3597, CVS, MANNING, SC",
            disabled: false,
          },
          {
            name: "3597, Rite Aid, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "3597, Walmart, BELVIDERE, IL",
            disabled: false,
          },
          {
            name: "3598, CVS, DOWNINGTOWN, PA",
            disabled: false,
          },
          {
            name: "3598, Walgreens, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "3598, Walmart, CEDAR KNOLLS, NJ",
            disabled: false,
          },
          {
            name: "3599, CVS, PENDLETON, SC",
            disabled: false,
          },
          {
            name: "3599, Walgreens, MADISON, TN",
            disabled: false,
          },
          {
            name: "3599, Walmart, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "36, ADUSA, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "36, Albertsons, IRVING, TX",
            disabled: false,
          },
          {
            name: "36, BJ's, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "36, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "36, Kroger, Fremont, OH",
            disabled: false,
          },
          {
            name: "36, Kroger, Mc Pherson, KS",
            disabled: false,
          },
          {
            name: "36, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "36, Meijer, WYOMING, MI",
            disabled: false,
          },
          {
            name: "36, Walmart, PARAGOULD, AR",
            disabled: false,
          },
          {
            name: "360, BJ's, GAINESVILLE, VA",
            disabled: false,
          },
          {
            name: "360, CVS, NORTH ARLINGTON, NJ",
            disabled: false,
          },
          {
            name: "360, Costco, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "360, Kroger, Franklin, WI",
            disabled: false,
          },
          {
            name: "360, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "360, Kroger, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "360, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "360, Kroger, Williamstown, KY",
            disabled: false,
          },
          {
            name: "360, Target, EAGAN, MN",
            disabled: false,
          },
          {
            name: "360, Walmart, CUSHING, OK",
            disabled: false,
          },
          {
            name: "3600, Albertsons, LAKE STEVENS, WA",
            disabled: false,
          },
          {
            name: "3600, Rite Aid, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "3600, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "3601, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3601, Walmart, CRESTWOOD, IL",
            disabled: false,
          },
          {
            name: "3602, CVS, LONGWOOD, FL",
            disabled: false,
          },
          {
            name: "3602, Rite Aid, NEW OXFORD, PA",
            disabled: false,
          },
          {
            name: "3602, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "3602, Walmart, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "3603, CVS, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "3603, Rite Aid, WELLSVILLE, OH",
            disabled: false,
          },
          {
            name: "3603, Walmart, FOREST, VA",
            disabled: false,
          },
          {
            name: "3604, Albertsons, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "3604, CVS, EDGEWATER, FL",
            disabled: false,
          },
          {
            name: "3604, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "3604, Walmart, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "3605, Walmart, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "3606, CVS, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "3606, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3606, Walmart, DEBARY, FL",
            disabled: false,
          },
          {
            name: "3607, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "3607, Rite Aid, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "3607, Walgreens, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "3607, Walmart, ALBION, NY",
            disabled: false,
          },
          {
            name: "3608, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3608, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "3608, Walgreens, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "3608, Walmart, MADISON, OH",
            disabled: false,
          },
          {
            name: "3609, CVS, WESTON, FL",
            disabled: false,
          },
          {
            name: "3609, Rite Aid, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "3609, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3609, Walmart, ELLENWOOD, GA",
            disabled: false,
          },
          {
            name: "361, ADUSA, UPPER MARLBORO, MD",
            disabled: false,
          },
          {
            name: "361, BJ's, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "361, Costco, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "361, Kroger, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "361, Kroger, LAWRENCEBURG, IN",
            disabled: false,
          },
          {
            name: "361, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "361, Kroger, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "361, Kroger, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "361, Kroger, Oxnard, CA",
            disabled: false,
          },
          {
            name: "361, Target, LANSING, MI",
            disabled: false,
          },
          {
            name: "361, Walmart, COLLINSVILLE, IL",
            disabled: false,
          },
          {
            name: "3610, Rite Aid, COLUMBIA, PA",
            disabled: false,
          },
          {
            name: "3610, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3611, Albertsons, BEDMINSTER, NJ",
            disabled: false,
          },
          {
            name: "3611, Rite Aid, ENOLA, PA",
            disabled: false,
          },
          {
            name: "3611, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "3612, Albertsons, BOONTON, NJ",
            disabled: false,
          },
          {
            name: "3612, CVS, OAK HILL, OH",
            disabled: false,
          },
          {
            name: "3612, Walmart, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "3613, Albertsons, SNOQUALMIE, WA",
            disabled: false,
          },
          {
            name: "3613, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "3614, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3614, CVS, DAYTONA BEACH SHORES, FL",
            disabled: false,
          },
          {
            name: "3614, Walmart, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "3615, Albertsons, CHATHAM, NJ",
            disabled: false,
          },
          {
            name: "3615, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3615, Walgreens, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "3615, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3616, Albertsons, CRESSKILL, NJ",
            disabled: false,
          },
          {
            name: "3616, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3616, Walmart, AMITE, LA",
            disabled: false,
          },
          {
            name: "3617, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3617, CVS, EASTON, PA",
            disabled: false,
          },
          {
            name: "3617, Walgreens, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "3617, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3618, Albertsons, FLORHAM PARK, NJ",
            disabled: false,
          },
          {
            name: "3618, CVS, HADDON HEIGHTS, NJ",
            disabled: false,
          },
          {
            name: "3618, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3619, Albertsons, GARDEN CITY, NY",
            disabled: false,
          },
          {
            name: "3619, CVS, ZEPHYRHILLS, FL",
            disabled: false,
          },
          {
            name: "3619, Rite Aid, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "3619, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "362, ADUSA, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "362, Albertsons, WOODRIDGE, IL",
            disabled: false,
          },
          {
            name: "362, CVS, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "362, Costco, HOOVER, AL",
            disabled: false,
          },
          {
            name: "362, Kroger, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "362, Kroger, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "362, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "362, Kroger, West Bloomfield, MI",
            disabled: false,
          },
          {
            name: "362, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "362, Target, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "362, Walmart, WINFIELD, AL",
            disabled: false,
          },
          {
            name: "3620, Albertsons, GARWOOD, NJ",
            disabled: false,
          },
          {
            name: "3620, CVS, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "3620, Rite Aid, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "3620, Walmart, RIVERTON, UT",
            disabled: false,
          },
          {
            name: "3621, Albertsons, IRVING, TX",
            disabled: false,
          },
          {
            name: "3621, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "3621, Walmart, CHAMBLEE, GA",
            disabled: false,
          },
          {
            name: "3622, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3622, CVS, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3622, Walgreens, ITASCA, IL",
            disabled: false,
          },
          {
            name: "3622, Walmart, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "3623, Albertsons, DESOTO, TX",
            disabled: false,
          },
          {
            name: "3623, Walgreens, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "3623, Walmart, LAREDO, TX",
            disabled: false,
          },
          {
            name: "3624, Albertsons, HILLSDALE, NJ",
            disabled: false,
          },
          {
            name: "3624, CVS, QUINCY, FL",
            disabled: false,
          },
          {
            name: "3624, Walmart, MONTICELLO, MN",
            disabled: false,
          },
          {
            name: "3625, Albertsons, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "3625, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3625, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "3625, Walmart, LAUDERDALE LAKES, FL",
            disabled: false,
          },
          {
            name: "3626, Albertsons, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "3626, CVS, BIG PINE KEY, FL",
            disabled: false,
          },
          {
            name: "3626, Walgreens, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "3626, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "3627, Walgreens, ALTON, IL",
            disabled: false,
          },
          {
            name: "3627, Walmart, OAKWOOD, GA",
            disabled: false,
          },
          {
            name: "3628, Albertsons, LIVINGSTON, NJ",
            disabled: false,
          },
          {
            name: "3628, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3628, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3628, Walmart, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "3629, Walgreens, HUDSON, FL",
            disabled: false,
          },
          {
            name: "3629, Walmart, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "363, ADUSA, DUNDALK, MD",
            disabled: false,
          },
          {
            name: "363, Albertsons, FLORENCE, OR",
            disabled: false,
          },
          {
            name: "363, Costco, BAYAMON, PR",
            disabled: false,
          },
          {
            name: "363, Kroger, COMMERCE TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "363, Kroger, HARRODSBURG, KY",
            disabled: false,
          },
          {
            name: "363, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "363, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "363, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "363, Kroger, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "363, Kroger, PEARL, MS",
            disabled: false,
          },
          {
            name: "363, Kroger, Russellville, KY",
            disabled: false,
          },
          {
            name: "363, Kroger, WAVERLY, OH",
            disabled: false,
          },
          {
            name: "363, Target, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "363, Walmart, MARSHALL, MO",
            disabled: false,
          },
          {
            name: "3630, Albertsons, MENDHAM, NJ",
            disabled: false,
          },
          {
            name: "3630, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3630, Walmart, MARION, IA",
            disabled: false,
          },
          {
            name: "3631, Albertsons, MIDLAND PARK, NJ",
            disabled: false,
          },
          {
            name: "3631, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3631, Walmart, CROWLEY, TX",
            disabled: false,
          },
          {
            name: "3632, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3632, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "3632, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "3632, Walmart, SANDUSKY, MI",
            disabled: false,
          },
          {
            name: "3633, Albertsons, UPPER MONTCLAIR, NJ",
            disabled: false,
          },
          {
            name: "3633, Walgreens, MOLINE, IL",
            disabled: false,
          },
          {
            name: "3633, Walmart, WAYNESBORO, PA",
            disabled: false,
          },
          {
            name: "3634, Albertsons, MORRISTOWN, NJ",
            disabled: false,
          },
          {
            name: "3634, CVS, CLEVELAND HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "3634, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3634, Walmart, TAMAQUA, PA",
            disabled: false,
          },
          {
            name: "3635, Albertsons, OLD GREENWICH, CT",
            disabled: false,
          },
          {
            name: "3635, CVS, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "3635, Rite Aid, CHESTER, VA",
            disabled: false,
          },
          {
            name: "3635, Walmart, FORT OGLETHORPE, GA",
            disabled: false,
          },
          {
            name: "3636, Albertsons, SHORT HILLS, NJ",
            disabled: false,
          },
          {
            name: "3636, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "3636, Walgreens, ORANGE, CA",
            disabled: false,
          },
          {
            name: "3637, Albertsons, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "3637, CVS, CALLAHAN, FL",
            disabled: false,
          },
          {
            name: "3637, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3637, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "3637, Walmart, YUKON, OK",
            disabled: false,
          },
          {
            name: "3638, Albertsons, SUMMIT, NJ",
            disabled: false,
          },
          {
            name: "3638, CVS, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "3638, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "3638, Walmart, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "3639, Albertsons, VERONA, NJ",
            disabled: false,
          },
          {
            name: "3639, CVS, BUSHNELL, FL",
            disabled: false,
          },
          {
            name: "3639, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "3639, Walmart, DULLES, VA",
            disabled: false,
          },
          {
            name: "364, ADUSA, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "364, CVS, MIDDLETOWN, CT",
            disabled: false,
          },
          {
            name: "364, Costco, BAYAMON, PR",
            disabled: false,
          },
          {
            name: "364, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "364, Kroger, DALEVILLE, VA",
            disabled: false,
          },
          {
            name: "364, Kroger, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "364, Kroger, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "364, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "364, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "364, Kroger, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "364, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "364, Kroger, Scottsville, KY",
            disabled: false,
          },
          {
            name: "364, Kroger, Versailles, KY",
            disabled: false,
          },
          {
            name: "364, Target, SCHOFIELD, WI",
            disabled: false,
          },
          {
            name: "364, Walmart, CENTER, TX",
            disabled: false,
          },
          {
            name: "3640, Albertsons, WHITEHOUSE STATION, NJ",
            disabled: false,
          },
          {
            name: "3640, CVS, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "3640, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3641, Albertsons, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "3641, Walmart, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "3642, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3642, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3643, CVS, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "3643, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3643, Walmart, MEDFORD, WI",
            disabled: false,
          },
          {
            name: "3644, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "3645, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "3645, Walgreens, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "3645, Walmart, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "3646, CVS, AUBURN, GA",
            disabled: false,
          },
          {
            name: "3646, Walmart, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "3647, CVS, VENICE, FL",
            disabled: false,
          },
          {
            name: "3647, Walgreens, NORMAN, OK",
            disabled: false,
          },
          {
            name: "3648, Albertsons, WAKEFIELD, MA",
            disabled: false,
          },
          {
            name: "3648, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3648, Walgreens, EDMOND, OK",
            disabled: false,
          },
          {
            name: "3648, Walmart, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "365, ADUSA, ABINGDON, MD",
            disabled: false,
          },
          {
            name: "365, BJ's, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "365, CVS, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "365, Costco, CAGUAS, BAIROA, PR",
            disabled: false,
          },
          {
            name: "365, Kroger, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "365, Kroger, Bakersfield, CA",
            disabled: false,
          },
          {
            name: "365, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "365, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "365, Kroger, Milwaukee, WI",
            disabled: false,
          },
          {
            name: "365, Kroger, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "365, Rite Aid, ELKTON, MD",
            disabled: false,
          },
          {
            name: "365, Target, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "365, Walmart, PEARL, MS",
            disabled: false,
          },
          {
            name: "3650, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3650, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3650, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3650, Walmart, VENTURA, CA",
            disabled: false,
          },
          {
            name: "3651, CVS, FLORAL PARK, NY",
            disabled: false,
          },
          {
            name: "3651, Walgreens, OLYMPIA FIELDS, IL",
            disabled: false,
          },
          {
            name: "3652, Albertsons, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "3652, CVS, PARKLAND, FL",
            disabled: false,
          },
          {
            name: "3652, Walgreens, FENTON, MO",
            disabled: false,
          },
          {
            name: "3652, Walmart, WEST SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "3653, CVS, INDIAN ROCKS BEACH, FL",
            disabled: false,
          },
          {
            name: "3653, Walmart, BURLESON, TX",
            disabled: false,
          },
          {
            name: "3654, Walmart, ROGERS, AR",
            disabled: false,
          },
          {
            name: "3655, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "3655, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3657, CVS, DELTONA, FL",
            disabled: false,
          },
          {
            name: "3657, Rite Aid, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "3657, Walgreens, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "3658, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3658, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3658, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "3659, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "366, ADUSA, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "366, Albertsons, RENTON, WA",
            disabled: false,
          },
          {
            name: "366, Costco, BUFORD, GA",
            disabled: false,
          },
          {
            name: "366, Kroger, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "366, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "366, Kroger, Florence, KY",
            disabled: false,
          },
          {
            name: "366, Kroger, HALES CORNERS, WI",
            disabled: false,
          },
          {
            name: "366, Kroger, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "366, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "366, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "366, Kroger, Norwalk, CA",
            disabled: false,
          },
          {
            name: "366, Kroger, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "366, Target, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "366, Walmart, MADISONVILLE, TN",
            disabled: false,
          },
          {
            name: "3660, CVS, VALRICO, FL",
            disabled: false,
          },
          {
            name: "3660, Walgreens, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "3660, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3661, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "3661, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3661, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3662, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3662, Walgreens, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "3663, CVS, INTERLACHEN, FL",
            disabled: false,
          },
          {
            name: "3663, Walgreens, BROOKHAVEN, PA",
            disabled: false,
          },
          {
            name: "3664, CVS, VALRICO, FL",
            disabled: false,
          },
          {
            name: "3665, CVS, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "3665, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "3666, CVS, ROCKLEDGE, FL",
            disabled: false,
          },
          {
            name: "3666, Walgreens, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "3667, CVS, LYNN HAVEN, FL",
            disabled: false,
          },
          {
            name: "3667, Rite Aid, BURTON, MI",
            disabled: false,
          },
          {
            name: "3668, CVS, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "3668, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3669, Albertsons, PLAISTOW, NH",
            disabled: false,
          },
          {
            name: "3669, Walgreens, SUN LAKES, AZ",
            disabled: false,
          },
          {
            name: "367, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "367, CVS, LIGHTHOUSE POINT, FL",
            disabled: false,
          },
          {
            name: "367, Costco, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "367, Kroger, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "367, Kroger, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "367, Kroger, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "367, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "367, Kroger, Long Beach, CA",
            disabled: false,
          },
          {
            name: "367, Kroger, WALTON, KY",
            disabled: false,
          },
          {
            name: "3670, CVS, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "3670, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "3671, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3671, Walgreens, MILPITAS, CA",
            disabled: false,
          },
          {
            name: "3672, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3672, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "3673, CVS, DELAND, FL",
            disabled: false,
          },
          {
            name: "3675, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "3677, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "3677, Walgreens, MIDDLETOWN, KY",
            disabled: false,
          },
          {
            name: "3678, CVS, ATHENS, GA",
            disabled: false,
          },
          {
            name: "3679, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "368, ADUSA, GAITHERSBURG, MD",
            disabled: false,
          },
          {
            name: "368, BJ's, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "368, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "368, Costco, SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "368, Kroger, Amelia, OH",
            disabled: false,
          },
          {
            name: "368, Kroger, Brookfield, WI",
            disabled: false,
          },
          {
            name: "368, Kroger, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "368, Kroger, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "368, Walmart, PARSONS, KS",
            disabled: false,
          },
          {
            name: "3680, Walgreens, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "3681, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3681, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3682, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3683, Walgreens, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "3685, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3685, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3686, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3687, Albertsons, EAST PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "3687, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "3687, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "3688, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3688, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3689, CVS, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "3689, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "369, CVS, WEST HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "369, Costco, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "369, Kroger, CAMPBELLSVILLE, KY",
            disabled: false,
          },
          {
            name: "369, Kroger, LA PUENTE, CA",
            disabled: false,
          },
          {
            name: "369, Kroger, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "369, Walmart, WINFIELD, KS",
            disabled: false,
          },
          {
            name: "3690, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3690, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3691, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "3692, Albertsons, SOUTH YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "3693, Walmart, SANTA ISABEL, PR",
            disabled: false,
          },
          {
            name: "3694, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3694, Walgreens, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "3696, Albertsons, BOSTON, MA",
            disabled: false,
          },
          {
            name: "3696, Walgreens, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "3697, CVS, ROCKY RIVER, OH",
            disabled: false,
          },
          {
            name: "3697, Rite Aid, EAST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "3698, Rite Aid, GLOUCESTER, VA",
            disabled: false,
          },
          {
            name: "3698, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3699, CVS, DEER PARK, TX",
            disabled: false,
          },
          {
            name: "3699, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "37, ADUSA, LEETSDALE, PA",
            disabled: false,
          },
          {
            name: "37, ADUSA, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "37, Albertsons, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "37, BJ's, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "37, CVS, CUMBERLAND, RI",
            disabled: false,
          },
          {
            name: "37, Kroger, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "37, Kroger, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "37, Walmart, FARMINGTON, MO",
            disabled: false,
          },
          {
            name: "370, CVS, WAYNE, PA",
            disabled: false,
          },
          {
            name: "370, Costco, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "370, HEB, MERCEDES, TX",
            disabled: false,
          },
          {
            name: "370, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "370, Kroger, CLEVELAND, MS",
            disabled: false,
          },
          {
            name: "370, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "370, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "370, Kroger, Snellville, GA",
            disabled: false,
          },
          {
            name: "370, Walmart, WELLINGTON, KS",
            disabled: false,
          },
          {
            name: "3700, CVS, BEVERLY HILLS, FL",
            disabled: false,
          },
          {
            name: "3700, Rite Aid, CANTON, OH",
            disabled: false,
          },
          {
            name: "3700, Walgreens, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "3700, Walmart, INDIAN TRAIL, NC",
            disabled: false,
          },
          {
            name: "3701, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "3701, Walmart, MOUNT OLIVE, NC",
            disabled: false,
          },
          {
            name: "3702, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "3702, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3703, CVS, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "3703, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "3703, Walmart, KENNER, LA",
            disabled: false,
          },
          {
            name: "3705, Rite Aid, HOPEWELL, VA",
            disabled: false,
          },
          {
            name: "3705, Walmart, YELM, WA",
            disabled: false,
          },
          {
            name: "3706, Rite Aid, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3707, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3708, CVS, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "3708, Walmart, SUISUN CITY, CA",
            disabled: false,
          },
          {
            name: "3709, CVS, COCOA, FL",
            disabled: false,
          },
          {
            name: "3709, Walmart, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "371, Albertsons, ENTERPRISE, OR",
            disabled: false,
          },
          {
            name: "371, BJ's, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "371, Costco, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "371, Kroger, Fuquay Varina, NC",
            disabled: false,
          },
          {
            name: "371, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "371, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "371, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "371, Kroger, MARTINS FERRY, OH",
            disabled: false,
          },
          {
            name: "371, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "371, Kroger, Sacramento, CA",
            disabled: false,
          },
          {
            name: "371, Walmart, GRANBURY, TX",
            disabled: false,
          },
          {
            name: "3710, Walgreens, LEMONT, IL",
            disabled: false,
          },
          {
            name: "3710, Walmart, DECATUR, GA",
            disabled: false,
          },
          {
            name: "3711, Albertsons, BALA CYNWYD, PA",
            disabled: false,
          },
          {
            name: "3711, CVS, JAMESTOWN, NC",
            disabled: false,
          },
          {
            name: "3712, Walmart, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "3713, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3713, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3713, Walmart, LADSON, SC",
            disabled: false,
          },
          {
            name: "3714, Walgreens, ALTON, IL",
            disabled: false,
          },
          {
            name: "3715, Rite Aid, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3716, Walgreens, KEARNEY, NE",
            disabled: false,
          },
          {
            name: "3716, Walmart, MANATI, PR",
            disabled: false,
          },
          {
            name: "3717, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3717, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "3718, CVS, ALLEN, TX",
            disabled: false,
          },
          {
            name: "3718, Walgreens, WARR ACRES, OK",
            disabled: false,
          },
          {
            name: "3719, Albertsons, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "3719, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "3719, Walgreens, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "372, ADUSA, KILMARNOCK, VA",
            disabled: false,
          },
          {
            name: "372, Costco, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "372, Kroger, JACKSON, TN",
            disabled: false,
          },
          {
            name: "372, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "372, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "372, Kroger, San Fernando, CA",
            disabled: false,
          },
          {
            name: "372, Kroger, THE DALLES, OR",
            disabled: false,
          },
          {
            name: "372, Walmart, DODGE CITY, KS",
            disabled: false,
          },
          {
            name: "3720, Albertsons, LOCKPORT, IL",
            disabled: false,
          },
          {
            name: "3720, Walmart, ARBUTUS, MD",
            disabled: false,
          },
          {
            name: "3721, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3721, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "3721, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3722, Albertsons, DRESHER, PA",
            disabled: false,
          },
          {
            name: "3722, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "3722, Walmart, KENT, OH",
            disabled: false,
          },
          {
            name: "3723, Albertsons, LA JUNTA, CO",
            disabled: false,
          },
          {
            name: "3723, CVS, OAK RIDGE, TN",
            disabled: false,
          },
          {
            name: "3723, Walgreens, UNIVERSITY PLACE, WA",
            disabled: false,
          },
          {
            name: "3723, Walmart, LOCUST GROVE, OK",
            disabled: false,
          },
          {
            name: "3724, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "3724, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "3724, Walmart, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "3725, Walmart, NILES, IL",
            disabled: false,
          },
          {
            name: "3726, CVS, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "3726, Rite Aid, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "3726, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3726, Walmart, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "3727, Albertsons, WALSENBURG, CO",
            disabled: false,
          },
          {
            name: "3727, CVS, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "3727, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3727, Walmart, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "3728, Albertsons, CANON CITY, CO",
            disabled: false,
          },
          {
            name: "3728, CVS, ATHENS, TN",
            disabled: false,
          },
          {
            name: "3728, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "3728, Walmart, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3729, Albertsons, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "3729, Walgreens, HANOVER PARK, IL",
            disabled: false,
          },
          {
            name: "3729, Walmart, SPARKS, NV",
            disabled: false,
          },
          {
            name: "373, ADUSA, DISTRICT HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "373, CVS, HOLYOKE, MA",
            disabled: false,
          },
          {
            name: "373, Costco, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "373, HEB, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "373, Kroger, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "373, Kroger, JONESBORO, GA",
            disabled: false,
          },
          {
            name: "373, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "373, Target, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "373, Walmart, HUNTSVILLE, AR",
            disabled: false,
          },
          {
            name: "3730, Albertsons, MINOOKA, IL",
            disabled: false,
          },
          {
            name: "3730, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3730, Walgreens, KERRVILLE, TX",
            disabled: false,
          },
          {
            name: "3730, Walmart, PRESCOTT VALLEY, AZ",
            disabled: false,
          },
          {
            name: "3731, Walgreens, PENNSAUKEN, NJ",
            disabled: false,
          },
          {
            name: "3731, Walmart, BERNALILLO, NM",
            disabled: false,
          },
          {
            name: "3732, Walgreens, SOUTH MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3732, Walmart, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "3733, Walmart, TEGA CAY, SC",
            disabled: false,
          },
          {
            name: "3734, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3734, Walmart, VERMILLION, SD",
            disabled: false,
          },
          {
            name: "3735, Albertsons, GLEN MILLS, PA",
            disabled: false,
          },
          {
            name: "3735, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3735, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3736, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "3736, Walmart, PINEVILLE, LA",
            disabled: false,
          },
          {
            name: "3737, Walgreens, NORTH PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "3738, Walgreens, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "3738, Walmart, NATRONA HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "3739, Albertsons, FEASTERVILLE TREVOSE, PA",
            disabled: false,
          },
          {
            name: "3739, Walmart, NAMPA, ID",
            disabled: false,
          },
          {
            name: "374, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "374, CVS, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "374, Costco, SHELBY TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "374, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "374, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "374, Kroger, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "374, Kroger, Pewaukee, WI",
            disabled: false,
          },
          {
            name: "374, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "374, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "374, Walmart, COWETA, OK",
            disabled: false,
          },
          {
            name: "3740, CVS, HARRIMAN, TN",
            disabled: false,
          },
          {
            name: "3740, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "3741, Albertsons, MORRIS, IL",
            disabled: false,
          },
          {
            name: "3741, Rite Aid, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "3741, Walgreens, AKRON, OH",
            disabled: false,
          },
          {
            name: "3741, Walmart, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "3742, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3742, Walmart, WOODLAND, WA",
            disabled: false,
          },
          {
            name: "3743, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "3743, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3743, Walmart, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "3744, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3745, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "3745, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3745, Walmart, MONROE, LA",
            disabled: false,
          },
          {
            name: "3746, CVS, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "3746, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3746, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "3747, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3747, Walmart, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "3748, CVS, APOPKA, FL",
            disabled: false,
          },
          {
            name: "3748, Rite Aid, DOVER, DE",
            disabled: false,
          },
          {
            name: "3748, Walgreens, DEL CITY, OK",
            disabled: false,
          },
          {
            name: "3748, Walmart, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "3749, CVS, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "3749, Rite Aid, MILFORD, DE",
            disabled: false,
          },
          {
            name: "3749, Walgreens, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "3749, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "375, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "375, CVS, DELMAR, NY",
            disabled: false,
          },
          {
            name: "375, Costco, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "375, Kroger, DECATUR, GA",
            disabled: false,
          },
          {
            name: "375, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "375, Kroger, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "375, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "375, Kroger, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "375, Kroger, Tigard, OR",
            disabled: false,
          },
          {
            name: "375, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "3750, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3750, Walgreens, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "3750, Walmart, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "3751, Rite Aid, CAMBRIDGE, MD",
            disabled: false,
          },
          {
            name: "3751, Walmart, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "3752, Walmart, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "3753, Albertsons, WAYNE, PA",
            disabled: false,
          },
          {
            name: "3753, CVS, SEMINOLE, FL",
            disabled: false,
          },
          {
            name: "3754, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "3754, Walmart, CHELAN, WA",
            disabled: false,
          },
          {
            name: "3755, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "3755, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3756, Rite Aid, DOVER, DE",
            disabled: false,
          },
          {
            name: "3756, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3757, CVS, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3757, Walmart, ARLINGTON, WA",
            disabled: false,
          },
          {
            name: "3758, CVS, WEEKI WACHEE, FL",
            disabled: false,
          },
          {
            name: "3758, Walgreens, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "3758, Walmart, CROOKSTON, MN",
            disabled: false,
          },
          {
            name: "3759, CVS, SWEDESBORO, NJ",
            disabled: false,
          },
          {
            name: "3759, Walgreens, CHELSEA, MA",
            disabled: false,
          },
          {
            name: "376, Costco, AUBURN HILLS, MI",
            disabled: false,
          },
          {
            name: "376, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "376, Kroger, LITHIA SPRINGS, GA",
            disabled: false,
          },
          {
            name: "376, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "376, Kroger, MAINEVILLE, OH",
            disabled: false,
          },
          {
            name: "376, Kroger, Mccomb, MS",
            disabled: false,
          },
          {
            name: "376, Kroger, Mitchell, IN",
            disabled: false,
          },
          {
            name: "376, Kroger, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "376, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "376, Walmart, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "3760, CVS, FORT OGLETHORPE, GA",
            disabled: false,
          },
          {
            name: "3760, Walgreens, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "3760, Walmart, NEW ULM, MN",
            disabled: false,
          },
          {
            name: "3761, Walmart, THIEF RIVER FALLS, MN",
            disabled: false,
          },
          {
            name: "3762, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "3762, Walmart, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "3763, Walgreens, WASHINGTON, IL",
            disabled: false,
          },
          {
            name: "3763, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3764, Walgreens, SOUTHAMPTON, PA",
            disabled: false,
          },
          {
            name: "3764, Walmart, LINDALE, TX",
            disabled: false,
          },
          {
            name: "3765, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3765, Walgreens, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "3765, Walmart, PIQUA, OH",
            disabled: false,
          },
          {
            name: "3766, CVS, DACULA, GA",
            disabled: false,
          },
          {
            name: "3766, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "3767, Albertsons, DOWNINGTOWN, PA",
            disabled: false,
          },
          {
            name: "3767, CVS, DALTON, GA",
            disabled: false,
          },
          {
            name: "3767, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "3768, CVS, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "3768, Walgreens, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "3768, Walmart, ALTAVISTA, VA",
            disabled: false,
          },
          {
            name: "3769, CVS, JEFFERSON CITY, TN",
            disabled: false,
          },
          {
            name: "3769, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "377, ADUSA, CONCORD, NC",
            disabled: false,
          },
          {
            name: "377, Albertsons, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "377, CVS, GROTON, CT",
            disabled: false,
          },
          {
            name: "377, Costco, SAINT LOUIS PAR, MN",
            disabled: false,
          },
          {
            name: "377, Kroger, Clinton, MS",
            disabled: false,
          },
          {
            name: "377, Kroger, FOREST, VA",
            disabled: false,
          },
          {
            name: "377, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "377, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "377, Kroger, PACOIMA, CA",
            disabled: false,
          },
          {
            name: "377, Kroger, TILLAMOOK, OR",
            disabled: false,
          },
          {
            name: "377, Walmart, SUMTER, SC",
            disabled: false,
          },
          {
            name: "3770, Albertsons, EAST MOLINE, IL",
            disabled: false,
          },
          {
            name: "3770, CVS, ROME, GA",
            disabled: false,
          },
          {
            name: "3770, Walgreens, EL CERRITO, CA",
            disabled: false,
          },
          {
            name: "3770, Walmart, STUART, VA",
            disabled: false,
          },
          {
            name: "3771, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "3771, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3772, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "3772, Walmart, JONESVILLE, VA",
            disabled: false,
          },
          {
            name: "3773, CVS, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "3773, Walgreens, URBANDALE, IA",
            disabled: false,
          },
          {
            name: "3773, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3774, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "3774, Walmart, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "3775, Albertsons, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "3775, Rite Aid, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "3775, Walgreens, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "3775, Walmart, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "3776, Albertsons, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "3776, CVS, ELBERTON, GA",
            disabled: false,
          },
          {
            name: "3776, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3777, CVS, MONROE, GA",
            disabled: false,
          },
          {
            name: "3777, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "3777, Walmart, FRISCO, TX",
            disabled: false,
          },
          {
            name: "3778, CVS, WAYNESBORO, GA",
            disabled: false,
          },
          {
            name: "3778, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3778, Walmart, CASPER, WY",
            disabled: false,
          },
          {
            name: "3779, CVS, KEY WEST, FL",
            disabled: false,
          },
          {
            name: "3779, Walgreens, MAYWOOD, IL",
            disabled: false,
          },
          {
            name: "378, ADUSA, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "378, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "378, Albertsons, NEWPORT, OR",
            disabled: false,
          },
          {
            name: "378, Costco, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "378, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "378, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "378, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "378, Kroger, RENO, NV",
            disabled: false,
          },
          {
            name: "378, Kroger, Racine, WI",
            disabled: false,
          },
          {
            name: "378, Walmart, HOLTON, KS",
            disabled: false,
          },
          {
            name: "3780, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "3780, Walmart, FALLSTON, MD",
            disabled: false,
          },
          {
            name: "3781, Rite Aid, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "3781, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "3782, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3782, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "3782, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3783, CVS, ATHENS, TN",
            disabled: false,
          },
          {
            name: "3783, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3783, Walmart, DAYTON, OH",
            disabled: false,
          },
          {
            name: "3784, Albertsons, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "3784, CVS, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "3784, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3784, Walmart, FRANKLIN, OH",
            disabled: false,
          },
          {
            name: "3785, CVS, GALAX, VA",
            disabled: false,
          },
          {
            name: "3785, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "3786, Albertsons, NEWTOWN SQUARE, PA",
            disabled: false,
          },
          {
            name: "3786, Walgreens, MOORE, OK",
            disabled: false,
          },
          {
            name: "3786, Walmart, BUFORD, GA",
            disabled: false,
          },
          {
            name: "3788, Albertsons, BRYN MAWR, PA",
            disabled: false,
          },
          {
            name: "3788, CVS, ISLAMORADA, FL",
            disabled: false,
          },
          {
            name: "3788, Walgreens, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "3788, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3789, CVS, CAPITOL HEIGHTS, MD",
            disabled: false,
          },
          {
            name: "3789, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "3789, Walmart, OGDEN, UT",
            disabled: false,
          },
          {
            name: "379, Albertsons, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "379, Costco, SPRINGDALE, OH",
            disabled: false,
          },
          {
            name: "379, Kroger, COMPTON, CA",
            disabled: false,
          },
          {
            name: "379, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "379, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "379, Kroger, MARSHFIELD, WI",
            disabled: false,
          },
          {
            name: "379, Walmart, OZARK, MO",
            disabled: false,
          },
          {
            name: "3790, Walmart, LOCKPORT, IL",
            disabled: false,
          },
          {
            name: "3791, CVS, GREENEVILLE, TN",
            disabled: false,
          },
          {
            name: "3791, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3791, Walmart, THREE RIVERS, MI",
            disabled: false,
          },
          {
            name: "3792, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "3792, CVS, ROGERSVILLE, TN",
            disabled: false,
          },
          {
            name: "3792, Walgreens, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "3792, Walmart, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "3793, CVS, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "3793, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "3794, CVS, SALEM, VA",
            disabled: false,
          },
          {
            name: "3794, Walgreens, GULFPORT, FL",
            disabled: false,
          },
          {
            name: "3794, Walmart, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "3795, CVS, WILTON, CT",
            disabled: false,
          },
          {
            name: "3795, Walgreens, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "3795, Walmart, NORTH BERGEN, NJ",
            disabled: false,
          },
          {
            name: "3796, Albertsons, CLIFTON HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "3796, Walgreens, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "3796, Walmart, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "3797, Albertsons, VISTA, CA",
            disabled: false,
          },
          {
            name: "3798, Albertsons, BROOMALL, PA",
            disabled: false,
          },
          {
            name: "3798, CVS, CORNELIA, GA",
            disabled: false,
          },
          {
            name: "3798, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "3799, CVS, BLUE BELL, PA",
            disabled: false,
          },
          {
            name: "3799, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "38, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "38, ADUSA, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "38, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "38, CVS, CHARLTON, MA",
            disabled: false,
          },
          {
            name: "38, Costco, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "38, HEB, SAN JUAN, TX",
            disabled: false,
          },
          {
            name: "38, Kroger, ARKANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "38, Kroger, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "38, Kroger, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "38, Kroger, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "38, Kroger, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "38, Walmart, IDABEL, OK",
            disabled: false,
          },
          {
            name: "380, Costco, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "380, Kroger, HILLSBORO, OH",
            disabled: false,
          },
          {
            name: "380, Kroger, MARION, IL",
            disabled: false,
          },
          {
            name: "380, Kroger, SUSSEX, WI",
            disabled: false,
          },
          {
            name: "3801, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "3801, Walgreens, OREGON CITY, OR",
            disabled: false,
          },
          {
            name: "3801, Walmart, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "3802, CVS, GREER, SC",
            disabled: false,
          },
          {
            name: "3802, Walgreens, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "3802, Walmart, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "3803, CVS, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "3803, Walgreens, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "3803, Walmart, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "3804, Rite Aid, NEWPORT, PA",
            disabled: false,
          },
          {
            name: "3804, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3804, Walmart, RANDALLSTOWN, MD",
            disabled: false,
          },
          {
            name: "3805, CVS, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "3805, Walmart, WOODLAND PARK, CO",
            disabled: false,
          },
          {
            name: "3806, CVS, LINCOLNTON, NC",
            disabled: false,
          },
          {
            name: "3806, Walmart, FAIRMONT, MN",
            disabled: false,
          },
          {
            name: "3807, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "3807, Walmart, BENSON, AZ",
            disabled: false,
          },
          {
            name: "3808, CVS, HICKORY, NC",
            disabled: false,
          },
          {
            name: "3809, CVS, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "3809, Walmart, UPPER SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "381, CVS, WYCKOFF, NJ",
            disabled: false,
          },
          {
            name: "381, Costco, BEDFORD PARK, IL",
            disabled: false,
          },
          {
            name: "381, HEB, HARKER HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "381, Kroger, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "381, Kroger, COVINGTON, KY",
            disabled: false,
          },
          {
            name: "381, Kroger, DULUTH, GA",
            disabled: false,
          },
          {
            name: "381, Kroger, Durham, NC",
            disabled: false,
          },
          {
            name: "381, Kroger, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "381, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "381, Kroger, MUSKEGO, WI",
            disabled: false,
          },
          {
            name: "381, Kroger, STARKVILLE, MS",
            disabled: false,
          },
          {
            name: "381, Walmart, COPPERAS COVE, TX",
            disabled: false,
          },
          {
            name: "3810, Walmart, EAST GREENVILLE, PA",
            disabled: false,
          },
          {
            name: "3811, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3811, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3812, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "3812, Walmart, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "3813, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "3814, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3814, Walgreens, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "3815, CVS, WADESBORO, NC",
            disabled: false,
          },
          {
            name: "3816, Albertsons, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "3816, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "3817, CVS, PARMA, OH",
            disabled: false,
          },
          {
            name: "3817, Walgreens, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "3817, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3818, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "3819, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "382, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "382, CVS, SOUTH WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "382, Costco, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "382, HEB, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "382, Kroger, New Berlin, WI",
            disabled: false,
          },
          {
            name: "382, Kroger, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "382, Walmart, OTTAWA, KS",
            disabled: false,
          },
          {
            name: "3820, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3821, CVS, HARTSVILLE, SC",
            disabled: false,
          },
          {
            name: "3821, Walgreens, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "3822, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "3822, Walgreens, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "3823, CVS, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "3823, Walmart, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "3824, Albertsons, OCEAN CITY, NJ",
            disabled: false,
          },
          {
            name: "3824, Walgreens, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "3824, Walmart, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "3825, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3825, Walgreens, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "3825, Walmart, HAVELOCK, NC",
            disabled: false,
          },
          {
            name: "3826, CVS, PORT ROYAL, SC",
            disabled: false,
          },
          {
            name: "3826, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3826, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "3827, Walgreens, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "3827, Walmart, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "3828, CVS, ELKIN, NC",
            disabled: false,
          },
          {
            name: "3828, Walgreens, STUART, FL",
            disabled: false,
          },
          {
            name: "3828, Walmart, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "3829, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3829, Walmart, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "383, ADUSA, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "383, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "383, Albertsons, MOSCOW, ID",
            disabled: false,
          },
          {
            name: "383, Costco, NILES, IL",
            disabled: false,
          },
          {
            name: "383, HEB, PORT ISABEL, TX",
            disabled: false,
          },
          {
            name: "383, Kroger, BRYAN, TX",
            disabled: false,
          },
          {
            name: "383, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "383, Kroger, Liberty Township, OH",
            disabled: false,
          },
          {
            name: "383, Kroger, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "383, Kroger, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "383, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "383, Walmart, SILSBEE, TX",
            disabled: false,
          },
          {
            name: "3830, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3830, Walmart, LITTLE EGG HARBOR, NJ",
            disabled: false,
          },
          {
            name: "3831, CVS, LOUISBURG, NC",
            disabled: false,
          },
          {
            name: "3831, Walmart, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "3832, CVS, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "3832, Walgreens, BROOKLYN PARK, MN",
            disabled: false,
          },
          {
            name: "3833, Walgreens, ELMWOOD PARK, IL",
            disabled: false,
          },
          {
            name: "3833, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "3834, CVS, MONCKS CORNER, SC",
            disabled: false,
          },
          {
            name: "3835, Albertsons, OCEAN VIEW, NJ",
            disabled: false,
          },
          {
            name: "3835, CVS, CROMWELL, CT",
            disabled: false,
          },
          {
            name: "3835, Walmart, OOLTEWAH, TN",
            disabled: false,
          },
          {
            name: "3836, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "3836, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "3837, CVS, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "3837, Rite Aid, POCOMOKE CITY, MD",
            disabled: false,
          },
          {
            name: "3837, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3837, Walmart, ROSCOE, IL",
            disabled: false,
          },
          {
            name: "3838, CVS, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "3838, Rite Aid, SPRINGVILLE, NY",
            disabled: false,
          },
          {
            name: "3838, Walgreens, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "3838, Walmart, TARENTUM, PA",
            disabled: false,
          },
          {
            name: "384, ADUSA, VERONA, VA",
            disabled: false,
          },
          {
            name: "384, ADUSA, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "384, Costco, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "384, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "384, Kroger, Bakersfield, CA",
            disabled: false,
          },
          {
            name: "384, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "384, Kroger, MUKWONAGO, WI",
            disabled: false,
          },
          {
            name: "384, Rite Aid, ELLICOTT CITY, MD",
            disabled: false,
          },
          {
            name: "384, Walmart, LUMBERTON, TX",
            disabled: false,
          },
          {
            name: "3840, Walgreens, BURIEN, WA",
            disabled: false,
          },
          {
            name: "3840, Walmart, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "3841, Albertsons, EASTON, MD",
            disabled: false,
          },
          {
            name: "3841, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3842, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3842, Walmart, MACEDON, NY",
            disabled: false,
          },
          {
            name: "3843, CVS, DILLON, SC",
            disabled: false,
          },
          {
            name: "3843, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3843, Walmart, DENTON, MD",
            disabled: false,
          },
          {
            name: "3844, CVS, UNION, SC",
            disabled: false,
          },
          {
            name: "3844, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3844, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3845, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3845, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3846, CVS, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "3846, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3846, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "3847, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "3847, Walgreens, IRVING, TX",
            disabled: false,
          },
          {
            name: "3847, Walmart, MESQUITE, NV",
            disabled: false,
          },
          {
            name: "3848, Walgreens, DEER PARK, TX",
            disabled: false,
          },
          {
            name: "3848, Walmart, SYRACUSE, UT",
            disabled: false,
          },
          {
            name: "3849, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "385, ADUSA, BEAR, DE",
            disabled: false,
          },
          {
            name: "385, Albertsons, COLVILLE, WA",
            disabled: false,
          },
          {
            name: "385, CVS, KEARNY, NJ",
            disabled: false,
          },
          {
            name: "385, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "385, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "385, Kroger, Highland, CA",
            disabled: false,
          },
          {
            name: "385, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "385, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "385, Kroger, Plain City, OH",
            disabled: false,
          },
          {
            name: "385, Kroger, TACOMA, WA",
            disabled: false,
          },
          {
            name: "385, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "385, Walmart, CUERO, TX",
            disabled: false,
          },
          {
            name: "3850, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "3850, Rite Aid, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "3850, Walmart, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "3851, CVS, CONWAY, SC",
            disabled: false,
          },
          {
            name: "3851, Rite Aid, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "3851, Walgreens, MENASHA, WI",
            disabled: false,
          },
          {
            name: "3851, Walmart, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "3852, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "3852, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3852, Walmart, UNICOI, TN",
            disabled: false,
          },
          {
            name: "3853, Albertsons, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "3853, CVS, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "3853, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3853, Walmart, HURON, SD",
            disabled: false,
          },
          {
            name: "3854, Albertsons, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "3855, CVS, MULLINS, SC",
            disabled: false,
          },
          {
            name: "3856, CVS, CONCORD, NC",
            disabled: false,
          },
          {
            name: "3856, Rite Aid, KENMORE, NY",
            disabled: false,
          },
          {
            name: "3857, Rite Aid, LATROBE, PA",
            disabled: false,
          },
          {
            name: "3857, Walgreens, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "3857, Walmart, MONONA, WI",
            disabled: false,
          },
          {
            name: "3858, Albertsons, TUCKERTON, NJ",
            disabled: false,
          },
          {
            name: "3858, Walmart, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "3859, Albertsons, CARSON, CA",
            disabled: false,
          },
          {
            name: "3859, Walgreens, DEPEW, NY",
            disabled: false,
          },
          {
            name: "386, ADUSA, ROCKY MOUNT, VA",
            disabled: false,
          },
          {
            name: "386, ADUSA, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "386, Albertsons, JUNCTION CITY, OR",
            disabled: false,
          },
          {
            name: "386, CVS, THOMPSONS STATION, TN",
            disabled: false,
          },
          {
            name: "386, Costco, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "386, Kroger, BEAUMONT, CA",
            disabled: false,
          },
          {
            name: "386, Kroger, POPLAR BLUFF, MO",
            disabled: false,
          },
          {
            name: "386, Kroger, Wales, WI",
            disabled: false,
          },
          {
            name: "386, Rite Aid, SEVERNA PARK, MD",
            disabled: false,
          },
          {
            name: "386, Walmart, JENNINGS, LA",
            disabled: false,
          },
          {
            name: "3860, CVS, BLACK MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "3860, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3860, Walmart, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3861, CVS, HAMPTON, SC",
            disabled: false,
          },
          {
            name: "3861, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "3861, Walmart, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "3862, CVS, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "3862, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3862, Walmart, HOLLY HILL, FL",
            disabled: false,
          },
          {
            name: "3863, CVS, LAKE CITY, SC",
            disabled: false,
          },
          {
            name: "3863, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3864, CVS, HOPE MILLS, NC",
            disabled: false,
          },
          {
            name: "3864, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "3864, Walmart, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "3866, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "3867, CVS, WILSON, NC",
            disabled: false,
          },
          {
            name: "3867, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "3867, Walmart, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "3868, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "3869, CVS, SALUDA, SC",
            disabled: false,
          },
          {
            name: "3869, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "3869, Walmart, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "387, ADUSA, REHOBOTH BEACH, DE",
            disabled: false,
          },
          {
            name: "387, ADUSA, TROY, NC",
            disabled: false,
          },
          {
            name: "387, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "387, Costco, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "387, HEB, ODESSA, TX",
            disabled: false,
          },
          {
            name: "387, Kroger, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "387, Kroger, OAK CREEK, WI",
            disabled: false,
          },
          {
            name: "387, Kroger, SAINT MATTHEWS, KY",
            disabled: false,
          },
          {
            name: "387, Kroger, Soledad, CA",
            disabled: false,
          },
          {
            name: "387, Walmart, CHANDLER, OK",
            disabled: false,
          },
          {
            name: "3870, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "3870, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3871, Rite Aid, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "3872, CVS, BEACH PARK, IL",
            disabled: false,
          },
          {
            name: "3872, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3872, Walmart, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "3873, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3874, CVS, ATHENS, GA",
            disabled: false,
          },
          {
            name: "3874, Walmart, DAWSONVILLE, GA",
            disabled: false,
          },
          {
            name: "3875, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "3875, Walgreens, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "3875, Walmart, WAHPETON, ND",
            disabled: false,
          },
          {
            name: "3876, CVS, CAYCE, SC",
            disabled: false,
          },
          {
            name: "3876, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "3876, Walgreens, MARION, IA",
            disabled: false,
          },
          {
            name: "3876, Walmart, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "3877, Walgreens, PARADISE, CA",
            disabled: false,
          },
          {
            name: "3877, Walmart, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "3878, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "3879, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "388, ADUSA, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "388, CVS, MADISON, CT",
            disabled: false,
          },
          {
            name: "388, Costco, OAK BROOK, IL",
            disabled: false,
          },
          {
            name: "388, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "388, Kroger, BRANDON, MS",
            disabled: false,
          },
          {
            name: "388, Kroger, ELKO, NV",
            disabled: false,
          },
          {
            name: "388, Kroger, Humble, TX",
            disabled: false,
          },
          {
            name: "388, Kroger, LONDON, OH",
            disabled: false,
          },
          {
            name: "388, Kroger, Oconomowoc, WI",
            disabled: false,
          },
          {
            name: "388, Kroger, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "388, ShopRite, DANBURY, CT",
            disabled: false,
          },
          {
            name: "388, Walmart, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "3880, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "3880, Walmart, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "3881, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "3881, Walgreens, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "3882, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "3882, Walgreens, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "3883, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "3883, Walgreens, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "3883, Walmart, KAPOLEI, HI",
            disabled: false,
          },
          {
            name: "3884, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3885, Walgreens, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "3885, Walmart, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "3886, Walgreens, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "3886, Walmart, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "3887, CVS, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "3887, Walmart, AVON PARK, FL",
            disabled: false,
          },
          {
            name: "3888, CVS, TRAVELERS REST, SC",
            disabled: false,
          },
          {
            name: "3888, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3889, CVS, RIVER FOREST, IL",
            disabled: false,
          },
          {
            name: "3889, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "3889, Walmart, APEX, NC",
            disabled: false,
          },
          {
            name: "389, ADUSA, HEMINGWAY, SC",
            disabled: false,
          },
          {
            name: "389, ADUSA, MILLVILLE, DE",
            disabled: false,
          },
          {
            name: "389, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "389, Kroger, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "389, Kroger, FONTANA, CA",
            disabled: false,
          },
          {
            name: "389, Kroger, GARDNERVILLE, NV",
            disabled: false,
          },
          {
            name: "389, Kroger, MAGNOLIA, TX",
            disabled: false,
          },
          {
            name: "389, Kroger, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "389, Kroger, PROSPECT, KY",
            disabled: false,
          },
          {
            name: "389, Walmart, EDMOND, OK",
            disabled: false,
          },
          {
            name: "3890, CVS, BRIGHTON, MA",
            disabled: false,
          },
          {
            name: "3890, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "3891, CVS, WEST UNION, SC",
            disabled: false,
          },
          {
            name: "3891, Walmart, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "3892, CVS, DENMARK, SC",
            disabled: false,
          },
          {
            name: "3893, CVS, BASSETT, VA",
            disabled: false,
          },
          {
            name: "3893, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "3893, Walmart, ZION, IL",
            disabled: false,
          },
          {
            name: "3894, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3894, Walgreens, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "3894, Walmart, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "3895, CVS, FARMVILLE, NC",
            disabled: false,
          },
          {
            name: "3896, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "3896, Walmart, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "3897, CVS, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "3897, Walgreens, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "3897, Walmart, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "3898, CVS, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "3898, Walgreens, WOONSOCKET, RI",
            disabled: false,
          },
          {
            name: "3899, CVS, BESSEMER CITY, NC",
            disabled: false,
          },
          {
            name: "3899, Walgreens, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "3899, Walmart, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "39, ADUSA, STONEHAM, MA",
            disabled: false,
          },
          {
            name: "39, ADUSA, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "39, Albertsons, MILES CITY, MT",
            disabled: false,
          },
          {
            name: "39, BJ's, NASHUA, NH",
            disabled: false,
          },
          {
            name: "39, HEB, BELTON, TX",
            disabled: false,
          },
          {
            name: "39, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "39, Kroger, EMPORIA, KS",
            disabled: false,
          },
          {
            name: "39, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "39, Walgreens, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "39, Walmart, FORT SCOTT, KS",
            disabled: false,
          },
          {
            name: "390, ADUSA, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "390, Albertsons, IDAHO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "390, Costco, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "390, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "390, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "390, Kroger, STOUGHTON, WI",
            disabled: false,
          },
          {
            name: "390, Kroger, TACOMA, WA",
            disabled: false,
          },
          {
            name: "390, Kroger, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "390, Kroger, WEST WENDOVER, NV",
            disabled: false,
          },
          {
            name: "390, Kroger, Wendover, NV",
            disabled: false,
          },
          {
            name: "390, Rite Aid, RANDALLSTOWN, MD",
            disabled: false,
          },
          {
            name: "390, Walmart, WAVERLY, TN",
            disabled: false,
          },
          {
            name: "3900, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3900, Walgreens, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "3901, CVS, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "3901, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "3903, CVS, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "3905, CVS, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "3905, Walgreens, WESTON, FL",
            disabled: false,
          },
          {
            name: "3906, Rite Aid, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "3907, Walgreens, SWANSEA, IL",
            disabled: false,
          },
          {
            name: "3908, CVS, TRACY, CA",
            disabled: false,
          },
          {
            name: "3908, Walgreens, JACKSON, NJ",
            disabled: false,
          },
          {
            name: "3909, CVS, EL DORADO HILLS, CA",
            disabled: false,
          },
          {
            name: "3909, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "391, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "391, Albertsons, NEWBURY PARK, CA",
            disabled: false,
          },
          {
            name: "391, Costco, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "391, Kroger, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "391, Kroger, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "391, Kroger, PARIS, TN",
            disabled: false,
          },
          {
            name: "391, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "391, Walmart, TUPELO, MS",
            disabled: false,
          },
          {
            name: "3910, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "3910, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3911, CVS, REDDING, CA",
            disabled: false,
          },
          {
            name: "3911, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "3912, Walgreens, CAVE CREEK, AZ",
            disabled: false,
          },
          {
            name: "3912, Walmart, LEDGEWOOD, NJ",
            disabled: false,
          },
          {
            name: "3913, Albertsons, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "3913, Walgreens, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "3913, Walmart, BLUE SPRINGS, MS",
            disabled: false,
          },
          {
            name: "3914, Albertsons, SILVER CITY, NM",
            disabled: false,
          },
          {
            name: "3914, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3914, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "3915, CVS, CHASE CITY, VA",
            disabled: false,
          },
          {
            name: "3915, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3916, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "3917, Walgreens, KINGSVILLE, TX",
            disabled: false,
          },
          {
            name: "3918, CVS, ROLESVILLE, NC",
            disabled: false,
          },
          {
            name: "3918, Walgreens, PEARL, MS",
            disabled: false,
          },
          {
            name: "3919, Albertsons, HAMILTON SQ, NJ",
            disabled: false,
          },
          {
            name: "3919, Albertsons, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "3919, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "392, CVS, KING GEORGE, VA",
            disabled: false,
          },
          {
            name: "392, Costco, BLOOMFIELD TWNS, MI",
            disabled: false,
          },
          {
            name: "392, Kroger, COVINGTON, KY",
            disabled: false,
          },
          {
            name: "392, Kroger, Columbus, WI",
            disabled: false,
          },
          {
            name: "392, Kroger, DAYTON, NV",
            disabled: false,
          },
          {
            name: "392, Kroger, DYERSBURG, TN",
            disabled: false,
          },
          {
            name: "392, Kroger, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "392, Walmart, WEATHERFORD, OK",
            disabled: false,
          },
          {
            name: "3920, Albertsons, PILESGROVE, NJ",
            disabled: false,
          },
          {
            name: "3920, Albertsons, WOODSTOWN, NJ",
            disabled: false,
          },
          {
            name: "3921, Albertsons, BARNEGAT, NJ",
            disabled: false,
          },
          {
            name: "3921, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3921, Walgreens, IRVING, TX",
            disabled: false,
          },
          {
            name: "3922, CVS, NORTON, VA",
            disabled: false,
          },
          {
            name: "3922, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "3923, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3924, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3925, CVS, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "3925, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "3926, Albertsons, LITCHFIELD PARK, AZ",
            disabled: false,
          },
          {
            name: "3926, Walgreens, NORTHFIELD, IL",
            disabled: false,
          },
          {
            name: "3927, CVS, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "3927, Walgreens, STREAMWOOD, IL",
            disabled: false,
          },
          {
            name: "3928, Walgreens, HAZEL CREST, IL",
            disabled: false,
          },
          {
            name: "3929, Walgreens, JOLIET, IL",
            disabled: false,
          },
          {
            name: "393, Albertsons, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "393, CVS, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "393, Costco, MADISON HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "393, Kroger, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "393, Kroger, Deforest, WI",
            disabled: false,
          },
          {
            name: "393, Kroger, MILLINGTON, TN",
            disabled: false,
          },
          {
            name: "393, Kroger, Tualatin, OR",
            disabled: false,
          },
          {
            name: "393, Walmart, JACKSON, TN",
            disabled: false,
          },
          {
            name: "3930, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "3930, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3931, Albertsons, YUMA, AZ",
            disabled: false,
          },
          {
            name: "3931, Walgreens, EDGEWATER, FL",
            disabled: false,
          },
          {
            name: "3932, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3932, CVS, FORT BRAGG, CA",
            disabled: false,
          },
          {
            name: "3932, Walgreens, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "3933, Walgreens, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3934, CVS, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "3934, Walgreens, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "3935, CVS, PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "3935, Walgreens, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "3935, Walmart, NARANJA, FL",
            disabled: false,
          },
          {
            name: "3937, CVS, RED BLUFF, CA",
            disabled: false,
          },
          {
            name: "3939, CVS, EUREKA, CA",
            disabled: false,
          },
          {
            name: "394, CVS, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "394, Costco, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "394, Kroger, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "394, Kroger, LA GRANGE, KY",
            disabled: false,
          },
          {
            name: "394, Kroger, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "394, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "394, Kroger, LILBURN, GA",
            disabled: false,
          },
          {
            name: "394, Kroger, MCFARLAND, WI",
            disabled: false,
          },
          {
            name: "394, Walmart, MOULTON, AL",
            disabled: false,
          },
          {
            name: "3940, CVS, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "3940, Walgreens, PALATINE, IL",
            disabled: false,
          },
          {
            name: "3941, Albertsons, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "3941, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "3941, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "3942, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "3942, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "3943, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "3943, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "3944, CVS, OAKDALE, CA",
            disabled: false,
          },
          {
            name: "3944, Walgreens, BRANFORD, CT",
            disabled: false,
          },
          {
            name: "3946, Walgreens, JOLIET, IL",
            disabled: false,
          },
          {
            name: "3947, CVS, AUBURN, CA",
            disabled: false,
          },
          {
            name: "3947, Walmart, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "3948, CVS, SPARKS, NV",
            disabled: false,
          },
          {
            name: "3948, Rite Aid, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "3948, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3949, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "3949, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "395, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "395, Kroger, BLANCHESTER, OH",
            disabled: false,
          },
          {
            name: "395, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "395, Kroger, New Albany, IN",
            disabled: false,
          },
          {
            name: "395, Walmart, MISSION, TX",
            disabled: false,
          },
          {
            name: "3950, CVS, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "3950, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3951, CVS, SOLANA BEACH, CA",
            disabled: false,
          },
          {
            name: "3953, CVS, HOLMES BEACH, FL",
            disabled: false,
          },
          {
            name: "3953, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "3954, Walgreens, RED BANK, TN",
            disabled: false,
          },
          {
            name: "3955, Walgreens, FARRAGUT, TN",
            disabled: false,
          },
          {
            name: "3956, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3957, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "3957, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "3958, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "3958, Walgreens, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "3959, CVS, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "3959, Walmart, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "396, CVS, GRANVILLE, OH",
            disabled: false,
          },
          {
            name: "396, Kroger, Amelia, OH",
            disabled: false,
          },
          {
            name: "396, Kroger, BALDWIN PARK, CA",
            disabled: false,
          },
          {
            name: "396, Kroger, Fort Atkinson, WI",
            disabled: false,
          },
          {
            name: "396, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "396, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "396, Kroger, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "396, ShopRite, DERBY, CT",
            disabled: false,
          },
          {
            name: "396, Walmart, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "3960, Albertsons, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "3960, CVS, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "3960, Walgreens, FOREST PARK, IL",
            disabled: false,
          },
          {
            name: "3961, Albertsons, BORDENTOWN, NJ",
            disabled: false,
          },
          {
            name: "3961, CVS, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "3961, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "3962, CVS, SELLERSBURG, IN",
            disabled: false,
          },
          {
            name: "3963, Albertsons, MAPLE SHADE, NJ",
            disabled: false,
          },
          {
            name: "3963, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "3963, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "3964, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "3964, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "3965, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3966, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "3966, Rite Aid, KALKASKA, MI",
            disabled: false,
          },
          {
            name: "3967, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "3967, Rite Aid, LANSING, MI",
            disabled: false,
          },
          {
            name: "3968, CVS, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "3969, Rite Aid, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "397, CVS, WEST WARWICK, RI",
            disabled: false,
          },
          {
            name: "397, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "397, Kroger, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "397, Kroger, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "397, Kroger, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "397, Kroger, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "397, Kroger, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "397, ShopRite, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "397, Target, WALKER, MI",
            disabled: false,
          },
          {
            name: "397, Walmart, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "3970, Albertsons, WEST DEPTFORD, NJ",
            disabled: false,
          },
          {
            name: "3970, Albertsons, WOODBURY, NJ",
            disabled: false,
          },
          {
            name: "3971, CVS, RICHEYVILLE, PA",
            disabled: false,
          },
          {
            name: "3971, Rite Aid, GRAFTON, VA",
            disabled: false,
          },
          {
            name: "3972, CVS, WHITING, NJ",
            disabled: false,
          },
          {
            name: "3972, Rite Aid, SHARON, PA",
            disabled: false,
          },
          {
            name: "3973, CVS, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "3974, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "3975, CVS, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "3976, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "3977, CVS, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "3978, CVS, MILFORD, OH",
            disabled: false,
          },
          {
            name: "3979, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "398, ADUSA, BISHOPVILLE, SC",
            disabled: false,
          },
          {
            name: "398, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "398, Kroger, JACKSON, TN",
            disabled: false,
          },
          {
            name: "398, Kroger, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "398, Kroger, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "398, Kroger, NASHOTAH, WI",
            disabled: false,
          },
          {
            name: "398, Walmart, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "3980, CVS, KENT, OH",
            disabled: false,
          },
          {
            name: "3981, CVS, TAVERNIER, FL",
            disabled: false,
          },
          {
            name: "3982, CVS, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "3983, Rite Aid, BATH, NY",
            disabled: false,
          },
          {
            name: "3984, CVS, PINECREST, FL",
            disabled: false,
          },
          {
            name: "3985, CVS, OXFORD, NC",
            disabled: false,
          },
          {
            name: "3987, CVS, GRANTSBORO, NC",
            disabled: false,
          },
          {
            name: "3988, CVS, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "3988, Walgreens, SEMINOLE, FL",
            disabled: false,
          },
          {
            name: "3988, Walmart, SPANISH FORK, UT",
            disabled: false,
          },
          {
            name: "3989, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "3989, Walgreens, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "399, ADUSA, RADFORD, VA",
            disabled: false,
          },
          {
            name: "399, Kroger, Griffin, GA",
            disabled: false,
          },
          {
            name: "399, Kroger, HARDY, VA",
            disabled: false,
          },
          {
            name: "399, Kroger, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "399, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "399, Kroger, Marysville, OH",
            disabled: false,
          },
          {
            name: "399, Walmart, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "3990, Walgreens, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "3990, Walmart, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "3991, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "3991, Target, Woodbury, MN",
            disabled: false,
          },
          {
            name: "3991, Walgreens, ROCK ISLAND, IL",
            disabled: false,
          },
          {
            name: "3992, CVS, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "3993, Albertsons, LONG BEACH TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "3993, Walgreens, CAROL STREAM, IL",
            disabled: false,
          },
          {
            name: "3994, Albertsons, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "3994, Walgreens, VILLA PARK, IL",
            disabled: false,
          },
          {
            name: "3995, CVS, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "3995, Walgreens, NORTHLAKE, IL",
            disabled: false,
          },
          {
            name: "3996, CVS, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "3996, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "3997, Albertsons, BRIGANTINE, NJ",
            disabled: false,
          },
          {
            name: "3997, CVS, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "3997, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "3998, CVS, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "3999, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "3999, CVS, CARNEGIE, PA",
            disabled: false,
          },
          {
            name: "4, ADUSA, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "4, ADUSA, ROSLINDALE, MA",
            disabled: false,
          },
          {
            name: "4, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4, Costco, MURRAY, UT",
            disabled: false,
          },
          {
            name: "4, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "4, Kroger, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "4, Kroger, LAGUNA BEACH, CA",
            disabled: false,
          },
          {
            name: "4, Kroger, Nashville, TN",
            disabled: false,
          },
          {
            name: "4, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "4, Target, DULUTH, MN",
            disabled: false,
          },
          {
            name: "4, Walmart, SILOAM SPRINGS, AR",
            disabled: false,
          },
          {
            name: "40, ADUSA, CARY, NC",
            disabled: false,
          },
          {
            name: "40, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "40, Kroger, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "40, Kroger, LEAVENWORTH, KS",
            disabled: false,
          },
          {
            name: "40, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "40, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "40, Kroger, Pico Rivera, CA",
            disabled: false,
          },
          {
            name: "40, Walmart, MOBERLY, MO",
            disabled: false,
          },
          {
            name: "400, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "400, CVS, CHELMSFORD, MA",
            disabled: false,
          },
          {
            name: "400, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "400, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "400, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "400, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "400, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "400, Walmart, CONROE, TX",
            disabled: false,
          },
          {
            name: "4000, CVS, INDIANA, PA",
            disabled: false,
          },
          {
            name: "4001, Albertsons, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "4001, Costco, KENT, WA",
            disabled: false,
          },
          {
            name: "4001, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "4002, Albertsons, BURKE, VA",
            disabled: false,
          },
          {
            name: "4003, Walgreens, DAVIE, FL",
            disabled: false,
          },
          {
            name: "4004, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4004, Rite Aid, WHITEHALL, PA",
            disabled: false,
          },
          {
            name: "4004, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "4005, Albertsons, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4005, Walgreens, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "4006, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4007, Albertsons, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "4007, Walgreens, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "4008, Albertsons, HELENA, MT",
            disabled: false,
          },
          {
            name: "4009, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4009, Walgreens, HILLSIDE, IL",
            disabled: false,
          },
          {
            name: "401, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "401, HEB, KINGSVILLE, TX",
            disabled: false,
          },
          {
            name: "401, Kroger, Grand Junction, CO",
            disabled: false,
          },
          {
            name: "401, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "401, Kroger, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "401, Kroger, SHAWANO, WI",
            disabled: false,
          },
          {
            name: "401, Walmart, PLAQUEMINE, LA",
            disabled: false,
          },
          {
            name: "4010, Rite Aid, LEXINGTON, OH",
            disabled: false,
          },
          {
            name: "4011, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4011, Rite Aid, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "4011, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4012, ADUSA, HERMITAGE, PA",
            disabled: false,
          },
          {
            name: "4012, Albertsons, GLASGOW, MT",
            disabled: false,
          },
          {
            name: "4012, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4013, Albertsons, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "4013, CVS, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "4013, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4014, Walgreens, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "4015, CVS, CRESTVIEW, FL",
            disabled: false,
          },
          {
            name: "4016, ADUSA, BOLIVAR, OH",
            disabled: false,
          },
          {
            name: "4017, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4017, CVS, PASADENA, MD",
            disabled: false,
          },
          {
            name: "4017, Walgreens, SHERWOOD, AR",
            disabled: false,
          },
          {
            name: "4018, ADUSA, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "4018, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "4018, CVS, FALLSTON, MD",
            disabled: false,
          },
          {
            name: "4018, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "402, ADUSA, KINGSTON, MA",
            disabled: false,
          },
          {
            name: "402, Albertsons, OAK HARBOR, WA",
            disabled: false,
          },
          {
            name: "402, Kroger, BLACKSBURG, VA",
            disabled: false,
          },
          {
            name: "402, Kroger, CANTON, GA",
            disabled: false,
          },
          {
            name: "402, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "402, Kroger, IRVING, TX",
            disabled: false,
          },
          {
            name: "402, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "402, Kroger, Saint Louis, MO",
            disabled: false,
          },
          {
            name: "402, Kroger, Shiprock, NM",
            disabled: false,
          },
          {
            name: "402, Kroger, WINCHESTER, KY",
            disabled: false,
          },
          {
            name: "402, Walmart, BREAUX BRIDGE, LA",
            disabled: false,
          },
          {
            name: "4020, CVS, NOTTINGHAM, PA",
            disabled: false,
          },
          {
            name: "4020, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "4021, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "4021, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4022, Albertsons, ANACONDA, MT",
            disabled: false,
          },
          {
            name: "4022, Rite Aid, NEW HAVEN, MI",
            disabled: false,
          },
          {
            name: "4023, Albertsons, GLENDIVE, MT",
            disabled: false,
          },
          {
            name: "4023, Walgreens, AUBURNDALE, FL",
            disabled: false,
          },
          {
            name: "4024, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4024, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4024, Walgreens, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "4025, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "4025, Walgreens, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "4026, CVS, CLEMSON, SC",
            disabled: false,
          },
          {
            name: "4026, Walgreens, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "4027, CVS, CENTURY, FL",
            disabled: false,
          },
          {
            name: "4027, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4029, ADUSA, AKRON, OH",
            disabled: false,
          },
          {
            name: "4029, Albertsons, HICKORY HILLS, IL",
            disabled: false,
          },
          {
            name: "4029, Walgreens, SUFFERN, NY",
            disabled: false,
          },
          {
            name: "403, Costco, SANTEE, CA",
            disabled: false,
          },
          {
            name: "403, HEB, GATESVILLE, TX",
            disabled: false,
          },
          {
            name: "403, Kroger, Appleton, WI",
            disabled: false,
          },
          {
            name: "403, Kroger, Campbellsville, KY",
            disabled: false,
          },
          {
            name: "403, Kroger, GARLAND, TX",
            disabled: false,
          },
          {
            name: "403, Kroger, Montrose, CO",
            disabled: false,
          },
          {
            name: "403, Kroger, Waynesboro, VA",
            disabled: false,
          },
          {
            name: "403, Walmart, RUSSELLVILLE, AL",
            disabled: false,
          },
          {
            name: "4030, ADUSA, TALLMADGE, OH",
            disabled: false,
          },
          {
            name: "4030, Albertsons, NEWARK, DE",
            disabled: false,
          },
          {
            name: "4030, CVS, REISTERSTOWN, MD",
            disabled: false,
          },
          {
            name: "4031, ADUSA, BARBERTON, OH",
            disabled: false,
          },
          {
            name: "4031, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "4032, ADUSA, STOW, OH",
            disabled: false,
          },
          {
            name: "4032, Walgreens, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "4033, Albertsons, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4033, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "4033, Walgreens, VENICE, FL",
            disabled: false,
          },
          {
            name: "4034, ADUSA, CANTON, OH",
            disabled: false,
          },
          {
            name: "4034, Walgreens, VALRICO, FL",
            disabled: false,
          },
          {
            name: "4037, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "4038, ADUSA, ERIE, PA",
            disabled: false,
          },
          {
            name: "4038, CVS, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "4038, Walgreens, ROSEMOUNT, MN",
            disabled: false,
          },
          {
            name: "4039, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "404, ADUSA, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "404, CVS, PLANT CITY, FL",
            disabled: false,
          },
          {
            name: "404, HEB, BEE CAVE, TX",
            disabled: false,
          },
          {
            name: "404, Kroger, Delta, CO",
            disabled: false,
          },
          {
            name: "404, Kroger, FLINT, MI",
            disabled: false,
          },
          {
            name: "404, Kroger, LEXINGTON, VA",
            disabled: false,
          },
          {
            name: "404, Kroger, MOSINEE, WI",
            disabled: false,
          },
          {
            name: "404, Kroger, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "404, Kroger, Saint Ann, MO",
            disabled: false,
          },
          {
            name: "404, Kroger, Savannah, GA",
            disabled: false,
          },
          {
            name: "404, Walmart, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "4040, Albertsons, HAMILTON, MT",
            disabled: false,
          },
          {
            name: "4040, Walgreens, CARY, IL",
            disabled: false,
          },
          {
            name: "4041, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "4041, CVS, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "4041, Walgreens, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "4042, Walgreens, DEKALB, IL",
            disabled: false,
          },
          {
            name: "4043, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4043, CVS, LOS ALAMITOS, CA",
            disabled: false,
          },
          {
            name: "4043, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "4044, Walgreens, CANTON, OH",
            disabled: false,
          },
          {
            name: "4045, CVS, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "4045, Rite Aid, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "4045, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4046, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4046, Walmart, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4047, Albertsons, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "4047, CVS, BLACKWOOD, NJ",
            disabled: false,
          },
          {
            name: "4047, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "4048, Walmart, PRAIRIEVILLE, LA",
            disabled: false,
          },
          {
            name: "4049, Walgreens, EL SOBRANTE, CA",
            disabled: false,
          },
          {
            name: "4049, Walmart, OLYMPIA FIELDS, IL",
            disabled: false,
          },
          {
            name: "405, ADUSA, FRANKLIN, VA",
            disabled: false,
          },
          {
            name: "405, Costco, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "405, Kroger, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "405, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "405, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "405, Kroger, Farmville, VA",
            disabled: false,
          },
          {
            name: "405, Kroger, Glenwood Springs, CO",
            disabled: false,
          },
          {
            name: "405, Kroger, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "405, Kroger, WAUSAU, WI",
            disabled: false,
          },
          {
            name: "405, Walmart, LEESVILLE, LA",
            disabled: false,
          },
          {
            name: "4050, ADUSA, GIRARD, PA",
            disabled: false,
          },
          {
            name: "4050, Walgreens, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "4051, ADUSA, WARREN, OH",
            disabled: false,
          },
          {
            name: "4051, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "4053, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "4054, CVS, NORTH ROYALTON, OH",
            disabled: false,
          },
          {
            name: "4054, Walgreens, IRVING, TX",
            disabled: false,
          },
          {
            name: "4054, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "4055, CVS, ALIQUIPPA, PA",
            disabled: false,
          },
          {
            name: "4055, Walgreens, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "4055, Walmart, UNIVERSAL CITY, TX",
            disabled: false,
          },
          {
            name: "4056, ADUSA, WARREN, OH",
            disabled: false,
          },
          {
            name: "4056, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4056, Walmart, CONVERSE, TX",
            disabled: false,
          },
          {
            name: "4057, Albertsons, FRANKLIN PARK, IL",
            disabled: false,
          },
          {
            name: "4057, CVS, HINCKLEY, OH",
            disabled: false,
          },
          {
            name: "4057, Walmart, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "4058, CVS, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "4058, Walgreens, EAST ELMHURST, NY",
            disabled: false,
          },
          {
            name: "4059, Walgreens, MAGNOLIA, NJ",
            disabled: false,
          },
          {
            name: "406, ADUSA, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "406, Albertsons, FOREST GROVE, OR",
            disabled: false,
          },
          {
            name: "406, CVS, PUNTA GORDA, FL",
            disabled: false,
          },
          {
            name: "406, Kroger, APPOMATTOX, VA",
            disabled: false,
          },
          {
            name: "406, Kroger, BATESVILLE, IN",
            disabled: false,
          },
          {
            name: "406, Kroger, BURTON, MI",
            disabled: false,
          },
          {
            name: "406, Kroger, Durango, CO",
            disabled: false,
          },
          {
            name: "406, Kroger, Schofield, WI",
            disabled: false,
          },
          {
            name: "406, Rite Aid, MILFORD, NH",
            disabled: false,
          },
          {
            name: "406, Walmart, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "4060, ADUSA, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "4060, Albertsons, BURBANK, IL",
            disabled: false,
          },
          {
            name: "4060, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "4061, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4062, CVS, MADISON, FL",
            disabled: false,
          },
          {
            name: "4063, CVS, SMITHFIELD, VA",
            disabled: false,
          },
          {
            name: "4063, Rite Aid, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "4063, Walmart, FORT MYERS BEACH, FL",
            disabled: false,
          },
          {
            name: "4064, Rite Aid, ALOHA, OR",
            disabled: false,
          },
          {
            name: "4064, Walgreens, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "4064, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4065, Walgreens, SEDONA, AZ",
            disabled: false,
          },
          {
            name: "4065, Walmart, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "4066, CVS, LATROBE, PA",
            disabled: false,
          },
          {
            name: "4066, Walgreens, YUKON, OK",
            disabled: false,
          },
          {
            name: "4067, Rite Aid, WASHOUGAL, WA",
            disabled: false,
          },
          {
            name: "4067, Walgreens, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "4068, CVS, HAUGHTON, LA",
            disabled: false,
          },
          {
            name: "4068, Rite Aid, WASHINGTON, MI",
            disabled: false,
          },
          {
            name: "4068, Walmart, SPANISH FORK, UT",
            disabled: false,
          },
          {
            name: "4069, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "4069, Walgreens, WEST CHICAGO, IL",
            disabled: false,
          },
          {
            name: "407, ADUSA, SAUGUS, MA",
            disabled: false,
          },
          {
            name: "407, CVS, ROCKVILLE CENTRE, NY",
            disabled: false,
          },
          {
            name: "407, Costco, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "407, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "407, Kroger, DECATUR, IN",
            disabled: false,
          },
          {
            name: "407, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "407, Kroger, MOUNT MORRIS, MI",
            disabled: false,
          },
          {
            name: "407, Kroger, PERRY, GA",
            disabled: false,
          },
          {
            name: "407, Kroger, WEST MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "407, Walmart, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "4070, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "4071, CVS, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "4071, Rite Aid, EUCLID, OH",
            disabled: false,
          },
          {
            name: "4072, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "4072, Walgreens, ROXBURY, MA",
            disabled: false,
          },
          {
            name: "4073, CVS, PEABODY, MA",
            disabled: false,
          },
          {
            name: "4075, ADUSA, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "4075, Walgreens, OKEECHOBEE, FL",
            disabled: false,
          },
          {
            name: "4077, ADUSA, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "4077, CVS, BELLE VERNON, PA",
            disabled: false,
          },
          {
            name: "4077, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "4078, ADUSA, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "4078, CVS, AVON LAKE, OH",
            disabled: false,
          },
          {
            name: "4078, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "4079, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "408, Kroger, BARDSTOWN, KY",
            disabled: false,
          },
          {
            name: "408, Kroger, CANTON, GA",
            disabled: false,
          },
          {
            name: "408, Kroger, Cortez, CO",
            disabled: false,
          },
          {
            name: "408, Kroger, Flint, MI",
            disabled: false,
          },
          {
            name: "408, Kroger, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "408, Kroger, MAINEVILLE, OH",
            disabled: false,
          },
          {
            name: "408, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "408, Kroger, Saint Louis, MO",
            disabled: false,
          },
          {
            name: "408, Kroger, Two Rivers, WI",
            disabled: false,
          },
          {
            name: "408, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "408, Walmart, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "4080, CVS, LAKE OZARK, MO",
            disabled: false,
          },
          {
            name: "4081, Walgreens, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "4082, CVS, ERIE, PA",
            disabled: false,
          },
          {
            name: "4082, Walgreens, CRESCENT SPRINGS, KY",
            disabled: false,
          },
          {
            name: "4083, CVS, LARGO, FL",
            disabled: false,
          },
          {
            name: "4083, Rite Aid, CHARLEROI, PA",
            disabled: false,
          },
          {
            name: "4083, Walgreens, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "4084, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "4085, Walgreens, COLLEYVILLE, TX",
            disabled: false,
          },
          {
            name: "4086, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4088, ADUSA, BROADVIEW HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4088, CVS, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "4088, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "4089, ADUSA, DOVER, OH",
            disabled: false,
          },
          {
            name: "4089, CVS, MOUNT PLEASANT, PA",
            disabled: false,
          },
          {
            name: "409, CVS, NARRAGANSETT, RI",
            disabled: false,
          },
          {
            name: "409, Costco, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "409, Kroger, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "409, Kroger, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "409, Kroger, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "409, Kroger, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "409, Kroger, HEBRON, KY",
            disabled: false,
          },
          {
            name: "409, Kroger, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "409, Kroger, LONDON, KY",
            disabled: false,
          },
          {
            name: "409, Kroger, Saint Louis, MO",
            disabled: false,
          },
          {
            name: "409, Walmart, HALEYVILLE, AL",
            disabled: false,
          },
          {
            name: "4091, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4091, CVS, SWISSVALE, PA",
            disabled: false,
          },
          {
            name: "4091, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4092, Rite Aid, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "4092, Walgreens, ELMWOOD PARK, NJ",
            disabled: false,
          },
          {
            name: "4093, ADUSA, ERIE, PA",
            disabled: false,
          },
          {
            name: "4094, Rite Aid, WEST DEPTFORD, NJ",
            disabled: false,
          },
          {
            name: "4095, ADUSA, ROOTSTOWN, OH",
            disabled: false,
          },
          {
            name: "4095, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "4095, Walgreens, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "4096, ADUSA, STOW, OH",
            disabled: false,
          },
          {
            name: "4096, CVS, CENTRAL FALLS, RI",
            disabled: false,
          },
          {
            name: "4097, Walgreens, GURNEE, IL",
            disabled: false,
          },
          {
            name: "4098, ADUSA, CHARDON, OH",
            disabled: false,
          },
          {
            name: "4098, CVS, INDIAN TRAIL, NC",
            disabled: false,
          },
          {
            name: "4098, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4099, CVS, MONTICELLO, FL",
            disabled: false,
          },
          {
            name: "4099, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "41, ADUSA, LEECHBURG, PA",
            disabled: false,
          },
          {
            name: "41, Albertsons, BERNARDSVILLE, NJ",
            disabled: false,
          },
          {
            name: "41, BJ's, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "41, CVS, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "41, Costco, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "41, Kroger, ARCADIA, CA",
            disabled: false,
          },
          {
            name: "41, Kroger, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "41, Kroger, Forest Park, GA",
            disabled: false,
          },
          {
            name: "41, Kroger, GOODLETTSVILLE, TN",
            disabled: false,
          },
          {
            name: "41, Kroger, Littleton, CO",
            disabled: false,
          },
          {
            name: "41, Kroger, Mesa, AZ",
            disabled: false,
          },
          {
            name: "41, Kroger, SALINA, KS",
            disabled: false,
          },
          {
            name: "41, Meijer, BENTON HARBOR, MI",
            disabled: false,
          },
          {
            name: "41, Walmart, BARTLESVILLE, OK",
            disabled: false,
          },
          {
            name: "410, ADUSA, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "410, ADUSA, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "410, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "410, Costco, NORWALK, CA",
            disabled: false,
          },
          {
            name: "410, Kroger, COLD SPRING, KY",
            disabled: false,
          },
          {
            name: "410, Kroger, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "410, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "410, Kroger, Macon, GA",
            disabled: false,
          },
          {
            name: "410, Kroger, Moab, UT",
            disabled: false,
          },
          {
            name: "410, Kroger, Saginaw, MI",
            disabled: false,
          },
          {
            name: "410, Kroger, WATERFORD, WI",
            disabled: false,
          },
          {
            name: "410, Walmart, MURRAY, KY",
            disabled: false,
          },
          {
            name: "4100, Walgreens, CLUTE, TX",
            disabled: false,
          },
          {
            name: "4100, Walmart, PROVO, UT",
            disabled: false,
          },
          {
            name: "4101, CVS, CHAGRIN FALLS, OH",
            disabled: false,
          },
          {
            name: "4101, Walgreens, CANTON, OH",
            disabled: false,
          },
          {
            name: "4101, Walmart, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "4102, Albertsons, SAGINAW, TX",
            disabled: false,
          },
          {
            name: "4102, CVS, OAKLAND, MD",
            disabled: false,
          },
          {
            name: "4102, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4102, Walmart, CASTROVILLE, TX",
            disabled: false,
          },
          {
            name: "4103, CVS, BELLEVUE, PA",
            disabled: false,
          },
          {
            name: "4103, Walgreens, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "4103, Walmart, DEVINE, TX",
            disabled: false,
          },
          {
            name: "4104, Walmart, DENTON, TX",
            disabled: false,
          },
          {
            name: "4105, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4105, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "4105, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4105, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "4106, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4107, Walgreens, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "4108, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4108, Walmart, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "4109, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4109, Walgreens, LINDEN, NJ",
            disabled: false,
          },
          {
            name: "411, CVS, LAKE WALES, FL",
            disabled: false,
          },
          {
            name: "411, Costco, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "411, HEB, PLEASANTON, TX",
            disabled: false,
          },
          {
            name: "411, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "411, Kroger, MILFORD, OH",
            disabled: false,
          },
          {
            name: "411, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "411, Kroger, STANTON, KY",
            disabled: false,
          },
          {
            name: "411, Kroger, Saginaw, MI",
            disabled: false,
          },
          {
            name: "411, Kroger, Saint Charles, MO",
            disabled: false,
          },
          {
            name: "411, Walmart, HOUSTON, MS",
            disabled: false,
          },
          {
            name: "4110, CVS, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "4111, CVS, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "4111, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4111, Walmart, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "4112, Albertsons, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "4112, CVS, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "4112, Walmart, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "4113, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "4113, Walgreens, ALVIN, TX",
            disabled: false,
          },
          {
            name: "4114, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "4114, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4114, Walmart, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "4115, CVS, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "4115, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "4115, Walmart, CIBOLO, TX",
            disabled: false,
          },
          {
            name: "4116, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "4116, Walgreens, BETHPAGE, NY",
            disabled: false,
          },
          {
            name: "4118, Walgreens, COHASSET, MA",
            disabled: false,
          },
          {
            name: "4118, Walmart, SHEPHERDSVILLE, KY",
            disabled: false,
          },
          {
            name: "4119, ADUSA, POLAND, OH",
            disabled: false,
          },
          {
            name: "4119, CVS, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "4119, Walgreens, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "412, ADUSA, CANDLER, NC",
            disabled: false,
          },
          {
            name: "412, Albertsons, SALEM, OR",
            disabled: false,
          },
          {
            name: "412, Costco, AZUSA, CA",
            disabled: false,
          },
          {
            name: "412, HEB, BEEVILLE, TX",
            disabled: false,
          },
          {
            name: "412, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "412, Kroger, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "412, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "412, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "412, Kroger, Neenah, WI",
            disabled: false,
          },
          {
            name: "412, Kroger, OXFORD, OH",
            disabled: false,
          },
          {
            name: "412, Kroger, Rawlins, WY",
            disabled: false,
          },
          {
            name: "412, Walmart, ATHENS, TX",
            disabled: false,
          },
          {
            name: "4120, Walgreens, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "4121, CVS, AMITYVILLE, NY",
            disabled: false,
          },
          {
            name: "4122, CVS, TAYLORS, SC",
            disabled: false,
          },
          {
            name: "4122, Walgreens, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "4123, Walgreens, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "4124, ADUSA, AKRON, OH",
            disabled: false,
          },
          {
            name: "4124, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4124, Walgreens, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "4125, CVS, VILLAS, NJ",
            disabled: false,
          },
          {
            name: "4126, CVS, WASHINGTON, NC",
            disabled: false,
          },
          {
            name: "4127, Walmart, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "4128, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "4128, Walmart, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "4129, Albertsons, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "4129, Walmart, PONCHATOULA, LA",
            disabled: false,
          },
          {
            name: "413, ADUSA, HYDE PARK, MA",
            disabled: false,
          },
          {
            name: "413, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "413, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "413, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "413, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "413, Kroger, FLINT, MI",
            disabled: false,
          },
          {
            name: "413, Kroger, Fort Wayne, IN",
            disabled: false,
          },
          {
            name: "413, Kroger, Fruita, CO",
            disabled: false,
          },
          {
            name: "413, Kroger, JONESBORO, GA",
            disabled: false,
          },
          {
            name: "413, Kroger, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "413, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "413, Kroger, OCONOMOWOC, WI",
            disabled: false,
          },
          {
            name: "413, Kroger, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "413, Walmart, PORT ISABEL, TX",
            disabled: false,
          },
          {
            name: "4130, CVS, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "4130, Walgreens, CLEVELAND HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4130, Walmart, KYLE, TX",
            disabled: false,
          },
          {
            name: "4131, Albertsons, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "4131, CVS, GARWOOD, NJ",
            disabled: false,
          },
          {
            name: "4131, Walgreens, HALTOM CITY, TX",
            disabled: false,
          },
          {
            name: "4131, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4132, Walgreens, HURST, TX",
            disabled: false,
          },
          {
            name: "4132, Walmart, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "4133, ADUSA, MIDDLEFIELD, OH",
            disabled: false,
          },
          {
            name: "4133, Albertsons, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "4133, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "4134, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4134, Walmart, STANTON, CA",
            disabled: false,
          },
          {
            name: "4135, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "4136, CVS, STAR CITY, WV",
            disabled: false,
          },
          {
            name: "4136, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "4137, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4137, Walmart, TACOMA, WA",
            disabled: false,
          },
          {
            name: "4138, Albertsons, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "4138, CVS, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "4138, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "4138, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "4139, Albertsons, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "4139, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "4139, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4139, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "414, Albertsons, MOUNTLAKE TERRACE, WA",
            disabled: false,
          },
          {
            name: "414, HEB, BRENHAM, TX",
            disabled: false,
          },
          {
            name: "414, Kroger, BLUFFTON, IN",
            disabled: false,
          },
          {
            name: "414, Kroger, Burlington, WI",
            disabled: false,
          },
          {
            name: "414, Kroger, EVANS, GA",
            disabled: false,
          },
          {
            name: "414, Kroger, LOS LUNAS, NM",
            disabled: false,
          },
          {
            name: "414, Kroger, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "414, Kroger, Steamboat Springs, CO",
            disabled: false,
          },
          {
            name: "414, ShopRite, MOSCOW, PA",
            disabled: false,
          },
          {
            name: "414, Walmart, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "4140, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4141, Walgreens, LAUDERDALE LAKES, FL",
            disabled: false,
          },
          {
            name: "4141, Walmart, LARGO, FL",
            disabled: false,
          },
          {
            name: "4142, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "4142, Walgreens, KANKAKEE, IL",
            disabled: false,
          },
          {
            name: "4142, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4143, Walgreens, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "4144, Rite Aid, SOMERSWORTH, NH",
            disabled: false,
          },
          {
            name: "4144, Walmart, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "4145, Albertsons, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "4145, Walgreens, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "4145, Walmart, GREER, SC",
            disabled: false,
          },
          {
            name: "4146, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "4146, Walgreens, PROSPECT HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "4147, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4147, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4147, Walmart, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "4148, CVS, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "4148, Walgreens, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "4148, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "4149, CVS, EAST HAMPTON, CT",
            disabled: false,
          },
          {
            name: "415, ADUSA, WILLIAMSTON, NC",
            disabled: false,
          },
          {
            name: "415, Albertsons, LINCOLN CITY, OR",
            disabled: false,
          },
          {
            name: "415, CVS, LATHAM, NY",
            disabled: false,
          },
          {
            name: "415, HEB, SCHERTZ, TX",
            disabled: false,
          },
          {
            name: "415, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "415, Kroger, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "415, Kroger, Craig, CO",
            disabled: false,
          },
          {
            name: "415, Kroger, GRANTS, NM",
            disabled: false,
          },
          {
            name: "415, Kroger, GROSSE ILE, MI",
            disabled: false,
          },
          {
            name: "415, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "415, Kroger, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "415, Walmart, BROUSSARD, LA",
            disabled: false,
          },
          {
            name: "4150, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4150, Albertsons, LAKE WORTH, TX",
            disabled: false,
          },
          {
            name: "4150, CVS, MARION, SC",
            disabled: false,
          },
          {
            name: "4150, Walgreens, BELVIDERE, IL",
            disabled: false,
          },
          {
            name: "4151, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4151, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "4151, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "4152, ADUSA, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "4152, Albertsons, DENTON, TX",
            disabled: false,
          },
          {
            name: "4152, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "4153, CVS, GREER, SC",
            disabled: false,
          },
          {
            name: "4153, Walmart, OLD BRIDGE, NJ",
            disabled: false,
          },
          {
            name: "4154, Walgreens, MOKENA, IL",
            disabled: false,
          },
          {
            name: "4155, CVS, GULF BREEZE, FL",
            disabled: false,
          },
          {
            name: "4155, Rite Aid, PLYMOUTH, NH",
            disabled: false,
          },
          {
            name: "4156, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "4156, Rite Aid, LINCOLN, NH",
            disabled: false,
          },
          {
            name: "4156, Walgreens, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "4156, Walmart, DERBY, VT",
            disabled: false,
          },
          {
            name: "4157, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "4157, Walmart, CARY, NC",
            disabled: false,
          },
          {
            name: "4158, CVS, AUGUSTA, ME",
            disabled: false,
          },
          {
            name: "4158, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "4159, Walgreens, PARMA HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4159, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "416, ADUSA, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "416, Costco, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "416, HEB, LA GRANGE, TX",
            disabled: false,
          },
          {
            name: "416, Kroger, Aspen, CO",
            disabled: false,
          },
          {
            name: "416, Kroger, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "416, Kroger, Germantown, TN",
            disabled: false,
          },
          {
            name: "416, Kroger, Wauwatosa, WI",
            disabled: false,
          },
          {
            name: "416, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "4160, Albertsons, LOVELOCK, NV",
            disabled: false,
          },
          {
            name: "4160, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "4160, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4160, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4161, CVS, VINTON, VA",
            disabled: false,
          },
          {
            name: "4161, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4161, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4162, CVS, BEAVER FALLS, PA",
            disabled: false,
          },
          {
            name: "4162, Walgreens, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "4162, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4163, Albertsons, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "4163, CVS, MONTVALE, NJ",
            disabled: false,
          },
          {
            name: "4163, Rite Aid, HILLSBORO, NH",
            disabled: false,
          },
          {
            name: "4163, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4163, Walmart, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "4164, CVS, JEFFERSON, GA",
            disabled: false,
          },
          {
            name: "4164, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4164, Walmart, KAUFMAN, TX",
            disabled: false,
          },
          {
            name: "4165, CVS, BREVARD, NC",
            disabled: false,
          },
          {
            name: "4165, Rite Aid, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "4165, Walgreens, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4165, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4166, CVS, MOOREFIELD, WV",
            disabled: false,
          },
          {
            name: "4166, Rite Aid, BRISTOL, NH",
            disabled: false,
          },
          {
            name: "4166, Walmart, SWEETWATER, TN",
            disabled: false,
          },
          {
            name: "4167, CVS, SUMMERSVILLE, WV",
            disabled: false,
          },
          {
            name: "4167, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4168, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "4168, Walmart, BEEBE, AR",
            disabled: false,
          },
          {
            name: "4169, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "4169, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "4169, Walmart, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "417, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "417, Kroger, Canon City, CO",
            disabled: false,
          },
          {
            name: "417, Kroger, EUGENE, OR",
            disabled: false,
          },
          {
            name: "417, Kroger, West Bend, WI",
            disabled: false,
          },
          {
            name: "417, Walmart, SULPHUR SPRINGS, TX",
            disabled: false,
          },
          {
            name: "4170, CVS, TANEYTOWN, MD",
            disabled: false,
          },
          {
            name: "4170, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "4171, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4171, Walgreens, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "4171, Walmart, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "4172, CVS, MAULDIN, SC",
            disabled: false,
          },
          {
            name: "4172, Walgreens, BILOXI, MS",
            disabled: false,
          },
          {
            name: "4173, CVS, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "4174, CVS, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "4174, Walgreens, PALM CITY, FL",
            disabled: false,
          },
          {
            name: "4174, Walmart, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "4175, CVS, HARDY, VA",
            disabled: false,
          },
          {
            name: "4176, Albertsons, WEATHERFORD, TX",
            disabled: false,
          },
          {
            name: "4176, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "4176, Walmart, SHERWOOD, OR",
            disabled: false,
          },
          {
            name: "4177, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4177, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "4177, Walmart, LINCOLNWOOD, IL",
            disabled: false,
          },
          {
            name: "4178, Albertsons, BURNEY, CA",
            disabled: false,
          },
          {
            name: "4178, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4178, Walmart, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "4179, Walgreens, GENEVA, IL",
            disabled: false,
          },
          {
            name: "418, ADUSA, NORWOOD, MA",
            disabled: false,
          },
          {
            name: "418, Albertsons, SHARON, MA",
            disabled: false,
          },
          {
            name: "418, CVS, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "418, Costco, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "418, HEB, DEL RIO, TX",
            disabled: false,
          },
          {
            name: "418, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "418, Kroger, Covington, TN",
            disabled: false,
          },
          {
            name: "418, Kroger, KENDALLVILLE, IN",
            disabled: false,
          },
          {
            name: "418, Kroger, Milwaukee, WI",
            disabled: false,
          },
          {
            name: "418, Kroger, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "418, Rite Aid, NEW CUMBERLAND, PA",
            disabled: false,
          },
          {
            name: "418, Walmart, FAIRBURY, NE",
            disabled: false,
          },
          {
            name: "4180, Walmart, NAMPA, ID",
            disabled: false,
          },
          {
            name: "4182, CVS, SURFSIDE, FL",
            disabled: false,
          },
          {
            name: "4182, Rite Aid, LITTLETON, NH",
            disabled: false,
          },
          {
            name: "4182, Walgreens, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "4182, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "4183, CVS, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "4183, Walgreens, OLATHE, KS",
            disabled: false,
          },
          {
            name: "4183, Walmart, BRYAN, TX",
            disabled: false,
          },
          {
            name: "4184, CVS, SUMTER, SC",
            disabled: false,
          },
          {
            name: "4184, Walmart, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "4185, CVS, INMAN, SC",
            disabled: false,
          },
          {
            name: "4185, Walgreens, ROELAND PARK, KS",
            disabled: false,
          },
          {
            name: "4185, Walmart, CUMMING, GA",
            disabled: false,
          },
          {
            name: "4186, CVS, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "4186, Walgreens, LENEXA, KS",
            disabled: false,
          },
          {
            name: "4187, Albertsons, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "4187, Walgreens, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "4187, Walmart, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "4188, CVS, WELLINGTON, FL",
            disabled: false,
          },
          {
            name: "4188, Walgreens, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "4188, Walmart, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "4189, Walgreens, LAKE WORTH, TX",
            disabled: false,
          },
          {
            name: "4189, Walmart, HELENA, AL",
            disabled: false,
          },
          {
            name: "419, Albertsons, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "419, CVS, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "419, Costco, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "419, HEB, EAGLE PASS, TX",
            disabled: false,
          },
          {
            name: "419, Kroger, FLUSHING, MI",
            disabled: false,
          },
          {
            name: "419, Kroger, GERMANTOWN, TN",
            disabled: false,
          },
          {
            name: "419, Kroger, Gunnison, CO",
            disabled: false,
          },
          {
            name: "419, Kroger, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "419, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "419, Walmart, PRATT, KS",
            disabled: false,
          },
          {
            name: "4190, CVS, TOCCOA, GA",
            disabled: false,
          },
          {
            name: "4190, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "4191, Albertsons, CORINTH, TX",
            disabled: false,
          },
          {
            name: "4191, Walmart, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "4192, Walgreens, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "4193, Rite Aid, PARLIN, NJ",
            disabled: false,
          },
          {
            name: "4193, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "4193, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "4194, CVS, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "4194, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4194, Walmart, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "4195, Walmart, CHOCTAW, OK",
            disabled: false,
          },
          {
            name: "4196, CVS, BURNSVILLE, NC",
            disabled: false,
          },
          {
            name: "4196, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "4197, CVS, FLETCHER, NC",
            disabled: false,
          },
          {
            name: "4197, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4197, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4198, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "4198, Walgreens, WEST SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "4198, Walmart, OLATHE, KS",
            disabled: false,
          },
          {
            name: "4199, CVS, HAGERSTOWN, MD",
            disabled: false,
          },
          {
            name: "4199, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "42, Albertsons, LIVINGSTON, MT",
            disabled: false,
          },
          {
            name: "42, Kroger, Birmingham, AL",
            disabled: false,
          },
          {
            name: "42, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "42, Kroger, CEDAR CITY, UT",
            disabled: false,
          },
          {
            name: "42, Kroger, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "42, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "42, Meijer, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "42, Walmart, COFFEYVILLE, KS",
            disabled: false,
          },
          {
            name: "420, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "420, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "420, Costco, OXNARD, CA",
            disabled: false,
          },
          {
            name: "420, Kroger, Dillon, CO",
            disabled: false,
          },
          {
            name: "420, Kroger, MAYSVILLE, KY",
            disabled: false,
          },
          {
            name: "420, Kroger, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "420, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "420, Walmart, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "4200, CVS, SALISBURY, MA",
            disabled: false,
          },
          {
            name: "4200, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4201, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "4201, Walgreens, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "4201, Walmart, EDGEWOOD, NM",
            disabled: false,
          },
          {
            name: "4202, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "4202, CVS, SHELBY, NC",
            disabled: false,
          },
          {
            name: "4202, Walgreens, SEVEN HILLS, OH",
            disabled: false,
          },
          {
            name: "4202, Walmart, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "4203, CVS, MOULTRIE, GA",
            disabled: false,
          },
          {
            name: "4203, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4203, Walmart, FORT MOHAVE, AZ",
            disabled: false,
          },
          {
            name: "4204, CVS, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "4204, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4205, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "4206, Walmart, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "4207, CVS, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "4208, Walmart, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "4209, Walmart, NEBRASKA CITY, NE",
            disabled: false,
          },
          {
            name: "421, ADUSA, SOMERSET, MA",
            disabled: false,
          },
          {
            name: "421, HEB, ALAMO, TX",
            disabled: false,
          },
          {
            name: "421, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "421, Kroger, Durango, CO",
            disabled: false,
          },
          {
            name: "421, Walmart, DECATUR, TX",
            disabled: false,
          },
          {
            name: "4210, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4210, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4211, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4212, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4214, CVS, EDGEWOOD, MD",
            disabled: false,
          },
          {
            name: "4214, Walgreens, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "4215, CVS, YORK, PA",
            disabled: false,
          },
          {
            name: "4215, Walmart, QUINLAN, TX",
            disabled: false,
          },
          {
            name: "4216, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4216, Walmart, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "4217, CVS, CLAXTON, GA",
            disabled: false,
          },
          {
            name: "4217, Walgreens, HOMOSASSA, FL",
            disabled: false,
          },
          {
            name: "4218, Albertsons, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "4218, Walgreens, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "4218, Walmart, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "4219, CVS, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "4219, Walgreens, CARBONDALE, IL",
            disabled: false,
          },
          {
            name: "4219, Walmart, BUDA, TX",
            disabled: false,
          },
          {
            name: "422, ADUSA, MARSHVILLE, NC",
            disabled: false,
          },
          {
            name: "422, Albertsons, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "422, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "422, Costco, SOUTH SAN FRANC, CA",
            disabled: false,
          },
          {
            name: "422, Kroger, Alamosa, CO",
            disabled: false,
          },
          {
            name: "422, Kroger, Fremont, OH",
            disabled: false,
          },
          {
            name: "422, Kroger, PEACHTREE CITY, GA",
            disabled: false,
          },
          {
            name: "422, Walmart, ROBINSON, IL",
            disabled: false,
          },
          {
            name: "4220, CVS, HAMPSTEAD, MD",
            disabled: false,
          },
          {
            name: "4220, Walgreens, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "4220, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4221, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "4221, Walgreens, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "4221, Walmart, CORNELIUS, OR",
            disabled: false,
          },
          {
            name: "4222, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4223, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4223, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "4223, Walmart, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "4224, CVS, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "4224, Walgreens, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "4224, Walmart, CONOVER, NC",
            disabled: false,
          },
          {
            name: "4225, CVS, ANNAPOLIS, MD",
            disabled: false,
          },
          {
            name: "4225, Walgreens, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "4226, Rite Aid, SOUTHAMPTON, NY",
            disabled: false,
          },
          {
            name: "4226, Walmart, DUNLAP, TN",
            disabled: false,
          },
          {
            name: "4227, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4228, Albertsons, WESTCHESTER, IL",
            disabled: false,
          },
          {
            name: "4228, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4228, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "4229, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4229, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "423, ADUSA, BENNETTSVILLE, SC",
            disabled: false,
          },
          {
            name: "423, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "423, Costco, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "423, HEB, WACO, TX",
            disabled: false,
          },
          {
            name: "423, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "423, Kroger, NEWPORT, KY",
            disabled: false,
          },
          {
            name: "423, Kroger, Rincon, GA",
            disabled: false,
          },
          {
            name: "423, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "423, Walmart, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "4230, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4230, Rite Aid, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "4230, Walgreens, KEIZER, OR",
            disabled: false,
          },
          {
            name: "4230, Walmart, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "4231, Albertsons, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "4231, CVS, PALM CITY, FL",
            disabled: false,
          },
          {
            name: "4231, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "4231, Walmart, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "4232, CVS, MONACA, PA",
            disabled: false,
          },
          {
            name: "4232, Rite Aid, LANSING, MI",
            disabled: false,
          },
          {
            name: "4232, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4233, Rite Aid, MARSHALL, MI",
            disabled: false,
          },
          {
            name: "4233, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4234, Albertsons, MC KINNEY, TX",
            disabled: false,
          },
          {
            name: "4234, Albertsons, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "4234, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "4234, Rite Aid, STURGIS, MI",
            disabled: false,
          },
          {
            name: "4234, Walgreens, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "4235, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4235, Walmart, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "4236, Rite Aid, NILES, MI",
            disabled: false,
          },
          {
            name: "4236, Walgreens, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "4237, ADUSA, ERIE, PA",
            disabled: false,
          },
          {
            name: "4237, CVS, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "4237, Rite Aid, BUCHANAN, MI",
            disabled: false,
          },
          {
            name: "4237, Walmart, INDIAN LAND, SC",
            disabled: false,
          },
          {
            name: "4238, CVS, OCOEE, FL",
            disabled: false,
          },
          {
            name: "4238, Rite Aid, BRIDGMAN, MI",
            disabled: false,
          },
          {
            name: "4238, Walmart, SANGER, CA",
            disabled: false,
          },
          {
            name: "4239, Albertsons, WYLIE, TX",
            disabled: false,
          },
          {
            name: "4239, Rite Aid, COLOMA, MI",
            disabled: false,
          },
          {
            name: "4239, Walmart, RENO, NV",
            disabled: false,
          },
          {
            name: "424, ADUSA, BANNER ELK, NC",
            disabled: false,
          },
          {
            name: "424, Albertsons, SAINT HELENS, OR",
            disabled: false,
          },
          {
            name: "424, CVS, HUDSON, NY",
            disabled: false,
          },
          {
            name: "424, Costco, SIGNAL HILL, CA",
            disabled: false,
          },
          {
            name: "424, HEB, HONDO, TX",
            disabled: false,
          },
          {
            name: "424, Kroger, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "424, Kroger, EDGEWOOD, NM",
            disabled: false,
          },
          {
            name: "424, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "424, Kroger, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "424, Kroger, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "424, Kroger, Union, KY",
            disabled: false,
          },
          {
            name: "424, ShopRite, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "424, Walmart, CLANTON, AL",
            disabled: false,
          },
          {
            name: "4240, CVS, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "4240, Rite Aid, HARTFORD, MI",
            disabled: false,
          },
          {
            name: "4240, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "4240, Walmart, HIGHLAND VILLAGE, TX",
            disabled: false,
          },
          {
            name: "4241, Walgreens, GRIFFITH, IN",
            disabled: false,
          },
          {
            name: "4241, Walmart, STILLWATER, OK",
            disabled: false,
          },
          {
            name: "4242, CVS, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "4242, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4243, CVS, PERRY, GA",
            disabled: false,
          },
          {
            name: "4243, Walgreens, REDDING, CA",
            disabled: false,
          },
          {
            name: "4243, Walmart, CLIO, MI",
            disabled: false,
          },
          {
            name: "4244, CVS, DUNBAR, WV",
            disabled: false,
          },
          {
            name: "4244, Walmart, PARK RAPIDS, MN",
            disabled: false,
          },
          {
            name: "4245, CVS, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "4245, Rite Aid, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "4245, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "4246, Rite Aid, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "4246, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "4246, Walmart, WADENA, MN",
            disabled: false,
          },
          {
            name: "4247, Walmart, HAVRE, MT",
            disabled: false,
          },
          {
            name: "4248, Walgreens, SEBASTIAN, FL",
            disabled: false,
          },
          {
            name: "4249, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4249, Walmart, SMELTERVILLE, ID",
            disabled: false,
          },
          {
            name: "425, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "425, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "425, Kroger, Flint, MI",
            disabled: false,
          },
          {
            name: "425, Kroger, Grand Junction, CO",
            disabled: false,
          },
          {
            name: "425, Kroger, Independence, KY",
            disabled: false,
          },
          {
            name: "425, Kroger, MACON, GA",
            disabled: false,
          },
          {
            name: "425, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "425, Rite Aid, POINT PLEASANT, NJ",
            disabled: false,
          },
          {
            name: "425, Walmart, BRENT, AL",
            disabled: false,
          },
          {
            name: "4250, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "4250, Walmart, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "4251, CVS, MILLEDGEVILLE, GA",
            disabled: false,
          },
          {
            name: "4251, Walgreens, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "4252, Albertsons, AURORA, IL",
            disabled: false,
          },
          {
            name: "4252, Walgreens, VILLA PARK, IL",
            disabled: false,
          },
          {
            name: "4252, Walmart, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "4253, CVS, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "4253, Walgreens, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "4253, Walmart, SAUK CENTRE, MN",
            disabled: false,
          },
          {
            name: "4254, CVS, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "4254, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4255, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "4255, Walgreens, FRASER, MI",
            disabled: false,
          },
          {
            name: "4255, Walmart, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "4256, CVS, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "4256, Rite Aid, ABINGTON, PA",
            disabled: false,
          },
          {
            name: "4256, Walmart, AMES, IA",
            disabled: false,
          },
          {
            name: "4257, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4257, Rite Aid, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "4257, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "4257, Walmart, AUSTIN, MN",
            disabled: false,
          },
          {
            name: "4258, CVS, GARDEN CITY, GA",
            disabled: false,
          },
          {
            name: "4258, Walgreens, WEST DUNDEE, IL",
            disabled: false,
          },
          {
            name: "4258, Walmart, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "4259, CVS, UNION, NJ",
            disabled: false,
          },
          {
            name: "4259, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "4259, Walmart, SHELBYVILLE, IL",
            disabled: false,
          },
          {
            name: "426, Albertsons, DEDHAM, MA",
            disabled: false,
          },
          {
            name: "426, HEB, WAXAHACHIE, TX",
            disabled: false,
          },
          {
            name: "426, Kroger, Avon, CO",
            disabled: false,
          },
          {
            name: "426, Kroger, Cordova, TN",
            disabled: false,
          },
          {
            name: "426, Kroger, Farmers Branch, TX",
            disabled: false,
          },
          {
            name: "426, Kroger, MASON, OH",
            disabled: false,
          },
          {
            name: "426, Kroger, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "426, Kroger, TAOS, NM",
            disabled: false,
          },
          {
            name: "426, Walmart, COLONY, TX",
            disabled: false,
          },
          {
            name: "4260, Albertsons, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "4260, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4260, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "4260, Walgreens, HOPKINS, MN",
            disabled: false,
          },
          {
            name: "4260, Walmart, PORT ST LUCIE, FL",
            disabled: false,
          },
          {
            name: "4261, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4261, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "4262, Albertsons, COQUILLE, OR",
            disabled: false,
          },
          {
            name: "4262, CVS, AURORA, IL",
            disabled: false,
          },
          {
            name: "4262, Walgreens, ORANGE CITY, FL",
            disabled: false,
          },
          {
            name: "4262, Walmart, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "4263, CVS, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "4263, Rite Aid, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "4263, Walgreens, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "4264, Walmart, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "4265, Albertsons, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4266, CVS, VENICE, FL",
            disabled: false,
          },
          {
            name: "4266, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4266, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4267, Albertsons, WATAUGA, TX",
            disabled: false,
          },
          {
            name: "4267, CVS, CORDELE, GA",
            disabled: false,
          },
          {
            name: "4267, Rite Aid, BRONX, NY",
            disabled: false,
          },
          {
            name: "4267, Walgreens, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4268, Albertsons, STREAMWOOD, IL",
            disabled: false,
          },
          {
            name: "4268, Rite Aid, TROY, MI",
            disabled: false,
          },
          {
            name: "4268, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4269, CVS, GENEVA, IL",
            disabled: false,
          },
          {
            name: "4269, Walgreens, SHAWNEE, OK",
            disabled: false,
          },
          {
            name: "427, ADUSA, FAIRHAVEN, MA",
            disabled: false,
          },
          {
            name: "427, ADUSA, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "427, CVS, BENSON, NC",
            disabled: false,
          },
          {
            name: "427, Costco, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "427, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "427, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "427, Kroger, COLUMBUS, MS",
            disabled: false,
          },
          {
            name: "427, Kroger, ELLENWOOD, GA",
            disabled: false,
          },
          {
            name: "427, Kroger, ROCHESTER, IN",
            disabled: false,
          },
          {
            name: "427, Kroger, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "427, Walmart, GREENVILLE, TX",
            disabled: false,
          },
          {
            name: "4270, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "4270, CVS, BRADFORD, PA",
            disabled: false,
          },
          {
            name: "4270, Rite Aid, RICHMOND, MI",
            disabled: false,
          },
          {
            name: "4272, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4272, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4272, Walmart, LOGAN, UT",
            disabled: false,
          },
          {
            name: "4273, Walmart, LELAND, NC",
            disabled: false,
          },
          {
            name: "4274, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4274, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4274, Walmart, DENVER, NC",
            disabled: false,
          },
          {
            name: "4275, Walmart, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "4276, Rite Aid, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "4276, Walmart, TAYLOR, PA",
            disabled: false,
          },
          {
            name: "4277, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4277, Walgreens, WAUCONDA, IL",
            disabled: false,
          },
          {
            name: "4277, Walmart, HURRICANE, WV",
            disabled: false,
          },
          {
            name: "4278, CVS, HELENA, MT",
            disabled: false,
          },
          {
            name: "4278, Rite Aid, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "4278, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4278, Walmart, QUINCY, WV",
            disabled: false,
          },
          {
            name: "4279, Albertsons, BURLESON, TX",
            disabled: false,
          },
          {
            name: "4279, Rite Aid, MIDDLEFIELD, OH",
            disabled: false,
          },
          {
            name: "4279, Walgreens, JUPITER, FL",
            disabled: false,
          },
          {
            name: "4279, Walmart, MIDLOTHIAN, TX",
            disabled: false,
          },
          {
            name: "428, Albertsons, CANTON, MA",
            disabled: false,
          },
          {
            name: "428, CVS, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "428, Costco, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "428, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "428, Kroger, ATHENS, GA",
            disabled: false,
          },
          {
            name: "428, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "428, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "428, Walmart, ZACHARY, LA",
            disabled: false,
          },
          {
            name: "4280, CVS, COCOA, FL",
            disabled: false,
          },
          {
            name: "4280, Rite Aid, NEWTON FALLS, OH",
            disabled: false,
          },
          {
            name: "4280, Walgreens, PALM SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4281, CVS, CAMDEN, SC",
            disabled: false,
          },
          {
            name: "4281, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4281, Walmart, LADYSMITH, WI",
            disabled: false,
          },
          {
            name: "4282, Rite Aid, CONCORD, NH",
            disabled: false,
          },
          {
            name: "4282, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "4283, CVS, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "4283, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4284, CVS, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "4284, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "4284, Walgreens, HIGHLAND HEIGHTS, KY",
            disabled: false,
          },
          {
            name: "4284, Walmart, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "4285, CVS, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "4285, Walgreens, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "4285, Walmart, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "4286, Albertsons, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4286, CVS, EASLEY, SC",
            disabled: false,
          },
          {
            name: "4286, Walmart, MONTGOMERY, IL",
            disabled: false,
          },
          {
            name: "4287, CVS, FORT MILL, SC",
            disabled: false,
          },
          {
            name: "4287, Rite Aid, MIDDLETOWN, PA",
            disabled: false,
          },
          {
            name: "4287, Walgreens, RAHWAY, NJ",
            disabled: false,
          },
          {
            name: "4288, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "4288, Walmart, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "4289, Albertsons, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4289, Walgreens, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "429, ADUSA, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "429, Albertsons, SALEM, OR",
            disabled: false,
          },
          {
            name: "429, CVS, CAPE MAY COURT HOUSE, NJ",
            disabled: false,
          },
          {
            name: "429, Costco, SAN JUAN CAPIST, CA",
            disabled: false,
          },
          {
            name: "429, HEB, RAYMONDVILLE, TX",
            disabled: false,
          },
          {
            name: "429, Kroger, CEDARTOWN, GA",
            disabled: false,
          },
          {
            name: "429, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "429, Kroger, GREENVILLE, MS",
            disabled: false,
          },
          {
            name: "429, Kroger, Hotchkiss, CO",
            disabled: false,
          },
          {
            name: "429, Kroger, IRVING, TX",
            disabled: false,
          },
          {
            name: "429, ShopRite, MOOSIC, PA",
            disabled: false,
          },
          {
            name: "429, Walmart, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "4290, Albertsons, AZLE, TX",
            disabled: false,
          },
          {
            name: "4290, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "4290, Walgreens, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "4291, CVS, ADELANTO, CA",
            disabled: false,
          },
          {
            name: "4291, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "4292, CVS, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "4292, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "4293, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "4293, Rite Aid, DUNCANNON, PA",
            disabled: false,
          },
          {
            name: "4293, Walgreens, DESOTO, TX",
            disabled: false,
          },
          {
            name: "4293, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4294, Albertsons, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "4294, CVS, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "4294, Rite Aid, BRONX, NY",
            disabled: false,
          },
          {
            name: "4294, Walgreens, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "4295, CVS, AIKEN, SC",
            disabled: false,
          },
          {
            name: "4295, Rite Aid, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4295, Walgreens, STOW, OH",
            disabled: false,
          },
          {
            name: "4295, Walmart, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "4296, Rite Aid, BARBERTON, OH",
            disabled: false,
          },
          {
            name: "4296, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "4297, CVS, SILER CITY, NC",
            disabled: false,
          },
          {
            name: "4297, Walgreens, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "4298, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "4298, Walgreens, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "4298, Walmart, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "4299, CVS, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "4299, Walgreens, WYOMING, MI",
            disabled: false,
          },
          {
            name: "4299, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "43, ADUSA, REVERE, MA",
            disabled: false,
          },
          {
            name: "43, Albertsons, GARWOOD, NJ",
            disabled: false,
          },
          {
            name: "43, Albertsons, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "43, CVS, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "43, Kroger, Nashville, TN",
            disabled: false,
          },
          {
            name: "43, Kroger, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "43, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "43, Meijer, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "43, Target, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "43, Walmart, JUNCTION CITY, KS",
            disabled: false,
          },
          {
            name: "430, ADUSA, BELLINGHAM, MA",
            disabled: false,
          },
          {
            name: "430, ADUSA, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "430, Albertsons, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "430, Kroger, Breckenridge, CO",
            disabled: false,
          },
          {
            name: "430, Kroger, Liberty Twp, OH",
            disabled: false,
          },
          {
            name: "430, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "430, Kroger, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "430, Kroger, West Bend, WI",
            disabled: false,
          },
          {
            name: "430, Walgreens, GOLDEN VALLEY, MN",
            disabled: false,
          },
          {
            name: "430, Walmart, MAYFIELD, KY",
            disabled: false,
          },
          {
            name: "4300, CVS, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "4300, Rite Aid, WIXOM, MI",
            disabled: false,
          },
          {
            name: "4301, CVS, NORTHFIELD, OH",
            disabled: false,
          },
          {
            name: "4301, Rite Aid, PONTIAC, MI",
            disabled: false,
          },
          {
            name: "4301, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "4302, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4302, Rite Aid, PONTIAC, MI",
            disabled: false,
          },
          {
            name: "4303, Walgreens, COCOA, FL",
            disabled: false,
          },
          {
            name: "4303, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4304, CVS, WESTLAKE, OH",
            disabled: false,
          },
          {
            name: "4304, Rite Aid, WATERFORD, MI",
            disabled: false,
          },
          {
            name: "4305, Albertsons, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "4306, Rite Aid, HIGHLAND, MI",
            disabled: false,
          },
          {
            name: "4306, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4307, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "4308, Albertsons, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "4309, CVS, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "4309, Rite Aid, LAPEER, MI",
            disabled: false,
          },
          {
            name: "4309, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4309, Walmart, ORANGEVALE, CA",
            disabled: false,
          },
          {
            name: "431, ADUSA, DILLON, SC",
            disabled: false,
          },
          {
            name: "431, Albertsons, MANSFIELD, MA",
            disabled: false,
          },
          {
            name: "431, CVS, EATONTOWN, NJ",
            disabled: false,
          },
          {
            name: "431, Costco, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "431, HEB, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "431, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "431, Kroger, Clarksdale, MS",
            disabled: false,
          },
          {
            name: "431, Kroger, Franklin, WI",
            disabled: false,
          },
          {
            name: "431, Kroger, PALESTINE, TX",
            disabled: false,
          },
          {
            name: "431, Kroger, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "431, Kroger, Woodland Park, CO",
            disabled: false,
          },
          {
            name: "431, Walmart, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "4310, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "4310, Walgreens, NEPTUNE BEACH, FL",
            disabled: false,
          },
          {
            name: "4311, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4312, Walgreens, GERMANTOWN, TN",
            disabled: false,
          },
          {
            name: "4313, Albertsons, BATTLE GROUND, WA",
            disabled: false,
          },
          {
            name: "4313, CVS, WEST YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "4313, Walgreens, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "4314, CVS, SOMERSWORTH, NH",
            disabled: false,
          },
          {
            name: "4314, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4315, Rite Aid, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "4315, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "4316, Albertsons, LAKEVIEW, OR",
            disabled: false,
          },
          {
            name: "4316, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "4316, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4317, Walgreens, MENTOR, OH",
            disabled: false,
          },
          {
            name: "4317, Walmart, TEHACHAPI, CA",
            disabled: false,
          },
          {
            name: "4318, Albertsons, CLATSKANIE, OR",
            disabled: false,
          },
          {
            name: "4318, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "4318, Walmart, MILLBROOK, AL",
            disabled: false,
          },
          {
            name: "4319, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4319, Rite Aid, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "432, ADUSA, ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "432, ADUSA, KING, NC",
            disabled: false,
          },
          {
            name: "432, CVS, EAST WINDSOR, NJ",
            disabled: false,
          },
          {
            name: "432, Costco, CORONA, CA",
            disabled: false,
          },
          {
            name: "432, HEB, LAMPASAS, TX",
            disabled: false,
          },
          {
            name: "432, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "432, Kroger, CUMMING, GA",
            disabled: false,
          },
          {
            name: "432, Kroger, Grand Junction, CO",
            disabled: false,
          },
          {
            name: "432, Kroger, Jackson, MS",
            disabled: false,
          },
          {
            name: "432, Kroger, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "432, Kroger, WHITE ROCK, NM",
            disabled: false,
          },
          {
            name: "432, Walmart, TALLADEGA, AL",
            disabled: false,
          },
          {
            name: "4320, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "4320, Rite Aid, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "4320, Walgreens, BROOKLYN CENTER, MN",
            disabled: false,
          },
          {
            name: "4321, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "4322, Rite Aid, ROCKWOOD, MI",
            disabled: false,
          },
          {
            name: "4322, Walmart, CRETE, NE",
            disabled: false,
          },
          {
            name: "4323, CVS, LENEXA, KS",
            disabled: false,
          },
          {
            name: "4323, Rite Aid, MASON, MI",
            disabled: false,
          },
          {
            name: "4323, Walmart, KANKAKEE, IL",
            disabled: false,
          },
          {
            name: "4324, Rite Aid, OWOSSO, MI",
            disabled: false,
          },
          {
            name: "4324, Walgreens, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "4324, Walmart, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "4325, Rite Aid, WATERFORD, MI",
            disabled: false,
          },
          {
            name: "4325, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4325, Walmart, YUMA, AZ",
            disabled: false,
          },
          {
            name: "4326, CVS, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "4326, Rite Aid, IONIA, MI",
            disabled: false,
          },
          {
            name: "4327, CVS, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "4327, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4328, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "433, ADUSA, MEDFORD, MA",
            disabled: false,
          },
          {
            name: "433, CVS, LENOX, MA",
            disabled: false,
          },
          {
            name: "433, Costco, MESA, AZ",
            disabled: false,
          },
          {
            name: "433, HEB, BURNET, TX",
            disabled: false,
          },
          {
            name: "433, Kroger, ATOKA, TN",
            disabled: false,
          },
          {
            name: "433, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "433, Kroger, El Jebel, CO",
            disabled: false,
          },
          {
            name: "433, Kroger, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "433, Kroger, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "433, ShopRite, STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "433, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "4330, CVS, BEDFORD, OH",
            disabled: false,
          },
          {
            name: "4330, Rite Aid, IMLAY CITY, MI",
            disabled: false,
          },
          {
            name: "4330, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "4330, Walmart, CHELSEA, AL",
            disabled: false,
          },
          {
            name: "4331, CVS, CONNEAUT, OH",
            disabled: false,
          },
          {
            name: "4331, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "4332, Rite Aid, BELLEVILLE, MI",
            disabled: false,
          },
          {
            name: "4332, Walgreens, ROCK ISLAND, IL",
            disabled: false,
          },
          {
            name: "4332, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4333, Albertsons, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "4333, CVS, AKRON, OH",
            disabled: false,
          },
          {
            name: "4333, Rite Aid, CLIO, MI",
            disabled: false,
          },
          {
            name: "4333, Walgreens, EAST MOLINE, IL",
            disabled: false,
          },
          {
            name: "4333, Walmart, FAIRHOPE, AL",
            disabled: false,
          },
          {
            name: "4334, Rite Aid, RIVERVIEW, MI",
            disabled: false,
          },
          {
            name: "4334, Walmart, WEAVERVILLE, NC",
            disabled: false,
          },
          {
            name: "4335, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "4335, Rite Aid, WOODHAVEN, MI",
            disabled: false,
          },
          {
            name: "4335, Walmart, FALCON, CO",
            disabled: false,
          },
          {
            name: "4336, CVS, NORTHFIELD, OH",
            disabled: false,
          },
          {
            name: "4336, Walmart, EL MIRAGE, AZ",
            disabled: false,
          },
          {
            name: "4337, CVS, SAINT SIMONS ISLAND, GA",
            disabled: false,
          },
          {
            name: "4337, Walgreens, BETHALTO, IL",
            disabled: false,
          },
          {
            name: "4337, Walmart, SAN LUIS, AZ",
            disabled: false,
          },
          {
            name: "4338, Rite Aid, AUBURN HILLS, MI",
            disabled: false,
          },
          {
            name: "4339, Rite Aid, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4339, Walmart, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "434, CVS, HOBART, IN",
            disabled: false,
          },
          {
            name: "434, HEB, PORT LAVACA, TX",
            disabled: false,
          },
          {
            name: "434, Kroger, BATESVILLE, MS",
            disabled: false,
          },
          {
            name: "434, Kroger, BURLINGTON, KY",
            disabled: false,
          },
          {
            name: "434, Kroger, Eagle, CO",
            disabled: false,
          },
          {
            name: "434, Kroger, Grand Prairie, TX",
            disabled: false,
          },
          {
            name: "434, Kroger, Madison, WI",
            disabled: false,
          },
          {
            name: "434, Kroger, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "434, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "4340, Rite Aid, BURTON, MI",
            disabled: false,
          },
          {
            name: "4340, Walgreens, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4340, Walmart, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "4341, Walmart, TRUTH OR CONSEQUENC, NM",
            disabled: false,
          },
          {
            name: "4341, Walmart, TRUTH OR CONSEQUENCES, NM",
            disabled: false,
          },
          {
            name: "4342, CVS, STRUTHERS, OH",
            disabled: false,
          },
          {
            name: "4344, CVS, MIDDLEBURG, FL",
            disabled: false,
          },
          {
            name: "4344, Walgreens, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "4345, CVS, UNIVERSITY HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4346, Walgreens, BELLEVUE, TN",
            disabled: false,
          },
          {
            name: "4347, CVS, GARFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4348, CVS, WILLOUGHBY HILLS, OH",
            disabled: false,
          },
          {
            name: "4348, Walgreens, MORRIS, IL",
            disabled: false,
          },
          {
            name: "4348, Walmart, DUNCANSVILLE, PA",
            disabled: false,
          },
          {
            name: "4349, CVS, MIDDLEFIELD, OH",
            disabled: false,
          },
          {
            name: "435, ADUSA, BELCHERTOWN, MA",
            disabled: false,
          },
          {
            name: "435, ADUSA, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "435, CVS, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "435, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "435, Kroger, ATHENS, GA",
            disabled: false,
          },
          {
            name: "435, Kroger, Carbondale, CO",
            disabled: false,
          },
          {
            name: "435, Kroger, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "435, Kroger, MURRAY, KY",
            disabled: false,
          },
          {
            name: "435, Walmart, HIGHLAND, IL",
            disabled: false,
          },
          {
            name: "4350, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "4350, Rite Aid, JACKSON, MI",
            disabled: false,
          },
          {
            name: "4350, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4350, Walmart, KILMARNOCK, VA",
            disabled: false,
          },
          {
            name: "4351, CVS, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "4351, Rite Aid, HUNTINGTON WOODS, MI",
            disabled: false,
          },
          {
            name: "4351, Walgreens, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "4352, Rite Aid, OAK PARK, MI",
            disabled: false,
          },
          {
            name: "4352, Walmart, FARGO, ND",
            disabled: false,
          },
          {
            name: "4353, CVS, DOVER, OH",
            disabled: false,
          },
          {
            name: "4353, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "4354, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4355, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4355, Walgreens, PALATINE, IL",
            disabled: false,
          },
          {
            name: "4355, Walmart, TAYLOR, AZ",
            disabled: false,
          },
          {
            name: "4356, Walgreens, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "4356, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4357, CVS, LAKE CITY, FL",
            disabled: false,
          },
          {
            name: "4357, Rite Aid, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "4357, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4358, CVS, DECHERD, TN",
            disabled: false,
          },
          {
            name: "4358, Rite Aid, WAYNE, MI",
            disabled: false,
          },
          {
            name: "4358, Walgreens, AGAWAM, MA",
            disabled: false,
          },
          {
            name: "4358, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "4359, CVS, HUDSON, OH",
            disabled: false,
          },
          {
            name: "4359, Walmart, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "436, ADUSA, ROXBORO, NC",
            disabled: false,
          },
          {
            name: "436, Costco, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "436, Kroger, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "436, Kroger, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "436, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "436, Kroger, FRANKENMUTH, MI",
            disabled: false,
          },
          {
            name: "436, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "436, Walmart, CARLYLE, IL",
            disabled: false,
          },
          {
            name: "4360, CVS, MEDINA, OH",
            disabled: false,
          },
          {
            name: "4360, Rite Aid, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4361, CVS, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "4361, Walgreens, FAIR LAWN, NJ",
            disabled: false,
          },
          {
            name: "4362, Rite Aid, FLAT ROCK, MI",
            disabled: false,
          },
          {
            name: "4363, CVS, MARTINSVILLE, VA",
            disabled: false,
          },
          {
            name: "4363, Rite Aid, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "4365, CVS, PULASKI, TN",
            disabled: false,
          },
          {
            name: "4365, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4366, CVS, CHESTERLAND, OH",
            disabled: false,
          },
          {
            name: "4366, Walgreens, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "4366, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "4367, Walgreens, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4367, Walmart, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "4368, CVS, MUNSTER, IN",
            disabled: false,
          },
          {
            name: "4368, Walmart, OCALA, FL",
            disabled: false,
          },
          {
            name: "4369, CVS, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "437, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "437, Costco, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "437, Kroger, BRIDGEPORT, MI",
            disabled: false,
          },
          {
            name: "437, Kroger, Buena Vista, CO",
            disabled: false,
          },
          {
            name: "437, Kroger, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "437, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "437, Walmart, SEALY, TX",
            disabled: false,
          },
          {
            name: "4370, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "4370, Walmart, FERNLEY, NV",
            disabled: false,
          },
          {
            name: "4371, CVS, OCEAN CITY, MD",
            disabled: false,
          },
          {
            name: "4371, Walgreens, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "4371, Walmart, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "4372, CVS, NORTHPORT, AL",
            disabled: false,
          },
          {
            name: "4372, Rite Aid, MILFORD, MI",
            disabled: false,
          },
          {
            name: "4372, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "4372, Walmart, KINGWOOD, WV",
            disabled: false,
          },
          {
            name: "4373, Walgreens, ANGLETON, TX",
            disabled: false,
          },
          {
            name: "4373, Walmart, WAKE VILLAGE, TX",
            disabled: false,
          },
          {
            name: "4374, CVS, RED SPRINGS, NC",
            disabled: false,
          },
          {
            name: "4374, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4374, Walmart, LITCHFIELD, MN",
            disabled: false,
          },
          {
            name: "4375, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "4375, Rite Aid, ST. CLAIR SHORES, MI",
            disabled: false,
          },
          {
            name: "4375, Walmart, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "4376, CVS, GRENADA, MS",
            disabled: false,
          },
          {
            name: "4376, Rite Aid, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "4376, Walgreens, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "4376, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "4377, Rite Aid, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "4377, Walmart, CRAIG, CO",
            disabled: false,
          },
          {
            name: "4378, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "4378, Rite Aid, ALMA, MI",
            disabled: false,
          },
          {
            name: "4378, Walgreens, ROCKLEDGE, FL",
            disabled: false,
          },
          {
            name: "4378, Walmart, ONLEY, VA",
            disabled: false,
          },
          {
            name: "4379, CVS, LENOIR, NC",
            disabled: false,
          },
          {
            name: "4379, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "438, ADUSA, STUARTS DRAFT, VA",
            disabled: false,
          },
          {
            name: "438, Costco, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "438, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "438, Kroger, Carrollton, IL",
            disabled: false,
          },
          {
            name: "438, Kroger, LILBURN, GA",
            disabled: false,
          },
          {
            name: "438, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "438, Walmart, BRECKENRIDGE, TX",
            disabled: false,
          },
          {
            name: "4380, CVS, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "4380, Rite Aid, HILLSDALE, MI",
            disabled: false,
          },
          {
            name: "4380, Walgreens, LAKE WALES, FL",
            disabled: false,
          },
          {
            name: "4380, Walmart, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4381, Albertsons, BAKER CITY, OR",
            disabled: false,
          },
          {
            name: "4381, CVS, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "4381, Rite Aid, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "4381, Walmart, BRANSON, MO",
            disabled: false,
          },
          {
            name: "4382, CVS, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "4382, Rite Aid, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "4382, Walgreens, POMONA, CA",
            disabled: false,
          },
          {
            name: "4383, CVS, PASADENA, TX",
            disabled: false,
          },
          {
            name: "4383, Walmart, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "4384, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "4384, Walmart, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "4385, CVS, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "4385, Rite Aid, WARREN, MI",
            disabled: false,
          },
          {
            name: "4385, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "4386, CVS, CHESTER, SC",
            disabled: false,
          },
          {
            name: "4386, Walgreens, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "4387, ADUSA, CANTON, OH",
            disabled: false,
          },
          {
            name: "4387, Albertsons, GLADSTONE, OR",
            disabled: false,
          },
          {
            name: "4387, Walgreens, OAKLAND PARK, FL",
            disabled: false,
          },
          {
            name: "4387, Walmart, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "4388, CVS, BEECH ISLAND, SC",
            disabled: false,
          },
          {
            name: "4388, Walmart, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "4389, CVS, WINDER, GA",
            disabled: false,
          },
          {
            name: "4389, Rite Aid, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4389, Walmart, WOODSVILLE, NH",
            disabled: false,
          },
          {
            name: "439, Costco, AURORA, CO",
            disabled: false,
          },
          {
            name: "439, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "439, Kroger, BOISE, ID",
            disabled: false,
          },
          {
            name: "439, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "439, Kroger, Liberty Twp, OH",
            disabled: false,
          },
          {
            name: "439, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "439, Kroger, WAYCROSS, GA",
            disabled: false,
          },
          {
            name: "4390, CVS, MOREHEAD CITY, NC",
            disabled: false,
          },
          {
            name: "4390, Rite Aid, WARREN, MI",
            disabled: false,
          },
          {
            name: "4390, Walmart, ENID, OK",
            disabled: false,
          },
          {
            name: "4391, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "4391, Walgreens, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "4392, Walgreens, KIRKWOOD, MO",
            disabled: false,
          },
          {
            name: "4392, Walmart, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "4393, Rite Aid, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "4393, Walgreens, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "4393, Walmart, NORTH HIGHLANDS, CA",
            disabled: false,
          },
          {
            name: "4394, Walgreens, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "4394, Walmart, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "4395, CVS, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "4395, Rite Aid, KENTWOOD, MI",
            disabled: false,
          },
          {
            name: "4395, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4395, Walmart, POST FALLS, ID",
            disabled: false,
          },
          {
            name: "4396, CVS, PARK RIDGE, IL",
            disabled: false,
          },
          {
            name: "4396, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4397, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "4397, Walgreens, BOARDMAN, OH",
            disabled: false,
          },
          {
            name: "4398, CVS, YADKINVILLE, NC",
            disabled: false,
          },
          {
            name: "4398, Walgreens, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "4399, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "4399, Walmart, ELKHART, IN",
            disabled: false,
          },
          {
            name: "44, ADUSA, WALPOLE, MA",
            disabled: false,
          },
          {
            name: "44, BJ's, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "44, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "44, Costco, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "44, Kroger, JUNCTION CITY, KS",
            disabled: false,
          },
          {
            name: "44, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "44, Kroger, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "44, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "44, Meijer, FLINT, MI",
            disabled: false,
          },
          {
            name: "44, Walmart, ELDON, MO",
            disabled: false,
          },
          {
            name: "440, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "440, Albertsons, HANOVER, MA",
            disabled: false,
          },
          {
            name: "440, CVS, MARGATE, FL",
            disabled: false,
          },
          {
            name: "440, Costco, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "440, Kroger, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "440, Kroger, LAKELAND, TN",
            disabled: false,
          },
          {
            name: "440, Kroger, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "440, Kroger, Montrose, CO",
            disabled: false,
          },
          {
            name: "440, Walmart, ROCKPORT, TX",
            disabled: false,
          },
          {
            name: "4400, CVS, GALLIPOLIS, OH",
            disabled: false,
          },
          {
            name: "4400, Walgreens, HUDSON, FL",
            disabled: false,
          },
          {
            name: "4401, CVS, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4401, Rite Aid, DOWAGIAC, MI",
            disabled: false,
          },
          {
            name: "4401, Walgreens, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "4402, Rite Aid, WARREN, MI",
            disabled: false,
          },
          {
            name: "4402, Walgreens, HALLANDALE BEACH, FL",
            disabled: false,
          },
          {
            name: "4403, CVS, MAPLEWOOD, MO",
            disabled: false,
          },
          {
            name: "4403, Rite Aid, NORTH MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "4403, Walgreens, QUINCY, MA",
            disabled: false,
          },
          {
            name: "4403, Walmart, QUEENSBURY, NY",
            disabled: false,
          },
          {
            name: "4404, Albertsons, DALLAS, OR",
            disabled: false,
          },
          {
            name: "4404, CVS, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "4404, Walgreens, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "4404, Walmart, ETTERS, PA",
            disabled: false,
          },
          {
            name: "4405, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "4405, Rite Aid, ADRIAN, MI",
            disabled: false,
          },
          {
            name: "4405, Walgreens, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "4405, Walmart, AURORA, IL",
            disabled: false,
          },
          {
            name: "4406, Albertsons, GIG HARBOR, WA",
            disabled: false,
          },
          {
            name: "4406, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4407, Albertsons, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "4407, Walgreens, GRANITE CITY, IL",
            disabled: false,
          },
          {
            name: "4407, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4408, Rite Aid, FENTON, MI",
            disabled: false,
          },
          {
            name: "4409, CVS, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "4409, Rite Aid, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "4409, Walgreens, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "4409, Walmart, ROCKMART, GA",
            disabled: false,
          },
          {
            name: "441, ADUSA, MOUNT AIRY, NC",
            disabled: false,
          },
          {
            name: "441, Albertsons, WARWICK, RI",
            disabled: false,
          },
          {
            name: "441, Costco, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "441, HEB, UVALDE, TX",
            disabled: false,
          },
          {
            name: "441, Kroger, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "441, Kroger, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "441, Kroger, New Castle, CO",
            disabled: false,
          },
          {
            name: "441, Kroger, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "441, Rite Aid, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "4410, Walmart, GRANITE FALLS, NC",
            disabled: false,
          },
          {
            name: "4411, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4412, Walgreens, TROY, MI",
            disabled: false,
          },
          {
            name: "4412, Walmart, LAUREL, MT",
            disabled: false,
          },
          {
            name: "4413, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "4413, Walmart, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "4414, Walmart, SMITHVILLE, TN",
            disabled: false,
          },
          {
            name: "4415, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4415, Rite Aid, WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "4415, Walgreens, MERCED, CA",
            disabled: false,
          },
          {
            name: "4415, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "4416, Walgreens, CUPERTINO, CA",
            disabled: false,
          },
          {
            name: "4416, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4417, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4417, Walmart, CAMBY, IN",
            disabled: false,
          },
          {
            name: "4418, CVS, PASADENA, MD",
            disabled: false,
          },
          {
            name: "4418, Walgreens, COPPELL, TX",
            disabled: false,
          },
          {
            name: "4419, CVS, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "4419, Rite Aid, NATRONA HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "442, CVS, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "442, Kroger, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "442, Kroger, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "442, Kroger, Vail, CO",
            disabled: false,
          },
          {
            name: "442, Rite Aid, PENN YAN, NY",
            disabled: false,
          },
          {
            name: "442, Walmart, KINGSVILLE, TX",
            disabled: false,
          },
          {
            name: "4420, Rite Aid, HOWELL, MI",
            disabled: false,
          },
          {
            name: "4420, Walmart, LEESVILLE, SC",
            disabled: false,
          },
          {
            name: "4421, CVS, MONTEAGLE, TN",
            disabled: false,
          },
          {
            name: "4421, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "4421, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4422, CVS, PALATKA, FL",
            disabled: false,
          },
          {
            name: "4422, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4423, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "4423, Walmart, MARTINSBURG, WV",
            disabled: false,
          },
          {
            name: "4424, CVS, EAST POINT, GA",
            disabled: false,
          },
          {
            name: "4424, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "4424, Walmart, WARREN, MI",
            disabled: false,
          },
          {
            name: "4425, CVS, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "4425, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4426, Rite Aid, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "4426, Walgreens, BELLEVIEW, FL",
            disabled: false,
          },
          {
            name: "4426, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4427, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4427, Walmart, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4428, CVS, HIXSON, TN",
            disabled: false,
          },
          {
            name: "4428, Walmart, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "4429, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4429, Walgreens, GLENOLDEN, PA",
            disabled: false,
          },
          {
            name: "443, ADUSA, ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "443, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "443, Costco, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "443, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "443, Kroger, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "443, Kroger, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "443, Kroger, Rifle, CO",
            disabled: false,
          },
          {
            name: "443, Rite Aid, PENNSBURG, PA",
            disabled: false,
          },
          {
            name: "443, Walmart, HONDO, TX",
            disabled: false,
          },
          {
            name: "4430, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4430, Walgreens, INKSTER, MI",
            disabled: false,
          },
          {
            name: "4430, Walmart, MARICOPA, AZ",
            disabled: false,
          },
          {
            name: "4431, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "4431, Rite Aid, HOUGHTON LAKE, MI",
            disabled: false,
          },
          {
            name: "4431, Walmart, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "4432, CVS, MONTGOMERY, WV",
            disabled: false,
          },
          {
            name: "4432, Rite Aid, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "4432, Walmart, NEWTON, NC",
            disabled: false,
          },
          {
            name: "4433, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4434, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "4434, Walmart, OCALA, FL",
            disabled: false,
          },
          {
            name: "4435, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "4435, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "4435, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "4436, CVS, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "4436, Walmart, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "4437, CVS, TWINSBURG, OH",
            disabled: false,
          },
          {
            name: "4437, Walgreens, HALTOM CITY, TX",
            disabled: false,
          },
          {
            name: "4438, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4438, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "4438, Walgreens, ELK GROVE VILLAGE, IL",
            disabled: false,
          },
          {
            name: "4438, Walmart, SARATOGA SPRINGS, UT",
            disabled: false,
          },
          {
            name: "4439, Rite Aid, DAVISON, MI",
            disabled: false,
          },
          {
            name: "4439, Walgreens, LIBERTY, MO",
            disabled: false,
          },
          {
            name: "4439, Walmart, PAW PAW, MI",
            disabled: false,
          },
          {
            name: "444, ADUSA, WHITMAN, MA",
            disabled: false,
          },
          {
            name: "444, Albertsons, HERMISTON, OR",
            disabled: false,
          },
          {
            name: "444, CVS, WESTBOROUGH, MA",
            disabled: false,
          },
          {
            name: "444, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "444, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "444, Kroger, BOUNTIFUL, UT",
            disabled: false,
          },
          {
            name: "444, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "444, Kroger, Grand Junction, CO",
            disabled: false,
          },
          {
            name: "444, Kroger, HOWELL, MI",
            disabled: false,
          },
          {
            name: "444, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "4440, CVS, FORT WALTON BEACH, FL",
            disabled: false,
          },
          {
            name: "4440, Rite Aid, SWARTZ CREEK, MI",
            disabled: false,
          },
          {
            name: "4440, Walgreens, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "4440, Walmart, IRMO, SC",
            disabled: false,
          },
          {
            name: "4441, CVS, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "4441, Rite Aid, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "4441, Walgreens, HOLLY HILL, FL",
            disabled: false,
          },
          {
            name: "4441, Walmart, PALM SPRINGS VILLAG, FL",
            disabled: false,
          },
          {
            name: "4441, Walmart, PALM SPRINGS VILLAGE, FL",
            disabled: false,
          },
          {
            name: "4442, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "4442, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "4443, Albertsons, NORTH PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "4443, CVS, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "4443, Rite Aid, FLUSHING, MI",
            disabled: false,
          },
          {
            name: "4443, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "4443, Walmart, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "4444, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "4444, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4445, CVS, LIMA, OH",
            disabled: false,
          },
          {
            name: "4445, Rite Aid, ALLEN PARK, MI",
            disabled: false,
          },
          {
            name: "4445, Walmart, CLEMSON, SC",
            disabled: false,
          },
          {
            name: "4446, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4446, Walmart, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "4447, CVS, LIMA, OH",
            disabled: false,
          },
          {
            name: "4447, Rite Aid, MOUNT MORRIS, MI",
            disabled: false,
          },
          {
            name: "4447, Walgreens, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "4448, Walgreens, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "4449, CVS, MILTON, FL",
            disabled: false,
          },
          {
            name: "4449, Walgreens, FERNANDINA BEACH, FL",
            disabled: false,
          },
          {
            name: "445, ADUSA, NORWOOD, NC",
            disabled: false,
          },
          {
            name: "445, Costco, YORBA LINDA, CA",
            disabled: false,
          },
          {
            name: "445, HEB, LOCKHART, TX",
            disabled: false,
          },
          {
            name: "445, Kroger, Arlington, TX",
            disabled: false,
          },
          {
            name: "445, Kroger, CLEVES, OH",
            disabled: false,
          },
          {
            name: "445, Kroger, Jonesboro, AR",
            disabled: false,
          },
          {
            name: "445, Kroger, LITHONIA, GA",
            disabled: false,
          },
          {
            name: "445, Kroger, Pagosa Springs, CO",
            disabled: false,
          },
          {
            name: "445, Kroger, Saint Clair Shores, MI",
            disabled: false,
          },
          {
            name: "445, Walmart, LEITCHFIELD, KY",
            disabled: false,
          },
          {
            name: "4450, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "4450, Walmart, MIDDLETOWN, KY",
            disabled: false,
          },
          {
            name: "4451, CVS, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "4451, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "4451, Walmart, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "4452, CVS, NORTH BABYLON, NY",
            disabled: false,
          },
          {
            name: "4452, Rite Aid, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "4452, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "4453, Walmart, GREENVILLE, TX",
            disabled: false,
          },
          {
            name: "4454, Walgreens, NOVI, MI",
            disabled: false,
          },
          {
            name: "4455, CVS, EAST NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "4455, Rite Aid, CARO, MI",
            disabled: false,
          },
          {
            name: "4455, Walgreens, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "4456, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4456, Walgreens, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "4456, Walmart, SOMERDALE, NJ",
            disabled: false,
          },
          {
            name: "4457, Walmart, BENNETTSVILLE, SC",
            disabled: false,
          },
          {
            name: "4458, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4458, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4458, Walmart, HOLLY SPRINGS, NC",
            disabled: false,
          },
          {
            name: "4459, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4459, Walmart, NASHVILLE, NC",
            disabled: false,
          },
          {
            name: "446, ADUSA, MONROE, NC",
            disabled: false,
          },
          {
            name: "446, ADUSA, WATERTOWN, MA",
            disabled: false,
          },
          {
            name: "446, HEB, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "446, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "446, Kroger, Granby, CO",
            disabled: false,
          },
          {
            name: "446, Kroger, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "446, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "446, Walmart, MADISONVILLE, TX",
            disabled: false,
          },
          {
            name: "4460, Rite Aid, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "4460, Walgreens, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "4460, Walmart, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "4461, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "4461, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4461, Walmart, LOUISA, KY",
            disabled: false,
          },
          {
            name: "4462, Walgreens, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "4463, Walgreens, SOUTH ELGIN, IL",
            disabled: false,
          },
          {
            name: "4464, CVS, LA VERGNE, TN",
            disabled: false,
          },
          {
            name: "4464, Walgreens, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "4464, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "4465, CVS, TAVARES, FL",
            disabled: false,
          },
          {
            name: "4465, Walmart, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "4466, CVS, TULLAHOMA, TN",
            disabled: false,
          },
          {
            name: "4466, Rite Aid, GARDEN CITY, MI",
            disabled: false,
          },
          {
            name: "4466, Walgreens, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "4466, Walmart, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "4467, CVS, MILLS RIVER, NC",
            disabled: false,
          },
          {
            name: "4467, Rite Aid, BERKLEY, MI",
            disabled: false,
          },
          {
            name: "4468, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "4468, Walgreens, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "4468, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "4469, Albertsons, BURNS, OR",
            disabled: false,
          },
          {
            name: "4469, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "4469, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "447, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "447, CVS, NORTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "447, Costco, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "447, Kroger, Carbondale, CO",
            disabled: false,
          },
          {
            name: "447, Kroger, HAZEL PARK, MI",
            disabled: false,
          },
          {
            name: "447, Kroger, LEBANON, OH",
            disabled: false,
          },
          {
            name: "447, Kroger, Stone Mountain, GA",
            disabled: false,
          },
          {
            name: "447, Kroger, TUPELO, MS",
            disabled: false,
          },
          {
            name: "447, Rite Aid, DOUGLASSVILLE, PA",
            disabled: false,
          },
          {
            name: "447, Walmart, DEL RIO, TX",
            disabled: false,
          },
          {
            name: "4470, Walgreens, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "4470, Walmart, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "4471, Albertsons, AUBURN, MA",
            disabled: false,
          },
          {
            name: "4471, CVS, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "4471, Rite Aid, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "4471, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4471, Walmart, RAWLINS, WY",
            disabled: false,
          },
          {
            name: "4472, CVS, PERRY, FL",
            disabled: false,
          },
          {
            name: "4472, Walmart, LITHONIA, GA",
            disabled: false,
          },
          {
            name: "4473, CVS, EAST LYME, CT",
            disabled: false,
          },
          {
            name: "4473, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4474, CVS, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "4474, Walgreens, BURBANK, CA",
            disabled: false,
          },
          {
            name: "4474, Walmart, KENAI, AK",
            disabled: false,
          },
          {
            name: "4475, Walmart, OLATHE, KS",
            disabled: false,
          },
          {
            name: "4476, Walmart, CHESTERFIELD, VA",
            disabled: false,
          },
          {
            name: "4477, Rite Aid, KEEGO HARBOR, MI",
            disabled: false,
          },
          {
            name: "4477, Walmart, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "4478, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4478, Walmart, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "4479, CVS, CROSSVILLE, TN",
            disabled: false,
          },
          {
            name: "4479, Walmart, PERRYSBURG, OH",
            disabled: false,
          },
          {
            name: "448, HEB, PALMVIEW, TX",
            disabled: false,
          },
          {
            name: "448, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "448, Kroger, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "448, Kroger, COPPELL, TX",
            disabled: false,
          },
          {
            name: "448, Kroger, JACKSON, TN",
            disabled: false,
          },
          {
            name: "448, Kroger, MASON, OH",
            disabled: false,
          },
          {
            name: "448, Kroger, TROY, MI",
            disabled: false,
          },
          {
            name: "448, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "4480, CVS, CHIPLEY, FL",
            disabled: false,
          },
          {
            name: "4480, Walgreens, OLDSMAR, FL",
            disabled: false,
          },
          {
            name: "4482, Rite Aid, LANSING, MI",
            disabled: false,
          },
          {
            name: "4482, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4482, Walmart, MOUNT JULIET, TN",
            disabled: false,
          },
          {
            name: "4483, Albertsons, AUBURN, WA",
            disabled: false,
          },
          {
            name: "4483, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "4483, Walgreens, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "4483, Walmart, WHITE HOUSE, TN",
            disabled: false,
          },
          {
            name: "4484, Walgreens, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "4484, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "4485, CVS, HIGH SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4485, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4486, Albertsons, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "4486, Walgreens, SCHERERVILLE, IN",
            disabled: false,
          },
          {
            name: "4487, Rite Aid, COMMERCE TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "4487, Walgreens, ASTON, PA",
            disabled: false,
          },
          {
            name: "4487, Walmart, AIKEN, SC",
            disabled: false,
          },
          {
            name: "4488, Rite Aid, GLADWIN, MI",
            disabled: false,
          },
          {
            name: "4488, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "4488, Walmart, MARINA, CA",
            disabled: false,
          },
          {
            name: "4489, CVS, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "449, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "449, Kroger, GARDEN CITY, ID",
            disabled: false,
          },
          {
            name: "449, Kroger, RICHLAND, MS",
            disabled: false,
          },
          {
            name: "449, Kroger, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "449, Kroger, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "449, Rite Aid, NEW LEBANON, OH",
            disabled: false,
          },
          {
            name: "449, Walmart, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "4490, CVS, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "4490, Rite Aid, EASTPOINTE, MI",
            disabled: false,
          },
          {
            name: "4490, Walgreens, WETHERSFIELD, CT",
            disabled: false,
          },
          {
            name: "4490, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4491, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4491, Walgreens, SAN PABLO, CA",
            disabled: false,
          },
          {
            name: "4491, Walmart, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "4492, Rite Aid, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "4493, Walgreens, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "4494, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "4494, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4494, Walmart, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "4495, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4495, Rite Aid, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "4496, Albertsons, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "4497, Walmart, HUEYTOWN, AL",
            disabled: false,
          },
          {
            name: "4498, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4498, Walgreens, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "4498, Walmart, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4499, CVS, LYNDHURST, OH",
            disabled: false,
          },
          {
            name: "4499, Walmart, ZEBULON, NC",
            disabled: false,
          },
          {
            name: "45, ADUSA, GREENFIELD, MA",
            disabled: false,
          },
          {
            name: "45, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "45, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "45, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "45, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "45, Kroger, CORONA, CA",
            disabled: false,
          },
          {
            name: "45, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "45, Kroger, Eastvale, CA",
            disabled: false,
          },
          {
            name: "45, Kroger, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "45, Kroger, WINFIELD, KS",
            disabled: false,
          },
          {
            name: "45, Meijer, ADRIAN, MI",
            disabled: false,
          },
          {
            name: "45, Walmart, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "450, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "450, Kroger, ALGONAC, MI",
            disabled: false,
          },
          {
            name: "450, Kroger, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "450, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "4500, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4500, CVS, PANAMA CITY, FL",
            disabled: false,
          },
          {
            name: "4500, Rite Aid, ST. CLAIR SHORES, MI",
            disabled: false,
          },
          {
            name: "4501, CVS, JENNINGS, LA",
            disabled: false,
          },
          {
            name: "4501, Walgreens, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4501, Walmart, WEST BROWNSVILLE, PA",
            disabled: false,
          },
          {
            name: "4502, CVS, ROME, GA",
            disabled: false,
          },
          {
            name: "4502, Rite Aid, TAWAS CITY, MI",
            disabled: false,
          },
          {
            name: "4502, Walgreens, CARPENTERSVILLE, IL",
            disabled: false,
          },
          {
            name: "4503, Rite Aid, WEST BRANCH, MI",
            disabled: false,
          },
          {
            name: "4503, Walgreens, MORTON GROVE, IL",
            disabled: false,
          },
          {
            name: "4503, Walmart, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "4504, CVS, SANDY SPRINGS, GA",
            disabled: false,
          },
          {
            name: "4504, Walgreens, GALESBURG, IL",
            disabled: false,
          },
          {
            name: "4504, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4506, CVS, CALHOUN, GA",
            disabled: false,
          },
          {
            name: "4506, Rite Aid, CADILLAC, MI",
            disabled: false,
          },
          {
            name: "4506, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "4506, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "4507, CVS, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "4507, Rite Aid, FRANKENMUTH, MI",
            disabled: false,
          },
          {
            name: "4507, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "4508, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "4508, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4508, Walmart, PENITAS, TX",
            disabled: false,
          },
          {
            name: "4509, Walmart, BENBROOK, TX",
            disabled: false,
          },
          {
            name: "451, ADUSA, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "451, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "451, Kroger, EULESS, TX",
            disabled: false,
          },
          {
            name: "451, Kroger, Grand Junction, CO",
            disabled: false,
          },
          {
            name: "451, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "451, Kroger, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "451, Rite Aid, YORK, PA",
            disabled: false,
          },
          {
            name: "451, Walmart, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "4510, Rite Aid, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "4510, Walgreens, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "4511, Walmart, SILVIS, IL",
            disabled: false,
          },
          {
            name: "4512, Albertsons, NORTH HAMPTON, NH",
            disabled: false,
          },
          {
            name: "4512, CVS, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "4512, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4512, Walgreens, WARREN, MI",
            disabled: false,
          },
          {
            name: "4512, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "4513, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "4513, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4513, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4514, Albertsons, HILLSBOROUGH, NH",
            disabled: false,
          },
          {
            name: "4514, CVS, TIFTON, GA",
            disabled: false,
          },
          {
            name: "4514, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4514, Walmart, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "4515, CVS, THOMASVILLE, GA",
            disabled: false,
          },
          {
            name: "4515, Rite Aid, AUBURN HILLS, MI",
            disabled: false,
          },
          {
            name: "4516, Albertsons, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "4516, Walgreens, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "4516, Walmart, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "4517, Walgreens, FREMONT, CA",
            disabled: false,
          },
          {
            name: "4517, Walmart, ALBANY, GA",
            disabled: false,
          },
          {
            name: "4518, CVS, WASHINGTON, GA",
            disabled: false,
          },
          {
            name: "4519, CVS, CARTHAGE, MS",
            disabled: false,
          },
          {
            name: "4519, Rite Aid, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "4519, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4519, Walmart, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "452, CVS, GREENBELT, MD",
            disabled: false,
          },
          {
            name: "452, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "452, Kroger, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "452, ShopRite, BROOKHAVEN, PA",
            disabled: false,
          },
          {
            name: "452, Walmart, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "4520, CVS, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "4520, Rite Aid, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "4520, Walgreens, MIAMISBURG, OH",
            disabled: false,
          },
          {
            name: "4520, Walmart, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4521, CVS, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "4521, Walgreens, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4521, Walmart, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "4522, CVS, AUSTELL, GA",
            disabled: false,
          },
          {
            name: "4522, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "4523, CVS, AIKEN, SC",
            disabled: false,
          },
          {
            name: "4523, Rite Aid, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "4523, Walgreens, BRANDON, FL",
            disabled: false,
          },
          {
            name: "4524, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "4524, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4524, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4525, Walmart, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "4526, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4526, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4526, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4527, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4527, Walmart, WAYCROSS, GA",
            disabled: false,
          },
          {
            name: "4528, Rite Aid, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "4528, Walmart, DALTON, GA",
            disabled: false,
          },
          {
            name: "4529, Walmart, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "453, ADUSA, TAPPAHANNOCK, VA",
            disabled: false,
          },
          {
            name: "453, Albertsons, RENTON, WA",
            disabled: false,
          },
          {
            name: "453, CVS, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "453, Costco, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "453, Kroger, Dearborn, MI",
            disabled: false,
          },
          {
            name: "453, Kroger, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "453, Kroger, POWDER SPRINGS, GA",
            disabled: false,
          },
          {
            name: "453, Walmart, MALDEN, MO",
            disabled: false,
          },
          {
            name: "4530, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "4530, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4530, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4531, CVS, JACKSON, GA",
            disabled: false,
          },
          {
            name: "4531, Walgreens, NORFOLK, NE",
            disabled: false,
          },
          {
            name: "4531, Walmart, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "4532, CVS, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "4532, Rite Aid, ALPENA, MI",
            disabled: false,
          },
          {
            name: "4532, Walgreens, PARK FOREST, IL",
            disabled: false,
          },
          {
            name: "4533, Walgreens, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "4533, Walmart, OAKLAND, TN",
            disabled: false,
          },
          {
            name: "4534, Albertsons, NEWPORT, NH",
            disabled: false,
          },
          {
            name: "4534, CVS, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "4535, CVS, BAINBRIDGE, GA",
            disabled: false,
          },
          {
            name: "4535, Walgreens, RANDOLPH, MA",
            disabled: false,
          },
          {
            name: "4536, CVS, BOONEVILLE, MS",
            disabled: false,
          },
          {
            name: "4537, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4537, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4538, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4538, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "4539, Rite Aid, JACKSON, MI",
            disabled: false,
          },
          {
            name: "454, ADUSA, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "454, Costco, IRVINE, CA",
            disabled: false,
          },
          {
            name: "454, Kroger, CORINTH, MS",
            disabled: false,
          },
          {
            name: "454, Kroger, GROSSE POINTE WOODS, MI",
            disabled: false,
          },
          {
            name: "454, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "454, Kroger, Union, KY",
            disabled: false,
          },
          {
            name: "454, Walmart, FAIRFIELD, IL",
            disabled: false,
          },
          {
            name: "4540, CVS, LAGRANGE, GA",
            disabled: false,
          },
          {
            name: "4540, Walgreens, PARK RIDGE, IL",
            disabled: false,
          },
          {
            name: "4540, Walmart, FOWLERVILLE, MI",
            disabled: false,
          },
          {
            name: "4542, CVS, CONYERS, GA",
            disabled: false,
          },
          {
            name: "4543, Albertsons, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "4543, Rite Aid, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "4543, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "4543, Walmart, PARKER, AZ",
            disabled: false,
          },
          {
            name: "4544, CVS, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "4544, Walgreens, PERTH AMBOY, NJ",
            disabled: false,
          },
          {
            name: "4545, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "4545, Rite Aid, WYANDOTTE, MI",
            disabled: false,
          },
          {
            name: "4545, Walmart, WILSON, NC",
            disabled: false,
          },
          {
            name: "4546, Rite Aid, CLAWSON, MI",
            disabled: false,
          },
          {
            name: "4546, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "4546, Walmart, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "4547, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "4548, Rite Aid, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "4548, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "4549, CVS, JONESBORO, GA",
            disabled: false,
          },
          {
            name: "4549, Walgreens, MINT HILL, NC",
            disabled: false,
          },
          {
            name: "455, ADUSA, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "455, ADUSA, WINCHESTER, MA",
            disabled: false,
          },
          {
            name: "455, Costco, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "455, HEB, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "455, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "455, Kroger, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "4550, Walgreens, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "4551, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4552, CVS, DOUGLAS, GA",
            disabled: false,
          },
          {
            name: "4552, Rite Aid, FLORAL PARK, NY",
            disabled: false,
          },
          {
            name: "4552, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4553, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "4553, Walmart, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "4554, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "4554, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4554, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4555, Albertsons, WEST LEBANON, NH",
            disabled: false,
          },
          {
            name: "4555, CVS, ATHENS, GA",
            disabled: false,
          },
          {
            name: "4556, Albertsons, BANGOR, ME",
            disabled: false,
          },
          {
            name: "4556, CVS, THOMSON, GA",
            disabled: false,
          },
          {
            name: "4556, Walgreens, GREENDALE, WI",
            disabled: false,
          },
          {
            name: "4556, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "4557, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "4557, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4558, Walmart, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "4559, Albertsons, LEWISTON, ME",
            disabled: false,
          },
          {
            name: "4559, Rite Aid, MARYSVILLE, MI",
            disabled: false,
          },
          {
            name: "4559, Walgreens, MILL VALLEY, CA",
            disabled: false,
          },
          {
            name: "456, ADUSA, GEORGETOWN, SC",
            disabled: false,
          },
          {
            name: "456, CVS, CLOSTER, NJ",
            disabled: false,
          },
          {
            name: "456, Kroger, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "456, Kroger, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "456, Kroger, POWDER SPRINGS, GA",
            disabled: false,
          },
          {
            name: "456, Kroger, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "456, Walgreens, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "456, Walmart, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "4560, Albertsons, SANFORD, ME",
            disabled: false,
          },
          {
            name: "4560, CVS, ALBANY, GA",
            disabled: false,
          },
          {
            name: "4560, Walgreens, PORTAGE, IN",
            disabled: false,
          },
          {
            name: "4560, Walmart, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "4561, Walgreens, BATAVIA, IL",
            disabled: false,
          },
          {
            name: "4561, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4563, Albertsons, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "4563, Walmart, DANIA BEACH, FL",
            disabled: false,
          },
          {
            name: "4564, CVS, EASTMAN, GA",
            disabled: false,
          },
          {
            name: "4564, Rite Aid, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "4564, Walmart, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "4565, CVS, MILLEDGEVILLE, GA",
            disabled: false,
          },
          {
            name: "4565, Walgreens, JAMAICA, NY",
            disabled: false,
          },
          {
            name: "4565, Walmart, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "4566, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "4567, CVS, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "4567, Rite Aid, LUDINGTON, MI",
            disabled: false,
          },
          {
            name: "4567, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4567, Walmart, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "4568, Albertsons, AUBURNDALE, MA",
            disabled: false,
          },
          {
            name: "4568, CVS, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "4568, Walgreens, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "4568, Walmart, BLAIR, NE",
            disabled: false,
          },
          {
            name: "4569, CVS, ALBANY, GA",
            disabled: false,
          },
          {
            name: "4569, Walmart, BOTTINEAU, ND",
            disabled: false,
          },
          {
            name: "457, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "457, CVS, SALEM, MA",
            disabled: false,
          },
          {
            name: "457, Kroger, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "457, Kroger, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "457, Kroger, DACULA, GA",
            disabled: false,
          },
          {
            name: "457, ShopRite, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "457, Walmart, VIDOR, TX",
            disabled: false,
          },
          {
            name: "4570, Walmart, NAPANOCH, NY",
            disabled: false,
          },
          {
            name: "4571, CVS, HAZLEHURST, GA",
            disabled: false,
          },
          {
            name: "4571, Walgreens, LAWRENCE, MA",
            disabled: false,
          },
          {
            name: "4572, Albertsons, BRIGHTON, MA",
            disabled: false,
          },
          {
            name: "4572, CVS, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "4572, Walgreens, WILLOWBROOK, IL",
            disabled: false,
          },
          {
            name: "4573, Walgreens, TEMPLE TERRACE, FL",
            disabled: false,
          },
          {
            name: "4574, Rite Aid, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "4574, Walmart, CONCORD, NC",
            disabled: false,
          },
          {
            name: "4575, CVS, SAINT SIMONS ISLAND, GA",
            disabled: false,
          },
          {
            name: "4576, CVS, TALLAPOOSA, GA",
            disabled: false,
          },
          {
            name: "4577, CVS, CUTHBERT, GA",
            disabled: false,
          },
          {
            name: "4577, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "4577, Walmart, RUSTON, LA",
            disabled: false,
          },
          {
            name: "4578, Walgreens, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "4579, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4579, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4579, Walmart, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "458, ADUSA, PITTSFIELD, MA",
            disabled: false,
          },
          {
            name: "458, ADUSA, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "458, Albertsons, MILL CREEK, WA",
            disabled: false,
          },
          {
            name: "458, HEB, CARTHAGE, TX",
            disabled: false,
          },
          {
            name: "458, Kroger, Brownstown, MI",
            disabled: false,
          },
          {
            name: "458, Kroger, DALTON, GA",
            disabled: false,
          },
          {
            name: "458, Kroger, EVERETT, WA",
            disabled: false,
          },
          {
            name: "458, Walmart, ARANSAS PASS, TX",
            disabled: false,
          },
          {
            name: "4580, CVS, MONTICELLO, GA",
            disabled: false,
          },
          {
            name: "4580, Rite Aid, VERMILION, OH",
            disabled: false,
          },
          {
            name: "4580, Walmart, VESTAVIA HILLS, AL",
            disabled: false,
          },
          {
            name: "4581, CVS, NILES, IL",
            disabled: false,
          },
          {
            name: "4581, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4582, CVS, SUMMERVILLE, GA",
            disabled: false,
          },
          {
            name: "4582, Walmart, NAVARRE, FL",
            disabled: false,
          },
          {
            name: "4583, CVS, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "4583, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "4584, Walgreens, WENTZVILLE, MO",
            disabled: false,
          },
          {
            name: "4585, CVS, FORT VALLEY, GA",
            disabled: false,
          },
          {
            name: "4585, Walgreens, RIVERVIEW, MI",
            disabled: false,
          },
          {
            name: "4585, Walmart, OWASSO, OK",
            disabled: false,
          },
          {
            name: "4586, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4586, Walmart, BILOXI, MS",
            disabled: false,
          },
          {
            name: "4587, Albertsons, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "4587, Walgreens, HIGHLAND VILLAGE, TX",
            disabled: false,
          },
          {
            name: "4588, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "4588, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4589, CVS, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "4589, Walgreens, PELHAM, AL",
            disabled: false,
          },
          {
            name: "4589, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "459, ADUSA, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "459, ADUSA, PINEVILLE, NC",
            disabled: false,
          },
          {
            name: "459, Albertsons, KENT, WA",
            disabled: false,
          },
          {
            name: "459, CVS, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "459, Costco, MONTEBELLO, CA",
            disabled: false,
          },
          {
            name: "459, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "459, Kroger, DECATUR, GA",
            disabled: false,
          },
          {
            name: "459, Kroger, RENTON, WA",
            disabled: false,
          },
          {
            name: "459, Kroger, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "459, Walmart, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "4590, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "4590, Walmart, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "4591, Walgreens, HALLANDALE BEACH, FL",
            disabled: false,
          },
          {
            name: "4591, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "4592, Albertsons, IPSWICH, MA",
            disabled: false,
          },
          {
            name: "4592, Rite Aid, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "4592, Walgreens, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "4593, CVS, SANDERSVILLE, GA",
            disabled: false,
          },
          {
            name: "4593, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "4593, Walmart, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "4594, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "4594, Walmart, CHERRYVILLE, NC",
            disabled: false,
          },
          {
            name: "4595, Albertsons, HYANNIS, MA",
            disabled: false,
          },
          {
            name: "4595, CVS, LITHONIA, GA",
            disabled: false,
          },
          {
            name: "4595, Walgreens, SALEM, MA",
            disabled: false,
          },
          {
            name: "4595, Walmart, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "4596, Albertsons, HARWICH PORT, MA",
            disabled: false,
          },
          {
            name: "4596, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "4597, Walmart, NORTH TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "4599, CVS, LEANDER, TX",
            disabled: false,
          },
          {
            name: "4599, Rite Aid, HASLETT, MI",
            disabled: false,
          },
          {
            name: "4599, Walmart, TIMNATH, CO",
            disabled: false,
          },
          {
            name: "46, ADUSA, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "46, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "46, BJ's, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "46, Kroger, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "46, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "46, Meijer, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "46, Walmart, BOLIVAR, MO",
            disabled: false,
          },
          {
            name: "460, ADUSA, ACTON, MA",
            disabled: false,
          },
          {
            name: "460, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "460, CVS, YEADON, PA",
            disabled: false,
          },
          {
            name: "460, Costco, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "460, Kroger, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "460, Kroger, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "460, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "4600, CVS, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "4600, Rite Aid, EATON RAPIDS, MI",
            disabled: false,
          },
          {
            name: "4600, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4600, Walmart, GRETNA, NE",
            disabled: false,
          },
          {
            name: "4601, ADUSA, WADSWORTH, OH",
            disabled: false,
          },
          {
            name: "4601, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "4601, Rite Aid, STRATFORD, NJ",
            disabled: false,
          },
          {
            name: "4601, Walmart, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "4602, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "4603, CVS, FITZGERALD, GA",
            disabled: false,
          },
          {
            name: "4603, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4603, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4604, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4605, CVS, ORRVILLE, OH",
            disabled: false,
          },
          {
            name: "4605, Rite Aid, WARREN, OH",
            disabled: false,
          },
          {
            name: "4605, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4605, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "4606, CVS, WARREN, OH",
            disabled: false,
          },
          {
            name: "4606, Walgreens, WACO, TX",
            disabled: false,
          },
          {
            name: "4606, Walmart, OSCEOLA, IA",
            disabled: false,
          },
          {
            name: "4607, CVS, MAYFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4607, Walgreens, BEVERLY HILLS, TX",
            disabled: false,
          },
          {
            name: "4607, Walmart, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "4608, CVS, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4609, Walmart, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "461, ADUSA, CONOVER, NC",
            disabled: false,
          },
          {
            name: "461, ADUSA, SOUTH DENNIS, MA",
            disabled: false,
          },
          {
            name: "461, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "461, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "461, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "461, Kroger, SACHSE, TX",
            disabled: false,
          },
          {
            name: "461, Kroger, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "461, Kroger, WASHINGTON, MI",
            disabled: false,
          },
          {
            name: "461, Walmart, EAGLE PASS, TX",
            disabled: false,
          },
          {
            name: "4610, CVS, ROTTERDAM, NY",
            disabled: false,
          },
          {
            name: "4610, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "4611, CVS, BALDWIN, NY",
            disabled: false,
          },
          {
            name: "4611, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "4611, Walgreens, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "4611, Walmart, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "4612, CVS, NICEVILLE, FL",
            disabled: false,
          },
          {
            name: "4612, Walmart, HAMBURG, PA",
            disabled: false,
          },
          {
            name: "4613, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4614, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4614, Walgreens, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "4615, Walgreens, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "4615, Walmart, GLENPOOL, OK",
            disabled: false,
          },
          {
            name: "4616, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "4616, Rite Aid, TITUSVILLE, PA",
            disabled: false,
          },
          {
            name: "4616, Walgreens, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "4616, Walmart, CLEVELAND, GA",
            disabled: false,
          },
          {
            name: "4617, Walgreens, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "4617, Walmart, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "4618, CVS, LILBURN, GA",
            disabled: false,
          },
          {
            name: "4618, Walgreens, LOXAHATCHEE, FL",
            disabled: false,
          },
          {
            name: "4618, Walmart, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "4619, Walgreens, SEBASTIAN, FL",
            disabled: false,
          },
          {
            name: "4619, Walmart, TUPELO, MS",
            disabled: false,
          },
          {
            name: "462, ADUSA, PLAINVILLE, MA",
            disabled: false,
          },
          {
            name: "462, Albertsons, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "462, CVS, STRATFORD, NJ",
            disabled: false,
          },
          {
            name: "462, Costco, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "462, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "462, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "462, Kroger, OAKLAND, TN",
            disabled: false,
          },
          {
            name: "462, Kroger, SCAPPOOSE, OR",
            disabled: false,
          },
          {
            name: "462, Kroger, White Hall, IL",
            disabled: false,
          },
          {
            name: "462, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "462, Walmart, ALVIN, TX",
            disabled: false,
          },
          {
            name: "4620, CVS, DENVER, NC",
            disabled: false,
          },
          {
            name: "4620, Rite Aid, WOLCOTT, CT",
            disabled: false,
          },
          {
            name: "4620, Walgreens, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "4621, CVS, GALLOWAY, OH",
            disabled: false,
          },
          {
            name: "4622, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "4623, Walmart, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "4625, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "4625, Walgreens, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "4625, Walmart, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "4626, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "4626, Walmart, JUNCTION CITY, KS",
            disabled: false,
          },
          {
            name: "4627, CVS, KEYSTONE HEIGHTS, FL",
            disabled: false,
          },
          {
            name: "4627, Walgreens, RENTON, WA",
            disabled: false,
          },
          {
            name: "4627, Walmart, DENTON, TX",
            disabled: false,
          },
          {
            name: "4628, CVS, CAYCE, SC",
            disabled: false,
          },
          {
            name: "4628, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4629, CVS, HAWTHORNE, FL",
            disabled: false,
          },
          {
            name: "463, CVS, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "463, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "463, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "463, Kroger, ARLINGTON, TN",
            disabled: false,
          },
          {
            name: "463, Kroger, Lewisville, TX",
            disabled: false,
          },
          {
            name: "463, Kroger, TROY, MI",
            disabled: false,
          },
          {
            name: "463, Kroger, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "463, Walmart, BEEVILLE, TX",
            disabled: false,
          },
          {
            name: "4631, Walgreens, WAYNE, MI",
            disabled: false,
          },
          {
            name: "4631, Walmart, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "4632, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "4632, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4633, CVS, GREENFIELD, IN",
            disabled: false,
          },
          {
            name: "4634, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "4634, Walgreens, COLLEYVILLE, TX",
            disabled: false,
          },
          {
            name: "4635, CVS, CARMEL, IN",
            disabled: false,
          },
          {
            name: "4635, Walgreens, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "4635, Walmart, CLINTON, TN",
            disabled: false,
          },
          {
            name: "4636, Walgreens, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "4636, Walmart, APPOMATTOX, VA",
            disabled: false,
          },
          {
            name: "4637, CVS, PRINCETON, KY",
            disabled: false,
          },
          {
            name: "4637, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "4638, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4638, Walmart, RUCKERSVILLE, VA",
            disabled: false,
          },
          {
            name: "4639, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "4639, Walgreens, KETTERING, OH",
            disabled: false,
          },
          {
            name: "4639, Walmart, ELIZABETH, CO",
            disabled: false,
          },
          {
            name: "464, ADUSA, CHATHAM, VA",
            disabled: false,
          },
          {
            name: "464, Albertsons, REDMOND, WA",
            disabled: false,
          },
          {
            name: "464, Costco, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "464, HEB, LULING, TX",
            disabled: false,
          },
          {
            name: "464, Kroger, FLORENCE, OR",
            disabled: false,
          },
          {
            name: "464, Kroger, MABLETON, GA",
            disabled: false,
          },
          {
            name: "464, Kroger, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "464, Kroger, TROY, MI",
            disabled: false,
          },
          {
            name: "464, Walmart, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "4641, Walmart, HUNTLEY, IL",
            disabled: false,
          },
          {
            name: "4642, Walgreens, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "4643, Walmart, BADEN, PA",
            disabled: false,
          },
          {
            name: "4644, CVS, CRESSKILL, NJ",
            disabled: false,
          },
          {
            name: "4644, Walgreens, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "4644, Walmart, MOON TOWNSHIP, PA",
            disabled: false,
          },
          {
            name: "4645, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4645, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "4646, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4647, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4648, Walgreens, TAVARES, FL",
            disabled: false,
          },
          {
            name: "4648, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4649, CVS, FISHERS, IN",
            disabled: false,
          },
          {
            name: "4649, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "465, ADUSA, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "465, CVS, MEDFORD, NJ",
            disabled: false,
          },
          {
            name: "465, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "465, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "465, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "465, Kroger, BLYTHEVILLE, AR",
            disabled: false,
          },
          {
            name: "465, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "465, Kroger, IMLAY CITY, MI",
            disabled: false,
          },
          {
            name: "465, Walmart, FLORESVILLE, TX",
            disabled: false,
          },
          {
            name: "4650, CVS, FREDERICK, MD",
            disabled: false,
          },
          {
            name: "4650, Walgreens, RUIDOSO, NM",
            disabled: false,
          },
          {
            name: "4651, Albertsons, FALMOUTH, ME",
            disabled: false,
          },
          {
            name: "4651, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "4652, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "4653, Walmart, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "4654, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "4654, Walmart, MARION, AR",
            disabled: false,
          },
          {
            name: "4655, CVS, GRAHAM, NC",
            disabled: false,
          },
          {
            name: "4655, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "4657, CVS, DARLINGTON, SC",
            disabled: false,
          },
          {
            name: "4657, Walgreens, PONTE VEDRA, FL",
            disabled: false,
          },
          {
            name: "4657, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4658, CVS, NEW HOPE, MN",
            disabled: false,
          },
          {
            name: "4659, CVS, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "4659, Walgreens, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "4659, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "466, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "466, Costco, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "466, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "466, Kroger, Florence, KY",
            disabled: false,
          },
          {
            name: "466, Kroger, VICKSBURG, MS",
            disabled: false,
          },
          {
            name: "466, Walmart, BOLIVAR, TN",
            disabled: false,
          },
          {
            name: "4660, Walgreens, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "4660, Walmart, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "4661, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4661, Walgreens, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4662, CVS, HATBORO, PA",
            disabled: false,
          },
          {
            name: "4662, Walgreens, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4663, Walgreens, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "4664, Walgreens, WESTCHESTER, IL",
            disabled: false,
          },
          {
            name: "4664, Walmart, CONWAY, SC",
            disabled: false,
          },
          {
            name: "4665, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4665, Walgreens, OLATHE, KS",
            disabled: false,
          },
          {
            name: "4667, CVS, PELHAM, AL",
            disabled: false,
          },
          {
            name: "4667, Walgreens, FEDERAL HEIGHTS, CO",
            disabled: false,
          },
          {
            name: "4667, Walmart, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "4668, CVS, POWDER SPRINGS, GA",
            disabled: false,
          },
          {
            name: "4668, Walgreens, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "4669, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "4669, Walmart, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "467, Albertsons, DOUGLAS, WY",
            disabled: false,
          },
          {
            name: "467, CVS, CALERA, AL",
            disabled: false,
          },
          {
            name: "467, HEB, MEXIA, TX",
            disabled: false,
          },
          {
            name: "467, Kroger, Fort Worth, TX",
            disabled: false,
          },
          {
            name: "467, Kroger, LOS ALAMOS, NM",
            disabled: false,
          },
          {
            name: "467, Kroger, Sandy Springs, GA",
            disabled: false,
          },
          {
            name: "467, Rite Aid, WEST READING, PA",
            disabled: false,
          },
          {
            name: "467, Walmart, DENTON, TX",
            disabled: false,
          },
          {
            name: "4671, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4671, Walgreens, UNIVERSITY CITY, MO",
            disabled: false,
          },
          {
            name: "4672, CVS, AMERICUS, GA",
            disabled: false,
          },
          {
            name: "4672, Rite Aid, ANGOLA, NY",
            disabled: false,
          },
          {
            name: "4672, Walgreens, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "4672, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4673, Walgreens, WARR ACRES, OK",
            disabled: false,
          },
          {
            name: "4673, Walmart, AUBURN, AL",
            disabled: false,
          },
          {
            name: "4674, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4674, Walgreens, VERNON HILLS, IL",
            disabled: false,
          },
          {
            name: "4674, Walmart, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "4675, CVS, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "4676, Rite Aid, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "4676, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "4677, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4677, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "4677, Walmart, MUSKEGO, WI",
            disabled: false,
          },
          {
            name: "4678, CVS, TIFTON, GA",
            disabled: false,
          },
          {
            name: "4678, Walmart, HURRICANE, UT",
            disabled: false,
          },
          {
            name: "4679, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "4679, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "4679, Walmart, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "468, ADUSA, HOPE MILLS, NC",
            disabled: false,
          },
          {
            name: "468, Costco, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "468, Kroger, AMELIA, OH",
            disabled: false,
          },
          {
            name: "468, Kroger, JACKSON, TN",
            disabled: false,
          },
          {
            name: "468, ShopRite, SOMERVILLE, NJ",
            disabled: false,
          },
          {
            name: "468, Walmart, TEXARKANA, AR",
            disabled: false,
          },
          {
            name: "4681, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "4681, Walgreens, EUREKA, CA",
            disabled: false,
          },
          {
            name: "4681, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "4682, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "4682, Rite Aid, MUNHALL, PA",
            disabled: false,
          },
          {
            name: "4682, Walmart, GORDONSVILLE, VA",
            disabled: false,
          },
          {
            name: "4683, Rite Aid, LORAIN, OH",
            disabled: false,
          },
          {
            name: "4683, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "4684, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "4684, Rite Aid, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "4684, Walgreens, GARFIELD HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4685, CVS, BERNARDSVILLE, NJ",
            disabled: false,
          },
          {
            name: "4685, Walgreens, SOUTH EUCLID, OH",
            disabled: false,
          },
          {
            name: "4686, CVS, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "4686, Rite Aid, PIKESVILLE, MD",
            disabled: false,
          },
          {
            name: "4686, Walmart, BENTONVILLE, AR",
            disabled: false,
          },
          {
            name: "4687, Walgreens, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "4687, Walmart, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "4688, Walgreens, WHITESTONE, NY",
            disabled: false,
          },
          {
            name: "4689, Walgreens, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "4689, Walmart, CEDAR HILLS, UT",
            disabled: false,
          },
          {
            name: "469, ADUSA, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "469, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "469, Albertsons, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "469, CVS, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "469, Costco, LA MESA, CA",
            disabled: false,
          },
          {
            name: "469, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "469, Kroger, WEST MEMPHIS, AR",
            disabled: false,
          },
          {
            name: "469, Walmart, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "4690, Walgreens, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "4690, Walmart, ST PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "4691, CVS, SPARKS, NV",
            disabled: false,
          },
          {
            name: "4691, Walgreens, MADISON HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4691, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4692, CVS, TUCKER, GA",
            disabled: false,
          },
          {
            name: "4692, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "4692, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4692, Walmart, EAST RIDGE, TN",
            disabled: false,
          },
          {
            name: "4693, CVS, SENECA, SC",
            disabled: false,
          },
          {
            name: "4693, Walgreens, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "4694, Albertsons, PETERBOROUGH, NH",
            disabled: false,
          },
          {
            name: "4694, CVS, CONYERS, GA",
            disabled: false,
          },
          {
            name: "4694, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4695, CVS, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "4695, Rite Aid, HARRISON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "4695, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "4695, Walmart, GODFREY, IL",
            disabled: false,
          },
          {
            name: "4696, CVS, ROGERS, MN",
            disabled: false,
          },
          {
            name: "4696, Rite Aid, ORTONVILLE, MI",
            disabled: false,
          },
          {
            name: "4696, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "4696, Walmart, HEBER CITY, UT",
            disabled: false,
          },
          {
            name: "4697, Rite Aid, PONTIAC, MI",
            disabled: false,
          },
          {
            name: "4697, Walgreens, FRIDLEY, MN",
            disabled: false,
          },
          {
            name: "4697, Walmart, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "4698, CVS, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "4699, Walgreens, DELAND, FL",
            disabled: false,
          },
          {
            name: "4699, Walmart, STREATOR, IL",
            disabled: false,
          },
          {
            name: "47, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "47, BJ's, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "47, CVS, D'IBERVILLE, MS",
            disabled: false,
          },
          {
            name: "47, Costco, FREMONT, CA",
            disabled: false,
          },
          {
            name: "47, Kroger, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "47, Kroger, SANDY, UT",
            disabled: false,
          },
          {
            name: "47, Kroger, Topeka, KS",
            disabled: false,
          },
          {
            name: "47, Kroger, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "47, Meijer, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "47, Walmart, SALLISAW, OK",
            disabled: false,
          },
          {
            name: "470, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "470, ADUSA, SANDWICH, MA",
            disabled: false,
          },
          {
            name: "470, Costco, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "470, Walmart, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "4700, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "4700, Walmart, PLEASANT GROVE, UT",
            disabled: false,
          },
          {
            name: "4701, Walgreens, ELLISVILLE, MO",
            disabled: false,
          },
          {
            name: "4702, Walgreens, HIGH RIDGE, MO",
            disabled: false,
          },
          {
            name: "4703, Rite Aid, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "4703, Walgreens, LAWTON, OK",
            disabled: false,
          },
          {
            name: "4704, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4705, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4706, Albertsons, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "4706, Rite Aid, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "4706, Walgreens, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "4706, Walmart, MAGNA, UT",
            disabled: false,
          },
          {
            name: "4707, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "4708, Rite Aid, WAVERLY, OH",
            disabled: false,
          },
          {
            name: "4708, Walgreens, HAINES CITY, FL",
            disabled: false,
          },
          {
            name: "4709, CVS, FAIRBURN, GA",
            disabled: false,
          },
          {
            name: "4709, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "471, ADUSA, ANDOVER, MA",
            disabled: false,
          },
          {
            name: "471, Albertsons, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "471, CVS, DORCHESTER, MA",
            disabled: false,
          },
          {
            name: "471, Costco, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "471, Kroger, COLLEGE PARK, GA",
            disabled: false,
          },
          {
            name: "471, Kroger, RAWLINS, WY",
            disabled: false,
          },
          {
            name: "471, Kroger, TUPELO, MS",
            disabled: false,
          },
          {
            name: "471, Walmart, LANCASTER, TX",
            disabled: false,
          },
          {
            name: "4710, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "4713, Albertsons, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "4714, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "4715, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "4715, CVS, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "4717, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4718, CVS, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "4719, CVS, WATKINSVILLE, GA",
            disabled: false,
          },
          {
            name: "4719, Walgreens, THE COLONY, TX",
            disabled: false,
          },
          {
            name: "472, ADUSA, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "472, ADUSA, LURAY, VA",
            disabled: false,
          },
          {
            name: "472, Costco, SALINAS, CA",
            disabled: false,
          },
          {
            name: "472, Kroger, Fond du Lac, WI",
            disabled: false,
          },
          {
            name: "472, Kroger, MADISON, MS",
            disabled: false,
          },
          {
            name: "472, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "4720, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4720, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4721, CVS, OAKWOOD, GA",
            disabled: false,
          },
          {
            name: "4721, Walgreens, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "4722, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4723, Albertsons, FLOURTOWN, PA",
            disabled: false,
          },
          {
            name: "4723, Walgreens, SAPULPA, OK",
            disabled: false,
          },
          {
            name: "4724, Walgreens, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "4725, Walgreens, CHAMPLIN, MN",
            disabled: false,
          },
          {
            name: "4726, CVS, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "4726, Rite Aid, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "4726, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "4727, Albertsons, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "4727, CVS, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "4727, Walgreens, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "4728, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4729, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4729, Walgreens, NORWOOD, MA",
            disabled: false,
          },
          {
            name: "473, ADUSA, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "473, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "473, Costco, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "473, HEB, PASADENA, TX",
            disabled: false,
          },
          {
            name: "473, Kroger, CUMMING, GA",
            disabled: false,
          },
          {
            name: "473, Kroger, FORT MOHAVE, AZ",
            disabled: false,
          },
          {
            name: "473, Kroger, OXFORD, MS",
            disabled: false,
          },
          {
            name: "473, ShopRite, WATCHUNG, NJ",
            disabled: false,
          },
          {
            name: "473, Walmart, GIDDINGS, TX",
            disabled: false,
          },
          {
            name: "4730, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "4730, Walgreens, EVERETT, WA",
            disabled: false,
          },
          {
            name: "4731, Walgreens, MADEIRA, OH",
            disabled: false,
          },
          {
            name: "4732, Walgreens, PEKIN, IL",
            disabled: false,
          },
          {
            name: "4733, Walgreens, JACKSONVILLE BEACH, FL",
            disabled: false,
          },
          {
            name: "4734, Walgreens, PALATKA, FL",
            disabled: false,
          },
          {
            name: "4734, Walmart, ARVADA, CO",
            disabled: false,
          },
          {
            name: "4735, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4736, Rite Aid, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "4736, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "4737, CVS, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "4738, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4738, Rite Aid, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "4739, Rite Aid, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "474, ADUSA, EAST WAREHAM, MA",
            disabled: false,
          },
          {
            name: "474, ADUSA, LAWRENCEVILLE, VA",
            disabled: false,
          },
          {
            name: "474, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "474, Costco, GOLETA, CA",
            disabled: false,
          },
          {
            name: "474, HEB, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "474, Kroger, CAVE CREEK, AZ",
            disabled: false,
          },
          {
            name: "474, Kroger, CLINTON, MS",
            disabled: false,
          },
          {
            name: "4740, CVS, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "4740, Rite Aid, PORTLAND, MI",
            disabled: false,
          },
          {
            name: "4741, Rite Aid, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "4742, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "4742, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "4743, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "4743, Walgreens, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "4744, Walgreens, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "4745, CVS, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "4745, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4746, Rite Aid, SOMERVILLE, NJ",
            disabled: false,
          },
          {
            name: "4746, Walgreens, IRVING, TX",
            disabled: false,
          },
          {
            name: "4747, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "4747, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "4747, Walmart, NORTHGLENN, CO",
            disabled: false,
          },
          {
            name: "4748, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4748, Walgreens, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "4749, Walgreens, LINCOLN PARK, MI",
            disabled: false,
          },
          {
            name: "475, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "475, ADUSA, HARWICH, MA",
            disabled: false,
          },
          {
            name: "475, Albertsons, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "475, Costco, SOUTH SAN FRANC, CA",
            disabled: false,
          },
          {
            name: "475, HEB, ELGIN, TX",
            disabled: false,
          },
          {
            name: "475, Kroger, DECATUR, GA",
            disabled: false,
          },
          {
            name: "475, Kroger, Hernando, MS",
            disabled: false,
          },
          {
            name: "475, Kroger, INDEPENDENCE, KY",
            disabled: false,
          },
          {
            name: "475, Kroger, Rockwall, TX",
            disabled: false,
          },
          {
            name: "475, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "475, Walmart, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "4750, Walgreens, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "4752, CVS, WESTWEGO, LA",
            disabled: false,
          },
          {
            name: "4752, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4753, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "4754, Walgreens, LA VISTA, NE",
            disabled: false,
          },
          {
            name: "4755, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4756, Walgreens, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "4756, Walmart, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "4757, Walgreens, BERMUDA DUNES, CA",
            disabled: false,
          },
          {
            name: "4757, Walmart, LACEY, WA",
            disabled: false,
          },
          {
            name: "4759, Walmart, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "476, Costco, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "476, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "476, Kroger, DULUTH, GA",
            disabled: false,
          },
          {
            name: "476, Walmart, GATESVILLE, TX",
            disabled: false,
          },
          {
            name: "4760, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "4761, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "4761, Rite Aid, FLINT, MI",
            disabled: false,
          },
          {
            name: "4761, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4762, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4762, Walmart, DIAMOND BAR, CA",
            disabled: false,
          },
          {
            name: "4764, Rite Aid, BROADVIEW HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "4764, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "4765, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "4765, Rite Aid, PERRY, MI",
            disabled: false,
          },
          {
            name: "4765, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "4766, Rite Aid, LORAIN, OH",
            disabled: false,
          },
          {
            name: "4766, Walgreens, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "4767, Rite Aid, BELLEFONTAINE, OH",
            disabled: false,
          },
          {
            name: "4768, Rite Aid, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "477, ADUSA, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "477, Albertsons, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "477, CVS, MOUNT EPHRAIM, NJ",
            disabled: false,
          },
          {
            name: "477, HEB, BUDA, TX",
            disabled: false,
          },
          {
            name: "477, Kroger, FORT MITCHELL, KY",
            disabled: false,
          },
          {
            name: "477, Kroger, LOGAN, UT",
            disabled: false,
          },
          {
            name: "477, Kroger, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "477, Walmart, SODDY DAISY, TN",
            disabled: false,
          },
          {
            name: "4770, Rite Aid, LANSING, MI",
            disabled: false,
          },
          {
            name: "4770, Walgreens, COOPER CITY, FL",
            disabled: false,
          },
          {
            name: "4771, CVS, OAK RIDGE, NJ",
            disabled: false,
          },
          {
            name: "4772, CVS, SPRING CITY, PA",
            disabled: false,
          },
          {
            name: "4772, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "4773, CVS, GILBERTSVILLE, PA",
            disabled: false,
          },
          {
            name: "4773, Walgreens, OAKLAND PARK, FL",
            disabled: false,
          },
          {
            name: "4774, Walgreens, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "4775, Walgreens, TWINSBURG, OH",
            disabled: false,
          },
          {
            name: "4776, Walgreens, BARBERTON, OH",
            disabled: false,
          },
          {
            name: "4777, CVS, GARLAND, TX",
            disabled: false,
          },
          {
            name: "4777, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "4778, CVS, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "4778, Rite Aid, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "4778, Walgreens, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "4779, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "4779, Walgreens, MONTGOMERY, IL",
            disabled: false,
          },
          {
            name: "478, ADUSA, BRAINTREE, MA",
            disabled: false,
          },
          {
            name: "478, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "478, Costco, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "478, Kroger, HERNANDO, MS",
            disabled: false,
          },
          {
            name: "478, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "478, Kroger, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "478, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "478, Walmart, PEARSALL, TX",
            disabled: false,
          },
          {
            name: "4780, Walgreens, LOMBARD, IL",
            disabled: false,
          },
          {
            name: "4782, CVS, GRAND BAY, AL",
            disabled: false,
          },
          {
            name: "4782, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "4783, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "4783, Rite Aid, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "4784, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4784, Rite Aid, WILLOWICK, OH",
            disabled: false,
          },
          {
            name: "4785, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "4786, Albertsons, FALLBROOK, CA",
            disabled: false,
          },
          {
            name: "4786, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4786, Walgreens, FRISCO, TX",
            disabled: false,
          },
          {
            name: "4787, CVS, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "4787, Walgreens, ALLEN, TX",
            disabled: false,
          },
          {
            name: "4788, Walgreens, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "4789, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4789, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "479, ADUSA, SCOTLAND NECK, NC",
            disabled: false,
          },
          {
            name: "479, CVS, HILLSIDE, NJ",
            disabled: false,
          },
          {
            name: "479, Costco, MARINA DEL REY, CA",
            disabled: false,
          },
          {
            name: "479, HEB, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "479, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "479, Kroger, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "479, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "479, Walmart, ALTUS, OK",
            disabled: false,
          },
          {
            name: "4790, CVS, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "4790, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4791, Rite Aid, WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "4791, Walgreens, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "4793, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4793, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "4794, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "4794, Rite Aid, PITTSFIELD, NH",
            disabled: false,
          },
          {
            name: "4794, Walgreens, CONWAY, AR",
            disabled: false,
          },
          {
            name: "4795, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "4795, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4795, Walgreens, EASTPOINTE, MI",
            disabled: false,
          },
          {
            name: "4796, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "4797, CVS, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "4797, Walgreens, DETROIT, MI",
            disabled: false,
          },
          {
            name: "4798, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "4799, CVS, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "4799, Walgreens, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "48, Albertsons, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "48, Costco, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "48, HEB, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "48, Kroger, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "48, Kroger, Hutchinson, KS",
            disabled: false,
          },
          {
            name: "48, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "48, Kroger, PRICE, UT",
            disabled: false,
          },
          {
            name: "48, Meijer, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "48, Target, ARVADA, CO",
            disabled: false,
          },
          {
            name: "48, Walmart, MONETT, MO",
            disabled: false,
          },
          {
            name: "480, ADUSA, CHELMSFORD, MA",
            disabled: false,
          },
          {
            name: "480, Costco, SUPERIOR, CO",
            disabled: false,
          },
          {
            name: "480, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "480, Kroger, GRAYSON, GA",
            disabled: false,
          },
          {
            name: "480, Walmart, PITTSFIELD, IL",
            disabled: false,
          },
          {
            name: "4800, CVS, AKRON, OH",
            disabled: false,
          },
          {
            name: "4800, Rite Aid, WINCHESTER, NH",
            disabled: false,
          },
          {
            name: "4800, Walgreens, LARGO, FL",
            disabled: false,
          },
          {
            name: "4801, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "4802, CVS, HARTVILLE, OH",
            disabled: false,
          },
          {
            name: "4803, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "4803, Walgreens, COOPER CITY, FL",
            disabled: false,
          },
          {
            name: "4804, CVS, CHAGRIN FALLS, OH",
            disabled: false,
          },
          {
            name: "4804, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "4805, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "4806, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "4806, Rite Aid, BURTON, MI",
            disabled: false,
          },
          {
            name: "4807, CVS, STREETSBORO, OH",
            disabled: false,
          },
          {
            name: "4808, CVS, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "4808, Walgreens, CUTLER BAY, FL",
            disabled: false,
          },
          {
            name: "4809, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "481, ADUSA, STURBRIDGE, MA",
            disabled: false,
          },
          {
            name: "481, Costco, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "481, Kroger, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "481, Kroger, Plano, TX",
            disabled: false,
          },
          {
            name: "481, Kroger, West Bloomfield Town, MI",
            disabled: false,
          },
          {
            name: "481, Kroger, West Bloomfield, MI",
            disabled: false,
          },
          {
            name: "481, Walmart, MATTOON, IL",
            disabled: false,
          },
          {
            name: "4810, CVS, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "4810, Rite Aid, CHESTER, MD",
            disabled: false,
          },
          {
            name: "4810, Walgreens, OAKLAND PARK, FL",
            disabled: false,
          },
          {
            name: "4811, Rite Aid, WADSWORTH, OH",
            disabled: false,
          },
          {
            name: "4811, Walgreens, DADE CITY, FL",
            disabled: false,
          },
          {
            name: "4812, Walgreens, PALMETTO, FL",
            disabled: false,
          },
          {
            name: "4813, CVS, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "4814, CVS, PELHAM, AL",
            disabled: false,
          },
          {
            name: "4814, Rite Aid, ORRVILLE, OH",
            disabled: false,
          },
          {
            name: "4815, CVS, ATHENS, AL",
            disabled: false,
          },
          {
            name: "4815, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "4816, CVS, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "4816, Walgreens, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "4817, Albertsons, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "4817, CVS, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "4818, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4818, Rite Aid, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "4818, Walgreens, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "4819, CVS, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "4819, Rite Aid, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "4819, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "482, ADUSA, AMHERST, VA",
            disabled: false,
          },
          {
            name: "482, ADUSA, COHASSET, MA",
            disabled: false,
          },
          {
            name: "482, CVS, SCARSDALE, NY",
            disabled: false,
          },
          {
            name: "482, Costco, RICHMOND, CA",
            disabled: false,
          },
          {
            name: "482, Kroger, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "482, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "482, Kroger, TUCKER, GA",
            disabled: false,
          },
          {
            name: "482, Walmart, WEST COLUMBIA, TX",
            disabled: false,
          },
          {
            name: "4820, CVS, DUMAS, TX",
            disabled: false,
          },
          {
            name: "4820, Rite Aid, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "4820, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "4821, CVS, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "4821, Rite Aid, EDISON, NJ",
            disabled: false,
          },
          {
            name: "4821, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "4822, CVS, HALEYVILLE, AL",
            disabled: false,
          },
          {
            name: "4822, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "4823, CVS, RAINBOW CITY, AL",
            disabled: false,
          },
          {
            name: "4823, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "4825, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4825, Rite Aid, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4826, CVS, OZARK, AL",
            disabled: false,
          },
          {
            name: "4826, Walgreens, SCHILLER PARK, IL",
            disabled: false,
          },
          {
            name: "4826, Walmart, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "4827, CVS, SAN JUAN, TX",
            disabled: false,
          },
          {
            name: "4827, Walgreens, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "4828, Walgreens, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "4829, CVS, HOMEWOOD, AL",
            disabled: false,
          },
          {
            name: "4829, Walgreens, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "483, CVS, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "483, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "483, Kroger, Arlington, TN",
            disabled: false,
          },
          {
            name: "483, Kroger, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "483, Walmart, PRATTVILLE, AL",
            disabled: false,
          },
          {
            name: "4830, CVS, BESSEMER, AL",
            disabled: false,
          },
          {
            name: "4830, Walgreens, MONONA, WI",
            disabled: false,
          },
          {
            name: "4832, Albertsons, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "4832, CVS, MIDFIELD, AL",
            disabled: false,
          },
          {
            name: "4832, Rite Aid, CAMBRIDGE, OH",
            disabled: false,
          },
          {
            name: "4832, Walgreens, FAIRVIEW HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "4833, CVS, GARDENDALE, AL",
            disabled: false,
          },
          {
            name: "4833, Rite Aid, NEW BALTIMORE, MI",
            disabled: false,
          },
          {
            name: "4834, CVS, JASPER, AL",
            disabled: false,
          },
          {
            name: "4835, CVS, NORTHPORT, AL",
            disabled: false,
          },
          {
            name: "4835, Walgreens, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "4836, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "4837, Walgreens, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "4838, CVS, PRATTVILLE, AL",
            disabled: false,
          },
          {
            name: "4838, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4839, CVS, PELL CITY, AL",
            disabled: false,
          },
          {
            name: "4839, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "484, ADUSA, LOUISA, VA",
            disabled: false,
          },
          {
            name: "484, Albertsons, LONDONDERRY, NH",
            disabled: false,
          },
          {
            name: "484, CVS, MOLINE, IL",
            disabled: false,
          },
          {
            name: "484, Costco, OREM, UT",
            disabled: false,
          },
          {
            name: "484, Kroger, SAVANNAH, TN",
            disabled: false,
          },
          {
            name: "484, Kroger, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "484, Walmart, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "4840, Rite Aid, HAZLETON, PA",
            disabled: false,
          },
          {
            name: "4840, Walgreens, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "4841, CVS, MARMORA, NJ",
            disabled: false,
          },
          {
            name: "4841, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "4842, CVS, TALLADEGA, AL",
            disabled: false,
          },
          {
            name: "4842, Walgreens, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "4843, CVS, WARRIOR, AL",
            disabled: false,
          },
          {
            name: "4843, Walgreens, BELMONT, NC",
            disabled: false,
          },
          {
            name: "4844, CVS, DECATUR, AL",
            disabled: false,
          },
          {
            name: "4845, CVS, GADSDEN, AL",
            disabled: false,
          },
          {
            name: "4845, Walgreens, FREEPORT, NY",
            disabled: false,
          },
          {
            name: "4846, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "4846, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4847, CVS, EVERGREEN, AL",
            disabled: false,
          },
          {
            name: "4848, Walgreens, FORT WALTON BEACH, FL",
            disabled: false,
          },
          {
            name: "4848, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "4849, CVS, GADSDEN, AL",
            disabled: false,
          },
          {
            name: "4849, Walmart, MOUNTAIN IRON, MN",
            disabled: false,
          },
          {
            name: "485, ADUSA, WYTHEVILLE, VA",
            disabled: false,
          },
          {
            name: "485, Albertsons, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "485, CVS, HURST, TX",
            disabled: false,
          },
          {
            name: "485, Costco, WAIPAHU, HI",
            disabled: false,
          },
          {
            name: "485, HEB, WESLACO, TX",
            disabled: false,
          },
          {
            name: "485, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "485, Kroger, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "485, Kroger, Fairbanks, AK",
            disabled: false,
          },
          {
            name: "485, Walmart, DONALDSONVILLE, LA",
            disabled: false,
          },
          {
            name: "4850, CVS, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "4852, Walgreens, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "4853, CVS, SELMA, AL",
            disabled: false,
          },
          {
            name: "4854, CVS, ONEONTA, AL",
            disabled: false,
          },
          {
            name: "4854, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4855, CVS, VESTAVIA HILLS, AL",
            disabled: false,
          },
          {
            name: "4855, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4856, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4856, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "4857, CVS, DECATUR, IL",
            disabled: false,
          },
          {
            name: "4857, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4858, CVS, TROY, AL",
            disabled: false,
          },
          {
            name: "4858, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "4859, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "486, ADUSA, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "486, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "486, Albertsons, UNIVERSITY PLACE, WA",
            disabled: false,
          },
          {
            name: "486, Costco, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "486, Kroger, CUMMING, GA",
            disabled: false,
          },
          {
            name: "486, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "486, Kroger, WARREN, MI",
            disabled: false,
          },
          {
            name: "486, Kroger, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "486, Walmart, BONNER SPRINGS, KS",
            disabled: false,
          },
          {
            name: "4860, CVS, UNION SPRINGS, AL",
            disabled: false,
          },
          {
            name: "4860, Walgreens, ALLEN, TX",
            disabled: false,
          },
          {
            name: "4861, CVS, CHILDERSBURG, AL",
            disabled: false,
          },
          {
            name: "4861, Rite Aid, GREAT NECK, NY",
            disabled: false,
          },
          {
            name: "4863, CVS, CENTRE, AL",
            disabled: false,
          },
          {
            name: "4864, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4865, CVS, WETUMPKA, AL",
            disabled: false,
          },
          {
            name: "4865, Walgreens, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "4865, Walmart, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "4866, CVS, COLUMBIANA, AL",
            disabled: false,
          },
          {
            name: "4866, Walgreens, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "4867, CVS, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "4867, Walgreens, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "4868, CVS, JACKSON, AL",
            disabled: false,
          },
          {
            name: "4868, Rite Aid, FLUSHING, NY",
            disabled: false,
          },
          {
            name: "4869, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4869, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "487, ADUSA, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "487, Costco, SANDY, UT",
            disabled: false,
          },
          {
            name: "487, HEB, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "487, Kroger, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "487, Kroger, TROY, MI",
            disabled: false,
          },
          {
            name: "487, ShopRite, WHARTON, NJ",
            disabled: false,
          },
          {
            name: "4870, CVS, ANNISTON, AL",
            disabled: false,
          },
          {
            name: "4870, Walgreens, CONCORD, NC",
            disabled: false,
          },
          {
            name: "4871, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4871, Rite Aid, WOODSVILLE, NH",
            disabled: false,
          },
          {
            name: "4871, Walgreens, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "4872, Albertsons, OXON HILL, MD",
            disabled: false,
          },
          {
            name: "4872, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4873, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4875, Walgreens, ABILENE, TX",
            disabled: false,
          },
          {
            name: "4876, Walgreens, EDISON, NJ",
            disabled: false,
          },
          {
            name: "4878, CVS, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "4879, CVS, MEXIA, TX",
            disabled: false,
          },
          {
            name: "4879, Walgreens, SAVAGE, MN",
            disabled: false,
          },
          {
            name: "488, ADUSA, READING, MA",
            disabled: false,
          },
          {
            name: "488, Albertsons, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "488, CVS, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "488, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "488, HEB, PORTLAND, TX",
            disabled: false,
          },
          {
            name: "488, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "488, Kroger, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "488, Kroger, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "488, Walmart, QUINCY, FL",
            disabled: false,
          },
          {
            name: "4880, CVS, DECATUR, TX",
            disabled: false,
          },
          {
            name: "4881, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "4882, CVS, FULTONDALE, AL",
            disabled: false,
          },
          {
            name: "4882, Walgreens, INVER GROVE HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "4883, CVS, SEMMES, AL",
            disabled: false,
          },
          {
            name: "4884, CVS, MADISON, AL",
            disabled: false,
          },
          {
            name: "4884, Walgreens, THIENSVILLE, WI",
            disabled: false,
          },
          {
            name: "4886, Rite Aid, WASHINGTON, MI",
            disabled: false,
          },
          {
            name: "4887, Walgreens, OAK CREEK, WI",
            disabled: false,
          },
          {
            name: "4888, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4888, Walgreens, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "4889, CVS, HOOVER, AL",
            disabled: false,
          },
          {
            name: "489, ADUSA, HUDSON, MA",
            disabled: false,
          },
          {
            name: "489, CVS, RYE, NY",
            disabled: false,
          },
          {
            name: "489, Costco, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "489, HEB, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "489, Kroger, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "489, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "489, Walmart, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "4891, CVS, TRUSSVILLE, AL",
            disabled: false,
          },
          {
            name: "4893, CVS, CLANTON, AL",
            disabled: false,
          },
          {
            name: "4893, Walgreens, SHARONVILLE, OH",
            disabled: false,
          },
          {
            name: "4894, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4894, Rite Aid, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "4894, Walgreens, THORNTON, CO",
            disabled: false,
          },
          {
            name: "4895, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4895, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "4896, CVS, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "4896, Walgreens, EDMOND, OK",
            disabled: false,
          },
          {
            name: "4897, CVS, CENTREVILLE, AL",
            disabled: false,
          },
          {
            name: "4897, Rite Aid, CENTER LINE, MI",
            disabled: false,
          },
          {
            name: "4898, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4898, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "4899, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "4899, Walgreens, ABILENE, TX",
            disabled: false,
          },
          {
            name: "49, ADUSA, WATERTOWN, MA",
            disabled: false,
          },
          {
            name: "49, BJ's, ISLANDIA, NY",
            disabled: false,
          },
          {
            name: "49, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "49, Kroger, Coeur D Alene, ID",
            disabled: false,
          },
          {
            name: "49, Kroger, Goodyear, AZ",
            disabled: false,
          },
          {
            name: "49, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "49, Kroger, Sunland, CA",
            disabled: false,
          },
          {
            name: "49, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "49, Walmart, HUGO, OK",
            disabled: false,
          },
          {
            name: "490, ADUSA, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "490, ADUSA, ONLEY, VA",
            disabled: false,
          },
          {
            name: "490, Albertsons, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "490, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "490, Kroger, BYRAM, MS",
            disabled: false,
          },
          {
            name: "490, Kroger, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "490, Kroger, HENDERSON, TX",
            disabled: false,
          },
          {
            name: "490, Walmart, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "4900, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4901, CVS, MUSCLE SHOALS, AL",
            disabled: false,
          },
          {
            name: "4901, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "4902, CVS, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "4902, Rite Aid, LINDENHURST, NY",
            disabled: false,
          },
          {
            name: "4903, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "4903, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "4904, CVS, HOMEWOOD, AL",
            disabled: false,
          },
          {
            name: "4904, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "4905, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "4906, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4906, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "4907, CVS, JACKSONVILLE, AL",
            disabled: false,
          },
          {
            name: "4908, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "4909, CVS, MILLBROOK, AL",
            disabled: false,
          },
          {
            name: "4909, Rite Aid, PRINCESS ANNE, MD",
            disabled: false,
          },
          {
            name: "4909, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "491, ADUSA, LEXINGTON, MA",
            disabled: false,
          },
          {
            name: "491, CVS, JACKSON HEIGHTS, NY",
            disabled: false,
          },
          {
            name: "491, Costco, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "491, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "491, Kroger, Brookhaven, GA",
            disabled: false,
          },
          {
            name: "491, Kroger, Granbury, TX",
            disabled: false,
          },
          {
            name: "491, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "491, Kroger, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "491, Walmart, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "4910, CVS, ALBERTVILLE, AL",
            disabled: false,
          },
          {
            name: "4910, Rite Aid, SELBYVILLE, DE",
            disabled: false,
          },
          {
            name: "4911, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "4912, CVS, CENTER POINT, AL",
            disabled: false,
          },
          {
            name: "4913, Albertsons, NEWTOWN, PA",
            disabled: false,
          },
          {
            name: "4913, CVS, HOOVER, AL",
            disabled: false,
          },
          {
            name: "4913, Rite Aid, LEWES, DE",
            disabled: false,
          },
          {
            name: "4913, Walgreens, DESTIN, FL",
            disabled: false,
          },
          {
            name: "4914, Rite Aid, LAUREL, DE",
            disabled: false,
          },
          {
            name: "4915, CVS, SYLACAUGA, AL",
            disabled: false,
          },
          {
            name: "4915, Rite Aid, DELMAR, MD",
            disabled: false,
          },
          {
            name: "4915, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4916, CVS, PLEASANT GROVE, AL",
            disabled: false,
          },
          {
            name: "4916, Rite Aid, MILLSBORO, DE",
            disabled: false,
          },
          {
            name: "4916, Walgreens, TEQUESTA, FL",
            disabled: false,
          },
          {
            name: "4917, CVS, GREENSBORO, AL",
            disabled: false,
          },
          {
            name: "4917, Rite Aid, BERLIN, MD",
            disabled: false,
          },
          {
            name: "4917, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "4918, Rite Aid, GEORGETOWN, DE",
            disabled: false,
          },
          {
            name: "4919, CVS, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "4919, Rite Aid, MILLVILLE, DE",
            disabled: false,
          },
          {
            name: "4919, Walgreens, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "492, ADUSA, GLASGOW, KY",
            disabled: false,
          },
          {
            name: "492, CVS, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "492, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "492, Kroger, BALCH SPRINGS, TX",
            disabled: false,
          },
          {
            name: "492, Kroger, LAKE CITY, GA",
            disabled: false,
          },
          {
            name: "492, Kroger, MADISON, MS",
            disabled: false,
          },
          {
            name: "492, Kroger, Maineville, OH",
            disabled: false,
          },
          {
            name: "492, Kroger, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "492, Walmart, VINCENNES, IN",
            disabled: false,
          },
          {
            name: "4920, Rite Aid, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "4920, Walgreens, SOUTH FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "4921, Walgreens, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "4923, Walgreens, WEST ROXBURY, MA",
            disabled: false,
          },
          {
            name: "4924, Rite Aid, HARRINGTON, DE",
            disabled: false,
          },
          {
            name: "4924, Walgreens, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "4925, CVS, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "4926, Albertsons, WILLINGBORO, NJ",
            disabled: false,
          },
          {
            name: "4926, CVS, PINSON, AL",
            disabled: false,
          },
          {
            name: "4926, Rite Aid, MIDDLETOWN, DE",
            disabled: false,
          },
          {
            name: "4927, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4928, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4928, Rite Aid, COLONIE, NY",
            disabled: false,
          },
          {
            name: "493, Albertsons, TACOMA, WA",
            disabled: false,
          },
          {
            name: "493, CVS, MIDDLETOWN, RI",
            disabled: false,
          },
          {
            name: "493, Kroger, BRANDON, MS",
            disabled: false,
          },
          {
            name: "493, Kroger, DENTON, TX",
            disabled: false,
          },
          {
            name: "493, Kroger, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "493, Walmart, PARIS, KY",
            disabled: false,
          },
          {
            name: "4930, CVS, MADISON, WI",
            disabled: false,
          },
          {
            name: "4931, CVS, MOULTON, AL",
            disabled: false,
          },
          {
            name: "4932, Albertsons, LINCROFT, NJ",
            disabled: false,
          },
          {
            name: "4932, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "4932, Walgreens, WARREN, MI",
            disabled: false,
          },
          {
            name: "4933, Albertsons, MC LEAN, VA",
            disabled: false,
          },
          {
            name: "4933, Albertsons, MCLEAN, VA",
            disabled: false,
          },
          {
            name: "4933, Walgreens, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "4934, CVS, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "4934, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "4935, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4935, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4936, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4936, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4937, Rite Aid, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "4937, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4938, CVS, BAY MINETTE, AL",
            disabled: false,
          },
          {
            name: "4938, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "4938, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4939, Walgreens, OAK BROOK, IL",
            disabled: false,
          },
          {
            name: "494, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "494, Albertsons, ENUMCLAW, WA",
            disabled: false,
          },
          {
            name: "494, CVS, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "494, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "494, Kroger, Albuquerque, NM",
            disabled: false,
          },
          {
            name: "494, Kroger, BUFORD, GA",
            disabled: false,
          },
          {
            name: "494, Kroger, RIDGELAND, MS",
            disabled: false,
          },
          {
            name: "494, Kroger, Woodhaven, MI",
            disabled: false,
          },
          {
            name: "494, Walmart, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "4940, CVS, TUSKEGEE, AL",
            disabled: false,
          },
          {
            name: "4940, Walgreens, ROUND LAKE BEACH, IL",
            disabled: false,
          },
          {
            name: "4941, CVS, ARAB, AL",
            disabled: false,
          },
          {
            name: "4941, Walgreens, WHEELING, IL",
            disabled: false,
          },
          {
            name: "4942, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "4943, CVS, TALLASSEE, AL",
            disabled: false,
          },
          {
            name: "4943, Rite Aid, ALGONAC, MI",
            disabled: false,
          },
          {
            name: "4944, CVS, PRATTVILLE, AL",
            disabled: false,
          },
          {
            name: "4945, CVS, FAIRHOPE, AL",
            disabled: false,
          },
          {
            name: "4946, CVS, ALICEVILLE, AL",
            disabled: false,
          },
          {
            name: "4946, Walgreens, CHESTERTON, IN",
            disabled: false,
          },
          {
            name: "4947, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4947, Rite Aid, AMHERST, OH",
            disabled: false,
          },
          {
            name: "4947, Walgreens, CRESTWOOD, IL",
            disabled: false,
          },
          {
            name: "4948, CVS, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "4948, Rite Aid, BURTON, MI",
            disabled: false,
          },
          {
            name: "4948, Walgreens, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "4949, CVS, OPELIKA, AL",
            disabled: false,
          },
          {
            name: "4949, Walgreens, FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "495, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "495, Albertsons, BURLINGTON, MA",
            disabled: false,
          },
          {
            name: "495, HEB, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "495, Kroger, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "495, Kroger, IRVING, TX",
            disabled: false,
          },
          {
            name: "495, Kroger, Saint Clair Shores, MI",
            disabled: false,
          },
          {
            name: "495, Kroger, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "495, Walmart, COLUMBUS, MS",
            disabled: false,
          },
          {
            name: "4950, CVS, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "4950, Walgreens, CLOVIS, NM",
            disabled: false,
          },
          {
            name: "4951, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "4952, Walgreens, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "4953, CVS, GREENVILLE, AL",
            disabled: false,
          },
          {
            name: "4953, Rite Aid, BRUNSWICK, OH",
            disabled: false,
          },
          {
            name: "4954, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "4955, Walgreens, AVENTURA, FL",
            disabled: false,
          },
          {
            name: "4956, CVS, PIEDMONT, AL",
            disabled: false,
          },
          {
            name: "4956, Rite Aid, GRAND BLANC, MI",
            disabled: false,
          },
          {
            name: "4957, CVS, DEMOPOLIS, AL",
            disabled: false,
          },
          {
            name: "4958, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "4959, CVS, DAPHNE, AL",
            disabled: false,
          },
          {
            name: "4959, Walgreens, MAITLAND, FL",
            disabled: false,
          },
          {
            name: "496, Albertsons, REDMOND, WA",
            disabled: false,
          },
          {
            name: "496, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "4960, CVS, HANCEVILLE, AL",
            disabled: false,
          },
          {
            name: "4960, Rite Aid, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "4960, Walgreens, NEW SMYRNA BEACH, FL",
            disabled: false,
          },
          {
            name: "4961, Rite Aid, PELHAM, NH",
            disabled: false,
          },
          {
            name: "4961, Walgreens, OCOEE, FL",
            disabled: false,
          },
          {
            name: "4962, Walgreens, BRANDON, FL",
            disabled: false,
          },
          {
            name: "4963, Walgreens, FREEHOLD, NJ",
            disabled: false,
          },
          {
            name: "4964, CVS, BESSEMER, AL",
            disabled: false,
          },
          {
            name: "4965, CVS, HELENA, AL",
            disabled: false,
          },
          {
            name: "4965, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "4966, Walgreens, MALDEN, MA",
            disabled: false,
          },
          {
            name: "4967, CVS, MOODY, AL",
            disabled: false,
          },
          {
            name: "4967, Walgreens, HOLYOKE, MA",
            disabled: false,
          },
          {
            name: "4968, CVS, GUNTERSVILLE, AL",
            disabled: false,
          },
          {
            name: "4968, Walgreens, LOCKPORT, NY",
            disabled: false,
          },
          {
            name: "4969, CVS, GORDO, AL",
            disabled: false,
          },
          {
            name: "4969, Rite Aid, ORCHARD PARK, NY",
            disabled: false,
          },
          {
            name: "497, ADUSA, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "497, ADUSA, WESTBOROUGH, MA",
            disabled: false,
          },
          {
            name: "497, Albertsons, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "497, HEB, KATY, TX",
            disabled: false,
          },
          {
            name: "497, Kroger, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "497, Kroger, Los Alamos, NM",
            disabled: false,
          },
          {
            name: "497, Kroger, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "497, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "497, Walmart, SHELBYVILLE, KY",
            disabled: false,
          },
          {
            name: "4970, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "4971, Walgreens, GRANITE CITY, IL",
            disabled: false,
          },
          {
            name: "4972, CVS, ATTALLA, AL",
            disabled: false,
          },
          {
            name: "4972, Walgreens, ARNOLD, MO",
            disabled: false,
          },
          {
            name: "4973, CVS, CAMDEN, AL",
            disabled: false,
          },
          {
            name: "4973, Walgreens, URBANDALE, IA",
            disabled: false,
          },
          {
            name: "4974, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "4975, CVS, LANETT, AL",
            disabled: false,
          },
          {
            name: "4975, Rite Aid, WESTLAKE, OH",
            disabled: false,
          },
          {
            name: "4975, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4976, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "4977, CVS, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "4977, Rite Aid, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "4978, CVS, MIDLOTHIAN, IL",
            disabled: false,
          },
          {
            name: "4978, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4979, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4979, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "498, ADUSA, SOMERVILLE, MA",
            disabled: false,
          },
          {
            name: "498, CVS, WEBSTER, MA",
            disabled: false,
          },
          {
            name: "498, HEB, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "498, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "498, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "498, Walmart, JENA, LA",
            disabled: false,
          },
          {
            name: "4980, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "4980, Walgreens, HILTON HEAD ISLAND, SC",
            disabled: false,
          },
          {
            name: "4981, CVS, PLAINVILLE, MA",
            disabled: false,
          },
          {
            name: "4981, Rite Aid, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "4981, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "4982, CVS, FISHERS, IN",
            disabled: false,
          },
          {
            name: "4982, Rite Aid, WILLIAMSVILLE, NY",
            disabled: false,
          },
          {
            name: "4982, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "4983, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "4983, Walgreens, CANTON, OH",
            disabled: false,
          },
          {
            name: "4984, CVS, GLEN MILLS, PA",
            disabled: false,
          },
          {
            name: "4984, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "4986, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "4987, CVS, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "4987, Rite Aid, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "4988, CVS, NASHVILLE, NC",
            disabled: false,
          },
          {
            name: "4988, Walgreens, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "4989, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "499, ADUSA, AMESBURY, MA",
            disabled: false,
          },
          {
            name: "499, Kroger, Aspen, CO",
            disabled: false,
          },
          {
            name: "499, Kroger, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "499, Kroger, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "499, Kroger, Socorro, NM",
            disabled: false,
          },
          {
            name: "499, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "499, Walmart, ENID, OK",
            disabled: false,
          },
          {
            name: "4990, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4990, Rite Aid, MOUNTAIN TOP, PA",
            disabled: false,
          },
          {
            name: "4991, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "4992, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "4992, Walgreens, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "4993, CVS, MADISON, MS",
            disabled: false,
          },
          {
            name: "4994, CVS, COCONUT GROVE, FL",
            disabled: false,
          },
          {
            name: "4995, CVS, BENSENVILLE, IL",
            disabled: false,
          },
          {
            name: "4996, CVS, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "4997, CVS, JACKSON, MS",
            disabled: false,
          },
          {
            name: "4997, Walgreens, MARINA, CA",
            disabled: false,
          },
          {
            name: "4998, CVS, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "4998, Rite Aid, MASSENA, NY",
            disabled: false,
          },
          {
            name: "4998, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "4999, Walgreens, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "5, ADUSA, PEABODY, MA",
            disabled: false,
          },
          {
            name: "5, Albertsons, RESTON, VA",
            disabled: false,
          },
          {
            name: "5, Kroger, ALBANY, OR",
            disabled: false,
          },
          {
            name: "5, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "5, Kroger, Duarte, CA",
            disabled: false,
          },
          {
            name: "5, Kroger, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "5, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "5, Target, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "5, Walmart, CONWAY, AR",
            disabled: false,
          },
          {
            name: "50, BJ's, STONEHAM, MA",
            disabled: false,
          },
          {
            name: "50, Kroger, COLBY, KS",
            disabled: false,
          },
          {
            name: "50, Kroger, COOS BAY, OR",
            disabled: false,
          },
          {
            name: "50, Kroger, Littleton, CO",
            disabled: false,
          },
          {
            name: "50, Meijer, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "50, Walmart, VINITA, OK",
            disabled: false,
          },
          {
            name: "500, CVS, STRATHAM, NH",
            disabled: false,
          },
          {
            name: "500, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "500, Kroger, Henrico, VA",
            disabled: false,
          },
          {
            name: "500, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "500, Kroger, Toledo, OH",
            disabled: false,
          },
          {
            name: "500, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5001, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5001, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5002, CVS, LANTANA, TX",
            disabled: false,
          },
          {
            name: "5002, Walgreens, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "5003, Walgreens, BALLWIN, MO",
            disabled: false,
          },
          {
            name: "5003, Walmart, PAGOSA SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5005, Walgreens, PATERSON, NJ",
            disabled: false,
          },
          {
            name: "5005, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5006, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5006, Walgreens, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "5007, Walmart, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "5008, CVS, CLINTON, NY",
            disabled: false,
          },
          {
            name: "5008, Walmart, HEMET, CA",
            disabled: false,
          },
          {
            name: "5009, CVS, PENN YAN, NY",
            disabled: false,
          },
          {
            name: "501, ADUSA, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "501, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "501, CVS, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "501, Kroger, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "501, Kroger, Gig Harbor, WA",
            disabled: false,
          },
          {
            name: "501, Kroger, HANNIBAL, MO",
            disabled: false,
          },
          {
            name: "501, Kroger, Holland, OH",
            disabled: false,
          },
          {
            name: "501, Kroger, Monroe, OH",
            disabled: false,
          },
          {
            name: "501, Kroger, North Chesterfield, VA",
            disabled: false,
          },
          {
            name: "501, Kroger, Sacramento, CA",
            disabled: false,
          },
          {
            name: "501, Walmart, LAUREL, MS",
            disabled: false,
          },
          {
            name: "5011, CVS, WELLSBORO, PA",
            disabled: false,
          },
          {
            name: "5012, CVS, CARSON, CA",
            disabled: false,
          },
          {
            name: "5012, Walmart, HAMILTON, NJ",
            disabled: false,
          },
          {
            name: "5013, CVS, MARGARETVILLE, NY",
            disabled: false,
          },
          {
            name: "5013, Walmart, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "5014, CVS, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "5014, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5014, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "5015, CVS, WATERVILLE, NY",
            disabled: false,
          },
          {
            name: "5015, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5016, Walgreens, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "5017, Walgreens, PUNTA GORDA, FL",
            disabled: false,
          },
          {
            name: "5018, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "5019, CVS, WALTON, NY",
            disabled: false,
          },
          {
            name: "502, ADUSA, PORT CHESTER, NY",
            disabled: false,
          },
          {
            name: "502, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "502, Albertsons, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "502, CVS, ITHACA, NY",
            disabled: false,
          },
          {
            name: "502, Kroger, Frederick, MD",
            disabled: false,
          },
          {
            name: "502, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "502, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "502, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "502, Kroger, Vernon Hills, IL",
            disabled: false,
          },
          {
            name: "502, Kroger, Warrenton, MO",
            disabled: false,
          },
          {
            name: "502, ShopRite, GIBBSTOWN, NJ",
            disabled: false,
          },
          {
            name: "502, Walmart, GALLIANO, LA",
            disabled: false,
          },
          {
            name: "5021, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5022, Walmart, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5023, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5023, Walmart, NATIONAL CITY, CA",
            disabled: false,
          },
          {
            name: "5024, CVS, SKANEATELES, NY",
            disabled: false,
          },
          {
            name: "5024, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5025, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "5025, Walmart, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5026, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5027, Walgreens, SIERRA VISTA, AZ",
            disabled: false,
          },
          {
            name: "5027, Walmart, LANCASTER, NY",
            disabled: false,
          },
          {
            name: "5028, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5028, Walmart, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "5029, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5029, Walmart, OREGON, OH",
            disabled: false,
          },
          {
            name: "503, ADUSA, BRONX, NY",
            disabled: false,
          },
          {
            name: "503, Albertsons, EVERETT, WA",
            disabled: false,
          },
          {
            name: "503, CVS, SEABROOK, NH",
            disabled: false,
          },
          {
            name: "503, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "503, Kroger, DECHERD, TN",
            disabled: false,
          },
          {
            name: "503, Kroger, Groveland, FL",
            disabled: false,
          },
          {
            name: "503, Kroger, North Las Vegas, NV",
            disabled: false,
          },
          {
            name: "503, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "503, Walmart, COLUMBUS, TX",
            disabled: false,
          },
          {
            name: "5030, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "5030, Walmart, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "5031, CVS, EAST GREENBUSH, NY",
            disabled: false,
          },
          {
            name: "5031, Walgreens, MIDDLEBURG HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "5031, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5032, CVS, TROY, NY",
            disabled: false,
          },
          {
            name: "5032, Walgreens, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "5032, Walmart, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "5033, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5033, Walmart, FORT MORGAN, CO",
            disabled: false,
          },
          {
            name: "5034, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5034, Walmart, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "5035, CVS, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "5035, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5035, Walmart, MULBERRY, FL",
            disabled: false,
          },
          {
            name: "5036, CVS, CAIRO, NY",
            disabled: false,
          },
          {
            name: "5036, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5036, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5037, CVS, RAVENA, NY",
            disabled: false,
          },
          {
            name: "5037, Walgreens, DESERT HOT SPRINGS, CA",
            disabled: false,
          },
          {
            name: "5037, Walmart, YULEE, FL",
            disabled: false,
          },
          {
            name: "5038, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "5038, Walgreens, HEMET, CA",
            disabled: false,
          },
          {
            name: "5038, Walmart, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "5039, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "5039, Walmart, CAMDEN, DE",
            disabled: false,
          },
          {
            name: "504, ADUSA, BRONX, NY",
            disabled: false,
          },
          {
            name: "504, ADUSA, HICKORY, NC",
            disabled: false,
          },
          {
            name: "504, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "504, Kroger, Forest Park, GA",
            disabled: false,
          },
          {
            name: "504, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "504, Kroger, SWANTON, OH",
            disabled: false,
          },
          {
            name: "504, Walmart, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "5040, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5040, Walmart, CARNEGIE, PA",
            disabled: false,
          },
          {
            name: "5041, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5041, Walgreens, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "5041, Walmart, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "5042, CVS, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "5042, Walgreens, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "5043, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5043, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5044, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "5044, Walgreens, BURLINGTON, IA",
            disabled: false,
          },
          {
            name: "5044, Walmart, GALENA, IL",
            disabled: false,
          },
          {
            name: "5045, CVS, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "5045, Walgreens, DEERFIELD, IL",
            disabled: false,
          },
          {
            name: "5045, Walmart, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "5046, CVS, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "5046, Walmart, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "5047, Walmart, AUDUBON, NJ",
            disabled: false,
          },
          {
            name: "5048, CVS, PEEKSKILL, NY",
            disabled: false,
          },
          {
            name: "5048, Walgreens, HASTINGS, MN",
            disabled: false,
          },
          {
            name: "5048, Walmart, NEW HUDSON, MI",
            disabled: false,
          },
          {
            name: "5049, CVS, PLEASANT VALLEY, NY",
            disabled: false,
          },
          {
            name: "5049, Walmart, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "505, ADUSA, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "505, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "505, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "505, CVS, FITCHBURG, MA",
            disabled: false,
          },
          {
            name: "505, Kroger, Dallas, TX",
            disabled: false,
          },
          {
            name: "505, Kroger, Fremont, OH",
            disabled: false,
          },
          {
            name: "505, Kroger, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "505, Kroger, Madison, AL",
            disabled: false,
          },
          {
            name: "505, Kroger, PALATINE, IL",
            disabled: false,
          },
          {
            name: "505, Walmart, DERIDDER, LA",
            disabled: false,
          },
          {
            name: "5050, CVS, WASHINGTONVILLE, NY",
            disabled: false,
          },
          {
            name: "5051, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "5051, Walgreens, SPRINGFIELD GARDENS, NY",
            disabled: false,
          },
          {
            name: "5051, Walmart, GREELEY, CO",
            disabled: false,
          },
          {
            name: "5052, CVS, HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "5053, CVS, CORNWALL, NY",
            disabled: false,
          },
          {
            name: "5053, Walgreens, FARRAGUT, TN",
            disabled: false,
          },
          {
            name: "5054, CVS, MAHOPAC, NY",
            disabled: false,
          },
          {
            name: "5054, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5055, CVS, DOVER PLAINS, NY",
            disabled: false,
          },
          {
            name: "5055, Walgreens, ALSIP, IL",
            disabled: false,
          },
          {
            name: "5055, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5056, CVS, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "5056, Walgreens, GURNEE, IL",
            disabled: false,
          },
          {
            name: "5056, Walmart, PRAIRIEVILLE, LA",
            disabled: false,
          },
          {
            name: "5057, CVS, MILLERTON, NY",
            disabled: false,
          },
          {
            name: "5057, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5057, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "5058, Walgreens, ARNOLD, MO",
            disabled: false,
          },
          {
            name: "5058, Walmart, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "5059, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5059, Walmart, HOPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "506, ADUSA, ROANOKE RAPIDS, NC",
            disabled: false,
          },
          {
            name: "506, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "506, CVS, EDISON, NJ",
            disabled: false,
          },
          {
            name: "506, Kroger, BUCYRUS, OH",
            disabled: false,
          },
          {
            name: "506, Kroger, Hoffman Estates, IL",
            disabled: false,
          },
          {
            name: "506, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "506, Kroger, Pleasant Prairie, WI",
            disabled: false,
          },
          {
            name: "506, Walmart, FLORA, IL",
            disabled: false,
          },
          {
            name: "5060, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5060, Walgreens, CLIVE, IA",
            disabled: false,
          },
          {
            name: "5060, Walmart, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "5061, CVS, COMMACK, NY",
            disabled: false,
          },
          {
            name: "5062, Walmart, AUBURN, AL",
            disabled: false,
          },
          {
            name: "5063, CVS, EAST HAMPTON, NY",
            disabled: false,
          },
          {
            name: "5063, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5064, CVS, FRAZER, PA",
            disabled: false,
          },
          {
            name: "5064, Walgreens, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "5064, Walmart, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "5065, CVS, BLANDON, PA",
            disabled: false,
          },
          {
            name: "5065, Walgreens, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "5065, Walmart, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "5066, CVS, PATCHOGUE, NY",
            disabled: false,
          },
          {
            name: "5066, Walgreens, ARLINGTON, TN",
            disabled: false,
          },
          {
            name: "5066, Walmart, AVON, OH",
            disabled: false,
          },
          {
            name: "5067, CVS, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "5067, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5068, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5069, CVS, CRAWFORDVILLE, FL",
            disabled: false,
          },
          {
            name: "507, ADUSA, MONROE, NC",
            disabled: false,
          },
          {
            name: "507, Albertsons, PLAINVIEW, TX",
            disabled: false,
          },
          {
            name: "507, CVS, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "507, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "507, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "507, Kroger, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "507, ShopRite, CLEMENTON, NJ",
            disabled: false,
          },
          {
            name: "507, Walmart, LAWRENCEBURG, KY",
            disabled: false,
          },
          {
            name: "5070, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5071, CVS, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "5071, Walmart, LAWTON, OK",
            disabled: false,
          },
          {
            name: "5072, CVS, DANSVILLE, NY",
            disabled: false,
          },
          {
            name: "5072, Walgreens, HOOVER, AL",
            disabled: false,
          },
          {
            name: "5072, Walmart, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "5073, CVS, HONEOYE, NY",
            disabled: false,
          },
          {
            name: "5073, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "5073, Walmart, COVINGTON, WA",
            disabled: false,
          },
          {
            name: "5074, CVS, WAYLAND, NY",
            disabled: false,
          },
          {
            name: "5075, CVS, WESTFIELD, NY",
            disabled: false,
          },
          {
            name: "5075, Walgreens, TEWKSBURY, MA",
            disabled: false,
          },
          {
            name: "5075, Walmart, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "5076, CVS, HILTON, NY",
            disabled: false,
          },
          {
            name: "5076, Walgreens, BERWYN, IL",
            disabled: false,
          },
          {
            name: "5076, Walmart, BREWER, ME",
            disabled: false,
          },
          {
            name: "5077, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5077, Walgreens, IOWA CITY, IA",
            disabled: false,
          },
          {
            name: "5077, Walmart, BOONTON, NJ",
            disabled: false,
          },
          {
            name: "5078, CVS, SODUS, NY",
            disabled: false,
          },
          {
            name: "5078, Walgreens, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "5078, Walmart, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "5079, CVS, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "5079, Walmart, PASS CHRISTIAN, MS",
            disabled: false,
          },
          {
            name: "508, ADUSA, SPARTA, NC",
            disabled: false,
          },
          {
            name: "508, Albertsons, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "508, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "508, Kroger, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "508, Kroger, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "508, Walmart, KERRVILLE, TX",
            disabled: false,
          },
          {
            name: "5080, CVS, NORTH PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5080, Walgreens, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "5080, Walmart, HURST, TX",
            disabled: false,
          },
          {
            name: "5081, CVS, BALA CYNWYD, PA",
            disabled: false,
          },
          {
            name: "5081, Walgreens, EAGAN, MN",
            disabled: false,
          },
          {
            name: "5081, Walmart, MERAUX, LA",
            disabled: false,
          },
          {
            name: "5082, Walmart, PARMA, OH",
            disabled: false,
          },
          {
            name: "5083, CVS, WESTON, FL",
            disabled: false,
          },
          {
            name: "5084, CVS, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5085, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5085, Walmart, BELMONT, NC",
            disabled: false,
          },
          {
            name: "5086, Walgreens, SOUTH CHICAGO HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "5087, CVS, JAMESTOWN, NY",
            disabled: false,
          },
          {
            name: "5087, Walgreens, FITCHBURG, WI",
            disabled: false,
          },
          {
            name: "5087, Walmart, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "5088, CVS, NORTH EAST, PA",
            disabled: false,
          },
          {
            name: "5088, Walgreens, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "5088, Walmart, TRIADELPHIA, WV",
            disabled: false,
          },
          {
            name: "5089, CVS, FALCONER, NY",
            disabled: false,
          },
          {
            name: "5089, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5089, Walmart, INVER GROVE HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "509, Albertsons, LEVELLAND, TX",
            disabled: false,
          },
          {
            name: "509, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "509, Kroger, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "509, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "509, Kroger, FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "509, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "5090, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "5090, Walgreens, SHOW LOW, AZ",
            disabled: false,
          },
          {
            name: "5090, Walmart, DE PERE, WI",
            disabled: false,
          },
          {
            name: "5091, CVS, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "5091, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5091, Walmart, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "5092, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5092, Walmart, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "5093, CVS, WARREN, PA",
            disabled: false,
          },
          {
            name: "5093, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5093, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "5094, CVS, MOUNT LEBANON, PA",
            disabled: false,
          },
          {
            name: "5094, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5094, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5095, CVS, EDINBORO, PA",
            disabled: false,
          },
          {
            name: "5095, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "5095, Walmart, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "5096, CVS, OIL CITY, PA",
            disabled: false,
          },
          {
            name: "5096, Walmart, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "5097, CVS, TITUSVILLE, PA",
            disabled: false,
          },
          {
            name: "5097, Walgreens, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "5097, Walmart, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "5098, CVS, CORRY, PA",
            disabled: false,
          },
          {
            name: "5098, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "5098, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "5099, CVS, MEADVILLE, PA",
            disabled: false,
          },
          {
            name: "5099, Walmart, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "51, HEB, BIG SPRING, TX",
            disabled: false,
          },
          {
            name: "51, Kroger, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "51, Kroger, Dallas, TX",
            disabled: false,
          },
          {
            name: "51, Kroger, GREAT BEND, KS",
            disabled: false,
          },
          {
            name: "51, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "51, Kroger, Wilsonville, OR",
            disabled: false,
          },
          {
            name: "51, Meijer, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "51, Walmart, FULTON, MO",
            disabled: false,
          },
          {
            name: "510, ADUSA, COLUMBUS, NC",
            disabled: false,
          },
          {
            name: "510, Albertsons, HEREFORD, TX",
            disabled: false,
          },
          {
            name: "510, CVS, GARDEN CITY, NY",
            disabled: false,
          },
          {
            name: "510, Kroger, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "510, Kroger, Harwood Heights, IL",
            disabled: false,
          },
          {
            name: "510, Kroger, Henderson, NV",
            disabled: false,
          },
          {
            name: "510, Kroger, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "510, Kroger, Romulus, MI",
            disabled: false,
          },
          {
            name: "510, Walmart, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "5100, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "5100, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "5101, CVS, MCMURRAY, PA",
            disabled: false,
          },
          {
            name: "5101, Walmart, PAHRUMP, NV",
            disabled: false,
          },
          {
            name: "5102, Walmart, GRETNA, LA",
            disabled: false,
          },
          {
            name: "5103, CVS, NATRONA HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "5103, Walmart, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "5104, CVS, MANORVILLE, NY",
            disabled: false,
          },
          {
            name: "5104, Walgreens, OAK FOREST, IL",
            disabled: false,
          },
          {
            name: "5104, Walmart, MORAINE, OH",
            disabled: false,
          },
          {
            name: "5105, Walmart, FRONT ROYAL, VA",
            disabled: false,
          },
          {
            name: "5106, Walgreens, GRAYSLAKE, IL",
            disabled: false,
          },
          {
            name: "5106, Walmart, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "5107, CVS, EAST GREENWICH, RI",
            disabled: false,
          },
          {
            name: "5107, Walgreens, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "5107, Walmart, MADISON, TN",
            disabled: false,
          },
          {
            name: "5108, Walgreens, LAKE VILLA, IL",
            disabled: false,
          },
          {
            name: "5108, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5109, CVS, JUNO BEACH, FL",
            disabled: false,
          },
          {
            name: "5109, Walmart, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "511, Albertsons, SLATON, TX",
            disabled: false,
          },
          {
            name: "511, CVS, HAINES CITY, FL",
            disabled: false,
          },
          {
            name: "511, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "511, Kroger, ELMHURST, IL",
            disabled: false,
          },
          {
            name: "511, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "511, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "511, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "511, Walmart, SUMTER, SC",
            disabled: false,
          },
          {
            name: "5110, CVS, SUN CITY CENTER, FL",
            disabled: false,
          },
          {
            name: "5110, Walmart, DRAPER, UT",
            disabled: false,
          },
          {
            name: "5111, Walgreens, HAZLET, NJ",
            disabled: false,
          },
          {
            name: "5111, Walmart, WATCHUNG, NJ",
            disabled: false,
          },
          {
            name: "5112, CVS, BELLE GLADE, FL",
            disabled: false,
          },
          {
            name: "5113, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5113, Walmart, PELL CITY, AL",
            disabled: false,
          },
          {
            name: "5115, CVS, DAVIE, FL",
            disabled: false,
          },
          {
            name: "5115, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5115, Walmart, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "5116, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "5116, Walmart, LA PORTE, TX",
            disabled: false,
          },
          {
            name: "5117, CVS, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "5117, Walgreens, JENISON, MI",
            disabled: false,
          },
          {
            name: "5117, Walmart, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "5118, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "5119, CVS, JENSEN BEACH, FL",
            disabled: false,
          },
          {
            name: "5119, Walgreens, CLINTON, IA",
            disabled: false,
          },
          {
            name: "5119, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "512, ADUSA, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "512, Albertsons, POST, TX",
            disabled: false,
          },
          {
            name: "512, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "512, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "512, Kroger, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "512, Kroger, SOUTHLAKE, TX",
            disabled: false,
          },
          {
            name: "512, Kroger, STEUBENVILLE, OH",
            disabled: false,
          },
          {
            name: "512, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5120, CVS, LADY LAKE, FL",
            disabled: false,
          },
          {
            name: "5120, Walgreens, DES PERES, MO",
            disabled: false,
          },
          {
            name: "5121, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5122, CVS, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5122, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5123, CVS, BROCKPORT, NY",
            disabled: false,
          },
          {
            name: "5123, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5123, Walmart, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5124, CVS, PINECREST, FL",
            disabled: false,
          },
          {
            name: "5124, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5124, Walmart, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "5125, CVS, NORTH MIAMI, FL",
            disabled: false,
          },
          {
            name: "5125, Walmart, OPELOUSAS, LA",
            disabled: false,
          },
          {
            name: "5126, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5126, Walgreens, LANSING, IL",
            disabled: false,
          },
          {
            name: "5126, Walmart, CENTRE, AL",
            disabled: false,
          },
          {
            name: "5127, Walgreens, LANSING, IL",
            disabled: false,
          },
          {
            name: "5127, Walmart, LA CROSSE, WI",
            disabled: false,
          },
          {
            name: "5128, CVS, JAMESBURG, NJ",
            disabled: false,
          },
          {
            name: "5128, Walgreens, SAUK VILLAGE, IL",
            disabled: false,
          },
          {
            name: "5129, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5129, Walmart, LANDOVER HILLS, MD",
            disabled: false,
          },
          {
            name: "513, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "513, CVS, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "513, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "513, Kroger, WHEATON, IL",
            disabled: false,
          },
          {
            name: "513, Walmart, BIG SPRING, TX",
            disabled: false,
          },
          {
            name: "5130, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "5130, Walmart, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "5131, CVS, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "5131, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5131, Walmart, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "5132, Walmart, WINTER SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5133, Walmart, ANDERSON, CA",
            disabled: false,
          },
          {
            name: "5134, Walgreens, SIMSBURY, CT",
            disabled: false,
          },
          {
            name: "5134, Walmart, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5135, Walgreens, SELDEN, NY",
            disabled: false,
          },
          {
            name: "5135, Walmart, RADCLIFF, KY",
            disabled: false,
          },
          {
            name: "5136, Walgreens, WATERTOWN, WI",
            disabled: false,
          },
          {
            name: "5136, Walmart, MARYSVILLE, CA",
            disabled: false,
          },
          {
            name: "5137, CVS, STUART, FL",
            disabled: false,
          },
          {
            name: "5137, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "5137, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "5138, Walgreens, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "5139, CVS, EUSTIS, FL",
            disabled: false,
          },
          {
            name: "5139, Walgreens, HICKORY HILLS, IL",
            disabled: false,
          },
          {
            name: "5139, Walmart, DIXON, CA",
            disabled: false,
          },
          {
            name: "514, Albertsons, BEND, OR",
            disabled: false,
          },
          {
            name: "514, CVS, TOTOWA, NJ",
            disabled: false,
          },
          {
            name: "514, Kroger, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "514, Kroger, LAKE ZURICH, IL",
            disabled: false,
          },
          {
            name: "514, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "514, Kroger, Madison, TN",
            disabled: false,
          },
          {
            name: "514, Kroger, North Chesterfield, VA",
            disabled: false,
          },
          {
            name: "514, Walmart, AIKEN, SC",
            disabled: false,
          },
          {
            name: "5140, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5140, Walmart, LA MESA, CA",
            disabled: false,
          },
          {
            name: "5141, CVS, PALM BEACH GARDENS, FL",
            disabled: false,
          },
          {
            name: "5141, Walgreens, LAPORTE, IN",
            disabled: false,
          },
          {
            name: "5141, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5142, CVS, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "5142, Walgreens, DUNCAN, OK",
            disabled: false,
          },
          {
            name: "5142, Walmart, NEPTUNE, NJ",
            disabled: false,
          },
          {
            name: "5143, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5143, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "5144, Walgreens, CLINTON, IA",
            disabled: false,
          },
          {
            name: "5144, Walmart, CONVERSE, TX",
            disabled: false,
          },
          {
            name: "5145, CVS, CAROL CITY, FL",
            disabled: false,
          },
          {
            name: "5145, Walgreens, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "5145, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5146, CVS, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5146, Walgreens, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "5146, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5147, Walgreens, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "5147, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5148, CVS, BRANDON, FL",
            disabled: false,
          },
          {
            name: "5148, Walgreens, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "5148, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "5149, CVS, TEMPLE TERRACE, FL",
            disabled: false,
          },
          {
            name: "5149, Walgreens, BROADVIEW, IL",
            disabled: false,
          },
          {
            name: "5149, Walmart, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "515, ADUSA, CHAGRIN FALLS, OH",
            disabled: false,
          },
          {
            name: "515, ADUSA, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "515, Albertsons, BURKBURNETT, TX",
            disabled: false,
          },
          {
            name: "515, Albertsons, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "515, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "515, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "515, Kroger, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "515, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "515, Kroger, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "515, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "515, Walmart, MURPHY, NC",
            disabled: false,
          },
          {
            name: "5150, CVS, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "5150, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5150, Walmart, MAPLEWOOD, MO",
            disabled: false,
          },
          {
            name: "5151, CVS, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "5151, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "5151, Walmart, ROME, GA",
            disabled: false,
          },
          {
            name: "5152, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5152, Walgreens, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "5152, Walmart, WEST HILLS, CA",
            disabled: false,
          },
          {
            name: "5153, CVS, EPPING, NH",
            disabled: false,
          },
          {
            name: "5154, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5154, Walmart, ROSEMEAD, CA",
            disabled: false,
          },
          {
            name: "5155, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5155, Walmart, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "5156, CVS, OLATHE, KS",
            disabled: false,
          },
          {
            name: "5156, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5156, Walmart, BEAUMONT, CA",
            disabled: false,
          },
          {
            name: "5157, CVS, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "5157, Walgreens, ESPANOLA, NM",
            disabled: false,
          },
          {
            name: "5157, Walmart, MORTON, IL",
            disabled: false,
          },
          {
            name: "5158, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5158, Walgreens, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "5159, CVS, WHITESTONE, NY",
            disabled: false,
          },
          {
            name: "5159, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "5159, Walmart, WEST BRANCH, MI",
            disabled: false,
          },
          {
            name: "516, ADUSA, HUNTINGTON, NY",
            disabled: false,
          },
          {
            name: "516, Albertsons, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "516, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "516, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "516, Kroger, KELLER, TX",
            disabled: false,
          },
          {
            name: "516, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "516, Kroger, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "516, Walmart, GUN BARREL CITY, TX",
            disabled: false,
          },
          {
            name: "5160, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5160, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "5160, Walmart, JACKSON, MI",
            disabled: false,
          },
          {
            name: "5161, Walgreens, DENTON, TX",
            disabled: false,
          },
          {
            name: "5162, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5162, Walmart, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "5163, CVS, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "5163, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5165, CVS, APALACHICOLA, FL",
            disabled: false,
          },
          {
            name: "5165, Walgreens, CLINTON, MS",
            disabled: false,
          },
          {
            name: "5165, Walmart, ALAMO, TX",
            disabled: false,
          },
          {
            name: "5166, CVS, WHITEHALL, NY",
            disabled: false,
          },
          {
            name: "5166, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5166, Walmart, DEMING, NM",
            disabled: false,
          },
          {
            name: "5167, Walgreens, BAY CITY, MI",
            disabled: false,
          },
          {
            name: "5167, Walmart, PAYSON, UT",
            disabled: false,
          },
          {
            name: "5168, Walgreens, FLAT ROCK, MI",
            disabled: false,
          },
          {
            name: "5168, Walmart, RICHFIELD, UT",
            disabled: false,
          },
          {
            name: "5169, CVS, JASPER, FL",
            disabled: false,
          },
          {
            name: "5169, Walgreens, TRENTON, MI",
            disabled: false,
          },
          {
            name: "517, ADUSA, HOPEWELL JUNCTION, NY",
            disabled: false,
          },
          {
            name: "517, Albertsons, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "517, CVS, LONGMEADOW, MA",
            disabled: false,
          },
          {
            name: "517, Kroger, COACHELLA, CA",
            disabled: false,
          },
          {
            name: "517, Kroger, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "517, Kroger, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "517, Kroger, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "517, Kroger, Richmond, VA",
            disabled: false,
          },
          {
            name: "517, Walmart, MUSTANG, OK",
            disabled: false,
          },
          {
            name: "5170, CVS, TEMPLE CITY, CA",
            disabled: false,
          },
          {
            name: "5170, Walgreens, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "5170, Walmart, SIDNEY, NE",
            disabled: false,
          },
          {
            name: "5171, CVS, LIVE OAK, FL",
            disabled: false,
          },
          {
            name: "5171, Rite Aid, AUBURN, WA",
            disabled: false,
          },
          {
            name: "5171, Walgreens, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "5172, CVS, LAKE BUTLER, FL",
            disabled: false,
          },
          {
            name: "5172, Rite Aid, AUBURN, WA",
            disabled: false,
          },
          {
            name: "5172, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5172, Walmart, PERRY, FL",
            disabled: false,
          },
          {
            name: "5173, CVS, WILLISTON, FL",
            disabled: false,
          },
          {
            name: "5173, Walgreens, JUPITER, FL",
            disabled: false,
          },
          {
            name: "5173, Walmart, DALTON, GA",
            disabled: false,
          },
          {
            name: "5174, CVS, WILTON MANORS, FL",
            disabled: false,
          },
          {
            name: "5174, Walgreens, LANTANA, FL",
            disabled: false,
          },
          {
            name: "5174, Walmart, SEMMES, AL",
            disabled: false,
          },
          {
            name: "5175, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5175, Rite Aid, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "5175, Walgreens, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "5175, Walmart, ALGOOD, TN",
            disabled: false,
          },
          {
            name: "5176, CVS, GULF BREEZE, FL",
            disabled: false,
          },
          {
            name: "5176, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "5177, CVS, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "5178, CVS, NICEVILLE, FL",
            disabled: false,
          },
          {
            name: "5178, Rite Aid, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "5178, Walgreens, WINTER SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5178, Walmart, ROCKAWAY, NJ",
            disabled: false,
          },
          {
            name: "5179, Rite Aid, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "5179, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "518, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "518, Albertsons, CHILDRESS, TX",
            disabled: false,
          },
          {
            name: "518, CVS, WAREHAM, MA",
            disabled: false,
          },
          {
            name: "518, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "518, Kroger, Glenview, IL",
            disabled: false,
          },
          {
            name: "518, Kroger, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "518, Kroger, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "518, Kroger, STANTON, CA",
            disabled: false,
          },
          {
            name: "518, Walmart, CANTON, GA",
            disabled: false,
          },
          {
            name: "5180, CVS, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5180, Rite Aid, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "5180, Walmart, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "5181, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5181, Rite Aid, MILL CREEK, WA",
            disabled: false,
          },
          {
            name: "5181, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5182, CVS, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "5182, Walgreens, BANNING, CA",
            disabled: false,
          },
          {
            name: "5182, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "5183, CVS, PANAMA CITY, FL",
            disabled: false,
          },
          {
            name: "5183, Rite Aid, EDMONDS, WA",
            disabled: false,
          },
          {
            name: "5183, Walmart, JEFFERSONTOWN, KY",
            disabled: false,
          },
          {
            name: "5184, Rite Aid, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "5184, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "5184, Walmart, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "5185, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "5185, Rite Aid, ENUMCLAW, WA",
            disabled: false,
          },
          {
            name: "5185, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "5185, Walmart, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5186, CVS, APPLETON, WI",
            disabled: false,
          },
          {
            name: "5186, Rite Aid, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "5186, Walmart, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "5187, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5187, Rite Aid, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "5188, Rite Aid, SAMMAMISH, WA",
            disabled: false,
          },
          {
            name: "5188, Walgreens, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "5188, Walmart, HIXSON, TN",
            disabled: false,
          },
          {
            name: "5189, CVS, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "5189, Rite Aid, KENT, WA",
            disabled: false,
          },
          {
            name: "5189, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "519, Albertsons, RENTON, WA",
            disabled: false,
          },
          {
            name: "519, Kroger, AURORA, IL",
            disabled: false,
          },
          {
            name: "519, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "519, Kroger, HENRICO, VA",
            disabled: false,
          },
          {
            name: "519, Kroger, Hendersonville, TN",
            disabled: false,
          },
          {
            name: "519, Walmart, HARRODSBURG, KY",
            disabled: false,
          },
          {
            name: "5190, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5190, Rite Aid, KENT, WA",
            disabled: false,
          },
          {
            name: "5190, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5190, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5191, CVS, SHIRLEY, NY",
            disabled: false,
          },
          {
            name: "5191, Walmart, FORNEY, TX",
            disabled: false,
          },
          {
            name: "5192, CVS, LARGO, FL",
            disabled: false,
          },
          {
            name: "5192, Rite Aid, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "5192, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5192, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5193, CVS, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "5193, Walgreens, POSEN, IL",
            disabled: false,
          },
          {
            name: "5193, Walmart, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "5194, CVS, FORT WALTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5194, Rite Aid, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "5194, Walgreens, LOWELL, IN",
            disabled: false,
          },
          {
            name: "5195, CVS, SANFORD, FL",
            disabled: false,
          },
          {
            name: "5195, Walgreens, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "5195, Walmart, EVERETT, WA",
            disabled: false,
          },
          {
            name: "5196, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5196, Walgreens, FAIRFIELD, OH",
            disabled: false,
          },
          {
            name: "5196, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5197, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5197, Rite Aid, MERCER ISLAND, WA",
            disabled: false,
          },
          {
            name: "5197, Walmart, OWENS CROSS ROADS, AL",
            disabled: false,
          },
          {
            name: "5198, CVS, SOUTH MIAMI, FL",
            disabled: false,
          },
          {
            name: "5198, Rite Aid, COVINGTON, WA",
            disabled: false,
          },
          {
            name: "5198, Walgreens, MIAMI BEACH, FL",
            disabled: false,
          },
          {
            name: "5198, Walmart, TIFTON, GA",
            disabled: false,
          },
          {
            name: "5199, Rite Aid, REDMOND, WA",
            disabled: false,
          },
          {
            name: "5199, Walmart, ANTIOCH, IL",
            disabled: false,
          },
          {
            name: "52, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "52, Albertsons, FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "52, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "52, HEB, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "52, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "52, Kroger, Austin, TX",
            disabled: false,
          },
          {
            name: "52, Kroger, Denison, TX",
            disabled: false,
          },
          {
            name: "52, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "52, Kroger, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "52, Kroger, Shoals, IN",
            disabled: false,
          },
          {
            name: "52, Meijer, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "52, Target, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "52, Walmart, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "520, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "520, Kroger, Antioch, TN",
            disabled: false,
          },
          {
            name: "520, Kroger, CHESTER, VA",
            disabled: false,
          },
          {
            name: "520, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "520, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "520, Kroger, Hanford, CA",
            disabled: false,
          },
          {
            name: "520, Kroger, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "520, Walmart, WINDER, GA",
            disabled: false,
          },
          {
            name: "5200, Walgreens, NEPTUNE, NJ",
            disabled: false,
          },
          {
            name: "5200, Walmart, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "5201, CVS, PLANT CITY, FL",
            disabled: false,
          },
          {
            name: "5201, Rite Aid, RENTON, WA",
            disabled: false,
          },
          {
            name: "5201, Walgreens, WEST LONG BRANCH, NJ",
            disabled: false,
          },
          {
            name: "5201, Walmart, EDISON, NJ",
            disabled: false,
          },
          {
            name: "5202, Walmart, COMMACK, NY",
            disabled: false,
          },
          {
            name: "5203, Rite Aid, RENTON, WA",
            disabled: false,
          },
          {
            name: "5203, Walgreens, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "5203, Walmart, LONDON, OH",
            disabled: false,
          },
          {
            name: "5204, CVS, PANAMA CITY, FL",
            disabled: false,
          },
          {
            name: "5204, Rite Aid, MILL CREEK, WA",
            disabled: false,
          },
          {
            name: "5204, Walmart, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "5205, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5205, Rite Aid, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "5205, Walgreens, MASON, OH",
            disabled: false,
          },
          {
            name: "5205, Walmart, LAYTON, UT",
            disabled: false,
          },
          {
            name: "5206, CVS, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "5206, Walgreens, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "5206, Walmart, SOUTH OGDEN, UT",
            disabled: false,
          },
          {
            name: "5207, Walgreens, CHICO, CA",
            disabled: false,
          },
          {
            name: "5207, Walmart, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "5208, Walgreens, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "5209, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "521, ADUSA, CHERRYVILLE, NC",
            disabled: false,
          },
          {
            name: "521, ADUSA, PEEKSKILL, NY",
            disabled: false,
          },
          {
            name: "521, Albertsons, DAMASCUS, OR",
            disabled: false,
          },
          {
            name: "521, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "521, Kroger, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "521, Kroger, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "521, Kroger, Murfreesboro, TN",
            disabled: false,
          },
          {
            name: "521, Walmart, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "5210, Walgreens, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "5210, Walmart, WYLIE, TX",
            disabled: false,
          },
          {
            name: "5211, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "5211, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5211, Walmart, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "5212, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5213, CVS, BROOKFIELD, IL",
            disabled: false,
          },
          {
            name: "5213, Walgreens, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "5214, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5214, Walgreens, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "5214, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5215, Rite Aid, BAINBRIDGE ISLAND, WA",
            disabled: false,
          },
          {
            name: "5215, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "5215, Walmart, DELANO, CA",
            disabled: false,
          },
          {
            name: "5216, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5216, Rite Aid, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "5216, Walgreens, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "5216, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "5217, Rite Aid, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "5217, Walgreens, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "5218, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5218, Walmart, ST PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "5219, Walmart, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "522, ADUSA, YONKERS, NY",
            disabled: false,
          },
          {
            name: "522, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "522, CVS, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "522, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "522, Kroger, GAHANNA, OH",
            disabled: false,
          },
          {
            name: "522, Kroger, HOPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "522, Kroger, PLANO, TX",
            disabled: false,
          },
          {
            name: "522, Walmart, CROSBY, TX",
            disabled: false,
          },
          {
            name: "5220, Rite Aid, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "5220, Walgreens, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "5220, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5221, Walgreens, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "5221, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5222, CVS, ALACHUA, FL",
            disabled: false,
          },
          {
            name: "5222, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "5223, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "5223, Rite Aid, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "5223, Walgreens, LANSING, MI",
            disabled: false,
          },
          {
            name: "5224, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5225, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5226, CVS, SUMMERFIELD, FL",
            disabled: false,
          },
          {
            name: "5226, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5227, CVS, JONESVILLE, FL",
            disabled: false,
          },
          {
            name: "5227, Rite Aid, BURIEN, WA",
            disabled: false,
          },
          {
            name: "5227, Walgreens, NEW BALTIMORE, MI",
            disabled: false,
          },
          {
            name: "5227, Walmart, BURKE, VA",
            disabled: false,
          },
          {
            name: "5228, Rite Aid, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "5228, Walmart, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "5229, CVS, UNIVERSITY PARK, FL",
            disabled: false,
          },
          {
            name: "5229, Walmart, WYNCOTE, PA",
            disabled: false,
          },
          {
            name: "523, ADUSA, MONROE, NY",
            disabled: false,
          },
          {
            name: "523, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "523, CVS, SANFORD, ME",
            disabled: false,
          },
          {
            name: "523, Kroger, DICKSON, TN",
            disabled: false,
          },
          {
            name: "523, Kroger, GURNEE, IL",
            disabled: false,
          },
          {
            name: "523, Kroger, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "523, Rite Aid, CAMDEN, NJ",
            disabled: false,
          },
          {
            name: "523, ShopRite, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "523, Walmart, CARTHAGE, TX",
            disabled: false,
          },
          {
            name: "5230, CVS, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "5230, Rite Aid, EVERETT, WA",
            disabled: false,
          },
          {
            name: "5230, Walgreens, WESTWEGO, LA",
            disabled: false,
          },
          {
            name: "5231, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "5231, Rite Aid, EVERETT, WA",
            disabled: false,
          },
          {
            name: "5231, Walmart, GALT, CA",
            disabled: false,
          },
          {
            name: "5232, Rite Aid, LAKE STEVENS, WA",
            disabled: false,
          },
          {
            name: "5232, Walmart, RIFLE, CO",
            disabled: false,
          },
          {
            name: "5233, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "5233, Walmart, WEST VALLEY CITY, UT",
            disabled: false,
          },
          {
            name: "5234, Rite Aid, ANACORTES, WA",
            disabled: false,
          },
          {
            name: "5234, Walmart, CLINTON, UT",
            disabled: false,
          },
          {
            name: "5235, Rite Aid, ARLINGTON, WA",
            disabled: false,
          },
          {
            name: "5235, Walgreens, OAK PARK, IL",
            disabled: false,
          },
          {
            name: "5235, Walmart, SANDY, UT",
            disabled: false,
          },
          {
            name: "5236, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "5236, Walmart, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "5237, Rite Aid, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "5237, Walgreens, ROGERS, AR",
            disabled: false,
          },
          {
            name: "5238, CVS, JUPITER, FL",
            disabled: false,
          },
          {
            name: "5238, Rite Aid, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "5239, CVS, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "5239, Rite Aid, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "5239, Walgreens, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "5239, Walmart, BECHTELSVILLE, PA",
            disabled: false,
          },
          {
            name: "524, ADUSA, WASHINGTONVILLE, NY",
            disabled: false,
          },
          {
            name: "524, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "524, Albertsons, CHINO, CA",
            disabled: false,
          },
          {
            name: "524, Kroger, CHESTER, VA",
            disabled: false,
          },
          {
            name: "524, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "524, Kroger, Northfield, IL",
            disabled: false,
          },
          {
            name: "524, Walmart, KENEDY, TX",
            disabled: false,
          },
          {
            name: "5240, Rite Aid, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "5240, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5240, Walmart, ITHACA, NY",
            disabled: false,
          },
          {
            name: "5241, CVS, CHALFONT, PA",
            disabled: false,
          },
          {
            name: "5241, Rite Aid, BLAINE, WA",
            disabled: false,
          },
          {
            name: "5241, Walgreens, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "5241, Walmart, NORTH HUNTINGDON, PA",
            disabled: false,
          },
          {
            name: "5242, Rite Aid, LYNDEN, WA",
            disabled: false,
          },
          {
            name: "5242, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "5242, Walmart, CICERO, NY",
            disabled: false,
          },
          {
            name: "5243, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5243, Rite Aid, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "5243, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "5244, Rite Aid, MONROE, WA",
            disabled: false,
          },
          {
            name: "5244, Walmart, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "5245, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5245, Walgreens, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "5245, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5246, CVS, PORT SAINT JOE, FL",
            disabled: false,
          },
          {
            name: "5246, Rite Aid, MUKILTEO, WA",
            disabled: false,
          },
          {
            name: "5246, Walgreens, APOPKA, FL",
            disabled: false,
          },
          {
            name: "5246, Walmart, WHARTON, TX",
            disabled: false,
          },
          {
            name: "5247, CVS, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5247, Rite Aid, OAK HARBOR, WA",
            disabled: false,
          },
          {
            name: "5247, Walgreens, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "5247, Walmart, ROANOKE, TX",
            disabled: false,
          },
          {
            name: "5248, CVS, NAVARRE, FL",
            disabled: false,
          },
          {
            name: "5248, Walgreens, PLAINFIELD, NJ",
            disabled: false,
          },
          {
            name: "5248, Walmart, NORTHPORT, AL",
            disabled: false,
          },
          {
            name: "5249, CVS, PACE, FL",
            disabled: false,
          },
          {
            name: "5249, Rite Aid, SNOHOMISH, WA",
            disabled: false,
          },
          {
            name: "525, Albertsons, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "525, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "525, Kroger, MAUMEE, OH",
            disabled: false,
          },
          {
            name: "525, Kroger, PARK RIDGE, IL",
            disabled: false,
          },
          {
            name: "525, Kroger, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "525, Walmart, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "5250, CVS, OAKLAND PARK, FL",
            disabled: false,
          },
          {
            name: "5250, Rite Aid, STANWOOD, WA",
            disabled: false,
          },
          {
            name: "5250, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5250, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5251, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5251, Walmart, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "5252, Walmart, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "5253, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5253, Walmart, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "5254, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5254, Rite Aid, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "5254, Walgreens, NORTH PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5254, Walmart, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "5255, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5255, Rite Aid, GIG HARBOR, WA",
            disabled: false,
          },
          {
            name: "5255, Walgreens, STUART, FL",
            disabled: false,
          },
          {
            name: "5255, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5256, Rite Aid, MILTON, WA",
            disabled: false,
          },
          {
            name: "5256, Walgreens, LINCOLNSHIRE, IL",
            disabled: false,
          },
          {
            name: "5256, Walmart, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "5257, CVS, OLATHE, KS",
            disabled: false,
          },
          {
            name: "5257, Rite Aid, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "5257, Walgreens, LIBERTYVILLE, IL",
            disabled: false,
          },
          {
            name: "5257, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "5258, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5258, Rite Aid, PORT ANGELES, WA",
            disabled: false,
          },
          {
            name: "5258, Walgreens, LIBERTYVILLE, IL",
            disabled: false,
          },
          {
            name: "5258, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5259, CVS, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "5259, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "526, ADUSA, EAST NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "526, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "526, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "526, Kroger, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "526, Kroger, MILFORD, MI",
            disabled: false,
          },
          {
            name: "526, Kroger, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "526, Kroger, Shorewood, IL",
            disabled: false,
          },
          {
            name: "526, ShopRite, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "526, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5260, Rite Aid, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "5260, Walgreens, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "5260, Walmart, ROGERS, AR",
            disabled: false,
          },
          {
            name: "5261, CVS, PRAIRIE VILLAGE, KS",
            disabled: false,
          },
          {
            name: "5261, Rite Aid, POULSBO, WA",
            disabled: false,
          },
          {
            name: "5261, Walgreens, PARKER, CO",
            disabled: false,
          },
          {
            name: "5261, Walmart, PINEVILLE, MO",
            disabled: false,
          },
          {
            name: "5262, Rite Aid, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "5262, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5262, Walmart, PELHAM, AL",
            disabled: false,
          },
          {
            name: "5263, CVS, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "5263, Walgreens, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "5263, Walmart, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "5264, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5264, Rite Aid, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "5264, Walmart, OSPREY, FL",
            disabled: false,
          },
          {
            name: "5265, CVS, LENEXA, KS",
            disabled: false,
          },
          {
            name: "5265, Rite Aid, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "5265, Walmart, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "5266, Rite Aid, SILVERDALE, WA",
            disabled: false,
          },
          {
            name: "5266, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "5266, Walmart, HUDSON, FL",
            disabled: false,
          },
          {
            name: "5267, CVS, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "5267, Rite Aid, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "5267, Walmart, ATHENS, GA",
            disabled: false,
          },
          {
            name: "5268, CVS, LEAVENWORTH, KS",
            disabled: false,
          },
          {
            name: "5269, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5269, Rite Aid, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5269, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "5269, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "527, ADUSA, AHOSKIE, NC",
            disabled: false,
          },
          {
            name: "527, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "527, Albertsons, IRVINE, CA",
            disabled: false,
          },
          {
            name: "527, Kroger, Bellevue, TN",
            disabled: false,
          },
          {
            name: "527, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "527, Kroger, DUNCANVILLE, TX",
            disabled: false,
          },
          {
            name: "527, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "527, Walmart, ANGLETON, TX",
            disabled: false,
          },
          {
            name: "5270, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5270, Walmart, LINDON, UT",
            disabled: false,
          },
          {
            name: "5271, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "5271, Rite Aid, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5272, CVS, MISSION, KS",
            disabled: false,
          },
          {
            name: "5272, Walmart, POULSBO, WA",
            disabled: false,
          },
          {
            name: "5273, CVS, BELLAIRE, TX",
            disabled: false,
          },
          {
            name: "5273, Walmart, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "5274, CVS, OLATHE, KS",
            disabled: false,
          },
          {
            name: "5274, Rite Aid, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5274, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5274, Walmart, PEARL CITY, HI",
            disabled: false,
          },
          {
            name: "5275, CVS, ABBEVILLE, LA",
            disabled: false,
          },
          {
            name: "5275, Rite Aid, UNIVERSITY PLACE, WA",
            disabled: false,
          },
          {
            name: "5275, Walgreens, WESTMONT, IL",
            disabled: false,
          },
          {
            name: "5275, Walmart, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "5276, CVS, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "5276, Rite Aid, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5276, Walmart, PALATINE, IL",
            disabled: false,
          },
          {
            name: "5277, CVS, BOGALUSA, LA",
            disabled: false,
          },
          {
            name: "5277, Rite Aid, LAKEWOOD, WA",
            disabled: false,
          },
          {
            name: "5277, Walgreens, BELTON, MO",
            disabled: false,
          },
          {
            name: "5278, CVS, DONALDSONVILLE, LA",
            disabled: false,
          },
          {
            name: "5278, Rite Aid, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "5278, Walgreens, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5278, Walmart, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "5279, Rite Aid, LACEY, WA",
            disabled: false,
          },
          {
            name: "5279, Walmart, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "528, ADUSA, NEWBURGH, NY",
            disabled: false,
          },
          {
            name: "528, ADUSA, SOUTHERN PINES, NC",
            disabled: false,
          },
          {
            name: "528, Albertsons, PAMPA, TX",
            disabled: false,
          },
          {
            name: "528, CVS, JOHNS ISLAND, SC",
            disabled: false,
          },
          {
            name: "528, Kroger, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "528, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "528, Kroger, Franklin, TN",
            disabled: false,
          },
          {
            name: "528, Kroger, Westchester, IL",
            disabled: false,
          },
          {
            name: "528, Walmart, BRADEN RIVER, FL",
            disabled: false,
          },
          {
            name: "5280, CVS, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "5280, Rite Aid, LACEY, WA",
            disabled: false,
          },
          {
            name: "5280, Walgreens, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "5280, Walmart, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "5281, Rite Aid, LACEY, WA",
            disabled: false,
          },
          {
            name: "5281, Walgreens, DELAFIELD, WI",
            disabled: false,
          },
          {
            name: "5281, Walmart, WOODBRIDGE, NJ",
            disabled: false,
          },
          {
            name: "5282, CVS, KAPLAN, LA",
            disabled: false,
          },
          {
            name: "5282, Rite Aid, ABERDEEN, WA",
            disabled: false,
          },
          {
            name: "5282, Walgreens, NILES, IL",
            disabled: false,
          },
          {
            name: "5282, Walmart, GREECE, NY",
            disabled: false,
          },
          {
            name: "5283, Rite Aid, HOQUIAM, WA",
            disabled: false,
          },
          {
            name: "5284, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5284, Rite Aid, CENTRALIA, WA",
            disabled: false,
          },
          {
            name: "5284, Walgreens, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "5285, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5285, Rite Aid, CHEHALIS, WA",
            disabled: false,
          },
          {
            name: "5285, Walmart, CANTON, OH",
            disabled: false,
          },
          {
            name: "5286, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "5286, Rite Aid, YELM, WA",
            disabled: false,
          },
          {
            name: "5286, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "5286, Walmart, THE VILLAGE, OK",
            disabled: false,
          },
          {
            name: "5287, Rite Aid, KELSO, WA",
            disabled: false,
          },
          {
            name: "5287, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "5287, Walmart, SPRING, TX",
            disabled: false,
          },
          {
            name: "5288, Rite Aid, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "5288, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "5288, Walmart, SEAGOVILLE, TX",
            disabled: false,
          },
          {
            name: "5289, CVS, MORGAN CITY, LA",
            disabled: false,
          },
          {
            name: "5289, Walgreens, NIXA, MO",
            disabled: false,
          },
          {
            name: "529, ADUSA, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "529, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "529, Albertsons, RANDOLPH, VT",
            disabled: false,
          },
          {
            name: "529, CVS, JOHNS ISLAND, SC",
            disabled: false,
          },
          {
            name: "529, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "529, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "529, Kroger, NELSONVILLE, OH",
            disabled: false,
          },
          {
            name: "529, Kroger, WESTERN SPRINGS, IL",
            disabled: false,
          },
          {
            name: "529, Walmart, LA MARQUE, TX",
            disabled: false,
          },
          {
            name: "5290, Walgreens, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "5290, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5291, Rite Aid, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "5291, Walgreens, UTICA, MI",
            disabled: false,
          },
          {
            name: "5291, Walmart, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "5292, CVS, OPELOUSAS, LA",
            disabled: false,
          },
          {
            name: "5292, Walmart, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "5293, CVS, PLAQUEMINE, LA",
            disabled: false,
          },
          {
            name: "5293, Rite Aid, MOSES LAKE, WA",
            disabled: false,
          },
          {
            name: "5293, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "5293, Walmart, VALLEY STREAM, NY",
            disabled: false,
          },
          {
            name: "5294, CVS, PONCHATOULA, LA",
            disabled: false,
          },
          {
            name: "5294, Walmart, MILFORD, CT",
            disabled: false,
          },
          {
            name: "5295, Rite Aid, OMAK, WA",
            disabled: false,
          },
          {
            name: "5295, Walgreens, RENO, NV",
            disabled: false,
          },
          {
            name: "5295, Walmart, FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "5296, Rite Aid, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "5296, Walmart, BARBOURSVILLE, WV",
            disabled: false,
          },
          {
            name: "5297, CVS, THIBODAUX, LA",
            disabled: false,
          },
          {
            name: "5297, Rite Aid, UNION GAP, WA",
            disabled: false,
          },
          {
            name: "5297, Walgreens, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "5297, Walmart, SAINT MATTHEWS, KY",
            disabled: false,
          },
          {
            name: "5298, Walmart, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "5299, CVS, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "5299, Walmart, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "53, ADUSA, BELLE VERNON, PA",
            disabled: false,
          },
          {
            name: "53, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "53, Albertsons, EAST NORRITON, PA",
            disabled: false,
          },
          {
            name: "53, BJ's, WAPPINGERS FALLS, NY",
            disabled: false,
          },
          {
            name: "53, Kroger, Brownstown, IN",
            disabled: false,
          },
          {
            name: "53, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "53, Kroger, COVINGTON, WA",
            disabled: false,
          },
          {
            name: "53, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "53, Kroger, Oklahoma City, OK",
            disabled: false,
          },
          {
            name: "53, Kroger, Salina, KS",
            disabled: false,
          },
          {
            name: "53, Kroger, TEMPLE CITY, CA",
            disabled: false,
          },
          {
            name: "53, Meijer, Waterford, MI",
            disabled: false,
          },
          {
            name: "530, ADUSA, DOBBS FERRY, NY",
            disabled: false,
          },
          {
            name: "530, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "530, Albertsons, MANCHESTER CENTER, VT",
            disabled: false,
          },
          {
            name: "530, CVS, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "530, Kroger, Evergreen Park, IL",
            disabled: false,
          },
          {
            name: "530, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "530, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "530, Kroger, Wayne, MI",
            disabled: false,
          },
          {
            name: "530, Target, OMAHA, NE",
            disabled: false,
          },
          {
            name: "530, Walmart, EL DORADO, AR",
            disabled: false,
          },
          {
            name: "5300, CVS, PARAMUS, NJ",
            disabled: false,
          },
          {
            name: "5300, Rite Aid, SUNNYSIDE, WA",
            disabled: false,
          },
          {
            name: "5300, Walgreens, HIGHLAND, CA",
            disabled: false,
          },
          {
            name: "5300, Walmart, GIBSONTON, FL",
            disabled: false,
          },
          {
            name: "5301, CVS, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "5301, Rite Aid, PULLMAN, WA",
            disabled: false,
          },
          {
            name: "5301, Walgreens, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "5301, Walmart, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5302, CVS, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "5303, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5303, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5303, Walmart, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "5304, CVS, RACELAND, LA",
            disabled: false,
          },
          {
            name: "5304, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5304, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "5305, CVS, LAUREL, MT",
            disabled: false,
          },
          {
            name: "5305, Rite Aid, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "5305, Walmart, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "5306, CVS, MARKSVILLE, LA",
            disabled: false,
          },
          {
            name: "5306, Walgreens, COUNCIL BLUFFS, IA",
            disabled: false,
          },
          {
            name: "5306, Walmart, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5307, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5307, Walgreens, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "5307, Walmart, GARDNER, KS",
            disabled: false,
          },
          {
            name: "5308, CVS, LAKEVILLE, MN",
            disabled: false,
          },
          {
            name: "5308, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5308, Walmart, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "5309, Walgreens, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "5309, Walmart, OBERLIN, OH",
            disabled: false,
          },
          {
            name: "531, Albertsons, AUBURN, WA",
            disabled: false,
          },
          {
            name: "531, CVS, SOMERS, NY",
            disabled: false,
          },
          {
            name: "531, Kroger, BARTONVILLE, IL",
            disabled: false,
          },
          {
            name: "531, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "531, Kroger, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "531, Kroger, WATERVILLE, OH",
            disabled: false,
          },
          {
            name: "531, ShopRite, WEST BERLIN, NJ",
            disabled: false,
          },
          {
            name: "531, Target, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "531, Walmart, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5310, Walmart, PRAIRIEVILLE, LA",
            disabled: false,
          },
          {
            name: "5311, CVS, DELANO, MN",
            disabled: false,
          },
          {
            name: "5311, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5311, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5311, Walmart, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "5312, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5312, Walgreens, GREEN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "5312, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5313, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "5313, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5313, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5313, Walmart, LAKE SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "5314, Rite Aid, PASCO, WA",
            disabled: false,
          },
          {
            name: "5314, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5314, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "5315, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "5315, Walgreens, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "5316, CVS, MERIDIANVILLE, AL",
            disabled: false,
          },
          {
            name: "5316, Rite Aid, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "5316, Walgreens, ROCHESTER, IN",
            disabled: false,
          },
          {
            name: "5316, Walmart, SAGINAW, TX",
            disabled: false,
          },
          {
            name: "5317, Rite Aid, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "5317, Walmart, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "5318, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5318, Rite Aid, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "5319, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5319, Rite Aid, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "5319, Walgreens, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "5319, Walmart, MACARTHUR, WV",
            disabled: false,
          },
          {
            name: "532, ADUSA, EASTCHESTER, NY",
            disabled: false,
          },
          {
            name: "532, Albertsons, CANYON, TX",
            disabled: false,
          },
          {
            name: "532, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "532, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "532, Kroger, Northbrook, IL",
            disabled: false,
          },
          {
            name: "532, Kroger, PICKERINGTON, OH",
            disabled: false,
          },
          {
            name: "532, Kroger, Sacramento, CA",
            disabled: false,
          },
          {
            name: "532, Kroger, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "532, Target, PAPILLION, NE",
            disabled: false,
          },
          {
            name: "532, Walmart, GONZALES, LA",
            disabled: false,
          },
          {
            name: "5320, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5320, Rite Aid, WALLA WALLA, WA",
            disabled: false,
          },
          {
            name: "5320, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "5321, CVS, BAKER, LA",
            disabled: false,
          },
          {
            name: "5321, Walgreens, MONROE, MI",
            disabled: false,
          },
          {
            name: "5321, Walmart, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "5322, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5322, Rite Aid, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "5322, Walgreens, WARREN, MI",
            disabled: false,
          },
          {
            name: "5323, CVS, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "5323, Rite Aid, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "5323, Walgreens, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "5323, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "5324, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5324, Walgreens, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "5325, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5325, Rite Aid, CANBY, OR",
            disabled: false,
          },
          {
            name: "5325, Walgreens, CHASKA, MN",
            disabled: false,
          },
          {
            name: "5325, Walmart, MARGATE, FL",
            disabled: false,
          },
          {
            name: "5326, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5326, Rite Aid, CLACKAMAS, OR",
            disabled: false,
          },
          {
            name: "5326, Walgreens, LARGO, FL",
            disabled: false,
          },
          {
            name: "5326, Walmart, OCALA, FL",
            disabled: false,
          },
          {
            name: "5327, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5327, Rite Aid, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "5327, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5327, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5328, CVS, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "5328, Rite Aid, HOOD RIVER, OR",
            disabled: false,
          },
          {
            name: "5328, Walgreens, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "5328, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5329, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5329, Rite Aid, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "5329, Walmart, ANTHEM, AZ",
            disabled: false,
          },
          {
            name: "533, Albertsons, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "533, Albertsons, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "533, CVS, WEST SENECA, NY",
            disabled: false,
          },
          {
            name: "533, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "533, Kroger, NORTHBROOK, IL",
            disabled: false,
          },
          {
            name: "533, Kroger, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "533, Kroger, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "533, Target, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "533, Walmart, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "5330, CVS, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "5330, Walgreens, MARCO ISLAND, FL",
            disabled: false,
          },
          {
            name: "5330, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5331, Rite Aid, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "5331, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5331, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5332, Rite Aid, OREGON CITY, OR",
            disabled: false,
          },
          {
            name: "5332, Walgreens, PASSAIC, NJ",
            disabled: false,
          },
          {
            name: "5332, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "5333, CVS, KENNER, LA",
            disabled: false,
          },
          {
            name: "5333, Walgreens, UNION CITY, NJ",
            disabled: false,
          },
          {
            name: "5334, Rite Aid, THE DALLES, OR",
            disabled: false,
          },
          {
            name: "5334, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "5335, Rite Aid, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "5335, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "5335, Walmart, BRAWLEY, CA",
            disabled: false,
          },
          {
            name: "5336, Walgreens, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "5336, Walmart, JENKS, OK",
            disabled: false,
          },
          {
            name: "5337, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "5337, Walmart, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "5338, CVS, HOUMA, LA",
            disabled: false,
          },
          {
            name: "5338, Rite Aid, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "5338, Walgreens, CRYSTAL RIVER, FL",
            disabled: false,
          },
          {
            name: "5338, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5339, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "5339, Rite Aid, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "5339, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "534, ADUSA, BALLENTINE, SC",
            disabled: false,
          },
          {
            name: "534, Albertsons, ARLINGTON, WA",
            disabled: false,
          },
          {
            name: "534, Kroger, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "534, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "534, Kroger, LEWISBURG, TN",
            disabled: false,
          },
          {
            name: "534, Kroger, Oakland, CA",
            disabled: false,
          },
          {
            name: "534, Kroger, Yorktown, VA",
            disabled: false,
          },
          {
            name: "5340, CVS, RIVER RIDGE, LA",
            disabled: false,
          },
          {
            name: "5340, Rite Aid, MCMINNVILLE, OR",
            disabled: false,
          },
          {
            name: "5340, Walmart, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "5341, CVS, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "5341, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "5341, Walmart, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "5342, Walmart, YUMA, AZ",
            disabled: false,
          },
          {
            name: "5343, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5343, Rite Aid, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "5343, Walgreens, WEST NEW YORK, NJ",
            disabled: false,
          },
          {
            name: "5343, Walmart, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "5344, CVS, MONROE, LA",
            disabled: false,
          },
          {
            name: "5344, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5344, Walmart, TOWSON, MD",
            disabled: false,
          },
          {
            name: "5345, CVS, MINDEN, LA",
            disabled: false,
          },
          {
            name: "5345, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5345, Walmart, DUNKIRK, MD",
            disabled: false,
          },
          {
            name: "5346, CVS, BALA CYNWYD, PA",
            disabled: false,
          },
          {
            name: "5346, Walmart, MEBANE, NC",
            disabled: false,
          },
          {
            name: "5347, CVS, CLAREMONT, NH",
            disabled: false,
          },
          {
            name: "5347, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5347, Walgreens, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "5347, Walmart, ESTERO, FL",
            disabled: false,
          },
          {
            name: "5348, CVS, GREENWICH, NY",
            disabled: false,
          },
          {
            name: "5348, Walgreens, YUCAIPA, CA",
            disabled: false,
          },
          {
            name: "5348, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "5349, CVS, KENNER, LA",
            disabled: false,
          },
          {
            name: "5349, Walgreens, HEMET, CA",
            disabled: false,
          },
          {
            name: "5349, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "535, Albertsons, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "535, Kroger, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "535, Kroger, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "535, Kroger, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "535, Walmart, ABILENE, TX",
            disabled: false,
          },
          {
            name: "5350, CVS, RYE BROOK, NY",
            disabled: false,
          },
          {
            name: "5350, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5350, Walgreens, ROSWELL, NM",
            disabled: false,
          },
          {
            name: "5350, Walmart, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "5351, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "5351, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5352, CVS, DULUTH, GA",
            disabled: false,
          },
          {
            name: "5352, Rite Aid, MILWAUKIE, OR",
            disabled: false,
          },
          {
            name: "5352, Walmart, BATAVIA, IL",
            disabled: false,
          },
          {
            name: "5353, CVS, DUBLIN, GA",
            disabled: false,
          },
          {
            name: "5353, Rite Aid, TIGARD, OR",
            disabled: false,
          },
          {
            name: "5353, Walgreens, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "5353, Walmart, SPRING, TX",
            disabled: false,
          },
          {
            name: "5354, CVS, GONZALES, LA",
            disabled: false,
          },
          {
            name: "5354, Rite Aid, TIGARD, OR",
            disabled: false,
          },
          {
            name: "5355, CVS, CUMMING, GA",
            disabled: false,
          },
          {
            name: "5355, Rite Aid, TIGARD, OR",
            disabled: false,
          },
          {
            name: "5355, Walgreens, CHICAGO HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "5355, Walmart, KENTON, OH",
            disabled: false,
          },
          {
            name: "5356, CVS, CEDARTOWN, GA",
            disabled: false,
          },
          {
            name: "5356, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5356, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5356, Walmart, BLAIRSVILLE, PA",
            disabled: false,
          },
          {
            name: "5357, CVS, HOPEWELL JUNCTION, NY",
            disabled: false,
          },
          {
            name: "5357, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5357, Walgreens, RAYTOWN, MO",
            disabled: false,
          },
          {
            name: "5358, CVS, SCHENECTADY, NY",
            disabled: false,
          },
          {
            name: "5358, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5358, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5358, Walmart, SHIPPENSBURG, PA",
            disabled: false,
          },
          {
            name: "5359, CVS, RED HOOK, NY",
            disabled: false,
          },
          {
            name: "5359, Rite Aid, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5359, Walmart, AZLE, TX",
            disabled: false,
          },
          {
            name: "536, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "536, Albertsons, BROWNFIELD, TX",
            disabled: false,
          },
          {
            name: "536, Albertsons, TROUTDALE, OR",
            disabled: false,
          },
          {
            name: "536, CVS, PALM SPRINGS, FL",
            disabled: false,
          },
          {
            name: "536, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "536, Kroger, FREMONT, OH",
            disabled: false,
          },
          {
            name: "536, Kroger, Norfolk, VA",
            disabled: false,
          },
          {
            name: "536, Kroger, PIGEON FORGE, TN",
            disabled: false,
          },
          {
            name: "536, Kroger, Westmont, IL",
            disabled: false,
          },
          {
            name: "536, Walmart, ABILENE, TX",
            disabled: false,
          },
          {
            name: "5360, CVS, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5360, Rite Aid, SALEM, OR",
            disabled: false,
          },
          {
            name: "5360, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5360, Walmart, TITUSVILLE, PA",
            disabled: false,
          },
          {
            name: "5361, Rite Aid, SALEM, OR",
            disabled: false,
          },
          {
            name: "5361, Walgreens, FORT DODGE, IA",
            disabled: false,
          },
          {
            name: "5361, Walmart, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5362, Rite Aid, SALEM, OR",
            disabled: false,
          },
          {
            name: "5362, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "5363, Walmart, HAMPTON, GA",
            disabled: false,
          },
          {
            name: "5364, Rite Aid, KEIZER, OR",
            disabled: false,
          },
          {
            name: "5364, Walgreens, MORTON GROVE, IL",
            disabled: false,
          },
          {
            name: "5364, Walmart, STILLWATER, OK",
            disabled: false,
          },
          {
            name: "5365, Rite Aid, ALBANY, OR",
            disabled: false,
          },
          {
            name: "5365, Walgreens, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "5365, Walmart, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "5366, CVS, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "5366, Rite Aid, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "5366, Walgreens, HANOVER PARK, IL",
            disabled: false,
          },
          {
            name: "5366, Walmart, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "5367, CVS, CEDARHURST, NY",
            disabled: false,
          },
          {
            name: "5367, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "5368, CVS, HEWLETT, NY",
            disabled: false,
          },
          {
            name: "5368, Rite Aid, DALLAS, OR",
            disabled: false,
          },
          {
            name: "5368, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "5368, Walmart, SALEM, OR",
            disabled: false,
          },
          {
            name: "5369, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5369, Rite Aid, LEBANON, OR",
            disabled: false,
          },
          {
            name: "5369, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "5369, Walmart, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "537, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "537, Albertsons, MONROE, WA",
            disabled: false,
          },
          {
            name: "537, Kroger, KELLER, TX",
            disabled: false,
          },
          {
            name: "537, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "537, Kroger, Naperville, IL",
            disabled: false,
          },
          {
            name: "537, Kroger, ROLLA, MO",
            disabled: false,
          },
          {
            name: "537, Kroger, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "537, Walmart, ODESSA, TX",
            disabled: false,
          },
          {
            name: "5370, Rite Aid, NEWPORT, OR",
            disabled: false,
          },
          {
            name: "5370, Walmart, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "5371, Rite Aid, LINCOLN CITY, OR",
            disabled: false,
          },
          {
            name: "5371, Walgreens, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "5371, Walmart, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "5372, CVS, PATCHOGUE, NY",
            disabled: false,
          },
          {
            name: "5372, Rite Aid, SILVERTON, OR",
            disabled: false,
          },
          {
            name: "5372, Walgreens, FONTANA, CA",
            disabled: false,
          },
          {
            name: "5372, Walmart, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "5373, Rite Aid, EUGENE, OR",
            disabled: false,
          },
          {
            name: "5373, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "5373, Walmart, CHIPPEWA FALLS, WI",
            disabled: false,
          },
          {
            name: "5374, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5374, Rite Aid, EUGENE, OR",
            disabled: false,
          },
          {
            name: "5374, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5374, Walmart, EATON, OH",
            disabled: false,
          },
          {
            name: "5375, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5375, Rite Aid, EUGENE, OR",
            disabled: false,
          },
          {
            name: "5375, Walgreens, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "5376, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "5376, Rite Aid, HARBOR, OR",
            disabled: false,
          },
          {
            name: "5376, Walgreens, WEATHERFORD, TX",
            disabled: false,
          },
          {
            name: "5376, Walmart, TAWAS CITY, MI",
            disabled: false,
          },
          {
            name: "5377, CVS, LIBERTY, NC",
            disabled: false,
          },
          {
            name: "5377, Walgreens, BURLESON, TX",
            disabled: false,
          },
          {
            name: "5378, Rite Aid, FLORENCE, OR",
            disabled: false,
          },
          {
            name: "5378, Walmart, CAYCE, SC",
            disabled: false,
          },
          {
            name: "5379, CVS, ADVANCE, NC",
            disabled: false,
          },
          {
            name: "5379, Walmart, CONNELLSVILLE, PA",
            disabled: false,
          },
          {
            name: "538, Albertsons, PORT TOWNSEND, WA",
            disabled: false,
          },
          {
            name: "538, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "538, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "538, Kroger, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "538, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "538, Kroger, PICKERINGTON, OH",
            disabled: false,
          },
          {
            name: "538, Kroger, Portsmouth, VA",
            disabled: false,
          },
          {
            name: "538, Walmart, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5380, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "5380, Rite Aid, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "5381, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5381, Walmart, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "5382, CVS, ALLSTON, MA",
            disabled: false,
          },
          {
            name: "5382, Rite Aid, ROSEBURG, OR",
            disabled: false,
          },
          {
            name: "5382, Walgreens, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "5382, Walmart, PASADENA, MD",
            disabled: false,
          },
          {
            name: "5383, Rite Aid, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "5383, Walmart, SUMTER, SC",
            disabled: false,
          },
          {
            name: "5384, CVS, SANFORD, NC",
            disabled: false,
          },
          {
            name: "5384, Rite Aid, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "5384, Walgreens, WESTERN SPRINGS, IL",
            disabled: false,
          },
          {
            name: "5384, Walmart, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "5385, CVS, SCOTIA, NY",
            disabled: false,
          },
          {
            name: "5385, Rite Aid, ASHLAND, OR",
            disabled: false,
          },
          {
            name: "5385, Walmart, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "5386, CVS, HOLLY HILL, SC",
            disabled: false,
          },
          {
            name: "5386, Rite Aid, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "5386, Walgreens, JOLIET, IL",
            disabled: false,
          },
          {
            name: "5386, Walmart, GRAND HAVEN, MI",
            disabled: false,
          },
          {
            name: "5387, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5387, Rite Aid, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "5387, Walmart, MIDDLEFIELD, OH",
            disabled: false,
          },
          {
            name: "5388, CVS, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "5388, Rite Aid, KLAMATH FALLS, OR",
            disabled: false,
          },
          {
            name: "5388, Walgreens, DECATUR, IL",
            disabled: false,
          },
          {
            name: "5388, Walmart, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "5389, CVS, MALTA, NY",
            disabled: false,
          },
          {
            name: "5389, Walgreens, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "5389, Walmart, WACO, TX",
            disabled: false,
          },
          {
            name: "539, Albertsons, BORGER, TX",
            disabled: false,
          },
          {
            name: "539, CVS, OLEAN, NY",
            disabled: false,
          },
          {
            name: "539, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "539, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "539, Kroger, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "539, Kroger, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "539, Walmart, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "5390, CVS, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "5390, Rite Aid, BEND, OR",
            disabled: false,
          },
          {
            name: "5390, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5390, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "5391, Rite Aid, BEND, OR",
            disabled: false,
          },
          {
            name: "5391, Walmart, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5392, Rite Aid, HINES, OR",
            disabled: false,
          },
          {
            name: "5392, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "5392, Walmart, BAXLEY, GA",
            disabled: false,
          },
          {
            name: "5393, Rite Aid, PRINEVILLE, OR",
            disabled: false,
          },
          {
            name: "5393, Walgreens, FRANKLIN, IN",
            disabled: false,
          },
          {
            name: "5393, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "5394, Rite Aid, REDMOND, OR",
            disabled: false,
          },
          {
            name: "5394, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "5394, Walmart, DINUBA, CA",
            disabled: false,
          },
          {
            name: "5395, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "5395, Rite Aid, PENDLETON, OR",
            disabled: false,
          },
          {
            name: "5395, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5396, CVS, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "5396, Rite Aid, BAKER CITY, OR",
            disabled: false,
          },
          {
            name: "5396, Walgreens, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "5396, Walmart, ALBANY, OR",
            disabled: false,
          },
          {
            name: "5397, Rite Aid, HERMISTON, OR",
            disabled: false,
          },
          {
            name: "5397, Walmart, WINONA, MN",
            disabled: false,
          },
          {
            name: "5398, Rite Aid, LA GRANDE, OR",
            disabled: false,
          },
          {
            name: "5398, Walgreens, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "5398, Walmart, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "5399, Walgreens, CASSELBERRY, FL",
            disabled: false,
          },
          {
            name: "5399, Walmart, DIXON, IL",
            disabled: false,
          },
          {
            name: "54, ADUSA, ABINGTON, MA",
            disabled: false,
          },
          {
            name: "54, ADUSA, SOMERSET, PA",
            disabled: false,
          },
          {
            name: "54, BJ's, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "54, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "54, Kroger, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "54, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "54, Kroger, San Antonio, TX",
            disabled: false,
          },
          {
            name: "54, Kroger, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "54, Meijer, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "54, Walmart, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "540, ADUSA, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "540, ADUSA, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "540, Albertsons, LAMESA, TX",
            disabled: false,
          },
          {
            name: "540, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "540, Kroger, Bloomingdale, IL",
            disabled: false,
          },
          {
            name: "540, Kroger, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "540, Kroger, PLANO, TX",
            disabled: false,
          },
          {
            name: "540, Kroger, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "540, Walmart, MORGAN CITY, LA",
            disabled: false,
          },
          {
            name: "5400, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5400, Rite Aid, ONTARIO, OR",
            disabled: false,
          },
          {
            name: "5401, CVS, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "5402, CVS, TAUNTON, MA",
            disabled: false,
          },
          {
            name: "5402, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5403, CVS, MANTECA, CA",
            disabled: false,
          },
          {
            name: "5403, Walmart, URBANA, IL",
            disabled: false,
          },
          {
            name: "5404, Walmart, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "5406, Walgreens, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "5407, CVS, LAKEVILLE, MA",
            disabled: false,
          },
          {
            name: "5407, Walgreens, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "5408, CVS, BARGERSVILLE, IN",
            disabled: false,
          },
          {
            name: "5408, Rite Aid, LEWISTON, ID",
            disabled: false,
          },
          {
            name: "5408, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5408, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5409, CVS, MARRERO, LA",
            disabled: false,
          },
          {
            name: "5409, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5409, Walmart, ENGLEWOOD, OH",
            disabled: false,
          },
          {
            name: "541, ADUSA, CARLE PLACE, NY",
            disabled: false,
          },
          {
            name: "541, CVS, ROCKVILLE CENTRE, NY",
            disabled: false,
          },
          {
            name: "541, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "541, Kroger, Des Plaines, IL",
            disabled: false,
          },
          {
            name: "541, Kroger, Goodlettsville, TN",
            disabled: false,
          },
          {
            name: "541, Walmart, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "5410, CVS, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "5410, Walmart, CANTON, OH",
            disabled: false,
          },
          {
            name: "5411, CVS, SANDY SPRINGS, GA",
            disabled: false,
          },
          {
            name: "5411, Walgreens, HANFORD, CA",
            disabled: false,
          },
          {
            name: "5411, Walmart, IONIA, MI",
            disabled: false,
          },
          {
            name: "5412, Rite Aid, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "5413, CVS, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "5413, Rite Aid, BOISE, ID",
            disabled: false,
          },
          {
            name: "5413, Walgreens, BLAINE, MN",
            disabled: false,
          },
          {
            name: "5414, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5414, Walmart, LANOKA HARBOR, NJ",
            disabled: false,
          },
          {
            name: "5415, Rite Aid, BOISE, ID",
            disabled: false,
          },
          {
            name: "5415, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5416, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "5417, CVS, ROME, GA",
            disabled: false,
          },
          {
            name: "5417, Rite Aid, BOISE, ID",
            disabled: false,
          },
          {
            name: "5417, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "5417, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5418, CVS, ROME, GA",
            disabled: false,
          },
          {
            name: "5418, Rite Aid, BOISE, ID",
            disabled: false,
          },
          {
            name: "5418, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5419, Rite Aid, BOISE, ID",
            disabled: false,
          },
          {
            name: "5419, Walmart, HERNANDO, MS",
            disabled: false,
          },
          {
            name: "542, ADUSA, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "542, ADUSA, SOUTH BOSTON, VA",
            disabled: false,
          },
          {
            name: "542, Albertsons, DUMAS, TX",
            disabled: false,
          },
          {
            name: "542, CVS, BAYSIDE, NY",
            disabled: false,
          },
          {
            name: "542, Kroger, Bannockburn, IL",
            disabled: false,
          },
          {
            name: "542, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "542, Kroger, LOGAN, OH",
            disabled: false,
          },
          {
            name: "542, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "542, Kroger, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "542, Walmart, HOUMA, LA",
            disabled: false,
          },
          {
            name: "5420, CVS, WINTERVILLE, NC",
            disabled: false,
          },
          {
            name: "5420, Rite Aid, COEUR D'ALENE, ID",
            disabled: false,
          },
          {
            name: "5420, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5421, CVS, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "5421, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "5421, Walmart, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "5422, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5422, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "5422, Walmart, BAINBRIDGE, GA",
            disabled: false,
          },
          {
            name: "5423, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5423, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5423, Walmart, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5424, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5424, Walmart, EAGLE POINT, OR",
            disabled: false,
          },
          {
            name: "5425, CVS, PATASKALA, OH",
            disabled: false,
          },
          {
            name: "5425, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5425, Walgreens, OAK PARK, MI",
            disabled: false,
          },
          {
            name: "5425, Walmart, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "5426, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "5426, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5426, Walgreens, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "5426, Walmart, FREMONT, CA",
            disabled: false,
          },
          {
            name: "5427, Walgreens, GERMANTOWN, WI",
            disabled: false,
          },
          {
            name: "5427, Walmart, ST. PETERS, MO",
            disabled: false,
          },
          {
            name: "5428, Walgreens, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "5428, Walmart, MESA, AZ",
            disabled: false,
          },
          {
            name: "5429, CVS, GEORGETOWN, OH",
            disabled: false,
          },
          {
            name: "5429, Walmart, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "543, ADUSA, WEST BABYLON, NY",
            disabled: false,
          },
          {
            name: "543, Albertsons, LACEY, WA",
            disabled: false,
          },
          {
            name: "543, HEB, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "543, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "543, Kroger, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "543, Kroger, Lombard, IL",
            disabled: false,
          },
          {
            name: "543, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "543, Kroger, Nokomis, IL",
            disabled: false,
          },
          {
            name: "543, Kroger, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "543, Walmart, OPELOUSAS, LA",
            disabled: false,
          },
          {
            name: "5430, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5430, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "5430, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5431, CVS, BETHEL, OH",
            disabled: false,
          },
          {
            name: "5431, Walgreens, BRUNSWICK, OH",
            disabled: false,
          },
          {
            name: "5432, CVS, CUT OFF, LA",
            disabled: false,
          },
          {
            name: "5432, Walgreens, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "5432, Walmart, NEW RICHMOND, WI",
            disabled: false,
          },
          {
            name: "5433, CVS, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "5433, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "5433, Walmart, HOT SPRINGS VILLAGE, AR",
            disabled: false,
          },
          {
            name: "5434, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5434, Walgreens, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "5434, Walmart, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "5435, CVS, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "5435, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5435, Walmart, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5436, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5436, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5436, Walmart, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "5437, CVS, FALMOUTH, KY",
            disabled: false,
          },
          {
            name: "5437, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5438, Walmart, NEW BERLIN, WI",
            disabled: false,
          },
          {
            name: "5439, CVS, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "5439, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5439, Walgreens, DEER PARK, NY",
            disabled: false,
          },
          {
            name: "5439, Walmart, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "544, ADUSA, MOUNT OLIVE, NC",
            disabled: false,
          },
          {
            name: "544, ADUSA, RONKONKOMA, NY",
            disabled: false,
          },
          {
            name: "544, Albertsons, BONNEY LAKE, WA",
            disabled: false,
          },
          {
            name: "544, HEB, BRYAN, TX",
            disabled: false,
          },
          {
            name: "544, Kroger, ALLEN, TX",
            disabled: false,
          },
          {
            name: "544, Kroger, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "544, Kroger, Crystal Lake, IL",
            disabled: false,
          },
          {
            name: "544, Walmart, DEL CITY, OK",
            disabled: false,
          },
          {
            name: "5440, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5440, Walmart, HAPPY VALLEY, OR",
            disabled: false,
          },
          {
            name: "5441, CVS, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "5441, Walmart, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "5442, CVS, DESTREHAN, LA",
            disabled: false,
          },
          {
            name: "5442, Walmart, ADDISON, IL",
            disabled: false,
          },
          {
            name: "5443, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5443, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "5443, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5444, CVS, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "5444, Walgreens, MATTOON, IL",
            disabled: false,
          },
          {
            name: "5444, Walmart, IRONWOOD, MI",
            disabled: false,
          },
          {
            name: "5445, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5445, Walgreens, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "5445, Walmart, ERIE, PA",
            disabled: false,
          },
          {
            name: "5446, CVS, EAST NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "5446, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "5446, Walmart, WAYNESBURG, PA",
            disabled: false,
          },
          {
            name: "5447, CVS, NEWTOWN, PA",
            disabled: false,
          },
          {
            name: "5447, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "5447, Walmart, KEARNY, NJ",
            disabled: false,
          },
          {
            name: "5448, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5448, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5448, Walmart, RAYNHAM, MA",
            disabled: false,
          },
          {
            name: "5449, CVS, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "5449, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5449, Walmart, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "545, ADUSA, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "545, ADUSA, FARMINGDALE, NY",
            disabled: false,
          },
          {
            name: "545, Albertsons, ABILENE, TX",
            disabled: false,
          },
          {
            name: "545, Kroger, DESOTO, TX",
            disabled: false,
          },
          {
            name: "545, Kroger, WHITE HOUSE, TN",
            disabled: false,
          },
          {
            name: "545, Walmart, MANCHESTER, KY",
            disabled: false,
          },
          {
            name: "5450, CVS, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "5450, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5450, Walmart, NORTH EAST, MD",
            disabled: false,
          },
          {
            name: "5451, CVS, FRANKLINTON, LA",
            disabled: false,
          },
          {
            name: "5451, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5451, Walmart, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "5452, CVS, MOUNT DORA, FL",
            disabled: false,
          },
          {
            name: "5452, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5452, Walmart, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "5453, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "5453, Walmart, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "5454, CVS, NEW ROCHELLE, NY",
            disabled: false,
          },
          {
            name: "5454, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5455, CVS, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "5455, Rite Aid, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5455, Walgreens, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "5455, Walmart, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "5456, CVS, BALLSTON SPA, NY",
            disabled: false,
          },
          {
            name: "5456, Walgreens, VISTA, CA",
            disabled: false,
          },
          {
            name: "5457, CVS, POWELL, OH",
            disabled: false,
          },
          {
            name: "5458, CVS, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "5458, Walmart, DELTA, CO",
            disabled: false,
          },
          {
            name: "5459, Rite Aid, BELL GARDENS, CA",
            disabled: false,
          },
          {
            name: "5459, Walgreens, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "5459, Walmart, STARKVILLE, MS",
            disabled: false,
          },
          {
            name: "546, ADUSA, PORT WASHINGTON, NY",
            disabled: false,
          },
          {
            name: "546, Kroger, FRISCO, TX",
            disabled: false,
          },
          {
            name: "546, Kroger, JOHNSTOWN, OH",
            disabled: false,
          },
          {
            name: "546, ShopRite, MULLICA HILL, NJ",
            disabled: false,
          },
          {
            name: "546, Walmart, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "5460, CVS, GERMANTOWN, MD",
            disabled: false,
          },
          {
            name: "5460, Walgreens, PONTIAC, IL",
            disabled: false,
          },
          {
            name: "5460, Walmart, PORTLAND, TX",
            disabled: false,
          },
          {
            name: "5461, CVS, MANALAPAN, NJ",
            disabled: false,
          },
          {
            name: "5461, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "5461, Walmart, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "5462, CVS, BROOMALL, PA",
            disabled: false,
          },
          {
            name: "5462, Walmart, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "5463, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5463, Rite Aid, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "5463, Walmart, HARTFORD, WI",
            disabled: false,
          },
          {
            name: "5464, Rite Aid, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "5464, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "5464, Walmart, THIBODAUX, LA",
            disabled: false,
          },
          {
            name: "5465, CVS, BURLESON, TX",
            disabled: false,
          },
          {
            name: "5465, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "5466, Walgreens, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "5466, Walmart, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "5467, CVS, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "5467, Walmart, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "5468, Walgreens, ADDISON, IL",
            disabled: false,
          },
          {
            name: "5469, CVS, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "5469, Walgreens, MCHENRY, IL",
            disabled: false,
          },
          {
            name: "5469, Walmart, HANOVER, PA",
            disabled: false,
          },
          {
            name: "547, ADUSA, SPENCER, NC",
            disabled: false,
          },
          {
            name: "547, Albertsons, ABILENE, TX",
            disabled: false,
          },
          {
            name: "547, Albertsons, GRAHAM, WA",
            disabled: false,
          },
          {
            name: "547, CVS, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "547, Kroger, FRISCO, TX",
            disabled: false,
          },
          {
            name: "547, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "547, Walmart, PLANT CITY, FL",
            disabled: false,
          },
          {
            name: "5470, CVS, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "5470, Rite Aid, EL SEGUNDO, CA",
            disabled: false,
          },
          {
            name: "5470, Walgreens, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "5470, Walmart, HUNTINGDON, PA",
            disabled: false,
          },
          {
            name: "5471, CVS, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "5471, Rite Aid, GARDENA, CA",
            disabled: false,
          },
          {
            name: "5471, Walmart, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "5472, CVS, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "5472, Walgreens, KENNER, LA",
            disabled: false,
          },
          {
            name: "5472, Walmart, SALINE, MI",
            disabled: false,
          },
          {
            name: "5473, CVS, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "5473, Walgreens, WESTLAKE, OH",
            disabled: false,
          },
          {
            name: "5474, CVS, WINNSBORO, SC",
            disabled: false,
          },
          {
            name: "5474, Walgreens, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "5475, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "5475, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "5476, CVS, LANCASTER, SC",
            disabled: false,
          },
          {
            name: "5476, Walgreens, KELLER, TX",
            disabled: false,
          },
          {
            name: "5476, Walmart, WOODBURY, NJ",
            disabled: false,
          },
          {
            name: "5477, Walmart, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "5478, Walgreens, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "5479, CVS, INDIAN LAND, SC",
            disabled: false,
          },
          {
            name: "5479, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5479, Walmart, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "548, ADUSA, SAYVILLE, NY",
            disabled: false,
          },
          {
            name: "548, Albertsons, ABILENE, TX",
            disabled: false,
          },
          {
            name: "548, Kroger, ALLEN, TX",
            disabled: false,
          },
          {
            name: "548, Kroger, PERRYSBURG, OH",
            disabled: false,
          },
          {
            name: "548, ShopRite, ABERDEEN, MD",
            disabled: false,
          },
          {
            name: "548, Walmart, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "5480, Walgreens, MILPITAS, CA",
            disabled: false,
          },
          {
            name: "5480, Walmart, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "5481, Walgreens, PETOSKEY, MI",
            disabled: false,
          },
          {
            name: "5481, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5482, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5482, Walmart, EATONTON, GA",
            disabled: false,
          },
          {
            name: "5483, CVS, SHERMAN OAKS, CA",
            disabled: false,
          },
          {
            name: "5483, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "5483, Walmart, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "5484, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "5485, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "5485, Rite Aid, VENICE, CA",
            disabled: false,
          },
          {
            name: "5485, Walgreens, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "5485, Walmart, EVERGREEN PARK, IL",
            disabled: false,
          },
          {
            name: "5486, Rite Aid, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "5486, Walmart, COUNTRY CLUB HILLS, IL",
            disabled: false,
          },
          {
            name: "5487, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "5487, Walmart, TRAVELERS REST, SC",
            disabled: false,
          },
          {
            name: "5488, Rite Aid, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "5488, Walmart, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "5489, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "5489, Walmart, PEMBROKE, NC",
            disabled: false,
          },
          {
            name: "549, Albertsons, ALLIANCE, NE",
            disabled: false,
          },
          {
            name: "549, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "549, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "549, Kroger, MARYSVILLE, OH",
            disabled: false,
          },
          {
            name: "549, ShopRite, BEL AIR, MD",
            disabled: false,
          },
          {
            name: "549, Walmart, HOBBS, NM",
            disabled: false,
          },
          {
            name: "5490, CVS, YARDLEY, PA",
            disabled: false,
          },
          {
            name: "5490, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5490, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5491, CVS, MAHWAH, NJ",
            disabled: false,
          },
          {
            name: "5491, Rite Aid, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "5491, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5492, Rite Aid, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "5492, Walmart, SOCORRO, NM",
            disabled: false,
          },
          {
            name: "5493, CVS, LOWELL, MA",
            disabled: false,
          },
          {
            name: "5494, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5494, Rite Aid, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "5494, Walmart, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "5495, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5495, Walgreens, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "5495, Walmart, GLENOLDEN, PA",
            disabled: false,
          },
          {
            name: "5496, CVS, EAST AMHERST, NY",
            disabled: false,
          },
          {
            name: "5497, CVS, COACHELLA, CA",
            disabled: false,
          },
          {
            name: "5497, Walmart, EVANS MILLS, NY",
            disabled: false,
          },
          {
            name: "5498, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "5498, Walmart, LOWVILLE, NY",
            disabled: false,
          },
          {
            name: "5499, Walgreens, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "5499, Walmart, MILFORD, OH",
            disabled: false,
          },
          {
            name: "55, ADUSA, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "55, Albertsons, TRACY, CA",
            disabled: false,
          },
          {
            name: "55, CVS, BRIGHTON, MA",
            disabled: false,
          },
          {
            name: "55, Kroger, La Canada, CA",
            disabled: false,
          },
          {
            name: "55, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "55, Kroger, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "55, Kroger, Washington, IN",
            disabled: false,
          },
          {
            name: "55, Meijer, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "55, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "55, Walmart, BOONEVILLE, AR",
            disabled: false,
          },
          {
            name: "550, ADUSA, AMITYVILLE, NY",
            disabled: false,
          },
          {
            name: "550, ADUSA, STRASBURG, VA",
            disabled: false,
          },
          {
            name: "550, Albertsons, MULESHOE, TX",
            disabled: false,
          },
          {
            name: "550, CVS, SAN CARLOS, CA",
            disabled: false,
          },
          {
            name: "550, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "550, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "550, Walmart, LAWRENCEVILLE, IL",
            disabled: false,
          },
          {
            name: "5500, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "5500, Rite Aid, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "5500, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5501, CVS, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "5501, Walgreens, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "5502, Walgreens, LENOIR CITY, TN",
            disabled: false,
          },
          {
            name: "5503, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5503, Walgreens, LANSING, MI",
            disabled: false,
          },
          {
            name: "5504, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "5504, Rite Aid, MONTEBELLO, CA",
            disabled: false,
          },
          {
            name: "5504, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5505, CVS, ABINGDON, VA",
            disabled: false,
          },
          {
            name: "5505, Rite Aid, NORWALK, CA",
            disabled: false,
          },
          {
            name: "5506, Walgreens, RIALTO, CA",
            disabled: false,
          },
          {
            name: "5507, CVS, SOUTH HILL, VA",
            disabled: false,
          },
          {
            name: "5508, CVS, ELIZABETHTOWN, NC",
            disabled: false,
          },
          {
            name: "5508, Rite Aid, BELLFLOWER, CA",
            disabled: false,
          },
          {
            name: "5508, Walgreens, PLANO, TX",
            disabled: false,
          },
          {
            name: "5509, Walgreens, FARMERS BRANCH, TX",
            disabled: false,
          },
          {
            name: "551, ADUSA, BAY SHORE, NY",
            disabled: false,
          },
          {
            name: "551, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "551, CVS, NEW HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "551, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "551, Kroger, CICERO, IL",
            disabled: false,
          },
          {
            name: "551, ShopRite, BELCAMP, MD",
            disabled: false,
          },
          {
            name: "551, Walmart, PALATKA, FL",
            disabled: false,
          },
          {
            name: "5510, Rite Aid, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "5510, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5511, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5511, Walgreens, KEWANEE, IL",
            disabled: false,
          },
          {
            name: "5512, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5512, Rite Aid, PARAMOUNT, CA",
            disabled: false,
          },
          {
            name: "5512, Walgreens, BETTENDORF, IA",
            disabled: false,
          },
          {
            name: "5513, CVS, MONROE, LA",
            disabled: false,
          },
          {
            name: "5513, Rite Aid, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "5514, CVS, BUENA VISTA, VA",
            disabled: false,
          },
          {
            name: "5514, Rite Aid, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "5514, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "5515, CVS, SURFSIDE BEACH, SC",
            disabled: false,
          },
          {
            name: "5515, Rite Aid, SEAL BEACH, CA",
            disabled: false,
          },
          {
            name: "5515, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "5516, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "5517, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5517, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "5518, CVS, BENNETTSVILLE, SC",
            disabled: false,
          },
          {
            name: "5519, CVS, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "5519, Walgreens, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "552, ADUSA, EAST MEADOW, NY",
            disabled: false,
          },
          {
            name: "552, ADUSA, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "552, Albertsons, LADERA RANCH, CA",
            disabled: false,
          },
          {
            name: "552, CVS, LEWISTON, NY",
            disabled: false,
          },
          {
            name: "552, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "552, Kroger, Huntsville, AL",
            disabled: false,
          },
          {
            name: "552, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "552, ShopRite, PISCATAWAY, NJ",
            disabled: false,
          },
          {
            name: "552, Walmart, WHITESBURG, KY",
            disabled: false,
          },
          {
            name: "5520, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "5520, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "5520, Walgreens, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "5521, CVS, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "5521, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "5521, Walgreens, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "5522, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "5522, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "5523, CVS, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "5523, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "5523, Walgreens, JENKINTOWN, PA",
            disabled: false,
          },
          {
            name: "5524, CVS, LITTLE RIVER, SC",
            disabled: false,
          },
          {
            name: "5525, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "5525, Walgreens, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "5526, Rite Aid, ALTADENA, CA",
            disabled: false,
          },
          {
            name: "5526, Walgreens, SANTA MONICA, CA",
            disabled: false,
          },
          {
            name: "5527, Walgreens, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "5528, Walgreens, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "5529, CVS, AIKEN, SC",
            disabled: false,
          },
          {
            name: "5529, Rite Aid, LA CANADA FLINTRIDGE, CA",
            disabled: false,
          },
          {
            name: "5529, Walgreens, MUSKOGEE, OK",
            disabled: false,
          },
          {
            name: "553, Albertsons, BATH, ME",
            disabled: false,
          },
          {
            name: "553, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "553, Kroger, ALSIP, IL",
            disabled: false,
          },
          {
            name: "553, Kroger, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "553, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "553, ShopRite, PARLIN, NJ",
            disabled: false,
          },
          {
            name: "553, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "553, Walmart, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "5530, Walgreens, STILLWATER, OK",
            disabled: false,
          },
          {
            name: "5531, CVS, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "5531, Rite Aid, SOUTH PASADENA, CA",
            disabled: false,
          },
          {
            name: "5531, Walgreens, ENID, OK",
            disabled: false,
          },
          {
            name: "5532, CVS, SUMMERFIELD, NC",
            disabled: false,
          },
          {
            name: "5532, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5533, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "5534, CVS, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "5534, Walgreens, KENTWOOD, MI",
            disabled: false,
          },
          {
            name: "5535, CVS, COTTAGE GROVE, WI",
            disabled: false,
          },
          {
            name: "5535, Walgreens, HOT SPRINGS VILLAGE, AR",
            disabled: false,
          },
          {
            name: "5536, CVS, BELTON, SC",
            disabled: false,
          },
          {
            name: "5536, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5537, CVS, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "5538, Walgreens, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "5539, Rite Aid, AGOURA HILLS, CA",
            disabled: false,
          },
          {
            name: "5539, Walgreens, SALINA, KS",
            disabled: false,
          },
          {
            name: "554, ADUSA, MILLER PLACE, NY",
            disabled: false,
          },
          {
            name: "554, ADUSA, WELCOME, NC",
            disabled: false,
          },
          {
            name: "554, Albertsons, BROWNWOOD, TX",
            disabled: false,
          },
          {
            name: "554, HEB, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "554, Kroger, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "554, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "554, ShopRite, GLASSBORO, NJ",
            disabled: false,
          },
          {
            name: "554, Walmart, LAREDO, TX",
            disabled: false,
          },
          {
            name: "5540, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "5540, Walgreens, BELLEVUE, NE",
            disabled: false,
          },
          {
            name: "5541, CVS, PAGELAND, SC",
            disabled: false,
          },
          {
            name: "5542, CVS, FOUNTAIN INN, SC",
            disabled: false,
          },
          {
            name: "5542, Walgreens, NILES, IL",
            disabled: false,
          },
          {
            name: "5543, CVS, AVONDALE, LA",
            disabled: false,
          },
          {
            name: "5543, Walgreens, HIGHWOOD, IL",
            disabled: false,
          },
          {
            name: "5544, CVS, PINEVILLE, LA",
            disabled: false,
          },
          {
            name: "5544, Walgreens, PEORIA HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "5545, CVS, MANTEO, NC",
            disabled: false,
          },
          {
            name: "5545, Walgreens, DECATUR, IL",
            disabled: false,
          },
          {
            name: "5547, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5548, CVS, SAINT GEORGE, SC",
            disabled: false,
          },
          {
            name: "5548, Rite Aid, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "5548, Walgreens, ERLANGER, KY",
            disabled: false,
          },
          {
            name: "5549, CVS, IRMO, SC",
            disabled: false,
          },
          {
            name: "5549, Walgreens, WARREN, OH",
            disabled: false,
          },
          {
            name: "555, ADUSA, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "555, ADUSA, LEVITTOWN, NY",
            disabled: false,
          },
          {
            name: "555, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "555, Albertsons, SAMMAMISH, WA",
            disabled: false,
          },
          {
            name: "555, CVS, BETHPAGE, NY",
            disabled: false,
          },
          {
            name: "555, HEB, UNIVERSAL CITY, TX",
            disabled: false,
          },
          {
            name: "555, Kroger, Kenton, OH",
            disabled: false,
          },
          {
            name: "555, Kroger, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "555, Walmart, DUBLIN, GA",
            disabled: false,
          },
          {
            name: "5550, CVS, CLOVER, SC",
            disabled: false,
          },
          {
            name: "5550, Walgreens, ROCKY RIVER, OH",
            disabled: false,
          },
          {
            name: "5551, CVS, TULARE, CA",
            disabled: false,
          },
          {
            name: "5551, Rite Aid, SAN FERNANDO, CA",
            disabled: false,
          },
          {
            name: "5552, CVS, TAYLORS, SC",
            disabled: false,
          },
          {
            name: "5552, Rite Aid, SYLMAR, CA",
            disabled: false,
          },
          {
            name: "5553, CVS, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "5553, Rite Aid, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "5553, Walgreens, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "5554, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5555, CVS, SANTEE, SC",
            disabled: false,
          },
          {
            name: "5555, Walgreens, RIALTO, CA",
            disabled: false,
          },
          {
            name: "5556, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "5557, CVS, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "5558, CVS, NEWLAND, NC",
            disabled: false,
          },
          {
            name: "5558, Walgreens, LANCASTER, TX",
            disabled: false,
          },
          {
            name: "5559, CVS, EDEN, NC",
            disabled: false,
          },
          {
            name: "556, ADUSA, HEMPSTEAD, NY",
            disabled: false,
          },
          {
            name: "556, Albertsons, SCOTTSBLUFF, NE",
            disabled: false,
          },
          {
            name: "556, CVS, GALES FERRY, CT",
            disabled: false,
          },
          {
            name: "556, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "556, Walmart, WAYCROSS, GA",
            disabled: false,
          },
          {
            name: "5560, CVS, BROUSSARD, LA",
            disabled: false,
          },
          {
            name: "5560, Walgreens, LUDINGTON, MI",
            disabled: false,
          },
          {
            name: "5562, Walgreens, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "5563, CVS, LELAND, NC",
            disabled: false,
          },
          {
            name: "5563, Walgreens, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "5564, Walgreens, DICKSON, TN",
            disabled: false,
          },
          {
            name: "5565, CVS, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "5565, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "5566, CVS, HILTON HEAD ISLAND, SC",
            disabled: false,
          },
          {
            name: "5566, Walgreens, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "5567, CVS, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "5567, Rite Aid, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "5567, Walgreens, COTTONWOOD, AZ",
            disabled: false,
          },
          {
            name: "5568, Rite Aid, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "5568, Walgreens, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "5569, CVS, PIEDMONT, SC",
            disabled: false,
          },
          {
            name: "5569, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "557, ADUSA, DEER PARK, NY",
            disabled: false,
          },
          {
            name: "557, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "557, Albertsons, OGALLALA, NE",
            disabled: false,
          },
          {
            name: "557, HEB, BELLMEAD, TX",
            disabled: false,
          },
          {
            name: "557, Kroger, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "557, Kroger, GARLAND, TX",
            disabled: false,
          },
          {
            name: "557, Kroger, LEBANON, TN",
            disabled: false,
          },
          {
            name: "557, Kroger, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "557, Walmart, EMPORIA, KS",
            disabled: false,
          },
          {
            name: "5570, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5571, Rite Aid, BURBANK, CA",
            disabled: false,
          },
          {
            name: "5571, Walgreens, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "5572, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5573, CVS, STARKVILLE, MS",
            disabled: false,
          },
          {
            name: "5573, Rite Aid, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "5574, Rite Aid, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "5574, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "5575, CVS, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "5575, Rite Aid, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "5575, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "5576, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "5576, Rite Aid, AZUSA, CA",
            disabled: false,
          },
          {
            name: "5576, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5578, Rite Aid, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "5578, Walgreens, DUNNELLON, FL",
            disabled: false,
          },
          {
            name: "5579, CVS, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "558, ADUSA, NORTHPORT, NY",
            disabled: false,
          },
          {
            name: "558, Albertsons, NEWCASTLE, WA",
            disabled: false,
          },
          {
            name: "558, HEB, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "558, Kroger, BELLAIRE, OH",
            disabled: false,
          },
          {
            name: "558, Kroger, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "558, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "558, Rite Aid, ABINGTON, PA",
            disabled: false,
          },
          {
            name: "558, ShopRite, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "558, Walmart, SALINA, KS",
            disabled: false,
          },
          {
            name: "5580, CVS, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "5580, Walgreens, DECATUR, GA",
            disabled: false,
          },
          {
            name: "5581, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5582, CVS, COLLINSVILLE, VA",
            disabled: false,
          },
          {
            name: "5582, Walgreens, FORT WALTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5583, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5583, Rite Aid, CORONA, CA",
            disabled: false,
          },
          {
            name: "5584, CVS, MIDDLETON, WI",
            disabled: false,
          },
          {
            name: "5584, Walgreens, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "5585, CVS, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "5586, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "5586, Rite Aid, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "5586, Walgreens, HOLBROOK, MA",
            disabled: false,
          },
          {
            name: "5587, Rite Aid, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "5587, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5588, CVS, DENVER, NC",
            disabled: false,
          },
          {
            name: "5588, Walgreens, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "5589, CVS, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "559, ADUSA, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "559, Kroger, Bolingbrook, IL",
            disabled: false,
          },
          {
            name: "559, Kroger, GARLAND, TX",
            disabled: false,
          },
          {
            name: "559, Kroger, SHELBYVILLE, TN",
            disabled: false,
          },
          {
            name: "559, Walmart, MUSCATINE, IA",
            disabled: false,
          },
          {
            name: "5590, CVS, LANDRUM, SC",
            disabled: false,
          },
          {
            name: "5591, CVS, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "5591, Rite Aid, ROWLAND HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "5591, Walgreens, HARBOR CITY, CA",
            disabled: false,
          },
          {
            name: "5592, CVS, MARS HILL, NC",
            disabled: false,
          },
          {
            name: "5592, Walgreens, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "5593, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "5593, Rite Aid, LA PUENTE, CA",
            disabled: false,
          },
          {
            name: "5594, CVS, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "5595, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "5595, Rite Aid, LA VERNE, CA",
            disabled: false,
          },
          {
            name: "5595, Walgreens, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "5596, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "5596, Walgreens, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "5597, CVS, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "5597, Walgreens, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "5598, CVS, LIBERTY, SC",
            disabled: false,
          },
          {
            name: "5598, Walgreens, EVERETT, WA",
            disabled: false,
          },
          {
            name: "5599, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "56, Albertsons, LISLE, IL",
            disabled: false,
          },
          {
            name: "56, BJ's, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "56, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "56, Kroger, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "56, Kroger, Odon, IN",
            disabled: false,
          },
          {
            name: "56, Kroger, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "56, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "56, Meijer, JACKSON, MI",
            disabled: false,
          },
          {
            name: "56, Walmart, AVA, MO",
            disabled: false,
          },
          {
            name: "560, ADUSA, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "560, Albertsons, COLLEYVILLE, TX",
            disabled: false,
          },
          {
            name: "560, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "560, CVS, DOUGLASTON, NY",
            disabled: false,
          },
          {
            name: "560, Kroger, FRISCO, TX",
            disabled: false,
          },
          {
            name: "560, Kroger, MELROSE PARK, IL",
            disabled: false,
          },
          {
            name: "560, Walmart, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "5600, CVS, BELOIT, WI",
            disabled: false,
          },
          {
            name: "5600, Rite Aid, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "5600, Walgreens, LAKE GENEVA, WI",
            disabled: false,
          },
          {
            name: "5600, Walmart, RANCHO SANTA MARGAR, CA",
            disabled: false,
          },
          {
            name: "5600, Walmart, RANCHO SANTA MARGARITA, CA",
            disabled: false,
          },
          {
            name: "5601, CVS, LENOIR CITY, TN",
            disabled: false,
          },
          {
            name: "5601, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "5601, Walmart, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "5602, Rite Aid, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "5602, Walgreens, JACKSONVILLE, IL",
            disabled: false,
          },
          {
            name: "5602, Walmart, CARSON, CA",
            disabled: false,
          },
          {
            name: "5603, Walgreens, SYCAMORE, IL",
            disabled: false,
          },
          {
            name: "5603, Walmart, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "5604, CVS, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "5604, Walgreens, ZEPHYRHILLS, FL",
            disabled: false,
          },
          {
            name: "5604, Walmart, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "5605, Walgreens, ROSWELL, GA",
            disabled: false,
          },
          {
            name: "5605, Walmart, PANORAMA CITY, CA",
            disabled: false,
          },
          {
            name: "5606, CVS, SYLVESTER, GA",
            disabled: false,
          },
          {
            name: "5606, Rite Aid, ROSEMEAD, CA",
            disabled: false,
          },
          {
            name: "5606, Walgreens, DAPHNE, AL",
            disabled: false,
          },
          {
            name: "5606, Walmart, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "5607, CVS, ALEXANDRIA, LA",
            disabled: false,
          },
          {
            name: "5608, CVS, DALTON, GA",
            disabled: false,
          },
          {
            name: "5608, Walgreens, COLUMBIA, IL",
            disabled: false,
          },
          {
            name: "5608, Walmart, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "5609, Walgreens, WHEELING, IL",
            disabled: false,
          },
          {
            name: "5609, Walmart, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "561, ADUSA, EAST ISLIP, NY",
            disabled: false,
          },
          {
            name: "561, ADUSA, GARNER, NC",
            disabled: false,
          },
          {
            name: "561, Albertsons, ARCADIA, CA",
            disabled: false,
          },
          {
            name: "561, Costco, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "561, HEB, FREDERICKSBURG, TX",
            disabled: false,
          },
          {
            name: "561, Kroger, CREST HILL, IL",
            disabled: false,
          },
          {
            name: "561, Kroger, FRISCO, TX",
            disabled: false,
          },
          {
            name: "561, Kroger, TULLAHOMA, TN",
            disabled: false,
          },
          {
            name: "561, ShopRite, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "561, Walmart, EASTLAND, TX",
            disabled: false,
          },
          {
            name: "5610, CVS, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "5610, Walgreens, AMHERST, NY",
            disabled: false,
          },
          {
            name: "5610, Walmart, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "5611, CVS, HOUMA, LA",
            disabled: false,
          },
          {
            name: "5611, Rite Aid, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "5611, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "5611, Walmart, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "5612, CVS, SULPHUR, LA",
            disabled: false,
          },
          {
            name: "5612, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "5612, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5613, CVS, HARTWELL, GA",
            disabled: false,
          },
          {
            name: "5613, Rite Aid, BONITA, CA",
            disabled: false,
          },
          {
            name: "5613, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "5613, Walmart, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "5614, CVS, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "5614, Rite Aid, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "5614, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "5614, Walmart, COLLEYVILLE, TX",
            disabled: false,
          },
          {
            name: "5615, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "5615, Walmart, HIALEAH GARDENS, FL",
            disabled: false,
          },
          {
            name: "5616, CVS, DETROIT LAKES, MN",
            disabled: false,
          },
          {
            name: "5616, Walgreens, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "5616, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5617, CVS, WALKER, LA",
            disabled: false,
          },
          {
            name: "5617, Rite Aid, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "5617, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5618, CVS, BLAKELY, GA",
            disabled: false,
          },
          {
            name: "5618, Rite Aid, LEMON GROVE, CA",
            disabled: false,
          },
          {
            name: "5619, CVS, CARY, IL",
            disabled: false,
          },
          {
            name: "5619, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "562, ADUSA, FARMINGVILLE, NY",
            disabled: false,
          },
          {
            name: "562, Albertsons, FRISCO, TX",
            disabled: false,
          },
          {
            name: "562, Costco, CORONA, CA",
            disabled: false,
          },
          {
            name: "562, HEB, ROCKPORT, TX",
            disabled: false,
          },
          {
            name: "562, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "562, Kroger, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "562, Kroger, WHEELING, WV",
            disabled: false,
          },
          {
            name: "562, Walmart, LEEDS, AL",
            disabled: false,
          },
          {
            name: "5620, Walgreens, MATAWAN, NJ",
            disabled: false,
          },
          {
            name: "5621, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "5621, Rite Aid, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "5621, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5622, CVS, DALLAS, GA",
            disabled: false,
          },
          {
            name: "5622, Walmart, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "5623, Rite Aid, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "5623, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5623, Walmart, GULF BREEZE, FL",
            disabled: false,
          },
          {
            name: "5624, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5624, Walgreens, FARMINGTON, MO",
            disabled: false,
          },
          {
            name: "5624, Walmart, FARMERS BRANCH, TX",
            disabled: false,
          },
          {
            name: "5625, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5625, Walmart, BROOKLYN CENTER, MN",
            disabled: false,
          },
          {
            name: "5626, CVS, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "5626, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5627, Rite Aid, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "5627, Walmart, GRESHAM, OR",
            disabled: false,
          },
          {
            name: "5628, CVS, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "5628, Walgreens, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "5628, Walmart, MONROE, WA",
            disabled: false,
          },
          {
            name: "5629, Rite Aid, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "5629, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5629, Walmart, EUREKA, CA",
            disabled: false,
          },
          {
            name: "563, ADUSA, HICKORY, NC",
            disabled: false,
          },
          {
            name: "563, ADUSA, HOLBROOK, NY",
            disabled: false,
          },
          {
            name: "563, Albertsons, ALLEN, TX",
            disabled: false,
          },
          {
            name: "563, Albertsons, SUNNYSIDE, WA",
            disabled: false,
          },
          {
            name: "563, CVS, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "563, Costco, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "563, HEB, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "563, Kroger, Elk Grove Village, IL",
            disabled: false,
          },
          {
            name: "563, Kroger, MADISONVILLE, KY",
            disabled: false,
          },
          {
            name: "563, Kroger, PLANO, TX",
            disabled: false,
          },
          {
            name: "563, Walmart, ORANGE CITY, FL",
            disabled: false,
          },
          {
            name: "5631, CVS, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "5631, Rite Aid, FALLBROOK, CA",
            disabled: false,
          },
          {
            name: "5632, Rite Aid, LAKESIDE, CA",
            disabled: false,
          },
          {
            name: "5632, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "5632, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5633, CVS, ELLENWOOD, GA",
            disabled: false,
          },
          {
            name: "5633, Walgreens, MARRERO, LA",
            disabled: false,
          },
          {
            name: "5633, Walmart, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "5634, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5634, Rite Aid, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "5634, Walgreens, LAKEVILLE, MN",
            disabled: false,
          },
          {
            name: "5634, Walmart, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5635, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5635, Rite Aid, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "5635, Walgreens, BRAINERD, MN",
            disabled: false,
          },
          {
            name: "5635, Walmart, VISALIA, CA",
            disabled: false,
          },
          {
            name: "5636, CVS, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "5636, Walgreens, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "5637, CVS, VILLA RICA, GA",
            disabled: false,
          },
          {
            name: "5637, Walmart, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "5638, Rite Aid, RAMONA, CA",
            disabled: false,
          },
          {
            name: "5638, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5638, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5639, CVS, FARRAGUT, TN",
            disabled: false,
          },
          {
            name: "5639, Walgreens, KENT, OH",
            disabled: false,
          },
          {
            name: "564, ADUSA, WEST BABYLON, NY",
            disabled: false,
          },
          {
            name: "564, Albertsons, COPPELL, TX",
            disabled: false,
          },
          {
            name: "564, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "564, Costco, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "564, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "564, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "564, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "5640, CVS, DAWSONVILLE, GA",
            disabled: false,
          },
          {
            name: "5640, Walmart, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "5641, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5641, Walmart, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "5642, Rite Aid, VISTA, CA",
            disabled: false,
          },
          {
            name: "5642, Walgreens, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "5643, Walgreens, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "5643, Walmart, OXNARD, CA",
            disabled: false,
          },
          {
            name: "5644, Walgreens, NORTHGLENN, CO",
            disabled: false,
          },
          {
            name: "5644, Walmart, IRVINE, CA",
            disabled: false,
          },
          {
            name: "5645, CVS, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "5645, Walgreens, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "5645, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5646, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5646, Walgreens, PAHRUMP, NV",
            disabled: false,
          },
          {
            name: "5646, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5647, CVS, ODESSA, TX",
            disabled: false,
          },
          {
            name: "5647, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5647, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5648, Walgreens, NAMPA, ID",
            disabled: false,
          },
          {
            name: "5649, Walgreens, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "5649, Walmart, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "565, Albertsons, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "565, CVS, VESTAL, NY",
            disabled: false,
          },
          {
            name: "565, Costco, SUMNER, WA",
            disabled: false,
          },
          {
            name: "565, Kroger, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "565, Kroger, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "565, Kroger, Oak Forest, IL",
            disabled: false,
          },
          {
            name: "565, Rite Aid, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "565, Walmart, CORSICANA, TX",
            disabled: false,
          },
          {
            name: "5650, Walgreens, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "5651, CVS, WESLACO, TX",
            disabled: false,
          },
          {
            name: "5652, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5652, Walgreens, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "5653, CVS, BUFORD, GA",
            disabled: false,
          },
          {
            name: "5653, Walgreens, PASCAGOULA, MS",
            disabled: false,
          },
          {
            name: "5653, Walmart, ORANGE BEACH, AL",
            disabled: false,
          },
          {
            name: "5654, CVS, JOHNSTOWN, OH",
            disabled: false,
          },
          {
            name: "5654, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5654, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5655, CVS, LIBERTY, MO",
            disabled: false,
          },
          {
            name: "5655, Walgreens, RIDGELAND, MS",
            disabled: false,
          },
          {
            name: "5656, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5657, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5657, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5657, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5657, Walmart, PLANO, TX",
            disabled: false,
          },
          {
            name: "5658, CVS, COMMERCE, GA",
            disabled: false,
          },
          {
            name: "5658, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5658, Walmart, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "5659, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5659, Walmart, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "566, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "566, Albertsons, PLANO, TX",
            disabled: false,
          },
          {
            name: "566, Kroger, DOLTON, IL",
            disabled: false,
          },
          {
            name: "566, Kroger, LA VERGNE, TN",
            disabled: false,
          },
          {
            name: "566, Kroger, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "566, Walmart, BOONVILLE, IN",
            disabled: false,
          },
          {
            name: "5660, CVS, PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5660, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5660, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "5661, CVS, BELTON, MO",
            disabled: false,
          },
          {
            name: "5661, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5661, Walmart, LA MIRADA, CA",
            disabled: false,
          },
          {
            name: "5662, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "5662, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5663, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5663, Walgreens, MARION, IN",
            disabled: false,
          },
          {
            name: "5663, Walmart, JURUPA VALLEY, CA",
            disabled: false,
          },
          {
            name: "5664, CVS, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "5664, Walgreens, EDWARDSVILLE, IL",
            disabled: false,
          },
          {
            name: "5664, Walmart, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "5665, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "5665, Walgreens, GLEN CARBON, IL",
            disabled: false,
          },
          {
            name: "5666, CVS, WAPAKONETA, OH",
            disabled: false,
          },
          {
            name: "5666, Walgreens, HOUSE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "5667, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5667, Walmart, SOUTH MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "5668, CVS, MADISONVILLE, TN",
            disabled: false,
          },
          {
            name: "5668, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5668, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5668, Walmart, GREENDALE, WI",
            disabled: false,
          },
          {
            name: "5669, Walgreens, WAUNAKEE, WI",
            disabled: false,
          },
          {
            name: "5669, Walmart, WEST MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "567, ADUSA, HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "567, Albertsons, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "567, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "567, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "567, Kroger, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "567, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "567, Walmart, CALDWELL, TX",
            disabled: false,
          },
          {
            name: "5670, CVS, OLIVETTE, MO",
            disabled: false,
          },
          {
            name: "5670, Walgreens, LA GRANGE, IL",
            disabled: false,
          },
          {
            name: "5670, Walmart, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "5671, CVS, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "5671, Rite Aid, BEAUMONT, CA",
            disabled: false,
          },
          {
            name: "5671, Walgreens, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "5671, Walmart, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "5672, Rite Aid, BANNING, CA",
            disabled: false,
          },
          {
            name: "5672, Walgreens, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "5672, Walmart, LUCAS, TX",
            disabled: false,
          },
          {
            name: "5673, CVS, MONTEZUMA, GA",
            disabled: false,
          },
          {
            name: "5673, Rite Aid, BLYTHE, CA",
            disabled: false,
          },
          {
            name: "5673, Walmart, SACHSE, TX",
            disabled: false,
          },
          {
            name: "5674, CVS, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "5675, CVS, BARNEGAT, NJ",
            disabled: false,
          },
          {
            name: "5675, Walgreens, LAKE ORION, MI",
            disabled: false,
          },
          {
            name: "5675, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5676, CVS, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "5676, Rite Aid, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "5676, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "5676, Walmart, DENVER, CO",
            disabled: false,
          },
          {
            name: "5678, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5678, Rite Aid, COACHELLA, CA",
            disabled: false,
          },
          {
            name: "5678, Walmart, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "5679, CVS, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "5679, Rite Aid, DESERT HOT SPRINGS, CA",
            disabled: false,
          },
          {
            name: "568, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "568, Kroger, ALLEN, TX",
            disabled: false,
          },
          {
            name: "568, Kroger, CHICAGO HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "568, Kroger, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "568, Rite Aid, JAMESTOWN, NY",
            disabled: false,
          },
          {
            name: "568, Walmart, CARTHAGE, TN",
            disabled: false,
          },
          {
            name: "5681, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5681, Rite Aid, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "5682, CVS, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "5682, Rite Aid, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "5683, CVS, BARNESVILLE, GA",
            disabled: false,
          },
          {
            name: "5683, Rite Aid, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "5683, Walgreens, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "5683, Walmart, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "5684, CVS, JESUP, GA",
            disabled: false,
          },
          {
            name: "5684, Rite Aid, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "5684, Walgreens, HICKORY HILLS, IL",
            disabled: false,
          },
          {
            name: "5684, Walmart, LA MESA, CA",
            disabled: false,
          },
          {
            name: "5685, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5685, Rite Aid, TWENTYNINE PALMS, CA",
            disabled: false,
          },
          {
            name: "5685, Walgreens, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "5686, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5686, Walmart, BURBANK, CA",
            disabled: false,
          },
          {
            name: "5687, CVS, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "5687, Rite Aid, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "5688, CVS, BARTLETT, IL",
            disabled: false,
          },
          {
            name: "5689, CVS, ELLISVILLE, MO",
            disabled: false,
          },
          {
            name: "5689, Walmart, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "569, Costco, COMMERCE, CA",
            disabled: false,
          },
          {
            name: "569, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "569, Kroger, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "569, Walmart, COLUMBIA, KY",
            disabled: false,
          },
          {
            name: "5690, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "5690, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5691, CVS, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "5691, Walmart, UPLAND, CA",
            disabled: false,
          },
          {
            name: "5692, CVS, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "5692, Rite Aid, BLUE JAY, CA",
            disabled: false,
          },
          {
            name: "5692, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "5693, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5693, Walgreens, IMMOKALEE, FL",
            disabled: false,
          },
          {
            name: "5693, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "5694, CVS, SODDY-DAISY, TN",
            disabled: false,
          },
          {
            name: "5694, Rite Aid, COLTON, CA",
            disabled: false,
          },
          {
            name: "5695, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "5695, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5695, Walmart, MOUNT PLEASANT, WI",
            disabled: false,
          },
          {
            name: "5696, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5696, Rite Aid, FONTANA, CA",
            disabled: false,
          },
          {
            name: "5696, Walgreens, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "5697, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5697, Rite Aid, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "5697, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "5697, Walmart, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "5698, CVS, GLADSTONE, MO",
            disabled: false,
          },
          {
            name: "5698, Walgreens, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "5699, CVS, MARTINEZ, GA",
            disabled: false,
          },
          {
            name: "5699, Rite Aid, NEEDLES, CA",
            disabled: false,
          },
          {
            name: "5699, Walgreens, REDDING, CA",
            disabled: false,
          },
          {
            name: "57, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "57, Albertsons, ELLSWORTH, ME",
            disabled: false,
          },
          {
            name: "57, BJ's, READING, PA",
            disabled: false,
          },
          {
            name: "57, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "57, Kroger, Charlestown, IN",
            disabled: false,
          },
          {
            name: "57, Kroger, Derby, KS",
            disabled: false,
          },
          {
            name: "57, Kroger, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "57, Kroger, Marana, AZ",
            disabled: false,
          },
          {
            name: "57, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "57, Kroger, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "57, Meijer, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "57, Walmart, WALNUT RIDGE, AR",
            disabled: false,
          },
          {
            name: "570, ADUSA, NEW HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "570, Albertsons, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "570, Costco, CORONA, CA",
            disabled: false,
          },
          {
            name: "570, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "570, Kroger, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "570, Kroger, DENTON, TX",
            disabled: false,
          },
          {
            name: "570, Kroger, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "5700, CVS, WAYNESBURG, PA",
            disabled: false,
          },
          {
            name: "5700, Rite Aid, PHELAN, CA",
            disabled: false,
          },
          {
            name: "5700, Walgreens, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "5700, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "5701, Rite Aid, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "5701, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "5701, Walmart, KERMAN, CA",
            disabled: false,
          },
          {
            name: "5702, Walgreens, LA PUENTE, CA",
            disabled: false,
          },
          {
            name: "5702, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "5703, CVS, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "5703, Walmart, MADISON, AL",
            disabled: false,
          },
          {
            name: "5704, CVS, ATHENS, GA",
            disabled: false,
          },
          {
            name: "5704, Rite Aid, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "5704, Walgreens, MOUNT JULIET, TN",
            disabled: false,
          },
          {
            name: "5704, Walmart, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "5705, Rite Aid, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "5705, Walgreens, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "5705, Walmart, GARDEN CITY BEACH, SC",
            disabled: false,
          },
          {
            name: "5706, CVS, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "5706, Walmart, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "5707, CVS, ELDERSBURG, MD",
            disabled: false,
          },
          {
            name: "5707, Walgreens, JACKSON, MI",
            disabled: false,
          },
          {
            name: "5707, Walmart, CROSS ROADS, TX",
            disabled: false,
          },
          {
            name: "5708, Rite Aid, FONTANA, CA",
            disabled: false,
          },
          {
            name: "5708, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "5709, Rite Aid, YUCAIPA, CA",
            disabled: false,
          },
          {
            name: "5709, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5709, Walmart, LOCUST GROVE, GA",
            disabled: false,
          },
          {
            name: "571, ADUSA, NEWTON, NC",
            disabled: false,
          },
          {
            name: "571, Albertsons, OREGON CITY, OR",
            disabled: false,
          },
          {
            name: "571, HEB, MISSION, TX",
            disabled: false,
          },
          {
            name: "571, Kroger, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "571, Kroger, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "571, Kroger, Hampton, VA",
            disabled: false,
          },
          {
            name: "571, Walmart, GEORGETOWN, KY",
            disabled: false,
          },
          {
            name: "5710, CVS, ELLWOOD CITY, PA",
            disabled: false,
          },
          {
            name: "5710, Rite Aid, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "5710, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5710, Walmart, MODESTO, CA",
            disabled: false,
          },
          {
            name: "5711, CVS, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "5711, Rite Aid, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "5711, Walgreens, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "5712, Rite Aid, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "5712, Walgreens, WARRENVILLE, IL",
            disabled: false,
          },
          {
            name: "5713, Walgreens, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "5713, Walmart, LAREDO, TX",
            disabled: false,
          },
          {
            name: "5714, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5714, Rite Aid, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "5714, Walgreens, DEPEW, NY",
            disabled: false,
          },
          {
            name: "5715, Rite Aid, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "5715, Walgreens, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "5715, Walmart, ABILENE, TX",
            disabled: false,
          },
          {
            name: "5716, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "5716, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "5717, CVS, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "5717, Rite Aid, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "5717, Walgreens, WASHINGTON, MO",
            disabled: false,
          },
          {
            name: "5717, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5718, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "5718, Rite Aid, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "5718, Walgreens, LAWRENCE, IN",
            disabled: false,
          },
          {
            name: "5719, CVS, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "5719, Walgreens, DECATUR, IL",
            disabled: false,
          },
          {
            name: "5719, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "572, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "572, Albertsons, EUGENE, OR",
            disabled: false,
          },
          {
            name: "572, Kroger, BARTONVILLE, TX",
            disabled: false,
          },
          {
            name: "572, Kroger, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "572, Kroger, De Witt, AR",
            disabled: false,
          },
          {
            name: "572, Kroger, Sparta, TN",
            disabled: false,
          },
          {
            name: "572, Walmart, KILGORE, TX",
            disabled: false,
          },
          {
            name: "5720, CVS, SOMERSET, PA",
            disabled: false,
          },
          {
            name: "5720, Walgreens, MOLINE, IL",
            disabled: false,
          },
          {
            name: "5721, CVS, EPHRATA, PA",
            disabled: false,
          },
          {
            name: "5721, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "5722, CVS, BEDFORD, VA",
            disabled: false,
          },
          {
            name: "5722, Rite Aid, HEMET, CA",
            disabled: false,
          },
          {
            name: "5722, Walmart, HARVEY, LA",
            disabled: false,
          },
          {
            name: "5723, CVS, SHREWSBURY, PA",
            disabled: false,
          },
          {
            name: "5723, Walgreens, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "5724, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "5724, Rite Aid, HEMET, CA",
            disabled: false,
          },
          {
            name: "5724, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5725, CVS, UNION CITY, GA",
            disabled: false,
          },
          {
            name: "5725, Rite Aid, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "5725, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5726, CVS, SHIPPENSBURG, PA",
            disabled: false,
          },
          {
            name: "5726, Walmart, ALAMOGORDO, NM",
            disabled: false,
          },
          {
            name: "5727, CVS, PLATTE CITY, MO",
            disabled: false,
          },
          {
            name: "5727, Walgreens, CEDAR LAKE, IN",
            disabled: false,
          },
          {
            name: "5727, Walmart, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5728, Walmart, NEWBURGH, IN",
            disabled: false,
          },
          {
            name: "5729, CVS, SOUTH BOSTON, VA",
            disabled: false,
          },
          {
            name: "5729, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "573, ADUSA, CRAMERTON, NC",
            disabled: false,
          },
          {
            name: "573, Albertsons, ASHLAND, OR",
            disabled: false,
          },
          {
            name: "573, CVS, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "573, Kroger, GRAFTON, VA",
            disabled: false,
          },
          {
            name: "573, Kroger, PROSPER, TX",
            disabled: false,
          },
          {
            name: "573, ShopRite, EDISON, NJ",
            disabled: false,
          },
          {
            name: "573, Walmart, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "5730, Rite Aid, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "5730, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "5731, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "5731, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5731, Walmart, LOCUST GROVE, VA",
            disabled: false,
          },
          {
            name: "5732, Rite Aid, BREA, CA",
            disabled: false,
          },
          {
            name: "5732, Walgreens, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "5732, Walmart, JOHNSON CITY, NY",
            disabled: false,
          },
          {
            name: "5733, CVS, MILLERSVILLE, MD",
            disabled: false,
          },
          {
            name: "5733, Rite Aid, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "5733, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "5734, CVS, READING, PA",
            disabled: false,
          },
          {
            name: "5734, Rite Aid, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "5734, Walgreens, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "5734, Walmart, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "5735, Walgreens, ELK GROVE VILLAGE, IL",
            disabled: false,
          },
          {
            name: "5735, Walmart, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "5736, CVS, CLARKSVILLE, VA",
            disabled: false,
          },
          {
            name: "5736, Rite Aid, LAGUNA WOODS, CA",
            disabled: false,
          },
          {
            name: "5736, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "5737, CVS, KINGSLAND, GA",
            disabled: false,
          },
          {
            name: "5737, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "5737, Walmart, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "5738, Walgreens, MOORE, OK",
            disabled: false,
          },
          {
            name: "5738, Walmart, SPRINGDALE, AR",
            disabled: false,
          },
          {
            name: "5739, CVS, OCEAN SPRINGS, MS",
            disabled: false,
          },
          {
            name: "5739, Walgreens, ARDMORE, OK",
            disabled: false,
          },
          {
            name: "574, Albertsons, ABILENE, TX",
            disabled: false,
          },
          {
            name: "574, Albertsons, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "574, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "574, HEB, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "574, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "574, Kroger, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "574, Walmart, SURFSIDE BEACH, SC",
            disabled: false,
          },
          {
            name: "5740, CVS, PICAYUNE, MS",
            disabled: false,
          },
          {
            name: "5740, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "5740, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "5741, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5741, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5742, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5743, CVS, NORTHAMPTON, PA",
            disabled: false,
          },
          {
            name: "5743, Rite Aid, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "5743, Walgreens, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "5743, Walmart, GARNER, NC",
            disabled: false,
          },
          {
            name: "5744, CVS, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "5744, Walgreens, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "5744, Walmart, THEODORE, AL",
            disabled: false,
          },
          {
            name: "5745, CVS, JACKSON, MS",
            disabled: false,
          },
          {
            name: "5745, Rite Aid, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "5745, Walgreens, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "5745, Walmart, LAKE WYLIE, SC",
            disabled: false,
          },
          {
            name: "5746, CVS, PEARL, MS",
            disabled: false,
          },
          {
            name: "5746, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "5747, CVS, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5747, Rite Aid, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "5747, Walgreens, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "5747, Walmart, LOCUST, NC",
            disabled: false,
          },
          {
            name: "5748, Rite Aid, ORANGE, CA",
            disabled: false,
          },
          {
            name: "5748, Walmart, GRIMES, IA",
            disabled: false,
          },
          {
            name: "5749, CVS, MASONTOWN, PA",
            disabled: false,
          },
          {
            name: "5749, Rite Aid, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "5749, Walgreens, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "575, ADUSA, ELIZABETH CITY, NC",
            disabled: false,
          },
          {
            name: "575, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "575, CVS, BATAVIA, NY",
            disabled: false,
          },
          {
            name: "575, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "575, Kroger, PORTSMOUTH, OH",
            disabled: false,
          },
          {
            name: "575, Kroger, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "575, Kroger, SMITHFIELD, VA",
            disabled: false,
          },
          {
            name: "575, Kroger, SPRINGFIELD, TN",
            disabled: false,
          },
          {
            name: "575, Walmart, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "5750, CVS, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "5751, Walmart, SALINAS, CA",
            disabled: false,
          },
          {
            name: "5752, Walgreens, EFFINGHAM, IL",
            disabled: false,
          },
          {
            name: "5752, Walmart, GARFIELD, NJ",
            disabled: false,
          },
          {
            name: "5753, CVS, CENTER MORICHES, NY",
            disabled: false,
          },
          {
            name: "5753, Rite Aid, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "5753, Walgreens, AVON, IN",
            disabled: false,
          },
          {
            name: "5753, Walmart, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "5754, Walmart, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "5755, Rite Aid, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "5755, Walgreens, STOUGHTON, MA",
            disabled: false,
          },
          {
            name: "5755, Walmart, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "5756, CVS, JACKSON, MS",
            disabled: false,
          },
          {
            name: "5756, Rite Aid, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "5756, Walgreens, EAST BOSTON, MA",
            disabled: false,
          },
          {
            name: "5757, CVS, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "5757, Rite Aid, YORBA LINDA, CA",
            disabled: false,
          },
          {
            name: "5757, Walgreens, PACE, FL",
            disabled: false,
          },
          {
            name: "5758, Walgreens, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "5758, Walmart, GREENACRES, FL",
            disabled: false,
          },
          {
            name: "5759, CVS, ERLANGER, KY",
            disabled: false,
          },
          {
            name: "5759, Rite Aid, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "5759, Walgreens, DECATUR, GA",
            disabled: false,
          },
          {
            name: "5759, Walmart, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "576, ADUSA, REIDSVILLE, NC",
            disabled: false,
          },
          {
            name: "576, CVS, HAMBURG, NY",
            disabled: false,
          },
          {
            name: "576, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "576, Kroger, England, AR",
            disabled: false,
          },
          {
            name: "576, Kroger, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "576, Kroger, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "576, Kroger, MILAN, MI",
            disabled: false,
          },
          {
            name: "576, Kroger, Norfolk, VA",
            disabled: false,
          },
          {
            name: "576, Rite Aid, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "576, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "5760, Rite Aid, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "5760, Walgreens, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "5760, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5761, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "5761, Rite Aid, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "5761, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "5761, Walmart, CANTON, MI",
            disabled: false,
          },
          {
            name: "5762, CVS, HATFIELD, PA",
            disabled: false,
          },
          {
            name: "5762, Walgreens, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "5763, Rite Aid, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "5763, Walgreens, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "5763, Walmart, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "5764, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "5764, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5765, CVS, BOWDON, GA",
            disabled: false,
          },
          {
            name: "5765, Walgreens, BOERNE, TX",
            disabled: false,
          },
          {
            name: "5766, Rite Aid, IRVINE, CA",
            disabled: false,
          },
          {
            name: "5766, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "5766, Walmart, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "5767, CVS, BROWNS MILLS, NJ",
            disabled: false,
          },
          {
            name: "5767, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "5767, Walmart, FISHERS, IN",
            disabled: false,
          },
          {
            name: "5768, Rite Aid, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "5768, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5768, Walmart, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "5769, CVS, CALUMET CITY, IL",
            disabled: false,
          },
          {
            name: "5769, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5769, Walmart, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "577, ADUSA, OCEANSIDE, NY",
            disabled: false,
          },
          {
            name: "577, Albertsons, BRECKENRIDGE, TX",
            disabled: false,
          },
          {
            name: "577, Albertsons, KLAMATH FALLS, OR",
            disabled: false,
          },
          {
            name: "577, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "577, Kroger, DUNDEE, MI",
            disabled: false,
          },
          {
            name: "577, Kroger, HAYES, VA",
            disabled: false,
          },
          {
            name: "577, Kroger, IRVING, TX",
            disabled: false,
          },
          {
            name: "577, Walmart, OLATHE, KS",
            disabled: false,
          },
          {
            name: "5770, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5771, CVS, SPRINGFIELD, NJ",
            disabled: false,
          },
          {
            name: "5771, Rite Aid, VENTURA, CA",
            disabled: false,
          },
          {
            name: "5771, Walgreens, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "5771, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "5772, Walgreens, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "5772, Walmart, LECANTO, FL",
            disabled: false,
          },
          {
            name: "5773, Walgreens, ARTESIA, CA",
            disabled: false,
          },
          {
            name: "5773, Walmart, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "5774, CVS, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "5774, Walgreens, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "5774, Walmart, HOUMA, LA",
            disabled: false,
          },
          {
            name: "5775, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "5776, CVS, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "5776, Rite Aid, CARPINTERIA, CA",
            disabled: false,
          },
          {
            name: "5776, Walgreens, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "5776, Walmart, OCEAN SPRINGS, MS",
            disabled: false,
          },
          {
            name: "5777, CVS, LAUREL, MS",
            disabled: false,
          },
          {
            name: "5777, Rite Aid, FILLMORE, CA",
            disabled: false,
          },
          {
            name: "5777, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "5777, Walmart, BROOKLYN, CT",
            disabled: false,
          },
          {
            name: "5778, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5778, Rite Aid, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "5779, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5779, Rite Aid, OJAI, CA",
            disabled: false,
          },
          {
            name: "5779, Walgreens, EUSTIS, FL",
            disabled: false,
          },
          {
            name: "5779, Walmart, KING GEORGE, VA",
            disabled: false,
          },
          {
            name: "578, Albertsons, CLYDE, TX",
            disabled: false,
          },
          {
            name: "578, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "578, Kroger, Chesapeake, VA",
            disabled: false,
          },
          {
            name: "578, Kroger, MONROE, MI",
            disabled: false,
          },
          {
            name: "578, Kroger, MOUNT JULIET, TN",
            disabled: false,
          },
          {
            name: "578, Kroger, WYLIE, TX",
            disabled: false,
          },
          {
            name: "578, Walmart, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "5780, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5780, Rite Aid, OXNARD, CA",
            disabled: false,
          },
          {
            name: "5780, Walgreens, TIGARD, OR",
            disabled: false,
          },
          {
            name: "5780, Walmart, PARAGOULD, AR",
            disabled: false,
          },
          {
            name: "5781, Walgreens, REDDING, CA",
            disabled: false,
          },
          {
            name: "5781, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5782, Rite Aid, PORT HUENEME, CA",
            disabled: false,
          },
          {
            name: "5782, Walmart, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "5783, Rite Aid, SANTA PAULA, CA",
            disabled: false,
          },
          {
            name: "5783, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "5784, CVS, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "5785, CVS, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "5786, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5786, Rite Aid, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "5786, Walmart, JASPER, GA",
            disabled: false,
          },
          {
            name: "5787, CVS, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5787, Rite Aid, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "5787, Walgreens, SCHERERVILLE, IN",
            disabled: false,
          },
          {
            name: "5787, Walmart, RAEFORD, NC",
            disabled: false,
          },
          {
            name: "5788, CVS, EDINA, MN",
            disabled: false,
          },
          {
            name: "5788, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5789, CVS, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "5789, Walgreens, WEST MEMPHIS, AR",
            disabled: false,
          },
          {
            name: "5789, Walmart, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "579, ADUSA, CORAM, NY",
            disabled: false,
          },
          {
            name: "579, Albertsons, SEMINOLE, TX",
            disabled: false,
          },
          {
            name: "579, CVS, TEMPLE TERRACE, FL",
            disabled: false,
          },
          {
            name: "579, Costco, MORROW, GA",
            disabled: false,
          },
          {
            name: "579, HEB, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "579, Kroger, FORNEY, TX",
            disabled: false,
          },
          {
            name: "579, Kroger, MONROE, MI",
            disabled: false,
          },
          {
            name: "579, ShopRite, BURLINGTON, NJ",
            disabled: false,
          },
          {
            name: "579, Walmart, ST AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "5790, CVS, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "5790, Walgreens, ATHENS, TN",
            disabled: false,
          },
          {
            name: "5790, Walmart, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "5791, CVS, LITCHFIELD PARK, AZ",
            disabled: false,
          },
          {
            name: "5791, Rite Aid, GOLETA, CA",
            disabled: false,
          },
          {
            name: "5791, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "5791, Walmart, PITTSBURG, KS",
            disabled: false,
          },
          {
            name: "5792, Walgreens, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "5793, Rite Aid, COALINGA, CA",
            disabled: false,
          },
          {
            name: "5793, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5793, Walmart, PONCE, PR",
            disabled: false,
          },
          {
            name: "5794, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "5794, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "5795, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5795, Walmart, OXFORD, PA",
            disabled: false,
          },
          {
            name: "5796, CVS, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "5796, Rite Aid, HANFORD, CA",
            disabled: false,
          },
          {
            name: "5797, CVS, CAROL STREAM, IL",
            disabled: false,
          },
          {
            name: "5797, Rite Aid, LAKE ISABELLA, CA",
            disabled: false,
          },
          {
            name: "5797, Walgreens, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "5797, Walmart, ALBANY, GA",
            disabled: false,
          },
          {
            name: "5798, Rite Aid, LINDSAY, CA",
            disabled: false,
          },
          {
            name: "5798, Walgreens, COVINA, CA",
            disabled: false,
          },
          {
            name: "5799, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "5799, Rite Aid, PORTERVILLE, CA",
            disabled: false,
          },
          {
            name: "5799, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "5799, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "58, ADUSA, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "58, Albertsons, FLORHAM PARK, NJ",
            disabled: false,
          },
          {
            name: "58, Albertsons, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "58, BJ's, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "58, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "58, Kroger, Long Beach, CA",
            disabled: false,
          },
          {
            name: "58, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "58, Kroger, Topeka, KS",
            disabled: false,
          },
          {
            name: "58, Meijer, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "58, Walmart, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "580, Albertsons, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "580, Costco, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "580, HEB, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "580, Kroger, LITTLE ELM, TX",
            disabled: false,
          },
          {
            name: "580, Kroger, Suffolk, VA",
            disabled: false,
          },
          {
            name: "580, ShopRite, NEWARK, DE",
            disabled: false,
          },
          {
            name: "580, Walmart, BARTOW, FL",
            disabled: false,
          },
          {
            name: "5801, CVS, GREENWOOD, MS",
            disabled: false,
          },
          {
            name: "5802, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "5802, Walgreens, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "5802, Walmart, CANOVANAS, PR",
            disabled: false,
          },
          {
            name: "5803, CVS, PLACENTIA, CA",
            disabled: false,
          },
          {
            name: "5803, Walgreens, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "5803, Walmart, SAN JUAN, PR",
            disabled: false,
          },
          {
            name: "5804, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "5804, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5804, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5805, Walmart, NORMAN, OK",
            disabled: false,
          },
          {
            name: "5806, Rite Aid, VISALIA, CA",
            disabled: false,
          },
          {
            name: "5806, Walmart, GRAND FORKS, ND",
            disabled: false,
          },
          {
            name: "5807, CVS, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "5807, Rite Aid, WASCO, CA",
            disabled: false,
          },
          {
            name: "5807, Walmart, COMPTON, CA",
            disabled: false,
          },
          {
            name: "5808, CVS, GREENVILLE, MS",
            disabled: false,
          },
          {
            name: "5808, Walgreens, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "5808, Walmart, ELSA, TX",
            disabled: false,
          },
          {
            name: "5809, CVS, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "5809, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5809, Walgreens, EUSTIS, FL",
            disabled: false,
          },
          {
            name: "5809, Walmart, EDINBURG, TX",
            disabled: false,
          },
          {
            name: "581, ADUSA, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "581, Albertsons, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "581, Costco, EVERETT, WA",
            disabled: false,
          },
          {
            name: "581, HEB, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "581, Kroger, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "581, Kroger, PLANO, TX",
            disabled: false,
          },
          {
            name: "581, Kroger, SEYMOUR, TN",
            disabled: false,
          },
          {
            name: "581, Walmart, MARSHALLTOWN, IA",
            disabled: false,
          },
          {
            name: "5810, Walgreens, METHUEN, MA",
            disabled: false,
          },
          {
            name: "5810, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5811, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "5811, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5811, Walgreens, AUSTELL, GA",
            disabled: false,
          },
          {
            name: "5812, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5812, Walmart, BLUE RIDGE, GA",
            disabled: false,
          },
          {
            name: "5813, CVS, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "5813, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5813, Walmart, MARTINEZ, GA",
            disabled: false,
          },
          {
            name: "5814, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "5814, Walgreens, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5814, Walmart, HOLLY SPRINGS, GA",
            disabled: false,
          },
          {
            name: "5815, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5815, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5815, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "5816, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5816, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "5816, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5817, ADUSA, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "5817, CVS, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "5817, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "5817, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5817, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5818, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5818, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "5819, CVS, PALOS HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "5819, Walmart, FRUIT COVE, FL",
            disabled: false,
          },
          {
            name: "582, CVS, SPENCER, MA",
            disabled: false,
          },
          {
            name: "582, HEB, BASTROP, TX",
            disabled: false,
          },
          {
            name: "582, Kroger, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "582, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "582, Kroger, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "582, Walmart, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "5820, CVS, LITTLE FERRY, NJ",
            disabled: false,
          },
          {
            name: "5820, Rite Aid, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "5820, Walmart, MIDDLEBURG, FL",
            disabled: false,
          },
          {
            name: "5821, Rite Aid, LOS OSOS, CA",
            disabled: false,
          },
          {
            name: "5821, Walgreens, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "5822, CVS, MOKENA, IL",
            disabled: false,
          },
          {
            name: "5823, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5823, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5824, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "5824, Rite Aid, ARROYO GRANDE, CA",
            disabled: false,
          },
          {
            name: "5824, Walgreens, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "5824, Walmart, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "5825, CVS, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "5825, Rite Aid, ARROYO GRANDE, CA",
            disabled: false,
          },
          {
            name: "5825, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5826, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5826, Walmart, BRANDON, FL",
            disabled: false,
          },
          {
            name: "5827, Rite Aid, ATASCADERO, CA",
            disabled: false,
          },
          {
            name: "5827, Walgreens, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "5828, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "5828, Walgreens, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "5828, Walmart, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "5829, CVS, ELGIN, IL",
            disabled: false,
          },
          {
            name: "5829, Walgreens, ZION, IL",
            disabled: false,
          },
          {
            name: "5829, Walmart, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "583, ADUSA, MEDFORD, NY",
            disabled: false,
          },
          {
            name: "583, Albertsons, SPEARFISH, SD",
            disabled: false,
          },
          {
            name: "583, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "583, HEB, WOODWAY, TX",
            disabled: false,
          },
          {
            name: "583, Walmart, ONEIDA, TN",
            disabled: false,
          },
          {
            name: "5830, ADUSA, BEACHWOOD, OH",
            disabled: false,
          },
          {
            name: "5830, Rite Aid, MORRO BAY, CA",
            disabled: false,
          },
          {
            name: "5830, Walgreens, MUNDELEIN, IL",
            disabled: false,
          },
          {
            name: "5831, ADUSA, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "5831, Rite Aid, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "5831, Walmart, LARGO, FL",
            disabled: false,
          },
          {
            name: "5832, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5832, Rite Aid, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "5832, Walgreens, BUFFALO GROVE, IL",
            disabled: false,
          },
          {
            name: "5832, Walmart, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "5833, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5833, Rite Aid, PISMO BEACH, CA",
            disabled: false,
          },
          {
            name: "5833, Walgreens, LA MARQUE, TX",
            disabled: false,
          },
          {
            name: "5835, CVS, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "5835, Rite Aid, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "5835, Walgreens, BELLAIRE, TX",
            disabled: false,
          },
          {
            name: "5835, Walmart, CAVE CREEK, AZ",
            disabled: false,
          },
          {
            name: "5836, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5836, Rite Aid, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "5836, Walgreens, WOODBURY, NJ",
            disabled: false,
          },
          {
            name: "5837, CVS, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "5837, Rite Aid, CALIFORNIA CITY, CA",
            disabled: false,
          },
          {
            name: "5837, Walgreens, THORNTON, CO",
            disabled: false,
          },
          {
            name: "5837, Walmart, ROGERS, AR",
            disabled: false,
          },
          {
            name: "5838, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5838, Walgreens, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "5839, ADUSA, MEDINA, OH",
            disabled: false,
          },
          {
            name: "5839, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "5839, Rite Aid, BISHOP, CA",
            disabled: false,
          },
          {
            name: "5839, Walgreens, IDAHO FALLS, ID",
            disabled: false,
          },
          {
            name: "5839, Walmart, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "584, ADUSA, HAMLET, NC",
            disabled: false,
          },
          {
            name: "584, Albertsons, TOPPENISH, WA",
            disabled: false,
          },
          {
            name: "584, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "584, HEB, EL CAMPO, TX",
            disabled: false,
          },
          {
            name: "584, Kroger, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "584, ShopRite, MONMOUTH JUNCTION, NJ",
            disabled: false,
          },
          {
            name: "584, Walmart, DRY RIDGE, KY",
            disabled: false,
          },
          {
            name: "5840, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5840, Rite Aid, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "5840, Walgreens, ANDOVER, KS",
            disabled: false,
          },
          {
            name: "5840, Walmart, OWASSO, OK",
            disabled: false,
          },
          {
            name: "5841, Walgreens, LANSING, MI",
            disabled: false,
          },
          {
            name: "5841, Walmart, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "5842, Walgreens, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "5842, Walmart, SOUTHGATE, MI",
            disabled: false,
          },
          {
            name: "5843, CVS, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "5843, Walmart, PATTERSON, CA",
            disabled: false,
          },
          {
            name: "5844, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5844, Rite Aid, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "5844, Walgreens, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "5844, Walmart, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "5845, CVS, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "5845, Rite Aid, RIDGECREST, CA",
            disabled: false,
          },
          {
            name: "5845, Walmart, NICEVILLE, FL",
            disabled: false,
          },
          {
            name: "5846, CVS, FOREST, MS",
            disabled: false,
          },
          {
            name: "5846, Rite Aid, ROSAMOND, CA",
            disabled: false,
          },
          {
            name: "5846, Walgreens, OXNARD, CA",
            disabled: false,
          },
          {
            name: "5846, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5847, Rite Aid, TEHACHAPI, CA",
            disabled: false,
          },
          {
            name: "5847, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5847, Walmart, POWHATAN, VA",
            disabled: false,
          },
          {
            name: "5848, Rite Aid, CHOWCHILLA, CA",
            disabled: false,
          },
          {
            name: "5848, Walgreens, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "5848, Walmart, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "5849, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "585, Albertsons, SHELTON, WA",
            disabled: false,
          },
          {
            name: "585, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "585, Kroger, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "585, Kroger, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "585, Walmart, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "5850, CVS, PASCAGOULA, MS",
            disabled: false,
          },
          {
            name: "5851, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "5851, Walmart, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "5852, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5852, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "5853, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5853, Rite Aid, KERMAN, CA",
            disabled: false,
          },
          {
            name: "5853, Walgreens, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "5853, Walmart, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "5854, CVS, DELTONA, FL",
            disabled: false,
          },
          {
            name: "5854, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5854, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5855, CVS, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "5855, Rite Aid, LOS BANOS, CA",
            disabled: false,
          },
          {
            name: "5855, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5855, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5856, Rite Aid, MADERA, CA",
            disabled: false,
          },
          {
            name: "5856, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "5857, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "5857, Walmart, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "5858, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5858, Rite Aid, REEDLEY, CA",
            disabled: false,
          },
          {
            name: "5858, Walgreens, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "5858, Walmart, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5859, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "5859, Walgreens, ENGLEWOOD, FL",
            disabled: false,
          },
          {
            name: "5859, Walmart, WASCO, CA",
            disabled: false,
          },
          {
            name: "586, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "586, CVS, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "586, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "586, Kroger, DENTON, TX",
            disabled: false,
          },
          {
            name: "586, Walmart, CONWAY, SC",
            disabled: false,
          },
          {
            name: "5860, Rite Aid, SELMA, CA",
            disabled: false,
          },
          {
            name: "5861, ADUSA, AKRON, OH",
            disabled: false,
          },
          {
            name: "5861, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5861, Walgreens, NORTHPORT, AL",
            disabled: false,
          },
          {
            name: "5861, Walmart, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "5862, CVS, SALEM, NH",
            disabled: false,
          },
          {
            name: "5862, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5862, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "5863, ADUSA, STREETSBORO, OH",
            disabled: false,
          },
          {
            name: "5863, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5863, Walgreens, EUREKA, CA",
            disabled: false,
          },
          {
            name: "5863, Walmart, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "5864, CVS, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "5864, Walgreens, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "5864, Walmart, GARDNERVILLE, NV",
            disabled: false,
          },
          {
            name: "5865, CVS, BRANDON, MS",
            disabled: false,
          },
          {
            name: "5865, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5866, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5866, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "5866, Walmart, FRISCO, TX",
            disabled: false,
          },
          {
            name: "5867, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "5867, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5867, Walmart, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "5868, CVS, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "5869, CVS, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "5869, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5869, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "5869, Walmart, MOSCOW, ID",
            disabled: false,
          },
          {
            name: "587, ADUSA, KENLY, NC",
            disabled: false,
          },
          {
            name: "587, CVS, BARTOW, FL",
            disabled: false,
          },
          {
            name: "587, HEB, KINGSLAND, TX",
            disabled: false,
          },
          {
            name: "587, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "587, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "587, Walmart, SPARTA, TN",
            disabled: false,
          },
          {
            name: "5870, CVS, NATCHEZ, MS",
            disabled: false,
          },
          {
            name: "5870, Walgreens, LARGO, FL",
            disabled: false,
          },
          {
            name: "5871, CVS, PRINCETON, NJ",
            disabled: false,
          },
          {
            name: "5871, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5871, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5872, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5872, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "5872, Walmart, SANTA ROSA BEACH, FL",
            disabled: false,
          },
          {
            name: "5873, Walgreens, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "5874, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "5874, Walmart, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "5875, CVS, BOWIE, MD",
            disabled: false,
          },
          {
            name: "5875, Walgreens, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "5875, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5876, Walgreens, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "5876, Walmart, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "5877, CVS, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "5877, Walgreens, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "5878, ADUSA, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "5878, CVS, RICHLAND, MS",
            disabled: false,
          },
          {
            name: "5878, Walgreens, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "5879, CVS, WIND GAP, PA",
            disabled: false,
          },
          {
            name: "5879, Rite Aid, GREENFIELD, CA",
            disabled: false,
          },
          {
            name: "5879, Walmart, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "588, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "588, Kroger, THOMPSONS STATION, TN",
            disabled: false,
          },
          {
            name: "588, Walmart, ALBANY, GA",
            disabled: false,
          },
          {
            name: "5880, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5880, Walmart, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "5881, CVS, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "5881, Walgreens, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "5881, Walmart, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "5882, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5882, Rite Aid, MONTEREY, CA",
            disabled: false,
          },
          {
            name: "5882, Walgreens, NEW HOPE, MN",
            disabled: false,
          },
          {
            name: "5882, Walmart, PALM SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5883, CVS, KOSCIUSKO, MS",
            disabled: false,
          },
          {
            name: "5883, Rite Aid, PACIFIC GROVE, CA",
            disabled: false,
          },
          {
            name: "5883, Walgreens, CRYSTAL, MN",
            disabled: false,
          },
          {
            name: "5883, Walmart, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "5884, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5884, Walgreens, FRANKLIN, WI",
            disabled: false,
          },
          {
            name: "5884, Walmart, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5885, CVS, NAZARETH, PA",
            disabled: false,
          },
          {
            name: "5885, Walgreens, MUSCATINE, IA",
            disabled: false,
          },
          {
            name: "5886, CVS, APEX, NC",
            disabled: false,
          },
          {
            name: "5886, Rite Aid, LOS ALTOS, CA",
            disabled: false,
          },
          {
            name: "5886, Walgreens, KEOKUK, IA",
            disabled: false,
          },
          {
            name: "5886, Walmart, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "5887, CVS, SAVOY, IL",
            disabled: false,
          },
          {
            name: "5888, Walmart, CAMP HILL, PA",
            disabled: false,
          },
          {
            name: "5889, CVS, ATCHISON, KS",
            disabled: false,
          },
          {
            name: "5889, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "589, ADUSA, AIKEN, SC",
            disabled: false,
          },
          {
            name: "589, HEB, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "589, Kroger, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "589, Kroger, PROSPER, TX",
            disabled: false,
          },
          {
            name: "589, ShopRite, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "589, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "5890, CVS, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "5890, Rite Aid, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "5890, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "5890, Walmart, ATWATER, CA",
            disabled: false,
          },
          {
            name: "5891, CVS, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "5891, Rite Aid, PACIFICA, CA",
            disabled: false,
          },
          {
            name: "5891, Walmart, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "5892, CVS, LAVEEN, AZ",
            disabled: false,
          },
          {
            name: "5892, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "5893, Rite Aid, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "5893, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5893, Walmart, NOVI, MI",
            disabled: false,
          },
          {
            name: "5894, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5894, Walmart, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "5896, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "5896, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "5897, CVS, MIAMI GARDENS, FL",
            disabled: false,
          },
          {
            name: "5897, Walgreens, POWDER SPRINGS, GA",
            disabled: false,
          },
          {
            name: "5898, CVS, AUDUBON, PA",
            disabled: false,
          },
          {
            name: "5898, Walgreens, LILBURN, GA",
            disabled: false,
          },
          {
            name: "5898, Walmart, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "5899, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "5899, Walmart, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "59, ADUSA, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "59, ADUSA, SMITHFIELD, NC",
            disabled: false,
          },
          {
            name: "59, Albertsons, HOBOKEN, NJ",
            disabled: false,
          },
          {
            name: "59, Albertsons, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "59, BJ's, PASADENA, MD",
            disabled: false,
          },
          {
            name: "59, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "59, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "59, Kroger, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "59, Kroger, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "59, Kroger, SIERRA VISTA, AZ",
            disabled: false,
          },
          {
            name: "59, Walmart, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "590, ADUSA, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "590, Albertsons, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "590, CVS, WOONSOCKET, RI",
            disabled: false,
          },
          {
            name: "590, HEB, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "590, Kroger, CROWLEY, TX",
            disabled: false,
          },
          {
            name: "590, Kroger, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "590, Kroger, JACKSON, OH",
            disabled: false,
          },
          {
            name: "590, Kroger, MOUNT JULIET, TN",
            disabled: false,
          },
          {
            name: "590, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5901, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5901, Walgreens, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "5902, CVS, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "5902, Walgreens, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "5903, Rite Aid, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "5903, Walgreens, JOHNS CREEK, GA",
            disabled: false,
          },
          {
            name: "5903, Walmart, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "5906, CVS, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "5906, Walgreens, OREGON, OH",
            disabled: false,
          },
          {
            name: "5907, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "5907, Rite Aid, ALAMO, CA",
            disabled: false,
          },
          {
            name: "5907, Walmart, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "5908, CVS, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "5908, Rite Aid, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "5908, Walmart, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "591, ADUSA, GRAHAM, NC",
            disabled: false,
          },
          {
            name: "591, Albertsons, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "591, HEB, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "591, Kroger, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "591, Kroger, BURLESON, TX",
            disabled: false,
          },
          {
            name: "591, Kroger, Pataskala, OH",
            disabled: false,
          },
          {
            name: "591, Walmart, CYNTHIANA, KY",
            disabled: false,
          },
          {
            name: "5910, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5910, Rite Aid, BENICIA, CA",
            disabled: false,
          },
          {
            name: "5910, Walgreens, TROUTDALE, OR",
            disabled: false,
          },
          {
            name: "5911, CVS, HAMPTON, VA",
            disabled: false,
          },
          {
            name: "5911, Walgreens, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "5911, Walmart, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "5912, CVS, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "5912, Walgreens, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "5912, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5913, CVS, PALATINE, IL",
            disabled: false,
          },
          {
            name: "5913, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "5914, CVS, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "5914, Walgreens, SPOKANE VALLEY, WA",
            disabled: false,
          },
          {
            name: "5915, Rite Aid, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "5917, CVS, PORT ORANGE, FL",
            disabled: false,
          },
          {
            name: "5917, Walgreens, FLINT, MI",
            disabled: false,
          },
          {
            name: "5918, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5919, CVS, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "5919, Walgreens, SOUTHLAKE, TX",
            disabled: false,
          },
          {
            name: "592, ADUSA, MOUNT VERNON, NY",
            disabled: false,
          },
          {
            name: "592, ADUSA, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "592, HEB, LEANDER, TX",
            disabled: false,
          },
          {
            name: "592, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "592, Kroger, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "592, Walmart, DERBY, KS",
            disabled: false,
          },
          {
            name: "5920, CVS, SAINT MICHAEL, MN",
            disabled: false,
          },
          {
            name: "5920, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5921, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "5921, Walgreens, GRANBURY, TX",
            disabled: false,
          },
          {
            name: "5922, Rite Aid, CASTRO VALLEY, CA",
            disabled: false,
          },
          {
            name: "5922, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5922, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "5923, CVS, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "5923, Rite Aid, HERCULES, CA",
            disabled: false,
          },
          {
            name: "5923, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5923, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "5924, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "5924, Walgreens, WORTH, IL",
            disabled: false,
          },
          {
            name: "5925, Rite Aid, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "5925, Walgreens, PALOS HILLS, IL",
            disabled: false,
          },
          {
            name: "5925, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "5926, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5927, Rite Aid, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "5927, Walgreens, GLEN ELLYN, IL",
            disabled: false,
          },
          {
            name: "5927, Walmart, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "5928, CVS, GAINESVILLE, VA",
            disabled: false,
          },
          {
            name: "5928, Rite Aid, NAPA, CA",
            disabled: false,
          },
          {
            name: "5928, Walgreens, WEBB CITY, MO",
            disabled: false,
          },
          {
            name: "5929, CVS, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "5929, Walmart, BATTLE GROUND, WA",
            disabled: false,
          },
          {
            name: "593, ADUSA, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "593, Albertsons, ANACORTES, WA",
            disabled: false,
          },
          {
            name: "593, HEB, TAYLOR, TX",
            disabled: false,
          },
          {
            name: "593, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "593, Walmart, DOUGLAS, GA",
            disabled: false,
          },
          {
            name: "5930, CVS, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "5930, Walmart, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "5931, Rite Aid, OAKLEY, CA",
            disabled: false,
          },
          {
            name: "5932, Walmart, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "5933, Rite Aid, ORINDA, CA",
            disabled: false,
          },
          {
            name: "5935, Rite Aid, BAY POINT, CA",
            disabled: false,
          },
          {
            name: "5935, Walgreens, SALEM, WI",
            disabled: false,
          },
          {
            name: "5935, Walmart, TIGARD, OR",
            disabled: false,
          },
          {
            name: "5936, CVS, NEENAH, WI",
            disabled: false,
          },
          {
            name: "5936, Walmart, VIENNA, VA",
            disabled: false,
          },
          {
            name: "5937, Rite Aid, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "5938, CVS, HANOVER, NH",
            disabled: false,
          },
          {
            name: "5938, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "5938, Walmart, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "5939, CVS, BURLINGTON, MA",
            disabled: false,
          },
          {
            name: "594, Albertsons, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "594, CVS, FALMOUTH, MA",
            disabled: false,
          },
          {
            name: "594, HEB, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "594, Kroger, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "594, Kroger, SPRING HILL, TN",
            disabled: false,
          },
          {
            name: "594, Kroger, TIFFIN, OH",
            disabled: false,
          },
          {
            name: "594, Rite Aid, CARMEL, NY",
            disabled: false,
          },
          {
            name: "594, ShopRite, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "594, Walmart, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "5940, Rite Aid, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "5940, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "5941, CVS, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "5941, Rite Aid, SUISUN CITY, CA",
            disabled: false,
          },
          {
            name: "5941, Walgreens, MASON CITY, IA",
            disabled: false,
          },
          {
            name: "5941, Walmart, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "5942, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "5942, Walgreens, NEWTON, IA",
            disabled: false,
          },
          {
            name: "5943, Rite Aid, UNION CITY, CA",
            disabled: false,
          },
          {
            name: "5943, Walgreens, INDIANOLA, IA",
            disabled: false,
          },
          {
            name: "5944, Rite Aid, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "5944, Walgreens, JOHNSTON, IA",
            disabled: false,
          },
          {
            name: "5944, Walmart, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "5945, Rite Aid, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "5945, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "5945, Walmart, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "5946, CVS, FAYETTEVILLE, WV",
            disabled: false,
          },
          {
            name: "5946, Walgreens, AVON PARK, FL",
            disabled: false,
          },
          {
            name: "5947, CVS, WESTON, WV",
            disabled: false,
          },
          {
            name: "5947, Walgreens, SEBRING, FL",
            disabled: false,
          },
          {
            name: "5947, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5948, Rite Aid, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "5948, Walgreens, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "5949, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "5949, Walgreens, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "595, ADUSA, LILLINGTON, NC",
            disabled: false,
          },
          {
            name: "595, CVS, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "595, HEB, CONROE, TX",
            disabled: false,
          },
          {
            name: "595, Walmart, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "5950, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "5950, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "5951, Walgreens, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "5952, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "5952, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "5953, Walgreens, LEBANON, TN",
            disabled: false,
          },
          {
            name: "5954, Walgreens, DALTON, GA",
            disabled: false,
          },
          {
            name: "5954, Walmart, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "5955, CVS, MANNINGTON, WV",
            disabled: false,
          },
          {
            name: "5955, Walgreens, GARDEN CITY PARK, NY",
            disabled: false,
          },
          {
            name: "5956, Walgreens, AMITYVILLE, NY",
            disabled: false,
          },
          {
            name: "5956, Walmart, VISALIA, CA",
            disabled: false,
          },
          {
            name: "5957, Rite Aid, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "5957, Walmart, LAKESIDE, CO",
            disabled: false,
          },
          {
            name: "5958, CVS, EASTVALE, CA",
            disabled: false,
          },
          {
            name: "5958, Rite Aid, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "5959, Walgreens, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "5959, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "596, ADUSA, ELKTON, VA",
            disabled: false,
          },
          {
            name: "596, ADUSA, NEW CITY, NY",
            disabled: false,
          },
          {
            name: "596, Albertsons, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "596, CVS, NEW MILFORD, NJ",
            disabled: false,
          },
          {
            name: "596, HEB, KATY, TX",
            disabled: false,
          },
          {
            name: "596, Kroger, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "596, Kroger, MIDLOTHIAN, TX",
            disabled: false,
          },
          {
            name: "596, Rite Aid, CORRY, PA",
            disabled: false,
          },
          {
            name: "596, Walmart, HERRIN, IL",
            disabled: false,
          },
          {
            name: "5960, CVS, HIGHLAND PARK, IL",
            disabled: false,
          },
          {
            name: "5960, Walgreens, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "5960, Walmart, SOCORRO, TX",
            disabled: false,
          },
          {
            name: "5961, CVS, ROMNEY, WV",
            disabled: false,
          },
          {
            name: "5961, Rite Aid, MILL VALLEY, CA",
            disabled: false,
          },
          {
            name: "5961, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5962, CVS, DENTON, TX",
            disabled: false,
          },
          {
            name: "5962, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "5963, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "5963, Rite Aid, NOVATO, CA",
            disabled: false,
          },
          {
            name: "5963, Walgreens, SCHERTZ, TX",
            disabled: false,
          },
          {
            name: "5963, Walmart, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "5964, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "5964, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "5965, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "5965, Rite Aid, APTOS, CA",
            disabled: false,
          },
          {
            name: "5965, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5965, Walmart, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "5966, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "5967, CVS, OCEAN VIEW, NJ",
            disabled: false,
          },
          {
            name: "5967, Rite Aid, CUPERTINO, CA",
            disabled: false,
          },
          {
            name: "5967, Walgreens, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "5968, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5968, Rite Aid, FELTON, CA",
            disabled: false,
          },
          {
            name: "5968, Walmart, WASHINGTON, DC",
            disabled: false,
          },
          {
            name: "5969, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5969, Rite Aid, FREEDOM, CA",
            disabled: false,
          },
          {
            name: "5969, Walgreens, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "5969, Walmart, CHANTILLY, VA",
            disabled: false,
          },
          {
            name: "597, ADUSA, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "597, Albertsons, IRVINE, CA",
            disabled: false,
          },
          {
            name: "597, Kroger, Crossville, TN",
            disabled: false,
          },
          {
            name: "597, Rite Aid, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "597, ShopRite, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "5971, CVS, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "5971, Rite Aid, HOLLISTER, CA",
            disabled: false,
          },
          {
            name: "5971, Walgreens, WARREN, MI",
            disabled: false,
          },
          {
            name: "5972, CVS, ROSENBERG, TX",
            disabled: false,
          },
          {
            name: "5972, Walgreens, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "5974, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "5975, Rite Aid, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "5976, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "5976, Rite Aid, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "5976, Walgreens, LINCOLN, IL",
            disabled: false,
          },
          {
            name: "5976, Walmart, BLAINE, MN",
            disabled: false,
          },
          {
            name: "5977, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "5977, Walgreens, CORALVILLE, IA",
            disabled: false,
          },
          {
            name: "5977, Walmart, BURNSVILLE, MN",
            disabled: false,
          },
          {
            name: "5978, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "5979, Rite Aid, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "5979, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "5979, Walmart, LINCOLN, CA",
            disabled: false,
          },
          {
            name: "598, Albertsons, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "598, CVS, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "598, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "598, Kroger, Oak Ridge, TN",
            disabled: false,
          },
          {
            name: "598, Kroger, PLANO, TX",
            disabled: false,
          },
          {
            name: "598, Walmart, KEARNEY, NE",
            disabled: false,
          },
          {
            name: "5980, CVS, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "5980, Walgreens, HERNANDO, FL",
            disabled: false,
          },
          {
            name: "5980, Walmart, GRANITE BAY, CA",
            disabled: false,
          },
          {
            name: "5981, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "5981, Walmart, CARMICHAEL, CA",
            disabled: false,
          },
          {
            name: "5982, Walmart, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "5983, CVS, PRESCOTT VALLEY, AZ",
            disabled: false,
          },
          {
            name: "5983, Rite Aid, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5983, Walgreens, BURLINGTON, NJ",
            disabled: false,
          },
          {
            name: "5984, CVS, VOORHEES, NJ",
            disabled: false,
          },
          {
            name: "5984, Rite Aid, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5985, Rite Aid, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5986, CVS, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "5986, Walgreens, SICKLERVILLE, NJ",
            disabled: false,
          },
          {
            name: "5987, Rite Aid, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5987, Walgreens, WILLINGBORO, NJ",
            disabled: false,
          },
          {
            name: "5987, Walmart, ROYSE CITY, TX",
            disabled: false,
          },
          {
            name: "5988, Rite Aid, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "5988, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "5989, Walgreens, DULUTH, GA",
            disabled: false,
          },
          {
            name: "599, ADUSA, TARRYTOWN, NY",
            disabled: false,
          },
          {
            name: "599, Albertsons, UPLAND, CA",
            disabled: false,
          },
          {
            name: "599, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "599, Kroger, CROSSVILLE, TN",
            disabled: false,
          },
          {
            name: "599, Kroger, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "599, Rite Aid, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "599, Walmart, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "5990, CVS, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "5990, Walgreens, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "5990, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5991, CVS, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "5991, Walmart, WICHITA, KS",
            disabled: false,
          },
          {
            name: "5992, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "5992, Walmart, LAKEVILLE, MN",
            disabled: false,
          },
          {
            name: "5993, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "5993, Walmart, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "5994, CVS, ESPANOLA, NM",
            disabled: false,
          },
          {
            name: "5994, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "5994, Walmart, WEST LINN, OR",
            disabled: false,
          },
          {
            name: "5995, CVS, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "5996, CVS, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "5996, Rite Aid, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "5996, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "5996, Walmart, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "5997, CVS, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "5997, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "5998, Rite Aid, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "5999, CVS, MOUNDS VIEW, MN",
            disabled: false,
          },
          {
            name: "5999, Rite Aid, ANGELS CAMP, CA",
            disabled: false,
          },
          {
            name: "6, ADUSA, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "6, ADUSA, NATICK, MA",
            disabled: false,
          },
          {
            name: "6, Albertsons, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "6, CVS, BROOKLINE, MA",
            disabled: false,
          },
          {
            name: "6, Costco, TUKWILA, WA",
            disabled: false,
          },
          {
            name: "6, HEB, STEPHENVILLE, TX",
            disabled: false,
          },
          {
            name: "6, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "6, Kroger, Columbia Falls, MT",
            disabled: false,
          },
          {
            name: "6, Kroger, ENCINO, CA",
            disabled: false,
          },
          {
            name: "6, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "60, ADUSA, MONROEVILLE, PA",
            disabled: false,
          },
          {
            name: "60, Albertsons, BOONTON, NJ",
            disabled: false,
          },
          {
            name: "60, Albertsons, CASPER, WY",
            disabled: false,
          },
          {
            name: "60, BJ's, COLUMBIA, MD",
            disabled: false,
          },
          {
            name: "60, CVS, PORT WENTWORTH, GA",
            disabled: false,
          },
          {
            name: "60, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "60, Kroger, CORNELIUS, OR",
            disabled: false,
          },
          {
            name: "60, Kroger, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "60, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "60, Kroger, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "60, Kroger, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "60, Walmart, TROY, MO",
            disabled: false,
          },
          {
            name: "600, ADUSA, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "600, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "600, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "600, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "600, Kroger, LAPEER, MI",
            disabled: false,
          },
          {
            name: "600, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "600, Walmart, PAMPA, TX",
            disabled: false,
          },
          {
            name: "6000, CVS, PASADENA, TX",
            disabled: false,
          },
          {
            name: "6000, Walgreens, SCHERERVILLE, IN",
            disabled: false,
          },
          {
            name: "6001, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6001, Rite Aid, ATWATER, CA",
            disabled: false,
          },
          {
            name: "6001, Walgreens, ROSCOE, IL",
            disabled: false,
          },
          {
            name: "6002, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "6003, CVS, WARR ACRES, OK",
            disabled: false,
          },
          {
            name: "6003, Rite Aid, CERES, CA",
            disabled: false,
          },
          {
            name: "6003, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "6004, ADUSA, LITITZ, PA",
            disabled: false,
          },
          {
            name: "6004, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "6005, ADUSA, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "6005, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6005, Rite Aid, MANTECA, CA",
            disabled: false,
          },
          {
            name: "6005, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6006, ADUSA, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "6006, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6007, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "6007, Rite Aid, MERCED, CA",
            disabled: false,
          },
          {
            name: "6007, Walgreens, BROOKLYN, MD",
            disabled: false,
          },
          {
            name: "6008, Rite Aid, MODESTO, CA",
            disabled: false,
          },
          {
            name: "6009, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "601, ADUSA, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "601, Albertsons, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "601, ShopRite, EGG HARBOR TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "601, Walmart, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "6010, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6010, Rite Aid, MODESTO, CA",
            disabled: false,
          },
          {
            name: "6011, ADUSA, PLYMOUTH MEETING, PA",
            disabled: false,
          },
          {
            name: "6011, Walgreens, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "6012, CVS, DALLAS, GA",
            disabled: false,
          },
          {
            name: "6012, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6013, CVS, SCOTTSBORO, AL",
            disabled: false,
          },
          {
            name: "6013, Rite Aid, NEWMAN, CA",
            disabled: false,
          },
          {
            name: "6013, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6014, ADUSA, ELIZABETHTOWN, PA",
            disabled: false,
          },
          {
            name: "6014, CVS, ROCKLEDGE, FL",
            disabled: false,
          },
          {
            name: "6014, Rite Aid, OAKDALE, CA",
            disabled: false,
          },
          {
            name: "6014, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "6015, CVS, DEL CITY, OK",
            disabled: false,
          },
          {
            name: "6015, Rite Aid, OAKDALE, CA",
            disabled: false,
          },
          {
            name: "6015, Walgreens, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "6016, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6016, Rite Aid, SONORA, CA",
            disabled: false,
          },
          {
            name: "6016, Walgreens, BELLE GLADE, FL",
            disabled: false,
          },
          {
            name: "6017, CVS, BAYOU LA BATRE, AL",
            disabled: false,
          },
          {
            name: "6017, Walgreens, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "6018, ADUSA, SOUDERTON, PA",
            disabled: false,
          },
          {
            name: "6018, Walgreens, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "6019, Rite Aid, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "602, Albertsons, BOSTON, MA",
            disabled: false,
          },
          {
            name: "602, Kroger, WARREN, MI",
            disabled: false,
          },
          {
            name: "602, Walmart, SPRING, TX",
            disabled: false,
          },
          {
            name: "6020, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "6021, CVS, MOORE, OK",
            disabled: false,
          },
          {
            name: "6021, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6022, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6023, ADUSA, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "6023, CVS, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "6023, Rite Aid, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "6023, Walgreens, FERGUSON, MO",
            disabled: false,
          },
          {
            name: "6024, CVS, NORMAN, OK",
            disabled: false,
          },
          {
            name: "6024, Walgreens, OVERLAND, MO",
            disabled: false,
          },
          {
            name: "6025, ADUSA, LEWISTOWN, PA",
            disabled: false,
          },
          {
            name: "6025, CVS, CENTEREACH, NY",
            disabled: false,
          },
          {
            name: "6026, CVS, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "6026, Rite Aid, CLEARLAKE, CA",
            disabled: false,
          },
          {
            name: "6026, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "6027, Walgreens, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "6028, Rite Aid, FORT BRAGG, CA",
            disabled: false,
          },
          {
            name: "6028, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "6029, ADUSA, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "6029, Rite Aid, HEALDSBURG, CA",
            disabled: false,
          },
          {
            name: "6029, Walgreens, SEFFNER, FL",
            disabled: false,
          },
          {
            name: "603, ADUSA, SEYMOUR, CT",
            disabled: false,
          },
          {
            name: "603, Albertsons, EAST FALMOUTH, MA",
            disabled: false,
          },
          {
            name: "603, Albertsons, TEATICKET, MA",
            disabled: false,
          },
          {
            name: "603, Kroger, Shelton, WA",
            disabled: false,
          },
          {
            name: "603, Walmart, PEKIN, IL",
            disabled: false,
          },
          {
            name: "6030, ADUSA, POTTSVILLE, PA",
            disabled: false,
          },
          {
            name: "6030, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6031, CVS, OXFORD, MS",
            disabled: false,
          },
          {
            name: "6031, Rite Aid, SEBASTOPOL, CA",
            disabled: false,
          },
          {
            name: "6032, CVS, KENDALL PARK, NJ",
            disabled: false,
          },
          {
            name: "6033, CVS, OAK RIDGE, NC",
            disabled: false,
          },
          {
            name: "6033, Rite Aid, UKIAH, CA",
            disabled: false,
          },
          {
            name: "6033, Walgreens, BESSEMER, AL",
            disabled: false,
          },
          {
            name: "6034, CVS, NORTH BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "6034, Rite Aid, WILLITS, CA",
            disabled: false,
          },
          {
            name: "6034, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "6035, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "6036, CVS, EWING, NJ",
            disabled: false,
          },
          {
            name: "6036, Rite Aid, EUREKA, CA",
            disabled: false,
          },
          {
            name: "6036, Walgreens, GRANITE BAY, CA",
            disabled: false,
          },
          {
            name: "6037, Rite Aid, MCKINLEYVILLE, CA",
            disabled: false,
          },
          {
            name: "6037, Walgreens, GERMANTOWN, TN",
            disabled: false,
          },
          {
            name: "6038, CVS, YARDVILLE, NJ",
            disabled: false,
          },
          {
            name: "6039, Walgreens, LA VERGNE, TN",
            disabled: false,
          },
          {
            name: "604, ADUSA, NAUGATUCK, CT",
            disabled: false,
          },
          {
            name: "604, Albertsons, MATTAPAN, MA",
            disabled: false,
          },
          {
            name: "604, CVS, CONCORD, MA",
            disabled: false,
          },
          {
            name: "604, Kroger, SEAL BEACH, CA",
            disabled: false,
          },
          {
            name: "604, Kroger, SPANAWAY, WA",
            disabled: false,
          },
          {
            name: "604, Target, PORTAGE, MI",
            disabled: false,
          },
          {
            name: "604, Walmart, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "6040, Rite Aid, CRESCENT CITY, CA",
            disabled: false,
          },
          {
            name: "6041, CVS, THURMONT, MD",
            disabled: false,
          },
          {
            name: "6041, Rite Aid, FORTUNA, CA",
            disabled: false,
          },
          {
            name: "6042, CVS, DOVER, PA",
            disabled: false,
          },
          {
            name: "6042, Rite Aid, AUBURN, CA",
            disabled: false,
          },
          {
            name: "6043, ADUSA, HELLERTOWN, PA",
            disabled: false,
          },
          {
            name: "6043, CVS, NEW HOPE, PA",
            disabled: false,
          },
          {
            name: "6044, Rite Aid, CARMICHAEL, CA",
            disabled: false,
          },
          {
            name: "6045, ADUSA, WEST GROVE, PA",
            disabled: false,
          },
          {
            name: "6045, Rite Aid, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "6046, ADUSA, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "6046, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6046, Walgreens, HILLSIDE, IL",
            disabled: false,
          },
          {
            name: "6047, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6047, Walgreens, TROPHY CLUB, TX",
            disabled: false,
          },
          {
            name: "6049, Rite Aid, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "605, ADUSA, ELIZABETH, PA",
            disabled: false,
          },
          {
            name: "605, ADUSA, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "605, CVS, LEESBURG, FL",
            disabled: false,
          },
          {
            name: "605, Kroger, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "605, Kroger, Houston, TX",
            disabled: false,
          },
          {
            name: "605, Kroger, Long Beach, CA",
            disabled: false,
          },
          {
            name: "605, Kroger, MADISON, AL",
            disabled: false,
          },
          {
            name: "605, Kroger, Morrilton, AR",
            disabled: false,
          },
          {
            name: "605, Kroger, TACOMA, WA",
            disabled: false,
          },
          {
            name: "605, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6050, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6050, Walgreens, WEST LAKE HILLS, TX",
            disabled: false,
          },
          {
            name: "6051, ADUSA, EXTON, PA",
            disabled: false,
          },
          {
            name: "6051, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6052, ADUSA, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "6052, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6053, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6053, Walgreens, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "6054, ADUSA, HANOVER, PA",
            disabled: false,
          },
          {
            name: "6054, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6054, Rite Aid, NORTH HIGHLANDS, CA",
            disabled: false,
          },
          {
            name: "6054, Walgreens, FLUSHING, MI",
            disabled: false,
          },
          {
            name: "6055, ADUSA, BURNHAM, PA",
            disabled: false,
          },
          {
            name: "6056, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6056, Walgreens, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "6057, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6057, Rite Aid, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "6057, Walgreens, COTTAGE GROVE, MN",
            disabled: false,
          },
          {
            name: "6058, CVS, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "6058, Rite Aid, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "6058, Walgreens, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "6059, Rite Aid, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "6059, Walgreens, WELDON SPRING, MO",
            disabled: false,
          },
          {
            name: "606, ADUSA, CROMWELL, CT",
            disabled: false,
          },
          {
            name: "606, Albertsons, LIBERTYVILLE, IL",
            disabled: false,
          },
          {
            name: "606, Kroger, MAUMELLE, AR",
            disabled: false,
          },
          {
            name: "606, Kroger, Madison, AL",
            disabled: false,
          },
          {
            name: "606, Kroger, Port Townsend, WA",
            disabled: false,
          },
          {
            name: "606, Target, SILVERDALE, WA",
            disabled: false,
          },
          {
            name: "606, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6060, CVS, CHESTER, NJ",
            disabled: false,
          },
          {
            name: "6060, Walgreens, FOUNTAIN HILLS, AZ",
            disabled: false,
          },
          {
            name: "6061, ADUSA, SHIPPENSBURG, PA",
            disabled: false,
          },
          {
            name: "6061, CVS, CARTERET, NJ",
            disabled: false,
          },
          {
            name: "6061, Walgreens, UPLAND, CA",
            disabled: false,
          },
          {
            name: "6062, Rite Aid, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "6062, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "6063, CVS, BEDMINSTER, NJ",
            disabled: false,
          },
          {
            name: "6063, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6064, CVS, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "6065, ADUSA, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "6065, CVS, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "6065, Rite Aid, WEST SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6065, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "6066, Rite Aid, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "6066, Walgreens, HUNTINGTON, IN",
            disabled: false,
          },
          {
            name: "6067, CVS, WHIPPANY, NJ",
            disabled: false,
          },
          {
            name: "6067, Walgreens, MOLINE, IL",
            disabled: false,
          },
          {
            name: "607, ADUSA, LIGONIER, PA",
            disabled: false,
          },
          {
            name: "607, ADUSA, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "607, ADUSA, SIMSBURY, CT",
            disabled: false,
          },
          {
            name: "607, Albertsons, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "607, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "607, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "607, Target, OLYMPIA, WA",
            disabled: false,
          },
          {
            name: "607, Walmart, HOBART, OK",
            disabled: false,
          },
          {
            name: "6070, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "6071, CVS, SUMMIT, NJ",
            disabled: false,
          },
          {
            name: "6071, Walgreens, LEHIGH ACRES, FL",
            disabled: false,
          },
          {
            name: "6072, ADUSA, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "6072, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6073, CVS, LIVINGSTON, NJ",
            disabled: false,
          },
          {
            name: "6073, Walgreens, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "6074, ADUSA, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "6074, CVS, WESTFIELD, NJ",
            disabled: false,
          },
          {
            name: "6074, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6074, Walgreens, SUMTER, SC",
            disabled: false,
          },
          {
            name: "6075, CVS, STANHOPE, NJ",
            disabled: false,
          },
          {
            name: "6076, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6076, Walgreens, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "6077, CVS, AURORA, IN",
            disabled: false,
          },
          {
            name: "6077, Walgreens, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "6078, CVS, LAWRENCEBURG, IN",
            disabled: false,
          },
          {
            name: "6078, Walmart, WYLIE, TX",
            disabled: false,
          },
          {
            name: "6079, ADUSA, YORK, PA",
            disabled: false,
          },
          {
            name: "6079, CVS, MILFORD, OH",
            disabled: false,
          },
          {
            name: "6079, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6079, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "608, ADUSA, COLCHESTER, CT",
            disabled: false,
          },
          {
            name: "608, Albertsons, FREEPORT, ME",
            disabled: false,
          },
          {
            name: "608, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "608, Target, SALEM, OR",
            disabled: false,
          },
          {
            name: "608, Walmart, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "6080, CVS, FAIRFIELD, OH",
            disabled: false,
          },
          {
            name: "6080, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6081, ADUSA, HAZLETON, PA",
            disabled: false,
          },
          {
            name: "6081, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6082, CVS, SHARONVILLE, OH",
            disabled: false,
          },
          {
            name: "6082, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6083, CVS, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "6083, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6083, Walgreens, LACEY, WA",
            disabled: false,
          },
          {
            name: "6084, ADUSA, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "6084, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6084, Walgreens, FAIRHOPE, AL",
            disabled: false,
          },
          {
            name: "6085, CVS, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "6085, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "6086, CVS, LEBANON, OH",
            disabled: false,
          },
          {
            name: "6086, Rite Aid, ANTELOPE, CA",
            disabled: false,
          },
          {
            name: "6087, ADUSA, YORK, PA",
            disabled: false,
          },
          {
            name: "6087, Rite Aid, CHICO, CA",
            disabled: false,
          },
          {
            name: "6088, ADUSA, MIDDLETOWN, PA",
            disabled: false,
          },
          {
            name: "6088, Rite Aid, COLUSA, CA",
            disabled: false,
          },
          {
            name: "6088, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "6089, ADUSA, HORSHAM, PA",
            disabled: false,
          },
          {
            name: "6089, CVS, HARRISON, OH",
            disabled: false,
          },
          {
            name: "6089, Rite Aid, GRASS VALLEY, CA",
            disabled: false,
          },
          {
            name: "6089, Walgreens, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "609, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "609, Albertsons, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "609, CVS, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "609, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "609, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "609, Kroger, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "609, Kroger, Savannah, GA",
            disabled: false,
          },
          {
            name: "609, Target, ALBANY, OR",
            disabled: false,
          },
          {
            name: "609, Walmart, HANNIBAL, MO",
            disabled: false,
          },
          {
            name: "6090, ADUSA, HALIFAX, PA",
            disabled: false,
          },
          {
            name: "6090, Rite Aid, GRIDLEY, CA",
            disabled: false,
          },
          {
            name: "6090, Walgreens, FRANKLIN PARK, NJ",
            disabled: false,
          },
          {
            name: "6091, ADUSA, BLUE BELL, PA",
            disabled: false,
          },
          {
            name: "6091, Rite Aid, OROVILLE, CA",
            disabled: false,
          },
          {
            name: "6091, Walgreens, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "6092, Rite Aid, PARADISE, CA",
            disabled: false,
          },
          {
            name: "6092, Walgreens, COLDWATER, MI",
            disabled: false,
          },
          {
            name: "6093, ADUSA, WIND GAP, PA",
            disabled: false,
          },
          {
            name: "6093, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6094, ADUSA, FAIRLESS HILLS, PA",
            disabled: false,
          },
          {
            name: "6094, CVS, MONTGOMERY, OH",
            disabled: false,
          },
          {
            name: "6094, Rite Aid, CHICO, CA",
            disabled: false,
          },
          {
            name: "6094, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "6095, ADUSA, SOUTHAMPTON, PA",
            disabled: false,
          },
          {
            name: "6095, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6095, Rite Aid, REDDING, CA",
            disabled: false,
          },
          {
            name: "6096, CVS, EDMOND, OK",
            disabled: false,
          },
          {
            name: "6096, Walgreens, BELOIT, WI",
            disabled: false,
          },
          {
            name: "6097, ADUSA, HERSHEY, PA",
            disabled: false,
          },
          {
            name: "6097, Rite Aid, REDDING, CA",
            disabled: false,
          },
          {
            name: "6097, Walgreens, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "6098, CVS, WILMINGTON, OH",
            disabled: false,
          },
          {
            name: "6098, Walgreens, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6098, Walmart, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "6099, Rite Aid, REDDING, CA",
            disabled: false,
          },
          {
            name: "61, ADUSA, EAST LONGMEADOW, MA",
            disabled: false,
          },
          {
            name: "61, ADUSA, KINSTON, NC",
            disabled: false,
          },
          {
            name: "61, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "61, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "61, BJ's, OWINGS MILLS, MD",
            disabled: false,
          },
          {
            name: "61, Costco, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "61, Kroger, BOULDER, CO",
            disabled: false,
          },
          {
            name: "61, Kroger, CHUBBUCK, ID",
            disabled: false,
          },
          {
            name: "61, Kroger, HAYS, KS",
            disabled: false,
          },
          {
            name: "61, Kroger, Pleasant Prairie, WI",
            disabled: false,
          },
          {
            name: "61, Kroger, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "61, Kroger, University Place, WA",
            disabled: false,
          },
          {
            name: "61, Meijer, FRANKLIN, OH",
            disabled: false,
          },
          {
            name: "61, Target, FARGO, ND",
            disabled: false,
          },
          {
            name: "61, Walmart, WARRENSBURG, MO",
            disabled: false,
          },
          {
            name: "610, ADUSA, HAYES, VA",
            disabled: false,
          },
          {
            name: "610, ADUSA, WETHERSFIELD, CT",
            disabled: false,
          },
          {
            name: "610, Albertsons, DERBY, VT",
            disabled: false,
          },
          {
            name: "610, CVS, FAIRHAVEN, MA",
            disabled: false,
          },
          {
            name: "610, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "610, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "610, Rite Aid, ROME, NY",
            disabled: false,
          },
          {
            name: "610, Target, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "610, Walmart, STEPHENVILLE, TX",
            disabled: false,
          },
          {
            name: "6100, ADUSA, NEWPORT, PA",
            disabled: false,
          },
          {
            name: "6100, Rite Aid, ANDERSON, CA",
            disabled: false,
          },
          {
            name: "6100, Walgreens, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "6101, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6101, Rite Aid, BURNEY, CA",
            disabled: false,
          },
          {
            name: "6101, Walgreens, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "6102, Walgreens, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "6103, ADUSA, MORRISVILLE, PA",
            disabled: false,
          },
          {
            name: "6103, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6103, Rite Aid, MOUNT SHASTA, CA",
            disabled: false,
          },
          {
            name: "6103, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "6104, Rite Aid, YREKA, CA",
            disabled: false,
          },
          {
            name: "6104, Walgreens, HOPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "6105, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "6106, ADUSA, NEW HOPE, PA",
            disabled: false,
          },
          {
            name: "6106, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "6106, Walgreens, DYER, IN",
            disabled: false,
          },
          {
            name: "6107, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6107, Rite Aid, SOUTH LAKE TAHOE, CA",
            disabled: false,
          },
          {
            name: "6108, Rite Aid, TRUCKEE, CA",
            disabled: false,
          },
          {
            name: "6108, Walgreens, CLIFTON, CO",
            disabled: false,
          },
          {
            name: "6109, CVS, CHOCTAW, OK",
            disabled: false,
          },
          {
            name: "6109, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "611, ADUSA, GRANBY, CT",
            disabled: false,
          },
          {
            name: "611, Albertsons, TEXARKANA, AR",
            disabled: false,
          },
          {
            name: "611, HEB, DRIPPING SPRINGS, TX",
            disabled: false,
          },
          {
            name: "611, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "611, Kroger, Palm Springs, CA",
            disabled: false,
          },
          {
            name: "611, Kroger, Sterling Heights, MI",
            disabled: false,
          },
          {
            name: "611, Target, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "611, Walmart, ROSWELL, NM",
            disabled: false,
          },
          {
            name: "6111, CVS, NORWOOD, OH",
            disabled: false,
          },
          {
            name: "6111, Walgreens, LAFAYETTE, CO",
            disabled: false,
          },
          {
            name: "6112, ADUSA, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "6112, Walgreens, OLATHE, KS",
            disabled: false,
          },
          {
            name: "6113, CVS, LATONIA, KY",
            disabled: false,
          },
          {
            name: "6113, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6115, Walgreens, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "6116, ADUSA, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "6116, CVS, ERLANGER, KY",
            disabled: false,
          },
          {
            name: "6116, Walgreens, POWELL, OH",
            disabled: false,
          },
          {
            name: "6117, ADUSA, LEOLA, PA",
            disabled: false,
          },
          {
            name: "6119, Walgreens, BLACKLICK, OH",
            disabled: false,
          },
          {
            name: "612, ADUSA, GREENWICH, CT",
            disabled: false,
          },
          {
            name: "612, ADUSA, LAURINBURG, NC",
            disabled: false,
          },
          {
            name: "612, HEB, LA VERNIA, TX",
            disabled: false,
          },
          {
            name: "612, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "612, ShopRite, SOMERS POINT, NJ",
            disabled: false,
          },
          {
            name: "612, Target, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "612, Walmart, CHARLESTON, IL",
            disabled: false,
          },
          {
            name: "6120, ADUSA, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "6120, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6121, ADUSA, BERWICK, PA",
            disabled: false,
          },
          {
            name: "6121, Rite Aid, GARDNERVILLE, NV",
            disabled: false,
          },
          {
            name: "6121, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "6122, ADUSA, WILLIAMSPORT, PA",
            disabled: false,
          },
          {
            name: "6122, Walgreens, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "6123, ADUSA, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "6123, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6124, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "6124, Walgreens, ARLETA, CA",
            disabled: false,
          },
          {
            name: "6125, Walgreens, SAN GABRIEL, CA",
            disabled: false,
          },
          {
            name: "6126, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6126, Walgreens, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "6127, Walgreens, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "6128, CVS, LAWTON, OK",
            disabled: false,
          },
          {
            name: "6128, Walgreens, SUN CITY WEST, AZ",
            disabled: false,
          },
          {
            name: "6129, CVS, CHEVIOT, OH",
            disabled: false,
          },
          {
            name: "6129, Walgreens, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "613, ADUSA, JONESVILLE, NC",
            disabled: false,
          },
          {
            name: "613, Albertsons, NARBERTH, PA",
            disabled: false,
          },
          {
            name: "613, Albertsons, PENN VALLEY, PA",
            disabled: false,
          },
          {
            name: "613, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "613, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "613, Kroger, BOISE, ID",
            disabled: false,
          },
          {
            name: "613, Kroger, CABOT, AR",
            disabled: false,
          },
          {
            name: "613, Target, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "613, Walmart, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "6130, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "6132, Walgreens, MADISON, WI",
            disabled: false,
          },
          {
            name: "6133, CVS, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "6134, CVS, GREENVILLE, OH",
            disabled: false,
          },
          {
            name: "6136, CVS, FRANKLIN, OH",
            disabled: false,
          },
          {
            name: "6136, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "6137, CVS, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "6137, Walgreens, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "6138, CVS, MIAMISBURG, OH",
            disabled: false,
          },
          {
            name: "6138, Walgreens, DECATUR, GA",
            disabled: false,
          },
          {
            name: "6139, CVS, SPRINGBORO, OH",
            disabled: false,
          },
          {
            name: "614, ADUSA, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "614, Albertsons, SHELBY, MT",
            disabled: false,
          },
          {
            name: "614, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "614, Kroger, BATTLE GROUND, WA",
            disabled: false,
          },
          {
            name: "614, Kroger, JACKSONVILLE, AR",
            disabled: false,
          },
          {
            name: "614, Kroger, Saint Clair Shores, MI",
            disabled: false,
          },
          {
            name: "614, Target, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "614, Walmart, LA GRANGE, GA",
            disabled: false,
          },
          {
            name: "614, Walmart, LAGRANGE, GA",
            disabled: false,
          },
          {
            name: "6140, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "6141, CVS, TROTWOOD, OH",
            disabled: false,
          },
          {
            name: "6141, Walgreens, OROVILLE, CA",
            disabled: false,
          },
          {
            name: "6142, CVS, SHAWNEE, OK",
            disabled: false,
          },
          {
            name: "6142, Walgreens, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "6143, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "6145, CVS, EATON, OH",
            disabled: false,
          },
          {
            name: "6145, Walgreens, BRYAN, TX",
            disabled: false,
          },
          {
            name: "6146, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "6147, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6147, Walgreens, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "6148, CVS, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "6149, CVS, UPPER ARLINGTON, OH",
            disabled: false,
          },
          {
            name: "6149, Walgreens, SATELLITE BEACH, FL",
            disabled: false,
          },
          {
            name: "6149, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "615, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "615, ADUSA, NORWICH, CT",
            disabled: false,
          },
          {
            name: "615, Albertsons, COLCHESTER, VT",
            disabled: false,
          },
          {
            name: "615, CVS, METHUEN, MA",
            disabled: false,
          },
          {
            name: "615, HEB, KATY, TX",
            disabled: false,
          },
          {
            name: "615, Kroger, Chino, CA",
            disabled: false,
          },
          {
            name: "615, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "615, Kroger, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "615, Kroger, Little Rock, AR",
            disabled: false,
          },
          {
            name: "615, Kroger, UNIVERSITY PLACE, WA",
            disabled: false,
          },
          {
            name: "615, ShopRite, SEWELL, NJ",
            disabled: false,
          },
          {
            name: "615, Target, REDDING, CA",
            disabled: false,
          },
          {
            name: "615, Walmart, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "6150, CVS, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "6151, CVS, MOUNT VERNON, OH",
            disabled: false,
          },
          {
            name: "6151, Walgreens, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6152, Walgreens, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6153, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6153, Walgreens, ANTIGO, WI",
            disabled: false,
          },
          {
            name: "6154, Walgreens, DUBUQUE, IA",
            disabled: false,
          },
          {
            name: "6155, CVS, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "6155, Walgreens, WILDWOOD, MO",
            disabled: false,
          },
          {
            name: "6156, Walgreens, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "6157, Walgreens, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "6158, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6158, Walgreens, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "6159, Walmart, WESLACO, TX",
            disabled: false,
          },
          {
            name: "616, ADUSA, GREENWICH, CT",
            disabled: false,
          },
          {
            name: "616, ADUSA, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "616, Albertsons, BERLIN, VT",
            disabled: false,
          },
          {
            name: "616, CVS, MAMARONECK, NY",
            disabled: false,
          },
          {
            name: "616, Kroger, DOUGLASVILLE, GA",
            disabled: false,
          },
          {
            name: "616, Kroger, Little Rock, AR",
            disabled: false,
          },
          {
            name: "616, Target, LANSING, MI",
            disabled: false,
          },
          {
            name: "616, Walmart, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "6161, CVS, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "6161, Walgreens, ELMWOOD PARK, NJ",
            disabled: false,
          },
          {
            name: "6162, CVS, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "6162, Walgreens, EAST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "6163, CVS, WORTHINGTON, OH",
            disabled: false,
          },
          {
            name: "6163, Walgreens, LEESBURG, FL",
            disabled: false,
          },
          {
            name: "6164, CVS, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "6164, Walgreens, NORTH PORT, FL",
            disabled: false,
          },
          {
            name: "6165, CVS, NORMAN, OK",
            disabled: false,
          },
          {
            name: "6165, Walgreens, CARMEL, IN",
            disabled: false,
          },
          {
            name: "6165, Walmart, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "6166, Walmart, DIBERVILLE, MS",
            disabled: false,
          },
          {
            name: "6167, CVS, ASHLAND, OH",
            disabled: false,
          },
          {
            name: "6168, Walgreens, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "6169, CVS, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "617, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "617, ADUSA, GENEVA, OH",
            disabled: false,
          },
          {
            name: "617, Albertsons, GUNNISON, CO",
            disabled: false,
          },
          {
            name: "617, HEB, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "617, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "617, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "617, ShopRite, SKILLMAN, NJ",
            disabled: false,
          },
          {
            name: "617, Target, BOISE, ID",
            disabled: false,
          },
          {
            name: "617, Walmart, SULLIVAN, IN",
            disabled: false,
          },
          {
            name: "6170, CVS, RIVERTON, NJ",
            disabled: false,
          },
          {
            name: "6170, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6170, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "6171, CVS, MARION, OH",
            disabled: false,
          },
          {
            name: "6171, Walgreens, PROSPECT, KY",
            disabled: false,
          },
          {
            name: "6172, CVS, KENTON, OH",
            disabled: false,
          },
          {
            name: "6172, Walmart, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "6173, CVS, NORWALK, OH",
            disabled: false,
          },
          {
            name: "6173, Walmart, ROBERTSDALE, AL",
            disabled: false,
          },
          {
            name: "6174, Walgreens, WILLIAMSTOWN, NJ",
            disabled: false,
          },
          {
            name: "6174, Walmart, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "6175, CVS, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "6176, CVS, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "6176, Walgreens, DARIEN, IL",
            disabled: false,
          },
          {
            name: "6176, Walmart, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "6177, CVS, BELLEVUE, OH",
            disabled: false,
          },
          {
            name: "6177, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "6178, CVS, BELLEFONTAINE, OH",
            disabled: false,
          },
          {
            name: "6178, Walmart, AURORA, CO",
            disabled: false,
          },
          {
            name: "6179, CVS, SIDNEY, OH",
            disabled: false,
          },
          {
            name: "6179, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "618, ADUSA, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "618, CVS, AMHERST, NY",
            disabled: false,
          },
          {
            name: "618, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "618, Kroger, ATHENS, GA",
            disabled: false,
          },
          {
            name: "618, Kroger, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "618, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "618, Target, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "618, Walmart, HIRAM, GA",
            disabled: false,
          },
          {
            name: "6180, CVS, CELINA, OH",
            disabled: false,
          },
          {
            name: "6180, Walgreens, NEW LENOX, IL",
            disabled: false,
          },
          {
            name: "6181, CVS, BRYAN, OH",
            disabled: false,
          },
          {
            name: "6181, Walgreens, ROCKLEDGE, FL",
            disabled: false,
          },
          {
            name: "6182, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6182, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6183, CVS, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "6183, Walgreens, BOUNTIFUL, UT",
            disabled: false,
          },
          {
            name: "6184, CVS, ATHENS, OH",
            disabled: false,
          },
          {
            name: "6185, CVS, PICKERINGTON, OH",
            disabled: false,
          },
          {
            name: "6185, Rite Aid, SOLVANG, CA",
            disabled: false,
          },
          {
            name: "6185, Walgreens, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "6186, CVS, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "6186, Walgreens, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "6187, Walgreens, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "6188, CVS, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "6188, Rite Aid, CORNING, CA",
            disabled: false,
          },
          {
            name: "6189, CVS, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "6189, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "619, ADUSA, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "619, ADUSA, WINDSOR, CT",
            disabled: false,
          },
          {
            name: "619, Albertsons, DARTMOUTH, MA",
            disabled: false,
          },
          {
            name: "619, HEB, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "619, Kroger, Farmington Hills, MI",
            disabled: false,
          },
          {
            name: "619, Kroger, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "619, Kroger, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "619, Kroger, Hendersonville, TN",
            disabled: false,
          },
          {
            name: "619, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "619, Target, SHOREVIEW, MN",
            disabled: false,
          },
          {
            name: "619, Walmart, DAYTON, TN",
            disabled: false,
          },
          {
            name: "6190, CVS, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "6190, Walgreens, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "6190, Walmart, LABELLE, FL",
            disabled: false,
          },
          {
            name: "6191, CVS, LONDON, OH",
            disabled: false,
          },
          {
            name: "6191, Walgreens, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "6192, CVS, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "6192, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "6193, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6194, Rite Aid, SPANAWAY, WA",
            disabled: false,
          },
          {
            name: "6195, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6195, Walgreens, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "6196, Walgreens, MARSHALL, TX",
            disabled: false,
          },
          {
            name: "6197, Rite Aid, DAVIS, CA",
            disabled: false,
          },
          {
            name: "6197, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6198, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6199, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6199, Walgreens, LAWTON, OK",
            disabled: false,
          },
          {
            name: "62, ADUSA, MALDEN, MA",
            disabled: false,
          },
          {
            name: "62, ADUSA, ROCHESTER, PA",
            disabled: false,
          },
          {
            name: "62, Albertsons, CASPER, WY",
            disabled: false,
          },
          {
            name: "62, BJ's, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "62, CVS, GLOUCESTER, MA",
            disabled: false,
          },
          {
            name: "62, Costco, UNION GAP, WA",
            disabled: false,
          },
          {
            name: "62, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "62, Kroger, PORT HUENEME, CA",
            disabled: false,
          },
          {
            name: "62, Kroger, Pleasant Prairie, WI",
            disabled: false,
          },
          {
            name: "62, Kroger, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "62, Walmart, BLYTHEVILLE, AR",
            disabled: false,
          },
          {
            name: "620, ADUSA, COLONIAL HEIGHTS, VA",
            disabled: false,
          },
          {
            name: "620, ADUSA, TRUMBULL, CT",
            disabled: false,
          },
          {
            name: "620, CVS, WATERVILLE, ME",
            disabled: false,
          },
          {
            name: "620, HEB, PEARSALL, TX",
            disabled: false,
          },
          {
            name: "620, Kroger, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "620, Kroger, JASPER, GA",
            disabled: false,
          },
          {
            name: "620, Kroger, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "620, ShopRite, SHREWSBURY, NJ",
            disabled: false,
          },
          {
            name: "620, Target, ONALASKA, WI",
            disabled: false,
          },
          {
            name: "620, Walmart, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "6200, Rite Aid, HAYDEN, ID",
            disabled: false,
          },
          {
            name: "6200, Walgreens, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "6201, Walgreens, ALBANY, GA",
            disabled: false,
          },
          {
            name: "6203, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6204, Walgreens, SANDY SPRINGS, GA",
            disabled: false,
          },
          {
            name: "6205, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6206, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6206, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "6207, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6207, Rite Aid, CORONA DEL MAR, CA",
            disabled: false,
          },
          {
            name: "6207, Walgreens, PEACHTREE CORNERS, GA",
            disabled: false,
          },
          {
            name: "6207, Walmart, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "6208, Walgreens, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "6209, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6209, Walgreens, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "621, ADUSA, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "621, ADUSA, SOUTHBURY, CT",
            disabled: false,
          },
          {
            name: "621, Albertsons, STRATHAM, NH",
            disabled: false,
          },
          {
            name: "621, CVS, COVENTRY, RI",
            disabled: false,
          },
          {
            name: "621, Costco, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "621, HEB, BOERNE, TX",
            disabled: false,
          },
          {
            name: "621, Kroger, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "621, Kroger, HEBRON, OH",
            disabled: false,
          },
          {
            name: "621, Kroger, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "621, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "621, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "621, Walmart, LAKE CITY, SC",
            disabled: false,
          },
          {
            name: "6210, Walgreens, GULF BREEZE, FL",
            disabled: false,
          },
          {
            name: "6211, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6211, Walgreens, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "6212, Walgreens, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "6213, Rite Aid, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "6213, Walgreens, FEDERAL HEIGHTS, CO",
            disabled: false,
          },
          {
            name: "6214, Rite Aid, COMPTON, CA",
            disabled: false,
          },
          {
            name: "6214, Walgreens, SCOTTS VALLEY, CA",
            disabled: false,
          },
          {
            name: "6215, Walgreens, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "6216, CVS, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6216, Walgreens, HOBART, IN",
            disabled: false,
          },
          {
            name: "6217, CVS, JEFFERSONTOWN, KY",
            disabled: false,
          },
          {
            name: "6217, Walgreens, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "6218, Walgreens, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "6219, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "6219, Walgreens, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "622, ADUSA, TORRINGTON, CT",
            disabled: false,
          },
          {
            name: "622, Albertsons, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "622, Costco, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "622, HEB, SPRING BRANCH, TX",
            disabled: false,
          },
          {
            name: "622, Kroger, HARRISON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "622, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "622, Kroger, Mesa, AZ",
            disabled: false,
          },
          {
            name: "622, Target, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "622, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "622, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6222, CVS, ARDMORE, OK",
            disabled: false,
          },
          {
            name: "6223, Walgreens, CROSSVILLE, TN",
            disabled: false,
          },
          {
            name: "6224, CVS, CHICKASHA, OK",
            disabled: false,
          },
          {
            name: "6224, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6225, CVS, EDMOND, OK",
            disabled: false,
          },
          {
            name: "6225, Rite Aid, ALPINE, CA",
            disabled: false,
          },
          {
            name: "6226, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6226, Walgreens, FAIRHAVEN, MA",
            disabled: false,
          },
          {
            name: "6226, Walmart, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "6227, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "6228, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6228, Walgreens, GLENVIEW, IL",
            disabled: false,
          },
          {
            name: "623, ADUSA, MIDDLETOWN, CT",
            disabled: false,
          },
          {
            name: "623, CVS, WESTPORT, CT",
            disabled: false,
          },
          {
            name: "623, Costco, ROYAL PALM BEAC, FL",
            disabled: false,
          },
          {
            name: "623, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "623, Kroger, GALLOWAY, OH",
            disabled: false,
          },
          {
            name: "623, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "623, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "623, Target, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "623, Walmart, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "6230, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6231, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6232, CVS, YUKON, OK",
            disabled: false,
          },
          {
            name: "6232, Rite Aid, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "6233, CVS, EDMOND, OK",
            disabled: false,
          },
          {
            name: "6233, Walmart, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "6234, CVS, EDMOND, OK",
            disabled: false,
          },
          {
            name: "6234, Rite Aid, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "6235, CVS, MUSTANG, OK",
            disabled: false,
          },
          {
            name: "6235, Rite Aid, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "6236, CVS, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6237, CVS, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "6238, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6239, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6239, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "624, ADUSA, MADISON, CT",
            disabled: false,
          },
          {
            name: "624, Albertsons, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "624, Costco, GIG HARBOR, WA",
            disabled: false,
          },
          {
            name: "624, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "624, Kroger, RUSSELLVILLE, AR",
            disabled: false,
          },
          {
            name: "624, Target, HOLLAND, OH",
            disabled: false,
          },
          {
            name: "624, Walmart, NEWBERRY, SC",
            disabled: false,
          },
          {
            name: "6240, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6242, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6242, Walgreens, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "6243, ADUSA, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "6243, Rite Aid, HANFORD, CA",
            disabled: false,
          },
          {
            name: "6243, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "6243, Walmart, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "6244, CVS, CRESTWOOD, KY",
            disabled: false,
          },
          {
            name: "6244, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6245, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6246, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "6247, CVS, NASSAU BAY, TX",
            disabled: false,
          },
          {
            name: "6247, Walgreens, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "6248, CVS, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "6249, Walgreens, LYNWOOD, CA",
            disabled: false,
          },
          {
            name: "625, ADUSA, ALIQUIPPA, PA",
            disabled: false,
          },
          {
            name: "625, ADUSA, WINSTED, CT",
            disabled: false,
          },
          {
            name: "625, Albertsons, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "625, CVS, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "625, Costco, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "625, Kroger, CONWAY, AR",
            disabled: false,
          },
          {
            name: "625, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "625, Kroger, RINCON, GA",
            disabled: false,
          },
          {
            name: "625, Target, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "625, Walgreens, MILLBRAE, CA",
            disabled: false,
          },
          {
            name: "625, Walmart, GEORGETOWN, SC",
            disabled: false,
          },
          {
            name: "6250, CVS, NEWBURGH, IN",
            disabled: false,
          },
          {
            name: "6250, Walgreens, BURBANK, CA",
            disabled: false,
          },
          {
            name: "6251, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6251, Walgreens, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "6252, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6253, ADUSA, NEW CUMBERLAND, PA",
            disabled: false,
          },
          {
            name: "6253, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6253, Walgreens, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "6254, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6255, ADUSA, EASTON, PA",
            disabled: false,
          },
          {
            name: "6255, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6255, Rite Aid, PASADENA, CA",
            disabled: false,
          },
          {
            name: "6255, Walgreens, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "6256, CVS, MOUNT VERNON, IN",
            disabled: false,
          },
          {
            name: "6256, Rite Aid, LOMA LINDA, CA",
            disabled: false,
          },
          {
            name: "6256, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "6257, ADUSA, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "6258, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "6258, Walgreens, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "6259, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "626, ADUSA, JEANNETTE, PA",
            disabled: false,
          },
          {
            name: "626, CVS, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "626, Costco, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "626, HEB, SAN BENITO, TX",
            disabled: false,
          },
          {
            name: "626, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "626, Kroger, La Puente, CA",
            disabled: false,
          },
          {
            name: "626, Kroger, Lacey, WA",
            disabled: false,
          },
          {
            name: "626, Kroger, Louisiana, MO",
            disabled: false,
          },
          {
            name: "626, ShopRite, HAZLET, NJ",
            disabled: false,
          },
          {
            name: "626, Target, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "626, Walmart, SEMINOLE, TX",
            disabled: false,
          },
          {
            name: "6260, CVS, TELL CITY, IN",
            disabled: false,
          },
          {
            name: "6260, Walgreens, EDGEWOOD, WA",
            disabled: false,
          },
          {
            name: "6261, Walgreens, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "6262, ADUSA, DANVILLE, PA",
            disabled: false,
          },
          {
            name: "6262, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "6263, CVS, BOONVILLE, IN",
            disabled: false,
          },
          {
            name: "6263, Rite Aid, VALENCIA, CA",
            disabled: false,
          },
          {
            name: "6263, Walgreens, LAKE CITY, FL",
            disabled: false,
          },
          {
            name: "6263, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "6264, CVS, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "6264, Walgreens, WATAUGA, TX",
            disabled: false,
          },
          {
            name: "6264, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "6265, ADUSA, NORTH WALES, PA",
            disabled: false,
          },
          {
            name: "6265, Walgreens, RANDALLSTOWN, MD",
            disabled: false,
          },
          {
            name: "6266, ADUSA, LEBANON, PA",
            disabled: false,
          },
          {
            name: "6266, Rite Aid, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "6267, ADUSA, GETTYSBURG, PA",
            disabled: false,
          },
          {
            name: "6267, CVS, PIGEON FORGE, TN",
            disabled: false,
          },
          {
            name: "6268, CVS, STEUBENVILLE, OH",
            disabled: false,
          },
          {
            name: "6268, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "627, Albertsons, GROTON, MA",
            disabled: false,
          },
          {
            name: "627, Costco, FONTANA, CA",
            disabled: false,
          },
          {
            name: "627, HEB, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "627, Kroger, CUMMING, GA",
            disabled: false,
          },
          {
            name: "627, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "627, Kroger, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "627, Target, TUKWILA, WA",
            disabled: false,
          },
          {
            name: "627, Walmart, DILLON, SC",
            disabled: false,
          },
          {
            name: "6270, CVS, MARTINS FERRY, OH",
            disabled: false,
          },
          {
            name: "6271, ADUSA, SHREWSBURY, PA",
            disabled: false,
          },
          {
            name: "6271, CVS, SAINT CLAIRSVILLE, OH",
            disabled: false,
          },
          {
            name: "6273, ADUSA, READING, PA",
            disabled: false,
          },
          {
            name: "6273, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6274, CVS, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "6274, Walgreens, WEST MONROE, LA",
            disabled: false,
          },
          {
            name: "6275, CVS, BETHPAGE, NY",
            disabled: false,
          },
          {
            name: "6276, CVS, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "6276, Rite Aid, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "6277, ADUSA, HUNTINGDON, PA",
            disabled: false,
          },
          {
            name: "6277, CVS, MOUNDSVILLE, WV",
            disabled: false,
          },
          {
            name: "6277, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6278, ADUSA, ASTON, PA",
            disabled: false,
          },
          {
            name: "6278, CVS, WHEELING, WV",
            disabled: false,
          },
          {
            name: "6278, Walgreens, COLLIERVILLE, TN",
            disabled: false,
          },
          {
            name: "6279, ADUSA, HUMMELSTOWN, PA",
            disabled: false,
          },
          {
            name: "6279, Walgreens, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "628, ADUSA, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "628, ADUSA, MECHANICSVILLE, VA",
            disabled: false,
          },
          {
            name: "628, Albertsons, BRUNSWICK, ME",
            disabled: false,
          },
          {
            name: "628, CVS, NORTH MIAMI, FL",
            disabled: false,
          },
          {
            name: "628, Costco, GRAFTON, WI",
            disabled: false,
          },
          {
            name: "628, Kroger, HARRIMAN, TN",
            disabled: false,
          },
          {
            name: "628, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "628, Target, KELSO, WA",
            disabled: false,
          },
          {
            name: "628, Walmart, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "6280, CVS, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "6280, Walgreens, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "6281, CVS, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "6281, Walgreens, DRAPER, UT",
            disabled: false,
          },
          {
            name: "6282, CVS, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "6282, Walgreens, TAYLORSVILLE, UT",
            disabled: false,
          },
          {
            name: "6283, CVS, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "6283, Walgreens, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "6284, ADUSA, ROYERSFORD, PA",
            disabled: false,
          },
          {
            name: "6284, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "6284, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "6285, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "6285, Walgreens, HAYS, KS",
            disabled: false,
          },
          {
            name: "6286, Walmart, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "6287, ADUSA, BLOOMSBURG, PA",
            disabled: false,
          },
          {
            name: "6287, Walgreens, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "6288, Walgreens, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "6289, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6289, Walgreens, GOLETA, CA",
            disabled: false,
          },
          {
            name: "629, ADUSA, SHELTON, CT",
            disabled: false,
          },
          {
            name: "629, Albertsons, DOVER FOXCROFT, ME",
            disabled: false,
          },
          {
            name: "629, Albertsons, DOVER-FOXCROFT, ME",
            disabled: false,
          },
          {
            name: "629, CVS, DANBURY, CT",
            disabled: false,
          },
          {
            name: "629, Costco, THORNTON, CO",
            disabled: false,
          },
          {
            name: "629, Kroger, BENTON, AR",
            disabled: false,
          },
          {
            name: "629, Kroger, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "629, Kroger, Commerce Township, MI",
            disabled: false,
          },
          {
            name: "629, Rite Aid, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "629, Walmart, UNION, SC",
            disabled: false,
          },
          {
            name: "6290, Walgreens, LOMPOC, CA",
            disabled: false,
          },
          {
            name: "6291, ADUSA, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "6291, Rite Aid, TRACY, CA",
            disabled: false,
          },
          {
            name: "6292, CVS, HOLLINS, VA",
            disabled: false,
          },
          {
            name: "6293, Rite Aid, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "6293, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "6294, ADUSA, YORK, PA",
            disabled: false,
          },
          {
            name: "6294, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6294, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6294, Walgreens, GLEN ELLYN, IL",
            disabled: false,
          },
          {
            name: "6295, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6295, Walgreens, PEABODY, MA",
            disabled: false,
          },
          {
            name: "6296, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "6297, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6299, ADUSA, NORTHFIELD, OH",
            disabled: false,
          },
          {
            name: "63, ADUSA, GAFFNEY, SC",
            disabled: false,
          },
          {
            name: "63, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "63, Albertsons, SOUTH HOLLAND, IL",
            disabled: false,
          },
          {
            name: "63, BJ's, YORK, PA",
            disabled: false,
          },
          {
            name: "63, Costco, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "63, HEB, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "63, Kroger, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "63, Kroger, CLACKAMAS, OR",
            disabled: false,
          },
          {
            name: "63, Kroger, HEBER CITY, UT",
            disabled: false,
          },
          {
            name: "63, Kroger, Maywood, IL",
            disabled: false,
          },
          {
            name: "63, Kroger, PRESCOTT VALLEY, AZ",
            disabled: false,
          },
          {
            name: "63, Kroger, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "63, Kroger, WELLINGTON, KS",
            disabled: false,
          },
          {
            name: "63, Meijer, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "63, Walmart, WAGONER, OK",
            disabled: false,
          },
          {
            name: "630, ADUSA, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "630, Albertsons, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "630, CVS, HARTSDALE, NY",
            disabled: false,
          },
          {
            name: "630, Costco, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "630, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "630, Kroger, Altadena, CA",
            disabled: false,
          },
          {
            name: "630, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "630, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "630, Kroger, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "630, Walmart, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "6300, ADUSA, RED LION, PA",
            disabled: false,
          },
          {
            name: "6300, Walmart, PROSPER, TX",
            disabled: false,
          },
          {
            name: "6301, ADUSA, THORNDALE, PA",
            disabled: false,
          },
          {
            name: "6302, CVS, NORTH TAZEWELL, VA",
            disabled: false,
          },
          {
            name: "6302, Rite Aid, SHAFTER, CA",
            disabled: false,
          },
          {
            name: "6302, Walgreens, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "6303, CVS, RICHLANDS, VA",
            disabled: false,
          },
          {
            name: "6304, ADUSA, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "6304, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "6304, Walgreens, KENT, WA",
            disabled: false,
          },
          {
            name: "6305, ADUSA, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "6305, CVS, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "6306, ADUSA, DOVER, PA",
            disabled: false,
          },
          {
            name: "6307, CVS, GASSAWAY, WV",
            disabled: false,
          },
          {
            name: "6307, Walgreens, MUKILTEO, WA",
            disabled: false,
          },
          {
            name: "6308, Walgreens, NORWALK, CT",
            disabled: false,
          },
          {
            name: "631, ADUSA, GLASTONBURY, CT",
            disabled: false,
          },
          {
            name: "631, Albertsons, VAIL, CO",
            disabled: false,
          },
          {
            name: "631, CVS, PEARL RIVER, NY",
            disabled: false,
          },
          {
            name: "631, Costco, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "631, HEB, GRANBURY, TX",
            disabled: false,
          },
          {
            name: "631, Kroger, Long Beach, CA",
            disabled: false,
          },
          {
            name: "631, Kroger, OPELIKA, AL",
            disabled: false,
          },
          {
            name: "631, Walmart, EASLEY, SC",
            disabled: false,
          },
          {
            name: "6310, ADUSA, DILLSBURG, PA",
            disabled: false,
          },
          {
            name: "6310, CVS, BLUEFIELD, WV",
            disabled: false,
          },
          {
            name: "6310, Rite Aid, SALINAS, CA",
            disabled: false,
          },
          {
            name: "6310, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "6311, CVS, GAULEY BRIDGE, WV",
            disabled: false,
          },
          {
            name: "6311, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "6312, CVS, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "6313, ADUSA, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "6313, Rite Aid, COMPTON, CA",
            disabled: false,
          },
          {
            name: "6313, Walgreens, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "6314, ADUSA, COOPERSBURG, PA",
            disabled: false,
          },
          {
            name: "6314, CVS, PRINCETON, WV",
            disabled: false,
          },
          {
            name: "6315, Walgreens, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "6317, ADUSA, ROYERSFORD, PA",
            disabled: false,
          },
          {
            name: "6318, CVS, ATHENS, WV",
            disabled: false,
          },
          {
            name: "6318, Rite Aid, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "6319, ADUSA, COPLAY, PA",
            disabled: false,
          },
          {
            name: "6319, CVS, TEXAS CITY, TX",
            disabled: false,
          },
          {
            name: "6319, Walgreens, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "632, ADUSA, ROCKY HILL, CT",
            disabled: false,
          },
          {
            name: "632, CVS, DRACUT, MA",
            disabled: false,
          },
          {
            name: "632, Costco, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "632, Kroger, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "632, Kroger, Glendale, CA",
            disabled: false,
          },
          {
            name: "632, Kroger, Little Rock, AR",
            disabled: false,
          },
          {
            name: "632, Kroger, NOVI, MI",
            disabled: false,
          },
          {
            name: "632, Target, FORT GRATIOT, MI",
            disabled: false,
          },
          {
            name: "632, Walmart, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "6320, ADUSA, LEHIGHTON, PA",
            disabled: false,
          },
          {
            name: "6320, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "6321, ADUSA, NAZARETH, PA",
            disabled: false,
          },
          {
            name: "6321, CVS, CLIFTON FORGE, VA",
            disabled: false,
          },
          {
            name: "6321, Walgreens, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "6322, CVS, STAUNTON, VA",
            disabled: false,
          },
          {
            name: "6323, Walgreens, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "6323, Walmart, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "6324, ADUSA, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "6325, CVS, LEXINGTON, VA",
            disabled: false,
          },
          {
            name: "6325, Rite Aid, KENMORE, WA",
            disabled: false,
          },
          {
            name: "6325, Walgreens, POWDER SPRINGS, GA",
            disabled: false,
          },
          {
            name: "6326, CVS, COVINGTON, VA",
            disabled: false,
          },
          {
            name: "6326, Walgreens, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "6327, CVS, WYTHEVILLE, VA",
            disabled: false,
          },
          {
            name: "6327, Walgreens, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "6328, Walgreens, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "6329, ADUSA, LANSDOWNE, PA",
            disabled: false,
          },
          {
            name: "6329, CVS, BLACKSBURG, VA",
            disabled: false,
          },
          {
            name: "6329, Walgreens, WYLIE, TX",
            disabled: false,
          },
          {
            name: "633, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "633, Costco, HELENA, MT",
            disabled: false,
          },
          {
            name: "633, Kroger, McDonough, GA",
            disabled: false,
          },
          {
            name: "633, Kroger, North Little Rock, AR",
            disabled: false,
          },
          {
            name: "633, Walmart, KEWANEE, IL",
            disabled: false,
          },
          {
            name: "6330, ADUSA, EASTON, PA",
            disabled: false,
          },
          {
            name: "6330, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "6331, ADUSA, MECHANICSBURG, PA",
            disabled: false,
          },
          {
            name: "6331, Walgreens, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "6332, ADUSA, LEWISBURG, PA",
            disabled: false,
          },
          {
            name: "6332, Walgreens, DOLTON, IL",
            disabled: false,
          },
          {
            name: "6333, ADUSA, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "6333, CVS, LEWISBURG, WV",
            disabled: false,
          },
          {
            name: "6333, Rite Aid, LA MIRADA, CA",
            disabled: false,
          },
          {
            name: "6333, Walgreens, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "6334, CVS, VERSAILLES, KY",
            disabled: false,
          },
          {
            name: "6334, Walgreens, NORTH BELLMORE, NY",
            disabled: false,
          },
          {
            name: "6335, ADUSA, WHITEHALL, PA",
            disabled: false,
          },
          {
            name: "6335, CVS, DANVILLE, KY",
            disabled: false,
          },
          {
            name: "6335, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "6336, ADUSA, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "6336, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "6337, CVS, MOUNT STERLING, KY",
            disabled: false,
          },
          {
            name: "6337, Walgreens, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "6338, CVS, CAMPBELLSVILLE, KY",
            disabled: false,
          },
          {
            name: "6338, Rite Aid, POMONA, CA",
            disabled: false,
          },
          {
            name: "6339, CVS, SOMERSET, KY",
            disabled: false,
          },
          {
            name: "634, ADUSA, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "634, Albertsons, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "634, CVS, KINGSTON, MA",
            disabled: false,
          },
          {
            name: "634, Costco, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "634, Kroger, COMMERCE TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "634, Kroger, DALLAS, GA",
            disabled: false,
          },
          {
            name: "634, Target, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "634, Walmart, CAMDEN, SC",
            disabled: false,
          },
          {
            name: "6340, CVS, SOUTH WILLIAMSON, KY",
            disabled: false,
          },
          {
            name: "6340, Walgreens, TULLAHOMA, TN",
            disabled: false,
          },
          {
            name: "6341, CVS, HARLAN, KY",
            disabled: false,
          },
          {
            name: "6341, Walgreens, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "6342, CVS, LONDON, KY",
            disabled: false,
          },
          {
            name: "6342, Rite Aid, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "6343, Walgreens, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "6344, CVS, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "6344, Walgreens, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "6345, CVS, WINCHESTER, KY",
            disabled: false,
          },
          {
            name: "6345, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "6346, CVS, RICHMOND, KY",
            disabled: false,
          },
          {
            name: "6346, Rite Aid, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "6346, Walgreens, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "6347, CVS, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "6347, Rite Aid, EPHRATA, WA",
            disabled: false,
          },
          {
            name: "6347, Walgreens, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "6348, ADUSA, RAVENNA, OH",
            disabled: false,
          },
          {
            name: "6348, CVS, HARRODSBURG, KY",
            disabled: false,
          },
          {
            name: "6349, CVS, IRONTON, OH",
            disabled: false,
          },
          {
            name: "6349, Walgreens, DORCHESTER CENTER, MA",
            disabled: false,
          },
          {
            name: "635, ADUSA, ANSONIA, CT",
            disabled: false,
          },
          {
            name: "635, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "635, CVS, WHITMAN, MA",
            disabled: false,
          },
          {
            name: "635, Costco, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "635, Kroger, Brinkley, AR",
            disabled: false,
          },
          {
            name: "635, Kroger, DACULA, GA",
            disabled: false,
          },
          {
            name: "635, Kroger, ESSEXVILLE, MI",
            disabled: false,
          },
          {
            name: "635, Kroger, Sun Valley, CA",
            disabled: false,
          },
          {
            name: "635, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6350, CVS, KENOVA, WV",
            disabled: false,
          },
          {
            name: "6350, Walgreens, OLIVETTE, MO",
            disabled: false,
          },
          {
            name: "6352, Walgreens, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "6353, Rite Aid, ALTURAS, CA",
            disabled: false,
          },
          {
            name: "6353, Walgreens, EAST RIDGE, TN",
            disabled: false,
          },
          {
            name: "6355, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6355, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "6356, Rite Aid, ANTIOCH, CA",
            disabled: false,
          },
          {
            name: "6357, CVS, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "6357, Walgreens, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "6358, Walgreens, TYLER, TX",
            disabled: false,
          },
          {
            name: "6359, ADUSA, NORTH OLMSTED, OH",
            disabled: false,
          },
          {
            name: "6359, CVS, ALCOA, TN",
            disabled: false,
          },
          {
            name: "6359, Walgreens, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "636, ADUSA, NEWTOWN, CT",
            disabled: false,
          },
          {
            name: "636, CVS, SANDWICH, MA",
            disabled: false,
          },
          {
            name: "636, Costco, DUNCANVILLE, TX",
            disabled: false,
          },
          {
            name: "636, Kroger, DULUTH, GA",
            disabled: false,
          },
          {
            name: "636, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "636, Rite Aid, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "636, Target, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "636, Walmart, PRINCETON, IL",
            disabled: false,
          },
          {
            name: "6360, CVS, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "6361, CVS, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "6361, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6362, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6363, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6363, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "6364, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6365, CVS, CLINTON, TN",
            disabled: false,
          },
          {
            name: "6365, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "6366, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6366, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6368, CVS, VISTA, CA",
            disabled: false,
          },
          {
            name: "6369, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6369, Walgreens, LANSING, MI",
            disabled: false,
          },
          {
            name: "637, Albertsons, STEAMBOAT SPRINGS, CO",
            disabled: false,
          },
          {
            name: "637, Costco, GYPSUM, CO",
            disabled: false,
          },
          {
            name: "637, Kroger, BENTON, AR",
            disabled: false,
          },
          {
            name: "637, Kroger, LAKE ORION, MI",
            disabled: false,
          },
          {
            name: "637, Kroger, Sylmar, CA",
            disabled: false,
          },
          {
            name: "637, Target, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "637, Walmart, LEXINGTON, NE",
            disabled: false,
          },
          {
            name: "6370, CVS, MOUNT VERNON, IL",
            disabled: false,
          },
          {
            name: "6370, Walgreens, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "6370, Walmart, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "6371, CVS, OLNEY, IL",
            disabled: false,
          },
          {
            name: "6371, Walgreens, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "6372, CVS, BENTON, IL",
            disabled: false,
          },
          {
            name: "6372, Walgreens, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "6373, CVS, WEST FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "6373, Walgreens, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "6374, CVS, ORANGE, TX",
            disabled: false,
          },
          {
            name: "6374, Walgreens, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "6375, ADUSA, ELYRIA, OH",
            disabled: false,
          },
          {
            name: "6376, CVS, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "6377, ADUSA, PAINESVILLE, OH",
            disabled: false,
          },
          {
            name: "6377, CVS, MADISONVILLE, KY",
            disabled: false,
          },
          {
            name: "6377, Walgreens, PALOS PARK, IL",
            disabled: false,
          },
          {
            name: "6378, Rite Aid, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6378, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6379, ADUSA, HOMESTEAD, PA",
            disabled: false,
          },
          {
            name: "6379, Rite Aid, LIVINGSTON, CA",
            disabled: false,
          },
          {
            name: "638, ADUSA, HICKORY, NC",
            disabled: false,
          },
          {
            name: "638, ADUSA, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "638, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "638, CVS, GIBBSBORO, NJ",
            disabled: false,
          },
          {
            name: "638, Costco, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "638, Kroger, Brighton Township, MI",
            disabled: false,
          },
          {
            name: "638, Kroger, Brighton, MI",
            disabled: false,
          },
          {
            name: "638, Kroger, JEFFERSON, GA",
            disabled: false,
          },
          {
            name: "638, Kroger, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "638, Target, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "638, Walmart, GAFFNEY, SC",
            disabled: false,
          },
          {
            name: "6380, CVS, MAYFIELD, KY",
            disabled: false,
          },
          {
            name: "6380, Walgreens, POCATELLO, ID",
            disabled: false,
          },
          {
            name: "6381, ADUSA, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "6381, CVS, ORANGE, TX",
            disabled: false,
          },
          {
            name: "6382, Walgreens, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "6383, CVS, MARION, KY",
            disabled: false,
          },
          {
            name: "6383, Walgreens, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "6384, ADUSA, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "6384, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "6385, ADUSA, CANFIELD, OH",
            disabled: false,
          },
          {
            name: "6385, CVS, FLORA, IL",
            disabled: false,
          },
          {
            name: "6385, Walgreens, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "6386, CVS, LAWRENCEVILLE, IL",
            disabled: false,
          },
          {
            name: "6386, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6387, Walgreens, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "6388, CVS, MARION, IL",
            disabled: false,
          },
          {
            name: "6388, Walgreens, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "6389, CVS, SALEM, IL",
            disabled: false,
          },
          {
            name: "6389, Rite Aid, OAKHURST, CA",
            disabled: false,
          },
          {
            name: "6389, Walgreens, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "639, Albertsons, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "639, CVS, NASHUA, NH",
            disabled: false,
          },
          {
            name: "639, Costco, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "639, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "639, Kroger, Lawrenceville, GA",
            disabled: false,
          },
          {
            name: "639, Kroger, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "639, Kroger, Palmdale, CA",
            disabled: false,
          },
          {
            name: "639, Kroger, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "639, Rite Aid, UTICA, NY",
            disabled: false,
          },
          {
            name: "639, Target, MESA, AZ",
            disabled: false,
          },
          {
            name: "639, Walmart, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "6390, Walgreens, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "6390, Walmart, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6391, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6392, Walmart, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "6393, CVS, DICKSON, TN",
            disabled: false,
          },
          {
            name: "6394, CVS, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "6394, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "6394, Walmart, BROWN DEER, WI",
            disabled: false,
          },
          {
            name: "6395, CVS, LAWRENCEBURG, TN",
            disabled: false,
          },
          {
            name: "6395, Rite Aid, CORCORAN, CA",
            disabled: false,
          },
          {
            name: "6395, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "6395, Walmart, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "6396, CVS, YAZOO CITY, MS",
            disabled: false,
          },
          {
            name: "6396, Rite Aid, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "6396, Walgreens, ROSEDALE, MD",
            disabled: false,
          },
          {
            name: "6397, Walmart, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6398, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6398, Walmart, DELTONA, FL",
            disabled: false,
          },
          {
            name: "6399, CVS, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "6399, Walgreens, YUCCA VALLEY, CA",
            disabled: false,
          },
          {
            name: "64, ADUSA, MCKEESPORT, PA",
            disabled: false,
          },
          {
            name: "64, ADUSA, ORLEANS, MA",
            disabled: false,
          },
          {
            name: "64, ADUSA, STATESVILLE, NC",
            disabled: false,
          },
          {
            name: "64, Albertsons, GARDEN CITY, NY",
            disabled: false,
          },
          {
            name: "64, Albertsons, SHERIDAN, WY",
            disabled: false,
          },
          {
            name: "64, BJ's, UTICA, NY",
            disabled: false,
          },
          {
            name: "64, Costco, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "64, HEB, WACO, TX",
            disabled: false,
          },
          {
            name: "64, Kroger, EVERGREEN, CO",
            disabled: false,
          },
          {
            name: "64, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "64, Kroger, Gurnee, IL",
            disabled: false,
          },
          {
            name: "64, Kroger, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "64, Meijer, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "64, Target, BOULDER, CO",
            disabled: false,
          },
          {
            name: "64, Walmart, BROWNSVILLE, TN",
            disabled: false,
          },
          {
            name: "640, ADUSA, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "640, ADUSA, NORWALK, CT",
            disabled: false,
          },
          {
            name: "640, Albertsons, APTOS, CA",
            disabled: false,
          },
          {
            name: "640, CVS, KEENE, NH",
            disabled: false,
          },
          {
            name: "640, Costco, LIHUE (KAUAI), HI",
            disabled: false,
          },
          {
            name: "640, Kroger, Lakewood, CO",
            disabled: false,
          },
          {
            name: "640, Kroger, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "640, Kroger, Searcy, AR",
            disabled: false,
          },
          {
            name: "640, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "6400, CVS, SHELBYVILLE, TN",
            disabled: false,
          },
          {
            name: "6400, Rite Aid, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "6400, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6401, CVS, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "6401, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6402, CVS, DAVIDSON, NC",
            disabled: false,
          },
          {
            name: "6403, CVS, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "6403, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6403, Walgreens, WESTON, FL",
            disabled: false,
          },
          {
            name: "6404, Walgreens, DAVIE, FL",
            disabled: false,
          },
          {
            name: "6405, CVS, SHELBY, NC",
            disabled: false,
          },
          {
            name: "6405, Walgreens, PALM BEACH GARDENS, FL",
            disabled: false,
          },
          {
            name: "6406, CVS, DALLAS, NC",
            disabled: false,
          },
          {
            name: "6407, CVS, KINGS MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "6407, Walgreens, KEY LARGO, FL",
            disabled: false,
          },
          {
            name: "6408, CVS, CONOVER, NC",
            disabled: false,
          },
          {
            name: "6408, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "6409, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6409, Walgreens, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "641, ADUSA, BRIDGEVILLE, PA",
            disabled: false,
          },
          {
            name: "641, ADUSA, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "641, CVS, ORANGEBURG, NY",
            disabled: false,
          },
          {
            name: "641, Costco, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "641, HEB, GONZALES, TX",
            disabled: false,
          },
          {
            name: "641, Kroger, BONAIRE, GA",
            disabled: false,
          },
          {
            name: "641, Kroger, Newport, AR",
            disabled: false,
          },
          {
            name: "641, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "641, Kroger, PORT CLINTON, OH",
            disabled: false,
          },
          {
            name: "641, Target, MERCED, CA",
            disabled: false,
          },
          {
            name: "641, Walmart, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "6410, CVS, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "6411, CVS, UPPER ARLINGTON, OH",
            disabled: false,
          },
          {
            name: "6411, Walgreens, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "6412, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6412, Walgreens, WESLEY CHAPEL, FL",
            disabled: false,
          },
          {
            name: "6413, CVS, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "6413, Walgreens, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "6414, ADUSA, MAPLE HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "6414, CVS, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "6414, Walgreens, MARGATE, FL",
            disabled: false,
          },
          {
            name: "6415, CVS, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "6416, CVS, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6416, Walgreens, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "6417, Walgreens, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "6418, Walgreens, LOS BANOS, CA",
            disabled: false,
          },
          {
            name: "6419, Walgreens, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "642, ADUSA, BRISTOL, CT",
            disabled: false,
          },
          {
            name: "642, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "642, CVS, WARWICK, RI",
            disabled: false,
          },
          {
            name: "642, Costco, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "642, HEB, PHARR, TX",
            disabled: false,
          },
          {
            name: "642, Kroger, FERNDALE, MI",
            disabled: false,
          },
          {
            name: "642, Kroger, HARRISBURG, IL",
            disabled: false,
          },
          {
            name: "642, Kroger, NORTH LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "642, Kroger, Tucson, AZ",
            disabled: false,
          },
          {
            name: "642, Kroger, Ventura, CA",
            disabled: false,
          },
          {
            name: "642, Rite Aid, WHITESBORO, NY",
            disabled: false,
          },
          {
            name: "642, Target, DELRAY BEACH, FL",
            disabled: false,
          },
          {
            name: "642, Walmart, CHERAW, SC",
            disabled: false,
          },
          {
            name: "6420, CVS, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6420, Walgreens, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "6421, CVS, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "6422, ADUSA, TEMPLE, PA",
            disabled: false,
          },
          {
            name: "6422, CVS, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "6422, Walgreens, SILVERDALE, WA",
            disabled: false,
          },
          {
            name: "6423, CVS, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "6423, Walgreens, BREMERTON, WA",
            disabled: false,
          },
          {
            name: "6424, CVS, MADISON, TN",
            disabled: false,
          },
          {
            name: "6424, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "6425, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "6426, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "6427, ADUSA, WILLOW GROVE, PA",
            disabled: false,
          },
          {
            name: "6427, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6427, Walgreens, BRIDGEVIEW, IL",
            disabled: false,
          },
          {
            name: "6429, CVS, LEBANON, TN",
            disabled: false,
          },
          {
            name: "6429, Walgreens, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "643, Costco, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "643, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "643, ShopRite, RIO GRANDE, NJ",
            disabled: false,
          },
          {
            name: "643, Target, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "643, Walmart, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "6430, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "6431, CVS, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "6431, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "6432, Rite Aid, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "6432, Walgreens, BRENTWOOD, MO",
            disabled: false,
          },
          {
            name: "6433, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6434, CVS, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "6434, Rite Aid, ESCALON, CA",
            disabled: false,
          },
          {
            name: "6435, CVS, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "6435, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6436, Walgreens, EDMOND, OK",
            disabled: false,
          },
          {
            name: "6437, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6437, Walgreens, LYNDON, KY",
            disabled: false,
          },
          {
            name: "6438, CVS, SPRINGFIELD, TN",
            disabled: false,
          },
          {
            name: "6438, Rite Aid, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "6438, Walgreens, CHINO, CA",
            disabled: false,
          },
          {
            name: "6439, Walgreens, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "644, ADUSA, DANBURY, CT",
            disabled: false,
          },
          {
            name: "644, Costco, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "644, HEB, BRYAN, TX",
            disabled: false,
          },
          {
            name: "644, Kroger, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "644, Kroger, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "644, Kroger, Santa Barbara, CA",
            disabled: false,
          },
          {
            name: "644, Walmart, ANDERSON, SC",
            disabled: false,
          },
          {
            name: "6440, Walgreens, GOLD CANYON, AZ",
            disabled: false,
          },
          {
            name: "6441, CVS, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "6441, Rite Aid, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "6442, ADUSA, HAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "6442, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6443, ADUSA, CHAMBERSBURG, PA",
            disabled: false,
          },
          {
            name: "6443, Rite Aid, MARIPOSA, CA",
            disabled: false,
          },
          {
            name: "6443, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6444, CVS, CANTON, IL",
            disabled: false,
          },
          {
            name: "6445, ADUSA, HATFIELD, PA",
            disabled: false,
          },
          {
            name: "6446, ADUSA, READING, PA",
            disabled: false,
          },
          {
            name: "6446, CVS, BARTONVILLE, IL",
            disabled: false,
          },
          {
            name: "6446, Walgreens, STANTON, CA",
            disabled: false,
          },
          {
            name: "6447, ADUSA, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "6447, Walgreens, MOUNDS VIEW, MN",
            disabled: false,
          },
          {
            name: "6448, ADUSA, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "6448, CVS, WASHINGTON, IL",
            disabled: false,
          },
          {
            name: "6448, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6448, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "6449, ADUSA, MANCHESTER, PA",
            disabled: false,
          },
          {
            name: "645, ADUSA, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "645, Albertsons, CHESTNUT HILL, MA",
            disabled: false,
          },
          {
            name: "645, CVS, BRISTOL, RI",
            disabled: false,
          },
          {
            name: "645, Costco, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "645, Kroger, EL SEGUNDO, CA",
            disabled: false,
          },
          {
            name: "645, Kroger, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "645, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "645, Walmart, NORFOLK, NE",
            disabled: false,
          },
          {
            name: "6450, CVS, CHILLICOTHE, IL",
            disabled: false,
          },
          {
            name: "6451, CVS, PEKIN, IL",
            disabled: false,
          },
          {
            name: "6451, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6452, Rite Aid, FERNDALE, WA",
            disabled: false,
          },
          {
            name: "6453, ADUSA, SELINSGROVE, PA",
            disabled: false,
          },
          {
            name: "6453, CVS, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "6453, Walgreens, MADERA, CA",
            disabled: false,
          },
          {
            name: "6454, Rite Aid, TULARE, CA",
            disabled: false,
          },
          {
            name: "6454, Walgreens, BROWNSBURG, IN",
            disabled: false,
          },
          {
            name: "6455, ADUSA, BARTONSVILLE, PA",
            disabled: false,
          },
          {
            name: "6455, CVS, PEORIA, IL",
            disabled: false,
          },
          {
            name: "6455, Rite Aid, RENTON, WA",
            disabled: false,
          },
          {
            name: "6455, Walgreens, MOORESVILLE, IN",
            disabled: false,
          },
          {
            name: "6456, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "6456, Rite Aid, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "6456, Walgreens, WEST LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "6457, ADUSA, TREXLERTOWN, PA",
            disabled: false,
          },
          {
            name: "6458, CVS, EUREKA, IL",
            disabled: false,
          },
          {
            name: "6458, Walgreens, MEDINA, OH",
            disabled: false,
          },
          {
            name: "6459, Rite Aid, VISALIA, CA",
            disabled: false,
          },
          {
            name: "6459, Walmart, HARKER HEIGHTS, TX",
            disabled: false,
          },
          {
            name: "646, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "646, ADUSA, STAMFORD, CT",
            disabled: false,
          },
          {
            name: "646, Costco, SPARKS, NV",
            disabled: false,
          },
          {
            name: "646, Kroger, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "646, Walmart, ANAMOSA, IA",
            disabled: false,
          },
          {
            name: "6460, CVS, ELKHART, IN",
            disabled: false,
          },
          {
            name: "6461, Walgreens, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "6462, CVS, WARSAW, IN",
            disabled: false,
          },
          {
            name: "6462, Rite Aid, KINGSTON, WA",
            disabled: false,
          },
          {
            name: "6462, Walgreens, FRANKLIN PARK, IL",
            disabled: false,
          },
          {
            name: "6463, ADUSA, GILBERTSVILLE, PA",
            disabled: false,
          },
          {
            name: "6463, CVS, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "6463, Walgreens, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "6464, ADUSA, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "6464, CVS, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "6464, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "6465, Rite Aid, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "6465, Walgreens, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "6466, CVS, SWANSEA, MA",
            disabled: false,
          },
          {
            name: "6467, CVS, NAPPANEE, IN",
            disabled: false,
          },
          {
            name: "6467, Walgreens, SUPERIOR, CO",
            disabled: false,
          },
          {
            name: "6467, Walmart, TYLER, TX",
            disabled: false,
          },
          {
            name: "6468, ADUSA, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "6468, CVS, BREMEN, IN",
            disabled: false,
          },
          {
            name: "6468, Rite Aid, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "6469, CVS, ELKHART, IN",
            disabled: false,
          },
          {
            name: "6469, Rite Aid, NORCO, CA",
            disabled: false,
          },
          {
            name: "6469, Walgreens, YORKVILLE, IL",
            disabled: false,
          },
          {
            name: "6469, Walmart, BYRAM, MS",
            disabled: false,
          },
          {
            name: "647, ADUSA, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "647, ADUSA, MILFORD, CT",
            disabled: false,
          },
          {
            name: "647, CVS, WEST LEBANON, NH",
            disabled: false,
          },
          {
            name: "647, Costco, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "647, Kroger, Clinton Township, MI",
            disabled: false,
          },
          {
            name: "647, Kroger, MORTON, IL",
            disabled: false,
          },
          {
            name: "647, Kroger, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "647, Target, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "647, Walmart, GRINNELL, IA",
            disabled: false,
          },
          {
            name: "6470, Walgreens, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "6470, Walmart, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "6471, ADUSA, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "6471, Walgreens, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "6472, ADUSA, HARLEYSVILLE, PA",
            disabled: false,
          },
          {
            name: "6472, CVS, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "6472, Rite Aid, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "6473, CVS, GRANGER, IN",
            disabled: false,
          },
          {
            name: "6473, Rite Aid, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "6473, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "6474, ADUSA, PERKASIE, PA",
            disabled: false,
          },
          {
            name: "6474, CVS, PLYMOUTH, IN",
            disabled: false,
          },
          {
            name: "6474, Walgreens, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "6475, ADUSA, PLUMSTEADVILLE, PA",
            disabled: false,
          },
          {
            name: "6475, CVS, ELKHART, IN",
            disabled: false,
          },
          {
            name: "6475, Rite Aid, LEMOORE, CA",
            disabled: false,
          },
          {
            name: "6475, Walgreens, WILLOWBROOK, IL",
            disabled: false,
          },
          {
            name: "6476, ADUSA, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "6476, Walmart, DANVILLE, IN",
            disabled: false,
          },
          {
            name: "6477, ADUSA, MALVERN, PA",
            disabled: false,
          },
          {
            name: "6477, Walgreens, NORMAN, OK",
            disabled: false,
          },
          {
            name: "6477, Walmart, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6478, ADUSA, EXTON, PA",
            disabled: false,
          },
          {
            name: "6478, Walgreens, MERRIAM, KS",
            disabled: false,
          },
          {
            name: "6479, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6479, Walgreens, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "648, ADUSA, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "648, Costco, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "648, Kroger, BURBANK, CA",
            disabled: false,
          },
          {
            name: "648, Walmart, SAINT PETERS, MO",
            disabled: false,
          },
          {
            name: "6480, ADUSA, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "6480, Rite Aid, SHASTA LAKE, CA",
            disabled: false,
          },
          {
            name: "6480, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "6480, Walmart, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "6481, ADUSA, CONSHOHOCKEN, PA",
            disabled: false,
          },
          {
            name: "6481, CVS, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "6481, Rite Aid, WILDOMAR, CA",
            disabled: false,
          },
          {
            name: "6481, Walgreens, DECATUR, GA",
            disabled: false,
          },
          {
            name: "6483, Walgreens, PHENIX CITY, AL",
            disabled: false,
          },
          {
            name: "6484, ADUSA, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "6484, CVS, MICHIGAN CITY, IN",
            disabled: false,
          },
          {
            name: "6484, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6485, ADUSA, MOUNT JOY, PA",
            disabled: false,
          },
          {
            name: "6485, CVS, WALKERTON, IN",
            disabled: false,
          },
          {
            name: "6485, Walgreens, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "6486, ADUSA, KUTZTOWN, PA",
            disabled: false,
          },
          {
            name: "6486, CVS, NEW CARLISLE, IN",
            disabled: false,
          },
          {
            name: "6486, Rite Aid, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "6486, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "6487, CVS, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "6487, Walgreens, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "6488, Rite Aid, KENT, WA",
            disabled: false,
          },
          {
            name: "6488, Walgreens, GARDENDALE, AL",
            disabled: false,
          },
          {
            name: "6489, Rite Aid, LAMONT, CA",
            disabled: false,
          },
          {
            name: "6489, Walgreens, SHAKOPEE, MN",
            disabled: false,
          },
          {
            name: "649, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "649, Albertsons, WATERBURY, VT",
            disabled: false,
          },
          {
            name: "649, CVS, HAMBURG, NY",
            disabled: false,
          },
          {
            name: "649, Costco, HOMESTEAD, PA",
            disabled: false,
          },
          {
            name: "649, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "649, Kroger, Orion, MI",
            disabled: false,
          },
          {
            name: "649, Kroger, PALMER, AK",
            disabled: false,
          },
          {
            name: "649, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "649, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "649, Walmart, TITUSVILLE, FL",
            disabled: false,
          },
          {
            name: "6491, CVS, VIDOR, TX",
            disabled: false,
          },
          {
            name: "6491, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6492, Rite Aid, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "6492, Walgreens, BRIDGETON, MO",
            disabled: false,
          },
          {
            name: "6493, Rite Aid, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "6493, Walgreens, LAKE SAINT LOUIS, MO",
            disabled: false,
          },
          {
            name: "6494, CVS, ANGOLA, IN",
            disabled: false,
          },
          {
            name: "6495, CVS, AUBURN, IN",
            disabled: false,
          },
          {
            name: "6495, Rite Aid, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "6496, CVS, NEW HAVEN, IN",
            disabled: false,
          },
          {
            name: "6496, Walgreens, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "6498, CVS, KENDALLVILLE, IN",
            disabled: false,
          },
          {
            name: "6498, Rite Aid, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "6498, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6499, CVS, SYRACUSE, IN",
            disabled: false,
          },
          {
            name: "6499, Walgreens, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "65, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "65, Albertsons, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "65, Costco, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "65, Kroger, Apache Junction, AZ",
            disabled: false,
          },
          {
            name: "65, Kroger, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "65, Kroger, MAGNA, UT",
            disabled: false,
          },
          {
            name: "65, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "65, Meijer, Shelby Twp., MI",
            disabled: false,
          },
          {
            name: "65, Walmart, SULLIVAN, MO",
            disabled: false,
          },
          {
            name: "650, ADUSA, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "650, CVS, NORTH CONWAY, NH",
            disabled: false,
          },
          {
            name: "650, Costco, DENVER, CO",
            disabled: false,
          },
          {
            name: "650, Kroger, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "650, Kroger, REDMOND, OR",
            disabled: false,
          },
          {
            name: "650, Kroger, ROCHESTER, MI",
            disabled: false,
          },
          {
            name: "650, Rite Aid, NORTH TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "650, Target, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6500, CVS, LIGONIER, IN",
            disabled: false,
          },
          {
            name: "6500, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "6500, Walmart, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "6501, ADUSA, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6501, ADUSA, EPHRATA, PA",
            disabled: false,
          },
          {
            name: "6501, Walgreens, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "6502, CVS, COLUMBIA CITY, IN",
            disabled: false,
          },
          {
            name: "6502, Walgreens, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "6503, CVS, NORTH WEBSTER, IN",
            disabled: false,
          },
          {
            name: "6503, Rite Aid, MARYSVILLE, WA",
            disabled: false,
          },
          {
            name: "6503, Walgreens, MILFORD, CT",
            disabled: false,
          },
          {
            name: "6504, ADUSA, EAST STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "6505, ADUSA, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "6505, CVS, NEWTON, MA",
            disabled: false,
          },
          {
            name: "6505, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6506, Walgreens, GRETNA, LA",
            disabled: false,
          },
          {
            name: "6507, ADUSA, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "6507, CVS, SAINT CLOUD, MN",
            disabled: false,
          },
          {
            name: "6507, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "6508, CVS, BUTLER, IN",
            disabled: false,
          },
          {
            name: "6508, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "6509, ADUSA, HUNTINGDON VALLEY, PA",
            disabled: false,
          },
          {
            name: "6509, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6509, Rite Aid, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "651, ADUSA, BLOOMFIELD, CT",
            disabled: false,
          },
          {
            name: "651, CVS, ZEPHYRHILLS, FL",
            disabled: false,
          },
          {
            name: "651, Costco, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "651, Kroger, CANBY, OR",
            disabled: false,
          },
          {
            name: "651, Kroger, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "651, Kroger, Decatur, GA",
            disabled: false,
          },
          {
            name: "651, Walmart, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "6510, ADUSA, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "6510, ADUSA, SPRING HOUSE, PA",
            disabled: false,
          },
          {
            name: "6510, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6510, Rite Aid, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "6510, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "6511, ADUSA, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "6512, ADUSA, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "6512, Rite Aid, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "6513, CVS, WABASH, IN",
            disabled: false,
          },
          {
            name: "6513, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "6514, ADUSA, PICKERINGTON, OH",
            disabled: false,
          },
          {
            name: "6514, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6514, Rite Aid, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "6514, Walgreens, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "6515, CVS, BLUFFTON, IN",
            disabled: false,
          },
          {
            name: "6515, Rite Aid, CALEXICO, CA",
            disabled: false,
          },
          {
            name: "6515, Walgreens, ELLENTON, FL",
            disabled: false,
          },
          {
            name: "6516, ADUSA, KENNETT SQUARE, PA",
            disabled: false,
          },
          {
            name: "6516, CVS, DECATUR, IN",
            disabled: false,
          },
          {
            name: "6517, ADUSA, LANGHORNE, PA",
            disabled: false,
          },
          {
            name: "6517, CVS, HUNTINGTON, IN",
            disabled: false,
          },
          {
            name: "6517, Walgreens, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "6518, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "6518, Walgreens, WINFIELD, IL",
            disabled: false,
          },
          {
            name: "6519, ADUSA, CHALFONT, PA",
            disabled: false,
          },
          {
            name: "6519, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "652, ADUSA, CLINTON, CT",
            disabled: false,
          },
          {
            name: "652, CVS, SAINT AUGUSTINE, FL",
            disabled: false,
          },
          {
            name: "652, Costco, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "652, Kroger, Atlanta, GA",
            disabled: false,
          },
          {
            name: "652, Kroger, CONWAY, AR",
            disabled: false,
          },
          {
            name: "652, Kroger, ELLENSBURG, WA",
            disabled: false,
          },
          {
            name: "652, Kroger, Southfield, MI",
            disabled: false,
          },
          {
            name: "652, Rite Aid, ONEONTA, NY",
            disabled: false,
          },
          {
            name: "652, Target, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "652, Walmart, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "6520, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6520, Rite Aid, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6520, Walgreens, JENSEN BEACH, FL",
            disabled: false,
          },
          {
            name: "6521, Rite Aid, GRAHAM, WA",
            disabled: false,
          },
          {
            name: "6521, Walgreens, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "6522, ADUSA, FLOURTOWN, PA",
            disabled: false,
          },
          {
            name: "6522, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6522, Rite Aid, DINUBA, CA",
            disabled: false,
          },
          {
            name: "6522, Walgreens, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "6523, ADUSA, BROOMALL, PA",
            disabled: false,
          },
          {
            name: "6524, ADUSA, STATE COLLEGE, PA",
            disabled: false,
          },
          {
            name: "6525, CVS, NORTH MANCHESTER, IN",
            disabled: false,
          },
          {
            name: "6525, Walgreens, TEXARKANA, TX",
            disabled: false,
          },
          {
            name: "6526, ADUSA, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "6526, ADUSA, NEWTOWN SQUARE, PA",
            disabled: false,
          },
          {
            name: "6526, CVS, CLAYTON, CA",
            disabled: false,
          },
          {
            name: "6526, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6527, CVS, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6527, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6528, CVS, BERNE, IN",
            disabled: false,
          },
          {
            name: "6528, Walgreens, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "6529, ADUSA, ENOLA, PA",
            disabled: false,
          },
          {
            name: "6529, ADUSA, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "6529, Rite Aid, BEAUMONT, CA",
            disabled: false,
          },
          {
            name: "653, ADUSA, WESTPORT, CT",
            disabled: false,
          },
          {
            name: "653, Albertsons, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "653, Costco, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "653, Kroger, JOHNS CREEK, GA",
            disabled: false,
          },
          {
            name: "653, Kroger, WASILLA, AK",
            disabled: false,
          },
          {
            name: "653, Walmart, HOPKINSVILLE, KY",
            disabled: false,
          },
          {
            name: "6530, Walgreens, ALBANY, OR",
            disabled: false,
          },
          {
            name: "6531, CVS, LOGANSPORT, IN",
            disabled: false,
          },
          {
            name: "6531, Walmart, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "6532, Rite Aid, INDIO, CA",
            disabled: false,
          },
          {
            name: "6532, Walgreens, SPRINGFIELD, TN",
            disabled: false,
          },
          {
            name: "6533, Walgreens, PAYSON, AZ",
            disabled: false,
          },
          {
            name: "6534, ADUSA, BROOKHAVEN, PA",
            disabled: false,
          },
          {
            name: "6534, CVS, LOGANSPORT, IN",
            disabled: false,
          },
          {
            name: "6534, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "6535, CVS, MONTICELLO, IN",
            disabled: false,
          },
          {
            name: "6535, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6536, CVS, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "6537, ADUSA, GROVEPORT, OH",
            disabled: false,
          },
          {
            name: "6537, CVS, WINAMAC, IN",
            disabled: false,
          },
          {
            name: "6537, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "6538, ADUSA, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "6538, CVS, KNOX, IN",
            disabled: false,
          },
          {
            name: "6538, Rite Aid, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "6539, ADUSA, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "6539, Rite Aid, GRANITE FALLS, WA",
            disabled: false,
          },
          {
            name: "654, ADUSA, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "654, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "654, CVS, ACTON, MA",
            disabled: false,
          },
          {
            name: "654, Costco, SOUTH SAN FRANC, CA",
            disabled: false,
          },
          {
            name: "654, Kroger, EAST WENATCHEE, WA",
            disabled: false,
          },
          {
            name: "654, Kroger, Shelby Township, MI",
            disabled: false,
          },
          {
            name: "654, Target, LARGO, FL",
            disabled: false,
          },
          {
            name: "6540, Walgreens, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "6541, Walgreens, TARPON SPRINGS, FL",
            disabled: false,
          },
          {
            name: "6542, ADUSA, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "6542, CVS, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "6542, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6543, CVS, NORTH JUDSON, IN",
            disabled: false,
          },
          {
            name: "6543, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6544, CVS, MAPLE SHADE, NJ",
            disabled: false,
          },
          {
            name: "6544, Rite Aid, BELFAIR, WA",
            disabled: false,
          },
          {
            name: "6545, ADUSA, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "6545, CVS, PERU, IN",
            disabled: false,
          },
          {
            name: "6545, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "6546, ADUSA, WALNUTPORT, PA",
            disabled: false,
          },
          {
            name: "6546, CVS, ROCHESTER, IN",
            disabled: false,
          },
          {
            name: "6546, Walgreens, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "6547, ADUSA, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "6547, Rite Aid, GALT, CA",
            disabled: false,
          },
          {
            name: "6547, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "6548, ADUSA, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "6548, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6548, Rite Aid, MAGALIA, CA",
            disabled: false,
          },
          {
            name: "6548, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "6548, Walmart, TAMPA, FL",
            disabled: false,
          },
          {
            name: "6549, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6549, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "655, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "655, HEB, KERRVILLE, TX",
            disabled: false,
          },
          {
            name: "655, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "655, Kroger, Gilbert, AZ",
            disabled: false,
          },
          {
            name: "655, Kroger, PORT ORCHARD, WA",
            disabled: false,
          },
          {
            name: "655, Target, TAMPA, FL",
            disabled: false,
          },
          {
            name: "655, Walmart, HANSON, KY",
            disabled: false,
          },
          {
            name: "6550, CVS, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "6550, Walgreens, CANTON, MI",
            disabled: false,
          },
          {
            name: "6551, CVS, MOORESVILLE, IN",
            disabled: false,
          },
          {
            name: "6551, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "6552, Walgreens, WESTMINSTER, CO",
            disabled: false,
          },
          {
            name: "6553, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6553, Rite Aid, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "6553, Walgreens, BETTENDORF, IA",
            disabled: false,
          },
          {
            name: "6554, Walgreens, PERU, IL",
            disabled: false,
          },
          {
            name: "6555, CVS, BROWNSBURG, IN",
            disabled: false,
          },
          {
            name: "6556, CVS, DANVILLE, IN",
            disabled: false,
          },
          {
            name: "6557, Rite Aid, OLIVEHURST, CA",
            disabled: false,
          },
          {
            name: "6557, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "6559, CVS, AVON, IN",
            disabled: false,
          },
          {
            name: "6559, Walgreens, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "656, ADUSA, LEONARDTOWN, MD",
            disabled: false,
          },
          {
            name: "656, ADUSA, RIDGEFIELD, CT",
            disabled: false,
          },
          {
            name: "656, CVS, KINGSVILLE, TX",
            disabled: false,
          },
          {
            name: "656, HEB, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "656, Kroger, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "656, Kroger, Bloomfield Hills, MI",
            disabled: false,
          },
          {
            name: "656, Kroger, Queen Creek, AZ",
            disabled: false,
          },
          {
            name: "656, Kroger, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "656, Target, TAMPA, FL",
            disabled: false,
          },
          {
            name: "656, Walmart, SHELBYVILLE, TN",
            disabled: false,
          },
          {
            name: "6560, Rite Aid, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "6560, Walgreens, MACON, GA",
            disabled: false,
          },
          {
            name: "6561, ADUSA, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "6561, Rite Aid, YUCAIPA, CA",
            disabled: false,
          },
          {
            name: "6561, Walgreens, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "6562, Walgreens, WAXAHACHIE, TX",
            disabled: false,
          },
          {
            name: "6563, ADUSA, QUARRYVILLE, PA",
            disabled: false,
          },
          {
            name: "6563, Walgreens, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "6564, ADUSA, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "6564, Walgreens, CALUMET CITY, IL",
            disabled: false,
          },
          {
            name: "6565, ADUSA, LEBANON, PA",
            disabled: false,
          },
          {
            name: "6565, CVS, ZIONSVILLE, IN",
            disabled: false,
          },
          {
            name: "6566, ADUSA, COLUMBIA, PA",
            disabled: false,
          },
          {
            name: "6566, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "6566, Walgreens, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "6567, ADUSA, QUARRYVILLE, PA",
            disabled: false,
          },
          {
            name: "6567, Walgreens, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "6568, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "6569, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6569, Walgreens, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "657, ADUSA, FOREST, VA",
            disabled: false,
          },
          {
            name: "657, ADUSA, WATERTOWN, CT",
            disabled: false,
          },
          {
            name: "657, Albertsons, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "657, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "657, Costco, FRESNO, CA",
            disabled: false,
          },
          {
            name: "657, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "657, Kroger, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "657, Kroger, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "657, Kroger, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "657, Kroger, WASHINGTON, IL",
            disabled: false,
          },
          {
            name: "657, Target, BEMIDJI, MN",
            disabled: false,
          },
          {
            name: "657, Walmart, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "6570, Walgreens, SHEBOYGAN, WI",
            disabled: false,
          },
          {
            name: "6571, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6572, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6573, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6573, Walgreens, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "6574, CVS, CICERO, IN",
            disabled: false,
          },
          {
            name: "6574, Walgreens, LORAIN, OH",
            disabled: false,
          },
          {
            name: "6576, Walmart, NORTH AUGUSTA, SC",
            disabled: false,
          },
          {
            name: "6577, Walgreens, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "6577, Walmart, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "6578, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6578, Walgreens, DESTIN, FL",
            disabled: false,
          },
          {
            name: "6578, Walmart, RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "6579, Walgreens, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "6579, Walmart, NEW CANEY, TX",
            disabled: false,
          },
          {
            name: "658, ADUSA, BERLIN, MD",
            disabled: false,
          },
          {
            name: "658, ADUSA, WILTON, CT",
            disabled: false,
          },
          {
            name: "658, CVS, WARMINSTER, PA",
            disabled: false,
          },
          {
            name: "658, Costco, TRACY, CA",
            disabled: false,
          },
          {
            name: "658, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "658, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "658, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "658, Kroger, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "658, Kroger, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "658, Target, MOORHEAD, MN",
            disabled: false,
          },
          {
            name: "658, Walmart, ROME, GA",
            disabled: false,
          },
          {
            name: "6580, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6580, Walgreens, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "6582, CVS, VENICE, CA",
            disabled: false,
          },
          {
            name: "6582, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "6583, CVS, BEECH GROVE, IN",
            disabled: false,
          },
          {
            name: "6583, Walgreens, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "6583, Walmart, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "6584, Walgreens, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "6585, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6585, Walgreens, CAMPBELL, CA",
            disabled: false,
          },
          {
            name: "6585, Walmart, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "6586, Walmart, CONCORD, NC",
            disabled: false,
          },
          {
            name: "6587, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "6587, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6588, Walgreens, AVON LAKE, OH",
            disabled: false,
          },
          {
            name: "6588, Walmart, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "6589, Walgreens, AUSTINTOWN, OH",
            disabled: false,
          },
          {
            name: "659, ADUSA, DANBURY, CT",
            disabled: false,
          },
          {
            name: "659, ADUSA, WADESBORO, NC",
            disabled: false,
          },
          {
            name: "659, Albertsons, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "659, Costco, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "659, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "659, Kroger, TUMWATER, WA",
            disabled: false,
          },
          {
            name: "659, Kroger, White Lake, MI",
            disabled: false,
          },
          {
            name: "659, Target, BAXTER, MN",
            disabled: false,
          },
          {
            name: "659, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6590, CVS, BRYAN, TX",
            disabled: false,
          },
          {
            name: "6590, Walmart, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "6592, Walgreens, WARWICK, RI",
            disabled: false,
          },
          {
            name: "6592, Walmart, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "6593, Walgreens, BENBROOK, TX",
            disabled: false,
          },
          {
            name: "6594, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6595, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6596, CVS, HAMPTON, NH",
            disabled: false,
          },
          {
            name: "6597, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6597, Walgreens, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "6599, CVS, FORTVILLE, IN",
            disabled: false,
          },
          {
            name: "6599, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "66, ADUSA, BEAVER FALLS, PA",
            disabled: false,
          },
          {
            name: "66, ADUSA, MARSTONS MILLS, MA",
            disabled: false,
          },
          {
            name: "66, Albertsons, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "66, BJ's, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "66, Costco, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "66, Kroger, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "66, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "66, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "66, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "66, Meijer, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "66, Walmart, CLARKSVILLE, AR",
            disabled: false,
          },
          {
            name: "660, ADUSA, WEST NEWTON, PA",
            disabled: false,
          },
          {
            name: "660, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "660, Costco, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "660, HEB, CONROE, TX",
            disabled: false,
          },
          {
            name: "660, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "660, Kroger, MURPHYSBORO, IL",
            disabled: false,
          },
          {
            name: "660, Kroger, WOOD VILLAGE, OR",
            disabled: false,
          },
          {
            name: "660, Target, FONTANA, CA",
            disabled: false,
          },
          {
            name: "660, Walmart, MUSCLE SHOALS, AL",
            disabled: false,
          },
          {
            name: "6601, Walgreens, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "6602, CVS, FISHERS, IN",
            disabled: false,
          },
          {
            name: "6603, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6603, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6604, Walgreens, PEORIA, IL",
            disabled: false,
          },
          {
            name: "6605, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6606, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6608, CVS, NEW PALESTINE, IN",
            disabled: false,
          },
          {
            name: "6608, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "6609, Walgreens, SEVIERVILLE, TN",
            disabled: false,
          },
          {
            name: "661, Costco, MODESTO, CA",
            disabled: false,
          },
          {
            name: "661, Kroger, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "661, Kroger, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "661, Target, WILLMAR, MN",
            disabled: false,
          },
          {
            name: "661, Walmart, ATHENS, AL",
            disabled: false,
          },
          {
            name: "6610, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6610, Walgreens, LOS LUNAS, NM",
            disabled: false,
          },
          {
            name: "6611, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6611, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "6612, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6612, Walgreens, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "6613, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6613, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6614, CVS, HAVRE DE GRACE, MD",
            disabled: false,
          },
          {
            name: "6614, Walgreens, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "6615, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "6616, CVS, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "6616, Walgreens, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "6617, CVS, ELWOOD, IN",
            disabled: false,
          },
          {
            name: "6618, CVS, ALEXANDRIA, IN",
            disabled: false,
          },
          {
            name: "6618, Walgreens, BARTLESVILLE, OK",
            disabled: false,
          },
          {
            name: "6619, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "662, ADUSA, NORWALK, CT",
            disabled: false,
          },
          {
            name: "662, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "662, Costco, BURLINGTON, WA",
            disabled: false,
          },
          {
            name: "662, HEB, TEXAS CITY, TX",
            disabled: false,
          },
          {
            name: "662, Kroger, BOISE, ID",
            disabled: false,
          },
          {
            name: "662, Target, COTTAGE GROVE, MN",
            disabled: false,
          },
          {
            name: "662, Walmart, DECATUR, AL",
            disabled: false,
          },
          {
            name: "6620, CVS, WINCHESTER, IN",
            disabled: false,
          },
          {
            name: "6620, Walgreens, ROSELLE, NJ",
            disabled: false,
          },
          {
            name: "6621, CVS, MARION, IN",
            disabled: false,
          },
          {
            name: "6621, Walgreens, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "6622, CVS, HARTFORD CITY, IN",
            disabled: false,
          },
          {
            name: "6623, CVS, MUNCIE, IN",
            disabled: false,
          },
          {
            name: "6623, Walgreens, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "6624, CVS, PORTLAND, IN",
            disabled: false,
          },
          {
            name: "6625, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "6625, Walgreens, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "6626, CVS, GAS CITY, IN",
            disabled: false,
          },
          {
            name: "6627, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6628, CVS, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "6629, Walgreens, HOMETOWN, IL",
            disabled: false,
          },
          {
            name: "663, ADUSA, CHARLES TOWN, WV",
            disabled: false,
          },
          {
            name: "663, ADUSA, MILFORD, CT",
            disabled: false,
          },
          {
            name: "663, Albertsons, PECOS, TX",
            disabled: false,
          },
          {
            name: "663, CVS, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "663, Costco, CONCORD, CA",
            disabled: false,
          },
          {
            name: "663, Kroger, Du Quoin, IL",
            disabled: false,
          },
          {
            name: "663, Kroger, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "663, Kroger, SANDY, OR",
            disabled: false,
          },
          {
            name: "663, Target, MANKATO, MN",
            disabled: false,
          },
          {
            name: "663, Walmart, ATHENS, TN",
            disabled: false,
          },
          {
            name: "6630, CVS, TIPTON, IN",
            disabled: false,
          },
          {
            name: "6631, Walgreens, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "6632, CVS, DUNKIRK, IN",
            disabled: false,
          },
          {
            name: "6632, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "6633, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "6633, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "6634, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "6635, CVS, MANKATO, MN",
            disabled: false,
          },
          {
            name: "6636, CVS, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "6637, CVS, SHELBYVILLE, IN",
            disabled: false,
          },
          {
            name: "6638, CVS, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "6638, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "6639, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "664, Albertsons, MEDFORD, NJ",
            disabled: false,
          },
          {
            name: "664, Costco, PLANO, TX",
            disabled: false,
          },
          {
            name: "664, Kroger, Augusta, GA",
            disabled: false,
          },
          {
            name: "664, Kroger, REDMOND, WA",
            disabled: false,
          },
          {
            name: "664, Kroger, VENTURA, CA",
            disabled: false,
          },
          {
            name: "664, Kroger, WHEELERSBURG, OH",
            disabled: false,
          },
          {
            name: "664, Target, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "664, Walmart, HAYS, KS",
            disabled: false,
          },
          {
            name: "6640, CVS, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "6640, Walgreens, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "6641, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6642, Walgreens, BURLINGTON, KY",
            disabled: false,
          },
          {
            name: "6643, CVS, NEW CASTLE, IN",
            disabled: false,
          },
          {
            name: "6643, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6644, CVS, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "6645, CVS, RUSHVILLE, IN",
            disabled: false,
          },
          {
            name: "6645, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6646, CVS, CAMBRIDGE CITY, IN",
            disabled: false,
          },
          {
            name: "6647, CVS, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "6648, CVS, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "6648, Walgreens, RESEDA, CA",
            disabled: false,
          },
          {
            name: "6649, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "665, ADUSA, EAST LYME, CT",
            disabled: false,
          },
          {
            name: "665, Albertsons, CARLSBAD, NM",
            disabled: false,
          },
          {
            name: "665, CVS, WOBURN, MA",
            disabled: false,
          },
          {
            name: "665, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "665, Kroger, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "665, Kroger, SUMNER, WA",
            disabled: false,
          },
          {
            name: "665, Target, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "665, Walmart, CAMPBELLSVILLE, KY",
            disabled: false,
          },
          {
            name: "6650, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6650, Walgreens, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "6651, CVS, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "6652, CVS, CONNERSVILLE, IN",
            disabled: false,
          },
          {
            name: "6653, CVS, WHITELAND, IN",
            disabled: false,
          },
          {
            name: "6653, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "6654, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6654, Walgreens, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "6655, CVS, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "6656, CVS, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "6656, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "6658, CVS, PENDLETON, IN",
            disabled: false,
          },
          {
            name: "6658, Walgreens, CARMICHAEL, CA",
            disabled: false,
          },
          {
            name: "6659, Walgreens, CLEVELAND, OH",
            disabled: false,
          },
          {
            name: "666, Target, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "666, Walmart, SEBRING, FL",
            disabled: false,
          },
          {
            name: "6660, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6661, CVS, KNIGHTSTOWN, IN",
            disabled: false,
          },
          {
            name: "6661, Walgreens, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "6662, CVS, MIDDLETOWN, IN",
            disabled: false,
          },
          {
            name: "6663, CVS, FRANKLIN, IN",
            disabled: false,
          },
          {
            name: "6663, Walgreens, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "6664, Walgreens, NEWBERG, OR",
            disabled: false,
          },
          {
            name: "6666, CVS, LEBANON, IN",
            disabled: false,
          },
          {
            name: "6666, Walgreens, PRESCOTT VALLEY, AZ",
            disabled: false,
          },
          {
            name: "6667, CVS, FRANKFORT, IN",
            disabled: false,
          },
          {
            name: "6668, CVS, CRAWFORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "6668, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6669, CVS, COVINGTON, IN",
            disabled: false,
          },
          {
            name: "6669, Walgreens, SOUTH JORDAN, UT",
            disabled: false,
          },
          {
            name: "667, ADUSA, WATERFORD, CT",
            disabled: false,
          },
          {
            name: "667, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "667, Costco, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "667, Kroger, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "667, Kroger, LITCHFIELD PARK, AZ",
            disabled: false,
          },
          {
            name: "667, Kroger, ROME, GA",
            disabled: false,
          },
          {
            name: "667, Rite Aid, ANSONIA, CT",
            disabled: false,
          },
          {
            name: "667, Walmart, TULLAHOMA, TN",
            disabled: false,
          },
          {
            name: "6670, CVS, KENTLAND, IN",
            disabled: false,
          },
          {
            name: "6672, Walgreens, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "6673, CVS, ATTICA, IN",
            disabled: false,
          },
          {
            name: "6673, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6674, CVS, DELPHI, IN",
            disabled: false,
          },
          {
            name: "6674, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "6675, CVS, ROSSVILLE, IN",
            disabled: false,
          },
          {
            name: "6675, Walgreens, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "6676, Walgreens, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "6677, CVS, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "6677, Walgreens, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "6678, Rite Aid, ROSSFORD, OH",
            disabled: false,
          },
          {
            name: "6678, Walgreens, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "6679, CVS, WATSEKA, IL",
            disabled: false,
          },
          {
            name: "6679, Rite Aid, MAUMEE, OH",
            disabled: false,
          },
          {
            name: "668, Albertsons, BELMONT, CA",
            disabled: false,
          },
          {
            name: "668, CVS, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "668, Costco, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "668, HEB, COPPERAS COVE, TX",
            disabled: false,
          },
          {
            name: "668, Kroger, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "668, Kroger, EAGLE RIVER, AK",
            disabled: false,
          },
          {
            name: "668, Kroger, LOGAN, WV",
            disabled: false,
          },
          {
            name: "668, Kroger, Mt Gay, WV",
            disabled: false,
          },
          {
            name: "668, Rite Aid, LAKE RONKONKOMA, NY",
            disabled: false,
          },
          {
            name: "668, Walmart, MCMINNVILLE, TN",
            disabled: false,
          },
          {
            name: "6680, Walgreens, BELLFLOWER, CA",
            disabled: false,
          },
          {
            name: "6681, Rite Aid, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "6682, CVS, BRAZIL, IN",
            disabled: false,
          },
          {
            name: "6682, Walgreens, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "6683, Walgreens, VISALIA, CA",
            disabled: false,
          },
          {
            name: "6685, Walgreens, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "6687, CVS, GREENCASTLE, IN",
            disabled: false,
          },
          {
            name: "6687, Walgreens, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "6688, CVS, ROCKVILLE, IN",
            disabled: false,
          },
          {
            name: "6688, Walgreens, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "6689, CVS, CLINTON, IN",
            disabled: false,
          },
          {
            name: "669, ADUSA, ROLESVILLE, NC",
            disabled: false,
          },
          {
            name: "669, CVS, SWAMPSCOTT, MA",
            disabled: false,
          },
          {
            name: "669, Costco, SOUTHLAKE, TX",
            disabled: false,
          },
          {
            name: "669, Kroger, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "669, Kroger, Redford, MI",
            disabled: false,
          },
          {
            name: "669, Kroger, Smithers, WV",
            disabled: false,
          },
          {
            name: "669, Target, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "669, Walmart, DALTON, GA",
            disabled: false,
          },
          {
            name: "6690, CVS, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "6691, CVS, DULUTH, MN",
            disabled: false,
          },
          {
            name: "6691, Walgreens, HIGHLAND, IN",
            disabled: false,
          },
          {
            name: "6692, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "6693, CVS, NEWTON, IL",
            disabled: false,
          },
          {
            name: "6693, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6694, CVS, PARIS, IL",
            disabled: false,
          },
          {
            name: "6694, Walgreens, ODESSA, TX",
            disabled: false,
          },
          {
            name: "6695, Walgreens, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "6696, CVS, BROWNSTOWN, IN",
            disabled: false,
          },
          {
            name: "6697, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "6697, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6698, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "6698, Walgreens, MIDLOTHIAN, VA",
            disabled: false,
          },
          {
            name: "6699, Walgreens, SUWANEE, GA",
            disabled: false,
          },
          {
            name: "67, ADUSA, LYNN, MA",
            disabled: false,
          },
          {
            name: "67, Albertsons, GILLETTE, WY",
            disabled: false,
          },
          {
            name: "67, BJ's, LINDEN, NJ",
            disabled: false,
          },
          {
            name: "67, Costco, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "67, Kroger, Cave Creek, AZ",
            disabled: false,
          },
          {
            name: "67, Kroger, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "67, Kroger, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "67, Meijer, MONROE, MI",
            disabled: false,
          },
          {
            name: "67, Target, PLANO, TX",
            disabled: false,
          },
          {
            name: "67, Walmart, MENA, AR",
            disabled: false,
          },
          {
            name: "670, ADUSA, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "670, ADUSA, SLIPPERY ROCK, PA",
            disabled: false,
          },
          {
            name: "670, CVS, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "670, Costco, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "670, Kroger, DAWSONVILLE, GA",
            disabled: false,
          },
          {
            name: "670, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "670, Kroger, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "670, Kroger, POWELL, TN",
            disabled: false,
          },
          {
            name: "670, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "670, Target, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "670, Walmart, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "6700, CVS, SULLIVAN, IN",
            disabled: false,
          },
          {
            name: "6700, Walgreens, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "6701, CVS, BARTLETT, IL",
            disabled: false,
          },
          {
            name: "6702, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6703, CVS, MARTINSVILLE, IN",
            disabled: false,
          },
          {
            name: "6703, Walgreens, LOCKPORT, IL",
            disabled: false,
          },
          {
            name: "6704, CVS, LAKE JACKSON, TX",
            disabled: false,
          },
          {
            name: "6704, Walgreens, PALM BAY, FL",
            disabled: false,
          },
          {
            name: "6705, CVS, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "6706, CVS, LINTON, IN",
            disabled: false,
          },
          {
            name: "6706, Walgreens, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "6707, CVS, EDINBURGH, IN",
            disabled: false,
          },
          {
            name: "6707, Walgreens, DERBY, KS",
            disabled: false,
          },
          {
            name: "671, ADUSA, BELHAVEN, NC",
            disabled: false,
          },
          {
            name: "671, Albertsons, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "671, CVS, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "671, Costco, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "671, HEB, CARRIZO SPRINGS, TX",
            disabled: false,
          },
          {
            name: "671, Kroger, CANTON, MI",
            disabled: false,
          },
          {
            name: "671, Kroger, Hilton Head, SC",
            disabled: false,
          },
          {
            name: "671, Kroger, Palmer, AK",
            disabled: false,
          },
          {
            name: "671, Target, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "671, Walmart, LEBANON, TN",
            disabled: false,
          },
          {
            name: "6710, CVS, LADERA RANCH, CA",
            disabled: false,
          },
          {
            name: "6710, Rite Aid, BANDON, OR",
            disabled: false,
          },
          {
            name: "6711, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "6712, CVS, NASHVILLE, IN",
            disabled: false,
          },
          {
            name: "6713, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "6714, CVS, MITCHELL, IN",
            disabled: false,
          },
          {
            name: "6714, Rite Aid, PALO CEDRO, CA",
            disabled: false,
          },
          {
            name: "6714, Walgreens, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "6715, CVS, EAGAN, MN",
            disabled: false,
          },
          {
            name: "6715, Walgreens, ODESSA, TX",
            disabled: false,
          },
          {
            name: "6716, Rite Aid, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6717, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "6717, Rite Aid, IRVINE, CA",
            disabled: false,
          },
          {
            name: "6718, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6718, Walgreens, ATWATER, CA",
            disabled: false,
          },
          {
            name: "6719, CVS, MARICOPA, AZ",
            disabled: false,
          },
          {
            name: "672, Albertsons, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "672, CVS, MALDEN, MA",
            disabled: false,
          },
          {
            name: "672, Costco, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "672, HEB, WACO, TX",
            disabled: false,
          },
          {
            name: "672, Kroger, ANNA, IL",
            disabled: false,
          },
          {
            name: "672, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "672, Kroger, Maricopa, AZ",
            disabled: false,
          },
          {
            name: "672, Target, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "672, Walmart, ALCOA, TN",
            disabled: false,
          },
          {
            name: "6720, Walgreens, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "6722, CVS, SALEM, IN",
            disabled: false,
          },
          {
            name: "6722, Rite Aid, FREELAND, WA",
            disabled: false,
          },
          {
            name: "6722, Walgreens, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "6723, CVS, BAY CITY, TX",
            disabled: false,
          },
          {
            name: "6723, Rite Aid, WOODLAKE, CA",
            disabled: false,
          },
          {
            name: "6723, Walgreens, LADY LAKE, FL",
            disabled: false,
          },
          {
            name: "6724, CVS, BEDFORD, IN",
            disabled: false,
          },
          {
            name: "6725, CVS, ANGLETON, TX",
            disabled: false,
          },
          {
            name: "6726, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6727, CVS, ALVIN, TX",
            disabled: false,
          },
          {
            name: "6727, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6728, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6729, CVS, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "6729, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "673, ADUSA, FAIRFIELD, CT",
            disabled: false,
          },
          {
            name: "673, ADUSA, WAYNESBURG, PA",
            disabled: false,
          },
          {
            name: "673, Costco, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "673, HEB, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "673, Kroger, DALLAS, GA",
            disabled: false,
          },
          {
            name: "673, Kroger, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "673, Kroger, Sterling Heights, MI",
            disabled: false,
          },
          {
            name: "673, Target, JACKSON, MI",
            disabled: false,
          },
          {
            name: "673, Walmart, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "6730, Walgreens, HOPKINS, MN",
            disabled: false,
          },
          {
            name: "6731, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "6732, Walgreens, PLANT CITY, FL",
            disabled: false,
          },
          {
            name: "6732, Walmart, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "6733, CVS, OMAHA, NE",
            disabled: false,
          },
          {
            name: "6733, Rite Aid, BETHEL PARK, PA",
            disabled: false,
          },
          {
            name: "6733, Walgreens, LAKE STATION, IN",
            disabled: false,
          },
          {
            name: "6734, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6735, Walgreens, SAINT ANTHONY, MN",
            disabled: false,
          },
          {
            name: "6736, CVS, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "6736, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "6738, CVS, WHARTON, TX",
            disabled: false,
          },
          {
            name: "6738, Walgreens, LA FOLLETTE, TN",
            disabled: false,
          },
          {
            name: "6739, CVS, SPENCER, IN",
            disabled: false,
          },
          {
            name: "6739, Rite Aid, TYRONE, PA",
            disabled: false,
          },
          {
            name: "6739, Walgreens, LOWELL, MA",
            disabled: false,
          },
          {
            name: "674, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "674, ADUSA, WILLIMANTIC, CT",
            disabled: false,
          },
          {
            name: "674, Albertsons, CLINTON, MA",
            disabled: false,
          },
          {
            name: "674, Costco, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "674, HEB, PALMHURST, TX",
            disabled: false,
          },
          {
            name: "674, Kroger, DUBLIN, GA",
            disabled: false,
          },
          {
            name: "674, Kroger, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "674, Kroger, Warren, MI",
            disabled: false,
          },
          {
            name: "674, Target, MARION, IL",
            disabled: false,
          },
          {
            name: "674, Walmart, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "6740, CVS, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "6740, Rite Aid, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "6740, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "6741, Rite Aid, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "6741, Walgreens, MANTUA, NJ",
            disabled: false,
          },
          {
            name: "6742, Rite Aid, ROARING SPRING, PA",
            disabled: false,
          },
          {
            name: "6742, Walgreens, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "6744, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6744, Rite Aid, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "6744, Walgreens, MIDDLEBURG, FL",
            disabled: false,
          },
          {
            name: "6745, CVS, FLORISSANT, MO",
            disabled: false,
          },
          {
            name: "6746, CVS, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "6746, Walgreens, CRYSTAL LAKE, IL",
            disabled: false,
          },
          {
            name: "6747, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "6748, CVS, DOWNERS GROVE, IL",
            disabled: false,
          },
          {
            name: "6748, Walgreens, ELIZABETH, NJ",
            disabled: false,
          },
          {
            name: "675, ADUSA, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "675, Albertsons, ODESSA, TX",
            disabled: false,
          },
          {
            name: "675, CVS, GLENOLDEN, PA",
            disabled: false,
          },
          {
            name: "675, Costco, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "675, HEB, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "675, Kroger, AIKEN, SC",
            disabled: false,
          },
          {
            name: "675, Kroger, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "675, Kroger, WATERFORD, MI",
            disabled: false,
          },
          {
            name: "675, Rite Aid, WEST SENECA, NY",
            disabled: false,
          },
          {
            name: "675, Target, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "675, Walmart, UNION CITY, TN",
            disabled: false,
          },
          {
            name: "6750, Rite Aid, VALLEY CENTER, CA",
            disabled: false,
          },
          {
            name: "6750, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "6751, Walgreens, BRANDON, FL",
            disabled: false,
          },
          {
            name: "6752, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6752, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "6753, Rite Aid, MENIFEE, CA",
            disabled: false,
          },
          {
            name: "6753, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6754, Walgreens, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "6756, CVS, SEYMOUR, IN",
            disabled: false,
          },
          {
            name: "6756, Rite Aid, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "6756, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "6757, CVS, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "6758, CVS, GREENSBURG, IN",
            disabled: false,
          },
          {
            name: "6758, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "6759, Walgreens, CORINTH, TX",
            disabled: false,
          },
          {
            name: "676, Albertsons, ALBANY, CA",
            disabled: false,
          },
          {
            name: "676, CVS, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "676, Costco, ARVADA, CO",
            disabled: false,
          },
          {
            name: "676, Kroger, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "676, Kroger, GOODYEAR, AZ",
            disabled: false,
          },
          {
            name: "676, Target, SALINAS, CA",
            disabled: false,
          },
          {
            name: "676, Walmart, ROCKWOOD, TN",
            disabled: false,
          },
          {
            name: "6760, CVS, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "6760, Walgreens, HOFFMAN ESTATES, IL",
            disabled: false,
          },
          {
            name: "6761, Walgreens, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "6762, Rite Aid, CARROLLTON, VA",
            disabled: false,
          },
          {
            name: "6762, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6763, CVS, PERKASIE, PA",
            disabled: false,
          },
          {
            name: "6764, CVS, JERSEY SHORE, PA",
            disabled: false,
          },
          {
            name: "6764, Rite Aid, FARMERSVILLE, CA",
            disabled: false,
          },
          {
            name: "6764, Walgreens, CARPENTERSVILLE, IL",
            disabled: false,
          },
          {
            name: "6765, CVS, CROFTON, MD",
            disabled: false,
          },
          {
            name: "6765, Walgreens, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "6766, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6767, CVS, FREEPORT, TX",
            disabled: false,
          },
          {
            name: "6768, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "6769, CVS, WOODFIN, NC",
            disabled: false,
          },
          {
            name: "6769, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "677, ADUSA, CANAAN, CT",
            disabled: false,
          },
          {
            name: "677, Albertsons, MILFORD, MA",
            disabled: false,
          },
          {
            name: "677, Costco, BURBANK, CA",
            disabled: false,
          },
          {
            name: "677, HEB, ELSA, TX",
            disabled: false,
          },
          {
            name: "677, Kroger, CHILLICOTHE, IL",
            disabled: false,
          },
          {
            name: "677, Kroger, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "677, Kroger, Marana, AZ",
            disabled: false,
          },
          {
            name: "677, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "677, Target, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "677, Walmart, DYERSBURG, TN",
            disabled: false,
          },
          {
            name: "6770, Walgreens, STARKVILLE, MS",
            disabled: false,
          },
          {
            name: "6771, Walgreens, TUPELO, MS",
            disabled: false,
          },
          {
            name: "6772, Walgreens, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "6773, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6775, CVS, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "6775, Walgreens, NAPLES, FL",
            disabled: false,
          },
          {
            name: "6776, Rite Aid, PHOENIX, OR",
            disabled: false,
          },
          {
            name: "6777, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6777, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "6778, Rite Aid, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "6778, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6779, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6779, Rite Aid, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "6779, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "678, ADUSA, UNCASVILLE, CT",
            disabled: false,
          },
          {
            name: "678, Albertsons, MERRIMACK, NH",
            disabled: false,
          },
          {
            name: "678, CVS, ENDICOTT, NY",
            disabled: false,
          },
          {
            name: "678, Costco, RANCHO CUCAMONG, CA",
            disabled: false,
          },
          {
            name: "678, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "678, Kroger, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "678, Kroger, Surprise, AZ",
            disabled: false,
          },
          {
            name: "678, Walmart, NEWPORT, TN",
            disabled: false,
          },
          {
            name: "6780, CVS, SCOTTSBURG, IN",
            disabled: false,
          },
          {
            name: "6782, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "6782, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "6783, Walgreens, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "6784, CVS, BROOKVILLE, IN",
            disabled: false,
          },
          {
            name: "6784, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "6785, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6785, Walgreens, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "6786, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "6786, Walgreens, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "6786, Walmart, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "6787, CVS, BATESVILLE, IN",
            disabled: false,
          },
          {
            name: "6788, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "6788, Walgreens, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "6789, CVS, WOODRIDGE, IL",
            disabled: false,
          },
          {
            name: "6789, Walgreens, FENTON, MO",
            disabled: false,
          },
          {
            name: "6789, Walmart, KING, NC",
            disabled: false,
          },
          {
            name: "679, ADUSA, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "679, Albertsons, ABILENE, TX",
            disabled: false,
          },
          {
            name: "679, Costco, CITY OF INDUSTR, CA",
            disabled: false,
          },
          {
            name: "679, HEB, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "679, Kroger, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "679, Kroger, SAHUARITA, AZ",
            disabled: false,
          },
          {
            name: "679, Kroger, West Bloomfield, MI",
            disabled: false,
          },
          {
            name: "679, Rite Aid, UPPER DARBY, PA",
            disabled: false,
          },
          {
            name: "679, Target, COEUR D'ALENE, ID",
            disabled: false,
          },
          {
            name: "6790, CVS, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "6790, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "6791, CVS, MADISON, IN",
            disabled: false,
          },
          {
            name: "6792, CVS, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "6794, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "6795, Rite Aid, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "6796, Walgreens, SOUTH ELGIN, IL",
            disabled: false,
          },
          {
            name: "6797, Walgreens, ROCKLEDGE, FL",
            disabled: false,
          },
          {
            name: "6798, CVS, HANOVER, IN",
            disabled: false,
          },
          {
            name: "6798, Walgreens, HOLLY HILL, FL",
            disabled: false,
          },
          {
            name: "6798, Walmart, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "68, Albertsons, OLD GREENWICH, CT",
            disabled: false,
          },
          {
            name: "68, Albertsons, WESTMONT, IL",
            disabled: false,
          },
          {
            name: "68, BJ's, CLAY, NY",
            disabled: false,
          },
          {
            name: "68, CVS, TRAFALGAR, IN",
            disabled: false,
          },
          {
            name: "68, Costco, SALEM, OR",
            disabled: false,
          },
          {
            name: "68, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "68, Kroger, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "68, Kroger, THORNTON, CO",
            disabled: false,
          },
          {
            name: "68, Kroger, VILLA PARK, CA",
            disabled: false,
          },
          {
            name: "68, Meijer, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "68, Target, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "68, Walmart, WYNNE, AR",
            disabled: false,
          },
          {
            name: "680, Albertsons, HOBBS, NM",
            disabled: false,
          },
          {
            name: "680, Costco, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "680, Kroger, CANTON, GA",
            disabled: false,
          },
          {
            name: "680, Kroger, JACKSON, MI",
            disabled: false,
          },
          {
            name: "680, Kroger, SANTA BARBARA, CA",
            disabled: false,
          },
          {
            name: "680, Kroger, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "680, Target, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "680, Walmart, GREENEVILLE, TN",
            disabled: false,
          },
          {
            name: "6800, CVS, MONTGOMERY, TX",
            disabled: false,
          },
          {
            name: "6800, Walgreens, PRATTVILLE, AL",
            disabled: false,
          },
          {
            name: "6801, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "6802, CVS, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "6802, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "6803, Walgreens, BELLEAIR BLUFFS, FL",
            disabled: false,
          },
          {
            name: "6804, CVS, MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "6806, CVS, GREENVILLE, TX",
            disabled: false,
          },
          {
            name: "6806, Walgreens, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "6807, CVS, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "6807, Walmart, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "6808, CVS, NORTH VERNON, IN",
            disabled: false,
          },
          {
            name: "6809, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "681, ADUSA, ASHLAND, VA",
            disabled: false,
          },
          {
            name: "681, ADUSA, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "681, Albertsons, ALAMOGORDO, NM",
            disabled: false,
          },
          {
            name: "681, CVS, MORRISVILLE, NC",
            disabled: false,
          },
          {
            name: "681, Costco, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "681, Kroger, BERMUDA DUNES, CA",
            disabled: false,
          },
          {
            name: "681, Kroger, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "681, Kroger, HILLSDALE, MI",
            disabled: false,
          },
          {
            name: "681, Kroger, SNOHOMISH, WA",
            disabled: false,
          },
          {
            name: "681, Target, KENT, WA",
            disabled: false,
          },
          {
            name: "681, Walmart, GUNTERSVILLE, AL",
            disabled: false,
          },
          {
            name: "6810, CVS, DILWORTH, MN",
            disabled: false,
          },
          {
            name: "6811, CVS, PLYMOUTH, MN",
            disabled: false,
          },
          {
            name: "6811, Walgreens, CRESTVIEW, FL",
            disabled: false,
          },
          {
            name: "6812, CVS, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "6812, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "6813, CVS, VEVAY, IN",
            disabled: false,
          },
          {
            name: "6813, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "6813, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "6814, CVS, VERSAILLES, IN",
            disabled: false,
          },
          {
            name: "6814, Walgreens, PUYALLUP, WA",
            disabled: false,
          },
          {
            name: "6814, Walmart, WINSTON SALEM, NC",
            disabled: false,
          },
          {
            name: "6817, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "6818, CVS, CLEBURNE, TX",
            disabled: false,
          },
          {
            name: "6819, CVS, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "6819, Walgreens, LAKE BLUFF, IL",
            disabled: false,
          },
          {
            name: "682, ADUSA, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "682, ADUSA, GROTON, CT",
            disabled: false,
          },
          {
            name: "682, Albertsons, RUIDOSO, NM",
            disabled: false,
          },
          {
            name: "682, Costco, ALBANY, OR",
            disabled: false,
          },
          {
            name: "682, Kroger, Dublin, OH",
            disabled: false,
          },
          {
            name: "682, Kroger, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "682, Kroger, MAPLE VALLEY, WA",
            disabled: false,
          },
          {
            name: "682, Kroger, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "682, Target, GERMANTOWN, TN",
            disabled: false,
          },
          {
            name: "682, Walmart, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6820, CVS, LINCOLN, IL",
            disabled: false,
          },
          {
            name: "6820, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "6821, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "6821, Walgreens, MEADOWS PLACE, TX",
            disabled: false,
          },
          {
            name: "6822, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6822, Walgreens, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "6823, Walgreens, BALDWIN, NY",
            disabled: false,
          },
          {
            name: "6824, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6825, CVS, WACO, TX",
            disabled: false,
          },
          {
            name: "6826, Walgreens, ARVADA, CO",
            disabled: false,
          },
          {
            name: "6827, CVS, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "6827, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "6828, Walmart, KERNERSVILLE, NC",
            disabled: false,
          },
          {
            name: "6829, CVS, TAYLORVILLE, IL",
            disabled: false,
          },
          {
            name: "6829, Walgreens, ALLEN, TX",
            disabled: false,
          },
          {
            name: "683, ADUSA, NEW MILFORD, CT",
            disabled: false,
          },
          {
            name: "683, ADUSA, SOMERSET, PA",
            disabled: false,
          },
          {
            name: "683, ADUSA, SWANSBORO, NC",
            disabled: false,
          },
          {
            name: "683, Albertsons, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "683, Costco, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "683, Kroger, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "683, Kroger, Macomb, MI",
            disabled: false,
          },
          {
            name: "683, Kroger, Peoria, AZ",
            disabled: false,
          },
          {
            name: "683, Kroger, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "683, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "683, Walmart, LAWRENCEBURG, TN",
            disabled: false,
          },
          {
            name: "6830, CVS, BELLEVILLE, IL",
            disabled: false,
          },
          {
            name: "6830, Walgreens, FLINT, MI",
            disabled: false,
          },
          {
            name: "6831, Walgreens, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "6832, CVS, ALTON, IL",
            disabled: false,
          },
          {
            name: "6832, Walgreens, STUART, FL",
            disabled: false,
          },
          {
            name: "6833, CVS, WOOD RIVER, IL",
            disabled: false,
          },
          {
            name: "6834, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "6835, CVS, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "6837, Walgreens, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "6839, Walgreens, BIXBY, OK",
            disabled: false,
          },
          {
            name: "684, ADUSA, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "684, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "684, Costco, PLANO, TX",
            disabled: false,
          },
          {
            name: "684, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "684, Kroger, MACOMB, MI",
            disabled: false,
          },
          {
            name: "684, Target, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "684, Walmart, LEXINGTON, TN",
            disabled: false,
          },
          {
            name: "6840, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "6841, CVS, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "6843, CVS, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "6843, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "6844, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "6845, CVS, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "6846, CVS, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "6849, CVS, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "6849, Walgreens, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "6849, Walmart, BILOXI, MS",
            disabled: false,
          },
          {
            name: "685, ADUSA, MONROE, CT",
            disabled: false,
          },
          {
            name: "685, Albertsons, FRISCO, TX",
            disabled: false,
          },
          {
            name: "685, CVS, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "685, Costco, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "685, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "685, Kroger, BIRMINGHAM, MI",
            disabled: false,
          },
          {
            name: "685, Kroger, MERIDIAN, ID",
            disabled: false,
          },
          {
            name: "685, Target, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "685, Walmart, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "6850, CVS, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "6850, Walgreens, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "6850, Walmart, MISSION, TX",
            disabled: false,
          },
          {
            name: "6851, CVS, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "6851, Walmart, SACHSE, TX",
            disabled: false,
          },
          {
            name: "6852, CVS, DUMFRIES, VA",
            disabled: false,
          },
          {
            name: "6852, Walgreens, BEAVERTON, OR",
            disabled: false,
          },
          {
            name: "6853, CVS, DAVENPORT, FL",
            disabled: false,
          },
          {
            name: "6853, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6854, CVS, CORSICANA, TX",
            disabled: false,
          },
          {
            name: "6854, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "6855, CVS, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "6855, Walgreens, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "6856, CVS, DENTON, TX",
            disabled: false,
          },
          {
            name: "6856, Walgreens, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "6857, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6858, CVS, PERRY HALL, MD",
            disabled: false,
          },
          {
            name: "6858, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "686, ADUSA, UNIONVILLE, CT",
            disabled: false,
          },
          {
            name: "686, Albertsons, CLOVIS, NM",
            disabled: false,
          },
          {
            name: "686, Albertsons, WINDHAM, NH",
            disabled: false,
          },
          {
            name: "686, CVS, BRAINTREE, MA",
            disabled: false,
          },
          {
            name: "686, Costco, MONTCLAIR, CA",
            disabled: false,
          },
          {
            name: "686, HEB, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "686, Kroger, FARRAGUT, TN",
            disabled: false,
          },
          {
            name: "686, Kroger, MESA, AZ",
            disabled: false,
          },
          {
            name: "686, Kroger, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "686, Kroger, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "686, Target, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "686, Walmart, FITZGERALD, GA",
            disabled: false,
          },
          {
            name: "6860, Walgreens, VALRICO, FL",
            disabled: false,
          },
          {
            name: "6861, CVS, STATESBORO, GA",
            disabled: false,
          },
          {
            name: "6861, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6862, Walgreens, CARLSTADT, NJ",
            disabled: false,
          },
          {
            name: "6864, CVS, WAXAHACHIE, TX",
            disabled: false,
          },
          {
            name: "6864, Walgreens, MAGNOLIA, TX",
            disabled: false,
          },
          {
            name: "6865, CVS, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "6865, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6866, CVS, COLUMBIA, IL",
            disabled: false,
          },
          {
            name: "6866, Walgreens, DES PLAINES, IL",
            disabled: false,
          },
          {
            name: "6867, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "6868, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "6869, CVS, NEW CASTLE, DE",
            disabled: false,
          },
          {
            name: "6869, Walgreens, PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "687, ADUSA, BRANFORD, CT",
            disabled: false,
          },
          {
            name: "687, ADUSA, ELLWOOD CITY, PA",
            disabled: false,
          },
          {
            name: "687, CVS, WEST ORANGE, NJ",
            disabled: false,
          },
          {
            name: "687, Costco, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "687, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "687, Kroger, BATESVILLE, AR",
            disabled: false,
          },
          {
            name: "687, Kroger, SUGAR HILL, GA",
            disabled: false,
          },
          {
            name: "687, Kroger, W Frankfort, IL",
            disabled: false,
          },
          {
            name: "687, Rite Aid, OAKLYN, NJ",
            disabled: false,
          },
          {
            name: "687, Target, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "687, Walmart, CROSSVILLE, TN",
            disabled: false,
          },
          {
            name: "6870, CVS, KEAAU, HI",
            disabled: false,
          },
          {
            name: "6871, CVS, FERDINAND, IN",
            disabled: false,
          },
          {
            name: "6871, Walgreens, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "6872, CVS, RANDOLPH, NJ",
            disabled: false,
          },
          {
            name: "6872, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "6873, CVS, LAMBERTVILLE, NJ",
            disabled: false,
          },
          {
            name: "6873, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "6874, CVS, WASHINGTON, IN",
            disabled: false,
          },
          {
            name: "6875, CVS, PAOLI, IN",
            disabled: false,
          },
          {
            name: "6876, CVS, PRINCETON, IN",
            disabled: false,
          },
          {
            name: "6876, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "6876, Walmart, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "6877, CVS, EGG HARBOR TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "6877, Walgreens, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "6878, CVS, JASPER, IN",
            disabled: false,
          },
          {
            name: "6878, Walmart, HAZEL GREEN, AL",
            disabled: false,
          },
          {
            name: "6879, Walmart, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "688, ADUSA, OLD SAYBROOK, CT",
            disabled: false,
          },
          {
            name: "688, Costco, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "688, Kroger, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "688, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "688, Kroger, Clarksburg, WV",
            disabled: false,
          },
          {
            name: "688, Kroger, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "688, Kroger, RICHMOND HILL, GA",
            disabled: false,
          },
          {
            name: "688, Target, DAYTONA BEACH, FL",
            disabled: false,
          },
          {
            name: "688, Walmart, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "6880, CVS, VINCENNES, IN",
            disabled: false,
          },
          {
            name: "6880, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "6881, CVS, HUNTINGBURG, IN",
            disabled: false,
          },
          {
            name: "6882, CVS, ENGLISH, IN",
            disabled: false,
          },
          {
            name: "6882, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "6883, CVS, LOOGOOTEE, IN",
            disabled: false,
          },
          {
            name: "6883, Walgreens, WHEAT RIDGE, CO",
            disabled: false,
          },
          {
            name: "6884, CVS, WEST BADEN SPRINGS, IN",
            disabled: false,
          },
          {
            name: "6884, Walgreens, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "6885, CVS, FAIRFIELD, IL",
            disabled: false,
          },
          {
            name: "6886, CVS, CARMI, IL",
            disabled: false,
          },
          {
            name: "6886, Walgreens, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "6887, CVS, MOUNT CARMEL, IL",
            disabled: false,
          },
          {
            name: "6887, Walgreens, LEESBURG, FL",
            disabled: false,
          },
          {
            name: "6887, Walmart, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "6888, Walgreens, NILES, OH",
            disabled: false,
          },
          {
            name: "6889, Walgreens, SOLON, OH",
            disabled: false,
          },
          {
            name: "689, ADUSA, MANCHESTER, CT",
            disabled: false,
          },
          {
            name: "689, CVS, WARWICK, RI",
            disabled: false,
          },
          {
            name: "689, Costco, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "689, Kroger, DALLAS, TX",
            disabled: false,
          },
          {
            name: "689, Kroger, MARANA, AZ",
            disabled: false,
          },
          {
            name: "689, Kroger, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "689, Target, MELBOURNE VILLAGE, FL",
            disabled: false,
          },
          {
            name: "689, Walgreens, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "689, Walmart, SOMERSET, KY",
            disabled: false,
          },
          {
            name: "6891, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6892, Walgreens, BRISTOL, RI",
            disabled: false,
          },
          {
            name: "6893, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6894, CVS, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "6894, Walgreens, WYNCOTE, PA",
            disabled: false,
          },
          {
            name: "6894, Walmart, APOPKA, FL",
            disabled: false,
          },
          {
            name: "6895, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "6896, CVS, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "6897, CVS, MENDOTA, IL",
            disabled: false,
          },
          {
            name: "6897, Walgreens, LAKE CITY, GA",
            disabled: false,
          },
          {
            name: "6898, Walgreens, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "6898, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "6899, CVS, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "6899, Walgreens, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "69, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "69, BJ's, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "69, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "69, Costco, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "69, HEB, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "69, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "69, Kroger, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "69, Kroger, Salt Lake City, UT",
            disabled: false,
          },
          {
            name: "69, Kroger, Vancouver, WA",
            disabled: false,
          },
          {
            name: "69, Meijer, Mt. Pleasant, MI",
            disabled: false,
          },
          {
            name: "69, Target, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "69, Walmart, FESTUS, MO",
            disabled: false,
          },
          {
            name: "690, Albertsons, ORLEANS, MA",
            disabled: false,
          },
          {
            name: "690, Costco, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "690, Kroger, OAK RIDGE, TN",
            disabled: false,
          },
          {
            name: "690, Target, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "690, Walmart, ELIZABETHTON, TN",
            disabled: false,
          },
          {
            name: "6900, CVS, EWING, NJ",
            disabled: false,
          },
          {
            name: "6901, CVS, GAINESVILLE, TX",
            disabled: false,
          },
          {
            name: "6901, Walgreens, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "6902, CVS, BRYN MAWR, PA",
            disabled: false,
          },
          {
            name: "6902, Walgreens, MILLVILLE, NJ",
            disabled: false,
          },
          {
            name: "6903, CVS, FOREST HILL, TX",
            disabled: false,
          },
          {
            name: "6903, Walgreens, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "6904, CVS, TYLER, TX",
            disabled: false,
          },
          {
            name: "6904, Walgreens, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "6905, CVS, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "6905, Walgreens, LINDENHURST, IL",
            disabled: false,
          },
          {
            name: "6906, CVS, RENSSELAER, IN",
            disabled: false,
          },
          {
            name: "6906, Walgreens, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "6907, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "6908, CVS, DEMOTTE, IN",
            disabled: false,
          },
          {
            name: "6908, Walgreens, NEW BRUNSWICK, NJ",
            disabled: false,
          },
          {
            name: "6909, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "691, ADUSA, POOLER, GA",
            disabled: false,
          },
          {
            name: "691, Albertsons, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "691, CVS, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "691, Costco, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "691, Kroger, GIG HARBOR, WA",
            disabled: false,
          },
          {
            name: "691, Kroger, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "691, Target, Leesburg, FL",
            disabled: false,
          },
          {
            name: "691, Walmart, FORT PAYNE, AL",
            disabled: false,
          },
          {
            name: "6910, CVS, CHESTERTON, IN",
            disabled: false,
          },
          {
            name: "6910, Walgreens, MURFREESBORO, TN",
            disabled: false,
          },
          {
            name: "6911, CVS, PORTAGE, IN",
            disabled: false,
          },
          {
            name: "6911, Walgreens, HOLLAND, MI",
            disabled: false,
          },
          {
            name: "6912, CVS, CEDAR LAKE, IN",
            disabled: false,
          },
          {
            name: "6912, Walgreens, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "6913, CVS, HOBART, IN",
            disabled: false,
          },
          {
            name: "6913, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "6914, CVS, DEMOTTE, IN",
            disabled: false,
          },
          {
            name: "6914, Walgreens, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "6915, CVS, VALPARAISO, IN",
            disabled: false,
          },
          {
            name: "6915, Walgreens, ROCKLIN, CA",
            disabled: false,
          },
          {
            name: "6916, CVS, NEW CUMBERLAND, PA",
            disabled: false,
          },
          {
            name: "6916, Walgreens, OAK PARK HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "6917, CVS, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "6917, Walgreens, LACEY, WA",
            disabled: false,
          },
          {
            name: "6918, CVS, PALESTINE, TX",
            disabled: false,
          },
          {
            name: "692, CVS, NORTH HAVEN, CT",
            disabled: false,
          },
          {
            name: "692, Costco, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "692, HEB, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "692, Kroger, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "692, Target, NOVATO, CA",
            disabled: false,
          },
          {
            name: "692, Walmart, DANVILLE, KY",
            disabled: false,
          },
          {
            name: "6920, CVS, THE COLONY, TX",
            disabled: false,
          },
          {
            name: "6920, Walgreens, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "6921, CVS, CENTRALIA, IL",
            disabled: false,
          },
          {
            name: "6922, CVS, SHELBYVILLE, IL",
            disabled: false,
          },
          {
            name: "6923, CVS, SULLIVAN, IL",
            disabled: false,
          },
          {
            name: "6923, Walgreens, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "6924, CVS, WESTVILLE, IL",
            disabled: false,
          },
          {
            name: "6924, Walgreens, PAOLI, PA",
            disabled: false,
          },
          {
            name: "6925, CVS, KILGORE, TX",
            disabled: false,
          },
          {
            name: "6926, CVS, HIGHLAND, IL",
            disabled: false,
          },
          {
            name: "6926, Walgreens, WILSON, NC",
            disabled: false,
          },
          {
            name: "6927, CVS, HOOPESTON, IL",
            disabled: false,
          },
          {
            name: "6927, Walgreens, WILSON, NC",
            disabled: false,
          },
          {
            name: "6928, Walgreens, ORANGE PARK, FL",
            disabled: false,
          },
          {
            name: "6929, CVS, CARLYLE, IL",
            disabled: false,
          },
          {
            name: "6929, Walgreens, CHERRY HILL, NJ",
            disabled: false,
          },
          {
            name: "6929, Walmart, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "693, ADUSA, ASHLAND CITY, TN",
            disabled: false,
          },
          {
            name: "693, CVS, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "693, Costco, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "693, HEB, KENEDY, TX",
            disabled: false,
          },
          {
            name: "693, Kroger, LINCOLN PARK, MI",
            disabled: false,
          },
          {
            name: "693, Kroger, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "693, Target, BROOKLYN PARK, MN",
            disabled: false,
          },
          {
            name: "693, Walmart, JACKSON, KY",
            disabled: false,
          },
          {
            name: "6930, CVS, GREENVILLE, IL",
            disabled: false,
          },
          {
            name: "6930, Walgreens, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "6931, CVS, CLINTON, IL",
            disabled: false,
          },
          {
            name: "6931, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "6931, Walmart, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "6932, CVS, HILLSBORO, IL",
            disabled: false,
          },
          {
            name: "6932, Walgreens, PORTER, TX",
            disabled: false,
          },
          {
            name: "6932, Walmart, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "6933, CVS, RANTOUL, IL",
            disabled: false,
          },
          {
            name: "6935, CVS, MAHOMET, IL",
            disabled: false,
          },
          {
            name: "6935, Walgreens, STEVENS POINT, WI",
            disabled: false,
          },
          {
            name: "6936, Walmart, STAFFORD, VA",
            disabled: false,
          },
          {
            name: "6937, CVS, DANVILLE, IL",
            disabled: false,
          },
          {
            name: "6937, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "6937, Walmart, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "6939, Walgreens, MEDWAY, MA",
            disabled: false,
          },
          {
            name: "694, ADUSA, NORTH HAVEN, CT",
            disabled: false,
          },
          {
            name: "694, Albertsons, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "694, Costco, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "694, HEB, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "694, Kroger, HAPPY VALLEY, OR",
            disabled: false,
          },
          {
            name: "694, Kroger, Haltom City, TX",
            disabled: false,
          },
          {
            name: "694, Kroger, MILLEDGEVILLE, GA",
            disabled: false,
          },
          {
            name: "694, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "694, Target, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "694, Walmart, HENDERSON, KY",
            disabled: false,
          },
          {
            name: "6940, CVS, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "6940, Walgreens, LEESBURG, FL",
            disabled: false,
          },
          {
            name: "6941, CVS, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "6941, Walgreens, DEERFIELD BEACH, FL",
            disabled: false,
          },
          {
            name: "6941, Walmart, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "6942, CVS, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "6942, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "6942, Walmart, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "6943, Walgreens, INVER GROVE HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "6943, Walmart, JONESBORO, AR",
            disabled: false,
          },
          {
            name: "6944, CVS, PARIS, TX",
            disabled: false,
          },
          {
            name: "6944, Walgreens, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "6945, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6946, CVS, WHITEHALL, OH",
            disabled: false,
          },
          {
            name: "6949, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6949, Walgreens, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "695, ADUSA, CHESHIRE, CT",
            disabled: false,
          },
          {
            name: "695, ADUSA, VERONA, PA",
            disabled: false,
          },
          {
            name: "695, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "695, CVS, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "695, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "695, Kroger, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "695, Kroger, Southgate, MI",
            disabled: false,
          },
          {
            name: "695, Target, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "695, Walmart, MADISON, TN",
            disabled: false,
          },
          {
            name: "6950, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6950, Walgreens, MACON, GA",
            disabled: false,
          },
          {
            name: "6951, Walmart, SUTTON, WV",
            disabled: false,
          },
          {
            name: "6952, Walmart, TIMBERVILLE, VA",
            disabled: false,
          },
          {
            name: "6953, CVS, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "6953, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "6953, Walmart, CENTERTON, AR",
            disabled: false,
          },
          {
            name: "6954, CVS, MIDDLETOWN, OH",
            disabled: false,
          },
          {
            name: "6954, Walgreens, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "6955, CVS, CONVERSE, TX",
            disabled: false,
          },
          {
            name: "6955, Walgreens, HUEYTOWN, AL",
            disabled: false,
          },
          {
            name: "6956, CVS, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "6956, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "6957, Walgreens, BOUND BROOK, NJ",
            disabled: false,
          },
          {
            name: "6958, CVS, LADSON, SC",
            disabled: false,
          },
          {
            name: "6958, Walgreens, ARLINGTON, TN",
            disabled: false,
          },
          {
            name: "6958, Walmart, CAMERON, NC",
            disabled: false,
          },
          {
            name: "6959, CVS, HENDERSON, TX",
            disabled: false,
          },
          {
            name: "6959, Walgreens, BENTON, AR",
            disabled: false,
          },
          {
            name: "696, ADUSA, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "696, Albertsons, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "696, CVS, BROOKFIELD, CT",
            disabled: false,
          },
          {
            name: "696, HEB, HUTTO, TX",
            disabled: false,
          },
          {
            name: "696, Kroger, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "696, Rite Aid, MAHANOY CITY, PA",
            disabled: false,
          },
          {
            name: "696, Target, BURLINGTON, WA",
            disabled: false,
          },
          {
            name: "696, Walmart, PRESTONSBURG, KY",
            disabled: false,
          },
          {
            name: "6960, CVS, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "6960, Walgreens, HARTFORD, WI",
            disabled: false,
          },
          {
            name: "6960, Walmart, SILOAM SPRINGS, AR",
            disabled: false,
          },
          {
            name: "6961, CVS, WEATHERFORD, TX",
            disabled: false,
          },
          {
            name: "6961, Walgreens, TAYLORSVILLE, UT",
            disabled: false,
          },
          {
            name: "6962, CVS, WOODWAY, TX",
            disabled: false,
          },
          {
            name: "6962, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "6962, Walmart, ROCK HILL, SC",
            disabled: false,
          },
          {
            name: "6963, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6963, Walgreens, PARIS, TN",
            disabled: false,
          },
          {
            name: "6963, Walmart, ANNA, TX",
            disabled: false,
          },
          {
            name: "6964, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "6964, Walmart, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "6965, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6965, Walgreens, GRANGER, IN",
            disabled: false,
          },
          {
            name: "6966, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6966, Walgreens, WATERBURY, CT",
            disabled: false,
          },
          {
            name: "6966, Walmart, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "6967, CVS, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "6967, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "6967, Walmart, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "6968, Walgreens, DANBURY, CT",
            disabled: false,
          },
          {
            name: "6968, Walmart, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "6969, CVS, SNYDER, TX",
            disabled: false,
          },
          {
            name: "697, ADUSA, DAYVILLE, CT",
            disabled: false,
          },
          {
            name: "697, Albertsons, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "697, CVS, MAMARONECK, NY",
            disabled: false,
          },
          {
            name: "697, HEB, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "697, Kroger, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "697, Kroger, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "697, Walmart, OCALA, FL",
            disabled: false,
          },
          {
            name: "6970, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "6970, Walgreens, SANFORD, FL",
            disabled: false,
          },
          {
            name: "6971, CVS, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "6971, Walgreens, BOISE, ID",
            disabled: false,
          },
          {
            name: "6971, Walmart, PEA RIDGE, AR",
            disabled: false,
          },
          {
            name: "6972, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "6972, Walgreens, COVINA, CA",
            disabled: false,
          },
          {
            name: "6973, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "6974, Walgreens, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "6975, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "6975, Walgreens, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "6975, Walmart, CABOT, AR",
            disabled: false,
          },
          {
            name: "6976, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "6976, Walgreens, PALMDALE, CA",
            disabled: false,
          },
          {
            name: "6977, Walgreens, IRONDALE, AL",
            disabled: false,
          },
          {
            name: "6978, CVS, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "6978, Walgreens, NICEVILLE, FL",
            disabled: false,
          },
          {
            name: "6978, Walmart, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "6979, CVS, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "6979, Walgreens, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "698, ADUSA, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "698, ADUSA, DENTON, MD",
            disabled: false,
          },
          {
            name: "698, ADUSA, MCDONALD, PA",
            disabled: false,
          },
          {
            name: "698, HEB, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "698, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "698, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "698, Kroger, Plano, TX",
            disabled: false,
          },
          {
            name: "698, Walmart, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "6980, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "6981, CVS, BENBROOK, TX",
            disabled: false,
          },
          {
            name: "6981, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "6982, CVS, THE COLONY, TX",
            disabled: false,
          },
          {
            name: "6983, CVS, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "6983, Walgreens, SOMERSET, NJ",
            disabled: false,
          },
          {
            name: "6984, CVS, DENISON, TX",
            disabled: false,
          },
          {
            name: "6985, Walgreens, LAKELAND, TN",
            disabled: false,
          },
          {
            name: "6986, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "6987, Walgreens, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "6988, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "6988, Walgreens, WEST JORDAN, UT",
            disabled: false,
          },
          {
            name: "6989, Walgreens, MANCHESTER, MO",
            disabled: false,
          },
          {
            name: "699, ADUSA, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "699, ADUSA, SOUTH WINDSOR, CT",
            disabled: false,
          },
          {
            name: "699, Albertsons, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "699, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "699, Kroger, SMYRNA, GA",
            disabled: false,
          },
          {
            name: "699, Kroger, YUMA, AZ",
            disabled: false,
          },
          {
            name: "699, Target, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "699, Walmart, OXFORD, MS",
            disabled: false,
          },
          {
            name: "6990, Walgreens, FAIRBORN, OH",
            disabled: false,
          },
          {
            name: "6991, Walgreens, SEBASTIAN, FL",
            disabled: false,
          },
          {
            name: "6992, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "6992, Walgreens, VERNON ROCKVILLE, CT",
            disabled: false,
          },
          {
            name: "6993, Walgreens, MARYVILLE, TN",
            disabled: false,
          },
          {
            name: "6995, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "6996, CVS, SPRINGDALE, OH",
            disabled: false,
          },
          {
            name: "6996, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "6997, CVS, PAWLING, NY",
            disabled: false,
          },
          {
            name: "6997, Walgreens, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "6998, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "6998, Walgreens, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "6998, Walmart, EAST POINT, GA",
            disabled: false,
          },
          {
            name: "6999, CVS, BERWYN, PA",
            disabled: false,
          },
          {
            name: "6999, Walgreens, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "7, ADUSA, MANSFIELD, MA",
            disabled: false,
          },
          {
            name: "7, BJ's, ALBANY, NY",
            disabled: false,
          },
          {
            name: "7, CVS, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "7, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "7, Kroger, Corvallis, OR",
            disabled: false,
          },
          {
            name: "7, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "7, Kroger, Sterling, KS",
            disabled: false,
          },
          {
            name: "7, Walmart, SHERWOOD, AR",
            disabled: false,
          },
          {
            name: "70, ADUSA, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "70, Albertsons, COLLEYVILLE, TX",
            disabled: false,
          },
          {
            name: "70, BJ's, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "70, CVS, FLOSSMOOR, IL",
            disabled: false,
          },
          {
            name: "70, HEB, ABILENE, TX",
            disabled: false,
          },
          {
            name: "70, Kroger, CORVALLIS, OR",
            disabled: false,
          },
          {
            name: "70, Kroger, FOUNTAIN HILLS, AZ",
            disabled: false,
          },
          {
            name: "70, Kroger, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "70, Kroger, Littleton, CO",
            disabled: false,
          },
          {
            name: "70, Kroger, Petersburg, IN",
            disabled: false,
          },
          {
            name: "70, Kroger, WOODLAND HILLS, CA",
            disabled: false,
          },
          {
            name: "70, Meijer, WOODHAVEN, MI",
            disabled: false,
          },
          {
            name: "70, Walmart, WEST MEMPHIS, AR",
            disabled: false,
          },
          {
            name: "700, Albertsons, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "700, Kroger, Garden City, MI",
            disabled: false,
          },
          {
            name: "700, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "700, Kroger, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "700, Target, ORO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "700, Walmart, SELMA, AL",
            disabled: false,
          },
          {
            name: "7000, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7000, Walgreens, WARRINGTON, PA",
            disabled: false,
          },
          {
            name: "7001, Walgreens, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "7002, CVS, AMHERST, VA",
            disabled: false,
          },
          {
            name: "7003, CVS, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "7004, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "7004, Walgreens, BOSSIER CITY, LA",
            disabled: false,
          },
          {
            name: "7004, Walmart, DALLAS, NC",
            disabled: false,
          },
          {
            name: "7005, CVS, LANCASTER, SC",
            disabled: false,
          },
          {
            name: "7005, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7007, Walgreens, RIVERTON, UT",
            disabled: false,
          },
          {
            name: "7008, CVS, COLUMBUS, NC",
            disabled: false,
          },
          {
            name: "7009, Walgreens, WAUSAU, WI",
            disabled: false,
          },
          {
            name: "7009, Walmart, RICHLANDS, NC",
            disabled: false,
          },
          {
            name: "701, ADUSA, NEWPORT, RI",
            disabled: false,
          },
          {
            name: "701, ADUSA, TROUTMAN, NC",
            disabled: false,
          },
          {
            name: "701, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "701, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "701, Kroger, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "701, Walmart, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "7010, Walgreens, VALRICO, FL",
            disabled: false,
          },
          {
            name: "7011, Walgreens, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "7012, CVS, BALLENTINE, SC",
            disabled: false,
          },
          {
            name: "7013, CVS, WEAVERVILLE, NC",
            disabled: false,
          },
          {
            name: "7014, Walgreens, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "7015, Walgreens, CHATSWORTH, CA",
            disabled: false,
          },
          {
            name: "7016, CVS, PAWLEYS ISLAND, SC",
            disabled: false,
          },
          {
            name: "7016, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "7017, CVS, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "7018, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "7018, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7019, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "702, CVS, ZION, IL",
            disabled: false,
          },
          {
            name: "702, HEB, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "702, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "702, Kroger, SHERMAN OAKS, CA",
            disabled: false,
          },
          {
            name: "702, Kroger, St. Matthews, KY",
            disabled: false,
          },
          {
            name: "702, Walmart, WINCHESTER, KY",
            disabled: false,
          },
          {
            name: "7020, CVS, NORMAL, IL",
            disabled: false,
          },
          {
            name: "7020, Walgreens, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "7020, Walmart, LA VERGNE, TN",
            disabled: false,
          },
          {
            name: "7021, CVS, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "7021, Walgreens, AURORA, CO",
            disabled: false,
          },
          {
            name: "7022, CVS, LAKE HAVASU CITY, AZ",
            disabled: false,
          },
          {
            name: "7022, Walgreens, FOUNTAIN, CO",
            disabled: false,
          },
          {
            name: "7023, Walgreens, LAKEWAY, TX",
            disabled: false,
          },
          {
            name: "7024, Walgreens, ODESSA, TX",
            disabled: false,
          },
          {
            name: "7026, CVS, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "7026, Walgreens, EL MIRAGE, AZ",
            disabled: false,
          },
          {
            name: "7028, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "7029, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "7029, Walgreens, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "703, ADUSA, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "703, ADUSA, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "703, Albertsons, CHESTER SPRINGS, PA",
            disabled: false,
          },
          {
            name: "703, Kroger, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "703, Kroger, CANTON, MI",
            disabled: false,
          },
          {
            name: "703, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "703, Walmart, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "7030, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "7031, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "7031, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "7032, CVS, ARMONK, NY",
            disabled: false,
          },
          {
            name: "7032, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "7032, Walmart, HENRICO, VA",
            disabled: false,
          },
          {
            name: "7033, Walgreens, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "7034, Walgreens, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "7036, CVS, CLOVER, SC",
            disabled: false,
          },
          {
            name: "7036, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "7038, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7038, Walgreens, CORDOVA, TN",
            disabled: false,
          },
          {
            name: "7039, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "7039, Walgreens, MUKWONAGO, WI",
            disabled: false,
          },
          {
            name: "704, ADUSA, CUMBERLAND, RI",
            disabled: false,
          },
          {
            name: "704, Albertsons, ALPINE, CA",
            disabled: false,
          },
          {
            name: "704, CVS, NORTHBOROUGH, MA",
            disabled: false,
          },
          {
            name: "704, Kroger, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "704, Kroger, GREENSBURG, KS",
            disabled: false,
          },
          {
            name: "704, Kroger, OTTAWA, IL",
            disabled: false,
          },
          {
            name: "704, Kroger, Shelby Township, MI",
            disabled: false,
          },
          {
            name: "7040, CVS, LITTLE RIVER, SC",
            disabled: false,
          },
          {
            name: "7041, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7042, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "7043, CVS, KENANSVILLE, NC",
            disabled: false,
          },
          {
            name: "7043, Walmart, RIVERTON, UT",
            disabled: false,
          },
          {
            name: "7044, CVS, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "7045, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "7046, CVS, HAMPSTEAD, NC",
            disabled: false,
          },
          {
            name: "7046, Walgreens, FAIRFIELD, OH",
            disabled: false,
          },
          {
            name: "7047, CVS, DURHAM, NC",
            disabled: false,
          },
          {
            name: "7047, Walgreens, NEWINGTON, CT",
            disabled: false,
          },
          {
            name: "7048, CVS, OCEAN ISLE BEACH, NC",
            disabled: false,
          },
          {
            name: "7049, CVS, ARCHDALE, NC",
            disabled: false,
          },
          {
            name: "7049, Walgreens, GREENEVILLE, TN",
            disabled: false,
          },
          {
            name: "705, ADUSA, GREENVILLE, RI",
            disabled: false,
          },
          {
            name: "705, Albertsons, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "705, CVS, WEST BOYLSTON, MA",
            disabled: false,
          },
          {
            name: "705, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "705, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "705, Kroger, EAST PEORIA, IL",
            disabled: false,
          },
          {
            name: "705, Kroger, PACIFIC PALISADES, CA",
            disabled: false,
          },
          {
            name: "705, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "705, Kroger, RICHMOND, KY",
            disabled: false,
          },
          {
            name: "705, Walmart, MOUNT DORA, FL",
            disabled: false,
          },
          {
            name: "7050, Walgreens, FESTUS, MO",
            disabled: false,
          },
          {
            name: "7051, CVS, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "7052, Walgreens, SAINT GEORGE, UT",
            disabled: false,
          },
          {
            name: "7053, CVS, MEBANE, NC",
            disabled: false,
          },
          {
            name: "7054, CVS, HARRISBURG, NC",
            disabled: false,
          },
          {
            name: "7055, CVS, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "7056, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7056, Walgreens, COLONIA, NJ",
            disabled: false,
          },
          {
            name: "7057, Walgreens, FRANKLIN SQUARE, NY",
            disabled: false,
          },
          {
            name: "7058, Walgreens, NEWBURGH, IN",
            disabled: false,
          },
          {
            name: "7059, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "706, ADUSA, GEORGETOWN, SC",
            disabled: false,
          },
          {
            name: "706, Albertsons, CARMEL, CA",
            disabled: false,
          },
          {
            name: "706, CVS, ACTON, MA",
            disabled: false,
          },
          {
            name: "706, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "706, Kroger, RICHMOND, MI",
            disabled: false,
          },
          {
            name: "706, Walmart, ZEPHYRHILLS, FL",
            disabled: false,
          },
          {
            name: "7060, Walgreens, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "7061, CVS, MOORE, SC",
            disabled: false,
          },
          {
            name: "7061, Walgreens, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "7062, CVS, WHITSETT, NC",
            disabled: false,
          },
          {
            name: "7062, Walmart, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "7063, CVS, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "7063, Walgreens, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "7064, CVS, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "7064, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "7065, CVS, PONTOTOC, MS",
            disabled: false,
          },
          {
            name: "7065, Walgreens, FENTON, MI",
            disabled: false,
          },
          {
            name: "7066, CVS, BRONX, NY",
            disabled: false,
          },
          {
            name: "7068, CVS, TYRONE, GA",
            disabled: false,
          },
          {
            name: "7068, Walgreens, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "7069, CVS, HAZLET, NJ",
            disabled: false,
          },
          {
            name: "7069, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "707, ADUSA, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "707, ADUSA, SHELBY, NC",
            disabled: false,
          },
          {
            name: "707, Albertsons, LEMON GROVE, CA",
            disabled: false,
          },
          {
            name: "707, CVS, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "707, HEB, LAKE JACKSON, TX",
            disabled: false,
          },
          {
            name: "707, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "707, Kroger, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "707, Walmart, CLARKSDALE, MS",
            disabled: false,
          },
          {
            name: "7070, Walgreens, MARINA DEL REY, CA",
            disabled: false,
          },
          {
            name: "7071, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7072, Walmart, CAPE GIRARDEAU, MO",
            disabled: false,
          },
          {
            name: "7073, CVS, PENNSBURG, PA",
            disabled: false,
          },
          {
            name: "7073, Walgreens, PASADENA, TX",
            disabled: false,
          },
          {
            name: "7074, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "7075, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "7076, Walgreens, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "7077, CVS, ANDALUSIA, AL",
            disabled: false,
          },
          {
            name: "7078, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "7078, Walgreens, VENICE, FL",
            disabled: false,
          },
          {
            name: "7079, CVS, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "7079, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "708, ADUSA, MIDDLETOWN, RI",
            disabled: false,
          },
          {
            name: "708, Albertsons, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "708, CVS, AUBURN, MA",
            disabled: false,
          },
          {
            name: "708, HEB, WIMBERLEY, TX",
            disabled: false,
          },
          {
            name: "708, Kroger, Brownstown Township, MI",
            disabled: false,
          },
          {
            name: "708, Kroger, Brownstown Twp, MI",
            disabled: false,
          },
          {
            name: "708, Kroger, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "708, Kroger, RIPLEY, WV",
            disabled: false,
          },
          {
            name: "708, Walmart, VICKSBURG, MS",
            disabled: false,
          },
          {
            name: "7080, CVS, ROBSTOWN, TX",
            disabled: false,
          },
          {
            name: "7080, Walgreens, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "7081, CVS, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "7083, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "7085, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "7086, Walgreens, PLAINVILLE, CT",
            disabled: false,
          },
          {
            name: "7087, CVS, YONKERS, NY",
            disabled: false,
          },
          {
            name: "7087, Walgreens, MENLO PARK, CA",
            disabled: false,
          },
          {
            name: "7087, Walmart, SALEM, IN",
            disabled: false,
          },
          {
            name: "7088, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "7088, Walgreens, LOS ALTOS, CA",
            disabled: false,
          },
          {
            name: "7089, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "709, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "709, CVS, TARPON SPRINGS, FL",
            disabled: false,
          },
          {
            name: "709, HEB, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "709, Kroger, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "709, Kroger, Georgetown, KY",
            disabled: false,
          },
          {
            name: "709, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "709, Walmart, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "7090, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7092, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7093, CVS, DANBURY, CT",
            disabled: false,
          },
          {
            name: "7093, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "7094, CVS, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "7096, CVS, BRIGANTINE, NJ",
            disabled: false,
          },
          {
            name: "7096, Walgreens, ABERDEEN, NC",
            disabled: false,
          },
          {
            name: "7097, CVS, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "7098, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "7098, Walmart, NEWPORT, NC",
            disabled: false,
          },
          {
            name: "7099, CVS, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "7099, Walmart, MORGAN CITY, LA",
            disabled: false,
          },
          {
            name: "71, ADUSA, ALTOONA, PA",
            disabled: false,
          },
          {
            name: "71, ADUSA, FALL RIVER, MA",
            disabled: false,
          },
          {
            name: "71, CVS, MILFORD, CT",
            disabled: false,
          },
          {
            name: "71, HEB, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "71, Kroger, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "71, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "71, Kroger, Castle Rock, CO",
            disabled: false,
          },
          {
            name: "71, Kroger, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "71, Kroger, KOKOMO, IN",
            disabled: false,
          },
          {
            name: "71, Meijer, Muskegon, MI",
            disabled: false,
          },
          {
            name: "71, Walmart, POCAHONTAS, AR",
            disabled: false,
          },
          {
            name: "710, ADUSA, PAWTUCKET, RI",
            disabled: false,
          },
          {
            name: "710, Albertsons, LA MESA, CA",
            disabled: false,
          },
          {
            name: "710, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "710, Kroger, CARROLLTON, KY",
            disabled: false,
          },
          {
            name: "710, Kroger, CHATSWORTH, CA",
            disabled: false,
          },
          {
            name: "710, Kroger, COLUMBUS, IN",
            disabled: false,
          },
          {
            name: "710, Kroger, HARPER WOODS, MI",
            disabled: false,
          },
          {
            name: "710, Walmart, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "7100, Walgreens, ELGIN, IL",
            disabled: false,
          },
          {
            name: "7101, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "7103, CVS, WILLISTON, VT",
            disabled: false,
          },
          {
            name: "7104, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7105, CVS, ROCHELLE PARK, NJ",
            disabled: false,
          },
          {
            name: "7105, Walgreens, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "7106, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "7107, Walgreens, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "7108, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "7109, CVS, SALEM, MA",
            disabled: false,
          },
          {
            name: "7109, Walgreens, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "711, ADUSA, CHESTER, VA",
            disabled: false,
          },
          {
            name: "711, Albertsons, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "711, HEB, ODESSA, TX",
            disabled: false,
          },
          {
            name: "711, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "711, Kroger, MOUNT VERNON, IL",
            disabled: false,
          },
          {
            name: "711, Kroger, SWARTZ CREEK, MI",
            disabled: false,
          },
          {
            name: "711, Walmart, GLASGOW, KY",
            disabled: false,
          },
          {
            name: "7110, CVS, ANDOVER, MN",
            disabled: false,
          },
          {
            name: "7110, Walgreens, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "7111, CVS, GRANBY, MA",
            disabled: false,
          },
          {
            name: "7111, Walgreens, FOREST LAKE, MN",
            disabled: false,
          },
          {
            name: "7112, CVS, MONTEVALLO, AL",
            disabled: false,
          },
          {
            name: "7112, Walgreens, KELLER, TX",
            disabled: false,
          },
          {
            name: "7113, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "7114, Walgreens, GLEN ALLEN, VA",
            disabled: false,
          },
          {
            name: "7115, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "7115, Walgreens, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "7116, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7116, Walgreens, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "7117, Walgreens, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "7119, Walgreens, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "712, ADUSA, LINCOLN, RI",
            disabled: false,
          },
          {
            name: "712, Albertsons, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "712, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "712, HEB, CUERO, TX",
            disabled: false,
          },
          {
            name: "712, Kroger, BURBANK, CA",
            disabled: false,
          },
          {
            name: "712, Kroger, Mount Sterling, KY",
            disabled: false,
          },
          {
            name: "712, Kroger, Vancouver, WA",
            disabled: false,
          },
          {
            name: "712, Rite Aid, JEFFERSON, OH",
            disabled: false,
          },
          {
            name: "712, Walmart, SCOTTSBORO, AL",
            disabled: false,
          },
          {
            name: "7120, CVS, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "7120, Walgreens, MCMINNVILLE, OR",
            disabled: false,
          },
          {
            name: "7122, CVS, CONCORD, NH",
            disabled: false,
          },
          {
            name: "7124, CVS, HURRICANE, WV",
            disabled: false,
          },
          {
            name: "7124, Walgreens, PISCATAWAY, NJ",
            disabled: false,
          },
          {
            name: "7126, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7126, Walgreens, DULUTH, MN",
            disabled: false,
          },
          {
            name: "7127, Walmart, POPLAR BLUFF, MO",
            disabled: false,
          },
          {
            name: "7128, CVS, CHICO, CA",
            disabled: false,
          },
          {
            name: "7129, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "7129, Walmart, OGALLALA, NE",
            disabled: false,
          },
          {
            name: "713, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "713, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "713, Kroger, Mission Hills, CA",
            disabled: false,
          },
          {
            name: "713, Kroger, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "713, Rite Aid, WARREN, OH",
            disabled: false,
          },
          {
            name: "713, Walmart, DADE CITY, FL",
            disabled: false,
          },
          {
            name: "7130, CVS, TARRYTOWN, NY",
            disabled: false,
          },
          {
            name: "7130, Walgreens, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "7131, Walgreens, ANACORTES, WA",
            disabled: false,
          },
          {
            name: "7132, CVS, THORNDALE, PA",
            disabled: false,
          },
          {
            name: "7132, Walgreens, EVERETT, WA",
            disabled: false,
          },
          {
            name: "7133, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "7134, CVS, WHEATON, IL",
            disabled: false,
          },
          {
            name: "7134, Walgreens, ATHENS, GA",
            disabled: false,
          },
          {
            name: "7135, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "7136, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "7136, Walgreens, ENUMCLAW, WA",
            disabled: false,
          },
          {
            name: "7137, CVS, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "7137, Walgreens, UNIVERSITY PLACE, WA",
            disabled: false,
          },
          {
            name: "7137, Walmart, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "7138, Walgreens, PARKER, CO",
            disabled: false,
          },
          {
            name: "7139, CVS, FULTON, MD",
            disabled: false,
          },
          {
            name: "7139, Walgreens, FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "714, ADUSA, CRANSTON, RI",
            disabled: false,
          },
          {
            name: "714, Albertsons, HAMMOND, LA",
            disabled: false,
          },
          {
            name: "714, HEB, LAKEWAY, TX",
            disabled: false,
          },
          {
            name: "714, Kroger, CARBONDALE, IL",
            disabled: false,
          },
          {
            name: "714, Kroger, DAVISON, MI",
            disabled: false,
          },
          {
            name: "714, Kroger, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "714, Walmart, HELENA-WEST HELENA, AR",
            disabled: false,
          },
          {
            name: "7140, CVS, WESTPORT, MA",
            disabled: false,
          },
          {
            name: "7140, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "7141, CVS, NAPA, CA",
            disabled: false,
          },
          {
            name: "7142, CVS, LOCKPORT, IL",
            disabled: false,
          },
          {
            name: "7142, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "7143, CVS, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "7143, Walgreens, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "7144, CVS, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "7145, Walgreens, WESTPORT, CT",
            disabled: false,
          },
          {
            name: "7146, Walmart, KINGS MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "7147, CVS, MADISON, WI",
            disabled: false,
          },
          {
            name: "7147, Walgreens, WICHITA, KS",
            disabled: false,
          },
          {
            name: "7148, Walgreens, HUTCHINSON, KS",
            disabled: false,
          },
          {
            name: "7149, Walgreens, LONGWOOD, FL",
            disabled: false,
          },
          {
            name: "715, CVS, WAYNE, NJ",
            disabled: false,
          },
          {
            name: "715, HEB, DEER PARK, TX",
            disabled: false,
          },
          {
            name: "715, Kroger, MONTEREY PARK, CA",
            disabled: false,
          },
          {
            name: "715, Kroger, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "715, Walmart, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "7151, CVS, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "7152, CVS, BLAINE, MN",
            disabled: false,
          },
          {
            name: "7152, Walgreens, NEWTON, KS",
            disabled: false,
          },
          {
            name: "7153, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "7154, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7154, Walgreens, CONWAY, SC",
            disabled: false,
          },
          {
            name: "7155, CVS, MADISON, AL",
            disabled: false,
          },
          {
            name: "7155, Walgreens, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "7156, CVS, RICHARDSON, TX",
            disabled: false,
          },
          {
            name: "7156, Walgreens, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "7156, Walmart, HEWITT, TX",
            disabled: false,
          },
          {
            name: "7157, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7158, Walgreens, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "7159, CVS, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "716, ADUSA, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "716, Albertsons, DENISON, TX",
            disabled: false,
          },
          {
            name: "716, CVS, NORTHVALE, NJ",
            disabled: false,
          },
          {
            name: "716, HEB, SEGUIN, TX",
            disabled: false,
          },
          {
            name: "716, Kroger, Macomb, MI",
            disabled: false,
          },
          {
            name: "716, Walmart, GREENWOOD, MS",
            disabled: false,
          },
          {
            name: "7160, Walgreens, GRANDVILLE, MI",
            disabled: false,
          },
          {
            name: "7162, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7162, Walmart, SURF CITY, NC",
            disabled: false,
          },
          {
            name: "7163, CVS, HOPE MILLS, NC",
            disabled: false,
          },
          {
            name: "7163, Walgreens, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "7164, CVS, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "7164, Walgreens, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "7165, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7166, CVS, RIVERDALE, IL",
            disabled: false,
          },
          {
            name: "7166, Walgreens, NEW IBERIA, LA",
            disabled: false,
          },
          {
            name: "7167, Walgreens, DUNWOODY, GA",
            disabled: false,
          },
          {
            name: "7168, CVS, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "7168, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "7168, Walmart, HERRIMAN, UT",
            disabled: false,
          },
          {
            name: "7169, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "717, Albertsons, LAKE CHARLES, LA",
            disabled: false,
          },
          {
            name: "717, HEB, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "717, Kroger, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "717, Kroger, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "7170, CVS, ROUND LAKE, IL",
            disabled: false,
          },
          {
            name: "7171, CVS, LODI, NJ",
            disabled: false,
          },
          {
            name: "7172, CVS, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "7173, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "7173, Walgreens, GRAHAM, WA",
            disabled: false,
          },
          {
            name: "7174, Walgreens, GREENFIELD, IN",
            disabled: false,
          },
          {
            name: "7174, Walmart, NORTH CHESTERFIELD, VA",
            disabled: false,
          },
          {
            name: "7175, CVS, WHITE BEAR LAKE, MN",
            disabled: false,
          },
          {
            name: "7175, Walgreens, GARDENA, CA",
            disabled: false,
          },
          {
            name: "7176, Walgreens, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "7177, Walgreens, SUN CITY CENTER, FL",
            disabled: false,
          },
          {
            name: "7177, Walmart, ROCKINGHAM, VA",
            disabled: false,
          },
          {
            name: "7178, CVS, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "7178, Walgreens, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "7178, Walmart, PRINCETON, TX",
            disabled: false,
          },
          {
            name: "7179, CVS, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "7179, Walmart, SWANSBORO, NC",
            disabled: false,
          },
          {
            name: "718, ADUSA, NARRAGANSETT, RI",
            disabled: false,
          },
          {
            name: "718, CVS, ANSONIA, CT",
            disabled: false,
          },
          {
            name: "718, Kroger, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "718, Walmart, AUBURNDALE, FL",
            disabled: false,
          },
          {
            name: "7180, Walmart, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "7181, CVS, BARRINGTON, IL",
            disabled: false,
          },
          {
            name: "7181, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "7181, Walmart, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "7183, CVS, LANDENBERG, PA",
            disabled: false,
          },
          {
            name: "7184, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "7184, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "7185, CVS, SEAFORD, NY",
            disabled: false,
          },
          {
            name: "7185, Walgreens, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "7185, Walmart, CUMMING, GA",
            disabled: false,
          },
          {
            name: "7187, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7187, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7188, CVS, MIDDLEBURY, IN",
            disabled: false,
          },
          {
            name: "7188, Walgreens, HILLTOP, MN",
            disabled: false,
          },
          {
            name: "7188, Walmart, DARLINGTON, SC",
            disabled: false,
          },
          {
            name: "7189, CVS, WRIGHTSTOWN, PA",
            disabled: false,
          },
          {
            name: "7189, Walgreens, ROXBURY CROSSING, MA",
            disabled: false,
          },
          {
            name: "719, Albertsons, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "719, Kroger, Corbin, KY",
            disabled: false,
          },
          {
            name: "719, Kroger, Lancaster, CA",
            disabled: false,
          },
          {
            name: "719, Walmart, RICHMOND, KY",
            disabled: false,
          },
          {
            name: "7190, CVS, WARETOWN, NJ",
            disabled: false,
          },
          {
            name: "7191, CVS, LAWNDALE, CA",
            disabled: false,
          },
          {
            name: "7191, Walgreens, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "7192, CVS, SLIDELL, LA",
            disabled: false,
          },
          {
            name: "7193, CVS, MISSION, TX",
            disabled: false,
          },
          {
            name: "7194, Walmart, ADEL, GA",
            disabled: false,
          },
          {
            name: "7195, Walgreens, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "7196, CVS, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "7196, Walgreens, NORTH WALES, PA",
            disabled: false,
          },
          {
            name: "7197, CVS, MAPLE GROVE, MN",
            disabled: false,
          },
          {
            name: "7197, Walgreens, MOSS BLUFF, LA",
            disabled: false,
          },
          {
            name: "7198, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7199, Walgreens, ROME, GA",
            disabled: false,
          },
          {
            name: "7199, Walmart, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "72, ADUSA, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "72, BJ's, WALDORF, MD",
            disabled: false,
          },
          {
            name: "72, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "72, Kroger, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "72, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "72, Kroger, Johnstown, CO",
            disabled: false,
          },
          {
            name: "72, Kroger, PARK CITY, UT",
            disabled: false,
          },
          {
            name: "72, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "72, Meijer, BELLEVILLE, MI",
            disabled: false,
          },
          {
            name: "72, Walmart, PITTSBURG, KS",
            disabled: false,
          },
          {
            name: "720, ADUSA, COVENTRY, RI",
            disabled: false,
          },
          {
            name: "720, Albertsons, ANCHORAGE, AK",
            disabled: false,
          },
          {
            name: "720, CVS, BOSTON, MA",
            disabled: false,
          },
          {
            name: "720, HEB, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "720, Kroger, HOWELL, MI",
            disabled: false,
          },
          {
            name: "720, Kroger, Lexington, KY",
            disabled: false,
          },
          {
            name: "720, Kroger, RANCHO PALOS VERDES, CA",
            disabled: false,
          },
          {
            name: "720, Kroger, Springfield, OH",
            disabled: false,
          },
          {
            name: "720, Walmart, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "7200, CVS, COCHRAN, GA",
            disabled: false,
          },
          {
            name: "7204, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "7205, Walmart, LEXINGTON, NC",
            disabled: false,
          },
          {
            name: "7206, CVS, MERCED, CA",
            disabled: false,
          },
          {
            name: "7206, Walgreens, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "7206, Walmart, ARCHDALE, NC",
            disabled: false,
          },
          {
            name: "7207, CVS, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "7207, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "7208, CVS, GLENDALE HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "7208, Walgreens, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "7209, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7209, Walmart, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "721, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "721, ADUSA, NORTH SMITHFIELD, RI",
            disabled: false,
          },
          {
            name: "721, Albertsons, PHOENIXVILLE, PA",
            disabled: false,
          },
          {
            name: "721, HEB, KILLEEN, TX",
            disabled: false,
          },
          {
            name: "721, Kroger, CANOGA PARK, CA",
            disabled: false,
          },
          {
            name: "721, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "721, Kroger, PINCKNEY, MI",
            disabled: false,
          },
          {
            name: "721, Walmart, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "7210, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7210, Walgreens, ATASCADERO, CA",
            disabled: false,
          },
          {
            name: "7211, Walgreens, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "7212, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "7212, Walgreens, LISLE, IL",
            disabled: false,
          },
          {
            name: "7213, CVS, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "7213, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7214, CVS, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "7214, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7216, CVS, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "7216, Walgreens, GALESBURG, IL",
            disabled: false,
          },
          {
            name: "7217, CVS, TUSCALOOSA, AL",
            disabled: false,
          },
          {
            name: "7218, Walgreens, BLAINE, MN",
            disabled: false,
          },
          {
            name: "7218, Walmart, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "7219, CVS, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "722, ADUSA, MANCHESTER, TN",
            disabled: false,
          },
          {
            name: "722, ADUSA, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "722, Albertsons, TRINIDAD, CO",
            disabled: false,
          },
          {
            name: "722, CVS, SPRINGFIELD, PA",
            disabled: false,
          },
          {
            name: "722, HEB, MAGNOLIA, TX",
            disabled: false,
          },
          {
            name: "722, Kroger, BUCKHANNON, WV",
            disabled: false,
          },
          {
            name: "722, Kroger, MIAMISBURG, OH",
            disabled: false,
          },
          {
            name: "722, Walmart, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "7220, CVS, PORTLAND, TX",
            disabled: false,
          },
          {
            name: "7220, Walgreens, CHELMSFORD, MA",
            disabled: false,
          },
          {
            name: "7220, Walmart, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "7221, Walmart, NORTH PORT, FL",
            disabled: false,
          },
          {
            name: "7222, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7222, Walgreens, MUSTANG, OK",
            disabled: false,
          },
          {
            name: "7222, Walmart, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "7223, CVS, LAFAYETTE, GA",
            disabled: false,
          },
          {
            name: "7224, CVS, MANDEVILLE, LA",
            disabled: false,
          },
          {
            name: "7224, Walgreens, KING OF PRUSSIA, PA",
            disabled: false,
          },
          {
            name: "7224, Walmart, LANCASTER, TX",
            disabled: false,
          },
          {
            name: "7225, CVS, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "7225, Walgreens, ELKINS PARK, PA",
            disabled: false,
          },
          {
            name: "7226, CVS, MORRISTOWN, TN",
            disabled: false,
          },
          {
            name: "7226, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "7227, CVS, CHATSWORTH, GA",
            disabled: false,
          },
          {
            name: "7228, CVS, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "7229, CVS, LIVINGSTON, TX",
            disabled: false,
          },
          {
            name: "7229, Walgreens, MACON, GA",
            disabled: false,
          },
          {
            name: "7229, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "723, ADUSA, BRISTOL, RI",
            disabled: false,
          },
          {
            name: "723, ADUSA, KNIGHTDALE, NC",
            disabled: false,
          },
          {
            name: "723, Albertsons, SPRING VALLEY, CA",
            disabled: false,
          },
          {
            name: "723, CVS, NASHUA, NH",
            disabled: false,
          },
          {
            name: "723, Kroger, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "723, Walmart, TROY, AL",
            disabled: false,
          },
          {
            name: "7230, Walgreens, POMONA, CA",
            disabled: false,
          },
          {
            name: "7232, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7232, Walmart, DESOTO, TX",
            disabled: false,
          },
          {
            name: "7233, Walgreens, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "7233, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "7234, Walgreens, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "7235, CVS, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "7235, Walgreens, VAN BUREN, AR",
            disabled: false,
          },
          {
            name: "7235, Walmart, WINTERVILLE, NC",
            disabled: false,
          },
          {
            name: "7236, CVS, STEPHENVILLE, TX",
            disabled: false,
          },
          {
            name: "7236, Walgreens, CENTRALIA, IL",
            disabled: false,
          },
          {
            name: "7237, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7238, CVS, MONROE TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "7238, Walmart, GRANTSBORO, NC",
            disabled: false,
          },
          {
            name: "7239, Walgreens, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "724, Albertsons, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "724, CVS, RENSSELAER, NY",
            disabled: false,
          },
          {
            name: "724, HEB, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "724, Kroger, NEW BALTIMORE, MI",
            disabled: false,
          },
          {
            name: "724, Kroger, TROY, MO",
            disabled: false,
          },
          {
            name: "724, Kroger, WEST HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "724, Walmart, JEFFERSON CITY, TN",
            disabled: false,
          },
          {
            name: "7240, Walmart, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "7241, Walgreens, DELTONA, FL",
            disabled: false,
          },
          {
            name: "7241, Walmart, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "7242, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "7242, Walgreens, PARIS, TX",
            disabled: false,
          },
          {
            name: "7242, Walmart, FARMINGTON, AR",
            disabled: false,
          },
          {
            name: "7243, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7243, Walmart, BURGAW, NC",
            disabled: false,
          },
          {
            name: "7244, Walgreens, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "7245, CVS, ROME, GA",
            disabled: false,
          },
          {
            name: "7245, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "7245, Walmart, SYLVESTER, GA",
            disabled: false,
          },
          {
            name: "7246, CVS, NEWPORT, TN",
            disabled: false,
          },
          {
            name: "7246, Walmart, COCHRAN, GA",
            disabled: false,
          },
          {
            name: "7247, CVS, GAHANNA, OH",
            disabled: false,
          },
          {
            name: "7247, Walgreens, MOUNT PLEASANT, MI",
            disabled: false,
          },
          {
            name: "7247, Walmart, ATMORE, AL",
            disabled: false,
          },
          {
            name: "7249, CVS, ALLEN, TX",
            disabled: false,
          },
          {
            name: "7249, Walmart, MOUNT VERNON, MO",
            disabled: false,
          },
          {
            name: "725, ADUSA, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "725, Albertsons, RAMONA, CA",
            disabled: false,
          },
          {
            name: "725, CVS, BUFFALO, NY",
            disabled: false,
          },
          {
            name: "725, Costco, TRACY, CA",
            disabled: false,
          },
          {
            name: "725, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "725, Kroger, Saint Albans, WV",
            disabled: false,
          },
          {
            name: "725, Walmart, HAINES CITY, FL",
            disabled: false,
          },
          {
            name: "7250, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "7251, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "7251, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7251, Walmart, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7252, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "7252, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "7253, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "7256, Walgreens, KETTERING, OH",
            disabled: false,
          },
          {
            name: "7257, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "7258, Walgreens, SOUTHBURY, CT",
            disabled: false,
          },
          {
            name: "7259, Walgreens, NEW BERLIN, WI",
            disabled: false,
          },
          {
            name: "7259, Walmart, GEORGETOWN, KY",
            disabled: false,
          },
          {
            name: "726, ADUSA, DENVER, NC",
            disabled: false,
          },
          {
            name: "726, ADUSA, WARWICK, RI",
            disabled: false,
          },
          {
            name: "726, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "726, Kroger, Canyon Country, CA",
            disabled: false,
          },
          {
            name: "726, Rite Aid, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "726, Walmart, ALEXANDER CITY, AL",
            disabled: false,
          },
          {
            name: "7260, CVS, ABILENE, TX",
            disabled: false,
          },
          {
            name: "7260, Walmart, SALINE, MI",
            disabled: false,
          },
          {
            name: "7261, CVS, SUPERIOR, WI",
            disabled: false,
          },
          {
            name: "7261, Walgreens, GRETNA, LA",
            disabled: false,
          },
          {
            name: "7262, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7262, Walgreens, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "7262, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "7263, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7263, Walgreens, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "7264, CVS, ANTHEM, AZ",
            disabled: false,
          },
          {
            name: "7264, Walgreens, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "7265, CVS, BLAIRSVILLE, GA",
            disabled: false,
          },
          {
            name: "7265, Walgreens, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "7266, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "7266, Walmart, PRINCETON, IN",
            disabled: false,
          },
          {
            name: "7267, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "7268, CVS, BRECKENRIDGE, TX",
            disabled: false,
          },
          {
            name: "7269, CVS, BROWNWOOD, TX",
            disabled: false,
          },
          {
            name: "727, ADUSA, CARY, NC",
            disabled: false,
          },
          {
            name: "727, ADUSA, PUTNAM, CT",
            disabled: false,
          },
          {
            name: "727, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "727, HEB, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "727, Kroger, VALENCIA, CA",
            disabled: false,
          },
          {
            name: "727, Walmart, CEDARTOWN, GA",
            disabled: false,
          },
          {
            name: "7270, Walgreens, BRATTLEBORO, VT",
            disabled: false,
          },
          {
            name: "7271, CVS, ABILENE, TX",
            disabled: false,
          },
          {
            name: "7272, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "7272, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "7273, CVS, CANTON, GA",
            disabled: false,
          },
          {
            name: "7273, Walgreens, CLERMONT, FL",
            disabled: false,
          },
          {
            name: "7274, Walgreens, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "7275, CVS, RED LION, PA",
            disabled: false,
          },
          {
            name: "7275, Walgreens, BELLEVILLE, MI",
            disabled: false,
          },
          {
            name: "7276, CVS, ERWIN, TN",
            disabled: false,
          },
          {
            name: "7276, Walgreens, CALDWELL, ID",
            disabled: false,
          },
          {
            name: "7277, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "7277, Walgreens, TWIN FALLS, ID",
            disabled: false,
          },
          {
            name: "7278, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7278, Walgreens, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "7279, Walgreens, GREER, SC",
            disabled: false,
          },
          {
            name: "728, Albertsons, CORONA, CA",
            disabled: false,
          },
          {
            name: "728, CVS, CUMBERLAND, RI",
            disabled: false,
          },
          {
            name: "728, HEB, HUNTSVILLE, TX",
            disabled: false,
          },
          {
            name: "728, Kroger, SHEPHERDSVILLE, KY",
            disabled: false,
          },
          {
            name: "728, Kroger, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "728, Walmart, HILTON HEAD ISLAND, SC",
            disabled: false,
          },
          {
            name: "7280, CVS, ELIZABETHTON, TN",
            disabled: false,
          },
          {
            name: "7280, Walgreens, THOMASVILLE, NC",
            disabled: false,
          },
          {
            name: "7280, Walmart, CULLMAN, AL",
            disabled: false,
          },
          {
            name: "7281, Walmart, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "7283, Walgreens, HOT SPRINGS, AR",
            disabled: false,
          },
          {
            name: "7284, Walgreens, LITTLE ROCK, AR",
            disabled: false,
          },
          {
            name: "7285, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "7285, Walgreens, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "7286, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7286, Walgreens, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "7287, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "7288, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7289, CVS, SIGNAL MOUNTAIN, TN",
            disabled: false,
          },
          {
            name: "7289, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "729, Costco, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "729, Kroger, COMMERCE TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "729, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "729, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "729, Kroger, NEWBURY PARK, CA",
            disabled: false,
          },
          {
            name: "729, Rite Aid, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "729, Walmart, BARDSTOWN, KY",
            disabled: false,
          },
          {
            name: "7290, Walgreens, MANKATO, MN",
            disabled: false,
          },
          {
            name: "7290, Walmart, CRESTWOOD, KY",
            disabled: false,
          },
          {
            name: "7291, CVS, KATY, TX",
            disabled: false,
          },
          {
            name: "7292, CVS, GRANBURY, TX",
            disabled: false,
          },
          {
            name: "7293, CVS, MARSHALL, TX",
            disabled: false,
          },
          {
            name: "7293, Walgreens, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "7294, CVS, BAXLEY, GA",
            disabled: false,
          },
          {
            name: "7294, Walmart, NORMAN, OK",
            disabled: false,
          },
          {
            name: "7295, CVS, ATHENS, TX",
            disabled: false,
          },
          {
            name: "7296, CVS, CROSBY, TX",
            disabled: false,
          },
          {
            name: "7296, Walmart, HUDSON, NC",
            disabled: false,
          },
          {
            name: "7298, Walgreens, FERN PARK, FL",
            disabled: false,
          },
          {
            name: "7298, Walmart, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "7299, Walgreens, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "7299, Walmart, PORT ST LUCIE, FL",
            disabled: false,
          },
          {
            name: "73, ADUSA, NEWBERRY, SC",
            disabled: false,
          },
          {
            name: "73, ADUSA, SEEKONK, MA",
            disabled: false,
          },
          {
            name: "73, ADUSA, WEST MIFFLIN, PA",
            disabled: false,
          },
          {
            name: "73, Albertsons, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "73, BJ's, WATCHUNG, NJ",
            disabled: false,
          },
          {
            name: "73, CVS, AMESBURY, MA",
            disabled: false,
          },
          {
            name: "73, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "73, Kroger, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "73, Kroger, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "73, Kroger, LIBERAL, KS",
            disabled: false,
          },
          {
            name: "73, Kroger, Long Beach, CA",
            disabled: false,
          },
          {
            name: "73, Kroger, PLEASANT GROVE, UT",
            disabled: false,
          },
          {
            name: "73, Kroger, Seymour, IN",
            disabled: false,
          },
          {
            name: "73, Walmart, SAPULPA, OK",
            disabled: false,
          },
          {
            name: "730, Albertsons, AVONDALE, PA",
            disabled: false,
          },
          {
            name: "730, CVS, SUDBURY, MA",
            disabled: false,
          },
          {
            name: "730, Kroger, ELKINS, WV",
            disabled: false,
          },
          {
            name: "730, Kroger, LEBANON, KY",
            disabled: false,
          },
          {
            name: "730, Kroger, Marietta, GA",
            disabled: false,
          },
          {
            name: "730, Kroger, PASADENA, CA",
            disabled: false,
          },
          {
            name: "730, Kroger, Springfield, OH",
            disabled: false,
          },
          {
            name: "730, Walmart, SYLACAUGA, AL",
            disabled: false,
          },
          {
            name: "7300, CVS, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "7301, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7301, Walgreens, HENDERSONVILLE, TN",
            disabled: false,
          },
          {
            name: "7301, Walmart, CARENCRO, LA",
            disabled: false,
          },
          {
            name: "7302, Walgreens, GOODLETTSVILLE, TN",
            disabled: false,
          },
          {
            name: "7303, Walgreens, CORONA, CA",
            disabled: false,
          },
          {
            name: "7304, Walmart, MORGANTON, NC",
            disabled: false,
          },
          {
            name: "7305, Walgreens, OXNARD, CA",
            disabled: false,
          },
          {
            name: "7306, CVS, CASTLE HILLS, TX",
            disabled: false,
          },
          {
            name: "7306, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "7307, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7307, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "7307, Walmart, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "7308, CVS, HILLSVILLE, VA",
            disabled: false,
          },
          {
            name: "7308, Walmart, NORMAN, OK",
            disabled: false,
          },
          {
            name: "7309, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7309, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "7309, Walmart, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "731, ADUSA, NEWPORT, RI",
            disabled: false,
          },
          {
            name: "731, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "731, CVS, SARATOGA SPRINGS, NY",
            disabled: false,
          },
          {
            name: "731, Costco, MONROVIA, MD",
            disabled: false,
          },
          {
            name: "731, Kroger, MALIBU, CA",
            disabled: false,
          },
          {
            name: "731, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "731, Target, HIGHLAND, IN",
            disabled: false,
          },
          {
            name: "731, Walmart, DEMOPOLIS, AL",
            disabled: false,
          },
          {
            name: "7310, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "7310, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "7311, Walgreens, BERGENFIELD, NJ",
            disabled: false,
          },
          {
            name: "7311, Walmart, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "7312, CVS, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "7312, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "7313, CVS, RAEFORD, NC",
            disabled: false,
          },
          {
            name: "7313, Walgreens, MODESTO, CA",
            disabled: false,
          },
          {
            name: "7314, CVS, CLINTON, NC",
            disabled: false,
          },
          {
            name: "7314, Walgreens, WINTER PARK, FL",
            disabled: false,
          },
          {
            name: "7315, CVS, WEST JEFFERSON, NC",
            disabled: false,
          },
          {
            name: "7315, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "7315, Walmart, HICKORY, NC",
            disabled: false,
          },
          {
            name: "7316, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "7317, CVS, NORTH WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "7317, Walgreens, DURHAM, NC",
            disabled: false,
          },
          {
            name: "7317, Walmart, GREENBRIER, AR",
            disabled: false,
          },
          {
            name: "7318, CVS, EDGEFIELD, SC",
            disabled: false,
          },
          {
            name: "7319, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "7319, Walgreens, ADRIAN, MI",
            disabled: false,
          },
          {
            name: "732, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "732, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "732, Kroger, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "732, Target, CICERO, IL",
            disabled: false,
          },
          {
            name: "7320, CVS, MADISON, NC",
            disabled: false,
          },
          {
            name: "7320, Walgreens, POWELL, TN",
            disabled: false,
          },
          {
            name: "7320, Walmart, YUMA, AZ",
            disabled: false,
          },
          {
            name: "7321, CVS, CHAPEL HILL, NC",
            disabled: false,
          },
          {
            name: "7321, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "7322, CVS, HILDEBRAN, NC",
            disabled: false,
          },
          {
            name: "7322, Walgreens, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "7323, CVS, NEWTON, NC",
            disabled: false,
          },
          {
            name: "7323, Walgreens, APPLETON, WI",
            disabled: false,
          },
          {
            name: "7324, CVS, MURFREESBORO, NC",
            disabled: false,
          },
          {
            name: "7324, Walmart, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "7325, CVS, PILOT MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "7326, CVS, COBLESKILL, NY",
            disabled: false,
          },
          {
            name: "7326, Walgreens, LOS GATOS, CA",
            disabled: false,
          },
          {
            name: "7326, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "7328, CVS, DENTON, NC",
            disabled: false,
          },
          {
            name: "7328, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "7329, CVS, SANFORD, NC",
            disabled: false,
          },
          {
            name: "7329, Walgreens, ROCKLAND, MA",
            disabled: false,
          },
          {
            name: "7329, Walmart, SAINT PAULS, NC",
            disabled: false,
          },
          {
            name: "733, Albertsons, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "733, CVS, WARWICK, RI",
            disabled: false,
          },
          {
            name: "733, Costco, LEHI, UT",
            disabled: false,
          },
          {
            name: "733, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "733, Kroger, DANVILLE, KY",
            disabled: false,
          },
          {
            name: "733, Kroger, Fountain Valley, CA",
            disabled: false,
          },
          {
            name: "733, Kroger, KATY, TX",
            disabled: false,
          },
          {
            name: "733, Target, EDWARDSVILLE, IL",
            disabled: false,
          },
          {
            name: "733, Walmart, VALLEY, AL",
            disabled: false,
          },
          {
            name: "7330, CVS, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "7330, Walgreens, JENSEN BEACH, FL",
            disabled: false,
          },
          {
            name: "7331, CVS, BOONE, NC",
            disabled: false,
          },
          {
            name: "7331, Walgreens, TROY, OH",
            disabled: false,
          },
          {
            name: "7332, CVS, ROCKINGHAM, NC",
            disabled: false,
          },
          {
            name: "7332, Walgreens, LEBANON, OH",
            disabled: false,
          },
          {
            name: "7333, CVS, HILTON HEAD ISLAND, SC",
            disabled: false,
          },
          {
            name: "7333, Walgreens, WILLIMANTIC, CT",
            disabled: false,
          },
          {
            name: "7334, CVS, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "7334, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7334, Walmart, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "7335, CVS, WILSON, NC",
            disabled: false,
          },
          {
            name: "7336, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "7337, Walgreens, LITHIA SPRINGS, GA",
            disabled: false,
          },
          {
            name: "7337, Walmart, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "7338, CVS, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "7338, Walgreens, ACWORTH, GA",
            disabled: false,
          },
          {
            name: "7339, CVS, WALNUT COVE, NC",
            disabled: false,
          },
          {
            name: "7339, Walmart, GROVETOWN, GA",
            disabled: false,
          },
          {
            name: "734, Albertsons, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "734, Costco, NAMPA, ID",
            disabled: false,
          },
          {
            name: "734, HEB, SAN ANGELO, TX",
            disabled: false,
          },
          {
            name: "734, Kroger, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "734, Kroger, MOREHEAD, KY",
            disabled: false,
          },
          {
            name: "734, Kroger, RAINELLE, WV",
            disabled: false,
          },
          {
            name: "734, Target, ALBANY, GA",
            disabled: false,
          },
          {
            name: "734, Walmart, ENTERPRISE, AL",
            disabled: false,
          },
          {
            name: "7340, Walgreens, CANTON, GA",
            disabled: false,
          },
          {
            name: "7340, Walmart, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "7341, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "7342, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7342, Walmart, MADISON, AL",
            disabled: false,
          },
          {
            name: "7343, CVS, GATE CITY, VA",
            disabled: false,
          },
          {
            name: "7343, Walgreens, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "7344, CVS, HAVELOCK, NC",
            disabled: false,
          },
          {
            name: "7344, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "7345, CVS, CAROLINA BEACH, NC",
            disabled: false,
          },
          {
            name: "7346, Walgreens, NEWPORT, KY",
            disabled: false,
          },
          {
            name: "7347, Walgreens, SOMERVILLE, NJ",
            disabled: false,
          },
          {
            name: "7347, Walmart, HURST, TX",
            disabled: false,
          },
          {
            name: "7348, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "7348, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7349, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "735, ADUSA, OAKBORO, NC",
            disabled: false,
          },
          {
            name: "735, Albertsons, WILDOMAR, CA",
            disabled: false,
          },
          {
            name: "735, Costco, WEST BOUNTIFUL, UT",
            disabled: false,
          },
          {
            name: "735, HEB, MARBLE FALLS, TX",
            disabled: false,
          },
          {
            name: "735, Kroger, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "735, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "735, Kroger, Murrieta, CA",
            disabled: false,
          },
          {
            name: "735, Target, Sierra Vista, AZ",
            disabled: false,
          },
          {
            name: "735, Walmart, WINCHESTER, TN",
            disabled: false,
          },
          {
            name: "7350, CVS, CASTLE HAYNE, NC",
            disabled: false,
          },
          {
            name: "7350, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "7351, CVS, PIEDMONT, SC",
            disabled: false,
          },
          {
            name: "7351, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "7352, CVS, BROOKNEAL, VA",
            disabled: false,
          },
          {
            name: "7354, CVS, KING, NC",
            disabled: false,
          },
          {
            name: "7354, Walgreens, IRVING, TX",
            disabled: false,
          },
          {
            name: "7355, Walgreens, RENTON, WA",
            disabled: false,
          },
          {
            name: "7356, CVS, EWA BEACH, HI",
            disabled: false,
          },
          {
            name: "7356, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "7357, Walgreens, ABINGDON, MD",
            disabled: false,
          },
          {
            name: "7357, Walmart, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "7359, CVS, GEORGETOWN, SC",
            disabled: false,
          },
          {
            name: "7359, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "736, ADUSA, WESTERLY, RI",
            disabled: false,
          },
          {
            name: "736, CVS, BEDFORD, MA",
            disabled: false,
          },
          {
            name: "736, Costco, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "736, HEB, KATY, TX",
            disabled: false,
          },
          {
            name: "736, Target, NORCO, CA",
            disabled: false,
          },
          {
            name: "736, Walmart, RUSSELLVILLE, KY",
            disabled: false,
          },
          {
            name: "7360, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "7361, Walgreens, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "7361, Walmart, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "7362, Walgreens, CREST HILL, IL",
            disabled: false,
          },
          {
            name: "7362, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "7363, CVS, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "7363, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7364, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7365, CVS, BRISTOL, VA",
            disabled: false,
          },
          {
            name: "7365, Walgreens, APEX, NC",
            disabled: false,
          },
          {
            name: "7366, Walgreens, NORRISTOWN, PA",
            disabled: false,
          },
          {
            name: "7367, Walgreens, COLLEGE POINT, NY",
            disabled: false,
          },
          {
            name: "7368, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "7369, Walgreens, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "737, ADUSA, NORTH KINGSTOWN, RI",
            disabled: false,
          },
          {
            name: "737, CVS, EAST AURORA, NY",
            disabled: false,
          },
          {
            name: "737, Costco, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "737, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "737, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "737, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "737, Kroger, Rialto, CA",
            disabled: false,
          },
          {
            name: "737, Kroger, SHELBY TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "737, Target, PINOLE, CA",
            disabled: false,
          },
          {
            name: "737, Walmart, LEWISBURG, TN",
            disabled: false,
          },
          {
            name: "7370, CVS, SOUTH EUCLID, OH",
            disabled: false,
          },
          {
            name: "7370, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "7371, CVS, WARRENSVILLE HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "7371, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7372, Walgreens, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "7373, CVS, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "7373, Walgreens, GRANTS PASS, OR",
            disabled: false,
          },
          {
            name: "7374, Walgreens, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "7375, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7376, Walgreens, PITTSBURG, CA",
            disabled: false,
          },
          {
            name: "7378, Walgreens, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "738, ADUSA, BEALETON, VA",
            disabled: false,
          },
          {
            name: "738, Albertsons, LAKESIDE, CA",
            disabled: false,
          },
          {
            name: "738, CVS, RIDGEFIELD, CT",
            disabled: false,
          },
          {
            name: "738, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "738, HEB, BELLAIRE, TX",
            disabled: false,
          },
          {
            name: "738, Kroger, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "738, Kroger, SAGINAW, MI",
            disabled: false,
          },
          {
            name: "738, Kroger, SPRING, TX",
            disabled: false,
          },
          {
            name: "738, Target, TRACY, CA",
            disabled: false,
          },
          {
            name: "738, Walmart, CAMDEN, TN",
            disabled: false,
          },
          {
            name: "7381, CVS, BEAUFORT, NC",
            disabled: false,
          },
          {
            name: "7381, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7382, CVS, SOUTHPORT, NC",
            disabled: false,
          },
          {
            name: "7383, Walgreens, SCOTTSBLUFF, NE",
            disabled: false,
          },
          {
            name: "7384, CVS, KINGSTREE, SC",
            disabled: false,
          },
          {
            name: "7385, Walgreens, WINTER GARDEN, FL",
            disabled: false,
          },
          {
            name: "7386, Walgreens, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "7387, Walgreens, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "7388, CVS, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "7388, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "7389, CVS, SALEM, VA",
            disabled: false,
          },
          {
            name: "739, ADUSA, WARWICK, RI",
            disabled: false,
          },
          {
            name: "739, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "739, Costco, BRICK, NJ",
            disabled: false,
          },
          {
            name: "739, Kroger, DANA POINT, CA",
            disabled: false,
          },
          {
            name: "739, Kroger, GASSAWAY, WV",
            disabled: false,
          },
          {
            name: "739, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "739, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "739, Target, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "739, Walmart, MIDDLESBORO, KY",
            disabled: false,
          },
          {
            name: "7390, CVS, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "7390, Walgreens, BELLINGHAM, WA",
            disabled: false,
          },
          {
            name: "7391, CVS, FRANKLIN, NH",
            disabled: false,
          },
          {
            name: "7391, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7392, Walgreens, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "7393, Walgreens, ABBEVILLE, LA",
            disabled: false,
          },
          {
            name: "7394, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "7394, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "7395, Walgreens, JOHNS CREEK, GA",
            disabled: false,
          },
          {
            name: "7396, CVS, NORTH MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "7396, Walgreens, CANTON, GA",
            disabled: false,
          },
          {
            name: "7397, CVS, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "7398, CVS, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "7398, Walgreens, HENDERSON, NC",
            disabled: false,
          },
          {
            name: "7399, Walgreens, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "74, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "74, BJ's, MAYS LANDING, NJ",
            disabled: false,
          },
          {
            name: "74, CVS, WAYNESBORO, VA",
            disabled: false,
          },
          {
            name: "74, HEB, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "74, Kroger, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "74, Kroger, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "74, Kroger, Roseville, MI",
            disabled: false,
          },
          {
            name: "74, Kroger, SALINA, KS",
            disabled: false,
          },
          {
            name: "74, Walgreens, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "74, Walmart, OSCEOLA, AR",
            disabled: false,
          },
          {
            name: "740, ADUSA, CENTREVILLE, VA",
            disabled: false,
          },
          {
            name: "740, ADUSA, MOUNT PLEASANT, NC",
            disabled: false,
          },
          {
            name: "740, Albertsons, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "740, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "740, Costco, LACEY, WA",
            disabled: false,
          },
          {
            name: "740, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "740, Target, MARY ESTHER, FL",
            disabled: false,
          },
          {
            name: "740, Walmart, OZARK, AL",
            disabled: false,
          },
          {
            name: "7400, Walgreens, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "7401, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "7401, Walgreens, INDIAN TRAIL, NC",
            disabled: false,
          },
          {
            name: "7403, Walgreens, BELLFLOWER, CA",
            disabled: false,
          },
          {
            name: "7404, CVS, KAUFMAN, TX",
            disabled: false,
          },
          {
            name: "7404, Walgreens, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "7405, Walgreens, DOTHAN, AL",
            disabled: false,
          },
          {
            name: "7406, CVS, WOODBURY, MN",
            disabled: false,
          },
          {
            name: "7406, Walgreens, CLINTON, TN",
            disabled: false,
          },
          {
            name: "7407, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7407, Walgreens, SEYMOUR, TN",
            disabled: false,
          },
          {
            name: "7409, Walgreens, SANDWICH, IL",
            disabled: false,
          },
          {
            name: "741, CVS, BEDFORD, NH",
            disabled: false,
          },
          {
            name: "741, Costco, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "741, HEB, MONT BELVIEU, TX",
            disabled: false,
          },
          {
            name: "741, Kroger, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "741, Kroger, MADISON, IN",
            disabled: false,
          },
          {
            name: "741, Kroger, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "741, Walmart, LENOIR CITY, TN",
            disabled: false,
          },
          {
            name: "7410, CVS, KENNEBUNK, ME",
            disabled: false,
          },
          {
            name: "7411, Walgreens, OLYMPIA FIELDS, IL",
            disabled: false,
          },
          {
            name: "7412, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7413, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7413, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "7415, CVS, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "7415, Walgreens, CHALMETTE, LA",
            disabled: false,
          },
          {
            name: "7416, CVS, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "7416, Walgreens, BIG RAPIDS, MI",
            disabled: false,
          },
          {
            name: "7417, Walgreens, WINDSOR, CO",
            disabled: false,
          },
          {
            name: "7418, Walgreens, KNOX, IN",
            disabled: false,
          },
          {
            name: "7419, CVS, GUN BARREL CITY, TX",
            disabled: false,
          },
          {
            name: "7419, Walgreens, WHEATON, IL",
            disabled: false,
          },
          {
            name: "742, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "742, Albertsons, LOS GATOS, CA",
            disabled: false,
          },
          {
            name: "742, Costco, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "742, HEB, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "742, Walmart, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "7420, CVS, CALABASH, NC",
            disabled: false,
          },
          {
            name: "7422, CVS, SAN MARCOS, TX",
            disabled: false,
          },
          {
            name: "7423, Walgreens, FENTON, MO",
            disabled: false,
          },
          {
            name: "7425, Walgreens, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "7426, CVS, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "7426, Walgreens, OPELOUSAS, LA",
            disabled: false,
          },
          {
            name: "7428, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "7428, Walgreens, SEDALIA, MO",
            disabled: false,
          },
          {
            name: "743, ADUSA, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "743, CVS, SWARTHMORE, PA",
            disabled: false,
          },
          {
            name: "743, Costco, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "743, Kroger, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "743, Kroger, HINTON, WV",
            disabled: false,
          },
          {
            name: "743, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "743, Kroger, PASADENA, CA",
            disabled: false,
          },
          {
            name: "743, Kroger, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "743, Walmart, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "7430, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7430, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "7431, CVS, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "7432, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "7433, Walgreens, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "7435, CVS, PORTER, TX",
            disabled: false,
          },
          {
            name: "7435, Walgreens, NORWOOD, OH",
            disabled: false,
          },
          {
            name: "7436, CVS, MOUNT PLEASANT, TX",
            disabled: false,
          },
          {
            name: "7436, Walgreens, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "7437, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "7437, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "7438, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "7439, CVS, SULPHUR SPRINGS, TX",
            disabled: false,
          },
          {
            name: "744, ADUSA, CLIFTON, VA",
            disabled: false,
          },
          {
            name: "744, Costco, WYOMING, MI",
            disabled: false,
          },
          {
            name: "744, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "744, Kroger, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "744, Kroger, Fishers, IN",
            disabled: false,
          },
          {
            name: "744, Kroger, Little Rock, AR",
            disabled: false,
          },
          {
            name: "744, Kroger, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "744, Kroger, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "744, Walmart, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "7440, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7440, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "7441, CVS, LIBERTY, TX",
            disabled: false,
          },
          {
            name: "7441, Walgreens, LIMA, OH",
            disabled: false,
          },
          {
            name: "7442, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7442, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "7443, CVS, ABILENE, TX",
            disabled: false,
          },
          {
            name: "7443, Walgreens, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "7444, CVS, GLADEWATER, TX",
            disabled: false,
          },
          {
            name: "7444, Walgreens, EDMOND, OK",
            disabled: false,
          },
          {
            name: "7445, CVS, BOWIE, TX",
            disabled: false,
          },
          {
            name: "7445, Walgreens, SAN ANSELMO, CA",
            disabled: false,
          },
          {
            name: "7446, CVS, TYLER, TX",
            disabled: false,
          },
          {
            name: "7446, Walgreens, GREENWOOD, SC",
            disabled: false,
          },
          {
            name: "7447, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "7448, CVS, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "7449, CVS, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "7449, Walgreens, OXNARD, CA",
            disabled: false,
          },
          {
            name: "745, ADUSA, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "745, Albertsons, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "745, CVS, EAST ROCKAWAY, NY",
            disabled: false,
          },
          {
            name: "745, Costco, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "745, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "745, Kroger, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "745, Kroger, SOMERSET, KY",
            disabled: false,
          },
          {
            name: "745, Walmart, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "7450, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "7451, CVS, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "7451, Walgreens, FOXFIELD, CO",
            disabled: false,
          },
          {
            name: "7452, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "7453, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "7453, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "7454, Walgreens, ANKENY, IA",
            disabled: false,
          },
          {
            name: "7455, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7455, Walgreens, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "7457, Walgreens, HUNTLEY, IL",
            disabled: false,
          },
          {
            name: "7458, CVS, SUNNYVALE, TX",
            disabled: false,
          },
          {
            name: "7459, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "7459, Walgreens, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "746, CVS, RANDOLPH, MA",
            disabled: false,
          },
          {
            name: "746, Costco, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "746, HEB, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "746, Kroger, HERRIN, IL",
            disabled: false,
          },
          {
            name: "746, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "746, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "746, Walmart, TEMPLE, TX",
            disabled: false,
          },
          {
            name: "7460, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7460, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7461, CVS, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "7461, Walgreens, NORTH MUSKEGON, MI",
            disabled: false,
          },
          {
            name: "7462, CVS, BEDFORD, TX",
            disabled: false,
          },
          {
            name: "7462, Walgreens, CASPER, WY",
            disabled: false,
          },
          {
            name: "7463, CVS, CARTHAGE, TX",
            disabled: false,
          },
          {
            name: "7463, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7464, CVS, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "7465, CVS, SEABROOK, TX",
            disabled: false,
          },
          {
            name: "7465, Walgreens, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "7466, CVS, CANTON, TX",
            disabled: false,
          },
          {
            name: "7466, Walgreens, HUDSON, FL",
            disabled: false,
          },
          {
            name: "7467, CVS, AZLE, TX",
            disabled: false,
          },
          {
            name: "7467, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "7468, Walgreens, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "7469, CVS, COPPELL, TX",
            disabled: false,
          },
          {
            name: "747, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "747, Albertsons, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "747, CVS, BLASDELL, NY",
            disabled: false,
          },
          {
            name: "747, Costco, WOODINVILLE, WA",
            disabled: false,
          },
          {
            name: "747, Kroger, Murrieta, CA",
            disabled: false,
          },
          {
            name: "747, Kroger, SULPHUR, LA",
            disabled: false,
          },
          {
            name: "747, Kroger, VANDALIA, OH",
            disabled: false,
          },
          {
            name: "747, Target, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "747, Walmart, CAHOKIA, IL",
            disabled: false,
          },
          {
            name: "7470, CVS, WEST COLUMBIA, TX",
            disabled: false,
          },
          {
            name: "7470, Walgreens, HARRISON, OH",
            disabled: false,
          },
          {
            name: "7471, CVS, CORPUS CHRISTI, TX",
            disabled: false,
          },
          {
            name: "7472, CVS, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "7472, Walgreens, BLUFFTON, IN",
            disabled: false,
          },
          {
            name: "7474, CVS, TAYLOR, TX",
            disabled: false,
          },
          {
            name: "7474, Walgreens, RICHMOND HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "7475, CVS, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "7475, Walgreens, ROANOKE RAPIDS, NC",
            disabled: false,
          },
          {
            name: "7476, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7476, Walgreens, KILL DEVIL HILLS, NC",
            disabled: false,
          },
          {
            name: "7477, CVS, NEDERLAND, TX",
            disabled: false,
          },
          {
            name: "7477, Walgreens, EAST WINDSOR, NJ",
            disabled: false,
          },
          {
            name: "7478, Walgreens, DECATUR, GA",
            disabled: false,
          },
          {
            name: "7479, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7479, Walgreens, SANFORD, NC",
            disabled: false,
          },
          {
            name: "748, ADUSA, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "748, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "748, Albertsons, EL DORADO HILLS, CA",
            disabled: false,
          },
          {
            name: "748, CVS, HAMLIN, PA",
            disabled: false,
          },
          {
            name: "748, Costco, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "748, HEB, SPRING, TX",
            disabled: false,
          },
          {
            name: "748, Kroger, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "748, Kroger, Irvine, CA",
            disabled: false,
          },
          {
            name: "748, Walgreens, NORTH MIAMI, FL",
            disabled: false,
          },
          {
            name: "748, Walmart, NEWTON, IA",
            disabled: false,
          },
          {
            name: "7480, CVS, CENTER, TX",
            disabled: false,
          },
          {
            name: "7480, Walgreens, AUBURN, WA",
            disabled: false,
          },
          {
            name: "7481, CVS, GARLAND, TX",
            disabled: false,
          },
          {
            name: "7481, Walgreens, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "7482, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "7484, Walgreens, PLAINWELL, MI",
            disabled: false,
          },
          {
            name: "7485, CVS, WALLER, TX",
            disabled: false,
          },
          {
            name: "7485, Walgreens, PORT CHESTER, NY",
            disabled: false,
          },
          {
            name: "7486, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7487, CVS, MIDLOTHIAN, TX",
            disabled: false,
          },
          {
            name: "7488, CVS, MINERAL WELLS, TX",
            disabled: false,
          },
          {
            name: "7489, CVS, BURLESON, TX",
            disabled: false,
          },
          {
            name: "7489, Walgreens, AMELIA, OH",
            disabled: false,
          },
          {
            name: "749, ADUSA, ANNANDALE, VA",
            disabled: false,
          },
          {
            name: "749, ADUSA, LUGOFF, SC",
            disabled: false,
          },
          {
            name: "749, Costco, MOUNT LAUREL, NJ",
            disabled: false,
          },
          {
            name: "749, HEB, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "749, Kroger, SAINT CLAIR SHORES, MI",
            disabled: false,
          },
          {
            name: "749, Target, DULUTH, GA",
            disabled: false,
          },
          {
            name: "749, Walmart, AMES, IA",
            disabled: false,
          },
          {
            name: "7490, CVS, PARIS, TX",
            disabled: false,
          },
          {
            name: "7490, Walgreens, CARTERET, NJ",
            disabled: false,
          },
          {
            name: "7491, CVS, CEDAR HILL, TX",
            disabled: false,
          },
          {
            name: "7491, Walgreens, KATY, TX",
            disabled: false,
          },
          {
            name: "7492, CVS, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "7492, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7493, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "7494, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "7495, Walgreens, ROY, UT",
            disabled: false,
          },
          {
            name: "7496, Walgreens, ENGLEWOOD, FL",
            disabled: false,
          },
          {
            name: "7498, CVS, LEWISVILLE, TX",
            disabled: false,
          },
          {
            name: "7499, CVS, SILSBEE, TX",
            disabled: false,
          },
          {
            name: "75, ADUSA, GARNER, NC",
            disabled: false,
          },
          {
            name: "75, Albertsons, FAIRFAX, VA",
            disabled: false,
          },
          {
            name: "75, BJ's, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "75, CVS, LYNN, MA",
            disabled: false,
          },
          {
            name: "75, Kroger, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "75, Kroger, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "75, Kroger, PARKER, CO",
            disabled: false,
          },
          {
            name: "75, Kroger, PAYSON, UT",
            disabled: false,
          },
          {
            name: "75, Kroger, PORTLAND, OR",
            disabled: false,
          },
          {
            name: "75, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "75, Walmart, PINEVILLE, LA",
            disabled: false,
          },
          {
            name: "750, Albertsons, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "750, CVS, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "750, Target, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "750, Walmart, INDEPENDENCE, IA",
            disabled: false,
          },
          {
            name: "7500, CVS, ERWIN, NC",
            disabled: false,
          },
          {
            name: "7500, Walgreens, FLINT, MI",
            disabled: false,
          },
          {
            name: "7501, CVS, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "7501, Walgreens, FLINT, MI",
            disabled: false,
          },
          {
            name: "7502, Walgreens, DULUTH, GA",
            disabled: false,
          },
          {
            name: "7503, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "7503, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "7504, CVS, MACON, GA",
            disabled: false,
          },
          {
            name: "7504, Walgreens, CLAREMORE, OK",
            disabled: false,
          },
          {
            name: "7505, CVS, LYMAN, SC",
            disabled: false,
          },
          {
            name: "7505, Walgreens, HOLLY SPRINGS, NC",
            disabled: false,
          },
          {
            name: "7506, CVS, CHICO, CA",
            disabled: false,
          },
          {
            name: "7506, Walgreens, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "7507, CVS, SOUTHLAKE, TX",
            disabled: false,
          },
          {
            name: "7508, CVS, BARNWELL, SC",
            disabled: false,
          },
          {
            name: "7509, CVS, FRONT ROYAL, VA",
            disabled: false,
          },
          {
            name: "7509, Walgreens, FRASER, MI",
            disabled: false,
          },
          {
            name: "751, CVS, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "751, Kroger, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "751, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "751, Kroger, Diamond, WV",
            disabled: false,
          },
          {
            name: "751, Kroger, OAK PARK, MI",
            disabled: false,
          },
          {
            name: "751, Target, VADNAIS HEIGHTS, MN",
            disabled: false,
          },
          {
            name: "751, Walmart, PELLA, IA",
            disabled: false,
          },
          {
            name: "7510, CVS, DANVILLE, VA",
            disabled: false,
          },
          {
            name: "7512, CVS, SHALLOTTE, NC",
            disabled: false,
          },
          {
            name: "7513, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "7515, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "7516, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "7516, Walgreens, ANTHEM, AZ",
            disabled: false,
          },
          {
            name: "7517, Walgreens, JACKSON, MS",
            disabled: false,
          },
          {
            name: "7518, CVS, WOODSTOCK, VA",
            disabled: false,
          },
          {
            name: "7518, Walgreens, FRANKLIN, TN",
            disabled: false,
          },
          {
            name: "7519, Walgreens, STOUGHTON, WI",
            disabled: false,
          },
          {
            name: "752, ADUSA, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "752, Albertsons, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "752, HEB, HUDSON OAKS, TX",
            disabled: false,
          },
          {
            name: "752, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "752, Kroger, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "752, Kroger, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "752, Target, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "752, Walmart, PASADENA, TX",
            disabled: false,
          },
          {
            name: "7521, CVS, WAYNESVILLE, NC",
            disabled: false,
          },
          {
            name: "7522, Walgreens, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "7523, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "7523, Walgreens, GALLOWAY, OH",
            disabled: false,
          },
          {
            name: "7524, CVS, LOCUST, NC",
            disabled: false,
          },
          {
            name: "7524, Walgreens, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "7525, CVS, ALTAVISTA, VA",
            disabled: false,
          },
          {
            name: "7525, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "7526, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "7528, Walgreens, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "7529, CVS, KNIGHTDALE, NC",
            disabled: false,
          },
          {
            name: "7529, Walgreens, CASTAIC, CA",
            disabled: false,
          },
          {
            name: "753, ADUSA, HERNDON, VA",
            disabled: false,
          },
          {
            name: "753, Albertsons, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "753, CVS, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "753, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "753, Kroger, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "753, Kroger, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "753, Target, PALATINE, IL",
            disabled: false,
          },
          {
            name: "753, Walmart, CEDAR FALLS, IA",
            disabled: false,
          },
          {
            name: "7530, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7531, CVS, HEMINGWAY, SC",
            disabled: false,
          },
          {
            name: "7531, Walgreens, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "7533, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "7534, CVS, PICKENS, SC",
            disabled: false,
          },
          {
            name: "7534, Walgreens, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "7535, Walgreens, BELLEVUE, TN",
            disabled: false,
          },
          {
            name: "7536, CVS, MINT HILL, NC",
            disabled: false,
          },
          {
            name: "7536, Walgreens, MIDDLETON, WI",
            disabled: false,
          },
          {
            name: "7537, CVS, NORTH CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "7537, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "7538, CVS, HONEA PATH, SC",
            disabled: false,
          },
          {
            name: "7539, CVS, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "754, Albertsons, COUNTRYSIDE, IL",
            disabled: false,
          },
          {
            name: "754, CVS, JOHNSON CITY, NY",
            disabled: false,
          },
          {
            name: "754, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "754, Kroger, MARMET, WV",
            disabled: false,
          },
          {
            name: "754, Kroger, Shelby Township, MI",
            disabled: false,
          },
          {
            name: "754, Target, JACKSON, MS",
            disabled: false,
          },
          {
            name: "754, Walmart, STATESBORO, GA",
            disabled: false,
          },
          {
            name: "7540, CVS, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "7540, Walgreens, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "7541, CVS, MCCORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "7541, Walgreens, NEWARK, OH",
            disabled: false,
          },
          {
            name: "7542, Walgreens, DENTON, TX",
            disabled: false,
          },
          {
            name: "7543, CVS, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "7543, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "7544, CVS, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "7544, Walgreens, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "7545, Walgreens, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "7546, CVS, SYLVA, NC",
            disabled: false,
          },
          {
            name: "7547, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "7548, CVS, FUQUAY-VARINA, NC",
            disabled: false,
          },
          {
            name: "7548, Walgreens, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "7549, CVS, WYOMING, MI",
            disabled: false,
          },
          {
            name: "7549, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "755, ADUSA, KANNAPOLIS, NC",
            disabled: false,
          },
          {
            name: "755, Kroger, ALISO VIEJO, CA",
            disabled: false,
          },
          {
            name: "755, Kroger, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "755, Target, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "755, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "7550, CVS, SNEADS FERRY, NC",
            disabled: false,
          },
          {
            name: "7550, Walgreens, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "7551, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7551, Walgreens, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "7552, CVS, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "7553, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "7554, CVS, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "7554, Walgreens, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "7555, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "7555, Walgreens, TEHACHAPI, CA",
            disabled: false,
          },
          {
            name: "7556, CVS, WEST COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "7556, Walgreens, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "7557, CVS, KILMARNOCK, VA",
            disabled: false,
          },
          {
            name: "7558, CVS, ORANGE, VA",
            disabled: false,
          },
          {
            name: "7558, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "756, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "756, ADUSA, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "756, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "756, Kroger, PLACENTIA, CA",
            disabled: false,
          },
          {
            name: "756, Rite Aid, EBENSBURG, PA",
            disabled: false,
          },
          {
            name: "756, Target, JOHNSON CITY, TN",
            disabled: false,
          },
          {
            name: "756, Walmart, TRION, GA",
            disabled: false,
          },
          {
            name: "7560, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "7561, CVS, LOUISA, VA",
            disabled: false,
          },
          {
            name: "7561, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "7562, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "7563, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "7564, CVS, MONROE, NC",
            disabled: false,
          },
          {
            name: "7565, CVS, ROCKY MOUNT, VA",
            disabled: false,
          },
          {
            name: "7566, CVS, ROCKWELL, NC",
            disabled: false,
          },
          {
            name: "7566, Walgreens, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "7567, CVS, BOILING SPRINGS, SC",
            disabled: false,
          },
          {
            name: "7568, CVS, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "7568, Walgreens, HALES CORNERS, WI",
            disabled: false,
          },
          {
            name: "7569, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "757, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "757, Albertsons, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "757, Costco, SUMNER, WA",
            disabled: false,
          },
          {
            name: "757, HEB, CONROE, TX",
            disabled: false,
          },
          {
            name: "757, Kroger, SOMERSET, KY",
            disabled: false,
          },
          {
            name: "757, Kroger, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "757, Kroger, STEVENSON RANCH, CA",
            disabled: false,
          },
          {
            name: "757, Target, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "757, Walmart, PLEASANTON, TX",
            disabled: false,
          },
          {
            name: "7570, CVS, WHITEVILLE, NC",
            disabled: false,
          },
          {
            name: "7570, Walgreens, EVERETT, WA",
            disabled: false,
          },
          {
            name: "7572, CVS, RANDLEMAN, NC",
            disabled: false,
          },
          {
            name: "7572, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "7573, CVS, MARSHVILLE, NC",
            disabled: false,
          },
          {
            name: "7573, Walgreens, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "7574, CVS, SPRUCE PINE, NC",
            disabled: false,
          },
          {
            name: "7574, Walgreens, CATONSVILLE, MD",
            disabled: false,
          },
          {
            name: "7575, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7575, Walgreens, EL MONTE, CA",
            disabled: false,
          },
          {
            name: "7577, CVS, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "7577, Walgreens, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "7578, CVS, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "7578, Walgreens, MARION, IL",
            disabled: false,
          },
          {
            name: "7579, Walgreens, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "758, ADUSA, MCLEAN, VA",
            disabled: false,
          },
          {
            name: "758, Albertsons, SPRING VALLEY, CA",
            disabled: false,
          },
          {
            name: "758, Costco, MORRIS, IL",
            disabled: false,
          },
          {
            name: "758, Kroger, HUBER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "758, Kroger, MOUNT WASHINGTON, KY",
            disabled: false,
          },
          {
            name: "758, Rite Aid, NIAGARA FALLS, NY",
            disabled: false,
          },
          {
            name: "758, Target, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "758, Walmart, AMERICUS, GA",
            disabled: false,
          },
          {
            name: "7580, CVS, SMITHFIELD, NC",
            disabled: false,
          },
          {
            name: "7580, Walgreens, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "7581, CVS, CHATHAM, VA",
            disabled: false,
          },
          {
            name: "7581, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "7582, Walgreens, LITCHFIELD PARK, AZ",
            disabled: false,
          },
          {
            name: "7583, CVS, CHESNEE, SC",
            disabled: false,
          },
          {
            name: "7583, Walgreens, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "7584, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "7584, Walgreens, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "7585, Walgreens, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "7586, Walgreens, GARLAND, TX",
            disabled: false,
          },
          {
            name: "7587, CVS, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "7588, CVS, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "7588, Walgreens, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "7589, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "7589, Walgreens, OCALA, FL",
            disabled: false,
          },
          {
            name: "759, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "759, CVS, PISCATAWAY, NJ",
            disabled: false,
          },
          {
            name: "759, Costco, MONROE TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "759, HEB, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "759, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "759, Kroger, MIAMISBURG, OH",
            disabled: false,
          },
          {
            name: "759, Kroger, WHITE LAKE, MI",
            disabled: false,
          },
          {
            name: "759, Target, WOODBRIDGE, VA",
            disabled: false,
          },
          {
            name: "759, Walmart, WAUCHULA, FL",
            disabled: false,
          },
          {
            name: "7591, Walgreens, CORONA, CA",
            disabled: false,
          },
          {
            name: "7592, CVS, RADFORD, VA",
            disabled: false,
          },
          {
            name: "7592, Walgreens, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "7593, CVS, LURAY, VA",
            disabled: false,
          },
          {
            name: "7593, Walgreens, BOILING SPRINGS, SC",
            disabled: false,
          },
          {
            name: "7594, CVS, LOCUST GROVE, VA",
            disabled: false,
          },
          {
            name: "7594, Walgreens, AUBURN, WA",
            disabled: false,
          },
          {
            name: "7595, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "7596, Walgreens, ELBURN, IL",
            disabled: false,
          },
          {
            name: "7597, CVS, LILLINGTON, NC",
            disabled: false,
          },
          {
            name: "7599, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "76, Albertsons, CROWN POINT, IN",
            disabled: false,
          },
          {
            name: "76, BJ's, YORKTOWN HEIGHTS, NY",
            disabled: false,
          },
          {
            name: "76, CVS, JOHNSTON, RI",
            disabled: false,
          },
          {
            name: "76, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "76, Kroger, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "76, Target, SIOUX FALLS, SD",
            disabled: false,
          },
          {
            name: "76, Walmart, BERRYVILLE, AR",
            disabled: false,
          },
          {
            name: "760, ADUSA, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "760, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "760, CVS, NEW BRITAIN, CT",
            disabled: false,
          },
          {
            name: "760, Costco, GILROY, CA",
            disabled: false,
          },
          {
            name: "760, Kroger, CORBIN, KY",
            disabled: false,
          },
          {
            name: "760, Kroger, WILMINGTON, CA",
            disabled: false,
          },
          {
            name: "760, Target, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "760, Walmart, HARDINSBURG, KY",
            disabled: false,
          },
          {
            name: "7600, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7601, CVS, CROWLEY, TX",
            disabled: false,
          },
          {
            name: "7601, Walgreens, CASPER, WY",
            disabled: false,
          },
          {
            name: "7601, Walmart, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "7602, Walgreens, MONROE, CT",
            disabled: false,
          },
          {
            name: "7603, CVS, SAGINAW, TX",
            disabled: false,
          },
          {
            name: "7603, Walgreens, MUSKEGO, WI",
            disabled: false,
          },
          {
            name: "7604, CVS, PARKERSBURG, WV",
            disabled: false,
          },
          {
            name: "7604, Walgreens, SALEM, VA",
            disabled: false,
          },
          {
            name: "7605, Walgreens, ROANOKE, VA",
            disabled: false,
          },
          {
            name: "7606, Walgreens, CHRISTIANSBURG, VA",
            disabled: false,
          },
          {
            name: "7607, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7608, Walgreens, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "7609, CVS, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "7609, Walgreens, MOBILE, AL",
            disabled: false,
          },
          {
            name: "761, Albertsons, PACIFIC GROVE, CA",
            disabled: false,
          },
          {
            name: "761, Costco, BOISE, ID",
            disabled: false,
          },
          {
            name: "761, Kroger, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "761, Rite Aid, CHEEKTOWAGA, NY",
            disabled: false,
          },
          {
            name: "761, Target, HEMET, CA",
            disabled: false,
          },
          {
            name: "761, Walmart, RACELAND, LA",
            disabled: false,
          },
          {
            name: "7610, CVS, HAVANA, IL",
            disabled: false,
          },
          {
            name: "7611, CVS, ALLISON PARK, PA",
            disabled: false,
          },
          {
            name: "7611, Walgreens, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "7612, CVS, TURTLE CREEK, PA",
            disabled: false,
          },
          {
            name: "7613, CVS, ELIZABETH, NJ",
            disabled: false,
          },
          {
            name: "7613, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "7614, Walgreens, LUMBERTON, TX",
            disabled: false,
          },
          {
            name: "7615, Walgreens, SHAWANO, WI",
            disabled: false,
          },
          {
            name: "7617, CVS, MANLIUS, NY",
            disabled: false,
          },
          {
            name: "7617, Walgreens, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "7618, CVS, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "7618, Walgreens, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "7619, CVS, ARLINGTON, TN",
            disabled: false,
          },
          {
            name: "7619, Walgreens, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "762, ADUSA, STERLING, VA",
            disabled: false,
          },
          {
            name: "762, CVS, AMHERST, NY",
            disabled: false,
          },
          {
            name: "762, Costco, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "762, Kroger, CLARKSVILLE, IN",
            disabled: false,
          },
          {
            name: "762, Kroger, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "762, Target, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "762, Walmart, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "7621, CVS, COPIAGUE, NY",
            disabled: false,
          },
          {
            name: "7622, CVS, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "7622, Walgreens, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "7623, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7623, Walgreens, NOGALES, AZ",
            disabled: false,
          },
          {
            name: "7624, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "7625, CVS, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "7626, CVS, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "7626, Walgreens, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "7627, Walgreens, BRONX, NY",
            disabled: false,
          },
          {
            name: "7628, CVS, RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "7628, Walgreens, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "7629, CVS, MARLBORO, NY",
            disabled: false,
          },
          {
            name: "7629, Walgreens, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "763, ADUSA, VIENNA, VA",
            disabled: false,
          },
          {
            name: "763, Albertsons, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "763, Kroger, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "763, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "763, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "763, Rite Aid, TONAWANDA, NY",
            disabled: false,
          },
          {
            name: "7630, CVS, PORTLAND, TN",
            disabled: false,
          },
          {
            name: "7631, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7632, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "7633, CVS, NORCROSS, GA",
            disabled: false,
          },
          {
            name: "7634, Walgreens, MARINETTE, WI",
            disabled: false,
          },
          {
            name: "7635, CVS, ELKHART, IN",
            disabled: false,
          },
          {
            name: "7635, Walgreens, STURGEON BAY, WI",
            disabled: false,
          },
          {
            name: "7637, CVS, HOSCHTON, GA",
            disabled: false,
          },
          {
            name: "7637, Walgreens, MILFORD, OH",
            disabled: false,
          },
          {
            name: "7638, Walgreens, JASPER, TX",
            disabled: false,
          },
          {
            name: "7639, CVS, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "764, Albertsons, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "764, Costco, MURRAY, UT",
            disabled: false,
          },
          {
            name: "764, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "764, Kroger, Pittsburg, CA",
            disabled: false,
          },
          {
            name: "764, Rite Aid, HOPEWELL, VA",
            disabled: false,
          },
          {
            name: "764, Walmart, BESSEMER, AL",
            disabled: false,
          },
          {
            name: "7640, CVS, LANCASTER, TX",
            disabled: false,
          },
          {
            name: "7641, CVS, LUMBERTON, NC",
            disabled: false,
          },
          {
            name: "7641, Walgreens, SOUTHINGTON, CT",
            disabled: false,
          },
          {
            name: "7643, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7643, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "7644, Walgreens, NORFOLK, VA",
            disabled: false,
          },
          {
            name: "7645, CVS, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "7645, Walgreens, FRISCO, TX",
            disabled: false,
          },
          {
            name: "7646, Walgreens, HICKORY, NC",
            disabled: false,
          },
          {
            name: "7648, CVS, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "7648, Walgreens, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "7649, CVS, BUCKHANNON, WV",
            disabled: false,
          },
          {
            name: "7649, Walgreens, GLENDORA, NJ",
            disabled: false,
          },
          {
            name: "765, ADUSA, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "765, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "765, CVS, SOUTHBRIDGE, MA",
            disabled: false,
          },
          {
            name: "765, Costco, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "765, Kroger, Dayton, OH",
            disabled: false,
          },
          {
            name: "765, Kroger, INDIO, CA",
            disabled: false,
          },
          {
            name: "765, Kroger, RONCEVERTE, WV",
            disabled: false,
          },
          {
            name: "765, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7650, CVS, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "7652, Walgreens, BLUFFTON, SC",
            disabled: false,
          },
          {
            name: "7653, CVS, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "7653, Walgreens, RED BLUFF, CA",
            disabled: false,
          },
          {
            name: "7654, CVS, CONWAY, SC",
            disabled: false,
          },
          {
            name: "7654, Walgreens, BALDWIN PARK, CA",
            disabled: false,
          },
          {
            name: "7655, CVS, ELIZABETHTON, TN",
            disabled: false,
          },
          {
            name: "7656, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "7656, Walgreens, RICHLAND, MS",
            disabled: false,
          },
          {
            name: "7657, Walgreens, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "7658, CVS, DUBLIN, VA",
            disabled: false,
          },
          {
            name: "7659, Walgreens, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "766, ADUSA, RICHFIELD, NC",
            disabled: false,
          },
          {
            name: "766, Costco, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "766, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "766, Kroger, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "766, Target, BEND, OR",
            disabled: false,
          },
          {
            name: "766, Walmart, FLORENCE, AL",
            disabled: false,
          },
          {
            name: "7660, Walgreens, CADILLAC, MI",
            disabled: false,
          },
          {
            name: "7661, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "7663, CVS, KELLER, TX",
            disabled: false,
          },
          {
            name: "7663, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7664, Walgreens, SOMERSET, KY",
            disabled: false,
          },
          {
            name: "7665, Walgreens, SHERWOOD, OR",
            disabled: false,
          },
          {
            name: "7666, CVS, COLUMBUS, GA",
            disabled: false,
          },
          {
            name: "7667, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "7668, CVS, CITRONELLE, AL",
            disabled: false,
          },
          {
            name: "767, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "767, Costco, FIFE, WA",
            disabled: false,
          },
          {
            name: "767, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "767, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "767, Kroger, Peoria, IL",
            disabled: false,
          },
          {
            name: "767, Target, SAN DIMAS, CA",
            disabled: false,
          },
          {
            name: "767, Walmart, LAKE CITY, FL",
            disabled: false,
          },
          {
            name: "7670, CVS, EASTON, PA",
            disabled: false,
          },
          {
            name: "7671, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "7671, Walgreens, TOMBALL, TX",
            disabled: false,
          },
          {
            name: "7672, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7672, Walgreens, SHILOH, IL",
            disabled: false,
          },
          {
            name: "7673, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7674, Walgreens, LEANDER, TX",
            disabled: false,
          },
          {
            name: "7675, CVS, RED OAK, TX",
            disabled: false,
          },
          {
            name: "7676, Walgreens, MARTINSVILLE, IN",
            disabled: false,
          },
          {
            name: "7677, CVS, YORK, PA",
            disabled: false,
          },
          {
            name: "7677, Walgreens, AUBURN, WA",
            disabled: false,
          },
          {
            name: "7678, CVS, RIVER OAKS, TX",
            disabled: false,
          },
          {
            name: "7678, Walgreens, ELDERSBURG, MD",
            disabled: false,
          },
          {
            name: "7679, Walgreens, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "768, Albertsons, CASTRO VALLEY, CA",
            disabled: false,
          },
          {
            name: "768, Costco, EL PASO, TX",
            disabled: false,
          },
          {
            name: "768, Kroger, DUNBAR, WV",
            disabled: false,
          },
          {
            name: "768, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "768, Walmart, KATY, TX",
            disabled: false,
          },
          {
            name: "7680, CVS, TERRELL, TX",
            disabled: false,
          },
          {
            name: "7680, Walgreens, WEBSTER GROVES, MO",
            disabled: false,
          },
          {
            name: "7681, CVS, WINSTON-SALEM, NC",
            disabled: false,
          },
          {
            name: "7681, Walgreens, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "7682, CVS, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "7683, CVS, STATELINE, NV",
            disabled: false,
          },
          {
            name: "7683, Walgreens, FINDLAY, OH",
            disabled: false,
          },
          {
            name: "7684, CVS, ERIE, PA",
            disabled: false,
          },
          {
            name: "7684, Walgreens, LIMA, OH",
            disabled: false,
          },
          {
            name: "7685, Walgreens, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "7686, CVS, MENTOR, OH",
            disabled: false,
          },
          {
            name: "7686, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7687, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "7688, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7688, Walgreens, WILSONVILLE, OR",
            disabled: false,
          },
          {
            name: "7689, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "7689, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "769, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "769, Albertsons, JENKINTOWN, PA",
            disabled: false,
          },
          {
            name: "769, CVS, EAST LONGMEADOW, MA",
            disabled: false,
          },
          {
            name: "769, Costco, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "769, HEB, WEBSTER, TX",
            disabled: false,
          },
          {
            name: "769, Kroger, SOUTH CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "769, Kroger, Salinas, CA",
            disabled: false,
          },
          {
            name: "769, Target, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "769, Walmart, VENICE, FL",
            disabled: false,
          },
          {
            name: "7690, Walgreens, NEW CASTLE, IN",
            disabled: false,
          },
          {
            name: "7692, Walgreens, CHESTERFIELD, MO",
            disabled: false,
          },
          {
            name: "7693, Walgreens, OMAHA, NE",
            disabled: false,
          },
          {
            name: "7694, CVS, TROY, OH",
            disabled: false,
          },
          {
            name: "7694, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7695, CVS, RAVENEL, SC",
            disabled: false,
          },
          {
            name: "7696, CVS, RICHFIELD, NC",
            disabled: false,
          },
          {
            name: "7696, Walgreens, BREAUX BRIDGE, LA",
            disabled: false,
          },
          {
            name: "7698, CVS, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "7698, Walgreens, PONCA CITY, OK",
            disabled: false,
          },
          {
            name: "7699, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "7699, Walgreens, CONCORD, NC",
            disabled: false,
          },
          {
            name: "77, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "77, BJ's, WEST NYACK, NY",
            disabled: false,
          },
          {
            name: "77, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "77, Kroger, English, IN",
            disabled: false,
          },
          {
            name: "77, Kroger, NEWTON, KS",
            disabled: false,
          },
          {
            name: "77, Kroger, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "77, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "77, Kroger, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "77, Walmart, TAYLOR, TX",
            disabled: false,
          },
          {
            name: "770, ADUSA, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "770, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "770, Costco, OGDEN, UT",
            disabled: false,
          },
          {
            name: "770, HEB, KERRVILLE, TX",
            disabled: false,
          },
          {
            name: "770, Kroger, BEAVER, WV",
            disabled: false,
          },
          {
            name: "770, Kroger, Los Angeles, CA",
            disabled: false,
          },
          {
            name: "770, Kroger, Miamisburg, OH",
            disabled: false,
          },
          {
            name: "770, Kroger, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "770, Target, MIDLAND, TX",
            disabled: false,
          },
          {
            name: "770, Walmart, GREAT BEND, KS",
            disabled: false,
          },
          {
            name: "7700, Rite Aid, LAMBERTVILLE, MI",
            disabled: false,
          },
          {
            name: "7700, Walgreens, FEDERAL WAY, WA",
            disabled: false,
          },
          {
            name: "7701, CVS, BLUE RIDGE, GA",
            disabled: false,
          },
          {
            name: "7701, Walgreens, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "7702, CVS, DUNCANVILLE, TX",
            disabled: false,
          },
          {
            name: "7702, Walgreens, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "7703, CVS, SLATON, TX",
            disabled: false,
          },
          {
            name: "7703, Walgreens, EAST LONGMEADOW, MA",
            disabled: false,
          },
          {
            name: "7704, CVS, LEVELLAND, TX",
            disabled: false,
          },
          {
            name: "7704, Walgreens, GREENFIELD, MA",
            disabled: false,
          },
          {
            name: "7706, CVS, FORSYTH, GA",
            disabled: false,
          },
          {
            name: "7707, CVS, LAMESA, TX",
            disabled: false,
          },
          {
            name: "7708, CVS, WHITEHOUSE, TX",
            disabled: false,
          },
          {
            name: "7708, Walgreens, MUNSTER, IN",
            disabled: false,
          },
          {
            name: "7709, CVS, TYLER, TX",
            disabled: false,
          },
          {
            name: "771, ADUSA, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "771, ADUSA, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "771, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "771, Costco, CITRUS HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "771, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "771, Kroger, Lompoc, CA",
            disabled: false,
          },
          {
            name: "771, Target, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "771, Walmart, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "7710, CVS, BROWNWOOD, TX",
            disabled: false,
          },
          {
            name: "7712, CVS, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "7712, Rite Aid, UNIONTOWN, OH",
            disabled: false,
          },
          {
            name: "7712, Walgreens, GLASGOW, KY",
            disabled: false,
          },
          {
            name: "7714, CVS, BRISTOL, TN",
            disabled: false,
          },
          {
            name: "7714, Walgreens, BEAUMONT, CA",
            disabled: false,
          },
          {
            name: "7715, CVS, IRVING, TX",
            disabled: false,
          },
          {
            name: "7715, Walgreens, GREENVILLE, NC",
            disabled: false,
          },
          {
            name: "7716, CVS, UNIVERSAL CITY, TX",
            disabled: false,
          },
          {
            name: "7716, Walgreens, RAINBOW CITY, AL",
            disabled: false,
          },
          {
            name: "7717, CVS, VIDALIA, GA",
            disabled: false,
          },
          {
            name: "7717, Walgreens, GADSDEN, AL",
            disabled: false,
          },
          {
            name: "7718, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "7719, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "7719, Walgreens, MACEDONIA, OH",
            disabled: false,
          },
          {
            name: "772, Costco, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "772, HEB, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "772, Kroger, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "772, Kroger, SIGNAL HILL, CA",
            disabled: false,
          },
          {
            name: "772, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "772, Target, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "772, Walmart, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7720, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "7721, CVS, BREMEN, GA",
            disabled: false,
          },
          {
            name: "7721, Walgreens, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "7722, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7723, Walgreens, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "7724, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7725, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7726, Walgreens, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "7727, Walgreens, WINONA, MN",
            disabled: false,
          },
          {
            name: "7728, CVS, KERRVILLE, TX",
            disabled: false,
          },
          {
            name: "7728, Rite Aid, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "7728, Walgreens, LAKEVILLE, MN",
            disabled: false,
          },
          {
            name: "7729, CVS, CAMERON, TX",
            disabled: false,
          },
          {
            name: "773, Albertsons, HAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "773, Costco, COEUR D' ALENE, ID",
            disabled: false,
          },
          {
            name: "773, Target, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "773, Walmart, EUNICE, LA",
            disabled: false,
          },
          {
            name: "7730, Walgreens, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "7731, Walgreens, SUSSEX, WI",
            disabled: false,
          },
          {
            name: "7732, CVS, ENNIS, TX",
            disabled: false,
          },
          {
            name: "7732, Walgreens, PORTAGE, WI",
            disabled: false,
          },
          {
            name: "7733, Walgreens, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "7734, Walgreens, PLYMOUTH, MA",
            disabled: false,
          },
          {
            name: "7735, CVS, PFLUGERVILLE, TX",
            disabled: false,
          },
          {
            name: "7736, CVS, EAST ELLIJAY, GA",
            disabled: false,
          },
          {
            name: "7736, Rite Aid, MOUNT MORRIS, MI",
            disabled: false,
          },
          {
            name: "7736, Walgreens, CRAWFORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "7737, Walgreens, ROWLETT, TX",
            disabled: false,
          },
          {
            name: "7738, CVS, GREENEVILLE, TN",
            disabled: false,
          },
          {
            name: "7738, Rite Aid, DAVISON, MI",
            disabled: false,
          },
          {
            name: "7739, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7739, Walgreens, SCRANTON, PA",
            disabled: false,
          },
          {
            name: "774, ADUSA, ARLINGTON, VA",
            disabled: false,
          },
          {
            name: "774, Albertsons, BENICIA, CA",
            disabled: false,
          },
          {
            name: "774, Costco, LAKE IN THE HIL, IL",
            disabled: false,
          },
          {
            name: "774, HEB, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "774, Kroger, Clarksburg, WV",
            disabled: false,
          },
          {
            name: "774, Kroger, EL CENTRO, CA",
            disabled: false,
          },
          {
            name: "774, Kroger, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "774, Kroger, VERSAILLES, KY",
            disabled: false,
          },
          {
            name: "774, Target, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "774, Walgreens, ORMOND BEACH, FL",
            disabled: false,
          },
          {
            name: "774, Walmart, COLUMBUS, NE",
            disabled: false,
          },
          {
            name: "7740, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7740, Rite Aid, ALMONT, MI",
            disabled: false,
          },
          {
            name: "7740, Walgreens, DARBY, PA",
            disabled: false,
          },
          {
            name: "7741, Walgreens, BROOKHAVEN, GA",
            disabled: false,
          },
          {
            name: "7742, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7742, Walgreens, CONYERS, GA",
            disabled: false,
          },
          {
            name: "7743, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "7744, CVS, EATONTON, GA",
            disabled: false,
          },
          {
            name: "7744, Walgreens, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "7745, CVS, RINGGOLD, GA",
            disabled: false,
          },
          {
            name: "7746, CVS, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "7746, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "7747, CVS, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7747, Walgreens, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "7748, Walgreens, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "7749, Walgreens, SUNSET BEACH, NC",
            disabled: false,
          },
          {
            name: "775, ADUSA, HERNDON, VA",
            disabled: false,
          },
          {
            name: "775, ADUSA, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "775, Albertsons, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "775, CVS, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "775, Costco, POWAY, CA",
            disabled: false,
          },
          {
            name: "775, HEB, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "775, Kroger, HAWAIIAN GARDENS, CA",
            disabled: false,
          },
          {
            name: "775, Kroger, SOUTHGATE, MI",
            disabled: false,
          },
          {
            name: "775, Target, TYLER, TX",
            disabled: false,
          },
          {
            name: "775, Walmart, GALESBURG, IL",
            disabled: false,
          },
          {
            name: "7750, Walgreens, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "7751, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "7751, Walgreens, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "7753, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7754, Walgreens, PALATINE, IL",
            disabled: false,
          },
          {
            name: "7755, CVS, TRENTON, GA",
            disabled: false,
          },
          {
            name: "7755, Walgreens, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "7756, CVS, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "7757, CVS, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "7757, Walgreens, OXFORD, MS",
            disabled: false,
          },
          {
            name: "7758, CVS, RINCON, GA",
            disabled: false,
          },
          {
            name: "7758, Rite Aid, DETROIT, MI",
            disabled: false,
          },
          {
            name: "7759, CVS, CLAYTON, GA",
            disabled: false,
          },
          {
            name: "7759, Walgreens, GROTON, CT",
            disabled: false,
          },
          {
            name: "776, ADUSA, ARLINGTON, MA",
            disabled: false,
          },
          {
            name: "776, Albertsons, MANAHAWKIN, NJ",
            disabled: false,
          },
          {
            name: "776, Kroger, JEFFERSONVILLE, IN",
            disabled: false,
          },
          {
            name: "776, Kroger, MARIETTA, OH",
            disabled: false,
          },
          {
            name: "776, Kroger, WARREN, MI",
            disabled: false,
          },
          {
            name: "776, Walmart, FREMONT, NE",
            disabled: false,
          },
          {
            name: "7760, CVS, MOKENA, IL",
            disabled: false,
          },
          {
            name: "7760, Walgreens, FARRAGUT, TN",
            disabled: false,
          },
          {
            name: "7761, CVS, FRANKLIN PARK, IL",
            disabled: false,
          },
          {
            name: "7761, Rite Aid, OXFORD, MI",
            disabled: false,
          },
          {
            name: "7761, Walgreens, BARNHART, MO",
            disabled: false,
          },
          {
            name: "7762, CVS, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "7762, Walgreens, AFFTON, MO",
            disabled: false,
          },
          {
            name: "7763, CVS, JASPER, TN",
            disabled: false,
          },
          {
            name: "7764, Walgreens, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "7765, Walgreens, LA QUINTA, CA",
            disabled: false,
          },
          {
            name: "7766, CVS, ALICE, TX",
            disabled: false,
          },
          {
            name: "7766, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7767, CVS, UNION, OH",
            disabled: false,
          },
          {
            name: "7767, Walgreens, CONCORD, NC",
            disabled: false,
          },
          {
            name: "7769, Walgreens, SPRING GROVE, IL",
            disabled: false,
          },
          {
            name: "777, Albertsons, SOUTH SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "777, CVS, WESTBURY, NY",
            disabled: false,
          },
          {
            name: "777, Costco, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "777, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "777, Kroger, Blytheville, AR",
            disabled: false,
          },
          {
            name: "777, Kroger, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "777, Kroger, SHELBYVILLE, KY",
            disabled: false,
          },
          {
            name: "777, Walmart, WEST ORANGE, TX",
            disabled: false,
          },
          {
            name: "7770, Walgreens, LANSING, MI",
            disabled: false,
          },
          {
            name: "7771, CVS, DRESDEN, TN",
            disabled: false,
          },
          {
            name: "7772, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "7773, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "7774, CVS, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "7774, Walgreens, FRESNO, TX",
            disabled: false,
          },
          {
            name: "7775, Walgreens, SPRING, TX",
            disabled: false,
          },
          {
            name: "7776, CVS, AMELIA, OH",
            disabled: false,
          },
          {
            name: "7776, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "7777, CVS, PORTSMOUTH, OH",
            disabled: false,
          },
          {
            name: "7777, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "7778, CVS, DECATUR, GA",
            disabled: false,
          },
          {
            name: "7778, Walgreens, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "7779, Walgreens, CHATTANOOGA, TN",
            disabled: false,
          },
          {
            name: "778, ADUSA, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "778, Albertsons, RICHBORO, PA",
            disabled: false,
          },
          {
            name: "778, CVS, ALBANY, NY",
            disabled: false,
          },
          {
            name: "778, Costco, FREMONT, CA",
            disabled: false,
          },
          {
            name: "778, Kroger, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "778, Kroger, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "778, Kroger, Lincoln Park, MI",
            disabled: false,
          },
          {
            name: "778, Target, FAYETTEVILLE, GA",
            disabled: false,
          },
          {
            name: "778, Walmart, PUNTA GORDA, FL",
            disabled: false,
          },
          {
            name: "7780, CVS, JACKSONVILLE, TX",
            disabled: false,
          },
          {
            name: "7781, Rite Aid, CRANBERRY TWP, PA",
            disabled: false,
          },
          {
            name: "7781, Walgreens, BLAINE, MN",
            disabled: false,
          },
          {
            name: "7782, CVS, HULL, GA",
            disabled: false,
          },
          {
            name: "7782, Walgreens, FERNDALE, WA",
            disabled: false,
          },
          {
            name: "7783, CVS, RICHMOND HILL, GA",
            disabled: false,
          },
          {
            name: "7783, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "7786, CVS, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "7786, Walgreens, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "7787, CVS, FLOWER MOUND, TX",
            disabled: false,
          },
          {
            name: "7788, Walgreens, ANDERSON, IN",
            disabled: false,
          },
          {
            name: "7789, Walgreens, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "779, ADUSA, WINTERVILLE, NC",
            disabled: false,
          },
          {
            name: "779, Albertsons, BENSALEM, PA",
            disabled: false,
          },
          {
            name: "779, Albertsons, CORNWELLS HEIGHTS, PA",
            disabled: false,
          },
          {
            name: "779, Costco, MOUNT PROSPECT, IL",
            disabled: false,
          },
          {
            name: "779, Kroger, GEORGETOWN, KY",
            disabled: false,
          },
          {
            name: "779, Kroger, Santa Maria, CA",
            disabled: false,
          },
          {
            name: "779, Target, ELIZABETHTOWN, KY",
            disabled: false,
          },
          {
            name: "779, Walmart, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "7790, CVS, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "7791, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "7791, Walgreens, BIRMINGHAM, AL",
            disabled: false,
          },
          {
            name: "7792, CVS, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "7792, Walgreens, MILLINGTON, TN",
            disabled: false,
          },
          {
            name: "7793, CVS, TRENTON, TN",
            disabled: false,
          },
          {
            name: "7794, CVS, LA FOLLETTE, TN",
            disabled: false,
          },
          {
            name: "7794, Walgreens, CALDWELL, NJ",
            disabled: false,
          },
          {
            name: "7795, CVS, MOUNT PLEASANT, SC",
            disabled: false,
          },
          {
            name: "7795, Walgreens, GREENWELL SPRINGS, LA",
            disabled: false,
          },
          {
            name: "7797, CVS, PEORIA, IL",
            disabled: false,
          },
          {
            name: "7797, Walgreens, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "7798, Walgreens, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "7799, CVS, PEORIA HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "7799, Walgreens, CHILLICOTHE, OH",
            disabled: false,
          },
          {
            name: "78, ADUSA, SANFORD, NC",
            disabled: false,
          },
          {
            name: "78, BJ's, WEST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "78, CVS, RUSSELLVILLE, AL",
            disabled: false,
          },
          {
            name: "78, Kroger, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "78, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "78, Kroger, Rancho Santa Margari, CA",
            disabled: false,
          },
          {
            name: "78, Target, ALTON, IL",
            disabled: false,
          },
          {
            name: "78, Walmart, MARSHFIELD, MO",
            disabled: false,
          },
          {
            name: "780, ADUSA, FALLS CHURCH, VA",
            disabled: false,
          },
          {
            name: "780, Albertsons, WALL TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "780, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "780, Costco, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "780, Kroger, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "780, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "780, Kroger, OAK HILL, WV",
            disabled: false,
          },
          {
            name: "780, Target, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "780, Walmart, MONROE, GA",
            disabled: false,
          },
          {
            name: "7800, Walgreens, DELAND, FL",
            disabled: false,
          },
          {
            name: "7801, CVS, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7801, Walgreens, CLAYTON, NC",
            disabled: false,
          },
          {
            name: "7804, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "7805, CVS, SUGAR LAND, TX",
            disabled: false,
          },
          {
            name: "7805, Walgreens, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "7806, CVS, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "7806, Walgreens, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "7808, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7808, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "7809, CVS, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "7809, Walgreens, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "781, CVS, BINGHAMTON, NY",
            disabled: false,
          },
          {
            name: "781, Costco, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "781, Kroger, CALEXICO, CA",
            disabled: false,
          },
          {
            name: "781, Kroger, PROCTORVILLE, OH",
            disabled: false,
          },
          {
            name: "781, Walmart, MARBLE FALLS, TX",
            disabled: false,
          },
          {
            name: "7810, Rite Aid, BIG RAPIDS, MI",
            disabled: false,
          },
          {
            name: "7811, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "7811, Walgreens, TROY, MO",
            disabled: false,
          },
          {
            name: "7812, Walgreens, ROGERS, MN",
            disabled: false,
          },
          {
            name: "7813, CVS, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "7814, Walgreens, CLINTON, CT",
            disabled: false,
          },
          {
            name: "7815, Walgreens, TAMPA, FL",
            disabled: false,
          },
          {
            name: "7816, CVS, SCHERTZ, TX",
            disabled: false,
          },
          {
            name: "7816, Walgreens, WEATHERFORD, OK",
            disabled: false,
          },
          {
            name: "7817, Walgreens, DODGE CITY, KS",
            disabled: false,
          },
          {
            name: "7818, CVS, HEREFORD, TX",
            disabled: false,
          },
          {
            name: "7818, Walgreens, GREAT BEND, KS",
            disabled: false,
          },
          {
            name: "7819, CVS, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "7819, Walgreens, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "782, ADUSA, FEEDING HILLS, MA",
            disabled: false,
          },
          {
            name: "782, Albertsons, SANDY, OR",
            disabled: false,
          },
          {
            name: "782, Costco, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "782, Kroger, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "782, Kroger, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "782, Kroger, Royal Oak, MI",
            disabled: false,
          },
          {
            name: "782, Walmart, UVALDE, TX",
            disabled: false,
          },
          {
            name: "7820, Walgreens, CARROLLTON, GA",
            disabled: false,
          },
          {
            name: "7821, CVS, LEAGUE CITY, TX",
            disabled: false,
          },
          {
            name: "7821, Walgreens, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "7822, Rite Aid, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "7822, Walgreens, SPARTANBURG, SC",
            disabled: false,
          },
          {
            name: "7823, Walgreens, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "7824, CVS, GARLAND, TX",
            disabled: false,
          },
          {
            name: "7824, Rite Aid, CANTON, MI",
            disabled: false,
          },
          {
            name: "7824, Walgreens, HAINESVILLE, IL",
            disabled: false,
          },
          {
            name: "7825, CVS, FRISCO, TX",
            disabled: false,
          },
          {
            name: "7825, Rite Aid, WEXFORD, PA",
            disabled: false,
          },
          {
            name: "7825, Walgreens, MOUNT HOLLY, NJ",
            disabled: false,
          },
          {
            name: "7826, CVS, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "7826, Walgreens, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "7827, CVS, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "7827, Rite Aid, QUAKERTOWN, PA",
            disabled: false,
          },
          {
            name: "7827, Walgreens, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "7828, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "7829, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7829, Rite Aid, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "7829, Walgreens, ROMEOVILLE, IL",
            disabled: false,
          },
          {
            name: "783, ADUSA, BURKE, VA",
            disabled: false,
          },
          {
            name: "783, Albertsons, LAFAYETTE, CA",
            disabled: false,
          },
          {
            name: "783, CVS, VALATIE, NY",
            disabled: false,
          },
          {
            name: "783, Costco, EDEN PRAIRIE, MN",
            disabled: false,
          },
          {
            name: "783, Kroger, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "783, Kroger, Tulare, CA",
            disabled: false,
          },
          {
            name: "783, Walmart, MACON, MO",
            disabled: false,
          },
          {
            name: "7830, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "7830, Rite Aid, BURLINGTON, NJ",
            disabled: false,
          },
          {
            name: "7830, Walgreens, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "7831, Rite Aid, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "7831, Walgreens, NEW HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "7832, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7832, Rite Aid, GIBSONIA, PA",
            disabled: false,
          },
          {
            name: "7832, Walgreens, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "7833, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "7835, Walgreens, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "7836, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "7836, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "7837, Walgreens, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "7838, CVS, DOUGLASSVILLE, PA",
            disabled: false,
          },
          {
            name: "7839, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "784, ADUSA, NORTH ADAMS, MA",
            disabled: false,
          },
          {
            name: "784, Costco, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "784, Kroger, Fresno, CA",
            disabled: false,
          },
          {
            name: "784, Kroger, GROSSE POINTE PARK, MI",
            disabled: false,
          },
          {
            name: "784, Kroger, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "784, Kroger, Scott Depot, WV",
            disabled: false,
          },
          {
            name: "784, Walmart, MOUNT PLEASANT, IA",
            disabled: false,
          },
          {
            name: "7841, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7841, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "7842, CVS, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "7843, CVS, WINCHESTER, VA",
            disabled: false,
          },
          {
            name: "7843, Rite Aid, MCKEESPORT, PA",
            disabled: false,
          },
          {
            name: "7843, Walgreens, KINGSTON, PA",
            disabled: false,
          },
          {
            name: "7844, Rite Aid, ADA, OH",
            disabled: false,
          },
          {
            name: "7844, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "7845, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "7846, Walgreens, MILLWOOD, WA",
            disabled: false,
          },
          {
            name: "7847, Walgreens, FAYETTEVILLE, AR",
            disabled: false,
          },
          {
            name: "7848, Walgreens, BRUNSWICK, GA",
            disabled: false,
          },
          {
            name: "7849, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "7849, Rite Aid, HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "7849, Walgreens, HORN LAKE, MS",
            disabled: false,
          },
          {
            name: "785, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "785, Costco, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "785, Kroger, CHARLESTON, WV",
            disabled: false,
          },
          {
            name: "785, Kroger, Henderson, NV",
            disabled: false,
          },
          {
            name: "785, Kroger, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "785, Walmart, WAYNESBORO, MS",
            disabled: false,
          },
          {
            name: "7850, Rite Aid, EMPORIUM, PA",
            disabled: false,
          },
          {
            name: "7851, Walgreens, BONITA SPRINGS, FL",
            disabled: false,
          },
          {
            name: "7852, CVS, CAVE CREEK, AZ",
            disabled: false,
          },
          {
            name: "7853, Rite Aid, SAINT MARYS, PA",
            disabled: false,
          },
          {
            name: "7853, Walgreens, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "7854, Walgreens, GARDEN CITY, MI",
            disabled: false,
          },
          {
            name: "7855, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7856, CVS, NORWALK, CT",
            disabled: false,
          },
          {
            name: "7857, Walgreens, SAND SPRINGS, OK",
            disabled: false,
          },
          {
            name: "7858, Walgreens, TULSA, OK",
            disabled: false,
          },
          {
            name: "7859, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7859, Walgreens, GASTONIA, NC",
            disabled: false,
          },
          {
            name: "786, Albertsons, FELTON, CA",
            disabled: false,
          },
          {
            name: "786, Costco, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "786, Kroger, COLTON, CA",
            disabled: false,
          },
          {
            name: "786, Kroger, Charleston, WV",
            disabled: false,
          },
          {
            name: "786, Walmart, DEKALB, IL",
            disabled: false,
          },
          {
            name: "7860, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "7860, Walgreens, FOX RIVER GROVE, IL",
            disabled: false,
          },
          {
            name: "7861, Rite Aid, MORGANTOWN, PA",
            disabled: false,
          },
          {
            name: "7861, Walgreens, POLAND, OH",
            disabled: false,
          },
          {
            name: "7862, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "7863, CVS, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "7864, Walgreens, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "7865, Walgreens, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "7866, Walgreens, JOLIET, IL",
            disabled: false,
          },
          {
            name: "7867, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7869, Rite Aid, NOVI, MI",
            disabled: false,
          },
          {
            name: "7869, Walgreens, NATIONAL CITY, CA",
            disabled: false,
          },
          {
            name: "787, ADUSA, NORTHAMPTON, MA",
            disabled: false,
          },
          {
            name: "787, Albertsons, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "787, Costco, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "787, Kroger, HAMMOND, IN",
            disabled: false,
          },
          {
            name: "787, Kroger, Weston, WV",
            disabled: false,
          },
          {
            name: "787, Walmart, RIVERDALE, GA",
            disabled: false,
          },
          {
            name: "7872, CVS, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "7874, Walgreens, TRAVERSE CITY, MI",
            disabled: false,
          },
          {
            name: "7875, Walgreens, PORT CHARLOTTE, FL",
            disabled: false,
          },
          {
            name: "7876, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "7877, Rite Aid, PINCKNEY, MI",
            disabled: false,
          },
          {
            name: "7877, Walgreens, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "7878, Rite Aid, CLARKS SUMMIT, PA",
            disabled: false,
          },
          {
            name: "7878, Walgreens, DAYTON, TX",
            disabled: false,
          },
          {
            name: "788, ADUSA, CENTREVILLE, VA",
            disabled: false,
          },
          {
            name: "788, Albertsons, MILL VALLEY, CA",
            disabled: false,
          },
          {
            name: "788, Costco, WEST DES MOINES, IA",
            disabled: false,
          },
          {
            name: "788, Kroger, BARBOURSVILLE, WV",
            disabled: false,
          },
          {
            name: "788, Kroger, Burbank, IL",
            disabled: false,
          },
          {
            name: "788, Walmart, CLINTON, AR",
            disabled: false,
          },
          {
            name: "7880, Rite Aid, NORTH WALES, PA",
            disabled: false,
          },
          {
            name: "7880, Walgreens, RHINELANDER, WI",
            disabled: false,
          },
          {
            name: "7881, Walgreens, EDGEWOOD, NM",
            disabled: false,
          },
          {
            name: "7882, Walgreens, BARABOO, WI",
            disabled: false,
          },
          {
            name: "7883, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "7884, CVS, ARDEN, NC",
            disabled: false,
          },
          {
            name: "7884, Rite Aid, CARLISLE, PA",
            disabled: false,
          },
          {
            name: "7884, Walgreens, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "7885, CVS, RINGGOLD, GA",
            disabled: false,
          },
          {
            name: "7885, Walgreens, DAYTON, OH",
            disabled: false,
          },
          {
            name: "7886, CVS, TEQUESTA, FL",
            disabled: false,
          },
          {
            name: "7886, Rite Aid, YORK, PA",
            disabled: false,
          },
          {
            name: "7886, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "7887, CVS, MIRAMAR, FL",
            disabled: false,
          },
          {
            name: "7888, CVS, CANTON, GA",
            disabled: false,
          },
          {
            name: "7888, Walgreens, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "7889, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7889, Walgreens, MIAMI, OK",
            disabled: false,
          },
          {
            name: "789, CVS, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "789, Rite Aid, BARRINGTON, NJ",
            disabled: false,
          },
          {
            name: "789, Walmart, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "7890, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "7891, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "7891, Rite Aid, SMYRNA, DE",
            disabled: false,
          },
          {
            name: "7892, CVS, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "7892, Walgreens, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "7893, CVS, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "7894, CVS, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "7894, Rite Aid, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "7894, Walgreens, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "7895, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "7895, Walgreens, CHANNAHON, IL",
            disabled: false,
          },
          {
            name: "7898, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "7899, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "7899, Walgreens, SAGINAW, TX",
            disabled: false,
          },
          {
            name: "79, ADUSA, ROARING SPRING, PA",
            disabled: false,
          },
          {
            name: "79, ADUSA, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "79, CVS, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "79, Kroger, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "79, Kroger, Edinburgh, IN",
            disabled: false,
          },
          {
            name: "79, Kroger, LAKE FOREST, CA",
            disabled: false,
          },
          {
            name: "79, Kroger, North Ogden, UT",
            disabled: false,
          },
          {
            name: "79, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "79, Target, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "79, Walmart, JOPLIN, MO",
            disabled: false,
          },
          {
            name: "790, ADUSA, HAYMARKET, VA",
            disabled: false,
          },
          {
            name: "790, Albertsons, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "790, CVS, LITTLE SILVER, NJ",
            disabled: false,
          },
          {
            name: "790, Kroger, Ann Arbor, MI",
            disabled: false,
          },
          {
            name: "790, Kroger, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "790, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "790, Rite Aid, HAVERTOWN, PA",
            disabled: false,
          },
          {
            name: "790, Walmart, MCCOOK, NE",
            disabled: false,
          },
          {
            name: "7901, Walgreens, REPUBLIC, MO",
            disabled: false,
          },
          {
            name: "7902, CVS, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "7906, Walgreens, WARSAW, IN",
            disabled: false,
          },
          {
            name: "7907, Walgreens, COLUMBIA CITY, IN",
            disabled: false,
          },
          {
            name: "7909, Walgreens, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "791, ADUSA, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "791, CVS, ERDENHEIM, PA",
            disabled: false,
          },
          {
            name: "791, Walmart, ALICE, TX",
            disabled: false,
          },
          {
            name: "7910, CVS, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "7911, Walgreens, COVINGTON, TN",
            disabled: false,
          },
          {
            name: "7912, Rite Aid, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "7915, CVS, RINGWOOD, NJ",
            disabled: false,
          },
          {
            name: "7915, Walgreens, NEPTUNE, NJ",
            disabled: false,
          },
          {
            name: "7916, CVS, BURLINGTON, CT",
            disabled: false,
          },
          {
            name: "7916, Walgreens, BROOKSVILLE, FL",
            disabled: false,
          },
          {
            name: "7917, CVS, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "7918, Walgreens, DUNEDIN, FL",
            disabled: false,
          },
          {
            name: "7919, CVS, BOYNTON BEACH, FL",
            disabled: false,
          },
          {
            name: "7919, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "792, Albertsons, COVINGTON, WA",
            disabled: false,
          },
          {
            name: "792, CVS, FLOWERY BRANCH, GA",
            disabled: false,
          },
          {
            name: "792, Kroger, HUNTINGTON, WV",
            disabled: false,
          },
          {
            name: "792, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "792, Target, PARMA, OH",
            disabled: false,
          },
          {
            name: "792, Walmart, ALEDO, IL",
            disabled: false,
          },
          {
            name: "7921, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7923, CVS, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "7923, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "7924, Rite Aid, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "7925, Walgreens, HENDERSON, KY",
            disabled: false,
          },
          {
            name: "7926, Walgreens, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "7927, Walgreens, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "7928, Rite Aid, LIMA, OH",
            disabled: false,
          },
          {
            name: "7928, Walgreens, GILLETTE, WY",
            disabled: false,
          },
          {
            name: "793, Albertsons, ARCATA, CA",
            disabled: false,
          },
          {
            name: "793, CVS, GLOVERSVILLE, NY",
            disabled: false,
          },
          {
            name: "793, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "793, Kroger, OKEMOS, MI",
            disabled: false,
          },
          {
            name: "793, Target, CUYAHOGA FALLS, OH",
            disabled: false,
          },
          {
            name: "793, Walmart, CANYON, TX",
            disabled: false,
          },
          {
            name: "7930, Walgreens, CARLSBAD, NM",
            disabled: false,
          },
          {
            name: "7931, Walgreens, PALM HARBOR, FL",
            disabled: false,
          },
          {
            name: "7932, CVS, MANCHESTER, NH",
            disabled: false,
          },
          {
            name: "7932, Walgreens, POUGHKEEPSIE, NY",
            disabled: false,
          },
          {
            name: "7933, CVS, COOPER CITY, FL",
            disabled: false,
          },
          {
            name: "7933, Walgreens, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "7934, Walgreens, THREE RIVERS, MI",
            disabled: false,
          },
          {
            name: "7935, Walgreens, ORANGE, CT",
            disabled: false,
          },
          {
            name: "7936, Walgreens, BIG PINE KEY, FL",
            disabled: false,
          },
          {
            name: "7937, CVS, PARRISH, FL",
            disabled: false,
          },
          {
            name: "7937, Walgreens, ABILENE, TX",
            disabled: false,
          },
          {
            name: "7938, CVS, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "7938, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7939, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "794, ADUSA, STERLING, VA",
            disabled: false,
          },
          {
            name: "794, CVS, BRISTOW, VA",
            disabled: false,
          },
          {
            name: "794, Costco, DALLAS, TX",
            disabled: false,
          },
          {
            name: "794, Kroger, LaGrange, KY",
            disabled: false,
          },
          {
            name: "794, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "794, Kroger, Scott Depot, WV",
            disabled: false,
          },
          {
            name: "794, Rite Aid, ENGLEWOOD, OH",
            disabled: false,
          },
          {
            name: "794, Target, NORTH CANTON, OH",
            disabled: false,
          },
          {
            name: "794, Walmart, HUTCHINSON, KS",
            disabled: false,
          },
          {
            name: "7940, CVS, OWENSBORO, KY",
            disabled: false,
          },
          {
            name: "7940, Walgreens, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "7941, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "7941, Walgreens, SIDNEY, OH",
            disabled: false,
          },
          {
            name: "7942, Walgreens, WHITEHALL, OH",
            disabled: false,
          },
          {
            name: "7943, CVS, WAXHAW, NC",
            disabled: false,
          },
          {
            name: "7944, CVS, SAINT PETERSBURG, FL",
            disabled: false,
          },
          {
            name: "7945, Rite Aid, OREGON, OH",
            disabled: false,
          },
          {
            name: "7946, Rite Aid, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "7946, Walgreens, CUMMING, GA",
            disabled: false,
          },
          {
            name: "7947, CVS, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "7948, CVS, FOREST, VA",
            disabled: false,
          },
          {
            name: "7949, Walgreens, POST FALLS, ID",
            disabled: false,
          },
          {
            name: "795, ADUSA, SPRINGFIELD, VA",
            disabled: false,
          },
          {
            name: "795, Kroger, OWOSSO, MI",
            disabled: false,
          },
          {
            name: "795, Target, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "795, Walmart, BARNWELL, SC",
            disabled: false,
          },
          {
            name: "7950, Walgreens, NORTH HILLS, CA",
            disabled: false,
          },
          {
            name: "7951, CVS, FREDERICKSBURG, VA",
            disabled: false,
          },
          {
            name: "7951, Walgreens, ANNISTON, AL",
            disabled: false,
          },
          {
            name: "7952, CVS, BALTIMORE, MD",
            disabled: false,
          },
          {
            name: "7952, Walgreens, IONIA, MI",
            disabled: false,
          },
          {
            name: "7955, Walgreens, THORNTON, CO",
            disabled: false,
          },
          {
            name: "7956, Walgreens, PAWLEYS ISLAND, SC",
            disabled: false,
          },
          {
            name: "7958, CVS, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "7958, Walgreens, BUFORD, GA",
            disabled: false,
          },
          {
            name: "7959, CVS, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "796, Kroger, ASHLAND, KY",
            disabled: false,
          },
          {
            name: "796, Target, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "796, Walmart, PERU, IL",
            disabled: false,
          },
          {
            name: "7960, Walgreens, LAWRENCEVILLE, GA",
            disabled: false,
          },
          {
            name: "7961, CVS, MULLICA HILL, NJ",
            disabled: false,
          },
          {
            name: "7962, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "7962, Walgreens, SARALAND, AL",
            disabled: false,
          },
          {
            name: "7963, Walgreens, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "7964, CVS, FLAGLER BEACH, FL",
            disabled: false,
          },
          {
            name: "7964, Walgreens, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "7965, Walgreens, PLEASANT PRAIRIE, WI",
            disabled: false,
          },
          {
            name: "7966, Walgreens, CHIPPEWA FALLS, WI",
            disabled: false,
          },
          {
            name: "7967, Walgreens, CLIVE, IA",
            disabled: false,
          },
          {
            name: "7968, Walgreens, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "7969, Walgreens, BERKELEY HEIGHTS, NJ",
            disabled: false,
          },
          {
            name: "797, ADUSA, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "797, ADUSA, BELMONT, NC",
            disabled: false,
          },
          {
            name: "797, Albertsons, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "797, Costco, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "797, Target, MOBILE, AL",
            disabled: false,
          },
          {
            name: "797, Walmart, WEST BURLINGTON, IA",
            disabled: false,
          },
          {
            name: "7970, CVS, LAKE IN THE HILLS, IL",
            disabled: false,
          },
          {
            name: "7971, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "7971, Walgreens, REDMOND, OR",
            disabled: false,
          },
          {
            name: "7972, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "7972, Walgreens, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "7973, Walgreens, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "7974, Walgreens, TRENTON, NJ",
            disabled: false,
          },
          {
            name: "7975, Walgreens, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "7976, Walgreens, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "7978, Walgreens, NORTH WILKESBORO, NC",
            disabled: false,
          },
          {
            name: "7979, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "798, ADUSA, LORTON, VA",
            disabled: false,
          },
          {
            name: "798, Albertsons, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "798, Costco, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "798, Target, TAMPA, FL",
            disabled: false,
          },
          {
            name: "798, Walmart, MARSHALL, IL",
            disabled: false,
          },
          {
            name: "7980, CVS, MACCLENNY, FL",
            disabled: false,
          },
          {
            name: "7981, Walgreens, CAROLINA BEACH, NC",
            disabled: false,
          },
          {
            name: "7982, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "7982, Walgreens, KAYSVILLE, UT",
            disabled: false,
          },
          {
            name: "7983, CVS, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "7983, Walgreens, UNION CITY, TN",
            disabled: false,
          },
          {
            name: "799, ADUSA, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "799, Albertsons, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "799, CVS, NEW BEDFORD, MA",
            disabled: false,
          },
          {
            name: "799, Costco, AUBURN, WA",
            disabled: false,
          },
          {
            name: "799, Kroger, BELPRE, OH",
            disabled: false,
          },
          {
            name: "799, Kroger, Las Vegas, NV",
            disabled: false,
          },
          {
            name: "799, Target, SARASOTA, FL",
            disabled: false,
          },
          {
            name: "799, Walmart, LIBERAL, KS",
            disabled: false,
          },
          {
            name: "7990, Walgreens, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "7991, CVS, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "7992, Walgreens, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "7993, CVS, GREENACRES, FL",
            disabled: false,
          },
          {
            name: "7994, Walgreens, CUMMING, GA",
            disabled: false,
          },
          {
            name: "7995, Walgreens, STONE MOUNTAIN, GA",
            disabled: false,
          },
          {
            name: "7996, Walgreens, ANKENY, IA",
            disabled: false,
          },
          {
            name: "7997, CVS, TIFFIN, OH",
            disabled: false,
          },
          {
            name: "7998, CVS, CITRUS HILLS, FL",
            disabled: false,
          },
          {
            name: "8, ADUSA, FRAMINGHAM, MA",
            disabled: false,
          },
          {
            name: "8, ADUSA, NEW KENSINGTON, PA",
            disabled: false,
          },
          {
            name: "8, Albertsons, CENTENNIAL, CO",
            disabled: false,
          },
          {
            name: "8, Albertsons, ENGLEWOOD, CO",
            disabled: false,
          },
          {
            name: "8, BJ's, EAST RUTHERFORD, NJ",
            disabled: false,
          },
          {
            name: "8, CVS, SHREWSBURY, MA",
            disabled: false,
          },
          {
            name: "8, Costco, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "8, Kroger, Columbus, IN",
            disabled: false,
          },
          {
            name: "8, Kroger, HIGHLANDS RANCH, CO",
            disabled: false,
          },
          {
            name: "8, Kroger, Hutchinson, KS",
            disabled: false,
          },
          {
            name: "8, Kroger, ORANGE, CA",
            disabled: false,
          },
          {
            name: "8, Walmart, MORRILTON, AR",
            disabled: false,
          },
          {
            name: "80, ADUSA, BROOKVILLE, PA",
            disabled: false,
          },
          {
            name: "80, ADUSA, SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "80, Albertsons, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "80, CVS, LAKEWAY, TX",
            disabled: false,
          },
          {
            name: "80, Kroger, IRVINE, CA",
            disabled: false,
          },
          {
            name: "80, Kroger, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "80, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "80, Target, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "80, Walmart, COLUMBIA, MO",
            disabled: false,
          },
          {
            name: "800, ADUSA, BLOOMFIELD, NJ",
            disabled: false,
          },
          {
            name: "800, ADUSA, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "800, Kroger, MOUNT GILEAD, OH",
            disabled: false,
          },
          {
            name: "800, Kroger, Marietta, OH",
            disabled: false,
          },
          {
            name: "800, Target, COLLEGE STATION, TX",
            disabled: false,
          },
          {
            name: "800, Walmart, LEESBURG, FL",
            disabled: false,
          },
          {
            name: "8001, CVS, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "8002, CVS, WALLED LAKE, MI",
            disabled: false,
          },
          {
            name: "8003, CVS, SALINE, MI",
            disabled: false,
          },
          {
            name: "8004, CVS, MILFORD, MI",
            disabled: false,
          },
          {
            name: "8006, CVS, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "8007, CVS, REDFORD, MI",
            disabled: false,
          },
          {
            name: "8008, CVS, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "8009, CVS, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "801, ADUSA, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "801, ADUSA, KEYPORT, NJ",
            disabled: false,
          },
          {
            name: "801, Albertsons, DURANGO, CO",
            disabled: false,
          },
          {
            name: "801, CVS, BATH, ME",
            disabled: false,
          },
          {
            name: "801, Target, LAREDO, TX",
            disabled: false,
          },
          {
            name: "801, Walmart, MARYVILLE, MO",
            disabled: false,
          },
          {
            name: "8010, CVS, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "8011, CVS, EASTPOINTE, MI",
            disabled: false,
          },
          {
            name: "8013, CVS, ADRIAN, MI",
            disabled: false,
          },
          {
            name: "8014, CVS, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8015, CVS, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "8016, CVS, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "802, ADUSA, FRANKLIN PARK, NJ",
            disabled: false,
          },
          {
            name: "802, Albertsons, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "802, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "802, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "802, Kroger, SUNBURY, OH",
            disabled: false,
          },
          {
            name: "802, Target, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "802, Walmart, MONROE, WI",
            disabled: false,
          },
          {
            name: "8021, CVS, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "8023, CVS, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "8024, CVS, RICHMOND, MI",
            disabled: false,
          },
          {
            name: "8025, CVS, TECUMSEH, MI",
            disabled: false,
          },
          {
            name: "8026, CVS, TROY, MI",
            disabled: false,
          },
          {
            name: "8027, CVS, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "8028, CVS, SOUTHGATE, MI",
            disabled: false,
          },
          {
            name: "8029, CVS, WYANDOTTE, MI",
            disabled: false,
          },
          {
            name: "803, ADUSA, EDISON, NJ",
            disabled: false,
          },
          {
            name: "803, ADUSA, MAIDEN, NC",
            disabled: false,
          },
          {
            name: "803, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "803, CVS, WESTBROOK, ME",
            disabled: false,
          },
          {
            name: "803, Kroger, Compton, CA",
            disabled: false,
          },
          {
            name: "803, Kroger, KENT, WA",
            disabled: false,
          },
          {
            name: "803, Kroger, WEIRTON, WV",
            disabled: false,
          },
          {
            name: "803, Rite Aid, JOHNSTOWN, PA",
            disabled: false,
          },
          {
            name: "803, Target, DES MOINES, IA",
            disabled: false,
          },
          {
            name: "803, Walmart, BOGALUSA, LA",
            disabled: false,
          },
          {
            name: "8030, CVS, TROY, MI",
            disabled: false,
          },
          {
            name: "8031, CVS, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "8032, CVS, CENTER LINE, MI",
            disabled: false,
          },
          {
            name: "8033, CVS, MADISON HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8034, CVS, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "8036, CVS, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "8038, CVS, WATERFORD, MI",
            disabled: false,
          },
          {
            name: "8039, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "804, Albertsons, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "804, CVS, PORTLAND, ME",
            disabled: false,
          },
          {
            name: "804, Kroger, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "804, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "804, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "804, Target, MASON CITY, IA",
            disabled: false,
          },
          {
            name: "804, Walmart, MINERAL WELLS, TX",
            disabled: false,
          },
          {
            name: "8042, CVS, BELLEVILLE, MI",
            disabled: false,
          },
          {
            name: "8044, CVS, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "8045, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "8046, CVS, HOWELL, MI",
            disabled: false,
          },
          {
            name: "8048, CVS, FARMINGTON, MI",
            disabled: false,
          },
          {
            name: "8049, CVS, WATERFORD, MI",
            disabled: false,
          },
          {
            name: "805, Kroger, BECKLEY, WV",
            disabled: false,
          },
          {
            name: "805, Kroger, LEWIS CENTER, OH",
            disabled: false,
          },
          {
            name: "805, Kroger, NORMANDY PARK, WA",
            disabled: false,
          },
          {
            name: "805, Target, MARSHFIELD, WI",
            disabled: false,
          },
          {
            name: "805, Walmart, FENTON, MO",
            disabled: false,
          },
          {
            name: "8050, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "8051, CVS, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "8052, CVS, HARPER WOODS, MI",
            disabled: false,
          },
          {
            name: "8053, CVS, KIMBALL, MI",
            disabled: false,
          },
          {
            name: "8054, CVS, HOLT, MI",
            disabled: false,
          },
          {
            name: "8055, CVS, MELVINDALE, MI",
            disabled: false,
          },
          {
            name: "8056, CVS, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8058, CVS, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "8059, CVS, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "806, Albertsons, NEWARK, DE",
            disabled: false,
          },
          {
            name: "806, CVS, SOUTH PORTLAND, ME",
            disabled: false,
          },
          {
            name: "806, Kroger, Compton, CA",
            disabled: false,
          },
          {
            name: "806, Kroger, MERCER ISLAND, WA",
            disabled: false,
          },
          {
            name: "806, Kroger, Whitehall, OH",
            disabled: false,
          },
          {
            name: "806, ShopRite, COMMACK, NY",
            disabled: false,
          },
          {
            name: "806, Target, STEVENS POINT, WI",
            disabled: false,
          },
          {
            name: "806, Walmart, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "8062, CVS, ROSEVILLE, MI",
            disabled: false,
          },
          {
            name: "8064, CVS, TRENTON, MI",
            disabled: false,
          },
          {
            name: "8065, CVS, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "8066, CVS, SOUTH LYON, MI",
            disabled: false,
          },
          {
            name: "8067, CVS, NOVI, MI",
            disabled: false,
          },
          {
            name: "8068, CVS, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "8069, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "807, ADUSA, BERKELEY SPRINGS, WV",
            disabled: false,
          },
          {
            name: "807, ADUSA, MATAWAN, NJ",
            disabled: false,
          },
          {
            name: "807, CVS, THORNWOOD, NY",
            disabled: false,
          },
          {
            name: "807, Kroger, Compton, CA",
            disabled: false,
          },
          {
            name: "807, Kroger, ELKVIEW, WV",
            disabled: false,
          },
          {
            name: "807, Kroger, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "807, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "807, Target, OSHKOSH, WI",
            disabled: false,
          },
          {
            name: "807, Walmart, NORTH RICHLAND HILL, TX",
            disabled: false,
          },
          {
            name: "807, Walmart, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "8071, CVS, LAKE ORION, MI",
            disabled: false,
          },
          {
            name: "8072, CVS, FLAT ROCK, MI",
            disabled: false,
          },
          {
            name: "8074, CVS, BERKLEY, MI",
            disabled: false,
          },
          {
            name: "8075, CVS, GARDEN CITY, MI",
            disabled: false,
          },
          {
            name: "8076, CVS, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "8077, CVS, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "8078, CVS, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "808, ADUSA, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "808, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "808, CVS, SECAUCUS, NJ",
            disabled: false,
          },
          {
            name: "808, Kroger, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "808, Kroger, Lexington, KY",
            disabled: false,
          },
          {
            name: "808, Kroger, MARION, OH",
            disabled: false,
          },
          {
            name: "808, ShopRite, SELDEN, NY",
            disabled: false,
          },
          {
            name: "808, Target, FOND DU LAC, WI",
            disabled: false,
          },
          {
            name: "808, Walmart, LAKE JACKSON, TX",
            disabled: false,
          },
          {
            name: "8080, CVS, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8082, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8085, CVS, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "8087, CVS, CHARLOTTE, MI",
            disabled: false,
          },
          {
            name: "8088, CVS, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "8089, CVS, CHELSEA, MI",
            disabled: false,
          },
          {
            name: "809, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "809, ADUSA, SOMERSET, NJ",
            disabled: false,
          },
          {
            name: "809, Albertsons, MEDIA, PA",
            disabled: false,
          },
          {
            name: "809, CVS, EGG HARBOR TOWNSHIP, NJ",
            disabled: false,
          },
          {
            name: "809, Target, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "809, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "809, Walmart, OXFORD, AL",
            disabled: false,
          },
          {
            name: "8091, CVS, FRASER, MI",
            disabled: false,
          },
          {
            name: "8092, CVS, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "8093, CVS, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "8094, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8097, CVS, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "81, ADUSA, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "81, ADUSA, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "81, Albertsons, OSWEGO, IL",
            disabled: false,
          },
          {
            name: "81, CVS, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "81, Kroger, BRIGHTON, CO",
            disabled: false,
          },
          {
            name: "81, Kroger, Crawfordsville, IN",
            disabled: false,
          },
          {
            name: "81, Kroger, Floyds Knobs, IN",
            disabled: false,
          },
          {
            name: "81, Kroger, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "81, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "81, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "81, Kroger, Woodland Hills, CA",
            disabled: false,
          },
          {
            name: "81, Walmart, STILWELL, OK",
            disabled: false,
          },
          {
            name: "810, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "810, CVS, LEOMINSTER, MA",
            disabled: false,
          },
          {
            name: "810, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "810, Target, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "810, Walmart, MASON CITY, IA",
            disabled: false,
          },
          {
            name: "8101, CVS, FERNDALE, MI",
            disabled: false,
          },
          {
            name: "8102, CVS, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "8103, CVS, HAZEL PARK, MI",
            disabled: false,
          },
          {
            name: "8104, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8106, CVS, OAK PARK, MI",
            disabled: false,
          },
          {
            name: "8107, CVS, GROSSE POINTE WOODS, MI",
            disabled: false,
          },
          {
            name: "8108, CVS, NEW BALTIMORE, MI",
            disabled: false,
          },
          {
            name: "811, ADUSA, TOMS RIVER, NJ",
            disabled: false,
          },
          {
            name: "811, Albertsons, CONCORD, NH",
            disabled: false,
          },
          {
            name: "811, Kroger, BEAVERCREEK, OH",
            disabled: false,
          },
          {
            name: "811, Kroger, Compton, CA",
            disabled: false,
          },
          {
            name: "811, Kroger, SAINT JOHNS, MI",
            disabled: false,
          },
          {
            name: "811, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "811, ShopRite, PATCHOGUE, NY",
            disabled: false,
          },
          {
            name: "811, Target, PANAMA CITY, FL",
            disabled: false,
          },
          {
            name: "811, Walmart, ARCADIA, FL",
            disabled: false,
          },
          {
            name: "8110, CVS, CLAWSON, MI",
            disabled: false,
          },
          {
            name: "8111, CVS, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "8114, CVS, SOUTHGATE, MI",
            disabled: false,
          },
          {
            name: "8115, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "812, ADUSA, EMERSON, NJ",
            disabled: false,
          },
          {
            name: "812, ADUSA, MOORESVILLE, NC",
            disabled: false,
          },
          {
            name: "812, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "812, Kroger, Kettering, OH",
            disabled: false,
          },
          {
            name: "812, Kroger, Saint Clairsville, OH",
            disabled: false,
          },
          {
            name: "812, ShopRite, NEW HYDE PARK, NY",
            disabled: false,
          },
          {
            name: "812, Target, BRANDON, FL",
            disabled: false,
          },
          {
            name: "812, Walmart, DUMAS, TX",
            disabled: false,
          },
          {
            name: "8121, CVS, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "8125, CVS, TAYLOR, MI",
            disabled: false,
          },
          {
            name: "8126, CVS, COLDWATER, MI",
            disabled: false,
          },
          {
            name: "8127, CVS, ROYAL OAK, MI",
            disabled: false,
          },
          {
            name: "8128, CVS, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "8129, CVS, LAKE ORION, MI",
            disabled: false,
          },
          {
            name: "813, ADUSA, CLIFTON, NJ",
            disabled: false,
          },
          {
            name: "813, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "813, Kroger, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "813, Rite Aid, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "813, Target, VENICE, FL",
            disabled: false,
          },
          {
            name: "813, Walgreens, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "813, Walmart, BROWNWOOD, TX",
            disabled: false,
          },
          {
            name: "8131, CVS, LINCOLN PARK, MI",
            disabled: false,
          },
          {
            name: "8132, CVS, BLOOMFIELD HILLS, MI",
            disabled: false,
          },
          {
            name: "8134, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8135, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "8136, CVS, BIRMINGHAM, MI",
            disabled: false,
          },
          {
            name: "8137, CVS, HAMTRAMCK, MI",
            disabled: false,
          },
          {
            name: "8139, CVS, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "814, CVS, DUMONT, NJ",
            disabled: false,
          },
          {
            name: "814, Kroger, Anderson, IN",
            disabled: false,
          },
          {
            name: "814, Kroger, Morgantown, WV",
            disabled: false,
          },
          {
            name: "814, Walmart, OKEECHOBEE, FL",
            disabled: false,
          },
          {
            name: "8140, CVS, NOVI, MI",
            disabled: false,
          },
          {
            name: "8141, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8143, CVS, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "8146, CVS, WARREN, MI",
            disabled: false,
          },
          {
            name: "8148, CVS, ALGONAC, MI",
            disabled: false,
          },
          {
            name: "8149, CVS, MARINE CITY, MI",
            disabled: false,
          },
          {
            name: "815, ADUSA, HOWELL, NJ",
            disabled: false,
          },
          {
            name: "815, ADUSA, WENDELL, NC",
            disabled: false,
          },
          {
            name: "815, CVS, POINT PLEASANT BEACH, NJ",
            disabled: false,
          },
          {
            name: "815, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "815, ShopRite, MASSAPEQUA, NY",
            disabled: false,
          },
          {
            name: "815, Target, SUNRISE, FL",
            disabled: false,
          },
          {
            name: "815, Walmart, OSAGE BEACH, MO",
            disabled: false,
          },
          {
            name: "8152, CVS, DEARBORN, MI",
            disabled: false,
          },
          {
            name: "8155, CVS, CLARKSTON, MI",
            disabled: false,
          },
          {
            name: "8157, CVS, REDFORD, MI",
            disabled: false,
          },
          {
            name: "8158, CVS, MACOMB, MI",
            disabled: false,
          },
          {
            name: "816, ADUSA, PHILLIPSBURG, NJ",
            disabled: false,
          },
          {
            name: "816, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "816, Albertsons, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "816, CVS, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "816, Kroger, Anderson, IN",
            disabled: false,
          },
          {
            name: "816, Kroger, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "816, ShopRite, RONKONKOMA, NY",
            disabled: false,
          },
          {
            name: "816, Target, STUART, FL",
            disabled: false,
          },
          {
            name: "816, Walmart, BROOKHAVEN, MS",
            disabled: false,
          },
          {
            name: "8160, CVS, BROWNSTOWN, MI",
            disabled: false,
          },
          {
            name: "8161, CVS, NOVI, MI",
            disabled: false,
          },
          {
            name: "8162, CVS, TROY, MI",
            disabled: false,
          },
          {
            name: "8163, CVS, NORTHVILLE, MI",
            disabled: false,
          },
          {
            name: "8165, CVS, YPSILANTI, MI",
            disabled: false,
          },
          {
            name: "8167, CVS, CANTON, MI",
            disabled: false,
          },
          {
            name: "817, ADUSA, HACKENSACK, NJ",
            disabled: false,
          },
          {
            name: "817, ADUSA, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "817, Albertsons, BEAR, DE",
            disabled: false,
          },
          {
            name: "817, CVS, PLAINSBORO, NJ",
            disabled: false,
          },
          {
            name: "817, Kroger, DUBLIN, OH",
            disabled: false,
          },
          {
            name: "817, Kroger, Danville, WV",
            disabled: false,
          },
          {
            name: "817, Kroger, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "817, Kroger, MADISON, WV",
            disabled: false,
          },
          {
            name: "817, Kroger, WILMINGTON, OH",
            disabled: false,
          },
          {
            name: "817, Target, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "817, Walmart, KISSIMMEE, FL",
            disabled: false,
          },
          {
            name: "8170, CVS, EASTPOINTE, MI",
            disabled: false,
          },
          {
            name: "8172, CVS, REDFORD, MI",
            disabled: false,
          },
          {
            name: "8173, CVS, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "8174, CVS, CLAWSON, MI",
            disabled: false,
          },
          {
            name: "8175, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8176, CVS, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "8178, CVS, FARMINGTON HILLS, MI",
            disabled: false,
          },
          {
            name: "8179, CVS, ROMEO, MI",
            disabled: false,
          },
          {
            name: "818, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "818, CVS, AMHERST, MA",
            disabled: false,
          },
          {
            name: "818, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "818, Target, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "818, Walmart, PANAMA CITY BEACH, FL",
            disabled: false,
          },
          {
            name: "8180, CVS, FERNDALE, MI",
            disabled: false,
          },
          {
            name: "8181, CVS, ALLEN PARK, MI",
            disabled: false,
          },
          {
            name: "8186, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8187, CVS, COMMERCE, MI",
            disabled: false,
          },
          {
            name: "819, ADUSA, LYNDHURST, NJ",
            disabled: false,
          },
          {
            name: "819, Albertsons, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "819, Kroger, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "819, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "819, Rite Aid, POTTSTOWN, PA",
            disabled: false,
          },
          {
            name: "819, ShopRite, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "819, Target, CLINTON TOWNSHIP, MI",
            disabled: false,
          },
          {
            name: "819, Walmart, CAPE CORAL, FL",
            disabled: false,
          },
          {
            name: "8190, CVS, CANTON, MI",
            disabled: false,
          },
          {
            name: "8191, CVS, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8196, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8198, CVS, MONROE, MI",
            disabled: false,
          },
          {
            name: "8199, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "82, ADUSA, HALIFAX, MA",
            disabled: false,
          },
          {
            name: "82, ADUSA, LATROBE, PA",
            disabled: false,
          },
          {
            name: "82, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "82, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "82, Kroger, GOLDEN, CO",
            disabled: false,
          },
          {
            name: "82, Kroger, VERNAL, UT",
            disabled: false,
          },
          {
            name: "82, Target, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "82, Walmart, PERRYVILLE, MO",
            disabled: false,
          },
          {
            name: "820, ADUSA, RIDGEWOOD, NJ",
            disabled: false,
          },
          {
            name: "820, ADUSA, ROMNEY, WV",
            disabled: false,
          },
          {
            name: "820, Albertsons, CENTREVILLE, MD",
            disabled: false,
          },
          {
            name: "820, CVS, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "820, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "820, Kroger, MOUNT VERNON, OH",
            disabled: false,
          },
          {
            name: "820, Kroger, REDMOND, WA",
            disabled: false,
          },
          {
            name: "820, Kroger, Springfield, OH",
            disabled: false,
          },
          {
            name: "820, Target, COON RAPIDS, MN",
            disabled: false,
          },
          {
            name: "820, Walmart, BOONVILLE, MO",
            disabled: false,
          },
          {
            name: "8200, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8204, CVS, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "8208, CVS, PLYMOUTH, MI",
            disabled: false,
          },
          {
            name: "821, Albertsons, WILDWOOD, NJ",
            disabled: false,
          },
          {
            name: "821, Kroger, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "821, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "821, Target, ALEXANDRIA, MN",
            disabled: false,
          },
          {
            name: "821, Walmart, CLOVIS, NM",
            disabled: false,
          },
          {
            name: "8211, CVS, WAYNE, MI",
            disabled: false,
          },
          {
            name: "8216, CVS, ANN ARBOR, MI",
            disabled: false,
          },
          {
            name: "822, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "822, ADUSA, ELIZABETH, NJ",
            disabled: false,
          },
          {
            name: "822, CVS, NEW MILFORD, CT",
            disabled: false,
          },
          {
            name: "822, Costco, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "822, Kroger, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "822, Kroger, Lafayette, IN",
            disabled: false,
          },
          {
            name: "822, Kroger, Washington Court Hou, OH",
            disabled: false,
          },
          {
            name: "822, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "822, Target, EL PASO, TX",
            disabled: false,
          },
          {
            name: "822, Walmart, AMARILLO, TX",
            disabled: false,
          },
          {
            name: "8221, CVS, DEARBORN HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8225, CVS, CANTON, MI",
            disabled: false,
          },
          {
            name: "8226, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "8227, CVS, SYLVAN LAKE, MI",
            disabled: false,
          },
          {
            name: "8229, CVS, WIXOM, MI",
            disabled: false,
          },
          {
            name: "823, Costco, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "823, Target, EL PASO, TX",
            disabled: false,
          },
          {
            name: "823, Walmart, PONCA CITY, OK",
            disabled: false,
          },
          {
            name: "8231, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8232, CVS, TRENTON, MI",
            disabled: false,
          },
          {
            name: "8233, CVS, SOUTHFIELD, MI",
            disabled: false,
          },
          {
            name: "8236, CVS, SAINT JOSEPH, MO",
            disabled: false,
          },
          {
            name: "8237, CVS, LEAWOOD, KS",
            disabled: false,
          },
          {
            name: "824, Albertsons, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "824, CVS, LAWRENCEVILLE, NJ",
            disabled: false,
          },
          {
            name: "824, Kroger, SAMMAMISH, WA",
            disabled: false,
          },
          {
            name: "824, Kroger, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "824, Kroger, URBANA, OH",
            disabled: false,
          },
          {
            name: "824, Kroger, West Lafayette, IN",
            disabled: false,
          },
          {
            name: "824, Target, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "824, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8240, CVS, COMMERCE, MI",
            disabled: false,
          },
          {
            name: "8241, CVS, HOLLY, MI",
            disabled: false,
          },
          {
            name: "8242, CVS, TROY, MI",
            disabled: false,
          },
          {
            name: "8244, CVS, NOVI, MI",
            disabled: false,
          },
          {
            name: "8245, CVS, FREEPORT, ME",
            disabled: false,
          },
          {
            name: "8248, CVS, MASSILLON, OH",
            disabled: false,
          },
          {
            name: "8249, CVS, PUTNAM, CT",
            disabled: false,
          },
          {
            name: "825, ADUSA, NEW BERN, NC",
            disabled: false,
          },
          {
            name: "825, ADUSA, WYCKOFF, NJ",
            disabled: false,
          },
          {
            name: "825, CVS, VENTNOR CITY, NJ",
            disabled: false,
          },
          {
            name: "825, Kroger, Kettering, OH",
            disabled: false,
          },
          {
            name: "825, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "825, Target, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "825, Walmart, STANFORD, KY",
            disabled: false,
          },
          {
            name: "826, ADUSA, WHITE SULPHUR SPRINGS, WV",
            disabled: false,
          },
          {
            name: "826, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "826, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "826, Kroger, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "826, Kroger, Kettering, OH",
            disabled: false,
          },
          {
            name: "826, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "826, Walmart, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "8260, CVS, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "8261, CVS, NEW BALTIMORE, MI",
            disabled: false,
          },
          {
            name: "8266, CVS, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "8267, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8268, CVS, JACKSON, MI",
            disabled: false,
          },
          {
            name: "8269, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "827, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "827, Costco, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "827, Kroger, CONNERSVILLE, IN",
            disabled: false,
          },
          {
            name: "827, Kroger, Lafayette, IN",
            disabled: false,
          },
          {
            name: "827, Kroger, NEWCASTLE, WA",
            disabled: false,
          },
          {
            name: "827, Target, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "827, Walmart, CANTON, TX",
            disabled: false,
          },
          {
            name: "8273, CVS, RIPLEY, MS",
            disabled: false,
          },
          {
            name: "8275, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8276, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8279, CVS, BROKEN ARROW, OK",
            disabled: false,
          },
          {
            name: "828, ADUSA, DUMONT, NJ",
            disabled: false,
          },
          {
            name: "828, Albertsons, HOCKESSIN, DE",
            disabled: false,
          },
          {
            name: "828, CVS, ASTON, PA",
            disabled: false,
          },
          {
            name: "828, Costco, AUBURN, WA",
            disabled: false,
          },
          {
            name: "828, Kroger, Athens, GA",
            disabled: false,
          },
          {
            name: "828, Kroger, EATON, OH",
            disabled: false,
          },
          {
            name: "828, Kroger, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "828, Target, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "828, Walgreens, RICHFIELD, MN",
            disabled: false,
          },
          {
            name: "828, Walmart, PLAINFIELD, IN",
            disabled: false,
          },
          {
            name: "8281, CVS, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "8282, CVS, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "8283, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "8285, CVS, MINNEAPOLIS, MN",
            disabled: false,
          },
          {
            name: "8287, CVS, MACOMB, MI",
            disabled: false,
          },
          {
            name: "8288, CVS, RUCKERSVILLE, VA",
            disabled: false,
          },
          {
            name: "829, ADUSA, FRANKLIN LAKES, NJ",
            disabled: false,
          },
          {
            name: "829, Kroger, NORTH BEND, WA",
            disabled: false,
          },
          {
            name: "829, Kroger, XENIA, OH",
            disabled: false,
          },
          {
            name: "829, Walgreens, RIVER GROVE, IL",
            disabled: false,
          },
          {
            name: "829, Walmart, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "8290, CVS, WYOMING, MI",
            disabled: false,
          },
          {
            name: "8291, CVS, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "8292, CVS, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "8293, CVS, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "8295, CVS, HOWELL, MI",
            disabled: false,
          },
          {
            name: "8299, CVS, WHITE LAKE, MI",
            disabled: false,
          },
          {
            name: "83, ADUSA, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "83, Kroger, CERRITOS, CA",
            disabled: false,
          },
          {
            name: "83, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "83, Kroger, Derby, KS",
            disabled: false,
          },
          {
            name: "83, Kroger, MURRAY, UT",
            disabled: false,
          },
          {
            name: "83, Kroger, North Vernon, IN",
            disabled: false,
          },
          {
            name: "83, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "83, Target, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "83, Walmart, MAGNOLIA, AR",
            disabled: false,
          },
          {
            name: "830, ADUSA, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "830, ADUSA, POINT PLEASANT, NJ",
            disabled: false,
          },
          {
            name: "830, CVS, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "830, Target, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "830, Walmart, ROCK FALLS, IL",
            disabled: false,
          },
          {
            name: "8300, CVS, STERLING HEIGHTS, MI",
            disabled: false,
          },
          {
            name: "8301, CVS, PORT HURON, MI",
            disabled: false,
          },
          {
            name: "8302, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "8306, CVS, WYOMING, MI",
            disabled: false,
          },
          {
            name: "8309, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "831, ADUSA, CARLSTADT, NJ",
            disabled: false,
          },
          {
            name: "831, Albertsons, SOMERS POINT, NJ",
            disabled: false,
          },
          {
            name: "831, CVS, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "831, Kroger, TACOMA, WA",
            disabled: false,
          },
          {
            name: "831, Kroger, Trimble, OH",
            disabled: false,
          },
          {
            name: "831, ShopRite, HAUPPAUGE, NY",
            disabled: false,
          },
          {
            name: "831, Target, SCOTTSBLUFF, NE",
            disabled: false,
          },
          {
            name: "831, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8310, CVS, MADISON, MS",
            disabled: false,
          },
          {
            name: "8311, CVS, FLOWOOD, MS",
            disabled: false,
          },
          {
            name: "8312, CVS, YUKON, OK",
            disabled: false,
          },
          {
            name: "8318, CVS, KELLER, TX",
            disabled: false,
          },
          {
            name: "832, Albertsons, HARLEM, MT",
            disabled: false,
          },
          {
            name: "832, Kroger, BELLEFONTAINE, OH",
            disabled: false,
          },
          {
            name: "832, Kroger, MUKILTEO, WA",
            disabled: false,
          },
          {
            name: "832, Kroger, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "832, Target, ROSWELL, NM",
            disabled: false,
          },
          {
            name: "8320, CVS, WYOMING, RI",
            disabled: false,
          },
          {
            name: "8321, CVS, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "8322, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "8323, CVS, GEORGETOWN, TX",
            disabled: false,
          },
          {
            name: "8325, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "833, Albertsons, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "833, CVS, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "833, Kroger, GREENVILLE, OH",
            disabled: false,
          },
          {
            name: "833, Rite Aid, CINNAMINSON, NJ",
            disabled: false,
          },
          {
            name: "833, Target, VERNON HILLS, IL",
            disabled: false,
          },
          {
            name: "833, Walmart, CARMI, IL",
            disabled: false,
          },
          {
            name: "8330, CVS, NORTH RICHLAND HILLS, TX",
            disabled: false,
          },
          {
            name: "8331, Walmart, YAPHANK, NY",
            disabled: false,
          },
          {
            name: "8335, CVS, SPRING, TX",
            disabled: false,
          },
          {
            name: "8336, CVS, LITTLE ELM, TX",
            disabled: false,
          },
          {
            name: "8337, CVS, ROCKWALL, TX",
            disabled: false,
          },
          {
            name: "834, ADUSA, ABERDEEN, NC",
            disabled: false,
          },
          {
            name: "834, ADUSA, BERKELEY HEIGHTS, NJ",
            disabled: false,
          },
          {
            name: "834, CVS, HICKORY HILLS, IL",
            disabled: false,
          },
          {
            name: "834, Target, ELGIN, IL",
            disabled: false,
          },
          {
            name: "834, Walmart, BETHANY, MO",
            disabled: false,
          },
          {
            name: "8340, CVS, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "8341, CVS, MANSFIELD, TX",
            disabled: false,
          },
          {
            name: "8342, CVS, DESOTO, TX",
            disabled: false,
          },
          {
            name: "8345, CVS, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "835, ADUSA, TENAFLY, NJ",
            disabled: false,
          },
          {
            name: "835, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "835, CVS, ELSA, TX",
            disabled: false,
          },
          {
            name: "835, Kroger, LYNNWOOD, WA",
            disabled: false,
          },
          {
            name: "835, Kroger, SPRINGFIELD, OH",
            disabled: false,
          },
          {
            name: "835, Target, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "835, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8351, CVS, BEAUMONT, TX",
            disabled: false,
          },
          {
            name: "8357, CVS, LAGO VISTA, TX",
            disabled: false,
          },
          {
            name: "836, Albertsons, FRISCO, CO",
            disabled: false,
          },
          {
            name: "836, CVS, RUNNEMEDE, NJ",
            disabled: false,
          },
          {
            name: "836, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "836, Kroger, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "836, Kroger, Warsaw, IN",
            disabled: false,
          },
          {
            name: "836, Rite Aid, BETHLEHEM, PA",
            disabled: false,
          },
          {
            name: "836, Target, GLENDALE HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "836, Walmart, SAINT MARYS, GA",
            disabled: false,
          },
          {
            name: "8362, CVS, MOBILE, AL",
            disabled: false,
          },
          {
            name: "8365, CVS, GILBERT, AZ",
            disabled: false,
          },
          {
            name: "8366, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "8367, CVS, LAKE WORTH, FL",
            disabled: false,
          },
          {
            name: "8369, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "837, ADUSA, EMPORIA, VA",
            disabled: false,
          },
          {
            name: "837, CVS, MARLTON, NJ",
            disabled: false,
          },
          {
            name: "837, Kroger, MAPLE VALLEY, WA",
            disabled: false,
          },
          {
            name: "837, Kroger, WARSAW, IN",
            disabled: false,
          },
          {
            name: "837, Rite Aid, HADDONFIELD, NJ",
            disabled: false,
          },
          {
            name: "837, Target, MELROSE PARK, IL",
            disabled: false,
          },
          {
            name: "837, Walmart, THAYER, MO",
            disabled: false,
          },
          {
            name: "8371, CVS, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "8372, CVS, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "8373, CVS, WEST PALM BEACH, FL",
            disabled: false,
          },
          {
            name: "8377, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "838, CVS, WESTFIELD, MA",
            disabled: false,
          },
          {
            name: "838, Kroger, Fairborn, OH",
            disabled: false,
          },
          {
            name: "838, Kroger, KIRKLAND, WA",
            disabled: false,
          },
          {
            name: "838, Target, WHEATON, IL",
            disabled: false,
          },
          {
            name: "838, Walmart, SAND SPRINGS, OK",
            disabled: false,
          },
          {
            name: "8380, CVS, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "8381, CVS, THE VILLAGES, FL",
            disabled: false,
          },
          {
            name: "8382, CVS, OCALA, FL",
            disabled: false,
          },
          {
            name: "8383, CVS, PALM COAST, FL",
            disabled: false,
          },
          {
            name: "8384, CVS, CEDAR PARK, TX",
            disabled: false,
          },
          {
            name: "8385, CVS, MEADOWS PLACE, TX",
            disabled: false,
          },
          {
            name: "8386, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "8387, CVS, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "8388, CVS, SEALY, TX",
            disabled: false,
          },
          {
            name: "8389, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "839, ADUSA, PORTSMOUTH, VA",
            disabled: false,
          },
          {
            name: "839, Albertsons, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "839, CVS, PLAINVILLE, CT",
            disabled: false,
          },
          {
            name: "839, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "839, Kroger, MERCER ISLAND, WA",
            disabled: false,
          },
          {
            name: "839, Rite Aid, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "839, Target, BATAVIA, IL",
            disabled: false,
          },
          {
            name: "839, Walmart, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "8392, CVS, KINGS PARK, NY",
            disabled: false,
          },
          {
            name: "8393, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "8394, CVS, ALLEN, TX",
            disabled: false,
          },
          {
            name: "8395, CVS, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "8396, CVS, WESLEY CHAPEL, FL",
            disabled: false,
          },
          {
            name: "8397, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "8398, CVS, BROWNSVILLE, TX",
            disabled: false,
          },
          {
            name: "8399, CVS, DETROIT, MI",
            disabled: false,
          },
          {
            name: "84, ADUSA, DU BOIS, PA",
            disabled: false,
          },
          {
            name: "84, BJ's, WATERFORD, CT",
            disabled: false,
          },
          {
            name: "84, CVS, SOUTHWICK, MA",
            disabled: false,
          },
          {
            name: "84, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "84, Kroger, AURORA, CO",
            disabled: false,
          },
          {
            name: "84, Kroger, CASTAIC, CA",
            disabled: false,
          },
          {
            name: "84, Kroger, NEWTON, KS",
            disabled: false,
          },
          {
            name: "84, Kroger, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "84, Kroger, Vincennes, IN",
            disabled: false,
          },
          {
            name: "840, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "840, CVS, HARTFORD, CT",
            disabled: false,
          },
          {
            name: "840, Kroger, Huntington, IN",
            disabled: false,
          },
          {
            name: "840, Kroger, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "840, Kroger, Sammamish, WA",
            disabled: false,
          },
          {
            name: "840, Target, NAPERVILLE, IL",
            disabled: false,
          },
          {
            name: "840, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "840, Walmart, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "841, ADUSA, CLOVER, SC",
            disabled: false,
          },
          {
            name: "841, Albertsons, AURORA, CO",
            disabled: false,
          },
          {
            name: "841, CVS, CONCORD, NH",
            disabled: false,
          },
          {
            name: "841, Kroger, HUNTINGTON, IN",
            disabled: false,
          },
          {
            name: "841, Kroger, SEQUIM, WA",
            disabled: false,
          },
          {
            name: "841, Rite Aid, BRIDGETON, NJ",
            disabled: false,
          },
          {
            name: "841, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "841, Walmart, TIPTON, IA",
            disabled: false,
          },
          {
            name: "8417, CVS, CARY, NC",
            disabled: false,
          },
          {
            name: "8418, CVS, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "8419, CVS, COVINGTON, GA",
            disabled: false,
          },
          {
            name: "842, ADUSA, YANCEYVILLE, NC",
            disabled: false,
          },
          {
            name: "842, Kroger, GROVE CITY, OH",
            disabled: false,
          },
          {
            name: "842, Kroger, LIGONIER, IN",
            disabled: false,
          },
          {
            name: "842, Target, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "842, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "842, Walmart, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "8424, CVS, GREENSBORO, GA",
            disabled: false,
          },
          {
            name: "8427, CVS, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "843, ADUSA, JERSEY CITY, NJ",
            disabled: false,
          },
          {
            name: "843, CVS, CHICOPEE, MA",
            disabled: false,
          },
          {
            name: "843, Kroger, Hinton, WV",
            disabled: false,
          },
          {
            name: "843, Kroger, Lafayette, IN",
            disabled: false,
          },
          {
            name: "843, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "843, Rite Aid, SOMERDALE, NJ",
            disabled: false,
          },
          {
            name: "843, Target, HODGKINS, IL",
            disabled: false,
          },
          {
            name: "843, Walmart, CAMILLA, GA",
            disabled: false,
          },
          {
            name: "8430, CVS, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "8431, CVS, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "8436, CVS, HIGHLAND, CA",
            disabled: false,
          },
          {
            name: "8437, CVS, WELLESLEY, MA",
            disabled: false,
          },
          {
            name: "844, CVS, WALPOLE, MA",
            disabled: false,
          },
          {
            name: "844, Kroger, CIRCLEVILLE, OH",
            disabled: false,
          },
          {
            name: "844, Kroger, Des Moines, WA",
            disabled: false,
          },
          {
            name: "844, Kroger, HURST, TX",
            disabled: false,
          },
          {
            name: "844, Target, TALLAHASSEE, FL",
            disabled: false,
          },
          {
            name: "844, Walmart, MORRIS, IL",
            disabled: false,
          },
          {
            name: "8440, CVS, CARROLLTON, TX",
            disabled: false,
          },
          {
            name: "8441, CVS, WINCHENDON, MA",
            disabled: false,
          },
          {
            name: "8442, CVS, WEBSTER, TX",
            disabled: false,
          },
          {
            name: "8443, CVS, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "8444, CVS, PLANO, TX",
            disabled: false,
          },
          {
            name: "8445, CVS, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "845, Albertsons, CAPE MAY, NJ",
            disabled: false,
          },
          {
            name: "845, CVS, BROOKLYN, NY",
            disabled: false,
          },
          {
            name: "845, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "845, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "845, Target, LAKE MARY, FL",
            disabled: false,
          },
          {
            name: "845, Walmart, BUFFALO, MO",
            disabled: false,
          },
          {
            name: "846, CVS, PORTSMOUTH, NH",
            disabled: false,
          },
          {
            name: "846, Kroger, West Allis, WI",
            disabled: false,
          },
          {
            name: "846, Walmart, LA GRANGE, TX",
            disabled: false,
          },
          {
            name: "847, Costco, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "847, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "847, Kroger, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "847, Kroger, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "847, Target, VIRGINIA, MN",
            disabled: false,
          },
          {
            name: "847, Walmart, DODGEVILLE, WI",
            disabled: false,
          },
          {
            name: "848, ADUSA, MEBANE, NC",
            disabled: false,
          },
          {
            name: "848, CVS, BELLPORT, NY",
            disabled: false,
          },
          {
            name: "848, Costco, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "848, Kroger, Anderson, IN",
            disabled: false,
          },
          {
            name: "848, Kroger, KNOXVILLE, TN",
            disabled: false,
          },
          {
            name: "848, Target, ABERDEEN, SD",
            disabled: false,
          },
          {
            name: "848, Walmart, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "849, ADUSA, SMITHFIELD, VA",
            disabled: false,
          },
          {
            name: "849, Albertsons, CHESTERTOWN, MD",
            disabled: false,
          },
          {
            name: "849, CVS, MONTVALE, NJ",
            disabled: false,
          },
          {
            name: "849, Kroger, HUNTSVILLE, AL",
            disabled: false,
          },
          {
            name: "849, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "849, Target, EL PASO, TX",
            disabled: false,
          },
          {
            name: "849, Walmart, SPRING, TX",
            disabled: false,
          },
          {
            name: "8491, CVS, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "8492, CVS, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "8495, CVS, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "8497, CVS, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "8498, CVS, AMBLER, PA",
            disabled: false,
          },
          {
            name: "85, ADUSA, FRANKLIN, PA",
            disabled: false,
          },
          {
            name: "85, ADUSA, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "85, CVS, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "85, HEB, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "85, Kroger, ARVADA, CO",
            disabled: false,
          },
          {
            name: "85, Kroger, Andover, KS",
            disabled: false,
          },
          {
            name: "85, Kroger, Bellflower, CA",
            disabled: false,
          },
          {
            name: "85, Kroger, MIDVALE, UT",
            disabled: false,
          },
          {
            name: "85, Target, MINOT, ND",
            disabled: false,
          },
          {
            name: "85, Walmart, BENTON, AR",
            disabled: false,
          },
          {
            name: "850, ADUSA, PENNINGTON, NJ",
            disabled: false,
          },
          {
            name: "850, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "850, Kroger, BOTHELL, WA",
            disabled: false,
          },
          {
            name: "850, Kroger, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "850, Kroger, Lincoln, IL",
            disabled: false,
          },
          {
            name: "850, Target, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "850, Walmart, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8500, CVS, ORLAND PARK, IL",
            disabled: false,
          },
          {
            name: "8502, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8505, CVS, WORTH, IL",
            disabled: false,
          },
          {
            name: "8508, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "851, ADUSA, TEANECK, NJ",
            disabled: false,
          },
          {
            name: "851, CVS, BRIDGE CITY, TX",
            disabled: false,
          },
          {
            name: "851, Kroger, ARLINGTON, TX",
            disabled: false,
          },
          {
            name: "851, Kroger, CANAL WINCHESTER, OH",
            disabled: false,
          },
          {
            name: "851, Kroger, EDMONDS, WA",
            disabled: false,
          },
          {
            name: "851, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "851, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "851, Walmart, RUIDOSO DOWNS, NM",
            disabled: false,
          },
          {
            name: "8512, CVS, PARK FOREST, IL",
            disabled: false,
          },
          {
            name: "8518, CVS, HIGHLAND, IN",
            disabled: false,
          },
          {
            name: "852, ADUSA, UNION, NJ",
            disabled: false,
          },
          {
            name: "852, Albertsons, MAYS LANDING, NJ",
            disabled: false,
          },
          {
            name: "852, CVS, EAST GREENWICH, RI",
            disabled: false,
          },
          {
            name: "852, Kroger, EVERETT, WA",
            disabled: false,
          },
          {
            name: "852, Kroger, LANSING, MI",
            disabled: false,
          },
          {
            name: "852, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "852, Target, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "852, Walmart, OTTAWA, IL",
            disabled: false,
          },
          {
            name: "8520, CVS, OXNARD, CA",
            disabled: false,
          },
          {
            name: "8523, CVS, RIALTO, CA",
            disabled: false,
          },
          {
            name: "8524, CVS, ROSCOE, IL",
            disabled: false,
          },
          {
            name: "8525, CVS, APPLETON, WI",
            disabled: false,
          },
          {
            name: "8526, CVS, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "8528, CVS, MACHESNEY PARK, IL",
            disabled: false,
          },
          {
            name: "8529, CVS, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "853, ADUSA, BAYONNE, NJ",
            disabled: false,
          },
          {
            name: "853, Kroger, BROOKFIELD, WI",
            disabled: false,
          },
          {
            name: "853, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "853, Kroger, EVERETT, WA",
            disabled: false,
          },
          {
            name: "853, Target, LODI, CA",
            disabled: false,
          },
          {
            name: "853, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "8530, CVS, LOVES PARK, IL",
            disabled: false,
          },
          {
            name: "8531, CVS, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "8532, CVS, CEDAR RAPIDS, IA",
            disabled: false,
          },
          {
            name: "8533, CVS, FREEPORT, IL",
            disabled: false,
          },
          {
            name: "8534, CVS, BELOIT, WI",
            disabled: false,
          },
          {
            name: "8538, CVS, CEDAR FALLS, IA",
            disabled: false,
          },
          {
            name: "854, CVS, NORWALK, CT",
            disabled: false,
          },
          {
            name: "854, Kroger, DECATUR, AL",
            disabled: false,
          },
          {
            name: "854, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "854, Walgreens, GREEN PARK, MO",
            disabled: false,
          },
          {
            name: "854, Walmart, FRANKFORT, IN",
            disabled: false,
          },
          {
            name: "8540, CVS, FREEPORT, IL",
            disabled: false,
          },
          {
            name: "8541, CVS, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "8542, CVS, GREEN BAY, WI",
            disabled: false,
          },
          {
            name: "8544, CVS, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "8545, CVS, MANITOWOC, WI",
            disabled: false,
          },
          {
            name: "8546, CVS, WATERLOO, IA",
            disabled: false,
          },
          {
            name: "8547, CVS, IOWA CITY, IA",
            disabled: false,
          },
          {
            name: "8549, CVS, MENOMINEE, MI",
            disabled: false,
          },
          {
            name: "855, ADUSA, WHITING, NJ",
            disabled: false,
          },
          {
            name: "855, CVS, GLASSBORO, NJ",
            disabled: false,
          },
          {
            name: "855, Target, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "855, Walmart, UNION CITY, GA",
            disabled: false,
          },
          {
            name: "8551, CVS, JANESVILLE, WI",
            disabled: false,
          },
          {
            name: "8554, CVS, GLADSTONE, MO",
            disabled: false,
          },
          {
            name: "8555, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8556, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8557, CVS, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "856, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "856, Kroger, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "856, Kroger, FOSTORIA, OH",
            disabled: false,
          },
          {
            name: "856, Kroger, MILL CREEK, WA",
            disabled: false,
          },
          {
            name: "856, Kroger, Mount Pleasant, WI",
            disabled: false,
          },
          {
            name: "856, Rite Aid, PROSPECT PARK, PA",
            disabled: false,
          },
          {
            name: "856, Target, NORFOLK, NE",
            disabled: false,
          },
          {
            name: "856, Walmart, BREMEN, GA",
            disabled: false,
          },
          {
            name: "8563, CVS, HARRISONVILLE, MO",
            disabled: false,
          },
          {
            name: "8564, CVS, INDEPENDENCE, MO",
            disabled: false,
          },
          {
            name: "8565, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8566, CVS, RAYTOWN, MO",
            disabled: false,
          },
          {
            name: "8567, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "857, ADUSA, WESTFIELD, NJ",
            disabled: false,
          },
          {
            name: "857, CVS, EAST HAVEN, CT",
            disabled: false,
          },
          {
            name: "857, Kroger, DELAWARE, OH",
            disabled: false,
          },
          {
            name: "857, Kroger, MOUNTLAKE TERRACE, WA",
            disabled: false,
          },
          {
            name: "857, Kroger, NEW HAVEN, IN",
            disabled: false,
          },
          {
            name: "857, Kroger, Saint Francis, WI",
            disabled: false,
          },
          {
            name: "857, Rite Aid, ARDMORE, PA",
            disabled: false,
          },
          {
            name: "857, Target, KEARNEY, NE",
            disabled: false,
          },
          {
            name: "857, Walmart, SANFORD, FL",
            disabled: false,
          },
          {
            name: "8570, CVS, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "8571, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8573, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8576, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8577, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8578, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8579, CVS, LEES SUMMIT, MO",
            disabled: false,
          },
          {
            name: "858, CVS, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "858, Kroger, SANDUSKY, OH",
            disabled: false,
          },
          {
            name: "858, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "858, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "858, Walmart, CAIRO, GA",
            disabled: false,
          },
          {
            name: "8580, CVS, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "8581, CVS, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "8582, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8584, CVS, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "8585, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8586, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8588, CVS, LEAWOOD, KS",
            disabled: false,
          },
          {
            name: "8589, CVS, FONTANA, CA",
            disabled: false,
          },
          {
            name: "859, ADUSA, EDISON, NJ",
            disabled: false,
          },
          {
            name: "859, Albertsons, CAPE MAY COURT HOUSE, NJ",
            disabled: false,
          },
          {
            name: "859, CVS, AGAWAM, MA",
            disabled: false,
          },
          {
            name: "859, Kroger, Bellevue, WA",
            disabled: false,
          },
          {
            name: "859, Target, WATERTOWN, SD",
            disabled: false,
          },
          {
            name: "859, Walmart, LAKE WALES, FL",
            disabled: false,
          },
          {
            name: "8590, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "8595, CVS, RAYMORE, MO",
            disabled: false,
          },
          {
            name: "8596, CVS, KEARNEY, MO",
            disabled: false,
          },
          {
            name: "8598, CVS, RAYTOWN, MO",
            disabled: false,
          },
          {
            name: "86, ADUSA, OIL CITY, PA",
            disabled: false,
          },
          {
            name: "86, Albertsons, OAK LAWN, IL",
            disabled: false,
          },
          {
            name: "86, CVS, CASA GRANDE, AZ",
            disabled: false,
          },
          {
            name: "86, HEB, PORT ARTHUR, TX",
            disabled: false,
          },
          {
            name: "86, Kroger, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "86, Kroger, CULVER CITY, CA",
            disabled: false,
          },
          {
            name: "86, Kroger, EVANSTON, WY",
            disabled: false,
          },
          {
            name: "86, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "86, Kroger, SUN CITY WEST, AZ",
            disabled: false,
          },
          {
            name: "86, Kroger, Salem, IN",
            disabled: false,
          },
          {
            name: "86, Target, DUBUQUE, IA",
            disabled: false,
          },
          {
            name: "86, Walmart, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "860, ADUSA, HASKELL, NJ",
            disabled: false,
          },
          {
            name: "860, Kroger, REDMOND, WA",
            disabled: false,
          },
          {
            name: "860, Target, WEST BURLINGTON, IA",
            disabled: false,
          },
          {
            name: "860, Walmart, DELAND, FL",
            disabled: false,
          },
          {
            name: "8600, CVS, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "8601, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8602, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8603, CVS, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "8605, CVS, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "8606, CVS, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "8607, CVS, GRANDVIEW, MO",
            disabled: false,
          },
          {
            name: "8608, CVS, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "8609, CVS, KANSAS CITY, MO",
            disabled: false,
          },
          {
            name: "861, ADUSA, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "861, CVS, BROCKTON, MA",
            disabled: false,
          },
          {
            name: "861, Kroger, GROVEPORT, OH",
            disabled: false,
          },
          {
            name: "861, Target, BUFFALO, MN",
            disabled: false,
          },
          {
            name: "861, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "8610, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "8611, CVS, MINOT, ND",
            disabled: false,
          },
          {
            name: "8612, CVS, FARGO, ND",
            disabled: false,
          },
          {
            name: "8613, CVS, FARGO, ND",
            disabled: false,
          },
          {
            name: "8614, CVS, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "8615, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "8616, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "8617, CVS, HELENA, MT",
            disabled: false,
          },
          {
            name: "8618, CVS, ANACONDA, MT",
            disabled: false,
          },
          {
            name: "862, Albertsons, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "862, CVS, MARLBORO, NJ",
            disabled: false,
          },
          {
            name: "862, Kroger, ALCOA, TN",
            disabled: false,
          },
          {
            name: "862, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "862, Kroger, Oak Creek, WI",
            disabled: false,
          },
          {
            name: "862, Target, CHANHASSEN, MN",
            disabled: false,
          },
          {
            name: "862, Walmart, HINESVILLE, GA",
            disabled: false,
          },
          {
            name: "8620, CVS, GRAND FORKS, ND",
            disabled: false,
          },
          {
            name: "8621, CVS, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "8622, CVS, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "8623, CVS, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "8624, CVS, GREAT FALLS, MT",
            disabled: false,
          },
          {
            name: "8626, CVS, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "8627, CVS, BUTTE, MT",
            disabled: false,
          },
          {
            name: "8628, CVS, BISMARCK, ND",
            disabled: false,
          },
          {
            name: "863, CVS, GILFORD, NH",
            disabled: false,
          },
          {
            name: "863, Kroger, ENUMCLAW, WA",
            disabled: false,
          },
          {
            name: "863, Kroger, Peoria, IL",
            disabled: false,
          },
          {
            name: "863, Target, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "863, Walmart, ROANOKE, AL",
            disabled: false,
          },
          {
            name: "8631, CVS, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "8632, CVS, DECATUR, IL",
            disabled: false,
          },
          {
            name: "8633, CVS, BETTENDORF, IA",
            disabled: false,
          },
          {
            name: "8634, CVS, MILAN, IL",
            disabled: false,
          },
          {
            name: "8635, CVS, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "8636, CVS, QUINCY, IL",
            disabled: false,
          },
          {
            name: "8638, CVS, CHARLESTON, IL",
            disabled: false,
          },
          {
            name: "8639, CVS, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "864, ADUSA, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "864, CVS, GLOUCESTER CITY, NJ",
            disabled: false,
          },
          {
            name: "864, Kroger, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "864, Kroger, Gig Harbor, WA",
            disabled: false,
          },
          {
            name: "864, Kroger, LAMBERTVILLE, MI",
            disabled: false,
          },
          {
            name: "864, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "864, Target, DELAFIELD, WI",
            disabled: false,
          },
          {
            name: "864, Walmart, VIDALIA, GA",
            disabled: false,
          },
          {
            name: "8640, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8642, CVS, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "8643, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8645, CVS, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "8646, CVS, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "8648, CVS, DECATUR, IL",
            disabled: false,
          },
          {
            name: "8649, CVS, FISHERS, IN",
            disabled: false,
          },
          {
            name: "865, CVS, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "865, Target, GURNEE, IL",
            disabled: false,
          },
          {
            name: "865, Walmart, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "8650, CVS, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "8651, CVS, WEST LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "8655, CVS, PERU, IL",
            disabled: false,
          },
          {
            name: "8656, CVS, ROCK ISLAND, IL",
            disabled: false,
          },
          {
            name: "8657, CVS, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "8658, CVS, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "8659, CVS, DAVENPORT, IA",
            disabled: false,
          },
          {
            name: "866, ADUSA, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "866, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "866, CVS, MIAMI, FL",
            disabled: false,
          },
          {
            name: "866, Kroger, HERMITAGE, TN",
            disabled: false,
          },
          {
            name: "866, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "866, Target, WOODRIDGE, IL",
            disabled: false,
          },
          {
            name: "866, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "8661, CVS, MATTOON, IL",
            disabled: false,
          },
          {
            name: "8663, CVS, STERLING, IL",
            disabled: false,
          },
          {
            name: "8665, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "8667, CVS, URBANA, IL",
            disabled: false,
          },
          {
            name: "867, ADUSA, HIGHLAND PARK, NJ",
            disabled: false,
          },
          {
            name: "867, Kroger, Brown Deer, WI",
            disabled: false,
          },
          {
            name: "867, Kroger, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "867, Target, BOLINGBROOK, IL",
            disabled: false,
          },
          {
            name: "867, Walmart, SCOTTSBLUFF, NE",
            disabled: false,
          },
          {
            name: "8671, CVS, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "8674, CVS, CARMEL, IN",
            disabled: false,
          },
          {
            name: "8675, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8678, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8679, CVS, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "868, Kroger, LAWRENCEBURG, TN",
            disabled: false,
          },
          {
            name: "868, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "868, Rite Aid, SALAMANCA, NY",
            disabled: false,
          },
          {
            name: "868, Target, CRESTWOOD, IL",
            disabled: false,
          },
          {
            name: "868, Walmart, CARLSBAD, NM",
            disabled: false,
          },
          {
            name: "8680, CVS, LAFAYETTE, IN",
            disabled: false,
          },
          {
            name: "8683, CVS, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "8684, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8685, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "869, Kroger, FISHERS, IN",
            disabled: false,
          },
          {
            name: "869, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "869, Walmart, ALAMOSA, CO",
            disabled: false,
          },
          {
            name: "8690, CVS, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "8691, CVS, KEWANEE, IL",
            disabled: false,
          },
          {
            name: "8692, CVS, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "8693, CVS, ADDISON, IL",
            disabled: false,
          },
          {
            name: "87, ADUSA, MASHPEE, MA",
            disabled: false,
          },
          {
            name: "87, Kroger, Conifer, CO",
            disabled: false,
          },
          {
            name: "87, Kroger, LOGAN, UT",
            disabled: false,
          },
          {
            name: "87, Kroger, Laveen, AZ",
            disabled: false,
          },
          {
            name: "87, Kroger, SAN PEDRO, CA",
            disabled: false,
          },
          {
            name: "87, Kroger, Sellersburg, IN",
            disabled: false,
          },
          {
            name: "87, Kroger, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "87, Walmart, MINDEN, LA",
            disabled: false,
          },
          {
            name: "870, ADUSA, AMELIA COURT HOUSE, VA",
            disabled: false,
          },
          {
            name: "870, Albertsons, SILVER SPRING, MD",
            disabled: false,
          },
          {
            name: "870, Kroger, ADDISON, TX",
            disabled: false,
          },
          {
            name: "870, Kroger, Knoxville, TN",
            disabled: false,
          },
          {
            name: "870, Kroger, PORT HADLOCK, WA",
            disabled: false,
          },
          {
            name: "870, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "870, Target, MERRILLVILLE, IN",
            disabled: false,
          },
          {
            name: "870, Walmart, JASPER, IN",
            disabled: false,
          },
          {
            name: "871, Albertsons, NEWARK, DE",
            disabled: false,
          },
          {
            name: "871, Kroger, GAHANNA, OH",
            disabled: false,
          },
          {
            name: "871, Kroger, Kenosha, WI",
            disabled: false,
          },
          {
            name: "871, Kroger, RENTON, WA",
            disabled: false,
          },
          {
            name: "871, Target, PEORIA, IL",
            disabled: false,
          },
          {
            name: "871, Walmart, MOUNTAIN VIEW, MO",
            disabled: false,
          },
          {
            name: "872, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "872, Kroger, SEATTLE, WA",
            disabled: false,
          },
          {
            name: "872, Target, LIVONIA, MI",
            disabled: false,
          },
          {
            name: "872, Walmart, PEARLAND, TX",
            disabled: false,
          },
          {
            name: "873, ADUSA, JACKSON, NJ",
            disabled: false,
          },
          {
            name: "873, Kroger, CUDAHY, WI",
            disabled: false,
          },
          {
            name: "873, Kroger, POWDERLY, KY",
            disabled: false,
          },
          {
            name: "873, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "873, Kroger, Studio City, CA",
            disabled: false,
          },
          {
            name: "873, Rite Aid, POTTSVILLE, PA",
            disabled: false,
          },
          {
            name: "873, Target, OCALA, FL",
            disabled: false,
          },
          {
            name: "873, Walmart, TAOS, NM",
            disabled: false,
          },
          {
            name: "8734, CVS, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "8735, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8738, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8739, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "874, ADUSA, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "874, Albertsons, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "874, Kroger, BELLEVUE, WA",
            disabled: false,
          },
          {
            name: "874, Kroger, COLUMBIA CITY, IN",
            disabled: false,
          },
          {
            name: "874, Kroger, Kenosha, WI",
            disabled: false,
          },
          {
            name: "874, Target, ORANGE CITY, FL",
            disabled: false,
          },
          {
            name: "874, Walmart, NATCHEZ, MS",
            disabled: false,
          },
          {
            name: "8740, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8742, CVS, CICERO, IL",
            disabled: false,
          },
          {
            name: "8744, CVS, BROOKFIELD, IL",
            disabled: false,
          },
          {
            name: "8745, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8746, CVS, AURORA, IL",
            disabled: false,
          },
          {
            name: "8747, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8749, CVS, LINCOLNWOOD, IL",
            disabled: false,
          },
          {
            name: "875, Kroger, WABASH, IN",
            disabled: false,
          },
          {
            name: "875, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "875, Walmart, RIDGELAND, MS",
            disabled: false,
          },
          {
            name: "8750, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8753, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8757, CVS, SKOKIE, IL",
            disabled: false,
          },
          {
            name: "876, Albertsons, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "876, Kroger, GLENDALE, WI",
            disabled: false,
          },
          {
            name: "876, Target, GRAPEVINE, TX",
            disabled: false,
          },
          {
            name: "876, Walmart, MANY, LA",
            disabled: false,
          },
          {
            name: "8760, CVS, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "8761, CVS, WAUKEGAN, IL",
            disabled: false,
          },
          {
            name: "8763, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "8764, CVS, PEWAUKEE, WI",
            disabled: false,
          },
          {
            name: "8765, CVS, WEST ALLIS, WI",
            disabled: false,
          },
          {
            name: "8767, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "8768, CVS, WHITEFISH BAY, WI",
            disabled: false,
          },
          {
            name: "8769, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "877, ADUSA, BASKING RIDGE, NJ",
            disabled: false,
          },
          {
            name: "877, Kroger, South Milwaukee, WI",
            disabled: false,
          },
          {
            name: "877, Kroger, Sun Valley, CA",
            disabled: false,
          },
          {
            name: "877, Target, HOLLYWOOD, FL",
            disabled: false,
          },
          {
            name: "877, Walmart, MONROE, NC",
            disabled: false,
          },
          {
            name: "8771, CVS, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "8772, CVS, CUDAHY, WI",
            disabled: false,
          },
          {
            name: "8773, CVS, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "8774, CVS, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "8775, CVS, CEDARBURG, WI",
            disabled: false,
          },
          {
            name: "8776, CVS, RACINE, WI",
            disabled: false,
          },
          {
            name: "8777, CVS, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "8779, CVS, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "878, Albertsons, ALEXANDRIA, VA",
            disabled: false,
          },
          {
            name: "878, Kroger, BOWLING GREEN, OH",
            disabled: false,
          },
          {
            name: "878, Kroger, Charleston, WV",
            disabled: false,
          },
          {
            name: "878, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "878, Kroger, Orange, CA",
            disabled: false,
          },
          {
            name: "878, Kroger, REDMOND, WA",
            disabled: false,
          },
          {
            name: "878, Target, FORT DODGE, IA",
            disabled: false,
          },
          {
            name: "878, Walmart, CUMMING, GA",
            disabled: false,
          },
          {
            name: "8780, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8782, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8784, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8787, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "8788, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8789, CVS, PAHRUMP, NV",
            disabled: false,
          },
          {
            name: "879, ADUSA, DELMAR, DE",
            disabled: false,
          },
          {
            name: "879, Albertsons, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "879, Kroger, GOSHEN, IN",
            disabled: false,
          },
          {
            name: "879, Kroger, Lake Forest, CA",
            disabled: false,
          },
          {
            name: "879, Kroger, Milwaukee, WI",
            disabled: false,
          },
          {
            name: "879, Kroger, STANWOOD, WA",
            disabled: false,
          },
          {
            name: "879, Kroger, THE COLONY, TX",
            disabled: false,
          },
          {
            name: "879, Kroger, WORTHINGTON, OH",
            disabled: false,
          },
          {
            name: "879, Target, LINCOLN, NE",
            disabled: false,
          },
          {
            name: "879, Walmart, LAFAYETTE, TN",
            disabled: false,
          },
          {
            name: "8790, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8791, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8792, CVS, SPARKS, NV",
            disabled: false,
          },
          {
            name: "8793, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "8794, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8795, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "8798, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "88, ADUSA, BEDFORD, MA",
            disabled: false,
          },
          {
            name: "88, ADUSA, TITUSVILLE, PA",
            disabled: false,
          },
          {
            name: "88, CVS, WILMINGTON, DE",
            disabled: false,
          },
          {
            name: "88, Costco, POMPANO BEACH, FL",
            disabled: false,
          },
          {
            name: "88, Kroger, PARKER, CO",
            disabled: false,
          },
          {
            name: "88, Kroger, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "88, Kroger, TOPEKA, KS",
            disabled: false,
          },
          {
            name: "88, Kroger, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "88, Walmart, MOUNTAIN GROVE, MO",
            disabled: false,
          },
          {
            name: "880, Kroger, GLENDALE, WI",
            disabled: false,
          },
          {
            name: "880, Kroger, MARION, OH",
            disabled: false,
          },
          {
            name: "880, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "880, Target, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "880, Walmart, IRVING, TX",
            disabled: false,
          },
          {
            name: "8800, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8801, CVS, ELKO, NV",
            disabled: false,
          },
          {
            name: "8804, CVS, NORTH LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8805, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8807, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8809, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "881, Albertsons, NORTHGLENN, CO",
            disabled: false,
          },
          {
            name: "881, Kroger, Columbus, OH",
            disabled: false,
          },
          {
            name: "881, Kroger, NEW BERLIN, WI",
            disabled: false,
          },
          {
            name: "881, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "881, Target, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "881, Walmart, LEXINGTON, SC",
            disabled: false,
          },
          {
            name: "8811, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8813, CVS, BOULDER CITY, NV",
            disabled: false,
          },
          {
            name: "8814, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8816, CVS, CORONA, CA",
            disabled: false,
          },
          {
            name: "8818, CVS, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "8819, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "882, Albertsons, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "882, Kroger, MILWAUKEE, WI",
            disabled: false,
          },
          {
            name: "882, Target, LAKE JACKSON, TX",
            disabled: false,
          },
          {
            name: "882, Walmart, PRAIRIE DU CHIEN, WI",
            disabled: false,
          },
          {
            name: "8820, CVS, NEWBURY PARK, CA",
            disabled: false,
          },
          {
            name: "8821, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8822, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "8825, CVS, GRAND TERRACE, CA",
            disabled: false,
          },
          {
            name: "8826, CVS, BULLHEAD CITY, AZ",
            disabled: false,
          },
          {
            name: "8827, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "8828, CVS, SIERRA VISTA, AZ",
            disabled: false,
          },
          {
            name: "8829, CVS, VENICE, CA",
            disabled: false,
          },
          {
            name: "883, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "883, Target, PASADENA, CA",
            disabled: false,
          },
          {
            name: "8833, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "8834, CVS, FOOTHILL RANCH, CA",
            disabled: false,
          },
          {
            name: "8835, CVS, SOUTH GATE, CA",
            disabled: false,
          },
          {
            name: "8836, CVS, VISTA, CA",
            disabled: false,
          },
          {
            name: "8838, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "884, ADUSA, PITTSBORO, NC",
            disabled: false,
          },
          {
            name: "884, Kroger, LANSING, MI",
            disabled: false,
          },
          {
            name: "884, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "884, Target, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "884, Walmart, SHELBYVILLE, IN",
            disabled: false,
          },
          {
            name: "8844, CVS, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "8846, CVS, TRABUCO CANYON, CA",
            disabled: false,
          },
          {
            name: "885, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "885, ADUSA, RINGWOOD, NJ",
            disabled: false,
          },
          {
            name: "885, Albertsons, DENVER, CO",
            disabled: false,
          },
          {
            name: "885, Kroger, WAUWATOSA, WI",
            disabled: false,
          },
          {
            name: "885, Target, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "885, Walmart, SEWARD, NE",
            disabled: false,
          },
          {
            name: "8850, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "8852, CVS, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "886, ADUSA, SHELBYVILLE, TN",
            disabled: false,
          },
          {
            name: "886, Kroger, ELKHART, IN",
            disabled: false,
          },
          {
            name: "886, Kroger, Grafton, WI",
            disabled: false,
          },
          {
            name: "886, Walmart, FORT DODGE, IA",
            disabled: false,
          },
          {
            name: "8861, CVS, BUENA PARK, CA",
            disabled: false,
          },
          {
            name: "8861, Walmart, SANTA ROSA BEACH, FL",
            disabled: false,
          },
          {
            name: "8862, CVS, GARDEN GROVE, CA",
            disabled: false,
          },
          {
            name: "8863, CVS, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "8864, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "8865, CVS, NORWALK, CA",
            disabled: false,
          },
          {
            name: "8866, CVS, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "8868, CVS, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "8869, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "887, Kroger, GREENFIELD, WI",
            disabled: false,
          },
          {
            name: "887, Kroger, HOLT, MI",
            disabled: false,
          },
          {
            name: "887, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "887, Kroger, Sun Valley, CA",
            disabled: false,
          },
          {
            name: "887, Target, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "887, Walmart, PETAL, MS",
            disabled: false,
          },
          {
            name: "8874, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "8876, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "8877, CVS, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "8878, CVS, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "8879, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "888, Kroger, LANSING, MI",
            disabled: false,
          },
          {
            name: "888, Kroger, Memphis, TN",
            disabled: false,
          },
          {
            name: "888, Kroger, Orange, CA",
            disabled: false,
          },
          {
            name: "888, Kroger, Taylorville, IL",
            disabled: false,
          },
          {
            name: "888, Kroger, Watertown, WI",
            disabled: false,
          },
          {
            name: "888, Target, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "888, Walmart, BUTLER, MO",
            disabled: false,
          },
          {
            name: "8880, CVS, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "8881, CVS, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "8882, CVS, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "8883, CVS, SANTA ANA, CA",
            disabled: false,
          },
          {
            name: "8884, CVS, LAKE FOREST, CA",
            disabled: false,
          },
          {
            name: "8885, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "8886, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "889, ADUSA, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "889, Kroger, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "889, Kroger, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "889, Kroger, Mount Pleasant, MI",
            disabled: false,
          },
          {
            name: "889, Kroger, Snoqualmie, WA",
            disabled: false,
          },
          {
            name: "889, Walmart, THOMASVILLE, GA",
            disabled: false,
          },
          {
            name: "8890, CVS, TUSTIN, CA",
            disabled: false,
          },
          {
            name: "8891, CVS, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "8893, CVS, SAN CLEMENTE, CA",
            disabled: false,
          },
          {
            name: "8894, CVS, REDLANDS, CA",
            disabled: false,
          },
          {
            name: "8895, CVS, POMONA, CA",
            disabled: false,
          },
          {
            name: "8896, CVS, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "89, ADUSA, ALLSTON, MA",
            disabled: false,
          },
          {
            name: "89, ADUSA, LENOIR, NC",
            disabled: false,
          },
          {
            name: "89, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "89, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "89, Costco, MIAMI, FL",
            disabled: false,
          },
          {
            name: "89, Kroger, AVONDALE, AZ",
            disabled: false,
          },
          {
            name: "89, Kroger, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "89, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "89, Walgreens, BRIDGEVIEW, IL",
            disabled: false,
          },
          {
            name: "89, Walmart, CAMDENTON, MO",
            disabled: false,
          },
          {
            name: "890, Albertsons, CAPE MAY COURT HOUSE, NJ",
            disabled: false,
          },
          {
            name: "890, Kroger, EAST LANSING, MI",
            disabled: false,
          },
          {
            name: "890, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "890, Kroger, Mequon, WI",
            disabled: false,
          },
          {
            name: "890, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "8902, CVS, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "8903, CVS, SUNNY ISLES BEACH, FL",
            disabled: false,
          },
          {
            name: "8904, CVS, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "8905, CVS, FRANKLIN, KY",
            disabled: false,
          },
          {
            name: "8906, CVS, MALDEN, MA",
            disabled: false,
          },
          {
            name: "8907, CVS, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "891, Kroger, MOUNT PLEASANT, WI",
            disabled: false,
          },
          {
            name: "891, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "891, Kroger, ZANESVILLE, OH",
            disabled: false,
          },
          {
            name: "891, Target, GALESBURG, IL",
            disabled: false,
          },
          {
            name: "891, Walmart, STERLING, IL",
            disabled: false,
          },
          {
            name: "8911, CVS, HOLLY SPRINGS, NC",
            disabled: false,
          },
          {
            name: "8912, CVS, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "8913, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "8915, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8917, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8918, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8919, CVS, KANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "892, Albertsons, THORNTON, CO",
            disabled: false,
          },
          {
            name: "892, Kroger, MCMINNVILLE, TN",
            disabled: false,
          },
          {
            name: "892, Kroger, MENOMONEE FALLS, WI",
            disabled: false,
          },
          {
            name: "892, Walmart, ANKENY, IA",
            disabled: false,
          },
          {
            name: "8921, CVS, TERRYTOWN, LA",
            disabled: false,
          },
          {
            name: "8922, CVS, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "8923, CVS, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "8924, CVS, EDGEWATER, NJ",
            disabled: false,
          },
          {
            name: "8925, CVS, BEE CAVE, TX",
            disabled: false,
          },
          {
            name: "8926, CVS, ANTIOCH, IL",
            disabled: false,
          },
          {
            name: "8927, CVS, NAPLES, FL",
            disabled: false,
          },
          {
            name: "8928, CVS, LELAND, NC",
            disabled: false,
          },
          {
            name: "893, ADUSA, FAYETTEVILLE, NC",
            disabled: false,
          },
          {
            name: "893, ADUSA, MORRIS PLAINS, NJ",
            disabled: false,
          },
          {
            name: "893, Albertsons, FOLSOM, PA",
            disabled: false,
          },
          {
            name: "893, Costco, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "893, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "893, Kroger, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "893, Kroger, MESQUITE, TX",
            disabled: false,
          },
          {
            name: "893, Kroger, Shorewood, WI",
            disabled: false,
          },
          {
            name: "893, Target, WOOD DALE, IL",
            disabled: false,
          },
          {
            name: "893, Walmart, LINDSAY, OK",
            disabled: false,
          },
          {
            name: "8930, CVS, ANOKA, MN",
            disabled: false,
          },
          {
            name: "8930, Walmart, DALLAS, TX",
            disabled: false,
          },
          {
            name: "8931, CVS, LACONIA, NH",
            disabled: false,
          },
          {
            name: "8932, CVS, TWINSBURG, OH",
            disabled: false,
          },
          {
            name: "8933, CVS, AUBURN, AL",
            disabled: false,
          },
          {
            name: "8934, CVS, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "8935, CVS, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "8936, CVS, MURRELLS INLET, SC",
            disabled: false,
          },
          {
            name: "8937, CVS, EUSTIS, FL",
            disabled: false,
          },
          {
            name: "8938, CVS, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "8939, CVS, LAKEWOOD, NJ",
            disabled: false,
          },
          {
            name: "894, ADUSA, BURLINGTON, NC",
            disabled: false,
          },
          {
            name: "894, Kroger, HARTSELLE, AL",
            disabled: false,
          },
          {
            name: "894, Kroger, Indianapolis, IN",
            disabled: false,
          },
          {
            name: "894, Kroger, Kirkland, WA",
            disabled: false,
          },
          {
            name: "894, Target, JOLIET, IL",
            disabled: false,
          },
          {
            name: "894, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "8943, CVS, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "8944, CVS, BILLINGS, MT",
            disabled: false,
          },
          {
            name: "8945, CVS, KINGSTON, NY",
            disabled: false,
          },
          {
            name: "8946, CVS, LONG GROVE, IL",
            disabled: false,
          },
          {
            name: "8947, CVS, WAUKESHA, WI",
            disabled: false,
          },
          {
            name: "8948, CVS, BLOOMINGDALE, IL",
            disabled: false,
          },
          {
            name: "8949, CVS, OAK FOREST, IL",
            disabled: false,
          },
          {
            name: "895, Costco, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "895, Kroger, FISHERS, IN",
            disabled: false,
          },
          {
            name: "895, Kroger, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "895, Kroger, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "895, Rite Aid, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "895, Target, BOURBONNAIS, IL",
            disabled: false,
          },
          {
            name: "895, Walmart, CUBA, MO",
            disabled: false,
          },
          {
            name: "8950, CVS, BLUE SPRINGS, MO",
            disabled: false,
          },
          {
            name: "8951, CVS, VINELAND, NJ",
            disabled: false,
          },
          {
            name: "8952, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "8954, CVS, OLIVE BRANCH, MS",
            disabled: false,
          },
          {
            name: "8955, CVS, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "8957, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "8958, CVS, LAFAYETTE, LA",
            disabled: false,
          },
          {
            name: "8958, Walmart, INDIO, CA",
            disabled: false,
          },
          {
            name: "8959, CVS, YOUNGSVILLE, NC",
            disabled: false,
          },
          {
            name: "896, Albertsons, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "896, Target, WALLED LAKE, MI",
            disabled: false,
          },
          {
            name: "896, Walmart, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "8960, CVS, EVANS, GA",
            disabled: false,
          },
          {
            name: "8961, CVS, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "8963, CVS, HARLINGEN, TX",
            disabled: false,
          },
          {
            name: "8966, CVS, HAYMARKET, VA",
            disabled: false,
          },
          {
            name: "8967, CVS, OTTSVILLE, PA",
            disabled: false,
          },
          {
            name: "897, ADUSA, PISCATAWAY, NJ",
            disabled: false,
          },
          {
            name: "897, Albertsons, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "897, Kroger, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "897, Kroger, Whitehall, OH",
            disabled: false,
          },
          {
            name: "897, Target, OVIEDO, FL",
            disabled: false,
          },
          {
            name: "897, Walmart, FORT STOCKTON, TX",
            disabled: false,
          },
          {
            name: "8970, CVS, GREAT BARRINGTON, MA",
            disabled: false,
          },
          {
            name: "8976, CVS, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "8977, CVS, KINGMAN, AZ",
            disabled: false,
          },
          {
            name: "8978, CVS, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "8979, CVS, HARRISBURG, PA",
            disabled: false,
          },
          {
            name: "898, Kroger, POWELL, OH",
            disabled: false,
          },
          {
            name: "898, Target, CASSELBERRY, FL",
            disabled: false,
          },
          {
            name: "898, Walmart, PECOS, TX",
            disabled: false,
          },
          {
            name: "8980, CVS, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "8981, CVS, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "8983, CVS, GLENDALE, AZ",
            disabled: false,
          },
          {
            name: "8984, CVS, PHILADELPHIA, PA",
            disabled: false,
          },
          {
            name: "8986, CVS, TULSA, OK",
            disabled: false,
          },
          {
            name: "899, ADUSA, LITTLE RIVER, SC",
            disabled: false,
          },
          {
            name: "899, Albertsons, AURORA, CO",
            disabled: false,
          },
          {
            name: "899, Target, NAPLES, FL",
            disabled: false,
          },
          {
            name: "899, Walmart, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "8990, CVS, HELOTES, TX",
            disabled: false,
          },
          {
            name: "8992, CVS, TUPELO, MS",
            disabled: false,
          },
          {
            name: "8993, CVS, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "8994, CVS, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "8999, CVS, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "9, ADUSA, GREENSBURG, PA",
            disabled: false,
          },
          {
            name: "9, ADUSA, HOLYOKE, MA",
            disabled: false,
          },
          {
            name: "9, Albertsons, BELGRADE, MT",
            disabled: false,
          },
          {
            name: "9, CVS, REVERE, MA",
            disabled: false,
          },
          {
            name: "9, Costco, ALOHA, OR",
            disabled: false,
          },
          {
            name: "9, HEB, DONNA, TX",
            disabled: false,
          },
          {
            name: "9, Kroger, Cincinnati, OH",
            disabled: false,
          },
          {
            name: "9, Kroger, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "9, Kroger, LARNED, KS",
            disabled: false,
          },
          {
            name: "9, Kroger, MISSOURI CITY, TX",
            disabled: false,
          },
          {
            name: "9, Kroger, Westlake Village, CA",
            disabled: false,
          },
          {
            name: "9, Walmart, SIKESTON, MO",
            disabled: false,
          },
          {
            name: "90, ADUSA, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "90, Albertsons, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "90, Kroger, Bedford, IN",
            disabled: false,
          },
          {
            name: "90, Kroger, Cleveland, TN",
            disabled: false,
          },
          {
            name: "90, Kroger, EDGEWATER, CO",
            disabled: false,
          },
          {
            name: "90, Kroger, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "90, Kroger, SALEM, OR",
            disabled: false,
          },
          {
            name: "90, Kroger, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "90, Target, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "90, Walmart, GROVE, OK",
            disabled: false,
          },
          {
            name: "900, ADUSA, RED SPRINGS, NC",
            disabled: false,
          },
          {
            name: "900, Kroger, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "900, Kroger, RUSSELL SPRINGS, KY",
            disabled: false,
          },
          {
            name: "900, Walgreens, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "900, Walmart, CHILDRESS, TX",
            disabled: false,
          },
          {
            name: "9000, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "9002, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9003, Walgreens, WESTON, FL",
            disabled: false,
          },
          {
            name: "9006, Walgreens, SEBRING, FL",
            disabled: false,
          },
          {
            name: "9007, Walgreens, GALLUP, NM",
            disabled: false,
          },
          {
            name: "9008, Walgreens, MAUSTON, WI",
            disabled: false,
          },
          {
            name: "9009, Walgreens, WISCONSIN RAPIDS, WI",
            disabled: false,
          },
          {
            name: "901, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "901, Kroger, ATHENS, OH",
            disabled: false,
          },
          {
            name: "901, Kroger, Arlington Heights, IL",
            disabled: false,
          },
          {
            name: "901, Kroger, ERLANGER, KY",
            disabled: false,
          },
          {
            name: "901, Kroger, Monticello, KY",
            disabled: false,
          },
          {
            name: "901, Kroger, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "901, Target, KALAMAZOO, MI",
            disabled: false,
          },
          {
            name: "901, Walmart, SEGUIN, TX",
            disabled: false,
          },
          {
            name: "9011, Walgreens, DANVERS, MA",
            disabled: false,
          },
          {
            name: "9013, Walgreens, SOUTHAVEN, MS",
            disabled: false,
          },
          {
            name: "9014, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "9015, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "9016, Walgreens, ALTAMONTE SPRINGS, FL",
            disabled: false,
          },
          {
            name: "9018, Walgreens, HIALEAH, FL",
            disabled: false,
          },
          {
            name: "902, CVS, MERRIMACK, NH",
            disabled: false,
          },
          {
            name: "902, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "902, Kroger, Libertyville, IL",
            disabled: false,
          },
          {
            name: "902, Kroger, PERU, IN",
            disabled: false,
          },
          {
            name: "902, Walmart, GREENCASTLE, IN",
            disabled: false,
          },
          {
            name: "9021, Walgreens, SAN JACINTO, CA",
            disabled: false,
          },
          {
            name: "9022, Walgreens, SPRINGFIELD, MO",
            disabled: false,
          },
          {
            name: "9023, Walgreens, CROWLEY, TX",
            disabled: false,
          },
          {
            name: "9024, Walgreens, BENSENVILLE, IL",
            disabled: false,
          },
          {
            name: "9025, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "9026, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "9028, Walgreens, GLEN BURNIE, MD",
            disabled: false,
          },
          {
            name: "903, Albertsons, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "903, CVS, BROOKHAVEN, PA",
            disabled: false,
          },
          {
            name: "903, Kroger, BRANDENBURG, KY",
            disabled: false,
          },
          {
            name: "903, Kroger, Kent, WA",
            disabled: false,
          },
          {
            name: "903, Kroger, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "903, Walmart, JACKSON, MS",
            disabled: false,
          },
          {
            name: "9030, Walgreens, RIDGECREST, CA",
            disabled: false,
          },
          {
            name: "9032, Walgreens, WALDORF, MD",
            disabled: false,
          },
          {
            name: "9034, Walgreens, ARVADA, CO",
            disabled: false,
          },
          {
            name: "9037, Walgreens, LAUREL, MS",
            disabled: false,
          },
          {
            name: "9038, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "904, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "904, Target, GRAND RAPIDS, MN",
            disabled: false,
          },
          {
            name: "904, Walmart, FOLEY, AL",
            disabled: false,
          },
          {
            name: "9040, Walgreens, STEPHENVILLE, TX",
            disabled: false,
          },
          {
            name: "9041, Walgreens, WICHITA FALLS, TX",
            disabled: false,
          },
          {
            name: "9043, Walgreens, GLENSHAW, PA",
            disabled: false,
          },
          {
            name: "9044, Walgreens, PALM BEACH GARDENS, FL",
            disabled: false,
          },
          {
            name: "9046, Walgreens, BRISTOL, VA",
            disabled: false,
          },
          {
            name: "9047, Walgreens, MANSFIELD, OH",
            disabled: false,
          },
          {
            name: "9048, Walgreens, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "9049, Walgreens, PITTSBURG, KS",
            disabled: false,
          },
          {
            name: "905, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "905, CVS, RAHWAY, NJ",
            disabled: false,
          },
          {
            name: "905, Kroger, Burien, WA",
            disabled: false,
          },
          {
            name: "905, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "905, Kroger, Palatine, IL",
            disabled: false,
          },
          {
            name: "905, Target, SALINA, KS",
            disabled: false,
          },
          {
            name: "905, Walmart, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "9057, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9059, Walgreens, ALGONQUIN, IL",
            disabled: false,
          },
          {
            name: "906, CVS, TROY, NY",
            disabled: false,
          },
          {
            name: "906, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "906, Kroger, Mercer Island, WA",
            disabled: false,
          },
          {
            name: "906, Kroger, Whitley City, KY",
            disabled: false,
          },
          {
            name: "906, Target, GARDEN CITY, KS",
            disabled: false,
          },
          {
            name: "906, Walmart, GALLUP, NM",
            disabled: false,
          },
          {
            name: "9062, Walgreens, GALVESTON, TX",
            disabled: false,
          },
          {
            name: "9063, Walgreens, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "9064, Walgreens, SMYRNA, TN",
            disabled: false,
          },
          {
            name: "9065, Walgreens, NORTHFIELD, MN",
            disabled: false,
          },
          {
            name: "9066, Walgreens, CUDAHY, WI",
            disabled: false,
          },
          {
            name: "9067, Walgreens, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "907, ADUSA, ELLIJAY, GA",
            disabled: false,
          },
          {
            name: "907, Costco, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "907, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "907, Kroger, HARRISON, OH",
            disabled: false,
          },
          {
            name: "907, Kroger, HOLLAND, OH",
            disabled: false,
          },
          {
            name: "907, Kroger, MARTINSVILLE, IN",
            disabled: false,
          },
          {
            name: "907, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "907, Walmart, FORSYTH, GA",
            disabled: false,
          },
          {
            name: "9071, Walgreens, NORTH HAVEN, CT",
            disabled: false,
          },
          {
            name: "9073, Walgreens, SHAKER HEIGHTS, OH",
            disabled: false,
          },
          {
            name: "9074, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "9075, Walgreens, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "9076, Walgreens, MISSION, TX",
            disabled: false,
          },
          {
            name: "9077, Walgreens, WARREN, OH",
            disabled: false,
          },
          {
            name: "9078, Walgreens, JAMISON, PA",
            disabled: false,
          },
          {
            name: "9079, Walgreens, MIDLAND, MI",
            disabled: false,
          },
          {
            name: "908, Albertsons, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "908, Walmart, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "9080, Walgreens, INDIO, CA",
            disabled: false,
          },
          {
            name: "9082, Walgreens, MAULDIN, SC",
            disabled: false,
          },
          {
            name: "9084, Walgreens, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "9085, Walgreens, ROCHESTER, MI",
            disabled: false,
          },
          {
            name: "9086, CVS, EL CERRITO, CA",
            disabled: false,
          },
          {
            name: "9086, Walgreens, MONROE, LA",
            disabled: false,
          },
          {
            name: "9089, Walgreens, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "909, ADUSA, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "909, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "909, Kroger, Frankfort, IL",
            disabled: false,
          },
          {
            name: "909, Kroger, GREENWOOD, IN",
            disabled: false,
          },
          {
            name: "909, Kroger, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "909, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "909, Walmart, CHALMETTE, LA",
            disabled: false,
          },
          {
            name: "9090, Walgreens, GRAHAM, NC",
            disabled: false,
          },
          {
            name: "9092, Walgreens, ROCK SPRINGS, WY",
            disabled: false,
          },
          {
            name: "9093, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "9094, Walgreens, AUSTIN, MN",
            disabled: false,
          },
          {
            name: "9095, Walgreens, OWATONNA, MN",
            disabled: false,
          },
          {
            name: "9098, Walgreens, LAKE PLACID, FL",
            disabled: false,
          },
          {
            name: "91, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "91, ADUSA, SHREWSBURY, MA",
            disabled: false,
          },
          {
            name: "91, Albertsons, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "91, Costco, DAVIE, FL",
            disabled: false,
          },
          {
            name: "91, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "91, Kroger, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "91, Kroger, Castle Pines, CO",
            disabled: false,
          },
          {
            name: "91, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "91, Walmart, FORREST CITY, AR",
            disabled: false,
          },
          {
            name: "910, ADUSA, HAMPSTEAD, NC",
            disabled: false,
          },
          {
            name: "910, Albertsons, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "910, Kroger, Columbus, IN",
            disabled: false,
          },
          {
            name: "910, Kroger, SAINT MARYS, OH",
            disabled: false,
          },
          {
            name: "910, Target, HILLSBORO, OR",
            disabled: false,
          },
          {
            name: "910, Walgreens, SIOUX CITY, IA",
            disabled: false,
          },
          {
            name: "910, Walmart, LAKE GENEVA, WI",
            disabled: false,
          },
          {
            name: "9100, Walgreens, PLYMOUTH, IN",
            disabled: false,
          },
          {
            name: "9101, CVS, HERMOSA BEACH, CA",
            disabled: false,
          },
          {
            name: "9101, Walgreens, HAMDEN, CT",
            disabled: false,
          },
          {
            name: "9102, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9102, Walgreens, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "9103, CVS, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "9104, Walgreens, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "9105, CVS, POWAY, CA",
            disabled: false,
          },
          {
            name: "9105, Walgreens, RIALTO, CA",
            disabled: false,
          },
          {
            name: "9109, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "911, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "911, Albertsons, SONOMA, CA",
            disabled: false,
          },
          {
            name: "911, CVS, WHITE PLAINS, NY",
            disabled: false,
          },
          {
            name: "911, Kroger, Elmhurst, IL",
            disabled: false,
          },
          {
            name: "911, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "911, Kroger, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "911, Rite Aid, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "911, Target, FRESNO, CA",
            disabled: false,
          },
          {
            name: "911, Walmart, MARRERO, LA",
            disabled: false,
          },
          {
            name: "9110, CVS, FALLBROOK, CA",
            disabled: false,
          },
          {
            name: "9110, Walgreens, EAST MEADOW, NY",
            disabled: false,
          },
          {
            name: "9111, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "9112, CVS, LEMON GROVE, CA",
            disabled: false,
          },
          {
            name: "9112, Walgreens, OAKLAND, TN",
            disabled: false,
          },
          {
            name: "9113, CVS, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "9113, Walgreens, KENNEWICK, WA",
            disabled: false,
          },
          {
            name: "9114, CVS, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "9115, Walgreens, CORAL SPRINGS, FL",
            disabled: false,
          },
          {
            name: "9116, Walgreens, COCONUT CREEK, FL",
            disabled: false,
          },
          {
            name: "9119, CVS, ORANGE, CA",
            disabled: false,
          },
          {
            name: "912, ADUSA, LORIS, SC",
            disabled: false,
          },
          {
            name: "912, CVS, TULARE, CA",
            disabled: false,
          },
          {
            name: "912, Target, CHINO, CA",
            disabled: false,
          },
          {
            name: "912, Walmart, NEW ORLEANS, LA",
            disabled: false,
          },
          {
            name: "9120, CVS, IMPERIAL BEACH, CA",
            disabled: false,
          },
          {
            name: "9120, Walgreens, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "9121, Walgreens, ALLEN, TX",
            disabled: false,
          },
          {
            name: "9123, Walgreens, GREENVILLE, TX",
            disabled: false,
          },
          {
            name: "9125, Walgreens, ROCHESTER HILLS, MI",
            disabled: false,
          },
          {
            name: "9126, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "9127, Walgreens, ROCKFORD, IL",
            disabled: false,
          },
          {
            name: "9128, Walgreens, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "9129, Walgreens, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "913, CVS, BRIDGEWATER, MA",
            disabled: false,
          },
          {
            name: "913, Kroger, LAWRENCEBURG, KY",
            disabled: false,
          },
          {
            name: "913, Kroger, SIDNEY, OH",
            disabled: false,
          },
          {
            name: "913, Kroger, Wheaton, IL",
            disabled: false,
          },
          {
            name: "913, Target, FOOTHILL RANCH, CA",
            disabled: false,
          },
          {
            name: "913, Walmart, DECORAH, IA",
            disabled: false,
          },
          {
            name: "9130, CVS, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "9130, Walgreens, BATTLE CREEK, MI",
            disabled: false,
          },
          {
            name: "9131, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9131, Walgreens, GRAND RAPIDS, MI",
            disabled: false,
          },
          {
            name: "9132, CVS, ELK GROVE, CA",
            disabled: false,
          },
          {
            name: "9132, Walgreens, GREENVILLE, MI",
            disabled: false,
          },
          {
            name: "9133, Walgreens, JACKSON, MI",
            disabled: false,
          },
          {
            name: "9134, CVS, INDIO, CA",
            disabled: false,
          },
          {
            name: "9134, Walgreens, OKATIE, SC",
            disabled: false,
          },
          {
            name: "9135, CVS, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "9135, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "9136, Walgreens, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9137, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9137, Walgreens, HAWTHORNE, CA",
            disabled: false,
          },
          {
            name: "9138, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "9139, Walgreens, PASADENA, CA",
            disabled: false,
          },
          {
            name: "914, Albertsons, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "914, Kroger, Lake Zurich, IL",
            disabled: false,
          },
          {
            name: "914, Kroger, RICHMOND, IN",
            disabled: false,
          },
          {
            name: "914, Kroger, Troy, OH",
            disabled: false,
          },
          {
            name: "914, Target, RANCHO SANTA MARGARITA, CA",
            disabled: false,
          },
          {
            name: "914, Walmart, CASSVILLE, MO",
            disabled: false,
          },
          {
            name: "9141, Walgreens, EVERGREEN PARK, IL",
            disabled: false,
          },
          {
            name: "9142, CVS, DAVIS, CA",
            disabled: false,
          },
          {
            name: "9142, Walgreens, NATCHEZ, MS",
            disabled: false,
          },
          {
            name: "9143, CVS, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "9143, Walgreens, BASTROP, TX",
            disabled: false,
          },
          {
            name: "9144, Walgreens, GREENVILLE, MS",
            disabled: false,
          },
          {
            name: "9145, Walgreens, SPRINGFIELD, IL",
            disabled: false,
          },
          {
            name: "9146, CVS, COVINA, CA",
            disabled: false,
          },
          {
            name: "9146, Walgreens, STURGIS, MI",
            disabled: false,
          },
          {
            name: "9148, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9148, Walgreens, ALPENA, MI",
            disabled: false,
          },
          {
            name: "9149, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "915, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "915, CVS, BEVERLY, MA",
            disabled: false,
          },
          {
            name: "915, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "915, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "915, Kroger, ELKHART, IN",
            disabled: false,
          },
          {
            name: "915, Kroger, Nashville, IL",
            disabled: false,
          },
          {
            name: "915, Target, SPOKANE, WA",
            disabled: false,
          },
          {
            name: "915, Walmart, STAFFORD, TX",
            disabled: false,
          },
          {
            name: "9150, CVS, AUBURN, CA",
            disabled: false,
          },
          {
            name: "9150, Walgreens, MURRAY, KY",
            disabled: false,
          },
          {
            name: "9152, CVS, SONOMA, CA",
            disabled: false,
          },
          {
            name: "9152, Walgreens, WORCESTER, MA",
            disabled: false,
          },
          {
            name: "9153, CVS, RANCHO MIRAGE, CA",
            disabled: false,
          },
          {
            name: "9153, Walgreens, GUILDERLAND, NY",
            disabled: false,
          },
          {
            name: "9154, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9154, Walgreens, COLONIE, NY",
            disabled: false,
          },
          {
            name: "9155, CVS, GRASS VALLEY, CA",
            disabled: false,
          },
          {
            name: "9155, Walgreens, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "9156, CVS, GOLETA, CA",
            disabled: false,
          },
          {
            name: "9156, Walgreens, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "9157, CVS, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "9157, Walgreens, CHUBBUCK, ID",
            disabled: false,
          },
          {
            name: "9158, CVS, OROVILLE, CA",
            disabled: false,
          },
          {
            name: "9158, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "9159, CVS, MADERA, CA",
            disabled: false,
          },
          {
            name: "916, ADUSA, CONWAY, SC",
            disabled: false,
          },
          {
            name: "916, CVS, OAKVILLE, CT",
            disabled: false,
          },
          {
            name: "916, Kroger, Shoreline, WA",
            disabled: false,
          },
          {
            name: "916, Kroger, WHITLEY CITY, KY",
            disabled: false,
          },
          {
            name: "916, Walmart, HATTIESBURG, MS",
            disabled: false,
          },
          {
            name: "9160, CVS, SAN GABRIEL, CA",
            disabled: false,
          },
          {
            name: "9161, CVS, MILPITAS, CA",
            disabled: false,
          },
          {
            name: "9161, Walgreens, CONROE, TX",
            disabled: false,
          },
          {
            name: "9162, CVS, LA MESA, CA",
            disabled: false,
          },
          {
            name: "9162, Walgreens, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "9163, CVS, PETALUMA, CA",
            disabled: false,
          },
          {
            name: "9163, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9165, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9165, Walgreens, DICKINSON, TX",
            disabled: false,
          },
          {
            name: "9166, CVS, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "9166, Walgreens, TWO RIVERS, WI",
            disabled: false,
          },
          {
            name: "9167, CVS, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "9168, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9168, Walgreens, SPARTA, WI",
            disabled: false,
          },
          {
            name: "9169, CVS, LA MESA, CA",
            disabled: false,
          },
          {
            name: "917, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "917, Albertsons, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "917, Kroger, Danville, WV",
            disabled: false,
          },
          {
            name: "917, Kroger, GRANBURY, TX",
            disabled: false,
          },
          {
            name: "917, Kroger, Oak Lawn, IL",
            disabled: false,
          },
          {
            name: "917, Kroger, PEORIA, IL",
            disabled: false,
          },
          {
            name: "917, Target, SNELLVILLE, GA",
            disabled: false,
          },
          {
            name: "917, Walmart, BRADY, TX",
            disabled: false,
          },
          {
            name: "9171, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "9172, CVS, SAN CARLOS, CA",
            disabled: false,
          },
          {
            name: "9173, CVS, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "9173, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "9174, CVS, TRUCKEE, CA",
            disabled: false,
          },
          {
            name: "9174, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "9175, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9175, Walgreens, BUCKEYE, AZ",
            disabled: false,
          },
          {
            name: "9176, CVS, TULARE, CA",
            disabled: false,
          },
          {
            name: "9176, Walgreens, JACKSONVILLE, IL",
            disabled: false,
          },
          {
            name: "9177, Walgreens, WEST LEBANON, NH",
            disabled: false,
          },
          {
            name: "9178, Walgreens, LONDONDERRY, NH",
            disabled: false,
          },
          {
            name: "9179, Walgreens, LAVEEN, AZ",
            disabled: false,
          },
          {
            name: "918, Albertsons, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "918, CVS, DARIEN, CT",
            disabled: false,
          },
          {
            name: "918, Kroger, PEORIA, IL",
            disabled: false,
          },
          {
            name: "918, Target, MATTHEWS, NC",
            disabled: false,
          },
          {
            name: "918, Walmart, MARSHALL, TX",
            disabled: false,
          },
          {
            name: "9180, CVS, WOODLAND, CA",
            disabled: false,
          },
          {
            name: "9180, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "9181, CVS, ENCINITAS, CA",
            disabled: false,
          },
          {
            name: "9181, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "9182, Walgreens, PINEVILLE, LA",
            disabled: false,
          },
          {
            name: "9183, Walgreens, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "9184, CVS, PLACERVILLE, CA",
            disabled: false,
          },
          {
            name: "9184, Walgreens, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "9186, Walgreens, GREEN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "9187, CVS, SOLANA BEACH, CA",
            disabled: false,
          },
          {
            name: "9188, CVS, ORLAND, CA",
            disabled: false,
          },
          {
            name: "919, Albertsons, LOS LUNAS, NM",
            disabled: false,
          },
          {
            name: "919, Albertsons, SARATOGA, CA",
            disabled: false,
          },
          {
            name: "919, CVS, GLENSIDE, PA",
            disabled: false,
          },
          {
            name: "919, Target, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "919, Walmart, FORT WALTON BEACH, FL",
            disabled: false,
          },
          {
            name: "9190, CVS, CORONA, CA",
            disabled: false,
          },
          {
            name: "9190, Walgreens, ISLANDIA, NY",
            disabled: false,
          },
          {
            name: "9191, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9192, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9192, Walgreens, OREM, UT",
            disabled: false,
          },
          {
            name: "9193, Walgreens, REYNOLDSBURG, OH",
            disabled: false,
          },
          {
            name: "9194, CVS, RAMONA, CA",
            disabled: false,
          },
          {
            name: "9195, CVS, LA JOLLA, CA",
            disabled: false,
          },
          {
            name: "9195, Walgreens, VIRGINIA BEACH, VA",
            disabled: false,
          },
          {
            name: "9196, Walgreens, CHESAPEAKE, VA",
            disabled: false,
          },
          {
            name: "9197, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9197, Walgreens, PLACENTIA, CA",
            disabled: false,
          },
          {
            name: "9198, CVS, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "9199, CVS, FAIR OAKS, CA",
            disabled: false,
          },
          {
            name: "9199, Walgreens, FALCON, CO",
            disabled: false,
          },
          {
            name: "92, ADUSA, NORTH ANDOVER, MA",
            disabled: false,
          },
          {
            name: "92, Albertsons, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "92, Costco, DORAL, FL",
            disabled: false,
          },
          {
            name: "92, HEB, VICTORIA, TX",
            disabled: false,
          },
          {
            name: "92, Kroger, COMMERCE CITY, CO",
            disabled: false,
          },
          {
            name: "92, Kroger, Nashville, TN",
            disabled: false,
          },
          {
            name: "92, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "92, Walmart, AURORA, MO",
            disabled: false,
          },
          {
            name: "920, Albertsons, ESTES PARK, CO",
            disabled: false,
          },
          {
            name: "920, CVS, CLINTON, MA",
            disabled: false,
          },
          {
            name: "920, Kroger, MOUNT ORAB, OH",
            disabled: false,
          },
          {
            name: "920, Kroger, NEW CASTLE, IN",
            disabled: false,
          },
          {
            name: "920, Kroger, Redmond, WA",
            disabled: false,
          },
          {
            name: "920, Kroger, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "920, Target, PEMBROKE PINES, FL",
            disabled: false,
          },
          {
            name: "920, Walmart, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "9202, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9202, Walgreens, MESA, AZ",
            disabled: false,
          },
          {
            name: "9203, CVS, MORAGA, CA",
            disabled: false,
          },
          {
            name: "9203, Walgreens, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "9204, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "9204, Walgreens, STATEN ISLAND, NY",
            disabled: false,
          },
          {
            name: "9205, CVS, TEMPE, AZ",
            disabled: false,
          },
          {
            name: "9205, Walgreens, ROCKPORT, TX",
            disabled: false,
          },
          {
            name: "9206, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "9208, CVS, SONORA, CA",
            disabled: false,
          },
          {
            name: "9208, Walgreens, MANCHESTER, TN",
            disabled: false,
          },
          {
            name: "921, CVS, SHOREWOOD, IL",
            disabled: false,
          },
          {
            name: "921, Kroger, Groveland, FL",
            disabled: false,
          },
          {
            name: "921, Kroger, Issaquah, WA",
            disabled: false,
          },
          {
            name: "921, Kroger, MILFORD, OH",
            disabled: false,
          },
          {
            name: "921, Kroger, MOORESVILLE, IN",
            disabled: false,
          },
          {
            name: "921, Target, JACKSON, TN",
            disabled: false,
          },
          {
            name: "921, Walmart, SALIDA, CO",
            disabled: false,
          },
          {
            name: "9210, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "9210, Walgreens, DELAVAN, WI",
            disabled: false,
          },
          {
            name: "9211, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9212, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9212, Walgreens, GREELEY, CO",
            disabled: false,
          },
          {
            name: "9213, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "9213, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "9214, CVS, NAPA, CA",
            disabled: false,
          },
          {
            name: "9214, Walgreens, LA CROSSE, WI",
            disabled: false,
          },
          {
            name: "9216, CVS, HALF MOON BAY, CA",
            disabled: false,
          },
          {
            name: "9216, Walgreens, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "9217, CVS, SUN CITY, AZ",
            disabled: false,
          },
          {
            name: "9217, Walgreens, LOMBARD, IL",
            disabled: false,
          },
          {
            name: "9218, CVS, MESA, AZ",
            disabled: false,
          },
          {
            name: "922, ADUSA, BLOWING ROCK, NC",
            disabled: false,
          },
          {
            name: "922, CVS, WEST ISLIP, NY",
            disabled: false,
          },
          {
            name: "922, Kroger, Bellevue, WA",
            disabled: false,
          },
          {
            name: "922, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "922, Kroger, DECATUR, IL",
            disabled: false,
          },
          {
            name: "922, Kroger, Lancaster, OH",
            disabled: false,
          },
          {
            name: "922, Kroger, Opa-Locka, FL",
            disabled: false,
          },
          {
            name: "922, Kroger, Springboro, OH",
            disabled: false,
          },
          {
            name: "922, Target, BRIGHTON, MI",
            disabled: false,
          },
          {
            name: "922, Walmart, CORYDON, IN",
            disabled: false,
          },
          {
            name: "9220, Walgreens, SOUTH BEND, IN",
            disabled: false,
          },
          {
            name: "9221, CVS, NEWBURY PARK, CA",
            disabled: false,
          },
          {
            name: "9222, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9223, Walgreens, MIDWEST CITY, OK",
            disabled: false,
          },
          {
            name: "9224, Walgreens, KELLER, TX",
            disabled: false,
          },
          {
            name: "9225, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9225, Walgreens, MOUNT WASHINGTON, KY",
            disabled: false,
          },
          {
            name: "9226, CVS, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "9226, Walgreens, CHESTER, VA",
            disabled: false,
          },
          {
            name: "9227, CVS, HILO, HI",
            disabled: false,
          },
          {
            name: "9228, CVS, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "9228, Walgreens, DALLAS, PA",
            disabled: false,
          },
          {
            name: "9229, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9229, Walgreens, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "923, Albertsons, RIO RANCHO, NM",
            disabled: false,
          },
          {
            name: "923, Kroger, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "923, Kroger, Gurnee, IL",
            disabled: false,
          },
          {
            name: "923, Kroger, Homewood, AL",
            disabled: false,
          },
          {
            name: "923, Kroger, Newark, OH",
            disabled: false,
          },
          {
            name: "923, Kroger, PEKIN, IL",
            disabled: false,
          },
          {
            name: "923, Rite Aid, TREVOSE, PA",
            disabled: false,
          },
          {
            name: "923, Target, WOODHAVEN, MI",
            disabled: false,
          },
          {
            name: "923, Walmart, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "9230, CVS, SUN CITY WEST, AZ",
            disabled: false,
          },
          {
            name: "9230, Walgreens, SIMPSONVILLE, SC",
            disabled: false,
          },
          {
            name: "9231, CVS, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "9231, Walgreens, STARKE, FL",
            disabled: false,
          },
          {
            name: "9232, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9232, Walgreens, CAMDEN, SC",
            disabled: false,
          },
          {
            name: "9233, CVS, JACKSON, CA",
            disabled: false,
          },
          {
            name: "9233, Walgreens, SHREWSBURY, MA",
            disabled: false,
          },
          {
            name: "9234, CVS, FREMONT, CA",
            disabled: false,
          },
          {
            name: "9235, CVS, CARPINTERIA, CA",
            disabled: false,
          },
          {
            name: "9235, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "9236, CVS, VENTURA, CA",
            disabled: false,
          },
          {
            name: "9236, Walgreens, GREENSBORO, NC",
            disabled: false,
          },
          {
            name: "9237, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "9237, Walgreens, SANDY, UT",
            disabled: false,
          },
          {
            name: "9238, CVS, CONCORD, CA",
            disabled: false,
          },
          {
            name: "9238, Walgreens, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "9239, Walgreens, MIDVALE, UT",
            disabled: false,
          },
          {
            name: "924, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "924, Kroger, DECATUR, IL",
            disabled: false,
          },
          {
            name: "924, Kroger, Northfield, IL",
            disabled: false,
          },
          {
            name: "924, Kroger, Rockledge, FL",
            disabled: false,
          },
          {
            name: "924, Kroger, Sammamish, WA",
            disabled: false,
          },
          {
            name: "924, Target, MOUNT PLEASANT, MI",
            disabled: false,
          },
          {
            name: "924, Walmart, STERLING, CO",
            disabled: false,
          },
          {
            name: "9240, CVS, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "9241, CVS, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "9242, CVS, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "9242, Walgreens, KALISPELL, MT",
            disabled: false,
          },
          {
            name: "9243, CVS, LODI, CA",
            disabled: false,
          },
          {
            name: "9244, Walgreens, GREELEY, CO",
            disabled: false,
          },
          {
            name: "9245, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9246, CVS, LAGUNA WOODS, CA",
            disabled: false,
          },
          {
            name: "9246, Walgreens, ARLINGTON HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "9247, CVS, DEL MAR, CA",
            disabled: false,
          },
          {
            name: "9248, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "9248, Walgreens, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "9249, Walgreens, HACKETTSTOWN, NJ",
            disabled: false,
          },
          {
            name: "925, Albertsons, LAS CRUCES, NM",
            disabled: false,
          },
          {
            name: "925, Kroger, Park Ridge, IL",
            disabled: false,
          },
          {
            name: "925, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "925, Kroger, Springboro, OH",
            disabled: false,
          },
          {
            name: "925, Walmart, SEFFNER, FL",
            disabled: false,
          },
          {
            name: "9250, Walgreens, EPPING, NH",
            disabled: false,
          },
          {
            name: "9251, CVS, PLEASANTON, CA",
            disabled: false,
          },
          {
            name: "9251, Walgreens, LAKE ORION, MI",
            disabled: false,
          },
          {
            name: "9252, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "9252, Walgreens, HIGHLAND, MI",
            disabled: false,
          },
          {
            name: "9253, CVS, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "9253, Walgreens, PADUCAH, KY",
            disabled: false,
          },
          {
            name: "9254, Walgreens, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "9256, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9256, Walgreens, ENTERPRISE, AL",
            disabled: false,
          },
          {
            name: "9257, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9257, Walgreens, STATESBORO, GA",
            disabled: false,
          },
          {
            name: "9258, Walgreens, SPRINGFIELD, OR",
            disabled: false,
          },
          {
            name: "926, Kroger, Bellevue, WA",
            disabled: false,
          },
          {
            name: "926, Kroger, HEATH, OH",
            disabled: false,
          },
          {
            name: "926, Kroger, Shorewood, IL",
            disabled: false,
          },
          {
            name: "926, Rite Aid, WAYNESBURG, PA",
            disabled: false,
          },
          {
            name: "926, Target, MOLINE, IL",
            disabled: false,
          },
          {
            name: "9261, CVS, LODI, CA",
            disabled: false,
          },
          {
            name: "9261, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9262, CVS, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "9262, Walgreens, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "9263, CVS, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "9264, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "9264, Walgreens, MARICOPA, AZ",
            disabled: false,
          },
          {
            name: "9265, Walgreens, COLUMBIA, TN",
            disabled: false,
          },
          {
            name: "9266, CVS, CAMP VERDE, AZ",
            disabled: false,
          },
          {
            name: "9266, Walgreens, PULASKI, TN",
            disabled: false,
          },
          {
            name: "9267, Walgreens, MILAN, IL",
            disabled: false,
          },
          {
            name: "9268, CVS, LA JOLLA, CA",
            disabled: false,
          },
          {
            name: "9269, CVS, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "927, ADUSA, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "927, Albertsons, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "927, CVS, WESTLAND, MI",
            disabled: false,
          },
          {
            name: "927, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "927, Kroger, Newcastle, WA",
            disabled: false,
          },
          {
            name: "927, Rite Aid, GETTYSBURG, PA",
            disabled: false,
          },
          {
            name: "927, Target, EVANSTON, IL",
            disabled: false,
          },
          {
            name: "927, Walmart, PLAINVIEW, TX",
            disabled: false,
          },
          {
            name: "9270, CVS, WICKENBURG, AZ",
            disabled: false,
          },
          {
            name: "9270, Walgreens, PETERSBURG, VA",
            disabled: false,
          },
          {
            name: "9271, CVS, VISALIA, CA",
            disabled: false,
          },
          {
            name: "9271, Walgreens, JONESBORO, GA",
            disabled: false,
          },
          {
            name: "9272, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9272, Walgreens, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "9273, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9274, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9276, Walgreens, SUMTER, SC",
            disabled: false,
          },
          {
            name: "9277, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9277, Walgreens, WAYCROSS, GA",
            disabled: false,
          },
          {
            name: "9278, CVS, YUMA, AZ",
            disabled: false,
          },
          {
            name: "9278, Walgreens, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "9279, CVS, FOUNTAIN HILLS, AZ",
            disabled: false,
          },
          {
            name: "9279, Walgreens, MARION, IN",
            disabled: false,
          },
          {
            name: "928, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "928, Albertsons, PLEASANT HILL, CA",
            disabled: false,
          },
          {
            name: "928, CVS, ROUND ROCK, TX",
            disabled: false,
          },
          {
            name: "928, Kroger, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "928, Kroger, Kirkland, WA",
            disabled: false,
          },
          {
            name: "928, Kroger, Westchester, IL",
            disabled: false,
          },
          {
            name: "928, Target, NILES, IL",
            disabled: false,
          },
          {
            name: "928, Walmart, SAINT JOHNS, FL",
            disabled: false,
          },
          {
            name: "9281, Walgreens, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "9282, CVS, DAVIS, CA",
            disabled: false,
          },
          {
            name: "9283, CVS, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "9284, Walgreens, WALTERBORO, SC",
            disabled: false,
          },
          {
            name: "9286, CVS, PORT HUENEME, CA",
            disabled: false,
          },
          {
            name: "9287, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "9288, Walgreens, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "929, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "929, CVS, FRANKLIN, MA",
            disabled: false,
          },
          {
            name: "929, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "929, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "929, Kroger, North Bend, WA",
            disabled: false,
          },
          {
            name: "929, Kroger, Western Springs, IL",
            disabled: false,
          },
          {
            name: "929, Target, PERU, IL",
            disabled: false,
          },
          {
            name: "929, Walmart, PORT SAINT LUCIE, FL",
            disabled: false,
          },
          {
            name: "9290, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9290, Walgreens, GARY, IN",
            disabled: false,
          },
          {
            name: "9291, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9292, Walgreens, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "9293, CVS, APACHE JUNCTION, AZ",
            disabled: false,
          },
          {
            name: "9294, CVS, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "9294, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9295, Walgreens, DECHERD, TN",
            disabled: false,
          },
          {
            name: "9296, CVS, DANVILLE, CA",
            disabled: false,
          },
          {
            name: "9297, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9297, Walgreens, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "9298, Walgreens, ESTERO, FL",
            disabled: false,
          },
          {
            name: "9299, CVS, PINOLE, CA",
            disabled: false,
          },
          {
            name: "93, ADUSA, DANVERS, MA",
            disabled: false,
          },
          {
            name: "93, ADUSA, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "93, ADUSA, WYTHEVILLE, VA",
            disabled: false,
          },
          {
            name: "93, Albertsons, BOULDER CITY, NV",
            disabled: false,
          },
          {
            name: "93, BJ's, NORTH HAVEN, CT",
            disabled: false,
          },
          {
            name: "93, Costco, PALM BEACH GARD, FL",
            disabled: false,
          },
          {
            name: "93, Kroger, DENVER, CO",
            disabled: false,
          },
          {
            name: "93, Kroger, Nashville, TN",
            disabled: false,
          },
          {
            name: "93, Kroger, Seymour, IN",
            disabled: false,
          },
          {
            name: "93, Kroger, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "93, Kroger, WOODS CROSS, UT",
            disabled: false,
          },
          {
            name: "93, Target, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "93, Walmart, COVINGTON, TN",
            disabled: false,
          },
          {
            name: "930, ADUSA, ROCKINGHAM, NC",
            disabled: false,
          },
          {
            name: "930, Target, SAINT CLOUD, MN",
            disabled: false,
          },
          {
            name: "930, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "9300, Walgreens, LUTZ, FL",
            disabled: false,
          },
          {
            name: "9301, Walgreens, SIKESTON, MO",
            disabled: false,
          },
          {
            name: "9302, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9303, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "9304, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "9305, Walgreens, VALDOSTA, GA",
            disabled: false,
          },
          {
            name: "9306, CVS, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "9306, Walgreens, COLONIAL HEIGHTS, TN",
            disabled: false,
          },
          {
            name: "9308, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "9309, CVS, FORT MOHAVE, AZ",
            disabled: false,
          },
          {
            name: "931, Kroger, Dayton, OH",
            disabled: false,
          },
          {
            name: "931, Kroger, Lancaster, OH",
            disabled: false,
          },
          {
            name: "931, Kroger, Lincolnwood, IL",
            disabled: false,
          },
          {
            name: "931, Kroger, Tacoma, WA",
            disabled: false,
          },
          {
            name: "931, Target, STILLWATER, MN",
            disabled: false,
          },
          {
            name: "931, Walmart, VERO BEACH, FL",
            disabled: false,
          },
          {
            name: "9311, CVS, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "9312, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9313, CVS, HIGHLAND, CA",
            disabled: false,
          },
          {
            name: "9313, Walgreens, NORMAL, IL",
            disabled: false,
          },
          {
            name: "9314, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9314, Walgreens, FAYETTEVILLE, TN",
            disabled: false,
          },
          {
            name: "9315, Walgreens, FIRESTONE, CO",
            disabled: false,
          },
          {
            name: "9316, CVS, NOVATO, CA",
            disabled: false,
          },
          {
            name: "9319, CVS, COTTONWOOD, AZ",
            disabled: false,
          },
          {
            name: "932, ADUSA, MOCKSVILLE, NC",
            disabled: false,
          },
          {
            name: "932, Albertsons, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "932, Kroger, Mukilteo, WA",
            disabled: false,
          },
          {
            name: "932, Kroger, PIQUA, OH",
            disabled: false,
          },
          {
            name: "932, Walmart, GRIFFIN, GA",
            disabled: false,
          },
          {
            name: "9320, CVS, MONTEREY, CA",
            disabled: false,
          },
          {
            name: "9320, Walgreens, BEDFORD, NH",
            disabled: false,
          },
          {
            name: "9321, Walgreens, EVANSVILLE, IN",
            disabled: false,
          },
          {
            name: "9322, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "9323, Walgreens, SEAGOVILLE, TX",
            disabled: false,
          },
          {
            name: "9324, CVS, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "9326, Walgreens, FRANKFORT, IL",
            disabled: false,
          },
          {
            name: "9327, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9328, CVS, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "9328, Walgreens, MEDFORD, OR",
            disabled: false,
          },
          {
            name: "9329, CVS, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "933, ADUSA, CHARLESTON, SC",
            disabled: false,
          },
          {
            name: "933, Albertsons, SEBASTOPOL, CA",
            disabled: false,
          },
          {
            name: "933, Kroger, Dayton, OH",
            disabled: false,
          },
          {
            name: "933, Kroger, Northbrook, IL",
            disabled: false,
          },
          {
            name: "933, Kroger, OTTAWA, IL",
            disabled: false,
          },
          {
            name: "933, Walmart, ROCHELLE, IL",
            disabled: false,
          },
          {
            name: "9330, CVS, MENLO PARK, CA",
            disabled: false,
          },
          {
            name: "9330, Walgreens, HOMEWOOD, IL",
            disabled: false,
          },
          {
            name: "9331, Walgreens, TINLEY PARK, IL",
            disabled: false,
          },
          {
            name: "9332, CVS, SANTA CRUZ, CA",
            disabled: false,
          },
          {
            name: "9332, Walgreens, CRANFORD, NJ",
            disabled: false,
          },
          {
            name: "9333, Walgreens, SAINT CLOUD, FL",
            disabled: false,
          },
          {
            name: "9334, CVS, YUMA, AZ",
            disabled: false,
          },
          {
            name: "9334, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "9335, Walgreens, ROCKAWAY, NJ",
            disabled: false,
          },
          {
            name: "9336, CVS, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9336, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "9337, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9337, Walgreens, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "9339, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "934, Albertsons, EL PASO, TX",
            disabled: false,
          },
          {
            name: "934, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "934, Kroger, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "934, Walmart, DAPHNE, AL",
            disabled: false,
          },
          {
            name: "9340, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9340, Walgreens, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "9341, CVS, SAN BERNARDINO, CA",
            disabled: false,
          },
          {
            name: "9342, CVS, MORGAN HILL, CA",
            disabled: false,
          },
          {
            name: "9342, Walgreens, EDGEWOOD, MD",
            disabled: false,
          },
          {
            name: "9343, CVS, PRESCOTT, AZ",
            disabled: false,
          },
          {
            name: "9343, Walgreens, MORGANTOWN, WV",
            disabled: false,
          },
          {
            name: "9344, Walgreens, NEW KENSINGTON, PA",
            disabled: false,
          },
          {
            name: "9346, CVS, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "9346, Walgreens, STREETSBORO, OH",
            disabled: false,
          },
          {
            name: "9347, CVS, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9347, Walgreens, PALOS HEIGHTS, IL",
            disabled: false,
          },
          {
            name: "9348, Walgreens, JACKSONVILLE, NC",
            disabled: false,
          },
          {
            name: "935, CVS, WALLINGFORD, CT",
            disabled: false,
          },
          {
            name: "935, Kroger, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "935, Kroger, Lynnwood, WA",
            disabled: false,
          },
          {
            name: "935, Kroger, Orland Park, IL",
            disabled: false,
          },
          {
            name: "935, Target, FLAGSTAFF, AZ",
            disabled: false,
          },
          {
            name: "935, Walmart, DENHAM SPRINGS, LA",
            disabled: false,
          },
          {
            name: "9350, Walgreens, FAIRMONT, MN",
            disabled: false,
          },
          {
            name: "9351, Walgreens, MISSOULA, MT",
            disabled: false,
          },
          {
            name: "9353, Walgreens, CORNELIUS, OR",
            disabled: false,
          },
          {
            name: "9357, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "9358, Walgreens, LINCOLNWOOD, IL",
            disabled: false,
          },
          {
            name: "9359, Walgreens, GREENDALE, IN",
            disabled: false,
          },
          {
            name: "936, ADUSA, KENANSVILLE, NC",
            disabled: false,
          },
          {
            name: "936, Albertsons, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "936, CVS, FRANKLIN PARK, NJ",
            disabled: false,
          },
          {
            name: "936, Kroger, Conroe, TX",
            disabled: false,
          },
          {
            name: "936, Kroger, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "936, Kroger, Westmont, IL",
            disabled: false,
          },
          {
            name: "936, Target, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "936, Walmart, EFFINGHAM, IL",
            disabled: false,
          },
          {
            name: "9360, Walgreens, FLORENCE, KY",
            disabled: false,
          },
          {
            name: "9361, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "9363, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "9364, Walgreens, ESCANABA, MI",
            disabled: false,
          },
          {
            name: "9365, Walgreens, HARTLAND, WI",
            disabled: false,
          },
          {
            name: "9366, Walgreens, MARBLE FALLS, TX",
            disabled: false,
          },
          {
            name: "9368, Walgreens, EL PASO, TX",
            disabled: false,
          },
          {
            name: "937, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "937, CVS, CARVER, MA",
            disabled: false,
          },
          {
            name: "937, Target, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "937, Walmart, MARIETTA, GA",
            disabled: false,
          },
          {
            name: "9370, CVS, SAN ANSELMO, CA",
            disabled: false,
          },
          {
            name: "9372, Walgreens, NORTH RIDGEVILLE, OH",
            disabled: false,
          },
          {
            name: "9373, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "9373, Walgreens, SHORELINE, WA",
            disabled: false,
          },
          {
            name: "9375, Walgreens, MOORE, OK",
            disabled: false,
          },
          {
            name: "9376, Walgreens, OTTAWA, KS",
            disabled: false,
          },
          {
            name: "9377, Walgreens, SALEM, OH",
            disabled: false,
          },
          {
            name: "9379, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "938, ADUSA, HOLLY SPRINGS, NC",
            disabled: false,
          },
          {
            name: "938, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "938, CVS, NORTH ATTLEBORO, MA",
            disabled: false,
          },
          {
            name: "938, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "938, Kroger, ENGLEWOOD, OH",
            disabled: false,
          },
          {
            name: "938, Kroger, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "938, Kroger, OREGON, OH",
            disabled: false,
          },
          {
            name: "938, Target, MODESTO, CA",
            disabled: false,
          },
          {
            name: "938, Walmart, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "9380, Walgreens, VANCOUVER, WA",
            disabled: false,
          },
          {
            name: "9382, Walgreens, CLINTON, MO",
            disabled: false,
          },
          {
            name: "9383, Walgreens, WARRENTON, VA",
            disabled: false,
          },
          {
            name: "9384, Walgreens, WELLINGTON, FL",
            disabled: false,
          },
          {
            name: "9385, Walgreens, ALLIANCE, OH",
            disabled: false,
          },
          {
            name: "9389, Walgreens, VISTA, CA",
            disabled: false,
          },
          {
            name: "939, ADUSA, DURHAM, NC",
            disabled: false,
          },
          {
            name: "939, Albertsons, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "939, Albertsons, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "939, Kroger, Chicago, IL",
            disabled: false,
          },
          {
            name: "939, Kroger, FAIRFIELD, OH",
            disabled: false,
          },
          {
            name: "939, Kroger, Mercer Island, WA",
            disabled: false,
          },
          {
            name: "939, Kroger, Perrysburg, OH",
            disabled: false,
          },
          {
            name: "939, Target, APPLE VALLEY, CA",
            disabled: false,
          },
          {
            name: "939, Walmart, WACO, TX",
            disabled: false,
          },
          {
            name: "9390, CVS, VALLEY SPRINGS, CA",
            disabled: false,
          },
          {
            name: "9391, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9393, CVS, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "9393, Walgreens, CANON CITY, CO",
            disabled: false,
          },
          {
            name: "9394, CVS, SANTA MARIA, CA",
            disabled: false,
          },
          {
            name: "9394, Walgreens, NEW BRAUNFELS, TX",
            disabled: false,
          },
          {
            name: "9395, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9397, CVS, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "9397, Walgreens, AUBURN, AL",
            disabled: false,
          },
          {
            name: "9399, CVS, PRATHER, CA",
            disabled: false,
          },
          {
            name: "94, ADUSA, WEST SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "94, BJ's, RIVERDALE, NJ",
            disabled: false,
          },
          {
            name: "94, Costco, BOCA RATON, FL",
            disabled: false,
          },
          {
            name: "94, HEB, MISSION, TX",
            disabled: false,
          },
          {
            name: "94, Kroger, MANHATTAN, KS",
            disabled: false,
          },
          {
            name: "94, Kroger, SALT LAKE CITY, UT",
            disabled: false,
          },
          {
            name: "94, Walmart, MILLINGTON, TN",
            disabled: false,
          },
          {
            name: "940, ADUSA, RUCKERSVILLE, VA",
            disabled: false,
          },
          {
            name: "940, Kroger, Bloomingdale, IL",
            disabled: false,
          },
          {
            name: "940, Kroger, LEBANON, IN",
            disabled: false,
          },
          {
            name: "940, Kroger, SYLVANIA, OH",
            disabled: false,
          },
          {
            name: "940, Target, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "940, Walmart, WESTWORTH VILLAGE, TX",
            disabled: false,
          },
          {
            name: "9400, Walgreens, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "9401, Walgreens, MIAMI, FL",
            disabled: false,
          },
          {
            name: "9402, Walgreens, VICKSBURG, MS",
            disabled: false,
          },
          {
            name: "9404, Walgreens, AURORA, IL",
            disabled: false,
          },
          {
            name: "9405, Walgreens, WEYMOUTH, MA",
            disabled: false,
          },
          {
            name: "9407, Walgreens, LAKEWOOD, OH",
            disabled: false,
          },
          {
            name: "9408, Walgreens, TYLER, TX",
            disabled: false,
          },
          {
            name: "9409, Walgreens, PERRYSBURG, OH",
            disabled: false,
          },
          {
            name: "941, ADUSA, CLEVELAND, TN",
            disabled: false,
          },
          {
            name: "941, CVS, WEST HAVEN, CT",
            disabled: false,
          },
          {
            name: "941, Target, HOLLISTER, CA",
            disabled: false,
          },
          {
            name: "941, Walmart, VALRICO, FL",
            disabled: false,
          },
          {
            name: "9410, Walgreens, ATHENS, TX",
            disabled: false,
          },
          {
            name: "9411, Walgreens, PALESTINE, TX",
            disabled: false,
          },
          {
            name: "9412, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "9413, Walgreens, CAMILLUS, NY",
            disabled: false,
          },
          {
            name: "9414, Walgreens, NORTH SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "9416, Walgreens, SYRACUSE, NY",
            disabled: false,
          },
          {
            name: "9417, Walgreens, CHARLOTTESVILLE, VA",
            disabled: false,
          },
          {
            name: "942, Albertsons, MIDDLEBURG, VA",
            disabled: false,
          },
          {
            name: "942, CVS, BROOKLYN, CT",
            disabled: false,
          },
          {
            name: "942, Kroger, BLUE ASH, OH",
            disabled: false,
          },
          {
            name: "942, Kroger, Bannockburn, IL",
            disabled: false,
          },
          {
            name: "942, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "942, Kroger, PEORIA, IL",
            disabled: false,
          },
          {
            name: "942, Target, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "942, Walmart, OCOEE, FL",
            disabled: false,
          },
          {
            name: "9420, Walgreens, CARTHAGE, MO",
            disabled: false,
          },
          {
            name: "9421, Walgreens, KEYSTONE HEIGHTS, FL",
            disabled: false,
          },
          {
            name: "9423, Walgreens, DES MOINES, WA",
            disabled: false,
          },
          {
            name: "9424, Walgreens, OVERLAND PARK, KS",
            disabled: false,
          },
          {
            name: "9425, Walgreens, SHAWNEE, KS",
            disabled: false,
          },
          {
            name: "9427, Walgreens, PELHAM, AL",
            disabled: false,
          },
          {
            name: "9428, Walgreens, KINGSPORT, TN",
            disabled: false,
          },
          {
            name: "9429, Walgreens, ELIZABETHTON, TN",
            disabled: false,
          },
          {
            name: "943, ADUSA, LORTON, VA",
            disabled: false,
          },
          {
            name: "943, Albertsons, SWEDESBORO, NJ",
            disabled: false,
          },
          {
            name: "943, CVS, WILLIMANTIC, CT",
            disabled: false,
          },
          {
            name: "943, Costco, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "943, Kroger, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "943, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "943, Kroger, Lombard, IL",
            disabled: false,
          },
          {
            name: "943, Target, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "943, Walmart, CASSELBERRY, FL",
            disabled: false,
          },
          {
            name: "9430, Walgreens, JEFFERSON CITY, TN",
            disabled: false,
          },
          {
            name: "9431, Walgreens, SUGAR GROVE, IL",
            disabled: false,
          },
          {
            name: "9432, Walgreens, ENFIELD, CT",
            disabled: false,
          },
          {
            name: "9433, Walgreens, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "9434, Walgreens, SMITHFIELD, NC",
            disabled: false,
          },
          {
            name: "9436, Walgreens, CRESTWOOD, MO",
            disabled: false,
          },
          {
            name: "9439, Walgreens, ELGIN, IL",
            disabled: false,
          },
          {
            name: "944, ADUSA, PILOT MOUNTAIN, NC",
            disabled: false,
          },
          {
            name: "944, CVS, SOUTH YARMOUTH, MA",
            disabled: false,
          },
          {
            name: "944, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "944, Kroger, Crystal Lake, IL",
            disabled: false,
          },
          {
            name: "944, Kroger, FISHERS, IN",
            disabled: false,
          },
          {
            name: "944, Walmart, CRESTVIEW, FL",
            disabled: false,
          },
          {
            name: "9440, Walgreens, BAY CITY, TX",
            disabled: false,
          },
          {
            name: "9441, Walgreens, WATERLOO, IL",
            disabled: false,
          },
          {
            name: "9443, Walgreens, SHELBYVILLE, KY",
            disabled: false,
          },
          {
            name: "9444, Walgreens, LAWRENCEBURG, TN",
            disabled: false,
          },
          {
            name: "9447, Walgreens, NASHUA, NH",
            disabled: false,
          },
          {
            name: "9448, Walgreens, ENNIS, TX",
            disabled: false,
          },
          {
            name: "9449, Walgreens, MCALLEN, TX",
            disabled: false,
          },
          {
            name: "945, ADUSA, BEAUFORT, SC",
            disabled: false,
          },
          {
            name: "945, Albertsons, POTOMAC, MD",
            disabled: false,
          },
          {
            name: "945, CVS, EVANS, GA",
            disabled: false,
          },
          {
            name: "945, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "945, Kroger, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "945, Target, Chesterfield, MI",
            disabled: false,
          },
          {
            name: "945, Walmart, LUBBOCK, TX",
            disabled: false,
          },
          {
            name: "9450, Walgreens, BAD AXE, MI",
            disabled: false,
          },
          {
            name: "9451, Walgreens, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "9452, Walgreens, MABLETON, GA",
            disabled: false,
          },
          {
            name: "9454, Walgreens, INDEPENDENCE, KS",
            disabled: false,
          },
          {
            name: "9455, Walgreens, PARSONS, KS",
            disabled: false,
          },
          {
            name: "9456, Walgreens, MONTGOMERY, AL",
            disabled: false,
          },
          {
            name: "9458, Walgreens, ASHEVILLE, NC",
            disabled: false,
          },
          {
            name: "9459, Walgreens, PINEY FLATS, TN",
            disabled: false,
          },
          {
            name: "946, ADUSA, RANDLEMAN, NC",
            disabled: false,
          },
          {
            name: "946, CVS, UXBRIDGE, MA",
            disabled: false,
          },
          {
            name: "946, Kroger, COLD SPRING, KY",
            disabled: false,
          },
          {
            name: "946, Kroger, DECATUR, IL",
            disabled: false,
          },
          {
            name: "9460, Walgreens, SAN TAN VALLEY, AZ",
            disabled: false,
          },
          {
            name: "9461, Walgreens, CENTEREACH, NY",
            disabled: false,
          },
          {
            name: "9462, Walgreens, CLINTON, NC",
            disabled: false,
          },
          {
            name: "9464, Walgreens, SANDY, UT",
            disabled: false,
          },
          {
            name: "9465, Walgreens, DYERSBURG, TN",
            disabled: false,
          },
          {
            name: "9467, Walgreens, NEOSHO, MO",
            disabled: false,
          },
          {
            name: "947, CVS, PALMYRA, VA",
            disabled: false,
          },
          {
            name: "947, Costco, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "947, Kroger, DANVILLE, IN",
            disabled: false,
          },
          {
            name: "947, Kroger, Holland, OH",
            disabled: false,
          },
          {
            name: "947, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "947, Target, DALLAS, TX",
            disabled: false,
          },
          {
            name: "947, Walmart, SHERMAN, TX",
            disabled: false,
          },
          {
            name: "9470, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "9471, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9472, Walgreens, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "9473, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9475, CVS, TORRANCE, CA",
            disabled: false,
          },
          {
            name: "9475, Walgreens, RIVERVIEW, FL",
            disabled: false,
          },
          {
            name: "9476, CVS, HERMOSA BEACH, CA",
            disabled: false,
          },
          {
            name: "9476, Walgreens, BURLINGTON, IA",
            disabled: false,
          },
          {
            name: "9477, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9477, Walgreens, MARSHFIELD, MA",
            disabled: false,
          },
          {
            name: "9479, CVS, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "9479, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "948, ADUSA, ROSEBORO, NC",
            disabled: false,
          },
          {
            name: "948, CVS, WEST CHESTER, PA",
            disabled: false,
          },
          {
            name: "948, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "948, Kroger, CRAWFORDSVILLE, IN",
            disabled: false,
          },
          {
            name: "948, Walmart, HICKORY, NC",
            disabled: false,
          },
          {
            name: "9480, CVS, PETALUMA, CA",
            disabled: false,
          },
          {
            name: "9481, CVS, STANTON, CA",
            disabled: false,
          },
          {
            name: "9481, Walgreens, MARYLAND HEIGHTS, MO",
            disabled: false,
          },
          {
            name: "9482, CVS, ARCATA, CA",
            disabled: false,
          },
          {
            name: "9482, Walgreens, MISHAWAKA, IN",
            disabled: false,
          },
          {
            name: "9483, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "9483, Walgreens, DEFIANCE, OH",
            disabled: false,
          },
          {
            name: "9484, CVS, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "9484, Walgreens, ORLANDO, FL",
            disabled: false,
          },
          {
            name: "9485, CVS, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "9485, Walgreens, NATCHITOCHES, LA",
            disabled: false,
          },
          {
            name: "9486, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "9486, Walgreens, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "9487, Walgreens, COLUMBIA, SC",
            disabled: false,
          },
          {
            name: "9488, CVS, ARTESIA, CA",
            disabled: false,
          },
          {
            name: "9488, Walgreens, GREENSBURG, IN",
            disabled: false,
          },
          {
            name: "9489, CVS, CERRITOS, CA",
            disabled: false,
          },
          {
            name: "9489, Walgreens, SHELBYVILLE, IN",
            disabled: false,
          },
          {
            name: "949, ADUSA, MOOREFIELD, WV",
            disabled: false,
          },
          {
            name: "949, Albertsons, FAIR HAVEN, NJ",
            disabled: false,
          },
          {
            name: "949, CVS, MERRICK, NY",
            disabled: false,
          },
          {
            name: "949, Target, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "9490, CVS, POLLOCK PINES, CA",
            disabled: false,
          },
          {
            name: "9490, Walgreens, EDGEWATER, MD",
            disabled: false,
          },
          {
            name: "9491, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "9491, Walgreens, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "9492, CVS, YORBA LINDA, CA",
            disabled: false,
          },
          {
            name: "9492, Walgreens, SHREVEPORT, LA",
            disabled: false,
          },
          {
            name: "9493, Walgreens, MONTROSE, CO",
            disabled: false,
          },
          {
            name: "9494, CVS, NEWARK, CA",
            disabled: false,
          },
          {
            name: "9494, Walgreens, SUGAR HILL, GA",
            disabled: false,
          },
          {
            name: "9495, CVS, COMPTON, CA",
            disabled: false,
          },
          {
            name: "9496, Walgreens, RIVERHEAD, NY",
            disabled: false,
          },
          {
            name: "9497, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "9497, Walgreens, SMITHTOWN, NY",
            disabled: false,
          },
          {
            name: "9498, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9498, Walgreens, WADING RIVER, NY",
            disabled: false,
          },
          {
            name: "95, ADUSA, HADLEY, MA",
            disabled: false,
          },
          {
            name: "95, ADUSA, MEADVILLE, PA",
            disabled: false,
          },
          {
            name: "95, Costco, TACOMA, WA",
            disabled: false,
          },
          {
            name: "95, HEB, LAREDO, TX",
            disabled: false,
          },
          {
            name: "95, Kroger, EVERETT, WA",
            disabled: false,
          },
          {
            name: "95, Kroger, Evans, CO",
            disabled: false,
          },
          {
            name: "95, Kroger, MONTEREY PARK, CA",
            disabled: false,
          },
          {
            name: "95, Kroger, SALINA, KS",
            disabled: false,
          },
          {
            name: "95, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "95, Walmart, DESLOGE, MO",
            disabled: false,
          },
          {
            name: "950, ADUSA, TANEYTOWN, MD",
            disabled: false,
          },
          {
            name: "950, Albertsons, GUERNEVILLE, CA",
            disabled: false,
          },
          {
            name: "950, CVS, LONGMEADOW, MA",
            disabled: false,
          },
          {
            name: "950, Kroger, Bothell, WA",
            disabled: false,
          },
          {
            name: "950, Kroger, Greenville, MS",
            disabled: false,
          },
          {
            name: "950, Kroger, ORANGE, TX",
            disabled: false,
          },
          {
            name: "950, Target, PHOENIX, AZ",
            disabled: false,
          },
          {
            name: "950, Walmart, BARTLETT, TN",
            disabled: false,
          },
          {
            name: "9500, Walgreens, AZLE, TX",
            disabled: false,
          },
          {
            name: "9501, Walgreens, STOCKBRIDGE, GA",
            disabled: false,
          },
          {
            name: "9502, CVS, HEMET, CA",
            disabled: false,
          },
          {
            name: "9503, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9503, Walgreens, BARNEGAT, NJ",
            disabled: false,
          },
          {
            name: "9504, Walgreens, RICHMOND, TX",
            disabled: false,
          },
          {
            name: "9505, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "9505, Walgreens, ROSELLE, IL",
            disabled: false,
          },
          {
            name: "9506, Walgreens, SCHAUMBURG, IL",
            disabled: false,
          },
          {
            name: "9507, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9507, Walgreens, FRIENDSWOOD, TX",
            disabled: false,
          },
          {
            name: "9508, CVS, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "9508, Walgreens, WEST PEORIA, IL",
            disabled: false,
          },
          {
            name: "9509, CVS, CONCORD, CA",
            disabled: false,
          },
          {
            name: "951, ADUSA, EDEN, NC",
            disabled: false,
          },
          {
            name: "951, Albertsons, ALAMEDA, CA",
            disabled: false,
          },
          {
            name: "951, Costco, SUMNER, WA",
            disabled: false,
          },
          {
            name: "951, Kroger, DAYTON, OH",
            disabled: false,
          },
          {
            name: "951, Kroger, Edmonds, WA",
            disabled: false,
          },
          {
            name: "951, Walmart, HEMPSTEAD, TX",
            disabled: false,
          },
          {
            name: "9510, CVS, WESTMINSTER, CA",
            disabled: false,
          },
          {
            name: "9510, Walgreens, LEWISBURG, TN",
            disabled: false,
          },
          {
            name: "9511, CVS, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "9511, Walgreens, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "9512, CVS, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "9512, Walgreens, RAPID CITY, SD",
            disabled: false,
          },
          {
            name: "9513, CVS, MANHATTAN BEACH, CA",
            disabled: false,
          },
          {
            name: "9514, Walgreens, MENOMONIE, WI",
            disabled: false,
          },
          {
            name: "9515, Walgreens, EAST MOLINE, IL",
            disabled: false,
          },
          {
            name: "9516, Walgreens, GILROY, CA",
            disabled: false,
          },
          {
            name: "9517, Walgreens, PINELLAS PARK, FL",
            disabled: false,
          },
          {
            name: "9518, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "952, Costco, BROOKSHIRE, TX",
            disabled: false,
          },
          {
            name: "952, Kroger, GREENFIELD, IN",
            disabled: false,
          },
          {
            name: "952, Target, FARMINGTON, NM",
            disabled: false,
          },
          {
            name: "952, Walmart, MOULTRIE, GA",
            disabled: false,
          },
          {
            name: "9520, Walgreens, HAMILTON, OH",
            disabled: false,
          },
          {
            name: "9521, Walgreens, BRIDGEPORT, CT",
            disabled: false,
          },
          {
            name: "9522, Walgreens, ATHENS, TN",
            disabled: false,
          },
          {
            name: "9524, Walgreens, LOUISVILLE, KY",
            disabled: false,
          },
          {
            name: "9525, CVS, GRIDLEY, CA",
            disabled: false,
          },
          {
            name: "9525, Walgreens, UKIAH, CA",
            disabled: false,
          },
          {
            name: "9526, CVS, GRANITE BAY, CA",
            disabled: false,
          },
          {
            name: "9526, Walgreens, PINEVILLE, LA",
            disabled: false,
          },
          {
            name: "9527, Walgreens, HIGH POINT, NC",
            disabled: false,
          },
          {
            name: "9528, CVS, CARLSBAD, CA",
            disabled: false,
          },
          {
            name: "9528, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "9529, CVS, SAN RAFAEL, CA",
            disabled: false,
          },
          {
            name: "953, ADUSA, WINGATE, NC",
            disabled: false,
          },
          {
            name: "953, Kroger, Everett, WA",
            disabled: false,
          },
          {
            name: "953, Kroger, MARSHALL, TX",
            disabled: false,
          },
          {
            name: "953, Kroger, STERLING, IL",
            disabled: false,
          },
          {
            name: "953, Target, LUFKIN, TX",
            disabled: false,
          },
          {
            name: "953, Walmart, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "9530, CVS, MOORPARK, CA",
            disabled: false,
          },
          {
            name: "9531, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9532, CVS, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "9532, Walgreens, RANCHO CORDOVA, CA",
            disabled: false,
          },
          {
            name: "9533, CVS, PORTER RANCH, CA",
            disabled: false,
          },
          {
            name: "9534, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9534, Walgreens, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "9535, CVS, LINCOLN, CA",
            disabled: false,
          },
          {
            name: "9535, Walgreens, NAVARRE, FL",
            disabled: false,
          },
          {
            name: "9536, CVS, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "9537, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9538, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9538, Walgreens, ROXBURY, MA",
            disabled: false,
          },
          {
            name: "9539, CVS, ANGELS CAMP, CA",
            disabled: false,
          },
          {
            name: "954, Albertsons, CRESCENT CITY, CA",
            disabled: false,
          },
          {
            name: "954, Walmart, HAZLEHURST, MS",
            disabled: false,
          },
          {
            name: "9540, CVS, NEWPORT BEACH, CA",
            disabled: false,
          },
          {
            name: "9540, Walgreens, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "9541, Walgreens, NEW ALBANY, OH",
            disabled: false,
          },
          {
            name: "9542, Walgreens, GOOSE CREEK, SC",
            disabled: false,
          },
          {
            name: "9543, CVS, LOMITA, CA",
            disabled: false,
          },
          {
            name: "9544, CVS, REDONDO BEACH, CA",
            disabled: false,
          },
          {
            name: "9544, Walgreens, MILWAUKIE, OR",
            disabled: false,
          },
          {
            name: "9545, CVS, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "9545, Walgreens, LONG BEACH, MS",
            disabled: false,
          },
          {
            name: "9546, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "9547, Walgreens, SHERIDAN, WY",
            disabled: false,
          },
          {
            name: "9548, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "9548, Walgreens, CHEYENNE, WY",
            disabled: false,
          },
          {
            name: "9549, CVS, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "955, Albertsons, CONCORD, CA",
            disabled: false,
          },
          {
            name: "955, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "955, Walmart, APOPKA, FL",
            disabled: false,
          },
          {
            name: "9550, CVS, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "9551, CVS, SEAL BEACH, CA",
            disabled: false,
          },
          {
            name: "9552, Walgreens, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "9554, CVS, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "9555, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "9555, Walgreens, KNIGHTDALE, NC",
            disabled: false,
          },
          {
            name: "9556, Walgreens, JACKSONVILLE, FL",
            disabled: false,
          },
          {
            name: "9558, CVS, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "9558, Walgreens, CLEMMONS, NC",
            disabled: false,
          },
          {
            name: "956, Albertsons, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "956, CVS, DOYLESTOWN, PA",
            disabled: false,
          },
          {
            name: "956, Walmart, MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "9560, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "9560, Walgreens, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "9561, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "9561, Walgreens, WOODLAND PARK, CO",
            disabled: false,
          },
          {
            name: "9562, CVS, IRVINE, CA",
            disabled: false,
          },
          {
            name: "9562, Walgreens, SHELBY, NC",
            disabled: false,
          },
          {
            name: "9563, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9564, Walgreens, LOVELAND, CO",
            disabled: false,
          },
          {
            name: "9565, Walgreens, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "9566, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "9566, Walgreens, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "9567, CVS, SANTA BARBARA, CA",
            disabled: false,
          },
          {
            name: "9567, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "9568, Walgreens, PUEBLO, CO",
            disabled: false,
          },
          {
            name: "9569, CVS, FOUNTAIN VALLEY, CA",
            disabled: false,
          },
          {
            name: "9569, Walgreens, PUEBLO WEST, CO",
            disabled: false,
          },
          {
            name: "957, ADUSA, CLYDE, NC",
            disabled: false,
          },
          {
            name: "957, CVS, WEST SPRINGFIELD, MA",
            disabled: false,
          },
          {
            name: "957, Kroger, Mountlake Terrace, WA",
            disabled: false,
          },
          {
            name: "957, Kroger, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "957, Kroger, PARIS, TX",
            disabled: false,
          },
          {
            name: "957, Kroger, Savannah, GA",
            disabled: false,
          },
          {
            name: "957, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "957, Target, VILLA PARK, IL",
            disabled: false,
          },
          {
            name: "957, Walmart, GENESEO, IL",
            disabled: false,
          },
          {
            name: "9570, Walgreens, BROOMFIELD, CO",
            disabled: false,
          },
          {
            name: "9571, Walgreens, CHINO VALLEY, AZ",
            disabled: false,
          },
          {
            name: "9572, CVS, LAKEWOOD, CA",
            disabled: false,
          },
          {
            name: "9572, Walgreens, PINECREST, FL",
            disabled: false,
          },
          {
            name: "9573, Walgreens, LAKELAND, FL",
            disabled: false,
          },
          {
            name: "9574, Walgreens, BRYAN, TX",
            disabled: false,
          },
          {
            name: "9575, CVS, CYPRESS, CA",
            disabled: false,
          },
          {
            name: "9577, CVS, HUNTINGTON BEACH, CA",
            disabled: false,
          },
          {
            name: "9577, Walgreens, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "9578, CVS, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "9578, Walgreens, CRAWFORDVILLE, FL",
            disabled: false,
          },
          {
            name: "9579, CVS, LONG BEACH, CA",
            disabled: false,
          },
          {
            name: "958, ADUSA, SUFFOLK, VA",
            disabled: false,
          },
          {
            name: "958, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "958, Target, BOWLING GREEN, KY",
            disabled: false,
          },
          {
            name: "958, Walmart, PLATTEVILLE, WI",
            disabled: false,
          },
          {
            name: "9580, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9580, Walgreens, CHATHAM, IL",
            disabled: false,
          },
          {
            name: "9581, CVS, DANA POINT, CA",
            disabled: false,
          },
          {
            name: "9581, Walgreens, FALLON, NV",
            disabled: false,
          },
          {
            name: "9582, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9582, Walgreens, OKLAHOMA CITY, OK",
            disabled: false,
          },
          {
            name: "9584, CVS, INGLEWOOD, CA",
            disabled: false,
          },
          {
            name: "9584, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "9585, CVS, OCEANSIDE, CA",
            disabled: false,
          },
          {
            name: "9585, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "9586, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9586, Walgreens, NEW CASTLE, PA",
            disabled: false,
          },
          {
            name: "9587, CVS, LAKE FOREST, CA",
            disabled: false,
          },
          {
            name: "9587, Walgreens, LAFAYETTE, TN",
            disabled: false,
          },
          {
            name: "9588, Walgreens, FONTANA, CA",
            disabled: false,
          },
          {
            name: "959, ADUSA, PALMYRA, VA",
            disabled: false,
          },
          {
            name: "959, CVS, WELLS, ME",
            disabled: false,
          },
          {
            name: "959, Kroger, Bellevue, WA",
            disabled: false,
          },
          {
            name: "959, Kroger, CARMEL, IN",
            disabled: false,
          },
          {
            name: "959, Kroger, LONGVIEW, TX",
            disabled: false,
          },
          {
            name: "959, Kroger, WEST CHESTER, OH",
            disabled: false,
          },
          {
            name: "959, Target, CLARKSVILLE, TN",
            disabled: false,
          },
          {
            name: "959, Walmart, BUSHNELL, FL",
            disabled: false,
          },
          {
            name: "9590, Walgreens, TACOMA, WA",
            disabled: false,
          },
          {
            name: "9591, Walgreens, YORK, PA",
            disabled: false,
          },
          {
            name: "9592, CVS, ARROYO GRANDE, CA",
            disabled: false,
          },
          {
            name: "9593, Walgreens, BELLA VISTA, AR",
            disabled: false,
          },
          {
            name: "9594, Walgreens, FORT SMITH, AR",
            disabled: false,
          },
          {
            name: "9595, CVS, ALBANY, CA",
            disabled: false,
          },
          {
            name: "9595, Walgreens, JENKS, OK",
            disabled: false,
          },
          {
            name: "9596, Walgreens, RICHLAND, WA",
            disabled: false,
          },
          {
            name: "9597, CVS, CAPITOLA, CA",
            disabled: false,
          },
          {
            name: "9597, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "9598, CVS, FULLERTON, CA",
            disabled: false,
          },
          {
            name: "9598, Walgreens, LONGMONT, CO",
            disabled: false,
          },
          {
            name: "96, ADUSA, WOBURN, MA",
            disabled: false,
          },
          {
            name: "96, BJ's, WILLOUGHBY, OH",
            disabled: false,
          },
          {
            name: "96, Costco, BOZEMAN, MT",
            disabled: false,
          },
          {
            name: "96, HEB, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "96, Kroger, GREENWOOD VILLAGE, CO",
            disabled: false,
          },
          {
            name: "96, Kroger, PASADENA, CA",
            disabled: false,
          },
          {
            name: "96, Kroger, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "96, Kroger, RUSHVILLE, IN",
            disabled: false,
          },
          {
            name: "96, Kroger, WICHITA, KS",
            disabled: false,
          },
          {
            name: "96, Target, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "96, Walmart, HARRISONVILLE, MO",
            disabled: false,
          },
          {
            name: "960, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "960, CVS, EASTON, PA",
            disabled: false,
          },
          {
            name: "960, Kroger, BLOOMINGTON, IN",
            disabled: false,
          },
          {
            name: "960, Kroger, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "960, Kroger, Redmond, WA",
            disabled: false,
          },
          {
            name: "960, Walmart, DUNNELLON, FL",
            disabled: false,
          },
          {
            name: "9600, CVS, FREMONT, CA",
            disabled: false,
          },
          {
            name: "9600, Walgreens, MELROSE PARK, IL",
            disabled: false,
          },
          {
            name: "9601, CVS, BURBANK, CA",
            disabled: false,
          },
          {
            name: "9601, Walgreens, HUMBLE, TX",
            disabled: false,
          },
          {
            name: "9602, Walgreens, THE WOODLANDS, TX",
            disabled: false,
          },
          {
            name: "9604, Walgreens, KEMAH, TX",
            disabled: false,
          },
          {
            name: "9605, CVS, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "9605, Walgreens, KENOSHA, WI",
            disabled: false,
          },
          {
            name: "9606, Walgreens, RACINE, WI",
            disabled: false,
          },
          {
            name: "9607, CVS, ROLLING HILLS ESTATES, CA",
            disabled: false,
          },
          {
            name: "9607, Walgreens, LITTLETON, CO",
            disabled: false,
          },
          {
            name: "9608, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "9609, Walgreens, WESTON, WI",
            disabled: false,
          },
          {
            name: "961, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "961, Kroger, GREENCASTLE, IN",
            disabled: false,
          },
          {
            name: "961, Target, CARY, NC",
            disabled: false,
          },
          {
            name: "961, Walmart, LA PLACE, LA",
            disabled: false,
          },
          {
            name: "9611, CVS, CANYON COUNTRY, CA",
            disabled: false,
          },
          {
            name: "9611, Walgreens, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "9612, CVS, CARMEL, CA",
            disabled: false,
          },
          {
            name: "9612, Walgreens, SHELTON, CT",
            disabled: false,
          },
          {
            name: "9614, Walgreens, HAVERHILL, MA",
            disabled: false,
          },
          {
            name: "9615, CVS, RESEDA, CA",
            disabled: false,
          },
          {
            name: "9615, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "9616, CVS, CATHEDRAL CITY, CA",
            disabled: false,
          },
          {
            name: "9616, Walgreens, MORENO VALLEY, CA",
            disabled: false,
          },
          {
            name: "9617, Walgreens, GAINESVILLE, FL",
            disabled: false,
          },
          {
            name: "9618, CVS, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "962, Albertsons, ALAMO, CA",
            disabled: false,
          },
          {
            name: "962, CVS, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "962, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "962, Target, ROCKY MOUNT, NC",
            disabled: false,
          },
          {
            name: "962, Walmart, TRINIDAD, CO",
            disabled: false,
          },
          {
            name: "9620, Walgreens, ATLANTA, GA",
            disabled: false,
          },
          {
            name: "9621, Walgreens, ELLENWOOD, GA",
            disabled: false,
          },
          {
            name: "9622, CVS, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "9622, Walgreens, LAGRANGE, GA",
            disabled: false,
          },
          {
            name: "9623, CVS, MERCED, CA",
            disabled: false,
          },
          {
            name: "9623, Walgreens, MCDONOUGH, GA",
            disabled: false,
          },
          {
            name: "9624, Walgreens, HARRISON, AR",
            disabled: false,
          },
          {
            name: "9625, Walgreens, LAKE OSWEGO, OR",
            disabled: false,
          },
          {
            name: "9626, Walgreens, BAYVILLE, NJ",
            disabled: false,
          },
          {
            name: "9627, Walgreens, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "9629, Walgreens, LOGANVILLE, GA",
            disabled: false,
          },
          {
            name: "963, Albertsons, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "963, CVS, EAST HILLS, NY",
            disabled: false,
          },
          {
            name: "963, Kroger, Enumclaw, WA",
            disabled: false,
          },
          {
            name: "963, Kroger, PLYMOUTH, IN",
            disabled: false,
          },
          {
            name: "963, Kroger, WINTERSVILLE, OH",
            disabled: false,
          },
          {
            name: "963, Target, MYRTLE BEACH, SC",
            disabled: false,
          },
          {
            name: "963, Walmart, WEATHERFORD, TX",
            disabled: false,
          },
          {
            name: "9630, CVS, VAN NUYS, CA",
            disabled: false,
          },
          {
            name: "9630, Walgreens, UNION CITY, GA",
            disabled: false,
          },
          {
            name: "9631, CVS, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "9631, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "9632, CVS, CHULA VISTA, CA",
            disabled: false,
          },
          {
            name: "9632, Walgreens, WALDORF, MD",
            disabled: false,
          },
          {
            name: "9633, CVS, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "9633, Walgreens, BEMIDJI, MN",
            disabled: false,
          },
          {
            name: "9634, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "9635, CVS, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "9635, Walgreens, RALEIGH, NC",
            disabled: false,
          },
          {
            name: "9636, CVS, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "9636, Walgreens, LOVELAND, OH",
            disabled: false,
          },
          {
            name: "9638, CVS, WINNETKA, CA",
            disabled: false,
          },
          {
            name: "964, ADUSA, COLONIAL BEACH, VA",
            disabled: false,
          },
          {
            name: "964, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "964, Target, GOLDSBORO, NC",
            disabled: false,
          },
          {
            name: "964, Walmart, EL PASO, TX",
            disabled: false,
          },
          {
            name: "9641, CVS, COVINA, CA",
            disabled: false,
          },
          {
            name: "9641, Walgreens, RANCHO MIRAGE, CA",
            disabled: false,
          },
          {
            name: "9642, CVS, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "9643, Walgreens, WARNER ROBINS, GA",
            disabled: false,
          },
          {
            name: "9645, Walgreens, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "9646, CVS, PALM DESERT, CA",
            disabled: false,
          },
          {
            name: "9646, Walgreens, MERRIMACK, NH",
            disabled: false,
          },
          {
            name: "9647, Walgreens, DALLAS, TX",
            disabled: false,
          },
          {
            name: "9648, CVS, INDIO, CA",
            disabled: false,
          },
          {
            name: "9648, Walgreens, WOODWAY, TX",
            disabled: false,
          },
          {
            name: "9649, CVS, YUCAIPA, CA",
            disabled: false,
          },
          {
            name: "965, Albertsons, WILLITS, CA",
            disabled: false,
          },
          {
            name: "965, CVS, FLORHAM PARK, NJ",
            disabled: false,
          },
          {
            name: "965, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "965, Kroger, WESTERVILLE, OH",
            disabled: false,
          },
          {
            name: "965, Walmart, TOMAH, WI",
            disabled: false,
          },
          {
            name: "9650, CVS, VICTORVILLE, CA",
            disabled: false,
          },
          {
            name: "9650, Walgreens, SALEM, OR",
            disabled: false,
          },
          {
            name: "9651, Walgreens, THE DALLES, OR",
            disabled: false,
          },
          {
            name: "9652, CVS, WEST HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "9652, Walgreens, COOLIDGE, AZ",
            disabled: false,
          },
          {
            name: "9653, CVS, HONOLULU, HI",
            disabled: false,
          },
          {
            name: "9654, CVS, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "9655, CVS, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "9656, CVS, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "9657, CVS, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "9657, Walgreens, DENVER, CO",
            disabled: false,
          },
          {
            name: "9658, CVS, BURBANK, CA",
            disabled: false,
          },
          {
            name: "966, ADUSA, CHESTER, VA",
            disabled: false,
          },
          {
            name: "966, Albertsons, SCOTTSDALE, AZ",
            disabled: false,
          },
          {
            name: "966, Kroger, Hilliard, OH",
            disabled: false,
          },
          {
            name: "966, Kroger, LAPORTE, IN",
            disabled: false,
          },
          {
            name: "966, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "966, Target, HUNTERSVILLE, NC",
            disabled: false,
          },
          {
            name: "966, Walmart, CORTEZ, CO",
            disabled: false,
          },
          {
            name: "9661, Walgreens, SALISBURY, NC",
            disabled: false,
          },
          {
            name: "9662, CVS, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "9667, CVS, DIAMOND BAR, CA",
            disabled: false,
          },
          {
            name: "9667, Walgreens, SAYVILLE, NY",
            disabled: false,
          },
          {
            name: "9668, CVS, PASADENA, CA",
            disabled: false,
          },
          {
            name: "9669, Walgreens, HUBBARD, OH",
            disabled: false,
          },
          {
            name: "967, Albertsons, ORINDA, CA",
            disabled: false,
          },
          {
            name: "967, Target, JACKSONVILLE BEACH, FL",
            disabled: false,
          },
          {
            name: "967, Walmart, SPRING HILL, FL",
            disabled: false,
          },
          {
            name: "9670, CVS, TARZANA, CA",
            disabled: false,
          },
          {
            name: "9670, Walgreens, ALTUS, OK",
            disabled: false,
          },
          {
            name: "9671, Walgreens, WARRENTON, OR",
            disabled: false,
          },
          {
            name: "9672, Walgreens, LEVITTOWN, PA",
            disabled: false,
          },
          {
            name: "9673, Walgreens, DOVER, PA",
            disabled: false,
          },
          {
            name: "9674, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9674, Walgreens, HOMESTEAD, PA",
            disabled: false,
          },
          {
            name: "9675, CVS, STUDIO CITY, CA",
            disabled: false,
          },
          {
            name: "9675, Walgreens, PITTSBURGH, PA",
            disabled: false,
          },
          {
            name: "9676, Walgreens, WASHINGTON, PA",
            disabled: false,
          },
          {
            name: "9677, CVS, ENCINO, CA",
            disabled: false,
          },
          {
            name: "9677, Walgreens, YORK, PA",
            disabled: false,
          },
          {
            name: "9678, CVS, LIVERMORE, CA",
            disabled: false,
          },
          {
            name: "9678, Walgreens, LEXINGTON, TN",
            disabled: false,
          },
          {
            name: "9679, CVS, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "9679, Walgreens, AUSTIN, TX",
            disabled: false,
          },
          {
            name: "968, Albertsons, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "968, Kroger, CINCINNATI, OH",
            disabled: false,
          },
          {
            name: "968, Target, MIAMI, FL",
            disabled: false,
          },
          {
            name: "968, Walmart, WINTER HAVEN, FL",
            disabled: false,
          },
          {
            name: "9680, CVS, ARCADIA, CA",
            disabled: false,
          },
          {
            name: "9680, Walgreens, TAYLOR, TX",
            disabled: false,
          },
          {
            name: "9681, CVS, EUREKA, CA",
            disabled: false,
          },
          {
            name: "9681, Walgreens, LEHI, UT",
            disabled: false,
          },
          {
            name: "9682, CVS, WOODLAND HILLS, CA",
            disabled: false,
          },
          {
            name: "9682, Walgreens, LITTLE CHUTE, WI",
            disabled: false,
          },
          {
            name: "9683, CVS, VENTURA, CA",
            disabled: false,
          },
          {
            name: "9683, Walgreens, JASPER, AL",
            disabled: false,
          },
          {
            name: "9684, CVS, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "9685, Walgreens, MANHATTAN BEACH, CA",
            disabled: false,
          },
          {
            name: "9686, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9687, Walgreens, DOVER, DE",
            disabled: false,
          },
          {
            name: "9688, CVS, PASADENA, CA",
            disabled: false,
          },
          {
            name: "9688, Walgreens, CLEARWATER, FL",
            disabled: false,
          },
          {
            name: "9689, CVS, MONROVIA, CA",
            disabled: false,
          },
          {
            name: "9689, Walgreens, WABASH, IN",
            disabled: false,
          },
          {
            name: "969, Albertsons, MORAGA, CA",
            disabled: false,
          },
          {
            name: "969, CVS, PALMER, MA",
            disabled: false,
          },
          {
            name: "969, Target, CARTERSVILLE, GA",
            disabled: false,
          },
          {
            name: "969, Walmart, GULFPORT, MS",
            disabled: false,
          },
          {
            name: "9690, CVS, REDWOOD CITY, CA",
            disabled: false,
          },
          {
            name: "9690, Walgreens, PONCHATOULA, LA",
            disabled: false,
          },
          {
            name: "9691, CVS, MARYSVILLE, CA",
            disabled: false,
          },
          {
            name: "9691, Walgreens, SOUTH HAVEN, MI",
            disabled: false,
          },
          {
            name: "9692, CVS, BURBANK, CA",
            disabled: false,
          },
          {
            name: "9692, Walgreens, UNION, MO",
            disabled: false,
          },
          {
            name: "9693, Walgreens, MCALESTER, OK",
            disabled: false,
          },
          {
            name: "9694, CVS, PASADENA, CA",
            disabled: false,
          },
          {
            name: "9696, CVS, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "9696, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9697, CVS, MALIBU, CA",
            disabled: false,
          },
          {
            name: "9697, Walgreens, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "9698, CVS, UPLAND, CA",
            disabled: false,
          },
          {
            name: "9699, CVS, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "9699, Walgreens, WAUPACA, WI",
            disabled: false,
          },
          {
            name: "97, ADUSA, HICKORY, NC",
            disabled: false,
          },
          {
            name: "97, BJ's, COLLEGE POINT, NY",
            disabled: false,
          },
          {
            name: "97, Costco, CLACKAMAS, OR",
            disabled: false,
          },
          {
            name: "97, Kroger, FORT COLLINS, CO",
            disabled: false,
          },
          {
            name: "97, Kroger, GLENDALE, CA",
            disabled: false,
          },
          {
            name: "97, Kroger, HUTCHINSON, KS",
            disabled: false,
          },
          {
            name: "97, Walmart, RIPLEY, TN",
            disabled: false,
          },
          {
            name: "970, Albertsons, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "970, Kroger, Hadlock, WA",
            disabled: false,
          },
          {
            name: "970, Kroger, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "970, Target, ALPHARETTA, GA",
            disabled: false,
          },
          {
            name: "970, Walmart, PICAYUNE, MS",
            disabled: false,
          },
          {
            name: "9700, CVS, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "9700, Walgreens, KINGWOOD, TX",
            disabled: false,
          },
          {
            name: "9701, Walgreens, VESTAVIA HILLS, AL",
            disabled: false,
          },
          {
            name: "9702, Walgreens, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9703, Walgreens, FORTUNA, CA",
            disabled: false,
          },
          {
            name: "9706, CVS, NORTHRIDGE, CA",
            disabled: false,
          },
          {
            name: "9706, Walgreens, GAINESVILLE, GA",
            disabled: false,
          },
          {
            name: "9708, Walgreens, DUBUQUE, IA",
            disabled: false,
          },
          {
            name: "9709, CVS, LA VERNE, CA",
            disabled: false,
          },
          {
            name: "9709, Walgreens, CHICAGO, IL",
            disabled: false,
          },
          {
            name: "971, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "971, Albertsons, HAYWARD, CA",
            disabled: false,
          },
          {
            name: "971, CVS, WESTERLY, RI",
            disabled: false,
          },
          {
            name: "971, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "971, Kroger, Renton, WA",
            disabled: false,
          },
          {
            name: "971, Walmart, VIROQUA, WI",
            disabled: false,
          },
          {
            name: "9710, Walgreens, FLOYDS KNOBS, IN",
            disabled: false,
          },
          {
            name: "9711, Walgreens, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "9712, CVS, FAIRFIELD, CA",
            disabled: false,
          },
          {
            name: "9712, Walgreens, NICHOLASVILLE, KY",
            disabled: false,
          },
          {
            name: "9713, CVS, SOUTH LAKE TAHOE, CA",
            disabled: false,
          },
          {
            name: "9713, Walgreens, JEFFERSON CITY, MO",
            disabled: false,
          },
          {
            name: "9714, CVS, SANTA CLARITA, CA",
            disabled: false,
          },
          {
            name: "9715, CVS, THOUSAND OAKS, CA",
            disabled: false,
          },
          {
            name: "9715, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "9716, Walgreens, RIPON, CA",
            disabled: false,
          },
          {
            name: "9717, CVS, NORTH HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "9717, Walgreens, EAST AMHERST, NY",
            disabled: false,
          },
          {
            name: "9718, CVS, NORCO, CA",
            disabled: false,
          },
          {
            name: "9719, CVS, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "9719, Walgreens, MEMPHIS, TN",
            disabled: false,
          },
          {
            name: "972, Albertsons, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "972, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "972, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "972, Walmart, LAKE WORTH, TX",
            disabled: false,
          },
          {
            name: "9720, Walgreens, GRAND PRAIRIE, TX",
            disabled: false,
          },
          {
            name: "9721, Walgreens, MIDLOTHIAN, TX",
            disabled: false,
          },
          {
            name: "9723, CVS, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "9723, Walgreens, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "9724, CVS, RANCHO CUCAMONGA, CA",
            disabled: false,
          },
          {
            name: "9724, Walgreens, LIVE OAK, FL",
            disabled: false,
          },
          {
            name: "9725, CVS, ORANGE, CA",
            disabled: false,
          },
          {
            name: "9727, CVS, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "9727, Walgreens, APPLE VALLEY, MN",
            disabled: false,
          },
          {
            name: "9728, Walgreens, CHANHASSEN, MN",
            disabled: false,
          },
          {
            name: "9729, CVS, ONTARIO, CA",
            disabled: false,
          },
          {
            name: "973, ADUSA, LOCUST GROVE, VA",
            disabled: false,
          },
          {
            name: "973, CVS, MAYNARD, MA",
            disabled: false,
          },
          {
            name: "973, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "973, Walmart, FORT PIERCE, FL",
            disabled: false,
          },
          {
            name: "9730, Walgreens, ASHEBORO, NC",
            disabled: false,
          },
          {
            name: "9732, CVS, HOLLYWOOD, CA",
            disabled: false,
          },
          {
            name: "9733, CVS, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "9733, Walgreens, FRANKLIN, OH",
            disabled: false,
          },
          {
            name: "9734, CVS, BURBANK, CA",
            disabled: false,
          },
          {
            name: "9735, Walgreens, WOODWARD, OK",
            disabled: false,
          },
          {
            name: "9737, CVS, GOLETA, CA",
            disabled: false,
          },
          {
            name: "9737, Walgreens, DARLINGTON, SC",
            disabled: false,
          },
          {
            name: "9738, Walgreens, SUMMERVILLE, SC",
            disabled: false,
          },
          {
            name: "9739, CVS, BIG BEAR LAKE, CA",
            disabled: false,
          },
          {
            name: "9739, Walgreens, EL CAMPO, TX",
            disabled: false,
          },
          {
            name: "974, ADUSA, HARRISONBURG, VA",
            disabled: false,
          },
          {
            name: "974, Kroger, BAYTOWN, TX",
            disabled: false,
          },
          {
            name: "974, Kroger, Bellevue, WA",
            disabled: false,
          },
          {
            name: "974, Kroger, SHELBYVILLE, IN",
            disabled: false,
          },
          {
            name: "974, Walmart, WEST MELBOURNE, FL",
            disabled: false,
          },
          {
            name: "9740, CVS, LA MIRADA, CA",
            disabled: false,
          },
          {
            name: "9740, Walgreens, DE FOREST, WI",
            disabled: false,
          },
          {
            name: "9741, Walgreens, OREGON, WI",
            disabled: false,
          },
          {
            name: "9742, Walgreens, YUMA, AZ",
            disabled: false,
          },
          {
            name: "9743, Walgreens, MOUNTAIN HOME, AR",
            disabled: false,
          },
          {
            name: "9744, CVS, ORANGE, CA",
            disabled: false,
          },
          {
            name: "9746, CVS, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "9746, Walgreens, WINDSOR LOCKS, CT",
            disabled: false,
          },
          {
            name: "9747, CVS, PLACENTIA, CA",
            disabled: false,
          },
          {
            name: "9747, Walgreens, HOMOSASSA, FL",
            disabled: false,
          },
          {
            name: "9748, CVS, WEST COVINA, CA",
            disabled: false,
          },
          {
            name: "9748, Walgreens, PLANTATION, FL",
            disabled: false,
          },
          {
            name: "9749, CVS, ORANGE, CA",
            disabled: false,
          },
          {
            name: "9749, Walgreens, WOODSTOCK, GA",
            disabled: false,
          },
          {
            name: "975, Albertsons, FORTUNA, CA",
            disabled: false,
          },
          {
            name: "975, Walmart, DURANT, OK",
            disabled: false,
          },
          {
            name: "9750, Walgreens, COLLINSVILLE, IL",
            disabled: false,
          },
          {
            name: "9751, CVS, AGOURA HILLS, CA",
            disabled: false,
          },
          {
            name: "9751, Walgreens, AURORA, IN",
            disabled: false,
          },
          {
            name: "9752, CVS, DALY CITY, CA",
            disabled: false,
          },
          {
            name: "9753, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "9753, Walgreens, DONALDSONVILLE, LA",
            disabled: false,
          },
          {
            name: "9757, Walgreens, CARY, NC",
            disabled: false,
          },
          {
            name: "9758, CVS, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "9758, Walgreens, IRONDEQUOIT, NY",
            disabled: false,
          },
          {
            name: "9759, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "9759, Walgreens, WILLIAMSVILLE, NY",
            disabled: false,
          },
          {
            name: "976, Walmart, WINNSBORO, LA",
            disabled: false,
          },
          {
            name: "9760, CVS, ANAHEIM, CA",
            disabled: false,
          },
          {
            name: "9761, CVS, BENICIA, CA",
            disabled: false,
          },
          {
            name: "9762, Walgreens, ANTIOCH, TN",
            disabled: false,
          },
          {
            name: "9763, CVS, PATTERSON, CA",
            disabled: false,
          },
          {
            name: "9763, Walgreens, FORT WORTH, TX",
            disabled: false,
          },
          {
            name: "9764, CVS, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "9765, Walgreens, PASCO, WA",
            disabled: false,
          },
          {
            name: "9766, Walgreens, SEARCY, AR",
            disabled: false,
          },
          {
            name: "9767, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "9768, Walgreens, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "9769, CVS, PICO RIVERA, CA",
            disabled: false,
          },
          {
            name: "9769, Walgreens, GRAND JUNCTION, CO",
            disabled: false,
          },
          {
            name: "977, Albertsons, SURPRISE, AZ",
            disabled: false,
          },
          {
            name: "977, Kroger, MOUNDSVILLE, WV",
            disabled: false,
          },
          {
            name: "977, Walmart, FERNANDINA BEACH, FL",
            disabled: false,
          },
          {
            name: "9770, CVS, HENDERSON, NV",
            disabled: false,
          },
          {
            name: "9771, Walgreens, ROCK HILL, MO",
            disabled: false,
          },
          {
            name: "9773, Walgreens, ALBUQUERQUE, NM",
            disabled: false,
          },
          {
            name: "9774, Walgreens, GREENVILLE, SC",
            disabled: false,
          },
          {
            name: "9776, Walgreens, HERMITAGE, PA",
            disabled: false,
          },
          {
            name: "9777, CVS, PLACENTIA, CA",
            disabled: false,
          },
          {
            name: "9778, Walgreens, NASHVILLE, TN",
            disabled: false,
          },
          {
            name: "9779, CVS, INDIAN WELLS, CA",
            disabled: false,
          },
          {
            name: "9779, Walgreens, RICHMOND, VA",
            disabled: false,
          },
          {
            name: "978, Albertsons, FORT BRAGG, CA",
            disabled: false,
          },
          {
            name: "978, Walmart, ARKANSAS CITY, KS",
            disabled: false,
          },
          {
            name: "9780, Walgreens, HESPERIA, CA",
            disabled: false,
          },
          {
            name: "9781, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9781, Walgreens, INDIO, CA",
            disabled: false,
          },
          {
            name: "9782, CVS, NIPOMO, CA",
            disabled: false,
          },
          {
            name: "9783, Walgreens, STERLING, CO",
            disabled: false,
          },
          {
            name: "9784, Walgreens, EAST HARTFORD, CT",
            disabled: false,
          },
          {
            name: "9785, CVS, LANCASTER, CA",
            disabled: false,
          },
          {
            name: "9785, Walgreens, NEW HAVEN, CT",
            disabled: false,
          },
          {
            name: "9786, Walgreens, CALLAHAN, FL",
            disabled: false,
          },
          {
            name: "9787, Walgreens, CHIEFLAND, FL",
            disabled: false,
          },
          {
            name: "9788, CVS, DUARTE, CA",
            disabled: false,
          },
          {
            name: "9788, Walgreens, HOMESTEAD, FL",
            disabled: false,
          },
          {
            name: "9789, CVS, MISSION HILLS, CA",
            disabled: false,
          },
          {
            name: "9789, Walgreens, AUGUSTA, GA",
            disabled: false,
          },
          {
            name: "979, Albertsons, NOVATO, CA",
            disabled: false,
          },
          {
            name: "979, Kroger, FRANKLIN, IN",
            disabled: false,
          },
          {
            name: "979, Kroger, SAVANNAH, GA",
            disabled: false,
          },
          {
            name: "979, Kroger, Stanwood, WA",
            disabled: false,
          },
          {
            name: "979, Walmart, SPARTA, WI",
            disabled: false,
          },
          {
            name: "9790, CVS, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "9791, CVS, ALHAMBRA, CA",
            disabled: false,
          },
          {
            name: "9791, Walgreens, ALTOONA, IA",
            disabled: false,
          },
          {
            name: "9792, Walgreens, DECATUR, IL",
            disabled: false,
          },
          {
            name: "9793, CVS, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "9793, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "9794, Walgreens, BLOOMINGTON, MN",
            disabled: false,
          },
          {
            name: "9795, Walgreens, SAINT PAUL, MN",
            disabled: false,
          },
          {
            name: "9796, Walgreens, LEBANON, MO",
            disabled: false,
          },
          {
            name: "9798, Walgreens, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "9799, CVS, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "9799, Walgreens, NEW HARTFORD, NY",
            disabled: false,
          },
          {
            name: "98, ADUSA, FLORENCE, SC",
            disabled: false,
          },
          {
            name: "98, ADUSA, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "98, Kroger, COLORADO SPRINGS, CO",
            disabled: false,
          },
          {
            name: "98, Kroger, LAWRENCE, KS",
            disabled: false,
          },
          {
            name: "98, Kroger, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "98, Walmart, BASTROP, LA",
            disabled: false,
          },
          {
            name: "980, ADUSA, TAYLORSVILLE, NC",
            disabled: false,
          },
          {
            name: "980, Albertsons, MESA, AZ",
            disabled: false,
          },
          {
            name: "980, Kroger, NOBLESVILLE, IN",
            disabled: false,
          },
          {
            name: "980, Kroger, Oregon, OH",
            disabled: false,
          },
          {
            name: "980, Walmart, GREELEY, CO",
            disabled: false,
          },
          {
            name: "9800, CVS, DANVILLE, CA",
            disabled: false,
          },
          {
            name: "9800, Walgreens, UTICA, NY",
            disabled: false,
          },
          {
            name: "9801, CVS, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "9801, Walgreens, ALLENTOWN, PA",
            disabled: false,
          },
          {
            name: "9802, CVS, MONTEREY, CA",
            disabled: false,
          },
          {
            name: "9803, CVS, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "9803, Walgreens, OAKMONT, PA",
            disabled: false,
          },
          {
            name: "9804, CVS, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "9804, Walgreens, UNIONTOWN, PA",
            disabled: false,
          },
          {
            name: "9805, CVS, CAMPBELL, CA",
            disabled: false,
          },
          {
            name: "9805, Walgreens, IRMO, SC",
            disabled: false,
          },
          {
            name: "9806, Walgreens, YANKTON, SD",
            disabled: false,
          },
          {
            name: "9807, CVS, SAN BRUNO, CA",
            disabled: false,
          },
          {
            name: "9807, Walgreens, GALLATIN, TN",
            disabled: false,
          },
          {
            name: "9808, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9808, Walgreens, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "9809, CVS, CARMICHAEL, CA",
            disabled: false,
          },
          {
            name: "981, Albertsons, CHANDLER, AZ",
            disabled: false,
          },
          {
            name: "981, CVS, FORT LAUDERDALE, FL",
            disabled: false,
          },
          {
            name: "981, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "981, Kroger, TERRE HAUTE, IN",
            disabled: false,
          },
          {
            name: "981, Target, KENNESAW, GA",
            disabled: false,
          },
          {
            name: "981, Walmart, MERIDIAN, MS",
            disabled: false,
          },
          {
            name: "9810, Walgreens, SEGUIN, TX",
            disabled: false,
          },
          {
            name: "9811, CVS, BURLINGAME, CA",
            disabled: false,
          },
          {
            name: "9811, Walgreens, YORKTOWN, VA",
            disabled: false,
          },
          {
            name: "9812, Walgreens, LONGVIEW, WA",
            disabled: false,
          },
          {
            name: "9813, Walgreens, ROGERS, AR",
            disabled: false,
          },
          {
            name: "9814, CVS, FAIR OAKS, CA",
            disabled: false,
          },
          {
            name: "9815, CVS, WALNUT CREEK, CA",
            disabled: false,
          },
          {
            name: "9815, Walgreens, KINGSBURG, CA",
            disabled: false,
          },
          {
            name: "9816, CVS, CHINO HILLS, CA",
            disabled: false,
          },
          {
            name: "9817, CVS, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "9817, Walgreens, SANTEE, CA",
            disabled: false,
          },
          {
            name: "9818, CVS, EL CAJON, CA",
            disabled: false,
          },
          {
            name: "9818, Walgreens, CROMWELL, CT",
            disabled: false,
          },
          {
            name: "9819, CVS, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "982, Albertsons, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "982, Kroger, STREATOR, IL",
            disabled: false,
          },
          {
            name: "982, Kroger, TOLEDO, OH",
            disabled: false,
          },
          {
            name: "982, Target, PEACHTREE CORNERS, GA",
            disabled: false,
          },
          {
            name: "982, Walmart, OWATONNA, MN",
            disabled: false,
          },
          {
            name: "9820, Walgreens, MERIDEN, CT",
            disabled: false,
          },
          {
            name: "9821, Walgreens, NEW CANAAN, CT",
            disabled: false,
          },
          {
            name: "9822, CVS, UKIAH, CA",
            disabled: false,
          },
          {
            name: "9823, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "9824, Walgreens, JERSEYVILLE, IL",
            disabled: false,
          },
          {
            name: "9826, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "9826, Walgreens, NORTH VERNON, IN",
            disabled: false,
          },
          {
            name: "9827, CVS, CONCORD, CA",
            disabled: false,
          },
          {
            name: "9827, Walgreens, PERU, IN",
            disabled: false,
          },
          {
            name: "9828, CVS, HANFORD, CA",
            disabled: false,
          },
          {
            name: "983, Albertsons, LAKEPORT, CA",
            disabled: false,
          },
          {
            name: "983, CVS, DRACUT, MA",
            disabled: false,
          },
          {
            name: "983, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "983, Kroger, WESTFIELD, IN",
            disabled: false,
          },
          {
            name: "9830, CVS, STOCKTON, CA",
            disabled: false,
          },
          {
            name: "9831, CVS, LA HABRA, CA",
            disabled: false,
          },
          {
            name: "9832, CVS, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "9833, CVS, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "9833, Walgreens, ASHTABULA, OH",
            disabled: false,
          },
          {
            name: "9834, CVS, SARATOGA, CA",
            disabled: false,
          },
          {
            name: "9834, Walgreens, GEORGETOWN, SC",
            disabled: false,
          },
          {
            name: "9835, Walgreens, JACKSON, TN",
            disabled: false,
          },
          {
            name: "9836, Walgreens, WHITE HOUSE, TN",
            disabled: false,
          },
          {
            name: "9837, Walgreens, ASHBURN, VA",
            disabled: false,
          },
          {
            name: "9838, CVS, SUN VALLEY, NV",
            disabled: false,
          },
          {
            name: "9838, Walgreens, LEESBURG, VA",
            disabled: false,
          },
          {
            name: "9839, Walgreens, CUDAHY, WI",
            disabled: false,
          },
          {
            name: "984, Albertsons, CLEARLAKE, CA",
            disabled: false,
          },
          {
            name: "984, CVS, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "984, Kroger, BOURBONNAIS, IL",
            disabled: false,
          },
          {
            name: "984, Kroger, Melissa, TX",
            disabled: false,
          },
          {
            name: "984, Kroger, TROY, OH",
            disabled: false,
          },
          {
            name: "984, Target, MEDINA, OH",
            disabled: false,
          },
          {
            name: "984, Walmart, CASTLE ROCK, CO",
            disabled: false,
          },
          {
            name: "9840, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9840, Walgreens, QUEEN CREEK, AZ",
            disabled: false,
          },
          {
            name: "9842, CVS, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "9842, Walgreens, DOWNEY, CA",
            disabled: false,
          },
          {
            name: "9843, CVS, FALLON, NV",
            disabled: false,
          },
          {
            name: "9843, Walgreens, MISSION VIEJO, CA",
            disabled: false,
          },
          {
            name: "9844, CVS, CAMARILLO, CA",
            disabled: false,
          },
          {
            name: "9844, Walgreens, PORTERVILLE, CA",
            disabled: false,
          },
          {
            name: "9845, Walgreens, ROWLAND HEIGHTS, CA",
            disabled: false,
          },
          {
            name: "9846, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9847, CVS, LAKE ELSINORE, CA",
            disabled: false,
          },
          {
            name: "9847, Walgreens, BEVERLY HILLS, FL",
            disabled: false,
          },
          {
            name: "9849, CVS, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "9849, Walgreens, CORDELE, GA",
            disabled: false,
          },
          {
            name: "985, ADUSA, CHARLOTTE, NC",
            disabled: false,
          },
          {
            name: "985, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "985, Kroger, AVON, IN",
            disabled: false,
          },
          {
            name: "985, Target, STRONGSVILLE, OH",
            disabled: false,
          },
          {
            name: "985, Walmart, FAIRFIELD, IA",
            disabled: false,
          },
          {
            name: "9851, CVS, GLENDORA, CA",
            disabled: false,
          },
          {
            name: "9851, Walgreens, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "9852, CVS, WHITTIER, CA",
            disabled: false,
          },
          {
            name: "9852, Walgreens, URBANA, IL",
            disabled: false,
          },
          {
            name: "9853, CVS, FELTON, CA",
            disabled: false,
          },
          {
            name: "9853, Walgreens, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "9854, Walgreens, NEW ALBANY, IN",
            disabled: false,
          },
          {
            name: "9855, CVS, TRACY, CA",
            disabled: false,
          },
          {
            name: "9855, Walgreens, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "9856, CVS, SUNNYVALE, CA",
            disabled: false,
          },
          {
            name: "9856, Walgreens, FRANKFORT, KY",
            disabled: false,
          },
          {
            name: "9857, Walgreens, LEXINGTON, KY",
            disabled: false,
          },
          {
            name: "9859, CVS, SIMI VALLEY, CA",
            disabled: false,
          },
          {
            name: "986, Albertsons, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "986, Target, FAIRLAWN, OH",
            disabled: false,
          },
          {
            name: "986, Walmart, FRISCO, CO",
            disabled: false,
          },
          {
            name: "9860, Walgreens, BATON ROUGE, LA",
            disabled: false,
          },
          {
            name: "9861, Walgreens, BOUTTE, LA",
            disabled: false,
          },
          {
            name: "9862, CVS, SCOTTS VALLEY, CA",
            disabled: false,
          },
          {
            name: "9862, Walgreens, RAYNE, LA",
            disabled: false,
          },
          {
            name: "9863, CVS, COSTA MESA, CA",
            disabled: false,
          },
          {
            name: "9864, Walgreens, GARDNERVILLE, NV",
            disabled: false,
          },
          {
            name: "9865, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9865, Walgreens, COMMACK, NY",
            disabled: false,
          },
          {
            name: "9866, CVS, MANTECA, CA",
            disabled: false,
          },
          {
            name: "9866, Walgreens, EASTCHESTER, NY",
            disabled: false,
          },
          {
            name: "9868, CVS, SAN RAMON, CA",
            disabled: false,
          },
          {
            name: "9868, Walgreens, MASSAPEQUA, NY",
            disabled: false,
          },
          {
            name: "9869, Walgreens, MIDDLE VILLAGE, NY",
            disabled: false,
          },
          {
            name: "987, ADUSA, NEWPORT NEWS, VA",
            disabled: false,
          },
          {
            name: "987, Albertsons, SANTA FE, NM",
            disabled: false,
          },
          {
            name: "987, CVS, LANSDALE, PA",
            disabled: false,
          },
          {
            name: "987, Kroger, Sandusky, OH",
            disabled: false,
          },
          {
            name: "987, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "987, Kroger, Terre Haute, IN",
            disabled: false,
          },
          {
            name: "987, Walmart, FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "9872, CVS, SEBASTOPOL, CA",
            disabled: false,
          },
          {
            name: "9872, Walgreens, WEBSTER, NY",
            disabled: false,
          },
          {
            name: "9873, CVS, SAN LUIS OBISPO, CA",
            disabled: false,
          },
          {
            name: "9873, Walgreens, CENTERVILLE, OH",
            disabled: false,
          },
          {
            name: "9874, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "9874, Walgreens, ELK CITY, OK",
            disabled: false,
          },
          {
            name: "9875, CVS, PITTSBURG, CA",
            disabled: false,
          },
          {
            name: "9875, Walgreens, LINCOLN CITY, OR",
            disabled: false,
          },
          {
            name: "9876, CVS, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "9876, Walgreens, LANCASTER, PA",
            disabled: false,
          },
          {
            name: "9878, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "9878, Walgreens, STROUDSBURG, PA",
            disabled: false,
          },
          {
            name: "9879, CVS, FOSTER CITY, CA",
            disabled: false,
          },
          {
            name: "9879, Walgreens, ORANGEBURG, SC",
            disabled: false,
          },
          {
            name: "988, CVS, TYLER, TX",
            disabled: false,
          },
          {
            name: "988, Target, STOW, OH",
            disabled: false,
          },
          {
            name: "988, Walmart, LUTZ, FL",
            disabled: false,
          },
          {
            name: "9880, Walgreens, PARAGOULD, AR",
            disabled: false,
          },
          {
            name: "9882, Walgreens, EL SEGUNDO, CA",
            disabled: false,
          },
          {
            name: "9883, Walgreens, IRVINE, CA",
            disabled: false,
          },
          {
            name: "9884, CVS, MODESTO, CA",
            disabled: false,
          },
          {
            name: "9884, Walgreens, MURRIETA, CA",
            disabled: false,
          },
          {
            name: "9885, Walgreens, PALM SPRINGS, CA",
            disabled: false,
          },
          {
            name: "9887, Walgreens, LAKEWOOD, CO",
            disabled: false,
          },
          {
            name: "989, Albertsons, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "989, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "989, Kroger, Monroe, OH",
            disabled: false,
          },
          {
            name: "989, Target, HEATH, OH",
            disabled: false,
          },
          {
            name: "989, Walmart, METAIRIE, LA",
            disabled: false,
          },
          {
            name: "9890, Walgreens, NEWNAN, GA",
            disabled: false,
          },
          {
            name: "9892, CVS, PISMO BEACH, CA",
            disabled: false,
          },
          {
            name: "9892, Walgreens, TAYLORVILLE, IL",
            disabled: false,
          },
          {
            name: "9893, CVS, HANFORD, CA",
            disabled: false,
          },
          {
            name: "9894, CVS, CUPERTINO, CA",
            disabled: false,
          },
          {
            name: "9896, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9896, Walgreens, CLEVELAND, MS",
            disabled: false,
          },
          {
            name: "9897, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9897, Walgreens, KINSTON, NC",
            disabled: false,
          },
          {
            name: "9898, CVS, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "9898, Walgreens, WHITEVILLE, NC",
            disabled: false,
          },
          {
            name: "9899, Walgreens, FREMONT, NE",
            disabled: false,
          },
          {
            name: "99, ADUSA, LOUISBURG, NC",
            disabled: false,
          },
          {
            name: "99, Costco, NA, NA",
            disabled: false,
          },
          {
            name: "99, HEB, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "99, Kroger, FOOTHILL RANCH, CA",
            disabled: false,
          },
          {
            name: "99, Kroger, Fort Collins, CO",
            disabled: false,
          },
          {
            name: "99, Walmart, UNION, MO",
            disabled: false,
          },
          {
            name: "990, CVS, TAMARAC, FL",
            disabled: false,
          },
          {
            name: "990, Kroger, COLUMBUS, OH",
            disabled: false,
          },
          {
            name: "990, Kroger, FORT WAYNE, IN",
            disabled: false,
          },
          {
            name: "990, Kroger, Maywood, IL",
            disabled: false,
          },
          {
            name: "990, Kroger, NACOGDOCHES, TX",
            disabled: false,
          },
          {
            name: "990, Kroger, Romulus, MI",
            disabled: false,
          },
          {
            name: "990, Target, LANCASTER, OH",
            disabled: false,
          },
          {
            name: "990, Walmart, MILTON, FL",
            disabled: false,
          },
          {
            name: "9901, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9902, Walgreens, SPARKS, NV",
            disabled: false,
          },
          {
            name: "9903, Walgreens, YOUNGSTOWN, OH",
            disabled: false,
          },
          {
            name: "9904, CVS, CASTRO VALLEY, CA",
            disabled: false,
          },
          {
            name: "9904, Walgreens, HILLIARD, OH",
            disabled: false,
          },
          {
            name: "9905, CVS, YORBA LINDA, CA",
            disabled: false,
          },
          {
            name: "9906, Walgreens, OXFORD, OH",
            disabled: false,
          },
          {
            name: "9907, Walgreens, BRENTWOOD, TN",
            disabled: false,
          },
          {
            name: "9908, Walgreens, MCKINNEY, TX",
            disabled: false,
          },
          {
            name: "9909, CVS, ATASCADERO, CA",
            disabled: false,
          },
          {
            name: "9909, Walgreens, SACHSE, TX",
            disabled: false,
          },
          {
            name: "991, Albertsons, PEORIA, AZ",
            disabled: false,
          },
          {
            name: "991, Kroger, AUBURN, IN",
            disabled: false,
          },
          {
            name: "991, Kroger, Aurora, CO",
            disabled: false,
          },
          {
            name: "991, Kroger, Columbus, OH",
            disabled: false,
          },
          {
            name: "991, Kroger, Milwaukee, WI",
            disabled: false,
          },
          {
            name: "991, Kroger, Oklahoma City, OK",
            disabled: false,
          },
          {
            name: "991, Kroger, Pleasant Prairie, WI",
            disabled: false,
          },
          {
            name: "991, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "991, Kroger, Seattle, WA",
            disabled: false,
          },
          {
            name: "991, Walmart, MOBILE, AL",
            disabled: false,
          },
          {
            name: "9910, CVS, RIVERSIDE, CA",
            disabled: false,
          },
          {
            name: "9911, Walgreens, YAKIMA, WA",
            disabled: false,
          },
          {
            name: "9912, CVS, DANA POINT, CA",
            disabled: false,
          },
          {
            name: "9912, Walgreens, ALAMOSA, CO",
            disabled: false,
          },
          {
            name: "9913, CVS, MILL VALLEY, CA",
            disabled: false,
          },
          {
            name: "9914, CVS, AUBURN, CA",
            disabled: false,
          },
          {
            name: "9914, Walgreens, DEFUNIAK SPRINGS, FL",
            disabled: false,
          },
          {
            name: "9915, CVS, PALO ALTO, CA",
            disabled: false,
          },
          {
            name: "9915, Walgreens, OAKLAND PARK, FL",
            disabled: false,
          },
          {
            name: "9916, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "9917, CVS, VACAVILLE, CA",
            disabled: false,
          },
          {
            name: "9917, Walgreens, PENSACOLA, FL",
            disabled: false,
          },
          {
            name: "9918, CVS, TEMECULA, CA",
            disabled: false,
          },
          {
            name: "9918, Walgreens, REXBURG, ID",
            disabled: false,
          },
          {
            name: "9919, CVS, TURLOCK, CA",
            disabled: false,
          },
          {
            name: "992, ADUSA, LYNCHBURG, VA",
            disabled: false,
          },
          {
            name: "992, Albertsons, VOORHEES, NJ",
            disabled: false,
          },
          {
            name: "992, CVS, FREEPORT, NY",
            disabled: false,
          },
          {
            name: "992, Kroger, Gurnee, IL",
            disabled: false,
          },
          {
            name: "992, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "992, Kroger, Johnstown, CO",
            disabled: false,
          },
          {
            name: "992, Kroger, San Antonio, TX",
            disabled: false,
          },
          {
            name: "992, Rite Aid, COATESVILLE, PA",
            disabled: false,
          },
          {
            name: "992, Target, CAPE GIRARDEAU, MO",
            disabled: false,
          },
          {
            name: "992, Walmart, TULSA, OK",
            disabled: false,
          },
          {
            name: "9920, Walgreens, CANTON, IL",
            disabled: false,
          },
          {
            name: "9921, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9921, Walgreens, CHAMPAIGN, IL",
            disabled: false,
          },
          {
            name: "9922, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9922, Walgreens, HARRISBURG, IL",
            disabled: false,
          },
          {
            name: "9923, CVS, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "9924, CVS, LAGUNA NIGUEL, CA",
            disabled: false,
          },
          {
            name: "9924, Walgreens, SOUTH HOLLAND, IL",
            disabled: false,
          },
          {
            name: "9925, CVS, PASO ROBLES, CA",
            disabled: false,
          },
          {
            name: "9925, Walgreens, WARRENVILLE, IL",
            disabled: false,
          },
          {
            name: "9926, CVS, LA JOLLA, CA",
            disabled: false,
          },
          {
            name: "9926, Walgreens, FOREST HILL, MD",
            disabled: false,
          },
          {
            name: "9927, CVS, VALLEJO, CA",
            disabled: false,
          },
          {
            name: "9927, Walgreens, SALISBURY, MD",
            disabled: false,
          },
          {
            name: "9928, CVS, ROHNERT PARK, CA",
            disabled: false,
          },
          {
            name: "9929, CVS, OAKLAND, CA",
            disabled: false,
          },
          {
            name: "9929, Walgreens, OZARK, MO",
            disabled: false,
          },
          {
            name: "993, Albertsons, FREMONT, CA",
            disabled: false,
          },
          {
            name: "993, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "993, Kroger, Denver, CO",
            disabled: false,
          },
          {
            name: "993, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "993, Kroger, Louisville, KY",
            disabled: false,
          },
          {
            name: "993, Kroger, Maywood, IL",
            disabled: false,
          },
          {
            name: "993, Target, HOUSTON, TX",
            disabled: false,
          },
          {
            name: "993, Walgreens, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "993, Walmart, MCPHERSON, KS",
            disabled: false,
          },
          {
            name: "9930, Walgreens, HENDERSONVILLE, NC",
            disabled: false,
          },
          {
            name: "9931, CVS, WINDSOR, CA",
            disabled: false,
          },
          {
            name: "9931, Walgreens, WILMINGTON, NC",
            disabled: false,
          },
          {
            name: "9932, CVS, YUBA CITY, CA",
            disabled: false,
          },
          {
            name: "9932, Walgreens, EDISON, NJ",
            disabled: false,
          },
          {
            name: "9933, CVS, CLOVIS, CA",
            disabled: false,
          },
          {
            name: "9933, Walgreens, FLEMINGTON, NJ",
            disabled: false,
          },
          {
            name: "9934, Walgreens, LEDGEWOOD, NJ",
            disabled: false,
          },
          {
            name: "9935, CVS, OAKHURST, CA",
            disabled: false,
          },
          {
            name: "9937, Walgreens, JAMESTOWN, NY",
            disabled: false,
          },
          {
            name: "9938, CVS, LAFAYETTE, CA",
            disabled: false,
          },
          {
            name: "9939, Walgreens, NEWARK, NY",
            disabled: false,
          },
          {
            name: "994, Albertsons, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "994, CVS, PROVIDENCE, RI",
            disabled: false,
          },
          {
            name: "994, Rite Aid, LAKE HIAWATHA, NJ",
            disabled: false,
          },
          {
            name: "994, Walmart, NEW PORT RICHEY, FL",
            disabled: false,
          },
          {
            name: "9940, CVS, SAN MATEO, CA",
            disabled: false,
          },
          {
            name: "9940, Walgreens, HICKSVILLE, NY",
            disabled: false,
          },
          {
            name: "9941, CVS, BERKELEY, CA",
            disabled: false,
          },
          {
            name: "9942, CVS, SAN LEANDRO, CA",
            disabled: false,
          },
          {
            name: "9942, Walgreens, BEAVER FALLS, PA",
            disabled: false,
          },
          {
            name: "9943, CVS, LAKEPORT, CA",
            disabled: false,
          },
          {
            name: "9944, CVS, SANTA CLARA, CA",
            disabled: false,
          },
          {
            name: "9945, Walgreens, SHELBYVILLE, TN",
            disabled: false,
          },
          {
            name: "9946, CVS, SANTA ROSA, CA",
            disabled: false,
          },
          {
            name: "9946, Walgreens, CYPRESS, TX",
            disabled: false,
          },
          {
            name: "9947, CVS, NOVATO, CA",
            disabled: false,
          },
          {
            name: "9947, Walgreens, RED OAK, TX",
            disabled: false,
          },
          {
            name: "9948, Walgreens, ABINGDON, VA",
            disabled: false,
          },
          {
            name: "9949, CVS, RIPON, CA",
            disabled: false,
          },
          {
            name: "9949, Walgreens, ALDIE, VA",
            disabled: false,
          },
          {
            name: "995, ADUSA, COOKEVILLE, TN",
            disabled: false,
          },
          {
            name: "995, Albertsons, SAN FRANCISCO, CA",
            disabled: false,
          },
          {
            name: "995, CVS, MILLIS, MA",
            disabled: false,
          },
          {
            name: "995, Kroger, Blue Ash, OH",
            disabled: false,
          },
          {
            name: "995, Kroger, Dallas, TX",
            disabled: false,
          },
          {
            name: "995, Kroger, Forest Park, GA",
            disabled: false,
          },
          {
            name: "995, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "995, Kroger, Lake Charles, LA",
            disabled: false,
          },
          {
            name: "995, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "995, Rite Aid, WAYNE, PA",
            disabled: false,
          },
          {
            name: "995, Target, REDMOND, WA",
            disabled: false,
          },
          {
            name: "995, Walmart, FRANKLIN, IN",
            disabled: false,
          },
          {
            name: "9950, CVS, DIXON, CA",
            disabled: false,
          },
          {
            name: "9950, Walgreens, CARNEGIE, PA",
            disabled: false,
          },
          {
            name: "9951, CVS, SALINAS, CA",
            disabled: false,
          },
          {
            name: "9951, Walgreens, ALABASTER, AL",
            disabled: false,
          },
          {
            name: "9952, Walgreens, MARANA, AZ",
            disabled: false,
          },
          {
            name: "9953, Walgreens, TUCSON, AZ",
            disabled: false,
          },
          {
            name: "9955, Walgreens, PATTERSON, CA",
            disabled: false,
          },
          {
            name: "9956, Walgreens, CLEWISTON, FL",
            disabled: false,
          },
          {
            name: "9958, CVS, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "9959, CVS, ESCONDIDO, CA",
            disabled: false,
          },
          {
            name: "9959, Walgreens, MERRITT ISLAND, FL",
            disabled: false,
          },
          {
            name: "996, Albertsons, SEA ISLE CITY, NJ",
            disabled: false,
          },
          {
            name: "996, CVS, CLIFTON PARK, NY",
            disabled: false,
          },
          {
            name: "996, Target, ISSAQUAH, WA",
            disabled: false,
          },
          {
            name: "996, Walmart, SPENCER, IN",
            disabled: false,
          },
          {
            name: "9960, CVS, CAPITOLA, CA",
            disabled: false,
          },
          {
            name: "9961, CVS, SAN MARCOS, CA",
            disabled: false,
          },
          {
            name: "9963, CVS, SAN DIEGO, CA",
            disabled: false,
          },
          {
            name: "9964, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9965, Walgreens, RANTOUL, IL",
            disabled: false,
          },
          {
            name: "9966, Walgreens, WESTFORD, MA",
            disabled: false,
          },
          {
            name: "9967, CVS, LAS VEGAS, NV",
            disabled: false,
          },
          {
            name: "9967, Walgreens, EASTON, MD",
            disabled: false,
          },
          {
            name: "997, Albertsons, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "997, CVS, GLEN COVE, NY",
            disabled: false,
          },
          {
            name: "997, Target, LA MESA, CA",
            disabled: false,
          },
          {
            name: "9970, CVS, BUELLTON, CA",
            disabled: false,
          },
          {
            name: "9970, Walgreens, HOOKSETT, NH",
            disabled: false,
          },
          {
            name: "9971, CVS, FRESNO, CA",
            disabled: false,
          },
          {
            name: "9971, Walgreens, ALBANY, NY",
            disabled: false,
          },
          {
            name: "9972, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "9972, Walgreens, YONKERS, NY",
            disabled: false,
          },
          {
            name: "9973, CVS, WEAVERVILLE, CA",
            disabled: false,
          },
          {
            name: "9974, CVS, RENO, NV",
            disabled: false,
          },
          {
            name: "9974, Walgreens, SPRINGVILLE, UT",
            disabled: false,
          },
          {
            name: "9975, CVS, BAKERSFIELD, CA",
            disabled: false,
          },
          {
            name: "9975, Walgreens, WILLIAMSBURG, VA",
            disabled: false,
          },
          {
            name: "9976, Walgreens, DECATUR, AL",
            disabled: false,
          },
          {
            name: "9978, CVS, GRANADA HILLS, CA",
            disabled: false,
          },
          {
            name: "9978, Walgreens, BRENTWOOD, CA",
            disabled: false,
          },
          {
            name: "9979, CVS, REDDING, CA",
            disabled: false,
          },
          {
            name: "9979, Walgreens, FORT MORGAN, CO",
            disabled: false,
          },
          {
            name: "998, ADUSA, CONCORD, NC",
            disabled: false,
          },
          {
            name: "998, Albertsons, HEALDSBURG, CA",
            disabled: false,
          },
          {
            name: "998, CVS, TAMPA, FL",
            disabled: false,
          },
          {
            name: "998, Kroger, INDIANAPOLIS, IN",
            disabled: false,
          },
          {
            name: "998, Kroger, Independence, KY",
            disabled: false,
          },
          {
            name: "998, Kroger, Phoenix, AZ",
            disabled: false,
          },
          {
            name: "998, Kroger, Portland, OR",
            disabled: false,
          },
          {
            name: "998, Walmart, WESTWOOD, KS",
            disabled: false,
          },
          {
            name: "9980, CVS, FOLSOM, CA",
            disabled: false,
          },
          {
            name: "9980, Walgreens, BRADENTON, FL",
            disabled: false,
          },
          {
            name: "9981, CVS, CARSON CITY, NV",
            disabled: false,
          },
          {
            name: "9981, Walgreens, CANTON, GA",
            disabled: false,
          },
          {
            name: "9982, CVS, LOS GATOS, CA",
            disabled: false,
          },
          {
            name: "9983, CVS, KINGSBURG, CA",
            disabled: false,
          },
          {
            name: "9983, Walgreens, BLOOMINGTON, IL",
            disabled: false,
          },
          {
            name: "9984, Walgreens, PLAINFIELD, IL",
            disabled: false,
          },
          {
            name: "9985, CVS, LOS ANGELES, CA",
            disabled: false,
          },
          {
            name: "9985, Walgreens, LEAWOOD, KS",
            disabled: false,
          },
          {
            name: "9986, CVS, MADERA, CA",
            disabled: false,
          },
          {
            name: "9986, Walgreens, KIRKSVILLE, MO",
            disabled: false,
          },
          {
            name: "9987, CVS, MOUNTAIN VIEW, CA",
            disabled: false,
          },
          {
            name: "9987, Walgreens, WAKE FOREST, NC",
            disabled: false,
          },
          {
            name: "9988, Walgreens, WASHINGTON, NC",
            disabled: false,
          },
          {
            name: "9989, CVS, MARTINEZ, CA",
            disabled: false,
          },
          {
            name: "999, ADUSA, SANFORD, NC",
            disabled: false,
          },
          {
            name: "999, Albertsons, FOSTER CITY, CA",
            disabled: false,
          },
          {
            name: "999, Walmart, SAN ANTONIO, TX",
            disabled: false,
          },
          {
            name: "9990, Walgreens, COVINGTON, LA",
            disabled: false,
          },
          {
            name: "9991, CVS, ALAMO, CA",
            disabled: false,
          },
          {
            name: "9991, Walgreens, ALAMOGORDO, NM",
            disabled: false,
          },
          {
            name: "9992, CVS, SACRAMENTO, CA",
            disabled: false,
          },
          {
            name: "9992, Walgreens, ROCHESTER, NY",
            disabled: false,
          },
          {
            name: "9993, CVS, ROSEVILLE, CA",
            disabled: false,
          },
          {
            name: "9994, Walgreens, EASTON, PA",
            disabled: false,
          },
          {
            name: "9995, CVS, SAN JOSE, CA",
            disabled: false,
          },
          {
            name: "9995, Walgreens, WEST WARWICK, RI",
            disabled: false,
          },
          {
            name: "9996, CVS, NORTH FORT MYERS, FL",
            disabled: false,
          },
          {
            name: "9996, Walgreens, GAFFNEY, SC",
            disabled: false,
          },
          {
            name: "9997, Walgreens, BOGALUSA, LA",
            disabled: false,
          },
          {
            name: "9998, Walgreens, BOSSIER CITY, LA",
            disabled: false,
          },
        ],
        value: "",
      },
      brand: {
        options: [
          {
            name: "CAL-C-TOSE",
            disabled: false,
          },
          {
            name: "ENFAGROW",
            disabled: false,
          },
          {
            name: "ENFAMIL",
            disabled: false,
          },
          {
            name: "ENFAMIL WIC",
            disabled: false,
          },
          {
            name: "NUTRAMIGEN",
            disabled: false,
          },
          {
            name: "NUTRAMIGEN / ALLERGY",
            disabled: false,
          },
          {
            name: "OTHER",
            disabled: false,
          },
          {
            name: "PREGESTIMIL",
            disabled: false,
          },
          {
            name: "PURAMINO/AA",
            disabled: false,
          },
          {
            name: "SPECIALTY",
            disabled: false,
          },
          {
            name: "SUPER HIGH PREMIUM",
            disabled: false,
          },
          {
            name: "TIGER'S MILK",
            disabled: false,
          },
          {
            name: "UNKNOWN",
            disabled: false,
          },
          {
            name: "VITAMINS",
            disabled: false,
          },
        ],
        value: "",
      },
      sku: {
        options: [
          {
            name: "000000000001014853",
            disabled: false,
          },
          {
            name: "000000000001014859",
            disabled: false,
          },
          {
            name: "000000000001014867",
            disabled: false,
          },
          {
            name: "000000000001014875",
            disabled: false,
          },
          {
            name: "000000000001014879",
            disabled: false,
          },
          {
            name: "000000000001014914",
            disabled: false,
          },
          {
            name: "000000000001014973",
            disabled: false,
          },
          {
            name: "000000000001014974",
            disabled: false,
          },
          {
            name: "000000000001015176",
            disabled: false,
          },
          {
            name: "000000000001118909",
            disabled: false,
          },
          {
            name: "000000000001136743",
            disabled: false,
          },
          {
            name: "000000000001154529",
            disabled: false,
          },
          {
            name: "000000000001155767",
            disabled: false,
          },
          {
            name: "000000000001158652",
            disabled: false,
          },
          {
            name: "000000000001158653",
            disabled: false,
          },
          {
            name: "000000000001158655",
            disabled: false,
          },
          {
            name: "000000000001180725",
            disabled: false,
          },
          {
            name: "000000000001184780",
            disabled: false,
          },
          {
            name: "000000000001214865",
            disabled: false,
          },
          {
            name: "000000000001215080",
            disabled: false,
          },
          {
            name: "000000000001222393",
            disabled: false,
          },
          {
            name: "000000000001222396",
            disabled: false,
          },
          {
            name: "000000000001222438",
            disabled: false,
          },
          {
            name: "000000000001238597",
            disabled: false,
          },
          {
            name: "000000000001249544",
            disabled: false,
          },
          {
            name: "000000000001249569",
            disabled: false,
          },
          {
            name: "000000000001249594",
            disabled: false,
          },
          {
            name: "000000000001249683",
            disabled: false,
          },
          {
            name: "000000000001249684",
            disabled: false,
          },
          {
            name: "000000000001253140",
            disabled: false,
          },
          {
            name: "000000000001253339",
            disabled: false,
          },
          {
            name: "000000000001257766",
            disabled: false,
          },
          {
            name: "000000000001258556",
            disabled: false,
          },
          {
            name: "000000000001263203",
            disabled: false,
          },
          {
            name: "000000000001263204",
            disabled: false,
          },
          {
            name: "000000000001279321",
            disabled: false,
          },
          {
            name: "000000000001281223",
            disabled: false,
          },
          {
            name: "000000000001281334",
            disabled: false,
          },
          {
            name: "000000000001281335",
            disabled: false,
          },
          {
            name: "000000000001281386",
            disabled: false,
          },
          {
            name: "000000000001281389",
            disabled: false,
          },
          {
            name: "000000000001282186",
            disabled: false,
          },
          {
            name: "000000000001282188",
            disabled: false,
          },
          {
            name: "000000000001282194",
            disabled: false,
          },
          {
            name: "000000000001284527",
            disabled: false,
          },
          {
            name: "000000000002004134",
            disabled: false,
          },
          {
            name: "000000000002004136",
            disabled: false,
          },
          {
            name: "000000000002004137",
            disabled: false,
          },
          {
            name: "000000000002004138",
            disabled: false,
          },
          {
            name: "000000000002004540",
            disabled: false,
          },
          {
            name: "000000000002004827",
            disabled: false,
          },
          {
            name: "000000000002004828",
            disabled: false,
          },
          {
            name: "000000000002005272",
            disabled: false,
          },
          {
            name: "000000000002005273",
            disabled: false,
          },
          {
            name: "000000000002005349",
            disabled: false,
          },
          {
            name: "000000000002009112",
            disabled: false,
          },
          {
            name: "000000000002009495",
            disabled: false,
          },
          {
            name: "000000000002011692",
            disabled: false,
          },
          {
            name: "000000000002014835",
            disabled: false,
          },
          {
            name: "000000000002014836",
            disabled: false,
          },
          {
            name: "000000000002014845",
            disabled: false,
          },
          {
            name: "000000000002014859",
            disabled: false,
          },
          {
            name: "000000000002015027",
            disabled: false,
          },
          {
            name: "000000000002015466",
            disabled: false,
          },
          {
            name: "000000000002015590",
            disabled: false,
          },
          {
            name: "000000000002015891",
            disabled: false,
          },
          {
            name: "000000000002015919",
            disabled: false,
          },
          {
            name: "000000000002017043",
            disabled: false,
          },
          {
            name: "000000000002019905",
            disabled: false,
          },
          {
            name: "000000000002020043",
            disabled: false,
          },
          {
            name: "000000000002020391",
            disabled: false,
          },
          {
            name: "000000000002026159",
            disabled: false,
          },
          {
            name: "000000000002026652",
            disabled: false,
          },
          {
            name: "000000000002027723",
            disabled: false,
          },
          {
            name: "000000000002027724",
            disabled: false,
          },
          {
            name: "000000000002031754",
            disabled: false,
          },
          {
            name: "000000000002031755",
            disabled: false,
          },
          {
            name: "000000000002031757",
            disabled: false,
          },
          {
            name: "000000000002031758",
            disabled: false,
          },
          {
            name: "000000000002032762",
            disabled: false,
          },
          {
            name: "000000000002032919",
            disabled: false,
          },
          {
            name: "000000000002033873",
            disabled: false,
          },
          {
            name: "000000000002033874",
            disabled: false,
          },
          {
            name: "000000000002034683",
            disabled: false,
          },
          {
            name: "000000000002036040",
            disabled: false,
          },
          {
            name: "000000000002036044",
            disabled: false,
          },
          {
            name: "000000000002036208",
            disabled: false,
          },
          {
            name: "000000000002036236",
            disabled: false,
          },
          {
            name: "000000000002036457",
            disabled: false,
          },
          {
            name: "000000000002038262",
            disabled: false,
          },
          {
            name: "000000000002038263",
            disabled: false,
          },
          {
            name: "000000000002038264",
            disabled: false,
          },
          {
            name: "000000000002038449",
            disabled: false,
          },
          {
            name: "000000000002039209",
            disabled: false,
          },
          {
            name: "000000000002039211",
            disabled: false,
          },
          {
            name: "000000000002039637",
            disabled: false,
          },
          {
            name: "000000000002039732",
            disabled: false,
          },
          {
            name: "000000000002039733",
            disabled: false,
          },
          {
            name: "000000000002039734",
            disabled: false,
          },
          {
            name: "000000000002039738",
            disabled: false,
          },
          {
            name: "000000000002039763",
            disabled: false,
          },
          {
            name: "000000000002039770",
            disabled: false,
          },
          {
            name: "000000000002039832",
            disabled: false,
          },
          {
            name: "000000000002039898",
            disabled: false,
          },
          {
            name: "000000000002039900",
            disabled: false,
          },
          {
            name: "000000000002039902",
            disabled: false,
          },
          {
            name: "000000000002039921",
            disabled: false,
          },
          {
            name: "000000000002040258",
            disabled: false,
          },
          {
            name: "000000000002040264",
            disabled: false,
          },
          {
            name: "000000000002040671",
            disabled: false,
          },
          {
            name: "000000000002040672",
            disabled: false,
          },
          {
            name: "000000000002041779",
            disabled: false,
          },
          {
            name: "000000000002042059",
            disabled: false,
          },
          {
            name: "000000000002044678",
            disabled: false,
          },
          {
            name: "000000000002044694",
            disabled: false,
          },
          {
            name: "000000000002044704",
            disabled: false,
          },
          {
            name: "000000000002044707",
            disabled: false,
          },
          {
            name: "000000000002044708",
            disabled: false,
          },
          {
            name: "000000000002044709",
            disabled: false,
          },
          {
            name: "000000000002044710",
            disabled: false,
          },
          {
            name: "000000000002044711",
            disabled: false,
          },
          {
            name: "000000000002044769",
            disabled: false,
          },
          {
            name: "000000000002044905",
            disabled: false,
          },
          {
            name: "000000000002046009",
            disabled: false,
          },
          {
            name: "000000000002047242",
            disabled: false,
          },
          {
            name: "000000000002047244",
            disabled: false,
          },
          {
            name: "000000000002047296",
            disabled: false,
          },
          {
            name: "000000000002047297",
            disabled: false,
          },
          {
            name: "000000000002047298",
            disabled: false,
          },
          {
            name: "000000000002047888",
            disabled: false,
          },
          {
            name: "000000000002048143",
            disabled: false,
          },
          {
            name: "000000000002048526",
            disabled: false,
          },
          {
            name: "000000000002048566",
            disabled: false,
          },
          {
            name: "000000000002048589",
            disabled: false,
          },
          {
            name: "000000000002048665",
            disabled: false,
          },
          {
            name: "000000000002048674",
            disabled: false,
          },
          {
            name: "000000000002049518",
            disabled: false,
          },
          {
            name: "000000000002049717",
            disabled: false,
          },
          {
            name: "000000000002050291",
            disabled: false,
          },
          {
            name: "000000000002050292",
            disabled: false,
          },
          {
            name: "000000000002050660",
            disabled: false,
          },
          {
            name: "000000000002050661",
            disabled: false,
          },
          {
            name: "000000000002050676",
            disabled: false,
          },
          {
            name: "000000000002050691",
            disabled: false,
          },
          {
            name: "000000000002050728",
            disabled: false,
          },
          {
            name: "000000000002050879",
            disabled: false,
          },
          {
            name: "000000000002050880",
            disabled: false,
          },
          {
            name: "000000000002050961",
            disabled: false,
          },
          {
            name: "000000000002051530",
            disabled: false,
          },
          {
            name: "000000000002051531",
            disabled: false,
          },
          {
            name: "000000000002051560",
            disabled: false,
          },
          {
            name: "000000000002051562",
            disabled: false,
          },
          {
            name: "000000000002051716",
            disabled: false,
          },
          {
            name: "000000000002051717",
            disabled: false,
          },
          {
            name: "000000000002052095",
            disabled: false,
          },
          {
            name: "000000000002053268",
            disabled: false,
          },
          {
            name: "000000000002053275",
            disabled: false,
          },
          {
            name: "000000000002054037",
            disabled: false,
          },
          {
            name: "000000000002055320",
            disabled: false,
          },
          {
            name: "000000000002055489",
            disabled: false,
          },
          {
            name: "000000000002055490",
            disabled: false,
          },
          {
            name: "000000000002055491",
            disabled: false,
          },
          {
            name: "000000000002055621",
            disabled: false,
          },
          {
            name: "000000000002055749",
            disabled: false,
          },
          {
            name: "000000000002055825",
            disabled: false,
          },
          {
            name: "000000000002055911",
            disabled: false,
          },
          {
            name: "000000000003118127",
            disabled: false,
          },
          {
            name: "000000000003119481",
            disabled: false,
          },
          {
            name: "000000000003122900",
            disabled: false,
          },
          {
            name: "000000000003123461",
            disabled: false,
          },
          {
            name: "000000000003125594",
            disabled: false,
          },
          {
            name: "000000000003125595",
            disabled: false,
          },
          {
            name: "000000000003127347",
            disabled: false,
          },
          {
            name: "000000000003127348",
            disabled: false,
          },
          {
            name: "000000000003127349",
            disabled: false,
          },
          {
            name: "000000000003127350",
            disabled: false,
          },
          {
            name: "000000000003127910",
            disabled: false,
          },
          {
            name: "000000000003129124",
            disabled: false,
          },
          {
            name: "000000000003130631",
            disabled: false,
          },
          {
            name: "000000000003132091",
            disabled: false,
          },
          {
            name: "000000000003132598",
            disabled: false,
          },
          {
            name: "000000000003135247",
            disabled: false,
          },
          {
            name: "000000000003139376",
            disabled: false,
          },
          {
            name: "000000000003140312",
            disabled: false,
          },
          {
            name: "000000000003141465",
            disabled: false,
          },
          {
            name: "000000000003142820",
            disabled: false,
          },
          {
            name: "000000000003144851",
            disabled: false,
          },
          {
            name: "000000000003144852",
            disabled: false,
          },
          {
            name: "000000000003158115",
            disabled: false,
          },
          {
            name: "000000000003158116",
            disabled: false,
          },
          {
            name: "000000000003168590",
            disabled: false,
          },
          {
            name: "000000000003168591",
            disabled: false,
          },
          {
            name: "000000000003168592",
            disabled: false,
          },
          {
            name: "000000000003168804",
            disabled: false,
          },
          {
            name: "000000000003168834",
            disabled: false,
          },
          {
            name: "000000000003169719",
            disabled: false,
          },
          {
            name: "000000000003170182",
            disabled: false,
          },
          {
            name: "000000000003170779",
            disabled: false,
          },
          {
            name: "000000000003170799",
            disabled: false,
          },
          {
            name: "000000000003172812",
            disabled: false,
          },
          {
            name: "000000000003172815",
            disabled: false,
          },
          {
            name: "000000000003172817",
            disabled: false,
          },
          {
            name: "000000000003172819",
            disabled: false,
          },
          {
            name: "000000000003173152",
            disabled: false,
          },
          {
            name: "000000000003173307",
            disabled: false,
          },
          {
            name: "000000000003173309",
            disabled: false,
          },
          {
            name: "000000000003173461",
            disabled: false,
          },
          {
            name: "000000000003173463",
            disabled: false,
          },
          {
            name: "000000000003173465",
            disabled: false,
          },
          {
            name: "000000000003174378",
            disabled: false,
          },
          {
            name: "000000000003176714",
            disabled: false,
          },
          {
            name: "000000000003177226",
            disabled: false,
          },
          {
            name: "000000000003179305",
            disabled: false,
          },
          {
            name: "000000000003179307",
            disabled: false,
          },
          {
            name: "000000000003179882",
            disabled: false,
          },
          {
            name: "000000000003180047",
            disabled: false,
          },
          {
            name: "000000000003180063",
            disabled: false,
          },
          {
            name: "000000000003180081",
            disabled: false,
          },
          {
            name: "000000000003180082",
            disabled: false,
          },
          {
            name: "000000000003180085",
            disabled: false,
          },
          {
            name: "000000000003180902",
            disabled: false,
          },
          {
            name: "000000000003181651",
            disabled: false,
          },
          {
            name: "000000000003182320",
            disabled: false,
          },
          {
            name: "000000000003186640",
            disabled: false,
          },
          {
            name: "000000000003186651",
            disabled: false,
          },
          {
            name: "000000000003188849",
            disabled: false,
          },
          {
            name: "000000000003189345",
            disabled: false,
          },
          {
            name: "000000000003189347",
            disabled: false,
          },
          {
            name: "000000000003192028",
            disabled: false,
          },
          {
            name: "000000000003192255",
            disabled: false,
          },
          {
            name: "000000000003192257",
            disabled: false,
          },
          {
            name: "000000000003194693",
            disabled: false,
          },
          {
            name: "000000000003194694",
            disabled: false,
          },
          {
            name: "000000000003194722",
            disabled: false,
          },
          {
            name: "000000000003194901",
            disabled: false,
          },
          {
            name: "000000000003198879",
            disabled: false,
          },
          {
            name: "000000000003199413",
            disabled: false,
          },
          {
            name: "000000000003199418",
            disabled: false,
          },
          {
            name: "000000000003200488",
            disabled: false,
          },
          {
            name: "000000000003204862",
            disabled: false,
          },
          {
            name: "000000000003204863",
            disabled: false,
          },
          {
            name: "000000000003204864",
            disabled: false,
          },
          {
            name: "000000000003208432",
            disabled: false,
          },
          {
            name: "000000000003208434",
            disabled: false,
          },
          {
            name: "000000000003208437",
            disabled: false,
          },
          {
            name: "000000000003209663",
            disabled: false,
          },
          {
            name: "000000000003209701",
            disabled: false,
          },
          {
            name: "000000000003215262",
            disabled: false,
          },
          {
            name: "000000000003219261",
            disabled: false,
          },
          {
            name: "000000000003220010",
            disabled: false,
          },
          {
            name: "000000000003220012",
            disabled: false,
          },
          {
            name: "000000000003221965",
            disabled: false,
          },
          {
            name: "000000000003222120",
            disabled: false,
          },
          {
            name: "000000000003223536",
            disabled: false,
          },
          {
            name: "000000000003226132",
            disabled: false,
          },
          {
            name: "000000000003263944",
            disabled: false,
          },
          {
            name: "000000000003264230",
            disabled: false,
          },
          {
            name: "000000000003264232",
            disabled: false,
          },
          {
            name: "000000000003265162",
            disabled: false,
          },
          {
            name: "000000000003267532",
            disabled: false,
          },
          {
            name: "000000000003267765",
            disabled: false,
          },
          {
            name: "000000000003268271",
            disabled: false,
          },
          {
            name: "000000000003270361",
            disabled: false,
          },
          {
            name: "000000000003271278",
            disabled: false,
          },
          {
            name: "000000000003271279",
            disabled: false,
          },
          {
            name: "000000000003271367",
            disabled: false,
          },
          {
            name: "000000000003271390",
            disabled: false,
          },
          {
            name: "000000000003272246",
            disabled: false,
          },
          {
            name: "000000030087511520",
            disabled: false,
          },
          {
            name: "1014867",
            disabled: false,
          },
          {
            name: "1014875",
            disabled: false,
          },
          {
            name: "1014879",
            disabled: false,
          },
          {
            name: "1014973",
            disabled: false,
          },
          {
            name: "1014974",
            disabled: false,
          },
          {
            name: "1015176",
            disabled: false,
          },
          {
            name: "1154529",
            disabled: false,
          },
          {
            name: "1158652",
            disabled: false,
          },
          {
            name: "1158655",
            disabled: false,
          },
          {
            name: "1191879",
            disabled: false,
          },
          {
            name: "1222396",
            disabled: false,
          },
          {
            name: "1222438",
            disabled: false,
          },
          {
            name: "1238597",
            disabled: false,
          },
          {
            name: "1249544",
            disabled: false,
          },
          {
            name: "1249683",
            disabled: false,
          },
          {
            name: "1249684",
            disabled: false,
          },
          {
            name: "1253140",
            disabled: false,
          },
          {
            name: "1253339",
            disabled: false,
          },
          {
            name: "1257766",
            disabled: false,
          },
          {
            name: "1281223",
            disabled: false,
          },
          {
            name: "1282188",
            disabled: false,
          },
          {
            name: "1282194",
            disabled: false,
          },
          {
            name: "13372",
            disabled: false,
          },
          {
            name: "2009112",
            disabled: false,
          },
          {
            name: "2015590",
            disabled: false,
          },
          {
            name: "2015919",
            disabled: false,
          },
          {
            name: "2026652",
            disabled: false,
          },
          {
            name: "2027723",
            disabled: false,
          },
          {
            name: "2027724",
            disabled: false,
          },
          {
            name: "2033125",
            disabled: false,
          },
          {
            name: "2033873",
            disabled: false,
          },
          {
            name: "2038262",
            disabled: false,
          },
          {
            name: "2038263",
            disabled: false,
          },
          {
            name: "2039733",
            disabled: false,
          },
          {
            name: "2039738",
            disabled: false,
          },
          {
            name: "2039769",
            disabled: false,
          },
          {
            name: "2039832",
            disabled: false,
          },
          {
            name: "2044678",
            disabled: false,
          },
          {
            name: "2044694",
            disabled: false,
          },
          {
            name: "2044704",
            disabled: false,
          },
          {
            name: "2044708",
            disabled: false,
          },
          {
            name: "2044769",
            disabled: false,
          },
          {
            name: "2044859",
            disabled: false,
          },
          {
            name: "2044905",
            disabled: false,
          },
          {
            name: "2048566",
            disabled: false,
          },
          {
            name: "2048589",
            disabled: false,
          },
          {
            name: "2049518",
            disabled: false,
          },
          {
            name: "2049717",
            disabled: false,
          },
          {
            name: "2050660",
            disabled: false,
          },
          {
            name: "2050661",
            disabled: false,
          },
          {
            name: "2050676",
            disabled: false,
          },
          {
            name: "2050691",
            disabled: false,
          },
          {
            name: "2050728",
            disabled: false,
          },
          {
            name: "2050879",
            disabled: false,
          },
          {
            name: "2050880",
            disabled: false,
          },
          {
            name: "2051530",
            disabled: false,
          },
          {
            name: "2051531",
            disabled: false,
          },
          {
            name: "2051560",
            disabled: false,
          },
          {
            name: "2051562",
            disabled: false,
          },
          {
            name: "2051717",
            disabled: false,
          },
          {
            name: "2055320",
            disabled: false,
          },
          {
            name: "2055489",
            disabled: false,
          },
          {
            name: "2055490",
            disabled: false,
          },
          {
            name: "2055491",
            disabled: false,
          },
          {
            name: "2055825",
            disabled: false,
          },
          {
            name: "3050951",
            disabled: false,
          },
          {
            name: "3073079",
            disabled: false,
          },
          {
            name: "3118127",
            disabled: false,
          },
          {
            name: "3119481",
            disabled: false,
          },
          {
            name: "3123461",
            disabled: false,
          },
          {
            name: "3125594",
            disabled: false,
          },
          {
            name: "3125595",
            disabled: false,
          },
          {
            name: "3127349",
            disabled: false,
          },
          {
            name: "3127910",
            disabled: false,
          },
          {
            name: "3129124",
            disabled: false,
          },
          {
            name: "3130631",
            disabled: false,
          },
          {
            name: "3142820",
            disabled: false,
          },
          {
            name: "3158115",
            disabled: false,
          },
          {
            name: "3158116",
            disabled: false,
          },
          {
            name: "3168590",
            disabled: false,
          },
          {
            name: "3168591",
            disabled: false,
          },
          {
            name: "3168592",
            disabled: false,
          },
          {
            name: "3168804",
            disabled: false,
          },
          {
            name: "3168834",
            disabled: false,
          },
          {
            name: "3170182",
            disabled: false,
          },
          {
            name: "3173309",
            disabled: false,
          },
          {
            name: "3173463",
            disabled: false,
          },
          {
            name: "3176714",
            disabled: false,
          },
          {
            name: "3179305",
            disabled: false,
          },
          {
            name: "3179307",
            disabled: false,
          },
          {
            name: "3179882",
            disabled: false,
          },
          {
            name: "3180047",
            disabled: false,
          },
          {
            name: "3180063",
            disabled: false,
          },
          {
            name: "3180081",
            disabled: false,
          },
          {
            name: "3180082",
            disabled: false,
          },
          {
            name: "3180085",
            disabled: false,
          },
          {
            name: "3180902",
            disabled: false,
          },
          {
            name: "3181651",
            disabled: false,
          },
          {
            name: "3186640",
            disabled: false,
          },
          {
            name: "3189345",
            disabled: false,
          },
          {
            name: "3189347",
            disabled: false,
          },
          {
            name: "3192028",
            disabled: false,
          },
          {
            name: "3192255",
            disabled: false,
          },
          {
            name: "3192257",
            disabled: false,
          },
          {
            name: "3198879",
            disabled: false,
          },
          {
            name: "3199413",
            disabled: false,
          },
          {
            name: "3199418",
            disabled: false,
          },
          {
            name: "3200488",
            disabled: false,
          },
          {
            name: "3204862",
            disabled: false,
          },
          {
            name: "3204863",
            disabled: false,
          },
          {
            name: "3204864",
            disabled: false,
          },
          {
            name: "3208434",
            disabled: false,
          },
          {
            name: "3208437",
            disabled: false,
          },
          {
            name: "3209663",
            disabled: false,
          },
          {
            name: "3209701",
            disabled: false,
          },
          {
            name: "3219261",
            disabled: false,
          },
          {
            name: "3221965",
            disabled: false,
          },
          {
            name: "3222120",
            disabled: false,
          },
          {
            name: "3226132",
            disabled: false,
          },
          {
            name: "3263944",
            disabled: false,
          },
          {
            name: "3264229",
            disabled: false,
          },
          {
            name: "3264230",
            disabled: false,
          },
          {
            name: "3264232",
            disabled: false,
          },
          {
            name: "3265162",
            disabled: false,
          },
          {
            name: "3267532",
            disabled: false,
          },
          {
            name: "3268271",
            disabled: false,
          },
          {
            name: "3271279",
            disabled: false,
          },
          {
            name: "3271390",
            disabled: false,
          },
          {
            name: "3272246",
            disabled: false,
          },
          {
            name: "3300579",
            disabled: false,
          },
          {
            name: "3300606",
            disabled: false,
          },
          {
            name: "51700-78239-03",
            disabled: false,
          },
          {
            name: "ENFAGROW0030087510337",
            disabled: false,
          },
          {
            name: "ENFAGROW0030087511414",
            disabled: false,
          },
          {
            name: "ENFAGROW0030087511961",
            disabled: false,
          },
          {
            name: "ENFAGROW0030087513075",
            disabled: false,
          },
          {
            name: "ENFAMIL WIC0030087121441",
            disabled: false,
          },
          {
            name: "ENFAMIL WIC0083997700961",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087136548",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087510242",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512125",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512127",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512129",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512365",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512643",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512748",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512749",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512750",
            disabled: false,
          },
          {
            name: "ENFAMIL0030087512751",
            disabled: false,
          },
          {
            name: "ENFAMIL0083997700961",
            disabled: false,
          },
          {
            name: "ENFAMIL0085080300248",
            disabled: false,
          },
          {
            name: "ENFAMIL0085080300252",
            disabled: false,
          },
          {
            name: "ENFAMILUNKNOWN",
            disabled: false,
          },
          {
            name: "NUTRAMIGEN / ALLERGY0030087510480",
            disabled: false,
          },
          {
            name: "NUTRAMIGEN / ALLERGY0030087510734",
            disabled: false,
          },
          {
            name: "NUTRAMIGEN / ALLERGY0030087513147",
            disabled: false,
          },
          {
            name: "SPECIALTY0030087143441",
            disabled: false,
          },
          {
            name: "SPECIALTY0030087146441",
            disabled: false,
          },
          {
            name: "SPECIALTY0083997700961",
            disabled: false,
          },
          {
            name: "SUPER HIGH PREMIUM0030087512353",
            disabled: false,
          },
          {
            name: "SUPER HIGH PREMIUM0030087512640",
            disabled: false,
          },
          {
            name: "UNKNOWN0030087834960",
            disabled: false,
          },
          {
            name: "UNKNOWN0030087845049",
            disabled: false,
          },
          {
            name: "VITAMINS0030087040203",
            disabled: false,
          },
          {
            name: "VITAMINS0030087512480",
            disabled: false,
          },
          {
            name: "VITAMINS0083997700961",
            disabled: false,
          },
          {
            name: "null",
            disabled: false,
          },
        ],
        value: "",
      },
    },
  },
};

const smartSearchSlice = createSlice({
  name: "smartSearch",
  initialState: initialState,
  reducers: {
    handleConversationId(state, action) {
      state.conversation = action.payload;
      // else state.showRecommendation = !state.showRecommendation;
    },
    updateConversationData(state, action) {
      state.conversationData = action.payload;
    },
    changeLikeDislikeStatus(state, action) {
      state.conversationLikeDislikeStatus = action.payload;
    },
    handleSearchConversationText(state, action) {
      state.searchConversationText = action.payload;
    },
    updateSelectedDataProduct(state, action) {
      state.selectedDataProduct = action.payload;
    },
    updateActiveChatThread(state, action) {
      state.sherlockAssist.activeChatThread = action.payload;
    },
    appendActiveChatThread(state, action) {
      state.sherlockAssist.activeChatThread = [
        ...state.sherlockAssist.activeChatThread,
        action.payload,
      ];
    },
    updateActiveSession(state, action) {
      state.sherlockAssist.activeSession = action.payload;
    },
    updateSessionHistory(state, action) {
      state.sherlockAssist.sessionHistory = action.payload;
    },
    clearSherlockChats(state, action) {
      state.sherlockAssist = {
        ...state.sherlockAssist,
        sessionHistory: [],
        activeSession: {},
        activeChatThread: [],
      };
    },
    startNewSherlockChat(state, action) {
      state.sherlockAssist = {
        ...state.sherlockAssist,
        activeSession: {},
        activeChatThread: [],
      };
    },
    updateSherlockAssistClusterStatus(state, action) {
      state.sherlockAssist.databricksCluster = action.payload;
    },
    updateShrlockAssistFilterState(state, action) {
      state.sherlockAssist.filters.state.value = action.payload;
    },
    updateShrlockAssistFilterCity(state, action) {
      state.sherlockAssist.filters.city.value = action.payload;
    },
    updateShrlockAssistFilterRetailer(state, action) {
      state.sherlockAssist.filters.retailer.value = action.payload;
    },
    updateShrlockAssistFilterStore(state, action) {
      state.sherlockAssist.filters.store.value = action.payload;
    },
    updateShrlockAssistFilterBrand(state, action) {
      state.sherlockAssist.filters.brand.value = action.payload;
    },
    updateShrlockAssistFilterSKU(state, action) {
      state.sherlockAssist.filters.sku.value = action.payload;
    },
    updateShrlockAssistSessionFilters(state, action) {
      state.sherlockAssist.sessionFilters = action.payload;
    },
    updateFilterCount(state, action) {
      state.sherlockAssist.filterCount = action.payload;
    },
  },
});

export const {
  handleConversationId,
  updateConversationData,
  changeLikeDislikeStatus,
  handleSearchConversationText,
  updateSelectedDataProduct,
  updateActiveChatThread,
  appendActiveChatThread,
  updateActiveSession,
  updateSessionHistory,
  clearSherlockChats,
  startNewSherlockChat,
  updateSherlockAssistClusterStatus,
  updateShrlockAssistFilterState,
  updateShrlockAssistFilterCity,
  updateShrlockAssistFilterRetailer,
  updateShrlockAssistFilterStore,
  updateShrlockAssistFilterBrand,
  updateShrlockAssistFilterSKU,
  updateShrlockAssistSessionFilters,
  updateFilterCount,
} = smartSearchSlice.actions;
export default smartSearchSlice.reducer;
